(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 2234:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(93359), exports);
tslib_1.__exportStar(__webpack_require__(29738), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 533:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapSections = void 0;
const jsx_runtime_1 = __webpack_require__(24246);
const react_error_boundary_1 = __webpack_require__(21906);
const uuid_1 = __webpack_require__(338);
/**
 * Will take in the page sections data and react section components
 * and render in the order they appear in the page sections data.
 * @param {*} pageSections
 * @param {*} sectionComponents
 */
const mapSections = (pageSections, sectionComponents, pageData) => {
    const componentMap = sectionComponents
        ? sectionComponents.reduce((compMap, Component) => {
            let schemaKey = '';
            if (Component?.Schema && typeof Component?.Schema === 'function') {
                schemaKey = Component.Schema(pageData)?.key;
            }
            else {
                schemaKey = Component.Schema.key;
            }
            if (!schemaKey) {
                return compMap;
            }
            compMap[schemaKey] = Component;
            return compMap;
        }, {})
        : {};
    return pageSections.reduce((acc, section) => {
        if (!section)
            return acc;
        const { _template: CompSchemaKey, ...cms } = section;
        const Comp = componentMap[CompSchemaKey];
        if (!Comp)
            return acc;
        if (cms?.sectionVisibility === 'hidden')
            return acc;
        return [
            ...acc,
            // sections wrapper with data-comp and data-comp-id for easy scrolling on section select
            (0, jsx_runtime_1.jsx)("section", { "data-comp": CompSchemaKey, "data-comp-id": cms?.id, children: (0, jsx_runtime_1.jsx)(react_error_boundary_1.ErrorBoundary, { "data-comp": "SectionErrorBoundary", FallbackComponent: () => ((0, jsx_runtime_1.jsx)(SectionErrorFallback, { name: CompSchemaKey })), children: (0, jsx_runtime_1.jsx)(Comp, { "comp-name": CompSchemaKey, cms: cms }) }) }, (0, uuid_1.v4)()),
        ];
    }, []);
};
exports.mapSections = mapSections;
function SectionErrorFallback({ name }) {
    return ((0, jsx_runtime_1.jsx)("section", { style: {
            padding: '16px',
        }, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                border: 'thin solid #f87171',
                height: '350px',
                width: '100%',
                backgroundColor: '#fecaca',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '8px',
            }, children: ["An error occured in your", (0, jsx_runtime_1.jsxs)("span", { style: { fontWeight: 'bold', fontFamily: 'monospace' }, children: ["\u00A0", name, "\u00A0"] }), "section"] }) }));
}
//# sourceMappingURL=mapSections.js.map

/***/ }),

/***/ 60118:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapSectionsWithAddedProps = void 0;
const mapSectionsWithAddedProps = (props) => (section) => {
    try {
        if (!section)
            return null;
        if (!props)
            return section;
        if (typeof props !== 'object') {
            console.warn('mapSectionsWithAddedProps:error: props must be an object');
            return section;
        }
        return {
            ...section,
            props: {
                ...section.props,
                children: {
                    ...section.props.children,
                    props: {
                        ...section.props.children.props,
                        children: {
                            ...section.props.children.props.children,
                            props: {
                                ...section.props.children.props.children.props,
                                ...props,
                            },
                        },
                    },
                },
            },
        };
    }
    catch (error) {
        return section;
    }
};
exports.mapSectionsWithAddedProps = mapSectionsWithAddedProps;
//# sourceMappingURL=mapSectionsWithAddedProps.js.map

/***/ }),

/***/ 29738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.renderSections = void 0;
const mapSections_1 = __webpack_require__(533);
const mapSectionsWithAddedProps_1 = __webpack_require__(60118);
const renderSections = (pageData, sectionComponents) => {
    const pageDataSections = pageData?.page?.sections ||
        pageData?.article?.sections ||
        pageData?.blog?.sections;
    if (!pageDataSections) {
        return () => {
            return null;
        };
    }
    const allSections = (0, mapSections_1.mapSections)([...pageDataSections], sectionComponents, pageData);
    const pageDataTemplateSections = pageDataSections?.filter((section) => section.parentContentType === 'template');
    const pageDataPageSections = pageDataSections?.filter((section) => section.parentContentType !== 'template');
    const templateSections = (0, mapSections_1.mapSections)(pageDataTemplateSections, sectionComponents, pageData);
    const pageSections = (0, mapSections_1.mapSections)(pageDataPageSections, sectionComponents, pageData);
    return (options) => {
        try {
            if (!options)
                return allSections;
            if (typeof options !== 'object') {
                throw new Error(`parameter must be an object; received ${typeof options}`);
            }
            if (options.type && !['template', 'page', 'all'].includes(options.type)) {
                console.warn('renderSections:', '`type` must be "template", "page", or "all"');
            }
            if (options.props && typeof options.props !== 'object') {
                throw new Error(`\`props\` must be an object; received ${typeof options.props}`);
            }
            const { props, type } = options;
            switch (type) {
                case 'template':
                    if (props) {
                        return templateSections.map((0, mapSectionsWithAddedProps_1.mapSectionsWithAddedProps)(props));
                    }
                    return templateSections;
                case 'page':
                    if (props) {
                        return pageSections.map((0, mapSectionsWithAddedProps_1.mapSectionsWithAddedProps)(props));
                    }
                    return pageSections;
                default:
                    if (props) {
                        return allSections.map((0, mapSectionsWithAddedProps_1.mapSectionsWithAddedProps)(props));
                    }
                    return allSections;
            }
        }
        catch (error) {
            console.error('renderSections:error', error.message);
            return allSections;
        }
    };
};
exports.renderSections = renderSections;
//# sourceMappingURL=renderSections.js.map

/***/ }),

/***/ 93359:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomizerShell = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable react-hooks/rules-of-hooks */
const react_1 = __webpack_require__(27378);
const penpal_1 = __webpack_require__(97221);
const router_1 = tslib_1.__importDefault(__webpack_require__(86677));
const useCustomizerShell = ({ environment = 'production', isPreview, isShareableToken, sectionComponents, staticProps, storefrontSettingsSchema, }) => {
    if (!isPreview || (isPreview && isShareableToken)) {
        return {
            pageData: staticProps.page || staticProps.blog || staticProps.article,
            storefrontSettings: staticProps?.settings?.settings,
        };
    }
    try {
        const [_pageData, _setPageData] = (0, react_1.useState)(null);
        const [_storefrontSettings, _setStorefrontSettings] = (0, react_1.useState)(null);
        const [parentConnection, setParentConnection] = (0, react_1.useState)(null);
        const [hasLoadedOnce, setHasLoadedOnce] = (0, react_1.useState)(false);
        const [isRouteChanging, setIsRouteChanging] = (0, react_1.useState)(false);
        // eslint-disable-next-line consistent-return
        const _refreshSections = (0, react_1.useCallback)(() => {
            if (!sectionComponents)
                return [];
            const sectionSchemas = sectionComponents
                .map((section) => {
                if (section.Schema && typeof section.Schema === 'function') {
                    const qualifiedSchema = section.Schema({ ...staticProps });
                    return qualifiedSchema;
                }
                return section.Schema;
            })
                .filter(Boolean);
            if (parentConnection) {
                try {
                    const sectionSchemasString = JSON.stringify(sectionSchemas);
                    parentConnection.setSectionsSchemas(sectionSchemasString);
                }
                catch (error) {
                    console.error(error);
                    // parentConnection.displayError('Something went wrong parsing sections');
                }
            }
        }, [staticProps, parentConnection, sectionComponents]);
        // eslint-disable-next-line consistent-return
        const _refreshStorefrontSettingsSchema = (0, react_1.useCallback)(() => {
            if (!storefrontSettingsSchema)
                return [];
            const storefrontSettingsSchemaString = JSON.stringify(storefrontSettingsSchema);
            if (parentConnection) {
                if (sectionComponents) {
                    parentConnection.setStorefrontSettingsSchema(storefrontSettingsSchemaString);
                }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [staticProps, parentConnection, storefrontSettingsSchema]);
        const handleRouteChangeStart = (url) => {
            if (url !== router_1.default.asPath) {
                setIsRouteChanging(true);
                _setPageData(null); // Clear page data when route changes to new path
            }
        };
        const handleRouteChangeComplete = (0, react_1.useCallback)((url) => {
            if (url === router_1.default.asPath)
                setIsRouteChanging(false);
            if (parentConnection) {
                const currentRoute = {
                    environment,
                    currentPath: router_1.default.router.asPath,
                    template: staticProps?.template,
                    templateType: staticProps?.templateType,
                    handle: staticProps?.pageHandle,
                    title: staticProps?.pageTitle,
                    description: staticProps?.pageDescription,
                };
                parentConnection.setCurrentRoute(currentRoute);
            }
        }, [parentConnection, staticProps, environment]);
        (0, react_1.useEffect)(() => {
            router_1.default.events.on('routeChangeStart', handleRouteChangeStart);
            router_1.default.events.on('routeChangeComplete', handleRouteChangeComplete);
            router_1.default.events.on('routeChangeError', handleRouteChangeComplete);
            return () => {
                router_1.default.events.off('routeChangeStart', handleRouteChangeStart);
                router_1.default.events.off('routeChangeComplete', handleRouteChangeComplete);
                router_1.default.events.off('routeChangeError', handleRouteChangeComplete);
            };
        }, [handleRouteChangeStart, handleRouteChangeComplete]);
        (0, react_1.useEffect)(() => {
            if (parentConnection) {
                parentConnection.onRouteChange(isRouteChanging);
            }
        }, [isRouteChanging, parentConnection]);
        (0, react_1.useEffect)(() => {
            const connection = (0, penpal_1.connectToParent)({
                // Methods child is exposing to parent.
                // parentOrigin: 'http://localhost:3000', // TODO: make this the platform URL
                // parentOrigin: 'https://backpack-platform.herokuapp.com', // TODO: make this the platform URL
                methods: {
                    routeToPage: (path) => {
                        router_1.default.push(path);
                    },
                    scrollToSection: (sectionId) => {
                        const sectionEl = document.querySelector(`[data-comp-id="${sectionId}"]`);
                        if (sectionEl) {
                            sectionEl.scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                            });
                        }
                    },
                    /**
                     * This is the live form data from the shell that will be used to render the page.
                     * @param {Object} content : The page content data from form to be rendered;
                     */
                    setPageData: (content) => {
                        _setPageData(content);
                    },
                    /**
                     * This is the live storefront settings from the shell that will be used to render the page.
                     * @param {*} settings : The storefront settings data from form to be rendered;
                     */
                    setStorefrontSettings: (settings) => {
                        _setStorefrontSettings(settings);
                    },
                },
            });
            async function setConnectionMethods() {
                try {
                    const newParentConnection = await connection.promise;
                    setParentConnection(newParentConnection);
                }
                catch (e) {
                    console.error('Error when trying to connect Frame to Customizer Shell.', e);
                }
            }
            setConnectionMethods();
        }, []);
        // Inform the Customizer shell which page we are on on initial load.
        (0, react_1.useEffect)(() => {
            if (parentConnection && !hasLoadedOnce) {
                const currentRoute = {
                    environment,
                    currentPath: router_1.default.router.asPath,
                    template: staticProps?.template,
                    templateType: staticProps?.templateType,
                    handle: staticProps?.pageHandle,
                    title: staticProps?.pageTitle,
                    description: staticProps?.pageDescription, // Needed?
                };
                parentConnection.setCurrentRoute(currentRoute);
                setHasLoadedOnce(true);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [parentConnection, staticProps]);
        (0, react_1.useEffect)(() => {
            _refreshSections();
            _refreshStorefrontSettingsSchema();
        }, [
            staticProps,
            _refreshSections,
            _refreshStorefrontSettingsSchema,
            sectionComponents,
        ]);
        return {
            pageData: _pageData,
            error: null,
            storefrontSettings: _storefrontSettings,
        };
    }
    catch (error) {
        console.error(error);
        return {
            pageData: staticProps.page,
            error,
            storefrontSettings: staticProps.settings,
        };
    }
};
exports.useCustomizerShell = useCustomizerShell;
//# sourceMappingURL=useCustomizerShell.js.map

/***/ }),

/***/ 96759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.N$ = __webpack_unused_export__ = void 0;
var memoize_1 = __webpack_require__(29234);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return memoize_1.memoize; } });
var rafTimeoutInterval_1 = __webpack_require__(41756);
Object.defineProperty(exports, "N$", ({ enumerable: true, get: function () { return rafTimeoutInterval_1.rafTimeoutInterval; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29234:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.memoize = void 0;
const memoize = (fn) => {
    const cache = {};
    return (...args) => {
        const n = args[0];
        if (n in cache) {
            return cache[n];
        }
        const result = fn(n);
        cache[n] = result;
        return result;
    };
};
exports.memoize = memoize;
//# sourceMappingURL=memoize.js.map

/***/ }),

/***/ 41756:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// See the links below for more information:
// http://creativejs.com/resources/requestanimationframe/
// https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
//
// Source:
// https://gist.github.com/joyrexus/7304146
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.rafTimeoutInterval = void 0;
const rafTimeoutInterval = () => {
    if (typeof window === 'undefined')
        return;
    var requestAnimFrame = (function () {
        return (window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (callback) {
                window.setTimeout(callback, 1000 / 60);
            });
    })();
    /**
     * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
     * @param {function} fn The callback function
     * @param {int} delay The delay in milliseconds
     */
    var requestInterval = function (fn, delay) {
        if (!window.requestAnimationFrame &&
            !window.webkitRequestAnimationFrame &&
            // Firefox 5 ships without cancel support
            !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) &&
            !window.oRequestAnimationFrame &&
            !window.msRequestAnimationFrame) {
            return window.setInterval(fn, delay);
        }
        var start = new Date().getTime();
        var handle = new Object();
        function loop() {
            var current = new Date().getTime();
            var delta = current - start;
            if (delta >= delay) {
                fn.call();
                start = new Date().getTime();
            }
            handle.value = requestAnimFrame(loop);
        }
        ;
        handle.value = requestAnimFrame(loop);
        return handle;
    };
    /**
    * Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
    * @param {function} fn The callback function
    * @param {int} delay The delay in milliseconds
    */
    var requestTimeout = function (fn, delay) {
        if (!window.requestAnimationFrame &&
            !window.webkitRequestAnimationFrame &&
            // Firefox 5 ships without cancelsupport
            !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) &&
            !window.oRequestAnimationFrame &&
            !window.msRequestAnimationFrame) {
            return window.setTimeout(fn, delay);
        }
        var start = new Date().getTime();
        var handle = new Object();
        function loop() {
            var current = new Date().getTime();
            var delta = current - start;
            delta >= delay
                ? fn.call()
                : handle.value = requestAnimFrame(loop);
        }
        ;
        handle.value = requestAnimFrame(loop);
        return handle;
    };
    /**
    * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
    * @param {int|object} fn The callback function
    */
    var clearRequestInterval = function (handle) {
        window.cancelAnimationFrame
            ? window.cancelAnimationFrame(handle.value)
            : window.webkitCancelAnimationFrame
                ? window.webkitCancelAnimationFrame(handle.value)
                : window.webkitCancelRequestAnimationFrame
                    ? window.webkitCancelRequestAnimationFrame(handle.value)
                    : /* Support for legacy API */ window.mozCancelRequestAnimationFrame
                        ? window.mozCancelRequestAnimationFrame(handle.value)
                        : window.oCancelRequestAnimationFrame
                            ? window.oCancelRequestAnimationFrame(handle.value)
                            : window.msCancelRequestAnimationFrame
                                ? window.msCancelRequestAnimationFrame(handle.value)
                                : clearInterval(handle);
    };
    /**
     * Behaves the same as clearTimeout except uses cancelRequestAnimationFrame() where possible for better performance
     * @param {int|object} fn The callback function
     */
    var clearRequestTimeout = function (handle) {
        window.cancelAnimationFrame
            ? window.cancelAnimationFrame(handle.value)
            : window.webkitCancelAnimationFrame
                ? window.webkitCancelAnimationFrame(handle.value)
                : window.webkitCancelRequestAnimationFrame
                    ? window.webkitCancelRequestAnimationFrame(handle.value)
                    : /* Support for legacy API */ window.mozCancelRequestAnimationFrame
                        ? window.mozCancelRequestAnimationFrame(handle.value)
                        : window.oCancelRequestAnimationFrame
                            ? window.oCancelRequestAnimationFrame(handle.value)
                            : window.msCancelRequestAnimationFrame
                                ? window.msCancelRequestAnimationFrame(handle.value)
                                : clearTimeout(handle);
    };
    window.requestAnimFrame = requestAnimFrame;
    window.requestInterval = requestInterval;
    window.requestTimeout = requestTimeout;
    window.clearRequestInterval = clearRequestInterval;
    window.clearRequestTimeout = clearRequestTimeout;
};
exports.rafTimeoutInterval = rafTimeoutInterval;
//# sourceMappingURL=rafTimeoutInterval.js.map

/***/ }),

/***/ 79141:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14284);

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StateProvider = void 0;
const tslib_1 = __webpack_require__(59312);
const jsx_runtime_1 = __webpack_require__(24246);
const recoil_1 = __webpack_require__(69853);
const recoil_toolkit_1 = __webpack_require__(80434);
const store_1 = tslib_1.__importDefault(__webpack_require__(24385));
function StateProvider({ storefrontSettings, route, pageData, pageProps, children, }) {
    function initializeState({ set }) {
        set(store_1.default.storefrontSettings, storefrontSettings);
        set(store_1.default.route, route);
        if (!pageData)
            return;
        if (pageData?.resourceType === 'product_page') {
            set(store_1.default.product, pageProps.product);
        }
        if (pageData?.resourceType === 'collection_page') {
            set(store_1.default.collection, pageProps.collection);
        }
        if (pageData?.resourceType === 'page') {
            set(store_1.default.page, pageProps.page);
        }
        if (pageData?.resourceType === 'blog') {
            set(store_1.default.blog, pageProps.blog);
        }
        if (pageData?.resourceType === 'article') {
            set(store_1.default.article, pageProps.article);
        }
    }
    const isDevelopment = "production" === 'development';
    // eslint-disable-next-line eqeqeq
    const recoilDevToolsEnabled = process.env.RECOIL_DEV_TOOLS_ENABLED == 'true';
    if (isDevelopment && recoilDevToolsEnabled) {
        return (
        // eslint-disable-next-line react/jsx-filename-extension
        (0, jsx_runtime_1.jsxs)(recoil_1.RecoilRoot, { initializeState: initializeState, children: [(0, jsx_runtime_1.jsx)(recoil_toolkit_1.RecoilDevTools, { enableConsole: true }), children] }));
    }
    return (0, jsx_runtime_1.jsx)(recoil_1.RecoilRoot, { initializeState: initializeState, children: children });
}
exports.StateProvider = StateProvider;
//# sourceMappingURL=StateProvider.js.map

/***/ }),

/***/ 98043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.analyticsStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  Analytics State
*/
const customerAndCartInit = (0, recoil_1.atom)({
    key: 'analytics/customerAndCartInit',
    default: false,
    effects: [
        // effects.logStateChange('customerAndCartInit'),
        effects_1.default.onChange({
            key: 'customerAndCartInit',
            topic: 'CUSTOMER_AND_CART_INIT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
exports.analyticsStore = {
    // actual state - atoms
    customerAndCartInit,
};
//# sourceMappingURL=analytics.js.map

/***/ }),

/***/ 9807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.analyticsStore = void 0;
var analytics_1 = __webpack_require__(98043);
Object.defineProperty(exports, "analyticsStore", ({ enumerable: true, get: function () { return analytics_1.analyticsStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 772:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useArticle = void 0;
var useArticle_1 = __webpack_require__(94170);
Object.defineProperty(exports, "useArticle", ({ enumerable: true, get: function () { return useArticle_1.useArticle; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 94170:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useArticle = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useArticle = () => (0, store_1.useRecoilValue)(store_1.default.article);
exports.useArticle = useArticle;
//# sourceMappingURL=useArticle.js.map

/***/ }),

/***/ 11634:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.articleStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  Article State
*/
const article = (0, recoil_1.atom)({
    key: 'article/article',
    default: null,
    effects: [
        // effects.logStateChange('article'),
        effects_1.default.onChange({
            key: 'article',
            topic: 'ARTICLE_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const articlesList = (0, recoil_1.atom)({
    key: 'article/articlesList',
    default: [],
});
// articles json fuse index
const articlesIndex = (0, recoil_1.atom)({
    key: 'article/articlesIndex',
    default: null, // { keys: [], records: [] }
});
exports.articleStore = {
    // actual state - atoms
    article,
    articlesIndex,
    articlesList,
};
//# sourceMappingURL=article.js.map

/***/ }),

/***/ 32159:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.articleStore = void 0;
var article_1 = __webpack_require__(11634);
Object.defineProperty(exports, "articleStore", ({ enumerable: true, get: function () { return article_1.articleStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 51457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useBlog = void 0;
var useBlog_1 = __webpack_require__(2897);
Object.defineProperty(exports, "useBlog", ({ enumerable: true, get: function () { return useBlog_1.useBlog; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2897:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useBlog = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useBlog = () => (0, store_1.useRecoilValue)(store_1.default.blog);
exports.useBlog = useBlog;
//# sourceMappingURL=useBlog.js.map

/***/ }),

/***/ 6345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.blogStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  Blog State
*/
const blog = (0, recoil_1.atom)({
    key: 'blog/blog',
    default: null,
    effects: [
        effects_1.default.onChange({
            key: 'blog',
            topic: 'BLOG_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const blogsList = (0, recoil_1.atom)({
    key: 'blog/blogsList',
    default: [],
});
// blogs json fuse index
const blogsIndex = (0, recoil_1.atom)({
    key: 'blog/blogsIndex',
    default: null, // { keys: [], recors: [] }
});
exports.blogStore = {
    // actual state - atoms
    blog,
    blogsIndex,
    blogsList,
};
//# sourceMappingURL=blog.js.map

/***/ }),

/***/ 3727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.blogStore = void 0;
var blog_1 = __webpack_require__(6345);
Object.defineProperty(exports, "blogStore", ({ enumerable: true, get: function () { return blog_1.blogStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 90106:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CartClient = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
const graphql_request_1 = __webpack_require__(63671);
const humanize_graphql_response_1 = tslib_1.__importDefault(__webpack_require__(27207));
const queries_1 = __webpack_require__(24765);
const mutations_1 = __webpack_require__(69881);
/**
 * @see: https://shopify.dev/custom-storefronts/cart
 */
class CartClient {
    constructor({ apiToken, apiVersion, domain, debug }) {
        this.apiToken = apiToken;
        this.apiVersion = apiVersion;
        this.domain = domain;
        this.endpoint = '';
        this.options = {};
        this.debug = debug || false;
        this.client = this.initClient();
    }
    initClient() {
        this.endpoint = `https://${this.domain}/api/${this.apiVersion}/graphql.json`;
        // client
        this.options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'X-Shopify-Storefront-Access-Token': this.apiToken,
                'Content-Type': 'application/json; charset=utf-8',
            },
        };
        return new graphql_request_1.GraphQLClient(this.endpoint, this.options);
    }
    /**
     * Customer queries client
     * @param {gqlQuery} query
     * @param {object} variables
     * @returns
     */
    async query({ query, variables }) {
        if (this.debug) {
            console.log('CartClient:', query, variables);
        }
        return this.client.rawRequest(query, variables);
    }
    /**
     * Customer mutation client
     * @param {gqlMutation} mutation
     * @param {object} variables
     * @returns
     */
    async mutate({ mutation, variables }) {
        if (this.debug) {
            console.log('CartClient:', mutation, variables);
        }
        return this.client.rawRequest(mutation, variables);
    }
    /**
     * Create a new cart
     * @param {country} twoDigitCountryCode - US, MX..
     * @param {cartInput} cartInput - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @returns a new full cart instance
     */
    async create({ country, cartInput } = { county: 'US', cartInput: {} }) {
        try {
            if (!cartInput) {
                throw new Error('cart create failed "cartInput" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.create,
                variables: { country, cartInput },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { cartCreate: { cart, userErrors }, } = data;
            if (userErrors?.length) {
                throw new Error(userErrors[0].message);
            }
            return { error: null, newCart: (0, humanize_graphql_response_1.default)(cart) };
        }
        catch (error) {
            return { error: error.message, newCart: null };
        }
    }
    /**
     * Retrieve an existing cart by id
     * @param {id} cart.id "Z2lkOi8vc2hvcGlmeS9DYXJ0LzRlMDFmMTQ5YTQ2MThlYzFmYzgwYjljMjk1ZGZjZTk4"
     * @returns full cart object
     */
    async get({ id, country } = { id: '', country: 'US' }) {
        try {
            if (!id) {
                throw new Error('cart get failed "id" not provided');
            }
            const query = queries_1.queries.get;
            const variables = { id, country };
            // get cart
            const { data, errors, status } = await this.query({ query, variables });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cart) {
                throw new Error('Cart object not returned in response');
            }
            return { error: null, existingCart: (0, humanize_graphql_response_1.default)(data.cart) };
        }
        catch (error) {
            return { error: error.message, existingCart: null };
        }
    }
    /**
     * Add a line item to the cart
     * @param {*} param0
     * @returns
     */
    async addItem({ cartId, country, merchandiseId, quantity, sellingPlanId, attributes } = {
        cartId: null,
        country: 'US',
        attributes: [],
        merchandiseId: null,
        quantity: 1,
        sellingPlanId: null,
    }) {
        try {
            if (!cartId) {
                throw new Error('addItem "cartId" not provided');
            }
            if (!merchandiseId) {
                throw new Error('addItem "merchandiseId" not provided');
            }
            // update cart with a single line item
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.addItems,
                variables: sellingPlanId
                    ? {
                        cartId,
                        country,
                        lines: [{ attributes, merchandiseId, quantity, sellingPlanId }],
                    }
                    : {
                        cartId,
                        country,
                        lines: [{ attributes, merchandiseId, quantity }],
                    },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesAdd?.updatedCart) {
                throw new Error('Add item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesAdd;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Add multiple line items to the cart
     * @param {*} param0
     * @returns
     */
    async addItems({ cartId, lines, country } = {
        cartId: null,
        country: 'US',
        lines: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('addItems "cartId" not provided');
            }
            if (!lines) {
                throw new Error('addItems "lines" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.addItems,
                variables: { cartId, country, lines },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesAdd?.updatedCart) {
                throw new Error('Add item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesAdd;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Remove a line item by id
     * @param {*} param0
     * @returns
     */
    async removeItem({ cartId, country, lineId } = {
        cartId: null,
        country: 'US',
        lineId: null,
    }) {
        try {
            if (!cartId) {
                throw new Error('removeItem "cartId" not provided');
            }
            if (!lineId) {
                throw new Error('removeItem "lineId" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.removeItems,
                variables: {
                    cartId,
                    country,
                    lineIds: [lineId],
                },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesRemove?.updatedCart) {
                throw new Error('Remove item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesRemove;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Remove multiple items from the cart by lineIds
     * @param {*} param0
     * @returns
     */
    async removeItems({ cartId, country, lineIds } = {
        cartId: null,
        country: 'US',
        lineIds: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('removeItems "cartId" not provided');
            }
            if (!lineIds) {
                throw new Error('removeItems "lineIds" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.removeItems,
                variables: {
                    cartId,
                    country,
                    lineIds,
                },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesRemove?.updatedCart) {
                throw new Error('Remove item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesRemove;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update a line item property
     * @param {*} param0
     * @returns
     */
    async updateItem({ cartId, country, lineId, quantity, merchandiseId, attributes, sellingPlanId, } = {
        cartId: null,
        country: 'US',
        lineId: null,
        quantity: 0,
        merchandiseId: null,
        attributes: [],
        sellingPlanId: null,
    }) {
        try {
            if (!cartId) {
                throw new Error('updateItem "cartId" not provided');
            }
            if (!lineId) {
                throw new Error('updateItem "lineId" not provided');
            }
            const update = { id: lineId };
            if (quantity) {
                update.quantity = quantity;
            }
            if (merchandiseId) {
                update.merchandiseId = merchandiseId;
            }
            if (attributes) {
                update.attributes = attributes;
            }
            if (sellingPlanId) {
                update.sellingPlanId = sellingPlanId;
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateItems,
                variables: {
                    cartId,
                    country,
                    lines: [update],
                },
            });
            if (status !== 200) {
                throw new Error(`Update item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesUpdate?.updatedCart) {
                throw new Error('Update item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update multiple line items at once
     * @param {*} param0
     * @returns
     */
    async updateItems({ cartId, country, lines } = {
        cartId: null,
        country: 'US',
        lines: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('updateItems "cartId" not provided');
            }
            if (!lines?.length) {
                throw new Error('updateItems "lines" not provided');
            }
            const lineToUpdate = (line) => {
                const updatedLine = {
                    id: line.lineId,
                    quantity: line?.quantity,
                    merchandiseId: line?.variant?.id || '',
                    attributes: line?.attributes || [],
                };
                if (line?.sellingPlanId) {
                    updatedLine.sellingPlanId = line.sellingPlanId;
                }
                return updatedLine;
            };
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateItems,
                variables: {
                    cartId,
                    country,
                    lines: lines.map(lineToUpdate),
                },
            });
            if (status !== 200) {
                throw new Error(`Update items request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesUpdate?.updatedCart) {
                throw new Error('Update items cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart note
     * @param {*} param0
     * @returns
     */
    async updateNote({ cartId, country, note } = {
        cartId: null,
        country: 'US',
        note: '',
    }) {
        try {
            if (!cartId) {
                throw new Error('updateNode "cartId" not provided');
            }
            if (typeof note === 'undefined') {
                throw new Error('updateNode "note" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateNote,
                variables: { cartId, country, note },
            });
            if (status !== 200) {
                throw new Error(`Update note request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartNoteUpdate?.updatedCart) {
                throw new Error('Update note cart object not returned in response');
            }
            const { updatedCart } = data.cartNoteUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart discount code
     * @param {*} param0
     * @returns
     */
    async updateDiscount({ cartId, country, discountCode } = {
        cartId: null,
        country: 'US',
        discountCode: '',
    }) {
        try {
            if (!cartId) {
                throw new Error('updateDiscount "cartId" not provided');
            }
            if (!discountCode) {
                throw new Error('updateDiscount "discountCode" not provided');
            }
            // only one is discountCode is allowed, god knows why they want this as an array.
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateDiscountCode,
                variables: { cartId, country, discountCodes: [discountCode] },
            });
            if (status !== 200) {
                throw new Error(`Update discount request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartDiscountCodesUpdate?.updatedCart) {
                throw new Error('Update discount cart object not returned in response');
            }
            const { updatedCart } = data.cartDiscountCodesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Remove cart discount code
     * @param {*} param0
     * @returns
     */
    async removeDiscount({ cartId, country } = {
        cartId: null,
        country: 'US',
    }) {
        try {
            if (!cartId) {
                throw new Error('removeDiscount "cartId" not provided');
            }
            // remove discount code by passing an empty array
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateDiscountCode,
                variables: { cartId, country, discountCodes: [] },
            });
            if (status !== 200) {
                throw new Error(`remove discount request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartDiscountCodesUpdate?.updatedCart) {
                throw new Error('Update discount cart object not returned in response');
            }
            const { updatedCart } = data.cartDiscountCodesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart attributes
     * @param {[{ key, value }...]} attributes
     * @returns
     */
    async updateAttributes({ cartId, country, attributes } = {
        cartId: null,
        country: 'US',
        attributes: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('updateAttributes "cartId" not provided');
            }
            if (!attributes) {
                throw new Error('updateAttributes "attributes" not provided');
            }
            // update cart-level attributes (not line attributes)
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateAttributes,
                variables: { cartId, country, attributes },
            });
            if (status !== 200) {
                throw new Error(`Update attributes request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartAttributesUpdate?.updatedCart) {
                throw new Error('Update attributes cart object not returned in response');
            }
            const { updatedCart } = data.cartAttributesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart attributes
     * @param {object} buyerIdentity
     * @param {country} twoDigitCountryCode - US, MX..
     * @returns
     */
    async updateBuyerIdentity({ cartId, country, buyerIdentity } = {
        cartId: null,
        buyerIdentity: null,
        country: 'US',
    }) {
        try {
            if (!cartId) {
                throw new Error('updateBuyerIdentity "cartId" not provided');
            }
            if (!buyerIdentity) {
                throw new Error('updateBuyerIdentity "buyerIdentity" not provided');
            }
            // update cart-level attributes (not line attributes)
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateBuyerIdentity,
                variables: { cartId, country, buyerIdentity },
            });
            if (status !== 200) {
                throw new Error(`Update buyerIdentity request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartBuyerIdentityUpdate?.updatedCart) {
                throw new Error('Update attributes cart object not returned in response');
            }
            const updatedCart = (0, humanize_graphql_response_1.default)(data.cartBuyerIdentityUpdate.updatedCart);
            return { error: null, updatedCart };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
}
exports.CartClient = CartClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 72728:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const graphql_request_1 = __webpack_require__(63671);
const customerFragment = (0, graphql_request_1.gql) `
  fragment Customer on Customer {
    acceptsMarketing
    createdAt
    defaultAddress {
      firstName
      lastName
      formatted
      formattedArea
      name
      address1
      address2
      latitude
      longitude
      id
      company
      country
      countryCodeV2
      province
      provinceCode
      phone
    }
    displayName
    email
    firstName
    id
    lastName
    phone
    tags
    updatedAt
    orders(first: 10) {
      edges {
        node {
          orderNumber
          id
        }
      }
    }
  }
`;
const buyerIdentity = (0, graphql_request_1.gql) `
  fragment BuyerIdentity on CartBuyerIdentity {
    email
    phone
    countryCode
    customer {
      ...Customer
    }
  }
  ${customerFragment}
`;
const attribute = (0, graphql_request_1.gql) `
  fragment Attribute on Attribute {
    key
    value
  }
`;
const discountCode = (0, graphql_request_1.gql) `
  fragment DiscountCode on CartDiscountCode {
    applicable
    code
  }
`;
const moneyV2 = (0, graphql_request_1.gql) `
  fragment MoneyV2 on MoneyV2 {
    amount
    currencyCode
  }
`;
const estimatedCost = (0, graphql_request_1.gql) `
  fragment EstimatedCost on CartEstimatedCost {
    subtotalAmount {
      ...MoneyV2
    }
    totalAmount {
      ...MoneyV2
    }
  }
`;
const lineEstimatedCost = (0, graphql_request_1.gql) `
  fragment LineEstimatedCost on CartLineEstimatedCost {
    subtotalAmount {
      ...MoneyV2
    }
    totalAmount {
      ...MoneyV2
    }
  }
`;
const discountAllocation = (0, graphql_request_1.gql) `
  fragment DiscountAllocation on CartDiscountAllocation {
    discountedAmount {
      ...MoneyV2
    }
    ... on CartCodeDiscountAllocation {
      __typename
      code
      discountedAmount {
        ...MoneyV2
      }
    }
    ... on CartCustomDiscountAllocation {
      __typename
      discountedAmount {
        ...MoneyV2
      }
      title
    }
    ... on CartAutomaticDiscountAllocation {
      __typename
      discountedAmount {
        ...MoneyV2
      }
      title
    }
  }
`;
const image = (0, graphql_request_1.gql) `
  fragment Image on Image {
    altText
    height
    src
    id
    width
  }
`;
const selectedOption = (0, graphql_request_1.gql) `
  fragment SelectedOption on SelectedOption {
    name
    value
  }
`;
const unitPriceMeasurement = (0, graphql_request_1.gql) `
  fragment UnitPriceMeasurement on UnitPriceMeasurement {
    measuredType
    quantityUnit
    quantityValue
    referenceUnit
    referenceValue
  }
`;
// barcode is erroring for some reason
const productVariant = (0, graphql_request_1.gql) `
  fragment ProductVariant on ProductVariant {
    availableForSale
    compareAtPriceV2 {
      ...MoneyV2
    }
    currentlyNotInStock
    id
    image {
      ...Image
    }
    priceV2 {
      ...MoneyV2
    }
    product {
      handle
      id
      title
      tags
      onlineStoreUrl
      collections(first: 100) {
        nodes {
          handle
        }
      }
      productType
    }
    quantityAvailable
    requiresShipping
    selectedOptions {
      ...SelectedOption
    }
    sku
    title
    unitPrice {
      ...MoneyV2
    }
    unitPriceMeasurement {
      ...UnitPriceMeasurement
    }
    weight
    weightUnit
  }
`;
const merchandise = (0, graphql_request_1.gql) `
  fragment Merchandise on Merchandise {
    ...ProductVariant
  }
`;
const priceAdjustment = (0, graphql_request_1.gql) `
  fragment PriceAdjustment on SellingPlanAllocationPriceAdjustment {
    compareAtPrice {
      ...MoneyV2
    }
    perDeliveryPrice {
      ...MoneyV2
    }
    price {
      ...MoneyV2
    }
    unitPrice {
      ...MoneyV2
    }
  }
`;
const sellingPlanOption = (0, graphql_request_1.gql) `
  fragment SellingPlanOption on SellingPlanOption {
    name
    value
  }
`;
const sellingPlan = (0, graphql_request_1.gql) `
  fragment SellingPlan on SellingPlan {
    description
    id
    name
    options {
      ...SellingPlanOption
    }
    recurringDeliveries
  }
`;
const fullCartFragment = (0, graphql_request_1.gql) `
  fragment FullCart on Cart {
    attributes {
      ...Attribute
    }
    buyerIdentity {
      ...BuyerIdentity
    }
    checkoutUrl
    createdAt
    discountAllocations {
      ...DiscountAllocation
    }
    discountCodes {
      ...DiscountCode
    }
    estimatedCost {
      ...EstimatedCost
    }
    id
    lines(first: 100) {
      edges {
        node {
          attributes {
            ...Attribute
          }
          discountAllocations {
            ...DiscountAllocation
          }
          estimatedCost {
            ...LineEstimatedCost
          }
          id
          variant: merchandise {
            ...Merchandise
          }
          quantity
          sellingPlanAllocation {
            sellingPlan {
              ...SellingPlan
            }
            priceAdjustments {
              ...PriceAdjustment
            }
          }
        }
      }
    }
    note
    updatedAt
    __typename
  }
  ${buyerIdentity}
  ${attribute}
  ${discountCode}
  ${moneyV2}
  ${estimatedCost}
  ${lineEstimatedCost}
  ${discountAllocation}
  ${image}
  ${selectedOption}
  ${unitPriceMeasurement}
  ${priceAdjustment}
  ${sellingPlan}
  ${sellingPlanOption}
  ${productVariant}
  ${merchandise}
`;
const useErrors = (0, graphql_request_1.gql) `
  fragment UserError on CartUserError {
    code
    field
    message
  }
`;
exports["default"] = {
    useErrors,
    fullCartFragment,
};
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 4812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CartClient = void 0;
var client_1 = __webpack_require__(90106);
Object.defineProperty(exports, "CartClient", ({ enumerable: true, get: function () { return client_1.CartClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 69881:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mutations = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(63671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(72728));
/*
  Mutations
*/
const addItems = (0, graphql_request_1.gql) `
  mutation addItems($country: CountryCode, $cartId: ID!, $lines: [CartLineInput!]!)
  @inContext(country: $country) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const create = (0, graphql_request_1.gql) `
  mutation create($country: CountryCode, $cartInput: CartInput)
  @inContext(country: $country) {
    cartCreate(input: $cartInput) {
      cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const removeItems = (0, graphql_request_1.gql) `
  mutation removeItems($country: CountryCode, $cartId: ID!, $lineIds: [ID!]!)
  @inContext(country: $country) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateAttributes = (0, graphql_request_1.gql) `
  mutation updateAttributes($country: CountryCode, $cartId: ID!, $attributes: [AttributeInput!]!)
  @inContext(country: $country) {
    cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateBuyerIdentity = (0, graphql_request_1.gql) `
  mutation updateBuyerIdentity($country: CountryCode, $cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!)
  @inContext(country: $country) {
    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateDiscountCode = (0, graphql_request_1.gql) `
  mutation updateDiscountCode($country: CountryCode, $cartId: ID!, $discountCodes: [String!])
  @inContext(country: $country) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateItems = (0, graphql_request_1.gql) `
  mutation updateItems($country: CountryCode, $cartId: ID!, $lines: [CartLineUpdateInput!]!)
  @inContext(country: $country) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateNote = (0, graphql_request_1.gql) `
  mutation updateNote($country: CountryCode, $cartId: ID!, $note: String)
  @inContext(country: $country) {
    cartNoteUpdate(cartId: $cartId, note: $note) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
exports.mutations = {
    addItems,
    create,
    removeItems,
    updateAttributes,
    updateBuyerIdentity,
    updateDiscountCode,
    updateItems,
    updateNote,
};
//# sourceMappingURL=mutations.js.map

/***/ }),

/***/ 24765:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queries = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(63671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(72728));
/*
  Queries
*/
const get = (0, graphql_request_1.gql) `
  query ($id: ID!, $country: CountryCode) @inContext(country: $country) {
    cart(id: $id) {
      ...FullCart
    }
  }
  ${fragments_1.default.fullCartFragment}
`;
exports.queries = {
    get,
};
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 48081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(87892), exports);
tslib_1.__exportStar(__webpack_require__(26228), exports);
tslib_1.__exportStar(__webpack_require__(91887), exports);
tslib_1.__exportStar(__webpack_require__(44717), exports);
// getters / selectors
tslib_1.__exportStar(__webpack_require__(67542), exports);
tslib_1.__exportStar(__webpack_require__(69659), exports);
tslib_1.__exportStar(__webpack_require__(63953), exports);
tslib_1.__exportStar(__webpack_require__(53660), exports);
tslib_1.__exportStar(__webpack_require__(88587), exports);
tslib_1.__exportStar(__webpack_require__(10295), exports);
tslib_1.__exportStar(__webpack_require__(82914), exports);
tslib_1.__exportStar(__webpack_require__(83061), exports);
tslib_1.__exportStar(__webpack_require__(13437), exports);
tslib_1.__exportStar(__webpack_require__(13015), exports); // no-op
tslib_1.__exportStar(__webpack_require__(26511), exports);
tslib_1.__exportStar(__webpack_require__(69745), exports);
tslib_1.__exportStar(__webpack_require__(68692), exports);
tslib_1.__exportStar(__webpack_require__(72249), exports);
tslib_1.__exportStar(__webpack_require__(11350), exports);
tslib_1.__exportStar(__webpack_require__(44471), exports);
tslib_1.__exportStar(__webpack_require__(95153), exports);
tslib_1.__exportStar(__webpack_require__(77411), exports);
tslib_1.__exportStar(__webpack_require__(70339), exports);
tslib_1.__exportStar(__webpack_require__(79249), exports);
tslib_1.__exportStar(__webpack_require__(42177), exports); // no-op
tslib_1.__exportStar(__webpack_require__(69997), exports); // no-op
tslib_1.__exportStar(__webpack_require__(91899), exports);
tslib_1.__exportStar(__webpack_require__(24502), exports);
tslib_1.__exportStar(__webpack_require__(70364), exports);
tslib_1.__exportStar(__webpack_require__(65201), exports);
tslib_1.__exportStar(__webpack_require__(76307), exports);
tslib_1.__exportStar(__webpack_require__(10579), exports);
tslib_1.__exportStar(__webpack_require__(67759), exports);
tslib_1.__exportStar(__webpack_require__(50684), exports);
tslib_1.__exportStar(__webpack_require__(83781), exports);
tslib_1.__exportStar(__webpack_require__(96442), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 67542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCart = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCart = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cart = (0, store_1.useRecoilValue)(store_1.default.cart);
    const cartItems = (0, store_1.useRecoilValue)(store_1.default.cartItems$());
    return isMounted && cart ? { ...cart, lines: cartItems } : null;
};
exports.useCart = useCart;
//# sourceMappingURL=useCart.js.map

/***/ }),

/***/ 91899:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddAttributes = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateAttributes_1 = __webpack_require__(70364);
const useCartAddAttributes = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({
        ...options,
        id: 'cart/addAttributes',
    });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const existingAttributes = (0, store_1.useRecoilValue)(store_1.default.cartAttributes$);
    const { cartUpdateAttributes } = (0, useCartUpdateAttributes_1.useCartUpdateAttributes)();
    const cartAddAttributes = (0, react_1.useCallback)(async (data, callback) => {
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data: {
                    validationErrors = [
                        `parameter is required; must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                case typeof data !== 'object': {
                    validationErrors = [
                        `parameter must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                case !data?.attributes: {
                    validationErrors = [
                        `"attributes" is required in parameter object, e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                case !Array.isArray(data?.attributes): {
                    validationErrors = [
                        `"attributes" must be an array, e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const updatedCart = await cartUpdateAttributes({
                attributes: [...existingAttributes, ...data.attributes],
            });
            if (!updatedCart || !updatedCart?.id) {
                throw new Error('Invalid cart add attributes response');
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartAddAttributes:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    return {
        cartAddAttributes,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCartAddAttributes = useCartAddAttributes;
//# sourceMappingURL=useCartAddAttributes.js.map

/***/ }),

/***/ 77411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddDiscount = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartAddDiscount = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/addDiscount' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartAddDiscount = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "discountCode", e.g. "{ discountCode: 'abc123' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "discountCode", e.g. "{ discountCode: 'abc123' }"`,
                    ];
                    break;
                case !data?.discountCode: {
                    validationErrors = [
                        `"discountCode" is required in parameter object, e.g. "{ discountCode: 'abc123' }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateDiscount(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart note update response for note ${data?.note}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartAddDiscount:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartAddDiscount,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCartAddDiscount = useCartAddDiscount;
//# sourceMappingURL=useCartAddDiscount.js.map

/***/ }),

/***/ 70339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddDiscountUrl = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-unused-expressions */
const router_1 = __webpack_require__(86677);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartAddDiscount_1 = __webpack_require__(77411);
const DEBUG = false;
const defaultProps = {
    queryParams: ['discount_code', 'discountCode'],
    removeParams: true,
};
/**
  looks for ?discountCode=xyz and attempts to apply it to the cart
  if we want to use another param we can pass it to this hook via queryParams
  e.g — useCartAddDiscountUrl({ queryParams: ['promo'] }) -> would work on  https..?promo=PACK_TEST
*/
const useCartAddDiscountUrl = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const cartId = (0, store_1.useRecoilValue)(store_1.default.cartId$);
    const [appliedDiscount, setApplied] = (0, react_1.useState)();
    const router = (0, router_1.useRouter)();
    const { cartAddDiscount } = (0, useCartAddDiscount_1.useCartAddDiscount)();
    const applyDiscountCodeOnMount = async () => {
        // already has a discount applied
        if (appliedDiscount || !cartId) {
            return null;
        }
        try {
            // search url params for a discount param, continue after the first find.
            const discountCode = Object.keys(router.query).reduce((_code, param) => {
                const isDiscountParam = props.queryParams.includes(param);
                if (_code)
                    return _code;
                if (isDiscountParam) {
                    const code = router.query[param];
                    return code;
                }
                return _code;
            }, null);
            DEBUG && console.log('useCartAddDiscountUrl:discountCode', discountCode);
            // eslint-disable-next-line prettier/prettier
            DEBUG && console.log(`useCartAddDiscountUrl: detected discount code ${discountCode} in a param(s) ${props.queryParams.join(',')}`);
            if (!discountCode)
                return null;
            DEBUG && console.log('useCartAddDiscountUrl: applying discount...');
            const cartWithDiscount = await cartAddDiscount({
                discountCode,
                checkoutId: cartId,
            });
            // eslint-disable-next-line prettier/prettier
            DEBUG && console.log('useCartAddDiscountUrl: discount application response', cartWithDiscount);
            // check if invalid discountCode provided
            if (!cartWithDiscount?.discountApplications?.length) {
                setApplied(false);
                // eslint-disable-next-line prettier/prettier
                DEBUG && console.log('useCartAddDiscountUrl: discount code application failed');
                return null;
            }
            DEBUG && console.log('useCartAddDiscountUrl: discount code applied!');
            const [base, params] = router.asPath.split('?');
            // if we have url param(s)
            if (params?.length && props.removeParams) {
                const cleanParams = new URLSearchParams(params);
                // remove promo from url after its been applied
                props.queryParams.forEach((param) => {
                    cleanParams.delete(param);
                });
                // if we still have other params after removing the discount one we keep them
                if (cleanParams.toString().length) {
                    // eslint-disable-next-line prettier/prettier
                    router.replace(`${base}?${cleanParams}`, undefined, { shallow: true });
                }
                else {
                    router.replace(`${base}`, undefined, { shallow: true });
                }
            }
            const appliedCode = cartWithDiscount.discountApplications[0];
            setApplied(appliedCode);
            return appliedCode;
        }
        catch (error) {
            setApplied(false);
            return null;
        }
    };
    (0, react_1.useEffect)(() => {
        applyDiscountCodeOnMount();
    }, [Object.keys(router.query).join(','), cartId]);
    return appliedDiscount;
};
exports.useCartAddDiscountUrl = useCartAddDiscountUrl;
//# sourceMappingURL=useCartAddDiscountUrl.js.map

/***/ }),

/***/ 42177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddGiftCard = void 0;
const react_1 = __webpack_require__(27378);
const useCartAddGiftCard = () => {
    (0, react_1.useEffect)(() => {
        console.warn('Cart giftcards are not yet supported on Cart API (v2)');
    }, []);
    return {
        cartAddGiftCard: null,
    };
};
exports.useCartAddGiftCard = useCartAddGiftCard;
//# sourceMappingURL=useCartAddGiftCard.js.map

/***/ }),

/***/ 76307:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddItem = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const helpers_1 = __webpack_require__(85542);
const useCartAddItem = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/addItem' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartAddItem = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        // current cart
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "merchandiseId" and "quantity", e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "merchandiseId" and "quantity", e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                case !data?.merchandiseId:
                    validationErrors = [
                        `"merchandiseId" is required in parameter object, e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                case !data?.quantity:
                    validationErrors = [
                        `"quantity" is required in parameter object, e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const _cart = snapshot.getLoadable(store_1.default.cart).contents;
            const { itemInCart, attributes, haveSameAttributes } = (0, helpers_1.getAddAction)({
                cart: _cart,
                data,
            });
            const addItemPromise = store_1.default.cartAddItem({
                ...data,
                attributes,
            });
            const updateItemPromise = store_1.default.cartUpdateItem({
                ...data,
                lineId: itemInCart?.id,
                quantity: data.quantity + (itemInCart?.quantity || 0),
                attributes,
            });
            const updateExisting = itemInCart && haveSameAttributes;
            // update existing cart item if already in cart
            const { error, updatedCart } = updateExisting
                ? await snapshot.getPromise(updateItemPromise) // update existing item
                : await snapshot.getPromise(addItemPromise); // add the item
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart add item response for merchandiseId ${data?.merchandiseId}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartAddItem:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartAddItem,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useCartAddItem = useCartAddItem;
//# sourceMappingURL=useCartAddItem.js.map

/***/ }),

/***/ 10579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddItems = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-await-in-loop */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const helpers_1 = __webpack_require__(85542);
const useCartAddItems = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/addItems' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartAddItems = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an array of objects with "merchandiseId" and "quantity", e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                case !Array.isArray(data):
                    validationErrors = [
                        `parameter must be an array of objects with "merchandiseId" and "quantity", e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                case !data?.length:
                    validationErrors = [
                        `parameter array must have at least one item to add, e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                // check all passed items to add have a variantId prop
                case data?.some((item) => !item?.merchandiseId):
                    validationErrors = [
                        `"merchandiseId" is required in every object in parameter array, e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                // check all passed items to add have a quantity prop
                case data?.some((item) => !item?.quantity):
                    validationErrors = [
                        `"quantity" is required in every object in parameter array, e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const results = [];
            // add or update each line item
            for (let index = 0; index < data.length; index += 1) {
                const currentItem = data[index];
                const _cart = snapshot.getLoadable(store_1.default.cart).contents;
                const { itemInCart, attributes, haveSameAttributes } = (0, helpers_1.getAddAction)({
                    cart: _cart,
                    data: currentItem,
                });
                const addItemPromise = store_1.default.cartAddItem({
                    ...currentItem,
                    quantity: itemInCart && haveSameAttributes
                        ? itemInCart.quantity + currentItem.quantity
                        : currentItem.quantity,
                    attributes,
                });
                const updateItemPromise = store_1.default.cartUpdateItem({
                    lineId: itemInCart?.id,
                    quantity: currentItem.quantity + (itemInCart?.quantity || 0),
                    attributes,
                });
                // update existing cart item if already in cart
                const { error, updatedCart } = itemInCart && haveSameAttributes
                    ? await snapshot.getPromise(updateItemPromise) // update existing item
                    : await snapshot.getPromise(addItemPromise); // add the item
                if (error) {
                    throw new Error(error);
                }
                if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                    throw new Error(`Failed to add item with id ${currentItem.merchandiseId}`);
                }
                else {
                    results.push(updatedCart);
                    snapshot.map(({ set }) => set(store_1.default.cart, updatedCart));
                }
            }
            const isValidCart = (cart) => cart && cart?.id;
            const success = results.filter(isValidCart).filter(Boolean).length === data?.length;
            if (!success) {
                throw new Error('Invalid add line items cart response');
            }
            const cart = results[results.length - 1];
            setFinished(true);
            setCart(cart);
            if (callback)
                callback(cart);
            return cart;
        }
        catch (error) {
            console.error('cartAddItems:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartAddItems,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartAddItems = useCartAddItems;
//# sourceMappingURL=useCartAddItems.js.map

/***/ }),

/***/ 26511:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAttributes = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartAttributes = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartAttributes = (0, store_1.useRecoilValue)(store_1.default.cartAttributes$);
    return isMounted ? cartAttributes : [];
};
exports.useCartAttributes = useCartAttributes;
//# sourceMappingURL=useCartAttributes.js.map

/***/ }),

/***/ 26228:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartBuyer = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartBuyer = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartBuyer = (0, store_1.useRecoilValue)(store_1.default.cartBuyer);
    return isMounted ? cartBuyer : null;
};
exports.useCartBuyer = useCartBuyer;
//# sourceMappingURL=useCartBuyer.js.map

/***/ }),

/***/ 95153:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartCheckout = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartCheckout = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/checkout' });
    const cartCheckoutUrl = (0, store_1.useRecoilValue)(store_1.default.cartCheckoutUrl$);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const setCartCheckout = (0, store_1.useSetRecoilState)(store_1.default.cartCheckout);
    // attempts to redirect the user to the checkout logged in (with Shopify+ multi-pass token)
    const cartCheckout = (0, react_1.useCallback)(async (data, callback) => {
        const redirect = typeof data?.redirect !== 'undefined' ? data?.redirect : true;
        let loggedOutCartCheckout;
        let checkoutUrl = cartCheckoutUrl; // e.g — storefront.myshopify.com
        // if we have cart domain we modify the checkout url host — e.g shop.storefront.com
        if (true) {
            checkoutUrl = new URL(cartCheckoutUrl);
            checkoutUrl.host = "shop.briogeohair.com";
        }
        const maybeCheckoutViaMultiPass = async () => {
            // data for multi-pass token
            const multiPassCustomer = {
                email: customer.email,
                addresses: customer.defaultAddress ? [customer.defaultAddress] : [],
                firstName: customer.firstName,
                lastName: customer.lastName,
                acceptsMarketing: customer.acceptsMarketing,
                return_to: checkoutUrl,
                tag_string: customer.tags.join(', '),
                created_at: new Date().toISOString(),
            };
            if (!multiPassCustomer)
                throw new Error('Missing multiPassCustomer');
            // fetch an authenticated multipass token from our api
            const multiPassReq = await fetch('/api/multipass', {
                method: 'POST',
                body: JSON.stringify(multiPassCustomer),
            });
            const multiPass = await multiPassReq.json();
            if (multiPassReq?.status !== 200) {
                console.log(`Checking out without multipass (401):`, multiPass.error);
                setErrors([`multipass api failed: ${multiPass.error}`]);
                setFinished(true);
                setCartCheckout(loggedOutCartCheckout);
                if (callback)
                    callback(checkoutUrl);
                return checkoutUrl;
            }
            if (multiPass?.error) {
                setErrors(['There was an error creating a multipass token']);
                setFinished(true);
                setCartCheckout(loggedOutCartCheckout);
                if (callback)
                    callback(checkoutUrl);
                return checkoutUrl;
            }
            if (multiPass?.url) {
                // got multi-pass url, go to checkout with multi-pass
                setFinished(true);
                const checkout = {
                    url: multiPass.url,
                    multiPass: true,
                    redirect,
                };
                setCartCheckout(checkout);
                if (callback)
                    callback(multiPass.url);
                return multiPass.url;
            }
            // just in case
            setFinished(true);
            setCartCheckout(loggedOutCartCheckout);
            if (callback)
                callback(checkoutUrl);
            return checkoutUrl;
        };
        // Attempt to checkout via multipass or regular
        try {
            setStarted(true);
            if (!checkoutUrl) {
                setErrors(['Cart checkoutUrl not provided']);
                return null;
            }
            // default checkout object (if no multipass)
            loggedOutCartCheckout = {
                url: checkoutUrl,
                redirect,
                multiPass: false,
            };
            // only if we have a customer we can attempt to multi-pass checkout
            if (customer) {
                await maybeCheckoutViaMultiPass();
                return true;
            }
            setFinished(true);
            // setting cartCheckout will trigger a redirect (if true)
            setCartCheckout(loggedOutCartCheckout);
            if (callback)
                callback(loggedOutCartCheckout);
            return loggedOutCartCheckout;
        }
        catch (exception) {
            setErrors([exception.message]);
            const checkout = {
                url: checkoutUrl,
                redirect,
                multiPass: false,
            };
            setCartCheckout(checkout);
            return checkout;
        }
    }, [customer, cartCheckoutUrl]);
    return {
        cartCheckout,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartCheckout = useCartCheckout;
//# sourceMappingURL=useCartCheckout.js.map

/***/ }),

/***/ 44471:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartClear = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartRemoveItems_1 = __webpack_require__(50684);
const useCartClear = () => {
    const cart = (0, store_1.useRecoilValue)(store_1.default.cart);
    const { cartRemoveItems, ...removeItemsState } = (0, useCartRemoveItems_1.useCartRemoveItems)();
    const cartClear = (0, react_1.useCallback)(async (callback) => {
        if (!cart?.lines?.length) {
            removeItemsState.setErrors(['Cart is already empty']);
            if (callback)
                callback(null);
            return null;
        }
        const lineIds = cart?.lines.map(({ id }) => id);
        const _cart = await cartRemoveItems({ lineIds });
        if (callback)
            callback(_cart);
        return _cart;
    }, [cart?.lines?.length, removeItemsState]);
    return {
        cartClear,
        ...removeItemsState,
    };
};
exports.useCartClear = useCartClear;
//# sourceMappingURL=useCartClear.js.map

/***/ }),

/***/ 63953:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartCount = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartCount = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartCount = (0, store_1.useRecoilValue)(store_1.default.cartCount$);
    return isMounted ? cartCount : null;
};
exports.useCartCount = useCartCount;
//# sourceMappingURL=useCartCount.js.map

/***/ }),

/***/ 11350:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartCreate = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartCreate = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/create' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // create a new cart with optional email, shippingAddress and note
    const cartCreate = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            const { error, newCart } = await snapshot.getPromise(store_1.default.cartCreate({
                country: data?.country || 'US',
                cartInput: data?.cartInput || {},
            }));
            if (error) {
                throw new Error(error);
            }
            if (!newCart || !newCart?.id || newCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart create response ${newCart}`);
            }
            setFinished(true);
            setCart(newCart);
            if (callback)
                callback(newCart);
            return newCart;
        }
        catch (error) {
            console.error('cartCreate:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartCreate,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartCreate = useCartCreate;
//# sourceMappingURL=useCartCreate.js.map

/***/ }),

/***/ 69745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartDiscounts = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartDiscounts = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartDiscounts = (0, store_1.useRecoilValue)(store_1.default.cartDiscounts$);
    return isMounted ? cartDiscounts : [];
};
exports.useCartDiscounts = useCartDiscounts;
//# sourceMappingURL=useCartDiscounts.js.map

/***/ }),

/***/ 88587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartEmail = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartEmail = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartEmail = (0, store_1.useRecoilValue)(store_1.default.cartEmail$);
    return isMounted ? cartEmail : null;
};
exports.useCartEmail = useCartEmail;
//# sourceMappingURL=useCartEmail.js.map

/***/ }),

/***/ 82914:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartEmpty = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartEmpty = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartEmpty = (0, store_1.useRecoilValue)(store_1.default.cartEmpty$);
    return isMounted ? cartEmpty : null;
};
exports.useCartEmpty = useCartEmpty;
//# sourceMappingURL=useCartEmpty.js.map

/***/ }),

/***/ 72249:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartGet = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartGet = (options) => {
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    const countryCode = country?.isoCode || 'US';
    const currencyCode = country?.currency?.isoCode || 'USD';
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({
        ...options,
        id: `cart/get/${countryCode}/${currencyCode}`,
    });
    // fetch an existing cart using a checkoutId
    const cartGet = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "id", e.g. "{ id: 'abc123' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "id", e.g. "{ id: 'abc123' }"`,
                    ];
                    break;
                case !data?.id: {
                    validationErrors = [
                        `"id" is required in parameter object, e.g. "{ id: 'abc123' }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, existingCart } = await snapshot.getPromise(store_1.default.cartGet({ id: data?.id || null }));
            if (error) {
                throw new Error(error);
            }
            if (!existingCart || existingCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart fetch response for id: ${data?.id}`);
            }
            setFinished(true);
            setCart(existingCart);
            if (callback)
                callback(existingCart);
            return existingCart;
        }
        catch (error) {
            console.error('cartGet:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartGet,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartGet = useCartGet;
//# sourceMappingURL=useCartGet.js.map

/***/ }),

/***/ 13015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartGiftCards = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
// Not yet supported on CART API
const useCartGiftCards = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const giftCards = (0, store_1.useRecoilValue)(store_1.default.cartGiftCards$);
    return isMounted ? giftCards : [];
};
exports.useCartGiftCards = useCartGiftCards;
//# sourceMappingURL=useCartGiftCards.js.map

/***/ }),

/***/ 69659:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartId = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartId = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartId = (0, store_1.useRecoilValue)(store_1.default.cart)?.id;
    return isMounted ? cartId : null;
};
exports.useCartId = useCartId;
//# sourceMappingURL=useCartId.js.map

/***/ }),

/***/ 68692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartInit = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-unused-expressions */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartGet_1 = __webpack_require__(72249);
const useCartCreate_1 = __webpack_require__(11350);
const DEBUG = false;
const defaultProps = {
    fetchOnMount: false,
    options: {},
};
const useCartInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const initializing = (0, react_1.useRef)(false);
    const setCustomerAndCartInit = (0, store_1.useSetRecoilState)(store_1.default.customerAndCartInit);
    const customerInit = (0, store_1.useRecoilValue)(store_1.default.customerInit);
    const [cartInit, setCartInit] = (0, store_1.useRecoilState)(store_1.default.cartInit);
    const [cart, setCart] = (0, store_1.useRecoilState)(store_1.default.cart);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const { cartGet, ...carGetStatus } = (0, useCartGet_1.useCartGet)();
    const { cartCreate, ...carCreateStatus } = (0, useCartCreate_1.useCartCreate)();
    const getCartAction = (0, react_1.useCallback)((_cart) => {
        // only run when customer has been initialized
        const thenDaysAgo = new Date();
        thenDaysAgo.setDate(thenDaysAgo.getDate() - 10);
        const createdAt = _cart?.createdAt ? new Date(_cart.createdAt) : new Date();
        // validations
        const noPersistedCart = !_cart;
        const cartPurchased = _cart?.completedAt || false;
        const persistedCartInvalid = !_cart?.id || (_cart?.__typename && _cart.__typename !== 'Cart');
        const isTenDaysOld = createdAt < thenDaysAgo;
        // any true returns true
        const shouldCreate = [
            noPersistedCart,
            cartPurchased,
            persistedCartInvalid,
            isTenDaysOld,
        ].some(Boolean);
        if (shouldCreate) {
            let createReason = null;
            if (noPersistedCart) {
                createReason = "Don't have a persisted cart, creating new cart...";
            }
            else if (persistedCartInvalid) {
                createReason =
                    'Have persisted cart, buts its invalid. creating new cart...';
            }
            else if (cartPurchased) {
                createReason =
                    'Have persisted cart but its been purchased, creating new cart...';
            }
            else if (isTenDaysOld) {
                createReason =
                    'Have expired persisted cart (10+ days old), creating new cart...';
            }
            // just for troubleshooting
            DEBUG &&
                createReason &&
                console.log(`🛒 cart init: creating new cart due: ${createReason}`);
        }
        return shouldCreate;
    }, []);
    const createNewCart = (0, react_1.useCallback)(async ({ email, attempt = 0 }) => {
        const maxRetries = 2;
        let newCart = null;
        if (attempt >= maxRetries) {
            setCartInit(false);
            return null;
        }
        newCart = await cartCreate({
            cartInput: email ? { buyerIdentity: { email } } : {},
        });
        if (newCart?.id) {
            setCartInit(true);
            return newCart;
        }
        // if we fail to create we should retry one more time
        return createNewCart({
            email,
            attempt: attempt + 1,
        });
    }, []);
    const createOrGetCartOnCustomerInit = () => {
        if (!props.fetchOnMount)
            return;
        if (!customerInit)
            return;
        if (initializing.current)
            return;
        if (cartInit) {
            setCustomerAndCartInit(true); // set for analytics (customer event)
            return;
        }
        initializing.current = true;
        const validatePersistedCartAndReuseOrCreate = async () => {
            const existingCart = await cartGet({ id: cart.id });
            if (existingCart?.id) {
                setCart(existingCart);
                setCartInit(true);
                return;
            }
            if (!existingCart) {
                setCart(null);
                await createNewCart({ email: customer?.email, attempt: 1 });
            }
        };
        if (getCartAction(cart)) {
            createNewCart({ email: customer?.email, attempt: 1 });
        }
        else {
            validatePersistedCartAndReuseOrCreate();
        }
    };
    (0, react_1.useEffect)(() => {
        createOrGetCartOnCustomerInit();
    }, [customerInit, cartInit, cart, customer, props?.fetchOnMount]);
    // no bueno if we get here
    const cartInitErrorHandler = () => {
        // todo: currently if we error and then retry and succeed this would still show the initial error
        const anyErrors = carGetStatus?.errors?.length || carCreateStatus?.errors?.length;
        if (anyErrors) {
            console.groupCollapsed('🛒 cart init: failed 🚫');
            carGetStatus?.errors &&
                console.log('🛒 cart init: get errors:\t\t\t', carGetStatus?.errors);
            carCreateStatus?.errors &&
                console.log('🛒 cart init: create errors:\t\t\t', carCreateStatus?.errors);
            console.groupEnd();
        }
    };
    (0, react_1.useEffect)(() => {
        cartInitErrorHandler();
    }, [carGetStatus?.errors?.length, carCreateStatus?.errors?.length]);
    return cart;
};
exports.useCartInit = useCartInit;
//# sourceMappingURL=useCartInit.js.map

/***/ }),

/***/ 83061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartItem = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartItem = ({ id } = { id: null }) => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartItem = (0, store_1.useRecoilValue)(store_1.default.cartItem$({ id }));
    return isMounted && id ? cartItem : null;
};
exports.useCartItem = useCartItem;
//# sourceMappingURL=useCartItem.js.map

/***/ }),

/***/ 53660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartItems = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartItems = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartItems = (0, store_1.useRecoilValue)(store_1.default.cartItems$());
    return isMounted ? cartItems : [];
};
exports.useCartItems = useCartItems;
//# sourceMappingURL=useCartItems.js.map

/***/ }),

/***/ 24502:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveAttributes = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateAttributes_1 = __webpack_require__(70364);
const useCartRemoveAttributes = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeAttribute' });
    // action
    const existingCustomAttributes = (0, store_1.useRecoilValue)(store_1.default.cartAttributes$);
    const { cartUpdateAttributes } = (0, useCartUpdateAttributes_1.useCartUpdateAttributes)();
    const cartRemoveAttributes = (0, react_1.useCallback)(async (data, callback) => {
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "attributeKeys", e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "attributeKeys", e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case !Array.isArray(data?.attributeKeys):
                    validationErrors = [
                        `"attributeKeys" must be an array of strings, e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case !data?.attributeKeys?.length:
                    validationErrors = [
                        `"attributeKeys" must have at least one key, e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case data?.attributeKeys?.some((key) => typeof key !== 'string'):
                    validationErrors = [
                        `Every key in "attributeKeys" must be a string, e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            // filter out attributes to remove
            const updatedAttributes = existingCustomAttributes.filter((attribute) => {
                try {
                    const markedForRemoval = data.attributeKeys.includes(attribute.key);
                    return !markedForRemoval;
                }
                catch (error) {
                    return true;
                }
            });
            const cartAttributes = await cartUpdateAttributes({
                attributes: updatedAttributes,
            });
            if (cartAttributes?.type?.name !== 'Attribute') {
                throw new Error('Invalid cart delete attributes response');
            }
            setFinished(true);
            // cartUpdateAttributes will updated the cart via setCart(cart)
            if (callback)
                callback(cartAttributes);
            return cartAttributes;
        }
        catch (error) {
            console.error('cartRemoveAttributes:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    return {
        cartRemoveAttributes,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveAttributes = useCartRemoveAttributes;
//# sourceMappingURL=useCartRemoveAttributes.js.map

/***/ }),

/***/ 79249:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveDiscount = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartRemoveDiscount = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeDiscount' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartRemoveDiscount = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartRemoveDiscount());
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || !updatedCart?.id) {
                throw new Error('Invalid discount remove response');
            }
            setFinished(true);
            // not triggering an update of side effects for some reason
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartRemoveDiscount:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartRemoveDiscount,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveDiscount = useCartRemoveDiscount;
//# sourceMappingURL=useCartRemoveDiscount.js.map

/***/ }),

/***/ 69997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveGiftCard = void 0;
const react_1 = __webpack_require__(27378);
const useCartRemoveGiftCard = () => {
    (0, react_1.useEffect)(() => {
        console.warn('Cart giftcards are not yet supported on Cart API (v2)');
    }, []);
    return {
        cartRemoveGiftCard: null,
    };
};
exports.useCartRemoveGiftCard = useCartRemoveGiftCard;
//# sourceMappingURL=useCartRemoveGiftCard.js.map

/***/ }),

/***/ 67759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveItem = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartRemoveItem = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeItem' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartRemoveItem = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "lineId", e.g. "{ lineId: 'abc123' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "lineId", e.g. "{ lineId: 'abc123' }"`,
                    ];
                    break;
                case !data?.lineId:
                    validationErrors = [
                        `"lineId" is required in parameter object, e.g. "{ lineId: 'abc123' }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartRemoveItem(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart remove item response for lineId ${data?.lineId}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartRemoveItem:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartRemoveItem,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveItem = useCartRemoveItem;
//# sourceMappingURL=useCartRemoveItem.js.map

/***/ }),

/***/ 50684:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveItems = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartRemoveItems = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeItems' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartRemoveItems = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "lineIds", e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "lineIds", e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case !data?.lineIds:
                    validationErrors = [
                        `"lineIds" is required in parameter object, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case !Array.isArray(data?.lineIds):
                    validationErrors = [
                        `"lineIds" must be an array of strings, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case !data?.lineIds?.length:
                    validationErrors = [
                        `"lineIds" must have at least one line id to remove, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case data?.lineIds?.some((lineId) => typeof lineId !== 'string'):
                    validationErrors = [
                        `Every line id in "lineIds" must be a string, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartRemoveItems(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart remove items response for lineIds ${data?.lineIds}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartRemoveItems:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartRemoveItems,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveItems = useCartRemoveItems;
//# sourceMappingURL=useCartRemoveItems.js.map

/***/ }),

/***/ 74420:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const DEBUG = false;
const useCartStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.cartStatusStarted('cart/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.cartStatusFinished('cart/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.cartStatusSuccess('cart/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.cartStatusErrors('cart/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.cartStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.cartStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.cartStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.cartStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useCartStartFinishErrors = useCartStartFinishErrors;
//# sourceMappingURL=useCartStartFinishErrors.js.map

/***/ }),

/***/ 91887:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartStatus = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
// global status of the cart, any cart action will trigger
// these states via useRecoilStartFinishErrors.js
const useCartStatus = () => {
    return {
        started: (0, store_1.useRecoilValue)(store_1.default.cartStatusStarted('cart/all')),
        finished: (0, store_1.useRecoilValue)(store_1.default.cartStatusFinished('cart/all')),
        success: (0, store_1.useRecoilValue)(store_1.default.cartStatusSuccess('cart/all')),
        errors: (0, store_1.useRecoilValue)(store_1.default.cartStatusErrors('cart/all')),
    };
};
exports.useCartStatus = useCartStatus;
//# sourceMappingURL=useCartStatus.js.map

/***/ }),

/***/ 10295:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartTotalPrice = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartTotalPrice = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartTotalPrice = (0, store_1.useRecoilValue)(store_1.default.cartTotal$);
    return isMounted ? cartTotalPrice : null;
};
exports.useCartTotalPrice = useCartTotalPrice;
//# sourceMappingURL=useCartTotalPrice.js.map

/***/ }),

/***/ 87892:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartTotals = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
// not localized
const useCartTotals = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const _cart = (0, store_1.useRecoilValue)(store_1.default.cart);
    const cartTotal = (0, store_1.useRecoilValue)(store_1.default.cartTotal$);
    const cartSubtotal = (0, store_1.useRecoilValue)(store_1.default.cartSubtotal$);
    const cartTax = (0, store_1.useRecoilValue)(store_1.default.cartTax$);
    const cartDuty = (0, store_1.useRecoilValue)(store_1.default.cartDuty$);
    const cartDiscountTotal = (0, store_1.useRecoilValue)(store_1.default.cartDiscountTotal$);
    return _cart && isMounted
        ? {
            total: cartTotal,
            subtotal: cartSubtotal,
            duty: cartDuty,
            tax: cartTax,
            discount: cartDiscountTotal,
        }
        : {
            total: 0,
            subtotal: 0,
            duty: 0,
            tax: 0,
            discount: 0,
        };
};
exports.useCartTotals = useCartTotals;
//# sourceMappingURL=useCartTotals.js.map

/***/ }),

/***/ 70364:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateAttributes = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateAttributes = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateAttributes' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartUpdateAttributes = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data: {
                    validationErrors = [
                        `parameter is required; must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                case typeof data !== 'object': {
                    validationErrors = [
                        `parameter must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                case !data?.attributes: {
                    validationErrors = [
                        `"attributes" is required in parameter object, e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                case !Array.isArray(data?.attributes): {
                    validationErrors = [
                        `"attributes" must be an array, e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateAttributes(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart attributes update response for ${data?.attributes}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartUpdateAttributes:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateAttributes,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateAttributes = useCartUpdateAttributes;
//# sourceMappingURL=useCartUpdateAttributes.js.map

/***/ }),

/***/ 44717:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateBuyerIdentity = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateBuyerIdentity = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateBuyerIdentity' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartUpdateBuyerIdentity = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data: {
                    validationErrors = [
                        'parameter is required; must be an object with "buyerIdentity", e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                case typeof data !== 'object': {
                    validationErrors = [
                        'parameter must be an object with "buyerIdentity", e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                case !data?.buyerIdentity: {
                    validationErrors = [
                        '"buyerIdentity" is required in parameter object, e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                case typeof data?.buyerIdentity !== 'object': {
                    validationErrors = [
                        '"buyerIdentity" must be an object, e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateBuyerIdentity(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart buyerIdentity update response for ${data?.buyerIdentity}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartUpdateBuyerIdentity:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateBuyerIdentity,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateBuyerIdentity = useCartUpdateBuyerIdentity;
//# sourceMappingURL=useCartUpdateBuyerIdentity.js.map

/***/ }),

/***/ 83781:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateItem = void 0;
const tslib_1 = __webpack_require__(59312);
const deepmerge_1 = tslib_1.__importDefault(__webpack_require__(20406));
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateItem = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateItem' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartUpdateItem = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "lineId", e.g. "{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "lineId", e.g. "{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }"`,
                    ];
                    break;
                case !data?.lineId:
                    validationErrors = [
                        `"lineId" is required in parameter object, e.g. "{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }"`,
                    ];
                    break;
                // quantity, attributes, merchandiseId, sellingPlanId are optional
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const _cart = snapshot.getLoadable(store_1.default.cart).contents;
            // find the item to update and merge in the updated props
            const updatedItemData = _cart.lines
                .filter((_line) => _line.id === data.lineId)
                .map((line) => (0, deepmerge_1.default)(line, data))[0];
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateItem(updatedItemData));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart update item response for merchandiseId ${data?.id}`);
            }
            setFinished(true);
            setCart(updatedCart);
            const updatedItem = updatedCart.lines.find((item) => item.id === data?.lineId) || null;
            if (callback)
                callback(updatedItem);
            return updatedItem;
        }
        catch (error) {
            console.error('cartUpdateItem:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateItem,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateItem = useCartUpdateItem;
//# sourceMappingURL=useCartUpdateItem.js.map

/***/ }),

/***/ 96442:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateItems = void 0;
const tslib_1 = __webpack_require__(59312);
const deepmerge_1 = tslib_1.__importDefault(__webpack_require__(20406));
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateItems = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateItems' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartUpdateItems = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an array of objects with "lineId", e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                case !Array.isArray(data):
                    validationErrors = [
                        `parameter must be an array of objects with "lineId", e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                case !data?.length:
                    validationErrors = [
                        `parameter array must have at least one item to update, e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                case data?.some((item) => !item?.lineId):
                    validationErrors = [
                        `"lineId" is required in every object in parameter array, e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                // there's other check we could do like checking quantity is an integer,
                // attributes and array and sellingPlanId a string
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const _cart = snapshot.getLoadable(store_1.default.cart).contents;
            const lines = _cart.lines.map((_line) => {
                const updatingLine = data.find((_updatingLine) => _updatingLine.lineId === _line.id);
                if (!updatingLine) {
                    return _line;
                }
                return (0, deepmerge_1.default)(_line, updatingLine);
            });
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateItems({ lines }));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart lines update response`);
            }
            setFinished(true);
            setCart(updatedCart);
            const updatingItemIds = data.map((line) => line.lineId);
            const updatedItems = updatedCart.lines.filter((item) => updatingItemIds.includes(item.id)) || [null];
            if (callback)
                callback(updatedItems);
            return updatedItems;
        }
        catch (error) {
            console.error('cartUpdateItems:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateItems,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateItems = useCartUpdateItems;
//# sourceMappingURL=useCartUpdateItems.js.map

/***/ }),

/***/ 65201:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateNote = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateNote = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateNote' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartUpdateNote = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "note", e.g. "{ note: 'hello' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "note", e.g. "{ note: 'hello' }"`,
                    ];
                    break;
                case !data?.note: {
                    validationErrors = [
                        `"note" is required in parameter object, e.g. "{ note: 'hello' }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateNote(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart note update response for note ${data?.note}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart.note);
            return updatedCart.note;
        }
        catch (error) {
            console.error('cartUpdateNote:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateNote,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateNote = useCartUpdateNote;
//# sourceMappingURL=useCartUpdateNote.js.map

/***/ }),

/***/ 13437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdatedAt = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartUpdatedAt = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartUpdatedAt = (0, store_1.useRecoilValue)(store_1.default.cart)?.updatedAt;
    return isMounted ? cartUpdatedAt : null;
};
exports.useCartUpdatedAt = useCartUpdatedAt;
//# sourceMappingURL=useCartUpdatedAt.js.map

/***/ }),

/***/ 74021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cartStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const atob_1 = tslib_1.__importDefault(__webpack_require__(88981));
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
const store_1 = __webpack_require__(20437);
const client_1 = __webpack_require__(4812);
const client_2 = __webpack_require__(25431);
const cartClient = new client_1.CartClient({
    apiToken: "60385688208d54f843f3c3cb36d767b2",
    apiVersion: '2025-04',
    domain: "shop.briogeohair.com" || 0,
});
const productClient = new client_2.ProductClient({
    apiToken: "60385688208d54f843f3c3cb36d767b2",
    apiVersion: '2025-04',
    domain: "briogeo-hair-care.myshopify.com",
});
/**
  CART STATE
*/
const cartInit = (0, recoil_1.atom)({
    key: 'cart/cartInit',
    default: null,
    effects: [
        // effects.logStateChange('cartInit'),
        effects_1.default.onChange({
            key: 'cartInit',
            topic: 'CART_INIT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const cart = (0, recoil_1.atom)({
    key: 'cart/cart',
    default: null,
    effects: [
        // effects.logStateChange('cart'),
        effects_1.default.setSelfToPersistedKey('cart', `Cart|${effects_1.default.SHOPIFY_NAME}`, 'CART_EXISTING'),
        effects_1.default.onSetUpdatePersistedKey(`Cart|${effects_1.default.SHOPIFY_NAME}`),
        effects_1.default.onChange({
            key: 'cart',
            topic: 'CART_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const cartLinePriceIn = (0, recoil_1.atomFamily)({
    key: 'cart/linePriceIn',
    default: null,
});
/* Status */
const cartStatusStarted = (0, recoil_1.atomFamily)({
    key: 'cart/statusStarted',
    default: false,
});
const cartStatusFinished = (0, recoil_1.atomFamily)({
    key: 'cart/statusFinished',
    default: false,
});
const cartStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'cart/statusSuccess',
    default: false,
});
const cartStatusErrors = (0, recoil_1.atomFamily)({
    key: 'cart/statusErrors',
    default: [],
});
const cartCheckout = (0, recoil_1.atom)({
    key: 'cart/checkout',
    default: {
        url: null,
        redirect: true,
        multiPass: undefined,
    },
    effects: [
        effects_1.default.onChange({
            key: 'cartCheckout',
            topic: 'CHECKOUT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
        effects_1.default.onSetRedirectToCheckout(), // last so we have a chance to fire events
    ],
});
/*
  ---------------
  Getters
  ---------------
*/
const cartId$ = (0, recoil_1.selector)({
    key: 'cart/cartId$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart)
            return null;
        return _cart.id;
    },
});
const cartCount$ = (0, recoil_1.selector)({
    key: 'cart/cartCount$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart)
            return 0;
        const { lines = [] } = _cart;
        const accLineTotals = (items, { quantity }) => items + quantity;
        const totalItems = lines?.reduce(accLineTotals, 0);
        return totalItems || 0;
    },
});
const cartLocale$ = (0, recoil_1.selector)({
    key: 'cart/locale$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.locale)
            return null;
        return _cart.locale;
    },
});
const cartEmpty$ = (0, recoil_1.selector)({
    key: 'cart/cartEmpty$',
    get: ({ get }) => {
        const _cartCount = get(cartCount$);
        return _cartCount === 0;
    },
});
// not yet supported on CartAPI
const cartGiftCards$ = (0, recoil_1.selector)({
    key: 'cart/cartGiftCards$',
    get: () => {
        return [];
    },
});
const cartDiscounts$ = (0, recoil_1.selector)({
    key: 'cart/cartDiscounts$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart?.discountCodes || [];
    },
});
const cartAttributes$ = (0, recoil_1.selector)({
    key: 'cartAttributes$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart
            ? _cart.attributes.map(({ key, value }) => ({ key, value }))
            : [];
    },
});
const cartTotal$ = (0, recoil_1.selector)({
    key: 'cart/total$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalAmount.amount;
    },
});
const cartSubtotal$ = (0, recoil_1.selector)({
    key: 'cart/subtotal$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.subtotalAmount?.amount)
            return 0;
        return _cart.estimatedCost.subtotalAmount.amount;
    },
});
const cartTax$ = (0, recoil_1.selector)({
    key: 'cart/tax$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalTaxAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalTaxAmount.amount;
    },
});
const cartDuty$ = (0, recoil_1.selector)({
    key: 'cart/duty$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalDutyAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalDutyAmount.amount;
    },
});
const cartDiscountTotal$ = (0, recoil_1.selector)({
    key: 'cart/discountTotal$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalDiscountAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalDiscountAmount.amount;
    },
});
const cartCheckoutUrl$ = (0, recoil_1.selector)({
    key: 'cart/CheckoutUrl$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart)
            return null;
        return _cart.checkoutUrl;
    },
});
const cartItems$ = (0, recoil_1.selectorFamily)({
    key: 'cart/cartItems$',
    get: () => ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.lines?.length)
            return [];
        return [..._cart.lines].reverse();
    },
});
const cartItem$ = (0, recoil_1.selectorFamily)({
    key: 'cart/cartItem$',
    get: ({ id: desiredItemId }) => function getCallback({ get }) {
        const _cartItems = get(cartItems$);
        // this helps us build  /products/handle?variant=legacyId from cart items
        const convertItemVariantIdsToLegacy = ({ merchandise, ...item }) => ({
            ...item,
            merchandise: {
                ...merchandise,
                id: (0, atob_1.default)(merchandise.id).split('/').pop(),
            },
        });
        return _cartItems.length
            ? _cartItems
                .filter(({ id }) => id === desiredItemId)
                .map(convertItemVariantIdsToLegacy)[0]
            : null;
    },
});
const cartBuyer$ = (0, recoil_1.selector)({
    key: 'cart/cartBuyer$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart.buyerIdentity;
    },
});
const cartEmail$ = (0, recoil_1.selector)({
    key: 'cart/cartEmail$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart?.buyerIdentity?.email ? _cart.buyerIdentity.email : null;
    },
});
/**
 * New async fetchers and setters
 */
const cartCreate = (0, recoil_1.selectorFamily)({
    key: 'cart/create',
    get: ({ country, cartInput }) => async () => {
        return cartClient.create({ country, cartInput });
    },
});
const cartGet = (0, recoil_1.selectorFamily)({
    key: 'cart/get',
    get: ({ id }) => async ({ get }) => {
        const _country = get(store_1.shopStore.country);
        const country = _country;
        return cartClient.get({ id, country: country.isoCode });
    },
});
const cartAddItem = (0, recoil_1.selectorFamily)({
    key: 'cart/addItem',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.addItem({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartAddItems = (0, recoil_1.selectorFamily)({
    key: 'cart/addItems',
    get: ({ lines = [] }) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.addItem({
            cartId: _cartId,
            country: country?.isoCode,
            lines,
        });
    },
});
const cartRemoveItem = (0, recoil_1.selectorFamily)({
    key: 'cart/removeItem',
    get: ({ lineId }) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.removeItem({
            cartId: _cartId,
            country: country?.isoCode,
            lineId,
        });
    },
});
const cartRemoveItems = (0, recoil_1.selectorFamily)({
    key: 'cart/removeItems',
    get: ({ lineIds = [] }) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.removeItems({
            cartId: _cartId,
            country: country?.isoCode,
            lineIds,
        });
    },
});
const cartUpdateItem = (0, recoil_1.selectorFamily)({
    key: 'cart/updateItem',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateItem({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateItems = (0, recoil_1.selectorFamily)({
    key: 'cart/updateItems',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateItems({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateNote = (0, recoil_1.selectorFamily)({
    key: 'cart/updateNote',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateNote({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateDiscount = (0, recoil_1.selectorFamily)({
    key: 'cart/updateDiscount',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateDiscount({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartRemoveDiscount = (0, recoil_1.selectorFamily)({
    key: 'cart/removeDiscount',
    get: () => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.removeDiscount({
            cartId: _cartId,
            country: country?.isoCode,
            discountCodes: [],
        });
    },
});
const cartUpdateAttributes = (0, recoil_1.selectorFamily)({
    key: 'cart/updateAttributes',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateAttributes({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateBuyerIdentity = (0, recoil_1.selectorFamily)({
    key: 'cart/updateBuyerIdentity',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateBuyerIdentity({
            cartId: _cartId,
            country: data?.country || country?.isoCode,
            ...data,
        });
    },
});
const fetchCartLinePriceIn = (0, recoil_1.selectorFamily)({
    key: 'cart/fetchCartLinePriceIn',
    get: (data) => async ({ get }) => {
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const country = get(store_1.shopStore.country);
        const _country = passedCountryCode || country.isoCode || 'US';
        return productClient.getLocalizedProduct({
            ...data,
            country: _country,
        });
    },
});
exports.cartStore = {
    // actual state - atoms
    cart,
    cartInit,
    cartCheckout,
    cartLinePriceIn,
    // status
    cartStatusStarted,
    cartStatusFinished,
    cartStatusSuccess,
    cartStatusErrors,
    // computed utils
    cartLocale$,
    cartBuyer$,
    cartId$,
    cartEmpty$,
    cartCount$,
    cartCheckoutUrl$,
    cartGiftCards$,
    cartAttributes$,
    cartDiscounts$,
    cartItems$,
    cartEmail$,
    cartItem$,
    // computed totals
    cartTotal$,
    cartSubtotal$,
    cartTax$,
    cartDuty$,
    cartDiscountTotal$,
    // Async queries and mutations
    cartCreate,
    cartGet,
    cartAddItem,
    cartAddItems,
    cartRemoveItem,
    cartRemoveItems,
    cartRemoveDiscount,
    cartUpdateItem,
    cartUpdateItems,
    cartUpdateNote,
    cartUpdateDiscount,
    cartUpdateAttributes,
    cartUpdateBuyerIdentity,
    fetchCartLinePriceIn,
};
//# sourceMappingURL=cart.js.map

/***/ }),

/***/ 29005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cartStore = void 0;
var cart_1 = __webpack_require__(74021);
Object.defineProperty(exports, "cartStore", ({ enumerable: true, get: function () { return cart_1.cartStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 50010:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(82311), exports);
tslib_1.__exportStar(__webpack_require__(70673), exports);
tslib_1.__exportStar(__webpack_require__(43301), exports);
tslib_1.__exportStar(__webpack_require__(41198), exports);
tslib_1.__exportStar(__webpack_require__(85583), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82311:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollection = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCollection = () => (0, store_1.useRecoilValue)(store_1.default.collection);
exports.useCollection = useCollection;
//# sourceMappingURL=useCollection.js.map

/***/ }),

/***/ 70673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionByHandle = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const router_1 = __webpack_require__(86677);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const store_2 = __webpack_require__(57152);
const useCollectionByHandle = ({ handle = null, fetchOnMount = true, options, }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const { isPreview } = (0, router_1.useRouter)();
    const setCollections = (0, store_1.useSetRecoilState)(store_1.default.collections);
    const [collection, setCollection] = (0, store_1.useRecoilState)(store_1.default.collectionByHandle$(handle));
    // fetch json collection on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        if (!handle) {
            setErrors(['A collection "handle" must be provided']);
        }
        const earlyExitIf = [
            !fetchOnMount,
            !handle,
            finished && collection?.id, // already have a collection
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionByHandle({ handle, version: 'full' })
            .then((jsonCollection) => {
            // bad response
            if ((!jsonCollection || !jsonCollection?.id) && !unMounting) {
                setErrors(['Invalid collection response']);
            }
            // fetch collection products
            fetch(`/json/collections/products/${jsonCollection.handle}.json`)
                .then((response) => response.json())
                .then((result) => {
                const loadedProducts = isPreview
                    ? result
                    : result.filter((product) => product.status === 'ACTIVE');
                const fullJsonCollection = {
                    ...jsonCollection,
                    products: [...jsonCollection.products, ...loadedProducts],
                };
                if (!unMounting)
                    setCollection(fullJsonCollection);
                if (!unMounting)
                    setFinished(true);
                // all good update collections, which in turns updates
                // the collectionByHandle familiy selector
                if (!unMounting) {
                    setCollections((collections) => ({
                        ...collections,
                        [jsonCollection.handle]: fullJsonCollection,
                    }));
                }
            });
        })
            .catch((error) => {
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, fetchOnMount]);
    return {
        collection: collection || null,
        fetchCollectionByHandle: store_2.collectionActions.fetchCollectionByHandle,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionByHandle = useCollectionByHandle;
//# sourceMappingURL=useCollectionByHandle.js.map

/***/ }),

/***/ 43301:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionHandles = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const store_2 = __webpack_require__(57152);
const useCollectionHandles = ({ fetchOnMount, options } = { fetchOnMount: true, options: null }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const [collectionHandles, setCollectionHandles] = (0, store_1.useRecoilState)(store_1.default.collectionHandles);
    // fetch json collection on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !fetchOnMount,
            finished && collectionHandles?.length, // already have a collection
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionHandles()
            .then((jsonCollectionHandles) => {
            // bad response
            if ((!jsonCollectionHandles || !jsonCollectionHandles?.length) &&
                !unMounting) {
                setErrors(['Invalid collection handles response']);
            }
            if (!unMounting)
                setFinished(true);
            // all good update collections, which in turns updates
            // the collectionByHandle familiy selector
            if (!unMounting)
                setCollectionHandles(jsonCollectionHandles);
        })
            .catch((error) => {
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [fetchOnMount, collectionHandles]);
    return {
        collectionHandles,
        fetchCollectionHandles: store_2.collectionActions.fetchCollectionHandles,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionHandles = useCollectionHandles;
//# sourceMappingURL=useCollectionHandles.js.map

/***/ }),

/***/ 85583:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionsIndex = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const store_2 = __webpack_require__(57152);
const useCollectionsIndex = ({ fetchOnMount, options } = { fetchOnMount: true, options: null }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const [collectionsIndex, setCollectionIndex] = (0, store_1.useRecoilState)(store_1.default.collectionsIndex);
    // fetch json collections on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !fetchOnMount,
            finished && collectionsIndex?.keys, // already have a collections
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionsIndex()
            .then((jsonCollectionIndex) => {
            // bad response
            if ((!jsonCollectionIndex || !jsonCollectionIndex?.keys) &&
                !unMounting) {
                setErrors(['Invalid collections index response']);
            }
            if (!unMounting)
                setFinished(true);
            // all good update collectionss, which in turns updates
            // the collectionsByHandle familiy selector
            if (!unMounting)
                setCollectionIndex(jsonCollectionIndex);
        })
            .catch((error) => {
            console.log('error', error);
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [fetchOnMount, collectionsIndex]);
    return {
        collectionsIndex,
        fetchCollectionsIndex: store_2.collectionActions.fetchCollectionsIndex,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionsIndex = useCollectionsIndex;
//# sourceMappingURL=useCollectionsIndex.js.map

/***/ }),

/***/ 41198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionsList = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const store_2 = __webpack_require__(57152);
const useCollectionsList = ({ fetchOnMount, options } = { fetchOnMount: true, options: null }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const [collectionsList, setCollectionList] = (0, store_1.useRecoilState)(store_1.default.collectionsList);
    // fetch json collections on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !fetchOnMount,
            finished && collectionsList?.length, // already have a collections
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionsList()
            .then((jsonCollectionList) => {
            // bad response
            if ((!jsonCollectionList || !jsonCollectionList?.length) &&
                !unMounting) {
                setErrors(['Invalid collections list response']);
            }
            if (!unMounting)
                setFinished(true);
            // all good update collectionss, which in turns updates
            // the collectionsByHandle familiy selector
            if (!unMounting)
                setCollectionList(jsonCollectionList);
        })
            .catch((error) => {
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [fetchOnMount, collectionsList]);
    return {
        collectionsList,
        fetchCollectionsList: store_2.collectionActions.fetchCollectionsList,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionsList = useCollectionsList;
//# sourceMappingURL=useCollectionsList.js.map

/***/ }),

/***/ 39939:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchCollectionHandles = exports.fetchCollectionsIndex = exports.fetchCollectionsList = exports.fetchCollectionByHandle = void 0;
const fetchCollectionByHandle = async ({ handle }) => {
    if (!handle)
        throw new TypeError('Missing required product "handle"');
    try {
        const url = `/json/collections/${handle}.json`;
        // eslint-disable-next-line no-undef
        const response = await fetch(url);
        if (response?.ok) {
            return await response.json();
        }
        return null;
    }
    catch (error) {
        console.error(`Failed to fetch ${handle} collection due to`, error.message);
        throw error;
    }
};
exports.fetchCollectionByHandle = fetchCollectionByHandle;
// collection listings and index fetch factory
const _fetchCollections = (target) => async () => {
    if (!target)
        throw new TypeError('Missing required collection endpoint "target"');
    try {
        const productUrl = `/json/${target}.json`;
        // eslint-disable-next-line no-undef
        const response = await fetch(productUrl);
        if (response?.ok) {
            return await response.json();
        }
        return null;
    }
    catch (error) {
        console.error(`Failed to fetch ${target} due to`, error.message);
        throw error;
    }
};
// product listings and indexes
exports.fetchCollectionsList = _fetchCollections('collections-list');
exports.fetchCollectionsIndex = _fetchCollections('collections-index');
exports.fetchCollectionHandles = _fetchCollections('collections');
//# sourceMappingURL=actions.js.map

/***/ }),

/***/ 12255:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.collectionStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  Product State
*/
const collection = (0, recoil_1.atom)({
    key: 'collection/collection',
    default: null,
    effects: [
        effects_1.default.onChange({
            key: 'collection',
            topic: 'COLLECTION_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const collections = (0, recoil_1.atom)({
    key: 'collection/collections',
    default: {},
});
const collectionsList = (0, recoil_1.atom)({
    key: 'collection/collectionsList',
    default: [],
});
// collections json fuse index
const collectionsIndex = (0, recoil_1.atom)({
    key: 'collection/collectionsIndex',
    default: null,
});
const collectionHandles = (0, recoil_1.atom)({
    key: 'collection/collectionHandles',
    default: [],
});
const collectionByHandle$ = (0, recoil_1.selectorFamily)({
    key: 'collection/collectionByHandle$',
    get: (handle) => function ({ get }) {
        const _collections = get(collections);
        const _collection = _collections && handle ? _collections[handle] : null;
        return _collection || null;
    },
    set: (handle) => ({ get, set }, newCollection) => {
        const _collections = get(collections);
        if (newCollection && newCollection?.handle && !_collections[handle]) {
            // add collection to cached list
            const _updatedCollections = {
                ..._collections,
                [handle]: newCollection,
            };
            set(collections, _updatedCollections);
            // set collection as default
            set(collection, newCollection);
        }
    },
});
exports.collectionStore = {
    // actual state - atoms
    collection,
    collections,
    collectionHandles,
    collectionsIndex,
    collectionsList,
    collectionByHandle$,
};
//# sourceMappingURL=collection.js.map

/***/ }),

/***/ 57152:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.collectionActions = exports.collectionStore = void 0;
const tslib_1 = __webpack_require__(59312);
var collection_1 = __webpack_require__(12255);
Object.defineProperty(exports, "collectionStore", ({ enumerable: true, get: function () { return collection_1.collectionStore; } }));
exports.collectionActions = tslib_1.__importStar(__webpack_require__(39939));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 86910:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CustomerClient = void 0;
class CustomerClient {
    constructor({ debug }) {
        this.debug = debug || false;
    }
    // eslint-disable-next-line class-methods-use-this
    async customerApi({ endpoint = 'get', body }) {
        const method = 'POST';
        const url = `/api/customer/${endpoint}`;
        const headers = { 'Content-Type': 'application/json' };
        try {
            // eslint-disable-next-line no-undef
            const request = await fetch(url, {
                method,
                headers,
                body: JSON.stringify(body),
            });
            if (!request?.ok) {
                throw new Error(`${endpoint} request not ok`);
            }
            const data = await request.json();
            if (this.debug) {
                console.log(`CustomerClient: ${url}`, body);
            }
            const { ok, errors, response } = data;
            if (errors?.length) {
                throw new Error(errors[0]);
            }
            if (!ok) {
                throw new Error(`${endpoint} response not ok`);
            }
            return { error: null, data: response };
        }
        catch (error) {
            console.log(`CustomerClient: ${url}/error: ${error.message}`);
            return { error: error.message, data: null };
        }
    }
    // Customer
    async activate(body) {
        return this.customerApi({ endpoint: 'activate', body });
    }
    async get(body) {
        return this.customerApi({ endpoint: 'get', body });
    }
    async login(body) {
        return this.customerApi({ endpoint: 'login', body });
    }
    async create(body) {
        return this.customerApi({ endpoint: 'create', body });
    }
    async update(body) {
        return this.customerApi({ endpoint: 'update', body });
    }
    async orders(body) {
        return this.customerApi({ endpoint: 'orders', body });
    }
    async order(body) {
        return this.customerApi({ endpoint: 'order', body });
    }
    async metafield(body) {
        return this.customerApi({ endpoint: 'metafield', body });
    }
    // Address
    async addresses(body) {
        return this.customerApi({ endpoint: 'addresses', body });
    }
    async addressCreate(body) {
        return this.customerApi({ endpoint: 'address-create', body });
    }
    async addressUpdate(body) {
        return this.customerApi({ endpoint: 'address-update', body });
    }
    async addressDelete(body) {
        return this.customerApi({ endpoint: 'address-delete', body });
    }
    // Password
    async passwordRecover(body) {
        return this.customerApi({ endpoint: 'password-recover', body });
    }
    async passwordReset(body) {
        return this.customerApi({ endpoint: 'password-reset', body });
    }
}
exports.CustomerClient = CustomerClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 40354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CustomerClient = void 0;
var client_1 = __webpack_require__(86910);
Object.defineProperty(exports, "CustomerClient", ({ enumerable: true, get: function () { return client_1.CustomerClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 33296:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(28640), exports); // new on v2 (async);
tslib_1.__exportStar(__webpack_require__(23478), exports); // new on v2
tslib_1.__exportStar(__webpack_require__(62081), exports); // new on v2
// getters — selectors
tslib_1.__exportStar(__webpack_require__(78138), exports); // now async on v2
tslib_1.__exportStar(__webpack_require__(52995), exports); // now async on v2
tslib_1.__exportStar(__webpack_require__(16764), exports);
tslib_1.__exportStar(__webpack_require__(61491), exports);
tslib_1.__exportStar(__webpack_require__(17382), exports);
// musts
tslib_1.__exportStar(__webpack_require__(41674), exports);
tslib_1.__exportStar(__webpack_require__(50124), exports);
// customer apis
tslib_1.__exportStar(__webpack_require__(67839), exports);
tslib_1.__exportStar(__webpack_require__(49638), exports);
tslib_1.__exportStar(__webpack_require__(81820), exports);
tslib_1.__exportStar(__webpack_require__(81151), exports);
tslib_1.__exportStar(__webpack_require__(52174), exports);
tslib_1.__exportStar(__webpack_require__(81041), exports);
// address apis
tslib_1.__exportStar(__webpack_require__(53063), exports);
tslib_1.__exportStar(__webpack_require__(59130), exports);
tslib_1.__exportStar(__webpack_require__(9230), exports);
// password apis
tslib_1.__exportStar(__webpack_require__(62148), exports);
tslib_1.__exportStar(__webpack_require__(23246), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 16764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomer = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomer = () => (0, store_1.useRecoilValue)(store_1.default.customer);
exports.useCustomer = useCustomer;
//# sourceMappingURL=useCustomer.js.map

/***/ }),

/***/ 17382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerAccessToken = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerAccessToken = () => (0, store_1.useRecoilValue)(store_1.default.accessToken);
exports.useCustomerAccessToken = useCustomerAccessToken;
//# sourceMappingURL=useCustomerAccessToken.js.map

/***/ }),

/***/ 81820:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerActivate = void 0;
const tslib_1 = __webpack_require__(59312);
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    options: {},
};
const useCustomerActivate = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/activate',
    });
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const activateAccount = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.customerId:
                validationErrors = ['customerId not provided'];
                break;
            case !data?.activationToken:
                validationErrors = ['activationToken not provided'];
                break;
            case !data?.password:
                validationErrors = ['password not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerActivate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer) {
                setErrors(['Invalid activate response missing customer']);
                return null;
            }
            if (!response?.accessToken) {
                setErrors(['Invalid activate response missing accessToken']);
                return null;
            }
            const { customer, accessToken } = response;
            setFinished(true);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.customer, customer);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        activateAccount,
        accessToken: finished ? _accessToken : null,
        customer: finished ? _customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerActivate = useCustomerActivate;
//# sourceMappingURL=useCustomerActivate.js.map

/***/ }),

/***/ 52995:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerAddresses = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useCustomerAddresses = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const fetching = (0, react_1.useRef)(false);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/addresses',
    });
    const [addresses, setAddresses] = (0, store_1.useRecoilState)(store_1.default.customerAddresses);
    const getAddresses = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddresses());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.addresses) {
                setErrors([`Missing addresses data for ${data}`]);
                return null;
            }
            setFinished(true);
            setAddresses(response.addresses);
            if (callback)
                callback(response.addresses);
            return response.addresses;
        }
        catch (error) {
            console.error('getAddresses:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            fetching.current,
            addresses?.length, // already have order
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        fetching.current = true;
        getAddresses()
            .then((_addresses) => {
            if (unMounting)
                return;
            setAddresses(_addresses);
            fetching.current = false;
        })
            .catch((error) => {
            console.error('failed to getAddresses due to', error.message);
        });
        return () => {
            unMounting = true;
            fetching.current = false;
        };
    }, [props.fetchOnMount]);
    return {
        addresses,
        getAddresses,
        setStarted,
        setFinished,
        setErrors,
        finished,
        ...status,
    };
};
exports.useCustomerAddresses = useCustomerAddresses;
//# sourceMappingURL=useCustomerAddresses.js.map

/***/ }),

/***/ 41674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerAuth = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(27378);
const router_1 = __webpack_require__(86677);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomer_1 = __webpack_require__(16764);
const defaultProps = {
    autoRedirect: true,
    defaultRoute: '/account/orders',
    id: '', // to help console.log specific useCustomerAuth instances
};
const useCustomerAuth = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { autoRedirect, defaultRoute, id } = props;
    const router = (0, router_1.useRouter)();
    const customer = (0, useCustomer_1.useCustomer)();
    const customerInit = (0, store_1.useRecoilValue)(store_1.default.customerInit);
    const [authenticated, setAuthenticated] = (0, store_1.useRecoilState)(store_1.default.authenticated);
    // path checkers
    const onLoginPath = /\/login/g.test(router?.asPath || '');
    const onRegisterPath = /\/register/g.test(router?.asPath || '');
    const onResetPath = /\/reset/g.test(router?.asPath || '');
    const onActivatePath = /\/activate/g.test(router?.asPath || '');
    const onLoginRegisterActivateOrResetPath = onLoginPath || onRegisterPath || onActivatePath || onResetPath;
    const onAnyAccountPath = /\/account/g.test(router?.asPath || '');
    const onAuthenticatedPath = onAnyAccountPath && !onLoginRegisterActivateOrResetPath;
    const queriedRedirectPath = router.query?.redirect;
    const onRedirectToPath = queriedRedirectPath
        ? router?.asPath === queriedRedirectPath
        : false;
    const isDefaultRoute = router?.asPath === defaultRoute;
    // Authenticate the user and maybe auto-redirect
    const authenticateUser = () => {
        // console.log(id, 'authenticateUser:customerInit', customerInit);
        if (!customerInit) {
            // Customer not ready, waiting for customerInit..
            return;
        }
        if (authenticated || authenticated === false) {
            // console.log(id, 'authenticateUser: non need to reauthenticate')
            return;
        }
        // Customer is ready..
        const loggedIn = customer?.id;
        if (loggedIn) {
            setAuthenticated(true);
            return;
        }
        setAuthenticated(false);
    };
    const routeGuest = () => {
        // Customer is ready..
        const loggedIn = customer?.id;
        if (loggedIn) {
            // console.log(id, 'routeGuest: already logged in early exit')
            return null;
        }
        if (authenticated !== false) {
            // console.log(id, 'routeGuest: authenticated or not yet authenticated early exit');
            return null; // can be 'undefined', 'false', true
        }
        // console.log('kick out if not logged in and the current path is protected')
        if (onAuthenticatedPath) {
            // console.log(id, 'routeGuest:Not logged in accessing a protected route. redirecting to login')
            router.push('/account/login');
        }
        else {
            // console.log(id, 'routeGuest:Not logged and accessing unprotected route. not redirecting (login, register, reset, activate)');
        }
        return null;
    };
    const routeCustomer = () => {
        if (!authenticated) {
            // console.log(id, 'routeCustomer: not authenticated early exit');
            return;
        }
        if (!onAnyAccountPath) {
            // console.log(id, `routeCustomer:Modal login scenario — NOT coming from /account/login, /account/register or /account/reset or any /account/x don't auto redirect`);
            return;
        }
        // if user sets withLogin.. HOC authOptions to autoRedirect: false
        if (!autoRedirect) {
            // console.log(id, 'routeCustomer:user needs to manually redirect away from these routes');
            return;
        }
        // user passed a redirect url via  ?redirect=/pages/xxx
        if (queriedRedirectPath && !onRedirectToPath) {
            // console.log(id, 'routeCustomer:Auto-redirecting to passed ?redirect');
            router.push(queriedRedirectPath);
            return;
        }
        /*
          This could be cleaned up into no if/else,
          I just want to keep it like this for clarity
          and future troubleshooting
        */
        if (onAuthenticatedPath) {
            // console.log(id, 'routeCustomer:Inside a protected account route. Not redirecting - eg. from /account/orders to /account/address')
        }
        else if (isDefaultRoute) {
            // console.log(id, 'routeCustomer:Already in default account route e.g /account/orders, No redirecting')
        }
        else {
            // console.log(id, `routeCustomer:Auto-redirecting to default ${defaultRoute || '/account/orders'}`)
            router.push(defaultRoute || '/account/orders');
        }
    };
    (0, react_1.useEffect)(() => {
        authenticateUser();
    }, [customerInit, authenticated, id]);
    // logged-out routing
    (0, react_1.useEffect)(() => {
        routeGuest();
    }, [authenticated, id, customer, onAuthenticatedPath]);
    // logged-in routing
    (0, react_1.useEffect)(() => {
        routeCustomer();
    }, [
        authenticated,
        id,
        customer,
        onAnyAccountPath,
        autoRedirect,
        queriedRedirectPath,
        onRedirectToPath,
        onAuthenticatedPath,
        isDefaultRoute,
        defaultRoute,
    ]);
    return { authenticated, customer, customerInit };
};
exports.useCustomerAuth = useCustomerAuth;
//# sourceMappingURL=useCustomerAuth.js.map

/***/ }),

/***/ 49638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerCreate = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerCreate = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({ ...props.options, id: 'customer/create' });
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // sign up method
    const customerCreate = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data:
                validationErrors = ['data not provided'];
                break;
            case !data.firstName:
                validationErrors = ['firstName not provided'];
                break;
            case !data.lastName:
                validationErrors = ['lastName not provided'];
                break;
            case !data.email:
                validationErrors = ['email not provided'];
                break;
            case !data.password:
                validationErrors = ['password not provided'];
                break;
            case typeof data.acceptsMarketing === 'undefined':
                validationErrors = ['acceptsMarketing not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerCreate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            const { customer, accessToken } = response;
            if (!customer?.__typename === 'Customer') {
                setErrors(['Invalid customer response']);
                return null;
            }
            if (!accessToken?.__typename === 'CustomerAccessToken') {
                setErrors(['Invalid customer accessToken response']);
                return null;
            }
            setFinished(true);
            // used to distinguish new sign ups and fire GTM events
            set(store_1.default.customer, customer);
            set(store_1.default.newCustomer, customer);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.authenticated, true);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        customerCreate,
        accessToken: finished ? _accessToken : null,
        customer: finished ? _customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerCreate = useCustomerCreate;
//# sourceMappingURL=useCustomerCreate.js.map

/***/ }),

/***/ 53063:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerCreateAddress = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const useCustomerGet_1 = __webpack_require__(67839);
const defaultProps = {
    options: {},
};
const useCustomerCreateAddress = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/addressCreate',
    });
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    const addresses = (0, store_1.useRecoilValue)(store_1.default.customerAddresses);
    // update a customer address, (optionally) set as default and get fresh customer
    const createAddress = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.address: {
                    validationErrors = ['address object to update not provided'];
                    break;
                }
                case typeof data?.isDefault === 'undefined': {
                    validationErrors = ['isDefault not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // accessToken is required and will be injected at addressCreate$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddressCreate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.address) {
                setErrors(['Invalid address create response']);
                return null;
            }
            const { address: newAddress } = response;
            // update the cached address and add the new address
            const updatedAddresses = [...addresses, newAddress];
            set(store_1.default.customerAddresses, updatedAddresses);
            setFinished(true);
            if (callback)
                callback(newAddress);
            await customerGet({ forceUpdate: true });
            return newAddress; // new address
        }
        catch (error) {
            console.error(`createAddress:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        createAddress,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerCreateAddress = useCustomerCreateAddress;
//# sourceMappingURL=useCustomerCreateAddress.js.map

/***/ }),

/***/ 61491:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerDefaultAddress = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerDefaultAddress = () => {
    return (0, store_1.useRecoilValue)(store_1.default.customerDefaultAddress$);
};
exports.useCustomerDefaultAddress = useCustomerDefaultAddress;
//# sourceMappingURL=useCustomerDefaultAddress.js.map

/***/ }),

/***/ 9230:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerDeleteAddress = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const useCustomerGet_1 = __webpack_require__(67839);
const useCustomerDeleteAddress = (options) => {
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)(options);
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const addresses = (0, store_1.useRecoilValue)(store_1.default.customerAddresses);
    // delete a customer address
    const deleteAddress = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.id: {
                    validationErrors = ['address id to delete not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // accessToken is required and will be injected at addressDelete$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddressDelete(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.deletedCustomerAddressId) {
                setErrors(['Invalid address delete response']);
                return null;
            }
            const { deletedCustomerAddressId } = response;
            // update the cached address by removing the currently deleted address
            const updatedAddresses = addresses.filter((_address) => {
                const wasDeleted = _address.id.split('?')[0] === data?.id.split('?')[0];
                if (wasDeleted)
                    return false;
                return true;
            });
            set(store_1.default.customerAddresses, updatedAddresses);
            setFinished(true);
            if (callback)
                callback(deletedCustomerAddressId);
            await customerGet({ forceUpdate: true });
            return deletedCustomerAddressId;
        }
        catch (error) {
            console.error(`deleteAddress:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        deleteAddress,
        accessToken: finished ? _accessToken : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerDeleteAddress = useCustomerDeleteAddress;
//# sourceMappingURL=useCustomerDeleteAddress.js.map

/***/ }),

/***/ 67839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerGet = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerGet = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const { setStarted, setFinished, setErrors, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        id: `customer/${accessToken?.token ?? ''}/get`,
        ...props.options,
    });
    const customerGet = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        const release = snapshot.retain();
        try {
            // return cached customer
            if (customer?.id && !data?.forceUpdate) {
                setFinished(true);
                return customer;
            }
            // can pass accessToken or will use the on in store
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerGet(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer) {
                setErrors(['customer get response missing customer data']);
                return null;
            }
            if (!response?.customer?.__typename === 'Customer') {
                setErrors(['customer get invalid customer response']);
                return null;
            }
            const { customer: _customer } = response;
            setFinished(true);
            set(store_1.default.customer, _customer);
            if (callback)
                callback(_customer);
            return _customer;
        }
        catch (error) {
            console.error(`customerGet:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, [customer]);
    return {
        customerGet,
        customer,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCustomerGet = useCustomerGet;
//# sourceMappingURL=useCustomerGet.js.map

/***/ }),

/***/ 50124:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerInit = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-expressions */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerGet_1 = __webpack_require__(67839);
const useCustomerLogout_1 = __webpack_require__(52174);
// temp while we validate new customer works as expected;
const DEBUG = false;
const defaultProps = {
    fetchOnMount: false,
    options: {},
};
const useCustomerInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const initializing = (0, react_1.useRef)(false);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const isValidAccessToken = (0, store_1.useRecoilValue)(store_1.default.isValidAccessToken$);
    const { customerLogout } = (0, useCustomerLogout_1.useCustomerLogout)();
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    const init = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        if (!props?.fetchOnMount)
            return null;
        if (initializing.current)
            return null;
        initializing.current = true;
        const release = snapshot.retain();
        try {
            switch (true) {
                case customer: {
                    DEBUG &&
                        console.log('👷‍♂️ customer init: Found existing customer (auto-login)'); // auto-login
                    break;
                }
                case !accessToken: {
                    DEBUG && console.log('👷‍♂️ customer init: No access token found.'); // no persisted token -> no auto-login attempt
                    set(store_1.default.customer, null);
                    break;
                }
                case isValidAccessToken: {
                    DEBUG &&
                        console.log('👷‍♂️ customer init: Have valid token fetching customer');
                    await customerGet({ accessToken }); // update customer data
                    break;
                }
                default: {
                    DEBUG &&
                        console.log('👷‍♂️ customer init: Invalid/expired token logging customer out');
                    await customerLogout(); // deletes stale accessToken
                    set(store_1.default.customerInit, false);
                    return null;
                }
            }
            set(store_1.default.customerInit, true);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            console.error('👷‍♂️ customer init: error', error.message);
            return null;
        }
        finally {
            release();
        }
    });
    // manage customer here, so that we don't cause un-necessary top level re-renders
    (0, react_1.useEffect)(() => {
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer, accessToken, isValidAccessToken, props?.fetchOnMount]);
    return customer;
};
exports.useCustomerInit = useCustomerInit;
//# sourceMappingURL=useCustomerInit.js.map

/***/ }),

/***/ 81151:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerLogin = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerLogin = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({ ...props.options, id: 'customer/login' });
    // state
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const customerLogin = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.email:
                    validationErrors = ['email not provided'];
                    break;
                case !data?.password:
                    validationErrors = ['password not provided'];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // get accessToken and customer via /api/customer-login
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerLogin(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.accessToken) {
                setErrors(['Invalid login response access token']);
                return null;
            }
            if (!response?.customer) {
                setErrors(['Invalid login response missing customer']);
                return null;
            }
            const { accessToken: _accessToken, customer: _customer } = response;
            setFinished(true);
            set(store_1.default.accessToken, _accessToken);
            set(store_1.default.customer, _customer);
            set(store_1.default.authenticated, true);
            if (callback)
                callback(customer);
            return customer || null;
        }
        catch (error) {
            console.error(`customerLogin:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        customerLogin,
        accessToken: finished ? accessToken : null,
        customer: finished ? customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerLogin = useCustomerLogin;
//# sourceMappingURL=useCustomerLogin.js.map

/***/ }),

/***/ 52174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerLogout = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
// keeping same verbose structure for consistency despite the fact that we don't need async calls
const useCustomerLogout = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const { started, setStarted, finished, setFinished, errors, setErrors, reset: resetStatus, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: `customer/${accessToken?.token ?? ''}/logout`,
    });
    // login method - get token from email and password then get customer from token
    const customerLogout = (0, store_1.useRecoilCallback)(({ snapshot, reset, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            setFinished(true);
            // will set both localStorage and state to null
            set(store_1.default.customer, null);
            reset(store_1.default.accessToken);
            reset(store_1.default.authenticated);
            // reset ancillary customer state
            reset(store_1.default.customerAddresses);
            reset(store_1.default.customerMetafield(undefined));
            reset(store_1.default.customerOrder(undefined));
            reset(store_1.default.customerOrders(1));
            reset(store_1.default.customerOrdersAction);
            reset(store_1.default.customerOrdersCursor(1));
            reset(store_1.default.customerOrdersPage);
            if (callback)
                callback(true);
            return true;
        }
        catch (error) {
            console.error(`customerLogout:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        customerLogout,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset: resetStatus,
    };
};
exports.useCustomerLogout = useCustomerLogout;
//# sourceMappingURL=useCustomerLogout.js.map

/***/ }),

/***/ 62081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerMetafield = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const helpers_1 = __webpack_require__(85542);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    key: '',
    namespace: '',
    fetchOnMount: true,
    options: {},
};
const useCustomerMetafield = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    let { key, namespace } = props;
    if (!key)
        throw new Error('"key" prop not provided');
    if (!namespace)
        throw new Error('"namespace" prop not provided');
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, helpers_1.useRecoilStartFinishErrors)({
        id: `product/getProductMetafield/${namespace}/${key}`,
        ...props.options,
    });
    const [metafield, setMetafield] = (0, store_1.useRecoilState)(store_1.default.productMetafield({ key, namespace }));
    const getMetafield = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (metafield) {
                setFinished(true);
                if (callback)
                    callback(metafield);
                return metafield;
            }
            if (data?.key) {
                key = data.key;
            }
            if (data?.namespace) {
                namespace = data.namespace;
            }
            let validationErrors = null;
            switch (true) {
                case !key: {
                    validationErrors = ['key not provided'];
                    break;
                }
                case !namespace: {
                    validationErrors = ['namespace not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // get the metafield via the product client
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerMetafield({ key, namespace }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.metafield) {
                setErrors([
                    `Invalid customer metafield response: ${JSON.stringify(response)}`,
                ]);
                return null;
            }
            setFinished(true);
            setMetafield(response.metafield);
            if (callback)
                callback(response.metafield);
            return response.metafield;
        }
        catch (error) {
            console.error(`getCustomerMetafield:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
    }, [key, namespace]);
    // fetch on change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !key,
            !namespace,
            !props.fetchOnMount,
            finished && metafield, // already have metafield
        ];
        const shouldExit = !earlyExitIf.some(Boolean);
        if (shouldExit) {
            getMetafield({ key, namespace })
                .then((_metafield) => {
                if (unMounting || !_metafield)
                    return;
                setMetafield(_metafield);
            })
                .catch((error) => {
                console.error('failed to getMetafield due to', error.message);
            });
        }
        return () => {
            if (shouldExit) {
                unMounting = true;
            }
        };
    }, [key, namespace, props.fetchOnMount]);
    return {
        metafield,
        getMetafield,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useCustomerMetafield = useCustomerMetafield;
//# sourceMappingURL=useCustomerMetafield.js.map

/***/ }),

/***/ 28640:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerOrder = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    id: null,
    fetchOnMount: true,
    options: {},
};
const useCustomerOrder = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props?.id) {
        throw new Error('id not provided');
    }
    const fetching = (0, react_1.useRef)(false);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: `customer/order/${props.id}`,
    });
    const [order, setOrder] = (0, store_1.useRecoilState)(store_1.default.customerOrder(props.id));
    const getOrder = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data.id:
                validationErrors = ['id not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerOrder(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.order?.id) {
                setErrors([`Missing order data for ${JSON.stringify(data)}`]);
                return null;
            }
            setFinished(true);
            setOrder(response.order);
            if (callback)
                callback(response.order);
            return response.order;
        }
        catch (error) {
            console.error('getOrder:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props?.id,
            !props.fetchOnMount,
            fetching.current,
            order, // already have order
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        fetching.current = true;
        getOrder({ id: props?.id })
            .then((_order) => {
            if (unMounting)
                return;
            setOrder(_order);
            fetching.current = false;
        })
            .catch((error) => {
            console.error('failed to getOrder due to', error.message);
        });
        return () => {
            unMounting = true;
            fetching.current = false;
        };
    }, [props.fetchOnMount, props?.id]);
    return {
        order,
        setStarted,
        setFinished,
        setErrors,
        finished,
        ...status,
    };
};
exports.useCustomerOrder = useCustomerOrder;
//# sourceMappingURL=useCustomerOrder.js.map

/***/ }),

/***/ 78138:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerOrders = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    page: 1,
    perPage: 10,
    fetchOnMount: true,
    options: {},
};
const useCustomerOrders = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const fetching = (0, react_1.useRef)(false);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const [page, setPage] = (0, store_1.useRecoilState)(store_1.default.customerOrdersPage);
    const setAction = (0, store_1.useSetRecoilState)(store_1.default.customerOrdersAction);
    const [cursor, setCursor] = (0, store_1.useRecoilState)(store_1.default.customerOrdersCursor(page));
    const [orders, setOrders] = (0, store_1.useRecoilState)(store_1.default.customerOrders(page));
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: `customer/${accessToken?.token ?? ''}/orders/${props.page}`,
    });
    const getNext = (0, react_1.useCallback)(() => {
        if (cursor?.after) {
            setFinished(false);
            setPage((_page) => _page + 1);
            setAction('next');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cursor?.after]);
    const getPrevious = (0, react_1.useCallback)(() => {
        if (cursor?.before && page > 1) {
            setFinished(false);
            setPage((_page) => _page - 1);
            setAction('prev');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cursor?.before, page]);
    const getPageOrdersData = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.page:
                validationErrors = ['page not provided'];
                break;
            case !data?.perPage:
                validationErrors = ['perPage not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerOrders(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!Array.isArray(response.orders)) {
                setErrors([`Missing orders data for ${data}`]);
                return null;
            }
            setFinished(true);
            if (callback)
                callback(response);
            return response;
        }
        catch (error) {
            console.error('getPageOrdersData:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !customer,
            !page,
            !props.perPage,
            !props.fetchOnMount,
            fetching.current,
            orders?.length, // already have metafield
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        fetching.current = true;
        getPageOrdersData({ page, perPage: props.perPage })
            .then((data) => {
            if (unMounting)
                return;
            setCursor({
                after: data.after || null,
                before: data.before || null,
            });
            setOrders(data.orders);
            fetching.current = false;
        })
            .catch((error) => {
            console.error('failed to getPageOrdersData due to', error.message);
        });
        return () => {
            unMounting = true;
            fetching.current = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer, props.fetchOnMount, props.perPage, page]);
    return {
        orders,
        page,
        hasPrevious: !!cursor?.before,
        getPrevious,
        hasNext: !!cursor?.after,
        getNext,
        setStarted,
        setFinished,
        setErrors,
        finished,
        ...status,
    };
};
exports.useCustomerOrders = useCustomerOrders;
//# sourceMappingURL=useCustomerOrders.js.map

/***/ }),

/***/ 62148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerRecoverPassword = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerRecoverPassword = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/passwordRecover',
    });
    // login method - get token from email and password then get customer from token
    const recoverPassword = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.email:
                validationErrors = ['email not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchPasswordRecover(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (typeof response?.emailSent === 'undefined') {
                setErrors(['Invalid recover email response']);
                return null;
            }
            const { emailSent } = response;
            setFinished(true);
            if (callback)
                callback(emailSent);
            return emailSent;
        }
        catch (error) {
            console.error('recoverPassword:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        recoverPassword,
        emailSent: (finished && !errors?.length) || null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerRecoverPassword = useCustomerRecoverPassword;
//# sourceMappingURL=useCustomerRecoverPassword.js.map

/***/ }),

/***/ 23246:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerResetPassword = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerResetPassword = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/passwordReset',
    });
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const resetPassword = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.password:
                validationErrors = ['password not provided'];
                break;
            case !data?.url:
                validationErrors = ['url not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchPasswordReset(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer) {
                setErrors(['Invalid reset response missing customer']);
                return null;
            }
            if (!response?.accessToken) {
                setErrors(['Invalid reset response missing accessToken']);
                return null;
            }
            const { customer, accessToken } = response;
            setFinished(true);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.customer, customer);
            set(store_1.default.authenticated, true);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            console.error('resetPassword:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        resetPassword,
        accessToken: finished ? _accessToken : null,
        customer: finished ? _customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerResetPassword = useCustomerResetPassword;
//# sourceMappingURL=useCustomerResetPassword.js.map

/***/ }),

/***/ 22957:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const DEBUG = false;
const useCustomerStartFinishErrors = (options) => {
    const setCustomerStarted = (0, store_1.useSetRecoilState)(store_1.default.customerStatusStarted('customer/all'));
    const setCustomerFinished = (0, store_1.useSetRecoilState)(store_1.default.customerStatusFinished('customer/all'));
    const setCustomerSuccess = (0, store_1.useSetRecoilState)(store_1.default.customerStatusSuccess('customer/all'));
    const setCustomerErrors = (0, store_1.useSetRecoilState)(store_1.default.customerStatusErrors('customer/all'));
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.customerStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.customerStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.customerStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.customerStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    const isCustomerId = /^customer/.test(options?.id);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setCustomerErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setCustomerStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCustomerFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCustomerFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setCustomerSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useCustomerStartFinishErrors = useCustomerStartFinishErrors;
//# sourceMappingURL=useCustomerStartFinishErrors.js.map

/***/ }),

/***/ 23478:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerStatus = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
// global status of the customer, any customer action will trigger
// these states via useRecoilStartFinishErrors.js
const useCustomerStatus = () => {
    return {
        started: (0, store_1.useRecoilValue)(store_1.default.customerStatusStarted('customer/all')),
        finished: (0, store_1.useRecoilValue)(store_1.default.customerStatusFinished('customer/all')),
        success: (0, store_1.useRecoilValue)(store_1.default.customerStatusSuccess('customer/all')),
        errors: (0, store_1.useRecoilValue)(store_1.default.customerStatusErrors('customer/all')),
    };
};
exports.useCustomerStatus = useCustomerStatus;
//# sourceMappingURL=useCustomerStatus.js.map

/***/ }),

/***/ 59130:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerUpdateAddress = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const useCustomerGet_1 = __webpack_require__(67839);
const defaultProps = {
    options: {},
};
const useCustomerUpdateAddress = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, success, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/updateAddress',
    });
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    // state
    const [address, setAddress] = (0, react_1.useState)();
    const addresses = (0, store_1.useRecoilValue)(store_1.default.customerAddresses);
    // update a customer address, (optionally) set as default and get fresh customer
    const updateAddress = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.id: {
                    validationErrors = ['address to update id not provided'];
                    break;
                }
                case !data?.address: {
                    validationErrors = ['address object to update not provided'];
                    break;
                }
                case typeof data?.isDefault === 'undefined': {
                    validationErrors = ['address isDefault to update not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // accessToken is required and will be injected at addressUpdate$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddressUpdate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.address) {
                setErrors(['Invalid address update response']);
                return null;
            }
            const { address: _updatedAddress } = response;
            setFinished(true);
            setAddress(_updatedAddress);
            // update the cached address which was just updated
            const updatedAddresses = addresses.map((_address) => {
                const wasUpdated = _address.id.split('?')[0] === _updatedAddress.id.split('?')[0];
                if (!wasUpdated)
                    return _address;
                return _updatedAddress;
            });
            set(store_1.default.customerAddresses, updatedAddresses);
            if (callback)
                callback(_updatedAddress);
            await customerGet({ forceUpdate: true });
            return _updatedAddress; // updated address
        }
        catch (error) {
            console.error('updateAddress:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        address,
        updateAddress,
        started,
        finished,
        success,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerUpdateAddress = useCustomerUpdateAddress;
//# sourceMappingURL=useCustomerUpdateAddress.js.map

/***/ }),

/***/ 81041:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerUpdateDetails = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerUpdateDetails = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, success, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({ ...props.options, id: 'customer/update' });
    // state
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const customerUpdateDetails = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data:
                validationErrors = ['data not provided'];
                break;
            case !data.firstName:
                validationErrors = ['firstName not provided'];
                break;
            case !data.lastName:
                validationErrors = ['lastName not provided'];
                break;
            case !data.email:
                validationErrors = ['email not provided'];
                break;
            case typeof data.acceptsMarketing === 'undefined':
                validationErrors = ['acceptsMarketing not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            // accessToken is also required so will be injected at customerUpdate$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerUpdate({ customer: data }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer ||
                !response?.customer?.id ||
                !response?.accessToken) {
                setErrors(['Invalid customer update response response']);
                return null;
            }
            const { customer, accessToken } = response;
            setFinished(true);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.customer, customer);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            console.error('customerUpdateDetails:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        customerUpdateDetails,
        customer: finished ? _customer : null,
        started,
        finished,
        success,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerUpdateDetails = useCustomerUpdateDetails;
//# sourceMappingURL=useCustomerUpdateDetails.js.map

/***/ }),

/***/ 26029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.customerStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
const store_1 = __webpack_require__(20437);
const client_1 = __webpack_require__(40354);
const client = new client_1.CustomerClient({
    debug: false,
});
/**
  Customer State
*/
const customerInit = (0, recoil_1.atom)({
    key: 'customer/init',
    default: false,
    effects: [
        // effects.logStateChange('customerInit'),
        effects_1.default.onChange({
            key: 'customerInit',
            topic: 'CUSTOMER_INIT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const accessToken = (0, recoil_1.atom)({
    key: 'customer/accessToken',
    default: null,
    effects: [
        // effects.logStateChange('accessToken'),
        effects_1.default.setSelfToPersistedKey('accessToken', `CustomerToken|${effects_1.default.SHOPIFY_NAME}`),
        effects_1.default.onSetUpdatePersistedKey(`CustomerToken|${effects_1.default.SHOPIFY_NAME}`),
    ],
});
const customer = (0, recoil_1.atom)({
    key: 'customer/customer',
    default: undefined,
    effects: [
        // effects.logStateChange('customer'),
        effects_1.default.onChange({
            key: 'customer',
            topic: 'CUSTOMER_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
// async
const customerAddresses = (0, recoil_1.atom)({
    key: 'customer/addresses',
    default: null,
});
// Paginated lists of order summaries for order history listing
const customerOrders = (0, recoil_1.atomFamily)({
    key: 'customer/orders',
    default: null,
});
// full order items with line items etc..
const customerOrder = (0, recoil_1.atomFamily)({
    key: 'customer/order',
    default: null,
});
const customerMetafield = (0, recoil_1.atomFamily)({
    key: 'customer/metafield',
    default: null,
});
const customerOrdersPage = (0, recoil_1.atom)({
    key: 'customer/ordersPage',
    default: 1,
});
const customerOrdersCursor = (0, recoil_1.atomFamily)({
    key: 'customer/ordersCursor',
    default: { before: null, after: null },
});
const customerOrdersAction = (0, recoil_1.atom)({
    key: 'customer/ordersAction',
    default: 'next', // || prev
});
const authenticated = (0, recoil_1.atom)({
    key: 'customer/authenticated',
    default: undefined,
});
const newCustomer = (0, recoil_1.atom)({
    key: 'customer/new',
    default: false,
    effects: [
        effects_1.default.onChange({
            key: 'newCustomer',
            topic: 'CUSTOMER_REGISTERED',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
/*
  ---------------
  Status
  ---------------
*/
const customerStatusStarted = (0, recoil_1.atomFamily)({
    key: 'customer/statusStarted',
    default: false,
});
const customerStatusFinished = (0, recoil_1.atomFamily)({
    key: 'customer/statusFinished',
    default: false,
});
const customerStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'customer/statusSuccess',
    default: false,
});
const customerStatusErrors = (0, recoil_1.atomFamily)({
    key: 'customer/statusErrors',
    default: [],
});
/*
  ---------------
  Getters
  ---------------
*/
const customerDefaultAddress$ = (0, recoil_1.selector)({
    key: 'customer/defaultAddress$',
    get: ({ get }) => {
        const _customer = get(customer);
        return _customer ? _customer.defaultAddress : null;
    },
});
const isValidAccessToken$ = (0, recoil_1.selector)({
    key: 'customer/isValidToken',
    get: ({ get }) => {
        const _accessToken = get(accessToken);
        const isValidToken = _accessToken?.expires
            ? Date.parse(_accessToken.expires) > Date.now()
            : false;
        return isValidToken;
    },
});
/*
  ---------------
  Async fetchers and setters
  ---------------
*/
/*
  Customer: ACTIVATE, LOGIN, GET, CREATE, UPDATE
*/
const fetchCustomerActivate = (0, recoil_1.selectorFamily)({
    key: 'customer/active',
    get: (activateDetails) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.activate({
            ...activateDetails,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerGet = (0, recoil_1.selectorFamily)({
    key: 'customer/get',
    get: ({ accessToken: passedToken, forceUpdate = false }) => async ({ get }) => {
        const _customer = get(customer);
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        if (passedToken || forceUpdate) {
            return client.get({
                accessToken: passedToken || _accessToken,
                country: country?.isoCode,
            });
        }
        return Promise.resolve(_customer);
    },
});
const fetchCustomerLogin = (0, recoil_1.selectorFamily)({
    key: 'customer/login',
    get: (loginDetails) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.login({
            ...loginDetails,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerCreate = (0, recoil_1.selectorFamily)({
    key: 'customer/create',
    get: (newCustomerData) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.create({
            ...newCustomerData,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerUpdate = (0, recoil_1.selectorFamily)({
    key: 'customer/update',
    get: ({ accessToken: passedToken, customer: updatedCustomer }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.update({
            accessToken: passedToken || _accessToken,
            customer: updatedCustomer,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerOrder = (0, recoil_1.selectorFamily)({
    key: 'customer/fetchCustomerOrder',
    get: ({ orderNumber = null, id = null }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        const { error, data } = await client.order({
            orderNumber,
            id,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
        if (error) {
            return {
                error,
                data: null,
            };
        }
        return {
            error: null,
            data,
        };
    },
});
const fetchCustomerMetafield = (0, recoil_1.selectorFamily)({
    key: 'customer/fetchCustomerMetafield',
    get: ({ namespace = null, key = null }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        const { error, data } = await client.metafield({
            namespace,
            key,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
        if (error) {
            return {
                error,
                data: null,
            };
        }
        return {
            error: null,
            data,
        };
    },
});
const fetchCustomerOrders = (0, recoil_1.selectorFamily)({
    key: 'customer/fetchCustomerOrders',
    get: ({ page = 1, perPage = 4 }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        const _cursor = get(customerOrdersCursor(page));
        const _prevCursor = get(customerOrdersCursor(page > 2 ? page - 1 : 1));
        const _action = get(customerOrdersAction);
        const fetchPage = async ({ page: _page, perPage: _perPage }) => {
            const pageInfo = {
                accessToken: _accessToken.token,
                country: country?.isoCode,
            };
            const isFirst = _page === 1;
            const isNext = _action === 'next';
            const isPrev = _action === 'previous';
            switch (true) {
                case isFirst: {
                    pageInfo.first = _perPage;
                    break;
                }
                case isNext: {
                    if (_prevCursor.after) {
                        pageInfo.after = _prevCursor.after;
                    }
                    pageInfo.first = _perPage;
                    break;
                }
                case isPrev: {
                    pageInfo.last = _perPage;
                    pageInfo.before = _cursor.before;
                    break;
                }
                default:
                    pageInfo.first = _perPage;
                    break;
            }
            const { error, data } = await client.orders(pageInfo);
            if (error) {
                return {
                    error,
                    data: {
                        orders: null,
                        ...pageInfo,
                    },
                };
            }
            // good
            return {
                error: null,
                data,
            };
        };
        return fetchPage({ page, perPage });
    },
});
/*
  Address: CREATE, DELETE, UPDATE
*/
const fetchAddresses = (0, recoil_1.selectorFamily)({
    key: 'customer/addresses',
    get: () => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addresses({
            accessToken: _accessToken,
            country: country?.isoCode,
        });
    },
});
const fetchAddressCreate = (0, recoil_1.selectorFamily)({
    key: 'customer/addressCreate',
    get: (newAddressData) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addressCreate({
            ...newAddressData,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
    },
});
const fetchAddressDelete = (0, recoil_1.selectorFamily)({
    key: 'customer/addressDelete',
    get: ({ id, accessToken: passedToken }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addressDelete({
            id,
            accessToken: passedToken || _accessToken,
            country: country?.isoCode,
        });
    },
});
const fetchAddressUpdate = (0, recoil_1.selectorFamily)({
    key: 'customer/addressUpdate',
    get: (addressUpdateData) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addressUpdate({
            ...addressUpdateData,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
    },
});
/*
  Password: RESET, RECOVER
*/
const fetchPasswordReset = (0, recoil_1.selectorFamily)({
    key: 'customer/passwordReset',
    get: (resetData) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.passwordReset({
            ...resetData,
            country: country?.isoCode,
        });
    },
});
const fetchPasswordRecover = (0, recoil_1.selectorFamily)({
    key: 'customer/passwordRecover',
    get: ({ email }) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.passwordRecover({
            email,
            country: country?.isoCode,
        });
    },
});
exports.customerStore = {
    // status — new on v2
    customerStatusStarted,
    customerStatusFinished,
    customerStatusSuccess,
    customerStatusErrors,
    // Async fetchers and setters — new on v2
    fetchAddresses,
    fetchAddressCreate,
    fetchAddressDelete,
    fetchAddressUpdate,
    // actual state - atoms
    customerAddresses,
    customerInit,
    accessToken,
    customer,
    customerMetafield,
    customerOrder,
    customerOrders,
    customerOrdersPage,
    customerOrdersCursor,
    customerOrdersAction,
    authenticated,
    newCustomer,
    // getters
    isValidAccessToken$,
    customerDefaultAddress$,
    fetchCustomerActivate,
    fetchCustomerCreate,
    fetchCustomerGet,
    fetchCustomerLogin,
    fetchCustomerMetafield,
    fetchCustomerOrder,
    fetchCustomerOrders,
    fetchCustomerUpdate,
    fetchPasswordRecover,
    fetchPasswordReset,
};
//# sourceMappingURL=customer.js.map

/***/ }),

/***/ 90747:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.customerStore = void 0;
var customer_1 = __webpack_require__(26029);
Object.defineProperty(exports, "customerStore", ({ enumerable: true, get: function () { return customer_1.customerStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 49025:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const logStateChange_1 = __webpack_require__(63645);
const onSetRedirectToCheckout_1 = __webpack_require__(69060);
const onSetUpdatePersistedKey_1 = __webpack_require__(85417);
const setSelfToPersistedKey_1 = __webpack_require__(95973);
const onChange_1 = __webpack_require__(24889);
const shared_1 = __webpack_require__(32065);
exports["default"] = {
    // shared utils
    SHOPIFY_NAME: shared_1.SHOPIFY_NAME,
    publishBusEvent: shared_1.publishBusEvent,
    publishGtmEvent: shared_1.publishGtmEvent,
    resolveTopicData: shared_1.resolveTopicData,
    routeToTemplate: shared_1.routeToTemplate,
    // effects
    logStateChange: logStateChange_1.logStateChange,
    onSetRedirectToCheckout: onSetRedirectToCheckout_1.onSetRedirectToCheckout,
    onSetUpdatePersistedKey: onSetUpdatePersistedKey_1.onSetUpdatePersistedKey,
    setSelfToPersistedKey: setSelfToPersistedKey_1.setSelfToPersistedKey,
    onChange: onChange_1.onChange,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 63645:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.logStateChange = void 0;
const logStateChange = key => ({ onSet }) => {
    onSet((newValue, oldValue) => {
        console.groupCollapsed(`updated "${key}"`);
        console.log('is:\t\t', newValue);
        console.log('was:\t', oldValue);
        console.groupEnd();
        return newValue;
    });
};
exports.logStateChange = logStateChange;
//# sourceMappingURL=logStateChange.js.map

/***/ }),

/***/ 24889:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onChange = void 0;
const shared_1 = __webpack_require__(32065);
const isBrowser = typeof window !== 'undefined';
// todo: we can use Router.page.data
const onChange = ({ topic: topicGroup, actions: passedActions }) => ({ onSet }) => {
    onSet((newValue, oldValue) => {
        if (!isBrowser)
            return newValue;
        if (!topicGroup)
            return newValue;
        if (!passedActions)
            return newValue;
        if (!newValue && !oldValue)
            return newValue;
        let actions = passedActions;
        if (!Array.isArray(passedActions)) {
            if (typeof passedActions === 'string') {
                actions = [passedActions];
            }
            else {
                console.warn('Invalid onChange actions provided. "actions" must be an array or a string', passedActions);
                return newValue;
            }
        }
        // converts a generic topic e.g CART_UPDATE to a more specific action if applicable
        try {
            const [topic, topicData] = (0, shared_1.resolveTopicData)(topicGroup, newValue, oldValue);
            if (!topic) {
                console.warn(`Could not determine topic for ${topicGroup}`);
                return newValue;
            }
            if (typeof topicData === 'undefined') {
                console.error(`No ${topic} topic data`);
                return newValue;
            }
            // perform each onChange action
            actions.forEach((action) => {
                switch (action) {
                    case 'publishGtmEvent': {
                        return (0, shared_1.publishGtmEvent)(topic, topicData);
                    }
                    case 'publishBusEvent': {
                        return (0, shared_1.publishBusEvent)(topic, topicData);
                    }
                    default:
                        console.warn(`Unsupported onChange action ${action}`);
                        return newValue;
                }
            });
            return newValue;
        }
        catch (error) {
            console.error(topicGroup, error.message);
            return newValue;
        }
    });
};
exports.onChange = onChange;
//# sourceMappingURL=onChange.js.map

/***/ }),

/***/ 69060:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onSetRedirectToCheckout = void 0;
const onSetRedirectToCheckout = () => ({ onSet }) => {
    onSet((newValue, oldValue) => {
        if (!newValue?.redirect)
            return; // In case user wants to manually redirect
        // redirect to either multipass or regular checkout
        window.location.href = newValue.url;
        return newValue;
    });
};
exports.onSetRedirectToCheckout = onSetRedirectToCheckout;
//# sourceMappingURL=onSetRedirectToCheckout.js.map

/***/ }),

/***/ 85417:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onSetUpdatePersistedKey = void 0;
/* eslint-disable max-lines */
const shared_1 = __webpack_require__(32065);
const onSetUpdatePersistedKey = (key) => ({ onSet }) => {
    onSet((newValue) => {
        let safeNewValue = newValue;
        switch (key) {
            case `CustomerToken|${shared_1.SHOPIFY_NAME}`: {
                // if somehow, we have an invalid token in state, we don't persist it.
                if (!newValue?.token || !newValue?.expires) {
                    safeNewValue = null;
                }
                break;
            }
            case `Cart|${shared_1.SHOPIFY_NAME}`: {
                // if somehow, we have an invalid cart in state, we skip the update to persist it.
                if (!newValue?.id) {
                    safeNewValue = null;
                }
                break;
            }
            default:
                break;
        }
        // eslint-disable-next-line no-undef
        window.localStorage.setItem(key, JSON.stringify(safeNewValue));
        return safeNewValue;
    });
};
exports.onSetUpdatePersistedKey = onSetUpdatePersistedKey;
//# sourceMappingURL=onSetUpdatePersistedKey.js.map

/***/ }),

/***/ 95973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setSelfToPersistedKey = void 0;
const shared_1 = __webpack_require__(32065);
const isBrowser = typeof window !== 'undefined';
const setSelfToPersistedKey = (key, cachedKey, topic) => ({ setSelf }) => {
    setSelf(() => {
        if (!isBrowser)
            return null;
        try {
            let cachedJsonValue = JSON.parse(window.localStorage.getItem(cachedKey));
            const isValidAccessToken = !!cachedJsonValue?.expires &&
                Date.parse(cachedJsonValue.expires) > Date.now();
            switch (key) {
                case 'accessToken': {
                    if (cachedJsonValue && cachedJsonValue?.expires) {
                        if (!isValidAccessToken) {
                            console.log('Token is expired deleting..');
                            window.localStorage.setItem(cachedKey, null);
                            cachedJsonValue = null;
                        }
                    }
                    break;
                }
                case 'cart': {
                    if (cachedJsonValue && cachedJsonValue?.completedAt) {
                        if (!isValidAccessToken) {
                            console.log('Cart completed at deleting..');
                            window.localStorage.setItem(cachedKey, null);
                            cachedJsonValue = null;
                        }
                    }
                    break;
                }
                case 'country': {
                    if (cachedJsonValue && !cachedJsonValue?.isoCode) {
                        console.log('Invalid cached country object resetting..');
                        window.localStorage.setItem(cachedKey, null);
                        cachedJsonValue = null;
                    }
                    break;
                }
                default:
                    break;
            }
            // console.log('Setting initial', `"${key}"`, 'to', cachedJsonValue)
            if (topic && cachedJsonValue)
                (0, shared_1.publishBusEvent)(topic, cachedJsonValue);
            return cachedJsonValue;
        }
        catch (error) {
            console.error('setSelfToPersistedKey: Could not set initial persisted values for', key, error.message);
            return null;
        }
    });
};
exports.setSelfToPersistedKey = setSelfToPersistedKey;
//# sourceMappingURL=setSelfToPersistedKey.js.map

/***/ }),

/***/ 32065:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.resolveTopicData = exports.resolveCartTopics = exports.resolveCustomerTopics = exports.resolveViewRouteTopics = exports.routeToTemplate = exports.publishGtmEvent = exports.publishBusEvent = exports.SHOPIFY_NAME = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const router_1 = tslib_1.__importDefault(__webpack_require__(86677));
const pubsub_js_1 = tslib_1.__importDefault(__webpack_require__(67651));
const isBrowser = typeof window !== 'undefined';
exports.SHOPIFY_NAME = "briogeo-hair-care.myshopify.com"?.split('.')[0] || '';
// Publish to EventBus
// eslint-disable-next-line consistent-return
const publishBusEvent = (topic, data) => {
    if (typeof topic === 'undefined') {
        console.warn(`No topic was provided for Bus event`);
        return null;
    }
    if (typeof data === 'undefined') {
        console.warn(`No data was provided for ${topic} Bus event`);
        return null;
    }
    pubsub_js_1.default.publish(topic, data);
};
exports.publishBusEvent = publishBusEvent;
const publishGtmEvent = (topic, gtmData) => {
    if (!isBrowser)
        return null;
    if (typeof topic === 'undefined') {
        console.warn(`No topic was provided for GTM event`);
        return null;
    }
    if (typeof gtmData === 'undefined') {
        console.warn(`No data was provided for ${topic} GTM event`);
        return null;
    }
    // eslint-disable-next-line no-undef
    if (!window?.dataLayer) {
        // console.warn(`An initialized dataLayer is required before publishing GTM ${topic} events`);
        return false;
    }
    // add event to GTM
    // eslint-disable-next-line no-undef
    window.dataLayer.push({
        event: topic,
        data: gtmData,
    });
    return true;
};
exports.publishGtmEvent = publishGtmEvent;
const routeToTemplate = ({ route }) => [
    {
        path: '/',
        name: 'isHome',
    },
    {
        path: '/account',
        name: 'isAccount',
    },
    {
        path: '/cart',
        name: 'isCart',
    },
    {
        path: '/collections/',
        name: 'isCollection',
    },
    {
        path: '/pages/',
        name: 'isPage',
    },
    {
        path: '/products/',
        name: 'isProduct',
    },
    {
        path: '/blogs/',
        name: 'isBlog',
    },
    {
        path: '/articles/',
        name: 'isArticle',
    },
    {
        path: '/404',
        name: 'is404',
    },
].reduce((templates, template) => {
    const _templates = templates;
    // check for home
    if (template.path === '/') {
        _templates[template.name] = route === template.path;
    }
    else {
        // non home routes
        const isValidPath = route.includes(template.path);
        _templates[template.name] = !!isValidPath;
    }
    return _templates;
}, {
    // initial templates
    isAccount: false,
    isArticle: false,
    isBlog: false,
    isCart: false,
    isCollection: false,
    isHome: false,
    isPage: false,
    isProduct: false,
    is404: false,
});
exports.routeToTemplate = routeToTemplate;
const resolveViewRouteTopics = (route) => {
    try {
        const template = (0, exports.routeToTemplate)({ route });
        const { isAccount, isArticle, isBlog, isCart, isCollection, isHome, isPage, isProduct, is404, } = template;
        const routeProps = router_1.default?.router?.components?.[router_1.default.route]?.props?.pageProps || null;
        switch (true) {
            case isAccount:
                return ['VIEW_ACCOUNT', route];
            case isArticle:
                return ['VIEW_ARTICLE', routeProps?.article || route];
            case isBlog:
                return ['VIEW_BLOG', routeProps?.blog || route];
            case isCart:
                return ['VIEW_CART', route];
            case isCollection: {
                const collectionFirst100products = {
                    ...routeProps?.collection,
                    products: routeProps?.collection?.products?.slice(0, 100),
                };
                return ['VIEW_COLLECTION', collectionFirst100products || route];
            }
            case isHome:
                return ['VIEW_HOME', routeProps?.page || route];
            case isPage:
                return ['VIEW_PAGE', routeProps?.page || route];
            case isProduct:
                return ['VIEW_PRODUCT', routeProps?.product || route];
            case is404:
                return ['VIEW_404', routeProps?.page || route];
            default:
                return ['VIEW_OTHER', route];
        }
    }
    catch (error) {
        console.error('resolveViewRouteTopics failed due to', error.message);
        return ['ROUTE_UPDATE', null];
    }
};
exports.resolveViewRouteTopics = resolveViewRouteTopics;
const resolveVariantTopics = (topic, currentVariant) => {
    const variantIsAvailable = currentVariant &&
        (currentVariant?.inventoryPolicy === 'CONTINUE' ||
            currentVariant?.inventoryQuantity > 0);
    if (variantIsAvailable) {
        if (currentVariant.inventoryPolicy === 'CONTINUE') {
            return ['SELECTED_VARIANT_AVAILABLE_CONTINUE', currentVariant];
        }
        return ['SELECTED_VARIANT_AVAILABLE', currentVariant];
    }
    if (!variantIsAvailable) {
        return ['SELECTED_VARIANT_SOLDOUT', currentVariant];
    }
    return [topic, currentVariant];
};
// eslint-disable-next-line consistent-return
const resolveCustomerTopics = (customer, prevCustomer) => {
    if (prevCustomer && customer) {
        return ['CUSTOMER_LOGIN', customer];
    }
    if (!prevCustomer && customer) {
        return ['CUSTOMER_LOGIN', customer];
    }
    if (prevCustomer && !customer) {
        return ['CUSTOMER_LOGOUT', prevCustomer];
    }
    return [];
};
exports.resolveCustomerTopics = resolveCustomerTopics;
const getTotalItems = (items) => items?.length
    ? items.reduce((total, { quantity }) => total + quantity, 0)
    : 0;
const resolveCartTopics = (topic, cart, prevCart) => {
    try {
        const lineItems = cart?.lines?.length;
        const lineItemsPrev = prevCart?.lines?.length || 0;
        const totalItems = getTotalItems(cart?.lines);
        const totalItemsPrev = getTotalItems(prevCart?.lines) || 0;
        const discounts = cart?.discountApplications?.length;
        const discountsPrev = prevCart?.discountApplications?.length;
        const createdAt = cart?.createdAt ? new Date(cart.createdAt) : null;
        const updatedAt = cart?.updatedAt ? new Date(cart.updatedAt) : null;
        const completedAt = cart?.completedAt ? new Date(cart.completedAt) : null;
        if (lineItems > lineItemsPrev) {
            // diff between both lineItemLists
            const addedItem = cart.lines?.filter(({ id: id1 }) => !prevCart?.lines?.some(({ id: id2 }) => id2 === id1));
            return ['CART_ADD_ITEM', addedItem];
        }
        if (lineItems < lineItemsPrev) {
            const removedItem = prevCart?.lines?.length
                ? prevCart.lines.filter(({ id: id1 }) => !cart.lines?.some(({ id: id2 }) => id2 === id1))
                : null;
            if (totalItemsPrev > 1 && totalItems === 0) {
                return ['CART_CLEARED', prevCart];
            }
            return ['CART_REMOVE_ITEM', removedItem];
        }
        if (totalItems !== totalItemsPrev) {
            if (totalItems > totalItemsPrev) {
                const modifiedItem = cart.lines?.filter(({ id: id1, quantity: qty1 }) => !prevCart?.lines?.some(({ id: id2, quantity: qty2 }) => id2 === id1 && qty1 === qty2));
                return ['CART_INCREASE_ITEM_QUANTITY', modifiedItem];
            }
            const modifiedItem = prevCart.lines?.filter(({ id: id1, quantity: qty1 }) => !cart?.lines?.some(({ id: id2, quantity: qty2 }) => id2 === id1 && qty1 === qty2));
            return ['CART_REDUCE_ITEM_QUANTITY', modifiedItem];
        }
        // Discounts
        if (discountsPrev < discounts) {
            // eslint-disable-next-line no-undef
            if (window?.location?.href?.includes('discountCode=')) {
                return ['CART_ADD_DISCOUNT_URL', cart?.discountApplications?.[0]?.code];
            }
            return ['CART_ADD_DISCOUNT', cart?.discountApplications?.[0]?.code];
        }
        if (discountsPrev > discounts) {
            return [
                'CART_REMOVE_DISCOUNT',
                prevCart?.discountApplications?.[0]?.code,
            ];
        }
        // notes
        if (cart?.note !== prevCart?.note) {
            if (prevCart?.note === null && cart.note) {
                return ['CART_ADD_NOTE', cart?.note];
            }
            if (prevCart?.note !== cart.note) {
                return ['CART_UPDATED_NOTE', cart?.note];
            }
            if (cart?.note === null && prevCart.note) {
                return ['CART_REMOVED_NOTE', cart?.note];
            }
        }
        if (completedAt) {
            return ['CART_PURCHASED', cart];
        }
        if (updatedAt > createdAt && totalItems) {
            return ['CART_UPDATED', cart];
        }
        if (!prevCart && cart) {
            return ['CART_CREATE', cart];
        }
        return ['CART_READY', cart];
    }
    catch (error) {
        console.error('resolveCartTopics failed due to:', error.message);
        return [null, null];
    }
};
exports.resolveCartTopics = resolveCartTopics;
// eslint-disable-next-line consistent-return
const resolveTopicData = (topicGroup, newValue, oldValue) => {
    try {
        switch (true) {
            case ['ROUTE_UPDATE'].includes(topicGroup): {
                return (0, exports.resolveViewRouteTopics)(newValue, oldValue);
            }
            case ['CUSTOMER_INIT'].includes(topicGroup): {
                return ['CUSTOMER_INIT', newValue];
            }
            case ['CUSTOMER_UPDATE'].includes(topicGroup): {
                return (0, exports.resolveCustomerTopics)(newValue, oldValue);
            }
            case ['CART_UPDATE'].includes(topicGroup): {
                return (0, exports.resolveCartTopics)(topicGroup, newValue, oldValue);
            }
            case ['COUNTRY_UPDATE'].includes(topicGroup): {
                return ['COUNTRY_UPDATE', newValue];
            }
            case ['VARIANT_UPDATE'].includes(topicGroup): {
                return resolveVariantTopics(topicGroup, newValue, oldValue);
            }
            case ['CHECKOUT'].includes(topicGroup): {
                return ['CHECKOUT', newValue];
            }
            case ['CUSTOMER_REGISTERED'].includes(topicGroup): {
                return ['CUSTOMER_REGISTERED', newValue];
            }
            default: {
                return [topicGroup, newValue];
            }
        }
    }
    catch (error) {
        console.error('resolveTopicData failed due', error.message);
    }
};
exports.resolveTopicData = resolveTopicData;
//# sourceMappingURL=shared.js.map

/***/ }),

/***/ 42667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Localize = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
const isomorphic_fetch_1 = tslib_1.__importDefault(__webpack_require__(84447));
const defaultProps = { country: 'US', currency: 'USD' };
class Localize {
    constructor({ country, currency } = defaultProps) {
        this.country = country;
        this.currency = currency;
    }
    /**
     * fetch a country's locale (extended info) by currencyCode or countryCode
     */
    async fetchLocale({ countryCode, currencyCode }) {
        if (!currencyCode && !countryCode) {
            throw new Error('"currencyCode" or "countryCode" must be provided');
        }
        const isDev = "production" !== 'production';
        const server = isDev ? 'http://localhost:8080' : "https://www.briogeohair.com";
        const endpoint = `${server}/api/shopify/locale`;
        const localeRequest = await (0, isomorphic_fetch_1.default)(endpoint, {
            method: 'POST',
            body: JSON.stringify({ countryCode, currencyCode }),
        });
        const { response } = await localeRequest.json();
        const { locale } = response;
        return locale;
    }
    localize({ amount, locale }) {
        const localeOptions = {
            style: 'currency',
            currency: locale.currency || this.currency,
        };
        const localizedAmount = new Intl.NumberFormat(locale.defaultLocale, localeOptions).format(amount);
        return localizedAmount.replace(/\.00$/, '');
    }
    /**
     * Add locale info to the cart, and localizes estimatedCosts and line prices for the current country
     * @param {*} param0
     * @returns
     */
    cartTotals({ cart, locale }) {
        const { discountAmount, totalSavingsAmount, totalDiscountAmount, totalCompareAtAmount, } = this.cartCombinedTotals({
            lines: cart.lines,
            locale,
        });
        const estimatedCost = this.estimatedCost({
            estimatedCost: cart.estimatedCost,
            locale,
            discountAmount,
            totalDiscountAmount,
            totalSavingsAmount,
            totalCompareAtAmount,
        });
        return { ...cart, locale, estimatedCost };
    }
    // estimate the total discount amount from, discount codes + subscriptions
    cartCombinedTotals({ lines, locale }) {
        let discountAmount = null; // custom
        let totalDiscountAmount = null; // custom
        let totalSavingsAmount = null; // custom
        let totalCompareAtAmount = null; // custom
        // get combined savings, discounts and compareAt (full price)
        // from all line items so we can display the full breakdown
        const combinedDefault = {
            combinedSavings: 0,
            combinedDiscount: 0,
            combinedDiscountTotal: 0,
            combineCompareAt: 0,
        };
        const itemTotals = (_total, line) => {
            const localizedLine = this.cartLine({ line, locale });
            // subscription discounts
            const savingsAmount = localizedLine?.estimatedCost?.savingsAmount;
            const lineDiscount = localizedLine?.estimatedCost?.discountAmount;
            const compareAtPriceAmount = localizedLine?.estimatedCost?.compareAtPriceAmount;
            const lineTotal = { ..._total };
            if (savingsAmount) {
                lineTotal.combinedSavings += savingsAmount.amountTotal;
            }
            if (lineDiscount) {
                lineTotal.combinedDiscount += lineDiscount.amountTotal;
            }
            if (compareAtPriceAmount) {
                lineTotal.combineCompareAt += compareAtPriceAmount.amountTotal;
            }
            // used as Discounted Total when theres discounts as subTotal does not include discount deductions
            lineTotal.combinedDiscountTotal +=
                localizedLine?.estimatedCost.totalAmount.amount;
            return lineTotal;
        };
        const { combinedSavings, combinedDiscountTotal, combinedDiscount, combineCompareAt, } = lines.reduce(itemTotals, combinedDefault);
        if (combinedSavings) {
            totalSavingsAmount = {
                amount: combinedSavings,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combinedSavings, locale }),
            };
        }
        if (combinedDiscount) {
            discountAmount = {
                amount: combinedDiscount,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combinedDiscount, locale }),
            };
        }
        if (combinedDiscountTotal) {
            totalDiscountAmount = {
                amount: combinedDiscountTotal,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combinedDiscountTotal, locale }),
            };
        }
        if (combineCompareAt) {
            totalCompareAtAmount = {
                amount: combineCompareAt,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combineCompareAt, locale }),
            };
        }
        return {
            discountAmount,
            totalDiscountAmount,
            totalSavingsAmount,
            totalCompareAtAmount,
        };
    }
    /**
     * Adds locale, compareAt and priceV2 locale pricing to a variant
     */
    cartLine({ line, locale }) {
        try {
            const variant = { ...line.variant, locale };
            let compareAtPriceAmount = null; // the full price before (sale)
            // localize cart line discountAllocations
            const { discountAllocations, discountAmount } = this.cartLineDiscountAllocations({
                discountAllocations: [...line.discountAllocations],
                quantity: line.quantity,
                locale,
            });
            // localize cartLine variant
            // localize priceV2
            const priceV2amount = parseFloat(variant.priceV2.amount);
            const priceV2amountTotal = priceV2amount * line.quantity;
            variant.priceV2 = {
                ...variant.priceV2,
                amount: priceV2amount,
                amountTotal: priceV2amountTotal,
                locale: this.localize({ amount: priceV2amount, locale }),
                localeTotal: this.localize({ amount: priceV2amountTotal, locale }),
            };
            compareAtPriceAmount = variant.priceV2;
            // // localize compareAtPriceV2
            if (variant?.compareAtPriceV2) {
                const compareAtPriceV2amount = parseFloat(variant.compareAtPriceV2.amount);
                const compareAtPriceV2amountTotal = compareAtPriceV2amount * line.quantity;
                variant.compareAtPriceV2 = {
                    ...variant.compareAtPriceV2,
                    amount: compareAtPriceV2amount,
                    amountTotal: compareAtPriceV2amountTotal,
                    locale: this.localize({ amount: compareAtPriceV2amount, locale }),
                    localeTotal: this.localize({
                        amount: compareAtPriceV2amountTotal,
                        locale,
                    }),
                };
                compareAtPriceAmount = variant.compareAtPriceV2;
            }
            // // localize compareAtPriceV2
            if (variant?.unitPrice) {
                const unitPriceAmount = parseFloat(variant.unitPrice.amount);
                const unitPriceAmountTotal = unitPriceAmount * line.quantity;
                variant.unitPrice = {
                    ...variant.unitPrice,
                    amount: unitPriceAmount,
                    amountTotal: unitPriceAmountTotal,
                    locale: this.localize({ amount: unitPriceAmount, locale }),
                    localeTotal: this.localize({
                        amount: unitPriceAmountTotal,
                        locale,
                    }),
                };
            }
            // // localize discountAtPrice
            if (variant?.discountAtPrice) {
                const discountAtPriceAmount = parseFloat(variant.discountAtPrice.amount);
                const discountAtPriceAmountTotal = discountAtPriceAmount * line.quantity;
                variant.discountAtPrice = {
                    ...variant.discountAtPrice,
                    amount: discountAtPriceAmount,
                    amountTotal: discountAtPriceAmountTotal,
                    locale: this.localize({
                        amount: discountAtPriceAmount,
                        locale,
                    }),
                    localeTotal: this.localize({
                        amount: discountAtPriceAmountTotal,
                        locale,
                    }),
                };
            }
            // maybe localize selling plan allocation for the line item
            let { sellingPlanAllocation } = line;
            if (sellingPlanAllocation) {
                sellingPlanAllocation = this.cartLineSellingPlanAllocation({
                    sellingPlanAllocation: { ...line.sellingPlanAllocation },
                    locale,
                    quantity: line.quantity,
                });
            }
            // if subscription, we use the sellingPlanAllocation savings else,
            // we use the variant compareAt and priceV2amount to estimate the savings
            let savingsAmount = null;
            const isSubscription = sellingPlanAllocation;
            if (isSubscription) {
                savingsAmount = sellingPlanAllocation.priceAdjustments[0].savingsAmount;
                // we overwrite this use the one from subscription
                compareAtPriceAmount =
                    sellingPlanAllocation.priceAdjustments[0].compareAtPrice;
            }
            else if (variant.compareAtPriceV2) {
                // one-time item
                const savingAmount = variant.compareAtPriceV2.amount - variant.priceV2.amount;
                const savingAmountTotal = variant.compareAtPriceV2.amountTotal - variant.priceV2.amountTotal;
                savingsAmount = savingAmount
                    ? {
                        amount: parseFloat(savingAmount.toFixed(2)),
                        amountTotal: parseFloat(savingAmountTotal.toFixed(2)),
                        currencyCode: locale.currency,
                        locale: this.localize({ amount: savingAmount, locale }),
                        localeTotal: this.localize({
                            amount: savingAmountTotal,
                            locale,
                        }),
                    }
                    : null;
            }
            // localize estimatedCost
            const estimatedCost = this.estimatedCost({
                estimatedCost: { ...line.estimatedCost },
                locale,
                discountAmount,
                savingsAmount,
                compareAtPriceAmount,
            });
            return {
                ...line,
                sellingPlanAllocation,
                estimatedCost,
                discountAllocations,
                variant,
                locale,
            };
        }
        catch (error) {
            console.error('cartLine:error', error);
            return line;
        }
    }
    /**
     * Adds locale, compareAt and priceV2 locale pricing to a variant
     */
    estimatedCost({ estimatedCost: cost, locale, discountAmount, // optional
    savingsAmount, // optional
    compareAtPriceAmount, // optional
    totalSavingsAmount, // optional
    totalDiscountAmount, // optional
    totalCompareAtAmount, // optional
     }) {
        const estimatedCost = { ...cost };
        // localize official fields
        if (cost?.subtotalAmount) {
            const subTotalAmount = parseFloat(cost.subtotalAmount.amount);
            estimatedCost.subtotalAmount = {
                ...estimatedCost.subtotalAmount,
                amount: subTotalAmount,
                locale: this.localize({ amount: subTotalAmount, locale }),
            };
        }
        if (cost?.totalAmount) {
            const totalAmount = parseFloat(cost.totalAmount.amount);
            estimatedCost.totalAmount = {
                ...estimatedCost.totalAmount,
                amount: totalAmount,
                locale: this.localize({ amount: totalAmount, locale }),
            };
        }
        if (cost?.totalDutyAmount) {
            const totalDutyAmount = parseFloat(cost.totalDutyAmount.amount);
            estimatedCost.totalDutyAmount = {
                ...estimatedCost.totalDutyAmount,
                amount: totalDutyAmount,
                locale: this.localize({ amount: totalDutyAmount, locale }),
            };
        }
        if (cost?.totalTaxAmount) {
            const totalTaxAmount = parseFloat(cost.totalTaxAmount.amount);
            estimatedCost.totalTaxAmount = {
                ...estimatedCost.totalTaxAmount,
                amount: totalTaxAmount,
                locale: this.localize({ amount: totalTaxAmount, locale }),
            };
        }
        // localize custom fields
        if (typeof discountAmount !== 'undefined') {
            estimatedCost.discountAmount = discountAmount;
        }
        if (typeof savingsAmount !== 'undefined') {
            estimatedCost.savingsAmount = savingsAmount;
        }
        if (typeof totalDiscountAmount !== 'undefined') {
            estimatedCost.totalDiscountAmount = totalDiscountAmount;
        }
        if (typeof totalSavingsAmount !== 'undefined') {
            estimatedCost.totalSavingsAmount = totalSavingsAmount;
        }
        if (typeof totalCompareAtAmount !== 'undefined') {
            estimatedCost.totalCompareAtAmount = totalCompareAtAmount;
        }
        if (compareAtPriceAmount) {
            estimatedCost.compareAtPriceAmount = compareAtPriceAmount;
        }
        return estimatedCost;
    }
    // Localize the line item's subscription pricing
    cartLineSellingPlanAllocation({ sellingPlanAllocation: _sellingPlanAllocation, locale, quantity, }) {
        const { priceAdjustments: _priceAdjustments, sellingPlan } = _sellingPlanAllocation;
        // localize each selling plan price adjustment for the given line item
        /**
          A list of price adjustments, with a maximum of two. When there are two
          the first price adjustment goes into effect at the time of purchase,
          while the second one starts after a certain number of orders
         */
        const priceAdjustments = _priceAdjustments?.map(({ compareAtPrice, perDeliveryPrice, price, unitPrice }) => {
            const localized = {};
            /**
              The price of the variant when it's purchased without a selling plan for the same number of deliveries.
              For example, if a customer purchases 6 deliveries of $10.00 granola separately, then the price is 6 x $10.00 = $60.00.
             */
            if (compareAtPrice) {
                localized.compareAtPrice = { ...compareAtPrice };
                const compareAtPriceAmount = parseFloat(compareAtPrice.amount);
                const compareAtPriceAmountTotal = compareAtPriceAmount * quantity;
                localized.compareAtPrice.amount = compareAtPriceAmount;
                localized.compareAtPrice.amountTotal = compareAtPriceAmountTotal;
                localized.compareAtPrice.locale = this.localize({
                    amount: compareAtPriceAmount,
                    locale,
                });
                localized.compareAtPrice.localeTotal = this.localize({
                    amount: compareAtPriceAmountTotal,
                    locale,
                });
            }
            /**
              The effective price for a single delivery. For example, for a prepaid subscription plan that
              includes 6 deliveries at the price of $48.00, the per delivery price is $8.00.
             */
            if (perDeliveryPrice) {
                localized.perDeliveryPrice = { ...perDeliveryPrice };
                const perDeliveryPriceAmount = parseFloat(perDeliveryPrice.amount);
                const perDeliveryPriceAmountTotal = perDeliveryPriceAmount * quantity;
                localized.perDeliveryPrice.amount = perDeliveryPriceAmount;
                localized.perDeliveryPrice.amountTotal = perDeliveryPriceAmountTotal;
                localized.perDeliveryPrice.locale = this.localize({
                    amount: perDeliveryPriceAmount,
                    locale,
                });
                localized.perDeliveryPrice.localeTotal = this.localize({
                    amount: perDeliveryPriceAmountTotal,
                    locale,
                });
            }
            /**
              The price of the variant when it's purchased with a selling plan For example, for a prepaid subscription plan
              that includes 6 deliveries of $10.00 granola, where the customer gets 20% off, the price is 6 x $10.00 x 0.80 = $48.00.
             */
            if (price) {
                localized.price = { ...price };
                const priceAmount = parseFloat(price.amount);
                const priceAmountTotal = priceAmount * quantity;
                localized.price.amount = priceAmount;
                localized.price.amountTotal = priceAmountTotal;
                localized.price.locale = this.localize({
                    amount: priceAmount,
                    locale,
                });
                localized.price.localeTotal = this.localize({
                    amount: priceAmountTotal,
                    locale,
                });
            }
            /**
              The resulting price per unit for the variant associated with the selling plan.
              If the variant isn't sold by quantity or measurement, then this field returns null.
             */
            if (unitPrice) {
                localized.unitPrice = { ...unitPrice };
                const unitPriceAmount = parseFloat(unitPrice.amount);
                const unitPriceAmountTotal = unitPriceAmount * quantity;
                localized.unitPrice.amount = unitPriceAmount;
                localized.unitPrice.amountTotal = unitPriceAmountTotal;
                localized.unitPrice.locale = this.localize({
                    amount: unitPriceAmount,
                    locale,
                });
                localized.unitPrice.localeTotal = this.localize({
                    amount: unitPriceAmountTotal,
                    locale,
                });
            }
            /**
              A custom property we add to calculate the discount amount applied by the subscription
             */
            const savingsAmount = localized.compareAtPrice.amount - localized.price.amount;
            const savingsAmountTotal = localized.compareAtPrice.amountTotal - localized.price.amountTotal;
            localized.savingsAmount = savingsAmount
                ? {
                    amount: parseFloat(savingsAmount.toFixed(2)),
                    amountTotal: parseFloat(savingsAmountTotal.toFixed(2)),
                    currencyCode: localized.compareAtPrice.currencyCode,
                    locale: this.localize({
                        amount: savingsAmount,
                        locale,
                    }),
                    localeTotal: this.localize({
                        amount: savingsAmountTotal,
                        locale,
                    }),
                }
                : null;
            return localized;
        });
        return { priceAdjustments, sellingPlan };
    }
    cartLineDiscountAllocations({ discountAllocations: _discountAllocations, quantity, locale, }) {
        let discountAmount = null; // the amount discounted
        const discountAllocations = [..._discountAllocations].map(({ discountedAmount: _discountAmount }) => {
            const amount = parseFloat(_discountAmount.amount);
            const amountTotal = amount * quantity;
            discountAmount = {
                ..._discountAmount,
                amount,
                amountTotal,
                locale: this.localize({ amount, locale }),
                localeTotal: this.localize({ amount: amountTotal, locale }),
            };
            return { discountAmount };
        });
        return { discountAllocations, discountAmount };
    }
    /**
     * Adds locale, locale min and max pricing to the product and compareAt and priceV2 locale pricing to its variants
     */
    product({ product: rawProduct, locale }) {
        const product = { ...rawProduct, locale };
        product.priceRange.maxVariantPrice.locale = this.localize({
            amount: product.priceRange.maxVariantPrice.amount,
            locale,
        });
        // localize minVariantPrice
        product.priceRange.minVariantPrice.locale = this.localize({
            amount: product.priceRange.minVariantPrice.amount,
            locale,
        });
        // localize variants
        product.variants = this.variants({
            variants: product.variants,
            locale,
        });
        return product;
    }
    /**
     * Localizes all product variants
     */
    variants({ variants = [], locale }) {
        return variants.map((variant) => {
            return this.variant({ variant, locale });
        });
    }
    /**
     * Adds locale, compareAt and priceV2 locale pricing to a variant
     */
    variant({ variant: rawVariant, locale }) {
        const variant = { ...rawVariant, locale };
        // localize the variant price
        let amount = parseFloat(variant.priceV2.amount);
        variant.priceV2 = {
            ...variant.priceV2,
            amount,
            locale: this.localize({ amount, locale }),
        };
        // localize the variant compareAtPriceV2
        if (variant?.compareAtPriceV2?.amount) {
            amount = parseFloat(variant.compareAtPriceV2.amount);
            variant.compareAtPriceV2 = {
                ...variant?.compareAtPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        // localize the variant sellingPlansAllocations
        if (variant?.sellingPlanAllocations?.length) {
            variant.sellingPlanAllocations = this.sellingPlanAllocations({
                sellingPlanAllocations: variant.sellingPlanAllocations,
                locale,
            });
        }
        return variant;
    }
    /**
     * Localize all selling plan allocations
     */
    sellingPlanAllocations({ sellingPlanAllocations: _sellingPlanAllocations = [], locale, }) {
        const sellingPlanAllocations = [..._sellingPlanAllocations];
        return sellingPlanAllocations.map((allocation) => {
            return this.sellingPlan({ allocation, locale });
        });
    }
    /**
     * Localize a single selling plan
     */
    sellingPlan({ allocation: _allocation, locale }) {
        const { priceAdjustments: _priceAdjustments, sellingPlan } = _allocation;
        // const adjustmentValue = sellingPlan?.priceAdjustments?.[0]?.adjustmentValue;
        // // A percentage amount that's deducted from the original variant price. For example, 10% off.
        // const percentageOff = adjustmentValue?.adjustmentPercentage || 0;
        // // A fixed price adjustment for a variant that's purchased with a selling plan.
        // const fixedPrice = adjustmentValue?.price?.amount || 0;
        // // A fixed amount that's deducted from the original variant price. For example, $10.00 off.
        // const amountOff = adjustmentValue?.adjustmentAmount?.amount || 0;
        const priceAdjustments = _priceAdjustments.map((adjustment) => {
            let { compareAtPrice, price, perDeliveryPrice, unitPrice } = adjustment;
            // localize selling plan compareAtPrice (Full price if no discount)
            if (compareAtPrice?.amount) {
                const amount = parseFloat(compareAtPrice.amount);
                compareAtPrice = {
                    ...compareAtPrice,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            // localize selling plan price
            if (price?.amount) {
                const amount = parseFloat(price.amount);
                price = {
                    ...price,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            // localize selling plan perDeliveryPrice
            if (perDeliveryPrice?.amount) {
                const amount = parseFloat(perDeliveryPrice.amount);
                perDeliveryPrice = {
                    ...perDeliveryPrice,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            // localize selling plan unitPrice
            if (unitPrice?.amount) {
                const amount = parseFloat(unitPrice.amount);
                unitPrice = {
                    ...unitPrice,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            return { compareAtPrice, price, perDeliveryPrice, unitPrice };
        });
        return { priceAdjustments, sellingPlan };
    }
    orderTotals({ order: rawOrder, locale }) {
        const order = { ...rawOrder, locale };
        // currents
        if (order?.currentTotalTax?.amount) {
            const amount = parseFloat(order.currentTotalTax.amount);
            order.currentTotalTax = {
                ...order?.currentTotalTax,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.currentTotalDuties?.amount) {
            const amount = parseFloat(order.currentTotalDuties.amount);
            order.currentTotalDuties = {
                ...order.currentTotalDuties,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.currentSubtotalPrice?.amount) {
            const amount = parseFloat(order.currentSubtotalPrice.amount);
            order.currentSubtotalPrice = {
                ...order.currentSubtotalPrice,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        // totals
        if (order?.totalPriceV2?.amount) {
            const amount = parseFloat(order.totalPriceV2.amount);
            order.totalPriceV2 = {
                ...order.totalPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.subtotalPriceV2?.amount) {
            const amount = parseFloat(order.subtotalPriceV2.amount);
            order.subtotalPriceV2 = {
                ...order.subtotalPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.totalRefundedV2?.amount) {
            const amount = parseFloat(order.totalRefundedV2.amount);
            order.totalRefundedV2 = {
                ...order.totalRefundedV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.totalShippingPriceV2?.amount) {
            const amount = parseFloat(order.totalShippingPriceV2.amount);
            order.totalShippingPriceV2 = {
                ...order.totalShippingPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.totalTaxV2?.amount) {
            const amount = parseFloat(order.totalTaxV2.amount);
            order.totalTaxV2 = {
                ...order.totalTaxV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        return order;
    }
    orderLine({ line: rawLine, locale, currentLocale }) {
        const line = { ...rawLine, locale };
        // localize to order's original locale
        if (line?.originalTotalPrice?.amount) {
            const amount = parseFloat(line.originalTotalPrice.amount);
            line.originalTotalPrice = {
                ...line.originalTotalPrice,
                amount,
                locale: this.localize({
                    amount,
                    locale,
                }),
            };
        }
        // discounted line price
        let allocatedAmount = null;
        line.discountAllocations = line.discountAllocations.map(({ allocatedAmount: _allocatedAmount }) => {
            const amount = parseFloat(_allocatedAmount.amount);
            allocatedAmount = {
                ..._allocatedAmount,
                amount,
                locale: this.localize({
                    amount,
                    locale,
                }),
            };
            return { allocatedAmount };
        });
        line.discountAmount = allocatedAmount;
        // overwriting
        const discountedPriceAmount = allocatedAmount?.amount
            ? parseFloat(line.originalTotalPrice.amount) -
                parseFloat(line.discountAmount.amount)
            : line.originalTotalPrice.amount;
        line.discountedTotalPrice = {
            ...line.originalTotalPrice,
            amount: discountedPriceAmount,
            locale: this.localize({
                amount: discountedPriceAmount,
                locale,
            }),
        };
        // localize variants to current locale (not orders loale)
        line.variant = this.variant({
            variant: line.variant,
            locale: currentLocale,
        });
        return line;
    }
}
exports.Localize = Localize;
//# sourceMappingURL=Localize.js.map

/***/ }),

/***/ 21772:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodedId = void 0;
/**
 * Decodes a base64 encoded id to a string.
 *  Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zOTYzMDYzMzU5OTE2MA -> gid://shopify/ProductVariant/39630633599160
 * @param {*} id a base64 encodedId
 * @returns decoded if
 */
const decodedId = (id) => {
    try {
        if (!id)
            return null;
        return window.atob(id);
    }
    catch (error) {
        return id;
    }
};
exports.decodedId = decodedId;
//# sourceMappingURL=decodedId.js.map

/***/ }),

/***/ 82708:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAddAction = void 0;
const tslib_1 = __webpack_require__(59312);
const lodash_isequal_1 = tslib_1.__importDefault(__webpack_require__(62004));
const getAddAction = ({ cart, data }) => {
    const sameVariantIdAndSellingPlan = ({ variant, sellingPlanAllocation }) => {
        // if the variant id is the same, and the selling plan is the same
        return (variant.id === data?.merchandiseId &&
            sellingPlanAllocation?.sellingPlan?.id === data?.sellingPlanId);
    };
    const mapAttributes = (attributesArray = []) => attributesArray.reduce((attrs, { key, value }) => {
        return { ...attrs, [key]: value };
    }, {});
    const itemInCart = cart.lines.find(sameVariantIdAndSellingPlan) || null;
    const itemInCartAttributes = itemInCart?.attributes
        ? mapAttributes(itemInCart.attributes)
        : {};
    const addingItemAttributes = data?.attributes
        ? mapAttributes(data.attributes)
        : {};
    const haveSameAttributes = itemInCart
        ? (0, lodash_isequal_1.default)(itemInCartAttributes, addingItemAttributes)
        : false;
    const attributes = data?.attributes?.length ? data.attributes : [];
    return { itemInCart, haveSameAttributes, attributes };
};
exports.getAddAction = getAddAction;
//# sourceMappingURL=getAddAction.js.map

/***/ }),

/***/ 85542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Localize = exports.useRecoilStartFinishErrors = exports.useStartFinishErrors = exports.useMounted = exports.getAddAction = exports.decodedId = void 0;
var decodedId_1 = __webpack_require__(21772);
Object.defineProperty(exports, "decodedId", ({ enumerable: true, get: function () { return decodedId_1.decodedId; } }));
var getAddAction_1 = __webpack_require__(82708);
Object.defineProperty(exports, "getAddAction", ({ enumerable: true, get: function () { return getAddAction_1.getAddAction; } }));
var useMounted_1 = __webpack_require__(14180);
Object.defineProperty(exports, "useMounted", ({ enumerable: true, get: function () { return useMounted_1.useMounted; } }));
var useStartFinishErrors_1 = __webpack_require__(50798);
Object.defineProperty(exports, "useStartFinishErrors", ({ enumerable: true, get: function () { return useStartFinishErrors_1.useStartFinishErrors; } }));
var useRecoilStartFinishErrors_1 = __webpack_require__(62574);
Object.defineProperty(exports, "useRecoilStartFinishErrors", ({ enumerable: true, get: function () { return useRecoilStartFinishErrors_1.useRecoilStartFinishErrors; } }));
var Localize_1 = __webpack_require__(42667);
Object.defineProperty(exports, "Localize", ({ enumerable: true, get: function () { return Localize_1.Localize; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 14180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMounted = void 0;
const react_1 = __webpack_require__(27378);
const useMounted = () => {
    const [isMounted, setIsMounted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let unmounting = false;
        if (!unmounting) {
            setIsMounted(true);
        }
        return () => {
            unmounting = true;
        };
    }, []);
    return isMounted;
};
exports.useMounted = useMounted;
//# sourceMappingURL=useMounted.js.map

/***/ }),

/***/ 62574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRecoilStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useRecoilStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.cartStatusStarted('cart/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.cartStatusFinished('cart/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.cartStatusSuccess('cart/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.cartStatusErrors('cart/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.cartStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.cartStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.cartStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.cartStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        console.log(options.id, 'updateStateOnErrors....', errors);
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (options?.id) {
                console.groupCollapsed('id', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useRecoilStartFinishErrors = useRecoilStartFinishErrors;
//# sourceMappingURL=useRecoilStartFinishErrors.js.map

/***/ }),

/***/ 50798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.cartStatusStarted('global'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.cartStatusFinished('global'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.cartStatusSuccess('global'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.cartStatusErrors('global'));
    const [started, setStarted] = (0, react_1.useState)(options?.started || false);
    const [success, setSuccess] = (0, react_1.useState)(options?.success || false);
    const [finished, setFinished] = (0, react_1.useState)(options?.finished || false);
    const [errors, setErrors] = (0, react_1.useState)(options?.errors || []);
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (options?.id) {
                console.groupCollapsed('id', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            setStarted(false);
            setSuccess(errors?.length === 0);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        setCartErrors(errors);
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (options?.id) {
            console.log('setting started to', started);
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        if (options?.id) {
            console.log('setting finished to', finished);
            setCartFinished(finished);
            const to = setTimeout(() => {
                if (unMounting)
                    return;
                setCartFinished(false);
                clearTimeout(to);
            }, 1000);
        }
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        setCartSuccess(success);
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useStartFinishErrors = useStartFinishErrors;
//# sourceMappingURL=useStartFinishErrors.js.map

/***/ }),

/***/ 17610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(772), exports);
tslib_1.__exportStar(__webpack_require__(51457), exports);
tslib_1.__exportStar(__webpack_require__(48081), exports);
tslib_1.__exportStar(__webpack_require__(50010), exports);
tslib_1.__exportStar(__webpack_require__(33296), exports);
tslib_1.__exportStar(__webpack_require__(29196), exports);
tslib_1.__exportStar(__webpack_require__(95314), exports);
tslib_1.__exportStar(__webpack_require__(68335), exports);
tslib_1.__exportStar(__webpack_require__(80972), exports);
tslib_1.__exportStar(__webpack_require__(5852), exports);
tslib_1.__exportStar(__webpack_require__(42022), exports);
tslib_1.__exportStar(__webpack_require__(8844), exports);
tslib_1.__exportStar(__webpack_require__(85542), exports);
//# sourceMappingURL=hooks.js.map

/***/ }),

/***/ 52031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.store = exports.StateProvider = void 0;
const tslib_1 = __webpack_require__(59312);
/* exports all storefront effects so they can be used in the project */
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
 * Pass down the storefront recoil hooks to the project
 * so that they can be in the same shared recoil instance
 */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
var StateProvider_1 = __webpack_require__(79141);
Object.defineProperty(exports, "StateProvider", ({ enumerable: true, get: function () { return StateProvider_1.StateProvider; } }));
/* eslint-disable import/export */
tslib_1.__exportStar(__webpack_require__(17610), exports); // These hooks will be the default hooks found in @backpackjs/storefront
exports.store = {
    state: store_1.default,
    effects: effects_1.default,
    recoil: {
        useRecoilState: store_1.useRecoilState,
        useRecoilStateLoadable: store_1.useRecoilStateLoadable,
        useSetRecoilState: store_1.useSetRecoilState,
        useResetRecoilState: store_1.useResetRecoilState,
        useRecoilValue: store_1.useRecoilValue,
        useRecoilValueLoadable: store_1.useRecoilValueLoadable,
        useRecoilSnapshot: store_1.useRecoilSnapshot,
        useRecoilCallback: store_1.useRecoilCallback,
        atom: store_1.atom,
        atomFamily: store_1.atomFamily,
        selector: store_1.selector,
        selectorFamily: store_1.selectorFamily,
    },
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29196:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedOrderTotals = exports.useLocalizedOrderLine = exports.useLocalizedCartTotals = exports.useLocalizedCartLine = exports.useLocalizedVariant = exports.useLocalizedProduct = void 0;
var useLocalizedProduct_1 = __webpack_require__(77831);
Object.defineProperty(exports, "useLocalizedProduct", ({ enumerable: true, get: function () { return useLocalizedProduct_1.useLocalizedProduct; } }));
var useLocalizedVariant_1 = __webpack_require__(30865);
Object.defineProperty(exports, "useLocalizedVariant", ({ enumerable: true, get: function () { return useLocalizedVariant_1.useLocalizedVariant; } }));
var useLocalizedCartLine_1 = __webpack_require__(94642);
Object.defineProperty(exports, "useLocalizedCartLine", ({ enumerable: true, get: function () { return useLocalizedCartLine_1.useLocalizedCartLine; } }));
var useLocalizedCartTotals_1 = __webpack_require__(54260);
Object.defineProperty(exports, "useLocalizedCartTotals", ({ enumerable: true, get: function () { return useLocalizedCartTotals_1.useLocalizedCartTotals; } }));
var useLocalizedOrderLine_1 = __webpack_require__(88370);
Object.defineProperty(exports, "useLocalizedOrderLine", ({ enumerable: true, get: function () { return useLocalizedOrderLine_1.useLocalizedOrderLine; } }));
var useLocalizedOrderTotals_1 = __webpack_require__(34205);
Object.defineProperty(exports, "useLocalizedOrderTotals", ({ enumerable: true, get: function () { return useLocalizedOrderTotals_1.useLocalizedOrderTotals; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 35988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocaleStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const DEBUG = false;
const useLocaleStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.localeStatusStarted('locale/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.localeStatusFinished('locale/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.localeStatusSuccess('locale/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.localeStatusErrors('locale/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.localeStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.localeStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.localeStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.localeStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useLocaleStartFinishErrors = useLocaleStartFinishErrors;
//# sourceMappingURL=useLocaleStartFinishErrors.js.map

/***/ }),

/***/ 94642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedCartLine = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    line: null,
    options: {},
};
/**
 * Localized a cart line item
 * @param {*} passedProps
 * @returns
 */
const useLocalizedCartLine = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props.line) {
        console.warn('useLocalizedCartLine "line" prop no provided');
        return { localized: null };
    }
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedCartLine(props.line)),
    };
};
exports.useLocalizedCartLine = useLocalizedCartLine;
//# sourceMappingURL=useLocalizedCartLine.js.map

/***/ }),

/***/ 54260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedCartTotals = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
/**
 * Localized a cart line totals
 * @param {*} passedProps
 * @returns
 */
const useLocalizedCartTotals = () => {
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedCartTotals),
    };
};
exports.useLocalizedCartTotals = useLocalizedCartTotals;
//# sourceMappingURL=useLocalizedCartTotals.js.map

/***/ }),

/***/ 88370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedOrderLine = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    line: null,
    currencyCode: '',
    options: {},
};
/**
 * Localized a order line item
 * @param {*} passedProps
 * @returns
 */
const useLocalizedOrderLine = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props.line) {
        console.warn('useLocalizedOrderLine "line" prop no provided');
        return { localized: null };
    }
    if (!props.currencyCode) {
        console.warn('useLocalizedOrderLine "currencyCode" prop no provided');
        return { localized: null };
    }
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedOrderLine(props)),
    };
};
exports.useLocalizedOrderLine = useLocalizedOrderLine;
//# sourceMappingURL=useLocalizedOrderLine.js.map

/***/ }),

/***/ 34205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedOrderTotals = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    order: null,
    options: {},
};
/**
 * Localized a cart line totals
 * @param {*} passedProps
 * @returns
 */
const useLocalizedOrderTotals = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props.order) {
        console.warn('useLocalizedOrderTotals "order" prop no provided');
        return { localized: null };
    }
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedOrderTotals(props.order)),
    };
};
exports.useLocalizedOrderTotals = useLocalizedOrderTotals;
//# sourceMappingURL=useLocalizedOrderTotals.js.map

/***/ }),

/***/ 77831:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedProduct = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const deepmerge_1 = tslib_1.__importDefault(__webpack_require__(20406));
const react_1 = __webpack_require__(27378);
const useLocaleStartFinishErrors_1 = __webpack_require__(35988);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    handle: null,
    product: null,
    countryCode: null,
    currency: null,
    localizeVariants: false,
    fetchOnMount: true,
    options: {},
};
/**
 * Retrieve the localized prices for a product in a given country
 * @param {*} passedProps
 * @returns
 */
const useLocalizedProduct = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const isBusy = (0, react_1.useRef)(false);
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    const product = props.product?.handle ? props.product : recoilProduct;
    let handle = props.handle || product?.handle;
    const recoilCountry = (0, store_1.useRecoilValue)(store_1.default.country);
    let country = props.countryCode || recoilCountry?.isoCode;
    let currency = props.currency || recoilCountry?.currency?.isoCode;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useLocaleStartFinishErrors_1.useLocaleStartFinishErrors)({
        ...props.options,
        id: `locale/product/${handle}/${country?.isoCode || country}/${currency}`,
    });
    const [localized, setLocalized] = (0, store_1.useRecoilState)(store_1.default.localizedProduct({ handle, country, currency }));
    const localize = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.country) {
                country = data.country;
            }
            if (data?.currency) {
                currency = data.currency;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !country: {
                    validationErrors = ['country not provided'];
                    break;
                }
                case !currency: {
                    validationErrors = ['currency not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product: _product } = await snapshot.getPromise(store_1.default.fetchLocaleProduct({ handle, country, currency }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_product) {
                setErrors([`Invalid product price in response ${_product}`]);
                return null;
            }
            if (!product?.variants) {
                setErrors([`Invalid source product provided ${product}`]);
                return null;
            }
            setFinished(true);
            // console.log('original product', product);
            // console.log('localized product', _product);
            // merge the original product with the localized version
            const mergedProduct = {
                ...product,
                locale: _product.locale,
                priceRange: _product.priceRange,
                requiresSellingPlan: _product.requiresSellingPlan,
                sellingPlanGroups: _product.requiresSellingPlan,
            };
            // localize all product variants including fromGrouping (optional)
            if (props.localizeVariants) {
                // merge the original variants (that have no locale) with the localized versions
                const localizedProductVariants = product.variants
                    .filter((variant) => !variant.fromGrouping)
                    .map((variant) => {
                    const localizedVariant = _product.variants.find((_variant) => _variant.id === variant.id);
                    return (0, deepmerge_1.default)(variant, localizedVariant);
                });
                // fetch locale for grouping variants as shopify knows nothing about the grouping
                const groupingVariants = product.variants.filter((variant) => variant.fromGrouping);
                const groupingVariantInPromise = groupingVariants.map((_variant) => snapshot.getPromise(store_1.default.fetchProductVariantPriceIn({
                    handle: _variant.product.handle,
                    selectedOptions: _variant.selectedOptions,
                })));
                const groupingLocalizedVariantsResponse = await Promise.all(groupingVariantInPromise);
                const groupingLocalizedVariants = groupingLocalizedVariantsResponse.map((response) => {
                    if (response.error) {
                        return null;
                    }
                    return response.variant;
                });
                // apply merged variants
                mergedProduct.variants = [
                    ...localizedProductVariants,
                    ...groupingLocalizedVariants,
                ];
            }
            setLocalized(mergedProduct);
            if (callback)
                callback(mergedProduct);
            return mergedProduct;
        }
        catch (error) {
            console.error('localize:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // fetch on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !country,
            !currency,
            !props.fetchOnMount,
            isBusy.current,
            localized,
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        isBusy.current = true;
        localize({ handle, country, currency })
            .then((_product) => {
            if (unMounting)
                return null;
            setLocalized(_product);
            isBusy.current = false;
            return _product;
        })
            .catch((error) => {
            console.error('failed to localize due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, country, currency, localized, props.fetchOnMount]);
    return {
        localized: localized || null,
        localize,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useLocalizedProduct = useLocalizedProduct;
//# sourceMappingURL=useLocalizedProduct.js.map

/***/ }),

/***/ 30865:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedVariant = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useLocaleStartFinishErrors_1 = __webpack_require__(35988);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    variant: { product: { handle: null }, selectedOptions: null, id: '' },
    countryCode: null,
    currency: null,
    fetchOnMount: true,
    options: {},
};
/**
 * Retrieve the localized prices for a product in a given country
 * @param {*} passedProps
 * @returns
 */
const useLocalizedVariant = (passedProps) => {
    const fallbackCountry = (0, store_1.useRecoilValue)(store_1.default.country)?.isoCode;
    const fallbackCurrency = (0, store_1.useRecoilValue)(store_1.default.country)?.currency?.isoCode;
    const props = passedProps?.variant
        ? { ...defaultProps, ...passedProps }
        : defaultProps;
    let { handle } = props.variant.product;
    let { selectedOptions } = props.variant;
    let country = props.countryCode || fallbackCountry;
    let currency = props.currency || fallbackCurrency;
    const statusId = `locale/product/${handle}/variant/${props.variant.id
        .split('/')
        .pop()}/${country}/${currency}`;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useLocaleStartFinishErrors_1.useLocaleStartFinishErrors)({ ...props.options, id: statusId });
    const [localized, setLocalized] = (0, store_1.useRecoilState)(store_1.default.localizedVariant({ handle, selectedOptions, country, currency }));
    const localize = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.selectedOptions) {
                selectedOptions = data.selectedOptions;
            }
            if (data?.country) {
                country = data.country;
            }
            if (data?.currency) {
                currency = data.currency;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !selectedOptions: {
                    validationErrors = ['selectedOptions not provided'];
                    break;
                }
                case !country: {
                    validationErrors = ['country not provided'];
                    break;
                }
                case !currency: {
                    validationErrors = ['currency not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, variant: _variant } = await snapshot.getPromise(store_1.default.fetchLocalizedVariant({
                handle,
                selectedOptions,
                country,
                currency,
            }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_variant) {
                setErrors([
                    `Invalid product variant price in response: ${_variant}`,
                ]);
                return null;
            }
            setFinished(true);
            setLocalized(_variant);
            if (callback)
                callback(_variant);
            return _variant;
        }
        catch (error) {
            console.error('localize:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !selectedOptions?.length,
            !country,
            !currency,
            !props.fetchOnMount,
            finished,
        ];
        if (earlyExitIf.some(Boolean)) {
            return;
        }
        localize({ handle, country, currency })
            .then((variant) => {
            if (unMounting)
                return;
            setLocalized(variant);
        })
            .catch((error) => {
            console.error('failed to localize due to', error.message);
        });
        // eslint-disable-next-line
        return () => {
            unMounting = true;
        };
    }, [
        country,
        currency,
        finished,
        handle,
        props.fetchOnMount,
        props.variant.id,
        selectedOptions,
    ]);
    return {
        localized: localized || null,
        localize,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useLocalizedVariant = useLocalizedVariant;
//# sourceMappingURL=useLocalizedVariant.js.map

/***/ }),

/***/ 29970:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.localeStore = void 0;
var locale_1 = __webpack_require__(24415);
Object.defineProperty(exports, "localeStore", ({ enumerable: true, get: function () { return locale_1.localeStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 24415:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.localeStore = void 0;
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const client_1 = __webpack_require__(25431);
const store_1 = __webpack_require__(20437);
const store_2 = __webpack_require__(29005);
const Localize_1 = __webpack_require__(42667);
const localize = new Localize_1.Localize();
const productClient = new client_1.ProductClient({
    apiToken: "60385688208d54f843f3c3cb36d767b2",
    apiVersion: '2025-04',
    domain: "briogeo-hair-care.myshopify.com",
});
/**
  Locale State
*/
const localizedProduct = (0, recoil_1.atomFamily)({
    key: 'locale/product',
    default: null,
});
const localizedVariant = (0, recoil_1.atomFamily)({
    key: 'locale/variant',
    default: null,
});
const localizedCartLine = (0, recoil_1.selectorFamily)({
    key: 'locale/cartLine',
    get: (line) => ({ get }) => {
        const { locale } = get(store_1.shopStore.country);
        return localize.cartLine({ line, locale });
    },
});
const localizedCartTotals = (0, recoil_1.selector)({
    key: 'locale/cartTotals',
    get: ({ get }) => {
        const cart = get(store_2.cartStore.cart);
        const { locale } = get(store_1.shopStore.country);
        return localize.cartTotals({ cart, locale });
    },
});
const localizedOrderLine = (0, recoil_1.selectorFamily)({
    key: 'locale/orderLine',
    get: ({ line, currencyCode }) => ({ get }) => {
        const { locale: currentLocale } = get(store_1.shopStore.country);
        const countries = get(store_1.shopStore.countries);
        const orderCounty = countries.find((country) => {
            return country.currency?.isoCode === currencyCode;
        });
        const orderLocale = orderCounty?.locale || currentLocale;
        return localize.orderLine({
            line,
            currentLocale,
            locale: orderLocale,
        });
    },
});
const localizedOrderTotals = (0, recoil_1.selectorFamily)({
    key: 'locale/orderTotals',
    get: (order) => ({ get }) => {
        const countries = get(store_1.shopStore.countries);
        const orderCounty = countries.find((country) => {
            return country.currency?.isoCode === order.currencyCode;
        });
        const orderLocale = orderCounty?.locale;
        return localize.orderTotals({
            order,
            locale: orderLocale,
        });
    },
});
/* Status */
const localeStatusStarted = (0, recoil_1.atomFamily)({
    key: 'locale/statusStarted',
    default: false,
});
const localeStatusFinished = (0, recoil_1.atomFamily)({
    key: 'locale/statusFinished',
    default: false,
});
const localeStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'locale/statusSuccess',
    default: false,
});
const localeStatusErrors = (0, recoil_1.atomFamily)({
    key: 'locale/statusErrors',
    default: [],
});
/* Async */
const fetchLocaleProduct = (0, recoil_1.selectorFamily)({
    key: 'locale/fetchProduct',
    get: (data) => async ({ get }) => {
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const country = get(store_1.shopStore.country);
        const _country = passedCountryCode || country?.isoCode || 'US';
        try {
            // get product in country's currency
            const { error, product: _product } = await productClient.getLocalizedProduct({
                ...data,
                country: _country,
            });
            if (error) {
                throw new Error(error);
            }
            if (!_product || !_product?.id) {
                throw new Error('Invalid locale product response');
            }
            // add locale to localized product
            const _localizedProduct = localize.product({
                product: _product,
                locale: country.locale,
            });
            return { error: null, product: _localizedProduct };
        }
        catch (error) {
            return { error: error.message, product: null };
        }
    },
});
const fetchLocalizedVariant = (0, recoil_1.selectorFamily)({
    key: 'locale/fetchVariant',
    get: (data) => async ({ get }) => {
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const country = get(store_1.shopStore.country);
        const _country = passedCountryCode || country?.isoCode || 'US';
        try {
            // get variant localized in the current country
            const { error, variant: rawVariant } = await productClient.getLocalizedVariant({
                ...data,
                country: _country,
                locale: country.locale,
            });
            if (error) {
                throw new Error(error);
            }
            if (!rawVariant || !rawVariant?.id) {
                throw new Error('Invalid locale variant response');
            }
            // add locale to localized variant
            const _localizedVariant = localize.variant({
                variant: rawVariant,
                locale: country.locale,
            });
            // convert sellingPlanAllocations to a map
            const spsByKey = (_sps, sp) => {
                return {
                    ..._sps,
                    [sp.sellingPlan.id]: sp,
                };
            };
            // added to make it easier to find the active selling plan
            const sellingPlans = _localizedVariant.sellingPlanAllocations.reduce(spsByKey, {});
            const variant = { ..._localizedVariant, sellingPlans };
            return { error: null, variant };
        }
        catch (error) {
            return { error: error.message, variant: null };
        }
    },
});
// Localized stored
exports.localeStore = {
    localizedProduct,
    localizedVariant,
    localizedCartLine,
    localizedCartTotals,
    localizedOrderLine,
    localizedOrderTotals,
    // status
    localeStatusStarted,
    localeStatusFinished,
    localeStatusSuccess,
    localeStatusErrors,
    // async
    fetchLocaleProduct,
    fetchLocalizedVariant,
};
//# sourceMappingURL=locale.js.map

/***/ }),

/***/ 95314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(43031), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 43031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePage = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const usePage = () => (0, store_1.useRecoilValue)(store_1.default.page);
exports.usePage = usePage;
//# sourceMappingURL=usePage.js.map

/***/ }),

/***/ 98886:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pageStore = void 0;
var page_1 = __webpack_require__(80523);
Object.defineProperty(exports, "pageStore", ({ enumerable: true, get: function () { return page_1.pageStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 80523:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pageStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  Page State
*/
const page = (0, recoil_1.atom)({
    key: 'page/page',
    default: null,
    effects: [
        // effects.logStateChange('page'),
        effects_1.default.onChange({
            key: 'page',
            topic: 'PAGE_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const pagesList = (0, recoil_1.atom)({
    key: 'page/pagesList',
    default: [],
});
// pages json fuse index
const pagesIndex = (0, recoil_1.atom)({
    key: 'page/pagesIndex',
    default: null,
});
exports.pageStore = {
    // actual state - atoms
    page,
    pagesIndex,
    pagesList,
};
//# sourceMappingURL=page.js.map

/***/ }),

/***/ 466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProductClient = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
const graphql_request_1 = __webpack_require__(63671);
const humanize_graphql_response_1 = tslib_1.__importDefault(__webpack_require__(27207));
const queries_1 = __webpack_require__(68318);
/**
 * @see: https://shopify.dev/custom-storefronts/cart
 */
class ProductClient {
    constructor({ apiToken, apiVersion, domain }) {
        this.apiToken = apiToken;
        this.apiVersion = apiVersion;
        this.domain = domain;
        this.endpoint = `https://${this.domain}/api/${apiVersion}/graphql.json`;
        this.options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'X-Shopify-Storefront-Access-Token': this.apiToken,
                'Content-Type': 'application/json; charset=utf-8',
            },
        };
        this.client = new graphql_request_1.GraphQLClient(this.endpoint, this.options);
    }
    /**
     *
     * @param
     * @returns
     */
    async storefront({ query, variables }) {
        return this.client.rawRequest(query, variables);
    }
    /**
     * Fetch a /json/ hosted file
     * @param {jsonPath} path a valid /json/**.* path
     * @returns a json object
     */
    async json({ path }) {
        try {
            if (!path)
                throw new TypeError('Missing required json "path"');
            const jsonUrl = `/json/${path}`;
            // eslint-disable-next-line no-undef
            const response = await fetch(jsonUrl);
            if (!response?.ok) {
                return { error: 'json response not ok', data: null };
            }
            const data = await response.json();
            return { error: null, data };
        }
        catch (error) {
            const errorMsg = `requestJson: failed to fetch json ${path} due to ${error.message}`;
            console.error(errorMsg);
            return { error, data: null };
        }
    }
    /**
     * Get a product's live sellingPlans by handle
     * @param {string} handle - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @returns a new full cart instance
     */
    async getByHandle({ handle } = { handle: null }) {
        try {
            if (!handle) {
                throw new Error('get product failed "handle" not provided');
            }
            const productPath = `products/${handle}.json`;
            const { error, data } = await this.json({
                path: productPath,
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, product: data };
        }
        catch (error) {
            console.error('getByHandle:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Fetch a list of all products with some basic meta (great for building collection filters)
     * @returns products-list.json
     */
    async getList() {
        try {
            const { error, data } = await this.json({
                path: 'products-list.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productsList: data };
        }
        catch (error) {
            console.error('getList:error', error.message);
            return { error: error.message, productsList: null };
        }
    }
    /**
     * Fetch a index of all products (used by fuse search index)
     * @returns products-index.json
     */
    async getIndex() {
        try {
            const { error, data } = await this.json({
                path: 'products-index.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productsIndex: data };
        }
        catch (error) {
            console.error('getIndex:error', error.message);
            return { error: error.message, productsIndex: null };
        }
    }
    /**
     * Fetch a set of uniq product properties
     * @returns products-uniq.json
     */
    async getUniq() {
        try {
            const { error, data } = await this.json({
                path: 'products-uniq.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productsUniq: data };
        }
        catch (error) {
            return { error: error.message, productsUniq: null };
        }
    }
    /**
     * Fetch a list of all product handles
     * @returns products.json
     */
    async getHandles() {
        try {
            const { error, data } = await this.json({
                path: 'products.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productHandles: data };
        }
        catch (error) {
            console.error('getHandles:error', error.message);
            return { error: error.message, productHandles: null };
        }
    }
    /**
     * Get a product's live sellingPlans by handle
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {string} handle - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @returns a new full cart instance
     */
    async getSellingPlans({ country, handle } = { country: 'US', handle: null }) {
        try {
            if (!handle) {
                throw new Error('get selling plans failed "handle" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getProductSellingPlans,
                variables: { country, handle },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            return { error: null, product: (0, humanize_graphql_response_1.default)(product) };
        }
        catch (error) {
            console.error('getProductSellingPlans:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Get a variant selling plans in a given countries context
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the target product's handle
     * @param {String} selectedOptions - the target variant's selectedOptions
     * @returns a full variant with prices in a target country
     */
    async getVariantSellingPlans({ country, currency, handle, selectedOptions } = {
        country: 'US',
        currency: 'USD',
        handle: null,
        selectedOptions: [],
        locale,
    }) {
        try {
            if (!handle) {
                throw new Error('get variant selling plan failed "handle" not provided');
            }
            if (!selectedOptions) {
                throw new Error('get variant selling plan failed "selectedOptions" not provided');
            }
            // get variant price in country
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getProductVariantSellingPlans,
                variables: { country, handle, selectedOptions },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = (0, humanize_graphql_response_1.default)(data);
            let { variant } = product;
            // add locale pricing and info to the variant
            variant = this._localizeVariant({ variant, locale, currency });
            return { error: null, variant };
        }
        catch (error) {
            console.error('getVariantSellingPlans:error', error.message);
            return { error: error.message, variant: null };
        }
    }
    /**
     * Get a product's live inventory by handle
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @param {Boolean} withQuantity - if true we return the quantities available too
     * @returns live inventory for a product
     */
    async getInventory({ country, handle, withQuantity } = {
        country: 'US',
        handle: null,
        withQuantity: true,
    }) {
        try {
            if (!handle) {
                throw new Error('get inventory failed "handle" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: withQuantity
                    ? queries_1.queries.getInventoryWithQuantity
                    : queries_1.queries.getInventory,
                variables: { country, handle },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            return { error: null, product: (0, humanize_graphql_response_1.default)(product) };
        }
        catch (error) {
            console.error('getInventory:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Get a product and variants price in a given countries context
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the target product's handle
     * @returns product and variants prices in that country
     */
    async getLocalizedProduct({ country, handle } = {
        country: 'US',
        handle: null,
    }) {
        try {
            if (!handle) {
                throw new Error('get localized product failed "handle" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getLocalizedProduct,
                variables: { country, handle },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = (0, humanize_graphql_response_1.default)(data);
            return { error: null, product };
        }
        catch (error) {
            console.error('getLocalizedProduct:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Get a variant price in a given countries context
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} locale - country locale
     * @param {String} handle - the target product's handle
     * @param {String} selectedOptions - the target variant's selectedOptions
     * @returns a full variant with prices in a target country
     */
    async getLocalizedVariant({ country, handle, selectedOptions } = {
        country: 'US',
        locale: null,
        handle: null,
        selectedOptions: [],
    }) {
        try {
            if (!country) {
                throw new Error('get localized variant "country" not provided');
            }
            if (!handle) {
                throw new Error('get localized variant "handle" not provided');
            }
            if (!selectedOptions) {
                throw new Error('get localized variant "selectedOptions" not provided');
            }
            // get variant price in country
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getLocalizedVariant,
                variables: { country, handle, selectedOptions },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (!data.product) {
                throw new Error(`No localized variant found for product with handle \`${handle}\``);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = (0, humanize_graphql_response_1.default)(data);
            const { variant } = product;
            return { error: null, variant };
        }
        catch (error) {
            console.error('getLocalizedVariant:error', error.message);
            return { error: error.message, variant: null };
        }
    }
    /**
     * Get a product's recommendations via shopify
     * @param {String} productId - product legacyResourceId
     * @param {Integer|String} limit - how many recommendations to get
     * @returns a new full cart instance
     */
    async getRecommendations({ productId, limit } = {
        productId: null,
        limit: 6,
    }) {
        try {
            if (!productId) {
                throw new Error('get recommendations failed "productId" not provided');
            }
            // eslint-disable-next-line no-undef
            const url = window.location.origin;
            const endpoint = `${url}/api/shopify/recommendations`;
            // eslint-disable-next-line no-undef
            const request = await fetch(endpoint, {
                method: 'POSt',
                body: JSON.stringify({ productId, limit }),
            });
            if (!request?.ok) {
                throw new Error('Recommendations request not ok');
            }
            const { errors, response } = await request.json();
            if (errors?.length) {
                throw new Error(errors[0]);
            }
            if (!response?.products) {
                throw new Error('Invalid recommendations response');
            }
            const { products } = response;
            const recommendations = products.map((product) => {
                return {
                    handle: product.handle,
                    legacyResourceId: productId,
                };
            });
            return { error: null, recommendations };
        }
        catch (error) {
            console.error('getRecommendations:error', error.message);
            return { error: error.message, recommendations: [] };
        }
    }
    /**
     * Get a product's metafield by handle
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the product handle
     * @param {String} key - the metafield key
     * @param {String} namespace - the metafield namespace
     * @returns a metafield key and value
     */
    async getMetafield({ country, handle, key, namespace } = {
        country: 'US',
        handle: null,
        key: '',
        namespace: '',
    }) {
        try {
            if (!handle) {
                throw new Error('get metafield failed "handle" not provided');
            }
            if (!key) {
                throw new Error('get metafield failed "key" not provided');
            }
            if (!namespace) {
                throw new Error('get metafield failed "namespace" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getMetafield,
                variables: { country, handle, key, namespace },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            return { error: null, metafield: product?.metafield };
        }
        catch (error) {
            console.error('getMetafield:error', error.message);
            return { error: error.message, metafield: null };
        }
    }
    /**
     * Get a product variant metafield
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the product handle
     * @param {[Object]} selectedOptions - the selectedOptions of the target variant
     * @param {String} key - the metafield key
     * @param {String} namespace - the metafield namespace
     * @returns a metafield key and value
     */
    async getVariantMetafield({ country, handle, key, namespace, selectedOptions } = {
        country: 'US',
        handle: null,
        key: '',
        namespace: '',
        selectedOptions: [], // eg.. [{ Size: '50 cm', ...}]
    }) {
        try {
            if (!handle) {
                throw new Error('get metafield failed "handle" not provided');
            }
            if (!key) {
                throw new Error('get metafield failed "key" not provided');
            }
            if (!namespace) {
                throw new Error('get metafield failed "namespace" not provided');
            }
            if (!selectedOptions) {
                throw new Error('get metafield failed "selectedOptions" not provided');
            }
            if (!Array.isArray(selectedOptions)) {
                throw new Error('get metafield failed "selectedOptions" must be an array');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getVariantMetafield,
                variables: { country, handle, key, namespace, selectedOptions },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            const { selectedVariant } = product;
            return { error: null, metafield: selectedVariant.metafield };
        }
        catch (error) {
            console.error('getVariantMetafield:error', error.message);
            return { error: error.message, metafield: null };
        }
    }
    /**
     * Search shopify admin api for products
     * @param {String} term - product term to search
     * @param {number} limit - optional limit 10 max
     * @returns a list of products
     */
    async searchProducts({ term, limit }) {
        try {
            // eslint-disable-next-line no-undef
            const request = await fetch('/api/shopify/search', {
                method: 'POST',
                body: JSON.stringify({
                    term,
                    limit: limit || 10,
                    types: ['product'],
                }),
            });
            if (!request?.ok) {
                throw new Error('Products search response not ok');
            }
            const { errors, response } = await request.json();
            if (errors?.length) {
                throw new Error(errors[0]);
            }
            return { error: null, results: response.results.products };
        }
        catch (error) {
            console.error('searchProducts:error', error.message);
            return { error: error.message, results: null };
        }
    }
}
exports.ProductClient = ProductClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 69195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const graphql_request_1 = __webpack_require__(63671);
const Price = (0, graphql_request_1.gql) `
  fragment Price on MoneyV2 {
    amount
    currencyCode
  }
`;
const SellingPlan = (0, graphql_request_1.gql) `
  fragment SellingPlan on SellingPlan {
    id
    name
    description
    priceAdjustments {
      adjustmentValue {
        ... on SellingPlanFixedAmountPriceAdjustment {
          adjustmentAmount {
            amount
            currencyCode
          }
        }
        ... on SellingPlanFixedPriceAdjustment {
          price {
            amount
            currencyCode
          }
        }
        ... on SellingPlanPercentagePriceAdjustment {
          adjustmentPercentage
        }
      }
      orderCount
    }
    recurringDeliveries
    options {
      name
      value
    }
  }
`;
const SellingPlanAllocation = (0, graphql_request_1.gql) `
  fragment SellingPlanAllocation on SellingPlanAllocation {
    priceAdjustments {
      compareAtPrice {
        ...Price
      }
      price {
        ...Price
      }
      perDeliveryPrice {
        ...Price
      }
      unitPrice {
        ...Price
      }
    }
    sellingPlan {
      ...SellingPlan
    }
  }
`;
const SellingPlanGroup = (0, graphql_request_1.gql) `
  fragment SellingPlanGroup on SellingPlanGroup {
    appName
    name
    options {
      name
      values
    }
    sellingPlans(first: 10) {
      edges {
        node {
          ...SellingPlan
        }
      }
    }
  }
`;
const LiveInventoryVariant = (0, graphql_request_1.gql) `
  fragment LiveInventoryVariant on ProductVariant {
    id
    availableForSale
    currentlyNotInStock
    product {
      handle
    }
  }
`;
const LiveInventoryVariantWithQuantity = (0, graphql_request_1.gql) `
  fragment LiveInventoryVariantWithQuantity on ProductVariant {
    id
    quantityAvailable
    currentlyNotInStock
    availableForSale
    product {
      handle
    }
  }
`;
const CountryPriceVariant = (0, graphql_request_1.gql) `
  fragment CountryPriceVariant on ProductVariant {
    id
    product {
      handle
    }
    compareAtPriceV2 {
      ...Price
    }
    priceV2 {
      ...Price
    }
    sellingPlanAllocations(first: 10) {
      edges {
        node {
          ...SellingPlanAllocation
        }
      }
    }
  }
`;
const CountryPriceSelectedVariant = (0, graphql_request_1.gql) `
  fragment CountryPriceSelectedVariant on ProductVariant {
    compareAtPriceV2 {
      ...Price
    }
    id
    priceV2 {
      ...Price
    }
    product {
      handle
      id
    }
    selectedOptions {
      name
      value
    }
    sellingPlanAllocations(first: 10) {
      edges {
        node {
          ...SellingPlanAllocation
        }
      }
    }
    unitPrice {
      ...Price
    }
    unitPriceMeasurement {
      measuredType
      quantityUnit
      quantityValue
    }
  }
`;
const FullVariant = (0, graphql_request_1.gql) `
  fragment FullVariant on ProductVariant {
    availableForSale
    barcode
    id
    compareAtPriceV2 {
      ...Price
    }
    product {
      handle
      id
    }
    sku
    image {
      originalSrc
      altText
      width
      height
    }
    quantityAvailable
    requiresShipping
    weight
    weightUnit
    availableForSale
    sellingPlanAllocations(first: 10) {
      edges {
        node {
          ...SellingPlanAllocation
        }
      }
    }
    selectedOptions {
      name
      value
    }
    unitPrice {
      ...Price
    }
    unitPriceMeasurement {
      measuredType
      quantityUnit
      quantityValue
    }
    priceV2 {
      ...Price
    }
  }
`;
const MinMaxVariantPrice = (0, graphql_request_1.gql) `
  fragment MinMaxVariantPrice on ProductPriceRange {
    maxVariantPrice {
      ...Price
    }
    minVariantPrice {
      ...Price
    }
  }
`;
const Metafield = (0, graphql_request_1.gql) `
  fragment Metafield on Metafield {
    key
    id
    value
    namespace
  }
`;
exports["default"] = {
    LiveInventoryVariant,
    LiveInventoryVariantWithQuantity,
    CountryPriceVariant,
    CountryPriceSelectedVariant,
    Metafield,
    MinMaxVariantPrice,
    Price,
    SellingPlan,
    SellingPlanAllocation,
    SellingPlanGroup,
};
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 25431:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProductClient = void 0;
var client_1 = __webpack_require__(466);
Object.defineProperty(exports, "ProductClient", ({ enumerable: true, get: function () { return client_1.ProductClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 68318:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queries = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(63671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(69195));
/*
  Queries
*/
const getProductSellingPlans = (0, graphql_request_1.gql) `
  query getProductSellingPlans($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      requiresSellingPlan
      sellingPlanGroups(first: 1) {
        edges {
          node {
            ...SellingPlanGroup
          }
        }
      }
    }
  }
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanGroup}
`;
const getProductVariantSellingPlans = (0, graphql_request_1.gql) `
  query getProductVariantSellingPlans($country: CountryCode, $handle: String!, $selectedOptions: [SelectedOptionInput!]!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      requiresSellingPlan
      sellingPlanGroups(first: 1) {
        edges {
          node {
            ...SellingPlanGroup
          }
        }
      }
      variant: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        ...CountryPriceSelectedVariant
      }
    }
  }
  ${fragments_1.default.Price}
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanGroup}
  ${fragments_1.default.SellingPlanAllocation}
  ${fragments_1.default.CountryPriceSelectedVariant}
`;
// withQuantity === false
const getInventory = (0, graphql_request_1.gql) `
  query getInventory($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      availableForSale
      variants(first: 250) {
        edges {
          node {
            ...LiveInventoryVariant
          }
        }
      }
    }
  }
  ${fragments_1.default.LiveInventoryVariant}
`;
// withQuantity === true (default)
const getInventoryWithQuantity = (0, graphql_request_1.gql) `
  query getInventoryWithQuantity($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      availableForSale
      totalInventory
      variants(first: 250) {
        edges {
          node {
            ...LiveInventoryVariantWithQuantity
          }
        }
      }
    }
  }
  ${fragments_1.default.LiveInventoryVariantWithQuantity}
`;
/*
  Temp querying for sellingPlanAllocations as we don't sync them atm
  Shorthand for now as this will be merged with the SSG product
  at productIn hooh
*/
const getLocalizedProduct = (0, graphql_request_1.gql) `
  query getLocalizedProduct($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      priceRange {
        ...MinMaxVariantPrice
      }
      compareAtPriceRange {
        ...MinMaxVariantPrice
      }
      requiresSellingPlan
      sellingPlanGroups(first: 1) {
        edges {
          node {
            ...SellingPlanGroup
          }
        }
      }
      variants(first: 250) {
        edges {
          node {
            ...CountryPriceVariant
          }
        }
      }
    }
  }
  ${fragments_1.default.Price}
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanGroup}
  ${fragments_1.default.MinMaxVariantPrice}
  ${fragments_1.default.SellingPlanAllocation}
  ${fragments_1.default.CountryPriceVariant}
`;
const getLocalizedVariant = (0, graphql_request_1.gql) `
  query getLocalizedVariant($country: CountryCode, $handle: String!, $selectedOptions: [SelectedOptionInput!]!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      priceRange {
        ...MinMaxVariantPrice
      }
      compareAtPriceRange {
        ...MinMaxVariantPrice
      }
      variant: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        ...CountryPriceSelectedVariant
      }
    }
  }
  ${fragments_1.default.Price}
  ${fragments_1.default.MinMaxVariantPrice}
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanAllocation}
  ${fragments_1.default.CountryPriceSelectedVariant}
`;
const getMetafield = (0, graphql_request_1.gql) `
  query getMetafield($country: CountryCode, $handle: String!, $key: String!, $namespace: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      handle
      id
      metafield(key: $key, namespace: $namespace) {
        ...Metafield
      }
    }
  }
  ${fragments_1.default.Metafield}
`;
const getVariantMetafield = (0, graphql_request_1.gql) `
  query getVariantMetafield($country: CountryCode, $handle: String!, $key: String!, $namespace: String!, $selectedOptions: [SelectedOptionInput!]!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      handle
      id
      selectedVariant: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        id
        metafield(key: $key, namespace: $namespace) {
          ...Metafield
        }
      }
    }
  }
  ${fragments_1.default.Metafield}
`;
exports.queries = {
    getProductSellingPlans,
    getProductVariantSellingPlans,
    getInventory,
    getInventoryWithQuantity,
    getLocalizedProduct,
    getLocalizedVariant,
    getMetafield,
    getVariantMetafield,
};
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 68335:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
// new in V2
tslib_1.__exportStar(__webpack_require__(89901), exports);
tslib_1.__exportStar(__webpack_require__(30476), exports);
tslib_1.__exportStar(__webpack_require__(75343), exports);
tslib_1.__exportStar(__webpack_require__(76722), exports);
tslib_1.__exportStar(__webpack_require__(99122), exports);
tslib_1.__exportStar(__webpack_require__(27080), exports);
tslib_1.__exportStar(__webpack_require__(89045), exports);
// Modified in v2
tslib_1.__exportStar(__webpack_require__(53269), exports); // renamed from useProductLiveInventory
// single products
tslib_1.__exportStar(__webpack_require__(79918), exports);
tslib_1.__exportStar(__webpack_require__(12631), exports);
tslib_1.__exportStar(__webpack_require__(42186), exports);
tslib_1.__exportStar(__webpack_require__(2237), exports);
tslib_1.__exportStar(__webpack_require__(56701), exports);
// listings and indexes
tslib_1.__exportStar(__webpack_require__(60869), exports);
tslib_1.__exportStar(__webpack_require__(64433), exports);
tslib_1.__exportStar(__webpack_require__(27220), exports);
tslib_1.__exportStar(__webpack_require__(62701), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 79918:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProduct = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProduct = (initial) => (0, store_1.useRecoilValue)(store_1.default.product) || initial;
exports.useProduct = useProduct;
//# sourceMappingURL=useProduct.js.map

/***/ }),

/***/ 42186:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductByHandle = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    handle: null,
    version: 'full',
    fetchOnMount: true,
    options: {},
};
const useProductByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props?.handle}/getProductByHandle`,
    });
    let { handle, version } = props;
    const [product, setProduct] = (0, store_1.useRecoilState)(store_1.default.productByHandle({ handle, version }));
    const fetchProductByHandle = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            if (product) {
                setFinished(true);
                if (callback)
                    callback(product);
                return product;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.version) {
                version = data.version;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product: _product } = await snapshot.getPromise(store_1.default.fetchProductByHandle({ handle, version }));
            if (error) {
                setErrors([error]);
            }
            if (!_product || !_product?.id) {
                setErrors([`invalid product response: ${_product}`]);
                return null;
            }
            setFinished(true);
            setProduct(_product);
            if (callback)
                callback(_product);
            return _product;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, [handle, product, version]);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            !handle,
            finished && product, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting) {
            setStarted(true);
        }
        fetchProductByHandle({ handle, version })
            .then((_product) => {
            if (!_product || unMounting)
                return;
            setProduct(_product);
        })
            .catch((error) => {
            console.error('failed to getProductByHandle due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, props.fetchOnMount]);
    return {
        product,
        fetchProductByHandle,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductByHandle = useProductByHandle;
//# sourceMappingURL=useProductByHandle.js.map

/***/ }),

/***/ 62701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductHandles = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = { fetchOnMount: true, options: {} };
const useProductHandles = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/getProductHandles',
    });
    const [productHandles, setProductHandles] = (0, store_1.useRecoilState)(store_1.default.productHandles);
    const fetchProductHandles = (0, store_1.useRecoilCallback)(({ snapshot }) => async (_, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productHandles) {
                setFinished(true);
                if (callback)
                    callback(productHandles);
                return productHandles;
            }
            const { error, productHandles: _productHandles } = await snapshot.getPromise(store_1.default.fetchProductHandles());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!Array.isArray(_productHandles)) {
                setErrors([`invalid product response: ${_productHandles}`]);
                return null;
            }
            setFinished(true);
            setProductHandles(_productHandles);
            if (callback)
                callback(_productHandles);
            return _productHandles;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productHandles?.length, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        fetchProductHandles()
            .then((jsonProductHandles) => {
            if (unMounting)
                return;
            // bad response
            if (!Array.isArray(jsonProductHandles)) {
                setErrors(['Invalid product handles response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductHandles(jsonProductHandles);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productHandles]);
    return {
        productHandles,
        fetchProductHandles,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductHandles = useProductHandles;
//# sourceMappingURL=useProductHandles.js.map

/***/ }),

/***/ 53269:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductInventory = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    withQuantity: true,
    options: {},
};
const useProductInventory = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props.handle}/getInventory`,
    });
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    let { withQuantity } = props;
    const [inventory, setInventory] = (0, store_1.useRecoilState)(store_1.default.productInventory({ handle, withQuantity }));
    const getInventory = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            if (inventory) {
                setFinished(true);
                if (callback)
                    callback(inventory);
                return inventory;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.withQuantity) {
                withQuantity = data.withQuantity;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product } = await snapshot.getPromise(store_1.default.fetchProductInventoryByHandle({ handle, withQuantity }));
            if (error) {
                setErrors([error]);
            }
            if (!product || !product?.id) {
                setErrors([`Invalid product live inventory response: ${product}`]);
                return null;
            }
            // convert variants array to keyed-object
            const _productInventory = {
                ...product,
                variants: product.variants.reduce((_variants, variant) => {
                    return { ..._variants, [(0, helpers_1.decodedId)(variant.id)]: variant };
                }, {}),
            };
            setFinished(true);
            setInventory(_productInventory);
            if (callback)
                callback(_productInventory);
            return _productInventory;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, [handle, inventory, withQuantity]);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, !handle, finished && inventory];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getInventory({ handle, withQuantity })
            .then((liveInventory) => {
            if (!liveInventory || unMounting)
                return;
            setInventory(liveInventory);
        })
            .catch((error) => {
            console.error('failed to fetchInventoryOnMount due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, props.fetchOnMount, inventory, withQuantity]);
    return {
        inventory,
        getInventory,
        finished,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useProductInventory = useProductInventory;
//# sourceMappingURL=useProductInventory.js.map

/***/ }),

/***/ 12631:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductInventoryByHandle = void 0;
const useProductInventory_1 = __webpack_require__(53269);
const defaultProps = {
    handle: null,
    withQuantity: true,
    fetchOnMount: true,
    options: {},
};
const useProductInventoryByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    return (0, useProductInventory_1.useProductInventory)({
        handle: props.handle,
        withQuantity: typeof props.withQuantity === 'undefined' ? true : props.withQuantity,
        fetchOnMount: typeof props.fetchOnMount === 'undefined' ? true : props.fetchOnMount,
    });
};
exports.useProductInventoryByHandle = useProductInventoryByHandle;
//# sourceMappingURL=useProductInventoryByHandle.js.map

/***/ }),

/***/ 2237:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductItemByHandle = void 0;
const react_1 = __webpack_require__(27378);
const useProductByHandle_1 = __webpack_require__(42186);
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    options: {},
};
// DEPRECATED - use useProductByHandle instead
const useProductItemByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { product: productItem, fetchProductByHandle, ...productByHandleStatus } = (0, useProductByHandle_1.useProductByHandle)(props);
    (0, react_1.useEffect)(() => {
        if (false) {}
    }, []);
    return {
        productItem,
        fetchProductItemByHandle: fetchProductByHandle,
        ...productByHandleStatus,
    };
};
exports.useProductItemByHandle = useProductItemByHandle;
//# sourceMappingURL=useProductItemByHandle.js.map

/***/ }),

/***/ 75343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductMetafield = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    handle: null,
    key: '',
    namespace: '',
    fetchOnMount: true,
    options: {},
};
const useProductMetafield = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props?.handle}/getProductMetafield`,
    });
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    let { key, namespace } = props;
    const [metafield, setMetafield] = (0, store_1.useRecoilState)(store_1.default.productMetafield({ handle, key, namespace }));
    const getMetafield = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (metafield) {
                setFinished(true);
                if (callback)
                    callback(metafield);
                return metafield;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.key) {
                key = data.key;
            }
            if (data?.namespace) {
                namespace = data.namespace;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !key: {
                    validationErrors = ['key not provided'];
                    break;
                }
                case !namespace: {
                    validationErrors = ['namespace not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // get the metafield via the product client
            const { error, metafield: _metafield } = await snapshot.getPromise(store_1.default.fetchMetafield({ handle, key, namespace }));
            if (error) {
                setErrors([error]);
            }
            if (!_metafield) {
                setErrors([`Invalid product metafield response: ${_metafield}`]);
                return [];
            }
            setFinished(true);
            setMetafield(_metafield);
            if (callback)
                callback(_metafield);
            return _metafield;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    }, [key, handle, namespace]);
    // fetch on change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !key,
            !namespace,
            !props.fetchOnMount,
            finished && metafield, // already have metafield
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getMetafield({ handle, key, namespace })
            .then((_metafield) => {
            if (unMounting || !_metafield)
                return;
            setMetafield(_metafield);
        })
            .catch((error) => {
            console.error('failed to getMetafield due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, key, namespace, props.fetchOnMount]);
    return {
        metafield,
        getMetafield,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductMetafield = useProductMetafield;
//# sourceMappingURL=useProductMetafield.js.map

/***/ }),

/***/ 56701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductRecommendations = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    legacyResourceId: null,
    fetchOnMount: true,
    limit: 6,
    options: {},
};
const useProductRecommendations = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    const product = props.product || recoilProduct;
    let { limit } = props;
    let legacyResourceId = props?.legacyResourceId || product?.legacyResourceId || null;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${legacyResourceId}/getRecommendations`,
    });
    const [recommendations, setRecommendations] = (0, store_1.useRecoilState)(store_1.default.productRecommendations({
        productId: legacyResourceId,
        limit,
    }));
    const getRecommendations = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.legacyResourceId) {
                legacyResourceId = data.legacyResourceId;
            }
            if (data?.limit) {
                limit = data.limit;
            }
            let validationErrors = null;
            switch (true) {
                case !legacyResourceId: {
                    validationErrors = ['legacyResourceId not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, recommendations: _recommendations } = await snapshot.getPromise(store_1.default.fetchProductRecommendations({
                productId: legacyResourceId,
                limit: limit || 6,
            }));
            if (error) {
                setErrors([error]);
            }
            if (!_recommendations) {
                setErrors([
                    `Invalid product recommendations response: ${_recommendations}`,
                ]);
                return [];
            }
            setFinished(true);
            setRecommendations(_recommendations);
            if (callback)
                callback(_recommendations);
            return _recommendations;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    }, [legacyResourceId, limit]);
    // fetch recommendations on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, !legacyResourceId, finished];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getRecommendations({ legacyResourceId, limit })
            // eslint-disable-next-line no-shadow
            .then((recommendations) => {
            if (!recommendations || unMounting)
                return;
            setRecommendations(recommendations);
        })
            .catch((error) => {
            console.error('failed to fetchRecommendationsOnMount due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [legacyResourceId, props.fetchOnMount, limit]);
    return {
        recommendations,
        getRecommendations,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductRecommendations = useProductRecommendations;
//# sourceMappingURL=useProductRecommendations.js.map

/***/ }),

/***/ 99122:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductRecommendationsByHandle = void 0;
const react_1 = __webpack_require__(27378);
const useProductRecommendations_1 = __webpack_require__(56701);
const useProductByHandle_1 = __webpack_require__(42186);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    limit: 6,
    options: {},
};
const useProductRecommendationsByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const [recommendations, setRecommendations] = (0, react_1.useState)([]);
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props.handle}/getRecommendationsByHandle`,
    });
    // fetch the product by handle to find the legacyResourceId which
    // shopify recommendation API requires
    const { product, ...productStatus } = (0, useProductByHandle_1.useProductByHandle)({
        handle: props.handle,
    });
    const { getRecommendations } = (0, useProductRecommendations_1.useProductRecommendations)({
        fetchOnMount: false,
    });
    // fetch the recommendations once we have the product legacyResourceId
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setStarted(true);
        const earlyExitIf = [!props.fetchOnMount, !product?.legacyResourceId];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (recommendations?.length) {
            setFinished(true);
            return undefined;
        }
        getRecommendations({
            legacyResourceId: product.legacyResourceId,
            limit: props.limit,
        })
            .then((_recommendations) => {
            if (!_recommendations || unMounting)
                return null;
            setFinished(true);
            setRecommendations(_recommendations);
            return _recommendations;
        })
            .catch((error) => {
            setErrors([error.message]);
            console.error('failed to fetchRecommendationsOnMount due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [productStatus?.finished, product?.handle, props.fetchOnMount]);
    return {
        recommendations,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductRecommendationsByHandle = useProductRecommendationsByHandle;
//# sourceMappingURL=useProductRecommendationsByHandle.js.map

/***/ }),

/***/ 27080:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductSearch = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    term: null,
    fetchOnMount: true,
    limit: 6,
    options: {},
};
const useProductSearch = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/search/${props.term}`,
    });
    let { term, limit } = props;
    const [results, setResults] = (0, store_1.useRecoilState)(store_1.default.productSearchResults(term));
    const getSearchResults = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.term) {
                term = data.term;
            }
            if (data?.limit) {
                limit = data.limit;
            }
            let validationErrors = null;
            switch (true) {
                case typeof term === 'undefined': {
                    validationErrors = ['term not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, results: _results } = await snapshot.getPromise(store_1.default.fetchSearchResults({ term, limit }));
            if (error) {
                setErrors([error]);
            }
            if (!_results) {
                setErrors([`Invalid product search response: ${_results}`]);
                return [];
            }
            setFinished(true);
            setResults(_results);
            if (callback)
                callback(_results);
            return _results;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    });
    // fetch results on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, !term, finished];
        if (earlyExitIf.some(Boolean))
            return undefined;
        getSearchResults({ term, limit })
            // eslint-disable-next-line no-shadow
            .then((_results) => {
            if (unMounting)
                return;
            setResults(_results);
        })
            .catch((error) => {
            console.error('failed to getSearchResults due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [term, props.fetchOnMount, limit]);
    return {
        results,
        getSearchResults,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductSearch = useProductSearch;
//# sourceMappingURL=useProductSearch.js.map

/***/ }),

/***/ 89901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductSellingPlans = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    options: {},
};
const useProductSellingPlans = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${handle}/getSellingPlans`,
    });
    const [sellingPlans, setSellingPlans] = (0, store_1.useRecoilState)(store_1.default.productSellingPlans({ handle }));
    const getSellingPlans = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (sellingPlans) {
                setFinished(true);
                if (callback)
                    callback(sellingPlans);
                return sellingPlans;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product: _product } = await snapshot.getPromise(store_1.default.fetchProductSellingPlan({ handle }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_product || !_product?.sellingPlanGroups) {
                setErrors([`Invalid product selling plans response: ${_product}`]);
                return null;
            }
            setFinished(true);
            const { requiresSellingPlan, sellingPlanGroups } = _product;
            const response = { requiresSellingPlan, sellingPlanGroups };
            setSellingPlans(response);
            if (callback)
                callback(response);
            return response;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, [handle]);
    // fetch on handle change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !props.fetchOnMount,
            finished && sellingPlans, // already have recommendations
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        getSellingPlans({ handle })
            .then((data) => {
            if (unMounting || !data)
                return;
            setSellingPlans(data);
        })
            .catch((error) => {
            console.error('failed to fetchProductSellingPlanByHandle due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, props.fetchOnMount]);
    return {
        requiresSellingPlan: typeof sellingPlans?.requiresSellingPlan !== 'undefined'
            ? sellingPlans?.requiresSellingPlan
            : null,
        sellingPlanGroups: sellingPlans?.sellingPlanGroups || null,
        hasSellingPlans: sellingPlans?.sellingPlanGroups?.length > 0,
        getSellingPlans,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductSellingPlans = useProductSellingPlans;
//# sourceMappingURL=useProductSellingPlans.js.map

/***/ }),

/***/ 42315:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const DEBUG = false;
const useProductStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.productStatusStarted('product/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.productStatusFinished('product/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.productStatusSuccess('product/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.productStatusErrors('product/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.productStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.productStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.productStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.productStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId)
            setCartErrors(errors);
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId)
            setCartStarted(started);
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId)
            setCartSuccess(success);
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useProductStartFinishErrors = useProductStartFinishErrors;
//# sourceMappingURL=useProductStartFinishErrors.js.map

/***/ }),

/***/ 76722:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductVariantMetafield = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
// TODO: input should be selectedVariant, handle and selectedOptions should be decipher from it
// @see: useProductVariantPriceIn
const defaultProps = {
    handle: null,
    key: '',
    namespace: '',
    selectedOptions: null,
    fetchOnMount: true,
    options: {},
};
const useProductVariantMetafield = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    let { key, namespace, selectedOptions } = props;
    const { finished, errors, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${handle}/${props?.key}/getProductVariantMetafield`,
    });
    const [metafield, setMetafield] = (0, store_1.useRecoilState)(store_1.default.productVariantMetafield({ handle, key, namespace, selectedOptions }));
    const getVariantMetafield = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (metafield) {
                setFinished(true);
                if (callback)
                    callback(metafield);
                return metafield;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.key) {
                key = data.key;
            }
            if (data?.namespace) {
                namespace = data.namespace;
            }
            if (data?.selectedOptions) {
                selectedOptions = data.selectedOptions;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !key: {
                    validationErrors = ['key not provided'];
                    break;
                }
                case !namespace: {
                    validationErrors = ['namespace not provided'];
                    break;
                }
                case !selectedOptions: {
                    validationErrors = ['selectedOptions not provided'];
                    break;
                }
                case !Array.isArray(selectedOptions): {
                    // eslint-disable-next-line prettier/prettier
                    validationErrors = [
                        'get metafield failed "selectedOptions" must be an array',
                    ];
                    break;
                }
                case !selectedOptions[0]?.name || !selectedOptions[0]?.value: {
                    // eslint-disable-next-line prettier/prettier
                    validationErrors = [
                        'get metafield failed invalid "selectedOptions". Must be in the shape [{ name: "Size", value: "50 cm" }, ..]',
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, metafield: _metafield } = await snapshot.getPromise(store_1.default.fetchVariantMetafield({
                handle,
                key,
                namespace,
                selectedOptions,
            }));
            if (error) {
                throw new Error(error);
            }
            setFinished(true);
            setMetafield(_metafield);
            if (callback)
                callback(_metafield);
            return _metafield;
        }
        catch (error) {
            console.error('failed to getVariantMetafield due to', error.message);
            setErrors([error.message]);
            return null;
        }
    }, [key, handle, namespace, selectedOptions]);
    // fetch on change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !key,
            !namespace,
            !selectedOptions,
            !props.fetchOnMount,
            finished && metafield,
            errors.length, // finished and errors
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getVariantMetafield({ handle, key, namespace, selectedOptions })
            .then((_metafield) => {
            if (unMounting)
                return;
            setMetafield(_metafield);
        })
            .catch((error) => {
            console.error('failed to getVariantMetafield due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, key, namespace, props.fetchOnMount, selectedOptions, finished]);
    return {
        metafield,
        getVariantMetafield,
        finished,
        errors,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductVariantMetafield = useProductVariantMetafield;
//# sourceMappingURL=useProductVariantMetafield.js.map

/***/ }),

/***/ 89045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductVariantSellingPlan = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    variant: { product: { handle: null }, selectedOptions: null, id: '' },
    countryCode: null,
    currency: null,
    fetchOnMount: true,
    options: {},
};
const useProductVariantSellingPlan = (passedProps) => {
    const countryFallback = (0, store_1.useRecoilValue)(store_1.default.country)?.isoCode;
    const currencyFallback = (0, store_1.useRecoilValue)(store_1.default.country)?.currency?.isoCode;
    const props = passedProps?.variant
        ? { ...defaultProps, ...passedProps }
        : defaultProps;
    let { handle } = props.variant.product;
    let { selectedOptions } = props.variant;
    let country = props.countryCode || countryFallback;
    let currency = props.currency || currencyFallback;
    const statusId = `product/${handle}/variant/${props.variant.id
        .split('/')
        .pop()}/${country}/${currency}/sellingPlan`;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({ ...props.options, id: statusId });
    const [variantSub, setVariantSub] = (0, store_1.useRecoilState)(store_1.default.productVariantSellingPlan({
        handle,
        selectedOptions,
        country,
        currency,
    }));
    const getVariantSellingPlans = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.selectedOptions) {
                selectedOptions = data.selectedOptions;
            }
            if (data?.country) {
                country = data.country;
            }
            if (data?.currency) {
                currency = data.currency;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !selectedOptions: {
                    validationErrors = ['selectedOptions not provided'];
                    break;
                }
                case !country: {
                    validationErrors = ['country not provided'];
                    break;
                }
                case !currency: {
                    validationErrors = ['currency not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, variant } = await snapshot.getPromise(store_1.default.fetchProductVariantSellingPlan({
                handle,
                selectedOptions,
                country,
                currency,
            }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!variant) {
                setErrors([
                    `Invalid product variant price in response: ${variant}`,
                ]);
                return null;
            }
            setFinished(true);
            setVariantSub(variant);
            if (callback)
                callback(variant);
            return variant;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    });
    // fetch on handle change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !selectedOptions?.length,
            !country,
            !currency,
            !props.fetchOnMount,
            finished && variantSub,
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getVariantSellingPlans({ handle })
            .then((data) => {
            if (unMounting)
                return;
            setVariantSub(data);
        })
            .catch((error) => {
            console.error('failed to getVariantSellingPlans due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [
        handle,
        props.variant.id,
        selectedOptions,
        country,
        currency,
        variantSub,
    ]);
    return {
        variantSub: variantSub || null,
        getVariantSellingPlans,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductVariantSellingPlan = useProductVariantSellingPlan;
//# sourceMappingURL=useProductVariantSellingPlan.js.map

/***/ }),

/***/ 30476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsFromHandles = void 0;
/* eslint-disable consistent-return */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    handles: null,
    options: {},
};
const useProductsFromHandles = (passedProps = defaultProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props?.handles?.join('/')}/getProductsFromHandles`,
    });
    const [products, setProducts] = (0, react_1.useState)(null);
    const [productsMap, setProductsMap] = (0, react_1.useState)(null);
    // fetch bundle products from handles
    (0, react_1.useEffect)(() => {
        if (!props.handles?.length) {
            return;
        }
        if (products?.length) {
            setFinished(true);
            return;
        }
        setStarted(true);
        let unMounting;
        const fetchProductFromHandle = (handle) => {
            // if we have already fetched return it, else fetch it
            const product = products?.[handle] || null;
            if (product)
                return product;
            const endpoint = `/json/products/${handle}.json`;
            // eslint-disable-next-line no-undef
            return fetch(endpoint)
                .then((response) => response.json())
                .catch((error) => {
                // console.error('Problem fetching', handle, error.message);
                setErrors([error.message]);
                return { handle };
            });
        };
        const setBundleProducts = (_products) => {
            if (!_products?.length) {
                // didn't fetch
                if (unMounting)
                    return;
                setFinished(true);
                return;
            }
            // have fetched products
            if (unMounting)
                return;
            // we return a products map keyed by handle — not an array
            const mergedProducts = (prevProducts) => {
                const newProducts = _products.reduce((byHandle, product) => {
                    return {
                        ...byHandle,
                        [product.handle]: product,
                    };
                }, {});
                return {
                    ...prevProducts,
                    ...newProducts,
                };
            };
            if (unMounting)
                return;
            setFinished(true);
            setProducts(_products);
            setProductsMap(mergedProducts);
        };
        const bundleProductsPromises = props.handles.map(fetchProductFromHandle);
        Promise.all(bundleProductsPromises).then(setBundleProducts);
        return () => {
            unMounting = true;
        };
    }, [props.handles?.join('|')]);
    return {
        products,
        productsMap,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsFromHandles = useProductsFromHandles;
//# sourceMappingURL=useProductsFromHandles.js.map

/***/ }),

/***/ 60869:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsIndex = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useProductsIndex = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/productsIndex',
    });
    const [productsIndex, setProductsIndex] = (0, store_1.useRecoilState)(store_1.default.productsIndex);
    const fetchProductHandles = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productsIndex) {
                setFinished(true);
                if (callback)
                    callback(productsIndex);
                return productsIndex;
            }
            const { error, productsIndex: _productsIndex } = await snapshot.getPromise(store_1.default.fetchProductsIndex());
            if (error) {
                setErrors([error]);
            }
            if (!_productsIndex) {
                setErrors([`invalid product response: ${_productsIndex}`]);
                return null;
            }
            setFinished(true);
            setProductsIndex(_productsIndex);
            if (callback)
                callback(_productsIndex);
            return _productsIndex;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productsIndex?.length, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting) {
            setStarted(true);
        }
        fetchProductHandles()
            .then((jsonProductsIndex) => {
            if (unMounting)
                return;
            // bad response
            if (!jsonProductsIndex) {
                setErrors(['Invalid products index response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductsIndex(jsonProductsIndex);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productsIndex]);
    return {
        productsIndex,
        fetchProductHandles,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsIndex = useProductsIndex;
//# sourceMappingURL=useProductsIndex.js.map

/***/ }),

/***/ 64433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsList = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useProductsList = (passedPops) => {
    const props = { ...defaultProps, ...passedPops };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/productsList',
    });
    const [productsList, setProductsList] = (0, store_1.useRecoilState)(store_1.default.productsList);
    const fetchProductsList = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productsList) {
                setFinished(true);
                if (callback)
                    callback(productsList);
                return productsList;
            }
            const { error, productsList: _productsList } = await snapshot.getPromise(store_1.default.fetchProductsList());
            if (error) {
                setErrors([error]);
            }
            if (!_productsList || !Array.isArray(_productsList)) {
                setErrors([`invalid product list response: ${_productsList}`]);
                return null;
            }
            setFinished(true);
            setProductsList(_productsList);
            if (callback)
                callback(_productsList);
            return _productsList;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productsList?.length, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        fetchProductsList()
            .then((jsonProductsList) => {
            if (unMounting)
                return;
            // bad response
            if (!Array.isArray(jsonProductsList)) {
                setErrors(['Invalid products index response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductsList(jsonProductsList);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productsList]);
    return {
        productsList,
        fetchProductsList,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsList = useProductsList;
//# sourceMappingURL=useProductsList.js.map

/***/ }),

/***/ 27220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsUniq = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = { fetchOnMount: true, options: {} };
const useProductsUniq = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/productsUniq',
    });
    const [productsUniq, setProductsUniq] = (0, store_1.useRecoilState)(store_1.default.productsUniq);
    const fetchProductsUniq = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productsUniq) {
                setFinished(true);
                if (callback)
                    callback(productsUniq);
                return productsUniq;
            }
            const { error, productsUniq: _productsUniq } = await snapshot.getPromise(store_1.default.fetchProductsUniq());
            if (error) {
                setErrors([error]);
            }
            if (!_productsUniq) {
                setErrors([`invalid product uniq response: ${_productsUniq}`]);
                return null;
            }
            setFinished(true);
            setProductsUniq(_productsUniq);
            if (callback)
                callback(_productsUniq);
            return _productsUniq;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productsUniq, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting) {
            setStarted(true);
        }
        fetchProductsUniq()
            .then((jsonProductsUniq) => {
            if (unMounting)
                return;
            // bad response
            if (!jsonProductsUniq) {
                setErrors(['Invalid products uniq response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductsUniq(jsonProductsUniq);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productsUniq]);
    return {
        productsUniq,
        fetchProductsUniq,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsUniq = useProductsUniq;
//# sourceMappingURL=useProductsUniq.js.map

/***/ }),

/***/ 21857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.productStore = void 0;
var product_1 = __webpack_require__(7099);
Object.defineProperty(exports, "productStore", ({ enumerable: true, get: function () { return product_1.productStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.productStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
const store_1 = __webpack_require__(20437);
const client_1 = __webpack_require__(25431);
const client = new client_1.ProductClient({
    apiToken: "60385688208d54f843f3c3cb36d767b2",
    apiVersion: '2025-04',
    domain: "briogeo-hair-care.myshopify.com",
});
/**
  Product State
*/
const product = (0, recoil_1.atom)({
    key: 'product/product',
    default: null,
    effects: [
        // effects.logStateChange('product'),
        effects_1.default.onChange({
            key: 'product',
            topic: 'PRODUCT_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const productByHandle = (0, recoil_1.atomFamily)({
    key: 'product/byHandle',
    default: null,
});
const productInventory = (0, recoil_1.atomFamily)({
    key: 'product/inventory',
    default: null,
});
const productSellingPlans = (0, recoil_1.atomFamily)({
    key: 'product/sellingPlans',
    default: null,
});
// market/country price
const productPriceIn = (0, recoil_1.atomFamily)({
    key: 'product/priceIn',
    default: null,
});
const productVariantPriceIn = (0, recoil_1.atomFamily)({
    key: 'product/variantPriceIn',
    default: null,
});
const productVariantSellingPlan = (0, recoil_1.atomFamily)({
    key: 'product/variantSellingPlan',
    default: null,
});
const productRecommendations = (0, recoil_1.atomFamily)({
    key: 'product/recommendations',
    default: [],
});
const productSearchResults = (0, recoil_1.atomFamily)({
    key: 'product/searchResults',
    default: [],
});
const productMetafield = (0, recoil_1.atomFamily)({
    key: 'product/metafield',
    default: null,
});
const productVariantMetafield = (0, recoil_1.atomFamily)({
    key: 'product/variantMetafield',
    default: null,
});
const productsList = (0, recoil_1.atom)({
    key: 'product/productsList',
    default: null,
});
const productsUniq = (0, recoil_1.atom)({
    key: 'product/productsUniq',
    default: null, // { types: [], vendors: [], options: [] }
});
// products json fuse index
const productsIndex = (0, recoil_1.atom)({
    key: 'product/productsIndex',
    default: null,
});
const productHandles = (0, recoil_1.atom)({
    key: 'product/productHandles',
    default: null, // []
});
/* Status */
const productStatusStarted = (0, recoil_1.atomFamily)({
    key: 'product/statusStarted',
    default: false,
});
const productStatusFinished = (0, recoil_1.atomFamily)({
    key: 'product/statusFinished',
    default: false,
});
const productStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'product/statusSuccess',
    default: false,
});
const productStatusErrors = (0, recoil_1.atomFamily)({
    key: 'product/statusErrors',
    default: [],
});
/*
  Async fetchers
*/
const fetchProductByHandle = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductByHandle',
    get: ({ handle, version }) => async () => {
        return client.getByHandle({
            handle,
            version,
        });
    },
});
const fetchProductInventoryByHandle = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductInventoryByHandle',
    get: (data) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const _country = passedCountryCode || country?.isoCode || 'US';
        return client.getInventory({
            ...data,
            country: _country,
        });
    },
});
const fetchProductSellingPlan = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductSellingPlan',
    get: (data) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const _country = passedCountryCode || country?.isoCode || 'US';
        return client.getSellingPlans({
            ...data,
            country: _country,
        });
    },
});
const fetchProductVariantSellingPlan = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductVariantSellingPlan',
    get: (data) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const _country = passedCountryCode || country?.isoCode || 'US';
        return client.getVariantSellingPlans({
            ...data,
            country: _country,
            locale: country?.locale,
        });
    },
});
const fetchProductHandles = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductHandles',
    get: () => async () => {
        return client.getHandles();
    },
});
const fetchProductsList = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductsList',
    get: () => async () => {
        return client.getList();
    },
});
const fetchProductsUniq = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductsUniq',
    get: () => async () => {
        return client.getUniq();
    },
});
const fetchProductsIndex = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductsIndex',
    get: () => async () => {
        return client.getIndex();
    },
});
const fetchProductRecommendations = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductRecommendations',
    get: ({ productId, limit }) => async () => {
        return client.getRecommendations({
            productId,
            limit,
        });
    },
});
const fetchSearchResults = (0, recoil_1.selectorFamily)({
    key: 'product/fetchSearchResults',
    get: ({ term, limit }) => async () => {
        return client.searchProducts({
            term,
            limit,
        });
    },
});
const fetchMetafield = (0, recoil_1.selectorFamily)({
    key: 'product/fetchMetafield',
    get: ({ handle, key, namespace }) => async () => {
        return client.getMetafield({
            handle,
            key,
            namespace,
        });
    },
});
const fetchVariantMetafield = (0, recoil_1.selectorFamily)({
    key: 'product/fetchVariantMetafield',
    get: ({ handle, key, namespace, selectedOptions }) => async () => {
        return client.getVariantMetafield({
            handle,
            key,
            namespace,
            selectedOptions,
        });
    },
});
exports.productStore = {
    // actual state - atoms
    product,
    productPriceIn,
    productVariantPriceIn,
    productVariantSellingPlan,
    productSellingPlans,
    productInventory,
    productByHandle,
    productMetafield,
    productVariantMetafield,
    productRecommendations,
    productSearchResults,
    productsIndex,
    productsList,
    productsUniq,
    productHandles,
    // status
    productStatusStarted,
    productStatusFinished,
    productStatusSuccess,
    productStatusErrors,
    // async fetches
    fetchProductByHandle,
    fetchProductSellingPlan,
    fetchProductVariantSellingPlan,
    fetchProductInventoryByHandle,
    fetchProductHandles,
    fetchProductsList,
    fetchProductsUniq,
    fetchProductsIndex,
    fetchProductRecommendations,
    fetchSearchResults,
    fetchMetafield,
    fetchVariantMetafield,
};
//# sourceMappingURL=product.js.map

/***/ }),

/***/ 80972:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(72962), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 72962:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withRouter = exports.useRouter = exports.Router = void 0;
const tslib_1 = __webpack_require__(59312);
const router_1 = tslib_1.__importStar(__webpack_require__(86677));
exports.Router = router_1.default;
exports.useRouter = router_1.useRouter;
exports.withRouter = router_1.withRouter;
//# sourceMappingURL=useRouter.js.map

/***/ }),

/***/ 5852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(82842), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82842:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSettings = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useSettings = () => {
    return (0, store_1.useRecoilValue)(store_1.default.storefrontSettings);
};
exports.useSettings = useSettings;
//# sourceMappingURL=useSettings.js.map

/***/ }),

/***/ 98584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.settingsStore = void 0;
var settings_1 = __webpack_require__(21782);
Object.defineProperty(exports, "settingsStore", ({ enumerable: true, get: function () { return settings_1.settingsStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 21782:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.settingsStore = void 0;
const recoil_1 = __webpack_require__(69853);
const storefrontSettings = (0, recoil_1.atom)({
    key: 'storefront/settings',
    default: null,
    effects: [],
});
exports.settingsStore = {
    // actual state - atoms
    storefrontSettings,
};
//# sourceMappingURL=settings.js.map

/***/ }),

/***/ 95587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ShopClient = void 0;
const tslib_1 = __webpack_require__(59312);
const graphql_request_1 = __webpack_require__(63671);
const humanize_graphql_response_1 = tslib_1.__importDefault(__webpack_require__(27207));
const queries_1 = __webpack_require__(15982);
class ShopClient {
    constructor({ apiToken, apiVersion, domain, debug }) {
        this.apiToken = apiToken;
        this.apiVersion = apiVersion;
        this.domain = domain;
        this.endpoint = '';
        this.options = {};
        this.debug = debug || false;
        this.client = this.init();
    }
    init() {
        this.endpoint = `https://${this.domain}/api/${this.apiVersion}/graphql.json`;
        // client
        this.options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'X-Shopify-Storefront-Access-Token': this.apiToken,
                'Content-Type': 'application/json; charset=utf-8',
            },
        };
        return new graphql_request_1.GraphQLClient(this.endpoint, this.options);
    }
    /**
     * Customer queries client
     * @param {gqlQuery} query
     * @param {object} variables
     * @returns
     */
    async query({ query, variables }) {
        if (this.debug) {
            console.log('ShopClient:', query, variables);
        }
        return this.client.rawRequest(query, variables);
    }
    /**
     * Customer mutation client
     * @param {gqlMutation} mutation
     * @param {object} variables
     * @returns
     */
    async mutate({ mutation, variables }) {
        if (this.debug) {
            console.log('ShopClient:', mutation, variables);
        }
        return this.client.rawRequest(mutation, variables);
    }
    /**
     * Query the storefront shop object data
     * @param {String} country
     */
    async getShop() {
        try {
            const request = await this.query({
                query: queries_1.queries.shop,
                variables: {},
            });
            const shop = request?.data?.shop;
            return { error: null, data: (0, humanize_graphql_response_1.default)(shop) };
        }
        catch (error) {
            return { error: error.message, data: null };
        }
    }
    /**
     * Query all countries locales
     * @param {String} country
     */
    async getLocales(props) {
        try {
            const { countryCode } = props;
            const request = await this.query({
                query: queries_1.queries.localization,
                variables: { country: countryCode },
            });
            const localization = request?.data?.localization;
            const countryCodes = localization.availableCountries.map((_country) => _country?.isoCode);
            // eslint-disable-next-line no-undef
            const localesRequest = await fetch('/api/shopify/locales', {
                method: 'POST',
                body: JSON.stringify({ countryCodes }),
            });
            const { response } = await localesRequest.json();
            if (!response) {
                throw new Error('getLocales: shopify locales response not ok');
            }
            const { locales } = response;
            return { error: null, data: locales };
        }
        catch (error) {
            console.error('getLocales:error', error.message);
            return { error: error.message, data: null };
        }
    }
    /**
     * Query available countries and currencies
     * @param {String} country
     * @see https://shopify.dev/custom-storefronts/products/international-pricing#query-available-countries-and-currencies
     */
    async getCountries(props) {
        try {
            if (!props?.countryCode) {
                throw new Error('getCountries: missing primary countryCode');
            }
            if (!props?.currencyCode) {
                throw new Error('getCountries: missing primary currencyCode');
            }
            if (!props?.currencies) {
                throw new Error('getCountries: missing currencies');
            }
            const { countryCode } = props;
            const request = await this.query({
                query: queries_1.queries.localization,
                variables: { country: countryCode },
            });
            if (request.status !== 200) {
                throw new Error(`getCountries: response error ${request.status}`);
            }
            const data = (0, humanize_graphql_response_1.default)(request?.data);
            const localization = data?.localization; // { availableCountries: [...], country: {..} }
            // fetch local for each available country and add it to each item
            const { data: locales } = await this.getLocales({ countryCode });
            const countryWithLocale = (_country) => {
                const locale = locales[_country?.isoCode];
                // if we don't a full locale for this country filter it out. Kosovo and Netherland Antilles
                // currently missing from country-locale-map@^1.8.0. I've requested the developer to add them.
                // @see: https://github.com/atnmorrison/country-locale-map/issues/27
                if (!locale)
                    return null;
                return { ..._country, locale: locales[_country?.isoCode] };
            };
            // default country
            localization.country.locale = locales[localization.country?.isoCode];
            // all available countries in the store (not the same as enabled markets)
            localization.availableCountries = localization.availableCountries
                .map(countryWithLocale)
                .filter(Boolean);
            /*
              Each currency represents an enabled market,
              if only one is set then markets are disabled
            */
            if (props.currencies?.length === 1) {
                localization.activeCountries = [localization.country];
            }
            else {
                // multiple markets enabled, filter
                localization.activeCountries = localization.availableCountries.filter((country) => {
                    return props.currencies.includes(country.locale.currency);
                });
            }
            return {
                error: null,
                data: localization,
            };
        }
        catch (error) {
            return { error: error.message, data: null };
        }
    }
}
exports.ShopClient = ShopClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 90465:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const graphql_request_1 = __webpack_require__(63671);
const Country = (0, graphql_request_1.gql) `
  fragment Country on Country {
    currency {
      isoCode
      name
      symbol
    }
    isoCode
    name
    unitSystem
  }
`;
const Policy = (0, graphql_request_1.gql) `
  fragment Policy on ShopPolicy {
    handle
    id
    title
    body
    __typename
  }
`;
exports["default"] = {
    Country,
    Policy,
};
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 76574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ShopClient = void 0;
var client_1 = __webpack_require__(95587);
Object.defineProperty(exports, "ShopClient", ({ enumerable: true, get: function () { return client_1.ShopClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 15982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queries = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(63671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(90465));
/*
  Queries
*/
const shop = (0, graphql_request_1.gql) `
  query {
    shop {
      description
      moneyFormat
      name
      paymentSettings {
        acceptedCardBrands
        cardVaultUrl
        countryCode
        currencyCode
        enabledPresentmentCurrencies
        supportedDigitalWallets
        shopifyPaymentsAccountId
      }
      primaryDomain {
        host
        sslEnabled
        url
      }
      shipsToCountries
    }
  }
`;
const localization = (0, graphql_request_1.gql) `
  query ($country: CountryCode) @inContext(country: $country) {
    shop {
      paymentSettings {
        enabledCurrencies: enabledPresentmentCurrencies
      }
    }
    localization {
      availableCountries {
        ...Country
      }
      country {
        ...Country
      }
    }
  }
  ${fragments_1.default.Country}
`;
exports.queries = {
    localization,
    shop,
};
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 42022:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocale = exports.useAvailableCountries = exports.useCountries = exports.useCountry = exports.useCurrencies = exports.useCurrency = exports.useShop = exports.useStorefrontInit = exports.useCountriesInit = exports.useShopInit = void 0;
var useShopInit_1 = __webpack_require__(33840);
Object.defineProperty(exports, "useShopInit", ({ enumerable: true, get: function () { return useShopInit_1.useShopInit; } }));
var useCountriesInit_1 = __webpack_require__(77344);
Object.defineProperty(exports, "useCountriesInit", ({ enumerable: true, get: function () { return useCountriesInit_1.useCountriesInit; } }));
// eslint-disable-next-line import/no-cycle
var useStorefrontInit_1 = __webpack_require__(28123); // new on v2
Object.defineProperty(exports, "useStorefrontInit", ({ enumerable: true, get: function () { return useStorefrontInit_1.useStorefrontInit; } }));
// getters
var useShop_1 = __webpack_require__(69056);
Object.defineProperty(exports, "useShop", ({ enumerable: true, get: function () { return useShop_1.useShop; } }));
var useCurrency_1 = __webpack_require__(28422);
Object.defineProperty(exports, "useCurrency", ({ enumerable: true, get: function () { return useCurrency_1.useCurrency; } }));
var useCurrencies_1 = __webpack_require__(371);
Object.defineProperty(exports, "useCurrencies", ({ enumerable: true, get: function () { return useCurrencies_1.useCurrencies; } }));
var useCountry_1 = __webpack_require__(85030);
Object.defineProperty(exports, "useCountry", ({ enumerable: true, get: function () { return useCountry_1.useCountry; } }));
var useCountries_1 = __webpack_require__(12411);
Object.defineProperty(exports, "useCountries", ({ enumerable: true, get: function () { return useCountries_1.useCountries; } }));
var useAvailableCountries_1 = __webpack_require__(17310);
Object.defineProperty(exports, "useAvailableCountries", ({ enumerable: true, get: function () { return useAvailableCountries_1.useAvailableCountries; } }));
var useLocale_1 = __webpack_require__(96376);
Object.defineProperty(exports, "useLocale", ({ enumerable: true, get: function () { return useLocale_1.useLocale; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 17310:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAvailableCountries = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useAvailableCountries = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const availableCountries = (0, store_1.useRecoilValue)(store_1.default.availableCountries);
    return isMounted ? availableCountries : null;
};
exports.useAvailableCountries = useAvailableCountries;
//# sourceMappingURL=useAvailableCountries.js.map

/***/ }),

/***/ 12411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCountries = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCountries = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const countries = (0, store_1.useRecoilValue)(store_1.default.countries);
    return isMounted ? countries : null;
};
exports.useCountries = useCountries;
//# sourceMappingURL=useCountries.js.map

/***/ }),

/***/ 77344:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCountriesInit = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useShopStartFinishErrors_1 = __webpack_require__(81108);
const defaultProps = {
    fetchOnMount: false,
    options: {},
};
const useCountriesInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const [country, setCountry] = (0, store_1.useRecoilState)(store_1.default.country);
    const [countries, setCountries] = (0, store_1.useRecoilState)(store_1.default.countries);
    const [availableCountries, setAvailableCountries] = (0, store_1.useRecoilState)(store_1.default.availableCountries);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useShopStartFinishErrors_1.useShopStartFinishErrors)({
        ...props.options,
        id: `shop/countries/init`,
    });
    const getCountries = (0, store_1.useRecoilCallback)(({ snapshot }) => async (_, callback) => {
        setStarted(true);
        const release = snapshot.retain();
        try {
            // can pass accessToken or will use the on in store
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCountries());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.country) {
                setErrors(['countries init response missing country data']);
                return null;
            }
            if (!response?.country?.name) {
                setErrors(['countries init invalid response']);
                return null;
            }
            const { country: _country, availableCountries: _availableCountries, activeCountries: _countries, } = response;
            setFinished(true);
            setAvailableCountries(_availableCountries);
            // mark the primary market as default
            const primaryCountry = { ..._country, isPrimary: true };
            const countriesWithPrimary = _countries.map((__country) => {
                if (__country?.isoCode === primaryCountry?.isoCode) {
                    return primaryCountry;
                }
                return __country;
            });
            // if we don't have a persisted country we set the shop default as default
            if (!country) {
                setCountry(primaryCountry);
            }
            setCountries(countriesWithPrimary);
            const data = {
                country: primaryCountry,
                countries: countriesWithPrimary,
                availableCountries: _availableCountries,
            };
            if (callback)
                callback(data);
            return data;
        }
        catch (error) {
            console.error(`getCountries:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // fetch on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, finished];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getCountries()
            // eslint-disable-next-line no-shadow
            .then((data) => {
            if (unMounting || !data)
                return null;
            if (!country) {
                setCountry(data.country);
            }
            setCountries(data.countries);
            return data;
        })
            .catch((error) => {
            console.error('failed to getCountries due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, country, finished]);
    return {
        country,
        countries,
        availableCountries,
        getCountries,
        finished,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCountriesInit = useCountriesInit;
//# sourceMappingURL=useCountriesInit.js.map

/***/ }),

/***/ 85030:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCountry = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useShopStartFinishErrors_1 = __webpack_require__(81108);
const useCartUpdateBuyerIdentity_1 = __webpack_require__(44717);
const useCountry = (options) => {
    const isMounted = (0, helpers_1.useMounted)();
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    const { setStarted, setFinished, setErrors, ...status } = (0, useShopStartFinishErrors_1.useShopStartFinishErrors)({ ...options, id: 'shop/updatedCountry' });
    const { cartUpdateBuyerIdentity } = (0, useCartUpdateBuyerIdentity_1.useCartUpdateBuyerIdentity)();
    const updateCountry = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        let validationErrors = null;
        switch (true) {
            case !data || !data?.country: {
                validationErrors = ['country data not provided'];
                break;
            }
            case !data?.country?.isoCode: {
                validationErrors = ['country must include an isoCode'];
                break;
            }
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            setStarted(true);
            // update the cart locale
            const updatedCart = await cartUpdateBuyerIdentity({
                country: data.country?.isoCode,
                buyerIdentity: {
                    countryCode: data.country?.isoCode,
                },
            });
            if (!updatedCart?.id) {
                setErrors(['Failed to update cart buyer identity countryCode']);
                return null;
            }
            // update the shop state
            set(store_1.default.country, data.country);
            setFinished(true);
            if (callback)
                callback(data.country);
            return data.country;
        }
        catch (error) {
            console.error('failed to update country to due to', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        country: isMounted ? country : null,
        updateCountry,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCountry = useCountry;
//# sourceMappingURL=useCountry.js.map

/***/ }),

/***/ 371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCurrencies = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCurrencies = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const currencies = (0, store_1.useRecoilValue)(store_1.default.currencies$);
    return isMounted ? currencies : null;
};
exports.useCurrencies = useCurrencies;
//# sourceMappingURL=useCurrencies.js.map

/***/ }),

/***/ 28422:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCurrency = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCurrency = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    return isMounted ? country?.locale?.currency || null : null;
};
exports.useCurrency = useCurrency;
//# sourceMappingURL=useCurrency.js.map

/***/ }),

/***/ 96376:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocale = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useLocale = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    return isMounted ? country?.locale || null : null;
};
exports.useLocale = useLocale;
//# sourceMappingURL=useLocale.js.map

/***/ }),

/***/ 69056:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useShop = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useShop = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const shop = (0, store_1.useRecoilValue)(store_1.default.shop);
    return isMounted ? shop : null;
};
exports.useShop = useShop;
//# sourceMappingURL=useShop.js.map

/***/ }),

/***/ 33840:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useShopInit = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useShopStartFinishErrors_1 = __webpack_require__(81108);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useShopInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const [shop, setShop] = (0, store_1.useRecoilState)(store_1.default.shop);
    const [, setShopInit] = (0, store_1.useRecoilState)(store_1.default.shopInit);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useShopStartFinishErrors_1.useShopStartFinishErrors)({
        ...props.options,
        id: `shop/init`,
    });
    const getShop = (0, store_1.useRecoilCallback)(({ snapshot }) => async (_, callback) => {
        setStarted(true);
        const release = snapshot.retain();
        try {
            // can pass accessToken or will use the on in store
            const { error, data: _shop } = await snapshot.getPromise(store_1.default.fetchShop());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_shop) {
                setErrors(['shop get response missing shop data']);
                return null;
            }
            setFinished(true);
            setShopInit(true);
            setShop(_shop);
            if (callback)
                callback(_shop);
            return _shop;
        }
        catch (error) {
            console.error(`getShop:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // fetch on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, shop];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getShop()
            // eslint-disable-next-line no-shadow
            .then((shop) => {
            if (unMounting)
                return;
            setShop(shop);
        })
            .catch((error) => {
            console.error('failed to getShop due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, shop, finished]);
    return {
        shop,
        getShop,
        finished,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useShopInit = useShopInit;
//# sourceMappingURL=useShopInit.js.map

/***/ }),

/***/ 81108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useShopStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const DEBUG = false;
const useShopStartFinishErrors = (options) => {
    const setShopStarted = (0, store_1.useSetRecoilState)(store_1.default.shopStatusStarted('shop/all'));
    const setShopFinished = (0, store_1.useSetRecoilState)(store_1.default.shopStatusFinished('shop/all'));
    const setShopSuccess = (0, store_1.useSetRecoilState)(store_1.default.shopStatusSuccess('shop/all'));
    const setShopErrors = (0, store_1.useSetRecoilState)(store_1.default.shopStatusErrors('shop/all'));
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.shopStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.shopStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.shopStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.shopStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    const isCustomerId = /^customer/.test(options?.id);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setShopErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setShopStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setShopFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setShopFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setShopSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useShopStartFinishErrors = useShopStartFinishErrors;
//# sourceMappingURL=useShopStartFinishErrors.js.map

/***/ }),

/***/ 28123:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStorefrontInit = void 0;
const useShopInit_1 = __webpack_require__(33840);
const useCountriesInit_1 = __webpack_require__(77344);
const hooks_1 = __webpack_require__(48081);
const hooks_2 = __webpack_require__(33296);
const useStorefrontInit = () => {
    // 1. initialize the shop to determine primary currency code and country
    const { shop, ...shopStatus } = (0, useShopInit_1.useShopInit)();
    const primaryCountryCode = shop?.paymentSettings?.countryCode;
    // 2. initialize the countries to get all the available countries/markets info
    const { country, countries, ...countriesStatus } = (0, useCountriesInit_1.useCountriesInit)({
        fetchOnMount: primaryCountryCode,
    });
    const fullCountryCode = country?.isoCode;
    // 3. initialize customer and cart (the cart will be initialized once customerInit is true)
    const cart = (0, hooks_1.useCartInit)({ fetchOnMount: fullCountryCode });
    const customer = (0, hooks_2.useCustomerInit)({ fetchOnMount: fullCountryCode });
    return {
        customer,
        cart,
        shop,
        country,
        countries,
        finished: customer && cart && shop && country && countries,
        errors: [...countriesStatus.errors, ...shopStatus.errors],
    };
};
exports.useStorefrontInit = useStorefrontInit;
//# sourceMappingURL=useStorefrontInit.js.map

/***/ }),

/***/ 20437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shopStore = void 0;
var shop_1 = __webpack_require__(44652);
Object.defineProperty(exports, "shopStore", ({ enumerable: true, get: function () { return shop_1.shopStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 44652:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shopStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
const client_1 = __webpack_require__(76574);
const client = new client_1.ShopClient({
    apiToken: "60385688208d54f843f3c3cb36d767b2",
    apiVersion: '2025-04',
    domain: "briogeo-hair-care.myshopify.com",
    debug: false,
});
// @see: https://shopify.dev/themes/internationalization/multiple-currencies-languages#javascript-submission-of-the-localization-form
const shop = (0, recoil_1.atom)({
    key: 'shop',
    default: null,
    effects: [
    // effects.logStateChange('shop')
    ],
});
const shopInit = (0, recoil_1.atom)({
    key: 'shop/init',
    default: false,
});
const country = (0, recoil_1.atom)({
    key: 'shop/country',
    default: null,
    // default: {
    //   currency: {
    //     isoCode: 'USD',
    //     name: 'United States Dollar',
    //     symbol: '$',
    //   },
    //   isoCode: 'US',
    //   name: 'United States',
    //   unitSystem: 'IMPERIAL_SYSTEM',
    // },
    effects: [
        // effects.logStateChange('country'),
        effects_1.default.setSelfToPersistedKey('country', `Country|${effects_1.default.SHOPIFY_NAME}`, 'COUNTRY_EXISTING'),
        effects_1.default.onSetUpdatePersistedKey(`Country|${effects_1.default.SHOPIFY_NAME}`),
        effects_1.default.onChange({
            key: 'country',
            topic: 'COUNTRY_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
/*
  ---------------
  Getters
  ---------------
*/
const primaryCurrencyCode$ = (0, recoil_1.selector)({
    key: 'shop/primaryCurrencyCode$',
    get: ({ get }) => {
        const _shop = get(shop);
        return _shop?.paymentSettings?.currencyCode || null;
    },
});
const primaryCountryCode$ = (0, recoil_1.selector)({
    key: 'shop/primaryCountryCode$',
    get: ({ get }) => {
        const _shop = get(shop);
        return _shop?.paymentSettings?.countryCode || null;
    },
});
/*
  When multiple markets are enabled on a store
  it will return an array of currencyCodes the user can checkout with
    e.g ['BR', 'CA', 'CN', 'DE', 'FR', 'GB', 'MX', 'RU', 'US']

  When no markets have been configured the array will include only the
  default market's currency code
    e.g ['USD] – user can only checkout in USD
*/
const currencies$ = (0, recoil_1.selector)({
    key: 'shop/currencies$',
    get: ({ get }) => {
        const _shop = get(shop);
        return _shop?.paymentSettings?.enabledPresentmentCurrencies || [];
    },
});
/*
  ---------------
  Status
  ---------------
*/
const countries = (0, recoil_1.atom)({
    key: 'shop/countries',
    default: [],
});
const availableCountries = (0, recoil_1.atom)({
    key: 'shop/availableCountries',
    default: [],
});
const shopStatusStarted = (0, recoil_1.atomFamily)({
    key: 'shop/statusStarted',
    default: false,
});
const shopStatusFinished = (0, recoil_1.atomFamily)({
    key: 'shop/statusFinished',
    default: false,
});
const shopStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'shop/statusSuccess',
    default: false,
});
const shopStatusErrors = (0, recoil_1.atomFamily)({
    key: 'shop/statusErrors',
    default: [],
});
/*
  ---------------
  Async fetchers and setters
  ---------------
*/
/*
  Shop: countries...
*/
const fetchShop = (0, recoil_1.selectorFamily)({
    key: 'shop/fetchShop',
    get: () => async () => {
        return client.getShop();
    },
});
const fetchCountries = (0, recoil_1.selectorFamily)({
    key: 'shop/fetchCountries',
    get: () => async ({ get }) => {
        const primaryCurrencyCode = get(primaryCurrencyCode$);
        const primaryCountryCode = get(primaryCountryCode$);
        const currencies = get(currencies$);
        if (!primaryCountryCode)
            return null;
        return client.getCountries({
            countryCode: primaryCountryCode,
            currencyCode: primaryCurrencyCode,
            currencies, // presentmentCurrencies.
        });
    },
});
// new on v2
exports.shopStore = {
    shop,
    shopInit,
    country,
    countries,
    availableCountries,
    primaryCurrencyCode$,
    primaryCountryCode$,
    currencies$,
    shopStatusStarted,
    shopStatusFinished,
    shopStatusSuccess,
    shopStatusErrors,
    fetchShop,
    fetchCountries,
};
//# sourceMappingURL=shop.js.map

/***/ }),

/***/ 24385:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectorFamily = exports.selector = exports.atomFamily = exports.atom = exports.useGotoRecoilSnapshot = exports.useRecoilCallback = exports.useRecoilSnapshot = exports.useRecoilValueLoadable = exports.useRecoilValue = exports.useResetRecoilState = exports.useSetRecoilState = exports.useRecoilStateLoadable = exports.useRecoilState = void 0;
const store_1 = __webpack_require__(9807);
const store_2 = __webpack_require__(32159);
const store_3 = __webpack_require__(3727);
const store_4 = __webpack_require__(29005);
const store_5 = __webpack_require__(57152);
const store_6 = __webpack_require__(90747);
const store_7 = __webpack_require__(29970);
const store_8 = __webpack_require__(98886);
const store_9 = __webpack_require__(21857);
const store_10 = __webpack_require__(20437);
const store_11 = __webpack_require__(6839);
const store_12 = __webpack_require__(98584);
// just so that we don't need to imports in components
var recoil_1 = __webpack_require__(69853);
Object.defineProperty(exports, "useRecoilState", ({ enumerable: true, get: function () { return recoil_1.useRecoilState; } }));
Object.defineProperty(exports, "useRecoilStateLoadable", ({ enumerable: true, get: function () { return recoil_1.useRecoilStateLoadable; } }));
Object.defineProperty(exports, "useSetRecoilState", ({ enumerable: true, get: function () { return recoil_1.useSetRecoilState; } }));
Object.defineProperty(exports, "useResetRecoilState", ({ enumerable: true, get: function () { return recoil_1.useResetRecoilState; } }));
Object.defineProperty(exports, "useRecoilValue", ({ enumerable: true, get: function () { return recoil_1.useRecoilValue; } }));
Object.defineProperty(exports, "useRecoilValueLoadable", ({ enumerable: true, get: function () { return recoil_1.useRecoilValueLoadable; } }));
Object.defineProperty(exports, "useRecoilSnapshot", ({ enumerable: true, get: function () { return recoil_1.useRecoilSnapshot; } }));
Object.defineProperty(exports, "useRecoilCallback", ({ enumerable: true, get: function () { return recoil_1.useRecoilCallback; } }));
Object.defineProperty(exports, "useGotoRecoilSnapshot", ({ enumerable: true, get: function () { return recoil_1.useGotoRecoilSnapshot; } }));
Object.defineProperty(exports, "atom", ({ enumerable: true, get: function () { return recoil_1.atom; } }));
Object.defineProperty(exports, "atomFamily", ({ enumerable: true, get: function () { return recoil_1.atomFamily; } }));
Object.defineProperty(exports, "selector", ({ enumerable: true, get: function () { return recoil_1.selector; } }));
Object.defineProperty(exports, "selectorFamily", ({ enumerable: true, get: function () { return recoil_1.selectorFamily; } }));
// eslint-disable-next-line import/no-default-export
exports["default"] = {
    ...store_1.analyticsStore,
    ...store_2.articleStore,
    ...store_3.blogStore,
    ...store_4.cartStore,
    ...store_5.collectionStore,
    ...store_6.customerStore,
    ...store_7.localeStore,
    ...store_8.pageStore,
    ...store_9.productStore,
    ...store_10.shopStore,
    ...store_11.viewStore,
    ...store_12.settingsStore,
};
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 8844:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTemplate = void 0;
var useTemplate_1 = __webpack_require__(30412);
Object.defineProperty(exports, "useTemplate", ({ enumerable: true, get: function () { return useTemplate_1.useTemplate; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 30412:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTemplate = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useTemplate = () => (0, store_1.useRecoilValue)(store_1.default.template);
exports.useTemplate = useTemplate;
//# sourceMappingURL=useTemplate.js.map

/***/ }),

/***/ 6839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.viewStore = void 0;
var view_1 = __webpack_require__(74979);
Object.defineProperty(exports, "viewStore", ({ enumerable: true, get: function () { return view_1.viewStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 74979:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.viewStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  ROUTE_VIEW State
*/
const route = (0, recoil_1.atom)({
    key: 'view/route',
    default: '',
    effects: [
        effects_1.default.onChange({
            key: 'route',
            topic: 'ROUTE_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const template = (0, recoil_1.selector)({
    key: 'view/template',
    default: null,
    get: ({ get }) => {
        const _route = get(route);
        const _template = _route
            ? effects_1.default.routeToTemplate({ route: _route })
            : null; // not ready
        return _template;
    },
});
// viewStore
exports.viewStore = {
    route,
    template,
};
//# sourceMappingURL=view.js.map

/***/ }),

/***/ 48438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgErrorIcon = function SvgErrorIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D0021B"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m4.464 4.464 7.072 7.072M4.464 11.536l7.071-7.072"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgErrorIcon);

/***/ }),

/***/ 23278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    d: "M14.545 1.415 1.414 14.546M14.586 14.545 1.455 1.414"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgIconClose);

/***/ }),

/***/ 88981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/* provided dependency */ var Buffer = __webpack_require__(30816)["Buffer"];
(function (w) {
  "use strict";

  function findBest(atobNative) {
    // normal window
    if ('function' === typeof atobNative) { return atobNative; }


    // browserify (web worker)
    if ('function' === typeof Buffer) {
      return function atobBrowserify(a) {
        //!! Deliberately using an API that's deprecated in node.js because
        //!! this file is for browsers and we expect them to cope with it.
        //!! Discussion: github.com/node-browser-compat/atob/pull/9
        return new Buffer(a, 'base64').toString('binary');
      };
    }

    // ios web worker with base64js
    if ('object' === typeof w.base64js) {
      // bufferToBinaryString
      // https://git.coolaj86.com/coolaj86/unibabel.js/blob/master/index.js#L50
      return function atobWebWorker_iOS(a) {
        var buf = w.base64js.b64ToByteArray(a);
        return Array.prototype.map.call(buf, function (ch) {
          return String.fromCharCode(ch);
        }).join('');
      };
    }

		return function () {
			// ios web worker without base64js
			throw new Error("You're probably in an old browser or an iOS webworker." +
				" It might help to include beatgammit's base64-js.");
    };
  }

  var atobBest = findBest(w.atob);
  w.atob = atobBest;

  if (( true) && module && module.exports) {
    module.exports = atobBest;
  }
}(window));


/***/ }),

/***/ 24782:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 72326:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


// See https://tools.ietf.org/html/rfc4647#section-3.1
// for more information on the algorithms.

exports.basicFilter = factory(basic, true)
exports.extendedFilter = factory(extended, true)
exports.lookup = factory(lookup)

// Basic Filtering (Section 3.3.1) matches a language priority list consisting
// of basic language ranges (Section 2.1) to sets of language tags.
function basic(tag, range) {
  return range === '*' || tag === range || tag.indexOf(range + '-') > -1
}

// Extended Filtering (Section 3.3.2) matches a language priority list
// consisting of extended language ranges (Section 2.2) to sets of language
// tags.
function extended(tag, range) {
  // 3.3.2.1
  var left = tag.split('-')
  var right = range.split('-')
  var leftIndex = 0
  var rightIndex = 0

  // 3.3.2.2
  if (right[rightIndex] !== '*' && left[leftIndex] !== right[rightIndex]) {
    return false
  }

  leftIndex++
  rightIndex++

  // 3.3.2.3
  while (rightIndex < right.length) {
    // 3.3.2.3.A
    if (right[rightIndex] === '*') {
      rightIndex++
      continue
    }

    // 3.3.2.3.B
    if (!left[leftIndex]) return false

    // 3.3.2.3.C
    if (left[leftIndex] === right[rightIndex]) {
      leftIndex++
      rightIndex++
      continue
    }

    // 3.3.2.3.D
    if (left[leftIndex].length === 1) return false

    // 3.3.2.3.E
    leftIndex++
  }

  // 3.3.2.4
  return true
}

// Lookup (Section 3.4) matches a language priority list consisting of basic
// language ranges to sets of language tags to find the one exact language tag
// that best matches the range.
function lookup(tag, range) {
  var right = range
  var index

  /* eslint-disable-next-line no-constant-condition */
  while (true) {
    if (right === '*' || tag === right) return true

    index = right.lastIndexOf('-')

    if (index < 0) return false

    if (right.charAt(index - 2) === '-') index -= 2

    right = right.slice(0, index)
  }
}

// Factory to perform a filter or a lookup.
// This factory creates a function that accepts a list of tags and a list of
// ranges, and contains logic to exit early for lookups.
// `check` just has to deal with one tag and one range.
// This match function iterates over ranges, and for each range,
// iterates over tags.  That way, earlier ranges matching any tag have
// precedence over later ranges.
function factory(check, filter) {
  return match

  function match(tags, ranges) {
    var left = cast(tags, 'tag')
    var right = cast(ranges == null ? '*' : ranges, 'range')
    var matches = []
    var rightIndex = -1
    var range
    var leftIndex
    var next

    while (++rightIndex < right.length) {
      range = right[rightIndex].toLowerCase()

      // Ignore wildcards in lookup mode.
      if (!filter && range === '*') continue

      leftIndex = -1
      next = []

      while (++leftIndex < left.length) {
        if (check(left[leftIndex].toLowerCase(), range)) {
          // Exit if this is a lookup and we have a match.
          if (!filter) return left[leftIndex]
          matches.push(left[leftIndex])
        } else {
          next.push(left[leftIndex])
        }
      }

      left = next
    }

    // If this is a filter, return the list.  If it’s a lookup, we didn’t find
    // a match, so return `undefined`.
    return filter ? matches : undefined
  }
}

// Validate tags or ranges, and cast them to arrays.
function cast(values, name) {
  var value = values && typeof values === 'string' ? [values] : values

  if (!value || typeof value !== 'object' || !('length' in value)) {
    throw new Error(
      'Invalid ' + name + ' `' + value + '`, expected non-empty string'
    )
  }

  return value
}


/***/ }),

/***/ 19377:
/***/ (function(module) {

module.exports = {
	trueFunc: function trueFunc(){
		return true;
	},
	falseFunc: function falseFunc(){
		return false;
	}
};

/***/ }),

/***/ 30816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(24782)
var ieee754 = __webpack_require__(78898)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 60042:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 89372:
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 80301:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var parser_context_1 = __webpack_require__(18777);
var render_1 = __webpack_require__(21941);
var CssSelectorParser = /** @class */ (function () {
    function CssSelectorParser() {
        this.pseudos = {};
        this.attrEqualityMods = {};
        this.ruleNestingOperators = {};
        this.substitutesEnabled = false;
    }
    CssSelectorParser.prototype.registerSelectorPseudos = function () {
        var pseudos = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            pseudos[_i] = arguments[_i];
        }
        for (var _a = 0, pseudos_1 = pseudos; _a < pseudos_1.length; _a++) {
            var pseudo = pseudos_1[_a];
            this.pseudos[pseudo] = 'selector';
        }
        return this;
    };
    CssSelectorParser.prototype.unregisterSelectorPseudos = function () {
        var pseudos = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            pseudos[_i] = arguments[_i];
        }
        for (var _a = 0, pseudos_2 = pseudos; _a < pseudos_2.length; _a++) {
            var pseudo = pseudos_2[_a];
            delete this.pseudos[pseudo];
        }
        return this;
    };
    CssSelectorParser.prototype.registerNumericPseudos = function () {
        var pseudos = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            pseudos[_i] = arguments[_i];
        }
        for (var _a = 0, pseudos_3 = pseudos; _a < pseudos_3.length; _a++) {
            var pseudo = pseudos_3[_a];
            this.pseudos[pseudo] = 'numeric';
        }
        return this;
    };
    CssSelectorParser.prototype.unregisterNumericPseudos = function () {
        var pseudos = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            pseudos[_i] = arguments[_i];
        }
        for (var _a = 0, pseudos_4 = pseudos; _a < pseudos_4.length; _a++) {
            var pseudo = pseudos_4[_a];
            delete this.pseudos[pseudo];
        }
        return this;
    };
    CssSelectorParser.prototype.registerNestingOperators = function () {
        var operators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operators[_i] = arguments[_i];
        }
        for (var _a = 0, operators_1 = operators; _a < operators_1.length; _a++) {
            var operator = operators_1[_a];
            this.ruleNestingOperators[operator] = true;
        }
        return this;
    };
    CssSelectorParser.prototype.unregisterNestingOperators = function () {
        var operators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operators[_i] = arguments[_i];
        }
        for (var _a = 0, operators_2 = operators; _a < operators_2.length; _a++) {
            var operator = operators_2[_a];
            delete this.ruleNestingOperators[operator];
        }
        return this;
    };
    CssSelectorParser.prototype.registerAttrEqualityMods = function () {
        var mods = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            mods[_i] = arguments[_i];
        }
        for (var _a = 0, mods_1 = mods; _a < mods_1.length; _a++) {
            var mod = mods_1[_a];
            this.attrEqualityMods[mod] = true;
        }
        return this;
    };
    CssSelectorParser.prototype.unregisterAttrEqualityMods = function () {
        var mods = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            mods[_i] = arguments[_i];
        }
        for (var _a = 0, mods_2 = mods; _a < mods_2.length; _a++) {
            var mod = mods_2[_a];
            delete this.attrEqualityMods[mod];
        }
        return this;
    };
    CssSelectorParser.prototype.enableSubstitutes = function () {
        this.substitutesEnabled = true;
        return this;
    };
    CssSelectorParser.prototype.disableSubstitutes = function () {
        this.substitutesEnabled = false;
        return this;
    };
    CssSelectorParser.prototype.parse = function (str) {
        return parser_context_1.parseCssSelector(str, 0, this.pseudos, this.attrEqualityMods, this.ruleNestingOperators, this.substitutesEnabled);
    };
    CssSelectorParser.prototype.render = function (path) {
        return render_1.renderEntity(path).trim();
    };
    return CssSelectorParser;
}());
exports.N = CssSelectorParser;


/***/ }),

/***/ 18777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(76517);
function parseCssSelector(str, pos, pseudos, attrEqualityMods, ruleNestingOperators, substitutesEnabled) {
    var l = str.length;
    var chr = '';
    function getStr(quote, escapeTable) {
        var result = '';
        pos++;
        chr = str.charAt(pos);
        while (pos < l) {
            if (chr === quote) {
                pos++;
                return result;
            }
            else if (chr === '\\') {
                pos++;
                chr = str.charAt(pos);
                var esc = void 0;
                if (chr === quote) {
                    result += quote;
                }
                else if ((esc = escapeTable[chr]) !== undefined) {
                    result += esc;
                }
                else if (utils_1.isHex(chr)) {
                    var hex = chr;
                    pos++;
                    chr = str.charAt(pos);
                    while (utils_1.isHex(chr)) {
                        hex += chr;
                        pos++;
                        chr = str.charAt(pos);
                    }
                    if (chr === ' ') {
                        pos++;
                        chr = str.charAt(pos);
                    }
                    result += String.fromCharCode(parseInt(hex, 16));
                    continue;
                }
                else {
                    result += chr;
                }
            }
            else {
                result += chr;
            }
            pos++;
            chr = str.charAt(pos);
        }
        return result;
    }
    function getIdent() {
        var result = '';
        chr = str.charAt(pos);
        while (pos < l) {
            if (utils_1.isIdent(chr)) {
                result += chr;
            }
            else if (chr === '\\') {
                pos++;
                if (pos >= l) {
                    throw Error('Expected symbol but end of file reached.');
                }
                chr = str.charAt(pos);
                if (utils_1.identSpecialChars[chr]) {
                    result += chr;
                }
                else if (utils_1.isHex(chr)) {
                    var hex = chr;
                    pos++;
                    chr = str.charAt(pos);
                    while (utils_1.isHex(chr)) {
                        hex += chr;
                        pos++;
                        chr = str.charAt(pos);
                    }
                    if (chr === ' ') {
                        pos++;
                        chr = str.charAt(pos);
                    }
                    result += String.fromCharCode(parseInt(hex, 16));
                    continue;
                }
                else {
                    result += chr;
                }
            }
            else {
                return result;
            }
            pos++;
            chr = str.charAt(pos);
        }
        return result;
    }
    function skipWhitespace() {
        chr = str.charAt(pos);
        var result = false;
        while (chr === ' ' || chr === "\t" || chr === "\n" || chr === "\r" || chr === "\f") {
            result = true;
            pos++;
            chr = str.charAt(pos);
        }
        return result;
    }
    function parse() {
        var res = parseSelector();
        if (pos < l) {
            throw Error('Rule expected but "' + str.charAt(pos) + '" found.');
        }
        return res;
    }
    function parseSelector() {
        var selector = parseSingleSelector();
        if (!selector) {
            return null;
        }
        var res = selector;
        chr = str.charAt(pos);
        while (chr === ',') {
            pos++;
            skipWhitespace();
            if (res.type !== 'selectors') {
                res = {
                    type: 'selectors',
                    selectors: [selector]
                };
            }
            selector = parseSingleSelector();
            if (!selector) {
                throw Error('Rule expected after ",".');
            }
            res.selectors.push(selector);
        }
        return res;
    }
    function parseSingleSelector() {
        skipWhitespace();
        var selector = {
            type: 'ruleSet'
        };
        var rule = parseRule();
        if (!rule) {
            return null;
        }
        var currentRule = selector;
        while (rule) {
            rule.type = 'rule';
            currentRule.rule = rule;
            currentRule = rule;
            skipWhitespace();
            chr = str.charAt(pos);
            if (pos >= l || chr === ',' || chr === ')') {
                break;
            }
            if (ruleNestingOperators[chr]) {
                var op = chr;
                pos++;
                skipWhitespace();
                rule = parseRule();
                if (!rule) {
                    throw Error('Rule expected after "' + op + '".');
                }
                rule.nestingOperator = op;
            }
            else {
                rule = parseRule();
                if (rule) {
                    rule.nestingOperator = null;
                }
            }
        }
        return selector;
    }
    // @ts-ignore no-overlap
    function parseRule() {
        var rule = null;
        while (pos < l) {
            chr = str.charAt(pos);
            if (chr === '*') {
                pos++;
                (rule = rule || {}).tagName = '*';
            }
            else if (utils_1.isIdentStart(chr) || chr === '\\') {
                (rule = rule || {}).tagName = getIdent();
            }
            else if (chr === '.') {
                pos++;
                rule = rule || {};
                (rule.classNames = rule.classNames || []).push(getIdent());
            }
            else if (chr === '#') {
                pos++;
                (rule = rule || {}).id = getIdent();
            }
            else if (chr === '[') {
                pos++;
                skipWhitespace();
                var attr = {
                    name: getIdent()
                };
                skipWhitespace();
                // @ts-ignore
                if (chr === ']') {
                    pos++;
                }
                else {
                    var operator = '';
                    if (attrEqualityMods[chr]) {
                        operator = chr;
                        pos++;
                        chr = str.charAt(pos);
                    }
                    if (pos >= l) {
                        throw Error('Expected "=" but end of file reached.');
                    }
                    if (chr !== '=') {
                        throw Error('Expected "=" but "' + chr + '" found.');
                    }
                    attr.operator = operator + '=';
                    pos++;
                    skipWhitespace();
                    var attrValue = '';
                    attr.valueType = 'string';
                    // @ts-ignore
                    if (chr === '"') {
                        attrValue = getStr('"', utils_1.doubleQuotesEscapeChars);
                        // @ts-ignore
                    }
                    else if (chr === '\'') {
                        attrValue = getStr('\'', utils_1.singleQuoteEscapeChars);
                        // @ts-ignore
                    }
                    else if (substitutesEnabled && chr === '$') {
                        pos++;
                        attrValue = getIdent();
                        attr.valueType = 'substitute';
                    }
                    else {
                        while (pos < l) {
                            if (chr === ']') {
                                break;
                            }
                            attrValue += chr;
                            pos++;
                            chr = str.charAt(pos);
                        }
                        attrValue = attrValue.trim();
                    }
                    skipWhitespace();
                    if (pos >= l) {
                        throw Error('Expected "]" but end of file reached.');
                    }
                    if (chr !== ']') {
                        throw Error('Expected "]" but "' + chr + '" found.');
                    }
                    pos++;
                    attr.value = attrValue;
                }
                rule = rule || {};
                (rule.attrs = rule.attrs || []).push(attr);
            }
            else if (chr === ':') {
                pos++;
                var pseudoName = getIdent();
                var pseudo = {
                    name: pseudoName
                };
                // @ts-ignore
                if (chr === '(') {
                    pos++;
                    var value = '';
                    skipWhitespace();
                    if (pseudos[pseudoName] === 'selector') {
                        pseudo.valueType = 'selector';
                        value = parseSelector();
                    }
                    else {
                        pseudo.valueType = pseudos[pseudoName] || 'string';
                        // @ts-ignore
                        if (chr === '"') {
                            value = getStr('"', utils_1.doubleQuotesEscapeChars);
                            // @ts-ignore
                        }
                        else if (chr === '\'') {
                            value = getStr('\'', utils_1.singleQuoteEscapeChars);
                            // @ts-ignore
                        }
                        else if (substitutesEnabled && chr === '$') {
                            pos++;
                            value = getIdent();
                            pseudo.valueType = 'substitute';
                        }
                        else {
                            while (pos < l) {
                                if (chr === ')') {
                                    break;
                                }
                                value += chr;
                                pos++;
                                chr = str.charAt(pos);
                            }
                            value = value.trim();
                        }
                        skipWhitespace();
                    }
                    if (pos >= l) {
                        throw Error('Expected ")" but end of file reached.');
                    }
                    if (chr !== ')') {
                        throw Error('Expected ")" but "' + chr + '" found.');
                    }
                    pos++;
                    pseudo.value = value;
                }
                rule = rule || {};
                (rule.pseudos = rule.pseudos || []).push(pseudo);
            }
            else {
                break;
            }
        }
        return rule;
    }
    return parse();
}
exports.parseCssSelector = parseCssSelector;


/***/ }),

/***/ 21941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(76517);
function renderEntity(entity) {
    var res = '';
    switch (entity.type) {
        case 'ruleSet':
            var currentEntity = entity.rule;
            var parts = [];
            while (currentEntity) {
                if (currentEntity.nestingOperator) {
                    parts.push(currentEntity.nestingOperator);
                }
                parts.push(renderEntity(currentEntity));
                currentEntity = currentEntity.rule;
            }
            res = parts.join(' ');
            break;
        case 'selectors':
            res = entity.selectors.map(renderEntity).join(', ');
            break;
        case 'rule':
            if (entity.tagName) {
                if (entity.tagName === '*') {
                    res = '*';
                }
                else {
                    res = utils_1.escapeIdentifier(entity.tagName);
                }
            }
            if (entity.id) {
                res += "#" + utils_1.escapeIdentifier(entity.id);
            }
            if (entity.classNames) {
                res += entity.classNames.map(function (cn) {
                    return "." + (utils_1.escapeIdentifier(cn));
                }).join('');
            }
            if (entity.attrs) {
                res += entity.attrs.map(function (attr) {
                    if ('operator' in attr) {
                        if (attr.valueType === 'substitute') {
                            return "[" + utils_1.escapeIdentifier(attr.name) + attr.operator + "$" + attr.value + "]";
                        }
                        else {
                            return "[" + utils_1.escapeIdentifier(attr.name) + attr.operator + utils_1.escapeStr(attr.value) + "]";
                        }
                    }
                    else {
                        return "[" + utils_1.escapeIdentifier(attr.name) + "]";
                    }
                }).join('');
            }
            if (entity.pseudos) {
                res += entity.pseudos.map(function (pseudo) {
                    if (pseudo.valueType) {
                        if (pseudo.valueType === 'selector') {
                            return ":" + utils_1.escapeIdentifier(pseudo.name) + "(" + renderEntity(pseudo.value) + ")";
                        }
                        else if (pseudo.valueType === 'substitute') {
                            return ":" + utils_1.escapeIdentifier(pseudo.name) + "($" + pseudo.value + ")";
                        }
                        else if (pseudo.valueType === 'numeric') {
                            return ":" + utils_1.escapeIdentifier(pseudo.name) + "(" + pseudo.value + ")";
                        }
                        else {
                            return (":" + utils_1.escapeIdentifier(pseudo.name) +
                                "(" + utils_1.escapeIdentifier(pseudo.value) + ")");
                        }
                    }
                    else {
                        return ":" + utils_1.escapeIdentifier(pseudo.name);
                    }
                }).join('');
            }
            break;
        default:
            throw Error('Unknown entity type: "' + entity.type + '".');
    }
    return res;
}
exports.renderEntity = renderEntity;


/***/ }),

/***/ 76517:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function isIdentStart(c) {
    return (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || (c === '-') || (c === '_');
}
exports.isIdentStart = isIdentStart;
function isIdent(c) {
    return (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || (c >= '0' && c <= '9') || c === '-' || c === '_';
}
exports.isIdent = isIdent;
function isHex(c) {
    return (c >= 'a' && c <= 'f') || (c >= 'A' && c <= 'F') || (c >= '0' && c <= '9');
}
exports.isHex = isHex;
function escapeIdentifier(s) {
    var len = s.length;
    var result = '';
    var i = 0;
    while (i < len) {
        var chr = s.charAt(i);
        if (exports.identSpecialChars[chr]) {
            result += '\\' + chr;
        }
        else {
            if (!(chr === '_' || chr === '-' ||
                (chr >= 'A' && chr <= 'Z') ||
                (chr >= 'a' && chr <= 'z') ||
                (i !== 0 && chr >= '0' && chr <= '9'))) {
                var charCode = chr.charCodeAt(0);
                if ((charCode & 0xF800) === 0xD800) {
                    var extraCharCode = s.charCodeAt(i++);
                    if ((charCode & 0xFC00) !== 0xD800 || (extraCharCode & 0xFC00) !== 0xDC00) {
                        throw Error('UCS-2(decode): illegal sequence');
                    }
                    charCode = ((charCode & 0x3FF) << 10) + (extraCharCode & 0x3FF) + 0x10000;
                }
                result += '\\' + charCode.toString(16) + ' ';
            }
            else {
                result += chr;
            }
        }
        i++;
    }
    return result;
}
exports.escapeIdentifier = escapeIdentifier;
function escapeStr(s) {
    var len = s.length;
    var result = '';
    var i = 0;
    var replacement;
    while (i < len) {
        var chr = s.charAt(i);
        if (chr === '"') {
            chr = '\\"';
        }
        else if (chr === '\\') {
            chr = '\\\\';
        }
        else if ((replacement = exports.strReplacementsRev[chr]) !== undefined) {
            chr = replacement;
        }
        result += chr;
        i++;
    }
    return "\"" + result + "\"";
}
exports.escapeStr = escapeStr;
exports.identSpecialChars = {
    '!': true,
    '"': true,
    '#': true,
    '$': true,
    '%': true,
    '&': true,
    '\'': true,
    '(': true,
    ')': true,
    '*': true,
    '+': true,
    ',': true,
    '.': true,
    '/': true,
    ';': true,
    '<': true,
    '=': true,
    '>': true,
    '?': true,
    '@': true,
    '[': true,
    '\\': true,
    ']': true,
    '^': true,
    '`': true,
    '{': true,
    '|': true,
    '}': true,
    '~': true
};
exports.strReplacementsRev = {
    '\n': '\\n',
    '\r': '\\r',
    '\t': '\\t',
    '\f': '\\f',
    '\v': '\\v'
};
exports.singleQuoteEscapeChars = {
    n: '\n',
    r: '\r',
    t: '\t',
    f: '\f',
    '\\': '\\',
    '\'': '\''
};
exports.doubleQuotesEscapeChars = {
    n: '\n',
    r: '\r',
    t: '\t',
    f: '\f',
    '\\': '\\',
    '"': '"'
};


/***/ }),

/***/ 20406:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 61242:
/***/ (function(module) {

"use strict";


module.exports = direction

var RTL = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC'
var LTR =
  'A-Za-z\u00C0-\u00D6\u00D8-\u00F6' +
  '\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C' +
  '\uFE00-\uFE6F\uFEFD-\uFFFF'

var rtl = new RegExp('^[^' + LTR + ']*[' + RTL + ']')
var ltr = new RegExp('^[^' + RTL + ']*[' + LTR + ']')

function direction(value) {
  value = String(value || '')

  if (rtl.test(value)) {
    return 'rtl'
  }

  if (ltr.test(value)) {
    return 'ltr'
  }

  return 'neutral'
}


/***/ }),

/***/ 89939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var QueryHandler = __webpack_require__(11857);
var each = (__webpack_require__(32458).each);

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ 34711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MediaQuery = __webpack_require__(89939);
var Util = __webpack_require__(32458);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ 11857:
/***/ (function(module) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ 32458:
/***/ (function(module) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ 46076:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(34711);
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 50229:
/***/ (function(module) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),

/***/ 66471:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 84125:
/***/ (function(module) {

"use strict";


var own = {}.hasOwnProperty

module.exports = hasProperty

// Check if `node` has a set `name` property.
function hasProperty(node, name) {
  var props
  var value

  if (!node || !name || typeof node !== 'object' || node.type !== 'element') {
    return false
  }

  props = node.properties
  value = props && own.call(props, name) && props[name]

  return value !== null && value !== undefined && value !== false
}


/***/ }),

/***/ 9690:
/***/ (function(module) {

"use strict";


module.exports = convert

function convert(test) {
  if (typeof test === 'string') {
    return tagNameFactory(test)
  }

  if (test === null || test === undefined) {
    return element
  }

  if (typeof test === 'object') {
    return any(test)
  }

  if (typeof test === 'function') {
    return callFactory(test)
  }

  throw new Error('Expected function, string, or array as test')
}

function convertAll(tests) {
  var length = tests.length
  var index = -1
  var results = []

  while (++index < length) {
    results[index] = convert(tests[index])
  }

  return results
}

function any(tests) {
  var checks = convertAll(tests)
  var length = checks.length

  return matches

  function matches() {
    var index = -1

    while (++index < length) {
      if (checks[index].apply(this, arguments)) {
        return true
      }
    }

    return false
  }
}

// Utility to convert a string a tag name check.
function tagNameFactory(test) {
  return tagName

  function tagName(node) {
    return element(node) && node.tagName === test
  }
}

// Utility to convert a function check.
function callFactory(test) {
  return call

  function call(node) {
    return element(node) && Boolean(test.apply(this, arguments))
  }
}

// Utility to return true if this is an element.
function element(node) {
  return (
    node &&
    typeof node === 'object' &&
    node.type === 'element' &&
    typeof node.tagName === 'string'
  )
}


/***/ }),

/***/ 76643:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var convert = __webpack_require__(9690)

module.exports = isElement

isElement.convert = convert

// Check if if `node` is an `element` and whether it passes the given test.
function isElement(node, test, index, parent, context) {
  var hasParent = parent !== null && parent !== undefined
  var hasIndex = index !== null && index !== undefined
  var check = convert(test)

  if (
    hasIndex &&
    (typeof index !== 'number' || index < 0 || index === Infinity)
  ) {
    throw new Error('Expected positive finite index for child node')
  }

  if (hasParent && (!parent.type || !parent.children)) {
    throw new Error('Expected parent node')
  }

  if (!node || !node.type || typeof node.type !== 'string') {
    return false
  }

  if (hasParent !== hasIndex) {
    throw new Error('Expected both parent and index')
  }

  return check.call(context, node, index, parent)
}


/***/ }),

/***/ 18870:
/***/ (function(module) {

"use strict";


module.exports = parse

var search = /[#.]/g

// Create a hast element from a simple CSS selector.
function parse(selector, defaultTagName) {
  var value = selector || ''
  var name = defaultTagName || 'div'
  var props = {}
  var start = 0
  var subvalue
  var previous
  var match

  while (start < value.length) {
    search.lastIndex = start
    match = search.exec(value)
    subvalue = value.slice(start, match ? match.index : value.length)

    if (subvalue) {
      if (!previous) {
        name = subvalue
      } else if (previous === '#') {
        props.id = subvalue
      } else if (props.className) {
        props.className.push(subvalue)
      } else {
        props.className = [subvalue]
      }

      start += subvalue.length
    }

    if (match) {
      previous = match[0]
      start++
    }
  }

  return {type: 'element', tagName: name, properties: props, children: []}
}


/***/ }),

/***/ 14339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.matches = matches
exports.selectAll = selectAll
exports.select = select

var any = __webpack_require__(58314)
var parse = __webpack_require__(49714)

function matches(selector, node, space) {
  return Boolean(
    any(parse(selector), node, {space: space, one: true, shallow: true})[0]
  )
}

function select(selector, node, space) {
  return any(parse(selector), node, {space: space, one: true})[0] || null
}

function selectAll(selector, node, space) {
  return any(parse(selector), node, {space: space})
}


/***/ }),

/***/ 58314:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = match

var html = __webpack_require__(38724)
var svg = __webpack_require__(83778)
var zwitch = __webpack_require__(18678)
var enter = __webpack_require__(27699)
var nest = __webpack_require__(66992)
var pseudo = __webpack_require__(18293)
var test = __webpack_require__(3998)

var type = zwitch('type', {
  unknown: unknownType,
  invalid: invalidType,
  handlers: {
    selectors: selectors,
    ruleSet: ruleSet,
    rule: rule
  }
})

function match(query, node, state) {
  return query && node ? type(query, node, state) : []
}

function selectors(query, node, state) {
  var collect = collector(state.one)
  var index = -1

  while (++index < query.selectors.length) {
    collect(ruleSet(query.selectors[index], node, state))
  }

  return collect.result
}

function ruleSet(query, node, state) {
  return rule(query.rule, node, state)
}

function rule(query, tree, state) {
  var collect = collector(state.one)

  if (state.shallow && query.rule) {
    throw new Error('Expected selector without nesting')
  }

  nest(
    query,
    tree,
    0,
    null,
    configure(query, {
      schema: state.space === 'svg' ? svg : html,
      language: null,
      direction: 'ltr',
      editableOrEditingHost: false,
      scopeElements: tree.type === 'root' ? tree.children : [tree],
      iterator: iterator,
      one: state.one,
      shallow: state.shallow
    })
  )

  return collect.result

  function iterator(query, node, index, parent, state) {
    var exit = enter(state, node)

    if (test(query, node, index, parent, state)) {
      if (query.rule) {
        nest(query.rule, node, index, parent, configure(query.rule, state))
      } else {
        collect(node)
        state.found = true
      }
    }

    exit()
  }

  function configure(query, state) {
    var pseudos = query.pseudos || []
    var index = -1

    while (++index < pseudos.length) {
      if (pseudo.needsIndex.indexOf(pseudos[index].name) > -1) {
        state.index = true
        break
      }
    }

    return state
  }
}

/* istanbul ignore next - Shouldn’t be invoked, all data is handled. */
function unknownType(query) {
  throw new Error('Unknown type `' + query.type + '`')
}

/* istanbul ignore next - Shouldn’t be invoked, parser gives correct data. */
function invalidType() {
  throw new Error('Invalid type')
}

function collector(one) {
  var result = []
  var found

  collect.result = result

  return collect

  // Append elements to array, filtering out duplicates.
  function collect(source) {
    var index = -1

    if ('length' in source) {
      while (++index < source.length) {
        collectOne(source[index])
      }
    } else {
      collectOne(source)
    }

    function collectOne(element) {
      if (one) {
        /* istanbul ignore if - shouldn’t happen, safeguards performance problems. */
        if (found) throw new Error('Cannot collect multiple nodes')
        found = true
      }

      if (result.indexOf(element) < 0) result.push(element)
    }
  }
}


/***/ }),

/***/ 94012:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = match

var commas = __webpack_require__(15492)
var has = __webpack_require__(84125)
var find = __webpack_require__(76285)
var spaces = __webpack_require__(69718)
var zwitch = __webpack_require__(18678)

var handle = zwitch('operator', {
  unknown: unknownOperator,
  invalid: exists,
  handlers: {
    '=': exact,
    '~=': spaceSeparatedList,
    '|=': exactOrPrefix,
    '^=': begins,
    '$=': ends,
    '*=': contains
  }
})

function match(query, node, schema) {
  var attrs = query.attrs
  var index = -1

  while (++index < attrs.length) {
    if (!handle(attrs[index], node, find(schema, attrs[index].name))) return
  }

  return true
}

// `[attr]`
function exists(query, node, info) {
  return has(node, info.property)
}

// `[attr=value]`
function exact(query, node, info) {
  return (
    has(node, info.property) &&
    normalizeValue(node.properties[info.property], info) === query.value
  )
}

// `[attr~=value]`
function spaceSeparatedList(query, node, info) {
  var value = node.properties[info.property]

  return (
    // If this is a comma-separated list, and the query is contained in it, return
    // true.
    (!info.commaSeparated &&
      value &&
      typeof value === 'object' &&
      value.indexOf(query.value) > -1) ||
    // For all other values (including comma-separated lists), return whether this
    // is an exact match.
    (has(node, info.property) && normalizeValue(value, info) === query.value)
  )
}

// `[attr|=value]`
function exactOrPrefix(query, node, info) {
  var value = normalizeValue(node.properties[info.property], info)

  return (
    has(node, info.property) &&
    (value === query.value ||
      (value.slice(0, query.value.length) === query.value &&
        value.charAt(query.value.length) === '-'))
  )
}

// `[attr^=value]`
function begins(query, node, info) {
  return (
    has(node, info.property) &&
    normalizeValue(node.properties[info.property], info).slice(
      0,
      query.value.length
    ) === query.value
  )
}

// `[attr$=value]`
function ends(query, node, info) {
  return (
    has(node, info.property) &&
    normalizeValue(node.properties[info.property], info).slice(
      -query.value.length
    ) === query.value
  )
}

// `[attr*=value]`
function contains(query, node, info) {
  return (
    has(node, info.property) &&
    normalizeValue(node.properties[info.property], info).indexOf(query.value) >
      -1
  )
}

/* istanbul ignore next - Shouldn’t be invoked, Parser throws an error instead. */
function unknownOperator(query) {
  throw new Error('Unknown operator `' + query.operator + '`')
}

// Stringify a hast value back to its HTML form.
function normalizeValue(value, info) {
  if (typeof value === 'number') {
    return String(value)
  }

  if (typeof value === 'boolean') {
    return info.attribute
  }

  if (typeof value === 'object' && 'length' in value) {
    return (info.commaSeparated ? commas.stringify : spaces.stringify)(value)
  }

  return value
}


/***/ }),

/***/ 74855:
/***/ (function(module) {

"use strict";


module.exports = match

function match(query, node) {
  var value = node.properties.className || []
  var index = -1

  while (++index < query.classNames.length) {
    if (value.indexOf(query.classNames[index]) < 0) return
  }

  return true
}


/***/ }),

/***/ 27699:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = enter

var direction = __webpack_require__(61242)
var is = __webpack_require__(76643)
var toString = __webpack_require__(17182)
var svg = __webpack_require__(83778)
var visit = __webpack_require__(1234)

// eslint-disable-next-line complexity
function enter(state, node) {
  var schema = state.schema
  var language = state.language
  var currentDirection = state.direction
  var editableOrEditingHost = state.editableOrEditingHost
  var dirInferred
  var type
  var found
  var lang
  var dir

  if (node.type === 'element') {
    lang = node.properties.xmlLang || node.properties.lang
    type = node.properties.type || 'text'
    dir = dirProperty(node)

    if (lang != null) {
      state.language = lang
      found = true
    }

    if (schema.space === 'html') {
      if (node.properties.contentEditable === 'true') {
        state.editableOrEditingHost = true
        found = true
      }

      if (is(node, 'svg')) {
        state.schema = svg
        found = true
      }

      // See: <https://html.spec.whatwg.org/#the-directionality>.
      // Explicit `[dir=rtl]`.
      if (dir === 'rtl') {
        dirInferred = dir
      } else if (
        // Explicit `[dir=ltr]`.
        dir === 'ltr' ||
        // HTML with an invalid or no `[dir]`.
        (dir !== 'auto' && is(node, 'html')) ||
        // `input[type=tel]` with an invalid or no `[dir]`.
        (dir !== 'auto' && is(node, 'input') && type === 'tel')
      ) {
        dirInferred = 'ltr'
        // `[dir=auto]` or `bdi` with an invalid or no `[dir]`.
      } else if (dir === 'auto' || is(node, 'bdi')) {
        if (is(node, 'textarea')) {
          // Check contents of `<textarea>`.
          dirInferred = dirBidi(toString(node))
        } else if (
          is(node, 'input') &&
          (type === 'email' ||
            type === 'search' ||
            type === 'tel' ||
            type === 'text')
        ) {
          // Check value of `<input>`.
          dirInferred = node.properties.value
            ? dirBidi(node.properties.value)
            : 'ltr'
        } else {
          // Check text nodes in `node`.
          visit(node, inferDirectionality)
        }
      }

      if (dirInferred) {
        state.direction = dirInferred
        found = true
      }
    }
    // Turn off editing mode in non-HTML spaces.
    else if (state.editableOrEditingHost) {
      state.editableOrEditingHost = false
      found = true
    }
  }

  return found ? reset : noop

  function reset() {
    state.schema = schema
    state.language = language
    state.direction = currentDirection
    state.editableOrEditingHost = editableOrEditingHost
  }

  function inferDirectionality(child) {
    if (child.type === 'text') {
      dirInferred = dirBidi(child.value)
      return dirInferred ? visit.EXIT : null
    }

    if (
      child !== node &&
      (is(child, ['bdi', 'script', 'style', 'textare']) || dirProperty(child))
    ) {
      return visit.SKIP
    }
  }
}

function dirBidi(value) {
  var result = direction(value)
  return result === 'neutral' ? null : result
}

function dirProperty(node) {
  var value =
    typeof node.properties.dir === 'string'
      ? node.properties.dir.toLowerCase()
      : null
  return value === 'auto' || value === 'ltr' || value === 'rtl' ? value : null
}

function noop() {}


/***/ }),

/***/ 33966:
/***/ (function(module) {

"use strict";


module.exports = match

function match(query, node) {
  return node.properties.id === query.id
}


/***/ }),

/***/ 59259:
/***/ (function(module) {

"use strict";


module.exports = match

function match(query, node) {
  return query.tagName === '*' || query.tagName === node.tagName
}


/***/ }),

/***/ 66992:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = match

var zwitch = __webpack_require__(18678)
var enter = __webpack_require__(27699)

var own = {}.hasOwnProperty

var handle = zwitch('nestingOperator', {
  unknown: unknownNesting,
  invalid: topScan, // `undefined` is the top query selector.
  handlers: {
    null: descendant, // `null` is the descendant combinator.
    '>': child,
    '+': nextSibling,
    '~': subsequentSibling
  }
})

function match(query, node, index, parent, state) {
  return handle(query, node, index, parent, state)
}

/* istanbul ignore next - Shouldn’t be invoked, parser gives correct data. */
function unknownNesting(query) {
  throw new Error('Unexpected nesting `' + query.nestingOperator + '`')
}

function topScan(query, node, index, parent, state) {
  /* istanbul ignore if - Shouldn’t happen. */
  if (parent) {
    throw new Error('topScan is supposed to be called from the root node')
  }

  state.iterator.apply(null, arguments)

  if (!state.shallow) descendant.apply(null, arguments)
}

function descendant(query, node, index, parent, state) {
  var previous = state.iterator

  state.iterator = iterator

  child.apply(this, arguments)

  function iterator(_, node, index, parent, state) {
    state.iterator = previous
    previous.apply(this, arguments)
    state.iterator = iterator

    if (state.one && state.found) return

    child.call(this, query, node, index, parent, state)
  }
}

function child(query, node, index, parent, state) {
  if (!node.children || !node.children.length) return
  indexedSearch(query, node, state)
}

function nextSibling(query, node, index, parent, state) {
  /* istanbul ignore if - Shouldn’t happen. */
  if (!parent) return
  indexedSearch(query, parent, state, index + 1, true)
}

function subsequentSibling(query, node, index, parent, state) {
  /* istanbul ignore if - Shouldn’t happen. */
  if (!parent) return

  indexedSearch(query, parent, state, index + 1)
}

// Handles `typeIndex` and `typeCount` properties for every walker.
function indexedSearch(query, parent, state, from, firstElementOnly) {
  var handle = state.index ? delay : add
  var children = parent.children
  var types = {}
  var delayed = []
  var elements = 0
  var index = -1

  // Start looking at `from`
  if (from == null) from = 0

  // Exit if there are no further nodes.
  if (from >= children.length) return

  // If we need to index for types, do so for all elements before `from`.
  if (state.index) {
    while (++index < from) {
      if (children[index].type === 'element') count(children[index].tagName)
    }
  }

  index = from - 1

  while (++index < children.length) {
    // Only check elements.
    // Check either all elements, or only check the first sibling
    if (children[index].type === 'element') {
      handle(children[index], index)

      // Stop if we’re looking for one node and it’s already found.
      if (state.one && state.found) return
      if (firstElementOnly) break
    }
  }

  if (state.index) {
    index = -1

    while (++index < delayed.length) {
      delayed[index]()
      if (state.one && state.found) return
    }
  }

  function delay(node, childIndex) {
    var elementsBefore = elements
    var elementsByTypeBefore = own.call(types, node.tagName)
      ? types[node.tagName]
      : 0

    count(node.tagName)

    delayed.push(fn)

    function fn() {
      // Before counting further elements:
      state.elementIndex = elementsBefore
      state.typeIndex = elementsByTypeBefore

      // After counting all elements.
      state.elementCount = elements
      state.typeCount = types[node.tagName]

      add(node, childIndex)
    }
  }

  function add(node, childIndex) {
    var exit = enter(state, node)
    state.iterator(query, node, childIndex, parent, state)
    exit()
  }

  function count(name) {
    if (!own.call(types, name)) types[name] = 0
    elements++
    types[name]++
  }
}


/***/ }),

/***/ 49714:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = parse

var Parser = (__webpack_require__(80301)/* .CssSelectorParser */ .N)
var nthCheck = (__webpack_require__(80364)/* ["default"] */ .ZP)
var zwitch = __webpack_require__(18678)

var nth = ['nth-child', 'nth-last-child', 'nth-of-type', 'nth-last-of-type']

var parser = new Parser()

var compile = zwitch('type', {
  handlers: {
    selectors: selectors,
    ruleSet: ruleSet,
    rule: rule
  }
})

parser.registerAttrEqualityMods('~', '|', '^', '$', '*')
parser.registerSelectorPseudos('any', 'matches', 'not', 'has')
parser.registerNestingOperators('>', '+', '~')

function parse(selector) {
  if (typeof selector !== 'string') {
    throw new Error('Expected `string` as selector, not `' + selector + '`')
  }

  return compile(parser.parse(selector))
}

function selectors(query) {
  var selectors = query.selectors
  var index = -1

  while (++index < selectors.length) {
    compile(selectors[index])
  }

  return query
}

function ruleSet(query) {
  return rule(query.rule)
}

function rule(query) {
  var pseudos = query.pseudos || []
  var index = -1
  var pseudo

  while (++index < pseudos.length) {
    pseudo = pseudos[index]

    if (nth.indexOf(pseudo.name) > -1) {
      pseudo.value = nthCheck(pseudo.value)
      pseudo.valueType = 'function'
    }
  }

  compile(query.rule)

  return query
}


/***/ }),

/***/ 18293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = match

var bcp47Match = __webpack_require__(72326)
var commaSeparated = __webpack_require__(15492)
var has = __webpack_require__(84125)
var is = __webpack_require__(76643)
var whitespace = __webpack_require__(24194)
var not = __webpack_require__(25608)
var zwitch = __webpack_require__(18678)
var anything = __webpack_require__(58314)

var handle = zwitch('name', {
  unknown: unknownPseudo,
  invalid: invalidPseudo,
  handlers: {
    any: matches,
    'any-link': anyLink,
    blank: blank,
    checked: checked,
    dir: dir,
    disabled: disabled,
    empty: empty,
    enabled: not(disabled),
    'first-child': firstChild,
    'first-of-type': firstOfType,
    has: hasSelector,
    lang: lang,
    'last-child': lastChild,
    'last-of-type': lastOfType,
    matches: matches,
    not: not(matches),
    'nth-child': nthChild,
    'nth-last-child': nthLastChild,
    'nth-of-type': nthOfType,
    'nth-last-of-type': nthLastOfType,
    'only-child': onlyChild,
    'only-of-type': onlyOfType,
    optional: not(required),
    'read-only': not(readWrite),
    'read-write': readWrite,
    required: required,
    root: root,
    scope: scope
  }
})

match.needsIndex = [
  'first-child',
  'first-of-type',
  'last-child',
  'last-of-type',
  'nth-child',
  'nth-last-child',
  'nth-of-type',
  'nth-last-of-type',
  'only-child',
  'only-of-type'
]

function match(query, node, index, parent, state) {
  var pseudos = query.pseudos
  var offset = -1

  while (++offset < pseudos.length) {
    if (!handle(pseudos[offset], node, index, parent, state)) return
  }

  return true
}

function matches(query, node, index, parent, state) {
  var shallow = state.shallow
  var one = state.one
  var result

  state.shallow = true
  state.one = true

  result = anything(query.value, node, state)[0] === node

  state.shallow = shallow
  state.one = one

  return result
}

function anyLink(query, node) {
  return is(node, ['a', 'area', 'link']) && has(node, 'href')
}

function checked(query, node) {
  if (is(node, ['input', 'menuitem'])) {
    return (
      (node.properties.type === 'checkbox' ||
        node.properties.type === 'radio') &&
      has(node, 'checked')
    )
  }

  if (is(node, 'option')) return has(node, 'selected')
}

function dir(query, node, index, parent, state) {
  return state.direction === query.value
}

function disabled(query, node) {
  return (
    is(node, [
      'button',
      'input',
      'select',
      'textarea',
      'optgroup',
      'option',
      'menuitem',
      'fieldset'
    ]) && has(node, 'disabled')
  )
}

function required(query, node) {
  return is(node, ['input', 'textarea', 'select']) && has(node, 'required')
}

function readWrite(query, node, index, parent, state) {
  return is(node, ['input', 'textarea'])
    ? !has(node, 'readOnly') && !has(node, 'disabled')
    : state.editableOrEditingHost
}

function root(query, node, index, parent, state) {
  return (
    (!parent || parent.type === 'root') &&
    (state.schema.space === 'html' || state.schema.space === 'svg') &&
    is(node, ['html', 'svg'])
  )
}

function scope(query, node, index, parent, state) {
  return is(node) && state.scopeElements.indexOf(node) > -1
}

function empty(query, node) {
  return !someChildren(node, check)

  function check(child) {
    return child.type === 'element' || child.type === 'text'
  }
}

function blank(query, node) {
  return !someChildren(node, check)

  function check(child) {
    return (
      child.type === 'element' || (child.type === 'text' && !whitespace(child))
    )
  }
}

function firstChild(query, node, index, parent, state) {
  assertDeep(state, query)
  return state.elementIndex === 0
}

function lang(query, node, index, parent, state) {
  return (
    state.language !== '' &&
    state.language != null &&
    bcp47Match.extendedFilter(state.language, commaSeparated.parse(query.value))
      .length
  )
}

function lastChild(query, node, index, parent, state) {
  assertDeep(state, query)
  return state.elementIndex === state.elementCount - 1
}

function onlyChild(query, node, index, parent, state) {
  assertDeep(state, query)
  return state.elementCount === 1
}

function nthChild(query, node, index, parent, state) {
  assertDeep(state, query)
  return query.value(state.elementIndex)
}

function nthLastChild(query, node, index, parent, state) {
  assertDeep(state, query)
  return query.value(state.elementCount - state.elementIndex - 1)
}

function nthOfType(query, node, index, parent, state) {
  assertDeep(state, query)
  return query.value(state.typeIndex)
}

function nthLastOfType(query, node, index, parent, state) {
  assertDeep(state, query)
  return query.value(state.typeCount - 1 - state.typeIndex)
}

function firstOfType(query, node, index, parent, state) {
  assertDeep(state, query)
  return state.typeIndex === 0
}

function lastOfType(query, node, index, parent, state) {
  assertDeep(state, query)
  return state.typeIndex === state.typeCount - 1
}

function onlyOfType(query, node, index, parent, state) {
  assertDeep(state, query)
  return state.typeCount === 1
}

function someChildren(node, check) {
  var children = node.children
  var index = -1

  while (++index < children.length) {
    if (check(children[index])) return true
  }
}

/* istanbul ignore next - Shouldn’t be invoked, parser gives correct data. */
function invalidPseudo() {
  throw new Error('Invalid pseudo-selector')
}

function unknownPseudo(query) {
  if (query.name) {
    throw new Error('Unknown pseudo-selector `' + query.name + '`')
  }

  throw new Error('Unexpected pseudo-element or empty pseudo-class')
}

function assertDeep(state, query) {
  if (state.shallow) {
    throw new Error('Cannot use `:' + query.name + '` without parent')
  }
}

function hasSelector(query, node, index, parent, state) {
  var shallow = state.shallow
  var one = state.one
  var scopeElements = state.scopeElements
  var value = appendScope(query.value)
  var result

  state.shallow = false
  state.one = true
  state.scopeElements = [node]

  result = anything(value, node, state)[0]

  state.shallow = shallow
  state.one = one
  state.scopeElements = scopeElements

  return result
}

function appendScope(value) {
  var selector =
    value.type === 'ruleSet' ? {type: 'selectors', selectors: [value]} : value
  var index = -1
  var rule

  while (++index < selector.selectors.length) {
    rule = selector.selectors[index].rule
    rule.nestingOperator = null

    if (
      !rule.pseudos ||
      rule.pseudos.length !== 1 ||
      rule.pseudos[0].name !== 'scope'
    ) {
      selector.selectors[index] = {
        type: 'rule',
        rule: rule,
        pseudos: [{name: 'scope'}]
      }
    }
  }

  return selector
}


/***/ }),

/***/ 3998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = test

var attributes = __webpack_require__(94012)
var classNames = __webpack_require__(74855)
var id = __webpack_require__(33966)
var name = __webpack_require__(59259)
var pseudos = __webpack_require__(18293)

function test(query, node, index, parent, state) {
  return (
    node &&
    node.type === 'element' &&
    (!query.tagName || name(query, node)) &&
    (!query.classNames || classNames(query, node)) &&
    (!query.id || id(query, node)) &&
    (!query.attrs || attributes(query, node, state.schema)) &&
    (!query.pseudos || pseudos(query, node, index, parent, state))
  )
}


/***/ }),

/***/ 15492:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.parse = parse
exports.stringify = stringify

var comma = ','
var space = ' '
var empty = ''

// Parse comma-separated tokens to an array.
function parse(value) {
  var values = []
  var input = String(value || empty)
  var index = input.indexOf(comma)
  var lastIndex = 0
  var end = false
  var val

  while (!end) {
    if (index === -1) {
      index = input.length
      end = true
    }

    val = input.slice(lastIndex, index).trim()

    if (val || !end) {
      values.push(val)
    }

    lastIndex = index + 1
    index = input.indexOf(comma, lastIndex)
  }

  return values
}

// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function stringify(values, options) {
  var settings = options || {}
  var left = settings.padLeft === false ? empty : space
  var right = settings.padRight ? space : empty

  // Ensure the last empty entry is seen.
  if (values[values.length - 1] === empty) {
    values = values.concat(empty)
  }

  return values.join(right + comma + left).trim()
}


/***/ }),

/***/ 24194:
/***/ (function(module) {

"use strict";


module.exports = interElementWhiteSpace

// HTML white-space expression.
// See <https://html.spec.whatwg.org/#space-character>.
var re = /[ \t\n\f\r]/g

function interElementWhiteSpace(node) {
  var value

  if (node && typeof node === 'object' && node.type === 'text') {
    value = node.value || ''
  } else if (typeof node === 'string') {
    value = node
  } else {
    return false
  }

  return value.replace(re, '') === ''
}


/***/ }),

/***/ 76285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var normalize = __webpack_require__(30487)
var DefinedInfo = __webpack_require__(66389)
var Info = __webpack_require__(60210)

var data = 'data'

module.exports = find

var valid = /^data[-\w.:]+$/i
var dash = /-[a-z]/g
var cap = /[A-Z]/g

function find(schema, value) {
  var normal = normalize(value)
  var prop = value
  var Type = Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      prop = datasetToProperty(value)
    } else {
      value = datasetToAttribute(value)
    }

    Type = DefinedInfo
  }

  return new Type(prop, value)
}

function datasetToProperty(attribute) {
  var value = attribute.slice(5).replace(dash, camelcase)
  return data + value.charAt(0).toUpperCase() + value.slice(1)
}

function datasetToAttribute(property) {
  var value = property.slice(4)

  if (dash.test(value)) {
    return property
  }

  value = value.replace(cap, kebab)

  if (value.charAt(0) !== '-') {
    value = '-' + value
  }

  return data + value
}

function kebab($0) {
  return '-' + $0.toLowerCase()
}

function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}


/***/ }),

/***/ 38724:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__(77476)
var xlink = __webpack_require__(24256)
var xml = __webpack_require__(77000)
var xmlns = __webpack_require__(55158)
var aria = __webpack_require__(93265)
var html = __webpack_require__(53597)

module.exports = merge([xml, xlink, xmlns, aria, html])


/***/ }),

/***/ 93265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var types = __webpack_require__(47731)
var create = __webpack_require__(10955)

var booleanish = types.booleanish
var number = types.number
var spaceSeparated = types.spaceSeparated

module.exports = create({
  transform: ariaTransform,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
})

function ariaTransform(_, prop) {
  return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
}


/***/ }),

/***/ 53597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var types = __webpack_require__(47731)
var create = __webpack_require__(10955)
var caseInsensitiveTransform = __webpack_require__(77753)

var boolean = types.boolean
var overloadedBoolean = types.overloadedBoolean
var booleanish = types.booleanish
var number = types.number
var spaceSeparated = types.spaceSeparated
var commaSeparated = types.commaSeparated

module.exports = create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    capture: boolean,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: commaSeparated,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextMenu: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: commaSeparated,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: boolean, // Lists. Use CSS to reduce space between items instead
    declare: boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: boolean, // `<frame>`
    noHref: boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
})


/***/ }),

/***/ 70437:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var types = __webpack_require__(47731)
var create = __webpack_require__(10955)
var caseSensitiveTransform = __webpack_require__(33781)

var boolean = types.boolean
var number = types.number
var spaceSeparated = types.spaceSeparated
var commaSeparated = types.commaSeparated
var commaOrSpaceSeparated = types.commaOrSpaceSeparated

module.exports = create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
})


/***/ }),

/***/ 77753:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var caseSensitiveTransform = __webpack_require__(33781)

module.exports = caseInsensitiveTransform

function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}


/***/ }),

/***/ 33781:
/***/ (function(module) {

"use strict";


module.exports = caseSensitiveTransform

function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}


/***/ }),

/***/ 10955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var normalize = __webpack_require__(30487)
var Schema = __webpack_require__(86788)
var DefinedInfo = __webpack_require__(66389)

module.exports = create

function create(definition) {
  var space = definition.space
  var mustUseProperty = definition.mustUseProperty || []
  var attributes = definition.attributes || {}
  var props = definition.properties
  var transform = definition.transform
  var property = {}
  var normal = {}
  var prop
  var info

  for (prop in props) {
    info = new DefinedInfo(
      prop,
      transform(attributes, prop),
      props[prop],
      space
    )

    if (mustUseProperty.indexOf(prop) !== -1) {
      info.mustUseProperty = true
    }

    property[prop] = info

    normal[normalize(prop)] = prop
    normal[normalize(info.attribute)] = prop
  }

  return new Schema(property, normal, space)
}


/***/ }),

/***/ 66389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Info = __webpack_require__(60210)
var types = __webpack_require__(47731)

module.exports = DefinedInfo

DefinedInfo.prototype = new Info()
DefinedInfo.prototype.defined = true

var checks = [
  'boolean',
  'booleanish',
  'overloadedBoolean',
  'number',
  'commaSeparated',
  'spaceSeparated',
  'commaOrSpaceSeparated'
]
var checksLength = checks.length

function DefinedInfo(property, attribute, mask, space) {
  var index = -1
  var check

  mark(this, 'space', space)

  Info.call(this, property, attribute)

  while (++index < checksLength) {
    check = checks[index]
    mark(this, check, (mask & types[check]) === types[check])
  }
}

function mark(values, key, value) {
  if (value) {
    values[key] = value
  }
}


/***/ }),

/***/ 60210:
/***/ (function(module) {

"use strict";


module.exports = Info

var proto = Info.prototype

proto.space = null
proto.attribute = null
proto.property = null
proto.boolean = false
proto.booleanish = false
proto.overloadedBoolean = false
proto.number = false
proto.commaSeparated = false
proto.spaceSeparated = false
proto.commaOrSpaceSeparated = false
proto.mustUseProperty = false
proto.defined = false

function Info(property, attribute) {
  this.property = property
  this.attribute = attribute
}


/***/ }),

/***/ 77476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(49720)
var Schema = __webpack_require__(86788)

module.exports = merge

function merge(definitions) {
  var length = definitions.length
  var property = []
  var normal = []
  var index = -1
  var info
  var space

  while (++index < length) {
    info = definitions[index]
    property.push(info.property)
    normal.push(info.normal)
    space = info.space
  }

  return new Schema(
    xtend.apply(null, property),
    xtend.apply(null, normal),
    space
  )
}


/***/ }),

/***/ 86788:
/***/ (function(module) {

"use strict";


module.exports = Schema

var proto = Schema.prototype

proto.space = null
proto.normal = {}
proto.property = {}

function Schema(property, normal, space) {
  this.property = property
  this.normal = normal

  if (space) {
    this.space = space
  }
}


/***/ }),

/***/ 47731:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


var powers = 0

exports.boolean = increment()
exports.booleanish = increment()
exports.overloadedBoolean = increment()
exports.number = increment()
exports.spaceSeparated = increment()
exports.commaSeparated = increment()
exports.commaOrSpaceSeparated = increment()

function increment() {
  return Math.pow(2, ++powers)
}


/***/ }),

/***/ 24256:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(10955)

module.exports = create({
  space: 'xlink',
  transform: xlinkTransform,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

function xlinkTransform(_, prop) {
  return 'xlink:' + prop.slice(5).toLowerCase()
}


/***/ }),

/***/ 77000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(10955)

module.exports = create({
  space: 'xml',
  transform: xmlTransform,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
})

function xmlTransform(_, prop) {
  return 'xml:' + prop.slice(3).toLowerCase()
}


/***/ }),

/***/ 55158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(10955)
var caseInsensitiveTransform = __webpack_require__(77753)

module.exports = create({
  space: 'xmlns',
  attributes: {
    xmlnsxlink: 'xmlns:xlink'
  },
  transform: caseInsensitiveTransform,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
})


/***/ }),

/***/ 30487:
/***/ (function(module) {

"use strict";


module.exports = normalize

function normalize(value) {
  return value.toLowerCase()
}


/***/ }),

/***/ 83778:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__(77476)
var xlink = __webpack_require__(24256)
var xml = __webpack_require__(77000)
var xmlns = __webpack_require__(55158)
var aria = __webpack_require__(93265)
var svg = __webpack_require__(70437)

module.exports = merge([xml, xlink, xmlns, aria, svg])


/***/ }),

/***/ 69718:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.parse = parse
exports.stringify = stringify

var empty = ''
var space = ' '
var whiteSpace = /[ \t\n\r\f]+/g

function parse(value) {
  var input = String(value || empty).trim()
  return input === empty ? [] : input.split(whiteSpace)
}

function stringify(values) {
  return values.join(space).trim()
}


/***/ }),

/***/ 66880:
/***/ (function(module) {

"use strict";


module.exports = convert

function convert(test) {
  if (test == null) {
    return ok
  }

  if (typeof test === 'string') {
    return typeFactory(test)
  }

  if (typeof test === 'object') {
    return 'length' in test ? anyFactory(test) : allFactory(test)
  }

  if (typeof test === 'function') {
    return test
  }

  throw new Error('Expected function, string, or object as test')
}

// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function allFactory(test) {
  return all

  function all(node) {
    var key

    for (key in test) {
      if (node[key] !== test[key]) return false
    }

    return true
  }
}

function anyFactory(tests) {
  var checks = []
  var index = -1

  while (++index < tests.length) {
    checks[index] = convert(tests[index])
  }

  return any

  function any() {
    var index = -1

    while (++index < checks.length) {
      if (checks[index].apply(this, arguments)) {
        return true
      }
    }

    return false
  }
}

// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
  return type

  function type(node) {
    return Boolean(node && node.type === test)
  }
}

// Utility to return true.
function ok() {
  return true
}


/***/ }),

/***/ 73695:
/***/ (function(module) {

module.exports = identity
function identity(d) {
  return d
}


/***/ }),

/***/ 85857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = visitParents

var convert = __webpack_require__(66880)
var color = __webpack_require__(73695)

var CONTINUE = true
var SKIP = 'skip'
var EXIT = false

visitParents.CONTINUE = CONTINUE
visitParents.SKIP = SKIP
visitParents.EXIT = EXIT

function visitParents(tree, test, visitor, reverse) {
  var step
  var is

  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  is = convert(test)
  step = reverse ? -1 : 1

  factory(tree, null, [])()

  function factory(node, index, parents) {
    var value = typeof node === 'object' && node !== null ? node : {}
    var name

    if (typeof value.type === 'string') {
      name =
        typeof value.tagName === 'string'
          ? value.tagName
          : typeof value.name === 'string'
          ? value.name
          : undefined

      visit.displayName =
        'node (' + color(value.type + (name ? '<' + name + '>' : '')) + ')'
    }

    return visit

    function visit() {
      var grandparents = parents.concat(node)
      var result = []
      var subresult
      var offset

      if (!test || is(node, index, parents[parents.length - 1] || null)) {
        result = toResult(visitor(node, parents))

        if (result[0] === EXIT) {
          return result
        }
      }

      if (node.children && result[0] !== SKIP) {
        offset = (reverse ? node.children.length : -1) + step

        while (offset > -1 && offset < node.children.length) {
          subresult = factory(node.children[offset], offset, grandparents)()

          if (subresult[0] === EXIT) {
            return subresult
          }

          offset =
            typeof subresult[1] === 'number' ? subresult[1] : offset + step
        }
      }

      return result
    }
  }
}

function toResult(value) {
  if (value !== null && typeof value === 'object' && 'length' in value) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}


/***/ }),

/***/ 1234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = visit

var visitParents = __webpack_require__(85857)

var CONTINUE = visitParents.CONTINUE
var SKIP = visitParents.SKIP
var EXIT = visitParents.EXIT

visit.CONTINUE = CONTINUE
visit.SKIP = SKIP
visit.EXIT = EXIT

function visit(tree, test, visitor, reverse) {
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  visitParents(tree, test, overload, reverse)

  function overload(node, parents) {
    var parent = parents[parents.length - 1]
    var index = parent ? parent.children.indexOf(node) : null
    return visitor(node, index, parent)
  }
}


/***/ }),

/***/ 18678:
/***/ (function(module) {

"use strict";


module.exports = factory

var noop = Function.prototype
var own = {}.hasOwnProperty

// Handle values based on a property.
function factory(key, options) {
  var settings = options || {}

  function one(value) {
    var fn = one.invalid
    var handlers = one.handlers

    if (value && own.call(value, key)) {
      fn = own.call(handlers, value[key]) ? handlers[value[key]] : one.unknown
    }

    return (fn || noop).apply(this, arguments)
  }

  one.handlers = settings.handlers || {}
  one.invalid = settings.invalid
  one.unknown = settings.unknown

  return one
}


/***/ }),

/***/ 17182:
/***/ (function(module) {

"use strict";
/**
 * @fileoverview
 *   Get the plain-text value of a hast node.
 * @longdescription
 *   ## Use
 *
 *   ```js
 *   var h = require('hastscript')
 *   var toString = require('hast-util-to-string')
 *
 *   toString(h('p', 'Alpha'))
 *   //=> 'Alpha'
 *   toString(h('div', [h('b', 'Bold'), ' and ', h('i', 'italic'), '.']))
 *   //=> 'Bold and italic.'
 *   ```
 *
 *   ## API
 *
 *   ### `toString(node)`
 *
 *   Transform a node to a string.
 */



module.exports = toString

function toString(node) {
  // “The concatenation of data of all the Text node descendants of the context
  // object, in tree order.”
  if ('children' in node) {
    return all(node)
  }

  // “Context object’s data.”
  return 'value' in node ? node.value : ''
}

function one(node) {
  if (node.type === 'text') {
    return node.value
  }

  return node.children ? all(node) : ''
}

function all(node) {
  var children = node.children
  var length = children.length
  var index = -1
  var result = []

  while (++index < length) {
    result[index] = one(children[index])
  }

  return result.join('')
}


/***/ }),

/***/ 27207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const isObject = __webpack_require__(83710)

function humanizeGraphQLResponse (input) {
  if (!input) return null
  const output = {}

  Object.keys(input).forEach(key => {
    if (input[key] && input[key].edges) {
      output[key] = input[key].edges.map(edge => humanizeGraphQLResponse(edge.node))
    } else if (isObject(input[key])) {
      output[key] = humanizeGraphQLResponse(input[key])
    } else {
      output[key] = input[key]
    }
  })

  return output
}

module.exports = humanizeGraphQLResponse


/***/ }),

/***/ 83710:
/***/ (function(module) {

module.exports = function isObject (obj) {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj)
}


/***/ }),

/***/ 78898:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 3812:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 48809:
/***/ (function(module) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),

/***/ 84447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(42572);
module.exports = self.fetch.bind(self);


/***/ }),

/***/ 99857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(31533);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 33198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 62004:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;


/***/ }),

/***/ 18425:
/***/ (function(module) {

(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=undefined;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=undefined;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
module.exports = function(forceSimilar) {
	if (typeof Map !== 'function' || forceSimilar) {
		var Similar = _dereq_('./similar');
		return new Similar();
	}
	else {
		return new Map();
	}
}

},{"./similar":2}],2:[function(_dereq_,module,exports){
function Similar() {
	this.list = [];
	this.lastItem = undefined;
	this.size = 0;

	return this;
}

Similar.prototype.get = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		return this.lastItem.val;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		return this.list[index].val;
	}

	return undefined;
};

Similar.prototype.set = function(key, val) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		this.lastItem.val = val;
		return this;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		this.list[index].val = val;
		return this;
	}

	this.lastItem = { key: key, val: val };
	this.list.push(this.lastItem);
	this.size++;

	return this;
};

Similar.prototype.delete = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		this.lastItem = undefined;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.size--;
		return this.list.splice(index, 1)[0];
	}

	return undefined;
};


// important that has() doesn't use get() in case an existing key has a falsy value, in which case has() would return false
Similar.prototype.has = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		return true;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		return true;
	}

	return false;
};

Similar.prototype.forEach = function(callback, thisArg) {
	var i;
	for (i = 0; i < this.size; i++) {
		callback.call(thisArg || this, this.list[i].val, this.list[i].key, this);
	}
};

Similar.prototype.indexOf = function(key) {
	var i;
	for (i = 0; i < this.size; i++) {
		if (this.isEqual(this.list[i].key, key)) {
			return i;
		}
	}
	return -1;
};

// check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
Similar.prototype.isEqual = function(val1, val2) {
	return val1 === val2 || (val1 !== val1 && val2 !== val2);
};

module.exports = Similar;
},{}],3:[function(_dereq_,module,exports){
var MapOrSimilar = _dereq_('map-or-similar');

module.exports = function (limit) {
	var cache = new MapOrSimilar(undefined === 'true'),
		lru = [];

	return function (fn) {
		var memoizerific = function () {
			var currentCache = cache,
				newMap,
				fnResult,
				argsLengthMinusOne = arguments.length - 1,
				lruPath = Array(argsLengthMinusOne + 1),
				isMemoized = true,
				i;

			if ((memoizerific.numArgs || memoizerific.numArgs === 0) && memoizerific.numArgs !== argsLengthMinusOne + 1) {
				throw new Error('Memoizerific functions should always be called with the same number of arguments');
			}

			// loop through each argument to traverse the map tree
			for (i = 0; i < argsLengthMinusOne; i++) {
				lruPath[i] = {
					cacheItem: currentCache,
					arg: arguments[i]
				};

				// climb through the hierarchical map tree until the second-last argument has been found, or an argument is missing.
				// if all arguments up to the second-last have been found, this will potentially be a cache hit (determined later)
				if (currentCache.has(arguments[i])) {
					currentCache = currentCache.get(arguments[i]);
					continue;
				}

				isMemoized = false;

				// make maps until last value
				newMap = new MapOrSimilar(undefined === 'true');
				currentCache.set(arguments[i], newMap);
				currentCache = newMap;
			}

			// we are at the last arg, check if it is really memoized
			if (isMemoized) {
				if (currentCache.has(arguments[argsLengthMinusOne])) {
					fnResult = currentCache.get(arguments[argsLengthMinusOne]);
				}
				else {
					isMemoized = false;
				}
			}

			if (!isMemoized) {
				fnResult = fn.apply(null, arguments);
				currentCache.set(arguments[argsLengthMinusOne], fnResult);
			}

			if (limit > 0) {
				lruPath[argsLengthMinusOne] = {
					cacheItem: currentCache,
					arg: arguments[argsLengthMinusOne]
				};

				if (isMemoized) {
					moveToMostRecentLru(lru, lruPath);
				}
				else {
					lru.push(lruPath);
				}

				if (lru.length > limit) {
					removeCachedResult(lru.shift());
				}
			}

			memoizerific.wasMemoized = isMemoized;
			memoizerific.numArgs = argsLengthMinusOne + 1;

			return fnResult;
		};

		memoizerific.limit = limit;
		memoizerific.wasMemoized = false;
		memoizerific.cache = cache;
		memoizerific.lru = lru;

		return memoizerific;
	};
};

// move current args to most recent position
function moveToMostRecentLru(lru, lruPath) {
	var lruLen = lru.length,
		lruPathLen = lruPath.length,
		isMatch,
		i, ii;

	for (i = 0; i < lruLen; i++) {
		isMatch = true;
		for (ii = 0; ii < lruPathLen; ii++) {
			if (!isEqual(lru[i][ii].arg, lruPath[ii].arg)) {
				isMatch = false;
				break;
			}
		}
		if (isMatch) {
			break;
		}
	}

	lru.push(lru.splice(i, 1)[0]);
}

// remove least recently used cache item and all dead branches
function removeCachedResult(removedLru) {
	var removedLruLen = removedLru.length,
		currentLru = removedLru[removedLruLen - 1],
		tmp,
		i;

	currentLru.cacheItem.delete(currentLru.arg);

	// walk down the tree removing dead branches (size 0) along the way
	for (i = removedLruLen - 2; i >= 0; i--) {
		currentLru = removedLru[i];
		tmp = currentLru.cacheItem.get(currentLru.arg);

		if (!tmp || !tmp.size) {
			currentLru.cacheItem.delete(currentLru.arg);
		} else {
			break;
		}
	}
}

// check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
function isEqual(val1, val2) {
	return val1 === val2 || (val1 !== val1 && val2 !== val2);
}
},{"map-or-similar":1}]},{},[3])(3)
});

/***/ }),

/***/ 42572:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* globals self */ exports.Headers = self.Headers;
exports.Request = self.Request;
exports.Response = self.Response;
exports.fetch = self.fetch;

//# sourceMappingURL=whatwg-fetch.js.map

/***/ }),

/***/ 14284:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) === null || ref === void 0 ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) === null || ref1 === void 0 ? void 0 : ref1.env) === 'object' ? __webpack_require__.g.process : __webpack_require__(66118);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6461:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(35980);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iT": function() { return /* reexport */ AccountsAuthLoader; },
  "bg": function() { return /* reexport */ PageErrorBoundary; },
  "yG": function() { return /* reexport */ PageHead; },
  "iA": function() { return /* reexport */ Partytown_Partytown; },
  "UZ": function() { return /* reexport */ PreviewModeToast; },
  "$j": function() { return /* reexport */ Spinner_Spinner; }
});

// UNUSED EXPORTS: RoutingSpinner

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/_components/Spinner.module.css
var Spinner_module = __webpack_require__(70127);
var Spinner_module_default = /*#__PURE__*/__webpack_require__.n(Spinner_module);
;// CONCATENATED MODULE: ./src/_components/Spinner.jsx



function Spinner_Spinner(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (Spinner_module_default()).spinner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.25 3C11.25 2.58579 11.5858 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 10.4448 2.61468 8.97258 3.26388 7.66623C3.44822 7.29529 3.89836 7.14403 4.26929 7.32836C4.64023 7.5127 4.79149 7.96284 4.60716 8.33377C4.05873 9.43734 3.75 10.6815 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C11.5858 3.75 11.25 3.41421 11.25 3Z",
            fill: props.color || "#1F2937"
        })
    });
}

;// CONCATENATED MODULE: ./src/_components/AccountsAuthLoader.jsx



function AccountsAuthLoader(param) {
    var _minHeight = param.minHeight, minHeight = _minHeight === void 0 ? 650 : _minHeight, _width = param.width, width = _width === void 0 ? "100%" : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            margin: 0,
            width: width || "100%",
            minWidth: 0,
            minHeight: minHeight || 650
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                boxSizing: "border-box",
                margin: 0,
                minWidth: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner_Spinner, {})
        })
    });
}

// EXTERNAL MODULE: ../node_modules/react-error-boundary/dist/react-error-boundary.esm.js
var react_error_boundary_esm = __webpack_require__(21906);
// EXTERNAL MODULE: ./src/_components/PageErrorBoundary.module.css
var PageErrorBoundary_module = __webpack_require__(1070);
var PageErrorBoundary_module_default = /*#__PURE__*/__webpack_require__.n(PageErrorBoundary_module);
;// CONCATENATED MODULE: ./src/_components/PageErrorBoundary.jsx




function PageError() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        role: "alert",
        style: {
            margin: 0,
            width: "100%",
            height: "100%",
            minWidth: 0,
            padding: "16px",
            boxSizing: "border-box"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "320px",
                    marginBottom: "24px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "80%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "60%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "60%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "24px",
                    marginBottom: "24px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    gap: "16px",
                    marginBottom: "24px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PageErrorBoundary_module_default()).skeletonBox,
                        style: {
                            width: "100%",
                            height: "100%",
                            aspectRatio: "1 / 1"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PageErrorBoundary_module_default()).skeletonBox,
                        style: {
                            width: "100%",
                            height: "100%",
                            aspectRatio: "1 / 1"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "24px",
                    marginBottom: "24px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "320px",
                    marginBottom: "24px"
                }
            })
        ]
    });
}
function PageErrorBoundary(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_esm.ErrorBoundary, {
        "data-comp": "PageErrorBoundary",
        FallbackComponent: PageError,
        children: children
    });
}

// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/_components/PageHead.jsx
/* provided dependency */ var process = __webpack_require__(14284);



var backpackHeadUserConfig = {};
function PageHead(param) {
    var _page = param.page, page = _page === void 0 ? {} : _page, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var resourceType = (page || {}).resourceType;
    var ref12 = (page === null || page === void 0 ? void 0 : page.seo) || {}, noIndex = ref12.noIndex, noFollow = ref12.noFollow;
    var index = noIndex ? "noindex" : "index";
    var follow = noFollow ? "nofollow" : "follow";
    var pageUrl = "";
    if (resourceType === "home_page") {
        pageUrl = "https://www.briogeohair.com";
    } else if (resourceType === "page") {
        pageUrl = "".concat("https://www.briogeohair.com", "/pages/").concat(page.handle);
    } else if (resourceType === "product_page") {
        pageUrl = "".concat("https://www.briogeohair.com", "/products/").concat(page.handle);
    } else if (resourceType === "collection_page") {
        pageUrl = "".concat("https://www.briogeohair.com", "/collections/").concat(page.handle);
    } else if (resourceType === "article") {
        pageUrl = "".concat("https://www.briogeohair.com", "/articles/").concat(page.handle);
    } else if (resourceType === "blog") {
        pageUrl = "".concat("https://www.briogeohair.com", "/blogs/").concat(page.handle);
    } else {
        pageUrl = "https://www.briogeohair.com";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: page === null || page === void 0 ? void 0 : (ref = page.seo) === null || ref === void 0 ? void 0 : ref.title
                    }, "page-title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: page === null || page === void 0 ? void 0 : (ref1 = page.seo) === null || ref1 === void 0 ? void 0 : ref1.description
                    }, "page-description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: page === null || page === void 0 ? void 0 : (ref2 = page.seo) === null || ref2 === void 0 ? void 0 : ref2.keywords
                    }, "page-keywords"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: pageUrl
                    }, "page-canonical-url"),
                    (page === null || page === void 0 ? void 0 : page.favicon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "shortcut icon",
                        href: page.favicon
                    }) : null,
                    (page === null || page === void 0 ? void 0 : (ref3 = page.seo) === null || ref3 === void 0 ? void 0 : ref3.image) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: page.seo.image
                            }, "page:fb:image"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:alt",
                                content: (page === null || page === void 0 ? void 0 : (ref4 = page.seo) === null || ref4 === void 0 ? void 0 : ref4.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                            }, "page:fb:image:alt"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: page.seo.image
                            }, "page:twitter:image")
                        ]
                    }) : null,
                    process.env.FACEBOOK_APP_ID ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "fb:app_id",
                        content: process.env.FACEBOOK_APP_ID
                    }, "page:fb:app_id") : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }, "page:fb:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }, "page:fb:type"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: (page === null || page === void 0 ? void 0 : (ref5 = page.seo) === null || ref5 === void 0 ? void 0 : ref5.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                    }, "page:fb:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: (page === null || page === void 0 ? void 0 : (ref6 = page.seo) === null || ref6 === void 0 ? void 0 : ref6.description) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.description)
                    }, "page:fb:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:locale",
                        content: backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.locale
                    }, "page:fb:locale"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:author",
                        content: backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.description
                    }, "page:fb:author"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }, "page:twitter:card"),
                    (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : (ref7 = backpackHeadUserConfig.social) === null || ref7 === void 0 ? void 0 : ref7.twitter) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: backpackHeadUserConfig.social.twitter
                    }, "page:twitter:site") : null,
                    (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : (ref8 = backpackHeadUserConfig.social) === null || ref8 === void 0 ? void 0 : ref8.twitter) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: backpackHeadUserConfig.social.twitter
                    }, "page:twitter:creator") : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: pageUrl
                    }, "page:twitter:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: (page === null || page === void 0 ? void 0 : (ref9 = page.seo) === null || ref9 === void 0 ? void 0 : ref9.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                    }, "page:twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: (page === null || page === void 0 ? void 0 : (ref10 = page.seo) === null || ref10 === void 0 ? void 0 : ref10.description) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.description)
                    }, "page:twitter:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: (page === null || page === void 0 ? void 0 : (ref11 = page.seo) === null || ref11 === void 0 ? void 0 : ref11.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                    }, "page:twitter:image:alt"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "".concat(index, ",").concat(follow)
                    }, "default-all-search-engines-crawling"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "googlebot",
                        content: "".concat(index, ",").concat(follow)
                    }, "default-google-engine-crawling")
                ]
            }),
            children
        ]
    });
}

;// CONCATENATED MODULE: ./src/_components/RoutingSpinner.jsx


function RoutingSpinner() {
    return /*#__PURE__*/ _jsx("div", {
        style: {
            width: "100%",
            height: "100%",
            position: "fixed",
            zIndex: "2147483647",
            pointerEvents: "none"
        },
        children: /*#__PURE__*/ _jsx("div", {
            style: {
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#374151cc"
            },
            children: /*#__PURE__*/ _jsx(Spinner, {
                color: "white"
            })
        })
    });
}

;// CONCATENATED MODULE: ../node_modules/@builder.io/partytown/integration/index.mjs
const PartytownSnippet = "/* Partytown 0.8.0 - MIT builder.io */\n!function(t,e,n,i,r,o,a,d,s,c,l,p){function u(){p||(p=1,\"/\"==(a=(o.lib||\"/~partytown/\")+(o.debug?\"debug/\":\"\"))[0]&&(s=e.querySelectorAll('script[type=\"text/partytown\"]'),i!=t?i.dispatchEvent(new CustomEvent(\"pt1\",{detail:t})):(d=setTimeout(f,1e4),e.addEventListener(\"pt0\",w),r?h(1):n.serviceWorker?n.serviceWorker.register(a+(o.swPath||\"partytown-sw.js\"),{scope:a}).then((function(t){t.active?h():t.installing&&t.installing.addEventListener(\"statechange\",(function(t){\"activated\"==t.target.state&&h()}))}),console.error):f())))}function h(t){c=e.createElement(t?\"script\":\"iframe\"),t||(c.setAttribute(\"style\",\"display:block;width:0;height:0;border:0;visibility:hidden\"),c.setAttribute(\"aria-hidden\",!0)),c.src=a+\"partytown-\"+(t?\"atomics.js?v=0.8.0\":\"sandbox-sw.html?\"+Date.now()),e.querySelector(o.sandboxParent||\"body\").appendChild(c)}function f(n,r){for(w(),i==t&&(o.forward||[]).map((function(e){delete t[e.split(\".\")[0]]})),n=0;n<s.length;n++)(r=e.createElement(\"script\")).innerHTML=s[n].innerHTML,e.head.appendChild(r);c&&c.parentNode.removeChild(c)}function w(){clearTimeout(d)}o=t.partytown||{},i==t&&(o.forward||[]).map((function(e){l=t,e.split(\".\").map((function(e,n,i){l=l[i[n]]=n+1<i.length?\"push\"==i[n+1]?[]:l[i[n]]||{}:function(){(t._ptf=t._ptf||[]).push(i,arguments)}}))})),\"complete\"==e.readyState?u():(t.addEventListener(\"DOMContentLoaded\",u),t.addEventListener(\"load\",u))}(window,document,navigator,top,window.crossOriginIsolated);";

const createSnippet = (config, snippetCode) => {
    const { forward = [], ...filteredConfig } = config || {};
    const configStr = JSON.stringify(filteredConfig, (k, v) => {
        if (typeof v === 'function') {
            v = String(v);
            if (v.startsWith(k + '(')) {
                v = 'function ' + v;
            }
        }
        return v;
    });
    return [
        `!(function(w,p,f,c){`,
        Object.keys(filteredConfig).length > 0
            ? `c=w[p]=Object.assign(w[p]||{},${configStr});`
            : `c=w[p]=w[p]||{};`,
        `c[f]=(c[f]||[])`,
        forward.length > 0 ? `.concat(${JSON.stringify(forward)})` : ``,
        `})(window,'partytown','forward');`,
        snippetCode,
    ].join('');
};

/**
 * The `type` attribute for Partytown scripts, which does two things:
 *
 * 1. Prevents the `<script>` from executing on the main thread.
 * 2. Is used as a selector so the Partytown library can find all scripts to execute in a web worker.
 *
 * @public
 */
const SCRIPT_TYPE = (/* unused pure expression or super */ null && (`text/partytown`));

/**
 * Function that returns the Partytown snippet as a string, which can be
 * used as the innerHTML of the inlined Partytown script in the head.
 *
 * @public
 */
const partytownSnippet = (config) => createSnippet(config, PartytownSnippet);



;// CONCATENATED MODULE: ../node_modules/@builder.io/partytown/react/index.mjs



/**
 * The React `<Partytown/>` component should be placed within the `<head>`
 * of the document. This component should work for SSR/SSG only HTML
 * (static HTML without javascript), clientside javascript only
 * (entire React app is build with clientside javascript),
 * and both SSR/SSG HTML that's then hydrated by the client.
 *
 * @public
 */
const Partytown = (props = {}) => {
    // purposely not using useState() or useEffect() so this component
    // can also work as a React Server Component
    // this check is only be done on the client, and skipped over on the server
    if (typeof document !== 'undefined' && !document._partytown) {
        if (!document.querySelector('script[data-partytown]')) {
            // the append script to document code should only run on the client
            // and only if the SSR'd script doesn't already exist within the document.
            // If the SSR'd script isn't found in the document, then this
            // must be a clientside only render. Append the partytown script
            // to the <head>.
            const scriptElm = document.createElement('script');
            scriptElm.dataset.partytown = '';
            scriptElm.innerHTML = partytownSnippet(props);
            document.head.appendChild(scriptElm);
        }
        // should only append this script once per document, and is not dynamic
        document._partytown = true;
    }
    // `dangerouslySetInnerHTML` only works for scripts rendered as HTML from SSR.
    // The added code will set the [type="data-pt-script"] attribute to the SSR rendered
    // <script>. If this code renders as SSR HTML, then on the client it'll execute
    // and add the attribute which will tell the Client JS of the component to NOT
    // add the same script to the <head>.
    const innerHTML = partytownSnippet(props) + 'document.currentScript.dataset.partytown="";';
    return react.createElement("script", { suppressHydrationWarning: true, dangerouslySetInnerHTML: { __html: innerHTML } });
};



;// CONCATENATED MODULE: ./src/_components/Partytown.jsx
/* provided dependency */ var Partytown_process = __webpack_require__(14284);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

/* eslint-disable react/destructuring-assignment */ 


var isNetlify = "true" === "true";
var context = Partytown_process.env.CONTEXT;
var isDev =  false || context === "dev";
var isPreview = [
    "deploy-preview",
    "branch-deploy"
].includes(context);
var isProduction =  true || 0;
var getProxyUrl = function(url) {
    try {
        if (url.startsWith("http")) return url;
        if (isDev) {
            return "http://localhost:".concat(Partytown_process.env.PORT, "/proxy/").concat(url);
        }
        if (isPreview) {
            return "".concat(Partytown_process.env.DEPLOY_PRIME_URL, "/proxy/").concat(url);
        // could also be `${process.env.DEPLOY_URL}/proxy/${url}` (unique deploy url)
        }
        if (isProduction && isNetlify) {
            return "".concat(Partytown_process.env.URL, "/proxy/").concat(url);
        }
        return "".concat(window.location.origin, "/proxy/").concat(url);
    } catch (error) {
        return "".concat("https://www.briogeohair.com", "/proxy/").concat(url);
    }
};
var resolveUrl = function(url, location, type) {
    var host = url.host, pathname = url.pathname, search = url.search;
    return type === "script" && !pathname.startsWith("/proxy") ? new URL("".concat(location.origin, "/proxy/").concat(host).concat(pathname).concat(search)) : url;
};
function Partytown_Partytown(props) {
    var ref;
    if (props.enabled !== true) return null;
    var options = _objectSpread({}, props, {
        resolveUrl: props.resolveUrl || resolveUrl,
        loadScriptsOnMainThread: props === null || props === void 0 ? void 0 : (ref = props.loadScriptsOnMainThread) === null || ref === void 0 ? void 0 : ref.flatMap(getProxyUrl)
    });
    if (isDev && props.debug === "verbose") {
        console.log("partytown options", options);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Partytown, _objectSpread({}, options))
    });
}

// EXTERNAL MODULE: ./src/_components/PreviewModeToast.module.css
var PreviewModeToast_module = __webpack_require__(3949);
var PreviewModeToast_module_default = /*#__PURE__*/__webpack_require__.n(PreviewModeToast_module);
;// CONCATENATED MODULE: ./src/_components/PreviewModeToast.jsx
function PreviewModeToast_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PreviewModeToast_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PreviewModeToast_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


function Eye(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", PreviewModeToast_objectSpread({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.75 12c0-.338.136-.905.493-1.591a7.858 7.858 0 0 1 1.64-2.108C6.374 6.926 8.694 5.75 12 5.75c3.308 0 5.627 1.176 7.116 2.551a7.86 7.86 0 0 1 1.64 2.108c.358.686.494 1.253.494 1.591 0 .338-.136.905-.493 1.591a7.86 7.86 0 0 1-1.64 2.108c-1.49 1.375-3.81 2.551-7.117 2.551-3.308 0-5.627-1.176-7.116-2.551a7.858 7.858 0 0 1-1.64-2.108c-.358-.686-.494-1.253-.494-1.591ZM12 4.25c-3.692 0-6.373 1.324-8.134 2.949a9.356 9.356 0 0 0-1.953 2.517c-.424.814-.663 1.622-.663 2.284 0 .662.24 1.47.663 2.284a9.356 9.356 0 0 0 1.953 2.517C5.627 18.426 8.308 19.75 12 19.75s6.373-1.324 8.134-2.949a9.356 9.356 0 0 0 1.953-2.517c.424-.814.663-1.622.663-2.284 0-.662-.24-1.47-.663-2.284a9.355 9.355 0 0 0-1.953-2.517C18.373 5.574 15.692 4.25 12 4.25ZM9.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Z",
            fill: "currentColor"
        })
    }));
}
function PreviewModeToast() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PreviewModeToast_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye, {
                style: {
                    width: 16,
                    height: 16,
                    minWidth: 16
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (PreviewModeToast_module_default()).message,
                children: "You are currently previewing your storefront with draft content"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/api/exitEdit",
                title: "Leave preview mode",
                style: {
                    fontSize: 12,
                    textAlign: "right"
                },
                children: "Exit preview mode"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/_components/index.js









/***/ }),

/***/ 98702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "au": function() { return /* reexport */ useCountdown; },
  "SZ": function() { return /* reexport */ useCustomerDetails; },
  "KZ": function() { return /* reexport */ useDataLayerActions; },
  "Nr": function() { return /* reexport */ useDebounce; },
  "ws": function() { return /* reexport */ usePackCookie; },
  "tp": function() { return /* reexport */ useProductsFromHandles; },
  "C7": function() { return /* reexport */ useScrollDirection; },
  "fB": function() { return /* reexport */ useThrottle; },
  "zs": function() { return /* reexport */ useYotpoProductBottomline; }
});

// UNUSED EXPORTS: useLocalizedProducts, useLocalizedSelectedVariant

// EXTERNAL MODULE: ./src/hooks/useCartDiscountPrices.js
var useCartDiscountPrices = __webpack_require__(4911);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
;// CONCATENATED MODULE: ./src/hooks/useDebounce.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// @see: https://usehooks.com/useDebounce/

var useDebounce = function(value, delay) {
    // State and setters for debounced value
    var ref = _slicedToArray(react.useState(value), 2), debouncedValue = ref[0], setDebouncedValue = ref[1];
    react.useEffect(function() {
        // Update debounced value after delay
        var handler = window.requestTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function() {
            window.clearRequestTimeout(handler);
        };
    }, [
        value,
        delay
    ] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
};

;// CONCATENATED MODULE: ./src/hooks/useThrottle.js
function useThrottle_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useThrottle_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useThrottle_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useThrottle_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useThrottle_slicedToArray(arr, i) {
    return useThrottle_arrayWithHoles(arr) || useThrottle_iterableToArrayLimit(arr, i) || useThrottle_unsupportedIterableToArray(arr, i) || useThrottle_nonIterableRest();
}
function useThrottle_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useThrottle_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useThrottle_arrayLikeToArray(o, minLen);
}

var useThrottle = function(value, delay) {
    // State and setters for debounced value
    var ref = useThrottle_slicedToArray(react.useState(value), 2), throttledValue = ref[0], setThrottledValue = ref[1];
    var ref1 = useThrottle_slicedToArray(react.useState(0), 2), throttleCount = ref1[0], setThrottleCount = ref1[1];
    react.useEffect(function() {
        if (throttleCount <= delay) {
            setThrottleCount(throttleCount + 1);
        }
    }, [
        value
    ]);
    react.useEffect(function() {
        // Update throttled value after iterations matches delay count
        if (throttleCount >= delay) {
            setThrottledValue(value);
        }
        return function() {
            if (throttleCount === delay) {
                setThrottleCount(0);
            }
        };
    }, [
        throttleCount,
        delay
    ] // Only re-call effect if delay changes
    );
    return throttledValue;
};

;// CONCATENATED MODULE: ./src/hooks/useScrollDirection.js

function useScrollDirection() {
    var ref = (0,react.useState)(""), scrollDirection = ref[0], setScrollDirection = ref[1];
    var lastScrollTop = 0;
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var currentScrollTop = window.scrollY;
            if (currentScrollTop < 0) {
                // Nullifies scroll direction when elastic scroll is triggered.
                setScrollDirection("");
                return;
            }
            if (currentScrollTop > lastScrollTop + 10) {
                setScrollDirection("down");
                lastScrollTop = currentScrollTop;
            } else if (currentScrollTop < lastScrollTop - 10) {
                setScrollDirection("up");
                lastScrollTop = currentScrollTop;
            }
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return scrollDirection;
}

;// CONCATENATED MODULE: ./src/hooks/useProductsFromHandles.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var useProductsFromHandles = function() {
    var handles = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        handles: null
    }).handles;
    if (!handles) throw new Error("[handles] prop not provided");
    var ref2 = (0,react.useState)({}), products = ref2[0], setProducts = ref2[1];
    var ref1 = (0,react.useState)(false), fetched = ref1[0], setFetched = ref1[1];
    var fetchBundleProductsFromHandles = function() {
        var unMounting;
        var fetchProductFromHandle = function(handle) {
            var ref;
            // if we have already fetched return it, else fetch it
            return (ref = products === null || products === void 0 ? void 0 : products[handle]) !== null && ref !== void 0 ? ref : fetch("/json/products/".concat(handle, ".json")).then(function(response) {
                return response.json();
            }).catch(function(error) {
                console.error("Problem fetching", handle, error.message);
                return {
                    handle: handle
                };
            });
        };
        var bundleProductsPromises = handles.map(fetchProductFromHandle);
        var setBundleProducts = function(_products) {
            if (!(_products === null || _products === void 0 ? void 0 : _products.length)) {
                // didn't fetch
                if (unMounting) return;
                setFetched(true);
                return;
            }
            // have fetched products
            if (unMounting) return;
            setFetched(true);
            // products setState updater function
            var mergedProducts = function(prevProducts) {
                var newProducts = _products.reduce(function(byHandle, product) {
                    byHandle[product.handle] = product;
                    return byHandle;
                }, {});
                return _objectSpread({}, prevProducts, newProducts);
            };
            if (unMounting) return;
            setProducts(mergedProducts);
        };
        Promise.all(bundleProductsPromises).then(setBundleProducts);
        return function() {
            unMounting = true;
        };
    };
    (0,react.useEffect)(fetchBundleProductsFromHandles, [
        handles === null || handles === void 0 ? void 0 : handles.join("|")
    ]);
    return {
        products: products,
        fetched: fetched,
        success: Object.keys(products).length === handles.length
    };
};

// EXTERNAL MODULE: ../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(35230);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/hooks/useYotpoProductBottomline.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var useYotpoProductBottomline = function(param) {
    var legacyResourceId = param.legacyResourceId;
    var ref1 = (0,react.useState)(null), bottomline = ref1[0], setBottomline = ref1[1];
    var fetchYotpoBottomline = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(id) {
            var ref, endpoint, options, response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        if (id) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        endpoint = "/api/yotpo";
                        options = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                action: "getYotpoProductBottomline",
                                legacyResourceId: id
                            })
                        };
                        _ctx.next = 8;
                        return fetch(endpoint, options);
                    case 8:
                        response = _ctx.sent;
                        _ctx.next = 11;
                        return response.json();
                    case 11:
                        data = _ctx.sent;
                        setBottomline(data === null || data === void 0 ? void 0 : (ref = data.response) === null || ref === void 0 ? void 0 : ref.bottomline);
                        _ctx.next = 18;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("fetchYotpoBottomline error: ".concat(_ctx.t0.message));
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }));
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        if (!legacyResourceId) return;
        fetchYotpoBottomline(legacyResourceId);
    }, [
        legacyResourceId
    ]);
    return {
        bottomline: bottomline
    };
};

;// CONCATENATED MODULE: ./src/hooks/useCustomerDetails.js
function useCustomerDetails_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useCustomerDetails_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useCustomerDetails_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useCustomerDetails_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var useCustomerDetails = function(param) {
    var email = param.email;
    var ref = (0,react.useState)(null), customerDetails = ref[0], setCustomerDetails = ref[1];
    var fetchCustomerDetails = (0,react.useCallback)(useCustomerDetails_asyncToGenerator(runtime_default().mark(function _callee() {
        var endpoint, options, response, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (email) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    endpoint = "/api/yotpo";
                    options = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            action: "getCustomerDetails",
                            email: email
                        })
                    };
                    _ctx.next = 7;
                    return fetch(endpoint, options);
                case 7:
                    response = _ctx.sent;
                    _ctx.next = 10;
                    return response.json();
                case 10:
                    data = _ctx.sent;
                    if (!data || !(data === null || data === void 0 ? void 0 : data.response)) {
                        setCustomerDetails(null);
                    }
                    setCustomerDetails(data);
                    return _ctx.abrupt("return");
                case 16:
                    _ctx.prev = 16;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("fetchYotpoBottomline error: ".concat(_ctx.t0.message));
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                16
            ]
        ]);
    })), []);
    (0,react.useEffect)(function() {
        if (!email) return;
        fetchCustomerDetails(email);
    }, [
        email
    ]);
    return {
        customerDetails: customerDetails
    };
};

// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/utilities/product.js
var product = __webpack_require__(46995);
;// CONCATENATED MODULE: ./src/hooks/localization/useLocalizedSelectedVariant.js
function useLocalizedSelectedVariant_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useLocalizedSelectedVariant_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useLocalizedSelectedVariant_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useLocalizedSelectedVariant_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useLocalizedSelectedVariant_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useLocalizedSelectedVariant_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useLocalizedSelectedVariant_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var useLocalizedSelectedVariant = function() {
    var localize = (0,dist.useLocalizedVariant)().localize;
    var getLocalizedVariant = (0,react.useCallback)(function() {
        var _ref = useLocalizedSelectedVariant_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var countryCode, variant, ref, ref1, ref2, ref3, ref4, ref5, ref6, localizedVariant, localCurrencyCode, localizedAmount, localizedCompareAtAmount;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        countryCode = param.countryCode, variant = param.variant;
                        _ctx.prev = 1;
                        ;
                        if (variant) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", null);
                    case 5:
                        if (countryCode) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", variant);
                    case 7:
                        _ctx.next = 9;
                        return localize({
                            handle: variant.product.handle,
                            selectedOptions: variant.selectedOptions,
                            country: countryCode
                        });
                    case 9:
                        localizedVariant = _ctx.sent;
                        if (localizedVariant) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return", variant);
                    case 12:
                        localCurrencyCode = (ref = localizedVariant.priceV2) === null || ref === void 0 ? void 0 : ref.currencyCode;
                        localizedAmount = (ref1 = localizedVariant.priceV2) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.amount) === null || ref2 === void 0 ? void 0 : ref2.toFixed(2);
                        localizedCompareAtAmount = (ref3 = localizedVariant.compareAtPriceV2) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.amount) === null || ref4 === void 0 ? void 0 : ref4.toFixed(2);
                        return _ctx.abrupt("return", useLocalizedSelectedVariant_objectSpread({}, variant, {
                            currencyCode: localCurrencyCode,
                            priceV2: {
                                amount: localizedAmount || ((ref5 = variant.priceV2) === null || ref5 === void 0 ? void 0 : ref5.amount),
                                currencyCode: localCurrencyCode
                            },
                            compareAtPriceV2: {
                                amount: localizedCompareAtAmount || ((ref6 = variant.compareAtPriceV2) === null || ref6 === void 0 ? void 0 : ref6.amount),
                                currencyCode: localCurrencyCode
                            },
                            price: localizedAmount || variant.price,
                            compareAtPrice: localizedCompareAtAmount || variant.compareAtPrice
                        }));
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error("getLocalizedVariant:error", _ctx.t0.message);
                        return _ctx.abrupt("return", variant);
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    18
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        getLocalizedVariant: getLocalizedVariant
    };
};

;// CONCATENATED MODULE: ./src/hooks/localization/useLocalizedProducts.js
function useLocalizedProducts_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useLocalizedProducts_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useLocalizedProducts_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useLocalizedProducts_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useLocalizedProducts_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useLocalizedProducts_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useLocalizedProducts_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var useLocalizedProducts = function() {
    var getLocalizedVariant = useLocalizedSelectedVariant().getLocalizedVariant;
    var getLocalizedProductsWithFirstVariant = (0,react.useCallback)(function() {
        var _ref1 = useLocalizedProducts_asyncToGenerator(runtime_default().mark(function _callee1(param) {
            var countryCode, products, localizedPromises;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        countryCode = param.countryCode, products = param.products;
                        _ctx1.prev = 1;
                        if (products === null || products === void 0 ? void 0 : products.length) {
                            _ctx1.next = 4;
                            break;
                        }
                        return _ctx1.abrupt("return", []);
                    case 4:
                        if (countryCode) {
                            _ctx1.next = 6;
                            break;
                        }
                        return _ctx1.abrupt("return", products);
                    case 6:
                        localizedPromises = products.map(function() {
                            var _ref = useLocalizedProducts_asyncToGenerator(runtime_default().mark(function _callee(product) {
                                var ref, ref1, ref2, localizedVariant, amount, currencyCode;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            ;
                                            if (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0]) {
                                                _ctx.next = 3;
                                                break;
                                            }
                                            return _ctx.abrupt("return", null);
                                        case 3:
                                            _ctx.next = 5;
                                            return getLocalizedVariant({
                                                variant: product.variants[0],
                                                countryCode: countryCode
                                            });
                                        case 5:
                                            localizedVariant = _ctx.sent;
                                            amount = (ref1 = localizedVariant.priceV2) === null || ref1 === void 0 ? void 0 : ref1.amount;
                                            currencyCode = (ref2 = localizedVariant.priceV2) === null || ref2 === void 0 ? void 0 : ref2.currencyCode;
                                            return _ctx.abrupt("return", useLocalizedProducts_objectSpread({}, product, {
                                                priceRange: {
                                                    max: amount,
                                                    maxVariantPrice: {
                                                        amount: amount,
                                                        currencyCode: currencyCode
                                                    },
                                                    min: amount,
                                                    minVariantPrice: {
                                                        amount: amount,
                                                        currencyCode: currencyCode
                                                    }
                                                },
                                                variants: [
                                                    localizedVariant
                                                ]
                                            }));
                                        case 9:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(product) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _ctx1.next = 9;
                        return Promise.all(localizedPromises);
                    case 9:
                        return _ctx1.abrupt("return", _ctx1.sent);
                    case 12:
                        _ctx1.prev = 12;
                        _ctx1.t0 = _ctx1["catch"](1);
                        console.error("getLocalizedProductsWithFirstVariant:error", _ctx1.t0.message);
                        return _ctx1.abrupt("return", products);
                    case 16:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref1.apply(this, arguments);
        };
    }(), []);
    return {
        getLocalizedProductsWithFirstVariant: getLocalizedProductsWithFirstVariant
    };
};

;// CONCATENATED MODULE: ./src/hooks/localization/index.js



;// CONCATENATED MODULE: ./src/hooks/datalayer/useDataLayerActions.js
function useDataLayerActions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useDataLayerActions_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useDataLayerActions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useDataLayerActions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useDataLayerActions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useDataLayerActions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useDataLayerActions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var isDevelopment = "production" === "development";
var useDataLayerActions = function() {
    var getLocalizedVariant = useLocalizedSelectedVariant().getLocalizedVariant;
    var getLocalizedProductsWithFirstVariant = useLocalizedProducts().getLocalizedProductsWithFirstVariant;
    var country = (0,dist.useCountry)().country;
    var countryCode = country === null || country === void 0 ? void 0 : country.isoCode;
    var sendClickProductItemEvent = (0,react.useCallback)(function() {
        var _ref = useDataLayerActions_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var isSearchResult, listIndex, localized, product, searchTerm, selectedVariant, localizedVariant;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isSearchResult = param.isSearchResult, listIndex = param.listIndex, localized = param.localized, product = param.product, searchTerm = param.searchTerm, selectedVariant = param.selectedVariant;
                        _ctx.prev = 1;
                        if (!(!selectedVariant || typeof listIndex !== "number")) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        localizedVariant = useDataLayerActions_objectSpread({}, selectedVariant, {
                            priceV2: (localized === null || localized === void 0 ? void 0 : localized.priceV2) || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.priceV2),
                            compareAtPriceV2: (localized === null || localized === void 0 ? void 0 : localized.compareAtPriceV2) || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.compareAtPriceV2),
                            image: selectedVariant.image || (product === null || product === void 0 ? void 0 : product.featuredImage) || "",
                            index: listIndex,
                            product: useDataLayerActions_objectSpread({}, selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.product, {
                                collections: product === null || product === void 0 ? void 0 : product.collections,
                                vendor: product === null || product === void 0 ? void 0 : product.vendor
                            }),
                            list: window.location.pathname.startsWith("/collections") ? window.location.pathname : "",
                            searchTerm: searchTerm
                        });
                        PubSub.publish(isSearchResult ? "CLICK_SEARCH_ITEM" : "CLICK_COLLECTION_ITEM", localizedVariant);
                        _ctx.next = 13;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        if (isDevelopment) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 12:
                        console.error("DataLayer:sendClickProductItemEvent error", _ctx.t0.message);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendClickProductBundleItemEvent = (0,react.useCallback)(function() {
        var _ref = useDataLayerActions_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var listIndex, localizedProducts;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        listIndex = param.listIndex, localizedProducts = param.localizedProducts;
                        _ctx.prev = 1;
                        if (!(!(localizedProducts === null || localizedProducts === void 0 ? void 0 : localizedProducts.length) || typeof listIndex !== "number")) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        PubSub.publish("CLICK_BUNDLE_ITEM", localizedProducts.map(function(product) {
                            var ref;
                            return (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
                        }).filter(Boolean));
                        _ctx.next = 12;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        if (isDevelopment) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 11:
                        console.error("DataLayer:sendClickProductBundleItemEvent error", _ctx.t0.message);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendViewCollectionEvent = (0,react.useCallback)(function() {
        var _ref = useDataLayerActions_asyncToGenerator(runtime_default().mark(function _callee(param1) {
            var collectionId, passedCountryCode, products, fullProducts, localizedProducts;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        collectionId = param1.collectionId, passedCountryCode = param1.countryCode, products = param1.products;
                        _ctx.prev = 1;
                        if (!(!(products === null || products === void 0 ? void 0 : products.length) || !collectionId)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(!passedCountryCode && !countryCode)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return (0,product/* fetchProductsFromHandles */.H)(products.slice(0, 12).map(function(param) {
                            var handle = param.handle;
                            return handle;
                        }));
                    case 8:
                        fullProducts = _ctx.sent;
                        _ctx.next = 11;
                        return getLocalizedProductsWithFirstVariant({
                            products: fullProducts,
                            countryCode: passedCountryCode || countryCode
                        });
                    case 11:
                        localizedProducts = _ctx.sent;
                        PubSub.publish("VIEW_COLLECTION_PAGE", {
                            products: localizedProducts === null || localizedProducts === void 0 ? void 0 : localizedProducts.filter(Boolean),
                            id: collectionId.split("/").pop()
                        });
                        _ctx.next = 20;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        if (isDevelopment) {
                            _ctx.next = 19;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 19:
                        console.error("DataLayer:sendViewCollectionEvent error", _ctx.t0.message);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendViewProductEvent = (0,react.useCallback)(function() {
        var _ref = useDataLayerActions_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var passedCountryCode, product, _selectedVariant, selectedVariant, ref, localizedVariant;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        passedCountryCode = param.countryCode, product = param.product, _selectedVariant = param.selectedVariant;
                        _ctx.prev = 1;
                        if (product) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(!passedCountryCode && !countryCode)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        selectedVariant = _selectedVariant;
                        // if no selected variant is passed, use the first variant
                        if (!selectedVariant) {
                            ;
                            selectedVariant = (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
                        }
                        if (selectedVariant) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 10:
                        _ctx.next = 12;
                        return getLocalizedVariant({
                            variant: selectedVariant,
                            countryCode: passedCountryCode || countryCode
                        });
                    case 12:
                        localizedVariant = _ctx.sent;
                        localizedVariant = useDataLayerActions_objectSpread({}, localizedVariant, {
                            image: localizedVariant.image || product.featuredImage,
                            product: useDataLayerActions_objectSpread({}, localizedVariant.product, {
                                vendor: product.vendor
                            })
                        });
                        PubSub.publish("VIEW_PRODUCT_PAGE", localizedVariant);
                        _ctx.next = 22;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        if (isDevelopment) {
                            _ctx.next = 21;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 21:
                        console.error("DataLayer:sendViewProductEvent error", _ctx.t0.message);
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendViewProductBundleEvent = (0,react.useCallback)(function() {
        var _ref1 = useDataLayerActions_asyncToGenerator(runtime_default().mark(function _callee1(param2) {
            var passedCountryCode, products, fullProducts, localizedVariants;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        passedCountryCode = param2.countryCode, products = param2.products;
                        _ctx1.prev = 1;
                        if (products === null || products === void 0 ? void 0 : products.length) {
                            _ctx1.next = 4;
                            break;
                        }
                        return _ctx1.abrupt("return");
                    case 4:
                        if (!(!passedCountryCode && !countryCode)) {
                            _ctx1.next = 6;
                            break;
                        }
                        return _ctx1.abrupt("return");
                    case 6:
                        _ctx1.next = 8;
                        return (0,product/* fetchProductsFromHandles */.H)(products.slice(0, 12).map(function(param) {
                            var handle = param.handle;
                            return handle;
                        }));
                    case 8:
                        fullProducts = _ctx1.sent;
                        _ctx1.next = 11;
                        return Promise.all(fullProducts.map(function() {
                            var _ref = useDataLayerActions_asyncToGenerator(runtime_default().mark(function _callee(product) {
                                var ref, selectedVariant, localizedVariant;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            ;
                                            selectedVariant = (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
                                            if (selectedVariant) {
                                                _ctx.next = 4;
                                                break;
                                            }
                                            return _ctx.abrupt("return", undefined);
                                        case 4:
                                            _ctx.next = 6;
                                            return getLocalizedVariant({
                                                variant: selectedVariant,
                                                countryCode: passedCountryCode || countryCode
                                            });
                                        case 6:
                                            localizedVariant = _ctx.sent;
                                            localizedVariant = useDataLayerActions_objectSpread({}, localizedVariant, {
                                                image: localizedVariant.image || product.featuredImage,
                                                product: useDataLayerActions_objectSpread({}, localizedVariant.product, {
                                                    collections: product.collections,
                                                    vendor: product.vendor
                                                })
                                            });
                                            return _ctx.abrupt("return", localizedVariant);
                                        case 9:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(product) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                    case 11:
                        localizedVariants = _ctx1.sent;
                        PubSub.publish("VIEW_PRODUCT_BUNDLE_PAGE", localizedVariants === null || localizedVariants === void 0 ? void 0 : localizedVariants.filter(Boolean));
                        _ctx1.next = 20;
                        break;
                    case 15:
                        _ctx1.prev = 15;
                        _ctx1.t0 = _ctx1["catch"](1);
                        if (isDevelopment) {
                            _ctx1.next = 19;
                            break;
                        }
                        return _ctx1.abrupt("return");
                    case 19:
                        console.error("DataLayer:sendViewProductBundleEvent error", _ctx1.t0.message);
                    case 20:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_) {
            return _ref1.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendViewSearchResultsEvent = (0,react.useCallback)(function() {
        var _ref = useDataLayerActions_asyncToGenerator(runtime_default().mark(function _callee(param3) {
            var passedCountryCode, isSearchPage, products, searchTerm, fullProducts, localizedProducts;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        passedCountryCode = param3.countryCode, isSearchPage = param3.isSearchPage, products = param3.products, searchTerm = param3.searchTerm;
                        _ctx.prev = 1;
                        if (products === null || products === void 0 ? void 0 : products.length) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(!passedCountryCode && !countryCode)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return (0,product/* fetchProductsFromHandles */.H)(products.slice(0, 12).map(function(param) {
                            var handle = param.handle;
                            return handle;
                        }));
                    case 8:
                        fullProducts = _ctx.sent;
                        _ctx.next = 11;
                        return getLocalizedProductsWithFirstVariant({
                            products: fullProducts,
                            countryCode: passedCountryCode || countryCode
                        });
                    case 11:
                        localizedProducts = _ctx.sent;
                        PubSub.publish(isSearchPage ? "VIEW_SEARCH_PAGE_RESULTS" : "VIEW_SEARCH_RESULTS", localizedProducts === null || localizedProducts === void 0 ? void 0 : localizedProducts.filter(Boolean).map(function(product) {
                            return useDataLayerActions_objectSpread({}, product, {
                                searchTerm: searchTerm
                            });
                        }));
                        _ctx.next = 20;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        if (isDevelopment) {
                            _ctx.next = 19;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 19:
                        console.error("DataLayer:sendViewSearchResultsEvent error", _ctx.t0.message);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendSubscribeEvent = (0,react.useCallback)(function(param) {
        var email = param.email, phone = param.phone;
        if (email) {
            PubSub.publish("SUBSCRIBE_EMAIL", email);
        }
        if (phone) {
            PubSub.publish("SUBSCRIBE_PHONE", phone);
        }
    }, []);
    var sendLogInEvent = (0,react.useCallback)(function() {
        PubSub.publish("CUSTOMER_LOGGED_IN");
    }, []);
    var sendRegisterEvent = (0,react.useCallback)(function() {
        PubSub.publish("CUSTOMER_REGISTERED");
    }, []);
    return {
        sendClickProductItemEvent: sendClickProductItemEvent,
        sendClickProductBundleItemEvent: sendClickProductBundleItemEvent,
        sendViewCollectionEvent: sendViewCollectionEvent,
        sendViewProductEvent: sendViewProductEvent,
        sendViewProductBundleEvent: sendViewProductBundleEvent,
        sendViewSearchResultsEvent: sendViewSearchResultsEvent,
        sendSubscribeEvent: sendSubscribeEvent,
        sendLogInEvent: sendLogInEvent,
        sendRegisterEvent: sendRegisterEvent
    };
};

;// CONCATENATED MODULE: ./src/hooks/datalayer/index.js


;// CONCATENATED MODULE: ./src/hooks/useCountdown.js
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}

var getReturnValues = function(countDown) {
    var cd = Number.isFinite(countDown) ? Math.max(0, countDown) : 0;
    var days = Math.floor(cd / (1000 * 60 * 60 * 24));
    var hours = Math.floor(cd % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(cd % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(cd % (1000 * 60) / 1000);
    return [
        days,
        hours,
        minutes,
        seconds
    ];
};
var toMillis = function(value) {
    if (typeof value === "number") return value;
    if (_instanceof(value, Date)) return value.getTime();
    // Luxon DateTime support
    if (value && typeof value.toMillis === "function") {
        return value.toMillis();
    }
    if (typeof value === "string") {
        var parsed = Date.parse(value);
        return Number.isNaN(parsed) ? NaN : parsed;
    }
    return NaN;
};
var useCountdown = function(targetDate) {
    var countDownDate = toMillis(targetDate);
    var ref = (0,react.useState)(function() {
        var delta = countDownDate - Date.now();
        return Number.isFinite(delta) ? Math.max(0, delta) : 0;
    }), countDown = ref[0], setCountDown = ref[1];
    (0,react.useEffect)(function() {
        if (!Number.isFinite(countDownDate)) {
            setCountDown(0);
            return;
        }
        var interval = setInterval(function() {
            var delta = countDownDate - Date.now();
            if (delta <= 0) {
                setCountDown(0);
                clearInterval(interval);
            } else {
                setCountDown(delta);
            }
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        countDownDate
    ]);
    return getReturnValues(countDown);
};


;// CONCATENATED MODULE: ./src/hooks/usePackCookie.js

function usePackCookie() {
    (0,react.useEffect)(function() {
        fetch("/api/pack-cookie");
    }, []);
}

;// CONCATENATED MODULE: ./src/hooks/index.js













/***/ }),

/***/ 4911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useCartDiscountPrices; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__);


var useCartDiscountPrices = function() {
    var cart = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__.useCart)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), discountAmount = ref1[0], setDiscountAmount = ref1[1];
    // discountAmount used for cart level discount such as discount
    // code that applies to the whole order
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref2;
        var _discountAmount = cart === null || cart === void 0 ? void 0 : (ref2 = cart.discountAllocations) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(carry, discount) {
            var ref;
            if (discount === null || discount === void 0 ? void 0 : (ref = discount.discountedAmount) === null || ref === void 0 ? void 0 : ref.amount) {
                return carry + Number(discount.discountedAmount.amount);
            }
            return carry;
        }, 0);
        setDiscountAmount(Number(_discountAmount || 0));
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    return {
        discountAmount: discountAmount
    };
};


/***/ }),

/***/ 33439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useKlaviyoApi; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35230);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var useKlaviyoApi = function() {
    var storeKeyId = "H6yLPD";
    var revision = "2024-02-15";
    var subscribeToList = function() {
        var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var listId, email, phone, source, callback, properties, response1;
            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        listId = param.listId, email = param.email, phone = param.phone, source = param.source, callback = param.callback, properties = param.properties;
                        if (!(typeof listId == "undefined")) {
                            _ctx.next = 4;
                            break;
                        }
                        console.error("useKlaviyoApi.subscribeToList: listId is required");
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(typeof email == "undefined" && typeof phone == "undefined")) {
                            _ctx.next = 7;
                            break;
                        }
                        console.error("useKlaviyoApi.subscribeToList: email or phone are required");
                        return _ctx.abrupt("return");
                    case 7:
                        _ctx.next = 9;
                        return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=".concat(storeKeyId), {
                            method: "POST",
                            headers: {
                                "Accept": "application/json",
                                "Content-Type": "application/json",
                                revision: revision
                            },
                            body: JSON.stringify({
                                data: {
                                    type: "subscription",
                                    attributes: {
                                        custom_source: source,
                                        profile: {
                                            data: {
                                                type: "profile",
                                                attributes: {
                                                    email: email,
                                                    phone_number: phone
                                                },
                                                properties: properties
                                            }
                                        }
                                    },
                                    relationships: {
                                        list: {
                                            data: {
                                                type: "list",
                                                id: listId
                                            }
                                        }
                                    }
                                }
                            })
                        }).then(function(response) {
                            if (response.status == 202) {
                                return "success";
                            } else {
                                return response.json();
                            }
                        });
                    case 9:
                        response1 = _ctx.sent;
                        if (callback) {
                            callback(response1);
                        }
                        return _ctx.abrupt("return", response1);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function subscribeToList(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var sendEvent = function() {
        var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var email, phone, eventName, profileProperties, eventProperties, metricName, callback, response2;
            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = param.email, phone = param.phone, eventName = param.eventName, profileProperties = param.profileProperties, eventProperties = param.eventProperties, metricName = param.metricName, callback = param.callback;
                        if (!(typeof eventName == "undefined")) {
                            _ctx.next = 4;
                            break;
                        }
                        console.error("useKlaviyoApi.sendEvent: eventName is required to submit an event to klaviyo");
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(typeof email == "undefined" && typeof phone == "undefined")) {
                            _ctx.next = 7;
                            break;
                        }
                        console.error("useKlaviyoApi.sendEvent: email or phone are required to identify the customer on klaviyo");
                        return _ctx.abrupt("return");
                    case 7:
                        if (!(typeof metricName == "undefined")) {
                            _ctx.next = 10;
                            break;
                        }
                        console.error("useKlaviyoApi.sendEvent: metricName property is required to submit an event to klaviyo");
                        return _ctx.abrupt("return");
                    case 10:
                        _ctx.next = 12;
                        return fetch("https://a.klaviyo.com/client/events/?company_id=".concat(storeKeyId), {
                            method: "POST",
                            headers: {
                                "Accept": "application/json",
                                "Content-Type": "application/json",
                                revision: revision
                            },
                            body: JSON.stringify({
                                data: {
                                    type: "event",
                                    attributes: {
                                        properties: _objectSpread({}, eventProperties),
                                        metric: {
                                            data: {
                                                type: "metric",
                                                attributes: {
                                                    name: metricName
                                                }
                                            }
                                        },
                                        profile: {
                                            data: {
                                                type: "profile",
                                                attributes: {
                                                    email: email,
                                                    phone_number: phone,
                                                    properties: profileProperties
                                                }
                                            }
                                        }
                                    }
                                }
                            })
                        }).then(function(response) {
                            if (response.status == 202) {
                                return "success";
                            } else {
                                return response.json();
                            }
                        });
                    case 12:
                        response2 = _ctx.sent;
                        if (callback) {
                            callback(response2);
                        }
                        return _ctx.abrupt("return", response2);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendEvent(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var backInStockSubscription = function() {
        var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var email, phone, variantId, callback, channels, response3;
            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = param.email, phone = param.phone, variantId = param.variantId, callback = param.callback;
                        if (!(typeof variantId == "undefined")) {
                            _ctx.next = 4;
                            break;
                        }
                        console.error("useKlaviyoApi.backInStockSubscription: variantId is required to submit a back in stock subscription event to klaviyo");
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(typeof email == "undefined" && typeof phone == "undefined")) {
                            _ctx.next = 7;
                            break;
                        }
                        console.error("useKlaviyoApi.backInStockSubscription: email or phone are required to identify the customer on klaviyo");
                        return _ctx.abrupt("return");
                    case 7:
                        channels = [];
                        if (phone) {
                            channels.push("SMS");
                        }
                        if (email) {
                            channels.push("EMAIL");
                        }
                        _ctx.next = 12;
                        return fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=".concat(storeKeyId), {
                            method: "POST",
                            headers: {
                                "Accept": "application/json",
                                "Content-Type": "application/json",
                                revision: revision
                            },
                            body: JSON.stringify({
                                data: {
                                    type: "back-in-stock-subscription",
                                    attributes: {
                                        channels: channels,
                                        profile: {
                                            data: {
                                                type: "profile",
                                                attributes: {
                                                    email: email,
                                                    phone_number: phone
                                                }
                                            }
                                        }
                                    },
                                    relationships: {
                                        variant: {
                                            data: {
                                                type: "catalog-variant",
                                                id: "$shopify:::$default:::".concat(variantId)
                                            }
                                        }
                                    }
                                }
                            })
                        }).then(function(response) {
                            if (response.status == 202) {
                                return "success";
                            } else {
                                return response.json();
                            }
                        });
                    case 12:
                        response3 = _ctx.sent;
                        if (callback) {
                            callback(response3);
                        }
                        return _ctx.abrupt("return", response3);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function backInStockSubscription(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        subscribeToList: subscribeToList,
        backInStockSubscription: backInStockSubscription,
        sendEvent: sendEvent
    };
};


/***/ }),

/***/ 8387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35230);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _snippets_account_AccountNav__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77350);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98702);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function AccountLayout(param) {
    var children = param.children;
    var ref = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCustomerAuth)(), customerInit = ref.customerInit, customer = ref.customer;
    var customerLogout = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCustomerLogout)().customerLogout;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), points = ref1[0], setPoints = ref1[1];
    var customerDetails = (0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useCustomerDetails */ .SZ)({
        email: customer === null || customer === void 0 ? void 0 : customer.email
    }).customerDetails;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setPoints((customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.points_balance) || 0);
    }, [
        customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.points_balance
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (customerInit) {
            if (typeof yotpoWidgetsContainer !== "undefined" && typeof (yotpoWidgetsContainer === null || yotpoWidgetsContainer === void 0 ? void 0 : yotpoWidgetsContainer.initWidgets) !== "undefined") {
                window.yotpoWidgetsContainer.initWidgets();
            }
        }
    }, [
        customerInit
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "mx-auto lg:flex flex-wrap px-0 lg:px-12 lg:pb-[60px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "w-full flex lg:hidden items-start justify-between bg-grey-9 px-4 py-1 lg:mb-7 lg:flex-col lg:items-start lg:bg-transparent lg:p-0 border-b border-grey-4 sticky top-0 z-[1]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h6", {
                                className: "m-0 text-h6-m lg:text-h5",
                                children: [
                                    "Hello ",
                                    customer.firstName,
                                    "!"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                className: "text-primary-2 font-bold text-xs m-0",
                                children: [
                                    "Points Balance: ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: points
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        type: "button",
                        "aria-label": "Sign out",
                        className: "text-small font-light underline hover:no-underline lg:hidden",
                        onClick: _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return customerLogout(null, function() {
                                            console.log("Signed Out");
                                        });
                                    case 2:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: "Sign Out"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "w-full lg:w-[276px] lg:flex-shrink-0 lg:pr-12 lg:pt-[60px] border-r-0 lg:border-r border-grey-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "relative lg:sticky z-0 lg:top-[150px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "hidden lg:flex items-start justify-between bg-grey-9 px-4 py-1 lg:mb-7 lg:flex-col lg:items-start lg:bg-transparent lg:p-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h6", {
                                            className: "m-0 text-h6-m lg:text-h5",
                                            children: [
                                                "Hello ",
                                                customer.firstName,
                                                "!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                            className: "text-primary-2 font-bold text-xs m-0",
                                            children: [
                                                "Points Balance: ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: points
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                    type: "button",
                                    "aria-label": "Sign out",
                                    className: "text-small font-light underline hover:no-underline lg:hidden",
                                    onClick: _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                                        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    _ctx.next = 2;
                                                    return customerLogout(null, function() {
                                                        console.log("Signed Out");
                                                    });
                                                case 2:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    })),
                                    children: "Sign Out"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_snippets_account_AccountNav__WEBPACK_IMPORTED_MODULE_4__/* .AccountNav */ .f, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "w-full lg:w-[calc(100%_-_276px)] lg:pt-[60px] px-5 lg:px-16 pt-4 pb-6 lg:py-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "mx-auto lg:max-w-[886px]",
                    children: children
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AccountLayout);


/***/ }),

/***/ 35980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// NAMESPACE OBJECT: ../node_modules/micromark/lib/constructs.js
var constructs_namespaceObject = {};
__webpack_require__.r(constructs_namespaceObject);
__webpack_require__.d(constructs_namespaceObject, {
  "attentionMarkers": function() { return attentionMarkers; },
  "contentInitial": function() { return contentInitial; },
  "disable": function() { return disable; },
  "document": function() { return constructs_document; },
  "flow": function() { return constructs_flow; },
  "flowInitial": function() { return flowInitial; },
  "insideSpan": function() { return insideSpan; },
  "string": function() { return constructs_string; },
  "text": function() { return constructs_text; }
});

// NAMESPACE OBJECT: ../node_modules/property-information/lib/util/types.js
var types_namespaceObject = {};
__webpack_require__.r(types_namespaceObject);
__webpack_require__.d(types_namespaceObject, {
  "boolean": function() { return types_boolean; },
  "booleanish": function() { return booleanish; },
  "commaOrSpaceSeparated": function() { return commaOrSpaceSeparated; },
  "commaSeparated": function() { return commaSeparated; },
  "number": function() { return number; },
  "overloadedBoolean": function() { return overloadedBoolean; },
  "spaceSeparated": function() { return spaceSeparated; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/core-nextjs/dist/utils/index.js
var utils = __webpack_require__(96759);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ../node_modules/telejson/dist/index.mjs
var telejson_dist = __webpack_require__(73347);
// EXTERNAL MODULE: ../node_modules/@backpackjs/core-nextjs/dist/customizerUtils/index.js
var customizerUtils = __webpack_require__(2234);
// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(42310);
// EXTERNAL MODULE: ../node_modules/is-buffer/index.js
var is_buffer = __webpack_require__(48809);
;// CONCATENATED MODULE: ../node_modules/unist-util-stringify-position/index.js
/**
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {object & {type: string, position?: Position|undefined}} NodeLike
 */

/**
 * Stringify one point, a position (start and end points), or a node’s
 * positional information.
 *
 * @param {Node|NodeLike|Position|Point|null} [value]
 * @returns {string}
 */
function stringifyPosition(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if ('position' in value || 'type' in value) {
    return position(value.position)
  }

  // Position.
  if ('start' in value || 'end' in value) {
    return position(value)
  }

  // Point.
  if ('line' in value || 'column' in value) {
    return point(value)
  }

  // ?
  return ''
}

/**
 * @param {Point|undefined} point
 * @returns {string}
 */
function point(point) {
  return index(point && point.line) + ':' + index(point && point.column)
}

/**
 * @param {Position|undefined} pos
 * @returns {string}
 */
function position(pos) {
  return point(pos && pos.start) + '-' + point(pos && pos.end)
}

/**
 * @param {number|undefined} value
 * @returns {number}
 */
function index(value) {
  return value && typeof value === 'number' ? value : 1
}

;// CONCATENATED MODULE: ../node_modules/vfile-message/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position|undefined}} NodeLike
 */



class VFileMessage extends Error {
  /**
   * Constructor of a message for `reason` at `place` from `origin`.
   * When an error is passed in as `reason`, copies the `stack`.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   */
  constructor(reason, place, origin) {
    /** @type {[string|null, string|null]} */
    const parts = [null, null]
    /** @type {Position} */
    let position = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: {line: null, column: null},
      // @ts-expect-error: "
      end: {line: null, column: null}
    }

    super()

    if (typeof place === 'string') {
      origin = place
      place = undefined
    }

    if (typeof origin === 'string') {
      const index = origin.indexOf(':')

      if (index === -1) {
        parts[1] = origin
      } else {
        parts[0] = origin.slice(0, index)
        parts[1] = origin.slice(index + 1)
      }
    }

    if (place) {
      // Node.
      if ('type' in place || 'position' in place) {
        if (place.position) {
          position = place.position
        }
      }
      // Position.
      else if ('start' in place || 'end' in place) {
        position = place
      }
      // Point.
      else if ('line' in place || 'column' in place) {
        position.start = place
      }
    }

    // Fields from `Error`
    this.name = stringifyPosition(place) || '1:1'
    this.message = typeof reason === 'object' ? reason.message : reason
    this.stack = typeof reason === 'object' ? reason.stack : ''

    /**
     * Reason for message.
     * @type {string}
     */
    this.reason = this.message
    /**
     * If true, marks associated file as no longer processable.
     * @type {boolean?}
     */
    // eslint-disable-next-line no-unused-expressions
    this.fatal
    /**
     * Starting line of error.
     * @type {number?}
     */
    this.line = position.start.line
    /**
     * Starting column of error.
     * @type {number?}
     */
    this.column = position.start.column
    /**
     * Namespace of warning.
     * @type {string?}
     */
    this.source = parts[0]
    /**
     * Category of message.
     * @type {string?}
     */
    this.ruleId = parts[1]
    /**
     * Full range information, when available.
     * Has start and end properties, both set to an object with line and column, set to number?.
     * @type {Position?}
     */
    this.position = position

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /* eslint-disable no-unused-expressions */
    /**
     * You can use this to specify the source value that’s being reported, which
     * is deemed incorrect.
     * @type {string?}
     */
    this.actual
    /**
     * You can use this to suggest values that should be used instead of
     * `actual`, one or more values that are deemed as acceptable.
     * @type {Array<string>?}
     */
    this.expected
    /**
     * You may add a file property with a path of a file (used throughout the VFile ecosystem).
     * @type {string?}
     */
    this.file
    /**
     * You may add a url property with a link to documentation for the message.
     * @type {string?}
     */
    this.url
    /**
     * You may add a note property with a long form description of the message (supported by vfile-reporter).
     * @type {string?}
     */
    this.note
    /* eslint-enable no-unused-expressions */
  }
}

VFileMessage.prototype.file = ''
VFileMessage.prototype.name = ''
VFileMessage.prototype.reason = ''
VFileMessage.prototype.message = ''
VFileMessage.prototype.stack = ''
VFileMessage.prototype.fatal = null
VFileMessage.prototype.column = null
VFileMessage.prototype.line = null
VFileMessage.prototype.source = null
VFileMessage.prototype.ruleId = null
VFileMessage.prototype.position = null

;// CONCATENATED MODULE: ../node_modules/vfile/lib/minpath.browser.js
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

const path = {basename, dirname, extname, join, sep: '/'}

/* eslint-disable max-depth, complexity */

/**
 * @param {string} path
 * @param {string} [ext]
 * @returns {string}
 */
function basename(path, ext) {
  if (ext !== undefined && typeof ext !== 'string') {
    throw new TypeError('"ext" argument must be a string')
  }

  assertPath(path)
  let start = 0
  let end = -1
  let index = path.length
  /** @type {boolean|undefined} */
  let seenNonSlash

  if (ext === undefined || ext.length === 0 || ext.length > path.length) {
    while (index--) {
      if (path.charCodeAt(index) === 47 /* `/` */) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        if (seenNonSlash) {
          start = index + 1
          break
        }
      } else if (end < 0) {
        // We saw the first non-path separator, mark this as the end of our
        // path component.
        seenNonSlash = true
        end = index + 1
      }
    }

    return end < 0 ? '' : path.slice(start, end)
  }

  if (ext === path) {
    return ''
  }

  let firstNonSlashEnd = -1
  let extIndex = ext.length - 1

  while (index--) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (seenNonSlash) {
        start = index + 1
        break
      }
    } else {
      if (firstNonSlashEnd < 0) {
        // We saw the first non-path separator, remember this index in case
        // we need it if the extension ends up not matching.
        seenNonSlash = true
        firstNonSlashEnd = index + 1
      }

      if (extIndex > -1) {
        // Try to match the explicit extension.
        if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
          if (extIndex < 0) {
            // We matched the extension, so mark this as the end of our path
            // component
            end = index
          }
        } else {
          // Extension does not match, so our result is the entire path
          // component
          extIndex = -1
          end = firstNonSlashEnd
        }
      }
    }
  }

  if (start === end) {
    end = firstNonSlashEnd
  } else if (end < 0) {
    end = path.length
  }

  return path.slice(start, end)
}

/**
 * @param {string} path
 * @returns {string}
 */
function dirname(path) {
  assertPath(path)

  if (path.length === 0) {
    return '.'
  }

  let end = -1
  let index = path.length
  /** @type {boolean|undefined} */
  let unmatchedSlash

  // Prefix `--` is important to not run on `0`.
  while (--index) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      if (unmatchedSlash) {
        end = index
        break
      }
    } else if (!unmatchedSlash) {
      // We saw the first non-path separator
      unmatchedSlash = true
    }
  }

  return end < 0
    ? path.charCodeAt(0) === 47 /* `/` */
      ? '/'
      : '.'
    : end === 1 && path.charCodeAt(0) === 47 /* `/` */
    ? '//'
    : path.slice(0, end)
}

/**
 * @param {string} path
 * @returns {string}
 */
function extname(path) {
  assertPath(path)

  let index = path.length

  let end = -1
  let startPart = 0
  let startDot = -1
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find.
  let preDotState = 0
  /** @type {boolean|undefined} */
  let unmatchedSlash

  while (index--) {
    const code = path.charCodeAt(index)

    if (code === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (unmatchedSlash) {
        startPart = index + 1
        break
      }

      continue
    }

    if (end < 0) {
      // We saw the first non-path separator, mark this as the end of our
      // extension.
      unmatchedSlash = true
      end = index + 1
    }

    if (code === 46 /* `.` */) {
      // If this is our first dot, mark it as the start of our extension.
      if (startDot < 0) {
        startDot = index
      } else if (preDotState !== 1) {
        preDotState = 1
      }
    } else if (startDot > -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension.
      preDotState = -1
    }
  }

  if (
    startDot < 0 ||
    end < 0 ||
    // We saw a non-dot character immediately before the dot.
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly `..`.
    (preDotState === 1 && startDot === end - 1 && startDot === startPart + 1)
  ) {
    return ''
  }

  return path.slice(startDot, end)
}

/**
 * @param {Array<string>} segments
 * @returns {string}
 */
function join(...segments) {
  let index = -1
  /** @type {string|undefined} */
  let joined

  while (++index < segments.length) {
    assertPath(segments[index])

    if (segments[index]) {
      joined =
        joined === undefined ? segments[index] : joined + '/' + segments[index]
    }
  }

  return joined === undefined ? '.' : normalize(joined)
}

/**
 * Note: `normalize` is not exposed as `path.normalize`, so some code is
 * manually removed from it.
 *
 * @param {string} path
 * @returns {string}
 */
function normalize(path) {
  assertPath(path)

  const absolute = path.charCodeAt(0) === 47 /* `/` */

  // Normalize the path according to POSIX rules.
  let value = normalizeString(path, !absolute)

  if (value.length === 0 && !absolute) {
    value = '.'
  }

  if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */) {
    value += '/'
  }

  return absolute ? '/' + value : value
}

/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 * @param {boolean} allowAboveRoot
 * @returns {string}
 */
function normalizeString(path, allowAboveRoot) {
  let result = ''
  let lastSegmentLength = 0
  let lastSlash = -1
  let dots = 0
  let index = -1
  /** @type {number|undefined} */
  let code
  /** @type {number} */
  let lastSlashIndex

  while (++index <= path.length) {
    if (index < path.length) {
      code = path.charCodeAt(index)
    } else if (code === 47 /* `/` */) {
      break
    } else {
      code = 47 /* `/` */
    }

    if (code === 47 /* `/` */) {
      if (lastSlash === index - 1 || dots === 1) {
        // Empty.
      } else if (lastSlash !== index - 1 && dots === 2) {
        if (
          result.length < 2 ||
          lastSegmentLength !== 2 ||
          result.charCodeAt(result.length - 1) !== 46 /* `.` */ ||
          result.charCodeAt(result.length - 2) !== 46 /* `.` */
        ) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf('/')

            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = ''
                lastSegmentLength = 0
              } else {
                result = result.slice(0, lastSlashIndex)
                lastSegmentLength = result.length - 1 - result.lastIndexOf('/')
              }

              lastSlash = index
              dots = 0
              continue
            }
          } else if (result.length > 0) {
            result = ''
            lastSegmentLength = 0
            lastSlash = index
            dots = 0
            continue
          }
        }

        if (allowAboveRoot) {
          result = result.length > 0 ? result + '/..' : '..'
          lastSegmentLength = 2
        }
      } else {
        if (result.length > 0) {
          result += '/' + path.slice(lastSlash + 1, index)
        } else {
          result = path.slice(lastSlash + 1, index)
        }

        lastSegmentLength = index - lastSlash - 1
      }

      lastSlash = index
      dots = 0
    } else if (code === 46 /* `.` */ && dots > -1) {
      dots++
    } else {
      dots = -1
    }
  }

  return result
}

/**
 * @param {string} path
 */
function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError(
      'Path must be a string. Received ' + JSON.stringify(path)
    )
  }
}

/* eslint-enable max-depth, complexity */

;// CONCATENATED MODULE: ../node_modules/vfile/lib/minproc.browser.js
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const proc = {cwd}

function cwd() {
  return '/'
}

;// CONCATENATED MODULE: ../node_modules/vfile/lib/minurl.shared.js
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */

/**
 * @param {unknown} fileURLOrPath
 * @returns {fileURLOrPath is URL}
 */
// From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function isUrl(fileURLOrPath) {
  return (
    fileURLOrPath !== null &&
    typeof fileURLOrPath === 'object' &&
    // @ts-expect-error: indexable.
    fileURLOrPath.href &&
    // @ts-expect-error: indexable.
    fileURLOrPath.origin
  )
}

;// CONCATENATED MODULE: ../node_modules/vfile/lib/minurl.browser.js
/// <reference lib="dom" />



// See: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js>

/**
 * @param {string|URL} path
 */
function urlToPath(path) {
  if (typeof path === 'string') {
    path = new URL(path)
  } else if (!isUrl(path)) {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' +
        path +
        '`'
    )
    error.code = 'ERR_INVALID_ARG_TYPE'
    throw error
  }

  if (path.protocol !== 'file:') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError('The URL must be of scheme file')
    error.code = 'ERR_INVALID_URL_SCHEME'
    throw error
  }

  return getPathFromURLPosix(path)
}

/**
 * @param {URL} url
 */
function getPathFromURLPosix(url) {
  if (url.hostname !== '') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    )
    error.code = 'ERR_INVALID_FILE_URL_HOST'
    throw error
  }

  const pathname = url.pathname
  let index = -1

  while (++index < pathname.length) {
    if (
      pathname.charCodeAt(index) === 37 /* `%` */ &&
      pathname.charCodeAt(index + 1) === 50 /* `2` */
    ) {
      const third = pathname.charCodeAt(index + 2)
      if (third === 70 /* `F` */ || third === 102 /* `f` */) {
        /** @type {NodeJS.ErrnoException} */
        const error = new TypeError(
          'File URL path must not include encoded / characters'
        )
        error.code = 'ERR_INVALID_FILE_URL_PATH'
        throw error
      }
    }
  }

  return decodeURIComponent(pathname)
}



;// CONCATENATED MODULE: ../node_modules/vfile/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {Record<string, unknown> & {type: string, position?: Position|undefined}} NodeLike
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 *
 * @typedef {'ascii'|'utf8'|'utf-8'|'utf16le'|'ucs2'|'ucs-2'|'base64'|'base64url'|'latin1'|'binary'|'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *   This is a copy of the typing from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Value|Options|VFile|URL} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 * @property {Value} [value]
 * @property {string} [cwd]
 * @property {Array<string>} [history]
 * @property {string|URL} [path]
 * @property {string} [basename]
 * @property {string} [stem]
 * @property {string} [extname]
 * @property {string} [dirname]
 * @property {Data} [data]
 *
 * @typedef Map
 *   Raw source map, see:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 * @property {Array<string>} sources
 * @property {Array<string>} names
 * @property {string|undefined} [sourceRoot]
 * @property {Array<string>|undefined} [sourcesContent]
 * @property {string} mappings
 * @property {string} file
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration: a bunch of keys that will be shallow copied over to the new
 *   file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 * @typedef {<T = ReporterSettings>(files: Array<VFile>, options: T) => string} Reporter
 */







// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
const order = ['history', 'path', 'basename', 'stem', 'extname', 'dirname']

class VFile {
  /**
   * Create a new virtual file.
   *
   * If `options` is `string` or `Buffer`, it’s treated as `{value: options}`.
   * If `options` is a `URL`, it’s treated as `{path: options}`.
   * If `options` is a `VFile`, shallow copies its data over to the new file.
   * All fields in `options` are set on the newly created `VFile`.
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * It’s not possible to set either `dirname` or `extname` without setting
   * either `history`, `path`, `basename`, or `stem` as well.
   *
   * @param {Compatible} [value]
   */
  constructor(value) {
    /** @type {Options} */
    let options

    if (!value) {
      options = {}
    } else if (typeof value === 'string' || is_buffer(value)) {
      // @ts-expect-error Looks like a buffer.
      options = {value}
    } else if (isUrl(value)) {
      options = {path: value}
    } else {
      // @ts-expect-error Looks like file or options.
      options = value
    }

    /**
     * Place to store custom information (default: `{}`).
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     * @type {Data}
     */
    this.data = {}

    /**
     * List of messages associated with the file.
     * @type {Array<VFileMessage>}
     */
    this.messages = []

    /**
     * List of filepaths the file moved between.
     * The first is the original path and the last is the current path.
     * @type {Array<string>}
     */
    this.history = []

    /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     * @type {string}
     */
    this.cwd = proc.cwd()

    /* eslint-disable no-unused-expressions */
    /**
     * Raw value.
     * @type {Value}
     */
    this.value

    // The below are non-standard, they are “well-known”.
    // As in, used in several tools.

    /**
     * Whether a file was saved to disk.
     * This is used by vfile reporters.
     * @type {boolean}
     */
    this.stored

    /**
     * Sometimes files have a non-string, compiled, representation.
     * This can be stored in the `result` field.
     * One example is when turning markdown into React nodes.
     * This is used by unified to store non-string results.
     * @type {unknown}
     */
    this.result

    /**
     * Sometimes files have a source map associated with them.
     * This can be stored in the `map` field.
     * This should be a `Map` type, which is equivalent to the `RawSourceMap`
     * type from the `source-map` module.
     * @type {Map|undefined}
     */
    this.map
    /* eslint-enable no-unused-expressions */

    // Set path related properties in the correct order.
    let index = -1

    while (++index < order.length) {
      const prop = order[index]

      // Note: we specifically use `in` instead of `hasOwnProperty` to accept
      // `vfile`s too.
      if (prop in options && options[prop] !== undefined) {
        // @ts-expect-error: TS is confused by the different types for `history`.
        this[prop] = prop === 'history' ? [...options[prop]] : options[prop]
      }
    }

    /** @type {string} */
    let prop

    // Set non-path related properties.
    for (prop in options) {
      // @ts-expect-error: fine to set other things.
      if (!order.includes(prop)) this[prop] = options[prop]
    }
  }

  /**
   * Get the full path (example: `'~/index.min.js'`).
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1]
  }

  /**
   * Set the full path (example: `'~/index.min.js'`).
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   * @param {string|URL} path
   */
  set path(path) {
    if (isUrl(path)) {
      path = urlToPath(path)
    }

    assertNonEmpty(path, 'path')

    if (this.path !== path) {
      this.history.push(path)
    }
  }

  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path === 'string' ? path.dirname(this.path) : undefined
  }

  /**
   * Set the parent path (example: `'~'`).
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(dirname) {
    lib_assertPath(this.basename, 'dirname')
    this.path = path.join(dirname || '', this.basename)
  }

  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path === 'string' ? path.basename(this.path) : undefined
  }

  /**
   * Set basename (including extname) (`'index.min.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(basename) {
    assertNonEmpty(basename, 'basename')
    assertPart(basename, 'basename')
    this.path = path.join(this.dirname || '', basename)
  }

  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path === 'string' ? path.extname(this.path) : undefined
  }

  /**
   * Set the extname (including dot) (example: `'.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(extname) {
    assertPart(extname, 'extname')
    lib_assertPath(this.dirname, 'extname')

    if (extname) {
      if (extname.charCodeAt(0) !== 46 /* `.` */) {
        throw new Error('`extname` must start with `.`')
      }

      if (extname.includes('.', 1)) {
        throw new Error('`extname` cannot contain multiple dots')
      }
    }

    this.path = path.join(this.dirname, this.stem + (extname || ''))
  }

  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path === 'string'
      ? path.basename(this.path, this.extname)
      : undefined
  }

  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(stem) {
    assertNonEmpty(stem, 'stem')
    assertPart(stem, 'stem')
    this.path = path.join(this.dirname || '', stem + (this.extname || ''))
  }

  /**
   * Serialize the file.
   *
   * @param {BufferEncoding} [encoding='utf8']
   *   When `value` is a `Buffer`, `encoding` is a character encoding to
   *   understand it as (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    return (this.value || '').toString(encoding)
  }

  /**
   * Constructs a new `VFileMessage`, where `fatal` is set to `false`, and
   * associates it with the file by adding it to `vfile.messages` and setting
   * `message.file` to the current filepath.
   *
   * @param {string|Error} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */
  message(reason, place, origin) {
    const message = new VFileMessage(reason, place, origin)

    if (this.path) {
      message.name = this.path + ':' + message.name
      message.file = this.path
    }

    message.fatal = false

    this.messages.push(message)

    return message
  }

  /**
   * Like `VFile#message()`, but associates an informational message where
   * `fatal` is set to `null`.
   *
   * @param {string|Error} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */
  info(reason, place, origin) {
    const message = this.message(reason, place, origin)

    message.fatal = null

    return message
  }

  /**
   * Like `VFile#message()`, but associates a fatal message where `fatal` is
   * set to `true`, and then immediately throws it.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string|Error} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {never}
   *   Message.
   */
  fail(reason, place, origin) {
    const message = this.message(reason, place, origin)

    message.fatal = true

    throw message
  }
}

/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {void}
 */
function assertPart(part, name) {
  if (part && part.includes(path.sep)) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + path.sep + '`'
    )
  }
}

/**
 * Assert that `part` is not empty.
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {asserts part is string}
 */
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

/**
 * Assert `path` exists.
 *
 * @param {string|undefined} path
 * @param {string} name
 * @returns {asserts path is string}
 */
function lib_assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}

;// CONCATENATED MODULE: ../node_modules/bail/index.js
/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */
function bail(error) {
  if (error) {
    throw error
  }
}

// EXTERNAL MODULE: ../node_modules/extend/index.js
var extend = __webpack_require__(50229);
;// CONCATENATED MODULE: ../node_modules/is-plain-obj/index.js
function isPlainObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

;// CONCATENATED MODULE: ../node_modules/trough/index.js
/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */

/**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */
function trough() {
  /** @type {Array<Middleware>} */
  const fns = []
  /** @type {Pipeline} */
  const pipeline = {run, use}

  return pipeline

  /** @type {Run} */
  function run(...values) {
    let middlewareIndex = -1
    /** @type {Callback} */
    const callback = values.pop()

    if (typeof callback !== 'function') {
      throw new TypeError('Expected function as last argument, not ' + callback)
    }

    next(null, ...values)

    /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */
    function next(error, ...output) {
      const fn = fns[++middlewareIndex]
      let index = -1

      if (error) {
        callback(error)
        return
      }

      // Copy non-nullish input into values.
      while (++index < values.length) {
        if (output[index] === null || output[index] === undefined) {
          output[index] = values[index]
        }
      }

      // Save the newly created `output` for the next call.
      values = output

      // Next or done.
      if (fn) {
        wrap(fn, next)(...output)
      } else {
        callback(null, ...output)
      }
    }
  }

  /** @type {Use} */
  function use(middelware) {
    if (typeof middelware !== 'function') {
      throw new TypeError(
        'Expected `middelware` to be a function, not ' + middelware
      )
    }

    fns.push(middelware)
    return pipeline
  }
}

/**
 * Wrap `middleware`.
 * Can be sync or async; return a promise, receive a callback, or return new
 * values and errors.
 *
 * @param {Middleware} middleware
 * @param {Callback} callback
 */
function wrap(middleware, callback) {
  /** @type {boolean} */
  let called

  return wrapped

  /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length
    /** @type {any} */
    let result

    if (fnExpectsCallback) {
      parameters.push(done)
    }

    try {
      result = middleware.apply(this, parameters)
    } catch (error) {
      const exception = /** @type {Error} */ (error)

      // Well, this is quite the pickle.
      // `middleware` received a callback and called it synchronously, but that
      // threw an error.
      // The only thing left to do is to throw the thing instead.
      if (fnExpectsCallback && called) {
        throw exception
      }

      return done(exception)
    }

    if (!fnExpectsCallback) {
      if (result instanceof Promise) {
        result.then(then, done)
      } else if (result instanceof Error) {
        done(result)
      } else {
        then(result)
      }
    }
  }

  /**
   * Call `callback`, only once.
   * @type {Callback}
   */
  function done(error, ...output) {
    if (!called) {
      called = true
      callback(error, ...output)
    }
  }

  /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */
  function then(value) {
    done(null, value)
  }
}

;// CONCATENATED MODULE: ../node_modules/unified/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */








// Expose a frozen processor.
const unified = base().freeze()

const own = {}.hasOwnProperty

// Function to create the first processor.
/**
 * @returns {Processor}
 */
function base() {
  const transformers = trough()
  /** @type {Processor['attachers']} */
  const attachers = []
  /** @type {Record<string, unknown>} */
  let namespace = {}
  /** @type {boolean|undefined} */
  let frozen
  let freezeIndex = -1

  // Data management.
  // @ts-expect-error: overloads are handled.
  processor.data = data
  processor.Parser = undefined
  processor.Compiler = undefined

  // Lock.
  processor.freeze = freeze

  // Plugins.
  processor.attachers = attachers
  // @ts-expect-error: overloads are handled.
  processor.use = use

  // API.
  processor.parse = parse
  processor.stringify = stringify
  // @ts-expect-error: overloads are handled.
  processor.run = run
  processor.runSync = runSync
  // @ts-expect-error: overloads are handled.
  processor.process = process
  processor.processSync = processSync

  // Expose.
  return processor

  // Create a new processor based on the processor in the current scope.
  /** @type {Processor} */
  function processor() {
    const destination = base()
    let index = -1

    while (++index < attachers.length) {
      destination.use(...attachers[index])
    }

    destination.data(extend(true, {}, namespace))

    return destination
  }

  /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */
  function data(key, value) {
    if (typeof key === 'string') {
      // Set `key`.
      if (arguments.length === 2) {
        assertUnfrozen('data', frozen)
        namespace[key] = value
        return processor
      }

      // Get `key`.
      return (own.call(namespace, key) && namespace[key]) || null
    }

    // Set space.
    if (key) {
      assertUnfrozen('data', frozen)
      namespace = key
      return processor
    }

    // Get space.
    return namespace
  }

  /** @type {Processor['freeze']} */
  function freeze() {
    if (frozen) {
      return processor
    }

    while (++freezeIndex < attachers.length) {
      const [attacher, ...options] = attachers[freezeIndex]

      if (options[0] === false) {
        continue
      }

      if (options[0] === true) {
        options[0] = undefined
      }

      /** @type {Transformer|void} */
      const transformer = attacher.call(processor, ...options)

      if (typeof transformer === 'function') {
        transformers.use(transformer)
      }
    }

    frozen = true
    freezeIndex = Number.POSITIVE_INFINITY

    return processor
  }

  /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */
  function use(value, ...options) {
    /** @type {Record<string, unknown>|undefined} */
    let settings

    assertUnfrozen('use', frozen)

    if (value === null || value === undefined) {
      // Empty.
    } else if (typeof value === 'function') {
      addPlugin(value, ...options)
    } else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        addList(value)
      } else {
        addPreset(value)
      }
    } else {
      throw new TypeError('Expected usable value, not `' + value + '`')
    }

    if (settings) {
      namespace.settings = Object.assign(namespace.settings || {}, settings)
    }

    return processor

    /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */
    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value)
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          const [plugin, ...options] = value
          addPlugin(plugin, ...options)
        } else {
          addPreset(value)
        }
      } else {
        throw new TypeError('Expected usable value, not `' + value + '`')
      }
    }

    /**
     * @param {Preset} result
     * @returns {void}
     */
    function addPreset(result) {
      addList(result.plugins)

      if (result.settings) {
        settings = Object.assign(settings || {}, result.settings)
      }
    }

    /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */
    function addList(plugins) {
      let index = -1

      if (plugins === null || plugins === undefined) {
        // Empty.
      } else if (Array.isArray(plugins)) {
        while (++index < plugins.length) {
          const thing = plugins[index]
          add(thing)
        }
      } else {
        throw new TypeError('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */
    function addPlugin(plugin, value) {
      let index = -1
      /** @type {Processor['attachers'][number]|undefined} */
      let entry

      while (++index < attachers.length) {
        if (attachers[index][0] === plugin) {
          entry = attachers[index]
          break
        }
      }

      if (entry) {
        if (isPlainObject(entry[1]) && isPlainObject(value)) {
          value = extend(true, entry[1], value)
        }

        entry[1] = value
      } else {
        // @ts-expect-error: fine.
        attachers.push([...arguments])
      }
    }
  }

  /** @type {Processor['parse']} */
  function parse(doc) {
    processor.freeze()
    const file = vfile(doc)
    const Parser = processor.Parser
    assertParser('parse', Parser)

    if (newable(Parser, 'parse')) {
      // @ts-expect-error: `newable` checks this.
      return new Parser(String(file), file).parse()
    }

    // @ts-expect-error: `newable` checks this.
    return Parser(String(file), file) // eslint-disable-line new-cap
  }

  /** @type {Processor['stringify']} */
  function stringify(node, doc) {
    processor.freeze()
    const file = vfile(doc)
    const Compiler = processor.Compiler
    assertCompiler('stringify', Compiler)
    assertNode(node)

    if (newable(Compiler, 'compile')) {
      // @ts-expect-error: `newable` checks this.
      return new Compiler(node, file).compile()
    }

    // @ts-expect-error: `newable` checks this.
    return Compiler(node, file) // eslint-disable-line new-cap
  }

  /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */
  function run(node, doc, callback) {
    assertNode(node)
    processor.freeze()

    if (!callback && typeof doc === 'function') {
      callback = doc
      doc = undefined
    }

    if (!callback) {
      return new Promise(executor)
    }

    executor(null, callback)

    /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */
    function executor(resolve, reject) {
      // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
      transformers.run(node, vfile(doc), done)

      /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */
      function done(error, tree, file) {
        tree = tree || node
        if (error) {
          reject(error)
        } else if (resolve) {
          resolve(tree)
        } else {
          // @ts-expect-error: `callback` is defined if `resolve` is not.
          callback(null, tree, file)
        }
      }
    }
  }

  /** @type {Processor['runSync']} */
  function runSync(node, file) {
    /** @type {Node|undefined} */
    let result
    /** @type {boolean|undefined} */
    let complete

    processor.run(node, file, done)

    assertDone('runSync', 'run', complete)

    // @ts-expect-error: we either bailed on an error or have a tree.
    return result

    /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */
    function done(error, tree) {
      bail(error)
      result = tree
      complete = true
    }
  }

  /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */
  function process(doc, callback) {
    processor.freeze()
    assertParser('process', processor.Parser)
    assertCompiler('process', processor.Compiler)

    if (!callback) {
      return new Promise(executor)
    }

    executor(null, callback)

    /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */
    function executor(resolve, reject) {
      const file = vfile(doc)

      processor.run(processor.parse(file), file, (error, tree, file) => {
        if (error || !tree || !file) {
          done(error)
        } else {
          /** @type {unknown} */
          const result = processor.stringify(tree, file)

          if (result === undefined || result === null) {
            // Empty.
          } else if (looksLikeAVFileValue(result)) {
            file.value = result
          } else {
            file.result = result
          }

          done(error, file)
        }
      })

      /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */
      function done(error, file) {
        if (error || !file) {
          reject(error)
        } else if (resolve) {
          resolve(file)
        } else {
          // @ts-expect-error: `callback` is defined if `resolve` is not.
          callback(null, file)
        }
      }
    }
  }

  /** @type {Processor['processSync']} */
  function processSync(doc) {
    /** @type {boolean|undefined} */
    let complete

    processor.freeze()
    assertParser('processSync', processor.Parser)
    assertCompiler('processSync', processor.Compiler)

    const file = vfile(doc)

    processor.process(file, done)

    assertDone('processSync', 'process', complete)

    return file

    /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */
    function done(error) {
      complete = true
      bail(error)
    }
  }
}

/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */
function newable(value, name) {
  return (
    typeof value === 'function' &&
    // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype &&
    // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    (keys(value.prototype) || name in value.prototype)
  )
}

/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */
function keys(value) {
  /** @type {string} */
  let key

  for (key in value) {
    if (own.call(value, key)) {
      return true
    }
  }

  return false
}

/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */
function assertParser(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `Parser`')
  }
}

/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */
function assertCompiler(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `Compiler`')
  }
}

/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      'Cannot call `' +
        name +
        '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.'
    )
  }
}

/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */
function assertNode(node) {
  // `isPlainObj` unfortunately uses `any` instead of `unknown`.
  // type-coverage:ignore-next-line
  if (!isPlainObject(node) || typeof node.type !== 'string') {
    throw new TypeError('Expected node, got `' + node + '`')
    // Fine.
  }
}

/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}

/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value)
}

/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */
function looksLikeAVFile(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'message' in value &&
      'messages' in value
  )
}

/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */
function looksLikeAVFileValue(value) {
  return typeof value === 'string' || is_buffer(value)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-string/index.js
/**
 * @typedef Options
 * @property {boolean} [includeImageAlt=true]
 */

/**
 * Get the text content of a node.
 * Prefer the node’s plain-text fields, otherwise serialize its children,
 * and if the given value is an array, serialize the nodes in it.
 *
 * @param {unknown} node
 * @param {Options} [options]
 * @returns {string}
 */
function mdast_util_to_string_toString(node, options) {
  var {includeImageAlt = true} = options || {}
  return one(node, includeImageAlt)
}

/**
 * @param {unknown} node
 * @param {boolean} includeImageAlt
 * @returns {string}
 */
function one(node, includeImageAlt) {
  return (
    (node &&
      typeof node === 'object' &&
      // @ts-ignore looks like a literal.
      (node.value ||
        // @ts-ignore looks like an image.
        (includeImageAlt ? node.alt : '') ||
        // @ts-ignore looks like a parent.
        ('children' in node && mdast_util_to_string_all(node.children, includeImageAlt)) ||
        (Array.isArray(node) && mdast_util_to_string_all(node, includeImageAlt)))) ||
    ''
  )
}

/**
 * @param {Array.<unknown>} values
 * @param {boolean} includeImageAlt
 * @returns {string}
 */
function mdast_util_to_string_all(values, includeImageAlt) {
  /** @type {Array.<string>} */
  var result = []
  var index = -1

  while (++index < values.length) {
    result[index] = one(values[index], includeImageAlt)
  }

  return result.join('')
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-chunked/index.js
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 * @param {T[]} list
 * @param {number} start
 * @param {number} remove
 * @param {T[]} items
 * @returns {void}
 */
function splice(list, start, remove, items) {
  const end = list.length
  let chunkStart = 0
  /** @type {unknown[]} */

  let parameters // Make start between zero and `end` (included).

  if (start < 0) {
    start = -start > end ? 0 : end + start
  } else {
    start = start > end ? end : start
  }

  remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.

  if (items.length < 10000) {
    parameters = Array.from(items)
    parameters.unshift(start, remove) // @ts-expect-error Hush, it’s fine.
    ;[].splice.apply(list, parameters)
  } else {
    // Delete `remove` items starting from `start`
    if (remove) [].splice.apply(list, [start, remove]) // Insert the items in chunks to not cause stack overflows.

    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 10000)
      parameters.unshift(start, 0) // @ts-expect-error Hush, it’s fine.
      ;[].splice.apply(list, parameters)
      chunkStart += 10000
      start += 10000
    }
  }
}
/**
 * Append `items` (an array) at the end of `list` (another array).
 * When `list` was empty, returns `items` instead.
 *
 * This prevents a potentially expensive operation when `list` is empty,
 * and adds items in batches to prevent V8 from hanging.
 *
 * @template {unknown} T
 * @param {T[]} list
 * @param {T[]} items
 * @returns {T[]}
 */

function push(list, items) {
  if (list.length > 0) {
    splice(list, list.length, 0, items)
    return list
  }

  return items
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-combine-extensions/index.js
/**
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */



const micromark_util_combine_extensions_hasOwnProperty = {}.hasOwnProperty

/**
 * Combine several syntax extensions into one.
 *
 * @param {Extension[]} extensions List of syntax extensions.
 * @returns {NormalizedExtension} A single combined extension.
 */
function combineExtensions(extensions) {
  /** @type {NormalizedExtension} */
  const all = {}
  let index = -1

  while (++index < extensions.length) {
    syntaxExtension(all, extensions[index])
  }

  return all
}

/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all Extension to merge into.
 * @param {Extension} extension Extension to merge.
 * @returns {void}
 */
function syntaxExtension(all, extension) {
  /** @type {string} */
  let hook

  for (hook in extension) {
    const maybe = micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    const left = maybe || (all[hook] = {})
    const right = extension[hook]
    /** @type {string} */
    let code

    for (code in right) {
      if (!micromark_util_combine_extensions_hasOwnProperty.call(left, code)) left[code] = []
      const value = right[code]
      constructs(
        // @ts-expect-error Looks like a list.
        left[code],
        Array.isArray(value) ? value : value ? [value] : []
      )
    }
  }
}

/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {unknown[]} existing
 * @param {unknown[]} list
 * @returns {void}
 */
function constructs(existing, list) {
  let index = -1
  /** @type {unknown[]} */
  const before = []

  while (++index < list.length) {
    // @ts-expect-error Looks like an object.
    ;(list[index].add === 'after' ? existing : before).push(list[index])
  }

  splice(existing, 0, 0, before)
}

/**
 * Combine several HTML extensions into one.
 *
 * @param {HtmlExtension[]} htmlExtensions List of HTML extensions.
 * @returns {HtmlExtension} A single combined extension.
 */
function micromark_util_combine_extensions_combineHtmlExtensions(htmlExtensions) {
  /** @type {HtmlExtension} */
  const handlers = {}
  let index = -1

  while (++index < htmlExtensions.length) {
    htmlExtension(handlers, htmlExtensions[index])
  }

  return handlers
}

/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all Extension to merge into.
 * @param {HtmlExtension} extension Extension to merge.
 * @returns {void}
 */
function htmlExtension(all, extension) {
  /** @type {string} */
  let hook

  for (hook in extension) {
    const maybe = micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    const left = maybe || (all[hook] = {})
    const right = extension[hook]
    /** @type {string} */
    let type

    if (right) {
      for (type in right) {
        left[type] = right[type]
      }
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-character/lib/unicode-punctuation-regex.js
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
const unicodePunctuationRegex =
  /[!-/:-@[-`{-~\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/

;// CONCATENATED MODULE: ../node_modules/micromark-util-character/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 */

const asciiAlpha = regexCheck(/[A-Za-z]/)
/**
 * Check whether the character code represents an ASCII digit (`0` through `9`).
 *
 * An **ASCII digit** is a character in the inclusive range U+0030 (`0`) to
 * U+0039 (`9`).
 */

const asciiDigit = regexCheck(/\d/)
/**
 * Check whether the character code represents an ASCII hex digit (`a` through
 * `f`, case insensitive, or `0` through `9`).
 *
 * An **ASCII hex digit** is an ASCII digit (see `asciiDigit`), ASCII upper hex
 * digit, or an ASCII lower hex digit.
 *
 * An **ASCII upper hex digit** is a character in the inclusive range U+0041
 * (`A`) to U+0046 (`F`).
 *
 * An **ASCII lower hex digit** is a character in the inclusive range U+0061
 * (`a`) to U+0066 (`f`).
 */

const asciiHexDigit = regexCheck(/[\dA-Fa-f]/)
/**
 * Check whether the character code represents an ASCII alphanumeric (`a`
 * through `z`, case insensitive, or `0` through `9`).
 *
 * An **ASCII alphanumeric** is an ASCII digit (see `asciiDigit`) or ASCII alpha
 * (see `asciiAlpha`).
 */

const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/)
/**
 * Check whether the character code represents ASCII punctuation.
 *
 * An **ASCII punctuation** is a character in the inclusive ranges U+0021
 * EXCLAMATION MARK (`!`) to U+002F SLASH (`/`), U+003A COLON (`:`) to U+0040 AT
 * SIGN (`@`), U+005B LEFT SQUARE BRACKET (`[`) to U+0060 GRAVE ACCENT
 * (`` ` ``), or U+007B LEFT CURLY BRACE (`{`) to U+007E TILDE (`~`).
 */

const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/)
/**
 * Check whether the character code represents an ASCII atext.
 *
 * atext is an ASCII alphanumeric (see `asciiAlphanumeric`), or a character in
 * the inclusive ranges U+0023 NUMBER SIGN (`#`) to U+0027 APOSTROPHE (`'`),
 * U+002A ASTERISK (`*`), U+002B PLUS SIGN (`+`), U+002D DASH (`-`), U+002F
 * SLASH (`/`), U+003D EQUALS TO (`=`), U+003F QUESTION MARK (`?`), U+005E
 * CARET (`^`) to U+0060 GRAVE ACCENT (`` ` ``), or U+007B LEFT CURLY BRACE
 * (`{`) to U+007E TILDE (`~`).
 *
 * See:
 * **\[RFC5322]**:
 * [Internet Message Format](https://tools.ietf.org/html/rfc5322).
 * P. Resnick.
 * IETF.
 */

const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/)
/**
 * Check whether a character code is an ASCII control character.
 *
 * An **ASCII control** is a character in the inclusive range U+0000 NULL (NUL)
 * to U+001F (US), or U+007F (DEL).
 *
 * @param {Code} code
 * @returns {code is number}
 */

function asciiControl(code) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127)
  )
}
/**
 * Check whether a character code is a markdown line ending (see
 * `markdownLineEnding`) or markdown space (see `markdownSpace`).
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownLineEndingOrSpace(code) {
  return code !== null && (code < 0 || code === 32)
}
/**
 * Check whether a character code is a markdown line ending.
 *
 * A **markdown line ending** is the virtual characters M-0003 CARRIAGE RETURN
 * LINE FEED (CRLF), M-0004 LINE FEED (LF) and M-0005 CARRIAGE RETURN (CR).
 *
 * In micromark, the actual character U+000A LINE FEED (LF) and U+000D CARRIAGE
 * RETURN (CR) are replaced by these virtual characters depending on whether
 * they occurred together.
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownLineEnding(code) {
  return code !== null && code < -2
}
/**
 * Check whether a character code is a markdown space.
 *
 * A **markdown space** is the concrete character U+0020 SPACE (SP) and the
 * virtual characters M-0001 VIRTUAL SPACE (VS) and M-0002 HORIZONTAL TAB (HT).
 *
 * In micromark, the actual character U+0009 CHARACTER TABULATION (HT) is
 * replaced by one M-0002 HORIZONTAL TAB (HT) and between 0 and 3 M-0001 VIRTUAL
 * SPACE (VS) characters, depending on the column at which the tab occurred.
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32
}
/**
 * Check whether the character code represents Unicode whitespace.
 *
 * Note that this does handle micromark specific markdown whitespace characters.
 * See `markdownLineEndingOrSpace` to check that.
 *
 * A **Unicode whitespace** is a character in the Unicode `Zs` (Separator,
 * Space) category, or U+0009 CHARACTER TABULATION (HT), U+000A LINE FEED (LF),
 * U+000C (FF), or U+000D CARRIAGE RETURN (CR) (**\[UNICODE]**).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 */

const unicodeWhitespace = regexCheck(/\s/)
/**
 * Check whether the character code represents Unicode punctuation.
 *
 * A **Unicode punctuation** is a character in the Unicode `Pc` (Punctuation,
 * Connector), `Pd` (Punctuation, Dash), `Pe` (Punctuation, Close), `Pf`
 * (Punctuation, Final quote), `Pi` (Punctuation, Initial quote), `Po`
 * (Punctuation, Other), or `Ps` (Punctuation, Open) categories, or an ASCII
 * punctuation (see `asciiPunctuation`).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 */
// Size note: removing ASCII from the regex and using `asciiPunctuation` here
// In fact adds to the bundle size.

const unicodePunctuation = regexCheck(unicodePunctuationRegex)
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => code is number}
 */

function regexCheck(regex) {
  return check
  /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code Character code
   * @returns {code is number} Whether the character code matches the bound regex
   */

  function check(code) {
    return code !== null && regex.test(String.fromCharCode(code))
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-factory-space/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */

/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {string} type
 * @param {number} [max=Infinity]
 * @returns {State}
 */

function factorySpace(effects, ok, type, max) {
  const limit = max ? max - 1 : Number.POSITIVE_INFINITY
  let size = 0
  return start
  /** @type {State} */

  function start(code) {
    if (markdownSpace(code)) {
      effects.enter(type)
      return prefix(code)
    }

    return ok(code)
  }
  /** @type {State} */

  function prefix(code) {
    if (markdownSpace(code) && size++ < limit) {
      effects.consume(code)
      return prefix
    }

    effects.exit(type)
    return ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/initialize/content.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {InitialConstruct} */
const content = {
  tokenize: initializeContent
}
/** @type {Initializer} */

function initializeContent(effects) {
  const contentStart = effects.attempt(
    this.parser.constructs.contentInitial,
    afterContentStartConstruct,
    paragraphInitial
  )
  /** @type {Token} */

  let previous
  return contentStart
  /** @type {State} */

  function afterContentStartConstruct(code) {
    if (code === null) {
      effects.consume(code)
      return
    }

    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, contentStart, 'linePrefix')
  }
  /** @type {State} */

  function paragraphInitial(code) {
    effects.enter('paragraph')
    return lineStart(code)
  }
  /** @type {State} */

  function lineStart(code) {
    const token = effects.enter('chunkText', {
      contentType: 'text',
      previous
    })

    if (previous) {
      previous.next = token
    }

    previous = token
    return data(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null) {
      effects.exit('chunkText')
      effects.exit('paragraph')
      effects.consume(code)
      return
    }

    if (markdownLineEnding(code)) {
      effects.consume(code)
      effects.exit('chunkText')
      return lineStart
    } // Data.

    effects.consume(code)
    return data
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/initialize/document.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Point} Point
 */

/**
 * @typedef {Record<string, unknown>} StackState
 * @typedef {[Construct, StackState]} StackItem
 */



/** @type {InitialConstruct} */

const document_document = {
  tokenize: initializeDocument
}
/** @type {Construct} */

const containerConstruct = {
  tokenize: tokenizeContainer
}
/** @type {Initializer} */

function initializeDocument(effects) {
  const self = this
  /** @type {Array<StackItem>} */

  const stack = []
  let continued = 0
  /** @type {TokenizeContext|undefined} */

  let childFlow
  /** @type {Token|undefined} */

  let childToken
  /** @type {number} */

  let lineStartOffset
  return start
  /** @type {State} */

  function start(code) {
    // First we iterate through the open blocks, starting with the root
    // document, and descending through last children down to the last open
    // block.
    // Each block imposes a condition that the line must satisfy if the block is
    // to remain open.
    // For example, a block quote requires a `>` character.
    // A paragraph requires a non-blank line.
    // In this phase we may match all or just some of the open blocks.
    // But we cannot close unmatched blocks yet, because we may have a lazy
    // continuation line.
    if (continued < stack.length) {
      const item = stack[continued]
      self.containerState = item[1]
      return effects.attempt(
        item[0].continuation,
        documentContinue,
        checkNewContainers
      )(code)
    } // Done.

    return checkNewContainers(code)
  }
  /** @type {State} */

  function documentContinue(code) {
    continued++ // Note: this field is called `_closeFlow` but it also closes containers.
    // Perhaps a good idea to rename it but it’s already used in the wild by
    // extensions.

    if (self.containerState._closeFlow) {
      self.containerState._closeFlow = undefined

      if (childFlow) {
        closeFlow()
      } // Note: this algorithm for moving events around is similar to the
      // algorithm when dealing with lazy lines in `writeToChild`.

      const indexBeforeExits = self.events.length
      let indexBeforeFlow = indexBeforeExits
      /** @type {Point|undefined} */

      let point // Find the flow chunk.

      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          point = self.events[indexBeforeFlow][1].end
          break
        }
      }

      exitContainers(continued) // Fix positions.

      let index = indexBeforeExits

      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point)
        index++
      } // Inject the exits earlier (they’re still also at the end).

      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      ) // Discard the duplicate exits.

      self.events.length = index
      return checkNewContainers(code)
    }

    return start(code)
  }
  /** @type {State} */

  function checkNewContainers(code) {
    // Next, after consuming the continuation markers for existing blocks, we
    // look for new block starts (e.g. `>` for a block quote).
    // If we encounter a new block start, we close any blocks unmatched in
    // step 1 before creating the new block as a child of the last matched
    // block.
    if (continued === stack.length) {
      // No need to `check` whether there’s a container, of `exitContainers`
      // would be moot.
      // We can instead immediately `attempt` to parse one.
      if (!childFlow) {
        return documentContinued(code)
      } // If we have concrete content, such as block HTML or fenced code,
      // we can’t have containers “pierce” into them, so we can immediately
      // start.

      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code)
      } // If we do have flow, it could still be a blank line,
      // but we’d be interrupting it w/ a new container if there’s a current
      // construct.

      self.interrupt = Boolean(
        childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack
      )
    } // Check if there is a new container.

    self.containerState = {}
    return effects.check(
      containerConstruct,
      thereIsANewContainer,
      thereIsNoNewContainer
    )(code)
  }
  /** @type {State} */

  function thereIsANewContainer(code) {
    if (childFlow) closeFlow()
    exitContainers(continued)
    return documentContinued(code)
  }
  /** @type {State} */

  function thereIsNoNewContainer(code) {
    self.parser.lazy[self.now().line] = continued !== stack.length
    lineStartOffset = self.now().offset
    return flowStart(code)
  }
  /** @type {State} */

  function documentContinued(code) {
    // Try new containers.
    self.containerState = {}
    return effects.attempt(
      containerConstruct,
      containerContinue,
      flowStart
    )(code)
  }
  /** @type {State} */

  function containerContinue(code) {
    continued++
    stack.push([self.currentConstruct, self.containerState]) // Try another.

    return documentContinued(code)
  }
  /** @type {State} */

  function flowStart(code) {
    if (code === null) {
      if (childFlow) closeFlow()
      exitContainers(0)
      effects.consume(code)
      return
    }

    childFlow = childFlow || self.parser.flow(self.now())
    effects.enter('chunkFlow', {
      contentType: 'flow',
      previous: childToken,
      _tokenizer: childFlow
    })
    return flowContinue(code)
  }
  /** @type {State} */

  function flowContinue(code) {
    if (code === null) {
      writeToChild(effects.exit('chunkFlow'), true)
      exitContainers(0)
      effects.consume(code)
      return
    }

    if (markdownLineEnding(code)) {
      effects.consume(code)
      writeToChild(effects.exit('chunkFlow')) // Get ready for the next line.

      continued = 0
      self.interrupt = undefined
      return start
    }

    effects.consume(code)
    return flowContinue
  }
  /**
   * @param {Token} token
   * @param {boolean} [eof]
   * @returns {void}
   */

  function writeToChild(token, eof) {
    const stream = self.sliceStream(token)
    if (eof) stream.push(null)
    token.previous = childToken
    if (childToken) childToken.next = token
    childToken = token
    childFlow.defineSkip(token.start)
    childFlow.write(stream) // Alright, so we just added a lazy line:
    //
    // ```markdown
    // > a
    // b.
    //
    // Or:
    //
    // > ~~~c
    // d
    //
    // Or:
    //
    // > | e |
    // f
    // ```
    //
    // The construct in the second example (fenced code) does not accept lazy
    // lines, so it marked itself as done at the end of its first line, and
    // then the content construct parses `d`.
    // Most constructs in markdown match on the first line: if the first line
    // forms a construct, a non-lazy line can’t “unmake” it.
    //
    // The construct in the third example is potentially a GFM table, and
    // those are *weird*.
    // It *could* be a table, from the first line, if the following line
    // matches a condition.
    // In this case, that second line is lazy, which “unmakes” the first line
    // and turns the whole into one content block.
    //
    // We’ve now parsed the non-lazy and the lazy line, and can figure out
    // whether the lazy line started a new flow block.
    // If it did, we exit the current containers between the two flow blocks.

    if (self.parser.lazy[token.start.line]) {
      let index = childFlow.events.length

      while (index--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
          (!childFlow.events[index][1].end || // …or ends after it.
            childFlow.events[index][1].end.offset > lineStartOffset)
        ) {
          // Exit: there’s still something open, which means it’s a lazy line
          // part of something.
          return
        }
      } // Note: this algorithm for moving events around is similar to the
      // algorithm when closing flow in `documentContinue`.

      const indexBeforeExits = self.events.length
      let indexBeforeFlow = indexBeforeExits
      /** @type {boolean|undefined} */

      let seen
      /** @type {Point|undefined} */

      let point // Find the previous chunk (the one before the lazy line).

      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          if (seen) {
            point = self.events[indexBeforeFlow][1].end
            break
          }

          seen = true
        }
      }

      exitContainers(continued) // Fix positions.

      index = indexBeforeExits

      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point)
        index++
      } // Inject the exits earlier (they’re still also at the end).

      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      ) // Discard the duplicate exits.

      self.events.length = index
    }
  }
  /**
   * @param {number} size
   * @returns {void}
   */

  function exitContainers(size) {
    let index = stack.length // Exit open containers.

    while (index-- > size) {
      const entry = stack[index]
      self.containerState = entry[1]
      entry[0].exit.call(self, effects)
    }

    stack.length = size
  }

  function closeFlow() {
    childFlow.write([null])
    childToken = undefined
    childFlow = undefined
    self.containerState._closeFlow = undefined
  }
}
/** @type {Tokenizer} */

function tokenizeContainer(effects, ok, nok) {
  return factorySpace(
    effects,
    effects.attempt(this.parser.constructs.document, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/blank-line.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const blankLine = {
  tokenize: tokenizeBlankLine,
  partial: true
}
/** @type {Tokenizer} */

function tokenizeBlankLine(effects, ok, nok) {
  return factorySpace(effects, afterWhitespace, 'linePrefix')
  /** @type {State} */

  function afterWhitespace(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-subtokenize/index.js
/**
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 */


/**
 * Tokenize subcontent.
 *
 * @param {Event[]} events
 * @returns {boolean}
 */
function subtokenize(events) {
  /** @type {Record<string, number>} */
  const jumps = {}
  let index = -1
  /** @type {Event} */

  let event
  /** @type {number|undefined} */

  let lineIndex
  /** @type {number} */

  let otherIndex
  /** @type {Event} */

  let otherEvent
  /** @type {Event[]} */

  let parameters
  /** @type {Event[]} */

  let subevents
  /** @type {boolean|undefined} */

  let more

  while (++index < events.length) {
    while (index in jumps) {
      index = jumps[index]
    }

    event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
    // is in the first content of a list item.

    if (
      index &&
      event[1].type === 'chunkFlow' &&
      events[index - 1][1].type === 'listItemPrefix'
    ) {
      subevents = event[1]._tokenizer.events
      otherIndex = 0

      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'lineEndingBlank'
      ) {
        otherIndex += 2
      }

      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'content'
      ) {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === 'content') {
            break
          }

          if (subevents[otherIndex][1].type === 'chunkText') {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true
            otherIndex++
          }
        }
      }
    } // Enter.

    if (event[0] === 'enter') {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events, index))
        index = jumps[index]
        more = true
      }
    } // Exit.
    else if (event[1]._container) {
      otherIndex = index
      lineIndex = undefined

      while (otherIndex--) {
        otherEvent = events[otherIndex]

        if (
          otherEvent[1].type === 'lineEnding' ||
          otherEvent[1].type === 'lineEndingBlank'
        ) {
          if (otherEvent[0] === 'enter') {
            if (lineIndex) {
              events[lineIndex][1].type = 'lineEndingBlank'
            }

            otherEvent[1].type = 'lineEnding'
            lineIndex = otherIndex
          }
        } else {
          break
        }
      }

      if (lineIndex) {
        // Fix position.
        event[1].end = Object.assign({}, events[lineIndex][1].start) // Switch container exit w/ line endings.

        parameters = events.slice(lineIndex, index)
        parameters.unshift(event)
        splice(events, lineIndex, index - lineIndex + 1, parameters)
      }
    }
  }

  return !more
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Event[]} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */

function subcontent(events, eventIndex) {
  const token = events[eventIndex][1]
  const context = events[eventIndex][2]
  let startPosition = eventIndex - 1
  /** @type {number[]} */

  const startPositions = []
  const tokenizer =
    token._tokenizer || context.parser[token.contentType](token.start)
  const childEvents = tokenizer.events
  /** @type {[number, number][]} */

  const jumps = []
  /** @type {Record<string, number>} */

  const gaps = {}
  /** @type {Chunk[]} */

  let stream
  /** @type {Token|undefined} */

  let previous
  let index = -1
  /** @type {Token|undefined} */

  let current = token
  let adjust = 0
  let start = 0
  const breaks = [start] // Loop forward through the linked tokens to pass them in order to the
  // subtokenizer.

  while (current) {
    // Find the position of the event for this token.
    while (events[++startPosition][1] !== current) {
      // Empty.
    }

    startPositions.push(startPosition)

    if (!current._tokenizer) {
      stream = context.sliceStream(current)

      if (!current.next) {
        stream.push(null)
      }

      if (previous) {
        tokenizer.defineSkip(current.start)
      }

      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true
      }

      tokenizer.write(stream)

      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = undefined
      }
    } // Unravel the next token.

    previous = current
    current = current.next
  } // Now, loop back through all events (and linked tokens), to figure out which
  // parts belong where.

  current = token

  while (++index < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index][0] === 'exit' &&
      childEvents[index - 1][0] === 'enter' &&
      childEvents[index][1].type === childEvents[index - 1][1].type &&
      childEvents[index][1].start.line !== childEvents[index][1].end.line
    ) {
      start = index + 1
      breaks.push(start) // Help GC.

      current._tokenizer = undefined
      current.previous = undefined
      current = current.next
    }
  } // Help GC.

  tokenizer.events = [] // If there’s one more token (which is the cases for lines that end in an
  // EOF), that’s perfect: the last point we found starts it.
  // If there isn’t then make sure any remaining content is added to it.

  if (current) {
    // Help GC.
    current._tokenizer = undefined
    current.previous = undefined
  } else {
    breaks.pop()
  } // Now splice the events from the subtokenizer into the current events,
  // moving back to front so that splice indices aren’t affected.

  index = breaks.length

  while (index--) {
    const slice = childEvents.slice(breaks[index], breaks[index + 1])
    const start = startPositions.pop()
    jumps.unshift([start, start + slice.length - 1])
    splice(events, start, 2, slice)
  }

  index = -1

  while (++index < jumps.length) {
    gaps[adjust + jumps[index][0]] = adjust + jumps[index][1]
    adjust += jumps[index][1] - jumps[index][0] - 1
  }

  return gaps
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/content.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */




/**
 * No name because it must not be turned off.
 * @type {Construct}
 */
const content_content = {
  tokenize: tokenizeContent,
  resolve: resolveContent
}
/** @type {Construct} */

const continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
}
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */

function resolveContent(events) {
  subtokenize(events)
  return events
}
/** @type {Tokenizer} */

function tokenizeContent(effects, ok) {
  /** @type {Token} */
  let previous
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('content')
    previous = effects.enter('chunkContent', {
      contentType: 'content'
    })
    return data(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null) {
      return contentEnd(code)
    }

    if (markdownLineEnding(code)) {
      return effects.check(
        continuationConstruct,
        contentContinue,
        contentEnd
      )(code)
    } // Data.

    effects.consume(code)
    return data
  }
  /** @type {State} */

  function contentEnd(code) {
    effects.exit('chunkContent')
    effects.exit('content')
    return ok(code)
  }
  /** @type {State} */

  function contentContinue(code) {
    effects.consume(code)
    effects.exit('chunkContent')
    previous.next = effects.enter('chunkContent', {
      contentType: 'content',
      previous
    })
    previous = previous.next
    return data
  }
}
/** @type {Tokenizer} */

function tokenizeContinuation(effects, ok, nok) {
  const self = this
  return startLookahead
  /** @type {State} */

  function startLookahead(code) {
    effects.exit('chunkContent')
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, prefixed, 'linePrefix')
  }
  /** @type {State} */

  function prefixed(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }

    const tail = self.events[self.events.length - 1]

    if (
      !self.parser.constructs.disable.null.includes('codeIndented') &&
      tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
    ) {
      return ok(code)
    }

    return effects.interrupt(self.parser.constructs.flow, nok, ok)(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/initialize/flow.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 */




/** @type {InitialConstruct} */
const flow = {
  tokenize: initializeFlow
}
/** @type {Initializer} */

function initializeFlow(effects) {
  const self = this
  const initial = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(
      this.parser.constructs.flowInitial,
      afterConstruct,
      factorySpace(
        effects,
        effects.attempt(
          this.parser.constructs.flow,
          afterConstruct,
          effects.attempt(content_content, afterConstruct)
        ),
        'linePrefix'
      )
    )
  )
  return initial
  /** @type {State} */

  function atBlankEnding(code) {
    if (code === null) {
      effects.consume(code)
      return
    }

    effects.enter('lineEndingBlank')
    effects.consume(code)
    effects.exit('lineEndingBlank')
    self.currentConstruct = undefined
    return initial
  }
  /** @type {State} */

  function afterConstruct(code) {
    if (code === null) {
      effects.consume(code)
      return
    }

    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    self.currentConstruct = undefined
    return initial
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/initialize/text.js
/**
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */
const resolver = {
  resolveAll: createResolver()
}
const string = initializeFactory('string')
const text_text = initializeFactory('text')
/**
 * @param {'string'|'text'} field
 * @returns {InitialConstruct}
 */

function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(
      field === 'text' ? resolveAllLineSuffixes : undefined
    )
  }
  /** @type {Initializer} */

  function initializeText(effects) {
    const self = this
    const constructs = this.parser.constructs[field]
    const text = effects.attempt(constructs, start, notText)
    return start
    /** @type {State} */

    function start(code) {
      return atBreak(code) ? text(code) : notText(code)
    }
    /** @type {State} */

    function notText(code) {
      if (code === null) {
        effects.consume(code)
        return
      }

      effects.enter('data')
      effects.consume(code)
      return data
    }
    /** @type {State} */

    function data(code) {
      if (atBreak(code)) {
        effects.exit('data')
        return text(code)
      } // Data.

      effects.consume(code)
      return data
    }
    /**
     * @param {Code} code
     * @returns {boolean}
     */

    function atBreak(code) {
      if (code === null) {
        return true
      }

      const list = constructs[code]
      let index = -1

      if (list) {
        while (++index < list.length) {
          const item = list[index]

          if (!item.previous || item.previous.call(self, self.previous)) {
            return true
          }
        }
      }

      return false
    }
  }
}
/**
 * @param {Resolver} [extraResolver]
 * @returns {Resolver}
 */

function createResolver(extraResolver) {
  return resolveAllText
  /** @type {Resolver} */

  function resolveAllText(events, context) {
    let index = -1
    /** @type {number|undefined} */

    let enter // A rather boring computation (to merge adjacent `data` events) which
    // improves mm performance by 29%.

    while (++index <= events.length) {
      if (enter === undefined) {
        if (events[index] && events[index][1].type === 'data') {
          enter = index
          index++
        }
      } else if (!events[index] || events[index][1].type !== 'data') {
        // Don’t do anything if there is one data token.
        if (index !== enter + 2) {
          events[enter][1].end = events[index - 1][1].end
          events.splice(enter + 2, index - enter - 2)
          index = enter + 2
        }

        enter = undefined
      }
    }

    return extraResolver ? extraResolver(events, context) : events
  }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */

function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0 // Skip first.

  while (++eventIndex <= events.length) {
    if (
      (eventIndex === events.length ||
        events[eventIndex][1].type === 'lineEnding') &&
      events[eventIndex - 1][1].type === 'data'
    ) {
      const data = events[eventIndex - 1][1]
      const chunks = context.sliceStream(data)
      let index = chunks.length
      let bufferIndex = -1
      let size = 0
      /** @type {boolean|undefined} */

      let tabs

      while (index--) {
        const chunk = chunks[index]

        if (typeof chunk === 'string') {
          bufferIndex = chunk.length

          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++
            bufferIndex--
          }

          if (bufferIndex) break
          bufferIndex = -1
        } // Number
        else if (chunk === -2) {
          tabs = true
          size++
        } else if (chunk === -1) {
          // Empty
        } else {
          // Replacement character, exit.
          index++
          break
        }
      }

      if (size) {
        const token = {
          type:
            eventIndex === events.length || tabs || size < 2
              ? 'lineSuffix'
              : 'hardBreakTrailing',
          start: {
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size,
            _index: data.start._index + index,
            _bufferIndex: index
              ? bufferIndex
              : data.start._bufferIndex + bufferIndex
          },
          end: Object.assign({}, data.end)
        }
        data.end = Object.assign({}, token.start)

        if (data.start.offset === data.end.offset) {
          Object.assign(data, token)
        } else {
          events.splice(
            eventIndex,
            0,
            ['enter', token, context],
            ['exit', token, context]
          )
          eventIndex += 2
        }
      }

      eventIndex++
    }
  }

  return events
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-resolve-all/index.js
/**
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 */

/**
 * Call all `resolveAll`s.
 *
 * @param {{resolveAll?: Resolver}[]} constructs
 * @param {Event[]} events
 * @param {TokenizeContext} context
 * @returns {Event[]}
 */
function resolveAll(constructs, events, context) {
  /** @type {Resolver[]} */
  const called = []
  let index = -1

  while (++index < constructs.length) {
    const resolve = constructs[index].resolveAll

    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context)
      called.push(resolve)
    }
  }

  return events
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/create-tokenizer.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 */

/**
 * @typedef Info
 * @property {() => void} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */




/**
 * Create a tokenizer.
 * Tokenizers deal with one type of data (e.g., containers, flow, text).
 * The parser is the object dealing with it all.
 * `initialize` works like other constructs, except that only its `tokenize`
 * function is used, in which case it doesn’t receive an `ok` or `nok`.
 * `from` can be given to set the point before the first character, although
 * when further lines are indented, they must be set with `defineSkip`.
 *
 * @param {ParseContext} parser
 * @param {InitialConstruct} initialize
 * @param {Omit<Point, '_index'|'_bufferIndex'>} [from]
 * @returns {TokenizeContext}
 */
function createTokenizer(parser, initialize, from) {
  /** @type {Point} */
  let point = Object.assign(
    from
      ? Object.assign({}, from)
      : {
          line: 1,
          column: 1,
          offset: 0
        },
    {
      _index: 0,
      _bufferIndex: -1
    }
  )
  /** @type {Record<string, number>} */

  const columnStart = {}
  /** @type {Array<Construct>} */

  const resolveAllConstructs = []
  /** @type {Array<Chunk>} */

  let chunks = []
  /** @type {Array<Token>} */

  let stack = []
  /** @type {boolean|undefined} */

  let consumed = true
  /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */

  const effects = {
    consume,
    enter,
    exit,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  }
  /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */

  const context = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser,
    sliceStream,
    sliceSerialize,
    now,
    defineSkip,
    write
  }
  /**
   * The state function.
   *
   * @type {State|void}
   */

  let state = initialize.tokenize.call(context, effects)
  /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */

  let expectedCode

  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize)
  }

  return context
  /** @type {TokenizeContext['write']} */

  function write(slice) {
    chunks = push(chunks, slice)
    main() // Exit if we’re not done, resolve might change stuff.

    if (chunks[chunks.length - 1] !== null) {
      return []
    }

    addResult(initialize, 0) // Otherwise, resolve, and exit.

    context.events = resolveAll(resolveAllConstructs, context.events, context)
    return context.events
  } //
  // Tools.
  //

  /** @type {TokenizeContext['sliceSerialize']} */

  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs)
  }
  /** @type {TokenizeContext['sliceStream']} */

  function sliceStream(token) {
    return sliceChunks(chunks, token)
  }
  /** @type {TokenizeContext['now']} */

  function now() {
    return Object.assign({}, point)
  }
  /** @type {TokenizeContext['defineSkip']} */

  function defineSkip(value) {
    columnStart[value.line] = value.column
    accountForPotentialSkip()
  } //
  // State management.
  //

  /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */

  function main() {
    /** @type {number} */
    let chunkIndex

    while (point._index < chunks.length) {
      const chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.

      if (typeof chunk === 'string') {
        chunkIndex = point._index

        if (point._bufferIndex < 0) {
          point._bufferIndex = 0
        }

        while (
          point._index === chunkIndex &&
          point._bufferIndex < chunk.length
        ) {
          go(chunk.charCodeAt(point._bufferIndex))
        }
      } else {
        go(chunk)
      }
    }
  }
  /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */

  function go(code) {
    consumed = undefined
    expectedCode = code
    state = state(code)
  }
  /** @type {Effects['consume']} */

  function consume(code) {
    if (markdownLineEnding(code)) {
      point.line++
      point.column = 1
      point.offset += code === -3 ? 2 : 1
      accountForPotentialSkip()
    } else if (code !== -1) {
      point.column++
      point.offset++
    } // Not in a string chunk.

    if (point._bufferIndex < 0) {
      point._index++
    } else {
      point._bufferIndex++ // At end of string chunk.
      // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
      // strings.

      if (point._bufferIndex === chunks[point._index].length) {
        point._bufferIndex = -1
        point._index++
      }
    } // Expose the previous character.

    context.previous = code // Mark as consumed.

    consumed = true
  }
  /** @type {Effects['enter']} */

  function enter(type, fields) {
    /** @type {Token} */
    // @ts-expect-error Patch instead of assign required fields to help GC.
    const token = fields || {}
    token.type = type
    token.start = now()
    context.events.push(['enter', token, context])
    stack.push(token)
    return token
  }
  /** @type {Effects['exit']} */

  function exit(type) {
    const token = stack.pop()
    token.end = now()
    context.events.push(['exit', token, context])
    return token
  }
  /**
   * Use results.
   *
   * @type {ReturnHandle}
   */

  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from)
  }
  /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */

  function onsuccessfulcheck(_, info) {
    info.restore()
  }
  /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {Record<string, unknown>} [fields]
   */

  function constructFactory(onreturn, fields) {
    return hook
    /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Construct|Array<Construct>|ConstructRecord} constructs
     * @param {State} returnState
     * @param {State} [bogusState]
     * @returns {State}
     */

    function hook(constructs, returnState, bogusState) {
      /** @type {Array<Construct>} */
      let listOfConstructs
      /** @type {number} */

      let constructIndex
      /** @type {Construct} */

      let currentConstruct
      /** @type {Info} */

      let info
      return Array.isArray(constructs)
        ? /* c8 ignore next 1 */
          handleListOfConstructs(constructs)
        : 'tokenize' in constructs // @ts-expect-error Looks like a construct.
        ? handleListOfConstructs([constructs])
        : handleMapOfConstructs(constructs)
      /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */

      function handleMapOfConstructs(map) {
        return start
        /** @type {State} */

        function start(code) {
          const def = code !== null && map[code]
          const all = code !== null && map.null
          const list = [
            // To do: add more extension tests.

            /* c8 ignore next 2 */
            ...(Array.isArray(def) ? def : def ? [def] : []),
            ...(Array.isArray(all) ? all : all ? [all] : [])
          ]
          return handleListOfConstructs(list)(code)
        }
      }
      /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */

      function handleListOfConstructs(list) {
        listOfConstructs = list
        constructIndex = 0

        if (list.length === 0) {
          return bogusState
        }

        return handleConstruct(list[constructIndex])
      }
      /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */

      function handleConstruct(construct) {
        return start
        /** @type {State} */

        function start(code) {
          // To do: not needed to store if there is no bogus state, probably?
          // Currently doesn’t work because `inspect` in document does a check
          // w/o a bogus, which doesn’t make sense. But it does seem to help perf
          // by not storing.
          info = store()
          currentConstruct = construct

          if (!construct.partial) {
            context.currentConstruct = construct
          }

          if (
            construct.name &&
            context.parser.constructs.disable.null.includes(construct.name)
          ) {
            return nok(code)
          }

          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok,
            nok
          )(code)
        }
      }
      /** @type {State} */

      function ok(code) {
        consumed = true
        onreturn(currentConstruct, info)
        return returnState
      }
      /** @type {State} */

      function nok(code) {
        consumed = true
        info.restore()

        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex])
        }

        return bogusState
      }
    }
  }
  /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */

  function addResult(construct, from) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct)
    }

    if (construct.resolve) {
      splice(
        context.events,
        from,
        context.events.length - from,
        construct.resolve(context.events.slice(from), context)
      )
    }

    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context)
    }
  }
  /**
   * Store state.
   *
   * @returns {Info}
   */

  function store() {
    const startPoint = now()
    const startPrevious = context.previous
    const startCurrentConstruct = context.currentConstruct
    const startEventsIndex = context.events.length
    const startStack = Array.from(stack)
    return {
      restore,
      from: startEventsIndex
    }
    /**
     * Restore state.
     *
     * @returns {void}
     */

    function restore() {
      point = startPoint
      context.previous = startPrevious
      context.currentConstruct = startCurrentConstruct
      context.events.length = startEventsIndex
      stack = startStack
      accountForPotentialSkip()
    }
  }
  /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */

  function accountForPotentialSkip() {
    if (point.line in columnStart && point.column < 2) {
      point.column = columnStart[point.line]
      point.offset += columnStart[point.line] - 1
    }
  }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'start'|'end'>} token
 * @returns {Array<Chunk>}
 */

function sliceChunks(chunks, token) {
  const startIndex = token.start._index
  const startBufferIndex = token.start._bufferIndex
  const endIndex = token.end._index
  const endBufferIndex = token.end._bufferIndex
  /** @type {Array<Chunk>} */

  let view

  if (startIndex === endIndex) {
    // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)]
  } else {
    view = chunks.slice(startIndex, endIndex)

    if (startBufferIndex > -1) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view[0] = view[0].slice(startBufferIndex)
    }

    if (endBufferIndex > 0) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view.push(chunks[endIndex].slice(0, endBufferIndex))
    }
  }

  return view
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean} [expandTabs=false]
 * @returns {string}
 */

function serializeChunks(chunks, expandTabs) {
  let index = -1
  /** @type {Array<string>} */

  const result = []
  /** @type {boolean|undefined} */

  let atTab

  while (++index < chunks.length) {
    const chunk = chunks[index]
    /** @type {string} */

    let value

    if (typeof chunk === 'string') {
      value = chunk
    } else
      switch (chunk) {
        case -5: {
          value = '\r'
          break
        }

        case -4: {
          value = '\n'
          break
        }

        case -3: {
          value = '\r' + '\n'
          break
        }

        case -2: {
          value = expandTabs ? ' ' : '\t'
          break
        }

        case -1: {
          if (!expandTabs && atTab) continue
          value = ' '
          break
        }

        default: {
          // Currently only replacement character.
          value = String.fromCharCode(chunk)
        }
      }

    atTab = chunk === -2
    result.push(value)
  }

  return result.join('')
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/thematic-break.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const thematicBreak = {
  name: 'thematicBreak',
  tokenize: tokenizeThematicBreak
}
/** @type {Tokenizer} */

function tokenizeThematicBreak(effects, ok, nok) {
  let size = 0
  /** @type {NonNullable<Code>} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('thematicBreak')
    marker = code
    return atBreak(code)
  }
  /** @type {State} */

  function atBreak(code) {
    if (code === marker) {
      effects.enter('thematicBreakSequence')
      return sequence(code)
    }

    if (markdownSpace(code)) {
      return factorySpace(effects, atBreak, 'whitespace')(code)
    }

    if (size < 3 || (code !== null && !markdownLineEnding(code))) {
      return nok(code)
    }

    effects.exit('thematicBreak')
    return ok(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === marker) {
      effects.consume(code)
      size++
      return sequence
    }

    effects.exit('thematicBreakSequence')
    return atBreak(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/list.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * @typedef {Record<string, unknown> & {marker: Code, type: string, size: number}} ListContainerState
 * @typedef {TokenizeContext & {containerState: ListContainerState}} TokenizeContextWithState
 */




/** @type {Construct} */

const list = {
  name: 'list',
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
}
/** @type {Construct} */

const listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
}
/** @type {Construct} */

const indentConstruct = {
  tokenize: tokenizeIndent,
  partial: true
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListStart(effects, ok, nok) {
  const self = this
  const tail = self.events[self.events.length - 1]
  let initialSize =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0
  let size = 0
  return start
  /** @type {State} */

  function start(code) {
    const kind =
      self.containerState.type ||
      (code === 42 || code === 43 || code === 45
        ? 'listUnordered'
        : 'listOrdered')

    if (
      kind === 'listUnordered'
        ? !self.containerState.marker || code === self.containerState.marker
        : asciiDigit(code)
    ) {
      if (!self.containerState.type) {
        self.containerState.type = kind
        effects.enter(kind, {
          _container: true
        })
      }

      if (kind === 'listUnordered') {
        effects.enter('listItemPrefix')
        return code === 42 || code === 45
          ? effects.check(thematicBreak, nok, atMarker)(code)
          : atMarker(code)
      }

      if (!self.interrupt || code === 49) {
        effects.enter('listItemPrefix')
        effects.enter('listItemValue')
        return inside(code)
      }
    }

    return nok(code)
  }
  /** @type {State} */

  function inside(code) {
    if (asciiDigit(code) && ++size < 10) {
      effects.consume(code)
      return inside
    }

    if (
      (!self.interrupt || size < 2) &&
      (self.containerState.marker
        ? code === self.containerState.marker
        : code === 41 || code === 46)
    ) {
      effects.exit('listItemValue')
      return atMarker(code)
    }

    return nok(code)
  }
  /**
   * @type {State}
   **/

  function atMarker(code) {
    effects.enter('listItemMarker')
    effects.consume(code)
    effects.exit('listItemMarker')
    self.containerState.marker = self.containerState.marker || code
    return effects.check(
      blankLine, // Can’t be empty when interrupting.
      self.interrupt ? nok : onBlank,
      effects.attempt(
        listItemPrefixWhitespaceConstruct,
        endOfPrefix,
        otherPrefix
      )
    )
  }
  /** @type {State} */

  function onBlank(code) {
    self.containerState.initialBlankLine = true
    initialSize++
    return endOfPrefix(code)
  }
  /** @type {State} */

  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter('listItemPrefixWhitespace')
      effects.consume(code)
      effects.exit('listItemPrefixWhitespace')
      return endOfPrefix
    }

    return nok(code)
  }
  /** @type {State} */

  function endOfPrefix(code) {
    self.containerState.size =
      initialSize +
      self.sliceSerialize(effects.exit('listItemPrefix'), true).length
    return ok(code)
  }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListContinuation(effects, ok, nok) {
  const self = this
  self.containerState._closeFlow = undefined
  return effects.check(blankLine, onBlank, notBlank)
  /** @type {State} */

  function onBlank(code) {
    self.containerState.furtherBlankLines =
      self.containerState.furtherBlankLines ||
      self.containerState.initialBlankLine // We have a blank line.
    // Still, try to consume at most the items size.

    return factorySpace(
      effects,
      ok,
      'listItemIndent',
      self.containerState.size + 1
    )(code)
  }
  /** @type {State} */

  function notBlank(code) {
    if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
      self.containerState.furtherBlankLines = undefined
      self.containerState.initialBlankLine = undefined
      return notInCurrentItem(code)
    }

    self.containerState.furtherBlankLines = undefined
    self.containerState.initialBlankLine = undefined
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code)
  }
  /** @type {State} */

  function notInCurrentItem(code) {
    // While we do continue, we signal that the flow should be closed.
    self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.

    self.interrupt = undefined
    return factorySpace(
      effects,
      effects.attempt(list, ok, nok),
      'linePrefix',
      self.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )(code)
  }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeIndent(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'listItemIndent',
    self.containerState.size + 1
  )
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'listItemIndent' &&
      tail[2].sliceSerialize(tail[1], true).length === self.containerState.size
      ? ok(code)
      : nok(code)
  }
}
/**
 * @type {Exiter}
 * @this {TokenizeContextWithState}
 */

function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type)
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'listItemPrefixWhitespace',
    self.parser.constructs.disable.null.includes('codeIndented')
      ? undefined
      : 4 + 1
  )
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return !markdownSpace(code) &&
      tail &&
      tail[1].type === 'listItemPrefixWhitespace'
      ? ok(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/block-quote.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const blockQuote = {
  name: 'blockQuote',
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit
}
/** @type {Tokenizer} */

function tokenizeBlockQuoteStart(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    if (code === 62) {
      const state = self.containerState

      if (!state.open) {
        effects.enter('blockQuote', {
          _container: true
        })
        state.open = true
      }

      effects.enter('blockQuotePrefix')
      effects.enter('blockQuoteMarker')
      effects.consume(code)
      effects.exit('blockQuoteMarker')
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    if (markdownSpace(code)) {
      effects.enter('blockQuotePrefixWhitespace')
      effects.consume(code)
      effects.exit('blockQuotePrefixWhitespace')
      effects.exit('blockQuotePrefix')
      return ok
    }

    effects.exit('blockQuotePrefix')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  return factorySpace(
    effects,
    effects.attempt(blockQuote, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}
/** @type {Exiter} */

function exit(effects) {
  effects.exit('blockQuote')
}

;// CONCATENATED MODULE: ../node_modules/micromark-factory-destination/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */


/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} literalType
 * @param {string} literalMarkerType
 * @param {string} rawType
 * @param {string} stringType
 * @param {number} [max=Infinity]
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryDestination(
  effects,
  ok,
  nok,
  type,
  literalType,
  literalMarkerType,
  rawType,
  stringType,
  max
) {
  const limit = max || Number.POSITIVE_INFINITY
  let balance = 0
  return start
  /** @type {State} */

  function start(code) {
    if (code === 60) {
      effects.enter(type)
      effects.enter(literalType)
      effects.enter(literalMarkerType)
      effects.consume(code)
      effects.exit(literalMarkerType)
      return destinationEnclosedBefore
    }

    if (code === null || code === 41 || asciiControl(code)) {
      return nok(code)
    }

    effects.enter(type)
    effects.enter(rawType)
    effects.enter(stringType)
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return destinationRaw(code)
  }
  /** @type {State} */

  function destinationEnclosedBefore(code) {
    if (code === 62) {
      effects.enter(literalMarkerType)
      effects.consume(code)
      effects.exit(literalMarkerType)
      effects.exit(literalType)
      effects.exit(type)
      return ok
    }

    effects.enter(stringType)
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return destinationEnclosed(code)
  }
  /** @type {State} */

  function destinationEnclosed(code) {
    if (code === 62) {
      effects.exit('chunkString')
      effects.exit(stringType)
      return destinationEnclosedBefore(code)
    }

    if (code === null || code === 60 || markdownLineEnding(code)) {
      return nok(code)
    }

    effects.consume(code)
    return code === 92 ? destinationEnclosedEscape : destinationEnclosed
  }
  /** @type {State} */

  function destinationEnclosedEscape(code) {
    if (code === 60 || code === 62 || code === 92) {
      effects.consume(code)
      return destinationEnclosed
    }

    return destinationEnclosed(code)
  }
  /** @type {State} */

  function destinationRaw(code) {
    if (code === 40) {
      if (++balance > limit) return nok(code)
      effects.consume(code)
      return destinationRaw
    }

    if (code === 41) {
      if (!balance--) {
        effects.exit('chunkString')
        effects.exit(stringType)
        effects.exit(rawType)
        effects.exit(type)
        return ok(code)
      }

      effects.consume(code)
      return destinationRaw
    }

    if (code === null || markdownLineEndingOrSpace(code)) {
      if (balance) return nok(code)
      effects.exit('chunkString')
      effects.exit(stringType)
      effects.exit(rawType)
      effects.exit(type)
      return ok(code)
    }

    if (asciiControl(code)) return nok(code)
    effects.consume(code)
    return code === 92 ? destinationRawEscape : destinationRaw
  }
  /** @type {State} */

  function destinationRawEscape(code) {
    if (code === 40 || code === 41 || code === 92) {
      effects.consume(code)
      return destinationRaw
    }

    return destinationRaw(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-factory-label/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').State} State
 */


/**
 * @this {TokenizeContext}
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} markerType
 * @param {string} stringType
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
  const self = this
  let size = 0
  /** @type {boolean} */

  let data
  return start
  /** @type {State} */

  function start(code) {
    effects.enter(type)
    effects.enter(markerType)
    effects.consume(code)
    effects.exit(markerType)
    effects.enter(stringType)
    return atBreak
  }
  /** @type {State} */

  function atBreak(code) {
    if (
      code === null ||
      code === 91 ||
      (code === 93 && !data) ||
      /* To do: remove in the future once we’ve switched from
       * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
       * which doesn’t need this */

      /* Hidden footnotes hook */

      /* c8 ignore next 3 */
      (code === 94 &&
        !size &&
        '_hiddenFootnoteSupport' in self.parser.constructs) ||
      size > 999
    ) {
      return nok(code)
    }

    if (code === 93) {
      effects.exit(stringType)
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return atBreak
    }

    effects.enter('chunkString', {
      contentType: 'string'
    })
    return label(code)
  }
  /** @type {State} */

  function label(code) {
    if (
      code === null ||
      code === 91 ||
      code === 93 ||
      markdownLineEnding(code) ||
      size++ > 999
    ) {
      effects.exit('chunkString')
      return atBreak(code)
    }

    effects.consume(code)
    data = data || !markdownSpace(code)
    return code === 92 ? labelEscape : label
  }
  /** @type {State} */

  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return label
    }

    return label(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-factory-title/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} markerType
 * @param {string} stringType
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
  /** @type {NonNullable<Code>} */
  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter(type)
    effects.enter(markerType)
    effects.consume(code)
    effects.exit(markerType)
    marker = code === 40 ? 41 : code
    return atFirstTitleBreak
  }
  /** @type {State} */

  function atFirstTitleBreak(code) {
    if (code === marker) {
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }

    effects.enter(stringType)
    return atTitleBreak(code)
  }
  /** @type {State} */

  function atTitleBreak(code) {
    if (code === marker) {
      effects.exit(stringType)
      return atFirstTitleBreak(marker)
    }

    if (code === null) {
      return nok(code)
    } // Note: blank lines can’t exist in content.

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return factorySpace(effects, atTitleBreak, 'linePrefix')
    }

    effects.enter('chunkString', {
      contentType: 'string'
    })
    return title(code)
  }
  /** @type {State} */

  function title(code) {
    if (code === marker || code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      return atTitleBreak(code)
    }

    effects.consume(code)
    return code === 92 ? titleEscape : title
  }
  /** @type {State} */

  function titleEscape(code) {
    if (code === marker || code === 92) {
      effects.consume(code)
      return title
    }

    return title(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-factory-whitespace/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */



/**
 * @param {Effects} effects
 * @param {State} ok
 */
function factoryWhitespace(effects, ok) {
  /** @type {boolean} */
  let seen
  return start
  /** @type {State} */

  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      seen = true
      return start
    }

    if (markdownSpace(code)) {
      return factorySpace(
        effects,
        start,
        seen ? 'linePrefix' : 'lineSuffix'
      )(code)
    }

    return ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-normalize-identifier/index.js
/**
 * Normalize an identifier (such as used in definitions).
 *
 * @param {string} value
 * @returns {string}
 */
function normalizeIdentifier(value) {
  return (
    value // Collapse Markdown whitespace.
      .replace(/[\t\n\r ]+/g, ' ') // Trim.
      .replace(/^ | $/g, '') // Some characters are considered “uppercase”, but if their lowercase
      // counterpart is uppercased will result in a different uppercase
      // character.
      // Hence, to get that form, we perform both lower- and uppercase.
      // Upper case makes sure keys will not interact with default prototypal
      // methods: no method is uppercase.
      .toLowerCase()
      .toUpperCase()
  )
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/definition.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */








/** @type {Construct} */
const definition = {
  name: 'definition',
  tokenize: tokenizeDefinition
}
/** @type {Construct} */

const titleConstruct = {
  tokenize: tokenizeTitle,
  partial: true
}
/** @type {Tokenizer} */

function tokenizeDefinition(effects, ok, nok) {
  const self = this
  /** @type {string} */

  let identifier
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('definition')
    return factoryLabel.call(
      self,
      effects,
      labelAfter,
      nok,
      'definitionLabel',
      'definitionLabelMarker',
      'definitionLabelString'
    )(code)
  }
  /** @type {State} */

  function labelAfter(code) {
    identifier = normalizeIdentifier(
      self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
    )

    if (code === 58) {
      effects.enter('definitionMarker')
      effects.consume(code)
      effects.exit('definitionMarker') // Note: blank lines can’t exist in content.

      return factoryWhitespace(
        effects,
        factoryDestination(
          effects,
          effects.attempt(
            titleConstruct,
            factorySpace(effects, after, 'whitespace'),
            factorySpace(effects, after, 'whitespace')
          ),
          nok,
          'definitionDestination',
          'definitionDestinationLiteral',
          'definitionDestinationLiteralMarker',
          'definitionDestinationRaw',
          'definitionDestinationString'
        )
      )
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('definition')

      if (!self.parser.defined.includes(identifier)) {
        self.parser.defined.push(identifier)
      }

      return ok(code)
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeTitle(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, before)(code)
      : nok(code)
  }
  /** @type {State} */

  function before(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(
        effects,
        factorySpace(effects, after, 'whitespace'),
        nok,
        'definitionTitle',
        'definitionTitleMarker',
        'definitionTitleString'
      )(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/code-indented.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const codeIndented = {
  name: 'codeIndented',
  tokenize: tokenizeCodeIndented
}
/** @type {Construct} */

const indentedContent = {
  tokenize: tokenizeIndentedContent,
  partial: true
}
/** @type {Tokenizer} */

function tokenizeCodeIndented(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeIndented')
    return factorySpace(effects, afterStartPrefix, 'linePrefix', 4 + 1)(code)
  }
  /** @type {State} */

  function afterStartPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? afterPrefix(code)
      : nok(code)
  }
  /** @type {State} */

  function afterPrefix(code) {
    if (code === null) {
      return after(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(indentedContent, afterPrefix, after)(code)
    }

    effects.enter('codeFlowValue')
    return content(code)
  }
  /** @type {State} */

  function content(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue')
      return afterPrefix(code)
    }

    effects.consume(code)
    return content
  }
  /** @type {State} */

  function after(code) {
    effects.exit('codeIndented')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeIndentedContent(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    // If this is a lazy line, it can’t be code.
    if (self.parser.lazy[self.now().line]) {
      return nok(code)
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return start
    }

    return factorySpace(effects, afterPrefix, 'linePrefix', 4 + 1)(code)
  }
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? ok(code)
      : markdownLineEnding(code)
      ? start(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/heading-atx.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */




/** @type {Construct} */
const headingAtx = {
  name: 'headingAtx',
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
}
/** @type {Resolver} */

function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2
  let contentStart = 3
  /** @type {Token} */

  let content
  /** @type {Token} */

  let text // Prefix whitespace, part of the opening.

  if (events[contentStart][1].type === 'whitespace') {
    contentStart += 2
  } // Suffix whitespace, part of the closing.

  if (
    contentEnd - 2 > contentStart &&
    events[contentEnd][1].type === 'whitespace'
  ) {
    contentEnd -= 2
  }

  if (
    events[contentEnd][1].type === 'atxHeadingSequence' &&
    (contentStart === contentEnd - 1 ||
      (contentEnd - 4 > contentStart &&
        events[contentEnd - 2][1].type === 'whitespace'))
  ) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4
  }

  if (contentEnd > contentStart) {
    content = {
      type: 'atxHeadingText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    }
    text = {
      type: 'chunkText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      // @ts-expect-error Constants are fine to assign.
      contentType: 'text'
    }
    splice(events, contentStart, contentEnd - contentStart + 1, [
      ['enter', content, context],
      ['enter', text, context],
      ['exit', text, context],
      ['exit', content, context]
    ])
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeHeadingAtx(effects, ok, nok) {
  const self = this
  let size = 0
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('atxHeading')
    effects.enter('atxHeadingSequence')
    return fenceOpenInside(code)
  }
  /** @type {State} */

  function fenceOpenInside(code) {
    if (code === 35 && size++ < 6) {
      effects.consume(code)
      return fenceOpenInside
    }

    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingSequence')
      return self.interrupt ? ok(code) : headingBreak(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function headingBreak(code) {
    if (code === 35) {
      effects.enter('atxHeadingSequence')
      return sequence(code)
    }

    if (code === null || markdownLineEnding(code)) {
      effects.exit('atxHeading')
      return ok(code)
    }

    if (markdownSpace(code)) {
      return factorySpace(effects, headingBreak, 'whitespace')(code)
    }

    effects.enter('atxHeadingText')
    return data(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === 35) {
      effects.consume(code)
      return sequence
    }

    effects.exit('atxHeadingSequence')
    return headingBreak(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null || code === 35 || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingText')
      return headingBreak(code)
    }

    effects.consume(code)
    return data
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/setext-underline.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const setextUnderline = {
  name: 'setextUnderline',
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
}
/** @type {Resolver} */

function resolveToSetextUnderline(events, context) {
  let index = events.length
  /** @type {number|undefined} */

  let content
  /** @type {number|undefined} */

  let text
  /** @type {number|undefined} */

  let definition // Find the opening of the content.
  // It’ll always exist: we don’t tokenize if it isn’t there.

  while (index--) {
    if (events[index][0] === 'enter') {
      if (events[index][1].type === 'content') {
        content = index
        break
      }

      if (events[index][1].type === 'paragraph') {
        text = index
      }
    } // Exit
    else {
      if (events[index][1].type === 'content') {
        // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1)
      }

      if (!definition && events[index][1].type === 'definition') {
        definition = index
      }
    }
  }

  const heading = {
    type: 'setextHeading',
    start: Object.assign({}, events[text][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  } // Change the paragraph to setext heading text.

  events[text][1].type = 'setextHeadingText' // If we have definitions in the content, we’ll keep on having content,
  // but we need move it.

  if (definition) {
    events.splice(text, 0, ['enter', heading, context])
    events.splice(definition + 1, 0, ['exit', events[content][1], context])
    events[content][1].end = Object.assign({}, events[definition][1].end)
  } else {
    events[content][1] = heading
  } // Add the heading exit at the end.

  events.push(['exit', heading, context])
  return events
}
/** @type {Tokenizer} */

function tokenizeSetextUnderline(effects, ok, nok) {
  const self = this
  let index = self.events.length
  /** @type {NonNullable<Code>} */

  let marker
  /** @type {boolean} */

  let paragraph // Find an opening.

  while (index--) {
    // Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (
      self.events[index][1].type !== 'lineEnding' &&
      self.events[index][1].type !== 'linePrefix' &&
      self.events[index][1].type !== 'content'
    ) {
      paragraph = self.events[index][1].type === 'paragraph'
      break
    }
  }

  return start
  /** @type {State} */

  function start(code) {
    if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
      effects.enter('setextHeadingLine')
      effects.enter('setextHeadingLineSequence')
      marker = code
      return closingSequence(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function closingSequence(code) {
    if (code === marker) {
      effects.consume(code)
      return closingSequence
    }

    effects.exit('setextHeadingLineSequence')
    return factorySpace(effects, closingSequenceEnd, 'lineSuffix')(code)
  }
  /** @type {State} */

  function closingSequenceEnd(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('setextHeadingLine')
      return ok(code)
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-html-tag-name/index.js
/**
 * List of lowercase HTML tag names which when parsing HTML (flow), result
 * in more relaxed rules (condition 6): because they are known blocks, the
 * HTML-like syntax doesn’t have to be strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 */
const htmlBlockNames = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'section',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
]

/**
 * List of lowercase HTML tag names which when parsing HTML (flow), result in
 * HTML that can include lines w/o exiting, until a closing tag also in this
 * list is found (condition 1).
 *
 * This module is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * Note that `textarea` was added in `CommonMark@0.30`.
 */
const htmlRawNames = ['pre', 'script', 'style', 'textarea']

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/html-flow.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */

const htmlFlow = {
  name: 'htmlFlow',
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
}
/** @type {Construct} */

const nextBlankConstruct = {
  tokenize: tokenizeNextBlank,
  partial: true
}
/** @type {Resolver} */

function resolveToHtmlFlow(events) {
  let index = events.length

  while (index--) {
    if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') {
      break
    }
  }

  if (index > 1 && events[index - 2][1].type === 'linePrefix') {
    // Add the prefix start to the HTML token.
    events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.

    events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.

    events.splice(index - 2, 2)
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeHtmlFlow(effects, ok, nok) {
  const self = this
  /** @type {number} */

  let kind
  /** @type {boolean} */

  let startTag
  /** @type {string} */

  let buffer
  /** @type {number} */

  let index
  /** @type {Code} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('htmlFlow')
    effects.enter('htmlFlowData')
    effects.consume(code)
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 33) {
      effects.consume(code)
      return declarationStart
    }

    if (code === 47) {
      effects.consume(code)
      return tagCloseStart
    }

    if (code === 63) {
      effects.consume(code)
      kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
      // right now, so we do need to search for `>`, similar to declarations.

      return self.interrupt ? ok : continuationDeclarationInside
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      buffer = String.fromCharCode(code)
      startTag = true
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function declarationStart(code) {
    if (code === 45) {
      effects.consume(code)
      kind = 2
      return commentOpenInside
    }

    if (code === 91) {
      effects.consume(code)
      kind = 5
      buffer = 'CDATA['
      index = 0
      return cdataOpenInside
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      kind = 4
      return self.interrupt ? ok : continuationDeclarationInside
    }

    return nok(code)
  }
  /** @type {State} */

  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code)
      return self.interrupt ? ok : continuationDeclarationInside
    }

    return nok(code)
  }
  /** @type {State} */

  function cdataOpenInside(code) {
    if (code === buffer.charCodeAt(index++)) {
      effects.consume(code)
      return index === buffer.length
        ? self.interrupt
          ? ok
          : continuation
        : cdataOpenInside
    }

    return nok(code)
  }
  /** @type {State} */

  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      buffer = String.fromCharCode(code)
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function tagName(code) {
    if (
      code === null ||
      code === 47 ||
      code === 62 ||
      markdownLineEndingOrSpace(code)
    ) {
      if (
        code !== 47 &&
        startTag &&
        htmlRawNames.includes(buffer.toLowerCase())
      ) {
        kind = 1
        return self.interrupt ? ok(code) : continuation(code)
      }

      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        kind = 6

        if (code === 47) {
          effects.consume(code)
          return basicSelfClosing
        }

        return self.interrupt ? ok(code) : continuation(code)
      }

      kind = 7 // Do not support complete HTML when interrupting

      return self.interrupt && !self.parser.lazy[self.now().line]
        ? nok(code)
        : startTag
        ? completeAttributeNameBefore(code)
        : completeClosingTagAfter(code)
    }

    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      buffer += String.fromCharCode(code)
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function basicSelfClosing(code) {
    if (code === 62) {
      effects.consume(code)
      return self.interrupt ? ok : continuation
    }

    return nok(code)
  }
  /** @type {State} */

  function completeClosingTagAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeClosingTagAfter
    }

    return completeEnd(code)
  }
  /** @type {State} */

  function completeAttributeNameBefore(code) {
    if (code === 47) {
      effects.consume(code)
      return completeEnd
    }

    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code)
      return completeAttributeName
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeNameBefore
    }

    return completeEnd(code)
  }
  /** @type {State} */

  function completeAttributeName(code) {
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return completeAttributeName
    }

    return completeAttributeNameAfter(code)
  }
  /** @type {State} */

  function completeAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code)
      return completeAttributeValueBefore
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeNameAfter
    }

    return completeAttributeNameBefore(code)
  }
  /** @type {State} */

  function completeAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 34 || code === 39) {
      effects.consume(code)
      marker = code
      return completeAttributeValueQuoted
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeValueBefore
    }

    marker = null
    return completeAttributeValueUnquoted(code)
  }
  /** @type {State} */

  function completeAttributeValueQuoted(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }

    if (code === marker) {
      effects.consume(code)
      return completeAttributeValueQuotedAfter
    }

    effects.consume(code)
    return completeAttributeValueQuoted
  }
  /** @type {State} */

  function completeAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96 ||
      markdownLineEndingOrSpace(code)
    ) {
      return completeAttributeNameAfter(code)
    }

    effects.consume(code)
    return completeAttributeValueUnquoted
  }
  /** @type {State} */

  function completeAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownSpace(code)) {
      return completeAttributeNameBefore(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function completeEnd(code) {
    if (code === 62) {
      effects.consume(code)
      return completeAfter
    }

    return nok(code)
  }
  /** @type {State} */

  function completeAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAfter
    }

    return code === null || markdownLineEnding(code)
      ? continuation(code)
      : nok(code)
  }
  /** @type {State} */

  function continuation(code) {
    if (code === 45 && kind === 2) {
      effects.consume(code)
      return continuationCommentInside
    }

    if (code === 60 && kind === 1) {
      effects.consume(code)
      return continuationRawTagOpen
    }

    if (code === 62 && kind === 4) {
      effects.consume(code)
      return continuationClose
    }

    if (code === 63 && kind === 3) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    if (code === 93 && kind === 5) {
      effects.consume(code)
      return continuationCharacterDataInside
    }

    if (markdownLineEnding(code) && (kind === 6 || kind === 7)) {
      return effects.check(
        nextBlankConstruct,
        continuationClose,
        continuationAtLineEnding
      )(code)
    }

    if (code === null || markdownLineEnding(code)) {
      return continuationAtLineEnding(code)
    }

    effects.consume(code)
    return continuation
  }
  /** @type {State} */

  function continuationAtLineEnding(code) {
    effects.exit('htmlFlowData')
    return htmlContinueStart(code)
  }
  /** @type {State} */

  function htmlContinueStart(code) {
    if (code === null) {
      return done(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(
        {
          tokenize: htmlLineEnd,
          partial: true
        },
        htmlContinueStart,
        done
      )(code)
    }

    effects.enter('htmlFlowData')
    return continuation(code)
  }
  /** @type {Tokenizer} */

  function htmlLineEnd(effects, ok, nok) {
    return start
    /** @type {State} */

    function start(code) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return lineStart
    }
    /** @type {State} */

    function lineStart(code) {
      return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
    }
  }
  /** @type {State} */

  function continuationCommentInside(code) {
    if (code === 45) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationRawTagOpen(code) {
    if (code === 47) {
      effects.consume(code)
      buffer = ''
      return continuationRawEndTag
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationRawEndTag(code) {
    if (code === 62 && htmlRawNames.includes(buffer.toLowerCase())) {
      effects.consume(code)
      return continuationClose
    }

    if (asciiAlpha(code) && buffer.length < 8) {
      effects.consume(code)
      buffer += String.fromCharCode(code)
      return continuationRawEndTag
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationCharacterDataInside(code) {
    if (code === 93) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationDeclarationInside(code) {
    if (code === 62) {
      effects.consume(code)
      return continuationClose
    } // More dashes.

    if (code === 45 && kind === 2) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationClose(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('htmlFlowData')
      return done(code)
    }

    effects.consume(code)
    return continuationClose
  }
  /** @type {State} */

  function done(code) {
    effects.exit('htmlFlow')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeNextBlank(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.exit('htmlFlowData')
    effects.enter('lineEndingBlank')
    effects.consume(code)
    effects.exit('lineEndingBlank')
    return effects.attempt(blankLine, ok, nok)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/code-fenced.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const codeFenced = {
  name: 'codeFenced',
  tokenize: tokenizeCodeFenced,
  concrete: true
}
/** @type {Tokenizer} */

function tokenizeCodeFenced(effects, ok, nok) {
  const self = this
  /** @type {Construct} */

  const closingFenceConstruct = {
    tokenize: tokenizeClosingFence,
    partial: true
  }
  /** @type {Construct} */

  const nonLazyLine = {
    tokenize: tokenizeNonLazyLine,
    partial: true
  }
  const tail = this.events[this.events.length - 1]
  const initialPrefix =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0
  let sizeOpen = 0
  /** @type {NonNullable<Code>} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeFenced')
    effects.enter('codeFencedFence')
    effects.enter('codeFencedFenceSequence')
    marker = code
    return sequenceOpen(code)
  }
  /** @type {State} */

  function sequenceOpen(code) {
    if (code === marker) {
      effects.consume(code)
      sizeOpen++
      return sequenceOpen
    }

    effects.exit('codeFencedFenceSequence')
    return sizeOpen < 3
      ? nok(code)
      : factorySpace(effects, infoOpen, 'whitespace')(code)
  }
  /** @type {State} */

  function infoOpen(code) {
    if (code === null || markdownLineEnding(code)) {
      return openAfter(code)
    }

    effects.enter('codeFencedFenceInfo')
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return info(code)
  }
  /** @type {State} */

  function info(code) {
    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceInfo')
      return factorySpace(effects, infoAfter, 'whitespace')(code)
    }

    if (code === 96 && code === marker) return nok(code)
    effects.consume(code)
    return info
  }
  /** @type {State} */

  function infoAfter(code) {
    if (code === null || markdownLineEnding(code)) {
      return openAfter(code)
    }

    effects.enter('codeFencedFenceMeta')
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return meta(code)
  }
  /** @type {State} */

  function meta(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceMeta')
      return openAfter(code)
    }

    if (code === 96 && code === marker) return nok(code)
    effects.consume(code)
    return meta
  }
  /** @type {State} */

  function openAfter(code) {
    effects.exit('codeFencedFence')
    return self.interrupt ? ok(code) : contentStart(code)
  }
  /** @type {State} */

  function contentStart(code) {
    if (code === null) {
      return after(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(
        nonLazyLine,
        effects.attempt(
          closingFenceConstruct,
          after,
          initialPrefix
            ? factorySpace(
                effects,
                contentStart,
                'linePrefix',
                initialPrefix + 1
              )
            : contentStart
        ),
        after
      )(code)
    }

    effects.enter('codeFlowValue')
    return contentContinue(code)
  }
  /** @type {State} */

  function contentContinue(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue')
      return contentStart(code)
    }

    effects.consume(code)
    return contentContinue
  }
  /** @type {State} */

  function after(code) {
    effects.exit('codeFenced')
    return ok(code)
  }
  /** @type {Tokenizer} */

  function tokenizeNonLazyLine(effects, ok, nok) {
    const self = this
    return start
    /** @type {State} */

    function start(code) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return lineStart
    }
    /** @type {State} */

    function lineStart(code) {
      return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
    }
  }
  /** @type {Tokenizer} */

  function tokenizeClosingFence(effects, ok, nok) {
    let size = 0
    return factorySpace(
      effects,
      closingSequenceStart,
      'linePrefix',
      this.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )
    /** @type {State} */

    function closingSequenceStart(code) {
      effects.enter('codeFencedFence')
      effects.enter('codeFencedFenceSequence')
      return closingSequence(code)
    }
    /** @type {State} */

    function closingSequence(code) {
      if (code === marker) {
        effects.consume(code)
        size++
        return closingSequence
      }

      if (size < sizeOpen) return nok(code)
      effects.exit('codeFencedFenceSequence')
      return factorySpace(effects, closingSequenceEnd, 'whitespace')(code)
    }
    /** @type {State} */

    function closingSequenceEnd(code) {
      if (code === null || markdownLineEnding(code)) {
        effects.exit('codeFencedFence')
        return ok(code)
      }

      return nok(code)
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/decode-named-character-reference/index.dom.js
/// <reference lib="dom" />

/* eslint-env browser */

const index_dom_element = document.createElement('i')

/**
 * @param {string} value
 * @returns {string|false}
 */
function decodeNamedCharacterReference(value) {
  const characterReference = '&' + value + ';'
  index_dom_element.innerHTML = characterReference
  const char = index_dom_element.textContent

  // Some named character references do not require the closing semicolon
  // (`&not`, for instance), which leads to situations where parsing the assumed
  // named reference of `&notit;` will result in the string `¬it;`.
  // When we encounter a trailing semicolon after parsing, and the character
  // reference to decode was not a semicolon (`&semi;`), we can assume that the
  // matching was not complete.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  if (char.charCodeAt(char.length - 1) === 59 /* `;` */ && value !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the character reference was
  // not valid.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  return char === characterReference ? false : char
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/character-reference.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const characterReference = {
  name: 'characterReference',
  tokenize: tokenizeCharacterReference
}
/** @type {Tokenizer} */

function tokenizeCharacterReference(effects, ok, nok) {
  const self = this
  let size = 0
  /** @type {number} */

  let max
  /** @type {(code: Code) => code is number} */

  let test
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('characterReference')
    effects.enter('characterReferenceMarker')
    effects.consume(code)
    effects.exit('characterReferenceMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 35) {
      effects.enter('characterReferenceMarkerNumeric')
      effects.consume(code)
      effects.exit('characterReferenceMarkerNumeric')
      return numeric
    }

    effects.enter('characterReferenceValue')
    max = 31
    test = asciiAlphanumeric
    return value(code)
  }
  /** @type {State} */

  function numeric(code) {
    if (code === 88 || code === 120) {
      effects.enter('characterReferenceMarkerHexadecimal')
      effects.consume(code)
      effects.exit('characterReferenceMarkerHexadecimal')
      effects.enter('characterReferenceValue')
      max = 6
      test = asciiHexDigit
      return value
    }

    effects.enter('characterReferenceValue')
    max = 7
    test = asciiDigit
    return value(code)
  }
  /** @type {State} */

  function value(code) {
    /** @type {Token} */
    let token

    if (code === 59 && size) {
      token = effects.exit('characterReferenceValue')

      if (
        test === asciiAlphanumeric &&
        !decodeNamedCharacterReference(self.sliceSerialize(token))
      ) {
        return nok(code)
      }

      effects.enter('characterReferenceMarker')
      effects.consume(code)
      effects.exit('characterReferenceMarker')
      effects.exit('characterReference')
      return ok
    }

    if (test(code) && size++ < max) {
      effects.consume(code)
      return value
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/character-escape.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const characterEscape = {
  name: 'characterEscape',
  tokenize: tokenizeCharacterEscape
}
/** @type {Tokenizer} */

function tokenizeCharacterEscape(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('characterEscape')
    effects.enter('escapeMarker')
    effects.consume(code)
    effects.exit('escapeMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (asciiPunctuation(code)) {
      effects.enter('characterEscapeValue')
      effects.consume(code)
      effects.exit('characterEscapeValue')
      effects.exit('characterEscape')
      return ok
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/line-ending.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const lineEnding = {
  name: 'lineEnding',
  tokenize: tokenizeLineEnding
}
/** @type {Tokenizer} */

function tokenizeLineEnding(effects, ok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, ok, 'linePrefix')
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/label-end.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */









/** @type {Construct} */
const labelEnd = {
  name: 'labelEnd',
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
}
/** @type {Construct} */

const resourceConstruct = {
  tokenize: tokenizeResource
}
/** @type {Construct} */

const fullReferenceConstruct = {
  tokenize: tokenizeFullReference
}
/** @type {Construct} */

const collapsedReferenceConstruct = {
  tokenize: tokenizeCollapsedReference
}
/** @type {Resolver} */

function resolveAllLabelEnd(events) {
  let index = -1
  /** @type {Token} */

  let token

  while (++index < events.length) {
    token = events[index][1]

    if (
      token.type === 'labelImage' ||
      token.type === 'labelLink' ||
      token.type === 'labelEnd'
    ) {
      // Remove the marker.
      events.splice(index + 1, token.type === 'labelImage' ? 4 : 2)
      token.type = 'data'
      index++
    }
  }

  return events
}
/** @type {Resolver} */

function resolveToLabelEnd(events, context) {
  let index = events.length
  let offset = 0
  /** @type {Token} */

  let token
  /** @type {number|undefined} */

  let open
  /** @type {number|undefined} */

  let close
  /** @type {Event[]} */

  let media // Find an opening.

  while (index--) {
    token = events[index][1]

    if (open) {
      // If we see another link, or inactive link label, we’ve been here before.
      if (
        token.type === 'link' ||
        (token.type === 'labelLink' && token._inactive)
      ) {
        break
      } // Mark other link openings as inactive, as we can’t have links in
      // links.

      if (events[index][0] === 'enter' && token.type === 'labelLink') {
        token._inactive = true
      }
    } else if (close) {
      if (
        events[index][0] === 'enter' &&
        (token.type === 'labelImage' || token.type === 'labelLink') &&
        !token._balanced
      ) {
        open = index

        if (token.type !== 'labelLink') {
          offset = 2
          break
        }
      }
    } else if (token.type === 'labelEnd') {
      close = index
    }
  }

  const group = {
    type: events[open][1].type === 'labelLink' ? 'link' : 'image',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }
  const label = {
    type: 'label',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[close][1].end)
  }
  const text = {
    type: 'labelText',
    start: Object.assign({}, events[open + offset + 2][1].end),
    end: Object.assign({}, events[close - 2][1].start)
  }
  media = [
    ['enter', group, context],
    ['enter', label, context]
  ] // Opening marker.

  media = push(media, events.slice(open + 1, open + offset + 3)) // Text open.

  media = push(media, [['enter', text, context]]) // Between.

  media = push(
    media,
    resolveAll(
      context.parser.constructs.insideSpan.null,
      events.slice(open + offset + 4, close - 3),
      context
    )
  ) // Text close, marker close, label close.

  media = push(media, [
    ['exit', text, context],
    events[close - 2],
    events[close - 1],
    ['exit', label, context]
  ]) // Reference, resource, or so.

  media = push(media, events.slice(close + 1)) // Media close.

  media = push(media, [['exit', group, context]])
  splice(events, open, events.length, media)
  return events
}
/** @type {Tokenizer} */

function tokenizeLabelEnd(effects, ok, nok) {
  const self = this
  let index = self.events.length
  /** @type {Token} */

  let labelStart
  /** @type {boolean} */

  let defined // Find an opening.

  while (index--) {
    if (
      (self.events[index][1].type === 'labelImage' ||
        self.events[index][1].type === 'labelLink') &&
      !self.events[index][1]._balanced
    ) {
      labelStart = self.events[index][1]
      break
    }
  }

  return start
  /** @type {State} */

  function start(code) {
    if (!labelStart) {
      return nok(code)
    } // It’s a balanced bracket, but contains a link.

    if (labelStart._inactive) return balanced(code)
    defined = self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize({
          start: labelStart.end,
          end: self.now()
        })
      )
    )
    effects.enter('labelEnd')
    effects.enter('labelMarker')
    effects.consume(code)
    effects.exit('labelMarker')
    effects.exit('labelEnd')
    return afterLabelEnd
  }
  /** @type {State} */

  function afterLabelEnd(code) {
    // Resource: `[asd](fgh)`.
    if (code === 40) {
      return effects.attempt(
        resourceConstruct,
        ok,
        defined ? ok : balanced
      )(code)
    } // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?

    if (code === 91) {
      return effects.attempt(
        fullReferenceConstruct,
        ok,
        defined
          ? effects.attempt(collapsedReferenceConstruct, ok, balanced)
          : balanced
      )(code)
    } // Shortcut reference: `[asd]`?

    return defined ? ok(code) : balanced(code)
  }
  /** @type {State} */

  function balanced(code) {
    labelStart._balanced = true
    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeResource(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('resource')
    effects.enter('resourceMarker')
    effects.consume(code)
    effects.exit('resourceMarker')
    return factoryWhitespace(effects, open)
  }
  /** @type {State} */

  function open(code) {
    if (code === 41) {
      return end(code)
    }

    return factoryDestination(
      effects,
      destinationAfter,
      nok,
      'resourceDestination',
      'resourceDestinationLiteral',
      'resourceDestinationLiteralMarker',
      'resourceDestinationRaw',
      'resourceDestinationString',
      32
    )(code)
  }
  /** @type {State} */

  function destinationAfter(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, between)(code)
      : end(code)
  }
  /** @type {State} */

  function between(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(
        effects,
        factoryWhitespace(effects, end),
        nok,
        'resourceTitle',
        'resourceTitleMarker',
        'resourceTitleString'
      )(code)
    }

    return end(code)
  }
  /** @type {State} */

  function end(code) {
    if (code === 41) {
      effects.enter('resourceMarker')
      effects.consume(code)
      effects.exit('resourceMarker')
      effects.exit('resource')
      return ok
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeFullReference(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    return factoryLabel.call(
      self,
      effects,
      afterLabel,
      nok,
      'reference',
      'referenceMarker',
      'referenceString'
    )(code)
  }
  /** @type {State} */

  function afterLabel(code) {
    return self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
      )
    )
      ? ok(code)
      : nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeCollapsedReference(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('reference')
    effects.enter('referenceMarker')
    effects.consume(code)
    effects.exit('referenceMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 93) {
      effects.enter('referenceMarker')
      effects.consume(code)
      effects.exit('referenceMarker')
      effects.exit('reference')
      return ok
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/label-start-image.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */

const labelStartImage = {
  name: 'labelStartImage',
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd.resolveAll
}
/** @type {Tokenizer} */

function tokenizeLabelStartImage(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('labelImage')
    effects.enter('labelImageMarker')
    effects.consume(code)
    effects.exit('labelImageMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 91) {
      effects.enter('labelMarker')
      effects.consume(code)
      effects.exit('labelMarker')
      effects.exit('labelImage')
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */

    /* Hidden footnotes hook */

    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-classify-character/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 */


/**
 * Classify whether a character code represents whitespace, punctuation, or
 * something else.
 *
 * Used for attention (emphasis, strong), whose sequences can open or close
 * based on the class of surrounding characters.
 *
 * Note that eof (`null`) is seen as whitespace.
 *
 * @param {Code} code
 * @returns {number|undefined}
 */
function classifyCharacter(code) {
  if (
    code === null ||
    markdownLineEndingOrSpace(code) ||
    unicodeWhitespace(code)
  ) {
    return 1
  }

  if (unicodePunctuation(code)) {
    return 2
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/attention.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Point} Point
 */




/** @type {Construct} */
const attention = {
  name: 'attention',
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
}
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */

function resolveAllAttention(events, context) {
  let index = -1
  /** @type {number} */

  let open
  /** @type {Token} */

  let group
  /** @type {Token} */

  let text
  /** @type {Token} */

  let openingSequence
  /** @type {Token} */

  let closingSequence
  /** @type {number} */

  let use
  /** @type {Event[]} */

  let nextEvents
  /** @type {number} */

  let offset // Walk through all events.
  //
  // Note: performance of this is fine on an mb of normal markdown, but it’s
  // a bottleneck for malicious stuff.

  while (++index < events.length) {
    // Find a token that can close.
    if (
      events[index][0] === 'enter' &&
      events[index][1].type === 'attentionSequence' &&
      events[index][1]._close
    ) {
      open = index // Now walk back to find an opener.

      while (open--) {
        // Find a token that can open the closer.
        if (
          events[open][0] === 'exit' &&
          events[open][1].type === 'attentionSequence' &&
          events[open][1]._open && // If the markers are the same:
          context.sliceSerialize(events[open][1]).charCodeAt(0) ===
            context.sliceSerialize(events[index][1]).charCodeAt(0)
        ) {
          // If the opening can close or the closing can open,
          // and the close size *is not* a multiple of three,
          // but the sum of the opening and closing size *is* multiple of three,
          // then don’t match.
          if (
            (events[open][1]._close || events[index][1]._open) &&
            (events[index][1].end.offset - events[index][1].start.offset) % 3 &&
            !(
              (events[open][1].end.offset -
                events[open][1].start.offset +
                events[index][1].end.offset -
                events[index][1].start.offset) %
              3
            )
          ) {
            continue
          } // Number of markers to use from the sequence.

          use =
            events[open][1].end.offset - events[open][1].start.offset > 1 &&
            events[index][1].end.offset - events[index][1].start.offset > 1
              ? 2
              : 1
          const start = Object.assign({}, events[open][1].end)
          const end = Object.assign({}, events[index][1].start)
          movePoint(start, -use)
          movePoint(end, use)
          openingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start,
            end: Object.assign({}, events[open][1].end)
          }
          closingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start: Object.assign({}, events[index][1].start),
            end
          }
          text = {
            type: use > 1 ? 'strongText' : 'emphasisText',
            start: Object.assign({}, events[open][1].end),
            end: Object.assign({}, events[index][1].start)
          }
          group = {
            type: use > 1 ? 'strong' : 'emphasis',
            start: Object.assign({}, openingSequence.start),
            end: Object.assign({}, closingSequence.end)
          }
          events[open][1].end = Object.assign({}, openingSequence.start)
          events[index][1].start = Object.assign({}, closingSequence.end)
          nextEvents = [] // If there are more markers in the opening, add them before.

          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = push(nextEvents, [
              ['enter', events[open][1], context],
              ['exit', events[open][1], context]
            ])
          } // Opening.

          nextEvents = push(nextEvents, [
            ['enter', group, context],
            ['enter', openingSequence, context],
            ['exit', openingSequence, context],
            ['enter', text, context]
          ]) // Between.

          nextEvents = push(
            nextEvents,
            resolveAll(
              context.parser.constructs.insideSpan.null,
              events.slice(open + 1, index),
              context
            )
          ) // Closing.

          nextEvents = push(nextEvents, [
            ['exit', text, context],
            ['enter', closingSequence, context],
            ['exit', closingSequence, context],
            ['exit', group, context]
          ]) // If there are more markers in the closing, add them after.

          if (events[index][1].end.offset - events[index][1].start.offset) {
            offset = 2
            nextEvents = push(nextEvents, [
              ['enter', events[index][1], context],
              ['exit', events[index][1], context]
            ])
          } else {
            offset = 0
          }

          splice(events, open - 1, index - open + 3, nextEvents)
          index = open + nextEvents.length - offset - 2
          break
        }
      }
    }
  } // Remove remaining sequences.

  index = -1

  while (++index < events.length) {
    if (events[index][1].type === 'attentionSequence') {
      events[index][1].type = 'data'
    }
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeAttention(effects, ok) {
  const attentionMarkers = this.parser.constructs.attentionMarkers.null
  const previous = this.previous
  const before = classifyCharacter(previous)
  /** @type {NonNullable<Code>} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('attentionSequence')
    marker = code
    return sequence(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === marker) {
      effects.consume(code)
      return sequence
    }

    const token = effects.exit('attentionSequence')
    const after = classifyCharacter(code)
    const open =
      !after || (after === 2 && before) || attentionMarkers.includes(code)
    const close =
      !before || (before === 2 && after) || attentionMarkers.includes(previous)
    token._open = Boolean(marker === 42 ? open : open && (before || !close))
    token._close = Boolean(marker === 42 ? close : close && (after || !open))
    return ok(code)
  }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */

function movePoint(point, offset) {
  point.column += offset
  point.offset += offset
  point._bufferIndex += offset
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/autolink.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const autolink = {
  name: 'autolink',
  tokenize: tokenizeAutolink
}
/** @type {Tokenizer} */

function tokenizeAutolink(effects, ok, nok) {
  let size = 1
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('autolink')
    effects.enter('autolinkMarker')
    effects.consume(code)
    effects.exit('autolinkMarker')
    effects.enter('autolinkProtocol')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      return schemeOrEmailAtext
    }

    return asciiAtext(code) ? emailAtext(code) : nok(code)
  }
  /** @type {State} */

  function schemeOrEmailAtext(code) {
    return code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)
      ? schemeInsideOrEmailAtext(code)
      : emailAtext(code)
  }
  /** @type {State} */

  function schemeInsideOrEmailAtext(code) {
    if (code === 58) {
      effects.consume(code)
      return urlInside
    }

    if (
      (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) &&
      size++ < 32
    ) {
      effects.consume(code)
      return schemeInsideOrEmailAtext
    }

    return emailAtext(code)
  }
  /** @type {State} */

  function urlInside(code) {
    if (code === 62) {
      effects.exit('autolinkProtocol')
      return end(code)
    }

    if (code === null || code === 32 || code === 60 || asciiControl(code)) {
      return nok(code)
    }

    effects.consume(code)
    return urlInside
  }
  /** @type {State} */

  function emailAtext(code) {
    if (code === 64) {
      effects.consume(code)
      size = 0
      return emailAtSignOrDot
    }

    if (asciiAtext(code)) {
      effects.consume(code)
      return emailAtext
    }

    return nok(code)
  }
  /** @type {State} */

  function emailAtSignOrDot(code) {
    return asciiAlphanumeric(code) ? emailLabel(code) : nok(code)
  }
  /** @type {State} */

  function emailLabel(code) {
    if (code === 46) {
      effects.consume(code)
      size = 0
      return emailAtSignOrDot
    }

    if (code === 62) {
      // Exit, then change the type.
      effects.exit('autolinkProtocol').type = 'autolinkEmail'
      return end(code)
    }

    return emailValue(code)
  }
  /** @type {State} */

  function emailValue(code) {
    if ((code === 45 || asciiAlphanumeric(code)) && size++ < 63) {
      effects.consume(code)
      return code === 45 ? emailValue : emailLabel
    }

    return nok(code)
  }
  /** @type {State} */

  function end(code) {
    effects.enter('autolinkMarker')
    effects.consume(code)
    effects.exit('autolinkMarker')
    effects.exit('autolink')
    return ok
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/html-text.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const htmlText = {
  name: 'htmlText',
  tokenize: tokenizeHtmlText
}
/** @type {Tokenizer} */

function tokenizeHtmlText(effects, ok, nok) {
  const self = this
  /** @type {NonNullable<Code>|undefined} */

  let marker
  /** @type {string} */

  let buffer
  /** @type {number} */

  let index
  /** @type {State} */

  let returnState
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('htmlText')
    effects.enter('htmlTextData')
    effects.consume(code)
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 33) {
      effects.consume(code)
      return declarationOpen
    }

    if (code === 47) {
      effects.consume(code)
      return tagCloseStart
    }

    if (code === 63) {
      effects.consume(code)
      return instruction
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      return tagOpen
    }

    return nok(code)
  }
  /** @type {State} */

  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code)
      return commentOpen
    }

    if (code === 91) {
      effects.consume(code)
      buffer = 'CDATA['
      index = 0
      return cdataOpen
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      return declaration
    }

    return nok(code)
  }
  /** @type {State} */

  function commentOpen(code) {
    if (code === 45) {
      effects.consume(code)
      return commentStart
    }

    return nok(code)
  }
  /** @type {State} */

  function commentStart(code) {
    if (code === null || code === 62) {
      return nok(code)
    }

    if (code === 45) {
      effects.consume(code)
      return commentStartDash
    }

    return comment(code)
  }
  /** @type {State} */

  function commentStartDash(code) {
    if (code === null || code === 62) {
      return nok(code)
    }

    return comment(code)
  }
  /** @type {State} */

  function comment(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 45) {
      effects.consume(code)
      return commentClose
    }

    if (markdownLineEnding(code)) {
      returnState = comment
      return atLineEnding(code)
    }

    effects.consume(code)
    return comment
  }
  /** @type {State} */

  function commentClose(code) {
    if (code === 45) {
      effects.consume(code)
      return end
    }

    return comment(code)
  }
  /** @type {State} */

  function cdataOpen(code) {
    if (code === buffer.charCodeAt(index++)) {
      effects.consume(code)
      return index === buffer.length ? cdata : cdataOpen
    }

    return nok(code)
  }
  /** @type {State} */

  function cdata(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 93) {
      effects.consume(code)
      return cdataClose
    }

    if (markdownLineEnding(code)) {
      returnState = cdata
      return atLineEnding(code)
    }

    effects.consume(code)
    return cdata
  }
  /** @type {State} */

  function cdataClose(code) {
    if (code === 93) {
      effects.consume(code)
      return cdataEnd
    }

    return cdata(code)
  }
  /** @type {State} */

  function cdataEnd(code) {
    if (code === 62) {
      return end(code)
    }

    if (code === 93) {
      effects.consume(code)
      return cdataEnd
    }

    return cdata(code)
  }
  /** @type {State} */

  function declaration(code) {
    if (code === null || code === 62) {
      return end(code)
    }

    if (markdownLineEnding(code)) {
      returnState = declaration
      return atLineEnding(code)
    }

    effects.consume(code)
    return declaration
  }
  /** @type {State} */

  function instruction(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 63) {
      effects.consume(code)
      return instructionClose
    }

    if (markdownLineEnding(code)) {
      returnState = instruction
      return atLineEnding(code)
    }

    effects.consume(code)
    return instruction
  }
  /** @type {State} */

  function instructionClose(code) {
    return code === 62 ? end(code) : instruction(code)
  }
  /** @type {State} */

  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      return tagClose
    }

    return nok(code)
  }
  /** @type {State} */

  function tagClose(code) {
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return tagClose
    }

    return tagCloseBetween(code)
  }
  /** @type {State} */

  function tagCloseBetween(code) {
    if (markdownLineEnding(code)) {
      returnState = tagCloseBetween
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagCloseBetween
    }

    return end(code)
  }
  /** @type {State} */

  function tagOpen(code) {
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return tagOpen
    }

    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function tagOpenBetween(code) {
    if (code === 47) {
      effects.consume(code)
      return end
    }

    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code)
      return tagOpenAttributeName
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenBetween
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenBetween
    }

    return end(code)
  }
  /** @type {State} */

  function tagOpenAttributeName(code) {
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return tagOpenAttributeName
    }

    return tagOpenAttributeNameAfter(code)
  }
  /** @type {State} */

  function tagOpenAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code)
      return tagOpenAttributeValueBefore
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeNameAfter
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenAttributeNameAfter
    }

    return tagOpenBetween(code)
  }
  /** @type {State} */

  function tagOpenAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 34 || code === 39) {
      effects.consume(code)
      marker = code
      return tagOpenAttributeValueQuoted
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueBefore
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenAttributeValueBefore
    }

    effects.consume(code)
    marker = undefined
    return tagOpenAttributeValueUnquoted
  }
  /** @type {State} */

  function tagOpenAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code)
      return tagOpenAttributeValueQuotedAfter
    }

    if (code === null) {
      return nok(code)
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueQuoted
      return atLineEnding(code)
    }

    effects.consume(code)
    return tagOpenAttributeValueQuoted
  }
  /** @type {State} */

  function tagOpenAttributeValueQuotedAfter(code) {
    if (code === 62 || code === 47 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function tagOpenAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    effects.consume(code)
    return tagOpenAttributeValueUnquoted
  } // We can’t have blank lines in content, so no need to worry about empty
  // tokens.

  /** @type {State} */

  function atLineEnding(code) {
    effects.exit('htmlTextData')
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(
      effects,
      afterPrefix,
      'linePrefix',
      self.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )
  }
  /** @type {State} */

  function afterPrefix(code) {
    effects.enter('htmlTextData')
    return returnState(code)
  }
  /** @type {State} */

  function end(code) {
    if (code === 62) {
      effects.consume(code)
      effects.exit('htmlTextData')
      effects.exit('htmlText')
      return ok
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/label-start-link.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */

const labelStartLink = {
  name: 'labelStartLink',
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
}
/** @type {Tokenizer} */

function tokenizeLabelStartLink(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('labelLink')
    effects.enter('labelMarker')
    effects.consume(code)
    effects.exit('labelMarker')
    effects.exit('labelLink')
    return after
  }
  /** @type {State} */

  function after(code) {
    /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */

    /* Hidden footnotes hook. */

    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/hard-break-escape.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const hardBreakEscape = {
  name: 'hardBreakEscape',
  tokenize: tokenizeHardBreakEscape
}
/** @type {Tokenizer} */

function tokenizeHardBreakEscape(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('hardBreakEscape')
    effects.enter('escapeMarker')
    effects.consume(code)
    return open
  }
  /** @type {State} */

  function open(code) {
    if (markdownLineEnding(code)) {
      effects.exit('escapeMarker')
      effects.exit('hardBreakEscape')
      return ok(code)
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/code-text.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const codeText = {
  name: 'codeText',
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous
}
/** @type {Resolver} */

function resolveCodeText(events) {
  let tailExitIndex = events.length - 4
  let headEnterIndex = 3
  /** @type {number} */

  let index
  /** @type {number|undefined} */

  let enter // If we start and end with an EOL or a space.

  if (
    (events[headEnterIndex][1].type === 'lineEnding' ||
      events[headEnterIndex][1].type === 'space') &&
    (events[tailExitIndex][1].type === 'lineEnding' ||
      events[tailExitIndex][1].type === 'space')
  ) {
    index = headEnterIndex // And we have data.

    while (++index < tailExitIndex) {
      if (events[index][1].type === 'codeTextData') {
        // Then we have padding.
        events[headEnterIndex][1].type = 'codeTextPadding'
        events[tailExitIndex][1].type = 'codeTextPadding'
        headEnterIndex += 2
        tailExitIndex -= 2
        break
      }
    }
  } // Merge adjacent spaces and data.

  index = headEnterIndex - 1
  tailExitIndex++

  while (++index <= tailExitIndex) {
    if (enter === undefined) {
      if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') {
        enter = index
      }
    } else if (
      index === tailExitIndex ||
      events[index][1].type === 'lineEnding'
    ) {
      events[enter][1].type = 'codeTextData'

      if (index !== enter + 2) {
        events[enter][1].end = events[index - 1][1].end
        events.splice(enter + 2, index - enter - 2)
        tailExitIndex -= index - enter - 2
        index = enter + 2
      }

      enter = undefined
    }
  }

  return events
}
/** @type {Previous} */

function previous(code) {
  // If there is a previous code, there will always be a tail.
  return (
    code !== 96 ||
    this.events[this.events.length - 1][1].type === 'characterEscape'
  )
}
/** @type {Tokenizer} */

function tokenizeCodeText(effects, ok, nok) {
  const self = this
  let sizeOpen = 0
  /** @type {number} */

  let size
  /** @type {Token} */

  let token
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeText')
    effects.enter('codeTextSequence')
    return openingSequence(code)
  }
  /** @type {State} */

  function openingSequence(code) {
    if (code === 96) {
      effects.consume(code)
      sizeOpen++
      return openingSequence
    }

    effects.exit('codeTextSequence')
    return gap(code)
  }
  /** @type {State} */

  function gap(code) {
    // EOF.
    if (code === null) {
      return nok(code)
    } // Closing fence?
    // Could also be data.

    if (code === 96) {
      token = effects.enter('codeTextSequence')
      size = 0
      return closingSequence(code)
    } // Tabs don’t work, and virtual spaces don’t make sense.

    if (code === 32) {
      effects.enter('space')
      effects.consume(code)
      effects.exit('space')
      return gap
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return gap
    } // Data.

    effects.enter('codeTextData')
    return data(code)
  } // In code.

  /** @type {State} */

  function data(code) {
    if (
      code === null ||
      code === 32 ||
      code === 96 ||
      markdownLineEnding(code)
    ) {
      effects.exit('codeTextData')
      return gap(code)
    }

    effects.consume(code)
    return data
  } // Closing fence.

  /** @type {State} */

  function closingSequence(code) {
    // More.
    if (code === 96) {
      effects.consume(code)
      size++
      return closingSequence
    } // Done!

    if (size === sizeOpen) {
      effects.exit('codeTextSequence')
      effects.exit('codeText')
      return ok(code)
    } // More or less accents: mark as data.

    token.type = 'codeTextData'
    return data(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/constructs.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */


/** @type {Extension['document']} */

const constructs_document = {
  [42]: list,
  [43]: list,
  [45]: list,
  [48]: list,
  [49]: list,
  [50]: list,
  [51]: list,
  [52]: list,
  [53]: list,
  [54]: list,
  [55]: list,
  [56]: list,
  [57]: list,
  [62]: blockQuote
}
/** @type {Extension['contentInitial']} */

const contentInitial = {
  [91]: definition
}
/** @type {Extension['flowInitial']} */

const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
}
/** @type {Extension['flow']} */

const constructs_flow = {
  [35]: headingAtx,
  [42]: thematicBreak,
  [45]: [setextUnderline, thematicBreak],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak,
  [96]: codeFenced,
  [126]: codeFenced
}
/** @type {Extension['string']} */

const constructs_string = {
  [38]: characterReference,
  [92]: characterEscape
}
/** @type {Extension['text']} */

const constructs_text = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
}
/** @type {Extension['insideSpan']} */

const insideSpan = {
  null: [attention, resolver]
}
/** @type {Extension['attentionMarkers']} */

const attentionMarkers = {
  null: [42, 95]
}
/** @type {Extension['disable']} */

const disable = {
  null: []
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/parse.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Create} Create
 */







/**
 * @param {ParseOptions} [options]
 * @returns {ParseContext}
 */

function parse(options = {}) {
  /** @type {FullNormalizedExtension} */
  // @ts-expect-error `defaultConstructs` is full, so the result will be too.
  const constructs = combineExtensions(
    // @ts-expect-error Same as above.
    [constructs_namespaceObject].concat(options.extensions || [])
  )
  /** @type {ParseContext} */

  const parser = {
    defined: [],
    lazy: {},
    constructs,
    content: create(content),
    document: create(document_document),
    flow: create(flow),
    string: create(string),
    text: create(text_text)
  }
  return parser
  /**
   * @param {InitialConstruct} initial
   */

  function create(initial) {
    return creator
    /** @type {Create} */

    function creator(from) {
      return createTokenizer(parser, initial, from)
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/preprocess.js
/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding} [encoding]
 * @param {boolean} [end=false]
 * @returns {Array<Chunk>}
 */
const search = /[\0\t\n\r]/g
/**
 * @returns {Preprocessor}
 */

function preprocess() {
  let column = 1
  let buffer = ''
  /** @type {boolean|undefined} */

  let start = true
  /** @type {boolean|undefined} */

  let atCarriageReturn
  return preprocessor
  /** @type {Preprocessor} */

  function preprocessor(value, encoding, end) {
    /** @type {Array<Chunk>} */
    const chunks = []
    /** @type {RegExpMatchArray|null} */

    let match
    /** @type {number} */

    let next
    /** @type {number} */

    let startPosition
    /** @type {number} */

    let endPosition
    /** @type {Code} */

    let code // @ts-expect-error `Buffer` does allow an encoding.

    value = buffer + value.toString(encoding)
    startPosition = 0
    buffer = ''

    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++
      }

      start = undefined
    }

    while (startPosition < value.length) {
      search.lastIndex = startPosition
      match = search.exec(value)
      endPosition =
        match && match.index !== undefined ? match.index : value.length
      code = value.charCodeAt(endPosition)

      if (!match) {
        buffer = value.slice(startPosition)
        break
      }

      if (code === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3)
        atCarriageReturn = undefined
      } else {
        if (atCarriageReturn) {
          chunks.push(-5)
          atCarriageReturn = undefined
        }

        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition))
          column += endPosition - startPosition
        }

        switch (code) {
          case 0: {
            chunks.push(65533)
            column++
            break
          }

          case 9: {
            next = Math.ceil(column / 4) * 4
            chunks.push(-2)

            while (column++ < next) chunks.push(-1)

            break
          }

          case 10: {
            chunks.push(-4)
            column = 1
            break
          }

          default: {
            atCarriageReturn = true
            column = 1
          }
        }
      }

      startPosition = endPosition + 1
    }

    if (end) {
      if (atCarriageReturn) chunks.push(-5)
      if (buffer) chunks.push(buffer)
      chunks.push(null)
    }

    return chunks
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/postprocess.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */

/**
 * @param {Array<Event>} events
 * @returns {Array<Event>}
 */

function postprocess(events) {
  while (!subtokenize(events)) {
    // Empty
  }

  return events
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-decode-numeric-character-reference/index.js
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 */
function decodeNumericCharacterReference(value, base) {
  const code = Number.parseInt(value, base)

  if (
    // C0 except for HT, LF, FF, CR, space
    code < 9 ||
    code === 11 ||
    (code > 13 && code < 32) || // Control character (DEL) of the basic block and C1 controls.
    (code > 126 && code < 160) || // Lone high surrogates and low surrogates.
    (code > 55295 && code < 57344) || // Noncharacters.
    (code > 64975 && code < 65008) ||
    (code & 65535) === 65535 ||
    (code & 65535) === 65534 || // Out of range
    code > 1114111
  ) {
    return '\uFFFD'
  }

  return String.fromCharCode(code)
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-decode-string/index.js


const characterEscapeOrReference =
  /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi
/**
 * Utility to decode markdown strings (which occur in places such as fenced
 * code info strings, destinations, labels, and titles).
 * The “string” content type allows character escapes and -references.
 * This decodes those.
 *
 * @param {string} value
 * @returns {string}
 */

function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode)
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */

function decode($0, $1, $2) {
  if ($1) {
    // Escape.
    return $1
  } // Reference.

  const head = $2.charCodeAt(0)

  if (head === 35) {
    const head = $2.charCodeAt(1)
    const hex = head === 120 || head === 88
    return decodeNumericCharacterReference($2.slice(hex ? 2 : 1), hex ? 16 : 10)
  }

  return decodeNamedCharacterReference($2) || $0
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-from-markdown/lib/index.js
/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {Root|Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 *
 * @typedef {UnistParent & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */

/**
 * @typedef _CompileDataFields
 * @property {boolean|undefined} expectingFirstListItemValue
 * @property {boolean|undefined} flowCodeInside
 * @property {boolean|undefined} setextHeadingSlurpLineEnding
 * @property {boolean|undefined} atHardBreak
 * @property {'collapsed'|'full'} referenceType
 * @property {boolean|undefined} inReference
 * @property {'characterReferenceMarkerHexadecimal'|'characterReferenceMarkerNumeric'} characterReferenceType
 *
 * @typedef {Record<string, unknown> & Partial<_CompileDataFields>} CompileData
 *
 * @typedef {(tree: Root) => Root|void} Transform
 * @typedef {(this: CompileContext, token: Token) => void} Handle
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 * @typedef {Record<string, Record<string, unknown>|Array<unknown>> & {canContainEols: Array<string>, transforms: Array<Transform>, enter: Handles, exit: Handles}} NormalizedExtension
 * @typedef {Partial<NormalizedExtension>} Extension
 *   An mdast extension changes how markdown tokens are turned into mdast.
 *
 * @typedef {(this: Omit<CompileContext, 'sliceSerialize'>, left: Token|undefined, right: Token) => void} OnEnterError
 * @typedef {(this: Omit<CompileContext, 'sliceSerialize'>, left: Token, right: Token) => void} OnExitError
 *
 * @typedef CompileContext
 *   mdast compiler context
 * @property {Array<Node | Fragment>} stack
 * @property {Array<[Token, OnEnterError|undefined]>} tokenStack
 * @property {(key: string, value?: unknown) => void} setData
 *   Set data into the key-value store.
 * @property {<K extends string>(key: K) => CompileData[K]} getData
 *   Get data from the key-value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<N extends Node>(this: CompileContext, node: N, token: Token, onError?: OnEnterError) => N} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {NormalizedExtension} config
 *   Configuration.
 *
 * @typedef {{mdastExtensions?: Array<Extension|Array<Extension>>}} FromMarkdownOptions
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 */









const lib_own = {}.hasOwnProperty
/**
 * @param value Markdown to parse (`string` or `Buffer`).
 * @param [encoding] Character encoding to understand `value` as when it’s a `Buffer` (`string`, default: `'utf8'`).
 * @param [options] Configuration
 */

const fromMarkdown =
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options) => Root) &
   *   ((value: Value, options?: Options) => Root)
   * )}
   */

  /**
   * @param {Value} value
   * @param {Encoding} [encoding]
   * @param {Options} [options]
   * @returns {Root}
   */
  function (value, encoding, options) {
    if (typeof encoding !== 'string') {
      options = encoding
      encoding = undefined
    }

    return compiler(options)(
      postprocess(
        parse(options).document().write(preprocess()(value, encoding, true))
      )
    )
  }
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options} [options]
 */

function compiler(options = {}) {
  /** @type {NormalizedExtension} */
  // @ts-expect-error: our base has all required fields, so the result will too.
  const config = configure(
    {
      transforms: [],
      canContainEols: [
        'emphasis',
        'fragment',
        'heading',
        'paragraph',
        'strong'
      ],
      enter: {
        autolink: opener(link),
        autolinkProtocol: onenterdata,
        autolinkEmail: onenterdata,
        atxHeading: opener(heading),
        blockQuote: opener(blockQuote),
        characterEscape: onenterdata,
        characterReference: onenterdata,
        codeFenced: opener(codeFlow),
        codeFencedFenceInfo: buffer,
        codeFencedFenceMeta: buffer,
        codeIndented: opener(codeFlow, buffer),
        codeText: opener(codeText, buffer),
        codeTextData: onenterdata,
        data: onenterdata,
        codeFlowValue: onenterdata,
        definition: opener(definition),
        definitionDestinationString: buffer,
        definitionLabelString: buffer,
        definitionTitleString: buffer,
        emphasis: opener(emphasis),
        hardBreakEscape: opener(hardBreak),
        hardBreakTrailing: opener(hardBreak),
        htmlFlow: opener(html, buffer),
        htmlFlowData: onenterdata,
        htmlText: opener(html, buffer),
        htmlTextData: onenterdata,
        image: opener(image),
        label: buffer,
        link: opener(link),
        listItem: opener(listItem),
        listItemValue: onenterlistitemvalue,
        listOrdered: opener(list, onenterlistordered),
        listUnordered: opener(list),
        paragraph: opener(paragraph),
        reference: onenterreference,
        referenceString: buffer,
        resourceDestinationString: buffer,
        resourceTitleString: buffer,
        setextHeading: opener(heading),
        strong: opener(strong),
        thematicBreak: opener(thematicBreak)
      },
      exit: {
        atxHeading: closer(),
        atxHeadingSequence: onexitatxheadingsequence,
        autolink: closer(),
        autolinkEmail: onexitautolinkemail,
        autolinkProtocol: onexitautolinkprotocol,
        blockQuote: closer(),
        characterEscapeValue: onexitdata,
        characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
        characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
        characterReferenceValue: onexitcharacterreferencevalue,
        codeFenced: closer(onexitcodefenced),
        codeFencedFence: onexitcodefencedfence,
        codeFencedFenceInfo: onexitcodefencedfenceinfo,
        codeFencedFenceMeta: onexitcodefencedfencemeta,
        codeFlowValue: onexitdata,
        codeIndented: closer(onexitcodeindented),
        codeText: closer(onexitcodetext),
        codeTextData: onexitdata,
        data: onexitdata,
        definition: closer(),
        definitionDestinationString: onexitdefinitiondestinationstring,
        definitionLabelString: onexitdefinitionlabelstring,
        definitionTitleString: onexitdefinitiontitlestring,
        emphasis: closer(),
        hardBreakEscape: closer(onexithardbreak),
        hardBreakTrailing: closer(onexithardbreak),
        htmlFlow: closer(onexithtmlflow),
        htmlFlowData: onexitdata,
        htmlText: closer(onexithtmltext),
        htmlTextData: onexitdata,
        image: closer(onexitimage),
        label: onexitlabel,
        labelText: onexitlabeltext,
        lineEnding: onexitlineending,
        link: closer(onexitlink),
        listItem: closer(),
        listOrdered: closer(),
        listUnordered: closer(),
        paragraph: closer(),
        referenceString: onexitreferencestring,
        resourceDestinationString: onexitresourcedestinationstring,
        resourceTitleString: onexitresourcetitlestring,
        resource: onexitresource,
        setextHeading: closer(onexitsetextheading),
        setextHeadingLineSequence: onexitsetextheadinglinesequence,
        setextHeadingText: onexitsetextheadingtext,
        strong: closer(),
        thematicBreak: closer()
      }
    },
    options.mdastExtensions || []
  )
  /** @type {CompileData} */

  const data = {}
  return compile
  /**
   * @param {Array<Event>} events
   * @returns {Root}
   */

  function compile(events) {
    /** @type {Root} */
    let tree = {
      type: 'root',
      children: []
    }
    /** @type {CompileContext['stack']} */

    const stack = [tree]
    /** @type {CompileContext['tokenStack']} */

    const tokenStack = []
    /** @type {Array<number>} */

    const listStack = []
    /** @type {Omit<CompileContext, 'sliceSerialize'>} */

    const context = {
      stack,
      tokenStack,
      config,
      enter,
      exit,
      buffer,
      resume,
      setData,
      getData
    }
    let index = -1

    while (++index < events.length) {
      // We preprocess lists to add `listItem` tokens, and to infer whether
      // items the list itself are spread out.
      if (
        events[index][1].type === 'listOrdered' ||
        events[index][1].type === 'listUnordered'
      ) {
        if (events[index][0] === 'enter') {
          listStack.push(index)
        } else {
          const tail = listStack.pop()
          index = prepareList(events, tail, index)
        }
      }
    }

    index = -1

    while (++index < events.length) {
      const handler = config[events[index][0]]

      if (lib_own.call(handler, events[index][1].type)) {
        handler[events[index][1].type].call(
          Object.assign(
            {
              sliceSerialize: events[index][2].sliceSerialize
            },
            context
          ),
          events[index][1]
        )
      }
    }

    if (tokenStack.length > 0) {
      const tail = tokenStack[tokenStack.length - 1]
      const handler = tail[1] || defaultOnError
      handler.call(context, undefined, tail[0])
    } // Figure out `root` position.

    tree.position = {
      start: point(
        events.length > 0
          ? events[0][1].start
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      ),
      end: point(
        events.length > 0
          ? events[events.length - 2][1].end
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      )
    }
    index = -1

    while (++index < config.transforms.length) {
      tree = config.transforms[index](tree) || tree
    }

    return tree
  }
  /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */

  function prepareList(events, start, length) {
    let index = start - 1
    let containerBalance = -1
    let listSpread = false
    /** @type {Token|undefined} */

    let listItem
    /** @type {number|undefined} */

    let lineIndex
    /** @type {number|undefined} */

    let firstBlankLineIndex
    /** @type {boolean|undefined} */

    let atMarker

    while (++index <= length) {
      const event = events[index]

      if (
        event[1].type === 'listUnordered' ||
        event[1].type === 'listOrdered' ||
        event[1].type === 'blockQuote'
      ) {
        if (event[0] === 'enter') {
          containerBalance++
        } else {
          containerBalance--
        }

        atMarker = undefined
      } else if (event[1].type === 'lineEndingBlank') {
        if (event[0] === 'enter') {
          if (
            listItem &&
            !atMarker &&
            !containerBalance &&
            !firstBlankLineIndex
          ) {
            firstBlankLineIndex = index
          }

          atMarker = undefined
        }
      } else if (
        event[1].type === 'linePrefix' ||
        event[1].type === 'listItemValue' ||
        event[1].type === 'listItemMarker' ||
        event[1].type === 'listItemPrefix' ||
        event[1].type === 'listItemPrefixWhitespace'
      ) {
        // Empty.
      } else {
        atMarker = undefined
      }

      if (
        (!containerBalance &&
          event[0] === 'enter' &&
          event[1].type === 'listItemPrefix') ||
        (containerBalance === -1 &&
          event[0] === 'exit' &&
          (event[1].type === 'listUnordered' ||
            event[1].type === 'listOrdered'))
      ) {
        if (listItem) {
          let tailIndex = index
          lineIndex = undefined

          while (tailIndex--) {
            const tailEvent = events[tailIndex]

            if (
              tailEvent[1].type === 'lineEnding' ||
              tailEvent[1].type === 'lineEndingBlank'
            ) {
              if (tailEvent[0] === 'exit') continue

              if (lineIndex) {
                events[lineIndex][1].type = 'lineEndingBlank'
                listSpread = true
              }

              tailEvent[1].type = 'lineEnding'
              lineIndex = tailIndex
            } else if (
              tailEvent[1].type === 'linePrefix' ||
              tailEvent[1].type === 'blockQuotePrefix' ||
              tailEvent[1].type === 'blockQuotePrefixWhitespace' ||
              tailEvent[1].type === 'blockQuoteMarker' ||
              tailEvent[1].type === 'listItemIndent'
            ) {
              // Empty
            } else {
              break
            }
          }

          if (
            firstBlankLineIndex &&
            (!lineIndex || firstBlankLineIndex < lineIndex)
          ) {
            // @ts-expect-error Patched.
            listItem._spread = true
          } // Fix position.

          listItem.end = Object.assign(
            {},
            lineIndex ? events[lineIndex][1].start : event[1].end
          )
          events.splice(lineIndex || index, 0, ['exit', listItem, event[2]])
          index++
          length++
        } // Create a new list item.

        if (event[1].type === 'listItemPrefix') {
          listItem = {
            type: 'listItem',
            // @ts-expect-error Patched
            _spread: false,
            start: Object.assign({}, event[1].start)
          } // @ts-expect-error: `listItem` is most definitely defined, TS...

          events.splice(index, 0, ['enter', listItem, event[2]])
          index++
          length++
          firstBlankLineIndex = undefined
          atMarker = true
        }
      }
    } // @ts-expect-error Patched.

    events[start][1]._spread = listSpread
    return length
  }
  /**
   * @type {CompileContext['setData']}
   * @param [value]
   */

  function setData(key, value) {
    data[key] = value
  }
  /**
   * @type {CompileContext['getData']}
   * @template {string} K
   * @param {K} key
   * @returns {CompileData[K]}
   */

  function getData(key) {
    return data[key]
  }
  /**
   * @param {Point} d
   * @returns {Point}
   */

  function point(d) {
    return {
      line: d.line,
      column: d.column,
      offset: d.offset
    }
  }
  /**
   * @param {(token: Token) => Node} create
   * @param {Handle} [and]
   * @returns {Handle}
   */

  function opener(create, and) {
    return open
    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */

    function open(token) {
      enter.call(this, create(token), token)
      if (and) and.call(this, token)
    }
  }
  /** @type {CompileContext['buffer']} */

  function buffer() {
    this.stack.push({
      type: 'fragment',
      children: []
    })
  }
  /**
   * @type {CompileContext['enter']}
   * @template {Node} N
   * @this {CompileContext}
   * @param {N} node
   * @param {Token} token
   * @param {OnEnterError} [errorHandler]
   * @returns {N}
   */

  function enter(node, token, errorHandler) {
    const parent = this.stack[this.stack.length - 1]
    // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
    parent.children.push(node)
    this.stack.push(node)
    this.tokenStack.push([token, errorHandler]) // @ts-expect-error: `end` will be patched later.

    node.position = {
      start: point(token.start)
    }
    return node
  }
  /**
   * @param {Handle} [and]
   * @returns {Handle}
   */

  function closer(and) {
    return close
    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */

    function close(token) {
      if (and) and.call(this, token)
      exit.call(this, token)
    }
  }
  /**
   * @type {CompileContext['exit']}
   * @this {CompileContext}
   * @param {Token} token
   * @param {OnExitError} [onExitError]
   * @returns {Node}
   */

  function exit(token, onExitError) {
    const node = this.stack.pop()
    const open = this.tokenStack.pop()

    if (!open) {
      throw new Error(
        'Cannot close `' +
          token.type +
          '` (' +
          stringifyPosition({
            start: token.start,
            end: token.end
          }) +
          '): it’s not open'
      )
    } else if (open[0].type !== token.type) {
      if (onExitError) {
        onExitError.call(this, token, open[0])
      } else {
        const handler = open[1] || defaultOnError
        handler.call(this, token, open[0])
      }
    }

    node.position.end = point(token.end)
    return node
  }
  /**
   * @this {CompileContext}
   * @returns {string}
   */

  function resume() {
    return mdast_util_to_string_toString(this.stack.pop())
  } //
  // Handlers.
  //

  /** @type {Handle} */

  function onenterlistordered() {
    setData('expectingFirstListItemValue', true)
  }
  /** @type {Handle} */

  function onenterlistitemvalue(token) {
    if (getData('expectingFirstListItemValue')) {
      const ancestor =
        /** @type {List} */
        this.stack[this.stack.length - 2]
      ancestor.start = Number.parseInt(this.sliceSerialize(token), 10)
      setData('expectingFirstListItemValue')
    }
  }
  /** @type {Handle} */

  function onexitcodefencedfenceinfo() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.lang = data
  }
  /** @type {Handle} */

  function onexitcodefencedfencemeta() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.meta = data
  }
  /** @type {Handle} */

  function onexitcodefencedfence() {
    // Exit if this is the closing fence.
    if (getData('flowCodeInside')) return
    this.buffer()
    setData('flowCodeInside', true)
  }
  /** @type {Handle} */

  function onexitcodefenced() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '')
    setData('flowCodeInside')
  }
  /** @type {Handle} */

  function onexitcodeindented() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.value = data.replace(/(\r?\n|\r)$/g, '')
  }
  /** @type {Handle} */

  function onexitdefinitionlabelstring(token) {
    // Discard label, use the source content instead.
    const label = this.resume()
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1]
    node.label = label
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
  }
  /** @type {Handle} */

  function onexitdefinitiontitlestring() {
    const data = this.resume()
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1]
    node.title = data
  }
  /** @type {Handle} */

  function onexitdefinitiondestinationstring() {
    const data = this.resume()
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1]
    node.url = data
  }
  /** @type {Handle} */

  function onexitatxheadingsequence(token) {
    const node =
      /** @type {Heading} */
      this.stack[this.stack.length - 1]

    if (!node.depth) {
      const depth = this.sliceSerialize(token).length
      node.depth = depth
    }
  }
  /** @type {Handle} */

  function onexitsetextheadingtext() {
    setData('setextHeadingSlurpLineEnding', true)
  }
  /** @type {Handle} */

  function onexitsetextheadinglinesequence(token) {
    const node =
      /** @type {Heading} */
      this.stack[this.stack.length - 1]
    node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2
  }
  /** @type {Handle} */

  function onexitsetextheading() {
    setData('setextHeadingSlurpLineEnding')
  }
  /** @type {Handle} */

  function onenterdata(token) {
    const parent =
      /** @type {Parent} */
      this.stack[this.stack.length - 1]
    /** @type {Node} */

    let tail = parent.children[parent.children.length - 1]

    if (!tail || tail.type !== 'text') {
      // Add a new text node.
      tail = text() // @ts-expect-error: we’ll add `end` later.

      tail.position = {
        start: point(token.start)
      } // @ts-expect-error: Assume `parent` accepts `text`.

      parent.children.push(tail)
    }

    this.stack.push(tail)
  }
  /** @type {Handle} */

  function onexitdata(token) {
    const tail = this.stack.pop()
    tail.value += this.sliceSerialize(token)
    tail.position.end = point(token.end)
  }
  /** @type {Handle} */

  function onexitlineending(token) {
    const context = this.stack[this.stack.length - 1]

    // If we’re at a hard break, include the line ending in there.
    if (getData('atHardBreak')) {
      const tail = context.children[context.children.length - 1]
      tail.position.end = point(token.end)
      setData('atHardBreak')
      return
    }

    if (
      !getData('setextHeadingSlurpLineEnding') &&
      config.canContainEols.includes(context.type)
    ) {
      onenterdata.call(this, token)
      onexitdata.call(this, token)
    }
  }
  /** @type {Handle} */

  function onexithardbreak() {
    setData('atHardBreak', true)
  }
  /** @type {Handle} */

  function onexithtmlflow() {
    const data = this.resume()
    const node =
      /** @type {HTML} */
      this.stack[this.stack.length - 1]
    node.value = data
  }
  /** @type {Handle} */

  function onexithtmltext() {
    const data = this.resume()
    const node =
      /** @type {HTML} */
      this.stack[this.stack.length - 1]
    node.value = data
  }
  /** @type {Handle} */

  function onexitcodetext() {
    const data = this.resume()
    const node =
      /** @type {InlineCode} */
      this.stack[this.stack.length - 1]
    node.value = data
  }
  /** @type {Handle} */

  function onexitlink() {
    const context =
      /** @type {Link & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1] // To do: clean.

    if (getData('inReference')) {
      context.type += 'Reference' // @ts-expect-error: mutate.

      context.referenceType = getData('referenceType') || 'shortcut' // @ts-expect-error: mutate.

      delete context.url
      delete context.title
    } else {
      // @ts-expect-error: mutate.
      delete context.identifier // @ts-expect-error: mutate.

      delete context.label
    }

    setData('referenceType')
  }
  /** @type {Handle} */

  function onexitimage() {
    const context =
      /** @type {Image & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1] // To do: clean.

    if (getData('inReference')) {
      context.type += 'Reference' // @ts-expect-error: mutate.

      context.referenceType = getData('referenceType') || 'shortcut' // @ts-expect-error: mutate.

      delete context.url
      delete context.title
    } else {
      // @ts-expect-error: mutate.
      delete context.identifier // @ts-expect-error: mutate.

      delete context.label
    }

    setData('referenceType')
  }
  /** @type {Handle} */

  function onexitlabeltext(token) {
    const ancestor =
      /** @type {(Link|Image) & {identifier: string, label: string}} */
      this.stack[this.stack.length - 2]
    const string = this.sliceSerialize(token)
    ancestor.label = decodeString(string)
    ancestor.identifier = normalizeIdentifier(string).toLowerCase()
  }
  /** @type {Handle} */

  function onexitlabel() {
    const fragment =
      /** @type {Fragment} */
      this.stack[this.stack.length - 1]
    const value = this.resume()
    const node =
      /** @type {(Link|Image) & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1] // Assume a reference.

    setData('inReference', true)

    if (node.type === 'link') {
      // @ts-expect-error: Assume static phrasing content.
      node.children = fragment.children
    } else {
      node.alt = value
    }
  }
  /** @type {Handle} */

  function onexitresourcedestinationstring() {
    const data = this.resume()
    const node =
      /** @type {Link|Image} */
      this.stack[this.stack.length - 1]
    node.url = data
  }
  /** @type {Handle} */

  function onexitresourcetitlestring() {
    const data = this.resume()
    const node =
      /** @type {Link|Image} */
      this.stack[this.stack.length - 1]
    node.title = data
  }
  /** @type {Handle} */

  function onexitresource() {
    setData('inReference')
  }
  /** @type {Handle} */

  function onenterreference() {
    setData('referenceType', 'collapsed')
  }
  /** @type {Handle} */

  function onexitreferencestring(token) {
    const label = this.resume()
    const node =
      /** @type {LinkReference|ImageReference} */
      this.stack[this.stack.length - 1]
    node.label = label
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
    setData('referenceType', 'full')
  }
  /** @type {Handle} */

  function onexitcharacterreferencemarker(token) {
    setData('characterReferenceType', token.type)
  }
  /** @type {Handle} */

  function onexitcharacterreferencevalue(token) {
    const data = this.sliceSerialize(token)
    const type = getData('characterReferenceType')
    /** @type {string} */

    let value

    if (type) {
      value = decodeNumericCharacterReference(
        data,
        type === 'characterReferenceMarkerNumeric' ? 10 : 16
      )
      setData('characterReferenceType')
    } else {
      // @ts-expect-error `decodeNamedCharacterReference` can return false for
      // invalid named character references, but everything we’ve tokenized is
      // valid.
      value = decodeNamedCharacterReference(data)
    }

    const tail = this.stack.pop()
    tail.value += value
    tail.position.end = point(token.end)
  }
  /** @type {Handle} */

  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token)
    const node =
      /** @type {Link} */
      this.stack[this.stack.length - 1]
    node.url = this.sliceSerialize(token)
  }
  /** @type {Handle} */

  function onexitautolinkemail(token) {
    onexitdata.call(this, token)
    const node =
      /** @type {Link} */
      this.stack[this.stack.length - 1]
    node.url = 'mailto:' + this.sliceSerialize(token)
  } //
  // Creaters.
  //

  /** @returns {Blockquote} */

  function blockQuote() {
    return {
      type: 'blockquote',
      children: []
    }
  }
  /** @returns {Code} */

  function codeFlow() {
    return {
      type: 'code',
      lang: null,
      meta: null,
      value: ''
    }
  }
  /** @returns {InlineCode} */

  function codeText() {
    return {
      type: 'inlineCode',
      value: ''
    }
  }
  /** @returns {Definition} */

  function definition() {
    return {
      type: 'definition',
      identifier: '',
      label: null,
      title: null,
      url: ''
    }
  }
  /** @returns {Emphasis} */

  function emphasis() {
    return {
      type: 'emphasis',
      children: []
    }
  }
  /** @returns {Heading} */

  function heading() {
    // @ts-expect-error `depth` will be set later.
    return {
      type: 'heading',
      depth: undefined,
      children: []
    }
  }
  /** @returns {Break} */

  function hardBreak() {
    return {
      type: 'break'
    }
  }
  /** @returns {HTML} */

  function html() {
    return {
      type: 'html',
      value: ''
    }
  }
  /** @returns {Image} */

  function image() {
    return {
      type: 'image',
      title: null,
      url: '',
      alt: null
    }
  }
  /** @returns {Link} */

  function link() {
    return {
      type: 'link',
      title: null,
      url: '',
      children: []
    }
  }
  /**
   * @param {Token} token
   * @returns {List}
   */

  function list(token) {
    return {
      type: 'list',
      ordered: token.type === 'listOrdered',
      start: null,
      // @ts-expect-error Patched.
      spread: token._spread,
      children: []
    }
  }
  /**
   * @param {Token} token
   * @returns {ListItem}
   */

  function listItem(token) {
    return {
      type: 'listItem',
      // @ts-expect-error Patched.
      spread: token._spread,
      checked: null,
      children: []
    }
  }
  /** @returns {Paragraph} */

  function paragraph() {
    return {
      type: 'paragraph',
      children: []
    }
  }
  /** @returns {Strong} */

  function strong() {
    return {
      type: 'strong',
      children: []
    }
  }
  /** @returns {Text} */

  function text() {
    return {
      type: 'text',
      value: ''
    }
  }
  /** @returns {ThematicBreak} */

  function thematicBreak() {
    return {
      type: 'thematicBreak'
    }
  }
}
/**
 * @param {Extension} combined
 * @param {Array<Extension|Array<Extension>>} extensions
 * @returns {Extension}
 */

function configure(combined, extensions) {
  let index = -1

  while (++index < extensions.length) {
    const value = extensions[index]

    if (Array.isArray(value)) {
      configure(combined, value)
    } else {
      extension(combined, value)
    }
  }

  return combined
}
/**
 * @param {Extension} combined
 * @param {Extension} extension
 * @returns {void}
 */

function extension(combined, extension) {
  /** @type {string} */
  let key

  for (key in extension) {
    if (lib_own.call(extension, key)) {
      const list = key === 'canContainEols' || key === 'transforms'
      const maybe = lib_own.call(combined, key) ? combined[key] : undefined
      /* c8 ignore next */

      const left = maybe || (combined[key] = list ? [] : {})
      const right = extension[key]

      if (right) {
        if (list) {
          // @ts-expect-error: `left` is an array.
          combined[key] = [...left, ...right]
        } else {
          Object.assign(left, right)
        }
      }
    }
  }
}
/** @type {OnEnterError} */

function defaultOnError(left, right) {
  if (left) {
    throw new Error(
      'Cannot close `' +
        left.type +
        '` (' +
        stringifyPosition({
          start: left.start,
          end: left.end
        }) +
        '): a different token (`' +
        right.type +
        '`, ' +
        stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is open'
    )
  } else {
    throw new Error(
      'Cannot close document, a token (`' +
        right.type +
        '`, ' +
        stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is still open'
    )
  }
}

;// CONCATENATED MODULE: ../node_modules/remark-parse/lib/index.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */



/** @type {import('unified').Plugin<[Options?] | void[], string, Root>} */
function remarkParse(options) {
  /** @type {import('unified').ParserFunction<Root>} */
  const parser = (doc) => {
    // Assume options.
    const settings = /** @type {Options} */ (this.data('settings'))

    return fromMarkdown(
      doc,
      Object.assign({}, settings, options, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data('micromarkExtensions') || [],
        mdastExtensions: this.data('fromMarkdownExtensions') || []
      })
    )
  }

  Object.assign(this, {Parser: parser})
}

;// CONCATENATED MODULE: ../node_modules/remark-parse/index.js


/* harmony default export */ var remark_parse = (remarkParse);

;// CONCATENATED MODULE: ../node_modules/unist-builder/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist').Literal} Literal
 * @typedef {Object.<string, unknown>} Props
 * @typedef {Array.<Node>|string} ChildrenOrValue
 *
 * @typedef {(<T extends string, P extends Record<string, unknown>, C extends Node[]>(type: T, props: P, children: C) => {type: T, children: C} & P)} BuildParentWithProps
 * @typedef {(<T extends string, P extends Record<string, unknown>>(type: T, props: P, value: string) => {type: T, value: string} & P)} BuildLiteralWithProps
 * @typedef {(<T extends string, P extends Record<string, unknown>>(type: T, props: P) => {type: T} & P)} BuildVoidWithProps
 * @typedef {(<T extends string, C extends Node[]>(type: T, children: C) => {type: T, children: C})} BuildParent
 * @typedef {(<T extends string>(type: T, value: string) => {type: T, value: string})} BuildLiteral
 * @typedef {(<T extends string>(type: T) => {type: T})} BuildVoid
 */

var u = /**
 * @type {BuildVoid & BuildVoidWithProps & BuildLiteral & BuildLiteralWithProps & BuildParent & BuildParentWithProps}
 */ (
  /**
   * @param {string} type Type of node
   * @param {Props|ChildrenOrValue} [props] Additional properties for node (or `children` or `value`)
   * @param {ChildrenOrValue} [value] `children` or `value` of node
   * @returns {Node}
   */
  function (type, props, value) {
    /** @type {Node} */
    var node = {type: String(type)}

    if (
      (value === undefined || value === null) &&
      (typeof props === 'string' || Array.isArray(props))
    ) {
      value = props
    } else {
      Object.assign(node, props)
    }

    if (Array.isArray(value)) {
      node.children = value
    } else if (value !== undefined && value !== null) {
      node.value = String(value)
    }

    return node
  }
)

;// CONCATENATED MODULE: ../node_modules/unist-util-is/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 *
 * @typedef {string} Type
 * @typedef {Object<string, unknown>} Props
 *
 * @typedef {null|undefined|Type|Props|TestFunctionAnything|Array.<Type|Props|TestFunctionAnything>} Test
 */

/**
 * Check if a node passes a test
 *
 * @callback TestFunctionAnything
 * @param {Node} node
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {boolean|void}
 */

/**
 * Check if a node passes a certain node test
 *
 * @template {Node} X
 * @callback TestFunctionPredicate
 * @param {Node} node
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {node is X}
 */

/**
 * @callback AssertAnything
 * @param {unknown} [node]
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {boolean}
 */

/**
 * Check if a node passes a certain node test
 *
 * @template {Node} Y
 * @callback AssertPredicate
 * @param {unknown} [node]
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {node is Y}
 */

const is =
  /**
   * Check if a node passes a test.
   * When a `parent` node is known the `index` of node should also be given.
   *
   * @type {(
   *   (<T extends Node>(node: unknown, test: T['type']|Partial<T>|TestFunctionPredicate<T>|Array.<T['type']|Partial<T>|TestFunctionPredicate<T>>, index?: number|null|undefined, parent?: Parent|null|undefined, context?: unknown) => node is T) &
   *   ((node?: unknown, test?: Test, index?: number|null|undefined, parent?: Parent|null|undefined, context?: unknown) => boolean)
   * )}
   */
  (
    /**
     * Check if a node passes a test.
     * When a `parent` node is known the `index` of node should also be given.
     *
     * @param {unknown} [node] Node to check
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @param {number|null|undefined} [index] Position of `node` in `parent`
     * @param {Parent|null|undefined} [parent] Parent of `node`
     * @param {unknown} [context] Context object to invoke `test` with
     * @returns {boolean} Whether test passed and `node` is a `Node` (object with `type` set to non-empty `string`).
     */
    // eslint-disable-next-line max-params
    function is(node, test, index, parent, context) {
      const check = convert(test)

      if (
        index !== undefined &&
        index !== null &&
        (typeof index !== 'number' ||
          index < 0 ||
          index === Number.POSITIVE_INFINITY)
      ) {
        throw new Error('Expected positive finite index')
      }

      if (
        parent !== undefined &&
        parent !== null &&
        (!is(parent) || !parent.children)
      ) {
        throw new Error('Expected parent node')
      }

      if (
        (parent === undefined || parent === null) !==
        (index === undefined || index === null)
      ) {
        throw new Error('Expected both parent and index')
      }

      // @ts-expect-error Looks like a node.
      return node && node.type && typeof node.type === 'string'
        ? Boolean(check.call(context, node, index, parent))
        : false
    }
  )

const convert =
  /**
   * @type {(
   *   (<T extends Node>(test: T['type']|Partial<T>|TestFunctionPredicate<T>) => AssertPredicate<T>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  (
    /**
     * Generate an assertion from a check.
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @returns {AssertAnything}
     */
    function (test) {
      if (test === undefined || test === null) {
        return ok
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      if (typeof test === 'object') {
        return Array.isArray(test) ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  )
/**
 * @param {Array.<Type|Props|TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */
function anyFactory(tests) {
  /** @type {Array.<AssertAnything>} */
  const checks = []
  let index = -1

  while (++index < tests.length) {
    checks[index] = convert(tests[index])
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @param {unknown[]} parameters
   * @returns {boolean}
   */
  function any(...parameters) {
    let index = -1

    while (++index < checks.length) {
      if (checks[index].call(this, ...parameters)) return true
    }

    return false
  }
}

/**
 * Utility to assert each property in `test` is represented in `node`, and each
 * values are strictly equal.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */
function propsFactory(check) {
  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    /** @type {string} */
    let key

    for (key in check) {
      // @ts-expect-error: hush, it sure works as an index.
      if (node[key] !== check[key]) return false
    }

    return true
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 *
 * @param {Type} check
 * @returns {AssertAnything}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */
function castFactory(check) {
  return assertion

  /**
   * @this {unknown}
   * @param {Array.<unknown>} parameters
   * @returns {boolean}
   */
  function assertion(...parameters) {
    // @ts-expect-error: spreading is fine.
    return Boolean(check.call(this, ...parameters))
  }
}

// Utility to return true.
function ok() {
  return true
}

;// CONCATENATED MODULE: ../node_modules/unist-util-visit-parents/color.browser.js
/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return d
}

;// CONCATENATED MODULE: ../node_modules/unist-util-visit-parents/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('./complex-types.js').Action} Action
 * @typedef {import('./complex-types.js').Index} Index
 * @typedef {import('./complex-types.js').ActionTuple} ActionTuple
 * @typedef {import('./complex-types.js').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */




/**
 * Continue traversing as normal
 */
const CONTINUE = true
/**
 * Do not traverse this node’s children
 */
const SKIP = 'skip'
/**
 * Stop traversing immediately
 */
const EXIT = false

/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param [reverse=false]
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const visitParents =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor<Node>} visitor
     * @param {boolean} [reverse=false]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test
        test = null
      }

      const is = convert(test)
      const step = reverse ? -1 : 1

      factory(tree, null, [])()

      /**
       * @param {Node} node
       * @param {number?} index
       * @param {Array<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */
        // @ts-expect-error: hush
        const value = typeof node === 'object' && node !== null ? node : {}
        /** @type {string|undefined} */
        let name

        if (typeof value.type === 'string') {
          name =
            typeof value.tagName === 'string'
              ? value.tagName
              : typeof value.name === 'string'
              ? value.name
              : undefined

          Object.defineProperty(visit, 'name', {
            value:
              'node (' +
              color(value.type + (name ? '<' + name + '>' : '')) +
              ')'
          })
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = []
          /** @type {ActionTuple} */
          let subresult
          /** @type {number} */
          let offset
          /** @type {Array<Parent>} */
          let grandparents

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult(visitor(node, parents))

            if (result[0] === EXIT) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== SKIP) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node)

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)()

              if (subresult[0] === EXIT) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step
            }
          }

          return result
        }
      }
    }
  )

/**
 * @param {VisitorResult} value
 * @returns {ActionTuple}
 */
function toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}

;// CONCATENATED MODULE: ../node_modules/unist-util-visit/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */



/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const visit =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor} visitor
     * @param {boolean} [reverse]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        visitor = test
        test = null
      }

      visitParents(tree, test, overload, reverse)

      /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */
      function overload(node, parents) {
        const parent = parents[parents.length - 1]
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  )



;// CONCATENATED MODULE: ../node_modules/unist-util-position/index.js
/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {Record<string, unknown> & {type: string, position?: PositionLike|undefined}} NodeLike
 * @typedef {import('unist').Point} Point
 *
 * @typedef {Partial<Point>} PointLike
 *
 * @typedef PositionLike
 * @property {PointLike} [start]
 * @property {PointLike} [end]
 */

const pointStart = unist_util_position_point('start')
const pointEnd = unist_util_position_point('end')

/**
 * Get the positional info of `node`.
 *
 * @param {NodeLike|Node} [node]
 * @returns {Position}
 */
function unist_util_position_position(node) {
  return {start: pointStart(node), end: pointEnd(node)}
}

/**
 * Get the positional info of `node`.
 *
 * @param {'start'|'end'} type
 */
function unist_util_position_point(type) {
  return point

  /**
   * Get the positional info of `node`.
   *
   * @param {NodeLike|Node} [node]
   * @returns {Point}
   */
  function point(node) {
    const point = (node && node.position && node.position[type]) || {}

    return {
      line: point.line || null,
      column: point.column || null,
      offset: point.offset > -1 ? point.offset : null
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/unist-util-generated/index.js
/**
 * @typedef {Object} PointLike
 * @property {number} [line]
 * @property {number} [column]
 * @property {number} [offset]
 *
 * @typedef {Object} PositionLike
 * @property {PointLike} [start]
 * @property {PointLike} [end]
 *
 * @typedef {Object} NodeLike
 * @property {PositionLike} [position]
 */

/**
 * Check if `node` is *generated*.
 *
 * @param {NodeLike} [node]
 * @returns {boolean}
 */
function generated(node) {
  return (
    !node ||
    !node.position ||
    !node.position.start ||
    !node.position.start.line ||
    !node.position.start.column ||
    !node.position.end ||
    !node.position.end.line ||
    !node.position.end.column
  )
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-definitions/index.js
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 * @typedef {import('mdast').Definition} Definition
 */



const mdast_util_definitions_own = {}.hasOwnProperty

/**
 * Find definitions in `node`.
 * Uses CommonMark precedence, which means that earlier definitions are
 * preferred over duplicate later definitions.
 *
 * @param {Node} node
 */
function definitions(node) {
  /** @type {Record<string, Definition>} */
  const cache = Object.create(null)

  if (!node || !node.type) {
    throw new Error('mdast-util-definitions expected node')
  }

  visit(node, 'definition', (definition) => {
    const id = clean(definition.identifier)
    if (id && !mdast_util_definitions_own.call(cache, id)) {
      cache[id] = definition
    }
  })

  return definition

  /**
   * Get a node from the bound definition cache.
   *
   * @param {string} identifier
   * @returns {Definition|null}
   */
  function definition(identifier) {
    const id = clean(identifier)
    return id && mdast_util_definitions_own.call(cache, id) ? cache[id] : null
  }
}

/**
 * @param {string} [value]
 * @returns {string}
 */
function clean(value) {
  return String(value || '').toUpperCase()
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/traverse.js
/**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('./index.js').H} H
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */



const traverse_own = {}.hasOwnProperty

/**
 * Transform an unknown node.
 * @type {Handler}
 * @param {MdastNode} node
 */
function unknown(h, node) {
  const data = node.data || {}

  if (
    'value' in node &&
    !(
      traverse_own.call(data, 'hName') ||
      traverse_own.call(data, 'hProperties') ||
      traverse_own.call(data, 'hChildren')
    )
  ) {
    return h.augment(node, u('text', node.value))
  }

  return h(node, 'div', traverse_all(h, node))
}

/**
 * @type {Handler}
 * @param {MdastNode} node
 */
function traverse_one(h, node, parent) {
  const type = node && node.type
  /** @type {Handler} */
  let fn

  // Fail on non-nodes.
  if (!type) {
    throw new Error('Expected node, got `' + node + '`')
  }

  if (traverse_own.call(h.handlers, type)) {
    fn = h.handlers[type]
  } else if (h.passThrough && h.passThrough.includes(type)) {
    fn = returnNode
  } else {
    fn = h.unknownHandler
  }

  return (typeof fn === 'function' ? fn : unknown)(h, node, parent)
}

/**
 * @type {Handler}
 * @param {MdastNode} node
 */
function returnNode(h, node) {
  // @ts-expect-error: Pass through custom node.
  return 'children' in node ? {...node, children: traverse_all(h, node)} : node
}

/**
 * @param {H} h
 * @param {MdastNode} parent
 */
function traverse_all(h, parent) {
  /** @type {Array<Content>} */
  const values = []

  if ('children' in parent) {
    const nodes = parent.children
    let index = -1

    while (++index < nodes.length) {
      const result = traverse_one(h, nodes[index], parent)

      if (result) {
        if (index && nodes[index - 1].type === 'break') {
          if (!Array.isArray(result) && result.type === 'text') {
            result.value = result.value.replace(/^\s+/, '')
          }

          if (!Array.isArray(result) && result.type === 'element') {
            const head = result.children[0]

            if (head && head.type === 'text') {
              head.value = head.value.replace(/^\s+/, '')
            }
          }
        }

        if (Array.isArray(result)) {
          values.push(...result)
        } else {
          values.push(result)
        }
      }
    }
  }

  return values
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-sanitize-uri/index.js



/**
 * Make a value safe for injection as a URL.
 *
 * This encodes unsafe characters with percent-encoding and skips already
 * encoded sequences (see `normalizeUri` below).
 * Further unsafe characters are encoded as character references (see
 * `micromark-util-encode`).
 *
 * Then, a regex of allowed protocols can be given, in which case the URL is
 * sanitized.
 * For example, `/^(https?|ircs?|mailto|xmpp)$/i` can be used for `a[href]`,
 * or `/^https?$/i` for `img[src]`.
 * If the URL includes an unknown protocol (one not matched by `protocol`, such
 * as a dangerous example, `javascript:`), the value is ignored.
 *
 * @param {string|undefined} url
 * @param {RegExp} [protocol]
 * @returns {string}
 */
function sanitizeUri(url, protocol) {
  const value = encode(normalizeUri(url || ''))

  if (!protocol) {
    return value
  }

  const colon = value.indexOf(':')
  const questionMark = value.indexOf('?')
  const numberSign = value.indexOf('#')
  const slash = value.indexOf('/')

  if (
    // If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign) || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))
  ) {
    return value
  }

  return ''
}
/**
 * Normalize a URL (such as used in definitions).
 *
 * Encode unsafe characters with percent-encoding, skipping already encoded
 * sequences.
 *
 * @param {string} value
 * @returns {string}
 */

function normalizeUri(value) {
  /** @type {Array<string>} */
  const result = []
  let index = -1
  let start = 0
  let skip = 0

  while (++index < value.length) {
    const code = value.charCodeAt(index)
    /** @type {string} */

    let replace = '' // A correct percent encoded value.

    if (
      code === 37 &&
      asciiAlphanumeric(value.charCodeAt(index + 1)) &&
      asciiAlphanumeric(value.charCodeAt(index + 2))
    ) {
      skip = 2
    } // ASCII.
    else if (code < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) {
        replace = String.fromCharCode(code)
      }
    } // Astral.
    else if (code > 55295 && code < 57344) {
      const next = value.charCodeAt(index + 1) // A correct surrogate pair.

      if (code < 56320 && next > 56319 && next < 57344) {
        replace = String.fromCharCode(code, next)
        skip = 1
      } // Lone surrogate.
      else {
        replace = '\uFFFD'
      }
    } // Unicode.
    else {
      replace = String.fromCharCode(code)
    }

    if (replace) {
      result.push(value.slice(start, index), encodeURIComponent(replace))
      start = index + skip + 1
      replace = ''
    }

    if (skip) {
      index += skip
      skip = 0
    }
  }

  return result.join('') + value.slice(start)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/wrap.js
/**
 * @typedef {import('./index.js').Content} Content
 */



/**
 * Wrap `nodes` with line feeds between each entry.
 * Optionally adds line feeds at the start and end.
 *
 * @param {Array<Content>} nodes
 * @param {boolean} [loose=false]
 * @returns {Array<Content>}
 */
function wrap_wrap(nodes, loose) {
  /** @type {Array<Content>} */
  const result = []
  let index = -1

  if (loose) {
    result.push(u('text', '\n'))
  }

  while (++index < nodes.length) {
    if (index) result.push(u('text', '\n'))
    result.push(nodes[index])
  }

  if (loose && nodes.length > 0) {
    result.push(u('text', '\n'))
  }

  return result
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/footer.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('./index.js').H} H
 */






/**
 * @param {H} h
 * @returns {Element|null}
 */
function footer(h) {
  let index = -1
  /** @type {Array<ElementContent>} */
  const listItems = []

  while (++index < h.footnoteOrder.length) {
    const def = h.footnoteById[h.footnoteOrder[index].toUpperCase()]

    if (!def) {
      continue
    }

    const content = traverse_all(h, def)
    const id = String(def.identifier)
    const safeId = normalizeUri(id.toLowerCase())
    let referenceIndex = 0
    /** @type {Array<ElementContent>} */
    const backReferences = []

    while (++referenceIndex <= h.footnoteCounts[id]) {
      /** @type {Element} */
      const backReference = {
        type: 'element',
        tagName: 'a',
        properties: {
          href:
            '#' +
            h.clobberPrefix +
            'fnref-' +
            safeId +
            (referenceIndex > 1 ? '-' + referenceIndex : ''),
          dataFootnoteBackref: true,
          className: ['data-footnote-backref'],
          ariaLabel: h.footnoteBackLabel
        },
        children: [{type: 'text', value: '↩'}]
      }

      if (referenceIndex > 1) {
        backReference.children.push({
          type: 'element',
          tagName: 'sup',
          children: [{type: 'text', value: String(referenceIndex)}]
        })
      }

      if (backReferences.length > 0) {
        backReferences.push({type: 'text', value: ' '})
      }

      backReferences.push(backReference)
    }

    const tail = content[content.length - 1]

    if (tail && tail.type === 'element' && tail.tagName === 'p') {
      const tailTail = tail.children[tail.children.length - 1]
      if (tailTail && tailTail.type === 'text') {
        tailTail.value += ' '
      } else {
        tail.children.push({type: 'text', value: ' '})
      }

      tail.children.push(...backReferences)
    } else {
      content.push(...backReferences)
    }

    /** @type {Element} */
    const listItem = {
      type: 'element',
      tagName: 'li',
      properties: {id: h.clobberPrefix + 'fn-' + safeId},
      children: wrap_wrap(content, true)
    }

    if (def.position) {
      listItem.position = def.position
    }

    listItems.push(listItem)
  }

  if (listItems.length === 0) {
    return null
  }

  return {
    type: 'element',
    tagName: 'section',
    properties: {dataFootnotes: true, className: ['footnotes']},
    children: [
      {
        type: 'element',
        tagName: h.footnoteLabelTagName,
        properties: {
          ...JSON.parse(JSON.stringify(h.footnoteLabelProperties)),
          id: 'footnote-label'
        },
        children: [u('text', h.footnoteLabel)]
      },
      {type: 'text', value: '\n'},
      {
        type: 'element',
        tagName: 'ol',
        properties: {},
        children: wrap_wrap(listItems, true)
      },
      {type: 'text', value: '\n'}
    ]
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/blockquote.js
/**
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {Blockquote} node
 */
function blockquote(h, node) {
  return h(node, 'blockquote', wrap_wrap(traverse_all(h, node), true))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/break.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Break} node
 * @returns {Array<Element|Text>}
 */
function hardBreak(h, node) {
  return [h(node, 'br'), u('text', '\n')]
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/code.js
/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Code} node
 */
function code(h, node) {
  const value = node.value ? node.value + '\n' : ''
  // To do: next major, use `node.lang` w/o regex, the splitting’s been going
  // on for years in remark now.
  const lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/)
  /** @type {Properties} */
  const props = {}

  if (lang) {
    props.className = ['language-' + lang]
  }

  const code = h(node, 'code', props, [u('text', value)])

  if (node.meta) {
    code.data = {meta: node.meta}
  }

  return h(node.position, 'pre', [code])
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/delete.js
/**
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Delete} node
 */
function strikethrough(h, node) {
  return h(node, 'del', traverse_all(h, node))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/emphasis.js
/**
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Emphasis} node
 */
function emphasis(h, node) {
  return h(node, 'em', traverse_all(h, node))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/footnote-reference.js
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {FootnoteReference} node
 */
function footnoteReference(h, node) {
  const id = String(node.identifier)
  const safeId = normalizeUri(id.toLowerCase())
  const index = h.footnoteOrder.indexOf(id)
  /** @type {number} */
  let counter

  if (index === -1) {
    h.footnoteOrder.push(id)
    h.footnoteCounts[id] = 1
    counter = h.footnoteOrder.length
  } else {
    h.footnoteCounts[id]++
    counter = index + 1
  }

  const reuseCounter = h.footnoteCounts[id]

  return h(node, 'sup', [
    h(
      node.position,
      'a',
      {
        href: '#' + h.clobberPrefix + 'fn-' + safeId,
        id:
          h.clobberPrefix +
          'fnref-' +
          safeId +
          (reuseCounter > 1 ? '-' + reuseCounter : ''),
        dataFootnoteRef: true,
        ariaDescribedBy: 'footnote-label'
      },
      [u('text', String(counter))]
    )
  ])
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/footnote.js
/**
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../index.js').Handler} Handler
 *
 * @todo
 *   `footnote` (or “inline note”) are a pandoc footnotes feature (`^[a note]`)
 *   that does not exist in GFM.
 *   We still have support for it, so that things remain working with
 *   `micromark-extension-footnote` and `mdast-util-footnote`, but in the future
 *   we might be able to remove it?
 */



/**
 * @type {Handler}
 * @param {Footnote} node
 */
function footnote(h, node) {
  const footnoteById = h.footnoteById
  let no = 1

  while (no in footnoteById) no++

  const identifier = String(no)

  footnoteById[identifier] = {
    type: 'footnoteDefinition',
    identifier,
    children: [{type: 'paragraph', children: node.children}],
    position: node.position
  }

  return footnoteReference(h, {
    type: 'footnoteReference',
    identifier,
    position: node.position
  })
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/heading.js
/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Heading} node
 */
function heading(h, node) {
  return h(node, 'h' + node.depth, traverse_all(h, node))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/html.js
/**
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * Return either a `raw` node in dangerous mode, otherwise nothing.
 *
 * @type {Handler}
 * @param {HTML} node
 */
function html(h, node) {
  return h.dangerous ? h.augment(node, u('raw', node.value)) : null
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/revert.js
/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */




/**
 * Return the content of a reference without definition as plain text.
 *
 * @type {Handler}
 * @param {ImageReference|LinkReference} node
 * @returns {Content|Array<Content>}
 */
function revert(h, node) {
  const subtype = node.referenceType
  let suffix = ']'

  if (subtype === 'collapsed') {
    suffix += '[]'
  } else if (subtype === 'full') {
    suffix += '[' + (node.label || node.identifier) + ']'
  }

  if (node.type === 'imageReference') {
    return u('text', '![' + node.alt + suffix)
  }

  const contents = traverse_all(h, node)
  const head = contents[0]

  if (head && head.type === 'text') {
    head.value = '[' + head.value
  } else {
    contents.unshift(u('text', '['))
  }

  const tail = contents[contents.length - 1]

  if (tail && tail.type === 'text') {
    tail.value += suffix
  } else {
    contents.push(u('text', suffix))
  }

  return contents
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/image-reference.js
/**
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {ImageReference} node
 */
function imageReference(h, node) {
  const def = h.definition(node.identifier)

  if (!def) {
    return revert(h, node)
  }

  /** @type {Properties} */
  const props = {src: normalizeUri(def.url || ''), alt: node.alt}

  if (def.title !== null && def.title !== undefined) {
    props.title = def.title
  }

  return h(node, 'img', props)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/image.js
/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Image} node
 */
function image_image(h, node) {
  /** @type {Properties} */
  const props = {src: normalizeUri(node.url), alt: node.alt}

  if (node.title !== null && node.title !== undefined) {
    props.title = node.title
  }

  return h(node, 'img', props)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/inline-code.js
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {InlineCode} node
 */
function inlineCode(h, node) {
  return h(node, 'code', [u('text', node.value.replace(/\r?\n|\r/g, ' '))])
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/link-reference.js
/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */





/**
 * @type {Handler}
 * @param {LinkReference} node
 */
function linkReference(h, node) {
  const def = h.definition(node.identifier)

  if (!def) {
    return revert(h, node)
  }

  /** @type {Properties} */
  const props = {href: normalizeUri(def.url || '')}

  if (def.title !== null && def.title !== undefined) {
    props.title = def.title
  }

  return h(node, 'a', props, traverse_all(h, node))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/link.js
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {Link} node
 */
function link_link(h, node) {
  /** @type {Properties} */
  const props = {href: normalizeUri(node.url)}

  if (node.title !== null && node.title !== undefined) {
    props.title = node.title
  }

  return h(node, 'a', props, traverse_all(h, node))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/list-item.js
/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').List} List
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 * @typedef {import('../index.js').Content} Content
 */




/**
 * @type {Handler}
 * @param {ListItem} node
 * @param {List} parent
 */
function listItem(h, node, parent) {
  const result = traverse_all(h, node)
  const loose = parent ? listLoose(parent) : listItemLoose(node)
  /** @type {Properties} */
  const props = {}
  /** @type {Array<Content>} */
  const wrapped = []

  if (typeof node.checked === 'boolean') {
    /** @type {Element} */
    let paragraph

    if (
      result[0] &&
      result[0].type === 'element' &&
      result[0].tagName === 'p'
    ) {
      paragraph = result[0]
    } else {
      paragraph = h(null, 'p', [])
      result.unshift(paragraph)
    }

    if (paragraph.children.length > 0) {
      paragraph.children.unshift(u('text', ' '))
    }

    paragraph.children.unshift(
      h(null, 'input', {
        type: 'checkbox',
        checked: node.checked,
        disabled: true
      })
    )

    // According to github-markdown-css, this class hides bullet.
    // See: <https://github.com/sindresorhus/github-markdown-css>.
    props.className = ['task-list-item']
  }

  let index = -1

  while (++index < result.length) {
    const child = result[index]

    // Add eols before nodes, except if this is a loose, first paragraph.
    if (
      loose ||
      index !== 0 ||
      child.type !== 'element' ||
      child.tagName !== 'p'
    ) {
      wrapped.push(u('text', '\n'))
    }

    if (child.type === 'element' && child.tagName === 'p' && !loose) {
      wrapped.push(...child.children)
    } else {
      wrapped.push(child)
    }
  }

  const tail = result[result.length - 1]

  // Add a final eol.
  if (tail && (loose || !('tagName' in tail) || tail.tagName !== 'p')) {
    wrapped.push(u('text', '\n'))
  }

  return h(node, 'li', props, wrapped)
}

/**
 * @param {List} node
 * @return {Boolean}
 */
function listLoose(node) {
  let loose = node.spread
  const children = node.children
  let index = -1

  while (!loose && ++index < children.length) {
    loose = listItemLoose(children[index])
  }

  return Boolean(loose)
}

/**
 * @param {ListItem} node
 * @return {Boolean}
 */
function listItemLoose(node) {
  const spread = node.spread

  return spread === undefined || spread === null
    ? node.children.length > 1
    : spread
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/list.js
/**
 * @typedef {import('mdast').List} List
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {List} node
 * @returns {Element}
 */
function list_list(h, node) {
  /** @type {Properties} */
  const props = {}
  const name = node.ordered ? 'ol' : 'ul'
  const items = traverse_all(h, node)
  let index = -1

  if (typeof node.start === 'number' && node.start !== 1) {
    props.start = node.start
  }

  // Like GitHub, add a class for custom styling.
  while (++index < items.length) {
    const item = items[index]

    if (
      item.type === 'element' &&
      item.tagName === 'li' &&
      item.properties &&
      Array.isArray(item.properties.className) &&
      item.properties.className.includes('task-list-item')
    ) {
      props.className = ['contains-task-list']
      break
    }
  }

  return h(node, name, props, wrap_wrap(items, true))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/paragraph.js
/**
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Paragraph} node
 */
function paragraph(h, node) {
  return h(node, 'p', traverse_all(h, node))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/root.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../index.js').Handler} Handler
 */





/**
 * @type {Handler}
 * @param {Root} node
 */
function root(h, node) {
  // @ts-expect-error `root`s are also fine.
  return h.augment(node, u('root', wrap_wrap(traverse_all(h, node))))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/strong.js
/**
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../index.js').Handler} Handler
 */



/**
 * @type {Handler}
 * @param {Strong} node
 */
function strong(h, node) {
  return h(node, 'strong', traverse_all(h, node))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/table.js
/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 * @typedef {import('../index.js').Content} Content
 */





/**
 * @type {Handler}
 * @param {Table} node
 */
function table(h, node) {
  const rows = node.children
  let index = -1
  const align = node.align || []
  /** @type {Array<Element>} */
  const result = []

  while (++index < rows.length) {
    const row = rows[index].children
    const name = index === 0 ? 'th' : 'td'
    /** @type {Array<Content>} */
    const out = []
    let cellIndex = -1
    const length = node.align ? align.length : row.length

    while (++cellIndex < length) {
      const cell = row[cellIndex]
      out.push(
        h(cell, name, {align: align[cellIndex]}, cell ? traverse_all(h, cell) : [])
      )
    }

    result[index] = h(rows[index], 'tr', wrap_wrap(out, true))
  }

  return h(
    node,
    'table',
    wrap_wrap(
      [h(result[0].position, 'thead', wrap_wrap([result[0]], true))].concat(
        result[1]
          ? h(
              {
                start: pointStart(result[1]),
                end: pointEnd(result[result.length - 1])
              },
              'tbody',
              wrap_wrap(result.slice(1), true)
            )
          : []
      ),
      true
    )
  )
}

;// CONCATENATED MODULE: ../node_modules/trim-lines/index.js
const tab = 9 /* `\t` */
const space = 32 /* ` ` */

/**
 * Remove initial and final spaces and tabs at the line breaks in `value`.
 * Does not trim initial and final spaces and tabs of the value itself.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Trimmed value.
 */
function trimLines(value) {
  const source = String(value)
  const search = /\r?\n|\r/g
  let match = search.exec(source)
  let last = 0
  /** @type {Array<string>} */
  const lines = []

  while (match) {
    lines.push(
      trimLine(source.slice(last, match.index), last > 0, true),
      match[0]
    )

    last = match.index + match[0].length
    match = search.exec(source)
  }

  lines.push(trimLine(source.slice(last), last > 0, false))

  return lines.join('')
}

/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */
function trimLine(value, start, end) {
  let startIndex = 0
  let endIndex = value.length

  if (start) {
    let code = value.codePointAt(startIndex)

    while (code === tab || code === space) {
      startIndex++
      code = value.codePointAt(startIndex)
    }
  }

  if (end) {
    let code = value.codePointAt(endIndex - 1)

    while (code === tab || code === space) {
      endIndex--
      code = value.codePointAt(endIndex - 1)
    }
  }

  return endIndex > startIndex ? value.slice(startIndex, endIndex) : ''
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/text.js
/**
 * @typedef {import('mdast').Text} Text
 * @typedef {import('../index.js').Handler} Handler
 */




/**
 * @type {Handler}
 * @param {Text} node
 */
function handlers_text_text(h, node) {
  return h.augment(node, u('text', trimLines(String(node.value))))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/thematic-break.js
/**
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {ThematicBreak} [node]
 * @returns {Element}
 */
function thematic_break_thematicBreak(h, node) {
  return h(node, 'hr')
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/index.js























const handlers = {
  blockquote: blockquote,
  break: hardBreak,
  code: code,
  delete: strikethrough,
  emphasis: emphasis,
  footnoteReference: footnoteReference,
  footnote: footnote,
  heading: heading,
  html: html,
  imageReference: imageReference,
  image: image_image,
  inlineCode: inlineCode,
  linkReference: linkReference,
  link: link_link,
  listItem: listItem,
  list: list_list,
  paragraph: paragraph,
  root: root,
  strong: strong,
  table: table,
  text: handlers_text_text,
  thematicBreak: thematic_break_thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
}

// Return nothing for nodes that are ignored.
function ignore() {
  return null
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/index.js
/**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('hast').Root|import('hast').Parent['children'][number]} HastNode
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} Content
 * @typedef {import('unist-util-position').PositionLike} PositionLike
 *
 * @typedef EmbeddedHastFields
 * @property {string} [hName]
 *   Defines the tag name of an element.
 * @property {Properties} [hProperties]
 *   Defines the properties of an element.
 * @property {Array<Content>} [hChildren]
 *   Defines the (hast) children of an element.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} Data
 *   unist data with embedded hast fields.
 *
 * @typedef {MdastNode & {data?: Data}} NodeWithData
 *   unist node with embedded hast data.
 *
 * @callback Handler
 *   Handle a node.
 * @param {H} h
 *   Handle context.
 * @param {any} node
 *   mdast node to handle.
 * @param {Parent|null} parent
 *   Parent of `node`.
 * @returns {Content|Array<Content>|null|undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 * @param {MdastNode|PositionLike|null|undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Properties} props
 *   Properties.
 * @param {Array<Content>?} [children]
 *   hast content.
 * @returns {Element}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 * @param {MdastNode|PositionLike|null|undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<Content>?} [children]
 *   hast content
 * @returns {Element}
 *   Compiled element.
 *
 * @typedef HFields
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {Properties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use to go back to a footnote call from the footnote section.
 * @property {(identifier: string) => Definition|null} definition
 *   Definition cache.
 * @property {Record<string, FootnoteDefinition>} footnoteById
 *   Footnote cache.
 * @property {Array<string>} footnoteOrder
 *   Order in which footnotes occur.
 * @property {Record<string, number>} footnoteCounts
 *   Counts the same footnote was used.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(left: NodeWithData|PositionLike|null|undefined, right: Content) => Content} augment
 *   Like `h` but lower-level and usable on non-elements.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [allowDangerousHtml=false]
 *   Whether to allow `html` nodes and inject them as `raw` HTML.
 * @property {string} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute to prevent it from *clobbering*.
 *   attributes.
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id=x></p>
 *   <script>alert(x)</script>
 *   ```
 *
 *   Elements by their ID are made available in browsers on the `window` object.
 *   Using a prefix prevents this from being a problem.
 * @property {string} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section.
 *   Affects screen reader users.
 *   Change it if you’re authoring in a different language.
 * @property {string} [footnoteLabelTagName='h2']
 *   HTML tag to use for the footnote label.
 *   Can be changed to match your document structure and play well with your choice of css.
 * @property {Properties} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label.
 *   A 'sr-only' class is added by default to hide this from sighted users.
 *   Change it to make the label visible, or add classes for other purposes.
 * @property {string} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call.
 *   Affects screen reader users.
 *   Change it if you’re authoring in a different language.
 * @property {Handlers} [handlers]
 *   Object mapping mdast nodes to functions handling them
 * @property {Array<string>} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast
 * @property {Handler} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Map of node types to handlers
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} H
 *   Handle context
 */










const mdast_util_to_hast_lib_own = {}.hasOwnProperty

/**
 * Turn mdast into hast.
 *
 * @param {MdastNode} tree
 *   mdast node.
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {H}
 *   `h` function.
 */
function factory(tree, options) {
  const settings = options || {}
  const dangerous = settings.allowDangerousHtml || false
  /** @type {Record<string, FootnoteDefinition>} */
  const footnoteById = {}

  h.dangerous = dangerous
  h.clobberPrefix =
    settings.clobberPrefix === undefined || settings.clobberPrefix === null
      ? 'user-content-'
      : settings.clobberPrefix
  h.footnoteLabel = settings.footnoteLabel || 'Footnotes'
  h.footnoteLabelTagName = settings.footnoteLabelTagName || 'h2'
  h.footnoteLabelProperties = settings.footnoteLabelProperties || {
    className: ['sr-only']
  }
  h.footnoteBackLabel = settings.footnoteBackLabel || 'Back to content'
  h.definition = definitions(tree)
  h.footnoteById = footnoteById
  /** @type {Array<string>} */
  h.footnoteOrder = []
  /** @type {Record<string, number>} */
  h.footnoteCounts = {}
  h.augment = augment
  h.handlers = {...handlers, ...settings.handlers}
  h.unknownHandler = settings.unknownHandler
  h.passThrough = settings.passThrough

  visit(tree, 'footnoteDefinition', (definition) => {
    const id = String(definition.identifier).toUpperCase()

    // Mimick CM behavior of link definitions.
    // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
    if (!mdast_util_to_hast_lib_own.call(footnoteById, id)) {
      footnoteById[id] = definition
    }
  })

  // @ts-expect-error Hush, it’s fine!
  return h

  /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {(NodeWithData|PositionLike)?} left
   * @param {Content} right
   * @returns {Content}
   */
  function augment(left, right) {
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (left && 'data' in left && left.data) {
      /** @type {Data} */
      const data = left.data

      if (data.hName) {
        if (right.type !== 'element') {
          right = {
            type: 'element',
            tagName: '',
            properties: {},
            children: []
          }
        }

        right.tagName = data.hName
      }

      if (right.type === 'element' && data.hProperties) {
        right.properties = {...right.properties, ...data.hProperties}
      }

      if ('children' in right && right.children && data.hChildren) {
        right.children = data.hChildren
      }
    }

    if (left) {
      const ctx = 'type' in left ? left : {position: left}

      if (!generated(ctx)) {
        // @ts-expect-error: fine.
        right.position = {start: pointStart(ctx), end: pointEnd(ctx)}
      }
    }

    return right
  }

  /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */
  function h(node, tagName, props, children) {
    if (Array.isArray(props)) {
      children = props
      props = {}
    }

    // @ts-expect-error augmenting an element yields an element.
    return augment(node, {
      type: 'element',
      tagName,
      properties: props || {},
      children: children || []
    })
  }
}

/**
 * Transform `tree` (an mdast node) to a hast node.
 *
 * @param {MdastNode} tree mdast node
 * @param {Options} [options] Configuration
 * @returns {HastNode|null|undefined} hast node
 */
function toHast(tree, options) {
  const h = factory(tree, options)
  const node = traverse_one(h, tree, null)
  const foot = footer(h)

  if (foot) {
    // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push(u('text', '\n'), foot)
  }

  return Array.isArray(node) ? {type: 'root', children: node} : node
}



;// CONCATENATED MODULE: ../node_modules/remark-rehype/lib/index.js
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */



// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(

/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */
const remarkRehype =
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  (
    function (destination, options) {
      return destination && 'run' in destination
        ? bridge(destination, options)
        : mutate(destination || options)
    }
  )

/* harmony default export */ var lib = (remarkRehype);

/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */
function bridge(destination, options) {
  return (node, file, next) => {
    destination.run(toHast(node, options), file, (error) => {
      next(error)
    })
  }
}

/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */
function mutate(options) {
  // @ts-expect-error: assume a corresponding node is returned by `toHast`.
  return (node) => toHast(node, options)
}

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/schema.js
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

class Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space) {
    this.property = property
    this.normal = normal
    if (space) {
      this.space = space
    }
  }
}

/** @type {Properties} */
Schema.prototype.property = {}
/** @type {Normal} */
Schema.prototype.normal = {}
/** @type {string|null} */
Schema.prototype.space = null

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/merge.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */



/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function merge(definitions, space) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  let index = -1

  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property)
    Object.assign(normal, definitions[index].normal)
  }

  return new Schema(property, normal, space)
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/normalize.js
/**
 * @param {string} value
 * @returns {string}
 */
function normalize_normalize(value) {
  return value.toLowerCase()
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/info.js
class Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    /** @type {string} */
    this.property = property
    /** @type {string} */
    this.attribute = attribute
  }
}

/** @type {string|null} */
Info.prototype.space = null
Info.prototype.boolean = false
Info.prototype.booleanish = false
Info.prototype.overloadedBoolean = false
Info.prototype.number = false
Info.prototype.commaSeparated = false
Info.prototype.spaceSeparated = false
Info.prototype.commaOrSpaceSeparated = false
Info.prototype.mustUseProperty = false
Info.prototype.defined = false

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/types.js
let powers = 0

const types_boolean = increment()
const booleanish = increment()
const overloadedBoolean = increment()
const number = increment()
const spaceSeparated = increment()
const commaSeparated = increment()
const commaOrSpaceSeparated = increment()

function increment() {
  return 2 ** ++powers
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/defined-info.js



/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
const checks = Object.keys(types_namespaceObject)

class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space) {
    let index = -1

    super(property, attribute)

    mark(this, 'space', space)

    if (typeof mask === 'number') {
      while (++index < checks.length) {
        const check = checks[index]
        mark(this, checks[index], (mask & types_namespaceObject[check]) === types_namespaceObject[check])
      }
    }
  }
}

DefinedInfo.prototype.defined = true

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value
  }
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/create.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */





const create_own = {}.hasOwnProperty

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function create(definition) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  /** @type {string} */
  let prop

  for (prop in definition.properties) {
    if (create_own.call(definition.properties, prop)) {
      const value = definition.properties[prop]
      const info = new DefinedInfo(
        prop,
        definition.transform(definition.attributes || {}, prop),
        value,
        definition.space
      )

      if (
        definition.mustUseProperty &&
        definition.mustUseProperty.includes(prop)
      ) {
        info.mustUseProperty = true
      }

      property[prop] = info

      normal[normalize_normalize(prop)] = prop
      normal[normalize_normalize(info.attribute)] = prop
    }
  }

  return new Schema(property, normal, definition.space)
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/xlink.js


const xlink = create({
  space: 'xlink',
  transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase()
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

;// CONCATENATED MODULE: ../node_modules/property-information/lib/xml.js


const xml = create({
  space: 'xml',
  transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase()
  },
  properties: {xmlLang: null, xmlBase: null, xmlSpace: null}
})

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/case-sensitive-transform.js
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/case-insensitive-transform.js


/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/xmlns.js



const xmlns = create({
  space: 'xmlns',
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  transform: caseInsensitiveTransform,
  properties: {xmlns: null, xmlnsXLink: null}
})

;// CONCATENATED MODULE: ../node_modules/property-information/lib/aria.js



const aria = create({
  transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
})

;// CONCATENATED MODULE: ../node_modules/property-information/lib/html.js




const html_html = create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: types_boolean,
    allowPaymentRequest: types_boolean,
    allowUserMedia: types_boolean,
    alt: null,
    as: null,
    async: types_boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: types_boolean,
    autoPlay: types_boolean,
    capture: types_boolean,
    charSet: null,
    checked: types_boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: types_boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: types_boolean,
    defer: types_boolean,
    dir: null,
    dirName: null,
    disabled: types_boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: types_boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: types_boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: types_boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: types_boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: types_boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: types_boolean,
    muted: types_boolean,
    name: null,
    nonce: null,
    noModule: types_boolean,
    noValidate: types_boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: types_boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: types_boolean,
    poster: null,
    preload: null,
    readOnly: types_boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: types_boolean,
    reversed: types_boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: types_boolean,
    seamless: types_boolean,
    selected: types_boolean,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: types_boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: types_boolean, // Lists. Use CSS to reduce space between items instead
    declare: types_boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: types_boolean, // `<frame>`
    noHref: types_boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: types_boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: types_boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: types_boolean,
    disableRemotePlayback: types_boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
})

;// CONCATENATED MODULE: ../node_modules/property-information/lib/svg.js




const svg = create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: types_boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
})

;// CONCATENATED MODULE: ../node_modules/property-information/index.js
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */












const property_information_html = merge([xml, xlink, xmlns, aria, html_html], 'html')
const property_information_svg = merge([xml, xlink, xmlns, aria, svg], 'svg')

;// CONCATENATED MODULE: ../node_modules/react-markdown/lib/rehype-filter.js


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 *
 * @callback AllowElement
 * @param {Element} element
 * @param {number} index
 * @param {Element|Root} parent
 * @returns {boolean|undefined}
 *
 * @typedef Options
 * @property {Array<string>} [allowedElements]
 * @property {Array<string>} [disallowedElements=[]]
 * @property {AllowElement} [allowElement]
 * @property {boolean} [unwrapDisallowed=false]
 */

/**
 * @type {import('unified').Plugin<[Options], Root>}
 */
function rehypeFilter(options) {
  if (options.allowedElements && options.disallowedElements) {
    throw new TypeError(
      'Only one of `allowedElements` and `disallowedElements` should be defined'
    )
  }

  if (
    options.allowedElements ||
    options.disallowedElements ||
    options.allowElement
  ) {
    return (tree) => {
      visit(tree, 'element', (node, index, parent_) => {
        const parent = /** @type {Element|Root} */ (parent_)
        /** @type {boolean|undefined} */
        let remove

        if (options.allowedElements) {
          remove = !options.allowedElements.includes(node.tagName)
        } else if (options.disallowedElements) {
          remove = options.disallowedElements.includes(node.tagName)
        }

        if (!remove && options.allowElement && typeof index === 'number') {
          remove = !options.allowElement(node, index, parent)
        }

        if (remove && typeof index === 'number') {
          if (options.unwrapDisallowed && node.children) {
            parent.children.splice(index, 1, ...node.children)
          } else {
            parent.children.splice(index, 1)
          }

          return index
        }

        return undefined
      })
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/react-markdown/lib/uri-transformer.js
const protocols = ['http', 'https', 'mailto', 'tel']

/**
 * @param {string} uri
 * @returns {string}
 */
function uriTransformer(uri) {
  const url = (uri || '').trim()
  const first = url.charAt(0)

  if (first === '#' || first === '/') {
    return url
  }

  const colon = url.indexOf(':')
  if (colon === -1) {
    return url
  }

  let index = -1

  while (++index < protocols.length) {
    const protocol = protocols[index]

    if (
      colon === protocol.length &&
      url.slice(0, protocol.length).toLowerCase() === protocol
    ) {
      return url
    }
  }

  index = url.indexOf('?')
  if (index !== -1 && colon > index) {
    return url
  }

  index = url.indexOf('#')
  if (index !== -1 && colon > index) {
    return url
  }

  // eslint-disable-next-line no-script-url
  return 'javascript:void(0)'
}

// EXTERNAL MODULE: ../node_modules/react-markdown/node_modules/react-is/index.js
var react_is = __webpack_require__(90117);
;// CONCATENATED MODULE: ../node_modules/hast-util-whitespace/index.js
/**
 * @param {unknown} thing
 * @returns {boolean}
 */
function whitespace(thing) {
  /** @type {string} */
  var value =
    // @ts-ignore looks like a node.
    thing && typeof thing === 'object' && thing.type === 'text'
      ? // @ts-ignore looks like a text.
        thing.value || ''
      : thing

  // HTML whitespace expression.
  // See <https://html.spec.whatwg.org/#space-character>.
  return typeof value === 'string' && value.replace(/[ \t\n\f\r]/g, '') === ''
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/find.js
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */





const valid = /^data[-\w.:]+$/i
const dash = /-[a-z]/g
const cap = /[A-Z]/g

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function find(schema, value) {
  const normal = normalize_normalize(value)
  let prop = value
  let Type = Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(dash, camelcase)
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1)
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4)

      if (!dash.test(rest)) {
        let dashes = rest.replace(cap, kebab)

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes
        }

        value = 'data' + dashes
      }
    }

    Type = DefinedInfo
  }

  return new Type(prop, value)
}

/**
 * @param {string} $0
 * @returns {string}
 */
function kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 * @returns {string}
 */
function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/hast-to-react.js
const hastToReact = {
  classId: 'classID',
  dataType: 'datatype',
  itemId: 'itemID',
  strokeDashArray: 'strokeDasharray',
  strokeDashOffset: 'strokeDashoffset',
  strokeLineCap: 'strokeLinecap',
  strokeLineJoin: 'strokeLinejoin',
  strokeMiterLimit: 'strokeMiterlimit',
  typeOf: 'typeof',
  xLinkActuate: 'xlinkActuate',
  xLinkArcRole: 'xlinkArcrole',
  xLinkHref: 'xlinkHref',
  xLinkRole: 'xlinkRole',
  xLinkShow: 'xlinkShow',
  xLinkTitle: 'xlinkTitle',
  xLinkType: 'xlinkType',
  xmlnsXLink: 'xmlnsXlink'
}

;// CONCATENATED MODULE: ../node_modules/space-separated-tokens/index.js
/**
 * Parse space separated tokens to an array of strings.
 *
 * @param {string} value Space separated tokens
 * @returns {Array.<string>} Tokens
 */
function space_separated_tokens_parse(value) {
  const input = String(value || '').trim()
  return input ? input.split(/[ \t\n\r\f]+/g) : []
}

/**
 * Serialize an array of strings as space separated tokens.
 *
 * @param {Array.<string|number>} values Tokens
 * @returns {string} Space separated tokens
 */
function stringify(values) {
  return values.join(' ').trim()
}

;// CONCATENATED MODULE: ../node_modules/comma-separated-tokens/index.js
/**
 * @typedef {Object} StringifyOptions
 * @property {boolean} [padLeft=true] Whether to pad a space before a token (`boolean`, default: `true`).
 * @property {boolean} [padRight=false] Whether to pad a space after a token (`boolean`, default: `false`).
 */

/**
 * Parse comma separated tokens to an array.
 *
 * @param {string} value
 * @returns {Array.<string>}
 */
function comma_separated_tokens_parse(value) {
  /** @type {Array.<string>} */
  var tokens = []
  var input = String(value || '')
  var index = input.indexOf(',')
  var start = 0
  /** @type {boolean} */
  var end
  /** @type {string} */
  var token

  while (!end) {
    if (index === -1) {
      index = input.length
      end = true
    }

    token = input.slice(start, index).trim()

    if (token || !end) {
      tokens.push(token)
    }

    start = index + 1
    index = input.indexOf(',', start)
  }

  return tokens
}

/**
 * Serialize an array of strings to comma separated tokens.
 *
 * @param {Array.<string|number>} values
 * @param {StringifyOptions} [options]
 * @returns {string}
 */
function comma_separated_tokens_stringify(values, options) {
  var settings = options || {}

  // Ensure the last empty entry is seen.
  if (values[values.length - 1] === '') {
    values = values.concat('')
  }

  return values
    .join(
      (settings.padRight ? ' ' : '') +
        ',' +
        (settings.padLeft === false ? '' : ' ')
    )
    .trim()
}

// EXTERNAL MODULE: ../node_modules/style-to-object/index.js
var style_to_object = __webpack_require__(55862);
;// CONCATENATED MODULE: ../node_modules/react-markdown/lib/ast-to-react.js
/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */

/**
 * @template T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'table'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: boolean}} TableCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableCellProps>} TableCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableCellComponent|ReactMarkdownNames} td
 * @property {TableCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */









const ast_to_react_own = {}.hasOwnProperty

// The table-related elements that must not contain whitespace text according
// to React.
const tableElements = new Set(['table', 'thead', 'tbody', 'tfoot', 'tr'])

/**
 * @param {Context} context
 * @param {Element|Root} node
 */
function childrenToReact(context, node) {
  /** @type {Array<ReactNode>} */
  const children = []
  let childIndex = -1
  /** @type {Comment|Doctype|Element|Raw|Text} */
  let child

  while (++childIndex < node.children.length) {
    child = node.children[childIndex]

    if (child.type === 'element') {
      children.push(toReact(context, child, childIndex, node))
    } else if (child.type === 'text') {
      // Currently, a warning is triggered by react for *any* white space in
      // tables.
      // So we drop it.
      // See: <https://github.com/facebook/react/pull/7081>.
      // See: <https://github.com/facebook/react/pull/7515>.
      // See: <https://github.com/remarkjs/remark-react/issues/64>.
      // See: <https://github.com/remarkjs/react-markdown/issues/576>.
      if (
        node.type !== 'element' ||
        !tableElements.has(node.tagName) ||
        !whitespace(child)
      ) {
        children.push(child.value)
      }
    } else if (child.type === 'raw' && !context.options.skipHtml) {
      // Default behavior is to show (encoded) HTML.
      children.push(child.value)
    }
  }

  return children
}

/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */
function toReact(context, node, index, parent) {
  const options = context.options
  const parentSchema = context.schema
  /** @type {ReactMarkdownNames} */
  // @ts-expect-error assume a known HTML/SVG element.
  const name = node.tagName
  /** @type {Record<string, unknown>} */
  const properties = {}
  let schema = parentSchema
  /** @type {string} */
  let property

  if (parentSchema.space === 'html' && name === 'svg') {
    schema = property_information_svg
    context.schema = schema
  }

  if (node.properties) {
    for (property in node.properties) {
      if (ast_to_react_own.call(node.properties, property)) {
        addProperty(properties, property, node.properties[property], context)
      }
    }
  }

  if (name === 'ol' || name === 'ul') {
    context.listDepth++
  }

  const children = childrenToReact(context, node)

  if (name === 'ol' || name === 'ul') {
    context.listDepth--
  }

  // Restore parent schema.
  context.schema = parentSchema

  // Nodes created by plugins do not have positional info, in which case we use
  // an object that matches the position interface.
  const position = node.position || {
    start: {line: null, column: null, offset: null},
    end: {line: null, column: null, offset: null}
  }
  const component =
    options.components && ast_to_react_own.call(options.components, name)
      ? options.components[name]
      : name
  const basic = typeof component === 'string' || component === react.Fragment

  if (!react_is.isValidElementType(component)) {
    throw new TypeError(
      `Component for name \`${name}\` not defined or is not renderable`
    )
  }

  properties.key = [
    name,
    position.start.line,
    position.start.column,
    index
  ].join('-')

  if (name === 'a' && options.linkTarget) {
    properties.target =
      typeof options.linkTarget === 'function'
        ? options.linkTarget(
            String(properties.href || ''),
            node.children,
            typeof properties.title === 'string' ? properties.title : null
          )
        : options.linkTarget
  }

  if (name === 'a' && options.transformLinkUri) {
    properties.href = options.transformLinkUri(
      String(properties.href || ''),
      node.children,
      typeof properties.title === 'string' ? properties.title : null
    )
  }

  if (
    !basic &&
    name === 'code' &&
    parent.type === 'element' &&
    parent.tagName !== 'pre'
  ) {
    properties.inline = true
  }

  if (
    !basic &&
    (name === 'h1' ||
      name === 'h2' ||
      name === 'h3' ||
      name === 'h4' ||
      name === 'h5' ||
      name === 'h6')
  ) {
    properties.level = Number.parseInt(name.charAt(1), 10)
  }

  if (name === 'img' && options.transformImageUri) {
    properties.src = options.transformImageUri(
      String(properties.src || ''),
      String(properties.alt || ''),
      typeof properties.title === 'string' ? properties.title : null
    )
  }

  if (!basic && name === 'li' && parent.type === 'element') {
    const input = getInputElement(node)
    properties.checked =
      input && input.properties ? Boolean(input.properties.checked) : null
    properties.index = getElementsBeforeCount(parent, node)
    properties.ordered = parent.tagName === 'ol'
  }

  if (!basic && (name === 'ol' || name === 'ul')) {
    properties.ordered = name === 'ol'
    properties.depth = context.listDepth
  }

  if (name === 'td' || name === 'th') {
    if (properties.align) {
      if (!properties.style) properties.style = {}
      // @ts-expect-error assume `style` is an object
      properties.style.textAlign = properties.align
      delete properties.align
    }

    if (!basic) {
      properties.isHeader = name === 'th'
    }
  }

  if (!basic && name === 'tr' && parent.type === 'element') {
    properties.isHeader = Boolean(parent.tagName === 'thead')
  }

  // If `sourcePos` is given, pass source information (line/column info from markdown source).
  if (options.sourcePos) {
    properties['data-sourcepos'] = flattenPosition(position)
  }

  if (!basic && options.rawSourcePos) {
    properties.sourcePosition = node.position
  }

  // If `includeElementIndex` is given, pass node index info to components.
  if (!basic && options.includeElementIndex) {
    properties.index = getElementsBeforeCount(parent, node)
    properties.siblingCount = getElementsBeforeCount(parent)
  }

  if (!basic) {
    properties.node = node
  }

  // Ensure no React warnings are emitted for void elements w/ children.
  return children.length > 0
    ? react.createElement(component, properties, children)
    : react.createElement(component, properties)
}

/**
 * @param {Element|Root} node
 * @returns {Element?}
 */
function getInputElement(node) {
  let index = -1

  while (++index < node.children.length) {
    const child = node.children[index]

    if (child.type === 'element' && child.tagName === 'input') {
      return child
    }
  }

  return null
}

/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */
function getElementsBeforeCount(parent, node) {
  let index = -1
  let count = 0

  while (++index < parent.children.length) {
    if (parent.children[index] === node) break
    if (parent.children[index].type === 'element') count++
  }

  return count
}

/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */
function addProperty(props, prop, value, ctx) {
  const info = find(ctx.schema, prop)
  let result = value

  // Ignore nullish and `NaN` values.
  // eslint-disable-next-line no-self-compare
  if (result === null || result === undefined || result !== result) {
    return
  }

  // Accept `array`.
  // Most props are space-separated.
  if (Array.isArray(result)) {
    result = info.commaSeparated ? comma_separated_tokens_stringify(result) : stringify(result)
  }

  if (info.property === 'style' && typeof result === 'string') {
    result = parseStyle(result)
  }

  if (info.space && info.property) {
    props[
      ast_to_react_own.call(hastToReact, info.property)
        ? hastToReact[info.property]
        : info.property
    ] = result
  } else if (info.attribute) {
    props[info.attribute] = result
  }
}

/**
 * @param {string} value
 * @returns {Record<string, string>}
 */
function parseStyle(value) {
  /** @type {Record<string, string>} */
  const result = {}

  try {
    style_to_object(value, iterator)
  } catch {
    // Silent.
  }

  return result

  /**
   * @param {string} name
   * @param {string} v
   */
  function iterator(name, v) {
    const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name
    result[k.replace(/-([a-z])/g, styleReplacer)] = v
  }
}

/**
 * @param {unknown} _
 * @param {string} $1
 */
function styleReplacer(_, $1) {
  return $1.toUpperCase()
}

/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */
function flattenPosition(pos) {
  return [
    pos.start.line,
    ':',
    pos.start.column,
    '-',
    pos.end.line,
    ':',
    pos.end.column
  ]
    .map((d) => String(d))
    .join('')
}

;// CONCATENATED MODULE: ../node_modules/react-markdown/lib/react-markdown.js
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */












const react_markdown_own = {}.hasOwnProperty
const changelog =
  'https://github.com/remarkjs/react-markdown/blob/main/changelog.md'

/** @type {Record<string, Deprecation>} */
const deprecated = {
  plugins: {to: 'plugins', id: 'change-plugins-to-remarkplugins'},
  renderers: {to: 'components', id: 'change-renderers-to-components'},
  astPlugins: {id: 'remove-buggy-html-in-markdown-parser'},
  allowDangerousHtml: {id: 'remove-buggy-html-in-markdown-parser'},
  escapeHtml: {id: 'remove-buggy-html-in-markdown-parser'},
  source: {to: 'children', id: 'change-source-to-children'},
  allowNode: {
    to: 'allowElement',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  allowedTypes: {
    to: 'allowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  disallowedTypes: {
    to: 'disallowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  includeNodeIndex: {
    to: 'includeElementIndex',
    id: 'change-includenodeindex-to-includeelementindex'
  }
}

/**
 * React component to render markdown.
 *
 * @param {ReactMarkdownOptions} options
 * @returns {ReactElement}
 */
function ReactMarkdown(options) {
  for (const key in deprecated) {
    if (react_markdown_own.call(deprecated, key) && react_markdown_own.call(options, key)) {
      const deprecation = deprecated[key]
      console.warn(
        `[react-markdown] Warning: please ${
          deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'
        } \`${key}\` (see <${changelog}#${deprecation.id}> for more info)`
      )
      delete deprecated[key]
    }
  }

  const processor = unified()
    .use(remark_parse)
    .use(options.remarkPlugins || [])
    .use(lib, {
      ...options.remarkRehypeOptions,
      allowDangerousHtml: true
    })
    .use(options.rehypePlugins || [])
    .use(rehypeFilter, options)

  const file = new VFile()

  if (typeof options.children === 'string') {
    file.value = options.children
  } else if (options.children !== undefined && options.children !== null) {
    console.warn(
      `[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`
    )
  }

  const hastNode = processor.runSync(processor.parse(file), file)

  if (hastNode.type !== 'root') {
    throw new TypeError('Expected a `root` node')
  }

  /** @type {ReactElement} */
  let result = react.createElement(
    react.Fragment,
    {},
    childrenToReact({options, schema: property_information_html, listDepth: 0}, hastNode)
  )

  if (options.className) {
    result = react.createElement('div', {className: options.className}, result)
  }

  return result
}

ReactMarkdown.defaultProps = {transformLinkUri: uriTransformer}

ReactMarkdown.propTypes = {
  // Core options:
  children: prop_types.string,
  // Layout options:
  className: prop_types.string,
  // Filter options:
  allowElement: prop_types.func,
  allowedElements: prop_types.arrayOf(prop_types.string),
  disallowedElements: prop_types.arrayOf(prop_types.string),
  unwrapDisallowed: prop_types.bool,
  // Plugin options:
  remarkPlugins: prop_types.arrayOf(
    prop_types.oneOfType([
      prop_types.object,
      prop_types.func,
      prop_types.arrayOf(
        prop_types.oneOfType([
          prop_types.bool,
          prop_types.string,
          prop_types.object,
          prop_types.func,
          prop_types.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            prop_types.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: prop_types.arrayOf(
    prop_types.oneOfType([
      prop_types.object,
      prop_types.func,
      prop_types.arrayOf(
        prop_types.oneOfType([
          prop_types.bool,
          prop_types.string,
          prop_types.object,
          prop_types.func,
          prop_types.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            prop_types.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: prop_types.bool,
  rawSourcePos: prop_types.bool,
  skipHtml: prop_types.bool,
  includeElementIndex: prop_types.bool,
  transformLinkUri: prop_types.oneOfType([prop_types.func, prop_types.bool]),
  linkTarget: prop_types.oneOfType([prop_types.func, prop_types.string]),
  transformImageUri: prop_types.func,
  components: prop_types.object
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-autolink-literal/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Code} Code
 */

const www = {
  tokenize: tokenizeWww,
  partial: true
}
const domain = {
  tokenize: tokenizeDomain,
  partial: true
}
const syntax_path = {
  tokenize: tokenizePath,
  partial: true
}
const punctuation = {
  tokenize: tokenizePunctuation,
  partial: true
}
const namedCharacterReference = {
  tokenize: tokenizeNamedCharacterReference,
  partial: true
}
const wwwAutolink = {
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
}
const httpAutolink = {
  tokenize: tokenizeHttpAutolink,
  previous: previousHttp
}
const emailAutolink = {
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
}
/** @type {ConstructRecord} */

const syntax_text = {}
/** @type {Extension} */

const gfmAutolinkLiteral = {
  text: syntax_text
}
let syntax_code = 48 // Add alphanumerics.

while (syntax_code < 123) {
  syntax_text[syntax_code] = emailAutolink
  syntax_code++
  if (syntax_code === 58) syntax_code = 65
  else if (syntax_code === 91) syntax_code = 97
}

syntax_text[43] = emailAutolink
syntax_text[45] = emailAutolink
syntax_text[46] = emailAutolink
syntax_text[95] = emailAutolink
syntax_text[72] = [emailAutolink, httpAutolink]
syntax_text[104] = [emailAutolink, httpAutolink]
syntax_text[87] = [emailAutolink, wwwAutolink]
syntax_text[119] = [emailAutolink, wwwAutolink]
/** @type {Tokenizer} */

function tokenizeEmailAutolink(effects, ok, nok) {
  const self = this
  /** @type {boolean} */

  let hasDot
  /** @type {boolean|undefined} */

  let hasDigitInLastSegment
  return start
  /** @type {State} */

  function start(code) {
    if (
      !gfmAtext(code) ||
      !previousEmail(self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }

    effects.enter('literalAutolink')
    effects.enter('literalAutolinkEmail')
    return atext(code)
  }
  /** @type {State} */

  function atext(code) {
    if (gfmAtext(code)) {
      effects.consume(code)
      return atext
    }

    if (code === 64) {
      effects.consume(code)
      return label
    }

    return nok(code)
  }
  /** @type {State} */

  function label(code) {
    if (code === 46) {
      return effects.check(punctuation, done, dotContinuation)(code)
    }

    if (code === 45 || code === 95) {
      return effects.check(punctuation, nok, dashOrUnderscoreContinuation)(code)
    }

    if (asciiAlphanumeric(code)) {
      if (!hasDigitInLastSegment && asciiDigit(code)) {
        hasDigitInLastSegment = true
      }

      effects.consume(code)
      return label
    }

    return done(code)
  }
  /** @type {State} */

  function dotContinuation(code) {
    effects.consume(code)
    hasDot = true
    hasDigitInLastSegment = undefined
    return label
  }
  /** @type {State} */

  function dashOrUnderscoreContinuation(code) {
    effects.consume(code)
    return afterDashOrUnderscore
  }
  /** @type {State} */

  function afterDashOrUnderscore(code) {
    if (code === 46) {
      return effects.check(punctuation, nok, dotContinuation)(code)
    }

    return label(code)
  }
  /** @type {State} */

  function done(code) {
    if (hasDot && !hasDigitInLastSegment) {
      effects.exit('literalAutolinkEmail')
      effects.exit('literalAutolink')
      return ok(code)
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeWwwAutolink(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    if (
      (code !== 87 && code !== 119) ||
      !previousWww(self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }

    effects.enter('literalAutolink')
    effects.enter('literalAutolinkWww') // For `www.` we check instead of attempt, because when it matches, GH
    // treats it as part of a domain (yes, it says a valid domain must come
    // after `www.`, but that’s not how it’s implemented by them).

    return effects.check(
      www,
      effects.attempt(domain, effects.attempt(syntax_path, done), nok),
      nok
    )(code)
  }
  /** @type {State} */

  function done(code) {
    effects.exit('literalAutolinkWww')
    effects.exit('literalAutolink')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeHttpAutolink(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    if (
      (code !== 72 && code !== 104) ||
      !previousHttp(self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }

    effects.enter('literalAutolink')
    effects.enter('literalAutolinkHttp')
    effects.consume(code)
    return t1
  }
  /** @type {State} */

  function t1(code) {
    if (code === 84 || code === 116) {
      effects.consume(code)
      return t2
    }

    return nok(code)
  }
  /** @type {State} */

  function t2(code) {
    if (code === 84 || code === 116) {
      effects.consume(code)
      return p
    }

    return nok(code)
  }
  /** @type {State} */

  function p(code) {
    if (code === 80 || code === 112) {
      effects.consume(code)
      return s
    }

    return nok(code)
  }
  /** @type {State} */

  function s(code) {
    if (code === 83 || code === 115) {
      effects.consume(code)
      return colon
    }

    return colon(code)
  }
  /** @type {State} */

  function colon(code) {
    if (code === 58) {
      effects.consume(code)
      return slash1
    }

    return nok(code)
  }
  /** @type {State} */

  function slash1(code) {
    if (code === 47) {
      effects.consume(code)
      return slash2
    }

    return nok(code)
  }
  /** @type {State} */

  function slash2(code) {
    if (code === 47) {
      effects.consume(code)
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    return code === null ||
      asciiControl(code) ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)
      ? nok(code)
      : effects.attempt(domain, effects.attempt(syntax_path, done), nok)(code)
  }
  /** @type {State} */

  function done(code) {
    effects.exit('literalAutolinkHttp')
    effects.exit('literalAutolink')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeWww(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.consume(code)
    return w2
  }
  /** @type {State} */

  function w2(code) {
    if (code === 87 || code === 119) {
      effects.consume(code)
      return w3
    }

    return nok(code)
  }
  /** @type {State} */

  function w3(code) {
    if (code === 87 || code === 119) {
      effects.consume(code)
      return dot
    }

    return nok(code)
  }
  /** @type {State} */

  function dot(code) {
    if (code === 46) {
      effects.consume(code)
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    return code === null || markdownLineEnding(code) ? nok(code) : ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeDomain(effects, ok, nok) {
  /** @type {boolean|undefined} */
  let hasUnderscoreInLastSegment
  /** @type {boolean|undefined} */

  let hasUnderscoreInLastLastSegment
  return domain
  /** @type {State} */

  function domain(code) {
    if (code === 38) {
      return effects.check(
        namedCharacterReference,
        done,
        punctuationContinuation
      )(code)
    }

    if (code === 46 || code === 95) {
      return effects.check(punctuation, done, punctuationContinuation)(code)
    } // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
    // occur, which sounds like ASCII only, but they also support `www.點看.com`,
    // so that’s Unicode.
    // Instead of some new production for Unicode alphanumerics, markdown
    // already has that for Unicode punctuation and whitespace, so use those.

    if (
      code === null ||
      asciiControl(code) ||
      unicodeWhitespace(code) ||
      (code !== 45 && unicodePunctuation(code))
    ) {
      return done(code)
    }

    effects.consume(code)
    return domain
  }
  /** @type {State} */

  function punctuationContinuation(code) {
    if (code === 46) {
      hasUnderscoreInLastLastSegment = hasUnderscoreInLastSegment
      hasUnderscoreInLastSegment = undefined
      effects.consume(code)
      return domain
    }

    if (code === 95) hasUnderscoreInLastSegment = true
    effects.consume(code)
    return domain
  }
  /** @type {State} */

  function done(code) {
    if (!hasUnderscoreInLastLastSegment && !hasUnderscoreInLastSegment) {
      return ok(code)
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizePath(effects, ok) {
  let balance = 0
  return inPath
  /** @type {State} */

  function inPath(code) {
    if (code === 38) {
      return effects.check(
        namedCharacterReference,
        ok,
        continuedPunctuation
      )(code)
    }

    if (code === 40) {
      balance++
    }

    if (code === 41) {
      return effects.check(
        punctuation,
        parenAtPathEnd,
        continuedPunctuation
      )(code)
    }

    if (pathEnd(code)) {
      return ok(code)
    }

    if (trailingPunctuation(code)) {
      return effects.check(punctuation, ok, continuedPunctuation)(code)
    }

    effects.consume(code)
    return inPath
  }
  /** @type {State} */

  function continuedPunctuation(code) {
    effects.consume(code)
    return inPath
  }
  /** @type {State} */

  function parenAtPathEnd(code) {
    balance--
    return balance < 0 ? ok(code) : continuedPunctuation(code)
  }
}
/** @type {Tokenizer} */

function tokenizeNamedCharacterReference(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.consume(code)
    return inside
  }
  /** @type {State} */

  function inside(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      return inside
    }

    if (code === 59) {
      effects.consume(code)
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    // If the named character reference is followed by the end of the path, it’s
    // not continued punctuation.
    return pathEnd(code) ? ok(code) : nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizePunctuation(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.consume(code)
    return after
  }
  /** @type {State} */

  function after(code) {
    // Check the next.
    if (trailingPunctuation(code)) {
      effects.consume(code)
      return after
    } // If the punctuation marker is followed by the end of the path, it’s not
    // continued punctuation.

    return pathEnd(code) ? ok(code) : nok(code)
  }
}
/**
 * @param {Code} code
 * @returns {boolean}
 */

function trailingPunctuation(code) {
  return (
    code === 33 ||
    code === 34 ||
    code === 39 ||
    code === 41 ||
    code === 42 ||
    code === 44 ||
    code === 46 ||
    code === 58 ||
    code === 59 ||
    code === 60 ||
    code === 63 ||
    code === 95 ||
    code === 126
  )
}
/**
 * @param {Code} code
 * @returns {boolean}
 */

function pathEnd(code) {
  return code === null || code === 60 || markdownLineEndingOrSpace(code)
}
/**
 * @param {Code} code
 * @returns {boolean}
 */

function gfmAtext(code) {
  return (
    code === 43 ||
    code === 45 ||
    code === 46 ||
    code === 95 ||
    asciiAlphanumeric(code)
  )
}
/** @type {Previous} */

function previousWww(code) {
  return (
    code === null ||
    code === 40 ||
    code === 42 ||
    code === 95 ||
    code === 126 ||
    markdownLineEndingOrSpace(code)
  )
}
/** @type {Previous} */

function previousHttp(code) {
  return code === null || !asciiAlpha(code)
}
/** @type {Previous} */

function previousEmail(code) {
  return code !== 47 && previousHttp(code)
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */

function previousUnbalanced(events) {
  let index = events.length
  let result = false

  while (index--) {
    const token = events[index][1]

    if (
      (token.type === 'labelLink' || token.type === 'labelImage') &&
      !token._balanced
    ) {
      result = true
      break
    } // @ts-expect-error If we’ve seen this token, and it was marked as not
    // having any unbalanced bracket before it, we can exit.

    if (token._gfmAutolinkLiteralWalkedInto) {
      result = false
      break
    }
  }

  if (events.length > 0 && !result) {
    // @ts-expect-error Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true
  }

  return result
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-footnote/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Event} Event
 */




const indent = {
  tokenize: syntax_tokenizeIndent,
  partial: true
}
/**
 * @returns {Extension}
 */

function gfmFootnote() {
  /** @type {Extension} */
  return {
    document: {
      [91]: {
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      [91]: {
        tokenize: tokenizeGfmFootnoteCall
      },
      [93]: {
        add: 'after',
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  }
}
/** @type {Tokenizer} */

function tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
  const self = this
  let index = self.events.length
  /** @type {Array<string>} */
  // @ts-expect-error It’s fine!

  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = [])
  /** @type {Token} */

  let labelStart // Find an opening.

  while (index--) {
    const token = self.events[index][1]

    if (token.type === 'labelImage') {
      labelStart = token
      break
    } // Exit if we’ve walked far enough.

    if (
      token.type === 'gfmFootnoteCall' ||
      token.type === 'labelLink' ||
      token.type === 'label' ||
      token.type === 'image' ||
      token.type === 'link'
    ) {
      break
    }
  }

  return start
  /** @type {State} */

  function start(code) {
    if (!labelStart || !labelStart._balanced) {
      return nok(code)
    }

    const id = normalizeIdentifier(
      self.sliceSerialize({
        start: labelStart.end,
        end: self.now()
      })
    )

    if (id.charCodeAt(0) !== 94 || !defined.includes(id.slice(1))) {
      return nok(code)
    }

    effects.enter('gfmFootnoteCallLabelMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteCallLabelMarker')
    return ok(code)
  }
}
/** @type {Resolver} */

function resolveToPotentialGfmFootnoteCall(events, context) {
  let index = events.length
  /** @type {Token|undefined} */

  let labelStart // Find an opening.

  while (index--) {
    if (
      events[index][1].type === 'labelImage' &&
      events[index][0] === 'enter'
    ) {
      labelStart = events[index][1]
      break
    }
  }

  // Change the `labelImageMarker` to a `data`.
  events[index + 1][1].type = 'data'
  events[index + 3][1].type = 'gfmFootnoteCallLabelMarker' // The whole (without `!`):

  const call = {
    type: 'gfmFootnoteCall',
    start: Object.assign({}, events[index + 3][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  } // The `^` marker

  const marker = {
    type: 'gfmFootnoteCallMarker',
    start: Object.assign({}, events[index + 3][1].end),
    end: Object.assign({}, events[index + 3][1].end)
  } // Increment the end 1 character.

  marker.end.column++
  marker.end.offset++
  marker.end._bufferIndex++
  const string = {
    type: 'gfmFootnoteCallString',
    start: Object.assign({}, marker.end),
    end: Object.assign({}, events[events.length - 1][1].start)
  }
  const chunk = {
    type: 'chunkString',
    contentType: 'string',
    start: Object.assign({}, string.start),
    end: Object.assign({}, string.end)
  }
  /** @type {Array<Event>} */

  const replacement = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    events[index + 1],
    events[index + 2],
    ['enter', call, context], // The `[`
    events[index + 3],
    events[index + 4], // The `^`.
    ['enter', marker, context],
    ['exit', marker, context], // Everything in between.
    ['enter', string, context],
    ['enter', chunk, context],
    ['exit', chunk, context],
    ['exit', string, context], // The ending (`]`, properly parsed and labelled).
    events[events.length - 2],
    events[events.length - 1],
    ['exit', call, context]
  ]
  events.splice(index, events.length - index + 1, ...replacement)
  return events
}
/** @type {Tokenizer} */

function tokenizeGfmFootnoteCall(effects, ok, nok) {
  const self = this
  /** @type {Array<string>} */
  // @ts-expect-error It’s fine!

  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = [])
  let size = 0
  /** @type {boolean} */

  let data
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('gfmFootnoteCall')
    effects.enter('gfmFootnoteCallLabelMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteCallLabelMarker')
    return callStart
  }
  /** @type {State} */

  function callStart(code) {
    if (code !== 94) return nok(code)
    effects.enter('gfmFootnoteCallMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteCallMarker')
    effects.enter('gfmFootnoteCallString')
    effects.enter('chunkString').contentType = 'string'
    return callData
  }
  /** @type {State} */

  function callData(code) {
    /** @type {Token} */
    let token

    if (code === null || code === 91 || size++ > 999) {
      return nok(code)
    }

    if (code === 93) {
      if (!data) {
        return nok(code)
      }

      effects.exit('chunkString')
      token = effects.exit('gfmFootnoteCallString')
      return defined.includes(normalizeIdentifier(self.sliceSerialize(token)))
        ? end(code)
        : nok(code)
    }

    effects.consume(code)

    if (!markdownLineEndingOrSpace(code)) {
      data = true
    }

    return code === 92 ? callEscape : callData
  }
  /** @type {State} */

  function callEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return callData
    }

    return callData(code)
  }
  /** @type {State} */

  function end(code) {
    effects.enter('gfmFootnoteCallLabelMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteCallLabelMarker')
    effects.exit('gfmFootnoteCall')
    return ok
  }
}
/** @type {Tokenizer} */

function tokenizeDefinitionStart(effects, ok, nok) {
  const self = this
  /** @type {Array<string>} */
  // @ts-expect-error It’s fine!

  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = [])
  /** @type {string} */

  let identifier
  let size = 0
  /** @type {boolean|undefined} */

  let data
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('gfmFootnoteDefinition')._container = true
    effects.enter('gfmFootnoteDefinitionLabel')
    effects.enter('gfmFootnoteDefinitionLabelMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteDefinitionLabelMarker')
    return labelStart
  }
  /** @type {State} */

  function labelStart(code) {
    if (code === 94) {
      effects.enter('gfmFootnoteDefinitionMarker')
      effects.consume(code)
      effects.exit('gfmFootnoteDefinitionMarker')
      effects.enter('gfmFootnoteDefinitionLabelString')
      return atBreak
    }

    return nok(code)
  }
  /** @type {State} */

  function atBreak(code) {
    /** @type {Token} */
    let token

    if (code === null || code === 91 || size > 999) {
      return nok(code)
    }

    if (code === 93) {
      if (!data) {
        return nok(code)
      }

      token = effects.exit('gfmFootnoteDefinitionLabelString')
      identifier = normalizeIdentifier(self.sliceSerialize(token))
      effects.enter('gfmFootnoteDefinitionLabelMarker')
      effects.consume(code)
      effects.exit('gfmFootnoteDefinitionLabelMarker')
      effects.exit('gfmFootnoteDefinitionLabel')
      return labelAfter
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      size++
      return atBreak
    }

    effects.enter('chunkString').contentType = 'string'
    return label(code)
  }
  /** @type {State} */

  function label(code) {
    if (
      code === null ||
      markdownLineEnding(code) ||
      code === 91 ||
      code === 93 ||
      size > 999
    ) {
      effects.exit('chunkString')
      return atBreak(code)
    }

    if (!markdownLineEndingOrSpace(code)) {
      data = true
    }

    size++
    effects.consume(code)
    return code === 92 ? labelEscape : label
  }
  /** @type {State} */

  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return label
    }

    return label(code)
  }
  /** @type {State} */

  function labelAfter(code) {
    if (code === 58) {
      effects.enter('definitionMarker')
      effects.consume(code)
      effects.exit('definitionMarker') // Any whitespace after the marker is eaten, forming indented code
      // is not possible.
      // No space is also fine, just like a block quote marker.

      return factorySpace(effects, done, 'gfmFootnoteDefinitionWhitespace')
    }

    return nok(code)
  }
  /** @type {State} */

  function done(code) {
    if (!defined.includes(identifier)) {
      defined.push(identifier)
    }

    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeDefinitionContinuation(effects, ok, nok) {
  // Either a blank line, which is okay, or an indented thing.
  return effects.check(blankLine, ok, effects.attempt(indent, ok, nok))
}
/** @type {Exiter} */

function gfmFootnoteDefinitionEnd(effects) {
  effects.exit('gfmFootnoteDefinition')
}
/** @type {Tokenizer} */

function syntax_tokenizeIndent(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'gfmFootnoteDefinitionIndent',
    4 + 1
  )
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'gfmFootnoteDefinitionIndent' &&
      tail[2].sliceSerialize(tail[1], true).length === 4
      ? ok(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-strikethrough/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Event} Event
 */

/**
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde (`boolean`, default:
 *   `true`).
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */




/**
 * @param {Options} [options]
 * @returns {Extension}
 */
function gfmStrikethrough(options = {}) {
  let single = options.singleTilde
  const tokenizer = {
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  }

  if (single === null || single === undefined) {
    single = true
  }

  return {
    text: {
      [126]: tokenizer
    },
    insideSpan: {
      null: [tokenizer]
    },
    attentionMarkers: {
      null: [126]
    }
  }
  /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */

  function resolveAllStrikethrough(events, context) {
    let index = -1 // Walk through all events.

    while (++index < events.length) {
      // Find a token that can close.
      if (
        events[index][0] === 'enter' &&
        events[index][1].type === 'strikethroughSequenceTemporary' &&
        events[index][1]._close
      ) {
        let open = index // Now walk back to find an opener.

        while (open--) {
          // Find a token that can open the closer.
          if (
            events[open][0] === 'exit' &&
            events[open][1].type === 'strikethroughSequenceTemporary' &&
            events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset ===
              events[open][1].end.offset - events[open][1].start.offset
          ) {
            events[index][1].type = 'strikethroughSequence'
            events[open][1].type = 'strikethroughSequence'
            const strikethrough = {
              type: 'strikethrough',
              start: Object.assign({}, events[open][1].start),
              end: Object.assign({}, events[index][1].end)
            }
            const text = {
              type: 'strikethroughText',
              start: Object.assign({}, events[open][1].end),
              end: Object.assign({}, events[index][1].start)
            } // Opening.

            const nextEvents = [
              ['enter', strikethrough, context],
              ['enter', events[open][1], context],
              ['exit', events[open][1], context],
              ['enter', text, context]
            ] // Between.

            splice(
              nextEvents,
              nextEvents.length,
              0,
              resolveAll(
                context.parser.constructs.insideSpan.null,
                events.slice(open + 1, index),
                context
              )
            ) // Closing.

            splice(nextEvents, nextEvents.length, 0, [
              ['exit', text, context],
              ['enter', events[index][1], context],
              ['exit', events[index][1], context],
              ['exit', strikethrough, context]
            ])
            splice(events, open - 1, index - open + 3, nextEvents)
            index = open + nextEvents.length - 2
            break
          }
        }
      }
    }

    index = -1

    while (++index < events.length) {
      if (events[index][1].type === 'strikethroughSequenceTemporary') {
        events[index][1].type = 'data'
      }
    }

    return events
  }
  /** @type {Tokenizer} */

  function tokenizeStrikethrough(effects, ok, nok) {
    const previous = this.previous
    const events = this.events
    let size = 0
    return start
    /** @type {State} */

    function start(code) {
      if (
        previous === 126 &&
        events[events.length - 1][1].type !== 'characterEscape'
      ) {
        return nok(code)
      }

      effects.enter('strikethroughSequenceTemporary')
      return more(code)
    }
    /** @type {State} */

    function more(code) {
      const before = classifyCharacter(previous)

      if (code === 126) {
        // If this is the third marker, exit.
        if (size > 1) return nok(code)
        effects.consume(code)
        size++
        return more
      }

      if (size < 2 && !single) return nok(code)
      const token = effects.exit('strikethroughSequenceTemporary')
      const after = classifyCharacter(code)
      token._open = !after || (after === 2 && Boolean(before))
      token._close = !before || (before === 2 && Boolean(after))
      return ok(code)
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-table/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 */

/**
 * @typedef {'left'|'center'|'right'|'none'} Align
 */



/** @type {Extension} */
const gfmTable = {
  flow: {
    null: {
      tokenize: tokenizeTable,
      resolve: resolveTable
    }
  }
}
const nextPrefixedOrBlank = {
  tokenize: tokenizeNextPrefixedOrBlank,
  partial: true
}
/** @type {Resolver} */

function resolveTable(events, context) {
  let index = -1
  /** @type {boolean|undefined} */

  let inHead
  /** @type {boolean|undefined} */

  let inDelimiterRow
  /** @type {boolean|undefined} */

  let inRow
  /** @type {number|undefined} */

  let contentStart
  /** @type {number|undefined} */

  let contentEnd
  /** @type {number|undefined} */

  let cellStart
  /** @type {boolean|undefined} */

  let seenCellInRow

  while (++index < events.length) {
    const token = events[index][1]

    if (inRow) {
      if (token.type === 'temporaryTableCellContent') {
        contentStart = contentStart || index
        contentEnd = index
      }

      if (
        // Combine separate content parts into one.
        (token.type === 'tableCellDivider' || token.type === 'tableRow') &&
        contentEnd
      ) {
        const content = {
          type: 'tableContent',
          start: events[contentStart][1].start,
          end: events[contentEnd][1].end
        }
        /** @type {Token} */

        const text = {
          type: 'chunkText',
          start: content.start,
          end: content.end,
          // @ts-expect-error It’s fine.
          contentType: 'text'
        }
        events.splice(
          contentStart,
          contentEnd - contentStart + 1,
          ['enter', content, context],
          ['enter', text, context],
          ['exit', text, context],
          ['exit', content, context]
        )
        index -= contentEnd - contentStart - 3
        contentStart = undefined
        contentEnd = undefined
      }
    }

    if (
      events[index][0] === 'exit' &&
      cellStart !== undefined &&
      cellStart + (seenCellInRow ? 0 : 1) < index &&
      (token.type === 'tableCellDivider' ||
        (token.type === 'tableRow' &&
          (cellStart + 3 < index ||
            events[cellStart][1].type !== 'whitespace')))
    ) {
      const cell = {
        type: inDelimiterRow
          ? 'tableDelimiter'
          : inHead
          ? 'tableHeader'
          : 'tableData',
        start: events[cellStart][1].start,
        end: events[index][1].end
      }
      events.splice(index + (token.type === 'tableCellDivider' ? 1 : 0), 0, [
        'exit',
        cell,
        context
      ])
      events.splice(cellStart, 0, ['enter', cell, context])
      index += 2
      cellStart = index + 1
      seenCellInRow = true
    }

    if (token.type === 'tableRow') {
      inRow = events[index][0] === 'enter'

      if (inRow) {
        cellStart = index + 1
        seenCellInRow = false
      }
    }

    if (token.type === 'tableDelimiterRow') {
      inDelimiterRow = events[index][0] === 'enter'

      if (inDelimiterRow) {
        cellStart = index + 1
        seenCellInRow = false
      }
    }

    if (token.type === 'tableHead') {
      inHead = events[index][0] === 'enter'
    }
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeTable(effects, ok, nok) {
  const self = this
  /** @type {Array<Align>} */

  const align = []
  let tableHeaderCount = 0
  /** @type {boolean|undefined} */

  let seenDelimiter
  /** @type {boolean|undefined} */

  let hasDash
  return start
  /** @type {State} */

  function start(code) {
    // @ts-expect-error Custom.
    effects.enter('table')._align = align
    effects.enter('tableHead')
    effects.enter('tableRow') // If we start with a pipe, we open a cell marker.

    if (code === 124) {
      return cellDividerHead(code)
    }

    tableHeaderCount++
    effects.enter('temporaryTableCellContent') // Can’t be space or eols at the start of a construct, so we’re in a cell.

    return inCellContentHead(code)
  }
  /** @type {State} */

  function cellDividerHead(code) {
    effects.enter('tableCellDivider')
    effects.consume(code)
    effects.exit('tableCellDivider')
    seenDelimiter = true
    return cellBreakHead
  }
  /** @type {State} */

  function cellBreakHead(code) {
    if (code === null || markdownLineEnding(code)) {
      return atRowEndHead(code)
    }

    if (markdownSpace(code)) {
      effects.enter('whitespace')
      effects.consume(code)
      return inWhitespaceHead
    }

    if (seenDelimiter) {
      seenDelimiter = undefined
      tableHeaderCount++
    }

    if (code === 124) {
      return cellDividerHead(code)
    } // Anything else is cell content.

    effects.enter('temporaryTableCellContent')
    return inCellContentHead(code)
  }
  /** @type {State} */

  function inWhitespaceHead(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return inWhitespaceHead
    }

    effects.exit('whitespace')
    return cellBreakHead(code)
  }
  /** @type {State} */

  function inCellContentHead(code) {
    // EOF, whitespace, pipe
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit('temporaryTableCellContent')
      return cellBreakHead(code)
    }

    effects.consume(code)
    return code === 92 ? inCellContentEscapeHead : inCellContentHead
  }
  /** @type {State} */

  function inCellContentEscapeHead(code) {
    if (code === 92 || code === 124) {
      effects.consume(code)
      return inCellContentHead
    } // Anything else.

    return inCellContentHead(code)
  }
  /** @type {State} */

  function atRowEndHead(code) {
    if (code === null) {
      return nok(code)
    }

    effects.exit('tableRow')
    effects.exit('tableHead')
    const originalInterrupt = self.interrupt
    self.interrupt = true
    return effects.attempt(
      {
        tokenize: tokenizeRowEnd,
        partial: true
      },
      function (code) {
        self.interrupt = originalInterrupt
        effects.enter('tableDelimiterRow')
        return atDelimiterRowBreak(code)
      },
      function (code) {
        self.interrupt = originalInterrupt
        return nok(code)
      }
    )(code)
  }
  /** @type {State} */

  function atDelimiterRowBreak(code) {
    if (code === null || markdownLineEnding(code)) {
      return rowEndDelimiter(code)
    }

    if (markdownSpace(code)) {
      effects.enter('whitespace')
      effects.consume(code)
      return inWhitespaceDelimiter
    }

    if (code === 45) {
      effects.enter('tableDelimiterFiller')
      effects.consume(code)
      hasDash = true
      align.push('none')
      return inFillerDelimiter
    }

    if (code === 58) {
      effects.enter('tableDelimiterAlignment')
      effects.consume(code)
      effects.exit('tableDelimiterAlignment')
      align.push('left')
      return afterLeftAlignment
    } // If we start with a pipe, we open a cell marker.

    if (code === 124) {
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      return atDelimiterRowBreak
    }

    return nok(code)
  }
  /** @type {State} */

  function inWhitespaceDelimiter(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return inWhitespaceDelimiter
    }

    effects.exit('whitespace')
    return atDelimiterRowBreak(code)
  }
  /** @type {State} */

  function inFillerDelimiter(code) {
    if (code === 45) {
      effects.consume(code)
      return inFillerDelimiter
    }

    effects.exit('tableDelimiterFiller')

    if (code === 58) {
      effects.enter('tableDelimiterAlignment')
      effects.consume(code)
      effects.exit('tableDelimiterAlignment')
      align[align.length - 1] =
        align[align.length - 1] === 'left' ? 'center' : 'right'
      return afterRightAlignment
    }

    return atDelimiterRowBreak(code)
  }
  /** @type {State} */

  function afterLeftAlignment(code) {
    if (code === 45) {
      effects.enter('tableDelimiterFiller')
      effects.consume(code)
      hasDash = true
      return inFillerDelimiter
    } // Anything else is not ok.

    return nok(code)
  }
  /** @type {State} */

  function afterRightAlignment(code) {
    if (code === null || markdownLineEnding(code)) {
      return rowEndDelimiter(code)
    }

    if (markdownSpace(code)) {
      effects.enter('whitespace')
      effects.consume(code)
      return inWhitespaceDelimiter
    } // `|`

    if (code === 124) {
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      return atDelimiterRowBreak
    }

    return nok(code)
  }
  /** @type {State} */

  function rowEndDelimiter(code) {
    effects.exit('tableDelimiterRow') // Exit if there was no dash at all, or if the header cell count is not the
    // delimiter cell count.

    if (!hasDash || tableHeaderCount !== align.length) {
      return nok(code)
    }

    if (code === null) {
      return tableClose(code)
    }

    return effects.check(
      nextPrefixedOrBlank,
      tableClose,
      effects.attempt(
        {
          tokenize: tokenizeRowEnd,
          partial: true
        },
        factorySpace(effects, bodyStart, 'linePrefix', 4),
        tableClose
      )
    )(code)
  }
  /** @type {State} */

  function tableClose(code) {
    effects.exit('table')
    return ok(code)
  }
  /** @type {State} */

  function bodyStart(code) {
    effects.enter('tableBody')
    return rowStartBody(code)
  }
  /** @type {State} */

  function rowStartBody(code) {
    effects.enter('tableRow') // If we start with a pipe, we open a cell marker.

    if (code === 124) {
      return cellDividerBody(code)
    }

    effects.enter('temporaryTableCellContent') // Can’t be space or eols at the start of a construct, so we’re in a cell.

    return inCellContentBody(code)
  }
  /** @type {State} */

  function cellDividerBody(code) {
    effects.enter('tableCellDivider')
    effects.consume(code)
    effects.exit('tableCellDivider')
    return cellBreakBody
  }
  /** @type {State} */

  function cellBreakBody(code) {
    if (code === null || markdownLineEnding(code)) {
      return atRowEndBody(code)
    }

    if (markdownSpace(code)) {
      effects.enter('whitespace')
      effects.consume(code)
      return inWhitespaceBody
    } // `|`

    if (code === 124) {
      return cellDividerBody(code)
    } // Anything else is cell content.

    effects.enter('temporaryTableCellContent')
    return inCellContentBody(code)
  }
  /** @type {State} */

  function inWhitespaceBody(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return inWhitespaceBody
    }

    effects.exit('whitespace')
    return cellBreakBody(code)
  }
  /** @type {State} */

  function inCellContentBody(code) {
    // EOF, whitespace, pipe
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit('temporaryTableCellContent')
      return cellBreakBody(code)
    }

    effects.consume(code)
    return code === 92 ? inCellContentEscapeBody : inCellContentBody
  }
  /** @type {State} */

  function inCellContentEscapeBody(code) {
    if (code === 92 || code === 124) {
      effects.consume(code)
      return inCellContentBody
    } // Anything else.

    return inCellContentBody(code)
  }
  /** @type {State} */

  function atRowEndBody(code) {
    effects.exit('tableRow')

    if (code === null) {
      return tableBodyClose(code)
    }

    return effects.check(
      nextPrefixedOrBlank,
      tableBodyClose,
      effects.attempt(
        {
          tokenize: tokenizeRowEnd,
          partial: true
        },
        factorySpace(effects, rowStartBody, 'linePrefix', 4),
        tableBodyClose
      )
    )(code)
  }
  /** @type {State} */

  function tableBodyClose(code) {
    effects.exit('tableBody')
    return tableClose(code)
  }
  /** @type {Tokenizer} */

  function tokenizeRowEnd(effects, ok, nok) {
    return start
    /** @type {State} */

    function start(code) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return factorySpace(effects, prefixed, 'linePrefix')
    }
    /** @type {State} */

    function prefixed(code) {
      // Blank or interrupting line.
      if (
        self.parser.lazy[self.now().line] ||
        code === null ||
        markdownLineEnding(code)
      ) {
        return nok(code)
      }

      const tail = self.events[self.events.length - 1] // Indented code can interrupt delimiter and body rows.

      if (
        !self.parser.constructs.disable.null.includes('codeIndented') &&
        tail &&
        tail[1].type === 'linePrefix' &&
        tail[2].sliceSerialize(tail[1], true).length >= 4
      ) {
        return nok(code)
      }

      self._gfmTableDynamicInterruptHack = true
      return effects.check(
        self.parser.constructs.flow,
        function (code) {
          self._gfmTableDynamicInterruptHack = false
          return nok(code)
        },
        function (code) {
          self._gfmTableDynamicInterruptHack = false
          return ok(code)
        }
      )(code)
    }
  }
}
/** @type {Tokenizer} */

function tokenizeNextPrefixedOrBlank(effects, ok, nok) {
  let size = 0
  return start
  /** @type {State} */

  function start(code) {
    // This is a check, so we don’t care about tokens, but we open a bogus one
    // so we’re valid.
    effects.enter('check') // EOL.

    effects.consume(code)
    return whitespace
  }
  /** @type {State} */

  function whitespace(code) {
    if (code === -1 || code === 32) {
      effects.consume(code)
      size++
      return size === 4 ? ok : whitespace
    } // EOF or whitespace

    if (code === null || markdownLineEndingOrSpace(code)) {
      return ok(code)
    } // Anything else.

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-task-list-item/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Code} Code
 */


const tasklistCheck = {
  tokenize: tokenizeTasklistCheck
}
const gfmTaskListItem = {
  text: {
    [91]: tasklistCheck
  }
}
/** @type {Tokenizer} */

function tokenizeTasklistCheck(effects, ok, nok) {
  const self = this
  return open
  /** @type {State} */

  function open(code) {
    if (
      // Exit if there’s stuff before.
      self.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !self._gfmTasklistFirstContentOfListItem
    ) {
      return nok(code)
    }

    effects.enter('taskListCheck')
    effects.enter('taskListCheckMarker')
    effects.consume(code)
    effects.exit('taskListCheckMarker')
    return inside
  }
  /** @type {State} */

  function inside(code) {
    // To match how GH works in comments, use `markdownSpace` (`[ \t]`) instead
    // of `markdownLineEndingOrSpace` (`[ \t\r\n]`).
    if (markdownLineEndingOrSpace(code)) {
      effects.enter('taskListCheckValueUnchecked')
      effects.consume(code)
      effects.exit('taskListCheckValueUnchecked')
      return close
    }

    if (code === 88 || code === 120) {
      effects.enter('taskListCheckValueChecked')
      effects.consume(code)
      effects.exit('taskListCheckValueChecked')
      return close
    }

    return nok(code)
  }
  /** @type {State} */

  function close(code) {
    if (code === 93) {
      effects.enter('taskListCheckMarker')
      effects.consume(code)
      effects.exit('taskListCheckMarker')
      effects.exit('taskListCheck')
      return effects.check(
        {
          tokenize: spaceThenNonSpace
        },
        ok,
        nok
      )
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function spaceThenNonSpace(effects, ok, nok) {
  const self = this
  return factorySpace(effects, after, 'whitespace')
  /** @type {State} */

  function after(code) {
    const tail = self.events[self.events.length - 1]
    return (
      // We either found spaces…
      ((tail && tail[1].type === 'whitespace') || // …or it was followed by a line ending, in which case, there has to be
        // non-whitespace after that line ending, because otherwise we’d get an
        // EOF as the content is closed with blank lines.
        markdownLineEnding(code)) &&
        code !== null
        ? ok(code)
        : nok(code)
    )
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm/index.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 */









/**
 * Support GFM or markdown on github.com.
 *
 * @param {Options} [options]
 * @returns {Extension}
 */
function gfm(options) {
  return combineExtensions([
    gfmAutolinkLiteral,
    gfmFootnote(),
    gfmStrikethrough(options),
    gfmTable,
    gfmTaskListItem
  ])
}

/**
 * Support to compile GFM to HTML.
 *
 * @param {HtmlOptions} [options]
 * @returns {HtmlExtension}
 */
function gfmHtml(options) {
  return combineHtmlExtensions([
    gfmAutolinkLiteralHtml,
    gfmFootnoteHtml(options),
    gfmStrikethroughHtml,
    gfmTableHtml,
    gfmTagfilterHtml,
    gfmTaskListItemHtml
  ])
}

;// CONCATENATED MODULE: ../node_modules/ccount/index.js
/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */
function ccount(value, character) {
  const source = String(value)

  if (typeof character !== 'string') {
    throw new TypeError('Expected character')
  }

  let count = 0
  let index = source.indexOf(character)

  while (index !== -1) {
    count++
    index = source.indexOf(character, index + character.length)
  }

  return count
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-find-and-replace/node_modules/escape-string-regexp/index.js
function escapeStringRegexp(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-find-and-replace/lib/index.js
/**
 * @typedef Options
 *   Configuration (optional).
 * @property {Test} [ignore]
 *   `unist-util-is` test used to assert parents
 *
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {Content|Root} Node
 * @typedef {Exclude<Extract<Node, import('mdast').Parent>, Root>} Parent
 *
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 *
 * @typedef RegExpMatchObject
 * @property {number} index
 * @property {string} input
 * @property {[Root, ...Array<Parent>, Text]} stack
 *
 * @typedef {string|RegExp} Find
 * @typedef {string|ReplaceFunction} Replace
 *
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 * @typedef {Record<string, Replace>} FindAndReplaceSchema
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 * @typedef {Array<Pair>} Pairs
 */

/**
 * @callback ReplaceFunction
 * @param {...any} parameters
 * @returns {Array<PhrasingContent>|PhrasingContent|string|false|undefined|null}
 */





const mdast_util_find_and_replace_lib_own = {}.hasOwnProperty

/**
 * @param tree mdast tree
 * @param find Value to find and remove. When `string`, escaped and made into a global `RegExp`
 * @param [replace] Value to insert.
 *   * When `string`, turned into a Text node.
 *   * When `Function`, called with the results of calling `RegExp.exec` as
 *     arguments, in which case it can return a single or a list of `Node`,
 *     a `string` (which is wrapped in a `Text` node), or `false` to not replace
 * @param [options] Configuration.
 */
const findAndReplace =
  /**
   * @type {(
   *   ((tree: Node, find: Find, replace?: Replace, options?: Options) => Node) &
   *   ((tree: Node, schema: FindAndReplaceSchema|FindAndReplaceList, options?: Options) => Node)
   * )}
   **/
  (
    /**
     * @param {Node} tree
     * @param {Find|FindAndReplaceSchema|FindAndReplaceList} find
     * @param {Replace|Options} [replace]
     * @param {Options} [options]
     */
    function (tree, find, replace, options) {
      /** @type {Options|undefined} */
      let settings
      /** @type {FindAndReplaceSchema|FindAndReplaceList} */
      let schema

      if (typeof find === 'string' || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [[find, replace]]
        settings = options
      } else {
        schema = find
        // @ts-expect-error don’t expect replace twice.
        settings = replace
      }

      if (!settings) {
        settings = {}
      }

      const ignored = convert(settings.ignore || [])
      const pairs = toPairs(schema)
      let pairIndex = -1

      while (++pairIndex < pairs.length) {
        visitParents(tree, 'text', visitor)
      }

      return tree

      /** @type {import('unist-util-visit-parents/complex-types').BuildVisitor<Root, 'text'>} */
      function visitor(node, parents) {
        let index = -1
        /** @type {Parent|undefined} */
        let grandparent

        while (++index < parents.length) {
          const parent = /** @type {Parent} */ (parents[index])

          if (
            ignored(
              parent,
              // @ts-expect-error mdast vs. unist parent.
              grandparent ? grandparent.children.indexOf(parent) : undefined,
              grandparent
            )
          ) {
            return
          }

          grandparent = parent
        }

        if (grandparent) {
          // @ts-expect-error: stack is fine.
          return handler(node, parents)
        }
      }

      /**
       * @param {Text} node
       * @param {[Root, ...Array<Parent>]} parents
       * @returns {VisitorResult}
       */
      function handler(node, parents) {
        const parent = parents[parents.length - 1]
        const find = pairs[pairIndex][0]
        const replace = pairs[pairIndex][1]
        let start = 0
        // @ts-expect-error: TS is wrong, some of these children can be text.
        const index = parent.children.indexOf(node)
        let change = false
        /** @type {Array<PhrasingContent>} */
        let nodes = []
        /** @type {number|undefined} */
        let position

        find.lastIndex = 0

        let match = find.exec(node.value)

        while (match) {
          position = match.index
          /** @type {RegExpMatchObject} */
          const matchObject = {
            index: match.index,
            input: match.input,
            stack: [...parents, node]
          }
          let value = replace(...match, matchObject)

          if (typeof value === 'string') {
            value = value.length > 0 ? {type: 'text', value} : undefined
          }

          if (value !== false) {
            if (start !== position) {
              nodes.push({
                type: 'text',
                value: node.value.slice(start, position)
              })
            }

            if (Array.isArray(value)) {
              nodes.push(...value)
            } else if (value) {
              nodes.push(value)
            }

            start = position + match[0].length
            change = true
          }

          if (!find.global) {
            break
          }

          match = find.exec(node.value)
        }

        if (change) {
          if (start < node.value.length) {
            nodes.push({type: 'text', value: node.value.slice(start)})
          }

          parent.children.splice(index, 1, ...nodes)
        } else {
          nodes = [node]
        }

        return index + nodes.length
      }
    }
  )

/**
 * @param {FindAndReplaceSchema|FindAndReplaceList} schema
 * @returns {Pairs}
 */
function toPairs(schema) {
  /** @type {Pairs} */
  const result = []

  if (typeof schema !== 'object') {
    throw new TypeError('Expected array or object as schema')
  }

  if (Array.isArray(schema)) {
    let index = -1

    while (++index < schema.length) {
      result.push([
        toExpression(schema[index][0]),
        toFunction(schema[index][1])
      ])
    }
  } else {
    /** @type {string} */
    let key

    for (key in schema) {
      if (mdast_util_find_and_replace_lib_own.call(schema, key)) {
        result.push([toExpression(key), toFunction(schema[key])])
      }
    }
  }

  return result
}

/**
 * @param {Find} find
 * @returns {RegExp}
 */
function toExpression(find) {
  return typeof find === 'string' ? new RegExp(escapeStringRegexp(find), 'g') : find
}

/**
 * @param {Replace} replace
 * @returns {ReplaceFunction}
 */
function toFunction(replace) {
  return typeof replace === 'function' ? replace : () => replace
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm-autolink-literal/index.js
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown/lib/types.js').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 * @typedef {import('mdast-util-find-and-replace').PhrasingContent} PhrasingContent
 */





const inConstruct = 'phrasing'
const notInConstruct = ['autolink', 'link', 'image', 'label']

/** @type {FromMarkdownExtension} */
const gfmAutolinkLiteralFromMarkdown = {
  transforms: [transformGfmAutolinkLiterals],
  enter: {
    literalAutolink: enterLiteralAutolink,
    literalAutolinkEmail: enterLiteralAutolinkValue,
    literalAutolinkHttp: enterLiteralAutolinkValue,
    literalAutolinkWww: enterLiteralAutolinkValue
  },
  exit: {
    literalAutolink: exitLiteralAutolink,
    literalAutolinkEmail: exitLiteralAutolinkEmail,
    literalAutolinkHttp: exitLiteralAutolinkHttp,
    literalAutolinkWww: exitLiteralAutolinkWww
  }
}

/** @type {ToMarkdownExtension} */
const gfmAutolinkLiteralToMarkdown = {
  unsafe: [
    {
      character: '@',
      before: '[+\\-.\\w]',
      after: '[\\-.\\w]',
      inConstruct,
      notInConstruct
    },
    {
      character: '.',
      before: '[Ww]',
      after: '[\\-.\\w]',
      inConstruct,
      notInConstruct
    },
    {character: ':', before: '[ps]', after: '\\/', inConstruct, notInConstruct}
  ]
}

/** @type {FromMarkdownHandle} */
function enterLiteralAutolink(token) {
  this.enter({type: 'link', title: null, url: '', children: []}, token)
}

/** @type {FromMarkdownHandle} */
function enterLiteralAutolinkValue(token) {
  this.config.enter.autolinkProtocol.call(this, token)
}

/** @type {FromMarkdownHandle} */
function exitLiteralAutolinkHttp(token) {
  this.config.exit.autolinkProtocol.call(this, token)
}

/** @type {FromMarkdownHandle} */
function exitLiteralAutolinkWww(token) {
  this.config.exit.data.call(this, token)
  const node = /** @type {Link} */ (this.stack[this.stack.length - 1])
  node.url = 'http://' + this.sliceSerialize(token)
}

/** @type {FromMarkdownHandle} */
function exitLiteralAutolinkEmail(token) {
  this.config.exit.autolinkEmail.call(this, token)
}

/** @type {FromMarkdownHandle} */
function exitLiteralAutolink(token) {
  this.exit(token)
}

/** @type {FromMarkdownTransform} */
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(
    tree,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, findEmail]
    ],
    {ignore: ['link', 'linkReference']}
  )
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 */
// eslint-disable-next-line max-params
function findUrl(_, protocol, domain, path, match) {
  let prefix = ''

  // Not an expected previous character.
  if (!mdast_util_gfm_autolink_literal_previous(match)) {
    return false
  }

  // Treat `www` as part of the domain.
  if (/^w/i.test(protocol)) {
    domain = protocol + domain
    protocol = ''
    prefix = 'http://'
  }

  if (!isCorrectDomain(domain)) {
    return false
  }

  const parts = splitUrl(domain + path)

  if (!parts[0]) return false

  /** @type {PhrasingContent} */
  const result = {
    type: 'link',
    title: null,
    url: prefix + protocol + parts[0],
    children: [{type: 'text', value: protocol + parts[0]}]
  }

  if (parts[1]) {
    return [result, {type: 'text', value: parts[1]}]
  }

  return result
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 */
function findEmail(_, atext, label, match) {
  if (
    // Not an expected previous character.
    !mdast_util_gfm_autolink_literal_previous(match, true) ||
    // Label ends in not allowed character.
    /[_-\d]$/.test(label)
  ) {
    return false
  }

  return {
    type: 'link',
    title: null,
    url: 'mailto:' + atext + '@' + label,
    children: [{type: 'text', value: atext + '@' + label}]
  }
}

/**
 * @param {string} domain
 * @returns {boolean}
 */
function isCorrectDomain(domain) {
  const parts = domain.split('.')

  if (
    parts.length < 2 ||
    (parts[parts.length - 1] &&
      (/_/.test(parts[parts.length - 1]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 1]))) ||
    (parts[parts.length - 2] &&
      (/_/.test(parts[parts.length - 2]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 2])))
  ) {
    return false
  }

  return true
}

/**
 * @param {string} url
 * @returns {[string, string|undefined]}
 */
function splitUrl(url) {
  const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url)
  /** @type {number} */
  let closingParenIndex
  /** @type {number} */
  let openingParens
  /** @type {number} */
  let closingParens
  /** @type {string|undefined} */
  let trail

  if (trailExec) {
    url = url.slice(0, trailExec.index)
    trail = trailExec[0]
    closingParenIndex = trail.indexOf(')')
    openingParens = ccount(url, '(')
    closingParens = ccount(url, ')')

    while (closingParenIndex !== -1 && openingParens > closingParens) {
      url += trail.slice(0, closingParenIndex + 1)
      trail = trail.slice(closingParenIndex + 1)
      closingParenIndex = trail.indexOf(')')
      closingParens++
    }
  }

  return [url, trail]
}

/**
 * @param {RegExpMatchObject} match
 * @param {boolean} [email=false]
 * @returns {boolean}
 */
function mdast_util_gfm_autolink_literal_previous(match, email) {
  const code = match.input.charCodeAt(match.index - 1)

  return (
    (match.index === 0 ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)) &&
    (!email || code !== 47)
  )
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/association.js
/**
 * @typedef {import('mdast').Association} Association
 */



/**
 * The `label` of an association is the string value: character escapes and
 * references work, and casing is intact.
 * The `identifier` is used to match one association to another: controversially,
 * character escapes and references don’t work in this matching: `&copy;` does
 * not match `©`, and `\+` does not match `+`.
 * But casing is ignored (and whitespace) is trimmed and collapsed: ` A\nb`
 * matches `a b`.
 * So, we do prefer the label when figuring out how we’re going to serialize:
 * it has whitespace, casing, and we can ignore most useless character escapes
 * and all character references.
 *
 * @param {Association} node
 * @returns {string}
 */
function association(node) {
  if (node.label || !node.identifier) {
    return node.label || ''
  }

  return decodeString(node.identifier)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/track.js
/**
 * @typedef {import('unist').Point} Point
 * @typedef {import('../types.js').TrackFields} TrackFields
 */

/**
 * Functions to track output positions.
 * This info isn’t used yet but suchs functionality allows line wrapping,
 * and theoretically source maps (though, is there practical use in that?).
 *
 * @param {TrackFields} options_
 */
function track(options_) {
  // Defaults are used to prevent crashes when older utilities somehow activate
  // this code.
  /* c8 ignore next 5 */
  const options = options_ || {}
  const now = options.now || {}
  let lineShift = options.lineShift || 0
  let line = now.line || 1
  let column = now.column || 1

  return {move, current, shift}

  /**
   * Get the current tracked info.
   *
   * @returns {{now: Point, lineShift: number}}
   */
  function current() {
    return {now: {line, column}, lineShift}
  }

  /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @param {number} value
   */
  function shift(value) {
    lineShift += value
  }

  /**
   * Move past a string.
   *
   * @param {string} value
   * @returns {string}
   */
  function move(value = '') {
    const chunks = value.split(/\r?\n|\r/g)
    const tail = chunks[chunks.length - 1]
    line += chunks.length - 1
    column =
      chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift
    return value
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/container-flow.js
/**
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').Join} Join
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').TrackFields} TrackFields
 */



/**
 * @param {Parent} parent
 * @param {Context} context
 * @param {TrackFields} safeOptions
 * @returns {string}
 */
function containerFlow(parent, context, safeOptions) {
  const indexStack = context.indexStack
  const children = parent.children || []
  const tracker = track(safeOptions)
  /** @type {Array<string>} */
  const results = []
  let index = -1

  indexStack.push(-1)

  while (++index < children.length) {
    const child = children[index]

    indexStack[indexStack.length - 1] = index

    results.push(
      tracker.move(
        context.handle(child, parent, context, {
          before: '\n',
          after: '\n',
          ...tracker.current()
        })
      )
    )

    if (child.type !== 'list') {
      context.bulletLastUsed = undefined
    }

    if (index < children.length - 1) {
      results.push(tracker.move(between(child, children[index + 1])))
    }
  }

  indexStack.pop()

  return results.join('')

  /**
   * @param {Node} left
   * @param {Node} right
   * @returns {string}
   */
  function between(left, right) {
    let index = context.join.length

    while (index--) {
      const result = context.join[index](left, right, parent, context)

      if (result === true || result === 1) {
        break
      }

      if (typeof result === 'number') {
        return '\n'.repeat(1 + result)
      }

      if (result === false) {
        return '\n\n<!---->\n\n'
      }
    }

    return '\n\n'
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/indent-lines.js
/**
 * @callback Map
 * @param {string} value
 * @param {number} line
 * @param {boolean} blank
 * @returns {string}
 */

const eol = /\r?\n|\r/g

/**
 * @param {string} value
 * @param {Map} map
 * @returns {string}
 */
function indentLines(value, map) {
  /** @type {Array<string>} */
  const result = []
  let start = 0
  let line = 0
  /** @type {RegExpExecArray|null} */
  let match

  while ((match = eol.exec(value))) {
    one(value.slice(start, match.index))
    result.push(match[0])
    start = match.index + match[0].length
    line++
  }

  one(value.slice(start))

  return result.join('')

  /**
   * @param {string} value
   */
  function one(value) {
    result.push(map(value, line, !value))
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/pattern-compile.js
/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */

/**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */
function patternCompile(pattern) {
  if (!pattern._compiled) {
    const before =
      (pattern.atBreak ? '[\\r\\n][\\t ]*' : '') +
      (pattern.before ? '(?:' + pattern.before + ')' : '')

    pattern._compiled = new RegExp(
      (before ? '(' + before + ')' : '') +
        (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') +
        pattern.character +
        (pattern.after ? '(?:' + pattern.after + ')' : ''),
      'g'
    )
  }

  return pattern._compiled
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/pattern-in-scope.js
/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */

/**
 * @param {Array<string>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */
function patternInScope(stack, pattern) {
  return (
    listInScope(stack, pattern.inConstruct, true) &&
    !listInScope(stack, pattern.notInConstruct, false)
  )
}

/**
 * @param {Array<string>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */
function listInScope(stack, list, none) {
  if (!list) {
    return none
  }

  if (typeof list === 'string') {
    list = [list]
  }

  let index = -1

  while (++index < list.length) {
    if (stack.includes(list[index])) {
      return true
    }
  }

  return false
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/safe.js
/**
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').SafeOptions} SafeOptions
 */




/**
 * @param {Context} context
 * @param {string|null|undefined} input
 * @param {SafeOptions & {encode?: Array<string>}} config
 * @returns {string}
 */
function safe(context, input, config) {
  const value = (config.before || '') + (input || '') + (config.after || '')
  /** @type {Array<number>} */
  const positions = []
  /** @type {Array<string>} */
  const result = []
  /** @type {Record<number, {before: boolean, after: boolean}>} */
  const infos = {}
  let index = -1

  while (++index < context.unsafe.length) {
    const pattern = context.unsafe[index]

    if (!patternInScope(context.stack, pattern)) {
      continue
    }

    const expression = patternCompile(pattern)
    /** @type {RegExpExecArray|null} */
    let match

    while ((match = expression.exec(value))) {
      const before = 'before' in pattern || Boolean(pattern.atBreak)
      const after = 'after' in pattern
      const position = match.index + (before ? match[1].length : 0)

      if (positions.includes(position)) {
        if (infos[position].before && !before) {
          infos[position].before = false
        }

        if (infos[position].after && !after) {
          infos[position].after = false
        }
      } else {
        positions.push(position)
        infos[position] = {before, after}
      }
    }
  }

  positions.sort(numerical)

  let start = config.before ? config.before.length : 0
  const end = value.length - (config.after ? config.after.length : 0)
  index = -1

  while (++index < positions.length) {
    const position = positions[index]

    // Character before or after matched:
    if (position < start || position >= end) {
      continue
    }

    // If this character is supposed to be escaped because it has a condition on
    // the next character, and the next character is definitly being escaped,
    // then skip this escape.
    if (
      (position + 1 < end &&
        positions[index + 1] === position + 1 &&
        infos[position].after &&
        !infos[position + 1].before &&
        !infos[position + 1].after) ||
      (positions[index - 1] === position - 1 &&
        infos[position].before &&
        !infos[position - 1].before &&
        !infos[position - 1].after)
    ) {
      continue
    }

    if (start !== position) {
      // If we have to use a character reference, an ampersand would be more
      // correct, but as backslashes only care about punctuation, either will
      // do the trick
      result.push(escapeBackslashes(value.slice(start, position), '\\'))
    }

    start = position

    if (
      /[!-/:-@[-`{-~]/.test(value.charAt(position)) &&
      (!config.encode || !config.encode.includes(value.charAt(position)))
    ) {
      // Character escape.
      result.push('\\')
    } else {
      // Character reference.
      result.push(
        '&#x' + value.charCodeAt(position).toString(16).toUpperCase() + ';'
      )
      start++
    }
  }

  result.push(escapeBackslashes(value.slice(start, end), config.after))

  return result.join('')
}

/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */
function numerical(a, b) {
  return a - b
}

/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */
function escapeBackslashes(value, after) {
  const expression = /\\(?=[!-/:-@[-`{-~])/g
  /** @type {Array<number>} */
  const positions = []
  /** @type {Array<string>} */
  const results = []
  const whole = value + after
  let index = -1
  let start = 0
  /** @type {RegExpExecArray|null} */
  let match

  while ((match = expression.exec(whole))) {
    positions.push(match.index)
  }

  while (++index < positions.length) {
    if (start !== positions[index]) {
      results.push(value.slice(start, positions[index]))
    }

    results.push('\\')
    start = positions[index]
  }

  results.push(value.slice(start))

  return results.join('')
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm-footnote/index.js
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 */








/**
 * @returns {FromMarkdownExtension}
 */
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteDefinition: enterFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteCallString: enterFootnoteCallString
    },
    exit: {
      gfmFootnoteDefinition: exitFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteCallString: exitFootnoteCallString
    }
  }

  /** @type {FromMarkdownHandle} */
  function enterFootnoteDefinition(token) {
    this.enter(
      {type: 'footnoteDefinition', identifier: '', label: '', children: []},
      token
    )
  }

  /** @type {FromMarkdownHandle} */
  function enterFootnoteDefinitionLabelString() {
    this.buffer()
  }

  /** @type {FromMarkdownHandle} */
  function exitFootnoteDefinitionLabelString(token) {
    const label = this.resume()
    const node = /** @type {FootnoteDefinition} */ (
      this.stack[this.stack.length - 1]
    )
    node.label = label
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
  }

  /** @type {FromMarkdownHandle} */
  function exitFootnoteDefinition(token) {
    this.exit(token)
  }

  /** @type {FromMarkdownHandle} */
  function enterFootnoteCall(token) {
    this.enter({type: 'footnoteReference', identifier: '', label: ''}, token)
  }

  /** @type {FromMarkdownHandle} */
  function enterFootnoteCallString() {
    this.buffer()
  }

  /** @type {FromMarkdownHandle} */
  function exitFootnoteCallString(token) {
    const label = this.resume()
    const node = /** @type {FootnoteDefinition} */ (
      this.stack[this.stack.length - 1]
    )
    node.label = label
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
  }

  /** @type {FromMarkdownHandle} */
  function exitFootnoteCall(token) {
    this.exit(token)
  }
}

/**
 * @returns {ToMarkdownExtension}
 */
function gfmFootnoteToMarkdown() {
  footnoteReference.peek = footnoteReferencePeek

  return {
    // This is on by default already.
    unsafe: [{character: '[', inConstruct: ['phrasing', 'label', 'reference']}],
    handlers: {footnoteDefinition, footnoteReference}
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {FootnoteReference} node
   */
  function footnoteReference(node, _, context, safeOptions) {
    const tracker = track(safeOptions)
    let value = tracker.move('[^')
    const exit = context.enter('footnoteReference')
    const subexit = context.enter('reference')
    value += tracker.move(
      safe(context, association(node), {
        ...tracker.current(),
        before: value,
        after: ']'
      })
    )
    subexit()
    exit()
    value += tracker.move(']')
    return value
  }

  /** @type {ToMarkdownHandle} */
  function footnoteReferencePeek() {
    return '['
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {FootnoteDefinition} node
   */
  function footnoteDefinition(node, _, context, safeOptions) {
    const tracker = track(safeOptions)
    let value = tracker.move('[^')
    const exit = context.enter('footnoteDefinition')
    const subexit = context.enter('label')
    value += tracker.move(
      safe(context, association(node), {
        ...tracker.current(),
        before: value,
        after: ']'
      })
    )
    subexit()
    value += tracker.move(
      ']:' + (node.children && node.children.length > 0 ? ' ' : '')
    )
    tracker.shift(4)
    value += tracker.move(
      indentLines(containerFlow(node, context, tracker.current()), map)
    )
    exit()

    return value

    /** @type {Map} */
    function map(line, index, blank) {
      if (index) {
        return (blank ? '' : '    ') + line
      }

      return line
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/container-phrasing.js
/**
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').SafeOptions} SafeOptions
 * @typedef {import('../types.js').Context} Context
 */



/**
 * @param {Parent} parent
 * @param {Context} context
 * @param {SafeOptions} safeOptions
 * @returns {string}
 */
function containerPhrasing(parent, context, safeOptions) {
  const indexStack = context.indexStack
  const children = parent.children || []
  /** @type {Array<string>} */
  const results = []
  let index = -1
  let before = safeOptions.before

  indexStack.push(-1)
  let tracker = track(safeOptions)

  while (++index < children.length) {
    const child = children[index]
    /** @type {string} */
    let after

    indexStack[indexStack.length - 1] = index

    if (index + 1 < children.length) {
      // @ts-expect-error: hush, it’s actually a `zwitch`.
      let handle = context.handle.handlers[children[index + 1].type]
      if (handle && handle.peek) handle = handle.peek
      after = handle
        ? handle(children[index + 1], parent, context, {
            before: '',
            after: '',
            ...tracker.current()
          }).charAt(0)
        : ''
    } else {
      after = safeOptions.after
    }

    // In some cases, html (text) can be found in phrasing right after an eol.
    // When we’d serialize that, in most cases that would be seen as html
    // (flow).
    // As we can’t escape or so to prevent it from happening, we take a somewhat
    // reasonable approach: replace that eol with a space.
    // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
    if (
      results.length > 0 &&
      (before === '\r' || before === '\n') &&
      child.type === 'html'
    ) {
      results[results.length - 1] = results[results.length - 1].replace(
        /(\r?\n|\r)$/,
        ' '
      )
      before = ' '

      // To do: does this work to reset tracker?
      tracker = track(safeOptions)
      tracker.move(results.join(''))
    }

    results.push(
      tracker.move(
        context.handle(child, parent, context, {
          ...tracker.current(),
          before,
          after
        })
      )
    )

    before = results[results.length - 1].slice(-1)
  }

  indexStack.pop()

  return results.join('')
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm-strikethrough/index.js
/**
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */




/** @type {FromMarkdownExtension} */
const gfmStrikethroughFromMarkdown = {
  canContainEols: ['delete'],
  enter: {strikethrough: enterStrikethrough},
  exit: {strikethrough: exitStrikethrough}
}

/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethroughs. So they sort of cancel each other out.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/c47743b/lib/unsafe.js#L11>
 */
const constructsWithoutStrikethrough = [
  'autolink',
  'destinationLiteral',
  'destinationRaw',
  'reference',
  'titleQuote',
  'titleApostrophe'
]

/** @type {ToMarkdownExtension} */
const gfmStrikethroughToMarkdown = {
  unsafe: [
    {
      character: '~',
      inConstruct: 'phrasing',
      notInConstruct: constructsWithoutStrikethrough
    }
  ],
  handlers: {delete: handleDelete}
}

handleDelete.peek = peekDelete

/** @type {FromMarkdownHandle} */
function enterStrikethrough(token) {
  this.enter({type: 'delete', children: []}, token)
}

/** @type {FromMarkdownHandle} */
function exitStrikethrough(token) {
  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */
function handleDelete(node, _, context, safeOptions) {
  const tracker = track(safeOptions)
  const exit = context.enter('emphasis')
  let value = tracker.move('~~')
  value += containerPhrasing(node, context, {
    ...tracker.current(),
    before: value,
    after: '~'
  })
  value += tracker.move('~~')
  exit()
  return value
}

/** @type {ToMarkdownHandle} */
function peekDelete() {
  return '~'
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/handle/inline-code.js
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Handle} Handle
 */



inline_code_inlineCode.peek = inlineCodePeek

/**
 * @type {Handle}
 * @param {InlineCode} node
 */
function inline_code_inlineCode(node, _, context) {
  let value = node.value || ''
  let sequence = '`'
  let index = -1

  // If there is a single grave accent on its own in the code, use a fence of
  // two.
  // If there are two in a row, use one.
  while (new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value)) {
    sequence += '`'
  }

  // If this is not just spaces or eols (tabs don’t count), and either the
  // first or last character are a space, eol, or tick, then pad with spaces.
  if (
    /[^ \r\n]/.test(value) &&
    ((/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value)) || /^`|`$/.test(value))
  ) {
    value = ' ' + value + ' '
  }

  // We have a potential problem: certain characters after eols could result in
  // blocks being seen.
  // For example, if someone injected the string `'\n# b'`, then that would
  // result in an ATX heading.
  // We can’t escape characters in `inlineCode`, but because eols are
  // transformed to spaces when going from markdown to HTML anyway, we can swap
  // them out.
  while (++index < context.unsafe.length) {
    const pattern = context.unsafe[index]
    const expression = patternCompile(pattern)
    /** @type {RegExpExecArray|null} */
    let match

    // Only look for `atBreak`s.
    // Btw: note that `atBreak` patterns will always start the regex at LF or
    // CR.
    if (!pattern.atBreak) continue

    while ((match = expression.exec(value))) {
      let position = match.index

      // Support CRLF (patterns only look for one of the characters).
      if (
        value.charCodeAt(position) === 10 /* `\n` */ &&
        value.charCodeAt(position - 1) === 13 /* `\r` */
      ) {
        position--
      }

      value = value.slice(0, position) + ' ' + value.slice(match.index + 1)
    }
  }

  return sequence + value + sequence
}

/**
 * @type {Handle}
 */
function inlineCodePeek() {
  return '`'
}

;// CONCATENATED MODULE: ../node_modules/markdown-table/index.js
/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|Array<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */

/**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */

/**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {Array<Array<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */
function markdownTable(table, options = {}) {
  const align = (options.align || []).concat()
  const stringLength = options.stringLength || defaultStringLength
  /** @type {Array<number>} Character codes as symbols for alignment per column. */
  const alignments = []
  /** @type {Array<Array<string>>} Cells per row. */
  const cellMatrix = []
  /** @type {Array<Array<number>>} Sizes of each cell per row. */
  const sizeMatrix = []
  /** @type {Array<number>} */
  const longestCellByColumn = []
  let mostCellsPerRow = 0
  let rowIndex = -1

  // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
  // do superfluous work when aligning, so optimize for aligning.
  while (++rowIndex < table.length) {
    /** @type {Array<string>} */
    const row = []
    /** @type {Array<number>} */
    const sizes = []
    let columnIndex = -1

    if (table[rowIndex].length > mostCellsPerRow) {
      mostCellsPerRow = table[rowIndex].length
    }

    while (++columnIndex < table[rowIndex].length) {
      const cell = serialize(table[rowIndex][columnIndex])

      if (options.alignDelimiters !== false) {
        const size = stringLength(cell)
        sizes[columnIndex] = size

        if (
          longestCellByColumn[columnIndex] === undefined ||
          size > longestCellByColumn[columnIndex]
        ) {
          longestCellByColumn[columnIndex] = size
        }
      }

      row.push(cell)
    }

    cellMatrix[rowIndex] = row
    sizeMatrix[rowIndex] = sizes
  }

  // Figure out which alignments to use.
  let columnIndex = -1

  if (typeof align === 'object' && 'length' in align) {
    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = toAlignment(align[columnIndex])
    }
  } else {
    const code = toAlignment(align)

    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = code
    }
  }

  // Inject the alignment row.
  columnIndex = -1
  /** @type {Array<string>} */
  const row = []
  /** @type {Array<number>} */
  const sizes = []

  while (++columnIndex < mostCellsPerRow) {
    const code = alignments[columnIndex]
    let before = ''
    let after = ''

    if (code === 99 /* `c` */) {
      before = ':'
      after = ':'
    } else if (code === 108 /* `l` */) {
      before = ':'
    } else if (code === 114 /* `r` */) {
      after = ':'
    }

    // There *must* be at least one hyphen-minus in each alignment cell.
    let size =
      options.alignDelimiters === false
        ? 1
        : Math.max(
            1,
            longestCellByColumn[columnIndex] - before.length - after.length
          )

    const cell = before + '-'.repeat(size) + after

    if (options.alignDelimiters !== false) {
      size = before.length + size + after.length

      if (size > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size
      }

      sizes[columnIndex] = size
    }

    row[columnIndex] = cell
  }

  // Inject the alignment row.
  cellMatrix.splice(1, 0, row)
  sizeMatrix.splice(1, 0, sizes)

  rowIndex = -1
  /** @type {Array<string>} */
  const lines = []

  while (++rowIndex < cellMatrix.length) {
    const row = cellMatrix[rowIndex]
    const sizes = sizeMatrix[rowIndex]
    columnIndex = -1
    /** @type {Array<string>} */
    const line = []

    while (++columnIndex < mostCellsPerRow) {
      const cell = row[columnIndex] || ''
      let before = ''
      let after = ''

      if (options.alignDelimiters !== false) {
        const size =
          longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0)
        const code = alignments[columnIndex]

        if (code === 114 /* `r` */) {
          before = ' '.repeat(size)
        } else if (code === 99 /* `c` */) {
          if (size % 2) {
            before = ' '.repeat(size / 2 + 0.5)
            after = ' '.repeat(size / 2 - 0.5)
          } else {
            before = ' '.repeat(size / 2)
            after = before
          }
        } else {
          after = ' '.repeat(size)
        }
      }

      if (options.delimiterStart !== false && !columnIndex) {
        line.push('|')
      }

      if (
        options.padding !== false &&
        // Don’t add the opening space if we’re not aligning and the cell is
        // empty: there will be a closing space.
        !(options.alignDelimiters === false && cell === '') &&
        (options.delimiterStart !== false || columnIndex)
      ) {
        line.push(' ')
      }

      if (options.alignDelimiters !== false) {
        line.push(before)
      }

      line.push(cell)

      if (options.alignDelimiters !== false) {
        line.push(after)
      }

      if (options.padding !== false) {
        line.push(' ')
      }

      if (
        options.delimiterEnd !== false ||
        columnIndex !== mostCellsPerRow - 1
      ) {
        line.push('|')
      }
    }

    lines.push(
      options.delimiterEnd === false
        ? line.join('').replace(/ +$/, '')
        : line.join('')
    )
  }

  return lines.join('\n')
}

/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */
function serialize(value) {
  return value === null || value === undefined ? '' : String(value)
}

/**
 * @param {string} value
 * @returns {number}
 */
function defaultStringLength(value) {
  return value.length
}

/**
 * @param {string|null|undefined} value
 * @returns {number}
 */
function toAlignment(value) {
  const code = typeof value === 'string' ? value.codePointAt(0) : 0

  return code === 67 /* `C` */ || code === 99 /* `c` */
    ? 99 /* `c` */
    : code === 76 /* `L` */ || code === 108 /* `l` */
    ? 108 /* `l` */
    : code === 82 /* `R` */ || code === 114 /* `r` */
    ? 114 /* `r` */
    : 0
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm-table/lib/index.js
/**
 * @typedef {import('mdast').AlignType} AlignType
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 *
 * @typedef Options
 * @property {boolean} [tableCellPadding=true]
 * @property {boolean} [tablePipeAlign=true]
 * @property {MarkdownTableOptions['stringLength']} [stringLength]
 */





/** @type {FromMarkdownExtension} */
const gfmTableFromMarkdown = {
  enter: {
    table: enterTable,
    tableData: enterCell,
    tableHeader: enterCell,
    tableRow: enterRow
  },
  exit: {
    codeText: exitCodeText,
    table: exitTable,
    tableData: lib_exit,
    tableHeader: lib_exit,
    tableRow: lib_exit
  }
}

/** @type {FromMarkdownHandle} */
function enterTable(token) {
  /** @type {Array<'left'|'right'|'center'|'none'>} */
  // @ts-expect-error: `align` is custom.
  const align = token._align
  this.enter(
    {
      type: 'table',
      align: align.map((d) => (d === 'none' ? null : d)),
      children: []
    },
    token
  )
  this.setData('inTable', true)
}

/** @type {FromMarkdownHandle} */
function exitTable(token) {
  this.exit(token)
  this.setData('inTable')
}

/** @type {FromMarkdownHandle} */
function enterRow(token) {
  this.enter({type: 'tableRow', children: []}, token)
}

/** @type {FromMarkdownHandle} */
function lib_exit(token) {
  this.exit(token)
}

/** @type {FromMarkdownHandle} */
function enterCell(token) {
  this.enter({type: 'tableCell', children: []}, token)
}

// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/** @type {FromMarkdownHandle} */
function exitCodeText(token) {
  let value = this.resume()

  if (this.getData('inTable')) {
    value = value.replace(/\\([\\|])/g, replace)
  }

  const node = /** @type {InlineCode} */ (this.stack[this.stack.length - 1])
  node.value = value
  this.exit(token)
}

/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */
function replace($0, $1) {
  // Pipes work, backslashes don’t (but can’t escape pipes).
  return $1 === '|' ? $1 : $0
}

/**
 * @param {Options} [options]
 * @returns {ToMarkdownExtension}
 */
function gfmTableToMarkdown(options) {
  const settings = options || {}
  const padding = settings.tableCellPadding
  const alignDelimiters = settings.tablePipeAlign
  const stringLength = settings.stringLength
  const around = padding ? ' ' : '|'

  return {
    unsafe: [
      {character: '\r', inConstruct: 'tableCell'},
      {character: '\n', inConstruct: 'tableCell'},
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      {atBreak: true, character: '|', after: '[\t :-]'},
      // A pipe in a cell must be encoded.
      {character: '|', inConstruct: 'tableCell'},
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      {atBreak: true, character: ':', after: '-'},
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      {atBreak: true, character: '-', after: '[:|-]'}
    ],
    handlers: {
      table: handleTable,
      tableRow: handleTableRow,
      tableCell: handleTableCell,
      inlineCode: inlineCodeWithTable
    }
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */
  function handleTable(node, _, context, safeOptions) {
    return serializeData(
      handleTableAsData(node, context, safeOptions),
      // @ts-expect-error: fixed in `markdown-table@3.0.1`.
      node.align
    )
  }

  /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */
  function handleTableRow(node, _, context, safeOptions) {
    const row = handleTableRowAsData(node, context, safeOptions)
    // `markdown-table` will always add an align row
    const value = serializeData([row])
    return value.slice(0, value.indexOf('\n'))
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */
  function handleTableCell(node, _, context, safeOptions) {
    const exit = context.enter('tableCell')
    const subexit = context.enter('phrasing')
    const value = containerPhrasing(node, context, {
      ...safeOptions,
      before: around,
      after: around
    })
    subexit()
    exit()
    return value
  }

  /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string>} [align]
   */
  function serializeData(matrix, align) {
    return markdownTable(matrix, {
      align,
      alignDelimiters,
      padding,
      stringLength
    })
  }

  /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */
  function handleTableAsData(node, context, safeOptions) {
    const children = node.children
    let index = -1
    /** @type {Array<Array<string>>} */
    const result = []
    const subexit = context.enter('table')

    while (++index < children.length) {
      result[index] = handleTableRowAsData(
        children[index],
        context,
        safeOptions
      )
    }

    subexit()

    return result
  }

  /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */
  function handleTableRowAsData(node, context, safeOptions) {
    const children = node.children
    let index = -1
    /** @type {Array<string>} */
    const result = []
    const subexit = context.enter('tableRow')

    while (++index < children.length) {
      // Note: the positional info as used here is incorrect.
      // Making it correct would be impossible due to aligning cells?
      // And it would need copy/pasting `markdown-table` into this project.
      result[index] = handleTableCell(
        children[index],
        node,
        context,
        safeOptions
      )
    }

    subexit()

    return result
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */
  function inlineCodeWithTable(node, parent, context) {
    let value = inline_code_inlineCode(node, parent, context)

    if (context.stack.includes('tableCell')) {
      value = value.replace(/\|/g, '\\$&')
    }

    return value
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/check-bullet.js
/**
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').Options} Options
 */

/**
 * @param {Context} context
 * @returns {Exclude<Options['bullet'], undefined>}
 */
function checkBullet(context) {
  const marker = context.options.bullet || '*'

  if (marker !== '*' && marker !== '+' && marker !== '-') {
    throw new Error(
      'Cannot serialize items with `' +
        marker +
        '` for `options.bullet`, expected `*`, `+`, or `-`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/check-list-item-indent.js
/**
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').Options} Options
 */

/**
 * @param {Context} context
 * @returns {Exclude<Options['listItemIndent'], undefined>}
 */
function checkListItemIndent(context) {
  const style = context.options.listItemIndent || 'tab'

  // To do: remove in a major.
  // @ts-expect-error: deprecated.
  if (style === 1 || style === '1') {
    return 'one'
  }

  if (style !== 'tab' && style !== 'one' && style !== 'mixed') {
    throw new Error(
      'Cannot serialize items with `' +
        style +
        '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`'
    )
  }

  return style
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/handle/list-item.js
/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').List} List
 * @typedef {import('../util/indent-lines.js').Map} Map
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').Handle} Handle
 */







/**
 * @type {Handle}
 * @param {ListItem} node
 */
function list_item_listItem(node, parent, context, safeOptions) {
  const listItemIndent = checkListItemIndent(context)
  let bullet = context.bulletCurrent || checkBullet(context)

  // Add the marker value for ordered lists.
  if (parent && parent.type === 'list' && parent.ordered) {
    bullet =
      (typeof parent.start === 'number' && parent.start > -1
        ? parent.start
        : 1) +
      (context.options.incrementListMarker === false
        ? 0
        : parent.children.indexOf(node)) +
      bullet
  }

  let size = bullet.length + 1

  if (
    listItemIndent === 'tab' ||
    (listItemIndent === 'mixed' &&
      ((parent && parent.type === 'list' && parent.spread) || node.spread))
  ) {
    size = Math.ceil(size / 4) * 4
  }

  const tracker = track(safeOptions)
  tracker.move(bullet + ' '.repeat(size - bullet.length))
  tracker.shift(size)
  const exit = context.enter('listItem')
  const value = indentLines(
    containerFlow(node, context, tracker.current()),
    map
  )
  exit()

  return value

  /** @type {Map} */
  function map(line, index, blank) {
    if (index) {
      return (blank ? '' : ' '.repeat(size)) + line
    }

    return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm-task-list-item/index.js
/**
 * @typedef {Extract<import('mdast').Root|import('mdast').Content, import('unist').Parent>} Parent
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').BlockContent} BlockContent
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */




/** @type {FromMarkdownExtension} */
const gfmTaskListItemFromMarkdown = {
  exit: {
    taskListCheckValueChecked: exitCheck,
    taskListCheckValueUnchecked: exitCheck,
    paragraph: exitParagraphWithTaskListItem
  }
}

/** @type {ToMarkdownExtension} */
const gfmTaskListItemToMarkdown = {
  unsafe: [{atBreak: true, character: '-', after: '[:|-]'}],
  handlers: {listItem: listItemWithTaskListItem}
}

/** @type {FromMarkdownHandle} */
function exitCheck(token) {
  const node = /** @type {ListItem} */ (this.stack[this.stack.length - 2])
  // We’re always in a paragraph, in a list item.
  node.checked = token.type === 'taskListCheckValueChecked'
}

/** @type {FromMarkdownHandle} */
function exitParagraphWithTaskListItem(token) {
  const parent = /** @type {Parent} */ (this.stack[this.stack.length - 2])
  const node = /** @type {Paragraph} */ (this.stack[this.stack.length - 1])
  const siblings = parent.children
  const head = node.children[0]
  let index = -1
  /** @type {Paragraph|undefined} */
  let firstParaghraph

  if (
    parent &&
    parent.type === 'listItem' &&
    typeof parent.checked === 'boolean' &&
    head &&
    head.type === 'text'
  ) {
    while (++index < siblings.length) {
      const sibling = siblings[index]
      if (sibling.type === 'paragraph') {
        firstParaghraph = sibling
        break
      }
    }

    if (firstParaghraph === node) {
      // Must start with a space or a tab.
      head.value = head.value.slice(1)

      if (head.value.length === 0) {
        node.children.shift()
      } else if (
        node.position &&
        head.position &&
        typeof head.position.start.offset === 'number'
      ) {
        head.position.start.column++
        head.position.start.offset++
        node.position.start = Object.assign({}, head.position.start)
      }
    }
  }

  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */
function listItemWithTaskListItem(node, parent, context, safeOptions) {
  const head = node.children[0]
  const checkable =
    typeof node.checked === 'boolean' && head && head.type === 'paragraph'
  const checkbox = '[' + (node.checked ? 'x' : ' ') + '] '
  const tracker = track(safeOptions)

  if (checkable) {
    tracker.move(checkbox)
  }

  let value = list_item_listItem(node, parent, context, {
    ...safeOptions,
    ...tracker.current()
  })

  if (checkable) {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check)
  }

  return value

  /**
   * @param {string} $0
   * @returns {string}
   */
  function check($0) {
    return $0 + checkbox
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm/lib/index.js
/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-gfm-table').Options} Options
 */







/**
 * @returns {Array<FromMarkdownExtension>}
 */
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown,
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown,
    gfmTableFromMarkdown,
    gfmTaskListItemFromMarkdown
  ]
}

/**
 * @param {Options} [options]
 * @returns {ToMarkdownExtension}
 */
function gfmToMarkdown(options) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown,
      gfmFootnoteToMarkdown(),
      gfmStrikethroughToMarkdown,
      gfmTableToMarkdown(options),
      gfmTaskListItemToMarkdown
    ]
  }
}

;// CONCATENATED MODULE: ../node_modules/remark-gfm/index.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */




/**
 * Plugin to support GFM (autolink literals, footnotes, strikethrough, tables, tasklists).
 *
 * @type {import('unified').Plugin<[Options?]|void[], Root>}
 */
function remarkGfm(options = {}) {
  const data = this.data()

  add('micromarkExtensions', gfm(options))
  add('fromMarkdownExtensions', gfmFromMarkdown())
  add('toMarkdownExtensions', gfmToMarkdown(options))

  /**
   * @param {string} field
   * @param {unknown} value
   */
  function add(field, value) {
    const list = /** @type {unknown[]} */ (
      // Other extensions
      /* c8 ignore next 2 */
      data[field] ? data[field] : (data[field] = [])
    )

    list.push(value)
  }
}

// EXTERNAL MODULE: ../node_modules/parse5/lib/parser/index.js
var lib_parser = __webpack_require__(66056);
;// CONCATENATED MODULE: ../node_modules/hastscript/node_modules/hast-util-parse-selector/index.js
/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 */

var hast_util_parse_selector_search = /[#.]/g

/**
 * Create a hast element from a simple CSS selector.
 *
 * @param selector A simple CSS selector.
 *   Can contain a tag-name (`foo`), classes (`.bar`), and an ID (`#baz`).
 *   Multiple classes are allowed.
 *   Uses the last ID if multiple IDs are found.
 * @param [defaultTagName='div'] Tag name to use if `selector` does not specify one.
 */
const parseSelector =
  /**
   * @type {(
   *  <Selector extends string, DefaultTagName extends string = 'div'>(selector?: Selector, defaultTagName?: DefaultTagName) => Element & {tagName: import('./extract.js').ExtractTagName<Selector, DefaultTagName>}
   * )}
   */
  (
    /**
     * @param {string} [selector]
     * @param {string} [defaultTagName='div']
     * @returns {Element}
     */
    function (selector, defaultTagName = 'div') {
      var value = selector || ''
      /** @type {Properties} */
      var props = {}
      var start = 0
      /** @type {string} */
      var subvalue
      /** @type {string} */
      var previous
      /** @type {RegExpMatchArray} */
      var match

      while (start < value.length) {
        hast_util_parse_selector_search.lastIndex = start
        match = hast_util_parse_selector_search.exec(value)
        subvalue = value.slice(start, match ? match.index : value.length)

        if (subvalue) {
          if (!previous) {
            defaultTagName = subvalue
          } else if (previous === '#') {
            props.id = subvalue
          } else if (Array.isArray(props.className)) {
            props.className.push(subvalue)
          } else {
            props.className = [subvalue]
          }

          start += subvalue.length
        }

        if (match) {
          previous = match[0]
          start++
        }
      }

      return {
        type: 'element',
        tagName: defaultTagName,
        properties: props,
        children: []
      }
    }
  )

;// CONCATENATED MODULE: ../node_modules/hastscript/lib/core.js
/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {Root['children'][number]} Child
 * @typedef {Child|Root} Node
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 *
 * @typedef {Root|Element} HResult
 * @typedef {string|number} HStyleValue
 * @typedef {Record<string, HStyleValue>} HStyle
 * @typedef {string|number|boolean|null|undefined} HPrimitiveValue
 * @typedef {Array<string|number>} HArrayValue
 * @typedef {HPrimitiveValue|HArrayValue} HPropertyValue
 * @typedef {{[property: string]: HPropertyValue|HStyle}} HProperties
 *   Acceptable properties value.
 *
 * @typedef {string|number|null|undefined} HPrimitiveChild
 * @typedef {Array<Node|HPrimitiveChild>} HArrayChild
 * @typedef {Node|HPrimitiveChild|HArrayChild} HChild
 *   Acceptable child value
 */






const buttonTypes = new Set(['menu', 'submit', 'reset', 'button'])

const core_own = {}.hasOwnProperty

/**
 * @param {Schema} schema
 * @param {string} defaultTagName
 * @param {Array<string>} [caseSensitive]
 */
function core_core(schema, defaultTagName, caseSensitive) {
  const adjust = caseSensitive && createAdjustMap(caseSensitive)

  const h =
    /**
     * @type {{
     *   (): Root
     *   (selector: null|undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */
    (
      /**
       * Hyperscript compatible DSL for creating virtual hast trees.
       *
       * @param {string|null} [selector]
       * @param {HProperties|HChild} [properties]
       * @param {Array<HChild>} children
       * @returns {HResult}
       */
      function (selector, properties, ...children) {
        let index = -1
        /** @type {HResult} */
        let node

        if (selector === undefined || selector === null) {
          node = {type: 'root', children: []}
          // @ts-expect-error Properties are not supported for roots.
          children.unshift(properties)
        } else {
          node = parseSelector(selector, defaultTagName)
          // Normalize the name.
          node.tagName = node.tagName.toLowerCase()
          if (adjust && core_own.call(adjust, node.tagName)) {
            node.tagName = adjust[node.tagName]
          }

          // Handle props.
          if (isProperties(properties, node.tagName)) {
            /** @type {string} */
            let key

            for (key in properties) {
              if (core_own.call(properties, key)) {
                // @ts-expect-error `node.properties` is set.
                core_addProperty(schema, node.properties, key, properties[key])
              }
            }
          } else {
            children.unshift(properties)
          }
        }

        // Handle children.
        while (++index < children.length) {
          addChild(node.children, children[index])
        }

        if (node.type === 'element' && node.tagName === 'template') {
          node.content = {type: 'root', children: node.children}
          node.children = []
        }

        return node
      }
    )

  return h
}

/**
 * @param {HProperties|HChild} value
 * @param {string} name
 * @returns {value is HProperties}
 */
function isProperties(value, name) {
  if (
    value === null ||
    value === undefined ||
    typeof value !== 'object' ||
    Array.isArray(value)
  ) {
    return false
  }

  if (name === 'input' || !value.type || typeof value.type !== 'string') {
    return true
  }

  if ('children' in value && Array.isArray(value.children)) {
    return false
  }

  if (name === 'button') {
    return buttonTypes.has(value.type.toLowerCase())
  }

  return !('value' in value)
}

/**
 * @param {Schema} schema
 * @param {Properties} properties
 * @param {string} key
 * @param {HStyle|HPropertyValue} value
 * @returns {void}
 */
function core_addProperty(schema, properties, key, value) {
  const info = find(schema, key)
  let index = -1
  /** @type {HPropertyValue} */
  let result

  // Ignore nullish and NaN values.
  if (value === undefined || value === null) return

  if (typeof value === 'number') {
    // Ignore NaN.
    if (Number.isNaN(value)) return

    result = value
  }
  // Booleans.
  else if (typeof value === 'boolean') {
    result = value
  }
  // Handle list values.
  else if (typeof value === 'string') {
    if (info.spaceSeparated) {
      result = space_separated_tokens_parse(value)
    } else if (info.commaSeparated) {
      result = comma_separated_tokens_parse(value)
    } else if (info.commaOrSpaceSeparated) {
      result = space_separated_tokens_parse(comma_separated_tokens_parse(value).join(' '))
    } else {
      result = parsePrimitive(info, info.property, value)
    }
  } else if (Array.isArray(value)) {
    result = value.concat()
  } else {
    result = info.property === 'style' ? style(value) : String(value)
  }

  if (Array.isArray(result)) {
    /** @type {Array<string|number>} */
    const finalResult = []

    while (++index < result.length) {
      // @ts-expect-error Assume no booleans in array.
      finalResult[index] = parsePrimitive(info, info.property, result[index])
    }

    result = finalResult
  }

  // Class names (which can be added both on the `selector` and here).
  if (info.property === 'className' && Array.isArray(properties.className)) {
    // @ts-expect-error Assume no booleans in `className`.
    result = properties.className.concat(result)
  }

  properties[info.property] = result
}

/**
 * @param {Array<Child>} nodes
 * @param {HChild} value
 * @returns {void}
 */
function addChild(nodes, value) {
  let index = -1

  if (value === undefined || value === null) {
    // Empty.
  } else if (typeof value === 'string' || typeof value === 'number') {
    nodes.push({type: 'text', value: String(value)})
  } else if (Array.isArray(value)) {
    while (++index < value.length) {
      addChild(nodes, value[index])
    }
  } else if (typeof value === 'object' && 'type' in value) {
    if (value.type === 'root') {
      addChild(nodes, value.children)
    } else {
      nodes.push(value)
    }
  } else {
    throw new Error('Expected node, nodes, or string, got `' + value + '`')
  }
}

/**
 * Parse a single primitives.
 *
 * @param {Info} info
 * @param {string} name
 * @param {HPrimitiveValue} value
 * @returns {HPrimitiveValue}
 */
function parsePrimitive(info, name, value) {
  if (typeof value === 'string') {
    if (info.number && value && !Number.isNaN(Number(value))) {
      return Number(value)
    }

    if (
      (info.boolean || info.overloadedBoolean) &&
      (value === '' || normalize_normalize(value) === normalize_normalize(name))
    ) {
      return true
    }
  }

  return value
}

/**
 * @param {HStyle} value
 * @returns {string}
 */
function style(value) {
  /** @type {Array<string>} */
  const result = []
  /** @type {string} */
  let key

  for (key in value) {
    if (core_own.call(value, key)) {
      result.push([key, value[key]].join(': '))
    }
  }

  return result.join('; ')
}

/**
 * @param {Array<string>} values
 * @returns {Record<string, string>}
 */
function createAdjustMap(values) {
  /** @type {Record<string, string>} */
  const result = {}
  let index = -1

  while (++index < values.length) {
    result[values[index].toLowerCase()] = values[index]
  }

  return result
}

;// CONCATENATED MODULE: ../node_modules/hastscript/lib/svg-case-sensitive-tag-names.js
const svgCaseSensitiveTagNames = [
  'altGlyph',
  'altGlyphDef',
  'altGlyphItem',
  'animateColor',
  'animateMotion',
  'animateTransform',
  'clipPath',
  'feBlend',
  'feColorMatrix',
  'feComponentTransfer',
  'feComposite',
  'feConvolveMatrix',
  'feDiffuseLighting',
  'feDisplacementMap',
  'feDistantLight',
  'feDropShadow',
  'feFlood',
  'feFuncA',
  'feFuncB',
  'feFuncG',
  'feFuncR',
  'feGaussianBlur',
  'feImage',
  'feMerge',
  'feMergeNode',
  'feMorphology',
  'feOffset',
  'fePointLight',
  'feSpecularLighting',
  'feSpotLight',
  'feTile',
  'feTurbulence',
  'foreignObject',
  'glyphRef',
  'linearGradient',
  'radialGradient',
  'solidColor',
  'textArea',
  'textPath'
]

;// CONCATENATED MODULE: ../node_modules/hastscript/lib/svg.js
/**
 * @typedef {import('./core.js').HChild} Child
 * @typedef {import('./core.js').HProperties} Properties
 *
 * @typedef {import('./jsx-classic').Element} s.JSX.Element
 * @typedef {import('./jsx-classic').IntrinsicAttributes} s.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic').IntrinsicElements} s.JSX.IntrinsicElements
 * @typedef {import('./jsx-classic').ElementChildrenAttribute} s.JSX.ElementChildrenAttribute
 */





const s = core_core(property_information_svg, 'g', svgCaseSensitiveTagNames)

;// CONCATENATED MODULE: ../node_modules/hastscript/lib/html.js
/**
 * @typedef {import('./core.js').HChild} Child Acceptable child value
 * @typedef {import('./core.js').HProperties} Properties Acceptable properties value.
 *
 * @typedef {import('./jsx-classic').Element} h.JSX.Element
 * @typedef {import('./jsx-classic').IntrinsicAttributes} h.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic').IntrinsicElements} h.JSX.IntrinsicElements
 * @typedef {import('./jsx-classic').ElementChildrenAttribute} h.JSX.ElementChildrenAttribute
 */




const h = core_core(property_information_html, 'div')

;// CONCATENATED MODULE: ../node_modules/vfile-location/index.js
/**
 * @typedef {import('unist').Point} Point
 * @typedef {import('vfile').VFile} VFile
 *
 * @typedef {Pick<Point, 'line'|'column'>} PositionalPoint
 * @typedef {Required<Point>} FullPoint
 * @typedef {NonNullable<Point['offset']>} Offset
 */

/**
 * Get transform functions for the given `document`.
 *
 * @param {string|Uint8Array|VFile} file
 */
function vfile_location_location(file) {
  var value = String(file)
  /** @type {Array.<number>} */
  var indices = []
  var search = /\r?\n|\r/g

  while (search.test(value)) {
    indices.push(search.lastIndex)
  }

  indices.push(value.length + 1)

  return {toPoint, toOffset}

  /**
   * Get the line and column-based `point` for `offset` in the bound indices.
   * Returns a point with `undefined` values when given invalid or out of bounds
   * input.
   *
   * @param {Offset} offset
   * @returns {FullPoint}
   */
  function toPoint(offset) {
    var index = -1

    if (offset > -1 && offset < indices[indices.length - 1]) {
      while (++index < indices.length) {
        if (indices[index] > offset) {
          return {
            line: index + 1,
            column: offset - (indices[index - 1] || 0) + 1,
            offset
          }
        }
      }
    }

    return {line: undefined, column: undefined, offset: undefined}
  }

  /**
   * Get the `offset` for a line and column-based `point` in the bound indices.
   * Returns `-1` when given invalid or out of bounds input.
   *
   * @param {PositionalPoint} point
   * @returns {Offset}
   */
  function toOffset(point) {
    var line = point && point.line
    var column = point && point.column
    /** @type {number} */
    var offset

    if (
      typeof line === 'number' &&
      typeof column === 'number' &&
      !Number.isNaN(line) &&
      !Number.isNaN(column) &&
      line - 1 in indices
    ) {
      offset = (indices[line - 2] || 0) + column - 1 || 0
    }

    return offset > -1 && offset < indices[indices.length - 1] ? offset : -1
  }
}

;// CONCATENATED MODULE: ../node_modules/web-namespaces/index.js
/**
 * Map of web namespaces.
 *
 * @type {Record<string, string>}
 */
const webNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg',
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace',
  xmlns: 'http://www.w3.org/2000/xmlns/'
}

;// CONCATENATED MODULE: ../node_modules/hast-util-from-parse5/lib/index.js
/**
 * @typedef {import('vfile').VFile} VFile
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('hast').Parent} Parent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {Parent['children'][number]} Child
 * @typedef {Element['children'][number]} ElementChild
 * @typedef {Child|Root} Node
 * @typedef {import('parse5').Document} P5Document
 * @typedef {import('parse5').DocumentType} P5Doctype
 * @typedef {import('parse5').CommentNode} P5Comment
 * @typedef {import('parse5').TextNode} P5Text
 * @typedef {import('parse5').Element} P5Element
 * @typedef {import('parse5').ElementLocation} P5ElementLocation
 * @typedef {import('parse5').Location} P5Location
 * @typedef {import('parse5').Attribute} P5Attribute
 * @typedef {import('parse5').Node} P5Node
 *
 * @typedef {'html'|'svg'} Space
 *
 * @callback Handler
 * @param {Context} ctx
 * @param {P5Node} node
 * @param {Array.<Child>} [children]
 * @returns {Node}
 *
 * @typedef Options
 * @property {Space} [space='html'] Whether the root of the tree is in the `'html'` or `'svg'` space. If an element in with the SVG namespace is found in `ast`, `fromParse5` automatically switches to the SVG space when entering the element, and switches back when leaving
 * @property {VFile} [file] `VFile`, used to add positional information to nodes. If given, the file should have the original HTML source as its contents
 * @property {boolean} [verbose=false] Whether to add extra positional information about starting tags, closing tags, and attributes to elements. Note: not used without `file`
 *
 * @typedef Context
 * @property {Schema} schema
 * @property {VFile|undefined} file
 * @property {boolean|undefined} verbose
 * @property {boolean} location
 */






const hast_util_from_parse5_lib_own = {}.hasOwnProperty

// Handlers.
const map = {
  '#document': lib_root,
  '#document-fragment': lib_root,
  '#text': lib_text,
  '#comment': comment,
  '#documentType': doctype
}

/**
 * Transform Parse5’s AST to a hast tree.
 *
 * @param {P5Node} ast
 * @param {Options|VFile} [options]
 */
function fromParse5(ast, options = {}) {
  /** @type {Options} */
  let settings
  /** @type {VFile|undefined} */
  let file

  if (isFile(options)) {
    file = options
    settings = {}
  } else {
    file = options.file
    settings = options
  }

  return transform(
    {
      schema: settings.space === 'svg' ? property_information_svg : property_information_html,
      file,
      verbose: settings.verbose,
      location: false
    },
    ast
  )
}

/**
 * Transform children.
 *
 * @param {Context} ctx
 * @param {P5Node} ast
 * @returns {Node}
 */
function transform(ctx, ast) {
  const schema = ctx.schema
  /** @type {Handler} */
  // @ts-expect-error: index is fine.
  const fn = hast_util_from_parse5_lib_own.call(map, ast.nodeName) ? map[ast.nodeName] : lib_element
  /** @type {Array.<Child>|undefined} */
  let children

  // Element.
  if ('tagName' in ast) {
    ctx.schema = ast.namespaceURI === webNamespaces.svg ? property_information_svg : property_information_html
  }

  if ('childNodes' in ast) {
    children = nodes(ctx, ast.childNodes)
  }

  const result = fn(ctx, ast, children)

  if ('sourceCodeLocation' in ast && ast.sourceCodeLocation && ctx.file) {
    // @ts-expect-error It’s fine.
    const position = createLocation(ctx, result, ast.sourceCodeLocation)

    if (position) {
      ctx.location = true
      result.position = position
    }
  }

  ctx.schema = schema

  return result
}

/**
 * Transform children.
 *
 * @param {Context} ctx
 * @param {Array.<P5Node>} children
 * @returns {Array.<Child>}
 */
function nodes(ctx, children) {
  let index = -1
  /** @type {Array.<Child>} */
  const result = []

  while (++index < children.length) {
    // @ts-expect-error Assume no roots in children.
    result[index] = transform(ctx, children[index])
  }

  return result
}

/**
 * Transform a document.
 * Stores `ast.quirksMode` in `node.data.quirksMode`.
 *
 * @type {Handler}
 * @param {P5Document} ast
 * @param {Array.<Child>} children
 * @returns {Root}
 */
function lib_root(ctx, ast, children) {
  /** @type {Root} */
  const result = {
    type: 'root',
    children,
    data: {quirksMode: ast.mode === 'quirks' || ast.mode === 'limited-quirks'}
  }

  if (ctx.file && ctx.location) {
    const doc = String(ctx.file)
    const loc = vfile_location_location(doc)
    result.position = {
      start: loc.toPoint(0),
      end: loc.toPoint(doc.length)
    }
  }

  return result
}

/**
 * Transform a doctype.
 *
 * @type {Handler}
 * @returns {Doctype}
 */
function doctype() {
  // @ts-expect-error Types are out of date.
  return {type: 'doctype'}
}

/**
 * Transform a text.
 *
 * @type {Handler}
 * @param {P5Text} ast
 * @returns {Text}
 */
function lib_text(_, ast) {
  return {type: 'text', value: ast.value}
}

/**
 * Transform a comment.
 *
 * @type {Handler}
 * @param {P5Comment} ast
 * @returns {Comment}
 */
function comment(_, ast) {
  return {type: 'comment', value: ast.data}
}

/**
 * Transform an element.
 *
 * @type {Handler}
 * @param {P5Element} ast
 * @param {Array.<ElementChild>} children
 * @returns {Element}
 */
function lib_element(ctx, ast, children) {
  const fn = ctx.schema.space === 'svg' ? s : h
  let index = -1
  /** @type {Object.<string, string>} */
  const props = {}

  while (++index < ast.attrs.length) {
    const attribute = ast.attrs[index]
    props[(attribute.prefix ? attribute.prefix + ':' : '') + attribute.name] =
      attribute.value
  }

  const result = fn(ast.tagName, props, children)

  if (result.tagName === 'template' && 'content' in ast) {
    const pos = ast.sourceCodeLocation
    const startTag = pos && pos.startTag && lib_position(pos.startTag)
    const endTag = pos && pos.endTag && lib_position(pos.endTag)

    /** @type {Root} */
    // @ts-expect-error Types are wrong.
    const content = transform(ctx, ast.content)

    if (startTag && endTag && ctx.file) {
      content.position = {start: startTag.end, end: endTag.start}
    }

    result.content = content
  }

  return result
}

/**
 * Create clean positional information.
 *
 * @param {Context} ctx
 * @param {Node} node
 * @param {P5ElementLocation} location
 * @returns {Position|null}
 */
function createLocation(ctx, node, location) {
  const result = lib_position(location)

  if (node.type === 'element') {
    const tail = node.children[node.children.length - 1]

    // Bug for unclosed with children.
    // See: <https://github.com/inikulin/parse5/issues/109>.
    if (
      result &&
      !location.endTag &&
      tail &&
      tail.position &&
      tail.position.end
    ) {
      result.end = Object.assign({}, tail.position.end)
    }

    if (ctx.verbose) {
      /** @type {Object.<string, Position|null>} */
      const props = {}
      /** @type {string} */
      let key

      for (key in location.attrs) {
        if (hast_util_from_parse5_lib_own.call(location.attrs, key)) {
          props[find(ctx.schema, key).property] = lib_position(location.attrs[key])
        }
      }

      node.data = {
        position: {
          opening: lib_position(location.startTag),
          closing: location.endTag ? lib_position(location.endTag) : null,
          properties: props
        }
      }
    }
  }

  return result
}

/**
 * @param {P5Location} loc
 * @returns {Position|null}
 */
function lib_position(loc) {
  const start = lib_point({
    line: loc.startLine,
    column: loc.startCol,
    offset: loc.startOffset
  })
  const end = lib_point({
    line: loc.endLine,
    column: loc.endCol,
    offset: loc.endOffset
  })
  // @ts-expect-error `null` is fine.
  return start || end ? {start, end} : null
}

/**
 * @param {Point} point
 * @returns {Point|null}
 */
function lib_point(point) {
  return point.line && point.column ? point : null
}

/**
 * @param {VFile|Options} value
 * @returns {value is VFile}
 */
function isFile(value) {
  return 'messages' in value
}

;// CONCATENATED MODULE: ../node_modules/hast-to-hyperscript/index.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 *
 * @typedef {import('unist-util-is').AssertPredicate<Element>} AssertElement
 * @typedef {import('unist-util-is').AssertPredicate<Text>} AssertText
 * @typedef {import('unist-util-is').AssertPredicate<Root>} AssertRoot
 *
 * @callback CreateElementLike
 * @param {string} name
 * @param {any} attributes
 * @param {Array.<string|any>} [children]
 * @returns {any}
 *
 * @typedef Context
 * @property {html|svg} schema
 * @property {string|null} prefix
 * @property {number} key
 * @property {boolean} react
 * @property {boolean} vue
 * @property {boolean} vdom
 * @property {boolean} hyperscript
 *
 * @typedef Options
 * @property {string|null} [prefix]
 * @property {'html'|'svg'} [space]
 */








const ns = /** @type {Record<string, string>} */ (webNamespaces)
const hast_to_hyperscript_toReact = /** @type {Record<string, string>} */ (hastToReact)

const hast_to_hyperscript_own = {}.hasOwnProperty

/** @type {AssertRoot} */
// @ts-expect-error it’s correct.
const hast_to_hyperscript_root = convert('root')
/** @type {AssertElement} */
// @ts-expect-error it’s correct.
const hast_to_hyperscript_element = convert('element')
/** @type {AssertText} */
// @ts-expect-error it’s correct.
const hast_to_hyperscript_text = convert('text')

/**
 * @template {CreateElementLike} H
 * @param {H} h
 * @param {Element|Root} tree
 * @param {string|boolean|Options} [options]
 * @returns {ReturnType<H>}
 */
function toH(h, tree, options) {
  if (typeof h !== 'function') {
    throw new TypeError('h is not a function')
  }

  const r = hast_to_hyperscript_react(h)
  const v = vue(h)
  const vd = vdom(h)
  /** @type {string|boolean|null|undefined} */
  let prefix
  /** @type {Element} */
  let node

  if (typeof options === 'string' || typeof options === 'boolean') {
    prefix = options
    options = {}
  } else {
    if (!options) options = {}
    prefix = options.prefix
  }

  if (hast_to_hyperscript_root(tree)) {
    // @ts-expect-error Allow `doctypes` in there, we’ll filter them out later.
    node =
      tree.children.length === 1 && hast_to_hyperscript_element(tree.children[0])
        ? tree.children[0]
        : {
            type: 'element',
            tagName: 'div',
            properties: {},
            children: tree.children
          }
  } else if (hast_to_hyperscript_element(tree)) {
    node = tree
  } else {
    throw new Error(
      // @ts-expect-error runtime.
      'Expected root or element, not `' + ((tree && tree.type) || tree) + '`'
    )
  }

  return hast_to_hyperscript_transform(h, node, {
    schema: options.space === 'svg' ? property_information_svg : property_information_html,
    prefix:
      prefix === undefined || prefix === null
        ? r || v || vd
          ? 'h-'
          : null
        : typeof prefix === 'string'
        ? prefix
        : prefix
        ? 'h-'
        : null,
    key: 0,
    react: r,
    vue: v,
    vdom: vd,
    hyperscript: hyperscript(h)
  })
}

/**
 * Transform a hast node through a hyperscript interface to *anything*!
 *
 * @template {CreateElementLike} H
 * @param {H} h
 * @param {Element} node
 * @param {Context} ctx
 */
function hast_to_hyperscript_transform(h, node, ctx) {
  const parentSchema = ctx.schema
  let schema = parentSchema
  let name = node.tagName
  /** @type {Record<string, unknown>} */
  const attributes = {}
  /** @type {Array.<ReturnType<H>|string>} */
  const nodes = []
  let index = -1
  /** @type {string} */
  let key

  if (parentSchema.space === 'html' && name.toLowerCase() === 'svg') {
    schema = property_information_svg
    ctx.schema = schema
  }

  for (key in node.properties) {
    if (node.properties && hast_to_hyperscript_own.call(node.properties, key)) {
      addAttribute(attributes, key, node.properties[key], ctx, name)
    }
  }

  if (ctx.vdom) {
    if (schema.space === 'html') {
      name = name.toUpperCase()
    } else if (schema.space) {
      attributes.namespace = ns[schema.space]
    }
  }

  if (ctx.prefix) {
    ctx.key++
    attributes.key = ctx.prefix + ctx.key
  }

  if (node.children) {
    while (++index < node.children.length) {
      const value = node.children[index]

      if (hast_to_hyperscript_element(value)) {
        nodes.push(hast_to_hyperscript_transform(h, value, ctx))
      } else if (hast_to_hyperscript_text(value)) {
        nodes.push(value.value)
      }
    }
  }

  // Restore parent schema.
  ctx.schema = parentSchema

  // Ensure no React warnings are triggered for void elements having children
  // passed in.
  return nodes.length > 0
    ? h.call(node, name, attributes, nodes)
    : h.call(node, name, attributes)
}

/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 * @param {string} name
 */
// eslint-disable-next-line complexity, max-params
function addAttribute(props, prop, value, ctx, name) {
  const info = find(ctx.schema, prop)
  /** @type {string|undefined} */
  let subprop

  // Ignore nullish and `NaN` values.
  // Ignore `false` and falsey known booleans for hyperlike DSLs.
  if (
    value === undefined ||
    value === null ||
    (typeof value === 'number' && Number.isNaN(value)) ||
    (value === false && (ctx.vue || ctx.vdom || ctx.hyperscript)) ||
    (!value && info.boolean && (ctx.vue || ctx.vdom || ctx.hyperscript))
  ) {
    return
  }

  if (Array.isArray(value)) {
    // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? comma_separated_tokens_stringify(value) : stringify(value)
  }

  // Treat `true` and truthy known booleans.
  if (info.boolean && ctx.hyperscript) {
    value = ''
  }

  // VDOM, Vue, and React accept `style` as object.
  if (
    info.property === 'style' &&
    typeof value === 'string' &&
    (ctx.react || ctx.vue || ctx.vdom)
  ) {
    value = hast_to_hyperscript_parseStyle(value, name)
  }

  if (ctx.vue) {
    if (info.property !== 'style') subprop = 'attrs'
  } else if (!info.mustUseProperty) {
    if (ctx.vdom) {
      if (info.property !== 'style') subprop = 'attributes'
    } else if (ctx.hyperscript) {
      subprop = 'attrs'
    }
  }

  if (subprop) {
    props[subprop] = Object.assign(props[subprop] || {}, {
      [info.attribute]: value
    })
  } else if (info.space && ctx.react) {
    props[hast_to_hyperscript_toReact[info.property] || info.property] = value
  } else {
    props[info.attribute] = value
  }
}

/**
 * Check if `h` is `react.createElement`.
 *
 * @param {CreateElementLike} h
 * @returns {boolean}
 */
function hast_to_hyperscript_react(h) {
  /** @type {unknown} */
  const node = h('div', {})
  return Boolean(
    node &&
      // @ts-expect-error Looks like a React node.
      ('_owner' in node || '_store' in node) &&
      // @ts-expect-error Looks like a React node.
      (node.key === undefined || node.key === null)
  )
}

/**
 * Check if `h` is `hyperscript`.
 *
 * @param {CreateElementLike} h
 * @returns {boolean}
 */
function hyperscript(h) {
  return 'context' in h && 'cleanup' in h
}

/**
 * Check if `h` is `virtual-dom/h`.
 *
 * @param {CreateElementLike} h
 * @returns {boolean}
 */
function vdom(h) {
  /** @type {unknown} */
  const node = h('div', {})
  // @ts-expect-error Looks like a vnode.
  return node.type === 'VirtualNode'
}

/**
 * Check if `h` is Vue.
 *
 * @param {CreateElementLike} h
 * @returns {boolean}
 */
function vue(h) {
  /** @type {unknown} */
  const node = h('div', {})
  // @ts-expect-error Looks like a Vue node.
  return Boolean(node && node.context && node.context._isVue)
}

/**
 * @param {string} value
 * @param {string} tagName
 * @returns {Record<string, string>}
 */
function hast_to_hyperscript_parseStyle(value, tagName) {
  /** @type {Record<string, string>} */
  const result = {}

  try {
    style_to_object(value, (name, value) => {
      if (name.slice(0, 4) === '-ms-') name = 'ms-' + name.slice(4)

      result[
        name.replace(
          /-([a-z])/g,
          /**
           * @param {string} _
           * @param {string} $1
           * @returns {string}
           */ (_, $1) => $1.toUpperCase()
        )
      ] = value
    })
  } catch (error) {
    error.message =
      tagName + '[style]' + error.message.slice('undefined'.length)
    throw error
  }

  return result
}

;// CONCATENATED MODULE: ../node_modules/zwitch/index.js
var zwitch_own = {}.hasOwnProperty

/**
 * @callback Handler
 * @param {...unknown} value
 * @return {unknown}
 *
 * @typedef {Record<string, Handler>} Handlers
 *
 * @typedef {Object} Options
 * @property {Handler} [unknown]
 * @property {Handler} [invalid]
 * @property {Handlers} [handlers]
 */

/**
 * Handle values based on a property.
 *
 * @param {string} key
 * @param {Options} [options]
 */
function zwitch(key, options) {
  var settings = options || {}

  /**
   * Handle one value.
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @param {...unknown} [value]
   * @this {unknown}
   * @returns {unknown}
   * @property {Handler} invalid
   * @property {Handler} unknown
   * @property {Handlers} handlers
   */
  function one(value) {
    var fn = one.invalid
    var handlers = one.handlers

    if (value && zwitch_own.call(value, key)) {
      fn = zwitch_own.call(handlers, value[key]) ? handlers[value[key]] : one.unknown
    }

    if (fn) {
      return fn.apply(this, arguments)
    }
  }

  one.handlers = settings.handlers || {}
  one.invalid = settings.invalid
  one.unknown = settings.unknown

  return one
}

;// CONCATENATED MODULE: ../node_modules/hast-util-to-parse5/lib/index.js
/**
 * @typedef {import('parse5').Node} P5Node
 * @typedef {import('parse5').Document} P5Document
 * @typedef {import('parse5').DocumentFragment} P5Fragment
 * @typedef {import('parse5').DocumentType} P5Doctype
 * @typedef {import('parse5').CommentNode} P5Comment
 * @typedef {import('parse5').TextNode} P5Text
 * @typedef {import('parse5').Element} P5Element
 * @typedef {import('parse5').Attribute} P5Attribute
 * @typedef {import('parse5').ParentNode} P5Parent
 * @typedef {Exclude<P5Node, P5Document|P5Fragment>} P5Child
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('property-information').Info} Info
 * @typedef {'html'|'svg'} Space
 * @typedef {import('hast').Parent} Parent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {Parent['children'][number]} Child
 * @typedef {Child|Root} Node
 *
 * @callback Handle
 * @param {Node} node
 * @param {Schema} schema
 * @returns {P5Node}
 */






var hast_util_to_parse5_lib_own = {}.hasOwnProperty

var lib_one = zwitch('type', {handlers: {root: hast_util_to_parse5_lib_root, element: hast_util_to_parse5_lib_element, text: hast_util_to_parse5_lib_text, comment: lib_comment, doctype: lib_doctype}})

/**
 * Transform a tree from hast to Parse5’s AST.
 *
 * @param {Node} tree
 * @param {Space} [space='html']
 * @returns {P5Node}
 */
function toParse5(tree, space) {
  // @ts-ignore Types are wrong.
  return lib_one(tree, space === 'svg' ? property_information_svg : property_information_html)
}

/**
 * @type {Handle}
 * @param {Root} node
 * @returns {P5Document}
 */
function hast_util_to_parse5_lib_root(node, schema) {
  /** @type {P5Document} */
  var p5 = {
    nodeName: '#document',
    mode: (node.data || {}).quirksMode ? 'quirks' : 'no-quirks',
    childNodes: []
  }
  // @ts-ignore Assume correct children.
  p5.childNodes = lib_all(node.children, p5, schema)
  return patch(node, p5)
}

/**
 * @type {Handle}
 * @param {Root} node
 * @returns {P5Fragment}
 */
function fragment(node, schema) {
  /** @type {P5Fragment} */
  var p5 = {nodeName: '#document-fragment', childNodes: []}
  // @ts-ignore Assume correct children.
  p5.childNodes = lib_all(node.children, p5, schema)
  return patch(node, p5)
}

/**
 * @type {Handle}
 * @param {Doctype} node
 * @returns {P5Doctype}
 */
function lib_doctype(node) {
  return patch(node, {
    nodeName: '#documentType',
    name: 'html',
    publicId: '',
    systemId: '',
    parentNode: undefined
  })
}

/**
 * @type {Handle}
 * @param {Text} node
 * @returns {P5Text}
 */
function hast_util_to_parse5_lib_text(node) {
  return patch(node, {
    nodeName: '#text',
    value: node.value,
    parentNode: undefined
  })
}

/**
 * @type {Handle}
 * @param {Comment} node
 * @returns {P5Comment}
 */
function lib_comment(node) {
  return patch(node, {
    nodeName: '#comment',
    data: node.value,
    parentNode: undefined
  })
}

/**
 * @type {Handle}
 * @param {Element} node
 * @returns {P5Element}
 */
function hast_util_to_parse5_lib_element(node, schema) {
  /** @type {Space} */
  // @ts-ignore Assume space.
  var space = schema.space
  return toH(h, Object.assign({}, node, {children: []}), {space})

  /**
   * @param {string} name
   * @param {Object.<string, string|boolean|number>} attrs
   */
  function h(name, attrs) {
    /** @type {Array.<P5Attribute>} */
    var values = []
    /** @type {Info} */
    var info
    /** @type {P5Attribute} */
    var value
    /** @type {string} */
    var key
    /** @type {number} */
    var index
    /** @type {P5Element} */
    var p5

    for (key in attrs) {
      if (!hast_util_to_parse5_lib_own.call(attrs, key) || attrs[key] === false) {
        continue
      }

      info = find(schema, key)

      if (info.boolean && !attrs[key]) {
        continue
      }

      value = {name: key, value: attrs[key] === true ? '' : String(attrs[key])}

      if (info.space && info.space !== 'html' && info.space !== 'svg') {
        index = key.indexOf(':')

        if (index < 0) {
          value.prefix = ''
        } else {
          value.name = key.slice(index + 1)
          value.prefix = key.slice(0, index)
        }

        value.namespace = webNamespaces[info.space]
      }

      values.push(value)
    }

    if (schema.space === 'html' && node.tagName === 'svg') schema = property_information_svg

    p5 = patch(node, {
      nodeName: name,
      tagName: name,
      attrs: values,
      namespaceURI: webNamespaces[schema.space],
      childNodes: [],
      parentNode: undefined
    })

    // @ts-ignore Assume correct children.
    p5.childNodes = lib_all(node.children, p5, schema)

    // @ts-ignore Types are wrong.
    if (name === 'template') p5.content = fragment(node.content, schema)

    return p5
  }
}

/**
 * @param {Array.<Child>} children
 * @param {P5Parent} p5
 * @param {Schema} schema
 * @returns {Array.<P5Child>}
 */
function lib_all(children, p5, schema) {
  var index = -1
  /** @type {Array.<P5Child>} */
  var result = []
  /** @type {P5Child} */
  var child

  if (children) {
    while (++index < children.length) {
      // @ts-ignore Assume child.
      child = lib_one(children[index], schema)

      // @ts-ignore types are wrong.
      child.parentNode = p5

      result.push(child)
    }
  }

  return result
}

/**
 * Patch specific properties.
 *
 * @template {P5Node} T
 * @param {Node} node
 * @param {T} p5
 * @returns {T}
 */
function patch(node, p5) {
  var position = node.position

  if (position && position.start && position.end) {
    // @ts-ignore Types are wrong.
    p5.sourceCodeLocation = {
      startLine: position.start.line,
      startCol: position.start.column,
      startOffset: position.start.offset,
      endLine: position.end.line,
      endCol: position.end.column,
      endOffset: position.end.offset
    }
  }

  return p5
}

;// CONCATENATED MODULE: ../node_modules/html-void-elements/index.js
/**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */
const htmlVoidElements = [
  'area',
  'base',
  'basefont',
  'bgsound',
  'br',
  'col',
  'command',
  'embed',
  'frame',
  'hr',
  'image',
  'img',
  'input',
  'isindex',
  'keygen',
  'link',
  'menuitem',
  'meta',
  'nextid',
  'param',
  'source',
  'track',
  'wbr'
]

;// CONCATENATED MODULE: ../node_modules/hast-util-raw/lib/index.js
/**
 * @typedef {import('vfile').VFile} VFile
 * @typedef {import('parse5').Document} P5Document
 * @typedef {import('parse5').DocumentFragment} P5Fragment
 * @typedef {Omit<import('parse5').Element, 'parentNode'>} P5Element
 * @typedef {import('parse5').Attribute} P5Attribute
 * @typedef {Omit<import('parse5').Location, 'startOffset' | 'endOffset'> & {startOffset: number|undefined, endOffset: number|undefined}} P5Location
 * @typedef {import('parse5').ParserOptions} P5ParserOptions
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').Content} Content
 * @typedef {Root|Content} Node
 * @typedef {import('../complex-types').Raw} Raw
 *
 * @typedef {Omit<Comment, 'value'> & {value: {stitch: Node}}} Stitch
 *
 * @typedef Options
 * @property {Array<string>} [passThrough]
 *   List of custom hast node types to pass through (keep) in hast.
 *   If the passed through nodes have children, those children are expected to
 *   be hast and will be handled.
 *
 * @typedef HiddenTokenizer
 * @property {Array<HiddenLocationTracker>} __mixins
 *   Way too simple, but works for us.
 * @property {HiddenPreprocessor} preprocessor
 * @property {(value: string) => void} write
 * @property {() => number} _consume
 * @property {Array<HiddenToken>} tokenQueue
 * @property {string} state
 * @property {string} returnState
 * @property {number} charRefCode
 * @property {Array<number>} tempBuff
 * @property {Function} _flushCodePointsConsumedAsCharacterReference
 * @property {string} lastStartTagName
 * @property {number} consumedAfterSnapshot
 * @property {boolean} active
 * @property {HiddenToken|undefined} currentCharacterToken
 * @property {HiddenToken|undefined} currentToken
 * @property {unknown} currentAttr
 * @property {Function} NAMED_CHARACTER_REFERENCE_STATE
 * @property {Function} NUMERIC_CHARACTER_REFERENCE_END_STATE
 *
 * @typedef {Record<string, unknown> & {location: P5Location}} HiddenToken
 *
 * @typedef HiddenPreprocessor
 * @property {string|undefined} html
 * @property {number} pos
 * @property {number} lastGapPos
 * @property {number} lastCharPos
 * @property {Array<number>} gapStack
 * @property {boolean} skipNextNewLine
 * @property {boolean} lastChunkWritten
 * @property {boolean} endOfChunkHit
 *
 * @typedef HiddenLocationTracker
 * @property {P5Location|undefined} currentAttrLocation
 * @property {P5Location} ctLoc
 * @property {HiddenPosTracker} posTracker
 *
 * @typedef HiddenPosTracker
 * @property {boolean} isEol
 * @property {number} lineStartPos
 * @property {number} droppedBufferSize
 * @property {number} offset
 * @property {number} col
 * @property {number} line
 */

// @ts-expect-error: untyped.









const inTemplateMode = 'IN_TEMPLATE_MODE'
const dataState = 'DATA_STATE'
const characterToken = 'CHARACTER_TOKEN'
const startTagToken = 'START_TAG_TOKEN'
const endTagToken = 'END_TAG_TOKEN'
const commentToken = 'COMMENT_TOKEN'
const doctypeToken = 'DOCTYPE_TOKEN'

/** @type {P5ParserOptions} */
const parseOptions = {sourceCodeLocationInfo: true, scriptingEnabled: false}

/**
 * Given a hast tree and an optional vfile (for positional info), return a new
 * parsed-again hast tree.
 *
 * @param tree
 *   Original hast tree.
 * @param file
 *   Virtual file for positional info, optional.
 * @param options
 *   Configuration.
 */
const raw =
  /**
   * @type {(
   *   ((tree: Node, file: VFile|undefined, options?: Options) => Node) &
   *   ((tree: Node, options?: Options) => Node)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {VFile} [file]
     * @param {Options} [options]
     */
    function (tree, file, options) {
      let index = -1
      const parser = new lib_parser(parseOptions)
      const one = zwitch('type', {
        // @ts-expect-error: hush.
        handlers: {root, element, text, comment, doctype, raw: handleRaw},
        // @ts-expect-error: hush.
        unknown: lib_unknown
      })
      /** @type {boolean|undefined} */
      let stitches
      /** @type {HiddenTokenizer|undefined} */
      let tokenizer
      /** @type {HiddenPreprocessor|undefined} */
      let preprocessor
      /** @type {HiddenPosTracker|undefined} */
      let posTracker
      /** @type {HiddenLocationTracker|undefined} */
      let locationTracker

      if (isOptions(file)) {
        options = file
        file = undefined
      }

      if (options && options.passThrough) {
        while (++index < options.passThrough.length) {
          // @ts-expect-error: hush.
          one.handlers[options.passThrough[index]] = stitch
        }
      }

      const result = fromParse5(
        documentMode(tree) ? document() : fragment(),
        file
      )

      if (stitches) {
        visit(result, 'comment', (node, index, parent) => {
          const stitch = /** @type {Stitch} */ (/** @type {unknown} */ (node))
          if (stitch.value.stitch && parent !== null && index !== null) {
            // @ts-expect-error: assume the stitch is allowed.
            parent.children[index] = stitch.value.stitch
            return index
          }
        })
      }

      // Unpack if possible and when not given a `root`.
      if (
        tree.type !== 'root' &&
        result.type === 'root' &&
        result.children.length === 1
      ) {
        return result.children[0]
      }

      return result

      /**
       * @returns {P5Fragment}
       */
      function fragment() {
        /** @type {P5Element} */
        const context = {
          nodeName: 'template',
          tagName: 'template',
          attrs: [],
          namespaceURI: webNamespaces.html,
          childNodes: []
        }
        /** @type {P5Element} */
        const mock = {
          nodeName: 'documentmock',
          tagName: 'documentmock',
          attrs: [],
          namespaceURI: webNamespaces.html,
          childNodes: []
        }
        /** @type {P5Fragment} */
        const doc = {nodeName: '#document-fragment', childNodes: []}

        parser._bootstrap(mock, context)
        parser._pushTmplInsertionMode(inTemplateMode)
        parser._initTokenizerForFragmentParsing()
        parser._insertFakeRootElement()
        parser._resetInsertionMode()
        parser._findFormInFragmentContext()

        tokenizer = parser.tokenizer
        /* c8 ignore next */
        if (!tokenizer) throw new Error('Expected `tokenizer`')
        preprocessor = tokenizer.preprocessor
        locationTracker = tokenizer.__mixins[0]
        posTracker = locationTracker.posTracker

        one(tree)

        resetTokenizer()

        parser._adoptNodes(mock.childNodes[0], doc)

        return doc
      }

      /**
       * @returns {P5Document}
       */
      function document() {
        /** @type {P5Document} */
        const doc = parser.treeAdapter.createDocument()

        parser._bootstrap(doc, undefined)
        tokenizer = parser.tokenizer
        /* c8 ignore next */
        if (!tokenizer) throw new Error('Expected `tokenizer`')
        preprocessor = tokenizer.preprocessor
        locationTracker = tokenizer.__mixins[0]
        posTracker = locationTracker.posTracker

        one(tree)

        resetTokenizer()

        return doc
      }

      /**
       * @param {Array<Content>} nodes
       * @returns {void}
       */
      function all(nodes) {
        let index = -1

        /* istanbul ignore else - invalid nodes, see rehypejs/rehype-raw#7. */
        if (nodes) {
          while (++index < nodes.length) {
            one(nodes[index])
          }
        }
      }

      /**
       * @param {Root} node
       * @returns {void}
       */
      function root(node) {
        all(node.children)
      }

      /**
       * @param {Element} node
       * @returns {void}
       */
      function element(node) {
        resetTokenizer()
        parser._processToken(startTag(node), webNamespaces.html)

        all(node.children)

        if (!htmlVoidElements.includes(node.tagName)) {
          resetTokenizer()
          parser._processToken(endTag(node))
        }
      }

      /**
       * @param {Text} node
       * @returns {void}
       */
      function text(node) {
        resetTokenizer()
        parser._processToken({
          type: characterToken,
          chars: node.value,
          location: createParse5Location(node)
        })
      }

      /**
       * @param {Doctype} node
       * @returns {void}
       */
      function doctype(node) {
        resetTokenizer()
        parser._processToken({
          type: doctypeToken,
          name: 'html',
          forceQuirks: false,
          publicId: '',
          systemId: '',
          location: createParse5Location(node)
        })
      }

      /**
       * @param {Comment|Stitch} node
       * @returns {void}
       */
      function comment(node) {
        resetTokenizer()
        parser._processToken({
          type: commentToken,
          data: node.value,
          location: createParse5Location(node)
        })
      }

      /**
       * @param {Raw} node
       * @returns {void}
       */
      function handleRaw(node) {
        const start = pointStart(node)
        const line = start.line || 1
        const column = start.column || 1
        const offset = start.offset || 0

        /* c8 ignore next 4 */
        if (!preprocessor) throw new Error('Expected `preprocessor`')
        if (!tokenizer) throw new Error('Expected `tokenizer`')
        if (!posTracker) throw new Error('Expected `posTracker`')
        if (!locationTracker) throw new Error('Expected `locationTracker`')

        // Reset preprocessor:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/tokenizer/preprocessor.js#L17>.
        preprocessor.html = undefined
        preprocessor.pos = -1
        preprocessor.lastGapPos = -1
        preprocessor.lastCharPos = -1
        preprocessor.gapStack = []
        preprocessor.skipNextNewLine = false
        preprocessor.lastChunkWritten = false
        preprocessor.endOfChunkHit = false

        // Reset preprocessor mixin:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/position-tracking/preprocessor-mixin.js>.
        posTracker.isEol = false
        posTracker.lineStartPos = -column + 1 // Looks weird, but ensures we get correct positional info.
        posTracker.droppedBufferSize = offset
        posTracker.offset = 0
        posTracker.col = 1
        posTracker.line = line

        // Reset location tracker:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/location-info/tokenizer-mixin.js>.
        locationTracker.currentAttrLocation = undefined
        locationTracker.ctLoc = createParse5Location(node)

        // See the code for `parse` and `parseFragment`:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/parser/index.js#L371>.
        tokenizer.write(node.value)
        parser._runParsingLoop(null)

        // Character references hang, so if we ended there, we need to flush
        // those too.
        // We reset the preprocessor as if the document ends here.
        // Then one single call to the relevant state does the trick, parse5
        // consumes the whole token.
        if (
          tokenizer.state === 'NAMED_CHARACTER_REFERENCE_STATE' ||
          tokenizer.state === 'NUMERIC_CHARACTER_REFERENCE_END_STATE'
        ) {
          preprocessor.lastChunkWritten = true
          tokenizer[tokenizer.state](tokenizer._consume())
        }
      }

      /**
       * @param {Node} node
       */
      function stitch(node) {
        stitches = true

        /** @type {Node} */
        let clone

        // Recurse, because to somewhat handle `[<x>]</x>` (where `[]` denotes the
        // passed through node).
        if ('children' in node) {
          clone = {
            ...node,
            children: raw(
              {type: 'root', children: node.children},
              file,
              options
              // @ts-expect-error Assume a given parent yields a parent.
            ).children
          }
        } else {
          clone = {...node}
        }

        // Hack: `value` is supposed to be a string, but as none of the tools
        // (`parse5` or `hast-util-from-parse5`) looks at it, we can pass nodes
        // through.
        comment({type: 'comment', value: {stitch: clone}})
      }

      function resetTokenizer() {
        /* c8 ignore next 2 */
        if (!tokenizer) throw new Error('Expected `tokenizer`')
        if (!posTracker) throw new Error('Expected `posTracker`')

        // Process final characters if they’re still there after hibernating.
        // Similar to:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/location-info/tokenizer-mixin.js#L95>.
        const token = tokenizer.currentCharacterToken

        if (token) {
          token.location.endLine = posTracker.line
          token.location.endCol = posTracker.col + 1
          token.location.endOffset = posTracker.offset + 1
          parser._processToken(token)
        }

        // Reset tokenizer:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/tokenizer/index.js#L218-L234>.
        // Especially putting it back in the `data` state is useful: some elements,
        // like textareas and iframes, change the state.
        // See GH-7.
        // But also if broken HTML is in `raw`, and then a correct element is given.
        // See GH-11.
        tokenizer.tokenQueue = []
        tokenizer.state = dataState
        tokenizer.returnState = ''
        tokenizer.charRefCode = -1
        tokenizer.tempBuff = []
        tokenizer.lastStartTagName = ''
        tokenizer.consumedAfterSnapshot = -1
        tokenizer.active = false
        tokenizer.currentCharacterToken = undefined
        tokenizer.currentToken = undefined
        tokenizer.currentAttr = undefined
      }
    }
  )
/**
 * @param {Element} node
 * @returns {HiddenToken}
 */
function startTag(node) {
  /** @type {P5Location} */
  const location = Object.assign(createParse5Location(node))
  // @ts-expect-error extra positional info.
  location.startTag = Object.assign({}, location)

  // Untyped token.
  return {
    type: startTagToken,
    tagName: node.tagName,
    selfClosing: false,
    attrs: attributes(node),
    location
  }
}

/**
 * @param {Element} node
 * @returns {Array<P5Attribute>}
 */
function attributes(node) {
  return toParse5({
    tagName: node.tagName,
    type: 'element',
    properties: node.properties,
    children: []
    // @ts-expect-error Assume element.
  }).attrs
}

/**
 * @param {Element} node
 * @returns {HiddenToken}
 */
function endTag(node) {
  /** @type {P5Location} */
  const location = Object.assign(createParse5Location(node))
  // @ts-expect-error extra positional info.
  location.startTag = Object.assign({}, location)

  // Untyped token.
  return {
    type: endTagToken,
    tagName: node.tagName,
    attrs: [],
    location
  }
}

/**
 * @param {Node} node
 */
function lib_unknown(node) {
  throw new Error('Cannot compile `' + node.type + '` node')
}

/**
 * @param {Node} node
 * @returns {boolean}
 */
function documentMode(node) {
  const head = node.type === 'root' ? node.children[0] : node
  return Boolean(
    head &&
      (head.type === 'doctype' ||
        (head.type === 'element' && head.tagName === 'html'))
  )
}

/**
 * @param {Node|Stitch} node
 * @returns {P5Location}
 */
function createParse5Location(node) {
  const start = pointStart(node)
  const end = pointEnd(node)

  return {
    startLine: start.line,
    startCol: start.column,
    startOffset: start.offset,
    endLine: end.line,
    endCol: end.column,
    endOffset: end.offset
  }
}

/**
 * @param {VFile|Options|undefined} value
 * @return {value is Options}
 */
function isOptions(value) {
  return Boolean(value && !('message' in value && 'messages' in value))
}

;// CONCATENATED MODULE: ../node_modules/rehype-raw/index.js
/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-raw').Options} Options
 * @typedef {import('hast-util-raw')} DoNotTouchAsThisImportIncludesRawInTree
 */



/**
 * Plugin to parse the tree again (and raw nodes).
 * Keeping positional info OK.  🙌
 *
 * @type {import('unified').Plugin<[Options?] | Array<void>, Root>}
 */
function rehypeRaw(options = {}) {
  return (tree, file) => {
    // Assume that when a root was given, it’s also returned.
    const result = /** @type {Root} */ (raw(tree, file, options))
    return result
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-directive/lib/factory-attributes.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */




/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} attributesType
 * @param {string} attributesMarkerType
 * @param {string} attributeType
 * @param {string} attributeIdType
 * @param {string} attributeClassType
 * @param {string} attributeNameType
 * @param {string} attributeInitializerType
 * @param {string} attributeValueLiteralType
 * @param {string} attributeValueType
 * @param {string} attributeValueMarker
 * @param {string} attributeValueData
 * @param {boolean} [disallowEol=false]
 */
/* eslint-disable-next-line max-params */
function factoryAttributes(
  effects,
  ok,
  nok,
  attributesType,
  attributesMarkerType,
  attributeType,
  attributeIdType,
  attributeClassType,
  attributeNameType,
  attributeInitializerType,
  attributeValueLiteralType,
  attributeValueType,
  attributeValueMarker,
  attributeValueData,
  disallowEol
) {
  /** @type {string} */
  let type
  /** @type {Code|undefined} */
  let marker
  return start

  /** @type {State} */
  function start(code) {
    effects.enter(attributesType)
    effects.enter(attributesMarkerType)
    effects.consume(code)
    effects.exit(attributesMarkerType)
    return between
  }

  /** @type {State} */
  function between(code) {
    if (code === 35) {
      type = attributeIdType
      return shortcutStart(code)
    }
    if (code === 46) {
      type = attributeClassType
      return shortcutStart(code)
    }
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.enter(attributeType)
      effects.enter(attributeNameType)
      effects.consume(code)
      return name
    }
    if (disallowEol && markdownSpace(code)) {
      return factorySpace(effects, between, 'whitespace')(code)
    }
    if (!disallowEol && markdownLineEndingOrSpace(code)) {
      return factoryWhitespace(effects, between)(code)
    }
    return end(code)
  }

  /** @type {State} */
  function shortcutStart(code) {
    effects.enter(attributeType)
    effects.enter(type)
    effects.enter(type + 'Marker')
    effects.consume(code)
    effects.exit(type + 'Marker')
    return shortcutStartAfter
  }

  /** @type {State} */
  function shortcutStartAfter(code) {
    if (
      code === null ||
      code === 34 ||
      code === 35 ||
      code === 39 ||
      code === 46 ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96 ||
      code === 125 ||
      markdownLineEndingOrSpace(code)
    ) {
      return nok(code)
    }
    effects.enter(type + 'Value')
    effects.consume(code)
    return shortcut
  }

  /** @type {State} */
  function shortcut(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }
    if (
      code === 35 ||
      code === 46 ||
      code === 125 ||
      markdownLineEndingOrSpace(code)
    ) {
      effects.exit(type + 'Value')
      effects.exit(type)
      effects.exit(attributeType)
      return between(code)
    }
    effects.consume(code)
    return shortcut
  }

  /** @type {State} */
  function name(code) {
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return name
    }
    effects.exit(attributeNameType)
    if (disallowEol && markdownSpace(code)) {
      return factorySpace(effects, nameAfter, 'whitespace')(code)
    }
    if (!disallowEol && markdownLineEndingOrSpace(code)) {
      return factoryWhitespace(effects, nameAfter)(code)
    }
    return nameAfter(code)
  }

  /** @type {State} */
  function nameAfter(code) {
    if (code === 61) {
      effects.enter(attributeInitializerType)
      effects.consume(code)
      effects.exit(attributeInitializerType)
      return valueBefore
    }

    // Attribute w/o value.
    effects.exit(attributeType)
    return between(code)
  }

  /** @type {State} */
  function valueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96 ||
      code === 125 ||
      (disallowEol && markdownLineEnding(code))
    ) {
      return nok(code)
    }
    if (code === 34 || code === 39) {
      effects.enter(attributeValueLiteralType)
      effects.enter(attributeValueMarker)
      effects.consume(code)
      effects.exit(attributeValueMarker)
      marker = code
      return valueQuotedStart
    }
    if (disallowEol && markdownSpace(code)) {
      return factorySpace(effects, valueBefore, 'whitespace')(code)
    }
    if (!disallowEol && markdownLineEndingOrSpace(code)) {
      return factoryWhitespace(effects, valueBefore)(code)
    }
    effects.enter(attributeValueType)
    effects.enter(attributeValueData)
    effects.consume(code)
    marker = undefined
    return valueUnquoted
  }

  /** @type {State} */
  function valueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }
    if (code === 125 || markdownLineEndingOrSpace(code)) {
      effects.exit(attributeValueData)
      effects.exit(attributeValueType)
      effects.exit(attributeType)
      return between(code)
    }
    effects.consume(code)
    return valueUnquoted
  }

  /** @type {State} */
  function valueQuotedStart(code) {
    if (code === marker) {
      effects.enter(attributeValueMarker)
      effects.consume(code)
      effects.exit(attributeValueMarker)
      effects.exit(attributeValueLiteralType)
      effects.exit(attributeType)
      return valueQuotedAfter
    }
    effects.enter(attributeValueType)
    return valueQuotedBetween(code)
  }

  /** @type {State} */
  function valueQuotedBetween(code) {
    if (code === marker) {
      effects.exit(attributeValueType)
      return valueQuotedStart(code)
    }
    if (code === null) {
      return nok(code)
    }

    // Note: blank lines can’t exist in content.
    if (markdownLineEnding(code)) {
      return disallowEol
        ? nok(code)
        : factoryWhitespace(effects, valueQuotedBetween)(code)
    }
    effects.enter(attributeValueData)
    effects.consume(code)
    return valueQuoted
  }

  /** @type {State} */
  function valueQuoted(code) {
    if (code === marker || code === null || markdownLineEnding(code)) {
      effects.exit(attributeValueData)
      return valueQuotedBetween(code)
    }
    effects.consume(code)
    return valueQuoted
  }

  /** @type {State} */
  function valueQuotedAfter(code) {
    return code === 125 || markdownLineEndingOrSpace(code)
      ? between(code)
      : end(code)
  }

  /** @type {State} */
  function end(code) {
    if (code === 125) {
      effects.enter(attributesMarkerType)
      effects.consume(code)
      effects.exit(attributesMarkerType)
      effects.exit(attributesType)
      return ok
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-directive/lib/factory-label.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 */


// This is a fork of:
// <https://github.com/micromark/micromark/tree/main/packages/micromark-factory-label>
// to allow empty labels, balanced brackets (such as for nested directives),
// text instead of strings, and optionally disallows EOLs.

/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} markerType
 * @param {string} stringType
 * @param {boolean} [disallowEol=false]
 */
// eslint-disable-next-line max-params
function factory_label_factoryLabel(
  effects,
  ok,
  nok,
  type,
  markerType,
  stringType,
  disallowEol
) {
  let size = 0
  let balance = 0
  /** @type {Token|undefined} */
  let previous
  return start

  /** @type {State} */
  function start(code) {
    effects.enter(type)
    effects.enter(markerType)
    effects.consume(code)
    effects.exit(markerType)
    return afterStart
  }

  /** @type {State} */
  function afterStart(code) {
    if (code === 93) {
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }
    effects.enter(stringType)
    return lineStart(code)
  }

  /** @type {State} */
  function lineStart(code) {
    if (code === 93 && !balance) {
      return atClosingBrace(code)
    }
    const token = effects.enter('chunkText', {
      contentType: 'text',
      previous
    })
    if (previous) previous.next = token
    previous = token
    return data(code)
  }

  /** @type {State} */
  function data(code) {
    if (code === null || size > 999) {
      return nok(code)
    }
    if (code === 91 && ++balance > 32) {
      return nok(code)
    }
    if (code === 93 && !balance--) {
      effects.exit('chunkText')
      return atClosingBrace(code)
    }
    if (markdownLineEnding(code)) {
      if (disallowEol) {
        return nok(code)
      }
      effects.consume(code)
      effects.exit('chunkText')
      return lineStart
    }
    effects.consume(code)
    return code === 92 ? dataEscape : data
  }

  /** @type {State} */
  function dataEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return data
    }
    return data(code)
  }

  /** @type {State} */
  function atClosingBrace(code) {
    effects.exit(stringType)
    effects.enter(markerType)
    effects.consume(code)
    effects.exit(markerType)
    effects.exit(type)
    return ok
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-directive/lib/factory-name.js
/**
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */


/**
 * @this {TokenizeContext}
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 */
function factoryName(effects, ok, nok, type) {
  const self = this
  return start

  /** @type {State} */
  function start(code) {
    if (asciiAlpha(code)) {
      effects.enter(type)
      effects.consume(code)
      return name
    }
    return nok(code)
  }

  /** @type {State} */
  function name(code) {
    if (code === 45 || code === 95 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return name
    }
    effects.exit(type)
    return self.previous === 45 || self.previous === 95 ? nok(code) : ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-directive/lib/directive-container.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 */







/** @type {Construct} */
const directiveContainer = {
  tokenize: tokenizeDirectiveContainer,
  concrete: true
}
const label = {
  tokenize: tokenizeLabel,
  partial: true
}
const directive_container_attributes = {
  tokenize: tokenizeAttributes,
  partial: true
}
const nonLazyLine = {
  tokenize: tokenizeNonLazyLine,
  partial: true
}

/** @type {Tokenizer} */
function tokenizeDirectiveContainer(effects, ok, nok) {
  const self = this
  const tail = self.events[self.events.length - 1]
  const initialSize =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0
  let sizeOpen = 0
  /** @type {Token} */
  let previous
  return start

  /** @type {State} */
  function start(code) {
    effects.enter('directiveContainer')
    effects.enter('directiveContainerFence')
    effects.enter('directiveContainerSequence')
    return sequenceOpen(code)
  }

  /** @type {State} */
  function sequenceOpen(code) {
    if (code === 58) {
      effects.consume(code)
      sizeOpen++
      return sequenceOpen
    }
    if (sizeOpen < 3) {
      return nok(code)
    }
    effects.exit('directiveContainerSequence')
    return factoryName.call(
      self,
      effects,
      afterName,
      nok,
      'directiveContainerName'
    )(code)
  }

  /** @type {State} */
  function afterName(code) {
    return code === 91
      ? effects.attempt(label, afterLabel, afterLabel)(code)
      : afterLabel(code)
  }

  /** @type {State} */
  function afterLabel(code) {
    return code === 123
      ? effects.attempt(directive_container_attributes, afterAttributes, afterAttributes)(code)
      : afterAttributes(code)
  }

  /** @type {State} */
  function afterAttributes(code) {
    return factorySpace(effects, openAfter, 'whitespace')(code)
  }

  /** @type {State} */
  function openAfter(code) {
    effects.exit('directiveContainerFence')
    if (code === null) {
      return afterOpening(code)
    }
    if (markdownLineEnding(code)) {
      if (self.interrupt) {
        return ok(code)
      }
      return effects.attempt(nonLazyLine, contentStart, afterOpening)(code)
    }
    return nok(code)
  }

  /** @type {State} */
  function afterOpening(code) {
    effects.exit('directiveContainer')
    return ok(code)
  }

  /** @type {State} */
  function contentStart(code) {
    if (code === null) {
      effects.exit('directiveContainer')
      return ok(code)
    }
    effects.enter('directiveContainerContent')
    return lineStart(code)
  }

  /** @type {State} */
  function lineStart(code) {
    if (code === null) {
      return after(code)
    }
    return effects.attempt(
      {
        tokenize: tokenizeClosingFence,
        partial: true
      },
      after,
      initialSize
        ? factorySpace(effects, chunkStart, 'linePrefix', initialSize + 1)
        : chunkStart
    )(code)
  }

  /** @type {State} */
  function chunkStart(code) {
    if (code === null) {
      return after(code)
    }
    const token = effects.enter('chunkDocument', {
      contentType: 'document',
      previous
    })
    if (previous) previous.next = token
    previous = token
    return contentContinue(code)
  }

  /** @type {State} */
  function contentContinue(code) {
    if (code === null) {
      const t = effects.exit('chunkDocument')
      self.parser.lazy[t.start.line] = false
      return after(code)
    }
    if (markdownLineEnding(code)) {
      return effects.check(nonLazyLine, nonLazyLineAfter, lineAfter)(code)
    }
    effects.consume(code)
    return contentContinue
  }

  /** @type {State} */
  function nonLazyLineAfter(code) {
    effects.consume(code)
    const t = effects.exit('chunkDocument')
    self.parser.lazy[t.start.line] = false
    return lineStart
  }

  /** @type {State} */
  function lineAfter(code) {
    const t = effects.exit('chunkDocument')
    self.parser.lazy[t.start.line] = false
    return after(code)
  }

  /** @type {State} */
  function after(code) {
    effects.exit('directiveContainerContent')
    effects.exit('directiveContainer')
    return ok(code)
  }

  /** @type {Tokenizer} */
  function tokenizeClosingFence(effects, ok, nok) {
    let size = 0
    return factorySpace(effects, closingPrefixAfter, 'linePrefix', 4)

    /** @type {State} */
    function closingPrefixAfter(code) {
      effects.enter('directiveContainerFence')
      effects.enter('directiveContainerSequence')
      return closingSequence(code)
    }

    /** @type {State} */
    function closingSequence(code) {
      if (code === 58) {
        effects.consume(code)
        size++
        return closingSequence
      }
      if (size < sizeOpen) return nok(code)
      effects.exit('directiveContainerSequence')
      return factorySpace(effects, closingSequenceEnd, 'whitespace')(code)
    }

    /** @type {State} */
    function closingSequenceEnd(code) {
      if (code === null || markdownLineEnding(code)) {
        effects.exit('directiveContainerFence')
        return ok(code)
      }
      return nok(code)
    }
  }
}

/** @type {Tokenizer} */
function tokenizeLabel(effects, ok, nok) {
  // Always a `[`
  return factory_label_factoryLabel(
    effects,
    ok,
    nok,
    'directiveContainerLabel',
    'directiveContainerLabelMarker',
    'directiveContainerLabelString',
    true
  )
}

/** @type {Tokenizer} */
function tokenizeAttributes(effects, ok, nok) {
  // Always a `{`
  return factoryAttributes(
    effects,
    ok,
    nok,
    'directiveContainerAttributes',
    'directiveContainerAttributesMarker',
    'directiveContainerAttribute',
    'directiveContainerAttributeId',
    'directiveContainerAttributeClass',
    'directiveContainerAttributeName',
    'directiveContainerAttributeInitializerMarker',
    'directiveContainerAttributeValueLiteral',
    'directiveContainerAttributeValue',
    'directiveContainerAttributeValueMarker',
    'directiveContainerAttributeValueData',
    true
  )
}

/** @type {Tokenizer} */
function tokenizeNonLazyLine(effects, ok, nok) {
  const self = this
  return start

  /** @type {State} */
  function start(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return lineStart
  }

  /** @type {State} */
  function lineStart(code) {
    return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-directive/lib/directive-leaf.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */







/** @type {Construct} */
const directiveLeaf = {
  tokenize: tokenizeDirectiveLeaf
}
const directive_leaf_label = {
  tokenize: directive_leaf_tokenizeLabel,
  partial: true
}
const directive_leaf_attributes = {
  tokenize: directive_leaf_tokenizeAttributes,
  partial: true
}

/** @type {Tokenizer} */
function tokenizeDirectiveLeaf(effects, ok, nok) {
  const self = this
  return start

  /** @type {State} */
  function start(code) {
    effects.enter('directiveLeaf')
    effects.enter('directiveLeafSequence')
    effects.consume(code)
    return inStart
  }

  /** @type {State} */
  function inStart(code) {
    if (code === 58) {
      effects.consume(code)
      effects.exit('directiveLeafSequence')
      return factoryName.call(
        self,
        effects,
        afterName,
        nok,
        'directiveLeafName'
      )
    }
    return nok(code)
  }

  /** @type {State} */
  function afterName(code) {
    return code === 91
      ? effects.attempt(directive_leaf_label, afterLabel, afterLabel)(code)
      : afterLabel(code)
  }

  /** @type {State} */
  function afterLabel(code) {
    return code === 123
      ? effects.attempt(directive_leaf_attributes, afterAttributes, afterAttributes)(code)
      : afterAttributes(code)
  }

  /** @type {State} */
  function afterAttributes(code) {
    return factorySpace(effects, end, 'whitespace')(code)
  }

  /** @type {State} */
  function end(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('directiveLeaf')
      return ok(code)
    }
    return nok(code)
  }
}

/** @type {Tokenizer} */
function directive_leaf_tokenizeLabel(effects, ok, nok) {
  // Always a `[`
  return factory_label_factoryLabel(
    effects,
    ok,
    nok,
    'directiveLeafLabel',
    'directiveLeafLabelMarker',
    'directiveLeafLabelString',
    true
  )
}

/** @type {Tokenizer} */
function directive_leaf_tokenizeAttributes(effects, ok, nok) {
  // Always a `{`
  return factoryAttributes(
    effects,
    ok,
    nok,
    'directiveLeafAttributes',
    'directiveLeafAttributesMarker',
    'directiveLeafAttribute',
    'directiveLeafAttributeId',
    'directiveLeafAttributeClass',
    'directiveLeafAttributeName',
    'directiveLeafAttributeInitializerMarker',
    'directiveLeafAttributeValueLiteral',
    'directiveLeafAttributeValue',
    'directiveLeafAttributeValueMarker',
    'directiveLeafAttributeValueData',
    true
  )
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-directive/lib/directive-text.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 */





/** @type {Construct} */
const directiveText = {
  tokenize: tokenizeDirectiveText,
  previous: directive_text_previous
}
const directive_text_label = {
  tokenize: directive_text_tokenizeLabel,
  partial: true
}
const directive_text_attributes = {
  tokenize: directive_text_tokenizeAttributes,
  partial: true
}

/** @type {Previous} */
function directive_text_previous(code) {
  // If there is a previous code, there will always be a tail.
  return (
    code !== 58 ||
    this.events[this.events.length - 1][1].type === 'characterEscape'
  )
}

/** @type {Tokenizer} */
function tokenizeDirectiveText(effects, ok, nok) {
  const self = this
  return start

  /** @type {State} */
  function start(code) {
    effects.enter('directiveText')
    effects.enter('directiveTextMarker')
    effects.consume(code)
    effects.exit('directiveTextMarker')
    return factoryName.call(self, effects, afterName, nok, 'directiveTextName')
  }

  /** @type {State} */
  function afterName(code) {
    return code === 58
      ? nok(code)
      : code === 91
      ? effects.attempt(directive_text_label, afterLabel, afterLabel)(code)
      : afterLabel(code)
  }

  /** @type {State} */
  function afterLabel(code) {
    return code === 123
      ? effects.attempt(directive_text_attributes, afterAttributes, afterAttributes)(code)
      : afterAttributes(code)
  }

  /** @type {State} */
  function afterAttributes(code) {
    effects.exit('directiveText')
    return ok(code)
  }
}

/** @type {Tokenizer} */
function directive_text_tokenizeLabel(effects, ok, nok) {
  // Always a `[`
  return factory_label_factoryLabel(
    effects,
    ok,
    nok,
    'directiveTextLabel',
    'directiveTextLabelMarker',
    'directiveTextLabelString'
  )
}

/** @type {Tokenizer} */
function directive_text_tokenizeAttributes(effects, ok, nok) {
  // Always a `{`
  return factoryAttributes(
    effects,
    ok,
    nok,
    'directiveTextAttributes',
    'directiveTextAttributesMarker',
    'directiveTextAttribute',
    'directiveTextAttributeId',
    'directiveTextAttributeClass',
    'directiveTextAttributeName',
    'directiveTextAttributeInitializerMarker',
    'directiveTextAttributeValueLiteral',
    'directiveTextAttributeValue',
    'directiveTextAttributeValueMarker',
    'directiveTextAttributeValueData'
  )
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-directive/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */





/**
 * @returns {Extension}
 */
function directive() {
  return {
    text: {
      [58]: directiveText
    },
    flow: {
      [58]: [directiveContainer, directiveLeaf]
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/character-entities-legacy/index.js
/**
 * List of legacy HTML named character references that don’t need a trailing semicolon.
 *
 * @type {Array<string>}
 */
const characterEntitiesLegacy = [
  'AElig',
  'AMP',
  'Aacute',
  'Acirc',
  'Agrave',
  'Aring',
  'Atilde',
  'Auml',
  'COPY',
  'Ccedil',
  'ETH',
  'Eacute',
  'Ecirc',
  'Egrave',
  'Euml',
  'GT',
  'Iacute',
  'Icirc',
  'Igrave',
  'Iuml',
  'LT',
  'Ntilde',
  'Oacute',
  'Ocirc',
  'Ograve',
  'Oslash',
  'Otilde',
  'Ouml',
  'QUOT',
  'REG',
  'THORN',
  'Uacute',
  'Ucirc',
  'Ugrave',
  'Uuml',
  'Yacute',
  'aacute',
  'acirc',
  'acute',
  'aelig',
  'agrave',
  'amp',
  'aring',
  'atilde',
  'auml',
  'brvbar',
  'ccedil',
  'cedil',
  'cent',
  'copy',
  'curren',
  'deg',
  'divide',
  'eacute',
  'ecirc',
  'egrave',
  'eth',
  'euml',
  'frac12',
  'frac14',
  'frac34',
  'gt',
  'iacute',
  'icirc',
  'iexcl',
  'igrave',
  'iquest',
  'iuml',
  'laquo',
  'lt',
  'macr',
  'micro',
  'middot',
  'nbsp',
  'not',
  'ntilde',
  'oacute',
  'ocirc',
  'ograve',
  'ordf',
  'ordm',
  'oslash',
  'otilde',
  'ouml',
  'para',
  'plusmn',
  'pound',
  'quot',
  'raquo',
  'reg',
  'sect',
  'shy',
  'sup1',
  'sup2',
  'sup3',
  'szlig',
  'thorn',
  'times',
  'uacute',
  'ucirc',
  'ugrave',
  'uml',
  'uuml',
  'yacute',
  'yen',
  'yuml'
]

;// CONCATENATED MODULE: ../node_modules/character-reference-invalid/index.js
/**
 * Map of invalid numeric character references to their replacements, according to HTML.
 *
 * @type {Record<number, string>}
 */
const characterReferenceInvalid = {
  0: '�',
  128: '€',
  130: '‚',
  131: 'ƒ',
  132: '„',
  133: '…',
  134: '†',
  135: '‡',
  136: 'ˆ',
  137: '‰',
  138: 'Š',
  139: '‹',
  140: 'Œ',
  142: 'Ž',
  145: '‘',
  146: '’',
  147: '“',
  148: '”',
  149: '•',
  150: '–',
  151: '—',
  152: '˜',
  153: '™',
  154: 'š',
  155: '›',
  156: 'œ',
  158: 'ž',
  159: 'Ÿ'
}

;// CONCATENATED MODULE: ../node_modules/is-decimal/index.js
/**
 * Check if the given character code, or the character code at the first
 * character, is decimal.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is a decimal
 */
function isDecimal(character) {
  const code =
    typeof character === 'string' ? character.charCodeAt(0) : character

  return code >= 48 && code <= 57 /* 0-9 */
}

;// CONCATENATED MODULE: ../node_modules/is-hexadecimal/index.js
/**
 * Check if the given character code, or the character code at the first
 * character, is hexadecimal.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is hexadecimal
 */
function isHexadecimal(character) {
  const code =
    typeof character === 'string' ? character.charCodeAt(0) : character

  return (
    (code >= 97 /* a */ && code <= 102) /* z */ ||
    (code >= 65 /* A */ && code <= 70) /* Z */ ||
    (code >= 48 /* A */ && code <= 57) /* Z */
  )
}

;// CONCATENATED MODULE: ../node_modules/is-alphabetical/index.js
/**
 * Check if the given character code, or the character code at the first
 * character, is alphabetical.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is alphabetical.
 */
function isAlphabetical(character) {
  const code =
    typeof character === 'string' ? character.charCodeAt(0) : character

  return (
    (code >= 97 && code <= 122) /* a-z */ ||
    (code >= 65 && code <= 90) /* A-Z */
  )
}

;// CONCATENATED MODULE: ../node_modules/is-alphanumerical/index.js



/**
 * Check if the given character code, or the character code at the first
 * character, is alphanumerical.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is alphanumerical.
 */
function isAlphanumerical(character) {
  return isAlphabetical(character) || isDecimal(character)
}

;// CONCATENATED MODULE: ../node_modules/parse-entities/lib/index.js
/**
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */








const fromCharCode = String.fromCharCode

// Warning messages.
const messages = [
  '',
  /* 1: Non terminated (named) */
  'Named character references must be terminated by a semicolon',
  /* 2: Non terminated (numeric) */
  'Numeric character references must be terminated by a semicolon',
  /* 3: Empty (named) */
  'Named character references cannot be empty',
  /* 4: Empty (numeric) */
  'Numeric character references cannot be empty',
  /* 5: Unknown (named) */
  'Named character references must be known',
  /* 6: Disallowed (numeric) */
  'Numeric character references cannot be disallowed',
  /* 7: Prohibited (numeric) */
  'Numeric character references cannot be outside the permissible Unicode range'
]

/**
 * Parse HTML character references.
 *
 * @param {string} value
 * @param {import('../index.js').Options} [options={}]
 */
function parseEntities(value, options = {}) {
  const additional =
    typeof options.additional === 'string'
      ? options.additional.charCodeAt(0)
      : options.additional
  /** @type {string[]} */
  const result = []
  let index = 0
  let lines = -1
  let queue = ''
  /** @type {Point|undefined} */
  let point
  /** @type {number[]|undefined} */
  let indent

  if (options.position) {
    if ('start' in options.position || 'indent' in options.position) {
      indent = options.position.indent
      point = options.position.start
    } else {
      point = options.position
    }
  }

  let line = (point ? point.line : 0) || 1
  let column = (point ? point.column : 0) || 1

  // Cache the current point.
  let previous = now()
  /** @type {number|undefined} */
  let character

  // Ensure the algorithm walks over the first character (inclusive).
  index--

  while (++index <= value.length) {
    // If the previous character was a newline.
    if (character === 10 /* `\n` */) {
      column = (indent ? indent[lines] : 0) || 1
    }

    character = value.charCodeAt(index)

    if (character === 38 /* `&` */) {
      const following = value.charCodeAt(index + 1)

      // The behavior depends on the identity of the next character.
      if (
        following === 9 /* `\t` */ ||
        following === 10 /* `\n` */ ||
        following === 12 /* `\f` */ ||
        following === 32 /* ` ` */ ||
        following === 38 /* `&` */ ||
        following === 60 /* `<` */ ||
        Number.isNaN(following) ||
        (additional && following === additional)
      ) {
        // Not a character reference.
        // No characters are consumed, and nothing is returned.
        // This is not an error, either.
        queue += fromCharCode(character)
        column++
        continue
      }

      const start = index + 1
      let begin = start
      let end = start
      /** @type {string} */
      let type

      if (following === 35 /* `#` */) {
        // Numerical reference.
        end = ++begin

        // The behavior further depends on the next character.
        const following = value.charCodeAt(end)

        if (following === 88 /* `X` */ || following === 120 /* `x` */) {
          // ASCII hexadecimal digits.
          type = 'hexadecimal'
          end = ++begin
        } else {
          // ASCII decimal digits.
          type = 'decimal'
        }
      } else {
        // Named reference.
        type = 'named'
      }

      let characterReferenceCharacters = ''
      let characterReference = ''
      let characters = ''
      // Each type of character reference accepts different characters.
      // This test is used to detect whether a reference has ended (as the semicolon
      // is not strictly needed).
      const test =
        type === 'named'
          ? isAlphanumerical
          : type === 'decimal'
          ? isDecimal
          : isHexadecimal

      end--

      while (++end <= value.length) {
        const following = value.charCodeAt(end)

        if (!test(following)) {
          break
        }

        characters += fromCharCode(following)

        // Check if we can match a legacy named reference.
        // If so, we cache that as the last viable named reference.
        // This ensures we do not need to walk backwards later.
        if (type === 'named' && characterEntitiesLegacy.includes(characters)) {
          characterReferenceCharacters = characters
          // @ts-expect-error: always able to decode.
          characterReference = decodeNamedCharacterReference(characters)
        }
      }

      let terminated = value.charCodeAt(end) === 59 /* `;` */

      if (terminated) {
        end++

        const namedReference =
          type === 'named' ? decodeNamedCharacterReference(characters) : false

        if (namedReference) {
          characterReferenceCharacters = characters
          characterReference = namedReference
        }
      }

      let diff = 1 + end - start
      let reference = ''

      if (!terminated && options.nonTerminated === false) {
        // Empty.
      } else if (!characters) {
        // An empty (possible) reference is valid, unless it’s numeric (thus an
        // ampersand followed by an octothorp).
        if (type !== 'named') {
          warning(4 /* Empty (numeric) */, diff)
        }
      } else if (type === 'named') {
        // An ampersand followed by anything unknown, and not terminated, is
        // invalid.
        if (terminated && !characterReference) {
          warning(5 /* Unknown (named) */, 1)
        } else {
          // If there’s something after an named reference which is not known,
          // cap the reference.
          if (characterReferenceCharacters !== characters) {
            end = begin + characterReferenceCharacters.length
            diff = 1 + end - begin
            terminated = false
          }

          // If the reference is not terminated, warn.
          if (!terminated) {
            const reason = characterReferenceCharacters
              ? 1 /* Non terminated (named) */
              : 3 /* Empty (named) */

            if (options.attribute) {
              const following = value.charCodeAt(end)

              if (following === 61 /* `=` */) {
                warning(reason, diff)
                characterReference = ''
              } else if (isAlphanumerical(following)) {
                characterReference = ''
              } else {
                warning(reason, diff)
              }
            } else {
              warning(reason, diff)
            }
          }
        }

        reference = characterReference
      } else {
        if (!terminated) {
          // All nonterminated numeric references are not rendered, and emit a
          // warning.
          warning(2 /* Non terminated (numeric) */, diff)
        }

        // When terminated and numerical, parse as either hexadecimal or
        // decimal.
        let referenceCode = Number.parseInt(
          characters,
          type === 'hexadecimal' ? 16 : 10
        )

        // Emit a warning when the parsed number is prohibited, and replace with
        // replacement character.
        if (prohibited(referenceCode)) {
          warning(7 /* Prohibited (numeric) */, diff)
          reference = fromCharCode(65533 /* `�` */)
        } else if (referenceCode in characterReferenceInvalid) {
          // Emit a warning when the parsed number is disallowed, and replace by
          // an alternative.
          warning(6 /* Disallowed (numeric) */, diff)
          reference = characterReferenceInvalid[referenceCode]
        } else {
          // Parse the number.
          let output = ''

          // Emit a warning when the parsed number should not be used.
          if (disallowed(referenceCode)) {
            warning(6 /* Disallowed (numeric) */, diff)
          }

          // Serialize the number.
          if (referenceCode > 0xffff) {
            referenceCode -= 0x10000
            output += fromCharCode((referenceCode >>> (10 & 0x3ff)) | 0xd800)
            referenceCode = 0xdc00 | (referenceCode & 0x3ff)
          }

          reference = output + fromCharCode(referenceCode)
        }
      }

      // Found it!
      // First eat the queued characters as normal text, then eat a reference.
      if (reference) {
        flush()

        previous = now()
        index = end - 1
        column += end - start + 1
        result.push(reference)
        const next = now()
        next.offset++

        if (options.reference) {
          options.reference.call(
            options.referenceContext,
            reference,
            {start: previous, end: next},
            value.slice(start - 1, end)
          )
        }

        previous = next
      } else {
        // If we could not find a reference, queue the checked characters (as
        // normal characters), and move the pointer to their end.
        // This is possible because we can be certain neither newlines nor
        // ampersands are included.
        characters = value.slice(start - 1, end)
        queue += characters
        column += characters.length
        index = end - 1
      }
    } else {
      // Handle anything other than an ampersand, including newlines and EOF.
      if (character === 10 /* `\n` */) {
        line++
        lines++
        column = 0
      }

      if (Number.isNaN(character)) {
        flush()
      } else {
        queue += fromCharCode(character)
        column++
      }
    }
  }

  // Return the reduced nodes.
  return result.join('')

  // Get current position.
  function now() {
    return {
      line,
      column,
      offset: index + ((point ? point.offset : 0) || 0)
    }
  }

  /**
   * Handle the warning.
   *
   * @param {1|2|3|4|5|6|7} code
   * @param {number} offset
   */
  function warning(code, offset) {
    /** @type {ReturnType<now>} */
    let position

    if (options.warning) {
      position = now()
      position.column += offset
      position.offset += offset

      options.warning.call(
        options.warningContext,
        messages[code],
        position,
        code
      )
    }
  }

  /**
   * Flush `queue` (normal text).
   * Macro invoked before each reference and at the end of `value`.
   * Does nothing when `queue` is empty.
   */
  function flush() {
    if (queue) {
      result.push(queue)

      if (options.text) {
        options.text.call(options.textContext, queue, {
          start: previous,
          end: now()
        })
      }

      queue = ''
    }
  }
}

/**
 * Check if `character` is outside the permissible unicode range.
 *
 * @param {number} code
 * @returns {boolean}
 */
function prohibited(code) {
  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
}

/**
 * Check if `character` is disallowed.
 *
 * @param {number} code
 * @returns {boolean}
 */
function disallowed(code) {
  return (
    (code >= 0x0001 && code <= 0x0008) ||
    code === 0x000b ||
    (code >= 0x000d && code <= 0x001f) ||
    (code >= 0x007f && code <= 0x009f) ||
    (code >= 0xfdd0 && code <= 0xfdef) ||
    (code & 0xffff) === 0xffff ||
    (code & 0xffff) === 0xfffe
  )
}

;// CONCATENATED MODULE: ../node_modules/stringify-entities/lib/core.js
/**
 * @typedef CoreOptions
 * @property {Array<string>} [subset=[]]
 *   Whether to only escape the given subset of characters.
 * @property {boolean} [escapeOnly=false]
 *   Whether to only escape possibly dangerous characters.
 *   Those characters are `"`, `&`, `'`, `<`, `>`, and `` ` ``.
 *
 * @typedef FormatOptions
 * @property {(code: number, next: number, options: CoreWithFormatOptions) => string} format
 *   Format strategy.
 *
 * @typedef {CoreOptions & FormatOptions & import('./util/format-smart.js').FormatSmartOptions} CoreWithFormatOptions
 */

/**
 * Encode certain characters in `value`.
 *
 * @param {string} value
 * @param {CoreWithFormatOptions} options
 * @returns {string}
 */
function lib_core_core(value, options) {
  value = value.replace(
    options.subset ? charactersToExpression(options.subset) : /["&'<>`]/g,
    basic
  )

  if (options.subset || options.escapeOnly) {
    return value
  }

  return (
    value
      // Surrogate pairs.
      .replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, surrogate)
      // BMP control characters (C0 except for LF, CR, SP; DEL; and some more
      // non-ASCII ones).
      .replace(
        // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
        /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g,
        basic
      )
  )

  /**
   * @param {string} pair
   * @param {number} index
   * @param {string} all
   */
  function surrogate(pair, index, all) {
    return options.format(
      (pair.charCodeAt(0) - 0xd800) * 0x400 +
        pair.charCodeAt(1) -
        0xdc00 +
        0x10000,
      all.charCodeAt(index + 2),
      options
    )
  }

  /**
   * @param {string} character
   * @param {number} index
   * @param {string} all
   */
  function basic(character, index, all) {
    return options.format(
      character.charCodeAt(0),
      all.charCodeAt(index + 1),
      options
    )
  }
}

/**
 * @param {Array<string>} subset
 * @returns {RegExp}
 */
function charactersToExpression(subset) {
  /** @type {Array<string>} */
  const groups = []
  let index = -1

  while (++index < subset.length) {
    groups.push(subset[index].replace(/[|\\{}()[\]^$+*?.]/g, '\\$&'))
  }

  return new RegExp('(?:' + groups.join('|') + ')', 'g')
}

;// CONCATENATED MODULE: ../node_modules/stringify-entities/lib/util/format-basic.js
/**
 * The smallest way to encode a character.
 *
 * @param {number} code
 * @returns {string}
 */
function formatBasic(code) {
  return '&#x' + code.toString(16).toUpperCase() + ';'
}

;// CONCATENATED MODULE: ../node_modules/stringify-entities/lib/index.js
/**
 * @typedef {import('./core.js').CoreOptions & import('./util/format-smart.js').FormatSmartOptions} Options
 * @typedef {import('./core.js').CoreOptions} LightOptions
 */





/**
 * Encode special characters in `value`.
 *
 * @param {string} value
 *   Value to encode.
 * @param {Options} [options]
 *   Configuration.
 * @returns {string}
 *   Encoded value.
 */
function stringifyEntities(value, options) {
  return core(value, Object.assign({format: formatSmart}, options))
}

/**
 * Encode special characters in `value` as hexadecimals.
 *
 * @param {string} value
 *   Value to encode.
 * @param {LightOptions} [options]
 *   Configuration.
 * @returns {string}
 *   Encoded value.
 */
function stringifyEntitiesLight(value, options) {
  return lib_core_core(value, Object.assign({format: formatBasic}, options))
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/check-quote.js
/**
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').Options} Options
 */

/**
 * @param {Context} context
 * @returns {Exclude<Options['quote'], undefined>}
 */
function checkQuote(context) {
  const marker = context.options.quote || '"'

  if (marker !== '"' && marker !== "'") {
    throw new Error(
      'Cannot serialize title with `' +
        marker +
        '` for `options.quote`, expected `"`, or `\'`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-directive/index.js
/**
 * @typedef {import('mdast').BlockContent} BlockContent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Token} Token
 * @typedef {import('mdast-util-to-markdown/lib/types.js').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown/lib/types.js').Context} Context
 * @typedef {import('mdast-util-to-markdown/lib/types.js').Options} ToMarkdownExtension
 * @typedef {import('./complex-types').ContainerDirective} ContainerDirective
 * @typedef {import('./complex-types').LeafDirective} LeafDirective
 * @typedef {import('./complex-types').TextDirective} TextDirective
 * @typedef {ContainerDirective|LeafDirective|TextDirective} Directive
 */









const mdast_util_directive_own = {}.hasOwnProperty

const shortcut = /^[^\t\n\r "#'.<=>`}]+$/

handleDirective.peek = peekDirective

/** @type {FromMarkdownExtension} */
const directiveFromMarkdown = {
  canContainEols: ['textDirective'],
  enter: {
    directiveContainer: enterContainer,
    directiveContainerAttributes: enterAttributes,
    directiveContainerLabel: enterContainerLabel,

    directiveLeaf: enterLeaf,
    directiveLeafAttributes: enterAttributes,

    directiveText: enterText,
    directiveTextAttributes: enterAttributes
  },
  exit: {
    directiveContainer: mdast_util_directive_exit,
    directiveContainerAttributeClassValue: exitAttributeClassValue,
    directiveContainerAttributeIdValue: exitAttributeIdValue,
    directiveContainerAttributeName: exitAttributeName,
    directiveContainerAttributeValue: exitAttributeValue,
    directiveContainerAttributes: exitAttributes,
    directiveContainerLabel: exitContainerLabel,
    directiveContainerName: exitName,

    directiveLeaf: mdast_util_directive_exit,
    directiveLeafAttributeClassValue: exitAttributeClassValue,
    directiveLeafAttributeIdValue: exitAttributeIdValue,
    directiveLeafAttributeName: exitAttributeName,
    directiveLeafAttributeValue: exitAttributeValue,
    directiveLeafAttributes: exitAttributes,
    directiveLeafName: exitName,

    directiveText: mdast_util_directive_exit,
    directiveTextAttributeClassValue: exitAttributeClassValue,
    directiveTextAttributeIdValue: exitAttributeIdValue,
    directiveTextAttributeName: exitAttributeName,
    directiveTextAttributeValue: exitAttributeValue,
    directiveTextAttributes: exitAttributes,
    directiveTextName: exitName
  }
}

/** @type {ToMarkdownExtension} */
const directiveToMarkdown = {
  unsafe: [
    {
      character: '\r',
      inConstruct: ['leafDirectiveLabel', 'containerDirectiveLabel']
    },
    {
      character: '\n',
      inConstruct: ['leafDirectiveLabel', 'containerDirectiveLabel']
    },
    {
      before: '[^:]',
      character: ':',
      after: '[A-Za-z]',
      inConstruct: ['phrasing']
    },
    {atBreak: true, character: ':', after: ':'}
  ],
  handlers: {
    containerDirective: handleDirective,
    leafDirective: handleDirective,
    textDirective: handleDirective
  }
}

/** @type {FromMarkdownHandle} */
function enterContainer(token) {
  enter.call(this, 'containerDirective', token)
}

/** @type {FromMarkdownHandle} */
function enterLeaf(token) {
  enter.call(this, 'leafDirective', token)
}

/** @type {FromMarkdownHandle} */
function enterText(token) {
  enter.call(this, 'textDirective', token)
}

/**
 * @this {CompileContext}
 * @param {Directive['type']} type
 * @param {Token} token
 */
function enter(type, token) {
  this.enter({type, name: '', attributes: {}, children: []}, token)
}

/**
 * @this {CompileContext}
 * @param {Token} token
 */
function exitName(token) {
  const node = /** @type {Directive} */ (this.stack[this.stack.length - 1])
  node.name = this.sliceSerialize(token)
}

/** @type {FromMarkdownHandle} */
function enterContainerLabel(token) {
  this.enter(
    {type: 'paragraph', data: {directiveLabel: true}, children: []},
    token
  )
}

/** @type {FromMarkdownHandle} */
function exitContainerLabel(token) {
  this.exit(token)
}

/** @type {FromMarkdownHandle} */
function enterAttributes() {
  this.setData('directiveAttributes', [])
  this.buffer() // Capture EOLs
}

/** @type {FromMarkdownHandle} */
function exitAttributeIdValue(token) {
  const list = /** @type {Array.<[string, string]>} */ (
    this.getData('directiveAttributes')
  )
  list.push([
    'id',
    parseEntities(this.sliceSerialize(token), {
      attribute: true
    })
  ])
}

/** @type {FromMarkdownHandle} */
function exitAttributeClassValue(token) {
  const list = /** @type {Array.<[string, string]>} */ (
    this.getData('directiveAttributes')
  )
  list.push([
    'class',
    parseEntities(this.sliceSerialize(token), {
      attribute: true
    })
  ])
}

/** @type {FromMarkdownHandle} */
function exitAttributeValue(token) {
  const list = /** @type {Array.<[string, string]>} */ (
    this.getData('directiveAttributes')
  )
  list[list.length - 1][1] = parseEntities(this.sliceSerialize(token), {
    attribute: true
  })
}

/** @type {FromMarkdownHandle} */
function exitAttributeName(token) {
  const list = /** @type {Array.<[string, string]>} */ (
    this.getData('directiveAttributes')
  )

  // Attribute names in CommonMark are significantly limited, so character
  // references can’t exist.
  list.push([this.sliceSerialize(token), ''])
}

/** @type {FromMarkdownHandle} */
function exitAttributes() {
  const list = /** @type {Array.<[string, string]>} */ (
    this.getData('directiveAttributes')
  )
  /** @type {Record.<string, string>} */
  const cleaned = {}
  let index = -1

  while (++index < list.length) {
    const attribute = list[index]

    if (attribute[0] === 'class' && cleaned.class) {
      cleaned.class += ' ' + attribute[1]
    } else {
      cleaned[attribute[0]] = attribute[1]
    }
  }

  this.setData('directiveAttributes')
  this.resume() // Drop EOLs
  const node = /** @type {Directive} */ (this.stack[this.stack.length - 1])
  node.attributes = cleaned
}

/** @type {FromMarkdownHandle} */
function mdast_util_directive_exit(token) {
  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {Directive} node
 */
function handleDirective(node, _, context, safeOptions) {
  const tracker = track(safeOptions)
  const sequence = fence(node)
  const exit = context.enter(node.type)
  let value = tracker.move(sequence + (node.name || ''))
  /** @type {Directive|Paragraph|undefined} */
  let label = node

  if (node.type === 'containerDirective') {
    const head = (node.children || [])[0]
    label = inlineDirectiveLabel(head) ? head : undefined
  }

  if (label && label.children && label.children.length > 0) {
    const exit = context.enter('label')
    const subexit = context.enter(node.type + 'Label')
    value += tracker.move('[')
    value += tracker.move(
      containerPhrasing(label, context, {
        ...tracker.current(),
        before: value,
        after: ']'
      })
    )
    value += tracker.move(']')
    subexit()
    exit()
  }

  value += tracker.move(mdast_util_directive_attributes(node, context))

  if (node.type === 'containerDirective') {
    const head = (node.children || [])[0]
    let shallow = node

    if (inlineDirectiveLabel(head)) {
      shallow = Object.assign({}, node, {children: node.children.slice(1)})
    }

    if (shallow && shallow.children && shallow.children.length > 0) {
      value += tracker.move('\n')
      value += tracker.move(containerFlow(shallow, context, tracker.current()))
    }

    value += tracker.move('\n' + sequence)
  }

  exit()
  return value
}

/** @type {ToMarkdownHandle} */
function peekDirective() {
  return ':'
}

/**
 * @param {Directive} node
 * @param {Context} context
 * @returns {string}
 */
function mdast_util_directive_attributes(node, context) {
  const quote = checkQuote(context)
  const subset = node.type === 'textDirective' ? [quote] : [quote, '\n', '\r']
  const attrs = node.attributes || {}
  /** @type {Array.<string>} */
  const values = []
  /** @type {string|undefined} */
  let classesFull
  /** @type {string|undefined} */
  let classes
  /** @type {string|undefined} */
  let id
  /** @type {string} */
  let key

  for (key in attrs) {
    if (
      mdast_util_directive_own.call(attrs, key) &&
      attrs[key] !== undefined &&
      attrs[key] !== null
    ) {
      const value = String(attrs[key])

      if (key === 'id') {
        id = shortcut.test(value) ? '#' + value : quoted('id', value)
      } else if (key === 'class') {
        const list = value.split(/[\t\n\r ]+/g)
        /** @type {Array.<string>} */
        const classesFullList = []
        /** @type {Array.<string>} */
        const classesList = []
        let index = -1

        while (++index < list.length) {
          ;(shortcut.test(list[index]) ? classesList : classesFullList).push(
            list[index]
          )
        }

        classesFull =
          classesFullList.length > 0
            ? quoted('class', classesFullList.join(' '))
            : ''
        classes = classesList.length > 0 ? '.' + classesList.join('.') : ''
      } else {
        values.push(quoted(key, value))
      }
    }
  }

  if (classesFull) {
    values.unshift(classesFull)
  }

  if (classes) {
    values.unshift(classes)
  }

  if (id) {
    values.unshift(id)
  }

  return values.length > 0 ? '{' + values.join(' ') + '}' : ''

  /**
   * @param {string} key
   * @param {string} value
   * @returns {string}
   */
  function quoted(key, value) {
    return (
      key +
      (value
        ? '=' + quote + stringifyEntitiesLight(value, {subset}) + quote
        : '')
    )
  }
}

/**
 * @param {BlockContent} node
 * @returns {node is Paragraph & {data: {directiveLabel: boolean}}}
 */
function inlineDirectiveLabel(node) {
  return Boolean(
    node && node.type === 'paragraph' && node.data && node.data.directiveLabel
  )
}

/**
 * @param {Directive} node
 * @returns {string}
 */
function fence(node) {
  let size = 0

  if (node.type === 'containerDirective') {
    visitParents(node, 'containerDirective', onvisit)
    size += 3
  } else if (node.type === 'leafDirective') {
    size = 2
  } else {
    size = 1
  }

  return ':'.repeat(size)

  /** @type {import('unist-util-visit-parents/complex-types').BuildVisitor<Root, Directive>} */
  function onvisit(_, parents) {
    let index = parents.length
    let nesting = 0

    while (index--) {
      if (parents[index].type === 'containerDirective') {
        nesting++
      }
    }

    if (nesting > size) size = nesting
  }
}

;// CONCATENATED MODULE: ../node_modules/remark-directive/index.js
/**
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('mdast-util-directive')} DoNotTouchAsThisImportIncludesDirectivesInTree
 */




/**
 * Plugin to support the generic directives proposal (`:cite[smith04]`,
 * `::youtube[Video of a cat in a box]{v=01ab2cd3efg}`, and such).
 *
 * @type {import('unified').Plugin<void[], Root>}
 */
function remarkDirective() {
  const data = this.data()

  add('micromarkExtensions', directive())
  add('fromMarkdownExtensions', directiveFromMarkdown)
  add('toMarkdownExtensions', directiveToMarkdown)

  /**
   * @param {string} field
   * @param {unknown} value
   */
  function add(field, value) {
    const list = /** @type {unknown[]} */ (
      // Other extensions
      /* c8 ignore next 2 */
      data[field] ? data[field] : (data[field] = [])
    )

    list.push(value)
  }
}

// EXTERNAL MODULE: ../node_modules/rehype-wrap/index.js
var rehype_wrap = __webpack_require__(65105);
var rehype_wrap_default = /*#__PURE__*/__webpack_require__.n(rehype_wrap);
// EXTERNAL MODULE: ./src/sections/Markdown/Markdown.module.css
var Markdown_module = __webpack_require__(62132);
var Markdown_module_default = /*#__PURE__*/__webpack_require__.n(Markdown_module);
;// CONCATENATED MODULE: ./src/sections/Markdown/Markdown.jsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









var components = {
    iframe: function(_param) {
        var node = _param.node, props = _objectWithoutProperties(_param, [
            "node"
        ]);
        return props.src.includes("youtube.com") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "responsive-video pb-youtube",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", _objectSpread({}, props))
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", _objectSpread({}, props));
    }
};
// remark plugin to add a custom tag to the AST
function htmlDirectives() {
    var ondirective = function ondirective(node) {
        var data = node.data || (node.data = {});
        var hast = h(node.name, node.attributes);
        var attributes = node.attributes || {};
        if (node.name !== "youtube" && node.type !== "textDirective") {
            data.hName = hast.tagname;
            data.hProperties = hast.properties;
        } else {
            var id = attributes.id;
            data.hName = "iframe";
            data.hProperties = {
                src: "https://www.youtube.com/embed/".concat(id),
                width: "100%",
                height: 200,
                frameBorder: 0,
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: true
            };
        }
    };
    var transform = function transform(tree) {
        visit(tree, [
            "textDirective",
            "leafDirective",
            "containerDirective"
        ], ondirective);
    };
    return transform;
}
function Markdown(param) {
    var cms = param.cms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(Markdown.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": Markdown.displayName,
        className: (Markdown_module_default()).markdownContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(Markdown.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(Markdown.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactMarkdown, {
                remarkPlugins: [
                    remarkDirective,
                    remarkGfm,
                    htmlDirectives
                ],
                rehypePlugins: [
                    rehypeRaw,
                    [
                        (rehype_wrap_default()),
                        {
                            wrapper: "div.table-wrapper",
                            selector: "table"
                        }
                    ], 
                ],
                components: components,
                children: cms === null || cms === void 0 ? void 0 : cms.content
            })
        ]
    });
}
Markdown.displayName = "Markdown";
Markdown.Schema = {
    category: "Page",
    label: Markdown.displayName,
    key: "markdown",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "content",
            label: "Content",
            component: "markdown",
            description: "This is a markdown field"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/Markdown/index.js


// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/snippets/globals/inputs/BasicInput.jsx


function BasicInput(param) {
    var name = param.name, label = param.label, _type = param.type, type = _type === void 0 ? "text" : _type, _required = param.required, required = _required === void 0 ? "false" : _required, _message = param.message, message = _message === void 0 ? "" : _message, hideLabel = param.hideLabel, placeholder = param.placeholder, noBorder = param.noBorder, _onChangeEvent = param.onChangeEvent, onChangeEvent = _onChangeEvent === void 0 ? function() {} : _onChangeEvent;
    var ref = (0,react.useState)(false), isInvalid = ref[0], setIsInvalid = ref[1];
    var inputStateClasses = isInvalid ? "border-error-state outline outline-1 outline-error-state text-error-state" : "focus:outline-ada-outline focus:rounded-none border-black placeholder-shown:text-black text-black hover:text-black focus:text-black";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "form-container flex flex-col",
        children: [
            !hideLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "sub-small mb-2 font-hafferBold",
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                name: name,
                id: name,
                type: type,
                placeholder: placeholder,
                required: required === "true",
                className: "".concat(inputStateClasses, " ").concat(noBorder === "true" ? "border-0" : "border", " w-full cursor-pointer py-3 px-4 placeholder-grey-7 transition-all placeholder-shown:border-grey-7 hover:border-black hover:placeholder-black focus:placeholder-black"),
                onInvalid: function() {
                    return setIsInvalid(true);
                },
                onChange: function() {
                    onChangeEvent(event);
                    setIsInvalid(false);
                },
                "aria-label": label
            }),
            isInvalid && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-xsmall mt-2 w-full text-error-state",
                children: message
            })
        ]
    });
}
/* harmony default export */ var inputs_BasicInput = (BasicInput);

;// CONCATENATED MODULE: ./src/snippets/globals/inputs/SelectElement.jsx

function SelectElement(param) {
    var options = param.options, name = param.name, label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "select-wrap relative flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "sub-small mb-2 font-hafferBold",
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                className: "w-full cursor-pointer border border-grey-5 py-3 px-4 text-black placeholder-black transition-all placeholder-shown:border-grey-5 hover:border-black hover:placeholder-black focus:placeholder-black focus:outline-ada-outline",
                name: name,
                id: name,
                children: options.map(function(option, optionIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: option.value,
                        children: option.label
                    }, "option-".concat(name, "-").concat(optionIndex));
                })
            })
        ]
    });
}
/* harmony default export */ var inputs_SelectElement = (SelectElement);

// EXTERNAL MODULE: ./src/snippets/globals/inputs/Checkbox.jsx
var Checkbox = __webpack_require__(34115);
;// CONCATENATED MODULE: ./src/snippets/globals/inputs/RadioButton.jsx

function RadioButton(param) {
    var label = param.label, name = param.name, value = param.value, id = param.id, _disabled = param.disabled, disabled = _disabled === void 0 ? "false" : _disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "my-3 flex items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "radio",
                value: value,
                name: name,
                id: id,
                disabled: disabled === "true"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "ml-4 pl-0.5 text-black",
                htmlFor: id,
                children: label
            })
        ]
    });
}
/* harmony default export */ var inputs_RadioButton = (RadioButton);

;// CONCATENATED MODULE: ./src/sections/Styleguide/Styleguide.jsx






function Styleguide(param) {
    var cms = param.cms;
    var selectOptions = [
        {
            label: "option one",
            value: "option-one"
        },
        {
            label: "option two",
            value: "option-two"
        },
        {
            label: "option three",
            value: "option-three"
        },
        {
            label: "option four",
            value: "option-four"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ccontain mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8 grid lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white px-5 py-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "h1 mb-11",
                                children: "Heading One (H1)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "h2 mb-11",
                                children: "Heading Two"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "h3 mb-11",
                                children: "Heading Three"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "h4 mb-11",
                                children: "Heading Four"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "h5 mb-11",
                                children: "Heading Five"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "h6 mb-11",
                                children: "Heading Six"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid gap-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-large",
                                        children: "Subtitle Large"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-regular",
                                        children: "Subtitle Regular"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-small",
                                        children: "Subtitle Small"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-xsmall",
                                        children: "Subtitle XSmall"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-xxsmall",
                                        children: "Subtitle XXSmall"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-black px-5 py-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "mb-11 text-white",
                                children: "Heading One"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "mb-11 text-white",
                                children: "Heading Two"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mb-11 text-white",
                                children: "Heading Three"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "mb-11 text-white",
                                children: "Heading Four"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "mb-11 text-white",
                                children: "Heading Five"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "mb-11 text-white",
                                children: "Heading Six"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid gap-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-large text-white",
                                        children: "Subtitle Large"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-regular text-white",
                                        children: "Subtitle Regular"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-small text-white",
                                        children: "Subtitle Small"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-xsmall text-white",
                                        children: "Subtitle XSmall"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-xxsmall text-white",
                                        children: "Subtitle XXSmall"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-large mb-4",
                        children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-regular mb-4",
                        children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-small mb-4",
                        children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xsmall mb-4",
                        children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-3 gap-x-4 gap-y-10 lg:grid-cols-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-gray-black"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Gray Black"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-black"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Black"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-primary-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Primary"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-primary-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Secondary - Pink"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-secondary-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Secondary - Pink 2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-secondary-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Secondary - Orange"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-tertiary-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Secondary - Purple"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-tertiary-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Secondary - Cream"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-quaternary-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Secondary - Green"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-quaternary-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Secondary - Seafoam"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-quinary-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Secondary - Blue"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-quinary-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Secondary - Blue 2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-quinary-2-alt"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Secondary - Blue 2 Alternative"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-senary-3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Mint"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-senary-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Brown"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-stylers-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Air Dry Cream"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-stylers-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Sculpting Cream"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-stylers-3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Texture Foam"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-stylers-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Sleek Stick"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-scalp-blue"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Scalp Blue"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-magenta"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Magenta"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-med-pink"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Medium Pink"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-brio-blue"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Briogeo Blue"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-cloud"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Cloud"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-mineral"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Mineral"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-deep-sea"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Deep Sea"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-sandstone"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Sandstone"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-sorrel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Sorrel"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-butter"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Butter"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-rosehip"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Rosehip"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-chestnut"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Chestnut"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-grey-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Grey 1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-grey-3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Grey 3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-grey-5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Grey 5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-grey-7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Grey 7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-grey-9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Grey 9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-error"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Error"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-24 bg-success"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Success"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-2",
                        children: "Primary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "button button--primary",
                        children: "Primary button"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-16 flex flex-col gap-4 md:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0",
                                children: "Secondary button - Outlined"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative h-[78px] w-[237px] bg-grey-4 pt-[11px] pl-[17px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "button button--secondary absolute",
                                    children: "Outline Button"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0",
                                children: "Tertiary button - Outlined"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative h-[78px] w-[237px] bg-black pt-[11px] pl-[17px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "button button--tertiary absolute",
                                    children: "Outline Button"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-16 block flex flex-col gap-4 md:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "button button--checkout",
                        children: "checkout"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "button button--primary",
                        disabled: true,
                        children: "disabled"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "my-16 flex grid gap-x-4 gap-y-6 lg:grid-cols-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_BasicInput, {
                        name: "firstname",
                        label: "First Name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_BasicInput, {
                        name: "email",
                        label: "Email",
                        type: "email",
                        required: "true",
                        message: "Please enter a valid email address"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-start-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_SelectElement, {
                            label: "Select Option",
                            name: "select-option",
                            options: selectOptions
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-start-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                label: "Checkbox 1",
                                name: "checkbox-1",
                                value: "checkbox 1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                label: "Checkbox 2",
                                name: "checkbox-2",
                                value: "checkbox 2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                label: "Checkbox 3",
                                name: "checkbox-3",
                                value: "checkbox 3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                label: "Checkbox 4",
                                name: "checkbox-4",
                                value: "checkbox 4"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_RadioButton, {
                                label: "Radio Button 1",
                                name: "radioes",
                                value: "bill",
                                id: "bill"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_RadioButton, {
                                label: "Radio Button 2",
                                name: "radioes",
                                value: "timmy",
                                id: "timmy"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_RadioButton, {
                                label: "Radio Button 3",
                                name: "radioes",
                                value: "fred",
                                id: "fred"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "This is an",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "inline link"
                                        })
                                    }),
                                    " ",
                                    "example"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "focus-link",
                                        children: "Focus Link"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "focus-link-rosehip",
                                        children: "Focus Link (Rosehip)"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative mt-2 h-[178px] w-[237px] bg-black pt-[11px] pl-[17px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-white",
                                            children: [
                                                "This is an",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "text-white",
                                                        children: "inline link"
                                                    })
                                                }),
                                                " ",
                                                "example"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "pt-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "focus-link-white",
                                                    children: "Focus Link"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-start-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "button button--primary",
                            children: "Submit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 grid lg:grid-cols-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "table-wrapper scrollbar col-span-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: "Order Value"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: "Standard Ground"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: "3-day"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$0 - $25"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$4.99"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$6.99"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$0 - $25"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$4.99"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$6.99"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$0 - $25"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$4.99"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$6.99"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$0 - $25"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$4.99"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$6.99"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$0 - $25"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$4.99"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$6.99"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$10 - $125"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$14.99"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "$16.99"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
Styleguide.displayName = "Styleguide";
Styleguide.Schema = {
    category: "Styleguide",
    label: Styleguide.displayName,
    key: "styleguide",
    fields: []
};

;// CONCATENATED MODULE: ./src/sections/Styleguide/index.js


// EXTERNAL MODULE: ./src/snippets/components/Image/index.js + 2 modules
var Image = __webpack_require__(69342);
;// CONCATENATED MODULE: ./src/sections/Banner/Banner.jsx


function Section(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-comp": Section.displayName,
        id: "".concat(Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            (cms === null || cms === void 0 ? void 0 : (ref = cms.background_d) === null || ref === void 0 ? void 0 : ref.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full ".concat((cms === null || cms === void 0 ? void 0 : (ref1 = cms.background_m) === null || ref1 === void 0 ? void 0 : ref1.src) ? "hidden lg:block" : ""),
                style: {
                    aspectRatio: cms === null || cms === void 0 ? void 0 : cms.aspect_ratio_d
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    src: cms === null || cms === void 0 ? void 0 : (ref2 = cms.background_d) === null || ref2 === void 0 ? void 0 : ref2.src,
                    alt: (cms === null || cms === void 0 ? void 0 : cms.background_image_alt) || "",
                    width: "3000",
                    height: "1685",
                    fill: true,
                    loading: "lazy",
                    sizes: "100vw"
                })
            }) : "",
            (cms === null || cms === void 0 ? void 0 : (ref3 = cms.background_m) === null || ref3 === void 0 ? void 0 : ref3.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full lg:hidden",
                style: {
                    aspectRatio: cms === null || cms === void 0 ? void 0 : cms.aspect_ratio_m
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    src: cms === null || cms === void 0 ? void 0 : (ref4 = cms.background_m) === null || ref4 === void 0 ? void 0 : ref4.src,
                    alt: (cms === null || cms === void 0 ? void 0 : cms.background_image_alt) || "",
                    width: "3000",
                    height: "1685",
                    fill: true,
                    loading: "lazy",
                    sizes: "100vw"
                })
            }) : ""
        ]
    });
}
Section.displayName = "Banner";
Section.Schema = {
    category: "Modules",
    label: Section.displayName,
    key: "banner",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "background_d",
            label: "Background Image (Desktop)",
            component: "image",
            description: "Recommended Image Size: 3000px wide"
        },
        {
            name: "aspect_ratio_d",
            label: "Desktop Background Aspect Ratio",
            description: 'Width divided by height, e.g. 16:9 image is "1.78"',
            component: "number"
        },
        {
            name: "background_m",
            label: "Background Image (Mobile)",
            component: "image",
            description: "Recommended Image Size: 2000px wide"
        },
        {
            name: "aspect_ratio_m",
            label: "Mobile Background Aspect Ratio",
            description: 'Width divided by height, e.g. 16:9 image is "1.78"',
            component: "number"
        },
        {
            name: "background_image_alt",
            label: "Background Image Alt text",
            component: "text"
        }, 
    ]
};
var Banner = Section;

;// CONCATENATED MODULE: ./src/sections/Banner/index.js


// EXTERNAL MODULE: ./src/utilities/Helper.js
var Helper = __webpack_require__(41717);
;// CONCATENATED MODULE: ./src/settings/FontSelector.js
var FontSelector = [
    {
        label: "Haffer Regular",
        value: "font-haffer"
    },
    {
        label: "Haffer Italic",
        value: "font-hafferItalic"
    },
    {
        label: "Haffer Bold",
        value: "font-hafferBold"
    },
    {
        label: "Haffer Bold Italic",
        value: "font-hafferBoldItalic"
    },
    {
        label: "Tiempos",
        value: "font-tiempos"
    },
    {
        label: "Tiempos Italic",
        value: "font-tiempos italic"
    }, 
];
var desktopFontSelector = [
    {
        label: "Haffer Regular",
        value: "sm:font-haffer"
    },
    {
        label: "Haffer Italic",
        value: "sm:font-hafferItalic"
    },
    {
        label: "Haffer Bold",
        value: "sm:font-hafferBold"
    },
    {
        label: "Haffer Bold Italic",
        value: "sm:font-hafferBoldItalic"
    },
    {
        label: "Tiempos",
        value: "sm:font-tiempos"
    },
    {
        label: "Tiempos Italic",
        value: "sm:font-tiempos sm:italic"
    }, 
];
var mobileFontSelector = [
    {
        label: "Haffer Regular",
        value: "max-sm:font-haffer"
    },
    {
        label: "Haffer Italic",
        value: "max-sm:font-hafferItalic"
    },
    {
        label: "Haffer Bold",
        value: "max-sm:font-hafferBold"
    },
    {
        label: "Haffer Bold Italic",
        value: "max-sm:font-hafferBoldItalic"
    },
    {
        label: "Tiempos",
        value: "max-sm:font-tiempos"
    },
    {
        label: "Tiempos Italic",
        value: "max-sm:font-tiempos max-sm:italic"
    }, 
];

;// CONCATENATED MODULE: ./src/sections/Ingredients/Ingredients.jsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





function Ingredients_Section(param) {
    var cms = param.cms;
    var ref3, ref1;
    var slider = (0,react.useRef)();
    var ingredientsBox = (0,react.useRef)();
    var ref2 = (0,react.useState)(false), ingredientsOpen = ref2[0], setIngredientsOpen = ref2[1];
    var scrollToSlide = function(index) {
        if (!slider.current) {
            return;
        }
        var slides = slider.current.querySelectorAll("[data-slide]");
        // Card center
        var cardCenter = slides[index].getBoundingClientRect().left + slider.current.scrollLeft + slides[index].offsetWidth / 2;
        // Slider Center
        var sliderCenter = slider.current.offsetWidth / 2;
        slider.current.scrollTo({
            left: cardCenter - sliderCenter,
            behavior: "smooth"
        });
    };
    var buildDots = function() {
        var ref;
        var dots = cms === null || cms === void 0 ? void 0 : (ref = cms.ingredients) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "dot m-0 list-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "h-3 w-3 cursor-pointer rounded-full border-2 border-black bg-black",
                    onClick: function() {
                        return scrollToSlide(index);
                    },
                    "data-dot": true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "sr-only",
                        children: [
                            "Go to slide $",
                            index
                        ]
                    })
                })
            }, "ingredient-".concat(cms.id || cms.cmsId || cms.tinaId, "-dot-").concat(index));
        });
        return dots;
    };
    var updateActiveDot = function(entries) {
        if (!slider.current) {
            return;
        }
        var slides = slider.current.querySelectorAll("[data-slide]");
        var dots = slider.current.parentElement.querySelectorAll("[data-dot]");
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var index = _toConsumableArray(slides).indexOf(entry.target);
                dots.forEach(function(dot) {
                    dot.classList.add("bg-black");
                });
                dots[index].classList.remove("bg-black");
            }
        });
    };
    var toggleIngredients = function(evt) {
        setIngredientsOpen(function(isOpen) {
            return !isOpen;
        });
    };
    var setIngredientsBoxSize = function() {
        if (ingredientsBox.current) {
            ingredientsBox.current.style.height = "".concat(ingredientsBox.current.querySelector("p").offsetHeight, "px");
        }
    };
    (0,react.useEffect)(function() {
        if (!slider.current) {
            return undefined;
        }
        var observer = new IntersectionObserver(updateActiveDot, {
            root: slider.current,
            rootMargin: "0px",
            threshold: 0.7
        });
        var slides = slider.current.querySelectorAll("[data-slide]");
        slides.forEach(function(slide) {
            observer.observe(slide);
        }, []);
        window.addEventListener("resize", setIngredientsBoxSize);
        return function() {
            window.removeEventListener("resize", setIngredientsBoxSize);
            slides.forEach(function(slide) {
                observer.unobserve(slide);
            });
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "".concat(Ingredients_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        className: "ingredients",
        "data-comp": Ingredients_Section.displayName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(Ingredients_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(Ingredients_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ingredients-header text-center",
                children: [
                    (cms === null || cms === void 0 ? void 0 : cms.section_optional_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2 px-5 text-base text-black ".concat((cms === null || cms === void 0 ? void 0 : cms.sectionOptionalTitleFont) || "font-hafferBold"),
                        children: cms === null || cms === void 0 ? void 0 : cms.section_optional_title
                    }),
                    (cms === null || cms === void 0 ? void 0 : cms.section_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-header mb-3 px-5 lg:mb-4 ".concat((cms === null || cms === void 0 ? void 0 : cms.sectionTitleFont) || "font-haffer"),
                        children: cms === null || cms === void 0 ? void 0 : cms.section_title
                    }),
                    (cms === null || cms === void 0 ? void 0 : cms.section_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mx-auto px-5 font-primary text-base font-light lg:max-w-[430px] lg:text-lg ".concat((cms === null || cms === void 0 ? void 0 : cms.sectionDescriptionFont) || ""),
                        dangerouslySetInnerHTML: {
                            __html: (0,Helper/* newLineToBr */.td)(cms === null || cms === void 0 ? void 0 : cms.section_description)
                        }
                    }),
                    (cms === null || cms === void 0 ? void 0 : (ref3 = cms.ingredients) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ingredients-list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "mx-auto mt-6 mb-0 flex w-full flex-nowrap gap-x-4 overflow-x-auto px-5 lg:container lg:mt-12 lg:grid lg:grid-cols-2 lg:gap-y-8 lg:gap-x-6 lg:px-5",
                                ref: slider,
                                children: cms === null || cms === void 0 ? void 0 : (ref1 = cms.ingredients) === null || ref1 === void 0 ? void 0 : ref1.map(function(ingredient, index) {
                                    var ref;
                                    return ((ingredient === null || ingredient === void 0 ? void 0 : ingredient.name) || (ingredient === null || ingredient === void 0 ? void 0 : ingredient.image) || (ingredient === null || ingredient === void 0 ? void 0 : ingredient.description)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "ingredient m-0 flex shrink-0 basis-[90%] flex-col border border-black lg:w-full lg:flex-row",
                                        "data-slide": true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "ingredient-image relative w-full border-b border-black before:block before:aspect-[318/263] before:w-full lg:h-full lg:max-w-[220px] lg:border-b-0 lg:border-r xl:max-w-[320px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                    src: ingredient === null || ingredient === void 0 ? void 0 : (ref = ingredient.image) === null || ref === void 0 ? void 0 : ref.src,
                                                    alt: ingredient === null || ingredient === void 0 ? void 0 : ingredient.image_alt,
                                                    width: "638",
                                                    height: "526",
                                                    fill: true,
                                                    loading: "lazy",
                                                    sizes: "(max-width: 1023px) 90vw ,25vw"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "ingredient-body h-full w-full",
                                                children: [
                                                    (ingredient === null || ingredient === void 0 ? void 0 : ingredient.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ingredient-header border-b border-black p-4 text-left lg:px-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "ingredient-title mb-0 text-base ".concat((ingredient === null || ingredient === void 0 ? void 0 : ingredient.nameFont) || "font-hafferBold"),
                                                            children: ingredient === null || ingredient === void 0 ? void 0 : ingredient.name
                                                        })
                                                    }),
                                                    (ingredient === null || ingredient === void 0 ? void 0 : ingredient.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "ingredient-description mb-4 px-4 pt-4 pb-0 text-left lg:px-5 ".concat((ingredient === null || ingredient === void 0 ? void 0 : ingredient.descriptionFont) || ""),
                                                        dangerouslySetInnerHTML: {
                                                            __html: (0,Helper/* newLineToBr */.td)(ingredient === null || ingredient === void 0 ? void 0 : ingredient.description)
                                                        }
                                                    }),
                                                    (ingredient === null || ingredient === void 0 ? void 0 : ingredient.source) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                        className: "ingredient-source mb-4 block px-4 text-left font-primary text-xs lg:px-5 ".concat((ingredient === null || ingredient === void 0 ? void 0 : ingredient.sourceFont) || "font-haffer"),
                                                        children: [
                                                            "Source: ",
                                                            ingredient === null || ingredient === void 0 ? void 0 : ingredient.source
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, "ingredient-".concat(cms.id || cms.cmsId || cms.tinaId, "-").concat(index));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "ingredients-dots-container m-0 mt-4 flex justify-center gap-2.5 p-0 lg:hidden",
                                children: buildDots()
                            })
                        ]
                    }),
                    (cms === null || cms === void 0 ? void 0 : cms.ingredients_list) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "more-ingredients container mx-auto mt-9 px-5 lg:mt-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ingredients-content mx-auto w-8/12 overflow-hidden transition-all duration-300 ease-in-out ".concat(ingredientsOpen ? "" : "!h-0"),
                                ref: ingredientsBox,
                                "aria-hidden": !ingredientsOpen,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-0 pb-4 ".concat((cms === null || cms === void 0 ? void 0 : cms.ingredientsListFont) || ""),
                                    dangerouslySetInnerHTML: {
                                        __html: (0,Helper/* newLineToBr */.td)(cms.ingredients_list)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "focus-link",
                                onClick: toggleIngredients,
                                children: ingredientsOpen ? "show less -" : "view full ingredient list +"
                            })
                        ]
                    })
                ]
            })
        ]
    }, cms.cmsId);
}
Ingredients_Section.displayName = "Ingredients";
Ingredients_Section.Schema = {
    category: "Product",
    label: Ingredients_Section.displayName,
    key: "ingredients",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "section_optional_title",
            label: "Section Pre-title",
            component: "text"
        },
        {
            name: "sectionOptionalTitleFont",
            label: "Section Pre-title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section pre-title text"
        },
        {
            name: "section_title",
            label: "Section Title",
            component: "text"
        },
        {
            name: "sectionTitleFont",
            label: "Section Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section title text"
        },
        {
            name: "section_description",
            label: "Section Description",
            component: "textarea"
        },
        {
            name: "sectionDescriptionFont",
            label: "Section Description Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section description text"
        },
        {
            name: "ingredients",
            label: "Ingredients",
            component: "group-list",
            fields: [
                {
                    name: "image",
                    label: "Image",
                    component: "image",
                    description: "Recomended image size: 638px x 526px"
                },
                {
                    name: "image_alt",
                    label: "Image alt text",
                    component: "text"
                },
                {
                    name: "name",
                    label: "Name",
                    component: "text"
                },
                {
                    name: "nameFont",
                    label: "Name Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the name text"
                },
                {
                    name: "description",
                    label: "Description",
                    component: "textarea",
                    description: "Recommended to keep the description under 180 characters, or have consistency across all ingredients description"
                },
                {
                    name: "descriptionFont",
                    label: "Description Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the description text"
                },
                {
                    name: "source",
                    label: "Information source",
                    component: "text"
                },
                {
                    name: "sourceFont",
                    label: "Information Source Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the information source text"
                }, 
            ]
        },
        {
            name: "ingredients_list",
            label: "Full ingredients list",
            component: "textarea"
        },
        {
            name: "ingredientsListFont",
            label: "Full Ingredients List Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the full ingredients list text"
        }, 
    ]
};
var Ingredients = Ingredients_Section;

;// CONCATENATED MODULE: ./src/sections/Ingredients/index.js


// EXTERNAL MODULE: ./src/snippets/index.js + 13 modules
var snippets = __webpack_require__(91588);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
;// CONCATENATED MODULE: ./src/sections/ProductSizes/ProductSizes.jsx





function ProductSizes_Section(param) {
    var cms = param.cms;
    var ref2, ref1;
    var router = (0,next_router.useRouter)();
    var onSelectOptionChange = function(evt) {
        router.push(evt.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-comp": "productsizes",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-info-container--sizes mb-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-small mb-1 font-hafferBold text-black",
                    children: "Size"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto w-full gap-px text-grey-3 hidden lg:inline-flex lg:justify-items-stretch [&>a]:w-full [&>a]:min-w-[25%]",
                    children: cms === null || cms === void 0 ? void 0 : (ref2 = cms.productsizes) === null || ref2 === void 0 ? void 0 : ref2.map(function(productsizes, index) {
                        var ref;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/products/".concat(productsizes === null || productsizes === void 0 ? void 0 : (ref = productsizes.productName) === null || ref === void 0 ? void 0 : ref.handle),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "product-size bg-grey-9 no-underline outline outline-1 outline-grey-4 duration-200 hover:z-[1] hover:bg-grey-9 text-black hover:outline-black font-hafferBold flex items-center justify-center".concat((productsizes === null || productsizes === void 0 ? void 0 : productsizes.enable_active_pdp) === true ? " product-size-active z-[1] bg-white text-black outline-black hover:bg-white" : "").concat((productsizes === null || productsizes === void 0 ? void 0 : productsizes.unavailable_pdp) === true ? " product-size-disabled" : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col p-2 text-center my-auto",
                                        children: [
                                            (productsizes === null || productsizes === void 0 ? void 0 : productsizes.label) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-small font-hafferBold leading-[19px]",
                                                children: productsizes === null || productsizes === void 0 ? void 0 : productsizes.label
                                            }),
                                            (productsizes === null || productsizes === void 0 ? void 0 : productsizes.size) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-small font-hafferBold leading-[19px]",
                                                children: productsizes === null || productsizes === void 0 ? void 0 : productsizes.size
                                            })
                                        ]
                                    })
                                })
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative lg:hidden ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            className: "border-black font-hafferBold",
                            onChange: onSelectOptionChange,
                            "aria-label": "select size",
                            children: cms === null || cms === void 0 ? void 0 : (ref1 = cms.productsizes) === null || ref1 === void 0 ? void 0 : ref1.map(function(productSize) {
                                var ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "/products/".concat(productSize === null || productSize === void 0 ? void 0 : (ref = productSize.productName) === null || ref === void 0 ? void 0 : ref.handle),
                                    selected: productSize.enable_active_pdp,
                                    disabled: productSize === null || productSize === void 0 ? void 0 : productSize.unavailable_pdp,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            productSize === null || productSize === void 0 ? void 0 : productSize.label,
                                            (productSize === null || productSize === void 0 ? void 0 : productSize.size) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    " - ",
                                                    productSize === null || productSize === void 0 ? void 0 : productSize.size
                                                ]
                                            })
                                        ]
                                    })
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconArrowDown */.BD, {
                            className: "absolute top-1/2 right-4 transform -translate-y-1/2 pointer-events-none"
                        })
                    ]
                })
            ]
        })
    });
}
ProductSizes_Section.displayName = "ProductSizes";
ProductSizes_Section.Schema = {
    category: "Product",
    label: ProductSizes_Section.displayName,
    key: "productsizes",
    fields: [
        {
            name: "productsizes",
            label: "Product Size",
            component: "group-list",
            fields: [
                {
                    component: "productSearch",
                    name: "productName",
                    label: "Select Product"
                },
                {
                    name: "label",
                    label: "Size Title",
                    component: "text"
                },
                {
                    name: "size",
                    label: "Size Amount",
                    component: "text"
                },
                {
                    component: "toggle",
                    name: "enable_active_pdp",
                    label: "Enable",
                    description: "Is this size on the current PDP?",
                    defaultValue: false
                },
                {
                    component: "toggle",
                    name: "unavailable_pdp",
                    label: "Enable",
                    description: "Is this size out of stock?",
                    defaultValue: false
                }, 
            ]
        }, 
    ]
};
var ProductSizes = ProductSizes_Section;

;// CONCATENATED MODULE: ./src/sections/ProductSizes/index.js


;// CONCATENATED MODULE: ./src/sections/Iconography/Iconography.jsx





function Iconography(param) {
    var cms = param.cms;
    var ref4, ref1, ref2;
    var getCTAclass = function(style) {
        if (style === "link") return "focus-link";
        if (style === "white-link") return "focus-link-white";
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(Iconography.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": Iconography.displayName,
        className: "".concat(cms.bgColor),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(Iconography.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(Iconography.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-[1440px] px-4 pt-[38px] lg:px-6 lg:pt-[64px] lg:pb-[26px] ".concat(cms.fgColor),
                children: [
                    (cms === null || cms === void 0 ? void 0 : cms.intro) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-regular mb-1.5 text-center md:mx-auto md:max-w-[430px] ".concat((cms === null || cms === void 0 ? void 0 : cms.introFont) || "font-hafferBold"),
                        children: cms.intro
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-header mb-3 text-center md:mx-auto md:mb-4 md:max-w-[430px] ".concat((cms === null || cms === void 0 ? void 0 : cms.headingFont) || "font-haffer"),
                        children: cms.heading
                    }),
                    (cms === null || cms === void 0 ? void 0 : cms.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-9 text-center font-light md:mx-auto md:max-w-[430px] md:text-[18px] md:leading-[26px] ".concat((cms === null || cms === void 0 ? void 0 : cms.contentFont) || "font-haffer"),
                        dangerouslySetInnerHTML: {
                            __html: (0,Helper/* newLineToBr */.td)(cms.content)
                        }
                    }),
                    (cms === null || cms === void 0 ? void 0 : (ref4 = cms.icons) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "-mx-4 flex flex-wrap justify-evenly text-center sm:justify-center lg:mx-0 ".concat(cms.fgColor),
                        children: cms.icons.map(function(icon, iconIdx) {
                            var ref, ref3;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: "iconography-item mb-[38px] max-w-[176px] px-2 md:px-3 lg:max-w-[228px]",
                                children: [
                                    (icon === null || icon === void 0 ? void 0 : icon.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative mx-auto mb-[18px] block aspect-square h-[85px] w-[85px] md:h-[100px] md:w-[100px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            src: icon.image.src,
                                            alt: icon.imageAlt,
                                            width: "100",
                                            height: "100",
                                            fill: true,
                                            sizes: "33vw",
                                            loading: "lazy"
                                        })
                                    }),
                                    (icon === null || icon === void 0 ? void 0 : icon.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-1.5 text-[16px] leading-[22px] md:mb-1 md:text-[18px] md:leading-[26px] ".concat((icon === null || icon === void 0 ? void 0 : icon.titleFont) || "font-hafferBold"),
                                        children: icon.title
                                    }),
                                    (icon === null || icon === void 0 ? void 0 : icon.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-3 text-[14px] font-light leading-[22px] md:text-[16px] md:leading-[24px] ".concat((icon === null || icon === void 0 ? void 0 : icon.descriptionFont) || ""),
                                        dangerouslySetInnerHTML: {
                                            __html: (0,Helper/* newLineToBr */.td)(icon.description)
                                        }
                                    }),
                                    (icon === null || icon === void 0 ? void 0 : (ref = icon.cta_link) === null || ref === void 0 ? void 0 : ref.text) && ((ref3 = icon.cta_link) === null || ref3 === void 0 ? void 0 : ref3.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: icon.cta_link.url,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "".concat(getCTAclass(icon.cta_style), " cursor-pointer text-[14px] leading-[22px] ").concat((icon === null || icon === void 0 ? void 0 : icon.descriptionFont) || "font-haffer"),
                                            children: icon.cta_link.text
                                        })
                                    })
                                ]
                            }, "iconography-item-".concat(iconIdx));
                        })
                    }),
                    (cms === null || cms === void 0 ? void 0 : (ref1 = cms.cta_main_link) === null || ref1 === void 0 ? void 0 : ref1.text) && (cms === null || cms === void 0 ? void 0 : (ref2 = cms.cta_main_link) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center pt-[16px] pb-[38px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: cms.cta_main_link.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "".concat(cms.cta_main_style, " mt-6 cursor-pointer text-[14px] leading-[22px] no-underline 2xl:mt-8"),
                                children: cms.cta_main_link.text
                            })
                        })
                    })
                ]
            })
        ]
    });
}
Iconography.displayName = "Iconography";
Iconography.Schema = {
    category: "Product",
    label: Iconography.displayName,
    key: "iconography",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "intro",
            label: "Intro Title",
            component: "text"
        },
        {
            name: "introFont",
            label: "Intro Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the intro text"
        },
        {
            name: "heading",
            label: "Heading",
            component: "text"
        },
        {
            name: "headingFont",
            label: "Heading Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the heading text"
        },
        {
            name: "content",
            label: "Content",
            component: "textarea"
        },
        {
            name: "contentFont",
            label: "Content Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the content text"
        },
        {
            name: "bgColor",
            label: "Background Color",
            component: "select",
            description: "For section background color, select one from preselected brand colors.",
            options: [
                {
                    label: "Black",
                    value: "bg-black"
                },
                {
                    label: "White",
                    value: "bg-white"
                },
                {
                    label: "Grey",
                    value: "bg-grey-1"
                },
                {
                    label: "Light Grey",
                    value: "bg-grey-9"
                },
                {
                    label: "Blue 1",
                    value: "bg-quinary-1"
                },
                {
                    label: "Blue 2",
                    value: "bg-quinary-2"
                },
                {
                    label: "Blue 3",
                    value: "bg-light-blue"
                },
                {
                    label: "Cream 1",
                    value: "bg-tertiary-2"
                },
                {
                    label: "Cream 2",
                    value: "bg-senary-4"
                },
                {
                    label: "Purple",
                    value: "bg-tertiary-1"
                },
                {
                    label: "Green",
                    value: "bg-quaternary-1"
                },
                {
                    label: "Pink 1",
                    value: "bg-primary-2"
                },
                {
                    label: "Pink 2",
                    value: "bg-secondary-1"
                },
                {
                    label: "Yellow",
                    value: "bg-yellow"
                },
                {
                    label: "Orange",
                    value: "bg-secondary-2"
                },
                {
                    label: "Seafoam 1",
                    value: "bg-quaternary-2"
                },
                {
                    label: "Seafoam 2",
                    value: "bg-senary-3"
                },
                {
                    label: "Seafoam 3",
                    value: "bg-senary-5"
                },
                {
                    label: "Air Dry Cream",
                    value: "bg-stylers-1"
                },
                {
                    label: "Sculpting Cream",
                    value: "bg-stylers-2"
                },
                {
                    label: "Texture Foam",
                    value: "bg-stylers-3"
                },
                {
                    label: "Sleek Stick",
                    value: "bg-stylers-4"
                },
                {
                    label: "Scalp Blue",
                    value: "bg-scalp-blue"
                },
                {
                    label: "Magenta",
                    value: "bg-magenta"
                },
                {
                    label: "Medium Pink",
                    value: "bg-med-pink"
                },
                {
                    label: "Briogeo Blue",
                    value: "bg-brio-blue"
                },
                {
                    label: "Cloud",
                    value: "bg-cloud"
                },
                {
                    label: "Mineral",
                    value: "bg-mineral"
                },
                {
                    label: "Deep Sea",
                    value: "bg-deep-sea"
                },
                {
                    label: "Sandstone",
                    value: "bg-sandstone"
                },
                {
                    label: "Sorrel",
                    value: "bg-sorrel"
                },
                {
                    label: "Butter",
                    value: "bg-butter"
                },
                {
                    label: "Rosehip",
                    value: "bg-rosehip"
                },
                {
                    label: "Chestnut",
                    value: "bg-chestnut"
                }, 
            ],
            defaultValue: "bg-white"
        },
        {
            name: "fgColor",
            label: "Foreground Color",
            component: "select",
            description: "For section foreground color, select one from preselected brand colors.",
            options: [
                {
                    label: "White",
                    value: "text-white"
                },
                {
                    label: "Dark",
                    value: "text-black"
                }, 
            ],
            defaultValue: "text-black"
        },
        {
            name: "icons",
            label: "Icons",
            component: "group-list",
            fields: [
                {
                    name: "image",
                    label: "Icon Image",
                    component: "image",
                    description: "PNG or SVG Format Icon Image, Recommended Image Size: 200px x 200px"
                },
                {
                    name: "imageAlt",
                    label: "Image alt text",
                    component: "text"
                },
                {
                    name: "title",
                    label: "Title",
                    component: "text"
                },
                {
                    name: "titleFont",
                    label: "Title Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the title text"
                },
                {
                    name: "description",
                    label: "Description",
                    component: "textarea"
                },
                {
                    name: "descriptionFont",
                    label: "Description Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the description text"
                },
                {
                    name: "cta_link",
                    label: "CTA Link",
                    component: "link",
                    description: "Optional CTA Link"
                },
                {
                    name: "cta_style",
                    label: "CTA Link Style",
                    component: "select",
                    options: [
                        {
                            label: "Focus Link",
                            value: "link"
                        },
                        {
                            label: "Focus Link White",
                            value: "white-link"
                        }, 
                    ],
                    defaultValue: "link"
                }, 
            ]
        },
        {
            name: "cta_main_link",
            label: "CTA Link",
            component: "link"
        },
        {
            component: "select",
            name: "cta_main_style",
            label: "CTA Style",
            options: [
                {
                    label: "Primary",
                    value: "button button--primary inline-block"
                },
                {
                    label: "Secondary",
                    value: "button button--secondary inline-block"
                },
                {
                    label: "Tertiary",
                    value: "button button--tertiary inline-block"
                }, 
            ],
            defaultValue: "button button--primary inline-block"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/Iconography/index.js


;// CONCATENATED MODULE: ./src/sections/Accordion/Accordion.jsx





function Accordion(param) {
    var cms = param.cms;
    var ref8, ref1, ref2, ref3, ref4, ref5, ref6;
    var checkActiveItems = function() {
        var ref;
        var activeItem = -1;
        for(var i = 0; i < (cms === null || cms === void 0 ? void 0 : (ref = cms.accordions) === null || ref === void 0 ? void 0 : ref.length); i++){
            if ((cms === null || cms === void 0 ? void 0 : cms.accordions[i].active) === true) {
                activeItem = i;
                break;
            }
        }
        return activeItem;
    };
    var ref7 = (0,react.useState)(checkActiveItems), active = ref7[0], setActive = ref7[1];
    var hasAccordionTitle = false;
    cms === null || cms === void 0 ? void 0 : (ref8 = cms.accordions) === null || ref8 === void 0 ? void 0 : ref8.forEach(function(a) {
        hasAccordionTitle || (hasAccordionTitle = !!a.title);
    });
    var toggleAccordion = function(e, index) {
        e.preventDefault();
        if (active === index) {
            setActive(-1);
        } else {
            setActive(index);
        }
    };
    var jsonSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: cms === null || cms === void 0 ? void 0 : (ref1 = cms.accordions) === null || ref1 === void 0 ? void 0 : ref1.map(function(accordion) {
            if ((accordion === null || accordion === void 0 ? void 0 : accordion.subtitle) && (accordion === null || accordion === void 0 ? void 0 : accordion.description)) {
                return {
                    "@type": "Question",
                    name: accordion.subtitle,
                    acceptedAnswer: {
                        "@type": "Answer",
                        text: accordion.description
                    }
                };
            }
        })
    };
    (0,react.useEffect)(function() {
        document.querySelectorAll(".accordion-item-panel").forEach(function(panel) {
            panel.style.maxHeight = "".concat(panel.scrollHeight, "px");
        });
        (0,Helper/* scrollToSection */.Qj)("".concat(Accordion.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-comp": Accordion.displayName,
        className: "accordion",
        id: "".concat(Accordion.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(Accordion.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(Accordion.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto w-max max-w-full px-0 md:px-5 lg:px-12 xl:max-w-[1440px]",
                children: [
                    ((cms === null || cms === void 0 ? void 0 : cms.title) || (cms === null || cms === void 0 ? void 0 : cms.description)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4",
                        children: [
                            (cms === null || cms === void 0 ? void 0 : cms.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-header mb-3 text-center md:mx-auto md:mb-4 md:max-w-[430px] ".concat((cms === null || cms === void 0 ? void 0 : cms.titleFont) || "font-tiempos"),
                                children: cms.title
                            }),
                            (cms === null || cms === void 0 ? void 0 : cms.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-9 text-center font-light md:mx-auto md:mb-8 md:max-w-[430px] md:text-[18px] md:leading-[26px] ".concat((cms === null || cms === void 0 ? void 0 : cms.descriptionFont) || "font-haffer"),
                                dangerouslySetInnerHTML: {
                                    __html: (0,Helper/* newLineToBr */.td)(cms.description)
                                }
                            })
                        ]
                    }),
                    (cms === null || cms === void 0 ? void 0 : (ref2 = cms.accordions) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto max-w-[1120px]",
                        children: cms.accordions.map(function(accordion, accordionIdx) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: "accordion-item ".concat(active === accordionIdx ? "active" : ""),
                                onClick: function(e) {
                                    return toggleAccordion(e, accordionIdx);
                                },
                                children: [
                                    hasAccordionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden w-1/5 shrink-0 border-r border-primary-1 md:block md:px-8 md:py-6 ${accordion?.titleFont || 'font-hafferBold'}",
                                        children: (accordion === null || accordion === void 0 ? void 0 : accordion.strikethroughTitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                            children: accordion === null || accordion === void 0 ? void 0 : accordion.title
                                        }) : accordion === null || accordion === void 0 ? void 0 : accordion.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "accordion-item-body",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((accordion === null || accordion === void 0 ? void 0 : accordion.image) ? "w-full md:w-[65%]" : "w-full"),
                                            children: [
                                                (accordion === null || accordion === void 0 ? void 0 : accordion.title) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "accordion-item-heading",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "md:hidden ${accordion?.titleFont || 'font-hafferBold'}",
                                                            children: (accordion === null || accordion === void 0 ? void 0 : accordion.strikethroughTitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                                                children: accordion === null || accordion === void 0 ? void 0 : accordion.title
                                                            }) : accordion === null || accordion === void 0 ? void 0 : accordion.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mb-0 hidden leading-[26px] md:block ".concat((accordion === null || accordion === void 0 ? void 0 : accordion.subtitleFont) || "font-hafferBold"),
                                                            children: accordion === null || accordion === void 0 ? void 0 : accordion.subtitle
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "accordion-item-heading",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-0 leading-[26px] ".concat((accordion === null || accordion === void 0 ? void 0 : accordion.subtitleFont) || "font-hafferBold"),
                                                        children: accordion === null || accordion === void 0 ? void 0 : accordion.subtitle
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "accordion-item-panel ".concat(active === accordionIdx ? "" : "!max-h-0"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "pl-4 pb-6 pr-12 lg:px-10",
                                                            children: [
                                                                (accordion === null || accordion === void 0 ? void 0 : accordion.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "mb-3 leading-[26px] md:hidden ".concat((accordion === null || accordion === void 0 ? void 0 : accordion.subtitleFont) || "font-hafferBold"),
                                                                    children: accordion === null || accordion === void 0 ? void 0 : accordion.subtitle
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "mb-0 text-[14px] font-light leading-[22px] md:text-[16px] md:leading-[24px] ".concat((accordion === null || accordion === void 0 ? void 0 : accordion.descriptionFont) || ""),
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: (0,Helper/* newLineToBr */.td)(accordion === null || accordion === void 0 ? void 0 : accordion.description)
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        (accordion === null || accordion === void 0 ? void 0 : accordion.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "accordion-item-image-wrapper",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                className: "top-0 left-0 h-full w-full object-cover md:absolute",
                                                                src: accordion.image.src,
                                                                alt: (accordion === null || accordion === void 0 ? void 0 : accordion.imageAlt) || "",
                                                                width: "1000",
                                                                height: "1000"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "accordion-trigger",
                                        "aria-label": "Toggle Accordion Item for ".concat((accordion === null || accordion === void 0 ? void 0 : accordion.title) || (accordion === null || accordion === void 0 ? void 0 : accordion.subtitle)),
                                        children: active === accordionIdx ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "sr-only",
                                            children: [
                                                "Close Accordion Item for $",
                                                (accordion === null || accordion === void 0 ? void 0 : accordion.title) || (accordion === null || accordion === void 0 ? void 0 : accordion.subtitle)
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "sr-only",
                                            children: [
                                                "Open Accordion Item for $",
                                                (accordion === null || accordion === void 0 ? void 0 : accordion.title) || (accordion === null || accordion === void 0 ? void 0 : accordion.subtitle)
                                            ]
                                        })
                                    })
                                ]
                            }, "accordion-item-".concat(accordionIdx));
                        })
                    }),
                    (cms === null || cms === void 0 ? void 0 : (ref3 = cms.cta_link) === null || ref3 === void 0 ? void 0 : ref3.text) && (cms === null || cms === void 0 ? void 0 : (ref4 = cms.cta_link) === null || ref4 === void 0 ? void 0 : ref4.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center pt-[38px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (ref5 = cms.cta_link) === null || ref5 === void 0 ? void 0 : ref5.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "button button--outline cursor-pointer text-[14px] leading-[22px] no-underline",
                                children: (ref6 = cms.cta_link) === null || ref6 === void 0 ? void 0 : ref6.text
                            })
                        })
                    })
                ]
            }),
            (cms === null || cms === void 0 ? void 0 : cms.enableFaq) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(jsonSchema)
                }
            })
        ]
    });
}
Accordion.displayName = "Accordion";
Accordion.Schema = {
    category: "Product",
    label: Accordion.displayName,
    key: "Accordion",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "title",
            label: "Title",
            component: "text"
        },
        {
            name: "titleFont",
            label: "Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the title text"
        },
        {
            name: "description",
            label: "Description",
            component: "textarea"
        },
        {
            name: "descriptionFont",
            label: "Description Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the description text"
        },
        {
            name: "enableFaq",
            label: "Enable FAQ",
            component: "toggle",
            toggleLabels: {
                true: "Yes",
                false: "No"
            },
            defaultValue: false,
            description: "Enables FAQ Schema for crawlers to recognize the frenquently asked questions, should be used on FAQ template"
        },
        {
            name: "cta_link",
            label: "CTA Link",
            component: "link"
        },
        {
            name: "accordions",
            label: "Accordions",
            component: "group-list",
            fields: [
                {
                    component: "toggle",
                    name: "active",
                    label: "Active by default",
                    description: "Shows this drawer item open by default, only one can be open at any time",
                    defaultValue: false
                },
                {
                    name: "strikethroughTitle",
                    label: "Strikethrough Title?",
                    component: "toggle",
                    toggleLabels: {
                        true: "Yes",
                        false: "No"
                    },
                    defaultValue: false
                },
                {
                    name: "title",
                    label: "Title",
                    component: "text"
                },
                {
                    name: "titleFont",
                    label: "Title Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the title text"
                },
                {
                    name: "subtitle",
                    label: "Subtitle",
                    component: "text"
                },
                {
                    name: "subtitleFont",
                    label: "Subtitle Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the subtitle text"
                },
                {
                    name: "description",
                    label: "Description",
                    component: "textarea"
                },
                {
                    name: "descriptionFont",
                    label: "Description Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the description text"
                },
                {
                    name: "image",
                    label: "Image",
                    component: "image",
                    description: "Recommended Image Size: 750px x 620px"
                },
                {
                    name: "imageAlt",
                    label: "Image alt text",
                    component: "text"
                }, 
            ]
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/Accordion/index.js


;// CONCATENATED MODULE: ./src/sections/Spacer/Spacer.jsx

function Spacer_Section(param) {
    var cms = param.cms;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "space-section-container",
        "data-comp": Spacer_Section.displayName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
            children: "\n        .space-section-container { margin-bottom: ".concat(cms.mobilePadding, "px; }\n        @media(min-width: 1024px) {\n          .space-section-container { margin-bottom: ").concat(cms.desktopPadding, "px; }\n        }\n      ")
        })
    });
}
Spacer_Section.displayName = "Spacer";
Spacer_Section.Schema = {
    category: "Layout",
    label: Spacer_Section.displayName,
    key: "spacer",
    fields: [
        {
            component: "number",
            name: "mobilePadding",
            label: "Section Bottom Margin - Mobile",
            defaultValue: 50
        },
        {
            component: "number",
            name: "desktopPadding",
            label: "Section Bottom Margin - Desktop",
            defaultValue: 100
        }, 
    ]
};
var Spacer = Spacer_Section;

;// CONCATENATED MODULE: ./src/sections/Spacer/index.js


;// CONCATENATED MODULE: ./src/sections/CollectionBanner/CollectionBanner.jsx



function CollectionBanner_Section(param) {
    var cms = param.cms, collection = param.collection;
    var hasBackgroundImage = false;
    if (cms.desktop_image && cms.mobile_image) {
        hasBackgroundImage = true;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "".concat(CollectionBanner_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": "CollectionBanner",
        className: "collection-banner relative flex flex-col justify-center overflow-hidden ".concat(!cms.isFullwidth ? "container" : "", " ").concat(!hasBackgroundImage ? "py-10" : "", " ").concat(cms.textColor, " ").concat(cms.textColor_m),
        children: collection ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: "#".concat(CollectionBanner_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.mobileSpacing, "px;\n            }\n            @media(min-width: 1024px) {\n              #").concat(CollectionBanner_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n                margin-top: ").concat(cms.desktopSpacing, "px;\n              }\n            }")
                }),
                hasBackgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                    className: "t-0 l-0 relative h-full w-full object-cover object-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            srcSet: cms.desktop_image.src,
                            media: "(min-width: 768px)",
                            width: "2880",
                            height: "800"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: cms.mobile_image.src,
                            alt: cms === null || cms === void 0 ? void 0 : cms.image_alt,
                            loading: "lazy",
                            className: "h-full w-full object-cover object-center",
                            width: "750",
                            height: "320"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(cms.isFullwidth ? "container" : "w-full", "\n            ").concat(hasBackgroundImage ? "absolute top-4 lg:top-1/2 lg:-translate-y-1/2" : "static", " mx-auto px-4 lg:px-16"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "banner-title h2 mb-4 max-w-[432px] ".concat((cms === null || cms === void 0 ? void 0 : cms.bannerTitleFont) || "font-tiempos"),
                            children: cms.banner_title || collection.title
                        }, "banner-title"),
                        (cms.banner_description || collection.banner_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "banner-description max-w-[432px] text-h6-m md:text-h6 ".concat((cms === null || cms === void 0 ? void 0 : cms.bannerDescriptionFont) || ""),
                            dangerouslySetInnerHTML: {
                                __html: (0,Helper/* newLineToBr */.td)(cms.banner_description || collection.description)
                            }
                        }, "banner-description")
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            className: "container relative my-20 w-full rounded-xl border border-error-state py-20 px-10 text-center font-sans text-base text-black after:absolute after:top-0 after:left-0 after:h-full after:w-full after:rounded-xl after:bg-error after:opacity-20",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "z-1 relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Collection Grid: "
                    }),
                    "This section ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "only"
                    }),
                    " works on a collection template"
                ]
            })
        })
    });
}
CollectionBanner_Section.displayName = "Collection Banner";
CollectionBanner_Section.Schema = {
    category: "Collection",
    label: CollectionBanner_Section.displayName,
    key: "collectionBanner",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "toggle",
            name: "isFullwidth",
            label: "Full Width",
            toggleLabels: {
                true: "Full Width",
                false: "Grid width"
            },
            defaultValue: true
        },
        {
            component: "select",
            name: "textColor",
            label: "Text Color (Desktop)",
            options: [
                {
                    label: "Light",
                    value: "md:text-white"
                },
                {
                    label: "Dark",
                    value: "md:text-black"
                }, 
            ],
            defaultValue: "md:text-black"
        },
        {
            component: "select",
            name: "textColor_m",
            label: "Text Color (Mobile)",
            options: [
                {
                    label: "Light",
                    value: "text-white"
                },
                {
                    label: "Dark",
                    value: "text-black"
                }, 
            ],
            defaultValue: "text-black"
        },
        {
            name: "banner_title",
            label: "Banner Title",
            component: "text"
        },
        {
            name: "bannerTitleFont",
            label: "Banner Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the banner title text"
        },
        {
            name: "banner_description",
            label: "Banner Description",
            component: "textarea"
        },
        {
            name: "bannerDescriptionFont",
            label: "Banner Description Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the banner description text"
        },
        {
            name: "desktop_image",
            label: "Desktop Image",
            component: "image",
            description: "Recommended Image Size: 2880px x 800px"
        },
        {
            name: "mobile_image",
            label: "Mobile Image",
            component: "image",
            description: "Recommended Image Size: 750px x 320px"
        },
        {
            name: "image_alt",
            label: "Image alt text",
            component: "text"
        }, 
    ]
};
var CollectionBanner = CollectionBanner_Section;

;// CONCATENATED MODULE: ./src/sections/CollectionBanner/index.js


// EXTERNAL MODULE: ../node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(35301);
// EXTERNAL MODULE: ./src/sections/FourUpCta/FourUpCta.module.css
var FourUpCta_module = __webpack_require__(35193);
var FourUpCta_module_default = /*#__PURE__*/__webpack_require__.n(FourUpCta_module);
;// CONCATENATED MODULE: ./src/sections/FourUpCta/FourUpCta.jsx
function FourUpCta_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FourUpCta_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FourUpCta_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function FourUpCta_Section(param) {
    var cms = param.cms;
    var ref, ref1, ref2;
    var itemCount = (cms === null || cms === void 0 ? void 0 : (ref = cms.listCta) === null || ref === void 0 ? void 0 : ref.length) || 0;
    var textColor = (cms === null || cms === void 0 ? void 0 : cms.textColor) || "black";
    var sectionTitleFont = (cms === null || cms === void 0 ? void 0 : cms.sectionTitleFont) || "font-hafferBold";
    if (itemCount <= 0) {
        return null;
    }
    var slideSettings = {
        infinite: false,
        variableWidth: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        swipeToSlide: true,
        swipe: true,
        adaptiveHeight: false,
        useTransform: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    dots: true
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true,
                    dots: true
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(FourUpCta_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        className: "".concat((FourUpCta_module_default())["four-up-cta"], " four-up-cta lg:px-12 text-").concat(textColor, " ").concat((cms === null || cms === void 0 ? void 0 : cms.bgColor) !== "bg-white" && (cms === null || cms === void 0 ? void 0 : cms.bgColor) !== "transparent" ? " pt-9 pb-9 md:pt-16 md:pb-10 ".concat(cms === null || cms === void 0 ? void 0 : cms.bgColor) : ""),
        "data-comp": FourUpCta_Section.displayName,
        style: {
            backgroundColor: cms === null || cms === void 0 ? void 0 : cms.customBgColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(FourUpCta_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(FourUpCta_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-[1120px]",
                children: [
                    (cms === null || cms === void 0 ? void 0 : cms.section_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mt-0 mb-8 px-4 text-center text-h2-m md:px-12 md:text-h3 lg:mb-11 lg:px-0 ".concat(sectionTitleFont),
                        children: cms === null || cms === void 0 ? void 0 : cms.section_title
                    }),
                    (cms === null || cms === void 0 ? void 0 : (ref1 = cms.listCta) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "-ml-4 overflow-hidden px-4 sm:-ml-6 md:px-12 lg:px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSlider, {
                            settings: slideSettings,
                            className: "flex flex-nowrap md:flex-wrap md:justify-center",
                            children: cms === null || cms === void 0 ? void 0 : (ref2 = cms.listCta) === null || ref2 === void 0 ? void 0 : ref2.map(function(cta, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaHtml, {
                                    item: cta === null || cta === void 0 ? void 0 : cta.cta,
                                    index: index,
                                    textColor: textColor
                                }, index);
                            })
                        })
                    })
                ]
            })
        ]
    }, cms.cmsId);
}
var buildCtaContent = function(item) {
    var content = "";
    var preDescriptionFont = (item === null || item === void 0 ? void 0 : item.preDescriptionFont) || "font-haffer";
    if (item === null || item === void 0 ? void 0 : item.pre_description) {
        content += '<strong class="'.concat(preDescriptionFont, '">').concat(item.pre_description, "</strong>");
    }
    if (item === null || item === void 0 ? void 0 : item.description) {
        content += item.description;
    }
    return content;
};
function CustomSlider(param, props) {
    var className = param.className, settings = param.settings, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, FourUpCta_objectSpread({}, settings, props, {
                    children: children
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-md:hidden ".concat(className),
                children: children
            })
        ]
    });
}
function CtaHtml(param) {
    var item = param.item, index = param.index, textColor = param.textColor;
    var ref, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var colorClass = "!text-white text-black";
    if (!(item === null || item === void 0 ? void 0 : (ref = item.image) === null || ref === void 0 ? void 0 : ref.src) && !(item === null || item === void 0 ? void 0 : item.title) && !(item === null || item === void 0 ? void 0 : item.description)) return null;
    var titleFont = (item === null || item === void 0 ? void 0 : item.titleFont) || "font-hafferBold";
    var preDescriptionFont = (item === null || item === void 0 ? void 0 : item.preDescriptionFont) || "font-haffer";
    var descriptionFont = (item === null || item === void 0 ? void 0 : item.descriptionFont) || "font-haffer";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-[283px] shrink-0 snap-center pl-4 text-sm sm:w-full sm:pl-6 md:w-1/2 md:pb-6 md:text-base",
        "data-slide": true,
        "data-index": index,
        children: (item === null || item === void 0 ? void 0 : (ref3 = item.link) === null || ref3 === void 0 ? void 0 : ref3.text) && (item === null || item === void 0 ? void 0 : (ref4 = item.link) === null || ref4 === void 0 ? void 0 : ref4.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: item === null || item === void 0 ? void 0 : (ref5 = item.link) === null || ref5 === void 0 ? void 0 : ref5.url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "".concat((FourUpCta_module_default()).ctaContainer, " text-").concat(textColor, " block border no-underline border-").concat(textColor, " h-full text-").concat(textColor),
                href: item === null || item === void 0 ? void 0 : (ref6 = item.link) === null || ref6 === void 0 ? void 0 : ref6.url,
                children: [
                    (item === null || item === void 0 ? void 0 : (ref7 = item.image) === null || ref7 === void 0 ? void 0 : ref7.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full border-b border-".concat(textColor),
                        style: {
                            aspectRatio: item.aspect_ratio
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: item.image.src,
                            className: "w-full",
                            alt: item.image_alt,
                            loading: "lazy",
                            width: "1092",
                            height: "752"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-7 py-8 md:px-9 md:py-11",
                        children: [
                            (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-0 mb-4 block text-h3-m md:text-h4 ".concat(titleFont),
                                children: item === null || item === void 0 ? void 0 : item.title
                            }),
                            ((item === null || item === void 0 ? void 0 : item.pre_description) || (item === null || item === void 0 ? void 0 : item.description)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "block ".concat(descriptionFont),
                                dangerouslySetInnerHTML: {
                                    __html: (0,Helper/* newLineToBr */.td)(buildCtaContent(item))
                                }
                            }),
                            (item === null || item === void 0 ? void 0 : (ref8 = item.link) === null || ref8 === void 0 ? void 0 : ref8.url) && (item === null || item === void 0 ? void 0 : (ref9 = item.link) === null || ref9 === void 0 ? void 0 : ref9.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                href: item === null || item === void 0 ? void 0 : (ref10 = item.link) === null || ref10 === void 0 ? void 0 : ref10.url,
                                className: "".concat((FourUpCta_module_default()).readmoreLink, " focus-link mt-3.5 inline-block text-sm md:mt-4 !text-").concat(textColor, " border-").concat(textColor, " ").concat(descriptionFont),
                                children: item === null || item === void 0 ? void 0 : (ref11 = item.link) === null || ref11 === void 0 ? void 0 : ref11.text
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((FourUpCta_module_default()).ctaContainer, " text-").concat(textColor, " border border-").concat(textColor, " h-full"),
            children: [
                (item === null || item === void 0 ? void 0 : (ref12 = item.image) === null || ref12 === void 0 ? void 0 : ref12.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full border-b border-".concat(textColor),
                    style: {
                        aspectRatio: item.aspect_ratio
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: item.image.src,
                        className: "w-full",
                        alt: item.image_alt,
                        loading: "lazy",
                        width: "1092",
                        height: "752"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-7 py-8 md:px-9 md:py-11",
                    children: [
                        (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-0 mb-4 block text-[22px] md:text-h4 ".concat(titleFont),
                            children: item === null || item === void 0 ? void 0 : item.title
                        }),
                        (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block ".concat(descriptionFont),
                            children: [
                                (item === null || item === void 0 ? void 0 : item.pre_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: item === null || item === void 0 ? void 0 : item.pre_description
                                }),
                                item === null || item === void 0 ? void 0 : item.description
                            ]
                        }),
                        (item === null || item === void 0 ? void 0 : (ref13 = item.link) === null || ref13 === void 0 ? void 0 : ref13.url) && (item === null || item === void 0 ? void 0 : (ref14 = item.link) === null || ref14 === void 0 ? void 0 : ref14.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: item === null || item === void 0 ? void 0 : (ref15 = item.link) === null || ref15 === void 0 ? void 0 : ref15.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: item === null || item === void 0 ? void 0 : (ref16 = item.link) === null || ref16 === void 0 ? void 0 : ref16.url,
                                className: "".concat((FourUpCta_module_default()).readmoreLink, " focus-link mt-3.5 inline-block text-sm md:mt-4 !text-").concat(textColor, " border-").concat(textColor, " ").concat(descriptionFont),
                                children: item === null || item === void 0 ? void 0 : (ref17 = item.link) === null || ref17 === void 0 ? void 0 : ref17.text
                            })
                        })
                    ]
                })
            ]
        })
    });
}
FourUpCta_Section.displayName = "4 Up CTA";
CustomSlider.displayName = "CustomSlider";
CtaHtml.displayName = "CtaHtml";
FourUpCta_Section.Schema = {
    category: "Extras",
    label: FourUpCta_Section.displayName,
    key: "four-up-cta",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "group-list",
            name: "listCta",
            label: "CTA",
            description: "List CTAs",
            fields: [
                {
                    label: "CTA",
                    name: "cta",
                    component: "group",
                    fields: [
                        {
                            label: "CTA Image",
                            name: "image",
                            component: "image",
                            description: "Recommended Image Size: 1092px x 752px"
                        },
                        {
                            name: "image_alt",
                            label: "Image alt text",
                            component: "text"
                        },
                        {
                            name: "aspect_ratio",
                            label: "CTA Aspect Ratio",
                            description: 'Width divided by height, e.g. 16:9 image is "1.78"',
                            component: "number"
                        },
                        {
                            label: "CTA Title",
                            name: "title",
                            component: "text"
                        },
                        {
                            name: "titleFont",
                            label: "Title Font",
                            component: "select",
                            options: FontSelector,
                            defaultValue: "font-hafferBold",
                            description: "Select the font for the title text"
                        },
                        {
                            name: "pre_description",
                            label: "CTA Pre-description",
                            component: "text"
                        },
                        {
                            name: "preDescriptionFont",
                            label: "Pre-description Font",
                            component: "select",
                            options: FontSelector,
                            defaultValue: "font-haffer",
                            description: "Select the font for the pre-description text"
                        },
                        {
                            name: "description",
                            label: "CTA Description",
                            component: "textarea",
                            description: "Recommended to keep the description under 180 characters, or have consistency across all ingredients description"
                        },
                        {
                            name: "descriptionFont",
                            label: "Description Font",
                            component: "select",
                            options: FontSelector,
                            defaultValue: "font-haffer",
                            description: "Select the font for the description text"
                        },
                        {
                            label: "CTA URL",
                            name: "link",
                            component: "link"
                        }, 
                    ]
                }, 
            ]
        },
        {
            name: "section_title",
            label: "Section Title",
            component: "text"
        },
        {
            name: "sectionTitleFont",
            label: "Section Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-hafferBold",
            description: "Select the font for the section title text"
        },
        {
            component: "select",
            name: "textColor",
            label: "Text Color",
            options: [
                {
                    label: "Light",
                    value: "white"
                },
                {
                    label: "Dark",
                    value: "black"
                }, 
            ],
            defaultValue: "black"
        },
        {
            component: "select",
            name: "bgColor",
            label: "Background Color",
            description: "For section background color, select one from preselected brand colors.",
            options: [
                {
                    label: "Black",
                    value: "bg-black"
                },
                {
                    label: "White",
                    value: "bg-white"
                },
                {
                    label: "Grey",
                    value: "bg-grey-1"
                },
                {
                    label: "Light Grey",
                    value: "bg-grey-9"
                },
                {
                    label: "Blue 1",
                    value: "bg-quinary-1"
                },
                {
                    label: "Blue 2",
                    value: "bg-quinary-2"
                },
                {
                    label: "Blue 3",
                    value: "bg-light-blue"
                },
                {
                    label: "Cream 1",
                    value: "bg-tertiary-2"
                },
                {
                    label: "Cream 2",
                    value: "bg-senary-4"
                },
                {
                    label: "Purple",
                    value: "bg-tertiary-1"
                },
                {
                    label: "Green",
                    value: "bg-quaternary-1"
                },
                {
                    label: "Pink 1",
                    value: "bg-primary-2"
                },
                {
                    label: "Pink 2",
                    value: "bg-secondary-1"
                },
                {
                    label: "Yellow",
                    value: "bg-yellow"
                },
                {
                    label: "Orange",
                    value: "bg-secondary-2"
                },
                {
                    label: "Seafoam 1",
                    value: "bg-quaternary-2"
                },
                {
                    label: "Seafoam 2",
                    value: "bg-senary-3"
                },
                {
                    label: "Seafoam 3",
                    value: "bg-senary-5"
                },
                {
                    label: "Air Dry Cream",
                    value: "bg-stylers-1"
                },
                {
                    label: "Sculpting Cream",
                    value: "bg-stylers-2"
                },
                {
                    label: "Texture Foam",
                    value: "bg-stylers-3"
                },
                {
                    label: "Sleek Stick",
                    value: "bg-stylers-4"
                },
                {
                    label: "Scalp Blue",
                    value: "bg-scalp-blue"
                },
                {
                    label: "Magenta",
                    value: "bg-magenta"
                },
                {
                    label: "Medium Pink",
                    value: "bg-med-pink"
                },
                {
                    label: "Briogeo Blue",
                    value: "bg-brio-blue"
                },
                {
                    label: "Cloud",
                    value: "bg-cloud"
                },
                {
                    label: "Mineral",
                    value: "bg-mineral"
                },
                {
                    label: "Deep Sea",
                    value: "bg-deep-sea"
                },
                {
                    label: "Sandstone",
                    value: "bg-sandstone"
                },
                {
                    label: "Sorrel",
                    value: "bg-sorrel"
                },
                {
                    label: "Butter",
                    value: "bg-butter"
                },
                {
                    label: "Rosehip",
                    value: "bg-rosehip"
                },
                {
                    label: "Chestnut",
                    value: "bg-chestnut"
                }, 
            ],
            defaultValue: "bg-white"
        },
        {
            component: "color",
            name: "customBgColor",
            label: "Custom Background Color",
            description: "Custom Background color"
        }, 
    ]
};
var FourUpCta = FourUpCta_Section;

;// CONCATENATED MODULE: ./src/sections/FourUpCta/index.js


// EXTERNAL MODULE: ./src/sections/StudyStatistics/StudyStatistics.module.css
var StudyStatistics_module = __webpack_require__(74190);
var StudyStatistics_module_default = /*#__PURE__*/__webpack_require__.n(StudyStatistics_module);
;// CONCATENATED MODULE: ./src/sections/StudyStatistics/StudyStatistics.jsx
function StudyStatistics_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function StudyStatistics_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            StudyStatistics_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







function StudyStatistics_Section(param) {
    var cms = param.cms;
    var studyItems = (cms === null || cms === void 0 ? void 0 : cms.study) || [];
    var scrollRef = (0,react.useRef)(null);
    var arrowNext = (0,react.useRef)(null);
    var arrowPrev = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), enableArrows = ref[0], setEnableArrows = ref[1];
    var updateSliderHeight = function() {
        var firstSlideHeight = scrollRef.current.innerSlider.list.querySelector(".slick-active").clientHeight;
        var sliderList = scrollRef.current.innerSlider.list;
        console.log(firstSlideHeight);
        sliderList.style.height = firstSlideHeight + "px";
    };
    (0,react.useEffect)(function() {
        if (scrollRef.current) {
            var child = scrollRef.current.innerSlider.props.children;
            if (!child) return;
            setEnableArrows(child.length > scrollRef.current.props.slidesToShow);
        }
    }, []);
    var slideSettings = {
        infinite: true,
        centerMode: false,
        variableWidth: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        swipeToSlide: true,
        swipe: true,
        adaptiveHeight: true
    };
    var slickNext = function() {
        scrollRef.current.slickNext();
    };
    var slickPrev = function() {
        scrollRef.current.slickPrev();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(StudyStatistics_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": StudyStatistics_Section.displayName,
        className: "".concat((StudyStatistics_module_default()).studyStatistics, " px-4 md-:mx-12 md-:px-12"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(StudyStatistics_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(StudyStatistics_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mx-auto max-w-[1220px]",
                children: [
                    enableArrows && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-5 flex justify-end lg:mb-0 lg:block lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                onClick: function() {
                                    return slickPrev();
                                },
                                className: "z-1 top-1/2 -left-1 flex h-11 w-11 items-center justify-center border border-black text-black hover:bg-black hover:text-white lg:absolute lg:-translate-y-1/2 lg:-translate-x-full xl:-left-6",
                                ref: arrowPrev,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconArrowLeft */.D6, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Prev"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                onClick: function() {
                                    return slickNext();
                                },
                                className: "z-1 top-1/2 -right-1 flex h-11 w-11 items-center justify-center border border-l-0 border-black text-black hover:bg-black hover:text-white lg:absolute lg:-translate-y-1/2 lg:translate-x-full lg:border-l xl:-right-6",
                                ref: arrowNext,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconArrowRight */.Ec, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Next"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, StudyStatistics_objectSpread({}, slideSettings, {
                            ref: scrollRef,
                            children: studyItems.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-0.5 flex w-full shrink-0 border border-black",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Study, {
                                        item: item,
                                        cms: cms,
                                        index: index,
                                        onLoadHandler: updateSliderHeight
                                    })
                                }, index);
                            })
                        }))
                    })
                ]
            })
        ]
    });
}
function Study(param) {
    var item = param.item, cms = param.cms, index = param.index, onLoadHandler = param.onLoadHandler;
    var ref6;
    var studyCol = (0,react.useRef)([]);
    var gridClasses = {
        1: "md:grid-rows-1 md:grid-cols-1",
        2: "md:grid-rows-1 md:grid-cols-2",
        3: "md:grid-rows-2 md:grid-cols-2"
    };
    var columnClasses = {
        1: [
            "row-span-1 col-span-1"
        ],
        2: [
            "row-span-1 col-span-1 md:border-r border-b md:border-b-0",
            "row-span-1 col-span-1", 
        ],
        3: [
            "row-span-2 col-span-1 md:border-r border-b md:border-b-0",
            "row-span-1 col-span-1 border-b md:border-b-0",
            "row-span-1 col-span-1 md:border-t", 
        ]
    };
    var columns = (item === null || item === void 0 ? void 0 : (ref6 = item.column) === null || ref6 === void 0 ? void 0 : ref6.filter(function(_, i) {
        return i < 3;
    })) || [];
    var columnCount = columns.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col md:grid ".concat(gridClasses[columnCount], " h-full gap-0"),
        children: columns.map(function(column, i) {
            var ref7, ref1, ref2, ref3, ref4, ref5;
            var image_d = column === null || column === void 0 ? void 0 : (ref7 = column.image_d) === null || ref7 === void 0 ? void 0 : ref7.src;
            var image_m = column === null || column === void 0 ? void 0 : (ref1 = column.image_m) === null || ref1 === void 0 ? void 0 : ref1.src;
            var title = column.title, subtitle = column.subtitle, description = column.description, titleImage = column.titleImage, cta = column.cta, ctaStyle = column.ctaStyle, productTitle = column.productTitle, image_alt = column.image_alt;
            var orderClasses = "order-0";
            if (i === 1 && (image_d || ((ref2 = columns[i + 1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image_d) === null || ref3 === void 0 ? void 0 : ref3.src))) {
                orderClasses = "order-1 border-b-0";
            }
            if (i === 2 && (image_d || ((ref4 = columns[i - 1]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image_d) === null || ref5 === void 0 ? void 0 : ref5.src))) {
                orderClasses += " md:border-t-0 border-b";
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex flex-col ".concat(columnClasses[columnCount][i], " ").concat(orderClasses),
                ref: function(ref) {
                    return studyCol.current.push(ref);
                },
                children: [
                    productTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(image_d ? "md:absolute md:top-0 md:left-0" : "", " w-full border-b border-black bg-white text-center md:w-3/4 md:border-r md:text-left"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "m-0 px-6 py-3 font-hafferBold text-sm lg:text-h5-m",
                            children: productTitle
                        })
                    }) : null,
                    image_d ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "study__media md:h-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pointer-events-none h-full w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                className: "object-fit h-full w-full object-cover",
                                children: [
                                    image_m ? /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        srcSet: image_m,
                                        media: "(max-width: 768px)",
                                        width: "684",
                                        height: "684"
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: image_d || image_m,
                                        loading: "lazy",
                                        alt: image_alt,
                                        onLoad: function() {
                                            if (index === 0) {
                                                onLoadHandler();
                                            }
                                        },
                                        className: "object-fit top-0 left-0 h-full w-full object-cover",
                                        width: "1092",
                                        height: "1336"
                                    })
                                ]
                            })
                        })
                    }) : null,
                    subtitle || title || description || cta ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(image_d ? "z-1 absolute left-0 top-0 flex h-full items-center" : "flex flex-grow flex-col justify-center", " w-full"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "study__content mx-auto flex w-full max-w-[460px] items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full overflow-hidden p-7 text-center md:p-8 md:text-left",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-start ".concat(titleImage && (titleImage === null || titleImage === void 0 ? void 0 : titleImage.src) ? "mx-auto max-w-[270px] justify-between md:max-w-full md:justify-start" : "justify-center md:justify-start"),
                                        children: [
                                            titleImage && (titleImage === null || titleImage === void 0 ? void 0 : titleImage.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex-shrink-0 pt-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: titleImage === null || titleImage === void 0 ? void 0 : titleImage.src,
                                                    alt: "",
                                                    className: "w-[50px] shrink-0",
                                                    loading: "lazy",
                                                    width: titleImage === null || titleImage === void 0 ? void 0 : titleImage.width,
                                                    height: titleImage === null || titleImage === void 0 ? void 0 : titleImage.height
                                                })
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((titleImage === null || titleImage === void 0 ? void 0 : titleImage.src) ? "pl-6 text-left md:pl-5" : "", " flex-grow"),
                                                children: [
                                                    subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mt-0 font-hafferBold text-h6-m font-normal md:text-h6 ".concat((titleImage === null || titleImage === void 0 ? void 0 : titleImage.src) ? "mb-1 md:mb-0" : "mb-3 md:mb-2.5 lg+:mb-9"),
                                                        children: subtitle
                                                    }) : null,
                                                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-tiempos ".concat((titleImage === null || titleImage === void 0 ? void 0 : titleImage.src) ? "text-[22px] md:text-h4" : "text-h2-m md:text-h2", "  m-0"),
                                                        children: title
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    }),
                                    description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-2 font-normal",
                                        dangerouslySetInnerHTML: {
                                            __html: (0,Helper/* newLineToBr */.td)(description)
                                        }
                                    }) : null,
                                    cta && (cta === null || cta === void 0 ? void 0 : cta.text) && (cta === null || cta === void 0 ? void 0 : cta.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "z-2 relative mt-5 md:mt-2 lg:mt-7",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: cta === null || cta === void 0 ? void 0 : cta.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "cursor-pointer ".concat(ctaStyle !== "focus-link" ? "button min-w-[190px] ".concat(ctaStyle) : ctaStyle, " mb-4 inline-block text-center no-underline"),
                                                children: cta === null || cta === void 0 ? void 0 : cta.text
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        })
                    }) : null
                ]
            }, "study-col-".concat(cms.id || cms.cmsId || cms.tinaId, "-").concat(i));
        })
    });
}
StudyStatistics_Section.displayName = "Study Statistics";
Study.displayName = "Study";
StudyStatistics_Section.Schema = {
    category: "Modules",
    label: StudyStatistics_Section.displayName,
    key: "study-statistics",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "group-list",
            name: "study",
            label: "Study",
            description: "Study",
            fields: [
                {
                    component: "group-list",
                    name: "column",
                    label: "Column",
                    description: "Column",
                    fields: [
                        {
                            label: "Image (Desktop)",
                            name: "image_d",
                            component: "image",
                            description: "Recommend image size: 1092px x 1336px (column 1), 1140px x 668px (column 2, 3)"
                        },
                        {
                            label: "Image (Mobile)",
                            name: "image_m",
                            component: "image",
                            description: "Recommend a square aspect ratio image with 684px x 684px"
                        },
                        {
                            name: "image_alt",
                            label: "Image alt text",
                            component: "text"
                        },
                        {
                            label: "Title Image",
                            name: "titleImage",
                            component: "image",
                            description: "Recommend a square aspect ratio image with 100px x 100px"
                        },
                        {
                            name: "productTitle",
                            label: "Product Title",
                            component: "text"
                        },
                        {
                            name: "subtitle",
                            label: "Sub-title",
                            component: "text"
                        },
                        {
                            label: "Title",
                            name: "title",
                            component: "text"
                        },
                        {
                            name: "description",
                            label: "Description",
                            component: "textarea"
                        },
                        {
                            label: "CTA",
                            name: "cta",
                            component: "link"
                        },
                        {
                            component: "select",
                            name: "ctaStyle",
                            label: "CTA Style",
                            options: [
                                {
                                    label: "Primary",
                                    value: "button--primary"
                                },
                                {
                                    label: "Secondary",
                                    value: "button--secondary"
                                },
                                {
                                    label: "Focus Link",
                                    value: "focus-link"
                                },
                                {
                                    label: "checkout",
                                    value: "button--checkout"
                                }, 
                            ],
                            defaultValue: "button--primary"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
};
var StudyStatistics = StudyStatistics_Section;

;// CONCATENATED MODULE: ./src/sections/StudyStatistics/index.js


// EXTERNAL MODULE: ./src/sections/ProductSpotlight/ProductSpotlight.module.css
var ProductSpotlight_module = __webpack_require__(78655);
var ProductSpotlight_module_default = /*#__PURE__*/__webpack_require__.n(ProductSpotlight_module);
;// CONCATENATED MODULE: ./src/sections/ProductSpotlight/ProductSpotlight.jsx





function ProductSpotlight_Section(param) {
    var cms = param.cms;
    var ref;
    var title = cms.title, description = cms.description, _titleFont = cms.titleFont, titleFont = _titleFont === void 0 ? "font-hafferBold" : _titleFont, _descriptionFont = cms.descriptionFont, descriptionFont = _descriptionFont === void 0 ? "font-haffer" : _descriptionFont;
    var spotlights = (cms === null || cms === void 0 ? void 0 : (ref = cms.spotlight) === null || ref === void 0 ? void 0 : ref.filter(function(_, i) {
        return i < 2;
    })) || [];
    var itemCount = spotlights.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(ProductSpotlight_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": ProductSpotlight_Section.displayName,
        className: "px-4 py-6 md:px-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(ProductSpotlight_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(ProductSpotlight_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-[1120px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full max-w-[546px]",
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-header mt-0 mb-2 md:mb-3 ".concat(titleFont),
                                children: title
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "m-0 text-sm font-light md:text-h6 ".concat(descriptionFont),
                                dangerouslySetInnerHTML: {
                                    __html: (0,Helper/* newLineToBr */.td)(description)
                                }
                            })
                        ]
                    }),
                    itemCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-4 block sm:mt-8 md:-ml-7 md:mt-9 md:flex",
                        children: spotlights.map(function(spotlight, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-12 w-full first:mt-0 md:mt-0 md:w-1/2 md:pl-7",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spotlight, {
                                    item: spotlight,
                                    index: index
                                })
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
}
function Spotlight(param) {
    var item = param.item;
    var ref6, ref1, ref2, ref3;
    var image = item.image, image_m = item.image_m, collection_link = item.collection_link, franchise_color = item.franchise_color, ingredient_name = item.ingredient_name, product_name = item.product_name, image_alt = item.image_alt, _ingredientNameFont = item.ingredientNameFont, ingredientNameFont = _ingredientNameFont === void 0 ? "font-tiempos" : _ingredientNameFont, _productNameFont = item.productNameFont, productNameFont = _productNameFont === void 0 ? "font-tiempos" : _productNameFont;
    var cta = item === null || item === void 0 ? void 0 : item.cta;
    var features = (item === null || item === void 0 ? void 0 : item.feature) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            image && ((collection_link === null || collection_link === void 0 ? void 0 : collection_link.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: collection_link === null || collection_link === void 0 ? void 0 : collection_link.url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "relative no-underline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                image_m ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image_m === null || image_m === void 0 ? void 0 : image_m.src,
                                    alt: image_alt,
                                    loading: "lazy",
                                    className: "block w-full md:hidden",
                                    width: "1344",
                                    height: "1344"
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image === null || image === void 0 ? void 0 : image.src,
                                    alt: image_alt,
                                    loading: "lazy",
                                    className: "hidden w-full md:block",
                                    width: "1092",
                                    height: "1092"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bottom-0 left-0 w-full px-0 py-4 sm:py-6 md:absolute md:px-5 md:py-8 lg+:px-7",
                            children: [
                                collection_link && (collection_link === null || collection_link === void 0 ? void 0 : collection_link.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "sub-xsmall mb-1 md:mb-2 ".concat(franchise_color),
                                    children: collection_link === null || collection_link === void 0 ? void 0 : collection_link.text
                                }),
                                ingredient_name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    role: "heading",
                                    className: "mt-0 mb-0 text-h5-m italic md:mb-1 md:text-h5 ".concat(ingredientNameFont),
                                    children: ingredient_name
                                }),
                                product_name && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "m-0 text-h3-m md:text-h4 ".concat(productNameFont),
                                    children: product_name
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            image_m ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: image_m === null || image_m === void 0 ? void 0 : image_m.src,
                                alt: image_alt,
                                loading: "lazy",
                                className: "block w-full md:hidden",
                                width: "1344",
                                height: "1344"
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: image === null || image === void 0 ? void 0 : image.src,
                                alt: image_alt,
                                loading: "lazy",
                                className: "hidden w-full md:block",
                                width: "1092",
                                height: "1092"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bottom-0 left-0 w-full px-0 py-4 sm:py-6 md:absolute md:px-5 md:py-8 lg+:px-7",
                        children: [
                            collection_link && (collection_link === null || collection_link === void 0 ? void 0 : collection_link.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "sub-xsmall mb-1 md:mb-2 ".concat(franchise_color),
                                children: collection_link === null || collection_link === void 0 ? void 0 : collection_link.text
                            }),
                            ingredient_name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-0 mb-0 text-h5-m italic md:mb-1 md:text-h5 ".concat(ingredientNameFont),
                                children: ingredient_name
                            }),
                            product_name && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "m-0 text-h3-m md:text-h4 ".concat(productNameFont),
                                children: product_name
                            })
                        ]
                    })
                ]
            })),
            features.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-large mt-0 border border-grey-3 md:mt-6",
                children: features.map(function(feature, i) {
                    var ref, ref4, ref5;
                    return (feature === null || feature === void 0 ? void 0 : feature.title) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex min-h-[100px] items-center border-t border-grey-3 px-6 py-5 first:border-t-0",
                        children: [
                            (feature === null || feature === void 0 ? void 0 : (ref = feature.image) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[42px] shrink-0 text-center ".concat((ProductSpotlight_module_default()).iconContainer),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: feature === null || feature === void 0 ? void 0 : (ref4 = feature.image) === null || ref4 === void 0 ? void 0 : ref4.src,
                                    alt: "",
                                    className: "w-42px h-42px object-contain",
                                    loading: "lazy",
                                    width: "100",
                                    height: "100"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "m-0 ".concat((feature === null || feature === void 0 ? void 0 : (ref5 = feature.image) === null || ref5 === void 0 ? void 0 : ref5.src) ? "pl-6" : ""),
                                children: [
                                    (feature === null || feature === void 0 ? void 0 : feature.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        className: (feature === null || feature === void 0 ? void 0 : feature.titleFont) || "font-haffer",
                                        children: feature === null || feature === void 0 ? void 0 : feature.title
                                    }),
                                    (feature === null || feature === void 0 ? void 0 : feature.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-2 ".concat((feature === null || feature === void 0 ? void 0 : feature.descriptionFont) || "font-haffer"),
                                        dangerouslySetInnerHTML: {
                                            __html: (0,Helper/* newLineToBr */.td)(feature === null || feature === void 0 ? void 0 : feature.description)
                                        }
                                    })
                                ]
                            })
                        ]
                    }, "spotlight-feature-".concat(i));
                })
            }) : null,
            cta && (cta === null || cta === void 0 ? void 0 : (ref6 = cta.link) === null || ref6 === void 0 ? void 0 : ref6.text) && (cta === null || cta === void 0 ? void 0 : (ref1 = cta.link) === null || ref1 === void 0 ? void 0 : ref1.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6 flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: cta === null || cta === void 0 ? void 0 : (ref2 = cta.link) === null || ref2 === void 0 ? void 0 : ref2.url,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "".concat((cta === null || cta === void 0 ? void 0 : cta.style) !== "focus-link" ? "button ".concat(cta === null || cta === void 0 ? void 0 : cta.style) : cta === null || cta === void 0 ? void 0 : cta.style, " mb-4 inline-block min-w-[190px] text-center no-underline"),
                        children: cta === null || cta === void 0 ? void 0 : (ref3 = cta.link) === null || ref3 === void 0 ? void 0 : ref3.text
                    })
                })
            }) : null
        ]
    });
}
ProductSpotlight_Section.displayName = "Product Spotlight";
Spotlight.displayName = "Spotlight";
ProductSpotlight_Section.Schema = {
    category: "Modules",
    label: ProductSpotlight_Section.displayName,
    key: "product-spotlight",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "title",
            label: "Section Title",
            component: "text"
        },
        {
            name: "titleFont",
            label: "Section Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-hafferBold",
            description: "Select the font for the section title"
        },
        {
            name: "description",
            label: "Section Description",
            component: "textarea"
        },
        {
            name: "descriptionFont",
            label: "Section Description Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section description"
        },
        {
            name: "spotlight",
            label: "Spotlight",
            component: "group-list",
            fields: [
                {
                    name: "image",
                    label: "Image (Desktop)",
                    component: "image",
                    description: "Recomended image width size: 1092px"
                },
                {
                    name: "image_m",
                    label: "Image (Mobile)",
                    component: "image",
                    description: "Recomended image width size: 1344px"
                },
                {
                    name: "image_alt",
                    label: "Image alt text",
                    component: "text"
                },
                {
                    name: "collection_link",
                    label: "Collection (Franchise)",
                    description: "Optional Field",
                    component: "link"
                },
                {
                    component: "select",
                    name: "franchise_color",
                    label: "Collection (Franchise) Color",
                    description: "Select from preselected brand colors.",
                    options: [
                        {
                            label: "Pink",
                            value: "text-primary-2"
                        },
                        {
                            label: "Blue 2",
                            value: "text-quinary-2"
                        },
                        {
                            label: "Blue 2 Alt",
                            value: "text-quinary-2-alt"
                        },
                        {
                            label: "Green",
                            value: "text-quaternary-1"
                        },
                        {
                            label: "Purple",
                            value: "text-tertiary-1"
                        },
                        {
                            label: "Pink 2",
                            value: "text-secondary-1"
                        },
                        {
                            label: "Orange",
                            value: "text-secondary-2"
                        },
                        {
                            label: "Cream",
                            value: "text-tertiary-2"
                        },
                        {
                            label: "Blue 1",
                            value: "text-quinary-1"
                        },
                        {
                            label: "Seafoam",
                            value: "text-quaternary-2"
                        },
                        {
                            label: "Air Dry Cream",
                            value: "text-stylers-1"
                        },
                        {
                            label: "Sculpting Cream",
                            value: "text-stylers-2"
                        },
                        {
                            label: "Texture Foam",
                            value: "text-stylers-3"
                        },
                        {
                            label: "Sleek Stick",
                            value: "text-stylers-4"
                        }
                    ],
                    defaultValue: "text-primary-2"
                },
                {
                    name: "ingredient_name",
                    label: "Ingredient",
                    description: "Optional Field",
                    component: "text"
                },
                {
                    name: "ingredientNameFont",
                    label: "Ingredient Name Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-tiempos",
                    description: "Select the font for the ingredient name text"
                },
                {
                    name: "product_name",
                    label: "Product Title",
                    description: "Optional Field",
                    component: "text"
                },
                {
                    name: "productNameFont",
                    label: "Product Name Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-tiempos",
                    description: "Select the font for the product name text"
                },
                {
                    name: "feature",
                    label: "Feature",
                    component: "group-list",
                    fields: [
                        {
                            name: "image",
                            label: "Icon",
                            component: "image",
                            description: "Recomended image size 100px x 100px"
                        },
                        {
                            name: "title",
                            label: "Title",
                            description: "Optional Field",
                            component: "text"
                        },
                        {
                            name: "titleFont",
                            label: "Title Font",
                            component: "select",
                            options: FontSelector,
                            defaultValue: "font-haffer",
                            description: "Select the font for the title text"
                        },
                        {
                            name: "description",
                            label: "Description",
                            description: "Optional Field",
                            component: "textarea"
                        },
                        {
                            name: "descriptionFont",
                            label: "Description Font",
                            component: "select",
                            options: FontSelector,
                            defaultValue: "font-haffer",
                            description: "Select the font for the description text"
                        }, 
                    ]
                },
                {
                    label: "CTA",
                    name: "cta",
                    component: "group",
                    fields: [
                        {
                            label: "CTA URL",
                            name: "link",
                            component: "link"
                        },
                        {
                            component: "select",
                            name: "style",
                            label: "Cta Style",
                            options: [
                                {
                                    label: "Primary",
                                    value: "button--primary"
                                },
                                {
                                    label: "Secondary",
                                    value: "button--secondary"
                                },
                                {
                                    label: "checkout",
                                    value: "button--checkout"
                                }, 
                            ],
                            defaultValue: "button--primary"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
};
var ProductSpotlight = ProductSpotlight_Section;

;// CONCATENATED MODULE: ./src/sections/ProductSpotlight/index.js


;// CONCATENATED MODULE: ./src/sections/ThreeUp/ThreeUp.jsx
function ThreeUp_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ThreeUp_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ThreeUp_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function ThreeUp(param) {
    var cms = param.cms;
    var ref1;
    var slider = null;
    var next = function() {
        if (slider) slider.slickNext();
    };
    var prev = function() {
        if (slider) slider.slickPrev();
    };
    var getCTAclass = function(style) {
        if (style === "link") return "focus-link";
        if (style === "white-link") return "focus-link-white";
        if (style === "primary") return "no-underline button button--primary";
        if (style === "secondary") return "no-underline button button--secondary";
        if (style === "tertiary") return "no-underline button button--tertiary";
        return "";
    };
    var settings = {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 2.3,
        slidesToScroll: 1,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1.8
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.6
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(ThreeUp.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": ThreeUp.displayName,
        className: "three-up flex flex-wrap items-center py-8 lg:py-12 ".concat(cms.bgColor, " ").concat(cms.fgColor),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(ThreeUp.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(ThreeUp.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-6 w-full px-4 lg:mb-0 lg:max-w-[390px] lg:pl-12 lg:pr-16",
                children: [
                    (cms === null || cms === void 0 ? void 0 : cms.intro) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-4 text-h6 ".concat((cms === null || cms === void 0 ? void 0 : cms.introFont) || "font-hafferBold"),
                        children: cms.intro
                    }),
                    (cms === null || cms === void 0 ? void 0 : cms.heading) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-header mb-1.5 lg:mb-3 ".concat((cms === null || cms === void 0 ? void 0 : cms.headingFont) || "font-haffer"),
                        children: cms.heading
                    }),
                    (cms === null || cms === void 0 ? void 0 : cms.body) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-0 ".concat((cms === null || cms === void 0 ? void 0 : cms.bodyFont) || ""),
                        dangerouslySetInnerHTML: {
                            __html: (0,Helper/* newLineToBr */.td)(cms.body)
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden lg:mt-10 lg:flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "three-up__arrow three-up__arrow--prev",
                                onClick: prev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "11",
                                    height: "17",
                                    viewBox: "0 0 11 17",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M8.75 2L2.25 8.5L8.75 15",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "square"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "three-up__arrow three-up__arrow--next -ml-px",
                                onClick: next,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "11",
                                    height: "17",
                                    viewBox: "0 0 11 17",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M2.25 2L8.75 8.5L2.25 15",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "square"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full lg:max-w-[calc(100%-390px)]",
                children: (cms === null || cms === void 0 ? void 0 : (ref1 = cms.columns) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, ThreeUp_objectSpread({
                    ref: function(c) {
                        return slider = c;
                    }
                }, settings, {
                    children: cms.columns.map(function(column, columnIdx) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "px-3 focus:outline-none",
                            children: [
                                (column === null || column === void 0 ? void 0 : column.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "mb-3 lg:mb-5 xl:mb-4",
                                    src: column.image.src,
                                    alt: column.image_alt,
                                    loading: "lazy",
                                    width: "864",
                                    height: "1022"
                                }),
                                (column === null || column === void 0 ? void 0 : column.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    className: "mb-1.5 ".concat((column === null || column === void 0 ? void 0 : column.titleFont) || "font-hafferBold"),
                                    children: column.title
                                }),
                                (column === null || column === void 0 ? void 0 : column.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xsmall mb-3 ".concat((column === null || column === void 0 ? void 0 : column.descriptionFont) || "font-haffer"),
                                    dangerouslySetInnerHTML: {
                                        __html: (0,Helper/* newLineToBr */.td)(column.description)
                                    }
                                }),
                                (column === null || column === void 0 ? void 0 : (ref = column.cta_link) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: column.cta_link.url,
                                    className: "".concat(getCTAclass(column.cta_style), " inline-block text-[14px] leading-[22px] ").concat((column === null || column === void 0 ? void 0 : column.descriptionFont) || "font-haffer"),
                                    children: column.cta_link.text
                                })
                            ]
                        }, "column-item-".concat(columnIdx));
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-5 flex px-4 lg:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "three-up__arrow three-up__arrow--mobile three-up__arrow--prev",
                        onClick: prev,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "11",
                            height: "17",
                            viewBox: "0 0 11 17",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M8.75 2L2.25 8.5L8.75 15",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "square"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "three-up__arrow three-up__arrow--mobile three-up__arrow--next -ml-px",
                        onClick: next,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "11",
                            height: "17",
                            viewBox: "0 0 11 17",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M2.25 2L8.75 8.5L2.25 15",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "square"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
ThreeUp.displayName = "ThreeUp";
ThreeUp.Schema = {
    category: "Modules",
    label: ThreeUp.displayName,
    key: "ThreeUp",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "bgColor",
            label: "Background Color",
            component: "select",
            description: "For section background color, select one from preselected brand colors.",
            options: [
                {
                    label: "Black",
                    value: "bg-black"
                },
                {
                    label: "White",
                    value: "bg-white"
                },
                {
                    label: "Grey",
                    value: "bg-grey-1"
                },
                {
                    label: "Light Grey",
                    value: "bg-grey-9"
                },
                {
                    label: "Blue 1",
                    value: "bg-quinary-1"
                },
                {
                    label: "Blue 2",
                    value: "bg-quinary-2"
                },
                {
                    label: "Blue 3",
                    value: "bg-light-blue"
                },
                {
                    label: "Cream 1",
                    value: "bg-tertiary-2"
                },
                {
                    label: "Cream 2",
                    value: "bg-senary-4"
                },
                {
                    label: "Purple",
                    value: "bg-tertiary-1"
                },
                {
                    label: "Green",
                    value: "bg-quaternary-1"
                },
                {
                    label: "Pink 1",
                    value: "bg-primary-2"
                },
                {
                    label: "Pink 2",
                    value: "bg-secondary-1"
                },
                {
                    label: "Yellow",
                    value: "bg-yellow"
                },
                {
                    label: "Orange",
                    value: "bg-secondary-2"
                },
                {
                    label: "Seafoam 1",
                    value: "bg-quaternary-2"
                },
                {
                    label: "Seafoam 2",
                    value: "bg-senary-3"
                },
                {
                    label: "Seafoam 3",
                    value: "bg-senary-5"
                },
                {
                    label: "Air Dry Cream",
                    value: "bg-stylers-1"
                },
                {
                    label: "Sculpting Cream",
                    value: "bg-stylers-2"
                },
                {
                    label: "Texture Foam",
                    value: "bg-stylers-3"
                },
                {
                    label: "Sleek Stick",
                    value: "bg-stylers-4"
                }
            ],
            defaultValue: "bg-white"
        },
        {
            name: "fgColor",
            label: "Foreground Color",
            component: "select",
            description: "For section foreground color, select one from preselected brand colors.",
            options: [
                {
                    label: "White",
                    value: "text-white"
                },
                {
                    label: "Dark",
                    value: "text-black"
                }, 
            ],
            defaultValue: "text-black"
        },
        {
            name: "intro",
            label: "Intro Title",
            component: "text"
        },
        {
            name: "introFont",
            label: "Intro Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the intro text"
        },
        {
            name: "heading",
            label: "Heading",
            component: "text"
        },
        {
            name: "headingFont",
            label: "Heading Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the heading text"
        },
        {
            name: "body",
            label: "Body",
            component: "textarea"
        },
        {
            name: "bodyFont",
            label: "Body Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the body text"
        },
        {
            name: "columns",
            label: "Columns",
            component: "group-list",
            fields: [
                {
                    name: "image",
                    label: "Image",
                    component: "image",
                    description: "Recommended Image Size: 864px x 1022px"
                },
                {
                    name: "image_alt",
                    label: "Image alt text",
                    component: "text"
                },
                {
                    name: "title",
                    label: "Title",
                    component: "text"
                },
                {
                    name: "titleFont",
                    label: "Title Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the title text"
                },
                {
                    name: "description",
                    label: "Description",
                    component: "textarea"
                },
                {
                    name: "descriptionFont",
                    label: "Description Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the description text"
                },
                {
                    name: "cta_link",
                    label: "CTA Link",
                    component: "link"
                },
                {
                    name: "cta_style",
                    label: "CTA Link Style",
                    component: "select",
                    options: [
                        {
                            label: "Primary",
                            value: "primary"
                        },
                        {
                            label: "Secondary",
                            value: "secondary"
                        },
                        {
                            label: "Tertiary",
                            value: "tertiary"
                        },
                        {
                            label: "Focus Link",
                            value: "link"
                        },
                        {
                            label: "Focus Link White",
                            value: "white-link"
                        }, 
                    ],
                    defaultValue: "link"
                }, 
            ]
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/ThreeUp/index.js


;// CONCATENATED MODULE: ./src/sections/ImageWithText/ImageWithText.jsx




function ImageWithText(param) {
    var cms = param.cms;
    var ref, ref1;
    var desktopImage = (cms === null || cms === void 0 ? void 0 : cms.image_d) ? cms.image_d : cms.image_m;
    var mobileImage = (cms === null || cms === void 0 ? void 0 : cms.image_m) ? cms.image_m : cms.image_d;
    var desktopVideo = (cms === null || cms === void 0 ? void 0 : cms.video_d) ? cms.video_d : cms.video_m;
    var mobileVideo = (cms === null || cms === void 0 ? void 0 : cms.video_m) ? cms.video_m : cms.video_d;
    var getVideoExt = function(url) {
        if (url.match(/\.webm/i)) {
            return "video".concat(url.match(/\.webm/i)[0].replace(".", "/").toLowerCase());
        }
        if (url.match(/\.mp4/i)) {
            return "video".concat(url.match(/\.mp4/i)[0].replace(".", "/").toLowerCase());
        }
        return "";
    };
    var getCTAclass = function(style) {
        if (style === "link") return "focus-link";
        if (style === "white-link") return "focus-link-white";
        if (style === "primary") return "no-underline button button--primary";
        if (style === "secondary") return "no-underline button button--secondary";
        if (style === "tertiary") return "no-underline button button--tertiary";
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(ImageWithText.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": ImageWithText.displayName,
        className: "image-w-text flex flex-wrap ".concat(cms.bgColor, " ").concat(cms.fgColor),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(ImageWithText.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(ImageWithText.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full lg:w-1/2 ".concat(cms.image_first ? "lg:order-first" : "lg:order-last"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:relative lg:w-full lg:pt-[100%]",
                    style: {
                        aspectRatio: cms.aspect_ratio_m
                    },
                    children: [
                        desktopVideo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            className: "absolute inset-0 hidden h-full w-full object-cover lg:block",
                            playsInline: true,
                            preload: "true",
                            loop: true,
                            autoPlay: true,
                            muted: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: desktopVideo,
                                    type: "".concat(getVideoExt(desktopVideo))
                                }),
                                "Video Not Found"
                            ]
                        }),
                        mobileVideo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            className: "w-full lg:hidden",
                            playsInline: true,
                            preload: "true",
                            loop: true,
                            autoPlay: true,
                            muted: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: mobileVideo,
                                    type: "".concat(getVideoExt(mobileVideo))
                                }),
                                "Video Not Found"
                            ]
                        }),
                        !desktopVideo && desktopImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "absolute inset-0 hidden h-full w-full object-cover lg:block",
                            src: "".concat(desktopImage.src, "?quality=75"),
                            alt: cms === null || cms === void 0 ? void 0 : cms.image_alt,
                            loading: "lazy",
                            width: "1440",
                            height: "1440"
                        }),
                        !mobileVideo && mobileImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "w-full lg:hidden",
                            src: "".concat(mobileImage.src, "?quality=75"),
                            alt: cms === null || cms === void 0 ? void 0 : cms.image_alt,
                            loading: "lazy",
                            width: "1536",
                            height: "1114"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full lg:w-1/2 ".concat(cms.image_first ? "lg:order-last" : "lg:order-first", " px-4 py-12 lg:flex lg:items-center lg:px-12 lg:py-10 2xl:px-[126px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(cms.text_align, " mx-auto max-w-[440px] lg:ml-0 lg:text-left"),
                    children: [
                        (cms === null || cms === void 0 ? void 0 : cms.intro) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: "mb-4 ".concat((cms === null || cms === void 0 ? void 0 : cms.introFont) || ""),
                            children: cms.intro
                        }),
                        (cms === null || cms === void 0 ? void 0 : cms.heading) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-header mb-4 ".concat((cms === null || cms === void 0 ? void 0 : cms.headingFont) || ""),
                            children: cms.heading
                        }),
                        (cms === null || cms === void 0 ? void 0 : cms.body) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-6 text-base ".concat((cms === null || cms === void 0 ? void 0 : cms.bodyFont) || "", " font-light 2xl:mb-8 2xl:text-[18px] 2xl:leading-[26px]"),
                            dangerouslySetInnerHTML: {
                                __html: (0,Helper/* newLineToBr */.td)(cms.body)
                            }
                        }),
                        (cms === null || cms === void 0 ? void 0 : (ref = cms.cta_link) === null || ref === void 0 ? void 0 : ref.text) && (cms === null || cms === void 0 ? void 0 : (ref1 = cms.cta_link) === null || ref1 === void 0 ? void 0 : ref1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: cms.cta_link.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "".concat(getCTAclass(cms.cta_style), " inline-block cursor-pointer text-base"),
                                children: cms.cta_link.text
                            })
                        }),
                        (cms === null || cms === void 0 ? void 0 : cms.npr_link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            src: cms.npr_link,
                            title: "NPR embedded audio player",
                            width: "100%",
                            height: "200",
                            frameBorder: "0",
                            scrolling: "no",
                            className: "mt-6 2xl:mt-8"
                        })
                    ]
                })
            })
        ]
    });
}
ImageWithText.displayName = "ImageWithText";
ImageWithText.Schema = {
    category: "Modules",
    label: ImageWithText.displayName,
    key: "ImageWithText",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "bgColor",
            label: "Background Color",
            component: "select",
            description: "For section background color, select one from preselected brand colors.",
            options: [
                {
                    label: "Black",
                    value: "bg-black"
                },
                {
                    label: "White",
                    value: "bg-white"
                },
                {
                    label: "Grey",
                    value: "bg-grey-1"
                },
                {
                    label: "Light Grey",
                    value: "bg-grey-9"
                },
                {
                    label: "Blue 1",
                    value: "bg-quinary-1"
                },
                {
                    label: "Blue 2",
                    value: "bg-quinary-2"
                },
                {
                    label: "Blue 3",
                    value: "bg-light-blue"
                },
                {
                    label: "Cream 1",
                    value: "bg-tertiary-2"
                },
                {
                    label: "Cream 2",
                    value: "bg-senary-4"
                },
                {
                    label: "Purple",
                    value: "bg-tertiary-1"
                },
                {
                    label: "Green",
                    value: "bg-quaternary-1"
                },
                {
                    label: "Pink 1",
                    value: "bg-primary-2"
                },
                {
                    label: "Pink 2",
                    value: "bg-secondary-1"
                },
                {
                    label: "Yellow",
                    value: "bg-yellow"
                },
                {
                    label: "Orange",
                    value: "bg-secondary-2"
                },
                {
                    label: "Seafoam 1",
                    value: "bg-quaternary-2"
                },
                {
                    label: "Seafoam 2",
                    value: "bg-senary-3"
                },
                {
                    label: "Seafoam 3",
                    value: "bg-senary-5"
                },
                {
                    label: "Air Dry Cream",
                    value: "bg-stylers-1"
                },
                {
                    label: "Sculpting Cream",
                    value: "bg-stylers-2"
                },
                {
                    label: "Texture Foam",
                    value: "bg-stylers-3"
                },
                {
                    label: "Sleek Stick",
                    value: "bg-stylers-4"
                },
                {
                    label: "Scalp Blue",
                    value: "bg-scalp-blue"
                },
                {
                    label: "Magenta",
                    value: "bg-magenta"
                },
                {
                    label: "Medium Pink",
                    value: "bg-med-pink"
                },
                {
                    label: "Briogeo Blue",
                    value: "bg-brio-blue"
                },
                {
                    label: "Cloud",
                    value: "bg-cloud"
                },
                {
                    label: "Mineral",
                    value: "bg-mineral"
                },
                {
                    label: "Deep Sea",
                    value: "bg-deep-sea"
                },
                {
                    label: "Sandstone",
                    value: "bg-sandstone"
                },
                {
                    label: "Sorrel",
                    value: "bg-sorrel"
                },
                {
                    label: "Butter",
                    value: "bg-butter"
                },
                {
                    label: "Rosehip",
                    value: "bg-rosehip"
                },
                {
                    label: "Chestnut",
                    value: "bg-chestnut"
                }, 
            ],
            defaultValue: "bg-white"
        },
        {
            name: "fgColor",
            label: "Foreground Color",
            component: "select",
            description: "For section foreground color, select one from preselected brand colors.",
            options: [
                {
                    label: "White",
                    value: "text-white"
                },
                {
                    label: "Dark",
                    value: "text-black"
                }, 
            ],
            defaultValue: "text-black"
        },
        {
            name: "image_first",
            label: "Image First?",
            component: "toggle",
            description: "This toggle effects on desktop view only",
            toggleLabels: {
                true: "Yes",
                false: "No"
            },
            defaultValue: true
        },
        {
            name: "image_d",
            label: "Image (Desktop)",
            component: "image",
            description: "Recommended Image Size: 1440px x 1440px"
        },
        {
            name: "image_m",
            label: "Image (Mobile)",
            component: "image",
            description: "Recommended Image Size: 1536px x 1114px"
        },
        {
            name: "image_alt",
            label: "Image alt text",
            component: "text"
        },
        {
            name: "video_d",
            label: "Video URL (Desktop)",
            component: "text",
            description: "Video media will need to be provided in 2 formats: webm as default and mp4 for IOS/safari fall-back"
        },
        {
            name: "video_m",
            label: "Video URL (Mobile)",
            component: "text",
            description: "Video media will need to be provided in 2 formats: webm as default and mp4 for IOS/safari fall-back"
        },
        {
            name: "aspect_ratio_m",
            label: "Image Aspect Ratio (Mobile)",
            description: 'Required only when a video is set on mobile layout. Width divided by height, e.g. 16:9 image is "1.78"',
            component: "number"
        },
        {
            name: "intro",
            label: "Intro Title",
            component: "text"
        },
        {
            name: "introFont",
            label: "Intro Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the intro text"
        },
        {
            name: "heading",
            label: "Heading",
            component: "text"
        },
        {
            name: "headingFont",
            label: "Heading Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the heading text"
        },
        {
            name: "body",
            label: "Body",
            component: "textarea"
        },
        {
            name: "bodyFont",
            label: "Body Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the body text"
        },
        {
            name: "cta_link",
            label: "CTA Link",
            component: "link"
        },
        {
            name: "cta_style",
            label: "CTA Link Style",
            component: "select",
            options: [
                {
                    label: "Primary",
                    value: "primary"
                },
                {
                    label: "Secondary",
                    value: "secondary"
                },
                {
                    label: "Tertiary",
                    value: "tertiary"
                },
                {
                    label: "Focus Link",
                    value: "link"
                },
                {
                    label: "Focus Link White",
                    value: "white-link"
                }, 
            ],
            defaultValue: "link"
        },
        {
            name: "npr_link",
            label: "NPR Link",
            component: "text",
            description: "Example for NPR link is https://www.npr.org/player/embed/900303741/900327675"
        },
        {
            name: "text_align",
            label: "Mobile Text Align",
            component: "select",
            options: [
                {
                    label: "Left Align",
                    value: "text-left"
                },
                {
                    label: "Center Align",
                    value: "text-center"
                }, 
            ],
            defaultValue: "text-center"
        }, 
    ]
};

// EXTERNAL MODULE: ./src/snippets/globals/layout/ProductPrice.jsx
var ProductPrice = __webpack_require__(13491);
;// CONCATENATED MODULE: ./src/sections/Hero/Hero.jsx










function Hero_Section(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var ref19 = (0,react.useState)(null), heroProduct = ref19[0], setHeroProduct = ref19[1];
    var cart = (0,dist.useCart)();
    var is_desktop = vpWidth > 640;
    var headingTag = cms.headingTag, introHeading_m = cms.introHeading_m, heading_m = cms.heading_m, description_m = cms.description_m, _aboveTheFold = cms.aboveTheFold, aboveTheFold = _aboveTheFold === void 0 ? false : _aboveTheFold;
    var image_d = cms === null || cms === void 0 ? void 0 : (ref = cms.background_d) === null || ref === void 0 ? void 0 : ref.src;
    var image_m = cms === null || cms === void 0 ? void 0 : (ref1 = cms.background_m) === null || ref1 === void 0 ? void 0 : ref1.src;
    var image_alt = cms.image_alt, introHeading = cms.introHeading, introHeadingSize = cms.introHeadingSize, introHeadingSize_m = cms.introHeadingSize_m, heading = cms.heading, headingSize = cms.headingSize, headingSize_m = cms.headingSize_m, description = cms.description, descriptionSize = cms.descriptionSize, descriptionSize_m = cms.descriptionSize_m, productData = cms.productData, cta1 = cms.cta1, cta2 = cms.cta2, sectionTitleFont = cms.sectionTitleFont, introHeadingFont_d = cms.introHeadingFont, introHeadingFont_m = cms.introHeadingFont_m, headingFont_d = cms.headingFont, headingFont_m = cms.headingFont_m, descriptionFont_d = cms.descriptionFont, descriptionFont_m = cms.descriptionFont_m;
    if (introHeading_m && !is_desktop) {
        introHeading = introHeading_m;
    }
    if (heading_m && !is_desktop) {
        heading = heading_m;
    }
    if (description_m && !is_desktop) {
        description = description_m;
    }
    var introHeadingFont = "".concat(introHeadingFont_m || "max-sm:font-hafferBold", " ").concat(introHeadingFont_d || "sm:font-hafferBold");
    var headingFont = "".concat(headingFont_m || "max-sm:font-tiempos italic", " ").concat(headingFont_d || "sm:font-tiempos italic");
    var descriptionFont = "".concat(descriptionFont_m || "max-sm:font-haffer", " ").concat(descriptionFont_d || "sm:font-haffer");
    var box_h_position = cms.box_h_position, box_v_position = cms.box_v_position, box_h_padding = cms.box_h_padding, box_h_position_m = cms.box_h_position_m, box_v_position_m = cms.box_v_position_m, textAlign = cms.textAlign, textAlign_m = cms.textAlign_m, textColor = cms.textColor, textColor_m = cms.textColor_m, overrides = cms.overrides;
    var video_d = cms.video_d, video_m = cms.video_m;
    var isFullwidth = (cms === null || cms === void 0 ? void 0 : cms.isFullwidth) || false;
    var applicableOverride = (0,Helper/* getApplicableOverride */.Nx)(cart, overrides);
    if (applicableOverride === null || applicableOverride === void 0 ? void 0 : applicableOverride.length) {
        var ref20, ref21, ref22;
        image_d = (ref20 = applicableOverride[0].background_d) === null || ref20 === void 0 ? void 0 : ref20.src;
        image_m = (ref21 = applicableOverride[0].background_m) === null || ref21 === void 0 ? void 0 : ref21.src;
        image_alt = applicableOverride[0].image_alt;
        introHeading = (ref22 = applicableOverride[0]) === null || ref22 === void 0 ? void 0 : ref22.introHeading;
        heading = applicableOverride[0].heading;
        description = applicableOverride[0].description;
        cta1 = applicableOverride[0].cta1;
        cta2 = applicableOverride[0].cta2;
        introHeadingSize = applicableOverride[0].introHeadingSize;
        introHeadingSize_m = applicableOverride[0].introHeadingSize_m;
        headingSize = applicableOverride[0].headingSize;
        headingSize_m = applicableOverride[0].headingSize_m;
        descriptionSize = applicableOverride[0].descriptionSize;
        descriptionSize_m = applicableOverride[0].descriptionSize_m;
        introHeadingFont_d = applicableOverride[0].introHeadingFont;
        introHeadingFont_m = applicableOverride[0].introHeadingFont_m;
        headingFont_d = applicableOverride[0].headingFont;
        headingFont_m = applicableOverride[0].headingFont_m;
        descriptionFont_d = applicableOverride[0].descriptionFont;
        descriptionFont_m = applicableOverride[0].descriptionFont_m;
        introHeadingFont = "".concat(introHeadingFont_m || "max-sm:font-hafferBold", " ").concat(introHeadingFont_d || "sm:font-hafferBold");
        headingFont = "".concat(headingFont_m || "max-sm:font-hafferBold", " ").concat(headingFont_d || "sm:font-hafferBold");
        descriptionFont = "".concat(descriptionFont_m || "max-sm:font-haffer", " ").concat(descriptionFont_d || "sm:font-haffer");
        if (applicableOverride[0].introHeading_m && !is_desktop) {
            introHeading = applicableOverride[0].introHeading_m;
        }
        if (applicableOverride[0].heading_m && !is_desktop) {
            heading = applicableOverride[0].heading_m;
        }
        if (applicableOverride[0].description_m && !is_desktop) {
            description = applicableOverride[0].description_m;
        }
    }
    var fetchProductByHandle = (0,dist.useProductByHandle)().fetchProductByHandle;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var has_video_d = (video_d === null || video_d === void 0 ? void 0 : video_d.url_mp4) || (video_d === null || video_d === void 0 ? void 0 : video_d.url_webm);
    var has_video_m = (video_m === null || video_m === void 0 ? void 0 : video_m.url_mp4) || (video_m === null || video_m === void 0 ? void 0 : video_m.url_webm);
    var has_cta1 = cta1 && (cta1 === null || cta1 === void 0 ? void 0 : (ref2 = cta1.link) === null || ref2 === void 0 ? void 0 : ref2.url) && (cta1 === null || cta1 === void 0 ? void 0 : (ref3 = cta1.link) === null || ref3 === void 0 ? void 0 : ref3.text);
    var has_cta2 = cta2 && (cta2 === null || cta2 === void 0 ? void 0 : (ref4 = cta2.link) === null || ref4 === void 0 ? void 0 : ref4.url) && (cta2 === null || cta2 === void 0 ? void 0 : (ref5 = cta2.link) === null || ref5 === void 0 ? void 0 : ref5.text);
    var has_cta1_withoutText = cta1 && (cta1 === null || cta1 === void 0 ? void 0 : (ref6 = cta1.link) === null || ref6 === void 0 ? void 0 : ref6.url);
    var has_cta2_withoutText = cta2 && (cta2 === null || cta2 === void 0 ? void 0 : (ref7 = cta2.link) === null || ref7 === void 0 ? void 0 : ref7.url);
    var refVideo = (0,react.useRef)(null);
    var refHero = (0,react.useRef)(null);
    var headingHtml = "<".concat(headingTag, ' class="m-0 ').concat(headingSize_m, " ").concat(headingSize, " font-normal ").concat(headingFont, " ").concat(textColor_m, " ").concat(textColor, '">').concat(heading, "</").concat(headingTag, ">");
    (0,react.useEffect)(function() {
        if (!refHero.current) return;
        var heroMedia = refHero.current.querySelector(".hero__media-container");
        var heroContent = refHero.current.querySelector(".hero__content");
        if (heroMedia) heroMedia.style.removeProperty("height");
        if (heroMedia && heroContent) {
            if (heroContent.offsetHeight > heroMedia.offsetHeight) {
                heroMedia.style.height = "".concat(heroContent.offsetHeight, "px");
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        if (productData === null || productData === void 0 ? void 0 : productData.product) {
            fetchProductByHandle({
                handle: productData.product.handle
            }).then(function(product) {
                setHeroProduct(product);
            });
        } else {
            setHeroProduct(null);
        }
    }, [
        productData === null || productData === void 0 ? void 0 : (ref8 = productData.product) === null || ref8 === void 0 ? void 0 : ref8.handle
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(Hero_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": Hero_Section.displayName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(Hero_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(Hero_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            (cms === null || cms === void 0 ? void 0 : cms.uniqueId) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: cms.uniqueId
            }),
            (cms === null || cms === void 0 ? void 0 : cms.section_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mx-4 lg:mx-0 mt-0 mb-4 text-h3-m md:text-h4 lg:mb-6 ".concat(sectionTitleFont || ""),
                children: cms === null || cms === void 0 ? void 0 : cms.section_title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative z-0 w-full".concat(isFullwidth ? "" : " container"),
                ref: refHero,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hero__media-container pointer-events-none !h-full w-full lg:!h-auto",
                        children: [
                            !has_video_m && image_m ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative sm:hidden",
                                style: {
                                    aspectRatio: cms.aspect_ratio_m
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: image_m,
                                    className: "absolute inset-0 h-full w-full",
                                    loading: aboveTheFold ? "eager" : "lazy",
                                    fill: true,
                                    sizes: "100vw",
                                    alt: image_alt,
                                    priority: aboveTheFold,
                                    fetchpriority: aboveTheFold ? "high" : "low"
                                })
                            }) : null,
                            !has_video_d && image_d ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative ".concat(image_m ? "max-sm:hidden" : ""),
                                style: {
                                    aspectRatio: cms.aspect_ratio_d
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: image_d,
                                    className: "absolute inset-0 h-full w-full",
                                    loading: aboveTheFold ? "eager" : "lazy",
                                    fill: true,
                                    sizes: "100vw",
                                    alt: image_alt,
                                    priority: aboveTheFold,
                                    fetchpriority: aboveTheFold ? "high" : "low"
                                })
                            }) : null,
                            has_video_m && /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                className: "hero__background h-full w-full object-cover sm:hidden",
                                preload: "auto",
                                autoPlay: true,
                                muted: true,
                                loop: true,
                                playsInline: true,
                                ref: refVideo,
                                style: {
                                    aspectRatio: video_m === null || video_m === void 0 ? void 0 : video_m.aspect_ratio
                                },
                                poster: video_m === null || video_m === void 0 ? void 0 : (ref9 = video_m.poster) === null || ref9 === void 0 ? void 0 : ref9.src,
                                children: [
                                    (video_m === null || video_m === void 0 ? void 0 : video_m.url_webm) && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: video_m === null || video_m === void 0 ? void 0 : video_m.url_webm,
                                        type: "video/webm"
                                    }),
                                    (video_m === null || video_m === void 0 ? void 0 : video_m.url_mp4) && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: video_m === null || video_m === void 0 ? void 0 : video_m.url_mp4,
                                        type: "video/mp4"
                                    })
                                ]
                            }),
                            has_video_d && /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                className: "hero__background h-full w-full object-cover ".concat(has_video_m ? "max-sm:hidden" : ""),
                                preload: "auto",
                                autoPlay: true,
                                muted: true,
                                loop: true,
                                playsInline: true,
                                ref: refVideo,
                                style: {
                                    aspectRatio: video_d === null || video_d === void 0 ? void 0 : video_d.aspect_ratio
                                },
                                poster: video_d === null || video_d === void 0 ? void 0 : (ref10 = video_d.poster) === null || ref10 === void 0 ? void 0 : ref10.src,
                                children: [
                                    (video_d === null || video_d === void 0 ? void 0 : video_d.url_webm) && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: video_d === null || video_d === void 0 ? void 0 : video_d.url_webm,
                                        type: "video/webm"
                                    }),
                                    (video_d === null || video_d === void 0 ? void 0 : video_d.url_mp4) && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: video_d === null || video_d === void 0 ? void 0 : video_d.url_mp4,
                                        type: "video/mp4"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute left-0 top-0 flex h-full w-full ".concat(box_v_position, " ").concat(box_v_position_m, " z-1"),
                        children: [
                            (introHeading || heading || description || has_cta1 || has_cta2) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hero__content sm-:py-20 container flex px-4 py-11 md:px-12 ".concat(box_h_padding, " ").concat(box_h_position, " ").concat(box_h_position_m),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "hero__block w-full max-w-[325px] overflow-hidden lg+:max-w-[432px] ".concat(textAlign_m, " ").concat(textAlign),
                                    children: [
                                        introHeading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "hero__intro-title mt-0 mb-4 ".concat(introHeadingFont, " ").concat(introHeadingSize_m, " font-normal ").concat(introHeadingSize, " ").concat(textColor_m, " ").concat(textColor),
                                            children: introHeading
                                        }) : null,
                                        heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: headingHtml
                                            },
                                            className: "hero__title mt-0 mb-3 lg:mb-4 ".concat(textColor_m, " ").concat(textColor)
                                        }),
                                        description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-normal ".concat(descriptionFont, " ").concat(descriptionSize_m, " ").concat(descriptionSize, " ").concat(textColor_m, " ").concat(textColor),
                                            dangerouslySetInnerHTML: {
                                                __html: (0,Helper/* newLineToBr */.td)(description)
                                            }
                                        }) : null,
                                        heroProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
                                            variant: heroProduct.variants[0],
                                            className: "mt-4 ".concat(descriptionFont, " ").concat(textColor_m, " ").concat(textColor),
                                            compareStyles: "opacity-70 text-currentcolor"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "hero__buttons z-2 relative mt-6 inline-block w-full max-w-[225px] ".concat(descriptionFont),
                                            children: [
                                                heroProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    className: "button ".concat(productData.style, " whitespace-nowrap ").concat((has_cta1 || has_cta2) && "mb-4"),
                                                    onClick: function() {
                                                        return cartAddItem({
                                                            merchandiseId: heroProduct.variants[0].id,
                                                            quantity: 1,
                                                            attributes: [
                                                                {
                                                                    key: "_sc",
                                                                    value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                                                                }
                                                            ]
                                                        }).then(function() {
                                                            window.dispatchEvent(new CustomEvent("openSideCart"));
                                                        });
                                                    },
                                                    children: [
                                                        "buy now",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "ml-1",
                                                            children: [
                                                                "-",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
                                                                    variant: heroProduct.variants[0],
                                                                    className: "ml-1 inline-block",
                                                                    compareStyles: "text-currentcolor"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                has_cta1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt-0 ".concat(has_cta2 ? "mb-4" : "mb-0"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: cta1 === null || cta1 === void 0 ? void 0 : (ref11 = cta1.link) === null || ref11 === void 0 ? void 0 : ref11.url,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "".concat(cta1 === null || cta1 === void 0 ? void 0 : cta1.style, " text-center no-underline"),
                                                            children: cta1 === null || cta1 === void 0 ? void 0 : (ref12 = cta1.link) === null || ref12 === void 0 ? void 0 : ref12.text
                                                        })
                                                    })
                                                }) : null,
                                                has_cta2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "m-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: cta2 === null || cta2 === void 0 ? void 0 : (ref13 = cta2.link) === null || ref13 === void 0 ? void 0 : ref13.url,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "".concat(cta2 === null || cta2 === void 0 ? void 0 : cta2.style, " text-center no-underline"),
                                                            children: cta2 === null || cta2 === void 0 ? void 0 : (ref14 = cta2.link) === null || ref14 === void 0 ? void 0 : ref14.text
                                                        })
                                                    })
                                                }) : null
                                            ]
                                        }),
                                        heroProduct && (productData === null || productData === void 0 ? void 0 : productData.showMoreInfo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hero__read-more ".concat(descriptionFont, " ").concat(textColor_m, " ").concat(textColor, " mt-4"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/products/".concat(heroProduct.handle),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "focus-link !text-currentcolor !border-currentcolor",
                                                    children: "learn more"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            has_cta1_withoutText && !has_cta2_withoutText || !has_cta1_withoutText && has_cta2_withoutText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    has_cta1_withoutText ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: cta1 === null || cta1 === void 0 ? void 0 : (ref15 = cta1.link) === null || ref15 === void 0 ? void 0 : ref15.url,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "z-1 absolute left-0 top-0 h-full w-full ".concat(textColor_m, " ").concat(textColor),
                                            "aria-label": cta1 === null || cta1 === void 0 ? void 0 : (ref16 = cta1.link) === null || ref16 === void 0 ? void 0 : ref16.text
                                        })
                                    }) : null,
                                    has_cta2_withoutText ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: cta2 === null || cta2 === void 0 ? void 0 : (ref17 = cta2.link) === null || ref17 === void 0 ? void 0 : ref17.url,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "z-1 absolute left-0 top-0 h-full w-full ".concat(textColor_m, " ").concat(textColor),
                                            "aria-label": cta2 === null || cta2 === void 0 ? void 0 : (ref18 = cta2.link) === null || ref18 === void 0 ? void 0 : ref18.text
                                        })
                                    }) : null
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
}
Hero_Section.displayName = "Hero";
Hero_Section.Schema = {
    category: "Modules",
    label: Hero_Section.displayName,
    key: "hero",
    fields: [
        {
            name: "section_title",
            label: "Title",
            component: "text"
        },
        {
            name: "sectionTitleFont",
            label: "Section Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section title text"
        },
        {
            name: "uniqueId",
            label: "Unique ID",
            component: "text",
            description: "use for anchor links"
        },
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "toggle",
            name: "isFullwidth",
            label: "Full Width",
            toggleLabels: {
                true: "Full Width",
                false: "Grid width"
            },
            defaultValue: true
        },
        {
            component: "toggle",
            name: "aboveTheFold",
            label: "Above the fold",
            toggleLabels: {
                true: "Yes",
                false: "No"
            },
            defaultValue: false
        },
        {
            name: "background_d",
            label: "Background Image (Desktop)",
            component: "image",
            description: "Recommended Image Size: 2880px x 1340px (height can be variable)"
        },
        {
            name: "aspect_ratio_d",
            label: "Image Aspect Ratio (Desktop)",
            description: 'Width divided by height, e.g. 16:9 image is "1.78"',
            component: "number"
        },
        {
            name: "background_m",
            label: "Background Image (Mobile)",
            component: "image",
            description: "Recommended Image Size: 750px x 1400px (height can be variable)"
        },
        {
            name: "aspect_ratio_m",
            label: "Image Aspect Ratio (Mobile)",
            description: 'Width divided by height, e.g. 16:9 image is "1.78"',
            component: "number"
        },
        {
            name: "image_alt",
            label: "Image alt text",
            component: "text"
        },
        {
            label: "Background Video (Desktop)",
            name: "video_d",
            component: "group",
            fields: [
                {
                    name: "aspect_ratio",
                    label: "Aspect Ratio",
                    description: 'Width divided by height, e.g. 16:9 video is "1.78"',
                    component: "number"
                },
                {
                    name: "url_mp4",
                    label: "Mp4 Video URL",
                    component: "text"
                },
                {
                    name: "url_webm",
                    label: "Webm Video URL",
                    component: "text"
                },
                {
                    name: "poster",
                    label: "Poster Image",
                    component: "image",
                    description: "First frame of the video while video loads"
                }, 
            ]
        },
        {
            label: "Background Video (Mobile)",
            name: "video_m",
            component: "group",
            fields: [
                {
                    name: "aspect_ratio",
                    label: "Aspect Ratio",
                    description: 'Width divided by height, e.g. 16:9 video is "1.78"',
                    component: "number"
                },
                {
                    name: "url_mp4",
                    label: "Mp4 Video URL",
                    component: "text"
                },
                {
                    name: "url_webm",
                    label: "Webm Video URL",
                    component: "text"
                },
                {
                    name: "poster",
                    label: "Poster Image",
                    component: "image",
                    description: "First frame of the video while video loads"
                }, 
            ]
        },
        {
            component: "select",
            name: "box_v_position",
            label: "Content Block Vertical Position (Desktop)",
            options: [
                {
                    label: "Top",
                    value: "sm:items-start"
                },
                {
                    label: "Middle",
                    value: "sm:items-center"
                },
                {
                    label: "Bottom",
                    value: "sm:items-end"
                }, 
            ],
            defaultValue: "sm:items-start"
        },
        {
            component: "select",
            name: "box_h_position",
            label: "Content Block Horizontal Position (Desktop)",
            options: [
                {
                    label: "Left",
                    value: "sm:justify-start md:pr-12"
                },
                {
                    label: "Center",
                    value: "sm:justify-center md:px-12"
                },
                {
                    label: "Right",
                    value: "sm:justify-end md:pl-12"
                }, 
            ],
            defaultValue: "sm:justify-start md:pr-12"
        },
        {
            component: "select",
            name: "box_h_padding",
            label: "Content Block Horizontal Padding (Desktop)",
            options: [
                {
                    label: "Small",
                    value: "md:px-12"
                },
                {
                    label: "Normal",
                    value: "md:px-[114px]"
                }, 
            ],
            defaultValue: "md:px-[114px]"
        },
        {
            component: "select",
            name: "textAlign",
            label: "Text Align (Desktop)",
            options: [
                {
                    label: "Left",
                    value: "sm:text-left"
                },
                {
                    label: "Center",
                    value: "sm:text-center"
                },
                {
                    label: "Right",
                    value: "sm:text-right"
                }, 
            ],
            defaultValue: "sm:text-left"
        },
        {
            component: "select",
            name: "textColor",
            label: "Text Color (Desktop)",
            options: [
                {
                    label: "Light",
                    value: "sm:text-white"
                },
                {
                    label: "Dark",
                    value: "sm:text-black"
                }, 
            ],
            defaultValue: "sm:text-black"
        },
        {
            component: "select",
            name: "box_v_position_m",
            label: "Content Block Vertical Position (Mobile)",
            options: [
                {
                    label: "Top",
                    value: "items-start"
                },
                {
                    label: "Middle",
                    value: "items-center"
                },
                {
                    label: "Bottom",
                    value: "items-end"
                }, 
            ],
            defaultValue: "items-start"
        },
        {
            component: "select",
            name: "box_h_position_m",
            label: "Content Block Horizontal Position (Mobile)",
            options: [
                {
                    label: "Left",
                    value: "justify-start"
                },
                {
                    label: "Center",
                    value: "justify-center"
                },
                {
                    label: "Right",
                    value: "justify-end"
                }, 
            ],
            defaultValue: "justify-start"
        },
        {
            component: "select",
            name: "textAlign_m",
            label: "Text Align (Mobile)",
            options: [
                {
                    label: "Left",
                    value: "text-left"
                },
                {
                    label: "Center",
                    value: "text-center"
                },
                {
                    label: "Right",
                    value: "text-right"
                }, 
            ],
            defaultValue: "text-left"
        },
        {
            component: "select",
            name: "textColor_m",
            label: "Text Color (Mobile)",
            options: [
                {
                    label: "Light",
                    value: "text-white"
                },
                {
                    label: "Dark",
                    value: "text-black"
                }, 
            ],
            defaultValue: "text-black"
        },
        {
            component: "select",
            name: "headingTag",
            label: "Heading Tag",
            options: [
                {
                    label: "H1",
                    value: "h1"
                },
                {
                    label: "H2",
                    value: "h2"
                },
                {
                    label: "H3",
                    value: "h3"
                }, 
            ],
            defaultValue: "h2",
            description: "If the section is first then the heading should be an H1 tag. Note: Heading styles will be the same no matter what the tag value is. This is for ADA + SEO."
        },
        {
            name: "introHeading",
            label: "Intro Heading (Desktop)",
            component: "text",
            defaultValue: "Optional intro title here"
        },
        {
            name: "introHeadingFont",
            label: "Intro Heading Font",
            component: "select",
            options: desktopFontSelector,
            defaultValue: "sm:font-hafferBold",
            description: "Select the font for the intro heading text"
        },
        {
            name: "introHeadingSize",
            label: "Intro Heading Size (Desktop)",
            component: "select",
            options: [
                {
                    label: "Large",
                    value: "lg+:sub-large"
                },
                {
                    label: "Regular",
                    value: "lg+:sub-regular"
                },
                {
                    label: "Small",
                    value: "lg+:sub-small"
                },
                {
                    label: "Xsmall",
                    value: "lg+:sub-xsmall"
                },
                {
                    label: "Xxsmall",
                    value: "lg+:sub-xxsmall"
                }, 
            ],
            defaultValue: "lg+:sub-large"
        },
        {
            name: "heading",
            label: "Heading (Desktop)",
            component: "text",
            defaultValue: "Clean chemistry. Healthy hair."
        },
        {
            name: "headingFont",
            label: "Heading Font (Desktop)",
            component: "select",
            options: desktopFontSelector,
            defaultValue: "sm:font-tiempos italic",
            description: "Select the font for the heading text"
        },
        {
            name: "headingSize",
            label: "Heading Size (Desktop)",
            component: "select",
            options: [
                {
                    label: "Heading One",
                    value: "lg+:text-h1"
                },
                {
                    label: "Heading Two",
                    value: "lg+:text-h2"
                },
                {
                    label: "Heading Three",
                    value: "lg+:text-h3"
                },
                {
                    label: "Heading Four",
                    value: "lg+:text-h4"
                },
                {
                    label: "Heading Five",
                    value: "lg+:text-h5"
                },
                {
                    label: "Heading Six",
                    value: "lg+:text-h6"
                }, 
            ],
            defaultValue: "lg+:text-h2"
        },
        {
            name: "description",
            label: "Description (Desktop)",
            component: "textarea",
            defaultValue: "We create powerful, naturally-derived solutions that are proven to improve hair\u2019s health, for every type and texture."
        },
        {
            name: "descriptionFont",
            label: "Description Font (Desktop)",
            component: "select",
            options: desktopFontSelector,
            defaultValue: "sm:font-haffer",
            description: "Select the font for the description text"
        },
        {
            name: "descriptionSize",
            label: "Description Size (Desktop)",
            component: "select",
            options: [
                {
                    label: "Text Size One",
                    value: "lg+:text-large"
                },
                {
                    label: "Text Size Two",
                    value: "lg+:text-regular"
                },
                {
                    label: "Text Size Three",
                    value: "lg+:text-small"
                },
                {
                    label: "Text Size Four",
                    value: "lg+:text-xsmall"
                }, 
            ],
            defaultValue: "lg+:text-large"
        },
        {
            name: "introHeading_m",
            label: "Intro Heading (Mobile)",
            component: "text",
            defaultValue: "Optional intro title here"
        },
        {
            name: "introHeadingFont_m",
            label: "Intro Heading Font (Mobile)",
            component: "select",
            options: mobileFontSelector,
            defaultValue: "max-sm:font-haffer",
            description: "Select the font for the intro heading text"
        },
        {
            name: "introHeadingSize_m",
            label: "Intro Heading Size (Mobile)",
            component: "select",
            options: [
                {
                    label: "Large",
                    value: "sub-large"
                },
                {
                    label: "Regular",
                    value: "sub-regular"
                },
                {
                    label: "Small",
                    value: "sub-small"
                },
                {
                    label: "Xsmall",
                    value: "sub-xsmall"
                },
                {
                    label: "Xxsmall",
                    value: "sub-xxsmall"
                }, 
            ],
            defaultValue: "sub-small"
        },
        {
            name: "heading_m",
            label: "Heading (Mobile)",
            component: "text",
            defaultValue: "Clean chemistry. Healthy hair."
        },
        {
            name: "headingFont_m",
            label: "Heading Font (Mobile)",
            component: "select",
            options: mobileFontSelector,
            defaultValue: "max-sm:font-haffer",
            description: "Select the font for the heading text"
        },
        {
            name: "headingSize_m",
            label: "Heading Size (Mobile)",
            component: "select",
            options: [
                {
                    label: "Heading One",
                    value: "text-h1-m"
                },
                {
                    label: "Heading Two",
                    value: "text-h2-m"
                },
                {
                    label: "Heading Three",
                    value: "text-h3-m"
                },
                {
                    label: "Heading Four",
                    value: "text-h4-m"
                },
                {
                    label: "Heading Five",
                    value: "text-h5-m"
                },
                {
                    label: "Heading Six",
                    value: "text-h6-m"
                }, 
            ],
            defaultValue: "text-h1-m"
        },
        {
            name: "description_m",
            label: "Description (Mobile)",
            component: "textarea",
            defaultValue: "We create powerful, naturally-derived solutions that are proven to improve hair\u2019s health, for every type and texture."
        },
        {
            name: "descriptionFont_m",
            label: "Description Font (Mobile)",
            component: "select",
            options: mobileFontSelector,
            defaultValue: "max-sm:font-haffer",
            description: "Select the font for the description text"
        },
        {
            name: "descriptionSize_m",
            label: "Description Size (Mobile)",
            component: "select",
            options: [
                {
                    label: "Text Size One",
                    value: "text-large"
                },
                {
                    label: "Text Size Two",
                    value: "text-regular"
                },
                {
                    label: "Text Size Three",
                    value: "text-small"
                },
                {
                    label: "Text Size Four",
                    value: "text-xsmall"
                }, 
            ],
            defaultValue: "text-regular"
        },
        {
            component: "group",
            name: "productData",
            label: "Product Data",
            description: "Settings related to adding a product button to the hero",
            fields: [
                {
                    component: "productSearch",
                    name: "product",
                    label: "Product",
                    description: "Select a product to turn the hero into a CTA module that adds the product to the cart"
                },
                {
                    component: "select",
                    name: "style",
                    label: "Button Style",
                    options: [
                        {
                            label: "Primary",
                            value: "button button--primary inline-block"
                        },
                        {
                            label: "Primary - Air Dry Cream",
                            value: "button button--primary-stylers-1 inline-block"
                        },
                        {
                            label: "Primary - Sculpting Cream",
                            value: "button button--primary-stylers-2 inline-block"
                        },
                        {
                            label: "Primary - Texture Foam",
                            value: "button button--primary-stylers-3 inline-block"
                        },
                        {
                            label: "Primary - Sleek Stick",
                            value: "button button--primary-stylers-4 inline-block"
                        },
                        {
                            label: "Secondary",
                            value: "button button--secondary inline-block"
                        },
                        {
                            label: "Tertiary",
                            value: "button button--tertiary inline-block"
                        },
                        {
                            label: "Focus Link",
                            value: "focus-link"
                        },
                        {
                            label: "Focus Link White",
                            value: "focus-link-white"
                        },
                        {
                            label: "checkout",
                            value: "button button--checkout inline-block"
                        }, 
                    ],
                    defaultValue: "button button--primary inline-block"
                },
                {
                    component: "toggle",
                    name: "showMoreInfo",
                    label: "Show More Info Button",
                    description: "Adds a button below the main CTA that links to the product page",
                    toggleLabels: {
                        true: "Yes",
                        false: "No"
                    }
                }
            ]
        },
        {
            label: "CTA 1",
            name: "cta1",
            component: "group",
            fields: [
                {
                    label: "CTA URL",
                    name: "link",
                    component: "link"
                },
                {
                    component: "select",
                    name: "style",
                    label: "Cta Style",
                    options: [
                        {
                            label: "Primary",
                            value: "button button--primary inline-block"
                        },
                        {
                            label: "Primary - Air Dry Cream",
                            value: "button button--primary-stylers-1 inline-block"
                        },
                        {
                            label: "Primary - Sculpting Cream",
                            value: "button button--primary-stylers-2 inline-block"
                        },
                        {
                            label: "Primary - Texture Foam",
                            value: "button button--primary-stylers-3 inline-block"
                        },
                        {
                            label: "Primary - Sleek Stick",
                            value: "button button--primary-stylers-4 inline-block"
                        },
                        {
                            label: "Secondary",
                            value: "button button--secondary inline-block"
                        },
                        {
                            label: "Tertiary",
                            value: "button button--tertiary inline-block"
                        },
                        {
                            label: "Focus Link",
                            value: "focus-link"
                        },
                        {
                            label: "Focus Link White",
                            value: "focus-link-white"
                        },
                        {
                            label: "checkout",
                            value: "button button--checkout inline-block"
                        }, 
                    ],
                    defaultValue: "button button--primary inline-block"
                }
            ]
        },
        {
            label: "CTA 2",
            name: "cta2",
            component: "group",
            fields: [
                {
                    label: "CTA URL",
                    name: "link",
                    component: "link"
                },
                {
                    component: "select",
                    name: "style",
                    label: "Cta Style",
                    options: [
                        {
                            label: "Primary",
                            value: "button button--primary inline-block"
                        },
                        {
                            label: "Primary - Air Dry Cream",
                            value: "button button--primary-stylers-1 inline-block"
                        },
                        {
                            label: "Primary - Sculpting Cream",
                            value: "button button--primary-stylers-2 inline-block"
                        },
                        {
                            label: "Primary - Texture Foam",
                            value: "button button--primary-stylers-3 inline-block"
                        },
                        {
                            label: "Primary - Sleek Stick",
                            value: "button button--primary-stylers-4 inline-block"
                        },
                        {
                            label: "Secondary",
                            value: "button button--secondary inline-block"
                        },
                        {
                            label: "Tertiary",
                            value: "button button--tertiary inline-block"
                        },
                        {
                            label: "Focus Link",
                            value: "focus-link"
                        },
                        {
                            label: "Focus Link White",
                            value: "focus-link-white"
                        },
                        {
                            label: "checkout",
                            value: "button button--checkout inline-block"
                        }, 
                    ],
                    defaultValue: "button button--primary inline-block"
                }, 
            ]
        },
        {
            component: "group-list",
            name: "overrides",
            label: "Hero overrides",
            description: "Describes the text cases when a discount code is applied on the cart",
            fields: [
                {
                    component: "text",
                    name: "discountCode",
                    label: "Discount code reference",
                    description: "Discount code that needs to be present on the cart in order to trigger this override"
                },
                {
                    name: "background_d",
                    label: "Background Image (Desktop)",
                    component: "image",
                    description: "Recommended Image Size: 2880px x 1340px (height can be variable)"
                },
                {
                    name: "background_m",
                    label: "Background Image (Mobile)",
                    component: "image",
                    description: "Recommended Image Size: 750px x 1400px (height can be variable)"
                },
                {
                    name: "image_alt",
                    label: "Image alt text",
                    component: "text"
                },
                {
                    name: "introHeading",
                    label: "Intro Heading (Desktop)",
                    component: "text",
                    defaultValue: "Optional intro title here"
                },
                {
                    name: "introHeadingFont",
                    label: "Intro Heading Font (Desktop)",
                    component: "select",
                    options: desktopFontSelector,
                    defaultValue: "sm:font-hafferBold",
                    description: "Select the font for the intro heading text"
                },
                {
                    name: "introHeadingSize",
                    label: "Intro Heading Size (Desktop)",
                    component: "select",
                    options: [
                        {
                            label: "Large",
                            value: "lg+:sub-large"
                        },
                        {
                            label: "Regular",
                            value: "lg+:sub-regular"
                        },
                        {
                            label: "Small",
                            value: "lg+:sub-small"
                        },
                        {
                            label: "Xsmall",
                            value: "lg+:sub-xsmall"
                        },
                        {
                            label: "Xxsmall",
                            value: "lg+:sub-xxsmall"
                        }, 
                    ],
                    defaultValue: "lg+:sub-large"
                },
                {
                    name: "heading",
                    label: "Heading (Desktop)",
                    component: "text",
                    defaultValue: "Clean chemistry. Healthy hair."
                },
                {
                    name: "headingFont",
                    label: "Heading Font (Desktop)",
                    component: "select",
                    options: desktopFontSelector,
                    defaultValue: "sm:font-hafferBold",
                    description: "Select the font for the heading text"
                },
                {
                    name: "headingSize",
                    label: "Heading Size (Desktop)",
                    component: "select",
                    options: [
                        {
                            label: "Heading One",
                            value: "lg+:text-h1"
                        },
                        {
                            label: "Heading Two",
                            value: "lg+:text-h2"
                        },
                        {
                            label: "Heading Three",
                            value: "lg+:text-h3"
                        },
                        {
                            label: "Heading Four",
                            value: "lg+:text-h4"
                        },
                        {
                            label: "Heading Five",
                            value: "lg+:text-h5"
                        },
                        {
                            label: "Heading Six",
                            value: "lg+:text-h6"
                        }, 
                    ],
                    defaultValue: "lg+:text-h2"
                },
                {
                    name: "description",
                    label: "Description (Desktop)",
                    component: "textarea",
                    defaultValue: "We create powerful, naturally-derived solutions that are proven to improve hair\u2019s health, for every type and texture."
                },
                {
                    name: "descriptionFont",
                    label: "Description Font (Desktop)",
                    component: "select",
                    options: desktopFontSelector,
                    defaultValue: "sm:font-hafferBold",
                    description: "Select the font for the description text"
                },
                {
                    name: "descriptionSize",
                    label: "Description Size (Desktop)",
                    component: "select",
                    options: [
                        {
                            label: "Text Size One",
                            value: "lg+:text-large"
                        },
                        {
                            label: "Text Size Two",
                            value: "lg+:text-regular"
                        },
                        {
                            label: "Text Size Three",
                            value: "lg+:text-small"
                        },
                        {
                            label: "Text Size Four",
                            value: "lg+:text-xsmall"
                        }, 
                    ],
                    defaultValue: "lg+:text-large"
                },
                {
                    name: "introHeading_m",
                    label: "Intro Heading (Mobile)",
                    component: "text",
                    defaultValue: "Optional intro title here"
                },
                {
                    name: "introHeadingFont_m",
                    label: "Intro Heading Font (Mobile)",
                    component: "select",
                    options: mobileFontSelector,
                    defaultValue: "max-sm:font-haffer",
                    description: "Select the font for the intro heading text"
                },
                {
                    name: "introHeadingSize_m",
                    label: "Intro Heading Size (Mobile)",
                    component: "select",
                    options: [
                        {
                            label: "Large",
                            value: "sub-large"
                        },
                        {
                            label: "Regular",
                            value: "sub-regular"
                        },
                        {
                            label: "Small",
                            value: "sub-small"
                        },
                        {
                            label: "Xsmall",
                            value: "sub-xsmall"
                        },
                        {
                            label: "Xxsmall",
                            value: "sub-xxsmall"
                        }, 
                    ],
                    defaultValue: "sub-small"
                },
                {
                    name: "heading_m",
                    label: "Heading (Mobile)",
                    component: "text",
                    defaultValue: "Clean chemistry. Healthy hair."
                },
                {
                    name: "headingFont_m",
                    label: "Heading Font (Mobile)",
                    component: "select",
                    options: mobileFontSelector,
                    defaultValue: "max-sm:font-tiempos italic",
                    description: "Select the font for the heading text"
                },
                {
                    name: "headingSize_m",
                    label: "Heading Size (Mobile)",
                    component: "select",
                    options: [
                        {
                            label: "Heading One",
                            value: "text-h1-m"
                        },
                        {
                            label: "Heading Two",
                            value: "text-h2-m"
                        },
                        {
                            label: "Heading Three",
                            value: "text-h3-m"
                        },
                        {
                            label: "Heading Four",
                            value: "text-h4-m"
                        },
                        {
                            label: "Heading Five",
                            value: "text-h5-m"
                        },
                        {
                            label: "Heading Six",
                            value: "text-h6-m"
                        }, 
                    ],
                    defaultValue: "text-h1-m"
                },
                {
                    name: "description_m",
                    label: "Description (Mobile)",
                    component: "textarea",
                    defaultValue: "We create powerful, naturally-derived solutions that are proven to improve hair\u2019s health, for every type and texture."
                },
                {
                    name: "descriptionFont_m",
                    label: "Description Font (Mobile)",
                    component: "select",
                    options: mobileFontSelector,
                    defaultValue: "max-sm:font-haffer",
                    description: "Select the font for the description text"
                },
                {
                    name: "descriptionSize_m",
                    label: "Description Size (Mobile)",
                    component: "select",
                    options: [
                        {
                            label: "Text Size One",
                            value: "text-large"
                        },
                        {
                            label: "Text Size Two",
                            value: "text-regular"
                        },
                        {
                            label: "Text Size Three",
                            value: "text-small"
                        },
                        {
                            label: "Text Size Four",
                            value: "text-xsmall"
                        }, 
                    ],
                    defaultValue: "text-regular"
                },
                {
                    label: "CTA 1",
                    name: "cta1",
                    component: "group",
                    fields: [
                        {
                            label: "CTA URL",
                            name: "link",
                            component: "link"
                        },
                        {
                            component: "select",
                            name: "style",
                            label: "Cta Style",
                            options: [
                                {
                                    label: "Primary",
                                    value: "button button--primary inline-block"
                                },
                                {
                                    label: "Secondary",
                                    value: "button button--secondary inline-block"
                                },
                                {
                                    label: "Tertiary",
                                    value: "button button--tertiary inline-block"
                                },
                                {
                                    label: "Focus Link",
                                    value: "focus-link"
                                },
                                {
                                    label: "Focus Link White",
                                    value: "focus-link-white"
                                },
                                {
                                    label: "checkout",
                                    value: "button button--checkout inline-block"
                                }, 
                            ],
                            defaultValue: "button button--primary inline-block"
                        }, 
                    ]
                },
                {
                    label: "CTA 2",
                    name: "cta2",
                    component: "group",
                    fields: [
                        {
                            label: "CTA URL",
                            name: "link",
                            component: "link"
                        },
                        {
                            component: "select",
                            name: "style",
                            label: "Cta Style",
                            options: [
                                {
                                    label: "Primary",
                                    value: "button button--primary inline-block"
                                },
                                {
                                    label: "Secondary",
                                    value: "button button--secondary inline-block"
                                },
                                {
                                    label: "Tertiary",
                                    value: "button button--tertiary inline-block"
                                },
                                {
                                    label: "Focus Link",
                                    value: "focus-link"
                                },
                                {
                                    label: "Focus Link White",
                                    value: "focus-link-white"
                                },
                                {
                                    label: "checkout",
                                    value: "button button--checkout inline-block"
                                }, 
                            ],
                            defaultValue: "button button--primary inline-block"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
};
var Hero = Hero_Section;

;// CONCATENATED MODULE: ./src/sections/Hero/index.js


;// CONCATENATED MODULE: ./src/sections/HTML/HTML.jsx


function HTML(param) {
    var cms = param.cms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "data-comp": HTML.displayName,
        id: "".concat(HTML.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(HTML.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(HTML.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            (cms === null || cms === void 0 ? void 0 : cms.snippet) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "m-auto block ".concat((cms === null || cms === void 0 ? void 0 : cms.snippetFont) || ""),
                dangerouslySetInnerHTML: {
                    __html: cms.snippet
                }
            })
        ]
    });
}
HTML.displayName = "HTML";
HTML.Schema = {
    category: "Modules",
    label: HTML.displayName,
    key: "html",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "snippet",
            label: "HTML Snippet",
            component: "html",
            description: "Paste in code snippet here"
        },
        {
            name: "snippetFont",
            label: "HTML Snippet Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the HTML snippet"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/HTML/index.js


// EXTERNAL MODULE: ./src/sections/CategoryCarousel/CategoryCarousel.module.css
var CategoryCarousel_module = __webpack_require__(48132);
var CategoryCarousel_module_default = /*#__PURE__*/__webpack_require__.n(CategoryCarousel_module);
;// CONCATENATED MODULE: ./src/sections/CategoryCarousel/CategoryCarousel.jsx
function CategoryCarousel_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CategoryCarousel_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return CategoryCarousel_arrayLikeToArray(arr);
}
function CategoryCarousel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CategoryCarousel_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function CategoryCarousel_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CategoryCarousel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CategoryCarousel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CategoryCarousel_toConsumableArray(arr) {
    return CategoryCarousel_arrayWithoutHoles(arr) || CategoryCarousel_iterableToArray(arr) || CategoryCarousel_unsupportedIterableToArray(arr) || CategoryCarousel_nonIterableSpread();
}
function CategoryCarousel_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CategoryCarousel_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CategoryCarousel_arrayLikeToArray(o, minLen);
}









function CategoryCarousel_Section(param) {
    var cms = param.cms;
    var categories = (cms === null || cms === void 0 ? void 0 : cms.categories) || [];
    var ref5 = (0,react.useState)(categories), filteredCategories = ref5[0], setFilteredCategories = ref5[1];
    var textColor = (cms === null || cms === void 0 ? void 0 : cms.textColor) || "black";
    var groupBtnBgColor = (cms === null || cms === void 0 ? void 0 : cms.textColor) === "black" ? "white" : "black";
    var textAlign = (cms === null || cms === void 0 ? void 0 : cms.textAlign) || "md-:text-left";
    var textAlign_m = (cms === null || cms === void 0 ? void 0 : cms.textAlign_m) || "text-left";
    var enableGroups = (cms === null || cms === void 0 ? void 0 : cms.enableGroups) || false;
    var enableMobileGrid = (cms === null || cms === void 0 ? void 0 : cms.enableMobileGrid) || false;
    var enableTileBorder = (cms === null || cms === void 0 ? void 0 : cms.enableTileBorder) || false;
    var allGroups = categories.map(function(catItem) {
        var ref;
        return catItem === null || catItem === void 0 ? void 0 : (ref = catItem.category) === null || ref === void 0 ? void 0 : ref.categoryGroup;
    }).filter(function(group) {
        return !!group;
    });
    var validGroups = CategoryCarousel_toConsumableArray(new Set(allGroups)).splice(0, 3);
    var scrollRef = (0,react.useRef)(null);
    var sliderContainer = (0,react.useRef)(null);
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var ref1 = (0,react.useState)(0), enableArrows = ref1[0], setEnableArrows = ref1[1];
    var renderAsGrid = enableMobileGrid && vpWidth < 1024;
    var ref2 = (0,react.useState)(validGroups[0]), activeGroup = ref2[0], setActiveGroup = ref2[1];
    var slickNext = function() {
        scrollRef.current.slickNext();
    };
    var slickPrev = function() {
        scrollRef.current.slickPrev();
    };
    var checkArrow = function(arrow) {
        var isDisabled = true;
        if (scrollRef.current && sliderContainer.current) {
            var activeSlides = sliderContainer.current.querySelectorAll(".slick-active");
            var slidesLenght = sliderContainer.current.querySelectorAll(".slick-slide").length - 1;
            switch(arrow){
                case "next":
                    isDisabled = parseInt(activeSlides[activeSlides.length - 1].dataset.index, 10) === slidesLenght;
                    break;
                case "prev":
                    isDisabled = parseInt(activeSlides[0].dataset.index, 10) === 0;
                    break;
                default:
                    break;
            }
        }
        return isDisabled;
    };
    var ref3 = (0,react.useState)(true), prevArrowDisabled = ref3[0], setPrevArrowDisabled = ref3[1];
    var ref4 = (0,react.useState)(false), nextArrowDisabled = ref4[0], setNextArrowDisabled = ref4[1];
    var slideSettings = {
        infinite: false,
        centerMode: false,
        variableWidth: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        swipeToSlide: false,
        swipe: true,
        useTransform: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.5,
                    infinite: false,
                    adaptiveHeight: false,
                    dots: true
                }
            }, 
        ],
        afterChange: function() {
            setNextArrowDisabled(checkArrow("next"));
            setPrevArrowDisabled(checkArrow("prev"));
        }
    };
    (0,react.useEffect)(function() {
        if (scrollRef.current) {
            var child = scrollRef.current.innerSlider.props.children;
            setEnableArrows(child.length > scrollRef.current.props.slidesToShow);
            scrollRef.current.slickGoTo(0);
            if (child.length > scrollRef.current.props.slidesToShow) {
                setNextArrowDisabled(checkArrow("next"));
                setPrevArrowDisabled(checkArrow("prev"));
            }
        }
    }, [
        vpWidth,
        filteredCategories
    ]);
    (0,react.useEffect)(function() {
        if (enableGroups) {
            setFilteredCategories(categories.filter(function(loopCategory) {
                var ref;
                return (loopCategory === null || loopCategory === void 0 ? void 0 : (ref = loopCategory.category) === null || ref === void 0 ? void 0 : ref.categoryGroup) === activeGroup;
            }));
        } else {
            setFilteredCategories(categories);
        }
    }, [
        enableGroups,
        activeGroup
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "category-carousel-".concat(cms.cmsId || cms.tinaId),
        className: "category-carousel relative overflow-hidden ".concat((CategoryCarousel_module_default())["category-carousel"], " text-").concat(textColor, " ").concat((cms === null || cms === void 0 ? void 0 : cms.bgColor) !== "bg-white" && (cms === null || cms === void 0 ? void 0 : cms.bgColor) !== "transparent" ? " pt-9 pb-9 sm:pt-12 sm:pt-12 md:pt-16 md:pb-16 ".concat(cms === null || cms === void 0 ? void 0 : cms.bgColor) : ""),
        "data-comp": CategoryCarousel_Section.displayName,
        style: {
            backgroundColor: cms === null || cms === void 0 ? void 0 : cms.customBgColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#category-carousel-".concat(cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #category-carousel-").concat(cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container ".concat(filteredCategories.length <= 4 && enableGroups === false ? "lg:ml-auto lg:!max-w-[992px] lg:pr-[18px] 2xl:ml-auto 2xl:!max-w-[1180px]" : "lg:ml-12 2xl:ml-[126px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:mr-auto ".concat(filteredCategories.length <= 4 ? "px-4 md:px-12 lg:px-0" : "px-4 md:px-12 lg:mr-[8rem] lg:px-0"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6 md:mb-9 ".concat(textAlign_m, " ").concat(textAlign),
                            children: [
                                (cms === null || cms === void 0 ? void 0 : cms.section_optional_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-4 max-w-[546px] ".concat((cms === null || cms === void 0 ? void 0 : cms.sectionOptionalTitleFont) || "font-hafferBold", " text-base md:mb-2 ").concat(textAlign === "md:text-center" ? "md:mx-auto" : "md:mx-0", " ").concat(textAlign_m === "text-center" ? "mx-auto" : ""),
                                    children: cms === null || cms === void 0 ? void 0 : cms.section_optional_title
                                }),
                                (cms === null || cms === void 0 ? void 0 : cms.section_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-header mt-0 mb-3 max-w-[546px] lg:mb-4 ".concat(textAlign === "md:text-center" ? "md:mx-auto" : "md:mx-0", " ").concat(textAlign_m === "text-center" ? "mx-auto" : "", " ").concat((cms === null || cms === void 0 ? void 0 : cms.sectionTitleFont) || "font-tiempos"),
                                    children: cms === null || cms === void 0 ? void 0 : cms.section_title
                                }),
                                (cms === null || cms === void 0 ? void 0 : cms.section_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "m-0 max-w-[546px] text-h6-m font-light md:text-h6 ".concat(textAlign === "md:text-center" ? "md:mx-auto" : "md:mx-0", " ").concat(textAlign_m === "text-center" ? "mx-auto" : "", " ").concat((cms === null || cms === void 0 ? void 0 : cms.sectionDescriptionFont) || ""),
                                    dangerouslySetInnerHTML: {
                                        __html: (0,Helper/* newLineToBr */.td)(cms === null || cms === void 0 ? void 0 : cms.section_description)
                                    }
                                }),
                                enableGroups === true && validGroups.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-4 mb-4 flex flex-wrap gap-x-4 gap-y-3 ".concat(textAlign === "md:text-center" ? "md:justify-center" : "md:justify-start", "\n              ").concat(textAlign_m === "text-center" ? "justify-center" : ""),
                                    children: validGroups.map(function(group) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            onClick: function() {
                                                return setActiveGroup(group);
                                            },
                                            className: "inline-block rounded-full border-2 px-4 py-1 font-hafferBold text-xs leading-tight border-".concat(textColor, " transition-all duration-150 ").concat(activeGroup === group ? "bg-".concat(textColor, " text-").concat(groupBtnBgColor) : "border-".concat(textColor, " text-").concat(textColor, " ").concat(textColor === "black" ? "lg:hover:bg-black lg:hover:text-white" : "lg:hover:bg-white lg:hover:text-black"), " ").concat((cms === null || cms === void 0 ? void 0 : cms.categoryGroupFont) || "font-hafferBold"),
                                            children: group
                                        }, group);
                                    })
                                })
                            ]
                        }),
                        filteredCategories.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "group relative -ml-4 -mr-4 ".concat(filteredCategories.length > 4 ? "" : "px-0 ", " slider-container"),
                            ref: sliderContainer,
                            children: renderAsGrid === false ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, CategoryCarousel_objectSpread({}, slideSettings, {
                                        className: "text-".concat(textColor),
                                        ref: scrollRef,
                                        children: filteredCategories.map(function(category, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                                                item: category === null || category === void 0 ? void 0 : category.category,
                                                textColor: textColor,
                                                enableTileBorder: enableTileBorder
                                            }, index);
                                        })
                                    })),
                                    enableArrows && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute top-1/2 flex w-full -translate-y-1/2 items-center justify-between pr-4 pl-8 opacity-0 transition-all duration-150 group-hover:opacity-100",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                type: "button",
                                                onClick: function() {
                                                    return slickPrev();
                                                },
                                                className: "flex h-11 w-11 items-center justify-center rounded-full bg-black text-white\n                        ".concat(prevArrowDisabled ? "pointer-events-none opacity-50" : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconArrowLeft */.D6, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Prev"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                type: "button",
                                                onClick: function() {
                                                    return slickNext();
                                                },
                                                className: "ml-[-1px] flex h-11 w-11 items-center justify-center rounded-full bg-black text-white\n                        ".concat(nextArrowDisabled ? "pointer-events-none opacity-50" : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconArrowRight */.Ec, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Next"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-wrap justify-center gap-x-4 gap-y-6 px-4",
                                children: filteredCategories.map(function(category, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                                        item: category === null || category === void 0 ? void 0 : category.category,
                                        textColor: textColor,
                                        isGrid: true,
                                        enableTileBorder: enableTileBorder
                                    }, index);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }, cms.cmsId || cms.tinaId);
}
function Category(param) {
    var item = param.item, textColor = param.textColor, isGrid = param.isGrid, _enableTileBorder = param.enableTileBorder, enableTileBorder = _enableTileBorder === void 0 ? false : _enableTileBorder;
    var ref, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    if (!(item === null || item === void 0 ? void 0 : (ref = item.image) === null || ref === void 0 ? void 0 : ref.src) && !(item === null || item === void 0 ? void 0 : item.title)) return null;
    var categoryTitleFont = (item === null || item === void 0 ? void 0 : item.titleFont) || "font-hafferBold";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(enableTileBorder ? (CategoryCarousel_module_default()).categoryTileBorder : (CategoryCarousel_module_default()).category, " text-").concat(textColor, " shrink-0 text-sm md:text-base ").concat(isGrid == true ? "" : "pl-4", " ").concat(isGrid === true ? (CategoryCarousel_module_default())["category-grid"] : ""),
        children: (item === null || item === void 0 ? void 0 : item.link) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: item === null || item === void 0 ? void 0 : item.link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "block no-underline ".concat(enableTileBorder ? "border border-".concat(textColor) : "", " h-full text-").concat(textColor),
                href: item === null || item === void 0 ? void 0 : item.link,
                children: [
                    (item === null || item === void 0 ? void 0 : (ref6 = item.image) === null || ref6 === void 0 ? void 0 : ref6.src) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "responsive-image ".concat((CategoryCarousel_module_default()).category__image),
                        children: [
                            (item === null || item === void 0 ? void 0 : (ref7 = item.image_hover) === null || ref7 === void 0 ? void 0 : ref7.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                src: item === null || item === void 0 ? void 0 : (ref8 = item.image_hover) === null || ref8 === void 0 ? void 0 : ref8.src,
                                loading: "lazy",
                                sizes: "(max-width:480px) 75vw,(max-width:1024px) 33vw, 25w",
                                width: "530",
                                height: "640",
                                fill: true,
                                className: "invisible w-full ".concat((CategoryCarousel_module_default()).category__hoverImage),
                                alt: item === null || item === void 0 ? void 0 : item.hoverImageAlt
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                src: item === null || item === void 0 ? void 0 : (ref9 = item.image) === null || ref9 === void 0 ? void 0 : ref9.src,
                                loading: "lazy",
                                sizes: "(max-width:480px) 75vw,(max-width:1024px) 33vw, 25w",
                                width: "530",
                                height: "640",
                                fill: true,
                                className: "w-full opacity-100",
                                alt: item === null || item === void 0 ? void 0 : item.imageAlt
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((CategoryCarousel_module_default()).category__title, " ").concat(enableTileBorder ? "border-t border-".concat(textColor) : "pt-4 md:pt-5 text-center", " transition-all"),
                        children: (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "m-0 text-sm font-hafferBold md:text-base ".concat(categoryTitleFont, " ").concat(enableTileBorder ? "block border-2 border-transparent p-4 text-center md:p-5 " : "focus-link text-currentcolor border-currentcolor hover:text-".concat(textColor)),
                            children: item === null || item === void 0 ? void 0 : item.title
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(enableTileBorder ? "border border-".concat(textColor) : "", " h-full hover:cursor-pointer"),
            children: [
                (item === null || item === void 0 ? void 0 : (ref10 = item.image) === null || ref10 === void 0 ? void 0 : ref10.src) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "responsive-image ".concat((CategoryCarousel_module_default()).category__image),
                    children: [
                        (item === null || item === void 0 ? void 0 : (ref11 = item.image_hover) === null || ref11 === void 0 ? void 0 : ref11.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: item === null || item === void 0 ? void 0 : (ref12 = item.image_hover) === null || ref12 === void 0 ? void 0 : ref12.src,
                            loading: "lazy",
                            className: "invisible w-full ".concat((CategoryCarousel_module_default()).category__hoverImage),
                            alt: "",
                            width: "530",
                            height: "640"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: item === null || item === void 0 ? void 0 : (ref13 = item.image) === null || ref13 === void 0 ? void 0 : ref13.src,
                            loading: "lazy",
                            className: "w-full",
                            alt: item === null || item === void 0 ? void 0 : item.imageAlt,
                            width: "530",
                            height: "640"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((CategoryCarousel_module_default()).category__title, " ").concat(enableTileBorder ? "border-t border-".concat(textColor) : "pt-4 md:pt-5 text-center", " transition-all"),
                    children: (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "m-0 font-hafferBold text-sm md:text-base ".concat(categoryTitleFont, " ").concat(enableTileBorder ? "block border-2 border-transparent p-4 text-center md:p-5 " : "focus-link text-currentcolor border-currentcolor hover:text-".concat(textColor)),
                        children: item === null || item === void 0 ? void 0 : item.title
                    })
                })
            ]
        })
    });
}
CategoryCarousel_Section.displayName = "Category Carousel";
Category.displayName = "Category";
CategoryCarousel_Section.Schema = {
    category: "Modules",
    label: CategoryCarousel_Section.displayName,
    key: "category-carousel",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "toggle",
            name: "enableMobileGrid",
            label: "Enable Mobile Grid",
            defaultValue: false,
            toggleLabels: {
                true: "Enable",
                false: "Disable"
            }
        },
        {
            component: "toggle",
            name: "enableGroups",
            label: "Enable Groups",
            defaultValue: false,
            toggleLabels: {
                true: "Enable",
                false: "Disable"
            }
        },
        {
            component: "toggle",
            name: "enableTileBorder",
            label: "Enable Tile Border",
            defaultValue: false,
            toggleLabels: {
                true: "Enable",
                false: "Disable"
            }
        },
        {
            component: "group-list",
            name: "categories",
            label: "Category",
            description: "Categories",
            fields: [
                {
                    label: "Category",
                    name: "category",
                    component: "group",
                    fields: [
                        {
                            label: "Category Group",
                            name: "categoryGroup",
                            component: "text",
                            description: "Label to group categories together, you can use up to three different groups, anything over this number will be ignored, the groups are counted from top to bottom in population"
                        },
                        {
                            name: "categoryGroupFont",
                            label: "Category Group Font",
                            component: "select",
                            options: FontSelector,
                            defaultValue: "font-haffer",
                            description: "Select the font for the category group text"
                        },
                        {
                            label: "Category Image",
                            name: "image",
                            component: "image",
                            description: "Recommended image size: 530px x 640px"
                        },
                        {
                            name: "imageAlt",
                            label: "Category Image Alt text",
                            component: "text"
                        },
                        {
                            label: "Category Hover Image",
                            name: "image_hover",
                            component: "image",
                            description: "Recommended image size: 530px x 640px"
                        },
                        {
                            name: "hoverImageAlt",
                            label: "Category Hover Image Alt text",
                            component: "text"
                        },
                        {
                            label: "Category Title",
                            name: "title",
                            component: "text"
                        },
                        {
                            name: "titleFont",
                            label: "Category Title Font",
                            component: "select",
                            options: FontSelector,
                            defaultValue: "font-haffer",
                            description: "Select the font for the category title text"
                        },
                        {
                            label: "Category URL",
                            name: "link",
                            component: "text"
                        }, 
                    ]
                }, 
            ]
        },
        {
            name: "section_optional_title",
            label: "Section Pre-title",
            component: "text"
        },
        {
            name: "sectionOptionalTitleFont",
            label: "Section Pre-title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section pre-title text"
        },
        {
            name: "section_title",
            label: "Section Title",
            component: "text"
        },
        {
            name: "sectionTitleFont",
            label: "Section Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section title text"
        },
        {
            name: "section_description",
            label: "Section Description",
            component: "textarea"
        },
        {
            name: "sectionDescriptionFont",
            label: "Section Description Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section description text"
        },
        {
            component: "select",
            name: "textColor",
            label: "Text Color",
            options: [
                {
                    label: "Light",
                    value: "white"
                },
                {
                    label: "Dark",
                    value: "black"
                }, 
            ],
            defaultValue: "black"
        },
        {
            component: "select",
            name: "textAlign",
            label: "Text Align (Desktop)",
            options: [
                {
                    label: "Left",
                    value: "md:text-left"
                },
                {
                    label: "Center",
                    value: "md:text-center"
                }, 
            ],
            defaultValue: "md:text-left"
        },
        {
            component: "select",
            name: "textAlign_m",
            label: "Text Align (Mobile)",
            options: [
                {
                    label: "Left",
                    value: "text-left"
                },
                {
                    label: "Center",
                    value: "text-center"
                }, 
            ],
            defaultValue: "text-left"
        },
        {
            component: "select",
            name: "bgColor",
            label: "Background Color",
            description: "For section background color, select one from preselected brand colors.",
            options: [
                {
                    label: "Black",
                    value: "bg-black"
                },
                {
                    label: "White",
                    value: "bg-white"
                },
                {
                    label: "Grey",
                    value: "bg-black"
                },
                {
                    label: "Light Grey",
                    value: "bg-grey-9"
                },
                {
                    label: "Blue 1",
                    value: "bg-quinary-1"
                },
                {
                    label: "Blue 2",
                    value: "bg-quinary-2"
                },
                {
                    label: "Blue 3",
                    value: "bg-light-blue"
                },
                {
                    label: "Cream 1",
                    value: "bg-tertiary-2"
                },
                {
                    label: "Cream 2",
                    value: "bg-senary-4"
                },
                {
                    label: "Purple",
                    value: "bg-tertiary-1"
                },
                {
                    label: "Green",
                    value: "bg-quaternary-1"
                },
                {
                    label: "Pink 1",
                    value: "bg-primary-2"
                },
                {
                    label: "Pink 2",
                    value: "bg-secondary-1"
                },
                {
                    label: "Yellow",
                    value: "bg-yellow"
                },
                {
                    label: "Orange",
                    value: "bg-secondary-2"
                },
                {
                    label: "Seafoam 1",
                    value: "bg-quaternary-2"
                },
                {
                    label: "Seafoam 2",
                    value: "bg-senary-3"
                },
                {
                    label: "Seafoam 3",
                    value: "bg-senary-5"
                },
                {
                    label: "Air Dry Cream",
                    value: "bg-stylers-1"
                },
                {
                    label: "Sculpting Cream",
                    value: "bg-stylers-2"
                },
                {
                    label: "Texture Foam",
                    value: "bg-stylers-3"
                },
                {
                    label: "Sleek Stick",
                    value: "bg-stylers-4"
                },
                {
                    label: "Scalp Blue",
                    value: "bg-scalp-blue"
                },
                {
                    label: "Magenta",
                    value: "bg-magenta"
                },
                {
                    label: "Medium Pink",
                    value: "bg-med-pink"
                },
                {
                    label: "Briogeo Blue",
                    value: "bg-brio-blue"
                },
                {
                    label: "Cloud",
                    value: "bg-cloud"
                },
                {
                    label: "Mineral",
                    value: "bg-mineral"
                },
                {
                    label: "Deep Sea",
                    value: "bg-deep-sea"
                },
                {
                    label: "Sandstone",
                    value: "bg-sandstone"
                },
                {
                    label: "Sorrel",
                    value: "bg-sorrel"
                },
                {
                    label: "Butter",
                    value: "bg-butter"
                },
                {
                    label: "Rosehip",
                    value: "bg-rosehip"
                },
                {
                    label: "Chestnut",
                    value: "bg-chestnut"
                }, 
            ],
            defaultValue: "bg-white"
        },
        {
            component: "color",
            name: "customBgColor",
            label: "Custom Background Color",
            description: "Custom Background color"
        }, 
    ]
};
var CategoryCarousel = CategoryCarousel_Section;

;// CONCATENATED MODULE: ./src/sections/CategoryCarousel/index.js


// EXTERNAL MODULE: ./src/snippets/icons/ArrowLeft.jsx
var ArrowLeft = __webpack_require__(92301);
// EXTERNAL MODULE: ./src/snippets/icons/ArrowRight.jsx
var ArrowRight = __webpack_require__(14604);
// EXTERNAL MODULE: ./src/snippets/icons/Close.jsx
var Close = __webpack_require__(54059);
// EXTERNAL MODULE: ./src/sections/CarouselHotspots/hotspot.module.css
var hotspot_module = __webpack_require__(9528);
var hotspot_module_default = /*#__PURE__*/__webpack_require__.n(hotspot_module);
;// CONCATENATED MODULE: ./src/sections/CarouselHotspots/Hotspot.jsx







function Hotspot(props) {
    var ref5, ref1, ref2, ref3;
    var hotspot = props === null || props === void 0 ? void 0 : props.data;
    if (!hotspot) return;
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var isMobile = vpWidth < 1024;
    var labelFont = (hotspot === null || hotspot === void 0 ? void 0 : hotspot.labelFont) || "font-hafferBold";
    var modalHeadingFont = (hotspot === null || hotspot === void 0 ? void 0 : hotspot.modal_headingFont) || "font-hafferBold";
    var modalBodyFont = (hotspot === null || hotspot === void 0 ? void 0 : hotspot.modal_bodyFont) || "font-haffer";
    var getLabelclass = function(style) {
        if (style === "dark-label") return "dark-label";
        if (style === "light-label") return "light-label";
        if (style === "pink-label") return "pink-label";
        return "";
    };
    var x_pos = (hotspot === null || hotspot === void 0 ? void 0 : hotspot.x_pos) ? hotspot.x_pos : 0;
    var y_pos = (hotspot === null || hotspot === void 0 ? void 0 : hotspot.y_pos) ? hotspot.y_pos : 0;
    if (x_pos < 0) x_pos = 0;
    if (y_pos < 0) y_pos = 0;
    if (x_pos > 100) x_pos = 100;
    if (y_pos > 100) y_pos = 100;
    var x_pos_m = (hotspot === null || hotspot === void 0 ? void 0 : hotspot.x_pos_m) ? hotspot.x_pos_m : x_pos;
    var y_pos_m = (hotspot === null || hotspot === void 0 ? void 0 : hotspot.y_pos_m) ? hotspot.y_pos_m : y_pos;
    if (x_pos_m < 0) x_pos_m = 0;
    if (y_pos_m < 0) y_pos_m = 0;
    if (x_pos_m > 100) x_pos_m = 100;
    if (y_pos_m > 100) y_pos_m = 100;
    var d_styles = {
        top: "".concat(y_pos, "%"),
        left: "".concat(x_pos, "%")
    };
    var m_styles = {
        top: "".concat(y_pos_m, "%"),
        left: "".concat(x_pos_m, "%")
    };
    var openModal = function(e) {
        var ref, ref4;
        var modal = (ref4 = (ref = e.target) === null || ref === void 0 ? void 0 : ref.closest(".hotspot")) === null || ref4 === void 0 ? void 0 : ref4.querySelector(".hotspot-modal");
        if (!modal) return;
        var copy = modal.cloneNode(true);
        document.body.appendChild(copy);
        copy.classList.remove("hidden");
        document.body.classList.add("overflow-hidden", "touch-none");
    };
    var closeModal = function(modal) {
        if (!modal) return;
        modal.remove();
        document.body.classList.remove("overflow-hidden", "touch-none");
    };
    (0,react.useEffect)(function() {
        document.body.addEventListener("click", function(e) {
            var closeBtn = e.target.closest(".hotspot-modal-close");
            if (closeBtn) {
                closeModal(closeBtn.closest(".hotspot-modal"));
            } else if (e.target.classList.contains("hotspot-modal")) {
                closeModal(e.target);
            }
        }, true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(getLabelclass(hotspot.style), " hotspot h-0 w-0"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute h-0 w-0",
                style: isMobile ? m_styles : d_styles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "m-[-6px] flex h-3 w-3 lg:h-4 lg:w-4 lg:-m-2 hotspot-button bg-black items-center justify-center rounded-full relative ".concat(labelFont),
                    onClick: function(e) {
                        return openModal(e);
                    },
                    type: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sr-only",
                            "aria-label": "Open modal for ".concat(hotspot === null || hotspot === void 0 ? void 0 : hotspot.label),
                            children: hotspot === null || hotspot === void 0 ? void 0 : hotspot.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute left-1/2 top-1/2 h-5 w-5 rounded-full border hotspot-pulse border-black ".concat((hotspot_module_default()).pulse)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute hidden h-0 w-0 lg:block",
                style: isMobile ? m_styles : d_styles,
                children: [
                    (hotspot === null || hotspot === void 0 ? void 0 : hotspot.label_direction) === "left" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hotspot-cta right-0 -translate-y-1/2 flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "".concat(labelFont),
                                type: "button",
                                onClick: function(e) {
                                    return openModal(e);
                                },
                                "aria-label": "Open modal for ".concat(hotspot === null || hotspot === void 0 ? void 0 : hotspot.label),
                                children: hotspot === null || hotspot === void 0 ? void 0 : hotspot.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h-0.5 w-[60px]"
                            })
                        ]
                    }),
                    (hotspot === null || hotspot === void 0 ? void 0 : hotspot.label_direction) === "right" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hotspot-cta left-0 -translate-y-1/2 flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "".concat(labelFont),
                                type: "button",
                                onClick: function(e) {
                                    return openModal(e);
                                },
                                "aria-label": "Open modal for ".concat(hotspot === null || hotspot === void 0 ? void 0 : hotspot.label),
                                children: hotspot === null || hotspot === void 0 ? void 0 : hotspot.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "order-first h-0.5 w-[60px]"
                            })
                        ]
                    }),
                    (hotspot === null || hotspot === void 0 ? void 0 : hotspot.label_direction) === "top" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hotspot-cta bottom-0 -translate-x-1/2 flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "".concat(labelFont),
                                type: "button",
                                onClick: function(e) {
                                    return openModal(e);
                                },
                                "aria-label": "Open modal for ".concat(hotspot === null || hotspot === void 0 ? void 0 : hotspot.label),
                                children: hotspot === null || hotspot === void 0 ? void 0 : hotspot.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h-[60px] w-0.5"
                            })
                        ]
                    }),
                    (hotspot === null || hotspot === void 0 ? void 0 : hotspot.label_direction) === "bottom" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hotspot-cta top-0 -translate-x-1/2 flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "".concat(labelFont),
                                type: "button",
                                onClick: function(e) {
                                    return openModal(e);
                                },
                                "aria-label": "Open modal for ".concat(hotspot === null || hotspot === void 0 ? void 0 : hotspot.label),
                                children: hotspot === null || hotspot === void 0 ? void 0 : hotspot.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "order-first h-[60px] w-0.5"
                            })
                        ]
                    }),
                    (hotspot === null || hotspot === void 0 ? void 0 : hotspot.modal_heading) && (hotspot === null || hotspot === void 0 ? void 0 : hotspot.modal_body) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hotspot-modal fixed inset-0 hidden h-full w-full p-4 z-[2001]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-full w-full items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative w-full max-w-[435px] bg-white px-[30px] py-[34px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "hotspot-modal-close absolute top-4 right-4 flex h-5 w-5 items-center justify-center",
                                        "aria-label": "hotspot modal close",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        className: "mb-3 ".concat(modalHeadingFont),
                                        children: hotspot.modal_heading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hotspot-modal-body ".concat(modalBodyFont),
                                        dangerouslySetInnerHTML: {
                                            __html: (0,Helper/* newLineToBr */.td)(hotspot.modal_body)
                                        }
                                    }),
                                    (hotspot === null || hotspot === void 0 ? void 0 : (ref5 = hotspot.modal_link) === null || ref5 === void 0 ? void 0 : ref5.text) && (hotspot === null || hotspot === void 0 ? void 0 : (ref1 = hotspot.modal_link) === null || ref1 === void 0 ? void 0 : ref1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex pt-[16px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: hotspot === null || hotspot === void 0 ? void 0 : (ref2 = hotspot.modal_link) === null || ref2 === void 0 ? void 0 : ref2.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "focus-link",
                                                children: hotspot === null || hotspot === void 0 ? void 0 : (ref3 = hotspot.modal_link) === null || ref3 === void 0 ? void 0 : ref3.text
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/CarouselHotspots/CarouselHotspots.jsx
function CarouselHotspots_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CarouselHotspots_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CarouselHotspots_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








function CarouselHotspots(param) {
    var cms = param.cms;
    var ref3, ref1, ref2;
    var slider = null;
    var _aboveTheFold = cms.aboveTheFold, aboveTheFold = _aboveTheFold === void 0 ? false : _aboveTheFold, _titleFont = cms.titleFont, titleFont = _titleFont === void 0 ? "font-hafferBold" : _titleFont;
    var next = function() {
        if (slider) slider.slickNext();
    };
    var prev = function() {
        if (slider) slider.slickPrev();
    };
    var settings = {
        arrows: false,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        centerMode: false,
        useTransform: false,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    arrows: false
                }
            }, 
        ]
    };
    (0,react.useEffect)(function() {
        (0,Helper/* scrollToSection */.Qj)("".concat(CarouselHotspots.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-comp": CarouselHotspots.displayName,
        className: "hotspots px-4 py-10 md-:px-12 md-:pb-20 lg:pt-20 lg:pb-[120px]",
        id: "".concat(CarouselHotspots.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(CarouselHotspots.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(CarouselHotspots.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hotspots-header mb-6 flex items-end justify-between md-:justify-center lg:mb-8 2xl:mb-11",
                children: (cms === null || cms === void 0 ? void 0 : cms.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-header hotspots-title mb-0 ".concat(titleFont),
                    children: cms.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hotspots-body relative flex items-center justify-center",
                children: [
                    (cms === null || cms === void 0 ? void 0 : (ref3 = cms.slides) === null || ref3 === void 0 ? void 0 : ref3.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "hotspots__arrow hotspots__arrow--prev absolute top-[-62px] right-[44px] flex flex-shrink-0 md:relative md:top-auto md:right-auto md:mb-11 md:mr-6",
                        onClick: prev,
                        "aria-label": "View previous hotspots",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "View previous hotspots"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* ArrowLeft */.X, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex-grow md-:w-[calc(100%-126px)] lg:w-[calc(100%-138px)] 2xl:max-w-[1120px]",
                        children: (cms === null || cms === void 0 ? void 0 : (ref1 = cms.slides) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, CarouselHotspots_objectSpread({
                            ref: function(c) {
                                return slider = c;
                            }
                        }, settings, {
                            children: cms.slides.map(function(slide, slideIdx) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: "relative w-full border border-black",
                                    children: [
                                        (slide === null || slide === void 0 ? void 0 : slide.bg_image_d) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "!hidden w-full lg:!block",
                                            src: slide.bg_image_d.src,
                                            alt: slide.alt_text,
                                            loading: aboveTheFold ? "eager" : "lazy",
                                            priority: aboveTheFold,
                                            fetchpriority: aboveTheFold ? "high" : "low",
                                            width: "2232",
                                            height: "1200"
                                        }),
                                        !(slide === null || slide === void 0 ? void 0 : slide.bg_image_d) && (slide === null || slide === void 0 ? void 0 : slide.bg_image_m) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "!hidden w-full lg:!block",
                                            src: slide.bg_image_m.src,
                                            alt: slide.alt_text,
                                            loading: aboveTheFold ? "eager" : "lazy",
                                            priority: aboveTheFold,
                                            fetchpriority: aboveTheFold ? "high" : "low",
                                            width: "1092",
                                            height: "1092"
                                        }),
                                        (slide === null || slide === void 0 ? void 0 : slide.bg_image_m) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "w-full lg:!hidden",
                                            src: slide.bg_image_m.src,
                                            alt: slide.alt_text,
                                            loading: aboveTheFold ? "eager" : "lazy",
                                            priority: aboveTheFold,
                                            fetchpriority: aboveTheFold ? "high" : "low",
                                            width: "1092",
                                            height: "1092"
                                        }),
                                        !(slide === null || slide === void 0 ? void 0 : slide.bg_image_m) && (slide === null || slide === void 0 ? void 0 : slide.bg_image_d) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "w-full lg:!hidden",
                                            src: slide.bg_image_d.src,
                                            alt: slide.alt_text,
                                            loading: aboveTheFold ? "eager" : "lazy",
                                            priority: aboveTheFold,
                                            fetchpriority: aboveTheFold ? "high" : "low",
                                            width: "2232",
                                            height: "1200"
                                        }),
                                        (slide === null || slide === void 0 ? void 0 : slide.heading) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute -top-px -left-px flex items-center border border-black bg-white py-2 px-4 lg:py-4 lg:px-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                className: "m-0 text-center lg:min-w-[90px] ".concat(slide === null || slide === void 0 ? void 0 : slide.headingFont),
                                                children: slide.heading
                                            })
                                        }),
                                        slide === null || slide === void 0 ? void 0 : (ref = slide.hotspots) === null || ref === void 0 ? void 0 : ref.map(function(hotspot, hotspotIdx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotspot, {
                                                data: hotspot
                                            }, "hotspot-item-".concat(hotspotIdx));
                                        })
                                    ]
                                }, "slide-item-".concat(slideIdx));
                            })
                        }))
                    }),
                    (cms === null || cms === void 0 ? void 0 : (ref2 = cms.slides) === null || ref2 === void 0 ? void 0 : ref2.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "hotspots__arrow hotspots__arrow--next absolute top-[-62px] right-0 flex flex-shrink-0 md:relative md:top-auto md:right-auto md:mb-11 md:ml-6",
                        onClick: next,
                        "aria-label": "View next hotspots",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "View next hotspots"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {})
                        ]
                    })
                ]
            })
        ]
    });
}
CarouselHotspots.displayName = "CarouselHotspots";
CarouselHotspots.Schema = {
    category: "Modules",
    label: CarouselHotspots.displayName,
    key: "CarouselHotspots",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "toggle",
            name: "aboveTheFold",
            label: "Above the fold",
            toggleLabels: {
                true: "Yes",
                false: "No"
            },
            defaultValue: false
        },
        {
            name: "title",
            label: "Title",
            component: "text"
        },
        {
            name: "titleFont",
            label: "Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-hafferBold",
            description: "Select the font for the title text"
        },
        {
            name: "slides",
            label: "Slides",
            component: "group-list",
            fields: [
                {
                    name: "bg_image_d",
                    label: "Background Image (Desktop)",
                    component: "image",
                    description: "Recommended Image Size: 2232px x 1200px"
                },
                {
                    name: "bg_image_m",
                    label: "Background Image (Mobile)",
                    component: "image",
                    description: "Recommended Image Size: 1092px x 1092px"
                },
                {
                    name: "alt_text",
                    label: "Alt",
                    description: "Add description of image here. For ADA",
                    component: "text",
                    defaultValue: "Placeholder alt text for hotspot image"
                },
                {
                    name: "heading",
                    label: "Heading",
                    component: "text"
                },
                {
                    name: "headingFont",
                    label: "Heading Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-hafferBold",
                    description: "Select the font for the heading text"
                },
                {
                    name: "hotspots",
                    label: "Hotspots",
                    component: "group-list",
                    fields: [
                        {
                            name: "x_pos",
                            label: "X Position",
                            component: "number",
                            description: "The percent of x position in width"
                        },
                        {
                            name: "y_pos",
                            label: "Y Position",
                            component: "number",
                            description: "The percent of y position in height"
                        },
                        {
                            name: "x_pos_m",
                            label: "X Position (Mobile)",
                            component: "number",
                            description: "The x position for mobile image"
                        },
                        {
                            name: "y_pos_m",
                            label: "Y Position (Mobile)",
                            component: "number",
                            description: "The y position for mobile image"
                        },
                        {
                            name: "label",
                            label: "Hotspot Label",
                            component: "text",
                            description: "Hotspot Label will be shown in desktop only"
                        },
                        {
                            name: "labelFont",
                            label: "Hotspot Label Font",
                            component: "select",
                            options: FontSelector,
                            defaultValue: "font-hafferBold",
                            description: "Select the font for the hotspot label text"
                        },
                        {
                            component: "select",
                            name: "style",
                            label: "Hotspot Label Color",
                            options: [
                                {
                                    label: "Dark",
                                    value: "dark-label"
                                },
                                {
                                    label: "Light",
                                    value: "light-label"
                                },
                                {
                                    label: "Pink",
                                    value: "pink-label"
                                }, 
                            ],
                            defaultValue: "dark-label"
                        },
                        {
                            name: "label_direction",
                            label: "Hotspot Direction",
                            component: "select",
                            description: "Hotspot Direction will be used in desktop only",
                            options: [
                                {
                                    label: "Left",
                                    value: "left"
                                },
                                {
                                    label: "Top",
                                    value: "top"
                                },
                                {
                                    label: "Right",
                                    value: "right"
                                },
                                {
                                    label: "Bottom",
                                    value: "bottom"
                                }, 
                            ],
                            defaultValue: "left"
                        },
                        {
                            name: "modal_heading",
                            label: "Modal Heading",
                            component: "text"
                        },
                        {
                            name: "modal_headingFont",
                            label: "Modal Heading Font",
                            component: "select",
                            options: FontSelector,
                            defaultValue: "font-hafferBold",
                            description: "Select the font for the modal heading text"
                        },
                        {
                            name: "modal_body",
                            label: "Modal Body",
                            component: "textarea"
                        },
                        {
                            name: "modal_bodyFont",
                            label: "Modal Body Font",
                            component: "select",
                            options: FontSelector,
                            defaultValue: "font-haffer",
                            description: "Select the font for the modal body text"
                        },
                        {
                            name: "modal_link",
                            label: "Modal Link (optional)",
                            component: "link"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/CarouselHotspots/index.js


;// CONCATENATED MODULE: ./src/sections/BorderedGrid/BorderedGrid.jsx




function BorderedGrid(param) {
    var cms = param.cms;
    var ref, ref1, ref2;
    var getCTAclass = function(style) {
        if (style === "link") return "focus-link";
        if (style === "primary") return "no-underline button button--primary";
        if (style === "secondary") return "no-underline button button--secondary";
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-comp": BorderedGrid.displayName,
        className: "bordered-grid px-4 py-12 md-:px-12 md-:py-14 2xl:py-16",
        id: "".concat(BorderedGrid.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(BorderedGrid.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(BorderedGrid.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto flex max-w-[1120px] flex-wrap border border-black",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full lg:order-last lg:w-1/2",
                        children: [
                            (cms === null || cms === void 0 ? void 0 : cms.image) && (cms === null || cms === void 0 ? void 0 : cms.over_grid) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "-m-2.5 flex h-[calc(100%+20px)] w-[calc(100%+20px)] items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: "w-full object-cover",
                                    width: "1160",
                                    height: "1240",
                                    loading: "lazy",
                                    sizes: "40vw",
                                    src: cms.image.src,
                                    alt: cms.image.alt
                                })
                            }),
                            (cms === null || cms === void 0 ? void 0 : cms.image) && !(cms === null || cms === void 0 ? void 0 : cms.over_grid) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative h-full w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: "w-full object-cover",
                                    width: "1120",
                                    height: "1200",
                                    loading: "lazy",
                                    sizes: "40vw",
                                    src: cms.image.src,
                                    alt: cms.imageAlt
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full border-t border-black lg:order-first lg:flex lg:w-1/2 lg:flex-col lg:border-t-0 lg:border-r",
                        children: [
                            (cms === null || cms === void 0 ? void 0 : cms.heading) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "border-b border-black px-7 py-6 md-:px-[120px] md-:py-8 lg:px-12 lg:py-6 xl:py-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-header mb-0 font-light ".concat((cms === null || cms === void 0 ? void 0 : cms.headingFont) || "font-tiempos"),
                                    children: cms.heading
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-7 py-6 md-:px-[120px] md-:py-8 lg:flex-grow lg:px-12 lg:py-6 xl:py-8",
                                children: [
                                    (cms === null || cms === void 0 ? void 0 : cms.body) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bordered-grid-body w-full ".concat((cms === null || cms === void 0 ? void 0 : cms.bodyFont) || "font-haffer"),
                                        dangerouslySetInnerHTML: {
                                            __html: cms.body
                                        }
                                    }),
                                    (cms === null || cms === void 0 ? void 0 : (ref = cms.cta_link) === null || ref === void 0 ? void 0 : ref.text) && (cms === null || cms === void 0 ? void 0 : (ref1 = cms.cta_link) === null || ref1 === void 0 ? void 0 : ref1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: cms.cta_link.url,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "".concat(getCTAclass(cms.cta_style), " mt-6 inline-block cursor-pointer text-[14px] leading-[22px] 2xl:mt-8"),
                                            children: cms.cta_link.text
                                        })
                                    })
                                ]
                            }),
                            (cms === null || cms === void 0 ? void 0 : (ref2 = cms.icons) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bordered-grid-icons border-t border-black",
                                children: cms.icons.map(function(icon, iconIdx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: "bordered-grid-icon border-r border-black py-6 last:border-r-0",
                                        children: [
                                            (icon === null || icon === void 0 ? void 0 : icon.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "mx-auto mb-3 block aspect-square h-14 w-14 md-:mb-[18px] md-:h-[66px] md-:w-[66px] xl:mb-2 xl:h-[76px] xl:w-[76px]",
                                                loading: "lazy",
                                                src: icon.image.src,
                                                alt: icon.iconAlt || icon.title,
                                                width: "160",
                                                height: "160"
                                            }),
                                            (icon === null || icon === void 0 ? void 0 : icon.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xsmall mb-0 font-hafferBold",
                                                children: icon.title
                                            })
                                        ]
                                    }, "icon-".concat(iconIdx));
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
BorderedGrid.displayName = "BorderedGrid";
BorderedGrid.Schema = {
    category: "Modules",
    label: BorderedGrid.displayName,
    key: "BorderedGrid",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "heading",
            label: "Heading",
            component: "text"
        },
        {
            name: "headingFont",
            label: "Heading Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the heading text"
        },
        {
            name: "body",
            label: "Body",
            description: "This holds paragraph text and ordered/unordered list",
            component: "html"
        },
        {
            name: "bodyFont",
            label: "Body Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the body text"
        },
        {
            name: "cta_link",
            label: "CTA Link",
            component: "link"
        },
        {
            name: "cta_style",
            label: "CTA Link Style",
            component: "select",
            options: [
                {
                    label: "Text Link",
                    value: "link"
                },
                {
                    label: "Button Primary",
                    value: "primary"
                },
                {
                    label: "Button Secondary",
                    value: "secondary"
                }, 
            ],
            defaultValue: "link"
        },
        {
            name: "icons",
            label: "Icons",
            component: "group-list",
            fields: [
                {
                    name: "title",
                    label: "Title",
                    component: "text"
                },
                {
                    name: "titleFont",
                    label: "Title Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the title text"
                },
                {
                    name: "image",
                    label: "Image Icon",
                    component: "image",
                    description: "PNG/SVG format image, Recommended Icon Size: 160px x 160px (square dimension)"
                },
                {
                    name: "iconAlt",
                    label: "Image alt text",
                    component: "text"
                }, 
            ]
        },
        {
            name: "image",
            label: "Image",
            component: "image",
            description: "Recommended Over Grid Image Size: 1160px x 1240px, without: 1120px x 1200px"
        },
        {
            name: "imageAlt",
            label: "Image alt text",
            component: "text"
        },
        {
            name: "over_grid",
            label: "Over Grid Image?",
            component: "toggle",
            toggleLabels: {
                true: "Yes",
                false: "No"
            },
            defaultValue: false
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/BorderedGrid/index.js


// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/sections/GorgiasContactForm/GorgiasContactForm.jsx


function GorgiasContactForm(param) {
    var cms = param.cms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(GorgiasContactForm.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(GorgiasContactForm.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(GorgiasContactForm.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                defer: true,
                type: "text/javascript",
                src: "https://contact-us.gorgias.help/api/contact-form-loader.js?source=https://contact-us.gorgias.help/en-US/embed/contact"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "stylesheet",
                href: "https://contact-us.gorgias.help/api/contact-form-loader.css"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "gorgias-contact-form-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "gorgias-contact-form-loader"
                })
            })
        ]
    });
}
GorgiasContactForm.displayName = "GorgiasContactForm";
GorgiasContactForm.Schema = {
    category: "Contact",
    label: GorgiasContactForm.displayName,
    key: "contactform",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/GorgiasContactForm/index.js


// EXTERNAL MODULE: ../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(35230);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/hooks/index.js + 13 modules
var hooks = __webpack_require__(98702);
// EXTERNAL MODULE: ./src/snippets/components/YotpoStars.jsx + 1 modules
var YotpoStars = __webpack_require__(8693);
// EXTERNAL MODULE: ./src/utilities/Images.js
var Images = __webpack_require__(80152);
// EXTERNAL MODULE: ./src/utilities/Metafields.js
var Metafields = __webpack_require__(86501);
// EXTERNAL MODULE: ./src/snippets/products/ProductBadge.jsx
var ProductBadge = __webpack_require__(36092);
;// CONCATENATED MODULE: ./src/sections/ProductUpsells/ProductUpsells.jsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}













function ProductUpsells_Section(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3, ref4;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var addItemToCart = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(id) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return cartAddItem({
                            merchandiseId: id,
                            quantity: 1,
                            attributes: [
                                {
                                    key: "_sc",
                                    value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                                }
                            ]
                        }, function() {
                            window.dispatchEvent(new CustomEvent("openSideCart"));
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addItemToCart(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var itemCount = (cms === null || cms === void 0 ? void 0 : (ref = cms.productupsells) === null || ref === void 0 ? void 0 : ref.length) || 0;
    if (itemCount <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(ProductUpsells_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": "productupsells",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(ProductUpsells_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(ProductUpsells_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-upsells inner-product-upsells-container flex flex-col items-center justify-center",
                children: [
                    (cms === null || cms === void 0 ? void 0 : cms.section_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "sub-regular mb-[16px] text-center font-normal",
                        children: cms.section_title
                    }),
                    (cms === null || cms === void 0 ? void 0 : (ref1 = cms.productupsells) === null || ref1 === void 0 ? void 0 : ref1.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-upsells-container w-full -pr-4 m-auto overflow-hidden ml-0 -mr-0 m-0 px-0 text-left border-grey-4 xl-plus:border-t",
                        children: cms === null || cms === void 0 ? void 0 : (ref2 = cms.productupsells) === null || ref2 === void 0 ? void 0 : ref2.map(function(upsellItem, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellItem, {
                                upsellItem: upsellItem,
                                index: index,
                                addItemToCart: addItemToCart
                            }, index);
                        })
                    }),
                    (cms === null || cms === void 0 ? void 0 : (ref3 = cms.productupsells) === null || ref3 === void 0 ? void 0 : ref3.length) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-main-upsell-container flex justify-center border-grey-4",
                        children: cms === null || cms === void 0 ? void 0 : (ref4 = cms.productupsells) === null || ref4 === void 0 ? void 0 : ref4.map(function(upsellItem, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellItem, {
                                upsellItem: upsellItem,
                                index: index,
                                addItemToCart: addItemToCart
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
}
function UpsellItem(param) {
    var upsellItem = param.upsellItem, index = param.index, addItemToCart = param.addItemToCart;
    var ref8, ref5, ref6, ref7;
    var product = (0,dist.useProductByHandle)({
        handle: upsellItem === null || upsellItem === void 0 ? void 0 : (ref8 = upsellItem.productName) === null || ref8 === void 0 ? void 0 : (ref5 = ref8.handle) === null || ref5 === void 0 ? void 0 : ref5.replace("/products/", "")
    }).product;
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var imageUrl = (0,react.useMemo)(function() {
        var ref;
        return (0,Images/* getSizedImageUrl */.M0)(product === null || product === void 0 ? void 0 : (ref = product.featuredImage) === null || ref === void 0 ? void 0 : ref.src, "200x200@2x");
    }, [
        product === null || product === void 0 ? void 0 : (ref6 = product.featuredImage) === null || ref6 === void 0 ? void 0 : ref6.src
    ]);
    var productTitle = metafieldMap.custom_product_title || (product === null || product === void 0 ? void 0 : product.title);
    var productIngredient = metafieldMap.custom_ingredient_title;
    var comparePriceText = (metafieldMap === null || metafieldMap === void 0 ? void 0 : metafieldMap.custom_compare_at_price) || "";
    var bottomline = (0,hooks/* useYotpoProductBottomline */.zs)({
        legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId
    }).bottomline;
    if (!product) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-upsell-container relative mb-[55px] w-full snap-center border border-grey-4 xl-plus:mb-0 xl-plus:mb-auto xl-plus:border-t-0 xl-plus:border-r xl-plus:border-b xl-plus:!border-l",
        "data-index": index,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full text-sm text-base",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex h-full w-full flex-row items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "product-upsell__image-container relative block aspect-square w-full w-auto bg-grey-9",
                            title: productTitle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* default */.Z, {
                                    product: product,
                                    className: "pointer-events-none !top-1 !right-2 z-10 !h-10 !w-10"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pointer-events-none aspect-square w-[140px]",
                                    children: imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        src: imageUrl,
                                        alt: (product === null || product === void 0 ? void 0 : (ref7 = product.featuredImage) === null || ref7 === void 0 ? void 0 : ref7.alt) || (product === null || product === void 0 ? void 0 : product.title),
                                        sizes: "(max-width=1023px) 50vw, 15vw",
                                        width: "140",
                                        height: "140",
                                        fill: true,
                                        loading: "lazy"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-full w-full flex-col p-4 px-4 py-2 xl-plus:flex-row xl-plus:items-start xl-plus:px-6 xl-plus:py-0 xl-plus:py-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "product-upsell__info-container flex w-full flex-col items-start no-underline",
                                    children: [
                                        productIngredient && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-xsmall pointer-events-none mb-[4px] text-left font-tiempos font-normal italic",
                                            children: productIngredient
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-small pointer-events-none mb-[6px] text-left font-tiempos font-normal leading-[19px]",
                                            children: productTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "yotpo-reviews pointer-events-none mb-[6px] min-h-[17.5px]",
                                            children: bottomline && bottomline.total_reviews > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-wrap items-center gap-1.5",
                                                children: bottomline.total_reviews ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YotpoStars/* YotpoStars */.M, {
                                                        rating: bottomline.average_score
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mb-0 text-[13px] leading-[17.5px] underline",
                                                    children: "No reviews"
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "yotpo-no-reviews text-sm text-black underline",
                                                children: "No reviews"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
                                            variant: product === null || product === void 0 ? void 0 : product.variants[0],
                                            className: "product-upsell-prices pointer-events-none mb-0 block !text-xs !text-black xl-plus:hidden",
                                            comparePriceText: comparePriceText
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-end justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
                                        variant: product === null || product === void 0 ? void 0 : product.variants[0],
                                        className: "product-upsell-prices pointer-events-none mb-4 hidden !text-xs !text-black xl-plus:block",
                                        comparePriceText: comparePriceText
                                    }),
                                    (product === null || product === void 0 ? void 0 : product.variants[0]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "product-upsell__atc-button text-xsmall button--primary absolute bottom-[-35px] z-[1] mr-[-1rem] mt-auto w-full !min-w-0 py-2 px-4 text-center font-hafferBold text-white transition xl-plus:relative xl-plus:bottom-auto xl-plus:mr-auto xl-plus:mt-0 xl-plus:w-[120px]",
                                        onClick: function() {
                                            addItemToCart(product === null || product === void 0 ? void 0 : product.variants[0].id);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "pointer-events-none mr-[4px] tracking-wide",
                                                children: "add"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "sr-only",
                                                children: [
                                                    "Add ",
                                                    productTitle,
                                                    " to the cart"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
ProductUpsells_Section.displayName = "ProductUpsells";
ProductUpsells_Section.Schema = {
    category: "Product",
    label: ProductUpsells_Section.displayName,
    key: "productupsells",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "section_title",
            label: "Section Title",
            component: "text"
        },
        {
            name: "productupsells",
            label: "Product Upsell",
            component: "group-list",
            fields: [
                {
                    component: "productSearch",
                    name: "productName",
                    label: "Select Product"
                }, 
            ]
        }, 
    ]
};
var ProductUpsells = ProductUpsells_Section;

;// CONCATENATED MODULE: ./src/sections/ProductUpsells/index.js


// EXTERNAL MODULE: ./src/snippets/globals/layout/ProductCard.jsx
var ProductCard = __webpack_require__(99666);
;// CONCATENATED MODULE: ./src/snippets/components/OrderRecommendation.jsx




function OrderRecommendation(param) {
    var orderId = param.orderId, title = param.title, showBWPBadge = param.showBWPBadge, aboveTheFold = param.aboveTheFold, index = param.index;
    var ref, ref1, ref2;
    var order = (0,dist.useCustomerOrder)({
        id: orderId
    }).order;
    if (!order) {
        return;
    }
    var matchingLineItem = order === null || order === void 0 ? void 0 : order.lineItems.find(function(item) {
        return item.title === title;
    });
    if (!(matchingLineItem === null || matchingLineItem === void 0 ? void 0 : (ref = matchingLineItem.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.handle) || (matchingLineItem === null || matchingLineItem === void 0 ? void 0 : (ref2 = matchingLineItem.variant) === null || ref2 === void 0 ? void 0 : ref2.availableForSale) === false) {
        return;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
        handle: matchingLineItem.variant.product.handle,
        showReviews: false,
        quickViewButton: "bottom",
        showBWPBadge: showBWPBadge,
        belowFold: !aboveTheFold,
        isSection: true
    }, "order-recommendation-".concat(index));
};

;// CONCATENATED MODULE: ./src/sections/ProductRecommendations/ProductRecommendations.jsx
function ProductRecommendations_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}










function ProductRecommendations_Section(param) {
    var cms = param.cms, collection = param.collection;
    var ref9, ref1;
    var textColor = cms.textColor, textColor_m = cms.textColor_m, _aboveTheFold = cms.aboveTheFold, aboveTheFold = _aboveTheFold === void 0 ? false : _aboveTheFold, _hideTextMobile = cms.hideTextMobile, hideTextMobile = _hideTextMobile === void 0 ? false : _hideTextMobile, _imageWidth = cms.imageWidth, imageWidth = _imageWidth === void 0 ? "lg:w-3/12" : _imageWidth, _productToShow = cms.productToShow, productToShow = _productToShow === void 0 ? "4.4" : _productToShow;
    var siteSettings = (0,dist.useSettings)();
    var bwpSettings = siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.buyWithPrime;
    var country = (0,dist.useCountry)().country;
    var isUs = (country === null || country === void 0 ? void 0 : country.isoCode) === "US";
    var showBWPBadge = false;
    var sliderRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(0), mgRight = ref2[0], setMgRight = ref2[1];
    var sliderWidth = imageWidth === "lg:w-3/12" ? "lg:w-9/12" : "lg:w-7/12";
    var orders = (0,dist.useCustomerOrders)({
        perPage: 5,
        page: 1
    }).orders;
    var ref3 = (0,react.useState)(null), initialOrders = ref3[0], setInitialOrders = ref3[1];
    var previouslyOrderedCarousel = false;
    var previousOrderLineItems = [];
    if (orders && initialOrders === null) {
        setInitialOrders(orders);
    }
    if (initialOrders) {
        previouslyOrderedCarousel = cms.recommendPreviouslyOrderedProducts && initialOrders.length > 3;
        initialOrders === null || initialOrders === void 0 ? void 0 : initialOrders.forEach(function(order) {
            order.lineItems.edges.forEach(function(lineItem) {
                var lineItemData = {
                    orderId: order.id,
                    title: lineItem.node.title
                };
                previousOrderLineItems.push(lineItemData);
            });
        });
    }
    if ((bwpSettings === null || bwpSettings === void 0 ? void 0 : bwpSettings.bwpLocation) === "global" && isUs) {
        showBWPBadge = true;
    }
    if ((bwpSettings === null || bwpSettings === void 0 ? void 0 : bwpSettings.bwpLocation) === "local" && (bwpSettings === null || bwpSettings === void 0 ? void 0 : (ref9 = bwpSettings.collectionList) === null || ref9 === void 0 ? void 0 : ref9.indexOf(collection === null || collection === void 0 ? void 0 : collection.title)) > -1 && isUs) {
        showBWPBadge = true;
    }
    (0,react.useEffect)(function() {
        if (!(sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) || !(cms === null || cms === void 0 ? void 0 : cms.overflowRightEdge)) return;
        var windowOffsetRight = function(ele) {
            var rect = ele.getBoundingClientRect();
            var width = document.body.clientWidth || window.clientWidth;
            return width - (rect.x + rect.width) > 0 ? width - (rect.x + rect.width) : 0;
        };
        var reachRightEdge = function() {
            if (!(sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current)) return;
            var slider = sliderRef.current;
            var parentEl = slider.closest(".recommendations-right-area");
            if (!parentEl) return;
            var right = -1 * windowOffsetRight(parentEl);
            setMgRight("".concat(right, "px"));
        };
        var debounceFunction = function(cb, delay) {
            var timer;
            return function() {
                if (timer) clearTimeout(timer);
                timer = setTimeout(function() {
                    return cb();
                }, delay);
            };
        };
        var debounce = debounceFunction(reachRightEdge, 300);
        debounce();
        window.addEventListener("resize", debounce);
        return function() {
            window.removeEventListener("resize", debounce);
        };
    }, [
        sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current,
        cms === null || cms === void 0 ? void 0 : cms.overflowRightEdge
    ]);
    var getCTAclass = function(style) {
        if (style === "link") return "focus-link";
        if (style === "white-link") return "focus-link-white";
        return "";
    };
    var buildImage = function() {
        if ((cms === null || cms === void 0 ? void 0 : cms.section_image_desktop) || (cms === null || cms === void 0 ? void 0 : cms.section_image_mobile)) {
            var ref, ref4, ref5, ref6, ref7, ref8;
            return (cms === null || cms === void 0 ? void 0 : (ref = cms.section_image_link) === null || ref === void 0 ? void 0 : ref.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: cms === null || cms === void 0 ? void 0 : (ref4 = cms.section_image_link) === null || ref4 === void 0 ? void 0 : ref4.url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "relative cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            className: "relative block h-auto w-full lg:h-full",
                            children: [
                                (cms === null || cms === void 0 ? void 0 : cms.section_image_mobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    srcSet: (0,Images/* getSizedImageUrl */.M0)(cms === null || cms === void 0 ? void 0 : cms.section_image_desktop.src, "432x@2x"),
                                    media: "(min-width: 1024px)",
                                    width: "864",
                                    height: "1420"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,Images/* getSizedImageUrl */.M0)((cms === null || cms === void 0 ? void 0 : (ref5 = cms.section_image_mobile) === null || ref5 === void 0 ? void 0 : ref5.src) || (cms === null || cms === void 0 ? void 0 : (ref6 = cms.section_image_desktop) === null || ref6 === void 0 ? void 0 : ref6.src), "670x405@2x"),
                                    alt: cms.section_image_alt,
                                    loading: aboveTheFold ? "eager" : "lazy",
                                    className: "top-0 left-0 w-full object-cover object-center lg:absolute lg:h-full",
                                    width: "1340",
                                    height: "800"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute bottom-0 left-0 hidden w-full py-4 px-5 sm:py-6 md:py-8 lg:block lg+:px-7",
                            children: [
                                (cms === null || cms === void 0 ? void 0 : cms.desktop_image_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "m-0 mb-3 ".concat((cms === null || cms === void 0 ? void 0 : cms.desktopImageTitleFont) || "font-tiempos", " text-h3-m md:text-h4 ").concat(textColor),
                                    children: cms === null || cms === void 0 ? void 0 : cms.desktop_image_title
                                }),
                                (cms === null || cms === void 0 ? void 0 : cms.desktop_image_copy) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-2 ".concat((cms === null || cms === void 0 ? void 0 : cms.desktopImageDescriptionFont) || "font-haffer", " ").concat(textColor),
                                    children: cms === null || cms === void 0 ? void 0 : cms.desktop_image_copy
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat(getCTAclass(cms.section_image_cta_style), " cursor-pointer text-[14px] leading-[22px] ").concat((cms === null || cms === void 0 ? void 0 : cms.desktopImageDescriptionFont) || "font-haffer"),
                                    children: cms.section_image_link.text
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute bottom-0 left-0 block w-full py-4 px-5 sm:py-6 md:py-8 lg:hidden lg+:px-7",
                            children: [
                                (cms === null || cms === void 0 ? void 0 : cms.mobile_image_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "m-0 mb-3 ".concat((cms === null || cms === void 0 ? void 0 : cms.mobileImageTitleFont) || "font-tiempos", " text-h3-m md:text-h4 ").concat(textColor_m),
                                    children: cms === null || cms === void 0 ? void 0 : cms.mobile_image_title
                                }),
                                (cms === null || cms === void 0 ? void 0 : cms.mobile_image_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-2 ".concat((cms === null || cms === void 0 ? void 0 : cms.mobileImageDescriptionFont) || "font-haffer", " ").concat(textColor_m),
                                    children: cms === null || cms === void 0 ? void 0 : cms.mobile_image_description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "focus-link cursor-pointer ${cms?.mobileImageDescriptionFont || 'font-haffer'}",
                                    children: cms.section_image_link.text
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                className: "relative block h-auto w-full lg:h-full",
                children: [
                    (cms === null || cms === void 0 ? void 0 : cms.section_image_mobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        srcSet: (0,Images/* getSizedImageUrl */.M0)(cms === null || cms === void 0 ? void 0 : cms.section_image_desktop.src, "432x@2x"),
                        media: "(min-width: 1024px)",
                        width: "864",
                        height: "1420"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,Images/* getSizedImageUrl */.M0)((cms === null || cms === void 0 ? void 0 : (ref7 = cms.section_image_mobile) === null || ref7 === void 0 ? void 0 : ref7.src) || (cms === null || cms === void 0 ? void 0 : (ref8 = cms.section_image_desktop) === null || ref8 === void 0 ? void 0 : ref8.src), "670x405@2x"),
                        alt: cms.section_image_alt,
                        loading: aboveTheFold ? "eager" : "lazy",
                        className: "top-0 left-0 w-full object-cover object-center lg:absolute lg:h-full",
                        width: "1340",
                        height: "800"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute bottom-0 left-0 hidden w-full py-4 px-5 sm:py-6 md:py-8 lg:block lg+:px-7",
                        children: [
                            (cms === null || cms === void 0 ? void 0 : cms.desktop_image_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "m-0 mb-3 ".concat((cms === null || cms === void 0 ? void 0 : cms.desktopImageTitleFont) || "font-tiempos", " text-h3-m md:text-h4 ").concat(textColor),
                                children: cms === null || cms === void 0 ? void 0 : cms.desktop_image_title
                            }),
                            (cms === null || cms === void 0 ? void 0 : cms.desktop_image_copy) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0 ".concat((cms === null || cms === void 0 ? void 0 : cms.desktopImageDescriptionFont) || "font-haffer", " ").concat(textColor),
                                children: cms === null || cms === void 0 ? void 0 : cms.desktop_image_copy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute bottom-0 left-0 block w-full py-4 px-5 sm:py-6 md:py-8 lg:hidden lg+:px-7",
                        children: [
                            (cms === null || cms === void 0 ? void 0 : cms.mobile_image_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "m-0 mb-3 ".concat((cms === null || cms === void 0 ? void 0 : cms.mobileImageTitleFont) || "font-tiempos", " text-h3-m md:text-h4 ").concat(textColor_m),
                                children: cms === null || cms === void 0 ? void 0 : cms.mobile_image_title
                            }),
                            (cms === null || cms === void 0 ? void 0 : cms.mobile_image_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0 ".concat((cms === null || cms === void 0 ? void 0 : cms.mobileImageDescriptionFont) || "font-haffer", " ").concat(textColor_m),
                                children: cms === null || cms === void 0 ? void 0 : cms.mobile_image_description
                            })
                        ]
                    })
                ]
            });
        }
        return null;
    };
    var buildText = function() {
        var floatingCta = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var ref, ref10;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "recommendations-text relative mx-auto mb-7 flex w-full max-w-[440px] flex-col items-center px-4 text-center md:mb-15 md:px-0 lg:block lg:max-w-full lg:text-left ".concat(hideTextMobile ? "max-lg:hidden" : ""),
            children: [
                (cms === null || cms === void 0 ? void 0 : cms.section_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-header mb-5 lg:mb-2 lg:max-w-md xl:max-w-lg ".concat((cms === null || cms === void 0 ? void 0 : cms.titleFont) || "font-tiempos"),
                    children: cms === null || cms === void 0 ? void 0 : cms.section_title
                }),
                (cms === null || cms === void 0 ? void 0 : cms.section_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-5 ".concat((cms === null || cms === void 0 ? void 0 : cms.descriptionFont) || "font-haffer", " text-h6-m lg:mb-4 lg:max-w-sm lg:text-h6 xl:max-w-lg"),
                    dangerouslySetInnerHTML: {
                        __html: (0,Helper/* newLineToBr */.td)(cms === null || cms === void 0 ? void 0 : cms.section_description)
                    }
                }),
                (cms === null || cms === void 0 ? void 0 : (ref = cms.section_cta) === null || ref === void 0 ? void 0 : ref.text) && (cms === null || cms === void 0 ? void 0 : (ref10 = cms.section_cta) === null || ref10 === void 0 ? void 0 : ref10.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((cms === null || cms === void 0 ? void 0 : cms.descriptionFont) || "font-haffer", " ").concat(floatingCta ? "lg:absolute lg:right-[7%] lg:bottom-0 " : "relative"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: cms === null || cms === void 0 ? void 0 : cms.section_cta.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "focus-link",
                            target: (cms === null || cms === void 0 ? void 0 : cms.section_cta.newTab) ? "_blank" : null,
                            children: cms === null || cms === void 0 ? void 0 : cms.section_cta.text
                        })
                    })
                })
            ]
        });
    };
    if (cms.recommendPreviouslyOrderedProducts && orders && orders.length === 0) {
        return;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "".concat(ProductRecommendations_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": ProductRecommendations_Section.key,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(ProductRecommendations_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(ProductRecommendations_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            (cms === null || cms === void 0 ? void 0 : cms.uniqueId) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: cms.uniqueId
            }),
            (cms === null || cms === void 0 ? void 0 : cms.section_heading) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mx-4 lg:mx-0 mt-0 mb-4 text-h3-m md:text-h4 lg:mb-6 ".concat((cms === null || cms === void 0 ? void 0 : cms.sectionHeadingFont) || "font-haffer"),
                children: cms === null || cms === void 0 ? void 0 : cms.section_heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center px-0 md-:px-12 lg:flex-row lg:items-stretch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "recommendations-left-area mb-6 w-full shrink-0 md:mb-7 lg:mb-0 ".concat(imageWidth, " ").concat(hideTextMobile ? "max-lg:hidden" : ""),
                        children: buildImage() ? buildImage() : buildText()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "recommendations-right-area w-full lg:pl-7 ".concat(sliderWidth),
                        children: [
                            buildImage() && buildText(true),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    marginRight: mgRight
                                },
                                ref: sliderRef,
                                children: previouslyOrderedCarousel || !cms.recommendPreviouslyOrderedProducts && (cms === null || cms === void 0 ? void 0 : (ref1 = cms.product_list) === null || ref1 === void 0 ? void 0 : ref1.length) > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_slick_lib/* default */.Z, {
                                    slidesToShow: Number(productToShow),
                                    infinite: true,
                                    arrows: true,
                                    draggable: true,
                                    slidesToScroll: 1,
                                    responsive: [
                                        {
                                            breakpoint: 1500,
                                            settings: {
                                                slidesToShow: Number(productToShow) - 1,
                                                slidesToScroll: 1
                                            }
                                        },
                                        {
                                            breakpoint: 1100,
                                            settings: {
                                                slidesToShow: Number(productToShow) - 2,
                                                slidesToScroll: 1
                                            }
                                        },
                                        {
                                            breakpoint: 1024,
                                            settings: {
                                                slidesToShow: Number(productToShow) - 1,
                                                slidesToScroll: 1,
                                                infinite: false,
                                                arrows: false
                                            }
                                        },
                                        {
                                            breakpoint: 450,
                                            settings: {
                                                slidesToShow: Number(productToShow) - 3 > 1 ? Number(productToShow) - 3 : 1.15,
                                                slidesToScroll: 1,
                                                infinite: false,
                                                arrows: false
                                            }
                                        }, 
                                    ],
                                    className: "product-recommendations-slider",
                                    children: [
                                        previouslyOrderedCarousel && previousOrderLineItems.map(function(lineItem, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderRecommendation, {
                                                orderId: lineItem.orderId,
                                                title: lineItem.title,
                                                showBWPBadge: showBWPBadge,
                                                aboveTheFold: aboveTheFold,
                                                index: index
                                            }, index);
                                        }),
                                        !previouslyOrderedCarousel && ((cms === null || cms === void 0 ? void 0 : cms.product_list) || []).map(function(productItem, index) {
                                            return productItem.product ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                                handle: productItem.product.handle,
                                                showReviews: false,
                                                quickViewButton: "bottom",
                                                showBWPBadge: showBWPBadge,
                                                belowFold: !aboveTheFold,
                                                isSection: true
                                            }, index) : null;
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-5",
                                    children: [
                                        cms.recommendPreviouslyOrderedProducts && initialOrders && initialOrders.length && previousOrderLineItems.map(function(lineItem, index) {
                                            if (index >= 3) {
                                                return;
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "max-w-xs flex-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderRecommendation, {
                                                    orderId: lineItem.orderId,
                                                    title: lineItem.title,
                                                    showBWPBadge: showBWPBadge,
                                                    aboveTheFold: aboveTheFold,
                                                    index: index
                                                })
                                            });
                                        }),
                                        !cms.recommendPreviouslyOrderedProducts && (cms === null || cms === void 0 ? void 0 : cms.product_list.map(function(productItem, index) {
                                            return productItem.product ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "max-w-xs flex-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                                    handle: productItem.product.handle,
                                                    showReviews: false,
                                                    quickViewButton: "bottom",
                                                    showBWPBadge: showBWPBadge,
                                                    belowFold: !aboveTheFold,
                                                    isSection: true
                                                }, index)
                                            }) : null;
                                        }))
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }, cms === null || cms === void 0 ? void 0 : cms.cmsId);
}
ProductRecommendations_Section.displayName = "Product Recommendations";
var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
ProductRecommendations_Section.Schema = {
    category: "Modules",
    label: ProductRecommendations_Section.displayName,
    key: "productRecommendations",
    fields: [
        {
            component: "toggle",
            name: "aboveTheFold",
            label: "Above the fold",
            toggleLabels: {
                true: "Yes",
                false: "No"
            },
            defaultValue: false
        },
        {
            name: "section_heading",
            label: "Heading",
            component: "text"
        },
        {
            name: "sectionHeadingFont",
            label: "Heading Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-tiempos",
            description: "Select the font for the section heading text"
        },
        {
            name: "uniqueId",
            label: "Unique ID",
            component: "text",
            description: "use for anchor links"
        },
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "text",
            label: "Section Title",
            name: "section_title"
        },
        (_obj = {
            component: "text",
            label: "Section Title Font",
            name: "titleFont"
        }, ProductRecommendations_defineProperty(_obj, "component", "select"), ProductRecommendations_defineProperty(_obj, "options", FontSelector), ProductRecommendations_defineProperty(_obj, "defaultValue", "font-tiempos"), ProductRecommendations_defineProperty(_obj, "description", "Select the font for the section title text"), _obj),
        {
            component: "textarea",
            label: "Section Description",
            name: "section_description"
        },
        (_obj1 = {
            component: "text",
            label: "Section Description Font",
            name: "descriptionFont"
        }, ProductRecommendations_defineProperty(_obj1, "component", "select"), ProductRecommendations_defineProperty(_obj1, "options", FontSelector), ProductRecommendations_defineProperty(_obj1, "defaultValue", "font-haffer"), ProductRecommendations_defineProperty(_obj1, "description", "Select the font for the section description text"), _obj1),
        {
            component: "link",
            label: "Section CTA",
            name: "section_cta"
        },
        {
            component: "image",
            label: "Section Image Desktop (optional)",
            name: "section_image_desktop",
            description: "Recommended size: 864px x 1420px (Height can be variable)"
        },
        {
            component: "select",
            name: "imageWidth",
            label: "image Container Width",
            options: [
                {
                    label: "small",
                    value: "lg:w-3/12"
                },
                {
                    label: "Large",
                    value: "lg:w-5/12"
                }, 
            ],
            defaultValue: "lg:w-3/12"
        },
        {
            component: "image",
            label: "Section Image Mobile (optional)",
            name: "section_image_mobile",
            description: "Recommended size: 1340px x 800px"
        },
        {
            component: "text",
            label: "Section Image Alt",
            name: "section_image_alt",
            description: "For ADA. Add description about image"
        },
        {
            component: "link",
            label: "Section Image Link",
            name: "section_image_link",
            description: "Optional. Applies to desktop and mobile image. If link and text are not populated then the link will not show"
        },
        {
            name: "section_image_section_image_",
            label: "CTA Link Style",
            component: "select",
            options: [
                {
                    label: "Focus Link",
                    value: "link"
                },
                {
                    label: "Focus Link White",
                    value: "white-link"
                }, 
            ],
            defaultValue: "link"
        },
        {
            component: "text",
            label: "Desktop Image Title",
            name: "desktop_image_title"
        },
        (_obj2 = {
            component: "text",
            label: "Desktop Image Title Font",
            name: "desktopImageTitleFont"
        }, ProductRecommendations_defineProperty(_obj2, "component", "select"), ProductRecommendations_defineProperty(_obj2, "options", FontSelector), ProductRecommendations_defineProperty(_obj2, "defaultValue", "font-tiempos"), ProductRecommendations_defineProperty(_obj2, "description", "Select the font for the desktop image title text"), _obj2),
        {
            component: "text",
            label: "Desktop Image Description",
            name: "desktop_image_copy"
        },
        (_obj3 = {
            component: "text",
            label: "Desktop Image Description Font",
            name: "desktopImageDescriptionFont"
        }, ProductRecommendations_defineProperty(_obj3, "component", "select"), ProductRecommendations_defineProperty(_obj3, "options", FontSelector), ProductRecommendations_defineProperty(_obj3, "defaultValue", "font-haffer"), ProductRecommendations_defineProperty(_obj3, "description", "Select the font for the desktop image description text"), _obj3),
        {
            component: "select",
            name: "textColor",
            label: "Text Color (Desktop)",
            options: [
                {
                    label: "Light",
                    value: "text-white"
                },
                {
                    label: "Dark",
                    value: "text-black"
                }, 
            ],
            defaultValue: "text-black"
        },
        {
            component: "toggle",
            name: "hideTextMobile",
            label: "hide Image & Section Texts (Mobile)",
            toggleLabels: {
                true: "Yes",
                false: "No"
            },
            defaultValue: false
        },
        {
            component: "text",
            label: "Mobile Image Title",
            name: "mobile_image_title"
        },
        (_obj4 = {
            component: "text",
            label: "Mobile Image Title Font",
            name: "mobileImageTitleFont"
        }, ProductRecommendations_defineProperty(_obj4, "component", "select"), ProductRecommendations_defineProperty(_obj4, "options", FontSelector), ProductRecommendations_defineProperty(_obj4, "defaultValue", "font-tiempos"), ProductRecommendations_defineProperty(_obj4, "description", "Select the font for the mobile image title text"), _obj4),
        {
            component: "text",
            label: "Mobile Image Description",
            name: "mobile_image_description"
        },
        (_obj5 = {
            component: "text",
            label: "Mobile Image Description Font",
            name: "mobileImageDescriptionFont"
        }, ProductRecommendations_defineProperty(_obj5, "component", "select"), ProductRecommendations_defineProperty(_obj5, "options", FontSelector), ProductRecommendations_defineProperty(_obj5, "defaultValue", "font-haffer"), ProductRecommendations_defineProperty(_obj5, "description", "Select the font for the mobile image description text"), _obj5),
        {
            component: "select",
            name: "textColor_m",
            label: "Text Color (Mobile)",
            options: [
                {
                    label: "Light",
                    value: "text-white"
                },
                {
                    label: "Dark",
                    value: "text-black"
                }, 
            ],
            defaultValue: "text-black"
        },
        {
            component: "select",
            name: "productToShow",
            label: "number Product per Slide (Desktop)",
            options: [
                {
                    label: "3",
                    value: "3.3"
                },
                {
                    label: "4",
                    value: "4.4"
                },
                {
                    label: "5",
                    value: "5.4"
                }, 
            ],
            defaultValue: "4.4"
        },
        {
            component: "toggle",
            name: "overflowRightEdge",
            label: "Slider overflow to right edge",
            toggleLabels: {
                true: "Yes",
                false: "No"
            },
            defaultValue: false
        },
        {
            component: "group-list",
            label: "Product List",
            name: "product_list",
            description: "Recommended to have at least 5 products populated.",
            fields: [
                {
                    component: "productSearch",
                    label: "Product",
                    name: "product"
                }, 
            ]
        },
        {
            component: "toggle",
            name: "recommendPreviouslyOrderedProducts",
            label: "Recommend previously ordered products",
            description: "Note: the section will not show if the user has no orders"
        }, 
    ]
};
var ProductRecommendations = ProductRecommendations_Section;

;// CONCATENATED MODULE: ./src/sections/ProductRecommendations/index.js


;// CONCATENATED MODULE: ./src/sections/ParallaxStory/ParallaxStory.jsx



function ParallaxStory(param) {
    var cms = param.cms;
    var ref;
    var storyContainer = (0,react.useRef)();
    var isElementInViewport = function(el) {
        // check if an element is past 60% of the viewport.
        var rect = el.getBoundingClientRect();
        return rect.top < window.outerHeight * 0.55;
    };
    (0,react.useEffect)(function() {
        var callbackFunc = function callbackFunc() {
            items.forEach(function(item, index) {
                if (isElementInViewport(item)) {
                    var moduleHeight = item.offsetHeight;
                    var visibleArea = window.outerHeight * 0.55 - item.getBoundingClientRect().top;
                    var barHeight = visibleArea * 100 / moduleHeight;
                    item.querySelector(".storyBar").style.height = barHeight > 100 ? "100%" : "".concat(barHeight, "%");
                    item.classList.add("in-view");
                } else {
                    item.classList.remove("in-view");
                }
            });
        };
        var items = storyContainer.current.querySelectorAll(".story-container");
        // listen for events
        if (true) {
            window.addEventListener("load", callbackFunc);
            window.addEventListener("resize", callbackFunc);
            window.addEventListener("scroll", callbackFunc);
        }
        return function() {
            window.removeEventListener("load", callbackFunc);
            window.removeEventListener("resize", callbackFunc);
            window.removeEventListener("scroll", callbackFunc);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "".concat(ParallaxStory.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": ParallaxStory.displayName,
        className: "parallax-story-container overflow-x-hidden",
        ref: storyContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(ParallaxStory.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(ParallaxStory.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "m-auto mb-[47px] max-w-[300px] text-center lg:mb-[165px] lg:max-w-[430px]",
                children: [
                    (cms === null || cms === void 0 ? void 0 : cms.section_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-header mb-3 px-5 lg:mb-4",
                        children: cms === null || cms === void 0 ? void 0 : cms.section_title
                    }),
                    (cms === null || cms === void 0 ? void 0 : cms.section_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mx-auto mb-0 px-5 font-primary text-base font-light lg:text-lg",
                        dangerouslySetInnerHTML: {
                            __html: (0,Helper/* newLineToBr */.td)(cms === null || cms === void 0 ? void 0 : cms.section_description)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "story-outer-container mx-auto w-full",
                children: cms === null || cms === void 0 ? void 0 : (ref = cms.stories) === null || ref === void 0 ? void 0 : ref.map(function(stories, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "story-container group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "storyBar lg:margin-auto absolute left-0 top-0 block w-1 bg-quinary-1 lg:left-auto"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "story-inner-container opacity-0 transition-opacity duration-300 ease-in-out group-[.in-view]:opacity-100",
                                children: [
                                    (stories === null || stories === void 0 ? void 0 : stories.story_pre_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-2 font-hafferBold text-base leading-none text-black",
                                        children: stories === null || stories === void 0 ? void 0 : stories.story_pre_title
                                    }),
                                    (stories === null || stories === void 0 ? void 0 : stories.story_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-large mb-1.5 font-tiempos sm:text-h4 md:mb-1",
                                        children: stories === null || stories === void 0 ? void 0 : stories.story_title
                                    }),
                                    (stories === null || stories === void 0 ? void 0 : stories.story_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-8 text-[14px] font-light leading-[22px] sm:text-[16px] sm:leading-[24px]",
                                        dangerouslySetInnerHTML: {
                                            __html: (0,Helper/* newLineToBr */.td)(stories === null || stories === void 0 ? void 0 : stories.story_description)
                                        }
                                    }),
                                    (stories === null || stories === void 0 ? void 0 : stories.story_image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: stories === null || stories === void 0 ? void 0 : stories.story_image.src,
                                        className: "story-image h-full w-full max-w-[240px] object-cover lg:max-w-[288px]",
                                        alt: stories === null || stories === void 0 ? void 0 : stories.image_alt,
                                        loading: "lazy",
                                        width: "820",
                                        height: "900"
                                    })
                                ]
                            })
                        ]
                    }, "".concat(cms.id, "-story-").concat(index));
                })
            })
        ]
    });
}
ParallaxStory.displayName = "ParallaxStory";
ParallaxStory.Schema = {
    category: "Modules",
    label: ParallaxStory.displayName,
    key: "ParallaxStory",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "text",
            label: "Section Title",
            name: "section_title"
        },
        {
            component: "textarea",
            label: "Section Description",
            name: "section_description"
        },
        {
            name: "stories",
            label: "Stories",
            component: "group-list",
            fields: [
                {
                    component: "image",
                    label: "Story Image",
                    name: "story_image",
                    description: "Recommended size: 820px x 900px"
                },
                {
                    name: "image_alt",
                    label: "Image alt text",
                    component: "text"
                },
                {
                    component: "text",
                    name: "story_pre_title",
                    label: "Story Pre-title"
                },
                {
                    component: "text",
                    label: "Story Title",
                    name: "story_title"
                },
                {
                    component: "textarea",
                    label: "Story Description",
                    name: "story_description"
                }, 
            ]
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/ParallaxStory/index.js


;// CONCATENATED MODULE: ./src/sections/Quiz/Quiz.jsx


function Quiz(param) {
    var cms = param.cms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "data-comp": Quiz.displayName,
        id: "".concat(Quiz.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(Quiz.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(Quiz.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            (cms === null || cms === void 0 ? void 0 : cms.snippet) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "m-auto block ".concat((cms === null || cms === void 0 ? void 0 : cms.snippetFont) || ""),
                dangerouslySetInnerHTML: {
                    __html: cms.snippet
                }
            })
        ]
    });
}
Quiz.displayName = "Quiz";
Quiz.Schema = {
    category: "Modules",
    label: Quiz.displayName,
    key: "quiz",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "snippet",
            label: "Quiz Snippet",
            component: "html",
            description: "Paste in snippet from Quiz app"
        },
        {
            name: "snippetFont",
            label: "Quiz Snippet Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the quiz snippet"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/Quiz/index.js


// EXTERNAL MODULE: ./src/snippets/globals/layout/FilterBar.jsx
var FilterBar = __webpack_require__(51422);
// EXTERNAL MODULE: ./src/snippets/globals/layout/ProductGrid.jsx + 1 modules
var ProductGrid = __webpack_require__(5011);
;// CONCATENATED MODULE: ./src/snippets/globals/layout/Pagination.jsx
function Pagination_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Pagination_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Pagination_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function Pagination(param) {
    var currentPage = param.currentPage, itemsPerPage = param.itemsPerPage, items = param.items, setLayoutParams = param.setLayoutParams, browserHistory = param.browserHistory;
    var router = (0,next_router.useRouter)();
    var maxPages = Math.ceil(items.length / itemsPerPage);
    var changeCurrentPage = function(page) {
        var urlParams = new URLSearchParams(document.location.search);
        if (page === 1) {
            urlParams.delete("page");
        } else {
            urlParams.set("page", page);
        }
        setLayoutParams(function(layoutParams) {
            var newParams = Pagination_objectSpread({}, layoutParams, {
                page: page
            });
            if (browserHistory) {
                router.push({
                    query: Pagination_objectSpread({}, router.query, {
                        page: newParams.page
                    })
                }, undefined, {
                    shallow: true
                });
            }
            return newParams;
        });
    };
    var buildPaginationItems = function() {
        var _loop = function(i) {
            paginationItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "pagination-item relative mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: "h-8 w-8 before:absolute before:bottom-0 before:left-0 before:right-0 before:mx-auto before:block before:w-0 before:border-b-2 before:border-black before:transition-all before:duration-150 hover:before:!w-3 ".concat(currentPage === i ? " before:!w-3" : ""),
                    onClick: function() {
                        changeCurrentPage(i);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": true,
                            children: i
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "sr-only",
                            children: [
                                "Go to page ",
                                i
                            ]
                        })
                    ]
                })
            }, "pagination-".concat(i)));
        };
        var paginationItems = [];
        var startPage = 1;
        var endPage = maxPages;
        var showPrevSpacer = false;
        var showNextSpacer = false;
        if (currentPage > 3) {
            showPrevSpacer = true;
            startPage = currentPage - 1;
        }
        if (currentPage < maxPages - 2) {
            showNextSpacer = true;
            endPage = parseInt(currentPage, 10) + 1;
        }
        if (showPrevSpacer) {
            paginationItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "relative mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: "h-8 w-8 before:absolute before:bottom-0 before:left-0 before:right-0 before:mx-auto before:block before:w-0 before:border-b-2 before:border-black before:transition-all before:duration-150 hover:before:w-3",
                    onClick: function() {
                        return changeCurrentPage(1);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Go to page"
                        }),
                        "1"
                    ]
                })
            }, "pagination-1"));
            paginationItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "leading-loose",
                    children: "..."
                })
            }, "previousSpacer"));
        }
        for(var i = startPage; i <= endPage; i++)_loop(i);
        if (showNextSpacer) {
            paginationItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "mt-0 h-8 w-8 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "leading-loose",
                    children: "..."
                })
            }, "nextSpacer"));
            paginationItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "relative mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: "h-8 w-8 before:absolute before:bottom-0 before:left-0 before:right-0 before:mx-auto before:block before:w-0 before:border-b-2 before:border-black before:transition-all before:duration-150 hover:before:w-3",
                    onClick: function() {
                        return changeCurrentPage(maxPages);
                    },
                    disabled: currentPage === maxPages,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Go to page"
                        }),
                        maxPages
                    ]
                })
            }, "pagination-".concat(maxPages)));
        }
        return paginationItems;
    };
    return maxPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "pagination mt-10 mb-20 flex w-full list-none justify-center p-0 font-hafferBold",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "pagination-item mt-0 mr-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: function() {
                        return currentPage > 1 && changeCurrentPage(parseInt(currentPage, 10) - 1);
                    },
                    className: "flex h-8 w-8 items-center justify-center border border-black transition-all duration-150 ".concat(currentPage === 1 ? "cursor-not-allowed opacity-50" : "hover:bg-black hover:text-white"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Go to previous page"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* ArrowLeft */.X, {})
                    ]
                })
            }, "previous-button"),
            buildPaginationItems(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "pagination-item mt-0 ml-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: function() {
                        return currentPage < maxPages && changeCurrentPage(parseInt(currentPage, 10) + 1);
                    },
                    className: "flex h-8 w-8 items-center justify-center border border-black transition-all duration-150 ".concat(currentPage === maxPages ? "cursor-not-allowed opacity-50" : "hover:bg-black hover:text-white"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Go to next page"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {})
                    ]
                })
            }, "next-button")
        ]
    });
}
/* harmony default export */ var layout_Pagination = (Pagination);

// EXTERNAL MODULE: ./src/snippets/components/CollectionHeader.jsx
var CollectionHeader = __webpack_require__(85634);
;// CONCATENATED MODULE: ./src/snippets/globals/layout/LoadMore.jsx
function LoadMore_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LoadMore_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LoadMore_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function LoadMore(param) {
    var currentPage = param.currentPage, itemsPerPage = param.itemsPerPage, items = param.items, setLayoutParams = param.setLayoutParams, scrollThreshold = param.scrollThreshold, currentPageItems = param.currentPageItems, browserHistory = param.browserHistory;
    var maxPages = Math.ceil(items.length / itemsPerPage);
    var isBrowser = "object" !== "undefined";
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(0), scrollPosition = ref2[0], setScrollPosition = ref2[1];
    var throttledScrollPosition = (0,hooks/* useThrottle */.fB)(scrollPosition, 20);
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var loadNewPage = function() {
        var nextPage = parseInt(currentPage) + 1;
        if (nextPage > maxPages || loading === true) return;
        setLayoutParams(function(layoutParams) {
            var newParams = LoadMore_objectSpread({}, layoutParams, {
                page: currentPage + 1
            });
            var urlParams = new URLSearchParams(newParams);
            var filter = urlParams.get("filters");
            urlParams.set("filter", filter);
            urlParams.delete("filters");
            if (isBrowser && browserHistory) {
                var ref;
                var newState = LoadMore_objectSpread({}, window.history.state, {
                    url: router.pathname,
                    as: router.pathname.replace("[handle]", router.query.handle) + "?" + ((ref = urlParams.toString()) === null || ref === void 0 ? void 0 : ref.replace(/%2C/g, "%7C"))
                });
                window.history.replaceState(newState, null, newState.as);
            }
            return newParams;
        });
    };
    var scrollHandler = function() {
        setScrollPosition(window.scrollY);
    };
    (0,react.useEffect)(function() {
        if (isBrowser && !!scrollThreshold && scrollThreshold > 0 && currentPage < maxPages) {
            window.addEventListener("scroll", scrollHandler);
        }
        if (currentPageItems.length === currentPage * itemsPerPage) {
            setLoading(false);
        }
        return function() {
            window.removeEventListener("scroll", scrollHandler);
        };
    }, [
        currentPageItems.length
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var windowHeight = isBrowser ? document === null || document === void 0 ? void 0 : (ref = document.body) === null || ref === void 0 ? void 0 : ref.offsetHeight : 0;
        var currentScrollThreshold = windowHeight * (scrollThreshold * 0.01);
        if (window.scrollY >= currentScrollThreshold) {
            loadNewPage();
        }
    }, [
        throttledScrollPosition
    ]);
    return (!scrollThreshold || scrollThreshold === 0) && currentPage < maxPages && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "load-more__container my-10 text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: loadNewPage,
            type: "button",
            className: "button button--primary",
            children: loading ? "loading..." : "load more"
        })
    });
};

;// CONCATENATED MODULE: ./src/sections/Collection/Collection.jsx
function Collection_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Collection_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Collection_arrayLikeToArray(arr);
}
function Collection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Collection_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Collection_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Collection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Collection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Collection_toConsumableArray(arr) {
    return Collection_arrayWithoutHoles(arr) || Collection_iterableToArray(arr) || Collection_unsupportedIterableToArray(arr) || Collection_nonIterableSpread();
}
function Collection_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Collection_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Collection_arrayLikeToArray(o, minLen);
}










function Collection_Section(param) {
    var cms = param.cms, collection = param.collection;
    var ref8, ref1, ref2, ref3;
    var router = (0,dist.useRouter)();
    var settings = (0,dist.useSettings)();
    var campaigns = Collection_objectSpread({}, settings === null || settings === void 0 ? void 0 : settings.collectionTile).campaigns;
    var fullProducts = collection === null || collection === void 0 ? void 0 : collection.products;
    var productsPerPage = 24;
    var sendViewCollectionEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewCollectionEvent;
    var queryFilters = (0,react.useMemo)(function() {
        var ref;
        if (!(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.filter)) return [];
        if (typeof router.query.filter === "string") {
            var ref7;
            return (ref7 = router.query.filter) === null || ref7 === void 0 ? void 0 : ref7.split("|");
        }
        return [];
    }, [
        router === null || router === void 0 ? void 0 : (ref8 = router.query) === null || ref8 === void 0 ? void 0 : ref8.filter
    ]);
    var ref4 = (0,react.useState)({
        filters: queryFilters,
        sort: (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.sort) || "def:def",
        page: (router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.page) || 1
    }), layoutParams = ref4[0], setLayoutParams = ref4[1];
    var promoTiles = (0,react.useMemo)(function() {
        if (!(campaigns === null || campaigns === void 0 ? void 0 : campaigns.length)) return [];
        var campaign1 = campaigns.find(function(campaign) {
            var ref;
            if (!(campaign === null || campaign === void 0 ? void 0 : campaign.enabled)) {
                return false;
            }
            return campaign === null || campaign === void 0 ? void 0 : (ref = campaign.collections) === null || ref === void 0 ? void 0 : ref.some(function(colHandle) {
                return colHandle.trim() === (collection === null || collection === void 0 ? void 0 : collection.handle);
            });
        });
        return (campaign1 === null || campaign1 === void 0 ? void 0 : campaign1.promoTiles) || [];
    }, [
        collection,
        campaigns
    ]);
    var getLoadedPageCTAs = function() {
        var currentPageCTAs = promoTiles === null || promoTiles === void 0 ? void 0 : promoTiles.filter(function(tile) {
            if (cms.enableLoadMore) {
                return Math.ceil(tile.position / productsPerPage) <= layoutParams.page;
            }
            return Math.ceil(tile.position / productsPerPage) == layoutParams.page;
        });
        var loadedPreviousCTAs = promoTiles === null || promoTiles === void 0 ? void 0 : promoTiles.filter(function(tile) {
            if (cms.enableLoadMore) {
                return false;
            }
            return Math.ceil(tile.position / productsPerPage) < layoutParams.page;
        });
        return {
            currentPageCTAs: currentPageCTAs,
            loadedPreviousCTAs: loadedPreviousCTAs
        };
    };
    var tileCtas = getLoadedPageCTAs();
    var sortItems = function() {
        var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var ref;
        var sortPieces = (layoutParams === null || layoutParams === void 0 ? void 0 : (ref = layoutParams.sort) === null || ref === void 0 ? void 0 : ref.split(":")) || [];
        var sortedItems = Collection_toConsumableArray(products).sort(function(a, b) {
            switch(sortPieces[0]){
                case "price":
                    if (sortPieces[1] === "asc") {
                        return (a.priceRange.min || 0) - (b.priceRange.min || 0);
                    }
                    return (b.priceRange.max || 0) - (a.priceRange.max || 0);
                case "alpha":
                    if (sortPieces[1] === "asc") {
                        return a.title.toUpperCase() < b.title.toUpperCase() ? "-1" : "1";
                    }
                    return a.title.toUpperCase() > b.title.toUpperCase() ? "-1" : "1";
                default:
                    return 0;
            }
        });
        return sortedItems;
    };
    var applyFilters = function() {
        var ref;
        var filteredProducts = fullProducts;
        if ((layoutParams === null || layoutParams === void 0 ? void 0 : (ref = layoutParams.filters) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var ref9;
            filteredProducts = collection === null || collection === void 0 ? void 0 : (ref9 = collection.products) === null || ref9 === void 0 ? void 0 : ref9.filter(function(product) {
                return product === null || product === void 0 ? void 0 : product.tags.some(function(tag) {
                    return layoutParams.filters.includes(tag);
                });
            });
        }
        return filteredProducts || [];
    };
    var collectionContainer = (0,react.useRef)();
    var products1 = applyFilters();
    var sortedItems1 = sortItems(products1) || [];
    var ref5 = (0,react.useState)(false), mobileFilterOpen = ref5[0], setMobileFilterOpen = ref5[1];
    var getCurrentPageItems = function() {
        var currentPageItems = [];
        var productList = Collection_toConsumableArray(sortedItems1);
        currentPageItems = (cms === null || cms === void 0 ? void 0 : cms.enableLoadMore) ? productList.slice(0, productsPerPage * ((layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page) || 1) - tileCtas.loadedPreviousCTAs.length - tileCtas.currentPageCTAs.length) : productList.slice(productsPerPage * (((layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page) || 1) - 1) - tileCtas.loadedPreviousCTAs.length, productsPerPage * ((layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page) || 1) - tileCtas.loadedPreviousCTAs.length - tileCtas.currentPageCTAs.length);
        if (tileCtas.currentPageCTAs.length) {
            tileCtas.currentPageCTAs.forEach(function(item) {
                var pageCorrection = 0;
                if (layoutParams.page > 1 && !cms.enableLoadMore) {
                    pageCorrection = productsPerPage * (layoutParams.page - 1);
                }
                currentPageItems.splice(item.position - 1 - pageCorrection, 0, item);
            });
        }
        return currentPageItems;
    };
    var currentPageItems1 = getCurrentPageItems();
    var scrollEffectParams = !(cms === null || cms === void 0 ? void 0 : cms.enableLoadMore) ? [
        layoutParams
    ] : [
        layoutParams.filters.length,
        layoutParams.sort
    ];
    var ref6 = (0,react.useState)(null), scrollY = ref6[0], setScrollY = ref6[1];
    var totalProductsRevealed = currentPageItems1 === null || currentPageItems1 === void 0 ? void 0 : currentPageItems1.length;
    var saveScrollTimeout;
    var saveScroll = function() {
        if (saveScrollTimeout) clearTimeout(saveScrollTimeout);
        saveScrollTimeout = setTimeout(function() {
            window.history.replaceState(Collection_objectSpread({}, window.history.state, {
                options: Collection_objectSpread({}, window.history.state.options, {
                    scrollY: window.scrollY,
                    totalProducts: totalProductsRevealed
                })
            }), "");
        }, 50);
    };
    (0,react.useEffect)(function() {
        var options = window.history.state.options;
        if ((options === null || options === void 0 ? void 0 : options.scrollY) && totalProductsRevealed === (options === null || options === void 0 ? void 0 : options.totalProducts)) {
            setScrollY(options.scrollY);
        }
    }, [
        totalProductsRevealed
    ]);
    (0,react.useEffect)(function() {
        if (scrollY) {
            setTimeout(function() {
                window.scrollTo(0, scrollY);
            }, 10);
        }
    }, [
        scrollY
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", saveScroll);
        return function() {
            window.removeEventListener("scroll", saveScroll);
        };
    }, [
        totalProductsRevealed
    ]);
    (0,react.useEffect)(function() {
        if (typeof document === "undefined") return undefined;
        var offsetTop = collectionContainer.current.offsetTop;
        var headerHeight = document.querySelector(".site-header").offsetHeight;
        if (window.scrollY > offsetTop && !window.location.hash) {
            window.scrollTo({
                top: offsetTop - headerHeight,
                behavior: "smooth"
            });
        }
    }, scrollEffectParams);
    (0,react.useEffect)(function() {
        sendViewCollectionEvent({
            products: collection === null || collection === void 0 ? void 0 : collection.products,
            collectionId: collection === null || collection === void 0 ? void 0 : collection.id
        });
    }, [
        "".concat(collection === null || collection === void 0 ? void 0 : collection.id).concat(!!(collection === null || collection === void 0 ? void 0 : (ref3 = collection.products) === null || ref3 === void 0 ? void 0 : ref3.length)),
        sendViewCollectionEvent, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: collectionContainer,
        id: "".concat(Collection_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterBar/* default */.Z, {
                mobileFilterOpen: mobileFilterOpen,
                setMobileFilterOpen: setMobileFilterOpen,
                currentFilters: layoutParams.filters,
                setLayoutParams: setLayoutParams,
                items: products1,
                sort: layoutParams.sort,
                browserHistory: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:mx-auto lg:container collection__product-grid-container w-full px-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeader/* default */.Z, {
                        sort: layoutParams.sort,
                        setMobileFilterOpen: setMobileFilterOpen,
                        setLayoutParams: setLayoutParams,
                        currentFilters: layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.filters,
                        itemCount: products1.length,
                        enableFilters: cms === null || cms === void 0 ? void 0 : cms.enableFilters,
                        productCount: currentPageItems1.length - tileCtas.currentPageCTAs.length,
                        itemsPerPage: productsPerPage,
                        enableLoadMore: cms === null || cms === void 0 ? void 0 : cms.enableLoadMore,
                        currentPage: layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGrid/* default */.Z, {
                        productList: currentPageItems1,
                        promoTiles: promoTiles,
                        showSubscriptionPrice: cms.showSubscriptionPrice,
                        collection: collection
                    }),
                    (cms === null || cms === void 0 ? void 0 : cms.enableLoadMore) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadMore, {
                        currentPage: layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page,
                        itemsPerPage: productsPerPage,
                        currentPageItems: currentPageItems1,
                        items: products1,
                        setLayoutParams: setLayoutParams,
                        scrollThreshold: (cms === null || cms === void 0 ? void 0 : cms.scrollThreshold) || 0,
                        browserHistory: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Pagination, {
                        currentPage: layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page,
                        itemsPerPage: productsPerPage,
                        items: products1,
                        setLayoutParams: setLayoutParams
                    })
                ]
            })
        ]
    }, "collection-container");
}
Collection_Section.displayName = "Collection Grid";
Collection_Section.Schema = {
    category: "Collection",
    label: Collection_Section.displayName,
    key: "collection",
    fields: [
        {
            name: "enableLoadMore",
            component: "toggle",
            label: "Enable Load More",
            defaultValue: true
        },
        {
            name: "scrollThreshold",
            component: "number",
            label: "Scroll Threshold",
            description: "What percentage of the page has the customer to scroll before loading more products?, recommended value 70/80",
            default: 80
        }
    ]
};
var Collection = Collection_Section;

;// CONCATENATED MODULE: ./src/sections/Collection/index.js


;// CONCATENATED MODULE: ./src/sections/FullWidthText/FullWidthText.jsx





function FullWidthText(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var orders = (0,dist.useCustomerOrders)({
        perPage: 5
    }).orders;
    var cart = (0,dist.useCart)();
    var sectionTitle = cms.sectionTitle, sectionDescription = cms.sectionDescription, sectionTitleFont = cms.sectionTitleFont, sectionDescriptionFont = cms.sectionDescriptionFont, cta1 = cms.cta1, cta2 = cms.cta2, bgColor = cms.bgColor, lightText = cms.lightText, hideIfUserHasOrders = cms.hideIfUserHasOrders;
    var overrides = cms.overrides;
    var applicableOverride = (0,Helper/* getApplicableOverride */.Nx)(cart, overrides);
    if (applicableOverride === null || applicableOverride === void 0 ? void 0 : applicableOverride.length) {
        var ref6;
        sectionTitle = (ref6 = applicableOverride[0]) === null || ref6 === void 0 ? void 0 : ref6.sectionTitle;
        sectionDescription = applicableOverride[0].sectionDescription;
        cta1 = applicableOverride[0].cta1;
        cta2 = applicableOverride[0].cta2;
        bgColor = applicableOverride[0].bgColor;
        lightText = applicableOverride[0].lightText;
        sectionTitleFont = applicableOverride[0].sectionTitleFont;
        sectionDescriptionFont = applicableOverride[0].sectionDescriptionFont;
    }
    if (hideIfUserHasOrders && (orders === null || orders === void 0 ? void 0 : orders.length) > 0) {
        return;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "".concat(FullWidthText.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": FullWidthText.key,
        className: bgColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(FullWidthText.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(FullWidthText.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-[1200px] py-9 px-5 text-center lg:py-16 ".concat(lightText ? "text-white" : "text-black"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "".concat(sectionTitleFont || "font-tiempos", " ").concat(cms === null || cms === void 0 ? void 0 : cms.fontSize, " mb-4"),
                        children: [
                            " ",
                            sectionTitle
                        ]
                    }),
                    sectionDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-0 text-h6-m lg:text-h6 ".concat(sectionDescriptionFont || "font-haffer"),
                        dangerouslySetInnerHTML: {
                            __html: (0,Helper/* newLineToBr */.td)(sectionDescription)
                        }
                    }),
                    ((cta1 === null || cta1 === void 0 ? void 0 : (ref = cta1.link) === null || ref === void 0 ? void 0 : ref.text) || (cta2 === null || cta2 === void 0 ? void 0 : (ref1 = cta2.link) === null || ref1 === void 0 ? void 0 : ref1.text)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-6 flex flex-wrap items-center justify-center gap-5 lg:mt-7",
                        children: [
                            (cta1 === null || cta1 === void 0 ? void 0 : (ref2 = cta1.link) === null || ref2 === void 0 ? void 0 : ref2.text) && (cta1 === null || cta1 === void 0 ? void 0 : (ref3 = cta1.link) === null || ref3 === void 0 ? void 0 : ref3.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: cms.cta1.link.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "".concat(cta1.style, " no-underline"),
                                    target: cta1.link.newTab ? "_blank" : null,
                                    children: cta1.link.text
                                })
                            }),
                            (cta2 === null || cta2 === void 0 ? void 0 : (ref4 = cta2.link) === null || ref4 === void 0 ? void 0 : ref4.text) && (cta2 === null || cta2 === void 0 ? void 0 : (ref5 = cta2.link) === null || ref5 === void 0 ? void 0 : ref5.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: cta2.link.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "".concat(cta2.style, " no-underline"),
                                    target: cta2.link.newTab ? "_blank" : null,
                                    children: cta2.link.text
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
FullWidthText.displayName = "Full Width Text";
FullWidthText.Schema = {
    category: "Modules",
    label: FullWidthText.displayName,
    key: "fullWidthText",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "text",
            label: "Section Title",
            name: "sectionTitle"
        },
        {
            name: "sectionTitleFont",
            label: "Section Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section title text"
        },
        {
            component: "textarea",
            label: "Section Description",
            name: "sectionDescription"
        },
        {
            name: "sectionDescriptionFont",
            label: "Section Description Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section description text"
        },
        {
            label: "CTA 1",
            name: "cta1",
            component: "group",
            fields: [
                {
                    label: "CTA URL",
                    name: "link",
                    component: "link"
                },
                {
                    component: "select",
                    name: "style",
                    label: "Cta Style",
                    options: [
                        {
                            label: "Primary",
                            value: "button button--primary inline-block"
                        },
                        {
                            label: "Secondary",
                            value: "button button--secondary inline-block"
                        },
                        {
                            label: "Tertiary",
                            value: "button button--tertiary inline-block"
                        },
                        {
                            label: "Focus Link",
                            value: "focus-link"
                        },
                        {
                            label: "Focus Link White",
                            value: "focus-link-white"
                        },
                        {
                            label: "checkout",
                            value: "button button--checkout inline-block"
                        }, 
                    ],
                    defaultValue: "button button--primary inline-block"
                }, 
            ]
        },
        {
            label: "CTA 2",
            name: "cta2",
            component: "group",
            fields: [
                {
                    label: "CTA URL",
                    name: "link",
                    component: "link"
                },
                {
                    component: "select",
                    name: "style",
                    label: "Cta Style",
                    options: [
                        {
                            label: "Primary",
                            value: "button button--primary inline-block"
                        },
                        {
                            label: "Secondary",
                            value: "button button--secondary inline-block"
                        },
                        {
                            label: "Tertiary",
                            value: "button button--tertiary inline-block"
                        },
                        {
                            label: "Focus Link",
                            value: "focus-link"
                        },
                        {
                            label: "Focus Link White",
                            value: "focus-link-white"
                        },
                        {
                            label: "checkout",
                            value: "button button--checkout inline-block"
                        }, 
                    ],
                    defaultValue: "button button--primary inline-block"
                }, 
            ]
        },
        {
            name: "bgColor",
            label: "Background Color",
            component: "select",
            description: "For section background color, select one from preselected brand colors.",
            options: [
                {
                    label: "Black",
                    value: "bg-black"
                },
                {
                    label: "White",
                    value: "bg-white"
                },
                {
                    label: "Grey",
                    value: "bg-grey-1"
                },
                {
                    label: "Light Grey",
                    value: "bg-grey-9"
                },
                {
                    label: "Blue 1",
                    value: "bg-quinary-1"
                },
                {
                    label: "Blue 2",
                    value: "bg-quinary-2"
                },
                {
                    label: "Blue 3",
                    value: "bg-light-blue"
                },
                {
                    label: "Cream 1",
                    value: "bg-tertiary-2"
                },
                {
                    label: "Cream 2",
                    value: "bg-senary-4"
                },
                {
                    label: "Purple",
                    value: "bg-tertiary-1"
                },
                {
                    label: "Green",
                    value: "bg-quaternary-1"
                },
                {
                    label: "Pink 1",
                    value: "bg-primary-2"
                },
                {
                    label: "Pink 2",
                    value: "bg-secondary-1"
                },
                {
                    label: "Yellow",
                    value: "bg-yellow"
                },
                {
                    label: "Orange",
                    value: "bg-secondary-2"
                },
                {
                    label: "Seafoam 1",
                    value: "bg-quaternary-2"
                },
                {
                    label: "Seafoam 2",
                    value: "bg-senary-3"
                },
                {
                    label: "Seafoam 3",
                    value: "bg-senary-5"
                },
                {
                    label: "Air Dry Cream",
                    value: "bg-stylers-1"
                },
                {
                    label: "Sculpting Cream",
                    value: "bg-stylers-2"
                },
                {
                    label: "Texture Foam",
                    value: "bg-stylers-3"
                },
                {
                    label: "Sleek Stick",
                    value: "bg-stylers-4"
                },
                {
                    label: "Magenta",
                    value: "bg-magenta"
                },
                {
                    label: "Medium Pink",
                    value: "bg-med-pink"
                },
                {
                    label: "Briogeo Blue",
                    value: "bg-brio-blue"
                },
                {
                    label: "Cloud",
                    value: "bg-cloud"
                },
                {
                    label: "Mineral",
                    value: "bg-mineral"
                },
                {
                    label: "Deep Sea",
                    value: "bg-deep-sea"
                },
                {
                    label: "Sandstone",
                    value: "bg-sandstone"
                },
                {
                    label: "Sorrel",
                    value: "bg-sorrel"
                },
                {
                    label: "Butter",
                    value: "bg-butter"
                },
                {
                    label: "Rosehip",
                    value: "bg-rosehip"
                },
                {
                    label: "Chestnut",
                    value: "bg-chestnut"
                }, 
            ],
            defaultValue: "bg-white"
        },
        {
            name: "lightText",
            label: "Text Color",
            component: "toggle",
            toggleLabels: {
                true: "Light",
                false: "Dark"
            }
        },
        {
            name: "fontSize",
            label: "Title Font Size",
            component: "select",
            options: [
                {
                    label: "H1",
                    value: "text-h1-m lg:text-h1"
                },
                {
                    label: "H2",
                    value: "text-h2-m lg:text-h2"
                },
                {
                    label: "H3",
                    value: "text-h3-m lg:text-h3"
                }, 
            ],
            defaultValue: "text-h1-m lg:text-h1"
        },
        {
            component: "group-list",
            name: "overrides",
            label: "Full Width Text overrides",
            description: "Describes the text cases when a discount code is applied on the cart",
            fields: [
                {
                    component: "text",
                    name: "discountCode",
                    label: "Discount code reference",
                    description: "Discount code that needs to be present on the cart in order to trigger this override"
                },
                {
                    name: "sectionTitle",
                    label: "Section Title",
                    component: "text",
                    defaultValue: "Clean chemistry. Healthy hair."
                },
                {
                    name: "sectionTitleFont",
                    label: "Section Title Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the section title text"
                },
                {
                    name: "sectionDescription",
                    label: "Section Description",
                    component: "textarea",
                    defaultValue: "We create powerful, naturally-derived solutions that are proven to improve hair's health, for every type and texture."
                },
                {
                    name: "sectionDescriptionFont",
                    label: "Section Description Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the section description text"
                },
                {
                    label: "CTA 1",
                    name: "cta1",
                    component: "group",
                    fields: [
                        {
                            label: "CTA URL",
                            name: "link",
                            component: "link"
                        },
                        {
                            component: "select",
                            name: "style",
                            label: "Cta Style",
                            options: [
                                {
                                    label: "Primary",
                                    value: "button button--primary inline-block"
                                },
                                {
                                    label: "Secondary",
                                    value: "button button--secondary inline-block"
                                },
                                {
                                    label: "Tertiary",
                                    value: "button button--tertiary inline-block"
                                },
                                {
                                    label: "Focus Link",
                                    value: "focus-link"
                                },
                                {
                                    label: "Focus Link White",
                                    value: "focus-link-white"
                                },
                                {
                                    label: "checkout",
                                    value: "button button--checkout inline-block"
                                }, 
                            ],
                            defaultValue: "button button--primary inline-block"
                        }, 
                    ]
                },
                {
                    label: "CTA 2",
                    name: "cta2",
                    component: "group",
                    fields: [
                        {
                            label: "CTA URL",
                            name: "link",
                            component: "link"
                        },
                        {
                            component: "select",
                            name: "style",
                            label: "Cta Style",
                            options: [
                                {
                                    label: "Primary",
                                    value: "button button--primary inline-block"
                                },
                                {
                                    label: "Secondary",
                                    value: "button button--secondary inline-block"
                                },
                                {
                                    label: "Tertiary",
                                    value: "button button--tertiary inline-block"
                                },
                                {
                                    label: "Focus Link",
                                    value: "focus-link"
                                },
                                {
                                    label: "Focus Link White",
                                    value: "focus-link-white"
                                },
                                {
                                    label: "checkout",
                                    value: "button button--checkout inline-block"
                                }, 
                            ],
                            defaultValue: "button button--primary inline-block"
                        }, 
                    ]
                },
                {
                    name: "bgColor",
                    label: "Background Color",
                    component: "select",
                    description: "For section background color, select one from preselected brand colors.",
                    options: [
                        {
                            label: "Black",
                            value: "bg-black"
                        },
                        {
                            label: "White",
                            value: "bg-white"
                        },
                        {
                            label: "Grey",
                            value: "bg-grey-1"
                        },
                        {
                            label: "Light Grey",
                            value: "bg-grey-9"
                        },
                        {
                            label: "Blue 1",
                            value: "bg-quinary-1"
                        },
                        {
                            label: "Blue 2",
                            value: "bg-quinary-2"
                        },
                        {
                            label: "Blue 3",
                            value: "bg-light-blue"
                        },
                        {
                            label: "Cream 1",
                            value: "bg-tertiary-2"
                        },
                        {
                            label: "Cream 2",
                            value: "bg-senary-4"
                        },
                        {
                            label: "Purple",
                            value: "bg-tertiary-1"
                        },
                        {
                            label: "Green",
                            value: "bg-quaternary-1"
                        },
                        {
                            label: "Pink 1",
                            value: "bg-primary-2"
                        },
                        {
                            label: "Pink 2",
                            value: "bg-secondary-1"
                        },
                        {
                            label: "Yellow",
                            value: "bg-yellow"
                        },
                        {
                            label: "Orange",
                            value: "bg-secondary-2"
                        },
                        {
                            label: "Seafoam 1",
                            value: "bg-quaternary-2"
                        },
                        {
                            label: "Seafoam 2",
                            value: "bg-senary-3"
                        },
                        {
                            label: "Seafoam 3",
                            value: "bg-senary-5"
                        },
                        {
                            label: "Air Dry Cream",
                            value: "bg-stylers-1"
                        },
                        {
                            label: "Sculpting Cream",
                            value: "bg-stylers-2"
                        },
                        {
                            label: "Texture Foam",
                            value: "bg-stylers-3"
                        },
                        {
                            label: "Sleek Stick",
                            value: "bg-stylers-4"
                        },
                        {
                            label: "Magenta",
                            value: "bg-magenta"
                        },
                        {
                            label: "Medium Pink",
                            value: "bg-med-pink"
                        },
                        {
                            label: "Briogeo Blue",
                            value: "bg-brio-blue"
                        },
                        {
                            label: "Cloud",
                            value: "bg-cloud"
                        },
                        {
                            label: "Mineral",
                            value: "bg-mineral"
                        },
                        {
                            label: "Deep Sea",
                            value: "bg-deep-sea"
                        },
                        {
                            label: "Sandstone",
                            value: "bg-sandstone"
                        },
                        {
                            label: "Sorrel",
                            value: "bg-sorrel"
                        },
                        {
                            label: "Butter",
                            value: "bg-butter"
                        },
                        {
                            label: "Rosehip",
                            value: "bg-rosehip"
                        },
                        {
                            label: "Chestnut",
                            value: "bg-chestnut"
                        }, 
                    ],
                    defaultValue: "bg-white"
                },
                {
                    name: "lightText",
                    label: "Text Color",
                    component: "toggle",
                    toggleLabels: {
                        true: "Light",
                        false: "Dark"
                    }
                }, 
            ]
        },
        {
            name: "hideIfUserHasOrders",
            label: "Hide section if user has orders",
            component: "toggle"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/FullWidthText/index.js


;// CONCATENATED MODULE: ./src/sections/StoreLocator/StoreLocator.jsx


function StoreLocator(param) {
    var cms = param.cms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(StoreLocator.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        className: "store-locator-container px-4 py-10 lg:px-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(StoreLocator.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(StoreLocator.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "m-auto lg:container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        type: "text/javascript",
                        src: "https://storelocator.w3apps.co/widget/bundle.js"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("w3-store-locator", {
                        "default-distance": "25",
                        distances: "5,25,100,250,-1",
                        "search-limit": "100"
                    })
                ]
            })
        ]
    });
}
StoreLocator.displayName = "StoreLocator";
StoreLocator.Schema = {
    category: "StoreLocator",
    label: StoreLocator.displayName,
    key: "storelocator",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/StoreLocator/index.js


;// CONCATENATED MODULE: ./src/sections/CollectionGrid/CollectionGrid.jsx
function CollectionGrid_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CollectionGrid_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return CollectionGrid_arrayLikeToArray(arr);
}
function CollectionGrid_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CollectionGrid_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function CollectionGrid_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CollectionGrid_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CollectionGrid_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CollectionGrid_toConsumableArray(arr) {
    return CollectionGrid_arrayWithoutHoles(arr) || CollectionGrid_iterableToArray(arr) || CollectionGrid_unsupportedIterableToArray(arr) || CollectionGrid_nonIterableSpread();
}
function CollectionGrid_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CollectionGrid_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CollectionGrid_arrayLikeToArray(o, minLen);
}










function CollectionGrid_Section(param) {
    var cms = param.cms;
    var ref4;
    var settings = (0,dist.useSettings)();
    var campaigns = CollectionGrid_objectSpread({}, settings === null || settings === void 0 ? void 0 : settings.collectionTile).campaigns;
    var collectionHandle = cms.collectionHandle, enableFilters = cms.enableFilters, sectionTitle = cms.sectionTitle, sectionSubtitle = cms.sectionSubtitle, enableLoadMore = cms.enableLoadMore, scrollThreshold = cms.scrollThreshold;
    var showSubscriptionPrice = cms.showSubscriptionPrice;
    var collection = (0,dist.useCollectionByHandle)({
        handle: collectionHandle || ""
    }).collection;
    var productHandles = collection === null || collection === void 0 ? void 0 : (ref4 = collection.products) === null || ref4 === void 0 ? void 0 : ref4.map(function(product) {
        return product.handle;
    });
    var ref1 = (0,hooks/* useProductsFromHandles */.tp)({
        handles: productHandles || []
    }), productsData = ref1.products;
    var productsPerPage = 24;
    var collectionContainer = (0,react.useRef)();
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var promoTiles = (0,react.useMemo)(function() {
        if (!(campaigns === null || campaigns === void 0 ? void 0 : campaigns.length)) return [];
        var campaign1 = campaigns.find(function(campaign) {
            var ref;
            if (!(campaign === null || campaign === void 0 ? void 0 : campaign.enabled)) {
                return false;
            }
            return campaign === null || campaign === void 0 ? void 0 : (ref = campaign.collections) === null || ref === void 0 ? void 0 : ref.some(function(colHandle) {
                return colHandle.trim() === (collection === null || collection === void 0 ? void 0 : collection.handle);
            });
        });
        return (campaign1 === null || campaign1 === void 0 ? void 0 : campaign1.promoTiles) || [];
    }, [
        collection,
        campaigns
    ]);
    var ref2 = (0,react.useState)({
        filters: [],
        sort: "def:def",
        page: 1
    }), layoutParams = ref2[0], setLayoutParams = ref2[1];
    if (!isUs) {
        showSubscriptionPrice = false;
    }
    var getLoadedPageCTAs = function() {
        var currentPageCTAs = promoTiles === null || promoTiles === void 0 ? void 0 : promoTiles.filter(function(tile) {
            if (cms.enableLoadMore) {
                return Math.ceil(tile.position / productsPerPage) <= layoutParams.page;
            }
            return Math.ceil(tile.position / productsPerPage) === layoutParams.page;
        });
        var loadedPreviousCTAs = promoTiles === null || promoTiles === void 0 ? void 0 : promoTiles.filter(function(tile) {
            if (enableLoadMore) {
                return false;
            }
            return Math.ceil(tile.position / productsPerPage) < layoutParams.page;
        });
        return {
            currentPageCTAs: currentPageCTAs,
            loadedPreviousCTAs: loadedPreviousCTAs
        };
    };
    var tileCtas = getLoadedPageCTAs();
    var sortItems = function() {
        var ref;
        var sortPieces = (layoutParams === null || layoutParams === void 0 ? void 0 : (ref = layoutParams.sort) === null || ref === void 0 ? void 0 : ref.split(":")) || [];
        var sortedItems = CollectionGrid_toConsumableArray(products1).sort(function(a, b) {
            switch(sortPieces[0]){
                case "price":
                    if (sortPieces[1] === "asc") {
                        return (a.priceRange.min || 0) - (b.priceRange.min || 0);
                    }
                    return (b.priceRange.max || 0) - (a.priceRange.max || 0);
                case "alpha":
                    if (sortPieces[1] === "asc") {
                        return a.title.toUpperCase() < b.title.toUpperCase() ? "-1" : "1";
                    }
                    return a.title.toUpperCase() > b.title.toUpperCase() ? "-1" : "1";
                default:
                    return 0;
            }
        });
        return sortedItems;
    };
    var applyFilters = function() {
        var ref;
        var products = Object.keys(productsData).map(function(key) {
            return productsData[key];
        });
        var filteredProducts = products;
        if ((layoutParams === null || layoutParams === void 0 ? void 0 : (ref = layoutParams.filters) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            filteredProducts = products === null || products === void 0 ? void 0 : products.filter(function(product) {
                return product === null || product === void 0 ? void 0 : product.tags.some(function(tag) {
                    return layoutParams.filters.includes(tag);
                });
            });
        }
        return filteredProducts || [];
    };
    var products1 = applyFilters();
    var sortedItems1 = sortItems(products1) || [];
    var getCurrentPageItems = function() {
        var currentPageItems = [];
        var productList = CollectionGrid_toConsumableArray(sortedItems1);
        currentPageItems = enableLoadMore ? productList.slice(0, productsPerPage * ((layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page) || 1) - tileCtas.loadedPreviousCTAs.length - tileCtas.currentPageCTAs.length) : productList.slice(productsPerPage * (((layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page) || 1) - 1) - tileCtas.loadedPreviousCTAs.length, productsPerPage * ((layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page) || 1) - tileCtas.loadedPreviousCTAs.length - tileCtas.currentPageCTAs.length);
        if (tileCtas.currentPageCTAs.length) {
            tileCtas.currentPageCTAs.forEach(function(item) {
                var pageCorrection = 0;
                if (layoutParams.page > 1 && !enableLoadMore) {
                    pageCorrection = productsPerPage * (layoutParams.page - 1);
                }
                currentPageItems.splice(item.position - 1 - pageCorrection, 0, item);
            });
        }
        return currentPageItems;
    };
    var buildSectionHeader = function() {
        if (!sectionTitle && !sectionSubtitle) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container text-center",
            children: [
                sectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "h3 collection-grid__title ".concat(sectionSubtitle !== undefined ? "mb-0" : "mb-5", " ").concat((cms === null || cms === void 0 ? void 0 : cms.sectionTitleFont) || "font-tiempos"),
                    children: sectionTitle
                }),
                sectionSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "collection-grid__subtitle ".concat((cms === null || cms === void 0 ? void 0 : cms.sectionSubtitleFont) || "font-haffer"),
                    children: sectionSubtitle
                })
            ]
        });
    };
    var currentPageItems1 = getCurrentPageItems();
    var ref3 = (0,react.useState)(false), mobileFilterOpen = ref3[0], setMobileFilterOpen = ref3[1];
    var scrollEffectParams = !enableLoadMore ? [
        layoutParams
    ] : [
        layoutParams.filters,
        layoutParams.sort
    ];
    (0,react.useEffect)(function() {
        var ref;
        if (typeof document === "undefined") return undefined;
        var offsetTop = collectionContainer === null || collectionContainer === void 0 ? void 0 : (ref = collectionContainer.current) === null || ref === void 0 ? void 0 : ref.offsetTop;
        var headerHeight = document.querySelector(".site-header").offsetHeight;
        if (window.scrollY > offsetTop && !window.location.hash) {
            window.scrollTo({
                top: offsetTop - headerHeight,
                behavior: "smooth"
            });
        }
    }, scrollEffectParams);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            buildSectionHeader(),
            collection && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: collectionContainer,
                id: "".concat(CollectionGrid_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
                children: [
                    enableFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterBar/* default */.Z, {
                        mobileFilterOpen: mobileFilterOpen,
                        setMobileFilterOpen: setMobileFilterOpen,
                        currentFilters: layoutParams.filters,
                        setLayoutParams: setLayoutParams,
                        items: products1,
                        browserHistory: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:mx-auto lg:container px-5 collection__product-grid-container w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeader/* default */.Z, {
                                sort: layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.sort,
                                setMobileFilterOpen: setMobileFilterOpen,
                                setLayoutParams: setLayoutParams,
                                currentFilters: layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.filters,
                                browserHistory: false,
                                itemCount: products1.length,
                                productCount: currentPageItems1.length - tileCtas.currentPageCTAs.length,
                                itemsPerPage: productsPerPage,
                                enableFilters: enableFilters,
                                currentPage: layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page,
                                enableLoadMore: enableLoadMore
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGrid/* default */.Z, {
                                productList: currentPageItems1,
                                showSubscriptionPrice: showSubscriptionPrice,
                                promoTiles: promoTiles
                            }),
                            enableLoadMore === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadMore, {
                                currentPage: layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page,
                                itemsPerPage: productsPerPage,
                                currentPageItems: currentPageItems1,
                                items: products1,
                                setLayoutParams: setLayoutParams,
                                scrollThreshold: scrollThreshold || 0
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Pagination, {
                                currentPage: layoutParams === null || layoutParams === void 0 ? void 0 : layoutParams.page,
                                itemsPerPage: productsPerPage,
                                items: products1,
                                setLayoutParams: setLayoutParams,
                                browserHistory: false
                            })
                        ]
                    })
                ]
            }, "collection-container")
        ]
    });
}
CollectionGrid_Section.displayName = "Collection Grid Module";
CollectionGrid_Section.Schema = {
    category: "Modules",
    label: "Collection Grid Module",
    key: "collection-grid",
    fields: [
        {
            component: "text",
            name: "sectionTitle",
            label: "Section Title"
        },
        {
            name: "sectionTitleFont",
            label: "Section Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section title text"
        },
        {
            component: "textarea",
            name: "sectionSubtitle",
            label: "Section Subtitle"
        },
        {
            name: "sectionSubtitleFont",
            label: "Section Subtitle Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section subtitle text"
        },
        {
            component: "text",
            name: "collectionHandle",
            label: "Collection Handle"
        },
        {
            component: "toggle",
            name: "enableFilters",
            label: "Toggle Filters",
            toggleLabels: {
                true: "Enable",
                false: "Disable"
            },
            defaultValue: true
        },
        {
            name: "enableLoadMore",
            component: "toggle",
            label: "Enable Load More",
            defaultValue: true
        },
        {
            name: "scrollThreshold",
            component: "number",
            label: "Scroll Threshold",
            description: "What percentage of the page has the customer to scroll before loading more products?, this will depend on the position of the module within the page, please use the scroll bar to figure out the most optimal value for this field.",
            defaultValue: 80
        },
        {
            component: "toggle",
            name: "showSubscriptionPrice",
            label: "Price Shown",
            toggleLabels: {
                true: "Subscription Price",
                false: "Regular Price"
            },
            defaultValue: true
        }, 
    ]
};
var CollectionGrid = CollectionGrid_Section;

;// CONCATENATED MODULE: ./src/sections/CollectionGrid/index.js


;// CONCATENATED MODULE: ./src/sections/CustomCursor/CustomCursor.jsx


function CustomCursor_Section(param) {
    var cms = param.cms;
    var enableCustomCursor = cms.enableCustomCursor;
    (0,react.useEffect)(function() {
        if (enableCustomCursor) {
            document.body.classList.add("show-custom-cursor");
        } else {
            document.body.classList.remove("show-custom-cursor");
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}
CustomCursor_Section.displayName = "Custom Cursor";
CustomCursor_Section.Schema = {
    category: "Modules",
    label: "Custom Cursor",
    key: "custom-cursor",
    fields: [
        {
            name: "enableCustomCursor",
            component: "toggle",
            label: "Enable Custom Cursor",
            defaultValue: false
        }
    ]
};
var CustomCursor = CustomCursor_Section;

;// CONCATENATED MODULE: ./src/sections/CustomCursor/index.js


;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BundleBuildercontext.jsx

var BuilderContext = /*#__PURE__*/ (0,react.createContext)({
    builderSettings: {},
    updateBuilderSettings: function() {},
    builderData: {},
    updateBuilderData: function() {}
});
function useBuilderContext() {
    return (0,react.useContext)(BuilderContext);
}

// EXTERNAL MODULE: ./src/sections/BundleBuilder/BuilderHeader.module.css
var BuilderHeader_module = __webpack_require__(71413);
var BuilderHeader_module_default = /*#__PURE__*/__webpack_require__.n(BuilderHeader_module);
;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderHeader.jsx







function BuilderHeader(param) {
    var scrollTop = param.scrollTop;
    var context = useBuilderContext();
    var _builderSettings = context.builderSettings, title = _builderSettings.title, description = _builderSettings.description, ctaTitle = _builderSettings.ctaTitle, disclaimer = _builderSettings.disclaimer, desktopBgImage = _builderSettings.desktopBgImage, mobileBgImage = _builderSettings.mobileBgImage, darkText = _builderSettings.darkText;
    if (!title && !description && !ctaTitle && !disclaimer) return null;
    var hasImage = !!desktopBgImage && !!mobileBgImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bundle-builder__header flex flex-col items-center justify-center py-14 px-10 text-center lg:min-h-[454px] lg:py-10\n      ".concat(hasImage ? "relative overflow-hidden" : "bg-light-blue"),
        children: [
            hasImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        className: "bundle-builder__desktop-header-image absolute top-1/2 hidden h-full w-auto max-w-none -translate-y-1/2 md:block xl:h-auto xl:w-full",
                        src: desktopBgImage === null || desktopBgImage === void 0 ? void 0 : desktopBgImage.src,
                        alt: desktopBgImage === null || desktopBgImage === void 0 ? void 0 : desktopBgImage.alt,
                        width: desktopBgImage.width,
                        height: desktopBgImage.height,
                        priority: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        className: "bundle-builder__mobile-header-image absolute top-1/2 block h-auto min-h-full w-auto min-w-full -translate-y-1/2 md:hidden",
                        src: mobileBgImage === null || mobileBgImage === void 0 ? void 0 : mobileBgImage.src,
                        alt: mobileBgImage === null || mobileBgImage === void 0 ? void 0 : mobileBgImage.alt,
                        width: desktopBgImage.width,
                        height: desktopBgImage.height,
                        priority: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bundle-builder__header-container z-10 flex max-w-xl flex-col justify-center\n        ".concat(hasImage && !darkText ? "text-white" : "", "\n      "),
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "bundle-builder__title mb-4",
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactMarkdown, {
                        remarkPlugins: [
                            remarkDirective,
                            remarkGfm
                        ],
                        className: "bundle-builder__description text-base",
                        children: description
                    }),
                    ctaTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "bundle-builder__cta button button--primary mx-auto mb-4 inline-block w-auto",
                        onClick: scrollTop,
                        children: ctaTitle
                    }),
                    disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactMarkdown, {
                        remarkPlugins: [
                            remarkDirective,
                            remarkGfm
                        ],
                        className: "".concat((BuilderHeader_module_default())["bundle-builder__disclaimer"], " bundle-builder__disclaimer mb-0 font-hafferBold text-xs italic"),
                        children: disclaimer
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderGridHeader.jsx


function BuilderGridHeader() {
    var context = useBuilderContext();
    var products = context.builderData.filteredProducts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bundle-builder__grid-header mb-4 flex justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "h5 bundle-builder__grid-title mb-0",
                children: "Build your bundle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "bundle-builder__product-count",
                children: [
                    products === null || products === void 0 ? void 0 : products.length,
                    " products"
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderFilters.jsx


function BuilderFilters() {
    var context = useBuilderContext();
    var filterList = context.builderSettings.filters;
    var activeFilter = context.builderData.activeFilter;
    var filters = filterList.map(function(filter, index) {
        var isAll = filter.value === undefined;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bundle-builder__filter",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "radio",
                    id: filter.name,
                    name: "products-filter",
                    value: filter.value || "",
                    onChange: function(e) {
                        return context.updateBuilderData({
                            activeFilter: filter.value || "",
                            page: 1
                        });
                    },
                    defaultChecked: isAll && activeFilter === "" ? true : activeFilter === filter.value,
                    className: "peer hidden"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    htmlFor: filter.name,
                    className: "inline-block rounded-full border-2 border-black py-1 px-4 font-hafferBold text-xs transition-all duration-150 ease-in-out\n          peer-checked:border-quinary-1 peer-checked:bg-quinary-1 peer-checked:text-white lg:hover:bg-black lg:hover:text-white ",
                    children: filter.name
                })
            ]
        }, filter.name);
    });
    if (filters.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bundle-builder__filters-container flex flex-wrap gap-2 mb-6",
        children: filters
    });
};

// EXTERNAL MODULE: ../node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(12393);
// EXTERNAL MODULE: ./src/snippets/products/ProductCustomBadges.jsx
var ProductCustomBadges = __webpack_require__(72936);
// EXTERNAL MODULE: ./src/snippets/products/BuyWithPrimeBadge.jsx + 1 modules
var BuyWithPrimeBadge = __webpack_require__(76731);
;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderProductCard.jsx















function BuilderProductCard(param) {
    var handle = param.handle, _showReviews = param.showReviews, showReviews = _showReviews === void 0 ? true : _showReviews, showBWPBadge = param.showBWPBadge, _showSubscriptionPrice = param.showSubscriptionPrice, showSubscriptionPrice = _showSubscriptionPrice === void 0 ? false : _showSubscriptionPrice;
    var ref11, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react_intersection_observer_modern/* useInView */.YD)({
        rootMargin: "400px",
        triggerOnce: true
    }), ref10 = ref9.ref, inView = ref9.inView;
    var product = (0,dist.useProductByHandle)({
        handle: handle,
        fetchOnMount: inView
    }).product;
    var firstSellingPlan = showSubscriptionPrice ? product === null || product === void 0 ? void 0 : (ref11 = product.variants) === null || ref11 === void 0 ? void 0 : (ref1 = ref11[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sellingPlanAllocations) === null || ref2 === void 0 ? void 0 : ref2[0] : null;
    var taggedBWP = (product === null || product === void 0 ? void 0 : (ref3 = product.tags) === null || ref3 === void 0 ? void 0 : ref3.indexOf("BWP")) > -1;
    var bottomline = (0,hooks/* useYotpoProductBottomline */.zs)({
        legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId
    }).bottomline;
    var ShowBuyWithPrime = false;
    if (showBWPBadge && taggedBWP) {
        ShowBuyWithPrime = true;
    }
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var primaryImgSrc = (0,react.useMemo)(function() {
        var ref;
        if (!((ref = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref === void 0 ? void 0 : ref.src)) return null;
        return (0,Images/* getSizedImageUrl */.M0)(product.images[0].src, "750x");
    }, [
        (ref4 = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref4 === void 0 ? void 0 : ref4.src
    ]);
    var primaryImgAlt = (0,react.useMemo)(function() {
        var ref;
        return (ref = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref === void 0 ? void 0 : ref.alt;
    }, [
        (ref5 = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref5 === void 0 ? void 0 : ref5.alt
    ]);
    var hoverImgSrc = (0,react.useMemo)(function() {
        var ref;
        if (!((ref = product === null || product === void 0 ? void 0 : product.images[1]) === null || ref === void 0 ? void 0 : ref.src)) return null;
        return (0,Images/* getSizedImageUrl */.M0)(product.images[1].src, "750x");
    }, [
        (ref6 = product === null || product === void 0 ? void 0 : product.images[1]) === null || ref6 === void 0 ? void 0 : ref6.src
    ]);
    var hoverImgAlt = (0,react.useMemo)(function() {
        var ref;
        return (ref = product === null || product === void 0 ? void 0 : product.images[1]) === null || ref === void 0 ? void 0 : ref.alt;
    }, [
        (ref7 = product === null || product === void 0 ? void 0 : product.images[1]) === null || ref7 === void 0 ? void 0 : ref7.alt
    ]);
    var collection = metafieldMap.custom_collection_title;
    var context = useBuilderContext();
    var builderData = context.builderData, builderSettings = context.builderSettings;
    var selectedProduct = builderData.selectedProducts.some(function(loopProduct) {
        return loopProduct.handle === handle;
    });
    var updateBundle = function(e) {
        e.stopPropagation();
        e.preventDefault();
        var selectedProducts = builderData.selectedProducts;
        if (selectedProduct) {
            selectedProducts = selectedProducts.filter(function(loopProduct) {
                return loopProduct.handle !== handle;
            });
        } else {
            selectedProducts.push(product);
        }
        context.updateBuilderData({
            selectedProducts: selectedProducts
        });
    };
    var setQuickViewProduct = function(qvProduct) {
        context.updateBuilderData({
            quickViewProduct: qvProduct
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-card flex h-full flex-col pt-[45px] lg:pt-0 bg-[#f8f8f8] lg:bg-transparent",
        id: product === null || product === void 0 ? void 0 : product.legacyResourceId,
        ref: ref10,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-card__image group relative block aspect-square shrink-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCustomBadges/* default */.Z, {
                        product: product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* default */.Z, {
                        product: product,
                        className: "md:!h-13 md:!w-13 !left-3 z-10 !h-11 !w-11 ".concat(ShowBuyWithPrime ? "!bottom-[68px] md:!bottom-[75px]" : "!bottom-[-0.25rem] lg:!bottom-3"),
                        forceSaveBadge: showSubscriptionPrice
                    }),
                    ShowBuyWithPrime === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyWithPrimeBadge/* default */.Z, {
                        className: "z-1 md:w-13 md:h-13 absolute bottom-[-0.25rem] lg:bottom-3 left-3 h-11 w-11"
                    }),
                    primaryImgSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "l-0 t-0 absolute aspect-square h-full w-full object-cover transition-opacity duration-300 lg:group-hover:opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: primaryImgSrc,
                            alt: primaryImgAlt,
                            width: "500",
                            height: "500",
                            loading: "lazy",
                            fill: true,
                            sizes: "(max-width: 768px) 50vw, (max-width: 1024) 35vw, 27vw",
                            "data-primary-image": true
                        })
                    }),
                    hoverImgSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "l-0 t-0 absolute aspect-square h-full w-full object-cover opacity-0 transition-opacity duration-300 lg:group-hover:opacity-100",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: hoverImgSrc,
                            alt: hoverImgAlt,
                            width: "500",
                            height: "500",
                            fill: true,
                            sizes: "(max-width: 768px) 50vw, (max-width: 1024) 35vw, 27vw",
                            loading: "lazy",
                            "data-hover-image": true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-card__body mt-3.5 pt-3 lg:pt-0 flex h-full flex-col bg-white",
                children: [
                    collection && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mb-0 font-hafferBold text-[11px] ".concat((0,Metafields/* getMetafieldColor */.O)(metafieldMap)),
                        children: collection
                    }),
                    metafieldMap.custom_ingredient_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mb-0.5 block font-tiempos text-sm italic",
                        children: metafieldMap.custom_ingredient_title
                    }),
                    (metafieldMap.custom_product_title || (product === null || product === void 0 ? void 0 : product.title)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-2 font-hafferBold text-sm text-black",
                        children: metafieldMap.custom_product_title || (product === null || product === void 0 ? void 0 : product.title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
                        variant: product === null || product === void 0 ? void 0 : product.variants[0],
                        planPrice: (ref8 = firstSellingPlan === null || firstSellingPlan === void 0 ? void 0 : firstSellingPlan.priceAdjustments[0].price) === null || ref8 === void 0 ? void 0 : ref8.amount,
                        selectedPlan: firstSellingPlan,
                        className: "mb-5"
                    }),
                    showSubscriptionPrice === true && metafieldMap.annual_savings_message !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "product-card__savings-message mb-5 -mt-3 block font-hafferBold text-sm font-bold text-black",
                        children: metafieldMap.annual_savings_message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "button mt-auto block w-full !min-w-0 ".concat(selectedProduct ? "button--secondary hover:!bg-white hover:!text-black lg:hover:!bg-black lg:hover:!text-white" : "button--primary", "\n          ").concat(!selectedProduct && builderData.selectedProducts.length === builderSettings.bundleSteps.length ? "!border-black !bg-black !text-white opacity-50" : "", "\n          "),
                        onClick: updateBundle,
                        disabled: !selectedProduct && builderData.selectedProducts.length === builderSettings.bundleSteps.length,
                        children: selectedProduct ? "remove" : "add to bundle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "focus-link mx-auto mt-2 text-xs",
                        onClick: function() {
                            setQuickViewProduct(product.handle);
                        },
                        children: "learn more"
                    })
                ]
            })
        ]
    }, product === null || product === void 0 ? void 0 : product.legacyResourceId);
};

;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderGrid.jsx



function BuilderGrid() {
    var context = useBuilderContext();
    var productsData = context.builderData.paginatedProducts;
    var buildProductItems = function() {
        var products = productsData === null || productsData === void 0 ? void 0 : productsData.map(function(product, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderProductCard, {
                handle: product.handle,
                index: index,
                isSearch: false
            }, product.handle);
        });
        return products;
    };
    var productItems = buildProductItems();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "builder-grid grid grid-cols-2 gap-5 lg:grid-cols-3",
        children: productItems
    });
};

;// CONCATENATED MODULE: ./src/snippets/icons/Lock.jsx
function Lock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Lock_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Lock_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function Lock(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", Lock_objectSpread({
        width: "8",
        height: "11",
        viewBox: "0 0 8 11",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 5H7.5C7.77614 5 8 5.22386 8 5.5V10C8 10.2761 7.77614 10.5 7.5 10.5H0.5C0.223858 10.5 0 10.2761 0 10V5.5C0 5.22386 0.223858 5 0.5 5Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.53994 2.83155C2.28305 3.43427 2.24999 4.23617 2.25 4.99999L0.75 5.00001C0.749988 4.26383 0.766942 3.16571 1.16006 2.2434C1.36405 1.76483 1.68079 1.30328 2.17129 0.965229C2.66461 0.62523 3.27609 0.449951 4.00003 0.449951C4.72396 0.449951 5.33543 0.62523 5.82876 0.965231C6.31925 1.30328 6.63599 1.76483 6.83997 2.24341C7.23308 3.16571 7.25002 4.26384 7.25002 5H5.75002C5.75002 4.23616 5.71697 3.43426 5.46008 2.83155C5.33906 2.5476 5.1808 2.3404 4.97754 2.20031C4.77712 2.06218 4.47609 1.94995 4.00003 1.94995C3.52396 1.94995 3.22293 2.06218 3.0225 2.20031C2.81924 2.3404 2.66097 2.54761 2.53994 2.83155Z"
            })
        ]
    }));
}

// EXTERNAL MODULE: ./src/sections/BundleBuilder/BuilderSteps.module.css
var BuilderSteps_module = __webpack_require__(97765);
var BuilderSteps_module_default = /*#__PURE__*/__webpack_require__.n(BuilderSteps_module);
;// CONCATENATED MODULE: ./src/snippets/icons/BagFull.jsx
function BagFull_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BagFull_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BagFull_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function BagFull(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", BagFull_objectSpread({
        width: "100%",
        height: "100%",
        viewBox: "0 0 26 33",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: "2",
        fill: "currentcolor"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.089,9.743L3.123,9.743L3.123,24.123C3.123,26.866 5.38,29.123 8.123,29.123C8.123,29.123 17.503,29.123 17.503,29.123C20.246,29.123 22.503,26.866 22.503,24.123C22.503,24.123 22.503,9.743 22.503,9.743L17.537,9.743L17.537,7.847C17.537,5.256 15.405,3.123 12.813,3.123C10.222,3.123 8.089,5.256 8.089,7.847L8.089,9.743ZM15.537,9.743L15.537,7.847C15.537,6.353 14.307,5.123 12.813,5.123C11.319,5.123 10.089,6.353 10.089,7.847L10.089,9.743L15.537,9.743Z"
        })
    }));
};

;// CONCATENATED MODULE: ./src/snippets/icons/BuilderRemove.jsx
function BuilderRemove_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BuilderRemove_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BuilderRemove_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function BuilderRemove(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", BuilderRemove_objectSpread({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5356 4.46449L4.46458 11.5356",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5356 11.5356L4.46458 4.46448",
                stroke: "white",
                strokeWidth: "2"
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderStep.jsx




function BuilderStep(param) {
    var product = param.product, removeProduct = param.removeProduct;
    var ref, ref1, ref2, ref3;
    var context = useBuilderContext();
    var builderSettings = context.builderSettings;
    return product.handle === builderSettings.heroProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bundle-builder__step-image-container rounded-sm",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
            className: "bundle-builder__step-image rounded-md",
            src: product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref[0].src,
            alt: product === null || product === void 0 ? void 0 : (ref1 = product.images) === null || ref1 === void 0 ? void 0 : ref1[0].alt,
            width: "3000",
            height: "1685",
            loading: "lazy",
            fill: true
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        onClick: function() {
            removeProduct(product.handle);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bundle-builder__step-image-container rounded-sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "absolute -top-2.5 -left-2.5 z-[2] flex h-5 w-5 items-center justify-center rounded-full bg-rosehip text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderRemove, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sr-only",
                            children: "Remove Product"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    className: "bundle-builder__step-image rounded-md",
                    src: product === null || product === void 0 ? void 0 : (ref2 = product.images) === null || ref2 === void 0 ? void 0 : ref2[0].src,
                    alt: product === null || product === void 0 ? void 0 : (ref3 = product.images) === null || ref3 === void 0 ? void 0 : ref3[0].alt,
                    width: "500",
                    height: "500",
                    loading: "lazy",
                    fill: true
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderSteps.jsx
function BuilderSteps_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BuilderSteps_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BuilderSteps_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BuilderSteps_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function BuilderSteps_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BuilderSteps_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BuilderSteps_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










function BuilderSteps() {
    var ref9, ref1, ref2, ref3;
    var context = useBuilderContext();
    var cartAddItems = (0,dist.useCartAddItems)().cartAddItems;
    var ref4 = (0,dist.useLocalizedVariant)(), localizeVariant = ref4.localize;
    var builderSettings = context.builderSettings;
    var builderData = context.builderData;
    var currentStepIndex = builderData.selectedProducts.length - 1;
    var currentStep = ((ref9 = builderSettings.bundleSteps) === null || ref9 === void 0 ? void 0 : ref9[currentStepIndex]) || {};
    var currentDiscount = (currentStep === null || currentStep === void 0 ? void 0 : currentStep.discountValue) || 0;
    var country = (0,dist.useCountry)().country;
    var currencySymbol = (country === null || country === void 0 ? void 0 : (ref1 = country.currency) === null || ref1 === void 0 ? void 0 : ref1.symbol) || "$";
    var ref5 = (0,react.useState)([]), localizedVariants = ref5[0], setLocalizedVariants = ref5[1];
    var ref6 = (0,react.useState)(false), bundleHasFreeGift = ref6[0], setBundleHasFreeGift = ref6[1];
    var router = (0,next_router.useRouter)();
    var settings = (0,dist.useSettings)();
    var ref7 = settings !== null && settings !== void 0 ? settings : {}, freeProductSettings = ref7.newFreeProducts;
    var currentCampaign = freeProductSettings === null || freeProductSettings === void 0 ? void 0 : (ref2 = freeProductSettings.gwpScenarios) === null || ref2 === void 0 ? void 0 : ref2.find(function(campaignObject) {
        return (campaignObject === null || campaignObject === void 0 ? void 0 : campaignObject.campaign) === builderSettings.campaign && (campaignObject === null || campaignObject === void 0 ? void 0 : campaignObject.enabled);
    });
    var cart = (0,dist.useCart)();
    var hasBundleItems = cart === null || cart === void 0 ? void 0 : (ref3 = cart.lines) === null || ref3 === void 0 ? void 0 : ref3.some(function(line) {
        return line.attributes.find(function(attr) {
            return attr.key === "_bundleId";
        });
    });
    var localizeVariants = function() {
        var _ref = BuilderSteps_asyncToGenerator(runtime_default().mark(function _callee() {
            var localizationRequest;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(builderData.selectedProducts.length === 0)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", []);
                    case 2:
                        localizationRequest = builderData.selectedProducts.map(function(product) {
                            return localizeVariant(BuilderSteps_objectSpread({}, product.variants[0], {
                                handle: product.handle
                            }));
                        });
                        _ctx.next = 5;
                        return Promise.all(localizationRequest).then(function(variants) {
                            setLocalizedVariants(variants);
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function localizeVariants() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeProduct = function(handle) {
        var selectedProducts = builderData.selectedProducts.filter(function(loopProduct) {
            return loopProduct.handle !== handle;
        });
        context.updateBuilderData({
            selectedProducts: selectedProducts
        });
    };
    var addBundleToCart = function() {
        var _ref = BuilderSteps_asyncToGenerator(runtime_default().mark(function _callee() {
            var selectedProducts, productIds, lineItems;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        selectedProducts = builderData.selectedProducts;
                        productIds = selectedProducts.map(function(product) {
                            return product.variants[0].id;
                        });
                        lineItems = productIds.map(function(id) {
                            var itemAttributes = [
                                {
                                    key: "_discount",
                                    value: "".concat(currentStep.discountValue)
                                },
                                {
                                    key: "_bundleId",
                                    value: "".concat(new Date().getTime())
                                },
                                {
                                    key: "_bundleCount",
                                    value: "".concat(selectedProducts.length)
                                },
                                {
                                    key: "_sc",
                                    value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                                }
                            ];
                            if (builderSettings.campaign) {
                                itemAttributes.push({
                                    key: "_campaign",
                                    value: builderSettings.campaign
                                });
                            }
                            ;
                            return {
                                merchandiseId: id,
                                quantity: 1,
                                attributes: itemAttributes
                            };
                        });
                        _ctx.next = 5;
                        return cartAddItems(lineItems, function() {
                            var newState = BuilderSteps_objectSpread({}, window.history.state, {
                                as: router.pathname.replace("[handle]", router.query.handle),
                                url: "".concat(router.pathname, "?handle=").concat(router.query.handle)
                            });
                            window.history.replaceState(newState, "", newState.as);
                            document.location.href = "/cart";
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addBundleToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (currentCampaign) {
            var bundleRequiresProduct = !!(currentCampaign === null || currentCampaign === void 0 ? void 0 : currentCampaign.gwpProductQualify) || !!(currentCampaign === null || currentCampaign === void 0 ? void 0 : currentCampaign.gwpProductQualifySecondary);
            var bundleHasProduct = builderData.selectedProducts.some(function(product) {
                var ref, ref8;
                return product.handle === (currentCampaign === null || currentCampaign === void 0 ? void 0 : (ref = currentCampaign.gwpProductQualify) === null || ref === void 0 ? void 0 : ref.handle) || product.handle === (currentCampaign === null || currentCampaign === void 0 ? void 0 : (ref8 = currentCampaign.gwpProductQualifySecondary) === null || ref8 === void 0 ? void 0 : ref8.handle);
            });
            if (bundleRequiresProduct && !bundleHasProduct) {
                setBundleHasFreeGift(false);
                return;
            }
            setBundleHasFreeGift(true);
        }
    }, [
        builderData.selectedProducts.length,
        currentCampaign
    ]);
    (0,react.useEffect)(function() {
        localizeVariants();
    }, [
        builderData.selectedProducts.length,
        country
    ]);
    var steps = builderSettings.bundleSteps.map(function(step, index) {
        var product = null;
        if (builderData.selectedProducts[index] !== undefined) {
            product = builderData.selectedProducts[index];
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bundle-builder__step relative h-[50px] w-[50px] rounded-md bg-grey-9 font-hafferBold before:absolute before:top-1/2\n        before:left-full before:block before:w-full before:border-b last:before:hidden lg:h-[100px] lg:w-[100px] lg:before:top-full\n        lg:before:left-1/2 lg:before:h-[33px] lg:before:w-0 lg:before:border-l\n        ".concat(product ? "border-2 border-solid border-rosehip before:!border-b-2 before:border-rosehip lg:before:border-l-2" : "border border-dashed", "\n        "),
            children: [
                product ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderStep, {
                    product: product,
                    removeProduct: removeProduct,
                    country: country
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bundle-builder__step-content relative flex h-full flex-col items-center justify-center gap-1 lg:gap-2.5",
                    children: index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bundle-builder__step-icon align-center inline-flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-black tracking-normal text-white lg:h-7 lg:w-7",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lock, {
                                    className: "block h-auto w-2 lg:w-2.5"
                                })
                            }),
                            (step === null || step === void 0 ? void 0 : step.discountValue) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bundle-builder__step-discount text-sub-xx-small lg:text-sm",
                                children: [
                                    step === null || step === void 0 ? void 0 : step.discountValue,
                                    "% off"
                                ]
                            })
                        ]
                    })
                }),
                bundleHasFreeGift && index == (currentCampaign === null || currentCampaign === void 0 ? void 0 : currentCampaign.gwpBundleCount) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bundle-builder__step-free-gift absolute -bottom-3.5 lg:-bottom-2.5 left-1/2 w-fit max-w-none -translate-x-1/2 whitespace-nowrap rounded-full border py-1 px-1.5 leading-none text-sub-xx-small\n            ".concat(product ? "border-rosehip bg-rosehip text-white" : "border-black bg-quinary-2", "\n          "),
                    children: "+ Free Gift!"
                })
            ]
        }, "step".concat(index));
    });
    var bundleTotal = localizedVariants === null || localizedVariants === void 0 ? void 0 : localizedVariants.reduce(function(total, variant) {
        var ref;
        return total + parseFloat(variant === null || variant === void 0 ? void 0 : (ref = variant.priceV2) === null || ref === void 0 ? void 0 : ref.amount);
    }, 0);
    var bundleDiscountedPrice = bundleTotal * (1 - currentDiscount / 100);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((BuilderSteps_module_default())["bundle-builder__sidebar-container"], " bundle-builder__sidebar-container sticky bottom-0 rounded-tl-[20px] rounded-tr-[20px] bg-grey-9 p-5 lg:relative lg:bottom-auto lg:!ml-0 lg:!w-full lg:rounded-tr-none lg:rounded-tl-none lg:!shadow-none lg:filter-none"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bundle-builder__step-info text-center font-hafferBold text-xs leading-4 lg:text-lg lg:leading-normal",
                children: currentStepIndex === -1 ? builderSettings.defaultBundleMessage : currentStep.stepInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bundle-builder__steps-container mt-3 flex w-full flex-row items-center justify-center gap-[30px] lg:mt-[30px] lg:mb-[40px] lg:flex-col ".concat(currentCampaign ? "mb-5" : "mb-4"),
                children: steps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "bundle-builder__add-to-cart-button button button--primary group w-full !px-2.5\n        ".concat((builderData.selectedProducts.length <= 1 || hasBundleItems === true) && "hover:border-grey-7 hover:bg-grey-7"),
                disabled: builderData.selectedProducts.length <= 1 || hasBundleItems === true,
                onClick: addBundleToCart,
                children: builderData.selectedProducts.length <= 1 ? "bundle & save" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "relative mr-2 inline-block w-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "transition-color relative z-[2] text-sm duration-150\n              ".concat(hasBundleItems ? "text-grey-7" : "text-rosehip group-hover:opacity-50"),
                                    children: builderData.selectedProducts.length
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BagFull, {
                                    className: "absolute -top-1.5 h-auto w-6 leading-none"
                                })
                            ]
                        }),
                        "add to cart",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                            className: "ml-1.5 inline-block",
                            children: "".concat(currencySymbol).concat(bundleTotal.toFixed(2).replace(".00", ""))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "dinline-block ml-1.5",
                            children: "".concat(currencySymbol).concat(bundleDiscountedPrice.toFixed(2).replace(".00", ""))
                        })
                    ]
                })
            }),
            hasBundleItems === true && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bundle-builder__error-message mt-2 text-center font-hafferBold text-xs leading-4 text-error",
                children: "You already have a bundle in your cart, please remove it before adding a new one."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderPagination.jsx




function BuilderPagination() {
    var context = useBuilderContext();
    var builderData = context.builderData, builderSettings = context.builderSettings;
    var pageLimit = builderSettings.pageLimit;
    var currentPage = builderData.page;
    var maxPages = Math.ceil(builderData.filteredProducts.length / pageLimit);
    if (maxPages <= 1) {
        return null;
    }
    var changeCurrentPage = function(page) {
        context.updateBuilderData({
            page: page
        });
    };
    var buildPaginationItems = function() {
        var _loop = function(i) {
            paginationItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "pagination-item relative mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: "h-8 w-8 before:absolute before:bottom-0 before:left-0 before:right-0 before:mx-auto before:block before:w-0 before:border-b-2 before:border-black before:transition-all before:duration-150 hover:before:!w-3 ".concat(currentPage === i ? " before:!w-3" : ""),
                    onClick: function() {
                        changeCurrentPage(i);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": true,
                            children: i
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "sr-only",
                            children: [
                                "Go to page ",
                                i
                            ]
                        })
                    ]
                })
            }, "pagination-".concat(i)));
        };
        var paginationItems = [];
        var startPage = 1;
        var endPage = maxPages;
        var showPrevSpacer = false;
        var showNextSpacer = false;
        if (currentPage > 3) {
            showPrevSpacer = true;
            startPage = currentPage - 1;
        }
        if (currentPage < maxPages - 2) {
            showNextSpacer = true;
            endPage = parseInt(currentPage, 10) + 1;
        }
        if (showPrevSpacer) {
            paginationItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "relative mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: "h-8 w-8 before:absolute before:bottom-0 before:left-0 before:right-0 before:mx-auto before:block before:w-0 before:border-b-2 before:border-black before:transition-all before:duration-150 hover:before:w-3",
                    onClick: function() {
                        return changeCurrentPage(1);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Go to page"
                        }),
                        "1"
                    ]
                })
            }, "pagination-1"));
            paginationItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "leading-loose",
                    children: "..."
                })
            }, "previousSpacer"));
        }
        for(var i = startPage; i <= endPage; i++)_loop(i);
        if (showNextSpacer) {
            paginationItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "mt-0 h-8 w-8 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "leading-loose",
                    children: "..."
                })
            }, "nextSpacer"));
            paginationItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "relative mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: "h-8 w-8 before:absolute before:bottom-0 before:left-0 before:right-0 before:mx-auto before:block before:w-0 before:border-b-2 before:border-black before:transition-all before:duration-150 hover:before:w-3",
                    onClick: function() {
                        return changeCurrentPage(maxPages);
                    },
                    disabled: currentPage === maxPages,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Go to page"
                        }),
                        maxPages
                    ]
                })
            }, "pagination-".concat(maxPages)));
        }
        return paginationItems;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "bundle-builder__pagination mt-10 flex w-full list-none justify-center p-0 font-hafferBold lg:mb-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "pagination-item mt-0 mr-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: function() {
                        return currentPage > 1 && changeCurrentPage(parseInt(currentPage, 10) - 1);
                    },
                    className: "flex h-8 w-8 items-center justify-center border border-black transition-all duration-150 ".concat(currentPage === 1 ? "cursor-not-allowed opacity-50" : "hover:bg-black hover:text-white"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Go to previous page"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* ArrowLeft */.X, {})
                    ]
                })
            }, "previous-button"),
            buildPaginationItems(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "pagination-item mt-0 ml-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: function() {
                        return currentPage < maxPages && changeCurrentPage(parseInt(currentPage, 10) + 1);
                    },
                    className: "flex h-8 w-8 items-center justify-center border border-black transition-all duration-150 ".concat(currentPage === maxPages ? "cursor-not-allowed opacity-50" : "hover:bg-black hover:text-white"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Go to next page"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {})
                    ]
                })
            }, "next-button")
        ]
    });
};

;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderLoadMore.jsx




function BundleLoadMore() {
    var context = useBuilderContext();
    var builderData = context.builderData, builderSettings = context.builderSettings;
    var maxPages = Math.ceil(builderData.filteredProducts.length / builderSettings.pageLimit);
    var isBrowser = "object" !== "undefined";
    var ref2 = (0,react.useState)(0), scrollPosition = ref2[0], setScrollPosition = ref2[1];
    var throttledScrollPosition = (0,hooks/* useThrottle */.fB)(scrollPosition, 20);
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var loadNewPage = function() {
        var page = builderData.page + 1;
        if (builderData.page < maxPages) {
            // setLoading(true);
            context.updateBuilderData({
                page: page
            });
        }
    };
    var scrollHandler = function() {
        setScrollPosition(window.scrollY);
    };
    (0,react.useEffect)(function() {
        if (isBrowser && !!builderSettings.scrollThreshold && builderSettings.scrollThreshold > 0 && builderData.page < maxPages) {
            window.addEventListener("scroll", scrollHandler);
        }
        if (builderData.filteredProducts.length === builderData.page * builderSettings.pageLimit) {
            setLoading(false);
        }
        return function() {
            window.removeEventListener("scroll", scrollHandler);
        };
    }, [
        builderData.filteredProducts.length
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var windowHeight = isBrowser ? document === null || document === void 0 ? void 0 : (ref = document.body) === null || ref === void 0 ? void 0 : ref.offsetHeight : 0;
        var currentScrollThreshold = windowHeight * (builderSettings.scrollThreshold * 0.01);
        if (window.scrollY >= currentScrollThreshold) {
            loadNewPage();
        }
    }, [
        throttledScrollPosition
    ]);
    return (!builderSettings.scrollThreshold || builderSettings.scrollThreshold === 0) && builderData.page < maxPages && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "load-more__container my-10 text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: loadNewPage,
            type: "button",
            className: "button button--primary",
            children: loading ? "Loading..." : "load more"
        })
    });
};

// EXTERNAL MODULE: ./src/snippets/products/ProductGallery.jsx
var ProductGallery = __webpack_require__(3052);
// EXTERNAL MODULE: ./src/snippets/products/ProductInformation.jsx + 3 modules
var ProductInformation = __webpack_require__(53748);
;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderQuickView.jsx









function BuilderQuickView() {
    var context = useBuilderContext();
    var builderData = context.builderData, builderSettings = context.builderSettings;
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var product = (0,dist.useProductByHandle)({
        handle: builderData.quickViewProduct
    }).product;
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var selectedProduct = builderData.selectedProducts.some(function(loopProduct) {
        return loopProduct.handle === builderData.quickViewProduct;
    });
    var closeQuickview = function() {
        context.updateBuilderData({
            quickViewProduct: null
        });
    };
    var updateBundle = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        var selectedProducts = builderData.selectedProducts;
        if (selectedProduct) {
            selectedProducts = selectedProducts.filter(function(loopProduct) {
                return loopProduct.handle !== product.handle;
            });
        } else {
            selectedProducts.push(product);
        }
        context.updateBuilderData({
            selectedProducts: selectedProducts,
            quickViewProduct: null
        });
    };
    (0,react.useEffect)(function() {
        var currentScroll = window.scrollY;
        document.body.style.setProperty("--topPosition", "-".concat(currentScroll, "px"));
        document.body.classList.add("overflow-hidden", "bg-overlay");
        return function() {
            document.body.classList.remove("overflow-hidden", "bg-overlay");
            var scrollTop = document.body.style.getPropertyValue("--topPosition");
            if (scrollTop) {
                window.scrollTo({
                    top: parseInt(scrollTop.replace("px", "") || "0", 10) * -1
                });
            }
        };
    }, []);
    if (!product) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "builder__quick-view fixed bottom-0 z-[1000000] h-[90%] w-full overflow-y-auto rounded-t-[30px] bg-white lg:top-1/2\n        lg:left-1/2 lg:h-[590px] lg:max-h-[90%] lg:w-[1075px] lg:max-w-[80%] lg:-translate-y-1/2 lg:-translate-x-1/2 lg:rounded-none lg:px-5 lg:pb-12 lg:pt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "quick-view__modal-header sticky top-0 z-10 mb-4 border-b border-grey-9 bg-white py-4 px-4 text-right lg:relative lg:border-b-0 lg:px-0 lg:py-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            onClick: closeQuickview,
                            className: "ml-auto flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "lg:sr-only font-hafferBold text-sm",
                                    children: "close"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {
                                    className: "h-4 w-4"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "quick-view__modal-body flex w-full flex-col px-4 lg:flex-row lg:px-0",
                        children: [
                            vpWidth <= 992 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInformation/* default */.Z, {
                                product: product,
                                hideDiscount: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "-mt-6 lg:mt-0 lg:w-6/12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGallery/* default */.Z, {
                                    product: product,
                                    quickView: true,
                                    bundleBuilder: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-full overflow-x-hidden lg:w-6/12 lg:overflow-y-auto lg:pl-5",
                                children: vpWidth > 992 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInformation/* default */.Z, {
                                            product: product,
                                            hideDiscount: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "button sticky bottom-0 w-full lg:relative\n                  ".concat(selectedProduct ? "button--secondary hover:!bg-white hover:!text-black lg:hover:!bg-black lg:hover:!text-white" : "button--primary", "\n                  ").concat(!selectedProduct && builderData.selectedProducts.length === builderSettings.bundleSteps.length ? "!border-black !bg-black !text-white opacity-50" : ""),
                                            disabled: !selectedProduct && builderData.selectedProducts.length === builderSettings.bundleSteps.length,
                                            onClick: updateBundle,
                                            children: selectedProduct ? "remove" : "add to bundle"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-5",
                                    children: metafieldMap.short_description
                                })
                            }),
                            vpWidth <= 992 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "button mb-4 lg:relative\n                ".concat(selectedProduct ? "button--secondary !bg-white hover:!bg-white hover:!text-black lg:hover:!bg-black lg:hover:!text-white" : "button--primary", "\n                ").concat(!selectedProduct && builderData.selectedProducts.length === builderSettings.bundleSteps.length ? "!border-black !bg-black !text-white opacity-50" : ""),
                                disabled: !selectedProduct && builderData.selectedProducts.length === builderSettings.bundleSteps.length,
                                onClick: updateBundle,
                                children: selectedProduct ? "remove" : "add to bundle"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: closeQuickview,
                className: "fixed top-0 left-0 z-[999999] h-full w-full bg-black opacity-30",
                "aria-label": "Close Quick View"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/snippets/globals/layout/Markdown.jsx
function Markdown_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Markdown_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Markdown_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Markdown_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Markdown_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Markdown_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function Markdown_Markdown(_param) {
    var content = _param.content, props = Markdown_objectWithoutProperties(_param, [
        "content"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactMarkdown, Markdown_objectSpread({}, props, {
        rehypePlugins: [
            rehypeRaw,
            [
                (rehype_wrap_default()),
                {
                    wrapper: "div.table-wrapper",
                    selector: "table"
                }
            ], 
        ],
        children: content
    }));
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/index.js + 8 modules
var browser = __webpack_require__(80080);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/react/dist/Particles.js



const f = (t) => {
  const i = t.id ?? "tsparticles";
  return (0,react.useEffect)(() => {
    let e;
    return browser/* tsParticles.load */.S6.load({ id: i, url: t.url, options: t.options }).then((l) => {
      var a;
      e = l, (a = t.particlesLoaded) == null || a.call(t, l);
    }), () => {
      e == null || e.destroy();
    };
  }, [i, t, t.url, t.options]), /* @__PURE__ */ (0,jsx_runtime.jsx)("div", { id: i, className: t.className });
};


;// CONCATENATED MODULE: ../node_modules/@tsparticles/react/dist/index.js




async function n(t) {
  await t(browser/* tsParticles */.S6);
}


;// CONCATENATED MODULE: ../node_modules/tsparticles/browser/index.js
async function loadFull(engine, refresh = true) {
    const { loadDestroyUpdater } = await __webpack_require__.e(/* import() */ 2370).then(__webpack_require__.bind(__webpack_require__, 62370)), { loadRollUpdater } = await __webpack_require__.e(/* import() */ 5016).then(__webpack_require__.bind(__webpack_require__, 45016)), { loadTiltUpdater } = await __webpack_require__.e(/* import() */ 9974).then(__webpack_require__.bind(__webpack_require__, 79974)), { loadTwinkleUpdater } = await __webpack_require__.e(/* import() */ 8203).then(__webpack_require__.bind(__webpack_require__, 28203)), { loadWobbleUpdater } = await __webpack_require__.e(/* import() */ 5279).then(__webpack_require__.bind(__webpack_require__, 35279)), { loadTextShape } = await __webpack_require__.e(/* import() */ 486).then(__webpack_require__.bind(__webpack_require__, 10486)), { loadExternalTrailInteraction } = await __webpack_require__.e(/* import() */ 7307).then(__webpack_require__.bind(__webpack_require__, 17307)), { loadAbsorbersPlugin } = await __webpack_require__.e(/* import() */ 344).then(__webpack_require__.bind(__webpack_require__, 60344)), { loadEmittersPlugin } = await __webpack_require__.e(/* import() */ 587).then(__webpack_require__.bind(__webpack_require__, 90587)), { loadEmittersShapeCircle } = await __webpack_require__.e(/* import() */ 957).then(__webpack_require__.bind(__webpack_require__, 60957)), { loadEmittersShapeSquare } = await __webpack_require__.e(/* import() */ 5171).then(__webpack_require__.bind(__webpack_require__, 55171)), { loadSlim } = await __webpack_require__.e(/* import() */ 5925).then(__webpack_require__.bind(__webpack_require__, 45925));
    await loadDestroyUpdater(engine, false);
    await loadRollUpdater(engine, false);
    await loadTiltUpdater(engine, false);
    await loadTwinkleUpdater(engine, false);
    await loadWobbleUpdater(engine, false);
    await loadTextShape(engine, false);
    await loadExternalTrailInteraction(engine, false);
    await loadAbsorbersPlugin(engine, false);
    await loadEmittersPlugin(engine, false);
    await loadEmittersShapeCircle(engine, false);
    await loadEmittersShapeSquare(engine, false);
    await loadSlim(engine, refresh);
}

;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BuilderFreeGiftToast.jsx
function BuilderFreeGiftToast_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BuilderFreeGiftToast_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BuilderFreeGiftToast_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BuilderFreeGiftToast_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










function BuilderFreeGiftToast(param) {
    var headerHidden = param.headerHidden;
    var ref7;
    var ref1 = useBuilderContext(), builderData = ref1.builderData, builderSettings = ref1.builderSettings;
    var settings = (0,dist.useSettings)();
    var ref2 = settings !== null && settings !== void 0 ? settings : {}, freeProductSettings = ref2.newFreeProducts;
    var currentCampaign = freeProductSettings === null || freeProductSettings === void 0 ? void 0 : (ref7 = freeProductSettings.gwpScenarios) === null || ref7 === void 0 ? void 0 : ref7.find(function(campaignObject) {
        return (campaignObject === null || campaignObject === void 0 ? void 0 : campaignObject.campaign) === builderSettings.campaign && campaignObject.enabled == true;
    });
    var ref3 = (0,react.useState)(false), qualifies = ref3[0], setQualifies = ref3[1];
    var ref4 = (0,react.useState)(false), wasClosed = ref4[0], setWasClosed = ref4[1];
    var ref5 = (0,react.useState)(false), particlesInitialized = ref5[0], setParticlesInitialized = ref5[1];
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var isMobile = vpWidth < 1024;
    var getHeaderHeight = function() {
        if (true) {
            return document.querySelector("header").offsetHeight;
        } else {}
    };
    var headerHeight = getHeaderHeight();
    (0,react.useEffect)(function() {
        var bundleRequiresProduct = !!(currentCampaign === null || currentCampaign === void 0 ? void 0 : currentCampaign.gwpProductQualify) || !!(currentCampaign === null || currentCampaign === void 0 ? void 0 : currentCampaign.gwpProductQualifySecondary);
        var bundleHasProduct = builderData.selectedProducts.some(function(product) {
            var ref, ref6;
            return product.handle === (currentCampaign === null || currentCampaign === void 0 ? void 0 : (ref = currentCampaign.gwpProductQualify) === null || ref === void 0 ? void 0 : ref.handle) || product.handle === (currentCampaign === null || currentCampaign === void 0 ? void 0 : (ref6 = currentCampaign.gwpProductQualifySecondary) === null || ref6 === void 0 ? void 0 : ref6.handle);
        });
        if (bundleRequiresProduct && !bundleHasProduct) {
            setQualifies(false);
            return;
        }
        if (currentCampaign && builderData.selectedProducts.length >= (currentCampaign === null || currentCampaign === void 0 ? void 0 : currentCampaign.gwpBundleCount)) {
            setQualifies(true);
        } else {
            setQualifies(false);
        }
    }, [
        builderData.selectedProducts.length
    ]);
    (0,react.useEffect)(function() {
        if (qualifies == false) {
            setWasClosed(false);
        }
    }, [
        qualifies
    ]);
    (0,react.useEffect)(function() {
        if (particlesInitialized) return;
        n(function() {
            var _ref = BuilderFreeGiftToast_asyncToGenerator(runtime_default().mark(function _callee(engine) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return loadFull(engine);
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(engine) {
                return _ref.apply(this, arguments);
            };
        }()).then(function() {
            setParticlesInitialized(true);
        });
    }, []);
    var isVisible = qualifies && !wasClosed;
    var options = {
        fullScreen: {
            enable: true,
            zIndex: 10
        },
        interactivity: {
            detectsOn: "window"
        },
        emitters: {
            life: {
                count: 1,
                duration: 0.1,
                delay: 0.4
            },
            position: {
                x: isMobile ? 50 : 85,
                y: isMobile ? headerHidden ? 5 : 15 : 98
            },
            rate: {
                quantity: 200,
                delay: 0.4
            }
        },
        particles: {
            life: {
                duration: {
                    sync: true,
                    value: 5
                },
                count: 1
            },
            color: {
                value: [
                    "#EDE757",
                    "#14A34A",
                    "#E61A4F",
                    "#5B9AC5",
                    "#00A19B"
                ]
            },
            size: {
                value: 5
            },
            move: {
                decay: 0.05,
                direction: isMobile ? "none" : "top",
                enable: true,
                gravity: {
                    enable: true
                },
                outModes: {
                    top: "none",
                    default: "destroy"
                },
                speed: {
                    min: isMobile ? 5 : 15,
                    max: isMobile ? 20 : 50
                }
            },
            number: {
                value: 0
            },
            opacity: {
                value: 1
            },
            rotate: {
                value: {
                    min: 0,
                    max: 360
                },
                direction: "random",
                animation: {
                    enable: true,
                    speed: 30
                }
            },
            tilt: {
                direction: "random",
                enable: true,
                value: {
                    min: 0,
                    max: 360
                },
                animation: {
                    enable: true,
                    speed: 30
                }
            },
            roll: {
                darken: {
                    enable: true,
                    value: 25
                },
                enable: true,
                speed: {
                    min: 5,
                    max: 15
                }
            },
            wobble: {
                distance: 30,
                enable: true,
                speed: {
                    min: -7,
                    max: 7
                }
            },
            shape: {
                type: [
                    "circle",
                    "square",
                    "polygon", 
                ],
                options: {
                    polygon: [
                        {
                            sides: 5
                        },
                        {
                            sides: 6
                        }, 
                    ]
                }
            }
        }
    };
    if (!(currentCampaign === null || currentCampaign === void 0 ? void 0 : currentCampaign.gwpQualifyMessage)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isVisible && particlesInitialized && !wasClosed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        dangerouslySetInnerHTML: {
                            __html: "#tsparticles canvas {z-index: 10}"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(f, {
                        id: "tsparticles",
                        options: options
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bundle-builder__toast-container fixed left-0 right-0 z-10 mx-auto w-max max-w-full p-3 lg:left-auto lg:top-auto lg:bottom-3 lg:right-[110px] lg:w-auto transition-all duration-150\n        ".concat(isVisible ? "translate-y-0" : "-translate-y-[200%] lg:translate-y-full", "\n      "),
                style: {
                    top: isMobile ? headerHidden ? "0px" : headerHeight + "px" : "unset"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "toast block w-full border bg-white py-3 pl-4 pr-14 lg:w-auto max-w-sm border-grey-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "absolute top-7 right-7",
                            onClick: function() {
                                setWasClosed(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sr-only",
                                    children: "Close free gift notification"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown_Markdown, {
                            content: currentCampaign === null || currentCampaign === void 0 ? void 0 : currentCampaign.gwpQualifyMessage
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/sections/BundleBuilder/BundleBuilder.jsx
function BundleBuilder_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BundleBuilder_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return BundleBuilder_arrayLikeToArray(arr);
}
function BundleBuilder_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BundleBuilder_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function BundleBuilder_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BundleBuilder_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BundleBuilder_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BundleBuilder_toConsumableArray(arr) {
    return BundleBuilder_arrayWithoutHoles(arr) || BundleBuilder_iterableToArray(arr) || BundleBuilder_unsupportedIterableToArray(arr) || BundleBuilder_nonIterableSpread();
}
function BundleBuilder_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BundleBuilder_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BundleBuilder_arrayLikeToArray(o, minLen);
}















function BundleBuilder(param) {
    var cms = param.cms;
    var ref5, ref1;
    var router = (0,next_router.useRouter)();
    var bundleBuilder = (0,react.useRef)(null);
    var isBrowser = "object" !== "undefined";
    var header = isBrowser ? document.querySelector(".site-header") : null;
    var scrollDirection = (0,hooks/* useScrollDirection */.C7)();
    var urlSearchParams = new URLSearchParams(isBrowser ? document.location.search : "");
    var ref2 = (0,react.useState)({
        campaign: cms.campaign,
        title: cms.title,
        description: cms.description,
        ctaTitle: cms.ctaTitle,
        disclaimer: cms.disclaimer,
        collection: cms.collection,
        filters: cms.filters || [],
        hideHeader: cms.hideHeader,
        bundleSteps: cms.bundleSteps || [],
        defaultBundleMessage: cms.defaultBundleMessage,
        pageLimit: 24,
        enableLoadMore: cms.enableLoadMore || false,
        scrollThreshold: cms.scrollThreshold || 0,
        desktopBgImage: cms.desktopBgImage,
        mobileBgImage: cms.mobileBgImage,
        darkText: cms.darkText || false,
        heroProduct: (ref5 = cms.heroProduct) === null || ref5 === void 0 ? void 0 : ref5.handle
    }), builderSettings = ref2[0], setBuilderSettings = ref2[1];
    var urlSelectedProducts = urlSearchParams.get("selectedProducts") || "";
    var ref3 = (0,react.useState)({
        products: [],
        freeGift: null,
        filteredProducts: [],
        selectedProducts: [],
        activeFilter: urlSearchParams.get("activeFilter") || "",
        page: urlSearchParams.get("page") ? Number.parseInt(urlSearchParams.get("page"), 10) : 1,
        quickViewProduct: null
    }), builderData = ref3[0], setBuilderData = ref3[1];
    var headerHidden = builderSettings.hideHeader && scrollDirection === "down";
    var collection = (0,dist.useCollectionByHandle)({
        handle: builderSettings === null || builderSettings === void 0 ? void 0 : builderSettings.collection
    }).collection;
    var productHandles = collection === null || collection === void 0 ? void 0 : (ref1 = collection.products) === null || ref1 === void 0 ? void 0 : ref1.filter(function(product) {
        return product.status === "ACTIVE";
    }).map(function(product) {
        return product.handle;
    });
    var ref4 = (0,hooks/* useProductsFromHandles */.tp)({
        handles: productHandles || []
    }), productsData = ref4.products, productsLoaded = ref4.success;
    var scrollTop = function() {
        var ref;
        bundleBuilder === null || bundleBuilder === void 0 ? void 0 : (ref = bundleBuilder.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    var updateBuilderData = function(data) {
        setBuilderData(function(currentData) {
            var newData = BundleBuilder_objectSpread({}, currentData, data);
            var queryData = {};
            if (data.page && data.page !== currentData.page && !builderSettings.enableLoadMore) {
                scrollTop();
            }
            if (cms.enableUrlHistory) {
                if (newData.page) {
                    queryData.page = newData.page;
                }
                if (newData.selectedProducts.length) {
                    var selectedProductsHandles = newData.selectedProducts.map(function(product) {
                        return product.handle;
                    });
                    queryData.selectedProducts = selectedProductsHandles.join(",");
                }
                if (newData.activeFilter) {
                    queryData.activeFilter = newData.activeFilter;
                }
                if (router.query.handle) {
                    queryData.handle = router.query.handle;
                }
                var searchParams = new URLSearchParams(queryData);
                var customState = BundleBuilder_objectSpread({}, window.history.state, {
                    url: router.pathname,
                    as: router.pathname.replace("[handle]", router.query.handle) + "?" + searchParams.toString()
                });
                window.history.replaceState(customState, null, customState.as);
            }
            return BundleBuilder_objectSpread({}, newData);
        });
    };
    var updateBuilderSettings = function(data) {
        setBuilderSettings(function(currentData) {
            return BundleBuilder_objectSpread({}, currentData, data);
        });
    };
    var applyFilter = function(products) {
        var filter = builderData.activeFilter;
        var filteredProducts = products;
        if (filter !== "" && filter !== undefined) {
            filteredProducts = products.filter(function(product) {
                var ref;
                return (ref = product.tags) === null || ref === void 0 ? void 0 : ref.some(function(tag) {
                    return tag === filter;
                });
            });
        }
        if (builderSettings.heroProduct) {
            filteredProducts = products.filter(function(product) {
                return product.handle !== builderSettings.heroProduct;
            });
        }
        return filteredProducts;
    };
    var applyPagination = function(productList) {
        var pageLimit = builderSettings.pageLimit;
        var page = builderData.page;
        var start = 0;
        if (!builderSettings.enableLoadMore) {
            start = (page - 1) * pageLimit;
        }
        var end = page * pageLimit;
        var paginatedProducts = productList.slice(start, end);
        return paginatedProducts;
    };
    (0,react.useEffect)(function() {
        var products = Object.keys(productsData).map(function(key) {
            return productsData[key];
        });
        var filteredProducts = applyFilter(products);
        var paginatedProducts = applyPagination(filteredProducts);
        var selectedProductsHandles = urlSelectedProducts.split(",") || "";
        if (builderSettings.heroProduct) {
            selectedProductsHandles = [
                builderSettings.heroProduct, 
            ].concat(BundleBuilder_toConsumableArray(selectedProductsHandles.slice(1, selectedProductsHandles.length)));
        }
        var selectedProducts = products.filter(function(product) {
            return selectedProductsHandles.includes(product.handle);
        });
        selectedProducts = selectedProducts.sort(function(a, b) {
            if (a.handle == builderSettings.heroProduct) {
                return -1;
            }
            return 1;
        });
        setBuilderData(function(currentData) {
            return BundleBuilder_objectSpread({}, currentData, {
                products: products,
                filteredProducts: filteredProducts,
                paginatedProducts: paginatedProducts,
                selectedProducts: selectedProducts
            });
        });
    }, [
        productsLoaded
    ]);
    (0,react.useEffect)(function() {
        var filteredProducts = applyFilter(builderData.products);
        var paginatedProducts = applyPagination(filteredProducts);
        setBuilderData(function(currentData) {
            return BundleBuilder_objectSpread({}, currentData, {
                filteredProducts: filteredProducts,
                paginatedProducts: paginatedProducts
            });
        });
    }, [
        builderData.activeFilter
    ]);
    (0,react.useEffect)(function() {
        var filteredProducts = applyFilter(builderData.products);
        var paginatedProducts = applyPagination(filteredProducts);
        setBuilderData(function(currentData) {
            return BundleBuilder_objectSpread({}, currentData, {
                paginatedProducts: paginatedProducts
            });
        });
    }, [
        builderData.page
    ]);
    (0,react.useEffect)(function() {
        if (header && builderSettings.hideHeader) {
            if (scrollDirection === "up") {
                header.style.top = "0";
            } else if (scrollDirection === "down") {
                var headerHeight = "-".concat(header.offsetHeight, "px");
                header.style.top = headerHeight;
            }
        }
    }, [
        scrollDirection
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuilderContext.Provider, {
        value: {
            builderSettings: builderSettings,
            updateBuilderSettings: updateBuilderSettings,
            builderData: builderData,
            updateBuilderData: updateBuilderData
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: "@media (max-width: 1024px) {#chat-button { z-index: 1 !important }}"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderHeader, {
                scrollTop: scrollTop
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bundle-builder__experience-container container mx-auto mt-11 mb-11 flex flex-col px-5 lg:flex-row lg:flex-nowrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bundle-builder__grid-container w-full lg:w-3/4\n            ".concat(headerHidden ? "scroll-m-0" : "scroll-m-24 lg:scroll-m-28", "\n          "),
                        ref: bundleBuilder,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderGridHeader, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderFilters, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderGrid, {}),
                            builderSettings.enableLoadMore === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BundleLoadMore, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderPagination, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bundle-builder__sidebar-container sticky bottom-0 z-10 mt-11 w-full self-start transition-all duration-150 lg:bottom-auto lg:mt-0 lg:w-1/4 lg:pl-5 ".concat(headerHidden ? "lg:top-5" : "lg:top-[105px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderSteps, {})
                    })
                ]
            }),
            builderData.quickViewProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderQuickView, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderFreeGiftToast, {
                headerHidden: headerHidden
            }, "builderToast")
        ]
    });
}
BundleBuilder.displayName = "Bundle Builder";
BundleBuilder.Schema = {
    category: "Modules",
    label: BundleBuilder.displayName,
    key: "BundleBuilder",
    fields: [
        {
            component: "text",
            name: "campaign",
            label: "Campaign",
            description: "Reference to allow Gift with purchase campaign to be applied to the current bundle builder experience"
        },
        {
            component: "text",
            name: "title",
            label: "Title",
            description: "Builder title displayed at the top of the experience, if not populated the title will not be rendered"
        },
        {
            component: "markdown",
            name: "description",
            label: "Description",
            description: "Builder description displayed at the top of the experience, if not populated the description will not be rendered"
        },
        {
            component: "text",
            name: "ctaTitle",
            label: "CTA Label",
            description: "Text shown on the CTA button at the top of the experience, by clicking it the customer will scroll down to the bundle experience, if not populated the button will not be rendered"
        },
        {
            component: "markdown",
            name: "disclaimer",
            label: "Header Disclaimer",
            description: "Message shown at the top of the experience, if not populated the disclaimer will not be rendered"
        },
        {
            component: "image",
            name: "desktopBgImage",
            label: "Desktop Background Image",
            description: "Background image to be shown on the header of the builder experience on desktop resolution, recommended image size 2160px x 800px"
        },
        {
            component: "image",
            name: "mobileBgImage",
            label: "Mobile Background Image",
            description: "Background image to be shown on the header of the builder experience on mobile resolution, recommended image size 1152px x 1152px"
        },
        {
            component: "toggle",
            name: "darkText",
            label: "Text Color",
            description: "Defines the text color on the builder header when an background image is populated",
            toggleLabels: {
                true: "Dark",
                false: "Light"
            },
            defaultValue: true
        },
        {
            component: "toggle",
            name: "hideHeader",
            label: "Hide Header on Scroll",
            description: "If enabled, the header will be hidden when the customer scrolls down, and will be shown again when the customer scrolls up, only in the page this experience is visible",
            defaultValue: true
        },
        {
            component: "toggle",
            name: "enableUrlHistory",
            label: "Enable URL history",
            description: "Saves the content on the URl, so the customer can share it or come back to the state of the experience they left when moving to a PDP",
            defaultValue: false
        },
        {
            component: "text",
            name: "collection",
            label: "Collection Handle",
            description: "Handle of the collection that want's to be used to load the products",
            defaultValue: "all-products"
        },
        {
            name: "enableLoadMore",
            component: "toggle",
            label: "Enable Load More",
            defaultValue: true
        },
        {
            name: "scrollThreshold",
            component: "number",
            label: "Scroll Threshold",
            description: 'What percentage of the page has the customer to scroll before loading more products?, recommended value 60. If this is set to 0 (zero) infinite scrolling will not be enabled and a "Load more" button will appear at the bottom of the product grid',
            defaultValue: 80
        },
        {
            name: "heroProduct",
            component: "productSearch",
            label: "Hero Product",
            description: "Set up a product that will be always present on the customers bundle, this product cannot be removed nor changed by the customer"
        },
        {
            component: "group-list",
            name: "filters",
            label: "Filters",
            fields: [
                {
                    component: "text",
                    name: "name",
                    label: "Name",
                    description: "Filter name shown to the customer on the builder experience"
                },
                {
                    component: "text",
                    name: "value",
                    label: "Filter Tag",
                    description: "Reference of the tag that will be used for filtering the products, this value is case sensitive and should match the product's tag",
                    defaultValue: "Start building your bundle"
                }, 
            ]
        },
        {
            component: "text",
            name: "defaultBundleMessage",
            label: "Default Bundle Message",
            description: "Message shown to the customer when the bundle is empty"
        },
        {
            component: "group-list",
            name: "bundleSteps",
            label: "Bundles Steps",
            fields: [
                {
                    component: "number",
                    name: "discountValue",
                    label: "Discount Value",
                    defaultValue: 0,
                    description: "If value is over 0, and the number of items on the bundles matches with this step, a discount will be applied to all the items added from the bundle"
                },
                {
                    component: "text",
                    name: "stepInfo",
                    label: "Step Info",
                    description: "Message shown to the customer when the current step is reached, used to display current current and next tier discount information"
                },
                {
                    component: "toggle",
                    name: "enableFreeGift",
                    label: "Enable Free Gift",
                    options: [
                        {
                            value: true,
                            label: "Yes"
                        },
                        {
                            value: false,
                            label: "No"
                        }, 
                    ],
                    description: "If enabled, when the customer reaches this step a free gift will be added to their cart with their bundle"
                },
                {
                    component: "productSearch",
                    name: "bundleFreeGiftProduct",
                    label: "Bundle Free Gift",
                    description: "Product that will be added to the cart as a free gift if the customer reaches the current step"
                }
            ],
            validate: {
                maxItems: 4,
                required: true
            }
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/BundleBuilder/index.js


;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizContext.jsx

var QuizContext = /*#__PURE__*/ (0,react.createContext)({
    quizSettings: {},
    quizData: {},
    updateQuizData: function() {},
    parseQuizResultUrl: function() {},
    getResultsProducts: function() {},
    buildSummaryResults: function() {}
});
function useQuizContext() {
    return (0,react.useContext)(QuizContext);
}

;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizOption.jsx
function QuizOption_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function QuizOption_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return QuizOption_arrayLikeToArray(arr);
}
function QuizOption_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function QuizOption_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function QuizOption_toConsumableArray(arr) {
    return QuizOption_arrayWithoutHoles(arr) || QuizOption_iterableToArray(arr) || QuizOption_unsupportedIterableToArray(arr) || QuizOption_nonIterableSpread();
}
function QuizOption_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return QuizOption_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return QuizOption_arrayLikeToArray(o, minLen);
}





function QuizOption(param) {
    var index = param.index, optionData = param.optionData, isMultipleChoice = param.isMultipleChoice, showOptionsImages = param.showOptionsImages, isFilter = param.isFilter, currentAnswers = param.currentAnswers;
    var ref, ref1, ref2;
    var context = useQuizContext();
    var quizData = context.quizData, updateQuizData = context.updateQuizData;
    var checkbox = (0,react.useRef)();
    var defaultChecked = false;
    var onOptionChange = function(evt) {
        if (evt.target.type !== "checkbox") return;
        var allInputs = evt.target.closest(".quiz-steps__options-container").querySelectorAll("input:checked");
        if ([
            "",
            "everything"
        ].includes(evt.target.value.toLowerCase())) {
            if (allInputs === null || allInputs === void 0 ? void 0 : allInputs.length) {
                var otherInput = QuizOption_toConsumableArray(allInputs).filter(function(input) {
                    return input !== evt.target;
                });
                otherInput.forEach(function(input) {
                    input.checked = false;
                });
            }
        } else {
            var otherInput1 = QuizOption_toConsumableArray(allInputs).filter(function(input) {
                return [
                    "",
                    "everything"
                ].includes(input.value.toLowerCase());
            });
            if (allInputs.length) {
                otherInput1.forEach(function(input) {
                    input.checked = false;
                });
            }
        }
    };
    var removeError = function() {
        updateQuizData({
            hasError: false
        });
    };
    if (Array.isArray(currentAnswers === null || currentAnswers === void 0 ? void 0 : currentAnswers.answer)) {
        var ref3, ref4;
        defaultChecked = (currentAnswers === null || currentAnswers === void 0 ? void 0 : (ref3 = currentAnswers.answer) === null || ref3 === void 0 ? void 0 : ref3.includes(String(index))) || (currentAnswers === null || currentAnswers === void 0 ? void 0 : (ref4 = currentAnswers.answer) === null || ref4 === void 0 ? void 0 : ref4.includes(optionData.value));
    } else {
        defaultChecked = (currentAnswers === null || currentAnswers === void 0 ? void 0 : currentAnswers.answer) == index;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "quiz__option h-auto w-full relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: checkbox,
                type: isMultipleChoice ? "checkbox" : "radio",
                name: "question-".concat(quizData.currentQuestion),
                onChange: function(evt) {
                    onOptionChange(evt);
                    removeError();
                },
                value: isFilter ? optionData.value : index,
                id: (0,Helper/* handleize */.v8)(optionData.label),
                className: "peer !absolute !top-0 !eft-0 !w-full !h-full !border-none !bg-transparent after:!hidden before:!hidden ".concat(!showOptionsImages ? "!rounded-full" : "!rounded-[20px]"),
                defaultChecked: defaultChecked
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: (0,Helper/* handleize */.v8)(optionData.label),
                className: "flex flex-col items-center justify-center h-full cursor-pointer overflow-hidden border-2 border-black text-center peer-checked:border-quinary-1 peer-checked:bg-quinary-1 peer-checked:text-white peer-focus:outline peer-focus:outline-1 lg:hover:border-quinary-1 lg:hover:bg-quinary-1 lg:hover:text-white\n         ".concat(!showOptionsImages ? "rounded-full peer-checked:border-quinary-1" : "rounded-[20px]", "\n        "),
                children: [
                    showOptionsImages && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "quiz__option-image border-b-2 w-full ".concat(((ref = checkbox.current) === null || ref === void 0 ? void 0 : ref.checked) ? "border-quinary-1" : "border-black"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: (ref1 = optionData.image) === null || ref1 === void 0 ? void 0 : ref1.src,
                            alt: (ref2 = optionData.image) === null || ref2 === void 0 ? void 0 : ref2.alt,
                            width: 140,
                            height: 80,
                            sizes: "140px, 250px, 350px",
                            className: "aspect-[140/80] h-full w-full object-cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "block py-2.5 px-5 font-hafferBold text-sm lg:text-base",
                        children: optionData.label
                    })
                ]
            })
        ]
    }, "option-".concat(index));
}

;// CONCATENATED MODULE: ./src/sections/QuizSection/Loading.jsx

function Loading() {
    var buildDots = function() {
        var dots = [];
        for(var i = 0; i < 3; i++){
            dots.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading__dot rounded-full w-2.5 h-2.5 bg-grey-3 mx-1 inline-block animate-bounce",
                style: {
                    animationDelay: "".concat(i * 150, "ms"),
                    animationFillMode: "both",
                    animationDuration: "750ms"
                }
            }, "dot-".concat(i)));
        }
        return dots;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "loading my-8",
        children: buildDots()
    });
}

;// CONCATENATED MODULE: ./src/hooks/ScrollLock.jsx

var useScrollLock = function() {
    var isDrawer = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var scrollLock = function() {
        var body = document.body;
        var currentScroll = window.scrollY;
        body.style.setProperty("--topPosition", "-".concat(currentScroll, "px"));
        body.classList.add("overflow-hidden", "bg-overlay", isDrawer !== false && "drawer-open");
    };
    var scrollUnlock = function() {
        var body = document.body;
        var scrollTop = body.style.getPropertyValue("--topPosition");
        body.classList.remove("overflow-hidden", "bg-overlay", isDrawer !== false && "drawer-open");
        body.style.removeProperty("--topPosition");
        if (scrollTop !== "") {
            window.scrollTo({
                top: parseInt(scrollTop.replace("px", "") || "0", 10) * -1
            });
        }
        window.lastSpot = parseInt(scrollTop.replace("px", "") || "0", 10) * -1;
    };
    (0,react.useState)(function() {
        if (true) {
            window.lastSpot = window.scrollY;
            var body = document.body;
            body.addEventListener("click", function(e) {
                if (e.target.nodeName === "BODY" && e.target.classList.contains("bg-overlay")) {
                    scrollUnlock();
                }
            });
        }
    }, []);
    return {
        scrollLock: scrollLock,
        scrollUnlock: scrollUnlock
    };
};

;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizQuestions.jsx
function QuizQuestions_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function QuizQuestions_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return QuizQuestions_arrayLikeToArray(arr);
}
function QuizQuestions_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function QuizQuestions_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function QuizQuestions_toConsumableArray(arr) {
    return QuizQuestions_arrayWithoutHoles(arr) || QuizQuestions_iterableToArray(arr) || QuizQuestions_unsupportedIterableToArray(arr) || QuizQuestions_nonIterableSpread();
}
function QuizQuestions_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return QuizQuestions_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return QuizQuestions_arrayLikeToArray(o, minLen);
}











function QuizQuestions() {
    var ref6;
    var context = useQuizContext();
    var ref1 = useScrollLock(), scrollLock = ref1.scrollLock, scrollUnlock = ref1.scrollUnlock;
    var quizData = context.quizData, quizSettings = context.quizSettings, updateQuizData = context.updateQuizData;
    var ref2 = (0,react.useState)([]), messages1 = ref2[0], setMessages = ref2[1];
    var ref3 = (0,react.useState)([]), currentAnswers = ref3[0], setCurrentAnswers = ref3[1];
    var ref4 = (0,react.useState)(false), helpTextOpen = ref4[0], setHelpTextOpen = ref4[1];
    var isFollowUpQuestion = String(quizData.currentQuestion).indexOf(".") > -1;
    var parentQuestion = quizSettings.questions.find(function(question) {
        return question.index == [
            parseInt(quizData.currentQuestion)
        ];
    });
    var currentQuestionArrayIndex2 = quizData.filteredQuestions.findIndex(function(question) {
        return question.index === parseInt(quizData.currentQuestion);
    });
    var getCurrentQuestionData = function() {
        if (!isFollowUpQuestion) {
            var ref;
            var currentQuestion = quizData.filteredQuestions.length > 0 ? (ref = quizData.filteredQuestions) === null || ref === void 0 ? void 0 : ref.find(function(question) {
                return question.index == quizData.currentQuestion;
            }) : quizSettings.questions.find(function(question) {
                return question.index == quizData.currentQuestion;
            });
            return currentQuestion || {};
        } else {
            var followUpOption = parentQuestion.options[quizData.currentQuestion.split(".")[1]];
            return {
                isMultipleChoice: followUpOption.isMultipleChoice,
                showOptionsImages: followUpOption.showOptionsImages,
                options: followUpOption.followUpOptions,
                message1: followUpOption.followUpMessage1,
                message2: followUpOption.followUpMessage2,
                isFollowUpQuestion: true
            };
        }
    };
    var getListMessages = function() {
        var messages = [];
        var answerMessage = null;
        if (isFollowUpQuestion) {
            var ref;
            answerMessage = (ref = quizData.answers.at(currentQuestionArrayIndex2)) === null || ref === void 0 ? void 0 : ref.answerMessage;
        } else {
            var ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
            answerMessage = ((ref8 = (ref7 = quizData.answers) === null || ref7 === void 0 ? void 0 : ref7.at(Math.max(currentQuestionArrayIndex2 - 1, 0))) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.answerMessage) === null || ref9 === void 0 ? void 0 : ref9.indexOf("###")) > -1 ? (ref11 = (ref10 = quizData.answers) === null || ref10 === void 0 ? void 0 : ref10.at(Math.max(currentQuestionArrayIndex2 - 1, 0))) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.answerMessage) === null || ref12 === void 0 ? void 0 : ref12.split("###")[1] : (ref14 = (ref13 = quizData.answers) === null || ref13 === void 0 ? void 0 : ref13.at(Math.max(currentQuestionArrayIndex2 - 1, 0))) === null || ref14 === void 0 ? void 0 : ref14.answerMessage;
        }
        if (answerMessage && answerMessage !== "") {
            messages.push(answerMessage);
        }
        if (questionData === null || questionData === void 0 ? void 0 : questionData.message1) {
            messages.push(questionData.message1);
        }
        if (questionData === null || questionData === void 0 ? void 0 : questionData.message2) {
            messages.push(questionData.message2);
        }
        return messages;
    };
    var questionData = getCurrentQuestionData();
    var ref5 = (0,react.useState)(true), loading = ref5[0], setLoading = ref5[1];
    var messagesToPrint = getListMessages();
    var isMultipleChoice = questionData.isMultipleChoice, showOptionsImages = questionData.showOptionsImages;
    var navigateToNextQuestion = function() {
        var ref;
        var answersData = getCurrentAnswers();
        var newAnswers = QuizQuestions_toConsumableArray(quizData.answers);
        var hasFollowUpQuestion = false;
        if (!isMultipleChoice) {
            var ref15, ref16, ref17, ref18, ref19;
            hasFollowUpQuestion = ((ref15 = questionData === null || questionData === void 0 ? void 0 : questionData.options[answersData]) === null || ref15 === void 0 ? void 0 : ref15.hasFollowUpQuestion) && (!!((ref16 = questionData === null || questionData === void 0 ? void 0 : questionData.options[answersData]) === null || ref16 === void 0 ? void 0 : ref16.followUpMessage1) || !!((ref17 = questionData === null || questionData === void 0 ? void 0 : questionData.options[answersData]) === null || ref17 === void 0 ? void 0 : ref17.followUpMessage2)) && ((ref18 = questionData === null || questionData === void 0 ? void 0 : questionData.options[answersData]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.followUpOptions) === null || ref19 === void 0 ? void 0 : ref19.length) > 0;
        }
        newAnswers[parseInt(currentQuestionArrayIndex2)] = {
            questionIndex: parseInt(quizData.currentQuestion),
            answer: questionData.isFollowUpQuestion ? "".concat(quizData.answers[parseInt(currentQuestionArrayIndex2)].answer, "-").concat(answersData) : answersData,
            answerMessage: questionData.isFollowUpQuestion ? "".concat(parentQuestion.options[quizData.answers[parseInt(currentQuestionArrayIndex2)].answer].answerMessage || "", "###").concat(questionData.options[answersData].answerMessage || "") : (ref = questionData === null || questionData === void 0 ? void 0 : questionData.options[answersData]) === null || ref === void 0 ? void 0 : ref.answerMessage
        };
        // Handles filter question
        if (questionData.isFilterQuestion && (answersData === null || answersData === void 0 ? void 0 : answersData.length) > 0) {
            var nextQuestion = quizSettings.questions.find(function(question) {
                return answersData.includes(question.category);
            });
            updateQuizData({
                filter: answersData,
                currentQuestion: nextQuestion.index,
                answers: newAnswers,
                hasError: false
            });
            return;
        }
        if (!answersData || !answersData.length) {
            updateQuizData({
                hasError: true
            });
            return;
        }
        ;
        if (hasFollowUpQuestion || Number.parseInt(quizData.currentQuestion) !== quizData.filteredQuestions[quizData.filteredQuestions.length - 1].index) {
            setLoading(true);
            var currentQuestionArrayIndex1 = quizData.filteredQuestions.findIndex(function(question) {
                return question.index === parseInt(quizData.currentQuestion);
            });
            updateQuizData({
                currentQuestion: hasFollowUpQuestion ? "".concat(quizData.currentQuestion, ".").concat(answersData) : quizData.filteredQuestions[currentQuestionArrayIndex1 + 1].index,
                answers: newAnswers,
                hasError: false
            });
        } else {
            var ref20;
            if ((ref20 = quizSettings.mailGateSettings) === null || ref20 === void 0 ? void 0 : ref20.enableMailGate) {
                updateQuizData({
                    quizStep: "mailGate",
                    answers: newAnswers,
                    hasError: false
                });
            } else {
                updateQuizData({
                    quizStep: "results",
                    answers: newAnswers,
                    hasError: false
                });
            }
        }
    };
    var navigateToPreviousQuestion = function() {
        var currentQuestionArrayIndex = quizData.filteredQuestions.findIndex(function(question) {
            return question.index === parseInt(quizData.currentQuestion);
        });
        updateQuizData({
            currentQuestion: isFollowUpQuestion ? parseInt(quizData.currentQuestion) : quizData.filteredQuestions[currentQuestionArrayIndex - 1].index,
            hasError: false
        });
    };
    var getCurrentAnswers = function() {
        var method = isMultipleChoice ? "querySelectorAll" : "querySelector";
        var answers = document[method](".quiz-steps__options-container input:checked");
        var forceEverything = false;
        if (!answers || answers.length === 0) {
            return null;
        }
        if (isMultipleChoice) {
            answers = Array.from(answers);
            var fullAnswerList = Array.from(document.querySelectorAll(".quiz-steps__options-container input"));
            var answersForEverything = fullAnswerList.filter(function(input) {
                return [
                    "",
                    "everything"
                ].includes(input.value.toLowerCase());
            });
            if (questionData.isFilterQuestion && answers.length === fullAnswerList.length - answersForEverything.length) {
                forceEverything = true;
            }
            if (questionData.isFilterQuestion && (answers[0].value === "" || answers[0].value === "everything")) {
                forceEverything = true;
            }
        }
        if (isMultipleChoice && !forceEverything) {
            answers = answers.map(function(answerItem) {
                return answerItem.value;
            });
        } else {
            if (questionData.isFilterQuestion && answers.value === "") {
                forceEverything = true;
            }
            answers = answers.value;
        }
        return forceEverything ? [
            "everything"
        ] : answers;
    };
    var toggleInfoModal = function() {
        setHelpTextOpen(!helpTextOpen);
        if (helpTextOpen) {
            scrollUnlock(true);
        } else {
            scrollLock(true);
        }
    };
    (0,react.useEffect)(function() {
        setTimeout(function() {
            if (messages1.length < messagesToPrint.length) {
                setMessages(messagesToPrint.slice(0, messages1.length + 1));
                if (messages1.length + 1 === messagesToPrint.length) {
                    setLoading(false);
                }
            }
        }, 2000);
    }, [
        messages1
    ]);
    (0,react.useEffect)(function() {
        setMessages([]);
        setLoading(true);
        var currentQuestionAnswers = quizData.answers.find(function(answer) {
            return (answer === null || answer === void 0 ? void 0 : answer.questionIndex) == parseInt(quizData.currentQuestion);
        });
        if (!isFollowUpQuestion) {
            setCurrentAnswers(currentQuestionAnswers);
        } else {
            setCurrentAnswers(null);
        }
    }, [
        quizData.currentQuestion
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "quiz-steps__container mb-10 flex h-full w-full flex-col overflow-y-auto bg-white lg:mb-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "quiz-steps__load-bar h-2 bg-light-blue",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "quiz-steps__load-bar__progress block h-full bg-quinary-1 transition-all duration-200",
                    style: {
                        width: "".concat((isFollowUpQuestion ? currentQuestionArrayIndex2 + 1.5 : currentQuestionArrayIndex2 + 1) / quizSettings.questions.length * 100, "%")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "quiz-steps__header mx-auto flex w-full max-w-2xl flex-col items-center py-3 px-5 lg:py-6",
                children: [
                    quizData.currentQuestion == 0 && !!quizSettings.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "quiz-steps__title mb-3.5 w-full text-h3-m lg:text-center lg:text-h3",
                        children: quizSettings.title
                    }),
                    quizData.currentQuestion == 0 && quizSettings.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown_Markdown, {
                        content: quizSettings.description,
                        className: "lg:text-center"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "quiz-steps__back-button w-full",
                        children: quizData.currentQuestion > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "flex items-center font-hafferBold",
                            onClick: function() {
                                navigateToPreviousQuestion();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* ArrowLeft */.X, {
                                    className: "leading-none"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-2 inline-block",
                                    children: "Back"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "quiz-steps__container mx-auto w-full max-w-2xl px-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "quiz-steps__body-content flex min-h-[540px] flex-col rounded-[20px] border border-grey-4 px-4 py-5 lg:px-12 lg:py-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-[80%]",
                            children: messages1.length > 0 && messages1.map(function(message, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-5 max-w-fit rounded-[20px] rounded-bl-none px-4 pt-3 pb-4 ".concat(quizSettings.textColor, " ").concat(quizSettings.bgColor),
                                    children: message
                                }, "message-".concat(quizData.questionIndex, "-").concat(index));
                            })
                        }),
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                            "aria-label": "Pick your hair answer below",
                            className: "quiz-steps__options-container mt-6 mb-6 mx-auto grid w-full max-w-3xl gap-x-6 gap-y-3 lg:gap-y-4\n              ".concat(questionData.optionsColumns, "\n            "),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                    className: "sr-only",
                                    children: "Question options"
                                }),
                                !loading && messages1.length === (messagesToPrint === null || messagesToPrint === void 0 ? void 0 : messagesToPrint.length) && (questionData === null || questionData === void 0 ? void 0 : (ref6 = questionData.options) === null || ref6 === void 0 ? void 0 : ref6.map(function(option, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizOption, {
                                        optionData: option,
                                        isMultipleChoice: isMultipleChoice,
                                        isFilter: questionData.isFilterQuestion,
                                        showOptionsImages: showOptionsImages,
                                        index: index,
                                        currentAnswers: currentAnswers
                                    }, option.label);
                                }))
                            ]
                        }),
                        !loading && messages1.length === (messagesToPrint === null || messagesToPrint === void 0 ? void 0 : messagesToPrint.length) && quizData.hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 block text-left font-hafferBold text-xs text-error",
                            children: isMultipleChoice ? "Please select any that apply" : "Please select one option"
                        }),
                        questionData.helpTitle && questionData.helpContent && !loading && messages1.length === (messagesToPrint === null || messagesToPrint === void 0 ? void 0 : messagesToPrint.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "quiz-questions__help-modal mt-8 w-full text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "focus-link mx-auto !font-primary !border-b-[1px]",
                                    onClick: toggleInfoModal,
                                    children: "need help?"
                                }),
                                helpTextOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "quiz-help-modal fixed top-0 left-0 z-[100001] flex h-full w-full items-center justify-center text-left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "quiz-help-modal__body h-auto max-h-[80%] max-w-xl overflow-y-auto bg-white px-5 py-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-right",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    label: "Close Info Modal",
                                                    onClick: toggleInfoModal,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "quiz-help-modal__header",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "mb-5 font-hafferBold text-lg lg:text-xl",
                                                    children: questionData.helpTitle
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "quiz-help-modal__content",
                                                children: questionData.helpContent.map(function(contentBlock, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mb-4 flex align-top",
                                                        children: [
                                                            contentBlock.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "mr-4 w-[75px] shrink-0",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                                    src: contentBlock.image.src,
                                                                    alt: contentBlock.image.alt,
                                                                    width: "75",
                                                                    height: "auto",
                                                                    className: "block"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown_Markdown, {
                                                                content: contentBlock.body,
                                                                className: "mb-[1rem]"
                                                            })
                                                        ]
                                                    }, "content-".concat(index));
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "quiz-questions_footer mt-auto w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "button button--primary mt-5 w-full",
                                onClick: function() {
                                    navigateToNextQuestion();
                                },
                                children: questionData.isFilterQuestion ? "get started!" : "continue"
                            })
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useKlaviyoApi.js
var useKlaviyoApi = __webpack_require__(33439);
;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizMailGate.jsx
function QuizMailGate_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function QuizMailGate_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                QuizMailGate_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                QuizMailGate_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function QuizMailGate_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function QuizMailGate_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            QuizMailGate_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









function QuizMailGate() {
    var form = (0,react.useRef)();
    var email = (0,react.useRef)();
    var context = useQuizContext();
    var quizSettings = context.quizSettings, quizData = context.quizData, updateQuizData = context.updateQuizData, parseQuizResultUrl = context.parseQuizResultUrl, getResultsProducts = context.getResultsProducts, buildSummaryResults = context.buildSummaryResults;
    var ref9 = (0,react.useState)([]), messages1 = ref9[0], setMessages = ref9[1];
    var ref1 = (0,react.useState)(function() {
        var ref, ref6;
        var messages = [];
        if (!!((ref = quizSettings.mailGateSettings) === null || ref === void 0 ? void 0 : ref.message1)) {
            var ref7;
            messages.push((ref7 = quizSettings.mailGateSettings) === null || ref7 === void 0 ? void 0 : ref7.message1);
        }
        if (!!((ref6 = quizSettings.mailGateSettings) === null || ref6 === void 0 ? void 0 : ref6.message2)) {
            var ref8;
            messages.push((ref8 = quizSettings.mailGateSettings) === null || ref8 === void 0 ? void 0 : ref8.message2);
        }
        return messages;
    }), messagesToPrint = ref1[0], setMessagesToPrint = ref1[1];
    var ref2 = (0,react.useState)(false), hasError = ref2[0], setHasError = ref2[1];
    var ref3 = (0,react.useState)(true), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,useKlaviyoApi/* useKlaviyoApi */.a)(), subscribeToList = ref4.subscribeToList, sendEvent = ref4.sendEvent;
    var resultProducts = getResultsProducts().filter(function(result) {
        return typeof result !== "undefined";
    });
    var ref5 = (0,dist.useProductsFromHandles)({
        version: "full",
        handles: resultProducts.map(function(productObject) {
            var ref;
            return productObject === null || productObject === void 0 ? void 0 : (ref = productObject.product) === null || ref === void 0 ? void 0 : ref.handle;
        })
    }), parsedProducts = ref5.products;
    if ((parsedProducts === null || parsedProducts === void 0 ? void 0 : parsedProducts.length) > 0) {
        resultProducts = resultProducts.map(function(resultObject) {
            var updatedProduct = parsedProducts.find(function(product) {
                var ref;
                return product.handle === (resultObject === null || resultObject === void 0 ? void 0 : (ref = resultObject.product) === null || ref === void 0 ? void 0 : ref.handle);
            });
            return QuizMailGate_objectSpread({}, resultObject, {
                product: updatedProduct || null
            });
        });
    }
    var quizSubscribe = function() {
        var _ref = QuizMailGate_asyncToGenerator(runtime_default().mark(function _callee(e) {
            var results, currentSearchParams, parsedResults, customerProperties;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        results = quizData.answers.filter(function(answer) {
                            return answer;
                        });
                        currentSearchParams = new URLSearchParams("step=results");
                        parsedResults = results.map(function(result) {
                            if (result) {
                                return "".concat(result.questionIndex, ":").concat(Array.isArray(result.answer) ? result.answer.join(",") : result.answer);
                            }
                        });
                        parsedResults.forEach(function(result) {
                            currentSearchParams.append("responses", result);
                        });
                        customerProperties = buildSummaryResults();
                        customerProperties = customerProperties.reduce(function(previousObject, currentObject) {
                            return Object.assign(previousObject, QuizMailGate_defineProperty({}, currentObject.label.toLowerCase().replaceAll(" ", "_"), currentObject.answer));
                        }, {});
                        _ctx.next = 9;
                        return subscribeToList({
                            listId: quizSettings.mailGateSettings.mailGateKlaviyoId,
                            email: document.querySelector('input[name="quiz-email"]').value,
                            source: "Quiz Mail Gate"
                        });
                    case 9:
                        _ctx.next = 11;
                        return sendEvent({
                            eventName: "Quiz Mail Gate Results",
                            metricName: "Quiz Save Results",
                            email: document.querySelector('input[name="quiz-email"]').value,
                            eventProperties: {
                                quizResultUrl: parseQuizResultUrl(),
                                products: resultProducts.map(function(resultObject) {
                                    var ref, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
                                    var customCollectionMetafield = resultObject === null || resultObject === void 0 ? void 0 : (ref = resultObject.product) === null || ref === void 0 ? void 0 : (ref10 = ref.metafields) === null || ref10 === void 0 ? void 0 : ref10.find(function(metafield) {
                                        return metafield.key === "custom_collection_title";
                                    });
                                    var customTitleMetafield = resultObject === null || resultObject === void 0 ? void 0 : (ref11 = resultObject.product) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.metafields) === null || ref12 === void 0 ? void 0 : ref12.find(function(metafield) {
                                        return metafield.key === "custom_product_title";
                                    });
                                    return {
                                        title: (customTitleMetafield === null || customTitleMetafield === void 0 ? void 0 : customTitleMetafield.value) || (resultObject === null || resultObject === void 0 ? void 0 : (ref13 = resultObject.product) === null || ref13 === void 0 ? void 0 : ref13.title),
                                        collection: (customCollectionMetafield === null || customCollectionMetafield === void 0 ? void 0 : customCollectionMetafield.value) || "",
                                        url: resultObject === null || resultObject === void 0 ? void 0 : (ref14 = resultObject.product) === null || ref14 === void 0 ? void 0 : ref14.onlineStoreUrl,
                                        image: resultObject === null || resultObject === void 0 ? void 0 : (ref15 = resultObject.product) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.featuredImage) === null || ref16 === void 0 ? void 0 : ref16.src,
                                        problem: resultObject === null || resultObject === void 0 ? void 0 : resultObject.resultMessage
                                    };
                                })
                            },
                            profileProperties: customerProperties
                        }).then(function(response) {
                            if (response.errors) {
                                setHasError(true);
                            } else {
                                updateQuizData({
                                    quizStep: "results"
                                });
                            }
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function quizSubscribe(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setTimeout(function() {
            if (messages1.length < messagesToPrint.length) {
                setMessages(messagesToPrint.slice(0, messages1.length + 1));
                if (messages1.length + 1 === messagesToPrint.length) {
                    setLoading(false);
                }
            }
        }, 2000);
    }, [
        messages1
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "quiz-mail-gate__container mx-auto w-full max-w-2xl px-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "quiz-steps__back-button w-full pt-3 lg:pt-6",
                    children: quizData.currentQuestion > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "flex items-center font-hafferBold",
                        onClick: function() {
                            updateQuizData({
                                quizStep: "steps",
                                hasError: false
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* ArrowLeft */.X, {
                                className: "leading-none"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-2 inline-block",
                                children: "Back"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "quiz-mail-gate__body-content mt-3 lg:mt-6 mb-10 flex min-h-[540px] flex-col rounded-[20px] border border-grey-4 px-4 py-5 lg:px-12 lg:py-8",
                    children: [
                        messages1.length > 0 && messages1.map(function(message, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-5 max-w-[80%] rounded-[20px] rounded-bl-none px-4 pt-3 pb-4 ".concat(quizSettings.textColor, " ").concat(quizSettings.bgColor),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown_Markdown, {
                                    content: message
                                })
                            }, "message-".concat(index));
                        }),
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {}),
                        !loading && messages1.length === messagesToPrint.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    className: "mail-gate__form",
                                    ref: form,
                                    id: "subscribeForm",
                                    onSubmit: quizSubscribe,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "email",
                                            name: "quiz-email",
                                            placeholder: "E-mail Address",
                                            label: "E-mail Address",
                                            ref: email,
                                            className: "border-grey-5 placeholder-black border w-full py-2 px-4",
                                            onChange: function() {
                                                if (hasError) {
                                                    setHasError(false);
                                                }
                                            }
                                        }),
                                        hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-error text-left",
                                            children: "There has been an error with your submission, please try again"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "quiz-mail-gate__footer mt-auto w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "mb-8 focus-link mx-auto !border-b-[1px] !font-primary",
                                                onClick: function() {
                                                    updateQuizData({
                                                        quizStep: "results"
                                                    });
                                                },
                                                children: quizSettings.mailGateSettings.mailGateCTAText
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "submit",
                                            className: "button button--primary w-full",
                                            form: "subscribeForm",
                                            children: quizSettings.mailGateSettings.mailGateSubmitText || "submit"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizProduct.jsx









function QuizProduct(props) {
    var ref, ref1, ref2;
    var productData = props.productData, index = props.index;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var ref3 = (0,react.useState)(false), added = ref3[0], setAdded = ref3[1];
    var product = (0,dist.useProductByHandle)({
        handle: productData.product.handle
    }).product;
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var currentVariant = product === null || product === void 0 ? void 0 : product.variants[0];
    var categoryTitle = metafieldMap.custom_collection_title;
    var categoryColor = (0,Metafields/* getMetafieldColor */.O)(metafieldMap);
    var customTitle = metafieldMap.custom_product_title || (product === null || product === void 0 ? void 0 : product.title);
    var bottomline = (0,hooks/* useYotpoProductBottomline */.zs)({
        legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId
    }).bottomline;
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    (0,react.useEffect)(function() {
        if (added) {
            if (isUs) {
                var datalayer = window.dataLayer || [];
                datalayer.push({
                    event: "quiz_atc_single_product"
                });
            }
            setTimeout(function() {
                setAdded(false);
            }, 3000);
        }
    }, [
        added
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "quiz-product flex flex-wrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "quiz-product__image w-1/3",
                children: (product === null || product === void 0 ? void 0 : (ref = product.featuredImage) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    src: product === null || product === void 0 ? void 0 : (ref1 = product.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.src,
                    alt: product === null || product === void 0 ? void 0 : (ref2 = product.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.altText,
                    width: 107,
                    height: 107,
                    loading: "lazy",
                    className: "block w-full"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "quiz-product__info w-2/3 pl-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat(categoryColor, " font-hafferBold text-xs"),
                        children: categoryTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                        className: "mb-1.5 font-tiempos text-sm",
                        children: [
                            " ",
                            customTitle,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YotpoStars/* YotpoStars */.M, {
                        rating: bottomline === null || bottomline === void 0 ? void 0 : bottomline.average_score
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "button button--checkout mt-3 w-full !text-xs",
                        onClick: function() {
                            cartAddItem({
                                merchandiseId: currentVariant.id,
                                quantity: 1,
                                attributes: [
                                    {
                                        key: "_sc",
                                        value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                                    }, 
                                ]
                            }).then(function() {
                                setAdded(true);
                            });
                        },
                        children: added == true ? "added" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "add to cart",
                                " ",
                                currentVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
                                    variant: currentVariant,
                                    className: "ml-2 inline-block !text-xs ",
                                    compareStyles: " !text-xs !text-white"
                                })
                            ]
                        })
                    })
                ]
            }),
            productData.resultMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-5 w-full text-xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "mb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: " Why this product? "
                        }),
                        " ",
                        productData.resultMessage,
                        " "
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/sections/QuizSection/Quiz.module.css
var Quiz_module = __webpack_require__(71915);
var Quiz_module_default = /*#__PURE__*/__webpack_require__.n(Quiz_module);
// EXTERNAL MODULE: ./src/snippets/icons/Info.jsx
var icons_Info = __webpack_require__(42004);
;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizResults.jsx
function QuizResults_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function QuizResults_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                QuizResults_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                QuizResults_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function QuizResults_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function QuizResults_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            QuizResults_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















function QuizResult() {
    var ref18, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var context = useQuizContext();
    var ref12 = useScrollLock(), scrollLock = ref12.scrollLock, scrollUnlock = ref12.scrollUnlock;
    var emailField = (0,react.useRef)(null);
    var ref13 = (0,react.useState)(false), summaryOpen = ref13[0], setSummaryOpen = ref13[1];
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var isMobile = vpWidth < 767;
    var cartAddItems = (0,dist.useCartAddItems)().cartAddItems;
    var ref14 = (0,react.useState)(false), saveResultsModalOpen = ref14[0], setSaveResultsModalOpen = ref14[1];
    var sendEvent = (0,useKlaviyoApi/* useKlaviyoApi */.a)().sendEvent;
    var ref15 = (0,react.useState)(""), saveResultsMessage = ref15[0], setSaveResultsMessage = ref15[1];
    var ref16 = (0,react.useState)(false), saveResultError = ref16[0], setSaveResultError = ref16[1];
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var quizSettings = context.quizSettings, quizData = context.quizData, updateQuizData = context.updateQuizData, getResultsProducts = context.getResultsProducts, parseQuizResultUrl = context.parseQuizResultUrl, buildSummaryResults = context.buildSummaryResults;
    var toggleResultSummary = function() {
        setSummaryOpen(!summaryOpen);
    };
    var addAllProductsToCart = function() {
        var _ref = QuizResults_asyncToGenerator(runtime_default().mark(function _callee() {
            var itemsToAdd;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        itemsToAdd = parsedProducts.map(function(product) {
                            return {
                                merchandiseId: product.variants[0].id,
                                quantity: 1,
                                attributes: [
                                    {
                                        key: "_sc",
                                        value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                                    }
                                ]
                            };
                        });
                        cartAddItems(itemsToAdd).then(function(cart) {
                            if (isUs) {
                                var dataLayer = window.dataLayer || [];
                                dataLayer.push({
                                    event: "quiz_atc_all_products",
                                    addedProducts: JSON.stringify(parsedProducts.map(function(product) {
                                        return {
                                            title: product.title,
                                            currency: "USD",
                                            price: product.variants[0].price
                                        };
                                    }))
                                });
                            }
                            window.dispatchEvent(new CustomEvent("openSideCart"));
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addAllProductsToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var resultProducts = getResultsProducts();
    var ref17 = (0,dist.useProductsFromHandles)({
        version: "full",
        handles: resultProducts.map(function(productObject) {
            var ref;
            return productObject === null || productObject === void 0 ? void 0 : (ref = productObject.product) === null || ref === void 0 ? void 0 : ref.handle;
        })
    }), parsedProducts = ref17.products;
    var dailyProducts = resultProducts.filter(function(productObject) {
        return (productObject === null || productObject === void 0 ? void 0 : productObject.routine) == "daily";
    });
    var specializedProducts = resultProducts.filter(function(productObject) {
        return (productObject === null || productObject === void 0 ? void 0 : productObject.routine) == "specialized";
    });
    var summaryResults = buildSummaryResults();
    var summaryPopup = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "quiz-result__summary-content absolute left-1/2 -mt-[1.5em] w-[348px] max-w-full -translate-x-1/2 translate-y-[2em] border border-grey-9 bg-white py-4 px-5 text-left lg:top-0 lg:mt-0 md:max-w-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute top-[-1px] left-1/2 hidden h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rotate-45 border-t border-l border-grey-9 bg-white md:block"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "block pr-5 font-hafferBold text-xs leading-normal",
                children: "Your quiz selections:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                onClick: toggleResultSummary,
                className: "absolute top-5 right-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sr-only",
                        children: "Close summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {
                        className: "h-2.5 w-2.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                className: "my-2 list-inside pl-0 text-xs",
                children: summaryResults.map(function(result, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "leading-relaxed m-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    result.label,
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-hafferBold ml-1",
                                children: result.answer
                            })
                        ]
                    }, "result-".concat(index));
                })
            })
        ]
    });
    var toggleSaveResultsModal = function() {
        setSaveResultsModalOpen(function(isOpen) {
            if (isOpen) {
                scrollUnlock();
                return false;
            } else {
                setSaveResultsMessage("");
                scrollLock();
                return true;
            }
        });
    };
    var sendResultsToEmail = function(e) {
        e.preventDefault();
        var email = emailField.current.value;
        var customerProperties = buildSummaryResults();
        customerProperties = customerProperties.reduce(function(previousObject, currentObject) {
            return Object.assign(previousObject, QuizResults_defineProperty({}, currentObject.label.toLowerCase().replaceAll(" ", "_"), currentObject.answer));
        }, {});
        if (email == "") {
            return;
        }
        var parsedResultProducts = resultProducts.filter(function(result) {
            return typeof result !== "undefined";
        }).map(function(resultObject) {
            var updatedProduct = parsedProducts.find(function(product) {
                return product.handle === resultObject.product.handle;
            });
            return QuizResults_objectSpread({}, resultObject, {
                product: updatedProduct
            });
        });
        sendEvent({
            email: email,
            eventName: "Quiz Save Results",
            metricName: "Quiz Save Results",
            eventProperties: {
                quizResultUrl: parseQuizResultUrl(),
                products: parsedResultProducts.map(function(resultObject) {
                    var ref, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
                    var customCollectionMetafield = resultObject === null || resultObject === void 0 ? void 0 : (ref = resultObject.product) === null || ref === void 0 ? void 0 : (ref19 = ref.metafields) === null || ref19 === void 0 ? void 0 : ref19.find(function(metafield) {
                        return metafield.key === "custom_collection_title";
                    });
                    var customTitleMetafield = resultObject === null || resultObject === void 0 ? void 0 : (ref20 = resultObject.product) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.metafields) === null || ref21 === void 0 ? void 0 : ref21.find(function(metafield) {
                        return metafield.key === "custom_product_title";
                    });
                    return {
                        title: (customTitleMetafield === null || customTitleMetafield === void 0 ? void 0 : customTitleMetafield.value) || (resultObject === null || resultObject === void 0 ? void 0 : (ref22 = resultObject.product) === null || ref22 === void 0 ? void 0 : ref22.title),
                        collection: (customCollectionMetafield === null || customCollectionMetafield === void 0 ? void 0 : customCollectionMetafield.value) || "",
                        url: resultObject === null || resultObject === void 0 ? void 0 : (ref23 = resultObject.product) === null || ref23 === void 0 ? void 0 : ref23.onlineStoreUrl,
                        image: resultObject === null || resultObject === void 0 ? void 0 : (ref24 = resultObject.product) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.featuredImage) === null || ref25 === void 0 ? void 0 : ref25.src,
                        problem: resultObject === null || resultObject === void 0 ? void 0 : resultObject.resultMessage
                    };
                })
            },
            profileProperties: customerProperties,
            callback: function(response) {
                if (typeof response == "string") {
                    setSaveResultsMessage("Your results have been saved!");
                } else {
                    setSaveResultsMessage(response.errors[0].detail);
                    setSaveResultError(true);
                }
            }
        });
    };
    (0,react.useEffect)(function() {
        updateQuizData(QuizResults_objectSpread({}, quizData, {
            sentAnaliticsEvent: true
        }));
        if (!quizData.loadedFromUrl) {
            if (true) {
                history.replaceState("", null, "".concat(document.location.protocol, "//").concat(parseQuizResultUrl()));
            }
            var answersMap = quizData.answers.map(function(answer) {
                return "".concat(answer.questionIndex, ":").concat(Array.isArray(answer.answer) ? answer.answer.join(",") : answer.answer);
            });
            var datalayer = window.dataLayer || [];
            datalayer.push({
                "event": "Quiz - View Results",
                "Quiz Question Data": answersMap.join("|")
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "quiz-result__header mx-auto w-[720px] max-w-full px-5 pt-[78px] pb-[60px] text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "h4 mb-5 font-tiempos",
                        children: [
                            " ",
                            quizSettings.resultTitle,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            quizSettings.resultDescription,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "quiz-result__info-container relative inline-block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        onClick: toggleResultSummary,
                                        className: "ml-1 align-middle",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "sr-only",
                                                children: "Open summary"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Info/* Info */.k, {
                                                className: "h-5 w-5"
                                            }),
                                            summaryOpen && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "absolute left-1/2 -bottom-1/2 z-20 mb-[-1px] h-2.5 w-2.5 -translate-x-1/2 rotate-45 border-t border-l border-grey-9 bg-white"
                                            })
                                        ]
                                    }),
                                    summaryOpen && !isMobile && summaryPopup
                                ]
                            }),
                            summaryOpen && isMobile && summaryPopup
                        ]
                    }),
                    quizSettings.addAllTop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center mt-5 lg:mt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "quiz-result__add-all-products-btn button button--primary",
                            onClick: addAllProductsToCart,
                            children: quizSettings.addAllLabel
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "quiz-result__body-content bg-grey-9 py-12",
                children: [
                    dailyProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "quiz-result__daily-routine-group lg-px-0 mx-auto w-[720px] max-w-full border-[#979797] px-5 ".concat(dailyProducts.length && specializedProducts.length && "lg:border-b", " "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "quiz-result__daily-routine-header text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "quiz-result__routine-title h3 mb-2",
                                        children: quizSettings.baseRoutineTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown_Markdown, {
                                        content: quizSettings.baseRoutineDescription
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "quiz-result__product-grid flex flex-wrap mt-6 lg:px-0 ".concat(dailyProducts.length % 2 !== 0 && (Quiz_module_default())["quiz-result__product-grid--odd"]),
                                children: dailyProducts.map(function(productData, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grid-item mb-6 w-full border-t border-[#979797] pt-7 first:border-t-0 lg:w-6/12 lg:border-t-0 lg:border-none lg:pt-0 lg:odd:pr-10 lg:even:pl-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizProduct, {
                                            productData: productData,
                                            index: index
                                        }, productData.product.id)
                                    });
                                })
                            })
                        ]
                    }),
                    specializedProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "quiz-result__specialized-routine-group lg-px-0 mx-auto mt-12 w-[720px] max-w-full px-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "quiz-result__daily-routine-header text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "quiz-result__routine-title h3 mb-2",
                                        children: quizSettings.specializedRoutineTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown_Markdown, {
                                        content: quizSettings.specializedRoutineDescription
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "quiz-result__product-grid flex flex-wrap mt-6 lg:px-0 ".concat(specializedProducts.length % 2 !== 0 && (Quiz_module_default())["quiz-result__product-grid--odd"]),
                                children: specializedProducts.map(function(productData, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grid-item mb-6 w-full border-t border-[#979797] pt-7 first:border-t-0 lg:w-6/12 lg:border-t-0 lg:border-none lg:pt-0 lg:odd:pr-10 lg:even:pl-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizProduct, {
                                            productData: productData,
                                            index: index
                                        }, productData.product.id)
                                    });
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "quiz-result__cta-container my-14 px-4 text-center",
                children: [
                    !quizSettings.addAllTop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mx-auto max-w-lg",
                                children: "Want it all? Add your entire customized routine to cart!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "quiz-result__add-all-products-btn button button--primary",
                                    onClick: addAllProductsToCart,
                                    children: quizSettings.addAllLabel
                                })
                            })
                        ]
                    }),
                    quizSettings.enableSaveResults && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            !quizSettings.addAllTop && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "my-2 block",
                                children: "or"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "quiz-result__save-results-btn button button--checkout",
                                    onClick: toggleSaveResultsModal,
                                    children: quizSettings.saveResultsLabel
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "focus-link mx-auto !font-primary !border-b-[1px]",
                            onClick: function() {
                                history.replaceState(null, "", window.location.pathname);
                                updateQuizData({
                                    quizStep: "steps",
                                    currentQuestion: 0,
                                    answers: [],
                                    isFiltered: false,
                                    hasError: false
                                });
                            },
                            children: "retake the quiz"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "quiz-result__banner container relative my-14 mx-auto lg:px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "quiz-result__banner-image",
                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: (ref18 = quizSettings.bannerImageMobile) === null || ref18 === void 0 ? void 0 : ref18.src,
                            alt: (ref1 = quizSettings.bannerImageMobile) === null || ref1 === void 0 ? void 0 : ref1.alt,
                            width: (ref2 = quizSettings.bannerImageMobile) === null || ref2 === void 0 ? void 0 : ref2.width,
                            height: (ref3 = quizSettings.bannerImageMobile) === null || ref3 === void 0 ? void 0 : ref3.height,
                            className: "w-full"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: (ref4 = quizSettings.bannerImageDesktop) === null || ref4 === void 0 ? void 0 : ref4.src,
                            alt: (ref5 = quizSettings.bannerImageDesktop) === null || ref5 === void 0 ? void 0 : ref5.alt,
                            width: (ref6 = quizSettings.bannerImageDesktop) === null || ref6 === void 0 ? void 0 : ref6.width,
                            height: (ref7 = quizSettings.bannerImageDesktop) === null || ref7 === void 0 ? void 0 : ref7.height,
                            className: "w-full"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "quiz-result__banner-info top-1/2 mt-8 px-5 text-center lg:absolute lg:ml-20 lg:mt-0 lg:max-w-[344px] lg:-translate-y-1/2 lg:px-0 lg:text-left ".concat(quizSettings.desktopBannerLightText ? "lg:text-white" : "text-black"),
                        children: [
                            quizSettings.resultBannerTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mb-0 text-h3-m lg:text-h2",
                                children: quizSettings.resultBannerTitle
                            }),
                            quizSettings.resultBannerBody && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown_Markdown, {
                                content: quizSettings.resultBannerBody,
                                className: "mt-5 last:mb-0 lg:mt-8"
                            }),
                            ((ref8 = quizSettings.resultBannerLink) === null || ref8 === void 0 ? void 0 : ref8.url) && ((ref9 = quizSettings.resultBannerLink) === null || ref9 === void 0 ? void 0 : ref9.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (ref10 = quizSettings.resultBannerLink) === null || ref10 === void 0 ? void 0 : ref10.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "button button--secondary mt-5 inline-block no-underline lg:mt-8 ".concat(quizSettings.desktopBannerLightText && "lg:!border-white lg:!text-white lg:hover:!bg-white lg:hover:!text-black"),
                                    target: quizSettings.resultBannerLink.newTab ? "_blank" : "_self",
                                    children: (ref11 = quizSettings.resultBannerLink) === null || ref11 === void 0 ? void 0 : ref11.text
                                })
                            })
                        ]
                    })
                ]
            }),
            quizSettings.enableSaveResults && saveResultsModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "save-results-modal fixed top-0 z-[100001] flex h-full w-full items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "quiz-help-modal__body h-auto max-h-[80%] max-w-xl overflow-y-auto bg-white px-5 py-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full text-right",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                label: "Close Info Modal",
                                onClick: toggleSaveResultsModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "h5 mb-5 text-center font-tiempos",
                            children: "Save Your Results"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Introduce your email to get your results straight to your inbox!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            action: "#",
                            onSubmit: sendResultsToEmail,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "email",
                                    name: "save-results-email",
                                    placeholder: "E-mail Address",
                                    label: "E-mail Address",
                                    className: "w-full border border-grey-5 py-2 px-4 placeholder-black",
                                    ref: emailField,
                                    onChange: function() {
                                        setSaveResultsMessage("");
                                    }
                                }),
                                saveResultsMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-2 text-left text-sm mb-0 ".concat(saveResultError ? "text-error" : "text-success"),
                                    children: saveResultsMessage
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: "button button--primary mt-5 w-full",
                                    children: "Submit"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/QuizSection/Quiz.jsx
function Quiz_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Quiz_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Quiz_arrayLikeToArray(arr);
}
function Quiz_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Quiz_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Quiz_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Quiz_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Quiz_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Quiz_toConsumableArray(arr) {
    return Quiz_arrayWithoutHoles(arr) || Quiz_iterableToArray(arr) || Quiz_unsupportedIterableToArray(arr) || Quiz_nonIterableSpread();
}
function Quiz_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Quiz_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Quiz_arrayLikeToArray(o, minLen);
}






function QuizSection(param) {
    var cms = param.cms;
    var ref9, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var sectionRef = (0,react.useRef)();
    var ref8 = (0,react.useState)({
        quizStep: "steps",
        currentQuestion: 0,
        answers: [],
        filter: "",
        hasError: false,
        isFiltered: false,
        filteredQuestions: []
    }), quizData = ref8[0], setQuizData = ref8[1];
    var filterQuestionData = {
        message1: cms === null || cms === void 0 ? void 0 : (ref9 = cms.filterSettings) === null || ref9 === void 0 ? void 0 : ref9.filterQuestionMessage1,
        message2: cms === null || cms === void 0 ? void 0 : (ref1 = cms.filterSettings) === null || ref1 === void 0 ? void 0 : ref1.filterQuestionMessage2,
        isMultipleChoice: cms === null || cms === void 0 ? void 0 : (ref2 = cms.filterSettings) === null || ref2 === void 0 ? void 0 : ref2.isMultipleChoice,
        showOptionsImages: cms === null || cms === void 0 ? void 0 : (ref3 = cms.filterSettings) === null || ref3 === void 0 ? void 0 : ref3.showOptionsImages,
        optionsColumns: cms === null || cms === void 0 ? void 0 : (ref4 = cms.filterSettings) === null || ref4 === void 0 ? void 0 : ref4.optionsColumns,
        options: cms === null || cms === void 0 ? void 0 : (ref5 = cms.filterSettings) === null || ref5 === void 0 ? void 0 : ref5.filterOptions,
        helpTitle: cms === null || cms === void 0 ? void 0 : (ref6 = cms.filterSettings) === null || ref6 === void 0 ? void 0 : ref6.filterHelpTitle,
        helpContent: cms === null || cms === void 0 ? void 0 : (ref7 = cms.filterSettings) === null || ref7 === void 0 ? void 0 : ref7.filterHelpContent,
        isFilterQuestion: true
    };
    var hasFilterQuestion = !!filterQuestionData.message1 && filterQuestionData.options.length > 0;
    var questionList = hasFilterQuestion ? [
        filterQuestionData
    ].concat(Quiz_toConsumableArray(cms.questions)) : cms.questions;
    var quizSettings = {
        title: cms.title,
        description: cms.description,
        questions: questionList.map(function(question, index) {
            return Quiz_objectSpread({}, question, {
                index: index
            });
        }),
        mailGateSettings: cms.mailGate,
        resultTitle: cms.resultTitle,
        resultDescription: cms.resultDescription,
        baseRoutineTitle: cms.baseRoutineTitle,
        baseRoutineDescription: cms.baseRoutineDescription,
        specializedRoutineTitle: cms.specializedRoutineTitle,
        specializedRoutineDescription: cms.specializedRoutineDescription,
        addAllTop: cms.addAllTop,
        addAllLabel: cms.addAllLabel,
        enableSaveResults: cms.enableSaveResults,
        saveResultsLabel: cms.saveResultsLabel,
        resultBannerTitle: cms.resultBannerTitle,
        resultBannerBody: cms.resultBannerBody,
        desktopBannerLightText: cms.desktopBannerLightText,
        resultBannerLink: cms.resultBannerLink,
        bannerImageDesktop: cms.bannerImageDesktop,
        bannerImageMobile: cms.bannerImageMobile,
        textColor: cms.textColor || "text-white",
        bgColor: cms.bgColor || "bg-primary-2"
    };
    var updateQuizData = function(newData) {
        setQuizData(Quiz_objectSpread({}, quizData, newData));
    };
    var getResultsProducts = function() {
        var ref12;
        var products = [];
        quizData === null || quizData === void 0 ? void 0 : (ref12 = quizData.answers) === null || ref12 === void 0 ? void 0 : ref12.forEach(function(answer) {
            if (!answer) {
                return;
            }
            ;
            var question1 = quizSettings.questions.find(function(question) {
                return question.index === answer.questionIndex;
            });
            // Multiple answers question
            if (Array.isArray(answer.answer)) {
                var resultProductList = [];
                var selectedOptions = question1.options.filter(function(option, index) {
                    return answer.answer.includes(String(index));
                });
                selectedOptions.forEach(function(option) {
                    var ref;
                    (ref = option.productList) === null || ref === void 0 ? void 0 : ref.forEach(function(productObject) {
                        if (!productObject.product) {
                            return;
                        }
                        resultProductList.push({
                            product: productObject.product,
                            routine: productObject.routineType,
                            resultMessage: productObject.resultMessage
                        });
                    });
                });
                products = Quiz_toConsumableArray(products).concat(Quiz_toConsumableArray(resultProductList));
            } else {
                // Single answer question
                if (answer.answer.indexOf("-") > -1) {
                    var ref13, ref10;
                    // Question with follow up question
                    var mainOption = question1.options[Number.parseInt(answer.answer.split("-")[0])];
                    var followUpOption = question1.options[Number.parseInt(answer.answer.split("-")[0])].followUpOptions[Number.parseInt(answer.answer.split("-")[1])];
                    var mainOptionProducts = mainOption === null || mainOption === void 0 ? void 0 : (ref13 = mainOption.productList) === null || ref13 === void 0 ? void 0 : ref13.map(function(productObject) {
                        if (!!productObject.product) {
                            return {
                                product: productObject.product,
                                routine: productObject.routineType,
                                resultMessage: productObject.resultMessage
                            };
                        }
                    });
                    var followUpOptionProducts = followUpOption === null || followUpOption === void 0 ? void 0 : (ref10 = followUpOption.productList) === null || ref10 === void 0 ? void 0 : ref10.map(function(productObject) {
                        if (!!productObject.product) {
                            return {
                                product: productObject.product,
                                routine: productObject.routineType,
                                resultMessage: productObject.resultMessage
                            };
                        }
                    });
                    if (mainOptionProducts) {
                        products = Quiz_toConsumableArray(products).concat(Quiz_toConsumableArray(mainOptionProducts));
                    }
                    if (followUpOptionProducts) {
                        products = Quiz_toConsumableArray(products).concat(Quiz_toConsumableArray(followUpOptionProducts));
                    }
                } else {
                    var ref11;
                    // Question without follow up question
                    var option1 = question1.options.find(function(option, index) {
                        return String(index) === answer.answer;
                    });
                    var optionProducts = option1 === null || option1 === void 0 ? void 0 : (ref11 = option1.productList) === null || ref11 === void 0 ? void 0 : ref11.map(function(productObject) {
                        if (!!productObject.product) {
                            return {
                                product: productObject.product,
                                routine: productObject.routineType,
                                resultMessage: productObject.resultMessage
                            };
                        }
                    });
                    if (option1 && optionProducts) {
                        products = Quiz_toConsumableArray(products).concat(Quiz_toConsumableArray(optionProducts));
                    }
                }
            }
        });
        return products;
    };
    var parseQuizResultUrl = function() {
        var results = quizData.answers.filter(function(answer) {
            return answer;
        });
        var currentSearchParams = new URLSearchParams("step=results");
        var parsedResults = results.map(function(result) {
            if (result) {
                return "".concat(result.questionIndex, ":").concat(Array.isArray(result.answer) ? result.answer.join(",") : result.answer);
            }
        });
        parsedResults.forEach(function(result) {
            currentSearchParams.append("responses", result);
        });
        return "".concat(document.location.host).concat(document.location.pathname, "?").concat(currentSearchParams.toString());
    };
    var buildSummaryResults = function() {
        var resultsArray = [];
        quizData.answers.forEach(function(answerItem) {
            if (!answerItem) {
                return;
            }
            var currentQuestion = quizSettings.questions.find(function(question) {
                return question.index === answerItem.questionIndex;
            });
            if ((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.isFilterQuestion) == true) {
                return;
            }
            var answer = null;
            if (answerItem.answer.indexOf("-") > -1) {
                var mainQuestionAnswer = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.options[answerItem.answer.split("-")[0]].label;
                var followUpQuestionAnswer = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.options[answerItem.answer.split("-")[0]].followUpOptions[answerItem.answer.split("-")[1]].label;
                answer = mainQuestionAnswer + " " + followUpQuestionAnswer;
            } else {
                var ref15;
                answer = Array.isArray(answerItem.answer) ? answerItem.answer.map(function(index) {
                    var ref, ref14;
                    return currentQuestion === null || currentQuestion === void 0 ? void 0 : (ref = currentQuestion.options) === null || ref === void 0 ? void 0 : (ref14 = ref[index]) === null || ref14 === void 0 ? void 0 : ref14.label;
                }).join(", ") : (ref15 = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.options[answerItem.answer]) === null || ref15 === void 0 ? void 0 : ref15.label;
            }
            resultsArray.push({
                label: currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.summaryLabel,
                answer: answer
            });
        });
        return resultsArray;
    };
    (0,react.useEffect)(function() {
        if (quizData.filter == "") {
            updateQuizData({
                isFiltered: false,
                filteredQuestions: quizSettings.questions
            });
        } else {
            var filteredQuestions = quizSettings.questions.filter(function(question) {
                return question.isFilterQuestion || quizData.filter.includes(question.category);
            });
            updateQuizData({
                isFiltered: true,
                filteredQuestions: filteredQuestions
            });
        }
        if (true) {
            var urlParams = new URLSearchParams(window.location.search);
            var step = urlParams.get("step");
            var answers = urlParams.getAll("responses").map(function(answer) {
                var answerPieces = answer.split(":");
                return {
                    questionIndex: Number.parseInt(answerPieces[0]),
                    answer: answerPieces[1].indexOf(",") > -1 ? answerPieces[1].split(",") : answerPieces[1]
                };
            });
            if (typeof step != "undefined" && answers.length > 0) {
                updateQuizData({
                    quizStep: step,
                    answers: answers,
                    loadedFromUrl: true
                });
            }
        }
    }, [
        quizData.filter
    ]);
    (0,react.useEffect)(function() {
        window.scrollTo({
            top: 0
        });
    }, [
        quizData.currentQuestion,
        quizData.quizStep
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizContext.Provider, {
        value: {
            quizData: quizData,
            updateQuizData: updateQuizData,
            quizSettings: quizSettings,
            getResultsProducts: getResultsProducts,
            parseQuizResultUrl: parseQuizResultUrl,
            buildSummaryResults: buildSummaryResults
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            ref: sectionRef,
            className: "quizContainer",
            children: [
                quizData.quizStep == "steps" && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizQuestions, {}),
                quizData.quizStep == "mailGate" && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizMailGate, {}),
                quizData.quizStep == "results" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizResult, {})
                })
            ]
        })
    });
}
QuizSection.displayName = "Quiz Section";
QuizSection.Schema = {
    category: "Modules",
    label: QuizSection.displayName,
    key: "quizSection",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "text",
            name: "title",
            label: "Title",
            defaultValue: "Let's find your perfect match!"
        },
        {
            component: "markdown",
            name: "description",
            label: "Description",
            defaultValue: "Chat with our virtual hair expert to find the perfect products for you!"
        },
        {
            component: "select",
            name: "bgColor",
            label: "Background Color",
            description: "For section background color, select one from preselected brand colors.",
            options: [
                {
                    label: "Black",
                    value: "bg-black"
                },
                {
                    label: "White",
                    value: "bg-white"
                },
                {
                    label: "Grey",
                    value: "bg-grey-1"
                },
                {
                    label: "Light Grey",
                    value: "bg-grey-9"
                },
                {
                    label: "Pink 1",
                    value: "bg-primary-2"
                },
                {
                    label: "Scalp Blue",
                    value: "bg-scalp-blue"
                },
                {
                    label: "Blue 1",
                    value: "bg-quinary-1"
                },
                {
                    label: "Blue 2",
                    value: "bg-quinary-2"
                },
                {
                    label: "Blue 3",
                    value: "bg-light-blue"
                },
                {
                    label: "Cream 1",
                    value: "bg-tertiary-2"
                },
                {
                    label: "Cream 2",
                    value: "bg-senary-4"
                },
                {
                    label: "Purple",
                    value: "bg-tertiary-1"
                },
                {
                    label: "Green",
                    value: "bg-quaternary-1"
                },
                {
                    label: "Pink 2",
                    value: "bg-secondary-1"
                },
                {
                    label: "Yellow",
                    value: "bg-yellow"
                },
                {
                    label: "Orange",
                    value: "bg-secondary-2"
                },
                {
                    label: "Seafoam 1",
                    value: "bg-quaternary-2"
                },
                {
                    label: "Seafoam 2",
                    value: "bg-senary-3"
                },
                {
                    label: "Seafoam 3",
                    value: "bg-senary-5"
                },
                {
                    label: "Air Dry Cream",
                    value: "bg-stylers-1"
                },
                {
                    label: "Sculpting Cream",
                    value: "bg-stylers-2"
                },
                {
                    label: "Texture Foam",
                    value: "bg-stylers-3"
                },
                {
                    label: "Sleek Stick",
                    value: "bg-stylers-4"
                },
                {
                    label: "Magenta",
                    value: "bg-magenta"
                },
                {
                    label: "Medium Pink",
                    value: "bg-med-pink"
                },
                {
                    label: "Briogeo Blue",
                    value: "bg-brio-blue"
                },
                {
                    label: "Cloud",
                    value: "bg-cloud"
                },
                {
                    label: "Mineral",
                    value: "bg-mineral"
                },
                {
                    label: "Deep Sea",
                    value: "bg-deep-sea"
                },
                {
                    label: "Sandstone",
                    value: "bg-sandstone"
                },
                {
                    label: "Sorrel",
                    value: "bg-sorrel"
                },
                {
                    label: "Butter",
                    value: "bg-butter"
                },
                {
                    label: "Rosehip",
                    value: "bg-rosehip"
                },
                {
                    label: "Chestnut",
                    value: "bg-chestnut"
                }, 
            ],
            defaultValue: "bg-primary-2"
        },
        {
            component: "select",
            name: "textColor",
            label: "Text Color",
            options: [
                {
                    label: "Light",
                    value: "text-white"
                },
                {
                    label: "Dark",
                    value: "text-black"
                }, 
            ],
            defaultValue: "text-white"
        },
        {
            component: "group",
            name: "filterSettings",
            label: "Filter Question Settings",
            fields: [
                {
                    component: "textarea",
                    name: "filterQuestionMessage1",
                    label: "Filter Question Message 1",
                    description: "Message to be shown as the intro for the filter question"
                },
                {
                    component: "textarea",
                    name: "filterQuestionMessage2",
                    label: "Filter Question Message 2",
                    description: "Message to be shown as the follow up for the filter question"
                },
                {
                    component: "toggle",
                    name: "isMultipleChoice",
                    label: "Is Multiple Choice?",
                    toggleLabels: {
                        true: "Yes",
                        false: "No"
                    },
                    defaultValue: false
                },
                {
                    component: "toggle",
                    name: "showOptionsImages",
                    label: "Show Options Images?",
                    toggleLabels: {
                        true: "Yes",
                        false: "No"
                    },
                    defaultValue: false
                },
                {
                    component: "select",
                    name: "optionsColumns",
                    label: "Options Columns",
                    options: [
                        {
                            label: "1 Column",
                            value: "grid-cols-1"
                        },
                        {
                            label: "2 Columns",
                            value: "grid-cols-2"
                        }, 
                    ]
                },
                {
                    component: "text",
                    name: "filterHelpTitle",
                    label: "Help Modal Title"
                },
                {
                    component: "group-list",
                    name: "filterHelpContent",
                    label: "Help Modal content",
                    fields: [
                        {
                            component: "image",
                            name: "image",
                            label: "Image",
                            description: "Optional, recomended image size: 180px x 180px"
                        },
                        {
                            component: "markdown",
                            name: "body",
                            label: "Body content",
                            description: "Required, content to be displayed in the modal"
                        }, 
                    ]
                },
                {
                    component: "group-list",
                    name: "filterOptions",
                    label: "Filter Options",
                    itemProps: {
                        label: "{{item.label}}"
                    },
                    fields: [
                        {
                            component: "text",
                            name: "label",
                            label: "Option Label",
                            description: "Label the customer will see on the option button"
                        },
                        {
                            component: "text",
                            name: "value",
                            label: "Option Value",
                            description: "Value used to filter the questions, this value should match exactly with the reference attribute added to the questions below, if empty this will force all the questions set below to be shown with no filters, also all other selected options will be disabled so this doesn't mix up with other filters"
                        },
                        {
                            component: "image",
                            name: "image",
                            label: "Option Image",
                            description: "Image displayed next to the option, only used if the filter question is set as an image question"
                        }, 
                    ]
                }, 
            ]
        },
        {
            component: "group-list",
            name: "questions",
            label: "Questions",
            itemProps: {
                label: "{{item.summaryLabel}}"
            },
            fields: [
                {
                    component: "text",
                    name: "category",
                    label: "Category",
                    description: "Value to be used when filtering the customer flow by the first question"
                },
                {
                    component: "textarea",
                    name: "message1",
                    label: "Message 1",
                    description: "Text to be shown before the question"
                },
                {
                    component: "textarea",
                    name: "message2",
                    label: "Message 2",
                    description: "Text to be shown before the question"
                },
                {
                    component: "text",
                    name: "summaryLabel",
                    label: "Summary Label",
                    description: "Label to be displayed on the results page pop up that summarizes the selected options"
                },
                {
                    component: "toggle",
                    name: "isMultipleChoice",
                    label: "Is Multiple Choice?",
                    toggleLabels: {
                        true: "Yes",
                        false: "No"
                    },
                    defaultValue: false
                },
                {
                    component: "toggle",
                    name: "showOptionsImages",
                    label: "Show Options Images?",
                    toggleLabels: {
                        true: "Yes",
                        false: "No"
                    },
                    defaultValue: false
                },
                {
                    component: "select",
                    name: "optionsColumns",
                    label: "Options Columns",
                    options: [
                        {
                            label: "1 Column",
                            value: "grid-cols-1"
                        },
                        {
                            label: "2 Columns",
                            value: "grid-cols-2"
                        }, 
                    ]
                },
                {
                    component: "group-list",
                    name: "options",
                    label: "Options",
                    itemProps: {
                        label: "{{item.label}}"
                    },
                    fields: [
                        {
                            component: "text",
                            name: "label",
                            label: "Option Label"
                        },
                        {
                            component: "image",
                            name: "image",
                            label: "Option Image",
                            description: "(Optional, used only if the option is set to show images), recommended image size: 180px x 180px"
                        },
                        {
                            component: "group-list",
                            name: "productList",
                            label: "Products",
                            itemProps: {
                                label: "{{item.product.data.title}}"
                            },
                            fields: [
                                {
                                    component: "select",
                                    name: "routineType",
                                    label: "Routine Type",
                                    options: [
                                        {
                                            label: "Daily",
                                            value: "daily"
                                        },
                                        {
                                            label: "Specialized",
                                            value: "specialized"
                                        }, 
                                    ],
                                    defaultValue: "daily"
                                },
                                {
                                    component: "productSearch",
                                    name: "product",
                                    label: "Product"
                                },
                                {
                                    component: "textarea",
                                    name: "resultMessage",
                                    label: "Result Message",
                                    description: "Message to be shown next to the product after the customer completes the quiz"
                                }, 
                            ]
                        },
                        {
                            component: "textarea",
                            name: "answerMessage",
                            label: "Answer Message",
                            description: "Message to be shown after the customer selects the option"
                        },
                        {
                            component: "toggle",
                            name: "hasFollowUpQuestion",
                            label: "Has Follow Up Question?",
                            description: "(This option doesn't work with multi option question) If enabled, a follow up question will be shown after the customer selects this option, if a product hs been selected for this option it will be disregarded"
                        },
                        {
                            component: "select",
                            name: "followUpOptionsColumns",
                            label: "Options Columns",
                            options: [
                                {
                                    label: "1 Column",
                                    value: "grid-cols-1"
                                },
                                {
                                    label: "2 Columns",
                                    value: "grid-cols-2"
                                }, 
                            ]
                        },
                        {
                            component: "textarea",
                            name: "followUpMessage1",
                            label: "Message 1",
                            description: "Text to be shown before the question"
                        },
                        {
                            component: "textarea",
                            name: "followUpMessage2",
                            label: "Message 2",
                            description: "Text to be shown before the question"
                        },
                        {
                            component: "group-list",
                            name: "followUpOptions",
                            label: "Follow Up Question Options",
                            itemProps: {
                                label: "{{item.label}}"
                            },
                            fields: [
                                {
                                    component: "text",
                                    name: "label",
                                    label: "Option Label"
                                },
                                {
                                    component: "image",
                                    name: "image",
                                    label: "Option Image",
                                    description: "(Optional, used only if the option is set to show images), recommended image size: 180px x 180px"
                                },
                                {
                                    component: "group-list",
                                    name: "productList",
                                    label: "Products",
                                    itemProps: {
                                        label: "{{item.product.data.title}}"
                                    },
                                    fields: [
                                        {
                                            component: "select",
                                            name: "routineType",
                                            label: "Routine Type",
                                            options: [
                                                {
                                                    label: "Daily",
                                                    value: "daily"
                                                },
                                                {
                                                    label: "Specialized",
                                                    value: "specialized"
                                                }, 
                                            ],
                                            defaultValue: "daily"
                                        },
                                        {
                                            component: "productSearch",
                                            name: "product",
                                            label: "product"
                                        },
                                        {
                                            component: "textarea",
                                            name: "resultMessage",
                                            label: "Result Message",
                                            description: "Message to be shown next to the product after the customer completes the quiz"
                                        }, 
                                    ]
                                },
                                {
                                    component: "textarea",
                                    name: "answerMessage",
                                    label: "Answer Message",
                                    description: "Message to be shown after the customer selects the option"
                                }, 
                            ]
                        }, 
                    ],
                    validate: {
                        required: true
                    }
                },
                {
                    component: "text",
                    name: "helpTitle",
                    label: "Help Modal Title"
                },
                {
                    component: "group-list",
                    name: "helpContent",
                    label: "Help Modal content",
                    fields: [
                        {
                            component: "image",
                            name: "image",
                            label: "Image",
                            description: "Optional, recomended image size: 180px x 180px"
                        },
                        {
                            component: "markdown",
                            name: "body",
                            label: "Body content",
                            description: "Required, content to be displayed in the modal"
                        }, 
                    ]
                }, 
            ]
        },
        {
            component: "group",
            name: "mailGate",
            label: "Mail Gate Settings",
            description: "Settings to configure the mail gate",
            fields: [
                {
                    component: "toggle",
                    name: "enableMailGate",
                    label: "Enable Mail Gate",
                    toggleLabels: {
                        true: "Yes",
                        false: "No"
                    },
                    defaultValue: true
                },
                {
                    component: "text",
                    name: "mailGateKlaviyoId",
                    label: "Mail Gate Klaviyo Id",
                    description: "Klaviyo list ID to subscribe the customers to (required if mail gate is enabled)"
                },
                {
                    component: "markdown",
                    name: "message1",
                    label: "Message 1"
                },
                {
                    component: "markdown",
                    name: "message2",
                    label: "Message 2"
                },
                {
                    component: "text",
                    name: "mailGateSubmitText",
                    label: "Mail Gate Submit Text",
                    description: "text for the email form submit button, if empty defaults to 'submit'",
                    defaultValue: "View my results"
                },
                {
                    component: "text",
                    name: "mailGateCTAText",
                    label: "Mail Gate skip CTA Text",
                    description: "Text for the button to skip submitting the email, if empty defaults to 'no thanks, just show me my results.'",
                    defaultValue: "no thanks, just show me my results."
                }, 
            ]
        },
        {
            component: "text",
            name: "resultTitle",
            label: "Result Page Title",
            description: "Title displayed at the top of the result page, if not populated will not render"
        },
        {
            component: "markdown",
            name: "resultDescription",
            label: "Result Page Description",
            description: "Information displayed below the title on the result page, if not populated will not render"
        },
        {
            component: "text",
            name: "baseRoutineTitle",
            label: "Base Routine Title"
        },
        {
            component: "markdown",
            name: "baseRoutineDescription",
            label: "Base Routine Description",
            description: "Information displayed below the base routine title"
        },
        {
            component: "text",
            name: "specializedRoutineTitle",
            label: "Specialized Routine Title"
        },
        {
            component: "markdown",
            name: "specializedRoutineDescription",
            label: "Specialized Routine Description",
            description: "Information displayed below the specialized routine title"
        },
        {
            component: "toggle",
            name: "addAllTop",
            label: "Add All Products Button Position",
            toggleLabels: {
                true: "Top",
                false: "Bottom"
            },
            defaultValue: false
        },
        {
            component: "text",
            name: "addAllLabel",
            label: "Add all products label",
            description: 'Label for the button that adds all recommended products at once, if not populated the button will default to "add all products"'
        },
        {
            component: "toggle",
            name: "enableSaveResults",
            label: "Enable Save Results",
            description: "Adds a button to allow the customer to send their results to their email without subscribing to the newsletter"
        },
        {
            component: "text",
            name: "saveResultsLabel",
            label: "Save Results Label",
            description: 'Label for the button that saves the results, if not populated the button will default to "save my results"'
        },
        {
            component: "toggle",
            name: "desktopBannerLightText",
            label: "Desktop Banner Text Color",
            defaultValue: true,
            toggleLabels: {
                true: "Light",
                false: "Dark"
            }
        },
        {
            component: "text",
            name: "resultBannerTitle",
            label: "Banner Title"
        },
        {
            component: "markdown",
            name: "resultBannerBody",
            label: "Banner Body Content"
        },
        {
            component: "link",
            name: "resultBannerLink",
            label: "Banner CTA",
            description: "renders a button on the banner, if either piece is not populated the button will not render"
        },
        {
            component: "image",
            name: "bannerImageDesktop",
            label: "Banner Image Desktop"
        },
        {
            component: "image",
            name: "bannerImageMobile",
            label: "Banner Image Mobile"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/QuizSection/index.js


;// CONCATENATED MODULE: ./src/snippets/globals/HorizontalCard.jsx
function HorizontalCard_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function HorizontalCard_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                HorizontalCard_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                HorizontalCard_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}












function HorizontalCard(param) {
    var productObject = param.productObject, imageClassNames = param.imageClassNames, buttonClassNames = param.buttonClassNames, index = param.index;
    var ref3, ref1, ref2;
    var product = (0,dist.useProductByHandle)({
        handle: productObject === null || productObject === void 0 ? void 0 : (ref3 = productObject.handle) === null || ref3 === void 0 ? void 0 : ref3.replace("/products/", "")
    }).product;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var addItemToCart = function() {
        var _ref = HorizontalCard_asyncToGenerator(runtime_default().mark(function _callee(id) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return cartAddItem({
                            merchandiseId: id,
                            quantity: 1,
                            attributes: [
                                {
                                    key: "_sc",
                                    value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                                }
                            ]
                        }, function() {
                            window.dispatchEvent(new CustomEvent("openSideCart"));
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addItemToCart(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var imageUrl = (0,react.useMemo)(function() {
        var ref;
        return (0,Images/* getSizedImageUrl */.M0)(product === null || product === void 0 ? void 0 : (ref = product.featuredImage) === null || ref === void 0 ? void 0 : ref.src, "200x200@2x");
    }, [
        product === null || product === void 0 ? void 0 : (ref1 = product.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.src
    ]);
    var productTitle = metafieldMap.custom_product_title || (product === null || product === void 0 ? void 0 : product.title);
    var productIngredient = metafieldMap.custom_ingredient_title;
    var bottomline = (0,hooks/* useYotpoProductBottomline */.zs)({
        legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId
    }).bottomline;
    if (!product) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full text-base mb-[34px] lg:mb-0 relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex h-full w-full flex-row items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "product-upsell__image-container relative block aspect-square bg-grey-9",
                        title: productTitle,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* default */.Z, {
                                product: product,
                                className: "pointer-events-none !top-1 !right-2 z-10 !h-10 !w-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pointer-events-none aspect-square w-[140px] ".concat(imageClassNames),
                                children: imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: imageUrl,
                                    alt: product === null || product === void 0 ? void 0 : (ref2 = product.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.alt,
                                    sizes: "(max-width=1023px) 50vw, 15vw",
                                    width: "140",
                                    height: "140",
                                    fill: true,
                                    loading: "lazy"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-full w-full flex-col p-4 px-4 py-2 lg:flex-row lg:items-start lg:px-6 lg:py-0 lg:py-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "product-upsell__info-container flex w-full flex-col items-start no-underline",
                                children: [
                                    productIngredient && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xsmall pointer-events-none mb-[4px] text-left font-tiempos font-normal italic",
                                        children: productIngredient
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-small pointer-events-none mb-[6px] text-left font-tiempos font-normal leading-[19px]",
                                        children: productTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "yotpo-reviews pointer-events-none mb-[6px] min-h-[17.5px]",
                                        children: metafieldMap.catalog_bottomline === '<div class="yotpo-display-wrapper" style=""> <div class="yotpo-clr"></div> </div>' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "yotpo-no-reviews text-sm text-black underline",
                                            children: "No reviews"
                                        }) : bottomline && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-wrap items-center gap-1.5",
                                            children: bottomline.total_reviews ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YotpoStars/* YotpoStars */.M, {
                                                    rating: bottomline.average_score
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-0 text-[13px] leading-[17.5px] underline",
                                                children: "No reviews"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
                                        variant: product === null || product === void 0 ? void 0 : product.variants[0],
                                        className: "product-upsell-prices pointer-events-none mb-0 block !text-xs !text-currentcolor xl-plus:hidden"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-end justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
                                    variant: product === null || product === void 0 ? void 0 : product.variants[0],
                                    className: "product-upsell-prices pointer-events-none mb-4 hidden !text-xs !text-currentcolor lg:block"
                                }),
                                (product === null || product === void 0 ? void 0 : product.variants[0]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: "product-upsell__atc-button text-xsmall absolute bottom-[-35px] z-[1] mr-[-1rem] mt-auto  w-full !min-w-0 py-2 px-4 text-center font-hafferBold transition lg:relative lg:bottom-auto lg:mr-auto lg:mt-0 lg:w-[120px] ".concat(buttonClassNames ? buttonClassNames : "button--primary"),
                                    onClick: function() {
                                        addItemToCart(product === null || product === void 0 ? void 0 : product.variants[0].id);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "pointer-events-none mr-[4px] tracking-wide",
                                            children: "add"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "sr-only",
                                            children: [
                                                "Add ",
                                                productTitle,
                                                " to the cart"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/snippets/icons/Play.jsx
function Play_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Play_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Play_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function Play(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", Play_objectSpread({
        width: "100%",
        height: "100%",
        viewBox: "0 0 63 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: "2"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "matrix(1,0,0,1,3.13253,3.17877)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28,0C12.546,0 0,12.546 0,28C0,43.454 12.546,56 28,56C43.454,56 56,43.454 56,28C56,12.546 43.454,0 28,0ZM28,2C42.35,2 54,13.65 54,28C54,42.35 42.35,54 28,54C13.65,54 2,42.35 2,28C2,13.65 13.65,2 28,2ZM37.961,27.206C38.485,27.606 38.485,28.394 37.961,28.794L23.607,39.771C22.949,40.274 22,39.805 22,38.976L22,17.024C22,16.195 22.949,15.726 23.608,16.229L37.961,27.206Z",
                fill: "currentColor"
            })
        })
    }));
}

;// CONCATENATED MODULE: ./src/snippets/icons/Pause.jsx
function Pause_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Pause_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Pause_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function Pause(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", Pause_objectSpread({
        width: "100%",
        height: "100%",
        viewBox: "0 0 63 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: "2"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.123,3.123C15.669,3.123 3.123,15.669 3.123,31.123C3.123,46.577 15.669,59.123 31.123,59.123C46.577,59.123 59.123,46.577 59.123,31.123C59.123,15.669 46.577,3.123 31.123,3.123ZM31.123,5.123C45.473,5.123 57.123,16.773 57.123,31.123C57.123,45.473 45.473,57.123 31.123,57.123C16.773,57.123 5.123,45.473 5.123,31.123C5.123,16.773 16.773,5.123 31.123,5.123ZM27.123,21.123L23.123,21.123L23.123,41.123L27.123,41.123L27.123,21.123ZM39.123,21.123L35.123,21.123L35.123,41.123L39.123,41.123L39.123,21.123Z",
                fill: "currentColor"
            })
        })
    }));
}

;// CONCATENATED MODULE: ./src/snippets/icons/Mute.jsx
function Mute_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Mute_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Mute_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function Mute(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", Mute_objectSpread({
        width: "100%",
        height: "100%",
        viewBox: "0 0 63 63",
        version: "1.1",
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: "2"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.123,3.123C15.669,3.123 3.123,15.669 3.123,31.123C3.123,46.577 15.669,59.123 31.123,59.123C46.577,59.123 59.123,46.577 59.123,31.123C59.123,15.669 46.577,3.123 31.123,3.123ZM31.123,5.123C45.473,5.123 57.123,16.773 57.123,31.123C57.123,45.473 45.473,57.123 31.123,57.123C16.773,57.123 5.123,45.473 5.123,31.123C5.123,16.773 16.773,5.123 31.123,5.123ZM37.624,40.115L37.624,35.411L40.677,38.394L42.585,36.53L25.794,20.123L23.886,21.987L28.465,26.462L24.123,26.462C23.571,26.462 23.123,26.91 23.123,27.462L23.123,34.784C23.123,35.336 23.571,35.784 24.123,35.784L29.229,35.784L36.021,40.913C36.68,41.41 37.624,40.94 37.624,40.115ZM37.624,27.913L33.045,23.333L36.069,21.317C36.734,20.874 37.624,21.351 37.624,22.149L37.624,27.913Z",
                fill: "currentColor"
            })
        })
    }));
}

;// CONCATENATED MODULE: ./src/snippets/icons/Unmute.jsx
function Unmute_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Unmute_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Unmute_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function Unmute(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", Unmute_objectSpread({
        width: "100%",
        height: "100%",
        viewBox: "0 0 63 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: "2"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.123,3.123C15.669,3.123 3.123,15.669 3.123,31.123C3.123,46.577 15.669,59.123 31.123,59.123C46.577,59.123 59.123,46.577 59.123,31.123C59.123,15.669 46.577,3.123 31.123,3.123ZM31.123,5.123C45.473,5.123 57.123,16.773 57.123,31.123C57.123,45.473 45.473,57.123 31.123,57.123C16.773,57.123 5.123,45.473 5.123,31.123C5.123,16.773 16.773,5.123 31.123,5.123ZM31.123,22.418L31.123,39.542C31.123,40.381 30.153,40.847 29.498,40.323L22.888,35.035L18.123,35.035C17.571,35.035 17.123,34.587 17.123,34.035L17.123,26.976C17.123,26.424 17.571,25.976 18.123,25.976L22.476,25.976L29.597,21.568C30.263,21.156 31.123,21.635 31.123,22.418ZM35.72,25.038C37.728,25.923 39.123,28.099 39.123,30.623C39.123,33.148 37.728,35.323 35.72,36.208L36.526,38.038C39.206,36.857 41.123,33.991 41.123,30.623C41.123,27.256 39.206,24.389 36.526,23.208L35.72,25.038ZM33.694,28.027C34.556,28.435 35.123,29.457 35.123,30.623C35.123,31.789 34.556,32.811 33.694,33.22L34.552,35.027C36.034,34.323 37.123,32.629 37.123,30.623C37.123,28.617 36.034,26.923 34.552,26.22L33.694,28.027Z",
                fill: "currentColor"
            })
        })
    }));
}

;// CONCATENATED MODULE: ./src/sections/Testimonial/Testimonial.jsx
function Testimonial_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Testimonial_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Testimonial_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















function Testimonial(param) {
    var cms = param.cms;
    var title = cms.title, subtitle = cms.subtitle, bgColor = cms.bgColor, lightText = cms.lightText, testimonials = cms.testimonials, titleFont = cms.titleFont, subtitleFont = cms.subtitleFont;
    var testimonialSlider = (0,react.useRef)(null);
    var sliderContainer = (0,react.useRef)(null);
    var tabsContainer = (0,react.useRef)(null);
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var isMobile = vpWidth < 768;
    var ref5 = (0,react.useState)(0), activeSlideIndex = ref5[0], setActiveSlideIndex = ref5[1];
    var ref1 = (0,react.useState)(0), previousSlideIndex = ref1[0], setPreviousSlideIndex = ref1[1];
    var ref2 = (0,react.useState)(false), mobileStatsOpen = ref2[0], setMobileStatsOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isPlaying = ref3[0], setIsPlaying = ref3[1];
    var ref4 = (0,react.useState)(true), isMuted = ref4[0], setIsMuted = ref4[1];
    var sliderSettings = {
        slidesToShow: 1,
        fade: true,
        infinite: true,
        arrows: false,
        lazyLoad: "ondemand",
        slide: ".slide",
        adaptiveHeight: true,
        beforeChange: function(currentSlide, nextSlide) {
            setActiveSlideIndex(nextSlide);
            setPreviousSlideIndex(currentSlide);
        }
    };
    var togglePlay = function() {
        var ref;
        var activeSlideVideo = sliderContainer === null || sliderContainer === void 0 ? void 0 : (ref = sliderContainer.current) === null || ref === void 0 ? void 0 : ref.querySelector('.slick-slide[data-index="'.concat(activeSlideIndex, '"] video'));
        if (activeSlideVideo) {
            if (isPlaying) {
                activeSlideVideo.pause();
                setIsPlaying(false);
            } else {
                activeSlideVideo.play();
                setIsPlaying(true);
            }
        }
    };
    var toggleAudio = function() {
        var ref;
        var activeSlideVideo = sliderContainer === null || sliderContainer === void 0 ? void 0 : (ref = sliderContainer.current) === null || ref === void 0 ? void 0 : ref.querySelector('.slick-slide[data-index="'.concat(activeSlideIndex, '"] video'));
        if (activeSlideVideo) {
            if (isMuted) {
                activeSlideVideo.muted = false;
                setIsMuted(false);
            } else {
                activeSlideVideo.muted = true;
                setIsMuted(true);
            }
        }
    };
    var toggleMobileStats = function() {
        setMobileStatsOpen(!mobileStatsOpen);
    };
    var buildSliderTabs = function() {
        var sliderTabs = testimonials.map(function(testimonial, index) {
            var activeClasses = lightText ? "bg-white text-black" : "bg-quinary-1 text-white border-quinary-1";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "border-2 rounded-full px-4 py-1 text-xs ".concat((testimonial === null || testimonial === void 0 ? void 0 : testimonial.tabTitleFont) || "font-hafferBold", " transition-colors whitespace-nowrap ").concat(activeSlideIndex === index && activeClasses, "\n            ").concat(lightText ? "border-white hover:bg-white hover:text-black" : "border-black hover:border-black hover:bg-black hover:text-white"),
                onClick: function() {
                    testimonialSlider.current.slickGoTo(index);
                },
                children: testimonial.tabTitle
            }, "tabButton-".concat(index));
        });
        return sliderTabs;
    };
    (0,react.useEffect)(function() {
        var ref, ref6;
        if ((tabsContainer === null || tabsContainer === void 0 ? void 0 : tabsContainer.current) && (tabsContainer === null || tabsContainer === void 0 ? void 0 : (ref = tabsContainer.current) === null || ref === void 0 ? void 0 : ref.scrollWidth) > (tabsContainer === null || tabsContainer === void 0 ? void 0 : (ref6 = tabsContainer.current) === null || ref6 === void 0 ? void 0 : ref6.clientWidth)) {
            var ref7, ref8;
            tabsContainer === null || tabsContainer === void 0 ? void 0 : (ref7 = tabsContainer.current) === null || ref7 === void 0 ? void 0 : ref7.classList.remove("justify-center");
            tabsContainer === null || tabsContainer === void 0 ? void 0 : (ref8 = tabsContainer.current) === null || ref8 === void 0 ? void 0 : ref8.classList.add("justify-start");
        } else {
            var ref9, ref10;
            tabsContainer === null || tabsContainer === void 0 ? void 0 : (ref9 = tabsContainer.current) === null || ref9 === void 0 ? void 0 : ref9.classList.add("justify-center");
            tabsContainer === null || tabsContainer === void 0 ? void 0 : (ref10 = tabsContainer.current) === null || ref10 === void 0 ? void 0 : ref10.classList.remove("justify-start");
        }
    }, [
        vpWidth
    ]);
    (0,react.useEffect)(function() {
        var ref, ref11;
        var previousSlideVideo = sliderContainer === null || sliderContainer === void 0 ? void 0 : (ref = sliderContainer.current) === null || ref === void 0 ? void 0 : ref.querySelector('.slick-slide[data-index="'.concat(previousSlideIndex, '"] video'));
        var activeSlideVideo = sliderContainer === null || sliderContainer === void 0 ? void 0 : (ref11 = sliderContainer.current) === null || ref11 === void 0 ? void 0 : ref11.querySelector('.slick-slide[data-index="'.concat(activeSlideIndex, '"] video'));
        if (previousSlideVideo) {
            previousSlideVideo.pause();
            previousSlideVideo.muted = true;
            setIsMuted(true);
        }
        if (activeSlideVideo) {
            activeSlideVideo.play();
            setIsPlaying(true);
        }
    }, [
        activeSlideIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: cms.id,
        className: "py-14 lg:py-24 ".concat(bgColor, " ").concat(lightText === true ? "text-white" : "text-black"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "testimonial__container container mx-auto px-4 lg:px-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "testimonial__header",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "testimonial__title mb-3 text-center text-[22px] md:text-h4 ".concat(titleFont || "font-tiempos"),
                            children: title
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "testimonial__subtitle mx-auto mb-6 max-w-[440px] text-center text-base md:text-lg ".concat(subtitleFont || "font-haffer"),
                            children: subtitle
                        })
                    ]
                }),
                (testimonials === null || testimonials === void 0 ? void 0 : testimonials.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "testimonial__tabs-indicators -mx-4 flex justify-center gap-3 overflow-auto px-4",
                    ref: tabsContainer,
                    children: buildSliderTabs()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "testimonial-body relative mt-10 md:mt-15",
                    ref: sliderContainer,
                    children: [
                        (testimonials === null || testimonials === void 0 ? void 0 : testimonials.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, Testimonial_objectSpread({
                            className: "testimonial__carousel mx-auto max-w-6xl",
                            ref: testimonialSlider
                        }, sliderSettings, {
                            children: testimonials.map(function(testimonial, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "slide",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "testimonial__slide flex w-full flex-col md:flex-row md:border ".concat(lightText ? "md:border-white" : "md:border-black"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "testimonial__graphic relative aspect-[9/16] w-full flex-shrink-0 md:w-5/12",
                                                children: [
                                                    (testimonial === null || testimonial === void 0 ? void 0 : testimonial.video) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                                                className: "absolute z-[1] h-full w-full object-cover",
                                                                loop: true,
                                                                muted: true,
                                                                playsInline: true,
                                                                loading: "lazy",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                                    src: testimonial.video
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                type: "button",
                                                                className: "testimonial__play-button absolute right-4 bottom-[98px] z-[2] text-black",
                                                                onClick: togglePlay,
                                                                children: [
                                                                    isPlaying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pause, {
                                                                        className: "h-16 w-16"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Play, {
                                                                        className: "h-16 w-16"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "sr-only",
                                                                        children: isPlaying ? "Pause" : "Play"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                type: "button",
                                                                className: "testimonial_audio-button absolute right-4 bottom-5 z-[2] text-black",
                                                                onClick: toggleAudio,
                                                                children: [
                                                                    isMuted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Unmute, {
                                                                        className: "h-16 w-16"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Mute, {
                                                                        className: "h-16 w-16"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "sr-only",
                                                                        children: isMuted ? "Unmute" : "Mute"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    testimonial.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                        className: "block w-full",
                                                        src: testimonial.image.src,
                                                        alt: testimonial.image.alt,
                                                        width: "885",
                                                        height: "498",
                                                        fill: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "testimonial__content flex w-full flex-col md:border-l ".concat(lightText ? "md:border-white" : "md:border-black"),
                                                children: [
                                                    !!(testimonial === null || testimonial === void 0 ? void 0 : testimonial.quote) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "testimonial__quote flex h-full flex-col justify-center py-4 px-0 ".concat((testimonial === null || testimonial === void 0 ? void 0 : testimonial.quoteFont) || "font-tiempos", " md:border-b md:py-8 md:pl-[72px] md:pr-[64px] ").concat(lightText ? "md:border-white" : "md:border-black", " "),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "mb-0 text-h3-m lg:text-h4 ".concat((testimonial === null || testimonial === void 0 ? void 0 : testimonial.quoteFont) || "font-tiempos"),
                                                                children: testimonial.quote
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "mt-2 mb-0 text-lg lg:mt-6 lg:text-h5 ".concat((testimonial === null || testimonial === void 0 ? void 0 : testimonial.nameFont) || "font-hafferBold"),
                                                                children: [
                                                                    testimonial.name,
                                                                    testimonial.instagramHandle && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://instagram.com/".concat(testimonial.instagramHandle.replace("@", "")),
                                                                        target: "_blank",
                                                                        className: "ml-2 ".concat((testimonial === null || testimonial === void 0 ? void 0 : testimonial.instagramHandleFont) || "font-haffer", " ").concat(lightText ? "focus-link-white" : "focus-link"),
                                                                        children: testimonial.instagramHandle
                                                                    }),
                                                                    isMobile && !!(testimonial === null || testimonial === void 0 ? void 0 : testimonial.stats) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                        type: "button",
                                                                        className: "testimonial__info-button relative ml-2 align-middle",
                                                                        onClick: toggleMobileStats,
                                                                        children: [
                                                                            mobileStatsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "absolute left-1/2 -top-3 h-4 w-4 -translate-x-1/2 -translate-y-full rotate-45 bg-white"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Info/* Info */.k, {
                                                                                className: "h-5 w-5"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    isMobile && mobileStatsOpen && (testimonial === null || testimonial === void 0 ? void 0 : testimonial.stats) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "testimonial-stat-container relative overflow-visible",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "testimonial__stats-mobile absolute inset-0 -top-[3.5em] z-50 min-h-min -translate-y-full bg-white p-5 pb-0 pr-16 font-primary text-xs text-black",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    type: "button",
                                                                                    className: "testimonial__info-button absolute top-5 right-5",
                                                                                    onClick: toggleMobileStats,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {})
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown_Markdown, {
                                                                                    content: testimonial.stats
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    !isMobile && !!(testimonial === null || testimonial === void 0 ? void 0 : testimonial.stats) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "testimonial__stats flex h-full flex-col justify-center py-8 pl-[72px] pr-[64px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown_Markdown, {
                                                            content: testimonial.stats
                                                        })
                                                    }),
                                                    !!(testimonial === null || testimonial === void 0 ? void 0 : testimonial.featuredProduct) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "testimonial__product mt-auto mb-[1px] md:border-t bg-white text-black lg:mb-0 ".concat(lightText ? "md:border-white" : "md:border-black"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalCard, {
                                                            productObject: testimonial.featuredProduct,
                                                            imageClassNames: "lg:!w-[215px]",
                                                            buttonClassNames: "button--checkout"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, "testimonial-slide-".concat(index));
                            })
                        })),
                        (testimonials === null || testimonials === void 0 ? void 0 : testimonials.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative mt-7 flex justify-end lg:static",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: "testimonial__prev-arrow z-1 h-[45px] w-[45px] border text-center lg:absolute lg:top-1/2 lg:-left-16 lg:-translate-y-1/2 transition-colors mr-[-1px] ".concat(lightText ? "border-white hover:text-black hover:bg-white" : "border-black hover:text-white hover:bg-black", " "),
                                    onClick: function() {
                                        return testimonialSlider.current.slickPrev();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconArrowLeft */.D6, {
                                            className: "mx-auto w-2.5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Previous"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: "testimonial__next-arrow z-1 h-[45px] w-[45px] border text-center lg:absolute lg:top-1/2 lg:-right-16 lg:-translate-y-1/2 transition-colors ".concat(lightText ? "border-white hover:text-black hover:bg-white" : "border-black hover:text-white hover:bg-black", " "),
                                    onClick: function() {
                                        return testimonialSlider.current.slickNext();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconArrowRight */.Ec, {
                                            className: "mx-auto w-2.5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Next"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, cms.id);
}
Testimonial.displayName = "Testimonial";
Testimonial.Schema = {
    category: "Modules",
    label: Testimonial.displayName,
    key: "Testimonial",
    fields: [
        {
            name: "title",
            label: "Title",
            component: "text"
        },
        {
            name: "titleFont",
            label: "Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the title text"
        },
        {
            name: "subtitle",
            label: "Subtitle",
            component: "textarea"
        },
        {
            name: "subtitleFont",
            label: "Subtitle Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the subtitle text"
        },
        {
            name: "bgColor",
            label: "Background Color",
            component: "select",
            description: "For section background color, select one from preselected brand colors.",
            options: [
                {
                    label: "Black",
                    value: "bg-black"
                },
                {
                    label: "White",
                    value: "bg-white"
                },
                {
                    label: "Grey",
                    value: "bg-grey-1"
                },
                {
                    label: "Light Grey",
                    value: "bg-grey-9"
                },
                {
                    label: "Blue 1",
                    value: "bg-quinary-1"
                },
                {
                    label: "Blue 2",
                    value: "bg-quinary-2"
                },
                {
                    label: "Blue 3",
                    value: "bg-light-blue"
                },
                {
                    label: "Cream 1",
                    value: "bg-tertiary-2"
                },
                {
                    label: "Cream 2",
                    value: "bg-senary-4"
                },
                {
                    label: "Purple",
                    value: "bg-tertiary-1"
                },
                {
                    label: "Green",
                    value: "bg-quaternary-1"
                },
                {
                    label: "Pink 1",
                    value: "bg-primary-2"
                },
                {
                    label: "Pink 2",
                    value: "bg-secondary-1"
                },
                {
                    label: "Yellow",
                    value: "bg-yellow"
                },
                {
                    label: "Orange",
                    value: "bg-secondary-2"
                },
                {
                    label: "Seafoam 1",
                    value: "bg-quaternary-2"
                },
                {
                    label: "Seafoam 2",
                    value: "bg-senary-3"
                },
                {
                    label: "Seafoam 3",
                    value: "bg-senary-5"
                },
                {
                    label: "Air Dry Cream",
                    value: "bg-stylers-1"
                },
                {
                    label: "Sculpting Cream",
                    value: "bg-stylers-2"
                },
                {
                    label: "Texture Foam",
                    value: "bg-stylers-3"
                },
                {
                    label: "Sleek Stick",
                    value: "bg-stylers-4"
                },
                {
                    label: "Scalp Blue",
                    value: "bg-scalp-blue"
                },
                {
                    label: "Magenta",
                    value: "bg-magenta"
                },
                {
                    label: "Medium Pink",
                    value: "bg-med-pink"
                },
                {
                    label: "Briogeo Blue",
                    value: "bg-brio-blue"
                },
                {
                    label: "Cloud",
                    value: "bg-cloud"
                },
                {
                    label: "Mineral",
                    value: "bg-mineral"
                },
                {
                    label: "Deep Sea",
                    value: "bg-deep-sea"
                },
                {
                    label: "Sandstone",
                    value: "bg-sandstone"
                },
                {
                    label: "Sorrel",
                    value: "bg-sorrel"
                },
                {
                    label: "Butter",
                    value: "bg-butter"
                },
                {
                    label: "Rosehip",
                    value: "bg-rosehip"
                },
                {
                    label: "Chestnut",
                    value: "bg-chestnut"
                }, 
            ],
            defaultValue: "bg-white"
        },
        {
            name: "lightText",
            label: "Text Color",
            component: "toggle",
            toggleLabels: {
                true: "Light",
                false: "Dark"
            }
        },
        {
            name: "testimonials",
            label: "Testimonials",
            component: "group-list",
            itemProps: {
                label: "Testimonial: {{item.name}}"
            },
            fields: [
                {
                    name: "tabTitle",
                    label: "Tab Title",
                    component: "text",
                    description: "Title for the testimonial tab"
                },
                {
                    name: "tabTitleFont",
                    label: "Tab Title Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the tab title text"
                },
                {
                    name: "image",
                    label: "Image",
                    component: "image",
                    description: "Recomended size: 885px x 498px (or equivalent aspect ratio)"
                },
                {
                    name: "video",
                    label: "Video",
                    component: "text",
                    description: "Recommended size: 885px x 498px (or equivalent aspect ratio) format MP4"
                },
                {
                    name: "quote",
                    label: "Quote",
                    component: "textarea"
                },
                {
                    name: "quoteFont",
                    label: "Quote Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the quote text"
                },
                {
                    name: "name",
                    label: "Reviewer Name",
                    component: "text"
                },
                {
                    name: "nameFont",
                    label: "Reviewer Name Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the reviewer name text"
                },
                {
                    name: "instagramHandle",
                    label: "Reviewer Instagram Handle",
                    component: "text"
                },
                {
                    name: "instagramHandleFont",
                    label: "Reviewer Instagram Handle Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the instagram handle text"
                },
                {
                    name: "stats",
                    label: "Reviewer Statistics",
                    component: "markdown",
                    description: "Details about the client's testimonial, this content is placed in a pop up window on mobile resolutions so consider the length of the content."
                },
                {
                    name: "featuredProduct",
                    label: "Featured product",
                    component: "productSearch",
                    description: "Product featured by this testimonial"
                }, 
            ]
        }
    ]
};

;// CONCATENATED MODULE: ./src/sections/Testimonial/index.js


;// CONCATENATED MODULE: ./src/snippets/icons/SliderArrow.jsx
function SliderArrow_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SliderArrow_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SliderArrow_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function SliderArrow(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", SliderArrow_objectSpread({
        width: "44",
        height: "44",
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "22",
                cy: "22",
                r: "22",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 22L19 15V29L12 22Z",
                fill: "#000000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 22L25 29L25 15L32 22Z",
                fill: "#000000"
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/sections/BeforeAfterSlider/BeforeAfterProductModal.jsx




function BeforeAfterProductModal(props) {
    var products = props.products, title = props.title, _titleFont = props.titleFont, titleFont = _titleFont === void 0 ? "font-hafferBold" : _titleFont, setProductModalOpen = props.setProductModalOpen;
    var compensateTop = products.some(function(productObject) {
        return productObject.current === true;
    });
    var sortedProducts = products.sort(function(productObject1, productObject2) {
        var a = productObject1.current ? 1 : 0;
        var b = productObject2.current ? 1 : 0;
        return b - a;
    });
    var columnsCount = "grid-cols-1";
    switch(products.length){
        case 2:
            columnsCount = "grid-cols-2";
            break;
        case 3:
            columnsCount = "grid-cols-2 lg:grid-cols-3";
            break;
        case 4:
            columnsCount = "grid-cols-2 lg:grid-cols-4";
            break;
        default:
            break;
    }
    var closeModal = function() {
        setProductModalOpen(false);
    };
    var outClickHandler = function(event) {
        if (!event.target.closest(".before-after__product-modal")) {
            closeModal();
        }
    };
    (0,react.useEffect)(function() {
        var currentScroll = window.scrollY;
        document.body.style.setProperty("--topPosition", "-".concat(currentScroll, "px"));
        document.body.classList.add("overflow-hidden", "bg-overlay");
        setTimeout(function() {
            document.addEventListener("click", outClickHandler);
        }, 100);
        return function() {
            document.body.classList.remove("overflow-hidden", "bg-overlay");
            var scrollTop = document.body.style.getPropertyValue("--topPosition");
            if (scrollTop) {
                window.scrollTo({
                    top: parseInt(scrollTop.replace("px", "") || "0", 10) * -1
                });
                document.body.style.removeProperty("--topPosition");
            }
            document.removeEventListener("click", outClickHandler);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "before-after__product-modal fixed bottom-0 top-1/2 left-1/2 z-[1000000] max-h-[90dvh] w-full max-w-[90%] -translate-y-1/2\n        -translate-x-1/2 overflow-y-auto bg-white px-5 pb-10 h-min lg:w-max lg:max-w-[80%] lg:px-12 lg:py-12 lg:pt-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "before-after__modal-header sticky top-0 z-20 bg-white py-4 pr-10 text-left lg:px-0 lg:mt-2",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-0 text-lg ".concat(titleFont),
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "before-after__modal-close absolute top-1 -right-4 p-4 lg:top-0",
                        onClick: closeModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "before-after__modal-body grid gap-5 ".concat(columnsCount, " ").concat(compensateTop == true && "pt-[55px]"),
                children: sortedProducts.map(function(productObject, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "before-after__modal-product flex flex-col relative",
                        children: [
                            productObject.current == true && index == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "before-after__modal-product-label absolute top-[-55px] inline-block self-start rounded-full bg-black py-2 px-2 lg:px-4 font-hafferBold text-xs text-white",
                                children: "current product"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                handle: productObject.product.handle,
                                showQuickBuyButton: true,
                                quickViewButton: "false",
                                isSection: true
                            })
                        ]
                    });
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/icons/Swap.jsx
function Swap_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Swap_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Swap_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function Swap(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", Swap_objectSpread({
        width: "19",
        height: "14",
        viewBox: "0 0 19 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.78293 3.57169C4.24236 5.10677 3.86617 7.35584 4.61854 9.24792L5.83667 6.99884L6.75026 7.48079L4.72602 11.1935L1 9.19422L1.48367 8.28388L3.57956 9.40842C2.79136 7.19504 3.27502 4.60682 5.04847 2.8397C7.14436 0.751419 10.333 0.447973 12.7692 1.89366L12.0169 2.6612C10.0105 1.59021 7.4668 1.89366 5.78293 3.57154V3.57169Z",
                fill: "#444444",
                stroke: "#444444",
                strokeWidth: "0.25"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.24869 12.657L7.00106 11.9073C9.00738 12.9783 11.5511 12.6749 13.235 10.997C14.7756 9.4619 15.1517 7.21283 14.3994 5.32075L13.1812 7.56982L12.2677 7.08788L14.274 3.37512L18 5.3743L17.5163 6.28464L15.4204 5.1601C16.2086 7.37347 15.725 9.96169 13.9515 11.7288C11.8734 13.8172 8.66702 14.1207 6.24869 12.657Z",
                fill: "#444444",
                stroke: "#444444",
                strokeWidth: "0.25"
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/sections/BeforeAfterSlider/BeforeAfterSlider.jsx
function BeforeAfterSlider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BeforeAfterSlider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BeforeAfterSlider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









function BeforeAfterSlider(param) {
    var cms = param.cms;
    var ref13, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var mobileSpacing = cms.mobileSpacing, desktopSpacing = cms.desktopSpacing, heading = cms.heading, body = cms.body, whiteLabel = cms.whiteLabel, imageRight = cms.imageRight, bgImageLabel = cms.bgImageLabel, fgImageLabel = cms.fgImageLabel, viewProductsCtaLabel = cms.viewProductsCtaLabel, viewProductsCtaIcon = cms.viewProductsCtaIcon, previewList = cms.previewList, _headingFont = cms.headingFont, headingFont = _headingFont === void 0 ? "font-tiempos" : _headingFont, _bodyFont = cms.bodyFont, bodyFont = _bodyFont === void 0 ? "font-hafferBold" : _bodyFont, _viewProductsCtaLabelFont = cms.viewProductsCtaLabelFont, viewProductsCtaLabelFont = _viewProductsCtaLabelFont === void 0 ? "font-hafferBold" : _viewProductsCtaLabelFont;
    var ref8 = (0,react.useState)(false), productModalOpen = ref8[0], setProductModalOpen = ref8[1];
    var backgroundImage = (0,react.useRef)(null);
    var foregroundImage = (0,react.useRef)(null);
    var sliderDivider = (0,react.useRef)(null);
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var isMobile = vpWidth < 1024;
    var ref9 = (0,react.useState)(previewList[0]), currentPreview = ref9[0], setCurrentPreview = ref9[1];
    var updateForegroundImageWidth = function(e) {
        var value = e.target.value;
        foregroundImage.current.style.width = "".concat(100 - value, "%");
        sliderDivider.current.style.left = "".concat(value, "%");
    };
    var settings = {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 5.1,
        mobileFirst: true,
        spaceBetween: 20,
        responsive: [
            {
                breakpoint: 662,
                settings: {
                    slidesToShow: 4.2
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "".concat(BeforeAfterSlider.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        className: "before-after-slider container mx-auto items-center justify-center px-4 lg:flex ".concat(imageRight == true ? "lg:flex-row-reverse" : "lg:flex-row"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(BeforeAfterSlider.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(BeforeAfterSlider.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(desktopSpacing, "px;\n            }\n          }\n        #").concat(BeforeAfterSlider.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " .slick-track {\n          display: flex;\n          padding: 0 20px;\n        }\n        ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "before-after-slider__image-container lg:w-5/12",
                children: [
                    isMobile && heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "before-after-slider__heading h4 mb-4 ".concat(headingFont),
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "before-after-slider__slider-container relative aspect-square cursor-not-allowed overflow-hidden border border-black",
                        children: [
                            bgImageLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute top-4 left-5 z-10 text-lg ".concat(bodyFont, " ").concat((currentPreview === null || currentPreview === void 0 ? void 0 : currentPreview.bgWhiteLabel) == true ? "text-white" : ""),
                                children: bgImageLabel
                            }),
                            fgImageLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute top-4 right-5 z-10 text-lg ".concat(bodyFont, " ").concat((currentPreview === null || currentPreview === void 0 ? void 0 : currentPreview.fgWhiteLabel) == true ? "text-white" : ""),
                                children: fgImageLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "before-after-slider__background-image",
                                ref: backgroundImage,
                                children: (currentPreview === null || currentPreview === void 0 ? void 0 : currentPreview.backgroundImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: "w-full object-cover object-left",
                                    src: currentPreview === null || currentPreview === void 0 ? void 0 : (ref13 = currentPreview.backgroundImage) === null || ref13 === void 0 ? void 0 : ref13.src,
                                    width: currentPreview === null || currentPreview === void 0 ? void 0 : (ref1 = currentPreview.backgroundImage) === null || ref1 === void 0 ? void 0 : ref1.width,
                                    height: currentPreview === null || currentPreview === void 0 ? void 0 : (ref2 = currentPreview.backgroundImage) === null || ref2 === void 0 ? void 0 : ref2.height,
                                    alt: currentPreview === null || currentPreview === void 0 ? void 0 : (ref3 = currentPreview.backgroundImage) === null || ref3 === void 0 ? void 0 : ref3.altText,
                                    quality: "100",
                                    loading: "lazy"
                                }, "image-left")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "before-after-slider__foreground-image absolute top-0 right-0 h-full w-1/2 overflow-hidden",
                                ref: foregroundImage,
                                children: (currentPreview === null || currentPreview === void 0 ? void 0 : currentPreview.foregroundImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: "h-full w-full object-cover object-right",
                                    src: currentPreview === null || currentPreview === void 0 ? void 0 : (ref4 = currentPreview.foregroundImage) === null || ref4 === void 0 ? void 0 : ref4.src,
                                    width: currentPreview === null || currentPreview === void 0 ? void 0 : (ref5 = currentPreview.foregroundImage) === null || ref5 === void 0 ? void 0 : ref5.width,
                                    height: currentPreview === null || currentPreview === void 0 ? void 0 : (ref6 = currentPreview.foregroundImage) === null || ref6 === void 0 ? void 0 : ref6.height,
                                    alt: currentPreview === null || currentPreview === void 0 ? void 0 : (ref7 = currentPreview.foregroundImage) === null || ref7 === void 0 ? void 0 : ref7.altText,
                                    quality: "100",
                                    loading: "lazy"
                                }, "image-right")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "before-after-slider__divider absolute top-0 left-1/2 block h-full w-[3px] bg-white",
                                ref: sliderDivider,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderArrow, {
                                    className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "range",
                                className: "absolute top-0 h-full w-full appearance-none opacity-0",
                                min: 6,
                                max: 94,
                                defaultValue: 50,
                                onChange: updateForegroundImageWidth,
                                "aria-label": "Slider to compare images"
                            }),
                            (currentPreview === null || currentPreview === void 0 ? void 0 : currentPreview.products) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "before-after-slider__cta absolute bottom-[-1px] right-[-1px] border border-black bg-white px-5 py-2.5 ".concat(viewProductsCtaLabelFont),
                                onClick: function() {
                                    return setProductModalOpen(true);
                                },
                                "aria-label": viewProductsCtaLabel,
                                children: [
                                    viewProductsCtaIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        src: viewProductsCtaIcon.src,
                                        width: "20",
                                        height: "20",
                                        className: "mr-4 inline-block h-5 w-5",
                                        alt: ""
                                    }),
                                    viewProductsCtaLabel
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "before-after-slider__body-container lg:w-5/12 ".concat(imageRight == true ? "lg:pr-16" : "lg:pl-16", " flex flex-col"),
                children: [
                    !isMobile && heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "before-after-slider__heading h4 mb-4 ".concat(headingFont),
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "before-after-slider__body ".concat(bodyFont, " order-4 mb-4 mt-2 lg:mt-0 text-base lg:order-2"),
                        dangerouslySetInnerHTML: {
                            __html: body
                        }
                    }),
                    previewList.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "order-1 mt-4 ".concat(bodyFont, " text-sm lg:order-3 lg:mt-2"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Swap, {
                                        className: "mr-1.5 inline-block"
                                    }),
                                    "Swap to see additional results"
                                ]
                            }),
                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, BeforeAfterSlider_objectSpread({}, settings, {
                                className: "order-2 mt-4 -mr-4 -ml-5 lg:order-4",
                                children: previewList.map(function(preview, index) {
                                    var ref, ref10, ref11, ref12;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "pr-2.5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "before-after-slider__thumbnail relative aspect-square cursor-pointer border ".concat(preview == currentPreview ? "border-primary-2" : "border-black"),
                                            onClick: function() {
                                                return setCurrentPreview(preview);
                                            },
                                            "aria-label": (preview === null || preview === void 0 ? void 0 : (ref = preview.foregroundImage) === null || ref === void 0 ? void 0 : ref.altText) || "Thumbnail ".concat(index + 1),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                className: "h-full w-full object-cover",
                                                src: "".concat(preview === null || preview === void 0 ? void 0 : (ref10 = preview.foregroundImage) === null || ref10 === void 0 ? void 0 : ref10.src),
                                                width: 110,
                                                height: 110,
                                                alt: (preview === null || preview === void 0 ? void 0 : (ref11 = preview.foregroundImage) === null || ref11 === void 0 ? void 0 : ref11.altText) || "Thumbnail ".concat(index + 1),
                                                loading: "lazy"
                                            })
                                        }, preview === null || preview === void 0 ? void 0 : (ref12 = preview.backgroundImage) === null || ref12 === void 0 ? void 0 : ref12.src)
                                    });
                                })
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-2 mt-4 grid max-w-md grid-cols-4 gap-2.5 lg:order-4",
                                children: previewList.map(function(preview, index) {
                                    var ref, ref14, ref15, ref16;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
                                        className: "before-after-slider__thumbnail relative aspect-square cursor-pointer border ".concat(preview == currentPreview ? "border-primary-2" : "border-black"),
                                        onClick: function() {
                                            return setCurrentPreview(preview);
                                        },
                                        "aria-label": (preview === null || preview === void 0 ? void 0 : (ref = preview.foregroundImage) === null || ref === void 0 ? void 0 : ref.altText) || "Thumbnail ".concat(index + 1),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            className: "h-full w-full object-cover",
                                            src: "".concat(preview === null || preview === void 0 ? void 0 : (ref14 = preview.foregroundImage) === null || ref14 === void 0 ? void 0 : ref14.src),
                                            width: 110,
                                            height: 110,
                                            alt: (preview === null || preview === void 0 ? void 0 : (ref15 = preview.foregroundImage) === null || ref15 === void 0 ? void 0 : ref15.altText) || "Thumbnail ".concat(index + 1),
                                            loading: "lazy"
                                        })
                                    }, preview === null || preview === void 0 ? void 0 : (ref16 = preview.backgroundImage) === null || ref16 === void 0 ? void 0 : ref16.src);
                                })
                            })
                        ]
                    })
                ]
            }),
            productModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(BeforeAfterProductModal, {
                products: currentPreview.products,
                title: currentPreview === null || currentPreview === void 0 ? void 0 : currentPreview.modalTitle,
                titleFont: (currentPreview === null || currentPreview === void 0 ? void 0 : currentPreview.modalTitleFont) || "font-hafferBold",
                setProductModalOpen: setProductModalOpen
            })
        ]
    });
}
BeforeAfterSlider.displayName = "Before After Slider";
BeforeAfterSlider.Schema = {
    category: "Modules",
    label: BeforeAfterSlider.displayName,
    key: "BeforeAfterSlider",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "heading",
            label: "Heading",
            component: "text"
        },
        {
            name: "headingFont",
            label: "Heading Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-tiempos",
            description: "Select the font for the heading text"
        },
        {
            name: "body",
            label: "Body",
            description: "This holds paragraph text and ordered/unordered list",
            component: "markdown"
        },
        {
            name: "bodyFont",
            label: "Body Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-tiempos",
            description: "Select the font for the body text"
        },
        {
            name: "imageRight",
            label: "Image Position",
            component: "toggle",
            toggleLabels: {
                true: "Right",
                false: "Left"
            },
            defaultValue: false,
            description: "Select the position of the image in the layout"
        },
        {
            name: "bgImageLabel",
            label: "Background Image Label",
            description: "Left area image label",
            component: "text"
        },
        {
            name: "fgImageLabel",
            label: "Foreground Image Label",
            description: "Right area image label",
            component: "text"
        },
        {
            name: "viewProductsCtaIcon",
            label: "View Products CTA Icon",
            component: "image",
            description: "Icon for the button that will show the list of products from the current thumbnail (if populated)"
        },
        {
            name: "viewProductsCtaLabel",
            label: "View Products CTA Label",
            component: "text",
            description: "Label for the button that will show the list of products from the current thumbnail (if populated)"
        },
        {
            name: "viewProductsCtaLabelFont",
            label: "View Products CTA Label Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-hafferBold",
            description: "Select the font for the view products cta label text"
        },
        {
            name: "previewList",
            label: "Preview list",
            component: "group-list",
            fields: [
                {
                    name: "backgroundImage",
                    label: "Background Image Image",
                    component: "image",
                    description: "Recommended image size: 600x600px"
                },
                {
                    name: "bgWhiteLabel",
                    label: "Background Image Label Color",
                    component: "toggle",
                    toggleLabels: {
                        true: "White",
                        false: "Black"
                    }
                },
                {
                    name: "foregroundImage",
                    label: "Foreground Image Image",
                    component: "image",
                    description: "Recommended image size: 600x600px (Used as the default image for the thumbnails)"
                },
                {
                    name: "fgWhiteLabel",
                    label: "Foreground Image Label Color",
                    component: "toggle",
                    toggleLabels: {
                        true: "White",
                        false: "Black"
                    }
                },
                {
                    name: "modalTitle",
                    label: "Modal Title",
                    component: "text",
                    description: "Heading for the modal that will show the list of products from the current preview if not populated the modal will have no heading"
                },
                {
                    name: "modalTitleFont",
                    label: "Modal Title Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-hafferBold",
                    description: "Select the font for the modal title text"
                },
                {
                    name: "products",
                    label: "Products Used",
                    component: "group-list",
                    description: "List of products used for the current item, if none is provided, the button to view products will not be shown",
                    fields: [
                        {
                            name: "product",
                            label: "Product",
                            component: "productSearch"
                        },
                        {
                            name: "current",
                            label: "Is current product?",
                            component: "toggle",
                            description: "Only one product can be marked as current, if more than one is marked as current, the first one will be used, also the current product will allways become first on the list"
                        }
                    ],
                    validate: {
                        maxItems: 4
                    }
                }
            ]
        }
    ]
};

;// CONCATENATED MODULE: ./src/sections/BeforeAfterSlider/index.js


;// CONCATENATED MODULE: ./src/sections/VideoWise/VideoWise.jsx






function VideoWise(param) {
    var cms = param.cms;
    var currency = (0,dist.useCurrency)();
    var product = (0,dist.useProduct)();
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var isBrowser = "object" !== "undefined";
    var ref = (0,react.useState)(isBrowser ? document.getElementById("videowise-style-css") : null), styleEl = ref[0], setStyleEl = ref[1];
    var ref1 = (0,react.useState)(isBrowser ? document.getElementById("videowise-vendors-js") : null), vendorsEl = ref1[0], setVendorsEl = ref1[1];
    var ref2 = (0,react.useState)(isBrowser ? document.getElementById("videowise-client-js") : null), clientEl = ref2[0], setClientEl = ref2[1];
    var ref3 = (0,react.useState)(false), addedProductToCart = ref3[0], setAddedProductToCart = ref3[1];
    var handleAddToCart = function(event) {
        setAddedProductToCart(true);
        var item = {
            merchandiseId: "gid://shopify/ProductVariant/".concat(event.detail.variantId),
            quantity: event.detail.qty || 1,
            attributes: [
                {
                    key: "_sc",
                    value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                }
            ]
        };
        if (event.detail.subscriptionId) {
            item.sellingPlanId = btoa("gid://shopify/SellingPlan/".concat(event.detail.subscriptionId));
        }
        cartAddItem(item);
    };
    var openCart = function() {
        if (addedProductToCart == true) {
            window.dispatchEvent(new CustomEvent("openSideCart"));
            setAddedProductToCart(false);
        }
    };
    (0,react.useState)(function() {
        if (isBrowser && !styleEl) {
            var style = document.createElement("link");
            style.rel = "stylesheet";
            style.as = "style";
            style.href = "https://assets.videowise.com/style.css.gz";
            style.id = "videowise-style-css";
            document.head.appendChild(style);
            setStyleEl(document.getElementById("videowise-style-css"));
        }
        if (isBrowser && !vendorsEl) {
            var vendors = document.createElement("script");
            vendors.type = "text/javascript";
            vendors.id = "videowise-vendors-js";
            vendors.async = true;
            vendors.defer = true;
            vendors.src = "https://assets.videowise.com/vendors.js.gz";
            document.head.appendChild(vendors);
            setVendorsEl(document.getElementById("videowise-vendor-js"));
        }
        if (isBrowser && !clientEl) {
            var client = document.createElement("script");
            client.type = "text/javascript";
            client.id = "videowise-client-js";
            client.async = true;
            client.defer = true;
            client.src = "https://assets.videowise.com/client.js.gz";
            document.head.appendChild(client);
            setClientEl(document.getElementById("videowise-client-js"));
        }
        if (isBrowser && !clientEl && !styleEl && !vendorsEl) {
            window.addEventListener("videowiseProductAddToCart", handleAddToCart);
            window.addEventListener("videowisePlayerClose", openCart);
        }
        return function() {
            document.removeChild(styleEl);
            document.removeChild(vendorsEl);
            document.removeChild(clientEl);
            window.removeEventListener("videowiseProductAddToCart", handleAddToCart);
            window.removeEventListener("videowisePlayerClose", openCart);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(VideoWise.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": VideoWise.displayName,
        className: "video-wise",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                id: "videoWiseSettiings-".concat(VideoWise.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
                dangerouslySetInnerHTML: {
                    __html: "var SKIP_CART=false;\n          var FORCE_DOMAIN = true;\n          var VIDEOWISE_FAST_INLINE_VIDEO_PLAYER = true;\n          var Shopify = {\n            shop: 'https://briogeo-hair-care.myshopify.com',\n            currency: {\n              active: \"".concat(currency || "USD", '",\n              rate: "1.0"\n            }\n          };\n\n          var __st = {\n            rid: ').concat(product ? '"' + product.legacyResourceId + '"' : null, ',\n            p: "').concat(product ? "product" : "home", "\"\n          };\n\n          var videowiseShadow = {\n            mode: 'open',\n            assets: [\n              {\n                type: 'style',\n                src: \"").concat(product ? "/components/videowise-product.css" : "/components/videowise.css", '",\n              }\n            ]\n          };\n        ')
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "\n        #".concat(VideoWise.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n          margin-top: ").concat(cms.mobileSpacing, "px;\n          margin-bottom: ").concat(cms.mobileBottomSpacing, "px;\n        }\n        @media(min-width: 1024px) {\n          #").concat(VideoWise.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.desktopSpacing, "px;\n            margin-bottom: ").concat(cms.desktopBottomSpacing, "px;\n          }\n        }\n      ")
            }),
            (cms === null || cms === void 0 ? void 0 : cms.codeSnippet) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n            ".concat(cms.flushEdges ? "lg:px-0" : "lg:container lg:px-5 lg:mx-auto", "\n            ").concat(cms.mobileFlushEdges ? "px-0" : "sm:container md:container px-5 mx-auto", "\n            ").concat((cms === null || cms === void 0 ? void 0 : cms.codeSnippetFont) || "", "\n          "),
                dangerouslySetInnerHTML: {
                    __html: cms.codeSnippet
                }
            })
        ]
    });
}
VideoWise.displayName = "VideoWise";
VideoWise.Schema = {
    category: "Modules",
    label: VideoWise.displayName,
    key: "VideoWise",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "number",
            name: "mobileBottomSpacing",
            label: "Section Bottom Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopBottomSpacing",
            label: "Section Bottom Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "toggle",
            name: "flushEdges",
            label: "Flush to edges (desktop)",
            description: "Allows the module to reach the edges of the container where it is located - Use only on pages other than PDP",
            defaultValue: false,
            toggleLabels: {
                true: "yes",
                false: "no"
            }
        },
        {
            component: "toggle",
            name: "mobileFlushEdges",
            label: "Flush to edges (mobile)",
            description: "Allows the module to reach the edges of the container where it is located - Use only on pages other than PDP",
            defaultValue: false,
            toggleLabels: {
                true: "yes",
                false: "no"
            }
        },
        {
            component: "html",
            name: "codeSnippet",
            label: "VideoWise Code Snippet"
        },
        {
            name: "codeSnippetFont",
            label: "VideoWise Code Snippet Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the VideoWise code snippet"
        }
    ]
};

;// CONCATENATED MODULE: ./src/sections/VideoWise/index.js


;// CONCATENATED MODULE: ./src/sections/BuyWithPrimePLP/BuyWithPrimePLP.jsx


function BuyWithPrimePLP(param) {
    var cms = param.cms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(BuyWithPrimePLP.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        className: "buy-with-prime-plp",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(BuyWithPrimePLP.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(BuyWithPrimePLP.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mr-auto ml-auto w-full max-w-[1440px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mr-[24px] mb-[60px] ml-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                            "data-target-id": "9huhml8i1e",
                            src: "https://cdn.us-east-1.prod.moon.dubai.aws.dev/fOslgRaZeZE9/REaTi65ZYr0K/latest/scripts/elements.js"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("bwp-collection", {
                            "content-item-id": "gq7kvrxvmk"
                        })
                    ]
                })
            })
        ]
    });
}
BuyWithPrimePLP.displayName = "BuyWithPrimePLP";
BuyWithPrimePLP.Schema = {
    category: "BuyWithPrimePLP",
    label: BuyWithPrimePLP.displayName,
    key: "buyWithPrimePLP",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/BuyWithPrimePLP/index.js


;// CONCATENATED MODULE: ./src/sections/CtaSlider/CtaSlider.schema.js

var COLORS = [
    {
        label: "Transparent",
        value: "var(--transparent)"
    },
    {
        label: "White",
        value: "var(--white)"
    },
    {
        label: "Dark Loden",
        value: "var(--dark-loden)"
    },
    {
        label: "Dark Orion",
        value: "var(--dark-orion)"
    },
    {
        label: "Orion",
        value: "var(--orion)"
    },
    {
        label: "Light Desert",
        value: "var(--light-desert)"
    }, 
];
function CtaSlider_schema_Schema() {
    return {
        category: "Navigation",
        label: "CtaSlider",
        key: "cta-slider",
        previewSrc: "https://cdn.shopify.com/s/files/1/1616/9825/files/in-page-nagigation.jpg?v=1717094674",
        fields: [
            {
                component: "number",
                name: "mobileSpacing",
                label: "Section Top Margin - Mobile",
                defaultValue: 60
            },
            {
                component: "number",
                name: "desktopSpacing",
                label: "Section Top Margin - Desktop",
                defaultValue: 80
            },
            {
                component: "toggle",
                name: "isFullwidth",
                label: "Full Width",
                toggleLabels: {
                    true: "Full Width",
                    false: "Grid width"
                },
                defaultValue: true
            },
            {
                component: "toggle",
                name: "enableSlider",
                label: "Enable Slider",
                defaultValue: true,
                toggleLabels: {
                    true: "Enable",
                    false: "Disable"
                }
            },
            {
                label: "CTA",
                name: "cta",
                component: "group-list",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                validate: {
                    minItems: 2,
                    maxItems: 8
                },
                fields: [
                    {
                        label: "CTA Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "CTA Title Font",
                        name: "titleFont",
                        component: "select",
                        options: FontSelector,
                        defaultValue: "font-hafferBold",
                        description: "Select the font for the title text"
                    },
                    {
                        label: "CTA URL",
                        name: "link",
                        component: "link"
                    },
                    {
                        label: "CTA Link Style",
                        name: "cta_style",
                        component: "select",
                        options: [
                            {
                                label: "Primary",
                                value: "no-underline button button--primary"
                            },
                            {
                                label: "Primary - Air Dry Cream",
                                value: "no-underline button button--primary-stylers-1"
                            },
                            {
                                label: "Primary - Sculpting Cream",
                                value: "no-underline button button--primary-stylers-2"
                            },
                            {
                                label: "Primary - Texture Foam",
                                value: "no-underline button button--primary-stylers-3"
                            },
                            {
                                label: "Primary - Sleek Stick",
                                value: "no-underline button button--primary-stylers-4"
                            },
                            {
                                label: "Secondary",
                                value: "no-underline button button--secondary"
                            },
                            {
                                label: "checkout",
                                value: "no-underline button button--checkout inline-block"
                            }, 
                        ],
                        defaultValue: "no-underline button button--primary"
                    },
                    {
                        label: "CTA Visibility",
                        name: "cta_visibility",
                        component: "select",
                        options: [
                            {
                                label: "Desktop",
                                value: "desktop"
                            },
                            {
                                label: "Mobile",
                                value: "mobile"
                            },
                            {
                                label: "Both",
                                value: ""
                            }, 
                        ],
                        defaultValue: ""
                    }, 
                ],
                defaultItem: {
                    label: "New CTA"
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/CtaSlider/CtaSlider.jsx
function CtaSlider_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CtaSlider_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return CtaSlider_arrayLikeToArray(arr);
}
function CtaSlider_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function CtaSlider_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CtaSlider_toConsumableArray(arr) {
    return CtaSlider_arrayWithoutHoles(arr) || CtaSlider_iterableToArray(arr) || CtaSlider_unsupportedIterableToArray(arr) || CtaSlider_nonIterableSpread();
}
function CtaSlider_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CtaSlider_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CtaSlider_arrayLikeToArray(o, minLen);
}




function CtaSlider(param1) {
    var cms = param1.cms;
    var ref3;
    var moduleID = "".concat(CtaSlider_schema_Schema().key, "-").concat(cms.id || cms.cmsId || cms.tinaId);
    var isFullwidth = (cms === null || cms === void 0 ? void 0 : cms.isFullwidth) || false;
    var itemCount = (cms === null || cms === void 0 ? void 0 : (ref3 = cms.cta) === null || ref3 === void 0 ? void 0 : ref3.length) || 0;
    var enableSlider = (cms === null || cms === void 0 ? void 0 : cms.enableSlider) || false;
    var sliderRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(0), mgRight = ref1[0], setMgRight = ref1[1];
    var ref2 = (0,react.useState)("justify-center"), justify = ref2[0], setjustify = ref2[1];
    var titleFont = (cms === null || cms === void 0 ? void 0 : cms.titleFont) || "font-hafferBold";
    (0,react.useEffect)(function() {
        if (!(sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) || !enableSlider) return;
        var isDown = false;
        var startX;
        var scrollLeft;
        var slider1 = sliderRef.current;
        var onSliderMousedown = function(e) {
            var slider = e.currentTarget;
            isDown = true;
            slider.classList.add("select-none", "!cursor-grabbing", "snap-none");
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        };
        var onSliderMouseleave = function(e) {
            var slider = e.currentTarget;
            isDown = false;
            slider.classList.remove("active");
        };
        var onSliderMouseup = function(e) {
            var slider = e.currentTarget;
            e.preventDefault();
            isDown = false;
            slider.classList.remove("select-none", "!cursor-grabbing", "snap-none");
        };
        var onSliderMousemove = function(e) {
            if (!isDown) return;
            var slider = e.currentTarget;
            e.preventDefault();
            var x = e.pageX - slider.offsetLeft;
            var walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        };
        slider1.addEventListener("mousedown", onSliderMousedown);
        slider1.addEventListener("mouseleave", onSliderMouseleave);
        slider1.addEventListener("mouseup", onSliderMouseup);
        slider1.addEventListener("mousemove", onSliderMousemove);
        var reachRightEdge = function() {
            if (!(sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current)) return;
            var slider = sliderRef.current;
            var right = -1 * sliderRef.current.offsetLeft;
            if (slider.scrollWidth > slider.clientWidth) {
                slider.classList.add("pr-4", "lg:pr-12");
                setjustify("justify-start");
                setMgRight("".concat(right, "px"));
            } else {
                slider.classList.remove("pr-4", "lg:pr-12");
                setjustify("justify-center");
                setMgRight(0);
            }
        };
        reachRightEdge();
        window.addEventListener("resize", reachRightEdge);
        var EXCLUDED_ANCHOR_LINKS = [];
        var header = document.querySelector(".site-header");
        var clamp = function(min, value, max) {
            return Math.min(Math.max(value, min), max);
        };
        var handleClick = function(e) {
            var ref;
            var anchor = e.target;
            if (!anchor || !(anchor === null || anchor === void 0 ? void 0 : anchor.hash) || (anchor === null || anchor === void 0 ? void 0 : (ref = anchor.dataset) === null || ref === void 0 ? void 0 : ref.initialized)) return;
            var anchorEl = document.querySelector(anchor.hash);
            if (!anchorEl) {
                return;
            }
            if (!/^#\D/.test(anchor.hash) || EXCLUDED_ANCHOR_LINKS.includes(anchor.hash)) return;
            e.preventDefault();
            var shift = anchorEl.offsetTop - window.scrollY;
            var distance = Math.abs(shift);
            var duration = clamp(300, distance, 1200) / 1000;
            document.body.classList.add("pointer-events-none");
            window.scrollTo({
                top: anchorEl.offsetTop - (header ? header.offsetHeight : 0),
                behavior: "smooth"
            });
            setTimeout(function() {
                document.body.classList.remove("pointer-events-none");
            }, duration * 1000);
            anchor.dataset.initialized = true;
        };
        var anchors = CtaSlider_toConsumableArray(slider1.querySelectorAll('a[href^="#"], a[href^="'.concat(window.location.pathname, '#"]')));
        anchors.forEach(function(anchor) {
            anchor.addEventListener("click", handleClick);
        });
        return function() {
            window.removeEventListener("resize", reachRightEdge);
            var slider = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current;
            if (slider) {
                slider.removeEventListener("mousedown", onSliderMousedown);
                slider.removeEventListener("mouseleave", onSliderMouseleave);
                slider.removeEventListener("mouseup", onSliderMouseup);
                slider.removeEventListener("mousemove", onSliderMousemove);
                anchors.forEach(function(anchor) {
                    anchor.removeEventListener("click", handleClick);
                });
            }
        };
    }, [
        sliderRef,
        enableSlider
    ]);
    (0,react.useEffect)(function() {}, []);
    if (itemCount <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(moduleID),
        className: "cta-slider px-4 lg:px-12 w-full".concat(isFullwidth ? "" : " max-w-[1180px] mx-auto"),
        "data-comp": CtaSlider.displayName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(moduleID, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(moduleID, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-0 flex flex-row",
                style: {
                    marginRight: mgRight
                },
                children: itemCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "scrollbar-hidden snap-mandatory will-change-scroll my-0 list-none pl-0 w-full flex flex-row ".concat(justify, " max-sm:items-center gap-3 ").concat(enableSlider ? " scrollbar" : "flex-wrap max-sm:flex-col"),
                    ref: sliderRef,
                    children: cms === null || cms === void 0 ? void 0 : cms.cta.map(function(param, index) {
                        var title = param.title, link = param.link, cta_style = param.cta_style, cta_visibility = param.cta_visibility, className = param.className;
                        var class_visibility = "";
                        if (cta_visibility === "desktop") {
                            class_visibility = "max-lg:hidden";
                        } else if (cta_visibility === "mobile") {
                            class_visibility = "lg:hidden";
                        }
                        return (link === null || link === void 0 ? void 0 : link.url) && (title || (link === null || link === void 0 ? void 0 : link.text)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full max-w-[225px] sm:max-w-[max(20%-0.6rem,151px)] md:max-w-max lg:min-w-[155px] flex-shrink-0 scroll-mr-6 ".concat(titleFont),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: link.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "".concat(cta_style, " ").concat(class_visibility, " block text-center w-full !min-w-0 pointer-events-none1 !cursor-[inherit] max-xs:px-2 !font-[inherit]"),
                                    draggable: "false",
                                    children: title || (link === null || link === void 0 ? void 0 : link.text)
                                })
                            })
                        }, "cta-slider-".concat(index));
                    })
                })
            })
        ]
    }, cms.tinaId);
}
CtaSlider.displayName = "CtaS lider";
CtaSlider.Schema = CtaSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CtaSlider/index.js


;// CONCATENATED MODULE: ./src/sections/HowToBuildBundle/HowToBuildBundle.jsx
function HowToBuildBundle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HowToBuildBundle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HowToBuildBundle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function HowToBuildBundle_Section(param) {
    var cms = param.cms;
    var ref5, ref1, ref2, ref3, ref4;
    var itemCount = (cms === null || cms === void 0 ? void 0 : (ref5 = cms.items) === null || ref5 === void 0 ? void 0 : ref5.length) || 0;
    var textColor = (cms === null || cms === void 0 ? void 0 : cms.textColor) || "black";
    var sectionCta = cms === null || cms === void 0 ? void 0 : cms.cta;
    var sectionSubTitleFont = (cms === null || cms === void 0 ? void 0 : cms.sectionSubTitleFont) || "font-haffer";
    var sectionTitleFont = (cms === null || cms === void 0 ? void 0 : cms.sectionTitleFont) || "font-hafferBold";
    var sectionDescriptionFont = (cms === null || cms === void 0 ? void 0 : cms.sectionDescriptionFont) || "font-haffer";
    if (itemCount <= 0) {
        return null;
    }
    var slideSettings = {
        infinite: false,
        variableWidth: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        swipeToSlide: true,
        swipe: true,
        adaptiveHeight: false,
        useTransform: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2.1,
                    dots: true
                }
            },
            {
                breakpoint: 680,
                settings: {
                    slidesToShow: 1.8,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.3,
                    dots: true
                }
            },
            {
                breakpoint: 390,
                settings: {
                    slidesToShow: 1.1,
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "".concat(HowToBuildBundle_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        className: "section-howto-build-bundle section-howto-build-bundle--".concat(cms === null || cms === void 0 ? void 0 : cms.layout, " pt-[35px] pb-14 lg:pb:16 text-").concat(cms === null || cms === void 0 ? void 0 : cms.contentAlign, " text-").concat(textColor, " ").concat(cms.bgColor),
        "data-comp": HowToBuildBundle_Section.displayName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((cms === null || cms === void 0 ? void 0 : cms.layout) == "container" ? "mx-auto max-w-[1188px]" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-5",
                    children: [
                        (cms === null || cms === void 0 ? void 0 : cms.sectionSubTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sub-regular ".concat(sectionSubTitleFont),
                            children: cms === null || cms === void 0 ? void 0 : cms.sectionSubTitle
                        }),
                        (cms === null || cms === void 0 ? void 0 : cms.sectionTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-h4-m md:text-h4 my-1 p-0 ".concat(sectionTitleFont),
                            children: cms === null || cms === void 0 ? void 0 : cms.sectionTitle
                        }),
                        (cms === null || cms === void 0 ? void 0 : cms.sectionDescription) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-large ".concat(sectionDescriptionFont),
                            children: cms === null || cms === void 0 ? void 0 : cms.sectionDescription
                        }),
                        (sectionCta === null || sectionCta === void 0 ? void 0 : (ref1 = sectionCta.link) === null || ref1 === void 0 ? void 0 : ref1.text) && (sectionCta === null || sectionCta === void 0 ? void 0 : (ref2 = sectionCta.link) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: sectionCta.link.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "".concat(sectionCta.style, " no-underline mt-6 lg:mt-4 ").concat(sectionDescriptionFont),
                                target: sectionCta.link.newTab ? "_blank" : null,
                                children: sectionCta.link.text
                            })
                        })
                    ]
                }),
                (cms === null || cms === void 0 ? void 0 : (ref3 = cms.items) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-9 lg:mt-11 ".concat((cms === null || cms === void 0 ? void 0 : cms.layout) == "container" ? "md:px-5" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToBuildBundle_CustomSlider, {
                        settings: slideSettings,
                        className: "flex flex-nowrap md:flex-wrap md:justify-center ".concat((cms === null || cms === void 0 ? void 0 : cms.layout) == "container" ? "gap-6" : ""),
                        children: cms === null || cms === void 0 ? void 0 : (ref4 = cms.items) === null || ref4 === void 0 ? void 0 : ref4.map(function(cta, index) {
                            var ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemHtml, {
                                item: cta,
                                index: index,
                                textColor: textColor,
                                showStepNumber: cms === null || cms === void 0 ? void 0 : cms.showStepNumber,
                                itemContentAlign: cms === null || cms === void 0 ? void 0 : cms.itemContentAlign,
                                isLastItem: (cms === null || cms === void 0 ? void 0 : (ref = cms.items) === null || ref === void 0 ? void 0 : ref.length) - 1 === index,
                                layout: cms === null || cms === void 0 ? void 0 : cms.layout
                            }, index);
                        })
                    })
                })
            ]
        })
    }, cms.cmsId);
}
function HowToBuildBundle_CustomSlider(param, props) {
    var className = param.className, settings = param.settings, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, HowToBuildBundle_objectSpread({}, settings, props, {
                    children: children
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-md:hidden ".concat(className),
                children: children
            })
        ]
    });
}
function ItemHtml(param) {
    var item = param.item, index = param.index, textColor = param.textColor, showStepNumber = param.showStepNumber, itemContentAlign = param.itemContentAlign, isLastItem = param.isLastItem, layout = param.layout;
    var ref, ref6;
    if (!(item === null || item === void 0 ? void 0 : (ref = item.image) === null || ref === void 0 ? void 0 : ref.src) && !(item === null || item === void 0 ? void 0 : item.title) && !(item === null || item === void 0 ? void 0 : item.description)) return null;
    var titleFont = (item === null || item === void 0 ? void 0 : item.titleFont) || "font-haffer";
    var descriptionFont = (item === null || item === void 0 ? void 0 : item.descriptionFont) || "font-haffer";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex-1 md:p-0\n        text-".concat(textColor, " text-").concat(itemContentAlign, " border-").concat(textColor, " h-full md:h-auto flex flex-col\n        ").concat(layout == "container" ? "max-w-[368px] pl-4" : ""),
        "data-slide": true,
        "data-index": index,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex flex-col h-full ".concat(layout == "container" ? "border" : "border-y border-l", " ").concat(isLastItem && layout != "container" ? 'after:content-[""] after:absolute after:h-full after:border-l after:border-'.concat(textColor, " after:right-0") : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1 flex items-center",
                    children: [
                        showStepNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[50px] leading-[62px] font-tiempos font-light flex items-center justify-center m-0 min-w-[80px]",
                            children: index + 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col justify-center h-full py-4 px-5 lg:py-6 ".concat(showStepNumber ? "border-l border-".concat(textColor) : ""),
                            children: [
                                (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "m-0 mb-1 sub-regular ".concat(titleFont),
                                    children: item === null || item === void 0 ? void 0 : item.title
                                }),
                                (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-small ".concat(descriptionFont),
                                    children: item === null || item === void 0 ? void 0 : item.description
                                })
                            ]
                        })
                    ]
                }),
                (item === null || item === void 0 ? void 0 : (ref6 = item.image) === null || ref6 === void 0 ? void 0 : ref6.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full h-0 pt-[115.5%] border-t border-".concat(textColor),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: item.image.src,
                        className: "absolute inset-0 w-full h-full p-4 object-contain",
                        alt: item.title,
                        width: "736",
                        height: "850"
                    })
                })
            ]
        })
    });
}
HowToBuildBundle_Section.displayName = "Bundle Builder How to";
var HowToBuildBundle_obj, HowToBuildBundle_obj1, HowToBuildBundle_obj2;
HowToBuildBundle_Section.Schema = {
    category: "Modules",
    label: HowToBuildBundle_Section.displayName,
    key: "bundle-builder-how-to",
    fields: [
        {
            component: "select",
            name: "layout",
            label: "Layout",
            options: [
                {
                    label: "Full Width",
                    value: "fullWidth"
                },
                {
                    label: "Container",
                    value: "container"
                }
            ],
            defaultValue: "container"
        },
        {
            component: "select",
            name: "contentAlign",
            label: "Heading Alignment",
            options: [
                {
                    label: "Left",
                    value: "left"
                },
                {
                    label: "Center",
                    value: "center"
                },
                {
                    label: "Right",
                    value: "right"
                }, 
            ],
            defaultValue: "center"
        },
        {
            component: "text",
            label: "Section SubTitle",
            name: "sectionSubTitle",
            defaultValue: "Bundle builder"
        },
        (HowToBuildBundle_obj = {
            component: "select",
            name: "sectionSubTitleFont",
            label: "Section Sub Title Font"
        }, HowToBuildBundle_defineProperty(HowToBuildBundle_obj, "component", "select"), HowToBuildBundle_defineProperty(HowToBuildBundle_obj, "options", FontSelector), HowToBuildBundle_defineProperty(HowToBuildBundle_obj, "defaultValue", "font-haffer"), HowToBuildBundle_defineProperty(HowToBuildBundle_obj, "description", "Select the font for the section sub title text"), HowToBuildBundle_obj),
        {
            component: "text",
            label: "Section Title",
            name: "sectionTitle",
            defaultValue: "Customize your routine"
        },
        (HowToBuildBundle_obj1 = {
            component: "select",
            name: "sectionTitleFont",
            label: "Section Title Font"
        }, HowToBuildBundle_defineProperty(HowToBuildBundle_obj1, "component", "select"), HowToBuildBundle_defineProperty(HowToBuildBundle_obj1, "options", FontSelector), HowToBuildBundle_defineProperty(HowToBuildBundle_obj1, "defaultValue", "font-hafferBold"), HowToBuildBundle_defineProperty(HowToBuildBundle_obj1, "description", "Select the font for the section title text"), HowToBuildBundle_obj1),
        {
            component: "textarea",
            label: "Section Description",
            name: "sectionDescription",
            defaultValue: "Create your perfect routine and save at the same time."
        },
        (HowToBuildBundle_obj2 = {
            component: "select",
            name: "sectionDescriptionFont",
            label: "Section Description Font"
        }, HowToBuildBundle_defineProperty(HowToBuildBundle_obj2, "component", "select"), HowToBuildBundle_defineProperty(HowToBuildBundle_obj2, "options", FontSelector), HowToBuildBundle_defineProperty(HowToBuildBundle_obj2, "defaultValue", "font-haffer"), HowToBuildBundle_defineProperty(HowToBuildBundle_obj2, "description", "Select the font for the section description text"), HowToBuildBundle_obj2),
        {
            label: "CTA",
            name: "cta",
            component: "group",
            fields: [
                {
                    label: "CTA URL",
                    name: "link",
                    component: "link"
                },
                {
                    component: "select",
                    name: "style",
                    label: "Cta Style",
                    options: [
                        {
                            label: "Primary",
                            value: "button button--primary inline-block"
                        },
                        {
                            label: "Secondary",
                            value: "button button--secondary inline-block"
                        },
                        {
                            label: "Tertiary",
                            value: "button button--tertiary inline-block"
                        },
                        {
                            label: "Focus Link",
                            value: "focus-link"
                        },
                        {
                            label: "Focus Link White",
                            value: "focus-link-white"
                        },
                        {
                            label: "checkout",
                            value: "button button--checkout inline-block"
                        }, 
                    ],
                    defaultValue: "button button--primary inline-block"
                }, 
            ]
        },
        {
            component: "select",
            name: "textColor",
            label: "Text Color",
            options: [
                {
                    label: "Light",
                    value: "white"
                },
                {
                    label: "Dark",
                    value: "black"
                }, 
            ],
            defaultValue: "black"
        },
        {
            component: "select",
            name: "bgColor",
            label: "Background Color",
            description: "For section background color, select one from preselected brand colors.",
            options: [
                {
                    label: "Black",
                    value: "bg-black"
                },
                {
                    label: "White",
                    value: "bg-white"
                },
                {
                    label: "Grey",
                    value: "bg-grey-1"
                },
                {
                    label: "Light Grey",
                    value: "bg-grey-9"
                },
                {
                    label: "Blue 1",
                    value: "bg-quinary-1"
                },
                {
                    label: "Blue 2",
                    value: "bg-quinary-2"
                },
                {
                    label: "Blue 3",
                    value: "bg-light-blue"
                },
                {
                    label: "Cream 1",
                    value: "bg-tertiary-2"
                },
                {
                    label: "Cream 2",
                    value: "bg-senary-4"
                },
                {
                    label: "Purple",
                    value: "bg-tertiary-1"
                },
                {
                    label: "Green",
                    value: "bg-quaternary-1"
                },
                {
                    label: "Pink 1",
                    value: "bg-primary-2"
                },
                {
                    label: "Pink 2",
                    value: "bg-secondary-1"
                },
                {
                    label: "Yellow",
                    value: "bg-yellow"
                },
                {
                    label: "Orange",
                    value: "bg-secondary-2"
                },
                {
                    label: "Seafoam 1",
                    value: "bg-quaternary-2"
                },
                {
                    label: "Seafoam 2",
                    value: "bg-senary-3"
                },
                {
                    label: "Seafoam 3",
                    value: "bg-senary-5"
                },
                {
                    label: "Air Dry Cream",
                    value: "bg-stylers-1"
                },
                {
                    label: "Sculpting Cream",
                    value: "bg-stylers-2"
                },
                {
                    label: "Texture Foam",
                    value: "bg-stylers-3"
                },
                {
                    label: "Sleek Stick",
                    value: "bg-stylers-4"
                },
                {
                    label: "Scalp Blue",
                    value: "bg-scalp-blue"
                },
                {
                    label: "Magenta",
                    value: "bg-magenta"
                },
                {
                    label: "Medium Pink",
                    value: "bg-med-pink"
                },
                {
                    label: "Briogeo Blue",
                    value: "bg-brio-blue"
                },
                {
                    label: "Cloud",
                    value: "bg-cloud"
                },
                {
                    label: "Mineral",
                    value: "bg-mineral"
                },
                {
                    label: "Deep Sea",
                    value: "bg-deep-sea"
                },
                {
                    label: "Sandstone",
                    value: "bg-sandstone"
                },
                {
                    label: "Sorrel",
                    value: "bg-sorrel"
                },
                {
                    label: "Butter",
                    value: "bg-butter"
                },
                {
                    label: "Rosehip",
                    value: "bg-rosehip"
                },
                {
                    label: "Chestnut",
                    value: "bg-chestnut"
                }, 
            ],
            defaultValue: "bg-grey-9"
        },
        {
            component: "toggle",
            name: "showStepNumber",
            label: "Show Step Number in Item?",
            toggleLabels: {
                true: "Show",
                false: "Hide"
            },
            defaultValue: true
        },
        {
            component: "select",
            name: "itemContentAlign",
            label: "Item Content Alignment",
            options: [
                {
                    label: "Left",
                    value: "left"
                },
                {
                    label: "Center",
                    value: "center"
                },
                {
                    label: "Right",
                    value: "right"
                }, 
            ],
            defaultValue: "left"
        },
        {
            component: "group-list",
            name: "items",
            label: "Items",
            itemProps: {
                label: "{{item.title}}"
            },
            fields: [
                {
                    label: "Image",
                    name: "image",
                    component: "image",
                    description: "Recommended Image Size: 736px x 850px"
                },
                {
                    label: "Title",
                    name: "title",
                    component: "text"
                },
                {
                    label: "Title Font",
                    name: "titleFont",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-hafferBold",
                    description: "Select the font for the title text"
                },
                {
                    label: "Description",
                    name: "description",
                    component: "textarea"
                },
                {
                    label: "Description Font",
                    name: "descriptionFont",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the description text"
                }, 
            ],
            validate: {
                maxItems: 3
            }
        }
    ]
};
var HowToBuildBundle = HowToBuildBundle_Section;

;// CONCATENATED MODULE: ./src/sections/HowToBuildBundle/index.js


;// CONCATENATED MODULE: ./src/sections/Quotes/Quotes.jsx
function Quotes_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Quotes_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Quotes_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function Quotes(param) {
    var cms = param.cms;
    var slider = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(0), currentSlide = ref2[0], setCurrentSlide = ref2[1];
    var quoteSlides = cms.quotes.filter(function(slide) {
        if (slide.authorImage || slide.author) {
            return true;
        }
    });
    var afterChangeHandler = function(oldIndex, newIndex) {
        setCurrentSlide(newIndex);
    };
    var buildSlides = function() {
        return quoteSlides.map(function(quoteObj) {
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "quotes__quote text-h2-m lg:text-h2 mb-0 ".concat((quoteObj === null || quoteObj === void 0 ? void 0 : quoteObj.quoteFont) || "font-tiempos"),
                        children: quoteObj.quote
                    }),
                    quoteObj.authorImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: (ref = quoteObj.authorImage) === null || ref === void 0 ? void 0 : ref.src,
                        alt: ((ref1 = quoteObj.authorImage) === null || ref1 === void 0 ? void 0 : ref1.alt) || "",
                        width: quoteObj.authorImage.width,
                        height: quoteObj.authorImage.height,
                        loading: "lazy",
                        sizes: "100vw",
                        className: "h-20 w-auto md:!hidden mx-auto mt-6 mb-2"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "quotes__author text-h5-m mb-2 mt-6 md:!hidden ".concat((quoteObj === null || quoteObj === void 0 ? void 0 : quoteObj.authorFont) || "font-hafferBold"),
                        children: quoteObj.author
                    })
                ]
            });
        });
    };
    var buildQuotesButtons = function() {
        return quoteSlides.map(function(quoteObj, index) {
            var markerClasses = "quotes__button transition-all duration-300 ease-in-out h-20 after:relative after:w-full after:border-b-2 after:border-currentcolor after:opacity-0 after:block after:mt-2.5";
            var activeClasses = "after:opacity-100 opacity-100";
            if (quoteObj.authorImage) {
                var ref, ref3;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "quotes__button ".concat(markerClasses, " ").concat(index === currentSlide ? activeClasses : "opacity-40"),
                    onClick: function() {
                        return slider.current.slickGoTo(index);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: (ref = quoteObj.authorImage) === null || ref === void 0 ? void 0 : ref.src,
                        alt: ((ref3 = quoteObj.authorImage) === null || ref3 === void 0 ? void 0 : ref3.alt) || "",
                        width: quoteObj.authorImage.width,
                        height: quoteObj.authorImage.height,
                        loading: "lazy",
                        sizes: "100vw",
                        className: "h-20 w-auto mx-auto"
                    })
                }, "slider-button-" + index);
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "quotes__button font-hafferBold text-h5 ".concat(markerClasses, " ").concat(index === currentSlide ? activeClasses : "opacity-50"),
                    onClick: function() {
                        return slider.current.slickGoTo(index);
                    },
                    children: quoteObj.author
                }, "slider-button-" + index);
            }
        });
    };
    var slideSettings = {
        slidesToShow: 1,
        infinite: true,
        centerMode: true,
        dots: false,
        arrows: false,
        fade: false,
        adaptiveHeight: true,
        centerPadding: 0,
        beforeChange: afterChangeHandler,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "quotes__container pt-12 pb-10 md:pt-16 md:pb-14 w-full px-5 ".concat(cms.fgColor, " ").concat(cms.bgColor, " [&_.slick-dots_li]:border-currentcolor [&_.slick-dots_li]:bg-currentcolor [&_.slick-dots_li.slick-active]:bg-transparent [&_.slick-dots_li.slick-active~li]:!bg-currentcolor"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "quotes__inner mx-auto text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-h6-m lg:text-h6 mb-4 md:mb-6 ".concat((cms === null || cms === void 0 ? void 0 : cms.headingFont) || "font-hafferBold"),
                    children: cms.heading
                }),
                cms.quotes && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, Quotes_objectSpread({
                            className: "quotes__inner max-w-[990px] mt-5 lg:mb-12 mx-auto"
                        }, slideSettings, {
                            ref: slider,
                            children: buildSlides()
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "quotes__custom-buttons hidden lg:flex flex-wrap gap-9 justify-center",
                            children: buildQuotesButtons()
                        })
                    ]
                })
            ]
        })
    });
}
Quotes.displayName = "Quotes";
Quotes.Schema = {
    category: "Modules",
    label: Quotes.displayName,
    key: "quotesModule",
    fields: [
        {
            component: "select",
            name: "bgColor",
            label: "Background Color",
            description: "For section background color, select one from preselected brand colors.",
            options: [
                {
                    label: "Black",
                    value: "bg-black"
                },
                {
                    label: "White",
                    value: "bg-white"
                },
                {
                    label: "Grey",
                    value: "bg-grey-1"
                },
                {
                    label: "Light Grey",
                    value: "bg-grey-9"
                },
                {
                    label: "Blue 1",
                    value: "bg-quinary-1"
                },
                {
                    label: "Blue 2",
                    value: "bg-quinary-2"
                },
                {
                    label: "Blue 3",
                    value: "bg-light-blue"
                },
                {
                    label: "Cream 1",
                    value: "bg-tertiary-2"
                },
                {
                    label: "Cream 2",
                    value: "bg-senary-4"
                },
                {
                    label: "Purple",
                    value: "bg-tertiary-1"
                },
                {
                    label: "Green",
                    value: "bg-quaternary-1"
                },
                {
                    label: "Pink 1",
                    value: "bg-primary-2"
                },
                {
                    label: "Pink 2",
                    value: "bg-secondary-1"
                },
                {
                    label: "Yellow",
                    value: "bg-yellow"
                },
                {
                    label: "Orange",
                    value: "bg-secondary-2"
                },
                {
                    label: "Seafoam 1",
                    value: "bg-quaternary-2"
                },
                {
                    label: "Seafoam 2",
                    value: "bg-senary-3"
                },
                {
                    label: "Seafoam 3",
                    value: "bg-senary-5"
                },
                {
                    label: "Air Dry Cream",
                    value: "bg-stylers-1"
                },
                {
                    label: "Sculpting Cream",
                    value: "bg-stylers-2"
                },
                {
                    label: "Texture Foam",
                    value: "bg-stylers-3"
                },
                {
                    label: "Sleek Stick",
                    value: "bg-stylers-4"
                },
                {
                    label: "Scalp Blue",
                    value: "bg-scalp-blue"
                },
                {
                    label: "Magenta",
                    value: "bg-magenta"
                },
                {
                    label: "Medium Pink",
                    value: "bg-med-pink"
                },
                {
                    label: "Briogeo Blue",
                    value: "bg-brio-blue"
                },
                {
                    label: "Cloud",
                    value: "bg-cloud"
                },
                {
                    label: "Mineral",
                    value: "bg-mineral"
                },
                {
                    label: "Deep Sea",
                    value: "bg-deep-sea"
                },
                {
                    label: "Sandstone",
                    value: "bg-sandstone"
                },
                {
                    label: "Sorrel",
                    value: "bg-sorrel"
                },
                {
                    label: "Butter",
                    value: "bg-butter"
                },
                {
                    label: "Rosehip",
                    value: "bg-rosehip"
                },
                {
                    label: "Chestnut",
                    value: "bg-chestnut"
                }, 
            ],
            defaultValue: "bg-white"
        },
        {
            name: "fgColor",
            label: "Foreground Color",
            component: "select",
            description: "For section foreground color, select one from preselected brand colors.",
            options: [
                {
                    label: "Light",
                    value: "text-white"
                },
                {
                    label: "Dark",
                    value: "text-black"
                }, 
            ],
            defaultValue: "text-black"
        },
        {
            component: "text",
            name: "heading",
            label: "Section Heading"
        },
        {
            name: "headingFont",
            label: "Section Heading Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section heading text"
        },
        {
            component: "group-list",
            name: "quotes",
            label: "Quotes",
            fields: [
                {
                    component: "textarea",
                    name: "quote",
                    label: "Quote",
                    description: "The quote text"
                },
                {
                    name: "quoteFont",
                    label: "Quote Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the quote text"
                },
                {
                    component: "text",
                    name: "author",
                    label: "Author",
                    description: "The author of the quote, if no author image is populated this value will be shown"
                },
                {
                    name: "authorFont",
                    label: "Author Font",
                    component: "select",
                    options: FontSelector,
                    defaultValue: "font-haffer",
                    description: "Select the font for the author text"
                },
                {
                    component: "image",
                    name: "authorImage",
                    label: "Author Image",
                    description: "Optional, used to populate the author's logo or image"
                }
            ]
        }
    ]
};

;// CONCATENATED MODULE: ./src/sections/Quotes/index.js


// EXTERNAL MODULE: ./src/sections/TableBuilder/TableBuilder.module.css
var TableBuilder_module = __webpack_require__(14478);
var TableBuilder_module_default = /*#__PURE__*/__webpack_require__.n(TableBuilder_module);
;// CONCATENATED MODULE: ./src/sections/TableBuilder/TableBuilder.jsx
function TableBuilder_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TableBuilder_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return TableBuilder_arrayLikeToArray(arr);
}
function TableBuilder_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TableBuilder_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function TableBuilder_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TableBuilder_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TableBuilder_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TableBuilder_toConsumableArray(arr) {
    return TableBuilder_arrayWithoutHoles(arr) || TableBuilder_iterableToArray(arr) || TableBuilder_unsupportedIterableToArray(arr) || TableBuilder_nonIterableSpread();
}
function TableBuilder_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TableBuilder_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TableBuilder_arrayLikeToArray(o, minLen);
}





var TableRow = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("tr", {
        className: "",
        children: children
    });
};
var TableColumnNode = function(props) {
    var children = props.children, _isHeading = props.isHeading, isHeading = _isHeading === void 0 ? false : _isHeading;
    return isHeading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("th", TableBuilder_objectSpread({}, props, {
        children: children
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", TableBuilder_objectSpread({}, props, {
        children: children
    }));
};
var TableColumn = function(param) {
    var column = param.column, isHeading = param.isHeading, _rowIndex = param.rowIndex, rowIndex = _rowIndex === void 0 ? 0 : _rowIndex, colspan = param.colspan;
    var image = column.image, title = column.title, titleFont = column.titleFont, description = column.description, descriptionFont = column.descriptionFont;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableColumnNode, {
        className: "".concat(rowIndex === 0 ? "" : "border-t", " border-0 border-black py-5 last:border-r-0"),
        isHeading: isHeading,
        colspan: colspan > 1 ? colspan : 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full gap-6 ".concat(isHeading ? "items-center" : ""),
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-8 flex-shrink-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "block aspect-square w-8 h-8 max-w-full",
                        loading: "lazy",
                        src: image.src,
                        alt: image.alt,
                        width: "100",
                        height: "100"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-left flex-grow",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "".concat(titleFont || "font-hafferBold"),
                            children: title
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-xsmall mb-0 ".concat(descriptionFont || ""),
                            dangerouslySetInnerHTML: {
                                __html: (0,Helper/* newLineToBr */.td)(description)
                            }
                        })
                    ]
                })
            ]
        })
    });
};
function TableBuilder_Section(param) {
    var cms = param.cms;
    var _Math;
    var ref4, ref1, ref2, ref3;
    var title = cms.title, titleFont = cms.titleFont, description = cms.description, descriptionFont = cms.descriptionFont, _headingAlign = cms.headingAlign, headingAlign = _headingAlign === void 0 ? "text-center" : _headingAlign, _tableLayout = cms.tableLayout, tableLayout = _tableLayout === void 0 ? "table-auto" : _tableLayout, tableRow = cms.tableRow;
    var columnCount = (tableRow === null || tableRow === void 0 ? void 0 : (ref4 = tableRow[0]) === null || ref4 === void 0 ? void 0 : (ref1 = ref4["tableColumn"]) === null || ref1 === void 0 ? void 0 : ref1.length) || 0;
    var tableRows = tableRow || [];
    var maxColumns = (_Math = Math).max.apply(_Math, TableBuilder_toConsumableArray(tableRows.map(function(row) {
        var ref;
        return (row === null || row === void 0 ? void 0 : (ref = row.tableColumn) === null || ref === void 0 ? void 0 : ref.length) || 0;
    })));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(TableBuilder_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        "data-comp": TableBuilder_Section.displayName,
        className: "px-4 py-6 md:px-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(TableBuilder_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(TableBuilder_Section.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-[1120px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full ".concat(headingAlign, " ").concat(headingAlign == "text-center" ? "max-w-[90%] mx-auto" : ""),
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-h2-m md:text-h3 mt-0 mb-2 md:mb-3 leading-[1.25] ".concat(titleFont || "font-tiempos"),
                                children: title
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "m-0 text-sm md:text-base font-light ".concat(descriptionFont || ""),
                                dangerouslySetInnerHTML: {
                                    __html: (0,Helper/* newLineToBr */.td)(description)
                                }
                            })
                        ]
                    }),
                    (tableRows === null || tableRows === void 0 ? void 0 : tableRows.length) && columnCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-11 table-wrapper pb-11",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                            className: "".concat(tableLayout, " ").concat((TableBuilder_module_default()).tableBuilder),
                            style: {
                                "--columns": maxColumns /*width: `max(100%, ${maxColumns *372}px)`*/ 
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                        children: ((tableRows === null || tableRows === void 0 ? void 0 : (ref2 = tableRows[0]) === null || ref2 === void 0 ? void 0 : ref2.tableColumn) || []).map(function(column, i) {
                                            var ref, ref5;
                                            var colLeng = (tableRows === null || tableRows === void 0 ? void 0 : (ref = tableRows[0]) === null || ref === void 0 ? void 0 : (ref5 = ref.tableColumn) === null || ref5 === void 0 ? void 0 : ref5.length) || 0;
                                            var colSpan = maxColumns > colLeng > 0 && i === colLeng - 1 ? maxColumns + 1 - colLeng : 1;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableColumn, {
                                                column: column,
                                                isHeading: true,
                                                colspan: colSpan
                                            }, "col-heading-".concat(i));
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                    children: (ref3 = tableRows === null || tableRows === void 0 ? void 0 : tableRows.slice(1)) === null || ref3 === void 0 ? void 0 : ref3.map(function(row, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: ((row === null || row === void 0 ? void 0 : row.tableColumn) || []).map(function(column, i) {
                                                var colLeng = (row === null || row === void 0 ? void 0 : row.tableColumn.length) || 0;
                                                var colSpan = maxColumns > colLeng > 0 && i === colLeng - 1 ? maxColumns + 1 - colLeng : 1;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableColumn, {
                                                    column: column,
                                                    rowIndex: index,
                                                    colspan: colSpan
                                                }, "col-".concat(index, "-").concat(i));
                                            })
                                        }, "row-".concat(index));
                                    })
                                })
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
}
TableBuilder_Section.displayName = "Table Builder";
var tableColumn = {
    name: "tableColumn",
    label: "table Column",
    component: "group-list",
    itemProps: {
        label: "{{item.title}}"
    },
    fields: [
        {
            name: "image",
            label: "Icon",
            component: "image",
            description: "Recomended image size 100px x 100px"
        },
        {
            name: "title",
            label: "Title",
            description: "Optional Field",
            component: "text"
        },
        {
            name: "titleFont",
            label: "Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the title text"
        },
        {
            name: "description",
            label: "Description",
            description: "Optional Field",
            component: "textarea"
        },
        {
            name: "descriptionFont",
            label: "Description Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the description text"
        }, 
    ]
};
TableBuilder_Section.Schema = {
    category: "Modules",
    label: TableBuilder_Section.displayName,
    key: "table-builder",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            name: "title",
            label: "Section Title",
            component: "text"
        },
        {
            name: "titleFont",
            label: "Section Title Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section title text"
        },
        {
            name: "description",
            label: "Section Description",
            component: "textarea"
        },
        {
            name: "descriptionFont",
            label: "Section Description Font",
            component: "select",
            options: FontSelector,
            defaultValue: "font-haffer",
            description: "Select the font for the section description text"
        },
        {
            component: "select",
            name: "headingAlign",
            label: "Heading Alignment",
            options: [
                {
                    label: "Left",
                    value: "text-left"
                },
                {
                    label: "Center",
                    value: "text-center"
                },
                {
                    label: "Right",
                    value: "text-right"
                }, 
            ],
            defaultValue: "center"
        },
        {
            component: "select",
            name: "tableLayout",
            label: "Table Layout",
            options: [
                {
                    label: "Auto",
                    value: "table-auto"
                },
                {
                    label: "Fixed",
                    value: "table-fixed"
                }, 
            ],
            defaultValue: "table-auto"
        },
        {
            name: "tableRow",
            label: "Table Row",
            component: "group-list",
            fields: [
                tableColumn, 
            ]
        }, 
    ]
};
var TableBuilder = TableBuilder_Section;

;// CONCATENATED MODULE: ./src/sections/TableBuilder/index.js


// EXTERNAL MODULE: ./src/layouts/AccountLayout.jsx
var AccountLayout = __webpack_require__(8387);
;// CONCATENATED MODULE: ./src/sections/MyRewards/MyRewards.jsx







function MyRewards(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3;
    var customer = (0,dist.useCustomer)();
    var ref4 = (0,react.useState)(false), loaded = ref4[0], setLoaded = ref4[1];
    var ref5 = (0,react.useState)(""), points = ref5[0], setPoints = ref5[1];
    var customerDetails = (0,hooks/* useCustomerDetails */.SZ)({
        email: customer === null || customer === void 0 ? void 0 : customer.email
    }).customerDetails;
    (0,react.useEffect)(function() {
        setPoints((customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.points_balance) || 0);
    }, [
        customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.points_balance
    ]);
    (0,react.useEffect)(function() {
        setLoaded(true);
    }, []);
    (0,react.useEffect)(function() {
        if ((window === null || window === void 0 ? void 0 : window.yotpoWidgetsContainer) && typeof window.yotpoWidgetsContainer.initWidgets === "function") {
            window.yotpoWidgetsContainer.initWidgets(); // Initialize the Yotpo widget 
        }
    }, [
        loaded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-0 pt-3 pb-10",
        id: "rewards",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border border-b-0 border-black pt-6 md:pt-16 pb-0 md:pb-16 bg-light-blue relative z-0 max-md:!aspect-auto",
                style: {
                    aspectRatio: ((ref = cms.myRewardImage) === null || ref === void 0 ? void 0 : ref.aspectRatio) || 0.65
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full flex flex-col md:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md-:w-1/2 px-4 md:pr-4 md:pl-12 text-black text-center md:text-left pb-6 md:pb-0 relative z-[1]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "h3 text-h2-m md:text-[42px] md:leading-none mb-3 md:mb-4",
                                    children: "My Briogeo Rewards"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xsmall md:text-sm mb-6",
                                    children: "Once you're done shopping, login or sign up to redeem coupons you qualify for at checkout."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "border border-quinary-2 inline-block text-center text-black w-[214px] max-w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "px-4 py-2 bg-quinary-2 text-regular font-medium",
                                            children: "Points Balance"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "px-4 py-2 text-h5 font-bold",
                                            children: points
                                        })
                                    ]
                                }),
                                loaded && points === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/account/referral",
                                            className: "text-center text-sm font-hafferBold border-b-2 border-black no-underline",
                                            target: "_blank",
                                            children: "refer a friend"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-xsmall ml-3 align-middle font-hafferBold text-primary-2",
                                            children: "Earn 500 pts!"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:absolute z-0 top-0 pointer-events-none !h-full w-full",
                            children: [
                                (cms === null || cms === void 0 ? void 0 : cms.myRewardImageM) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative md:hidden h-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        src: cms.myRewardImageM.src,
                                        className: "relative inset-0 !h-full !w-full object-right-bottom",
                                        loading: "eager",
                                        fill: false,
                                        width: (ref1 = cms.myRewardImageM) === null || ref1 === void 0 ? void 0 : ref1.width,
                                        height: (ref2 = cms.myRewardImageM) === null || ref2 === void 0 ? void 0 : ref2.height,
                                        sizes: "100vw",
                                        alt: cms.myRewardImageM.alt,
                                        priority: true,
                                        fetchpriority: "high"
                                    })
                                }) : null,
                                (cms === null || cms === void 0 ? void 0 : cms.myRewardImage) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative  h-full ".concat((cms === null || cms === void 0 ? void 0 : cms.myRewardImageM) ? "max-md:hidden" : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        src: cms.myRewardImage.src,
                                        className: "absolute inset-0 !h-full !w-full object-right-bottom",
                                        loading: "eager",
                                        fill: true,
                                        sizes: "100vw",
                                        alt: cms.myRewardImage.alt,
                                        priority: true,
                                        fetchpriority: "high"
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "border border-black px-3 py-7 md:px-10 md:py-8",
                children: [
                    customer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "swell-customer-identification",
                        "data-authenticated": "true",
                        "data-email": customer === null || customer === void 0 ? void 0 : customer.email,
                        "data-id": customer === null || customer === void 0 ? void 0 : (ref3 = customer.id) === null || ref3 === void 0 ? void 0 : ref3.replace("gid://shopify/Customer/", ""),
                        "data-tags": '"[]"',
                        style: {
                            display: "none"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "yotpo-widget-instance",
                        "data-yotpo-instance-id": (cms === null || cms === void 0 ? void 0 : cms.yotpoWidgetId) || "1106786"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "yotpo-widget-instance",
                        "data-yotpo-instance-id": "23934",
                        "mode-rewards-history-only": "true"
                    }),
                    loaded && points > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-x-11 gap-y-6 justify-center items-center mt-10 flex-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#rewards-history",
                                onClick: function(e) {
                                    return e.preventDefault();
                                },
                                className: "text-center text-sm font-hafferBold border-b-2 border-black no-underline yotpo-rewards-pop-up",
                                children: "rewards history"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/pages/rewards",
                                className: "text-center text-sm font-hafferBold border-b-2 border-black no-underline",
                                target: "_blank",
                                children: "earn more points"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full sm:w-auto text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/account/referral",
                                        className: "text-center text-sm font-hafferBold border-b-2 border-black no-underline",
                                        target: "_blank",
                                        children: "refer a friend"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xsmall ml-3 align-middle font-hafferBold text-primary-2",
                                        children: "Earn 500 pts!"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
MyRewards.displayName = "My Rewards";
MyRewards.Schema = {
    category: "Account",
    label: MyRewards.displayName,
    key: "account-my-rewards",
    fields: [
        {
            component: "number",
            name: "yotpoWidgetId",
            label: "yotpo Widget Id",
            defaultValue: 892619
        },
        {
            label: "Image (Desktop)",
            name: "myRewardImage",
            component: "image",
            description: "Recommended Image Size: 888 x 576"
        },
        {
            label: "Image (Mobile)",
            name: "myRewardImageM",
            component: "image",
            description: "Recommended Image Size: 686 x 390"
        },
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "number",
            name: "mobileBottomSpacing",
            label: "Section Bottom Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopBottomSpacing",
            label: "Section Bottom Margin - Desktop",
            defaultValue: 80
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/MyRewards/index.js


;// CONCATENATED MODULE: ./src/sections/RedoOrderTracking/RedoOrderTracking.jsx


function RedoOrderTracking(param) {
    var cms = param.cms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "".concat(RedoOrderTracking.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "#".concat(RedoOrderTracking.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n            margin-top: ").concat(cms.mobileSpacing, "px;\n          }\n          @media(min-width: 1024px) {\n            #").concat(RedoOrderTracking.Schema.key, "-").concat(cms.id || cms.cmsId || cms.tinaId, " {\n              margin-top: ").concat(cms.desktopSpacing, "px;\n            }\n          }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "redo-order-tracking-login-target"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "redo-config",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: '\n          window.redoWidgetId = "p1wnnrcs47wd8yr";\n          window.redoStorefront = {                                                                                                                                                       \n          storeUrl: "briogeo-hair-care.myshopify.com",\n          env: {                                                                                                                                                                        \n            REDO_SHOPIFY_SERVER_URL: "https://shopify-server.getredo.com",\n            REDO_RETURN_APP_URL: "https://returns.getredo.com",                                                                                                                         \n          },                                                                                                                                                                            \n          };\n      '
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://shopify-extension.getredo.com/orderTrackingLogin.js",
                strategy: "afterInteractive"
            })
        ]
    });
}
RedoOrderTracking.displayName = "RedoOrderTracking";
RedoOrderTracking.Schema = {
    category: "Order Tracking",
    label: RedoOrderTracking.displayName,
    key: "trackingform",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/RedoOrderTracking/index.js


;// CONCATENATED MODULE: ./src/sections/index.js









































/* harmony default export */ var sections = ([
    Markdown,
    Styleguide,
    Banner,
    Iconography,
    Accordion,
    Ingredients,
    ProductSizes,
    Spacer,
    ThreeUp,
    FourUpCta,
    StudyStatistics,
    ProductSpotlight,
    CategoryCarousel,
    ImageWithText,
    Hero,
    HTML,
    CarouselHotspots,
    BorderedGrid,
    GorgiasContactForm,
    ProductUpsells,
    CollectionBanner,
    ProductRecommendations,
    ParallaxStory,
    Quiz,
    Collection,
    FullWidthText,
    StoreLocator,
    CollectionGrid,
    CustomCursor,
    BundleBuilder,
    QuizSection,
    Testimonial,
    BeforeAfterSlider,
    VideoWise,
    BuyWithPrimePLP,
    CtaSlider,
    HowToBuildBundle,
    Quotes,
    TableBuilder,
    MyRewards,
    RedoOrderTracking, 
]);

;// CONCATENATED MODULE: ../node_modules/luxon/build/es6/luxon.mjs
// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
class LuxonError extends Error {}

/**
 * @private
 */
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class ConflictingSpecificationError extends LuxonError {}

/**
 * @private
 */
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}

/**
 * @private
 */
class InvalidArgumentError extends LuxonError {}

/**
 * @private
 */
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}

/**
 * @private
 */

const luxon_n = "numeric",
  luxon_s = "short",
  l = "long";

const DATE_SHORT = {
  year: luxon_n,
  month: luxon_n,
  day: luxon_n,
};

const DATE_MED = {
  year: luxon_n,
  month: luxon_s,
  day: luxon_n,
};

const DATE_MED_WITH_WEEKDAY = {
  year: luxon_n,
  month: luxon_s,
  day: luxon_n,
  weekday: luxon_s,
};

const DATE_FULL = {
  year: luxon_n,
  month: l,
  day: luxon_n,
};

const DATE_HUGE = {
  year: luxon_n,
  month: l,
  day: luxon_n,
  weekday: l,
};

const TIME_SIMPLE = {
  hour: luxon_n,
  minute: luxon_n,
};

const TIME_WITH_SECONDS = {
  hour: luxon_n,
  minute: luxon_n,
  second: luxon_n,
};

const TIME_WITH_SHORT_OFFSET = {
  hour: luxon_n,
  minute: luxon_n,
  second: luxon_n,
  timeZoneName: luxon_s,
};

const TIME_WITH_LONG_OFFSET = {
  hour: luxon_n,
  minute: luxon_n,
  second: luxon_n,
  timeZoneName: l,
};

const TIME_24_SIMPLE = {
  hour: luxon_n,
  minute: luxon_n,
  hourCycle: "h23",
};

const TIME_24_WITH_SECONDS = {
  hour: luxon_n,
  minute: luxon_n,
  second: luxon_n,
  hourCycle: "h23",
};

const TIME_24_WITH_SHORT_OFFSET = {
  hour: luxon_n,
  minute: luxon_n,
  second: luxon_n,
  hourCycle: "h23",
  timeZoneName: luxon_s,
};

const TIME_24_WITH_LONG_OFFSET = {
  hour: luxon_n,
  minute: luxon_n,
  second: luxon_n,
  hourCycle: "h23",
  timeZoneName: l,
};

const DATETIME_SHORT = {
  year: luxon_n,
  month: luxon_n,
  day: luxon_n,
  hour: luxon_n,
  minute: luxon_n,
};

const DATETIME_SHORT_WITH_SECONDS = {
  year: luxon_n,
  month: luxon_n,
  day: luxon_n,
  hour: luxon_n,
  minute: luxon_n,
  second: luxon_n,
};

const DATETIME_MED = {
  year: luxon_n,
  month: luxon_s,
  day: luxon_n,
  hour: luxon_n,
  minute: luxon_n,
};

const DATETIME_MED_WITH_SECONDS = {
  year: luxon_n,
  month: luxon_s,
  day: luxon_n,
  hour: luxon_n,
  minute: luxon_n,
  second: luxon_n,
};

const DATETIME_MED_WITH_WEEKDAY = {
  year: luxon_n,
  month: luxon_s,
  day: luxon_n,
  weekday: luxon_s,
  hour: luxon_n,
  minute: luxon_n,
};

const DATETIME_FULL = {
  year: luxon_n,
  month: l,
  day: luxon_n,
  hour: luxon_n,
  minute: luxon_n,
  timeZoneName: luxon_s,
};

const DATETIME_FULL_WITH_SECONDS = {
  year: luxon_n,
  month: l,
  day: luxon_n,
  hour: luxon_n,
  minute: luxon_n,
  second: luxon_n,
  timeZoneName: luxon_s,
};

const DATETIME_HUGE = {
  year: luxon_n,
  month: l,
  day: luxon_n,
  weekday: l,
  hour: luxon_n,
  minute: luxon_n,
  timeZoneName: l,
};

const DATETIME_HUGE_WITH_SECONDS = {
  year: luxon_n,
  month: l,
  day: luxon_n,
  weekday: l,
  hour: luxon_n,
  minute: luxon_n,
  second: luxon_n,
  timeZoneName: l,
};

/**
 * @interface
 */
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }

  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }

  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}

let singleton$1 = null;

/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new SystemZone();
    }
    return singleton$1;
  }

  /** @override **/
  get type() {
    return "system";
  }

  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }

  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }

  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }

  /** @override **/
  get isValid() {
    return true;
  }
}

const dtfCache = new Map();
function makeDTF(zoneName) {
  let dtf = dtfCache.get(zoneName);
  if (dtf === undefined) {
    dtf = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zoneName,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short",
    });
    dtfCache.set(zoneName, dtf);
  }
  return dtf;
}

const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6,
};

function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""),
    parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted),
    [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}

function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];

    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}

const ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    let zone = ianaZoneCache.get(name);
    if (zone === undefined) {
      ianaZoneCache.set(name, (zone = new IANAZone(name)));
    }
    return zone;
  }

  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache.clear();
    dtfCache.clear();
  }

  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(s) {
    return this.isValidZone(s);
  }

  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }

  constructor(name) {
    super();
    /** @private **/
    this.zoneName = name;
    /** @private **/
    this.valid = IANAZone.isValidZone(name);
  }

  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }

  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }

  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    if (!this.valid) return NaN;
    const date = new Date(ts);

    if (isNaN(date)) return NaN;

    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts
      ? partsOffset(dtf, date)
      : hackyOffset(dtf, date);

    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }

    // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
    const adjustedHour = hour === 24 ? 0 : hour;

    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0,
    });

    let asTS = +date;
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }

  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }

  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}

// todo - remap caching

let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}

const intlDTCache = new Map();
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache.get(key);
  if (dtf === undefined) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache.set(key, dtf);
  }
  return dtf;
}

const intlNumCache = new Map();
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache.get(key);
  if (inf === undefined) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache.set(key, inf);
  }
  return inf;
}

const intlRelCache = new Map();
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts; // exclude `base` from the options
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache.get(key);
  if (inf === undefined) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache.set(key, inf);
  }
  return inf;
}

let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}

const intlResolvedOptionsCache = new Map();
function getCachedIntResolvedOptions(locString) {
  let opts = intlResolvedOptionsCache.get(locString);
  if (opts === undefined) {
    opts = new Intl.DateTimeFormat(locString).resolvedOptions();
    intlResolvedOptionsCache.set(locString, opts);
  }
  return opts;
}

const weekInfoCache = new Map();
function getCachedWeekInfo(locString) {
  let data = weekInfoCache.get(locString);
  if (!data) {
    const locale = new Intl.Locale(locString);
    // browsers currently implement this as a property, but spec says it should be a getter function
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
    if (!("minimalDays" in data)) {
      data = { ...fallbackWeekSettings, ...data };
    }
    weekInfoCache.set(locString, data);
  }
  return data;
}

function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:

  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u

  // private subtags and unicode subtags have ordering requirements,
  // and we're not properly parsing this, so just strip out the
  // private ones if they exist.
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }

  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }

    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}

function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }

    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }

    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}

function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}

function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}

function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();

  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}

function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return (
      loc.numberingSystem === "latn" ||
      !loc.locale ||
      loc.locale.startsWith("en") ||
      getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn"
    );
  }
}

/**
 * @private
 */

class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;

    const { padTo, floor, ...otherOpts } = opts;

    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }

  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}

/**
 * @private
 */

class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = undefined;

    let z = undefined;
    if (this.opts.timeZone) {
      // Don't apply any workarounds if a timeZone is explicitly provided in opts
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
        // we manually apply the offset and substitute the zone as needed.
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({ minutes: dt.offset });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      // Custom zones can have any offset / offsetName so we just manually
      // apply the offset and substitute the zone as needed.
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({ minutes: dt.offset });
      this.originalZone = dt.zone;
    }

    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }

  format() {
    if (this.originalZone) {
      // If we have to substitute in the actual zone name, we have to use
      // formatToParts so that the timezone can be replaced.
      return this.formatToParts()
        .map(({ value }) => value)
        .join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }

  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName,
          });
          return {
            ...part,
            value: offsetName,
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }

  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}

/**
 * @private
 */
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }

  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }

  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}

const fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7],
};

/**
 * @private
 */
class Locale {
  static fromOpts(opts) {
    return Locale.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }

  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }

  static resetCache() {
    sysLocaleCache = null;
    intlDTCache.clear();
    intlNumCache.clear();
    intlRelCache.clear();
    intlResolvedOptionsCache.clear();
    weekInfoCache.clear();
  }

  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }

  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);

    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);

    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};

    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }

  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }

    return this.fastNumbersCached;
  }

  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness =
      (this.numberingSystem === null || this.numberingSystem === "latn") &&
      (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }

  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        validateWeekSettings(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }

  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }

  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }

  months(length, format = false) {
    return listStuff(this, length, months, () => {
      // Workaround for "ja" locale: formatToParts does not label all parts of the month
      // as "month" and for this locale there is no difference between "format" and "non-format".
      // As such, just use format() instead of formatToParts() and take the whole string
      const monthSpecialCase = this.intl === "ja" || this.intl.startsWith("ja-");
      format &= !monthSpecialCase;
      const intl = format ? { month: length, day: "numeric" } : { month: length },
        formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        const mapper = !monthSpecialCase
          ? (dt) => this.extract(dt, intl, "month")
          : (dt) => this.dtFormatter(dt, intl).format();
        this.monthsCache[formatStr][length] = mapMonths(mapper);
      }
      return this.monthsCache[formatStr][length];
    });
  }

  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format
          ? { weekday: length, year: "numeric", month: "long", day: "numeric" }
          : { weekday: length },
        formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays((dt) =>
          this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }

  meridiems() {
    return listStuff(
      this,
      undefined,
      () => meridiems,
      () => {
        // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
        // for AM and PM. This is probably wrong, but it's makes parsing way easier.
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }

        return this.meridiemCache;
      }
    );
  }

  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = { era: length };

      // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map((dt) =>
          this.extract(dt, intl, "era")
        );
      }

      return this.eraCache[length];
    });
  }

  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts),
      results = df.formatToParts(),
      matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }

  numberFormatter(opts = {}) {
    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }

  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }

  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }

  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }

  isEnglish() {
    return (
      this.locale === "en" ||
      this.locale.toLowerCase() === "en-us" ||
      getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us")
    );
  }

  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }

  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }

  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }

  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }

  equals(other) {
    return (
      this.locale === other.locale &&
      this.numberingSystem === other.numberingSystem &&
      this.outputCalendar === other.outputCalendar
    );
  }

  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}

let singleton = null;

/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }

  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }

  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s) {
    if (s) {
      const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }

  constructor(offset) {
    super();
    /** @private **/
    this.fixed = offset;
  }

  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }

  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }

  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }

  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }

  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }

  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }

  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
}

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */
class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    /**  @private */
    this.zoneName = zoneName;
  }

  /** @override **/
  get type() {
    return "invalid";
  }

  /** @override **/
  get name() {
    return this.zoneName;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName() {
    return null;
  }

  /** @override **/
  formatOffset() {
    return "";
  }

  /** @override **/
  offset() {
    return NaN;
  }

  /** @override **/
  equals() {
    return false;
  }

  /** @override **/
  get isValid() {
    return false;
  }
}

/**
 * @private
 */

function normalizeZone(input, defaultZone) {
  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

const numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d",
};

const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881],
};

const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");

function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);

      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}

// cache of {numberingSystem: {append: regex}}
const digitRegexCache = new Map();
function resetDigitRegexCache() {
  digitRegexCache.clear();
}

function digitRegex({ numberingSystem }, append = "") {
  const ns = numberingSystem || "latn";

  let appendCache = digitRegexCache.get(ns);
  if (appendCache === undefined) {
    appendCache = new Map();
    digitRegexCache.set(ns, appendCache);
  }
  let regex = appendCache.get(append);
  if (regex === undefined) {
    regex = new RegExp(`${numberingSystems[ns]}${append}`);
    appendCache.set(append, regex);
  }

  return regex;
}

let now = () => Date.now(),
  defaultZone = "system",
  defaultLocale = null,
  defaultNumberingSystem = null,
  defaultOutputCalendar = null,
  twoDigitCutoffYear = 60,
  throwOnInvalid,
  defaultWeekSettings = null;

/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now;
  }

  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    now = n;
  }

  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }

  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }

  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }

  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }

  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }

  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }

  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }

  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }

  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */

  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }

  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }

  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }

  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }

  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }

  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }

  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
}

class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }

  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}

const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
  leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}

function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));

  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }

  const js = d.getUTCDay();

  return js === 0 ? 7 : js;
}

function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}

function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder,
    month0 = table.findIndex((i) => i < ordinal),
    day = ordinal - table[month0];
  return { month: month0 + 1, day };
}

function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return ((isoWeekday - startOfWeek + 7) % 7) + 1;
}

/**
 * @private
 */

function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj,
    ordinal = computeOrdinal(year, month, day),
    weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);

  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7),
    weekYear;

  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }

  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}

function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData,
    weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek),
    yearInDays = daysInYear(weekYear);

  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek,
    year;

  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }

  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}

function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}

function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}

/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData =
    !isUndefined(obj.localWeekday) ||
    !isUndefined(obj.localWeekNumber) ||
    !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData =
      !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);

    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek(),
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}

function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear),
    validWeek = integerBetween(
      obj.weekNumber,
      1,
      weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)
    ),
    validWeekday = integerBetween(obj.weekday, 1, 7);

  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}

function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year),
    validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}

function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year),
    validMonth = integerBetween(obj.month, 1, 12),
    validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}

function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour =
      integerBetween(hour, 0, 23) ||
      (hour === 24 && minute === 0 && second === 0 && millisecond === 0),
    validMinute = integerBetween(minute, 0, 59),
    validSecond = integerBetween(second, 0, 59),
    validMillisecond = integerBetween(millisecond, 0, 999);

  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/

/**
 * @private
 */

// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}

function isNumber(o) {
  return typeof o === "number";
}

function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}

function isString(o) {
  return typeof o === "string";
}

function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}

// CAPABILITIES

function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}

function hasLocaleWeekInfo() {
  try {
    return (
      typeof Intl !== "undefined" &&
      !!Intl.Locale &&
      ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype)
    );
  } catch (e) {
    return false;
  }
}

// OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}

function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}

function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}

function luxon_hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (
      !integerBetween(settings.firstDay, 1, 7) ||
      !integerBetween(settings.minimalDays, 1, 7) ||
      !Array.isArray(settings.weekend) ||
      settings.weekend.some((v) => !integerBetween(v, 1, 7))
    ) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend),
    };
  }
}

// NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}

// x % n but takes the sign of n instead of x
function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}

function padStart(input, n = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n, "0");
  } else {
    padded = ("" + input).padStart(n, "0");
  }
  return padded;
}

function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}

function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseFloat(string);
  }
}

function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    const f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}

function roundTo(number, digits, rounding = "round") {
  const factor = 10 ** digits;
  switch (rounding) {
    case "expand":
      return number > 0
        ? Math.ceil(number * factor) / factor
        : Math.floor(number * factor) / factor;
    case "trunc":
      return Math.trunc(number * factor) / factor;
    case "round":
      return Math.round(number * factor) / factor;
    case "floor":
      return Math.floor(number * factor) / factor;
    case "ceil":
      return Math.ceil(number * factor) / factor;
    default:
      throw new RangeError(`Value rounding ${rounding} is out of range`);
  }
}

// DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}

function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1,
    modYear = year + (month - modMonth) / 12;

  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}

// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );

  // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
    // so if obj.year is in 99, but obj.day makes it roll over into year 100,
    // the calculations done by Date.UTC are using year 2000 - which is incorrect
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}

// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}

function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}

function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}

// PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts),
    intlOpts = {
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };

  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }

  const modified = { timeZoneName: offsetFormat, ...intlOpts };

  const parsed = new Intl.DateTimeFormat(locale, modified)
    .formatToParts(date)
    .find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}

// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);

  // don't || this because we want to preserve -0
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }

  const offMin = parseInt(offMinuteStr, 10) || 0,
    offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}

// COERCION

function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}

function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (luxon_hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}

/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */
function formatOffset(offset, format) {
  const hours = Math.trunc(Math.abs(offset / 60)),
    minutes = Math.trunc(Math.abs(offset % 60)),
    sign = offset >= 0 ? "+" : "-";

  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}

function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}

/**
 * @private
 */

const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];

function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}

const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];

function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}

const meridiems = ["AM", "PM"];

const erasLong = ["Before Christ", "Anno Domini"];

const erasShort = ["BC", "AD"];

const erasNarrow = ["B", "A"];

function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}

function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}

function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}

function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}

function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}

function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."],
  };

  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;

  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }

  const isInPast = Object.is(count, -0) || count < 0,
    fmtValue = Math.abs(count),
    singular = fmtValue === 1,
    lilUnits = units[unit],
    fmtUnit = narrow
      ? singular
        ? lilUnits[1]
        : lilUnits[2] || lilUnits[1]
      : singular
      ? units[unit][0]
      : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}

function stringifyTokens(splits, tokenToString) {
  let s = "";
  for (const token of splits) {
    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }
  return s;
}

const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS,
};

/**
 * @private
 */

class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }

  static parseFormat(fmt) {
    // white-space is always considered a literal in user-provided formats
    // the " " token has a special meaning (see unitForToken)

    let current = null,
      currentFull = "",
      bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        // turn '' into a literal signal quote instead of just skipping the empty literal
        if (currentFull.length > 0 || bracketed) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull === "" ? "'" : currentFull,
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }

    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }

    return splits;
  }

  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }

  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }

  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }

  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }

  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }

  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }

  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }

  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }

  num(n, p = 0, signDisplay = undefined) {
    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }

    const opts = { ...this.opts };

    if (p > 0) {
      opts.padTo = p;
    }
    if (signDisplay) {
      opts.signDisplay = signDisplay;
    }

    return this.loc.numberFormatter(opts).format(n);
  }

  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en",
      useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory",
      string = (opts, extract) => this.loc.extract(dt, opts, extract),
      formatOffset = (opts) => {
        if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
          return "Z";
        }

        return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
      },
      meridiem = () =>
        knownEnglish
          ? meridiemForDateTime(dt)
          : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"),
      month = (length, standalone) =>
        knownEnglish
          ? monthForDateTime(dt, length)
          : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"),
      weekday = (length, standalone) =>
        knownEnglish
          ? weekdayForDateTime(dt, length)
          : string(
              standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
              "weekday"
            ),
      maybeMacro = (token) => {
        const formatOpts = Formatter.macroTokenToFormatOpts(token);
        if (formatOpts) {
          return this.formatWithSystemDefault(dt, formatOpts);
        } else {
          return token;
        }
      },
      era = (length) =>
        knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, "era"),
      tokenToString = (token) => {
        // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
        switch (token) {
          // ms
          case "S":
            return this.num(dt.millisecond);
          case "u":
          // falls through
          case "SSS":
            return this.num(dt.millisecond, 3);
          // seconds
          case "s":
            return this.num(dt.second);
          case "ss":
            return this.num(dt.second, 2);
          // fractional seconds
          case "uu":
            return this.num(Math.floor(dt.millisecond / 10), 2);
          case "uuu":
            return this.num(Math.floor(dt.millisecond / 100));
          // minutes
          case "m":
            return this.num(dt.minute);
          case "mm":
            return this.num(dt.minute, 2);
          // hours
          case "h":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
          case "hh":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
          case "H":
            return this.num(dt.hour);
          case "HH":
            return this.num(dt.hour, 2);
          // offset
          case "Z":
            // like +6
            return formatOffset({ format: "narrow", allowZ: this.opts.allowZ });
          case "ZZ":
            // like +06:00
            return formatOffset({ format: "short", allowZ: this.opts.allowZ });
          case "ZZZ":
            // like +0600
            return formatOffset({ format: "techie", allowZ: this.opts.allowZ });
          case "ZZZZ":
            // like EST
            return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
          case "ZZZZZ":
            // like Eastern Standard Time
            return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
          // zone
          case "z":
            // like America/New_York
            return dt.zoneName;
          // meridiems
          case "a":
            return meridiem();
          // dates
          case "d":
            return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
          case "dd":
            return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
          // weekdays - standalone
          case "c":
            // like 1
            return this.num(dt.weekday);
          case "ccc":
            // like 'Tues'
            return weekday("short", true);
          case "cccc":
            // like 'Tuesday'
            return weekday("long", true);
          case "ccccc":
            // like 'T'
            return weekday("narrow", true);
          // weekdays - format
          case "E":
            // like 1
            return this.num(dt.weekday);
          case "EEE":
            // like 'Tues'
            return weekday("short", false);
          case "EEEE":
            // like 'Tuesday'
            return weekday("long", false);
          case "EEEEE":
            // like 'T'
            return weekday("narrow", false);
          // months - standalone
          case "L":
            // like 1
            return useDateTimeFormatter
              ? string({ month: "numeric", day: "numeric" }, "month")
              : this.num(dt.month);
          case "LL":
            // like 01, doesn't seem to work
            return useDateTimeFormatter
              ? string({ month: "2-digit", day: "numeric" }, "month")
              : this.num(dt.month, 2);
          case "LLL":
            // like Jan
            return month("short", true);
          case "LLLL":
            // like January
            return month("long", true);
          case "LLLLL":
            // like J
            return month("narrow", true);
          // months - format
          case "M":
            // like 1
            return useDateTimeFormatter
              ? string({ month: "numeric" }, "month")
              : this.num(dt.month);
          case "MM":
            // like 01
            return useDateTimeFormatter
              ? string({ month: "2-digit" }, "month")
              : this.num(dt.month, 2);
          case "MMM":
            // like Jan
            return month("short", false);
          case "MMMM":
            // like January
            return month("long", false);
          case "MMMMM":
            // like J
            return month("narrow", false);
          // years
          case "y":
            // like 2014
            return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
          case "yy":
            // like 14
            return useDateTimeFormatter
              ? string({ year: "2-digit" }, "year")
              : this.num(dt.year.toString().slice(-2), 2);
          case "yyyy":
            // like 0012
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 4);
          case "yyyyyy":
            // like 000012
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 6);
          // eras
          case "G":
            // like AD
            return era("short");
          case "GG":
            // like Anno Domini
            return era("long");
          case "GGGGG":
            return era("narrow");
          case "kk":
            return this.num(dt.weekYear.toString().slice(-2), 2);
          case "kkkk":
            return this.num(dt.weekYear, 4);
          case "W":
            return this.num(dt.weekNumber);
          case "WW":
            return this.num(dt.weekNumber, 2);
          case "n":
            return this.num(dt.localWeekNumber);
          case "nn":
            return this.num(dt.localWeekNumber, 2);
          case "ii":
            return this.num(dt.localWeekYear.toString().slice(-2), 2);
          case "iiii":
            return this.num(dt.localWeekYear, 4);
          case "o":
            return this.num(dt.ordinal);
          case "ooo":
            return this.num(dt.ordinal, 3);
          case "q":
            // like 1
            return this.num(dt.quarter);
          case "qq":
            // like 01
            return this.num(dt.quarter, 2);
          case "X":
            return this.num(Math.floor(dt.ts / 1000));
          case "x":
            return this.num(dt.ts);
          default:
            return maybeMacro(token);
        }
      };

    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }

  formatDurationFromString(dur, fmt) {
    const invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
    const tokenToField = (token) => {
        switch (token[0]) {
          case "S":
            return "milliseconds";
          case "s":
            return "seconds";
          case "m":
            return "minutes";
          case "h":
            return "hours";
          case "d":
            return "days";
          case "w":
            return "weeks";
          case "M":
            return "months";
          case "y":
            return "years";
          default:
            return null;
        }
      },
      tokenToString = (lildur, info) => (token) => {
        const mapped = tokenToField(token);
        if (mapped) {
          const inversionFactor =
            info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
          let signDisplay;
          if (this.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) {
            signDisplay = "never";
          } else if (this.opts.signMode === "all") {
            signDisplay = "always";
          } else {
            // "auto" and "negative" are the same, but "auto" has better support
            signDisplay = "auto";
          }
          return this.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
        } else {
          return token;
        }
      },
      tokens = Formatter.parseFormat(fmt),
      realTokens = tokens.reduce(
        (found, { literal, val }) => (literal ? found : found.concat(val)),
        []
      ),
      collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t)),
      durationInfo = {
        isNegativeDuration: collapsed < 0,
        // this relies on "collapsed" being based on "shiftTo", which builds up the object
        // in order
        largestUnit: Object.keys(collapsed.values)[0],
      };
    return stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
  }
}

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;

function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}

function combineExtractors(...extractors) {
  return (m) =>
    extractors
      .reduce(
        ([mergedVals, mergedZone, cursor], ex) => {
          const [val, zone, next] = ex(m, cursor);
          return [{ ...mergedVals, ...val }, zone || mergedZone, next];
        },
        [{}, null, 1]
      )
      .slice(0, 2);
}

function luxon_parse(s, ...patterns) {
  if (s == null) {
    return [null, null];
  }

  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}

function simpleParse(...keys) {
  return (match, cursor) => {
    const ret = {};
    let i;

    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}

// ISO and SQL parsing
const offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:[Tt]${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);

function luxon_int(match, pos, fallback) {
  const m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}

function extractISOYmd(match, cursor) {
  const item = {
    year: luxon_int(match, cursor),
    month: luxon_int(match, cursor + 1, 1),
    day: luxon_int(match, cursor + 2, 1),
  };

  return [item, null, cursor + 3];
}

function extractISOTime(match, cursor) {
  const item = {
    hours: luxon_int(match, cursor, 0),
    minutes: luxon_int(match, cursor + 1, 0),
    seconds: luxon_int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3]),
  };

  return [item, null, cursor + 4];
}

function extractISOOffset(match, cursor) {
  const local = !match[cursor] && !match[cursor + 1],
    fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
    zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}

function extractIANAZone(match, cursor) {
  const zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
}

// ISO time parsing

const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);

// ISO duration parsing

const isoDuration =
  /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;

function extractISODuration(match) {
  const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] =
    match;

  const hasNegativePrefix = s[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";

  const maybeNegate = (num, force = false) =>
    num !== undefined && (force || (num && hasNegativePrefix)) ? -num : num;

  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds),
    },
  ];
}

// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60,
};

function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr),
  };

  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday =
      weekdayStr.length > 3
        ? weekdaysLong.indexOf(weekdayStr) + 1
        : weekdaysShort.indexOf(weekdayStr) + 1;
  }

  return result;
}

// RFC 2822/5322
const rfc2822 =
  /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;

function extractRFC2822(match) {
  const [
      ,
      weekdayStr,
      dayStr,
      monthStr,
      yearStr,
      hourStr,
      minuteStr,
      secondStr,
      obsOffset,
      milOffset,
      offHourStr,
      offMinuteStr,
    ] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);

  let offset;
  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }

  return [result, new FixedOffsetZone(offset)];
}

function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s
    .replace(/\([^()]*\)|[\n\t]/g, " ")
    .replace(/(\s\s+)/g, " ")
    .trim();
}

// http date

const rfc1123 =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
  rfc850 =
    /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
  ascii =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;

function extractRFC1123Or850(match) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

function extractASCII(match) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);

const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);

/*
 * @private
 */

function parseISODate(s) {
  return luxon_parse(
    s,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}

function parseRFC2822Date(s) {
  return luxon_parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}

function parseHTTPDate(s) {
  return luxon_parse(
    s,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}

function parseISODuration(s) {
  return luxon_parse(s, [isoDuration, extractISODuration]);
}

const extractISOTimeOnly = combineExtractors(extractISOTime);

function parseISOTimeOnly(s) {
  return luxon_parse(s, [isoTimeOnly, extractISOTimeOnly]);
}

const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);

const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);

function parseSQL(s) {
  return luxon_parse(
    s,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}

const INVALID$2 = "Invalid Duration";

// unit conversion constants
const lowOrderMatrix = {
    weeks: {
      days: 7,
      hours: 7 * 24,
      minutes: 7 * 24 * 60,
      seconds: 7 * 24 * 60 * 60,
      milliseconds: 7 * 24 * 60 * 60 * 1000,
    },
    days: {
      hours: 24,
      minutes: 24 * 60,
      seconds: 24 * 60 * 60,
      milliseconds: 24 * 60 * 60 * 1000,
    },
    hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1000 },
    minutes: { seconds: 60, milliseconds: 60 * 1000 },
    seconds: { milliseconds: 1000 },
  },
  casualMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1000,
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1000,
    },

    ...lowOrderMatrix,
  },
  daysInYearAccurate = 146097.0 / 400,
  daysInMonthAccurate = 146097.0 / 4800,
  accurateMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: daysInYearAccurate / 7,
      days: daysInYearAccurate,
      hours: daysInYearAccurate * 24,
      minutes: daysInYearAccurate * 24 * 60,
      seconds: daysInYearAccurate * 24 * 60 * 60,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: daysInYearAccurate / 28,
      days: daysInYearAccurate / 4,
      hours: (daysInYearAccurate * 24) / 4,
      minutes: (daysInYearAccurate * 24 * 60) / 4,
      seconds: (daysInYearAccurate * 24 * 60 * 60) / 4,
      milliseconds: (daysInYearAccurate * 24 * 60 * 60 * 1000) / 4,
    },
    months: {
      weeks: daysInMonthAccurate / 7,
      days: daysInMonthAccurate,
      hours: daysInMonthAccurate * 24,
      minutes: daysInMonthAccurate * 24 * 60,
      seconds: daysInMonthAccurate * 24 * 60 * 60,
      milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000,
    },
    ...lowOrderMatrix,
  };

// units ordered by size
const orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds",
];

const reverseUnits = orderedUnits$1.slice(0).reverse();

// clone really means "create another instance just like this one, but with these changes"
function clone$1(dur, alts, clear = false) {
  // deep merge for vals
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...(alts.values || {}) },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix,
  };
  return new Duration(conf);
}

function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}

// NB: mutates parameters
function normalizeValues(matrix, vals) {
  // the logic below assumes the overall value of the duration is positive
  // if this is not the case, factor is used to make it so
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;

  orderedUnits$1.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];

        // if (previousVal < 0):
        // lower order unit is negative (e.g. { years: 2, days: -2 })
        // normalize this by reducing the higher order unit by the appropriate amount
        // and increasing the lower order unit
        // this can never make the higher order unit negative, because this function only operates
        // on positive durations, so the amount of time represented by the lower order unit cannot
        // be larger than the higher order unit
        // else:
        // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
        // in this case we attempt to convert as much as possible from the lower order unit into
        // the higher order one
        //
        // Math.floor takes care of both of these cases, rounding away from 0
        // if previousVal < 0 it makes the absolute value larger
        // if previousVal >= it makes the absolute value smaller
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);

  // try to convert any decimals into smaller units if possible
  // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
  orderedUnits$1.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}

// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}

/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */
class Duration {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;

    if (config.matrix) {
      matrix = config.matrix;
    }

    /**
     * @access private
     */
    this.values = config.values;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.matrix = matrix;
    /**
     * @access private
     */
    this.isLuxonDuration = true;
  }

  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration.fromObject({ milliseconds: count }, opts);
  }

  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${
          obj === null ? "null" : typeof obj
        }`
      );
    }

    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix,
    });
  }

  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }

  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }

  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds",
    }[unit ? unit.toLowerCase() : unit];

    if (!normalized) throw new InvalidUnitError(unit);

    return normalized;
  }

  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return (o && o.isLuxonDuration) || false;
  }

  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false,
    };
    return this.isValid
      ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt)
      : INVALID$2;
  }

  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID$2;

    const showZeros = opts.showZeros !== false;

    const l = orderedUnits$1
      .map((unit) => {
        const val = this.values[unit];
        if (isUndefined(val) || (val === 0 && !showZeros)) {
          return null;
        }
        return this.loc
          .numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) })
          .format(val);
      })
      .filter((n) => n);

    return this.loc
      .listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts })
      .format(l);
  }

  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;

    let s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;

    const millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;

    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false,
    };

    const dateTime = DateTime.fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }

  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid) return NaN;

    return durationToMillis(this.matrix, this.values);
  }

  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid) return this;

    const dur = Duration.fromDurationLike(duration),
      result = {};

    for (const k of orderedUnits$1) {
      if (luxon_hasOwnProperty(dur.values, k) || luxon_hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }

    return clone$1(this, { values: result }, true);
  }

  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid) return this;

    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }

  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, { values: result }, true);
  }

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }

  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid) return this;

    const mixed = { ...this.values, ...normalizeObject(values, Duration.normalizeUnit) };
    return clone$1(this, { values: mixed });
  }

  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$1(this, opts);
  }

  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }

  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, { values: vals }, true);
  }

  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, { values: vals }, true);
  }

  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;

    if (units.length === 0) {
      return this;
    }

    units = units.map((u) => Duration.normalizeUnit(u));

    const built = {},
      accumulated = {},
      vals = this.toObject();
    let lastUnit;

    for (const k of orderedUnits$1) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;

        let own = 0;

        // anything we haven't boiled down yet should get boiled to this unit
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }

        // plus anything that's already in this unit
        if (isNumber(vals[k])) {
          own += vals[k];
        }

        // only keep the integer part for now in the hopes of putting any decimal part
        // into a smaller unit later
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1000 - i * 1000) / 1000;

        // otherwise, keep it in the wings to boil it later
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }

    // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] +=
          key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }

    normalizeValues(this.matrix, built);
    return clone$1(this, { values: built }, true);
  }

  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }

  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, { values: negated }, true);
  }

  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.values);
    return clone$1(this, { values: vals }, true);
  }

  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }

  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }

  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }

  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }

  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }

  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }

  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }

  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }

  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }

  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    if (!this.loc.equals(other.loc)) {
      return false;
    }

    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }

    for (const u of orderedUnits$1) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
}

const INVALID$1 = "Invalid Interval";

// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}

/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */
class Interval {
  /**
   * @private
   */
  constructor(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */
    this.e = config.end;
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.isLuxonInterval = true;
  }

  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }

  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start),
      builtEnd = friendlyDateTime(end);

    const validateError = validateStartEnd(builtStart, builtEnd);

    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd,
      });
    } else {
      return validateError;
    }
  }

  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }

  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }

  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s, e] = (text || "").split("/", 2);
    if (s && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }

      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }

      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }

      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }

  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return (o && o.isLuxonInterval) || false;
  }

  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }

  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }

  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid ? (this.e ? this.e.minus(1) : null) : null;
  }

  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }

  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }

  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts?.useLocaleWeeks) {
      end = this.end.reconfigure({ locale: start.locale });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }

  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }

  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }

  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }

  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }

  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }

  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }

  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes
        .map(friendlyDateTime)
        .filter((d) => this.contains(d))
        .sort((a, b) => a.toMillis() - b.toMillis()),
      results = [];
    let { s } = this,
      i = 0;

    while (s < this.e) {
      const added = sorted[i] || this.e,
        next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }

    return results;
  }

  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);

    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }

    let { s } = this,
      idx = 1,
      next;

    const results = [];
    while (s < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }

    return results;
  }

  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }

  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }

  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }

  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }

  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }

  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    return this.s.equals(other.s) && this.e.equals(other.e);
  }

  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s = this.s > other.s ? this.s : other.s,
      e = this.e < other.e ? this.e : other.e;

    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }

  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s = this.s < other.s ? this.s : other.s,
      e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }

  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals
      .sort((a, b) => a.s - b.s)
      .reduce(
        ([sofar, current], item) => {
          if (!current) {
            return [sofar, item];
          } else if (current.overlaps(item) || current.abutsStart(item)) {
            return [sofar, current.union(item)];
          } else {
            return [sofar.concat([current]), item];
          }
        },
        [[], null]
      );
    if (final) {
      found.push(final);
    }
    return found;
  }

  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null,
      currentCount = 0;
    const results = [],
      ends = intervals.map((i) => [
        { time: i.s, type: "s" },
        { time: i.e, type: "e" },
      ]),
      flattened = Array.prototype.concat(...ends),
      arr = flattened.sort((a, b) => a.time - b.time);

    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;

      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }

        start = null;
      }
    }

    return Interval.merge(results);
  }

  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals))
      .map((i) => this.intersection(i))
      .filter((i) => i && !i.isEmpty());
  }

  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return INVALID$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }

  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid
      ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this)
      : INVALID$1;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }

  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }

  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }

  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */
class luxon_Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });

    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }

  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }

  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }

  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }

  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }

  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    // copy the array, because we cache it internally
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }

  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }

  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }

  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }

  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }

  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }

  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }

  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative(), localeWeek: hasLocaleWeekInfo() };
  }
}

function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(),
    ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}

function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - (days % 7)) / 7;
      },
    ],
    ["days", dayDiff],
  ];

  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;

  /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;

      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);

      if (highWater > later) {
        // we overshot the end point, backtrack cursor by 1
        results[unit]--;
        cursor = earlier.plus(results);

        // if we are still overshooting now, we need to backtrack again
        // this happens in certain situations when diffing times in different zones,
        // because this calculation ignores time zones
        if (cursor > later) {
          // keep the "overshot by 1" around as highWater
          highWater = cursor;
          // backtrack cursor by 1
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

function diff (earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);

  const remainingMillis = later - cursor;

  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  const duration = Duration.fromObject(results, opts);

  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts)
      .shiftTo(...lowerOrderUnits)
      .plus(duration);
  } else {
    return duration;
  }
}

const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";

function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s]) => post(parseDigits(s)) };
}

const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");

function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}

function stripInsensitivities(s) {
  return s
    .replace(/\./g, "") // ignore dots that were made optional
    .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}

function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s]) =>
        strings.findIndex((i) => stripInsensitivities(s) === stripInsensitivities(i)) + startIndex,
    };
  }
}

function offset(regex, groups) {
  return { regex, deser: ([, h, m]) => signedOffset(h, m), groups };
}

function simple(regex) {
  return { regex, deser: ([s]) => s };
}

function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

/**
 * @param token
 * @param {Locale} loc
 */
function unitForToken(token, loc) {
  const one = digitRegex(loc),
    two = digitRegex(loc, "{2}"),
    three = digitRegex(loc, "{3}"),
    four = digitRegex(loc, "{4}"),
    six = digitRegex(loc, "{6}"),
    oneOrTwo = digitRegex(loc, "{1,2}"),
    oneToThree = digitRegex(loc, "{1,3}"),
    oneToSix = digitRegex(loc, "{1,6}"),
    oneToNine = digitRegex(loc, "{1,9}"),
    twoToFour = digitRegex(loc, "{2,4}"),
    fourToSix = digitRegex(loc, "{4,6}"),
    literal = (t) => ({ regex: RegExp(escapeToken(t.val)), deser: ([s]) => s, literal: true }),
    unitate = (t) => {
      if (token.literal) {
        return literal(t);
      }
      switch (t.val) {
        // era
        case "G":
          return oneOf(loc.eras("short"), 0);
        case "GG":
          return oneOf(loc.eras("long"), 0);
        // years
        case "y":
          return intUnit(oneToSix);
        case "yy":
          return intUnit(twoToFour, untruncateYear);
        case "yyyy":
          return intUnit(four);
        case "yyyyy":
          return intUnit(fourToSix);
        case "yyyyyy":
          return intUnit(six);
        // months
        case "M":
          return intUnit(oneOrTwo);
        case "MM":
          return intUnit(two);
        case "MMM":
          return oneOf(loc.months("short", true), 1);
        case "MMMM":
          return oneOf(loc.months("long", true), 1);
        case "L":
          return intUnit(oneOrTwo);
        case "LL":
          return intUnit(two);
        case "LLL":
          return oneOf(loc.months("short", false), 1);
        case "LLLL":
          return oneOf(loc.months("long", false), 1);
        // dates
        case "d":
          return intUnit(oneOrTwo);
        case "dd":
          return intUnit(two);
        // ordinals
        case "o":
          return intUnit(oneToThree);
        case "ooo":
          return intUnit(three);
        // time
        case "HH":
          return intUnit(two);
        case "H":
          return intUnit(oneOrTwo);
        case "hh":
          return intUnit(two);
        case "h":
          return intUnit(oneOrTwo);
        case "mm":
          return intUnit(two);
        case "m":
          return intUnit(oneOrTwo);
        case "q":
          return intUnit(oneOrTwo);
        case "qq":
          return intUnit(two);
        case "s":
          return intUnit(oneOrTwo);
        case "ss":
          return intUnit(two);
        case "S":
          return intUnit(oneToThree);
        case "SSS":
          return intUnit(three);
        case "u":
          return simple(oneToNine);
        case "uu":
          return simple(oneOrTwo);
        case "uuu":
          return intUnit(one);
        // meridiem
        case "a":
          return oneOf(loc.meridiems(), 0);
        // weekYear (k)
        case "kkkk":
          return intUnit(four);
        case "kk":
          return intUnit(twoToFour, untruncateYear);
        // weekNumber (W)
        case "W":
          return intUnit(oneOrTwo);
        case "WW":
          return intUnit(two);
        // weekdays
        case "E":
        case "c":
          return intUnit(one);
        case "EEE":
          return oneOf(loc.weekdays("short", false), 1);
        case "EEEE":
          return oneOf(loc.weekdays("long", false), 1);
        case "ccc":
          return oneOf(loc.weekdays("short", true), 1);
        case "cccc":
          return oneOf(loc.weekdays("long", true), 1);
        // offset/zone
        case "Z":
        case "ZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
        case "ZZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
        // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
        // because we don't have any way to figure out what they are
        case "z":
          return simple(/[a-z_+-/]{1,256}?/i);
        // this special-case "token" represents a place where a macro-token expanded into a white-space literal
        // in this case we accept any non-newline white-space
        case " ":
          return simple(/[^\S\n\r]/);
        default:
          return literal(t);
      }
    };

  const unit = unitate(token) || {
    invalidReason: MISSING_FTP,
  };

  unit.token = token;

  return unit;
}

const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy",
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM",
  },
  day: {
    numeric: "d",
    "2-digit": "dd",
  },
  weekday: {
    short: "EEE",
    long: "EEEE",
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh",
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH",
  },
  minute: {
    numeric: "m",
    "2-digit": "mm",
  },
  second: {
    numeric: "s",
    "2-digit": "ss",
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ",
  },
};

function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;

  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value,
    };
  }

  const style = formatOpts[type];

  // The user might have explicitly specified hour12 or hourCycle
  // if so, respect their decision
  // if not, refer back to the resolvedOpts, which are based on the locale
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      // tokens only differentiate between 24 hours or not,
      // so we do not need to check hourCycle here, which is less supported anyways
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }

  if (val) {
    return {
      literal: false,
      val,
    };
  }

  return undefined;
}

function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [`^${re}$`, units];
}

function match(input, regex, handlers) {
  const matches = input.match(regex);

  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (luxon_hasOwnProperty(handlers, i)) {
        const h = handlers[i],
          groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}

function dateTimeFromMatches(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };

  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }

  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }

  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }

  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }

  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }

  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }

  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }

    return r;
  }, {});

  return [vals, zone, specificOffset];
}

let dummyDateTimeCache = null;

function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }

  return dummyDateTimeCache;
}

function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }

  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);

  if (tokens == null || tokens.includes(undefined)) {
    return token;
  }

  return tokens;
}

function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}

/**
 * @private
 */

class TokenParser {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);

    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }

  explainFromTokens(input) {
    if (!this.isValid) {
      return { input, tokens: this.tokens, invalidReason: this.invalidReason };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers),
        [result, zone, specificOffset] = matches
          ? dateTimeFromMatches(matches)
          : [null, null, undefined];
      if (luxon_hasOwnProperty(matches, "a") && luxon_hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError(
          "Can't include meridiem when specifying 24-hour format"
        );
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset,
      };
    }
  }

  get isValid() {
    return !this.disqualifyingUnit;
  }

  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}

function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}

function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}

function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }

  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}

const INVALID = "Invalid DateTime";
const MAX_DATE = 8.64e15;

function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}

// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}

/**
 * @param {DateTime} dt
 */
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(
      dt.c,
      dt.loc.getMinDaysInFirstWeek(),
      dt.loc.getStartOfWeek()
    );
  }
  return dt.localWeekData;
}

// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid,
  };
  return new DateTime({ ...current, ...alts, old: current });
}

// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  let utcGuess = localTS - o * 60 * 1000;

  // Test whether the zone matches the offset for this ts
  const o2 = tz.offset(utcGuess);

  // If so, offset didn't change and we're done
  if (o === o2) {
    return [utcGuess, o];
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= (o2 - o) * 60 * 1000;

  // If that gives us the local time we want, we're done
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }

  // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
}

// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;

  const d = new Date(ts);

  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds(),
  };
}

// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
}

// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
  const oPre = inst.o,
    year = inst.c.year + Math.trunc(dur.years),
    month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
    c = {
      ...inst.c,
      year,
      month,
      day:
        Math.min(inst.c.day, daysInMonth(year, month)) +
        Math.trunc(dur.days) +
        Math.trunc(dur.weeks) * 7,
    },
    millisToAdd = Duration.fromObject({
      years: dur.years - Math.trunc(dur.years),
      quarters: dur.quarters - Math.trunc(dur.quarters),
      months: dur.months - Math.trunc(dur.months),
      weeks: dur.weeks - Math.trunc(dur.weeks),
      days: dur.days - Math.trunc(dur.days),
      hours: dur.hours,
      minutes: dur.minutes,
      seconds: dur.seconds,
      milliseconds: dur.milliseconds,
    }).as("milliseconds"),
    localTS = objToLocalTS(c);

  let [ts, o] = fixOffset(localTS, oPre, inst.zone);

  if (millisToAdd !== 0) {
    ts += millisToAdd;
    // that could have changed the offset by going over a DST, but we want to keep the ts the same
    o = inst.zone.offset(ts);
  }

  return { ts, o };
}

// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if ((parsed && Object.keys(parsed).length !== 0) || parsedZone) {
    const interpretationZone = parsedZone || zone,
      inst = DateTime.fromObject(parsed, {
        ...opts,
        zone: interpretationZone,
        specificOffset,
      });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}

// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid
    ? Formatter.create(Locale.create("en-US"), {
        allowZ,
        forceSimple: true,
      }).formatDateTimeFromString(dt, format)
    : null;
}

function toISODate(o, extended, precision) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (precision === "year") return c;
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    if (precision === "month") return c;
    c += "-";
  } else {
    c += padStart(o.c.month);
    if (precision === "month") return c;
  }
  c += padStart(o.c.day);
  return c;
}

function toISOTime(
  o,
  extended,
  suppressSeconds,
  suppressMilliseconds,
  includeOffset,
  extendedZone,
  precision
) {
  let showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0,
    c = "";
  switch (precision) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      c += padStart(o.c.hour);
      if (precision === "hour") break;
      if (extended) {
        c += ":";
        c += padStart(o.c.minute);
        if (precision === "minute") break;
        if (showSeconds) {
          c += ":";
          c += padStart(o.c.second);
        }
      } else {
        c += padStart(o.c.minute);
        if (precision === "minute") break;
        if (showSeconds) {
          c += padStart(o.c.second);
        }
      }
      if (precision === "second") break;
      if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
        c += ".";
        c += padStart(o.c.millisecond, 3);
      }
  }

  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }

  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}

// defaults for unspecified units in the supported calendars
const defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  };

// Units in the supported calendars, sorted by bigness
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
  orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond",
  ],
  orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];

// standardize case and plurality in units
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal",
  }[unit.toLowerCase()];

  if (!normalized) throw new InvalidUnitError(unit);

  return normalized;
}

function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}

// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */
function guessOffsetForZone(zone) {
  if (zoneOffsetTs === undefined) {
    zoneOffsetTs = Settings.now();
  }

  // Do not cache anything but IANA zones, because it is not safe to do so.
  // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
  if (zone.type !== "iana") {
    return zone.offset(zoneOffsetTs);
  }
  const zoneName = zone.name;
  let offsetGuess = zoneOffsetGuessCache.get(zoneName);
  if (offsetGuess === undefined) {
    offsetGuess = zone.offset(zoneOffsetTs);
    zoneOffsetGuessCache.set(zoneName, offsetGuess);
  }
  return offsetGuess;
}

// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }

  const loc = Locale.fromObject(opts);

  let ts, o;

  // assume we have the higher-order units
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }

    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }

    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }

  return new DateTime({ ts, zone, loc, o });
}

function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round,
    rounding = isUndefined(opts.rounding) ? "trunc" : opts.rounding,
    format = (c, unit) => {
      c = roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
      const formatter = end.loc.clone(opts).relFormatter(opts);
      return formatter.format(c, unit);
    },
    differ = (unit) => {
      if (opts.calendary) {
        if (!end.hasSame(start, unit)) {
          return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
        } else return 0;
      } else {
        return end.diff(start, unit).get(unit);
      }
    };

  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }

  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}

function lastOpts(argList) {
  let opts = {},
    args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}

/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */
let zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */
const zoneOffsetGuessCache = new Map();

/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */
class DateTime {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;

    let invalid =
      config.invalid ||
      (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) ||
      (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;

    let c = null,
      o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);

      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        // If an offset has been passed and we have not been called from
        // clone(), we can trust it and avoid the offset calculation.
        const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }

    /**
     * @access private
     */
    this._zone = zone;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.invalid = invalid;
    /**
     * @access private
     */
    this.weekData = null;
    /**
     * @access private
     */
    this.localWeekData = null;
    /**
     * @access private
     */
    this.c = c;
    /**
     * @access private
     */
    this.o = o;
    /**
     * @access private
     */
    this.isLuxonDateTime = true;
  }

  // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }

  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }

  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;

    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }

  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }

    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options),
    });
  }

  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options),
      });
    }
  }

  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options),
      });
    }
  }

  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);

    const tsNow = Settings.now(),
      offsetProvis = !isUndefined(opts.specificOffset)
        ? opts.specificOffset
        : zoneToUse.offset(tsNow),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    const useWeekData = definiteWeekDef || (normalized.weekday && !containsGregor);

    // configure ourselves to deal with gregorian dates or week stuff
    let units,
      defaultValues,
      objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }

    // set default values for missing stuff
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }

    // make sure the values we have are in range
    const higherOrderInvalid = useWeekData
        ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek)
        : containsOrdinal
        ? hasInvalidOrdinalData(normalized)
        : hasInvalidGregorianData(normalized),
      invalid = higherOrderInvalid || hasInvalidTimeData(normalized);

    if (invalid) {
      return DateTime.invalid(invalid);
    }

    // compute the actual time
    const gregorian = useWeekData
        ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek)
        : containsOrdinal
        ? ordinalToGregorian(normalized)
        : normalized,
      [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse),
      inst = new DateTime({
        ts: tsFinal,
        zone: zoneToUse,
        o: offsetFinal,
        loc,
      });

    // gregorian data + weekday serves only to validate
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }

    if (!inst.isValid) {
      return DateTime.invalid(inst.invalid);
    }

    return inst;
  }

  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }

  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }

  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }

  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }

    const { locale = null, numberingSystem = null } = opts,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      }),
      [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }

  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }

  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }

  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }

  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return (o && o.isLuxonDateTime) || false;
  }

  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => (t ? t.val : null)).join("");
  }

  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }

  static resetCache() {
    zoneOffsetTs = undefined;
    zoneOffsetGuessCache.clear();
  }

  // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }

  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }

  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }

  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }

  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }

  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }

  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }

  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }

  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }

  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }

  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }

  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }

  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }

  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }

  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }

  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }

  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }

  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }

  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? luxon_Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }

  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? luxon_Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }

  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? luxon_Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }

  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? luxon_Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }

  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }

  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }

  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }

  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }

  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return (
        this.offset > this.set({ month: 1, day: 1 }).offset ||
        this.offset > this.set({ month: 5 }).offset
      );
    }
  }

  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 86400000;
    const minuteMs = 60000;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);

    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (
      c1.hour === c2.hour &&
      c1.minute === c2.minute &&
      c1.second === c2.second &&
      c1.millisecond === c2.millisecond
    ) {
      return [clone(this, { ts: ts1 }), clone(this, { ts: ts2 })];
    }
    return [this];
  }

  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }

  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }

  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid
      ? weeksInWeekYear(
          this.localWeekYear,
          this.loc.getMinDaysInFirstWeek(),
          this.loc.getStartOfWeek()
        )
      : NaN;
  }

  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }

  // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }

  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }

  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, { ts: newTS, zone });
    }
  }

  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone(this, { loc });
  }

  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }

  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid) return this;

    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);

    const settingWeekStuff =
        !isUndefined(normalized.weekYear) ||
        !isUndefined(normalized.weekNumber) ||
        !isUndefined(normalized.weekday),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(
        { ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };

      // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }

    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone(this, { ts, o });
  }

  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }

  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }

  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;

    const o = {},
      normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }

    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }

    return this.set(o);
  }

  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid
      ? this.plus({ [unit]: 1 })
          .startOf(unit, opts)
          .minus(1)
      : this;
  }

  // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt)
      : INVALID;
  }

  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this)
      : INVALID;
  }

  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this)
      : [];
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false,
    precision = "milliseconds",
  } = {}) {
    if (!this.isValid) {
      return null;
    }

    precision = normalizeUnit(precision);
    const ext = format === "extended";

    let c = toISODate(this, ext, precision);
    if (orderedUnits.indexOf(precision) >= 3) c += "T";
    c += toISOTime(
      this,
      ext,
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
    return c;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format = "extended", precision = "day" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended", normalizeUnit(precision));
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended",
    precision = "milliseconds",
  } = {}) {
    if (!this.isValid) {
      return null;
    }

    precision = normalizeUnit(precision);
    let c = includePrefix && orderedUnits.indexOf(precision) >= 3 ? "T" : "";
    return (
      c +
      toISOTime(
        this,
        format === "extended",
        suppressSeconds,
        suppressMilliseconds,
        includeOffset,
        extendedZone,
        precision
      )
    );
  }

  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";

    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }

    return toTechFormat(this, fmt, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }

    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }

  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }

  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }

  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }

  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1000) : NaN;
  }

  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }

  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};

    const base = { ...this.c };

    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }

  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }

  // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }

    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };

    const units = maybeArray(unit).map(Duration.normalizeUnit),
      otherIsLater = otherDateTime.valueOf() > this.valueOf(),
      earlier = otherIsLater ? this : otherDateTime,
      later = otherIsLater ? otherDateTime : this,
      diffed = diff(earlier, later, units, durOpts);

    return otherIsLater ? diffed.negate() : diffed;
  }

  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }

  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }

  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;

    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return (
      adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts)
    );
  }

  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return (
      this.isValid &&
      other.isValid &&
      this.valueOf() === other.valueOf() &&
      this.zone.equals(other.zone) &&
      this.loc.equals(other.loc)
    );
  }

  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime.fromObject({}, { zone: this.zone }),
      padding = options.padding ? (this < base ? -options.padding : options.padding) : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit,
    });
  }

  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;

    return diffRelative(options.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true,
    });
  }

  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }

  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }

  // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });
    return explainFromTokens(localeToUse, text, fmt);
  }

  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }

  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });
    return new TokenParser(localeToUse, fmt);
  }

  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError(
        "fromFormatParser requires an input string and a format parser"
      );
    }
    const { locale = null, numberingSystem = null } = opts,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });

    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(
        `fromFormatParser called with a locale of ${localeToUse}, ` +
          `but the format parser was created for ${formatParser.locale}`
      );
    }

    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);

    if (invalidReason) {
      return DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(
        result,
        zone,
        opts,
        `format ${formatParser.format}`,
        text,
        specificOffset
      );
    }
  }

  // FORMAT PRESETS

  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}

/**
 * @private
 */
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}

const VERSION = "3.7.2";


//# sourceMappingURL=luxon.mjs.map

;// CONCATENATED MODULE: ./src/settings/Timezones.js
/* harmony default export */ var Timezones = ([
    {
        label: "Etc/GMT-12",
        value: "Etc/GMT-12"
    },
    {
        label: "Etc/GMT-11",
        value: "Etc/GMT-11"
    },
    {
        label: "Pacific/Midway",
        value: "Pacific/Midway"
    },
    {
        label: "America/Adak",
        value: "America/Adak"
    },
    {
        label: "America/Anchorage",
        value: "America/Anchorage"
    },
    {
        label: "Pacific/Gambier",
        value: "Pacific/Gambier"
    },
    {
        label: "America/Dawson_Creek",
        value: "America/Dawson_Creek"
    },
    {
        label: "America/Ensenada",
        value: "America/Ensenada"
    },
    {
        label: "America/Los_Angeles",
        value: "America/Los_Angeles"
    },
    {
        label: "America/Chihuahua",
        value: "America/Chihuahua"
    },
    {
        label: "America/Denver",
        value: "America/Denver"
    },
    {
        label: "America/Belize",
        value: "America/Belize"
    },
    {
        label: "America/Cancun",
        value: "America/Cancun"
    },
    {
        label: "America/Chicago",
        value: "America/Chicago"
    },
    {
        label: "Chile/EasterIsland",
        value: "Chile/EasterIsland"
    },
    {
        label: "America/Bogota",
        value: "America/Bogota"
    },
    {
        label: "America/Havana",
        value: "America/Havana"
    },
    {
        label: "America/New_York",
        value: "America/New_York"
    },
    {
        label: "America/Caracas",
        value: "America/Caracas"
    },
    {
        label: "America/Campo_Grande",
        value: "America/Campo_Grande"
    },
    {
        label: "America/Glace_Bay",
        value: "America/Glace_Bay"
    },
    {
        label: "America/Goose_Bay",
        value: "America/Goose_Bay"
    },
    {
        label: "America/Santiago",
        value: "America/Santiago"
    },
    {
        label: "America/La_Paz",
        value: "America/La_Paz"
    },
    {
        label: "America/Argentina/Buenos_Aires",
        value: "America/Argentina/Buenos_Aires"
    },
    {
        label: "America/Montevideo",
        value: "America/Montevideo"
    },
    {
        label: "America/Araguaina",
        value: "America/Araguaina"
    },
    {
        label: "America/Godthab",
        value: "America/Godthab"
    },
    {
        label: "America/Miquelon",
        value: "America/Miquelon"
    },
    {
        label: "America/Sao_Paulo",
        value: "America/Sao_Paulo"
    },
    {
        label: "America/St_Johns",
        value: "America/St_Johns"
    },
    {
        label: "America/Noronha",
        value: "America/Noronha"
    },
    {
        label: "Atlantic/Cape_Verde",
        value: "Atlantic/Cape_Verde"
    },
    {
        label: "Europe/Belfast",
        value: "Europe/Belfast"
    },
    {
        label: "Africa/Abidjan",
        value: "Africa/Abidjan"
    },
    {
        label: "Europe/Dublin",
        value: "Europe/Dublin"
    },
    {
        label: "Europe/Lisbon",
        value: "Europe/Lisbon"
    },
    {
        label: "Europe/London",
        value: "Europe/London"
    },
    {
        label: "UTC",
        value: "UTC"
    },
    {
        label: "Africa/Algiers",
        value: "Africa/Algiers"
    },
    {
        label: "Africa/Windhoek",
        value: "Africa/Windhoek"
    },
    {
        label: "Atlantic/Azores",
        value: "Atlantic/Azores"
    },
    {
        label: "Atlantic/Stanley",
        value: "Atlantic/Stanley"
    },
    {
        label: "Europe/Amsterdam",
        value: "Europe/Amsterdam"
    },
    {
        label: "Europe/Belgrade",
        value: "Europe/Belgrade"
    },
    {
        label: "Europe/Brussels",
        value: "Europe/Brussels"
    },
    {
        label: "Africa/Cairo",
        value: "Africa/Cairo"
    },
    {
        label: "Africa/Blantyre",
        value: "Africa/Blantyre"
    },
    {
        label: "Asia/Beirut",
        value: "Asia/Beirut"
    },
    {
        label: "Asia/Damascus",
        value: "Asia/Damascus"
    },
    {
        label: "Asia/Gaza",
        value: "Asia/Gaza"
    },
    {
        label: "Asia/Jerusalem",
        value: "Asia/Jerusalem"
    },
    {
        label: "Africa/Addis_Ababa",
        value: "Africa/Addis_Ababa"
    },
    {
        label: "Asia/Riyadh",
        value: "Asia/Riyadh"
    },
    {
        label: "Europe/Minsk",
        value: "Europe/Minsk"
    },
    {
        label: "Asia/Tehran",
        value: "Asia/Tehran"
    },
    {
        label: "Asia/Dubai",
        value: "Asia/Dubai"
    },
    {
        label: "Asia/Yerevan",
        value: "Asia/Yerevan"
    },
    {
        label: "Europe/Moscow",
        value: "Europe/Moscow"
    },
    {
        label: "Asia/Kabul",
        value: "Asia/Kabul"
    },
    {
        label: "Asia/Tashkent",
        value: "Asia/Tashkent"
    },
    {
        label: "Asia/Kolkata",
        value: "Asia/Kolkata"
    },
    {
        label: "Asia/Kathmandu",
        value: "Asia/Kathmandu"
    },
    {
        label: "Asia/Dhaka",
        value: "Asia/Dhaka"
    },
    {
        label: "Asia/Yekaterinburg",
        value: "Asia/Yekaterinburg"
    },
    {
        label: "Asia/Rangoon",
        value: "Asia/Rangoon"
    },
    {
        label: "Asia/Bangkok",
        value: "Asia/Bangkok"
    },
    {
        label: "Asia/Novosibirsk",
        value: "Asia/Novosibirsk"
    },
    {
        label: "Etc/GMT+8",
        value: "Etc/GMT+8"
    },
    {
        label: "Asia/Hong_Kong",
        value: "Asia/Hong_Kong"
    },
    {
        label: "Asia/Krasnoyarsk",
        value: "Asia/Krasnoyarsk"
    },
    {
        label: "Australia/Perth",
        value: "Australia/Perth"
    },
    {
        label: "Australia/Eucla",
        value: "Australia/Eucla"
    },
    {
        label: "Asia/Irkutsk",
        value: "Asia/Irkutsk"
    },
    {
        label: "Asia/Seoul",
        value: "Asia/Seoul"
    },
    {
        label: "Asia/Tokyo",
        value: "Asia/Tokyo"
    },
    {
        label: "Australia/Adelaide",
        value: "Australia/Adelaide"
    },
    {
        label: "Australia/Darwin",
        value: "Australia/Darwin"
    },
    {
        label: "Pacific/Marquesas",
        value: "Pacific/Marquesas"
    },
    {
        label: "Etc/GMT+10",
        value: "Etc/GMT+10"
    },
    {
        label: "Australia/Brisbane",
        value: "Australia/Brisbane"
    },
    {
        label: "Australia/Hobart",
        value: "Australia/Hobart"
    },
    {
        label: "Asia/Yakutsk",
        value: "Asia/Yakutsk"
    },
    {
        label: "Australia/Lord_Howe",
        value: "Australia/Lord_Howe"
    },
    {
        label: "Asia/Vladivostok",
        value: "Asia/Vladivostok"
    },
    {
        label: "Pacific/Norfolk",
        value: "Pacific/Norfolk"
    },
    {
        label: "Etc/GMT+12",
        value: "Etc/GMT+12"
    },
    {
        label: "Asia/Anadyr",
        value: "Asia/Anadyr"
    },
    {
        label: "Asia/Magadan",
        value: "Asia/Magadan"
    },
    {
        label: "Pacific/Auckland",
        value: "Pacific/Auckland"
    },
    {
        label: "Pacific/Chatham",
        value: "Pacific/Chatham"
    },
    {
        label: "Pacific/Tongatapu",
        value: "Pacific/Tongatapu"
    },
    {
        label: "Pacific/Kiritimati",
        value: "Pacific/Kiritimati"
    }, 
]);

;// CONCATENATED MODULE: ./src/settings/index.js


var generateId = function() {
    return Math.random().toString(36).substr(2, 9);
};
/* harmony default export */ var settings = ([
    {
        label: "Analytics",
        name: "analytics",
        component: "group",
        description: "Enable Shopify analytics",
        fields: [
            {
                label: "Enabled",
                name: "enabled",
                component: "toggle",
                description: 'Ensure "NEXT_PUBLIC_SHOPIFY_SHOP_ID" is set as an env var',
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: true
            }, 
        ]
    },
    {
        label: "Geo Localization",
        name: "geoLocalization",
        component: "group",
        fields: [
            {
                label: "Enable Country Recommendation",
                component: "toggle",
                name: "enableNotification",
                description: "Enables a modal window that notifies the customer about being on a country different to their own, if disabled the store will pick customer's location by default"
            },
            {
                label: "Modal title",
                component: "text",
                name: "modalTitle",
                description: "Title for the modal shown to the customer, use keyword [currentCountry] to show the current store country name use [customerCountry] to show the country where they are located at, use [storeCurrency] to display store's current currency, use [customerCurrency] to show the customer's country currency (example USD $)"
            },
            {
                label: "Modal description",
                component: "markdown",
                name: "modalBody",
                description: "Body of the modal shown to the customer, use keyword [currentCountry] to show the current store country name, use [customerCountry] to show the country where they are located at, use [storeCurrency] to display store's current currency, use [customerCurrency] to show the customer's country currency (example USD $)"
            }, 
        ]
    },
    {
        label: "Countdown Timer",
        name: "countdown",
        component: "group",
        fields: [
            {
                label: "Enable Countdown",
                name: "enable",
                component: "select",
                options: [
                    {
                        label: "Sitewide",
                        value: "global"
                    },
                    {
                        label: "Homepage Only",
                        value: "homepage"
                    },
                    {
                        label: "Disable",
                        value: "none"
                    }, 
                ],
                defaultValue: "global"
            },
            {
                label: "Show Countdown Expired",
                name: "enableExpired",
                component: "toggle",
                description: "When timer expires, hide banner or live the timer at zero",
                toggleLabels: {
                    true: "Enabled",
                    false: "Disabled"
                },
                defaultValue: true
            },
            {
                component: "select",
                name: "layout",
                label: "Countdown Layout",
                description: "Countdown Layout",
                options: [
                    {
                        label: "Center",
                        value: "center"
                    },
                    {
                        label: "Split",
                        value: "split"
                    }, 
                ],
                defaultValue: "center"
            },
            {
                label: "Background Color",
                name: "backgroundColor",
                component: "color",
                defaultValue: "#EDF0F5"
            },
            {
                label: "Countdown/Message Color",
                name: "clockColor",
                component: "color",
                defaultValue: "#000000"
            },
            {
                label: "Timer Label Display",
                name: "timerLabelInline",
                component: "toggle",
                toggleLabels: {
                    true: "Inline",
                    false: "below number"
                },
                defaultValue: true
            },
            {
                label: "Target Time",
                name: "targetTime",
                component: "text",
                description: "Date format: ".concat(DateTime.now().toFormat("yyyy-MM-dd TT")),
                defaultValue: DateTime.now().toFormat("yyyy-MM-dd TT")
            },
            {
                label: "Target TimeZone",
                name: "timezone",
                component: "select",
                options: Timezones,
                defaultValue: "America/Los_Angeles"
            },
            {
                label: "Title",
                name: "title",
                component: "rich-text",
                description: "",
                defaultValue: "Countdown Timer Copy"
            },
            {
                label: "CTA",
                name: "cta",
                component: "group",
                description: "",
                fields: [
                    {
                        label: "CTA URL",
                        name: "link",
                        component: "link",
                        description: "Recommended Max Character count: 17"
                    },
                    {
                        component: "select",
                        name: "ctaPosition",
                        label: "CTA Position (Desktop)",
                        options: [
                            {
                                label: "Right",
                                value: "right"
                            },
                            {
                                label: "next to title",
                                value: ""
                            }, 
                        ],
                        defaultValue: "right"
                    },
                    {
                        component: "select",
                        name: "style",
                        label: "Cta Style",
                        description: "CTA Style and link title will be applied the same for desktop and mobile",
                        options: [
                            {
                                label: "Primary",
                                value: "button button--primary inline-block"
                            },
                            {
                                label: "Secondary",
                                value: "button button--secondary inline-block"
                            },
                            {
                                label: "Focus Link",
                                value: "focus-link"
                            },
                            {
                                label: "checkout",
                                value: "button button--checkout inline-block"
                            }, 
                        ],
                        defaultValue: "button button--primary inline-block"
                    }, 
                ]
            }, 
        ]
    },
    {
        label: "Discount Banner",
        name: "discountBanner",
        component: "group",
        description: "Discount Banner Settings",
        fields: [
            {
                component: "toggle",
                name: "toggleAutoRotate",
                label: "Auto Rotate Toggle",
                description: "Describes if banner is auto-rotating when 2 messages populated.",
                toggleLabels: {
                    true: "Enable",
                    false: "Disable"
                },
                defaultValue: true
            },
            {
                component: "toggle",
                name: "toggleAutoRotateInt",
                label: "Int Auto Rotate Toggle",
                description: "Int - Describes if banner is auto-rotating when 2 messages populated.",
                toggleLabels: {
                    true: "Enable",
                    false: "Disable"
                },
                defaultValue: true
            },
            {
                component: "group-list",
                name: "messages",
                label: "Discount Banner Messages",
                description: "Discount banner messages for desktop and mobile.",
                fields: [
                    {
                        component: "textarea",
                        name: "messageMobile",
                        label: "Mobile Message"
                    },
                    {
                        component: "textarea",
                        name: "messageDesktop",
                        label: "Desktop Message"
                    }, 
                ]
            },
            {
                component: "group-list",
                name: "messagesInt",
                label: "Int Discount Banner Messages",
                description: "International discount banner messages for desktop and mobile.",
                fields: [
                    {
                        component: "textarea",
                        name: "messageMobile",
                        label: "Mobile Message"
                    },
                    {
                        component: "textarea",
                        name: "messageDesktop",
                        label: "Desktop Message"
                    }, 
                ]
            },
            {
                component: "select",
                name: "bgColor",
                label: "Background Color",
                description: "For discount banner background color, select one from preselected brand colors.",
                options: [
                    {
                        label: "Black",
                        value: "black"
                    },
                    {
                        label: "Grey",
                        value: "grey-1"
                    },
                    {
                        label: "Pink",
                        value: "primary-2"
                    },
                    {
                        label: "Green",
                        value: "quaternary-1"
                    },
                    {
                        label: "Blue 1",
                        value: "quinary-1"
                    },
                    {
                        label: "Blue 2",
                        value: "quinary-2"
                    },
                    {
                        label: "Air Dry Cream",
                        value: "stylers-1"
                    },
                    {
                        label: "Sculpting Cream",
                        value: "stylers-2"
                    },
                    {
                        label: "Texture Foam",
                        value: "stylers-3"
                    },
                    {
                        label: "Sleek Stick",
                        value: "stylers-4"
                    },
                    {
                        label: "Scalp Blue",
                        value: "scalp-blue"
                    },
                    {
                        label: "Magenta",
                        value: "magenta"
                    },
                    {
                        label: "Medium Pink",
                        value: "med-pink"
                    },
                    {
                        label: "Briogeo Blue",
                        value: "brio-blue"
                    },
                    {
                        label: "Cloud",
                        value: "cloud"
                    },
                    {
                        label: "Mineral",
                        value: "mineral"
                    },
                    {
                        label: "Deep Sea",
                        value: "deep-sea"
                    },
                    {
                        label: "Sandstone",
                        value: "sandstone"
                    },
                    {
                        label: "Sorrel",
                        value: "sorrel"
                    },
                    {
                        label: "Butter",
                        value: "butter"
                    },
                    {
                        label: "Rosehip",
                        value: "rosehip"
                    },
                    {
                        label: "Chestnut",
                        value: "chestnut"
                    }, 
                ],
                defaultValue: "quinary-2"
            },
            {
                component: "select",
                name: "textColor",
                label: "Text Color",
                options: [
                    {
                        label: "Light",
                        value: "text-white"
                    },
                    {
                        label: "Dark",
                        value: "text-black"
                    }, 
                ],
                defaultValue: "text-black"
            },
            {
                component: "select",
                name: "bgColorInt",
                label: "Int Background Color",
                description: "International - For discount banner background color, select one from preselected brand colors.",
                options: [
                    {
                        label: "Black",
                        value: "black"
                    },
                    {
                        label: "Grey",
                        value: "grey-1"
                    },
                    {
                        label: "Pink",
                        value: "primary-2"
                    },
                    {
                        label: "Green",
                        value: "quaternary-1"
                    },
                    {
                        label: "Blue 1",
                        value: "quinary-1"
                    },
                    {
                        label: "Blue 2",
                        value: "quinary-2"
                    },
                    {
                        label: "Air Dry Cream",
                        value: "stylers-1"
                    },
                    {
                        label: "Sculpting Cream",
                        value: "stylers-2"
                    },
                    {
                        label: "Texture Foam",
                        value: "stylers-3"
                    },
                    {
                        label: "Sleek Stick",
                        value: "stylers-4"
                    },
                    {
                        label: "Scalp Blue",
                        value: "scalp-blue"
                    },
                    {
                        label: "Magenta",
                        value: "magenta"
                    },
                    {
                        label: "Medium Pink",
                        value: "med-pink"
                    },
                    {
                        label: "Briogeo Blue",
                        value: "brio-blue"
                    },
                    {
                        label: "Cloud",
                        value: "cloud"
                    },
                    {
                        label: "Mineral",
                        value: "mineral"
                    },
                    {
                        label: "Deep Sea",
                        value: "deep-sea"
                    },
                    {
                        label: "Sandstone",
                        value: "sandstone"
                    },
                    {
                        label: "Sorrel",
                        value: "sorrel"
                    },
                    {
                        label: "Butter",
                        value: "butter"
                    },
                    {
                        label: "Rosehip",
                        value: "rosehip"
                    },
                    {
                        label: "Chestnut",
                        value: "chestnut"
                    }, 
                ],
                defaultValue: "quinary-2"
            },
            {
                component: "select",
                name: "textColorInt",
                label: "Int Text Color",
                options: [
                    {
                        label: "Light",
                        value: "text-white"
                    },
                    {
                        label: "Dark",
                        value: "text-black"
                    }, 
                ],
                defaultValue: "text-black"
            },
            {
                component: "group-list",
                name: "overrides",
                label: "Discount overrides",
                description: "Describes the text cases when a discount code is applied on the cart, this overrides will apply to both INTL and US customers the same",
                fields: [
                    {
                        component: "text",
                        name: "discountCode",
                        label: "Discount code reference",
                        description: "Discount code that needs to be present on the cart in order to trigger this override"
                    },
                    {
                        component: "textarea",
                        name: "messageMobile",
                        label: "Mobile Message"
                    },
                    {
                        component: "textarea",
                        name: "messageDesktop",
                        label: "Desktop Message"
                    }, 
                ]
            }, 
        ]
    },
    {
        label: "Global Share Image",
        name: "globalShareImage",
        component: "group",
        fields: [
            {
                label: "Image",
                name: "image",
                component: "image",
                description: "Recommended image size: 1200 x 628px"
            }, 
        ]
    },
    {
        label: "Preload Images",
        name: "preloadImages",
        component: "textarea",
        description: "Enter Image URL separated by comma"
    },
    {
        label: "Header",
        name: "header",
        component: "group",
        fields: [
            {
                label: "Logo",
                name: "logo",
                component: "image"
            },
            {
                label: "Logo Alt Text",
                name: "tagline",
                component: "text",
                description: "Add descriptive text for ADA"
            },
            {
                label: "Rewards Link in Header",
                name: "rewards_enabled",
                component: "toggle",
                description: "Toggle Off if wanting to display custom CTA below instead.",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: true
            },
            {
                label: "CTA",
                name: "cta",
                component: "group",
                description: "If Rewards Link in Header is toggled off then CTA will display instead",
                fields: [
                    {
                        label: "CTA URL",
                        name: "link",
                        component: "link",
                        description: "Recommended Max Character count: 17"
                    },
                    {
                        component: "select",
                        name: "style",
                        label: "Cta Style",
                        description: "CTA Style and link title will be applied the same for desktop and mobile",
                        options: [
                            {
                                label: "Primary",
                                value: "button button--primary inline-block"
                            },
                            {
                                label: "Secondary",
                                value: "button button--secondary inline-block"
                            },
                            {
                                label: "Focus Link",
                                value: "focus-link"
                            },
                            {
                                label: "Focus Link Rosehip",
                                value: "focus-link-rosehip"
                            },
                            {
                                label: "checkout",
                                value: "button button--checkout inline-block"
                            }, 
                        ],
                        defaultValue: "button button--primary inline-block"
                    }, 
                ]
            }, 
        ]
    },
    {
        label: "Header Menu",
        name: "header_menu",
        component: "group-list",
        itemProps: {
            label: "{{item.link.text}}"
        },
        fields: [
            {
                label: "Link",
                name: "link",
                component: "link"
            },
            {
                label: "Column",
                name: "column",
                component: "group-list",
                fields: [
                    {
                        component: "toggle",
                        name: "enable_column",
                        label: "Enable",
                        description: "Enable Column",
                        defaultValue: true
                    },
                    {
                        component: "toggle",
                        name: "featured_column",
                        label: "Featured Column",
                        description: "Doubles the column width and allows for links images to be placed on top of the links",
                        defaultValue: false
                    },
                    {
                        label: "Menu",
                        name: "menu",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.link.text}}"
                        },
                        fields: [
                            {
                                component: "toggle",
                                name: "open_column",
                                label: "Enable",
                                description: "Mobile Menu- Show Menu Dropdown Open by Default",
                                defaultValue: false
                            },
                            {
                                label: "Link",
                                name: "link",
                                component: "link"
                            },
                            {
                                label: "Link Icon",
                                name: "link_icon",
                                component: "image",
                                description: "Recommended Icon Size: 50px x 50px (square dimension) for regular icons next to the text"
                            },
                            {
                                label: "Child Menu",
                                name: "child_menu",
                                component: "group-list",
                                itemProps: {
                                    label: "{{item.link.text}}"
                                },
                                fields: [
                                    {
                                        label: "Link",
                                        name: "link",
                                        component: "link"
                                    },
                                    {
                                        label: "Link Icon",
                                        name: "link_icon",
                                        component: "image",
                                        description: "Recommended Icon Size: 50px x 50px (square dimension) and 200px x 200px for featured columns where icons are placed on top of the text"
                                    },
                                    {
                                        component: "color",
                                        name: "link_color",
                                        label: "Custom Color",
                                        description: "Custom Link color"
                                    },
                                    {
                                        label: "Promo Text",
                                        name: "promo_text",
                                        component: "text",
                                        description: "Add Promo Text"
                                    },
                                    {
                                        label: "Hover Image",
                                        name: "link_hover_image",
                                        component: "image",
                                        description: "Recommended Icon Size: 1392px x 920px"
                                    },
                                    {
                                        component: "toggle",
                                        name: "bold_underline",
                                        label: "Bold and Underline",
                                        description: "Make menu item bold and underline",
                                        defaultValue: false
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        label: "CTA",
                        name: "cta",
                        component: "group",
                        fields: [
                            {
                                label: "CTA Image",
                                name: "image",
                                component: "image"
                            },
                            {
                                label: "CTA Title",
                                name: "title",
                                component: "text"
                            },
                            {
                                label: "CTA URL",
                                name: "url",
                                component: "text"
                            }, 
                        ]
                    }, 
                ]
            }, 
        ]
    },
    {
        label: "Mobile Sticky Navigation",
        name: "mobileStickyNavigation",
        component: "group-list",
        itemProps: {
            label: "{{item.link.text}}"
        },
        fields: [
            {
                label: "Link",
                name: "link",
                component: "link"
            }, 
        ]
    },
    {
        label: "Footer",
        name: "footer",
        component: "group",
        fields: [
            {
                label: "Quiz Banner",
                name: "quizBanner",
                component: "group",
                fields: [
                    {
                        label: "Banner Invisibility",
                        name: "bannerInvisibility",
                        description: "Hide the footer quiz banner on the following pages",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.link.text}}"
                        },
                        fields: [
                            {
                                label: "Link",
                                name: "link",
                                component: "link"
                            }, 
                        ]
                    },
                    {
                        component: "text",
                        label: "Title",
                        name: "sectionTitle"
                    },
                    {
                        name: "fontSize",
                        label: "Title Font Size",
                        component: "select",
                        options: [
                            {
                                label: "H1",
                                value: "text-h1-m md:text-h1"
                            },
                            {
                                label: "H2",
                                value: "text-h2-m md:text-h2"
                            },
                            {
                                label: "H3",
                                value: "text-h3-m md:text-h3 text-[22px] md:text-[38px]"
                            }, 
                        ],
                        defaultValue: "text-h3-m md:text-h3 text-[22px] md:text-[38px]"
                    },
                    {
                        component: "textarea",
                        label: "Description",
                        name: "sectionDescription"
                    },
                    {
                        label: "CTA",
                        name: "cta",
                        component: "group",
                        fields: [
                            {
                                label: "CTA URL",
                                name: "link",
                                component: "link"
                            },
                            {
                                component: "select",
                                name: "style",
                                label: "Cta Style",
                                options: [
                                    {
                                        label: "Primary",
                                        value: "button button--primary inline-block"
                                    },
                                    {
                                        label: "Secondary",
                                        value: "button button--secondary inline-block"
                                    },
                                    {
                                        label: "Tertiary",
                                        value: "button button--tertiary inline-block"
                                    },
                                    {
                                        label: "Focus Link",
                                        value: "focus-link"
                                    },
                                    {
                                        label: "Focus Link White",
                                        value: "focus-link-white"
                                    },
                                    {
                                        label: "checkout",
                                        value: "button button--checkout inline-block"
                                    }, 
                                ],
                                defaultValue: "button button--primary inline-block"
                            }, 
                        ]
                    },
                    {
                        component: "select",
                        name: "textAlign",
                        label: "Text Align (Desktop)",
                        options: [
                            {
                                label: "Left",
                                value: "md:text-left"
                            },
                            {
                                label: "Center",
                                value: "md:text-center"
                            },
                            {
                                label: "Right",
                                value: "md:text-right"
                            }, 
                        ],
                        defaultValue: "md:text-center"
                    },
                    {
                        component: "select",
                        name: "textAlign_m",
                        label: "Text Align (Mobile)",
                        options: [
                            {
                                label: "Left",
                                value: "text-left"
                            },
                            {
                                label: "Center",
                                value: "text-center"
                            },
                            {
                                label: "Right",
                                value: "text-right"
                            }, 
                        ],
                        defaultValue: "text-center"
                    },
                    {
                        name: "lightText",
                        label: "Text Color",
                        component: "toggle",
                        toggleLabels: {
                            true: "Light",
                            false: "Dark"
                        },
                        defaultValue: "Light"
                    },
                    {
                        name: "bgColor",
                        label: "Background Color",
                        component: "select",
                        description: "For section background color, select one from preselected brand colors.",
                        options: [
                            {
                                label: "Black",
                                value: "bg-black"
                            },
                            {
                                label: "White",
                                value: "bg-white"
                            },
                            {
                                label: "Grey",
                                value: "bg-grey-1"
                            },
                            {
                                label: "Light Grey",
                                value: "bg-grey-9"
                            },
                            {
                                label: "Blue 1",
                                value: "bg-quinary-1"
                            },
                            {
                                label: "Blue 2",
                                value: "bg-quinary-2"
                            },
                            {
                                label: "Blue 3",
                                value: "bg-light-blue"
                            },
                            {
                                label: "Cream 1",
                                value: "bg-tertiary-2"
                            },
                            {
                                label: "Cream 2",
                                value: "bg-senary-4"
                            },
                            {
                                label: "Purple",
                                value: "bg-tertiary-1"
                            },
                            {
                                label: "Green",
                                value: "bg-quaternary-1"
                            },
                            {
                                label: "Pink 1",
                                value: "bg-primary-2"
                            },
                            {
                                label: "Pink 2",
                                value: "bg-secondary-1"
                            },
                            {
                                label: "Yellow",
                                value: "bg-yellow"
                            },
                            {
                                label: "Orange",
                                value: "bg-secondary-2"
                            },
                            {
                                label: "Seafoam 1",
                                value: "bg-quaternary-2"
                            },
                            {
                                label: "Seafoam 2",
                                value: "bg-senary-3"
                            },
                            {
                                label: "Seafoam 3",
                                value: "bg-senary-5"
                            },
                            {
                                label: "Air Dry Cream",
                                value: "bg-stylers-1"
                            },
                            {
                                label: "Sculpting Cream",
                                value: "bg-stylers-2"
                            },
                            {
                                label: "Texture Foam",
                                value: "bg-stylers-3"
                            },
                            {
                                label: "Sleek Stick",
                                value: "bg-stylers-4"
                            },
                            {
                                label: "Scalp Blue",
                                value: "bg-scalp-blue"
                            },
                            {
                                label: "Magenta",
                                value: "bg-magenta"
                            },
                            {
                                label: "Medium Pink",
                                value: "bg-med-pink"
                            },
                            {
                                label: "Briogeo Blue",
                                value: "bg-brio-blue"
                            },
                            {
                                label: "Cloud",
                                value: "bg-cloud"
                            },
                            {
                                label: "Mineral",
                                value: "bg-mineral"
                            },
                            {
                                label: "Deep Sea",
                                value: "bg-deep-sea"
                            },
                            {
                                label: "Sandstone",
                                value: "bg-sandstone"
                            },
                            {
                                label: "Sorrel",
                                value: "bg-sorrel"
                            },
                            {
                                label: "Butter",
                                value: "bg-butter"
                            },
                            {
                                label: "Rosehip",
                                value: "bg-rosehip"
                            },
                            {
                                label: "Chestnut",
                                value: "bg-chestnut"
                            }, 
                        ],
                        defaultValue: "bg-quaternary-2"
                    }, 
                ]
            },
            {
                label: "Monogram",
                name: "monogram",
                component: "image"
            },
            {
                label: "Tagline",
                name: "tagline",
                component: "text"
            },
            {
                name: "footerBgColor",
                label: "Background Color",
                component: "select",
                description: "For section background color, select one from preselected brand colors.",
                options: [
                    {
                        label: "Gray Black",
                        value: "bg-gray-black"
                    },
                    {
                        label: "Black",
                        value: "bg-black"
                    },
                    {
                        label: "White",
                        value: "bg-white"
                    },
                    {
                        label: "Grey",
                        value: "bg-grey-1"
                    },
                    {
                        label: "Light Grey",
                        value: "bg-grey-9"
                    },
                    {
                        label: "Blue 1",
                        value: "bg-quinary-1"
                    },
                    {
                        label: "Blue 2",
                        value: "bg-quinary-2"
                    },
                    {
                        label: "Blue 3",
                        value: "bg-light-blue"
                    },
                    {
                        label: "Cream 1",
                        value: "bg-tertiary-2"
                    },
                    {
                        label: "Cream 2",
                        value: "bg-senary-4"
                    },
                    {
                        label: "Purple",
                        value: "bg-tertiary-1"
                    },
                    {
                        label: "Green",
                        value: "bg-quaternary-1"
                    },
                    {
                        label: "Pink 1",
                        value: "bg-primary-2"
                    },
                    {
                        label: "Pink 2",
                        value: "bg-secondary-1"
                    },
                    {
                        label: "Yellow",
                        value: "bg-yellow"
                    },
                    {
                        label: "Orange",
                        value: "bg-secondary-2"
                    },
                    {
                        label: "Seafoam 1",
                        value: "bg-quaternary-2"
                    },
                    {
                        label: "Seafoam 2",
                        value: "bg-senary-3"
                    },
                    {
                        label: "Seafoam 3",
                        value: "bg-senary-5"
                    },
                    {
                        label: "Air Dry Cream",
                        value: "bg-stylers-1"
                    },
                    {
                        label: "Sculpting Cream",
                        value: "bg-stylers-2"
                    },
                    {
                        label: "Texture Foam",
                        value: "bg-stylers-3"
                    },
                    {
                        label: "Sleek Stick",
                        value: "bg-stylers-4"
                    },
                    {
                        label: "Scalp Blue",
                        value: "bg-scalp-blue"
                    },
                    {
                        label: "Magenta",
                        value: "bg-magenta"
                    },
                    {
                        label: "Medium Pink",
                        value: "bg-med-pink"
                    },
                    {
                        label: "Briogeo Blue",
                        value: "bg-brio-blue"
                    },
                    {
                        label: "Cloud",
                        value: "bg-cloud"
                    },
                    {
                        label: "Mineral",
                        value: "bg-mineral"
                    },
                    {
                        label: "Deep Sea",
                        value: "bg-deep-sea"
                    },
                    {
                        label: "Sandstone",
                        value: "bg-sandstone"
                    },
                    {
                        label: "Sorrel",
                        value: "bg-sorrel"
                    },
                    {
                        label: "Butter",
                        value: "bg-butter"
                    },
                    {
                        label: "Rosehip",
                        value: "bg-rosehip"
                    },
                    {
                        label: "Chestnut",
                        value: "bg-chestnut"
                    }, 
                ],
                defaultValue: "bg-black"
            },
            {
                label: "Footer Menu 1",
                name: "footerMenu1",
                component: "group-list",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                fields: [
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    }, 
                ]
            },
            {
                label: "Footer Menu 2",
                name: "footerMenu2",
                component: "group-list",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                fields: [
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    }, 
                ]
            },
            {
                label: "Footer Small Menu",
                name: "footerSmallMenu",
                component: "group-list",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                fields: [
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    }, 
                ]
            },
            {
                label: "Email Subscribe",
                name: "email",
                component: "group",
                fields: [
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Klaviyo List ID",
                        name: "listId",
                        component: "text"
                    },
                    {
                        label: "Button Text",
                        name: "buttonText",
                        component: "text"
                    },
                    {
                        label: "Success Message",
                        name: "successMessage",
                        component: "text"
                    }, 
                ]
            }, 
        ]
    },
    {
        label: "Product",
        name: "product",
        component: "group",
        fields: [
            {
                component: "group",
                name: "productValueProps",
                label: "Value Props",
                fields: [
                    {
                        label: "Value Icon 1",
                        name: "value_icon_1",
                        component: "image",
                        description: "Recommended SVG Icon Size: 24px x 24px (square dimension)"
                    },
                    {
                        label: "Value Promo Text 1",
                        name: "value_text_1",
                        component: "text",
                        description: "Value Description (recommended 24 characters)"
                    },
                    {
                        label: "Value Icon 2",
                        name: "value_icon_2",
                        component: "image",
                        description: "Recommended SVG Icon Size: 24px x 24px (square dimension)"
                    },
                    {
                        label: "Value Promo Text 2",
                        name: "value_text_2",
                        component: "text",
                        description: "Value Description (recommended 24 characters)"
                    },
                    {
                        label: "Value Icon 3",
                        name: "value_icon_3",
                        component: "image",
                        description: "Recommended SVG Icon Size: 24px x 24px (square dimension)"
                    },
                    {
                        label: "Value Promo Text 3",
                        name: "value_text_3",
                        component: "text",
                        description: "Value Description (recommended 24 characters)"
                    }, 
                ]
            },
            {
                label: "Coming Soon Email Subscribe",
                name: "productEmail",
                component: "group",
                fields: [
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Klaviyo List ID",
                        name: "listId",
                        component: "text"
                    },
                    {
                        label: "Button Text",
                        name: "buttonText",
                        component: "text"
                    },
                    {
                        label: "Success Message",
                        name: "successMessage",
                        component: "text"
                    }, 
                ]
            },
            {
                component: "toggle",
                name: "enableGlobalDiscountMessage",
                label: "Enable global discount message",
                toggleLabels: {
                    true: "Enabled",
                    false: "Disabled"
                }
            },
            {
                component: "textarea",
                name: "globalDiscountMessage",
                label: "Global discount message",
                info: "Will override any discount message on all products with the exception of the prodcuts listed on the setting below"
            },
            {
                component: "list",
                name: "globalDiscountExceptions",
                label: "Global discount message exceptions",
                info: "The products populated on this list will not display the global discount message populated above if enabled",
                field: {
                    component: "productSearch"
                }
            }
        ]
    },
    {
        label: "Cart Page",
        name: "cartPage",
        component: "group",
        fields: [
            {
                label: "Cart Empty Message",
                name: "cartEmptyMessage",
                component: "text",
                defaultValue: "Oops! Your cart is currently empty."
            },
            {
                label: "CTA",
                name: "cta",
                component: "group",
                fields: [
                    {
                        label: "CTA Title",
                        name: "title",
                        component: "text",
                        defaultValue: "continue shopping"
                    },
                    {
                        label: "CTA URL",
                        name: "url",
                        component: "text",
                        defaultValue: "/"
                    }, 
                ]
            }, 
        ]
    },
    {
        label: "Side Cart",
        name: "sideCart",
        component: "group",
        fields: [
            {
                label: "Free Shipping Threshold",
                name: "freeShippingThreshold",
                component: "group",
                fields: [
                    {
                        label: "Free Shipping Threshold",
                        name: "Threshold",
                        component: "number",
                        description: "Enter a dollar amount. Free shipping will be applied when cart total meets the threshold.",
                        defaultValue: 0
                    },
                    {
                        label: "Free shipping product information",
                        name: "information",
                        component: "text",
                        description: "Example: away from our free mini hair mask OR away from free shipping. (use text [TOTAL] for variable for left amount)",
                        defaultValue: "You are only [TOTAL] away from free shipping. (subscription orders ship free)"
                    },
                    {
                        label: "Message when threshold is met",
                        name: "message",
                        component: "text",
                        description: "Example: Yay! you're getting a free mini hair mask!",
                        defaultValue: "Yay! You're getting free shipping!"
                    },
                    {
                        label: "Enable subscription shipping message",
                        name: "enableSubscriptionText",
                        description: "If enabled, carts with subscriptions will show the free shipping message below",
                        component: "toggle",
                        toggleLabels: {
                            true: "Enabled",
                            false: "Disabled"
                        }
                    },
                    {
                        label: "Subscription shipping message",
                        name: "subscriptionThresoldText",
                        component: "text",
                        defaultValue: "Yay! You're getting free shipping!"
                    }, 
                ]
            },
            {
                label: "Promotional Slider",
                name: "promotionalSlider",
                component: "group",
                fields: [
                    {
                        label: "Enable Promotional Slider",
                        name: "enable",
                        component: "toggle",
                        toggleLabels: {
                            true: "Enabled",
                            false: "Disabled"
                        }
                    },
                    {
                        label: "Background Color",
                        name: "backgroundColorHex",
                        component: "color",
                        defaultValue: "#B8C5D6"
                    },
                    {
                        label: "Text Color",
                        name: "textColor",
                        component: "select",
                        options: [
                            {
                                label: "White",
                                value: "text-white"
                            },
                            {
                                label: "Black",
                                value: "text-black"
                            }, 
                        ],
                        defaultValue: "text-black"
                    },
                    {
                        label: "Enable Auto Play",
                        name: "enableAutoplay",
                        component: "toggle",
                        toggleLabels: {
                            true: "Enabled",
                            false: "Disabled"
                        }
                    },
                    {
                        label: "Autoplay Speed",
                        name: "autoplaySpeed",
                        component: "number",
                        description: "Time each slide will stay in screen in seconds (if auto  play is enabled)",
                        defaultValue: 5
                    },
                    {
                        label: "Promotional Slide",
                        name: "slide",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.text}}"
                        },
                        fields: [
                            {
                                label: "Customer Base",
                                name: "customerBase",
                                component: "select",
                                options: [
                                    {
                                        label: "US only ",
                                        value: "us"
                                    },
                                    {
                                        label: "International Only",
                                        value: "intl"
                                    },
                                    {
                                        label: "All",
                                        value: "all"
                                    }, 
                                ],
                                defaultValue: "all"
                            },
                            {
                                label: "Slide Text",
                                name: "text",
                                component: "markdown",
                                defaultValue: "Promotional message"
                            }
                        ]
                    }
                ]
            },
            {
                label: "Enable Upsell Products",
                name: "enableUpsellProducts",
                component: "toggle",
                toggleLabels: {
                    true: "Enabled",
                    false: "Disabled"
                },
                defaultValue: true
            },
            {
                label: "Upsell Products Label",
                name: "upsellProductsLabel",
                component: "text",
                defaultValue: "You May Also Like"
            }
        ]
    },
    {
        label: "Discount Highlight",
        name: "discountHighlight",
        component: "group",
        fields: [
            {
                label: "Enable Discount Highlight",
                name: "enableDiscountHighlight",
                component: "toggle",
                toggleLabels: {
                    true: "Enabled",
                    false: "Disabled"
                },
                description: "If enabled, percentage difference between compare at price vs price will be shown on the mini cart and cart template, this will also enable this discount to be visible within the PDP"
            },
            {
                label: "Cart Discount Message",
                name: "cartDiscountMessage",
                component: "text",
                defaultValue: "Black Friday Savings"
            },
            {
                label: "PDP discount message",
                name: "pdpDiscountMessage",
                component: "text",
                description: "Use the keyword [discount] to dynamically display the savings value, if this text is not populated the text will not be displayed",
                defaultValue: "[discount] OFF BLACK FRIDAY"
            }, 
        ]
    },
    {
        label: "Search",
        name: "search",
        component: "group",
        fields: [
            {
                label: "Terms heading",
                name: "termsHeading",
                component: "text",
                defaultValue: "Popular Searches"
            },
            {
                label: "Popular search terms",
                name: "terms",
                component: "group-list",
                itemProps: {
                    label: "{{item.label}}"
                },
                defaultItem: function() {
                    return {
                        id: generateId(),
                        label: "New term"
                    };
                },
                fields: [
                    {
                        label: "Term",
                        name: "label",
                        component: "text"
                    }, 
                ],
                defaultValue: [
                    {
                        label: "Moisturize",
                        value: "Moisturize"
                    },
                    {
                        label: "Strengthen",
                        value: "Strengthen"
                    },
                    {
                        label: "Repair",
                        value: "Repair"
                    },
                    {
                        label: "Treatment",
                        value: "Treatment"
                    },
                    {
                        label: "Charcoal",
                        value: "Charcoal"
                    },
                    {
                        label: "Refresh",
                        value: "Refresh"
                    },
                    {
                        label: "Shampoo",
                        value: "Shampoo"
                    },
                    {
                        label: "Conditioner",
                        value: "Conditioner"
                    },
                    {
                        label: "Leave-In",
                        value: "Leave-In"
                    }, 
                ]
            },
            {
                label: "Terms heading",
                name: "productsHeading",
                component: "text",
                defaultValue: "Popular products"
            },
            {
                name: "products",
                label: "Popular products",
                component: "group-list",
                description: "Only add max of three products",
                itemProps: {
                    label: "{{item.product.title}}"
                },
                fields: [
                    {
                        name: "product",
                        component: "productSearch",
                        label: "Product"
                    }, 
                ]
            }, 
        ]
    },
    {
        label: "Collection Tile",
        name: "collectionTile",
        component: "group",
        fields: [
            {
                label: "Promo Tile Campaigns",
                name: "campaigns",
                component: "group-list",
                itemProps: {
                    label: "{{item.name}}"
                },
                fields: [
                    {
                        label: "Enable",
                        name: "enabled",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Name",
                        name: "name",
                        component: "text"
                    },
                    {
                        label: "Promo Tiles",
                        name: "promoTiles",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.position}}: {{item.text.heading}}"
                        },
                        fields: [
                            {
                                label: "Grid Position",
                                name: "position",
                                component: "number",
                                description: "Assigns grid order"
                            },
                            {
                                label: "Aspect Ratio",
                                name: "aspectRatio",
                                component: "select",
                                options: [
                                    {
                                        label: "1:1",
                                        value: "aspect-[1/1]"
                                    },
                                    {
                                        label: "4:5",
                                        value: "aspect-[4/5]"
                                    },
                                    {
                                        label: "3:4",
                                        value: "aspect-[3/4]"
                                    },
                                    {
                                        label: "2:3",
                                        value: "aspect-[2/3]"
                                    },
                                    {
                                        label: "9:16",
                                        value: "aspect-[9/16]"
                                    },
                                    {
                                        label: "Fill",
                                        value: "h-full"
                                    }, 
                                ]
                            },
                            {
                                label: "Link",
                                name: "link",
                                component: "link",
                                description: "Makes the entire tile a clickable link"
                            },
                            {
                                label: "Image Settings",
                                name: "background",
                                component: "group",
                                fields: [
                                    {
                                        label: "Image Alt",
                                        name: "alt",
                                        component: "text",
                                        description: "Brief description of image"
                                    },
                                    {
                                        label: "Desktop Image",
                                        name: "d_image",
                                        component: "image",
                                        description: '*Required. Recommended Image size for "Fill" setting: 674px x 1000px'
                                    },
                                    {
                                        label: "Mobile Image",
                                        name: "m_image",
                                        component: "image",
                                        description: '*Required. Recommended Image size for "Fill" setting: 628px x 1528px'
                                    }, 
                                ]
                            }, 
                        ],
                        defaultItem: {
                            position: 5,
                            aspectRatio: "h-full"
                        }
                    },
                    {
                        label: "Collection Handles",
                        name: "collections",
                        component: "list",
                        description: 'Add all collection handles that will run this campaign, e.g. "all", "best-sellers"',
                        field: {
                            component: "text"
                        }
                    }, 
                ],
                defaultItem: {
                    enabled: false,
                    name: "Campaign",
                    promoTiles: [
                        {
                            position: 5,
                            aspectRatio: "h-full"
                        }, 
                    ],
                    collections: [
                        "all"
                    ]
                }
            }, 
        ]
    },
    {
        label: "Subscriptions",
        name: "subscriptions",
        component: "group",
        fields: [
            {
                label: "Free Shipping Text",
                name: "freeShippingText",
                component: "text",
                defaultValue: "Free Shipping"
            },
            {
                label: "Color Badge Text",
                name: "colorBadgeText",
                component: "text",
                defaultVlue: "Most Popular!"
            },
            {
                label: "Cancel Anytime Text",
                name: "cancelText",
                component: "text",
                defaultValue: "Cancel anytime + membership perks."
            },
            {
                component: "toggle",
                name: "selectSubscriptionOnLoad",
                label: "Select Subscription on load",
                description: "Toggle default subscription option selection in Product Page and Quickview Modal.",
                toggleLabels: {
                    true: "Yes",
                    false: "No"
                },
                defaultValue: true
            },
            {
                label: "Product Subscription Modal",
                name: "subscriptionModal",
                component: "group",
                fields: [
                    {
                        label: "Trigger CTA Label",
                        name: "triggerCTALabel",
                        component: "text"
                    },
                    {
                        label: "Modal Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Modal Content List",
                        name: "contentList",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.title}}"
                        },
                        fields: [
                            {
                                label: "Icon",
                                name: "icon",
                                component: "image",
                                description: "Recommended Icon Size: 100px x 100px (square dimension)"
                            },
                            {
                                label: "Title",
                                name: "title",
                                component: "text"
                            },
                            {
                                label: "Description",
                                name: "description",
                                component: "textarea"
                            }, 
                        ],
                        validate: {
                            maxItems: 5
                        }
                    }
                ]
            }
        ]
    },
    {
        label: "Automatic Discount Collections",
        name: "automaticDiscountCollections",
        component: "group",
        fields: [
            {
                label: "Collections",
                name: "collections",
                component: "group-list",
                itemProps: {
                    label: "Collection"
                },
                fields: [
                    {
                        label: "Collection",
                        name: "collection",
                        component: "collections",
                        required: true
                    },
                    {
                        component: "number",
                        name: "discountPercentage",
                        label: "Discount Percentage",
                        description: "Note: the actual discount must be configured in the Shopify admin under Discounts. This is for display purposes only.",
                        required: true,
                        validate: {
                            min: 0,
                            max: 100
                        }
                    },
                    {
                        component: "date",
                        name: "startDate",
                        label: "Start date",
                        timeFormat: true,
                        dateFormat: "MM/DD/YYYY",
                        required: true
                    },
                    {
                        component: "date",
                        name: "endDate",
                        label: "End date",
                        timeFormat: true,
                        dateFormat: "MM/DD/YYYY",
                        required: true
                    }, 
                ],
                defaultItem: {}
            }
        ]
    },
    {
        label: "Free Product Scenarios",
        name: "newFreeProducts",
        component: "group",
        fields: [
            {
                label: "Free Product Scenarios",
                name: "gwpScenarios",
                component: "blocks",
                templates: {
                    buyXGetY: {
                        label: "Buy X Get Y",
                        key: "buyXGetY",
                        fields: [
                            {
                                component: "toggle",
                                name: "enabled",
                                label: "Enable Promotion",
                                description: "Disable this to pre-populate any promotion without getting it active on the site",
                                toggleLabels: {
                                    true: "Yes",
                                    false: "No"
                                },
                                defaultValue: true
                            },
                            {
                                component: "text",
                                name: "campaign",
                                label: "Gift Campaign",
                                description: "Unique identifier for the GWP promotion, this is required to allow managing individual GWPs",
                                validate: {
                                    required: true
                                }
                            },
                            {
                                name: "gwpProductQualify",
                                label: "Add This Product To Cart To Qualify For Gift (USD)",
                                component: "productSearch"
                            },
                            {
                                name: "enableSubQualify",
                                label: "Check to look for only subscription in cart",
                                component: "toggle",
                                toggleLabels: {
                                    true: "Yes",
                                    false: "No"
                                },
                                defaultValue: false
                            },
                            {
                                name: "gwpProduct",
                                label: "Gift With Purchase Product",
                                component: "productSearch"
                            },
                            {
                                label: "Add item to cart label",
                                name: "gwpAddBack",
                                component: "text",
                                default: "Add free gift",
                                description: "Label for the button that the customer uses to add the items back to their cart if they have opted out"
                            }, 
                        ]
                    },
                    spendXGetY: {
                        label: "Spend X Get Y",
                        key: "spendXGetY",
                        fields: [
                            {
                                component: "toggle",
                                name: "enabled",
                                label: "Enable Promotion",
                                description: "Disable this to pre-populate any promotion without getting it active on the site",
                                toggleLabels: {
                                    true: "Yes",
                                    false: "No"
                                },
                                defaultValue: true
                            },
                            {
                                component: "text",
                                name: "campaign",
                                label: "Gift Campaign",
                                description: "Unique identifier for the GWP promotion, this is required to allow managing individual GWPs",
                                validate: {
                                    required: true
                                }
                            },
                            {
                                name: "gwpProduct",
                                label: "Gift With Purchase Product",
                                component: "productSearch"
                            },
                            {
                                label: "Cart Spend To Qualify For Gift (USD)",
                                name: "gwpCartMinimum",
                                component: "number"
                            },
                            {
                                label: "Add item to cart label",
                                name: "gwpAddBack",
                                component: "text",
                                default: "Add free gift",
                                description: "Label for the button that the customer uses to add the items back to their cart if they have opted out"
                            }, 
                        ]
                    },
                    spendXandChooseY: {
                        label: "Spend X Choose Y",
                        key: "spendXChooseY",
                        fields: [
                            {
                                component: "toggle",
                                name: "enabled",
                                label: "Enable Promotion",
                                description: "Disable this to pre-populate any promotion without getting it active on the site",
                                toggleLabels: {
                                    true: "Yes",
                                    false: "No"
                                },
                                defaultValue: true
                            },
                            {
                                component: "text",
                                name: "campaign",
                                label: "Gift Campaign",
                                description: "Unique identifier for the GWP promotion, this is required to allow managing individual GWPs",
                                validate: {
                                    required: true
                                }
                            },
                            {
                                name: "gwpProduct",
                                label: "Gift With Purchase Product",
                                component: "list",
                                field: {
                                    component: "productSearch"
                                },
                                validate: {
                                    maxItems: 4
                                }
                            },
                            {
                                label: "Cart Spend To Qualify For Gift (USD)",
                                name: "gwpCartMinimum",
                                component: "number"
                            },
                            {
                                label: "Add item to cart label",
                                name: "gwpAddBack",
                                component: "text",
                                default: "Add free gift",
                                description: "Label for the button that the customer uses to add the items back to their cart if they have opted out"
                            },
                            {
                                label: "Modal Settings",
                                name: "modalSettings",
                                component: "group",
                                description: "Information to show on the modal when the customer is selecting the free gift",
                                fields: [
                                    {
                                        label: "Title",
                                        name: "title",
                                        component: "text"
                                    },
                                    {
                                        label: "subtitle",
                                        name: "subtitle",
                                        component: "textarea"
                                    },
                                    {
                                        label: "Add to Cart text",
                                        name: "atcText",
                                        component: "text",
                                        defaultValue: "add to cart"
                                    },
                                    {
                                        label: "Skip button text",
                                        name: "skipButtonText",
                                        component: "text",
                                        defaultValue: "skip free gift"
                                    }
                                ]
                            }
                        ]
                    },
                    buyFromCollectionGetY: {
                        label: "Buy From Collection Get Y",
                        name: "buyFromCollectionGetY",
                        key: "buyFromCollectionGetY",
                        fields: [
                            {
                                component: "toggle",
                                name: "enabled",
                                label: "Enable Promotion",
                                description: "Disable this to pre-populate any promotion without getting it active on the site",
                                toggleLabels: {
                                    true: "Yes",
                                    false: "No"
                                },
                                defaultValue: true
                            },
                            {
                                component: "text",
                                name: "campaign",
                                label: "Gift Campaign",
                                description: "Unique identifier for the GWP promotion, this is required to allow managing individual GWPs",
                                validate: {
                                    required: true
                                }
                            },
                            {
                                name: "gwpCollectionQualify",
                                label: "Add products from this collection To Qualify For Gift (USD)",
                                component: "text",
                                info: "Enter collection handle"
                            },
                            {
                                name: "gwpProduct",
                                label: "Gift With Purchase Product",
                                component: "productSearch"
                            },
                            {
                                label: "Add item to cart label",
                                name: "gwpAddBack",
                                component: "text",
                                default: "Add free gift",
                                description: "Label for the button that the customer uses to add the items back to their cart if they have opted out"
                            }, 
                        ]
                    },
                    buySubscriptionGetY: {
                        label: "Buy Subscription Get Y",
                        name: "buySubscriptionGetY",
                        fields: [
                            {
                                component: "toggle",
                                name: "enabled",
                                label: "Enable Promotion",
                                description: "Disable this to pre-populate any promotion without getting it active on the site",
                                toggleLabels: {
                                    true: "Yes",
                                    false: "No"
                                },
                                defaultValue: true
                            },
                            {
                                component: "text",
                                name: "campaign",
                                label: "Gift Campaign",
                                description: "Unique identifier for the GWP promotion, this is required to allow managing individual GWPs",
                                validate: {
                                    required: true
                                }
                            },
                            {
                                name: "gwpAllSubsQualify",
                                label: "Enable All Subscription Products to Qualify for Gift (USD)",
                                component: "toggle",
                                toggleLabels: {
                                    true: "Yes",
                                    false: "No"
                                },
                                defaultValue: false,
                                description: "Enables only subscription products to trigger free gift"
                            },
                            {
                                name: "gwpProduct",
                                label: "Gift With Purchase Product",
                                component: "productSearch"
                            },
                            {
                                label: "Add item to cart label",
                                name: "gwpAddBack",
                                component: "text",
                                default: "Add free gift",
                                description: "Label for the button that the customer uses to add the items back to their cart if they have opted out"
                            }, 
                        ]
                    },
                    buyBundleGetY: {
                        label: "Buy Bundle Get Gift",
                        name: "buyBundleGetY",
                        fields: [
                            {
                                component: "toggle",
                                name: "enabled",
                                label: "Enable Promotion",
                                description: "Disable this to pre-populate any promotion without getting it active on the site",
                                toggleLabels: {
                                    true: "Yes",
                                    false: "No"
                                },
                                defaultValue: true
                            },
                            {
                                component: "text",
                                name: "campaign",
                                label: "Gift Campaign",
                                description: "Unique identifier for the GWP promotion, this is required to allow managing individual GWPs",
                                validate: {
                                    required: true
                                }
                            },
                            {
                                name: "gwpProduct",
                                label: "Gift With Purchase Product",
                                component: "productSearch"
                            },
                            {
                                name: "gwpBundleCount",
                                label: "Qualifying bundle length",
                                component: "number",
                                defaultValue: 0
                            },
                            {
                                component: "productSearch",
                                label: "Qualifying product",
                                name: "gwpProductQualify",
                                description: "Product that needs to be in the bundle to trigger the free gift, if the bundle length is matched but the product is not in the bundle the gift will not be added"
                            },
                            {
                                component: "productSearch",
                                label: "Qualifying product (second option)",
                                name: "gwpProductQualifySecondary",
                                description: "Product that needs to be in the bundle to trigger the free gift, if the bundle length is matched but the product is not in the bundle the gift will not be added"
                            },
                            {
                                component: "text",
                                label: "Qualify Message",
                                name: "gwpQualifyMessage",
                                description: "Message that will be displayed on a toast with confetti when the bundle qualifies for the gift",
                                default: "You've got a free gift"
                            },
                            {
                                label: "Add item to cart label",
                                name: "gwpAddBack",
                                component: "text",
                                default: "Add free gift",
                                description: "Label for the button that the customer uses to add the items back to their cart if they have opted out"
                            }, 
                        ]
                    },
                    freeSamples: {
                        label: "Free Samples",
                        name: "freeSamples",
                        fields: [
                            {
                                label: "Enable Free Samples",
                                name: "enabled",
                                component: "toggle",
                                toggleLabels: {
                                    true: "Yes",
                                    false: "No"
                                }
                            },
                            {
                                component: "text",
                                name: "campaign",
                                label: "Gift Campaign (required)",
                                description: "Unique identifier for the GWP promotion, this is required to allow managing individual GWPs",
                                validate: {
                                    required: true
                                }
                            },
                            {
                                name: "gwpProduct",
                                label: "Free Sample Product",
                                component: "productSearch"
                            },
                            {
                                label: "Cart Spend To Qualify For Samples (USD)",
                                name: "samplesCartMinimum",
                                component: "number"
                            },
                            {
                                label: "Add item to cart label",
                                name: "gwpAddBack",
                                component: "text",
                                default: "Add Free Sample",
                                description: "Label for the button that the customer uses to add the items back to their cart if they have opted out"
                            }, 
                        ]
                    }
                }
            }
        ]
    },
    {
        label: "Account",
        name: "account",
        component: "group",
        fields: [
            {
                label: "Refer A Friend Image",
                name: "referFriendImage",
                component: "image",
                description: "Recommended Image Size: 1000 x 1000"
            },
            {
                label: "Sign In Message",
                name: "SignInMessage",
                component: "text"
            }
        ]
    },
    {
        label: "Social Share",
        name: "socialShare",
        component: "group",
        fields: [
            {
                label: "Instagram",
                name: "instagramLink",
                component: "text"
            },
            {
                label: "Facebook",
                name: "facebookLink",
                component: "text"
            },
            {
                label: "You Tube",
                name: "youTubeLink",
                component: "text"
            },
            {
                label: "Pinterest",
                name: "pinterestLink",
                component: "text"
            },
            {
                label: "Twitter",
                name: "twitterLink",
                component: "text"
            },
            {
                label: "Tik Tok",
                name: "tikTokLink",
                component: "text"
            }, 
        ]
    },
    {
        label: "Buy with Prime",
        name: "buyWithPrime",
        component: "group",
        fields: [
            {
                label: "Badges Location",
                name: "bwpLocation",
                component: "select",
                description: "For this feature to work the products must include the tag BWP, if no products include the tag beside of the options selected below they will not show",
                options: [
                    {
                        label: "None (disabled)",
                        value: "disabled"
                    },
                    {
                        label: "Selected collections",
                        value: "local"
                    },
                    {
                        label: "Sitewide",
                        value: "global"
                    }, 
                ]
            },
            {
                label: "Collections",
                name: "collectionList",
                component: "list",
                description: "List of collections in which the badges will be show, badge will be shown on the PDP besides it being applied to any collection unless the Badges location option is set to disabled, this reference should match exactly with the Collection Name in order to work",
                field: {
                    component: "text"
                }
            }, 
        ]
    }, 
]);

// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/snippets/components/NavDesktop.jsx
function NavDesktop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NavDesktop_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NavDesktop_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function NavDesktop(param) {
    var menu = param.menu;
    var childItem = (0,react.useRef)([]);
    var menuLeaveTimer;
    var lis = childItem.current;
    var openMegaMenu = function() {
        clearTimeout(menuLeaveTimer);
        var scrollTop = window.scrollY;
        if (!document.body.style.getPropertyValue("--topPosition")) {
            document.body.style.setProperty("--topPosition", "-".concat(scrollTop, "px"));
            document.body.classList.add("bg-overlay", "drawer-open");
        }
        var megaMenus = document.querySelectorAll(".mega-menu");
        if (megaMenus.length > 0) {
            var header = document.querySelector(".site-header");
            var headerHeight = header.offsetHeight + header.getBoundingClientRect().top;
            megaMenus.forEach(function(megaMenu) {
                megaMenu.style.maxHeight = "calc(100vh - ".concat(headerHeight, "px)");
            });
        }
    };
    var closeMegaMenu = function() {
        menuLeaveTimer = setTimeout(function() {
            document.body.classList.remove("bg-overlay", "drawer-open");
            var scrollTop = document.body.style.getPropertyValue("--topPosition");
            document.body.style.removeProperty("--topPosition");
            window.scrollTo({
                top: scrollTop.replace("px", "") * -1
            });
        }, 400);
    };
    (0,react.useEffect)(function() {
        if (lis) {
            lis.forEach(function(el) {
                var ref;
                if (el === null || el === void 0 ? void 0 : (ref = el.classList) === null || ref === void 0 ? void 0 : ref.contains("has-child")) {
                    el === null || el === void 0 ? void 0 : el.addEventListener("mouseover", openMegaMenu);
                    el === null || el === void 0 ? void 0 : el.addEventListener("mouseout", closeMegaMenu);
                }
            });
        }
        return function() {
            if (lis) {
                lis.forEach(function(el) {
                    var ref;
                    if (el === null || el === void 0 ? void 0 : (ref = el.classList) === null || ref === void 0 ? void 0 : ref.contains("has-child")) {
                        el === null || el === void 0 ? void 0 : el.removeEventListener("mouseover", openMegaMenu);
                        el === null || el === void 0 ? void 0 : el.removeEventListener("mouseout", closeMegaMenu);
                    }
                });
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "hidden flex-1 lg:flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
            id: "main-navbar",
            className: "hidden lg:block",
            "aria-label": "Header Navigation",
            children: menu && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "m-0 flex h-full list-none items-center px-8",
                role: "menubar",
                "aria-label": "Header Navigation List",
                children: menu.map(function(menuLink, menuLinkIndex) {
                    var ref6, ref1, ref2, ref3, ref4, ref5;
                    var columns = (menuLink === null || menuLink === void 0 ? void 0 : menuLink.column.filter(function(column) {
                        return column.enable_column;
                    })) || [];
                    var num_col = columns.reduce(function(accumulator, currentValue) {
                        return accumulator += (currentValue === null || currentValue === void 0 ? void 0 : currentValue.featured_column) == true ? 2 : 1;
                    }, 0);
                    var is_megamenu = num_col > 1 || num_col === 1 && ((ref6 = columns[0]) === null || ref6 === void 0 ? void 0 : (ref1 = ref6.cta) === null || ref1 === void 0 ? void 0 : ref1.image);
                    return (menuLink === null || menuLink === void 0 ? void 0 : (ref2 = menuLink.link) === null || ref2 === void 0 ? void 0 : ref2.text) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "level-1 block mt-0 ml-11 first:ml-0".concat(num_col ? " has-child" : ""),
                        role: "presentation",
                        ref: function(ref) {
                            childItem.current[menuLinkIndex] = ref;
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (menuLink === null || menuLink === void 0 ? void 0 : (ref3 = menuLink.link) === null || ref3 === void 0 ? void 0 : ref3.url) ? menuLink.link.url : "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "relative block whitespace-nowrap font-hafferBold lg:text-[14px] xl:text-base no-underline",
                                    role: "menuitem",
                                    tabIndex: "".concat(num_col ? -1 : 0),
                                    "aria-haspopup": num_col ? true : false,
                                    children: [
                                        menuLink === null || menuLink === void 0 ? void 0 : (ref4 = menuLink.link) === null || ref4 === void 0 ? void 0 : ref4.text,
                                        num_col ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "arrow",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconChevronDown */.C2, {})
                                        }) : ""
                                    ]
                                })
                            }),
                            num_col ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(is_megamenu ? "mega-menu-container left-0 w-full" : "dropdown-menu-container w-78 -ml-4", " absolute top-full"),
                                "aria-label": menuLink === null || menuLink === void 0 ? void 0 : (ref5 = menuLink.link) === null || ref5 === void 0 ? void 0 : ref5.text,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(is_megamenu ? "mega-menu flex flex-wrap" : "dropdown-menu px-14 py-9", " relative z-0 border-b border-grey-7 bg-white"),
                                    children: columns.map(function(col, colIndex) {
                                        return (col === null || col === void 0 ? void 0 : col.enable_column) === true ? is_megamenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildMegaMenu, {
                                            menuItem: col,
                                            ColNumber: num_col
                                        }, "menu-column-".concat(colIndex)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildDopdownMenu, {
                                            menuItem: col
                                        }, "menu-column-".concat(colIndex)) : false;
                                    })
                                })
                            }) : false
                        ]
                    }, "menu-item-".concat(menuLinkIndex)) : false;
                })
            })
        })
    });
}
function ChildDopdownMenu(param) {
    var menuItem = param.menuItem;
    if (!menuItem) return null;
    return (menuItem === null || menuItem === void 0 ? void 0 : menuItem.menu) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "list-none p-0",
        children: menuItem.menu && menuItem.menu.map(function(childmenu, childmenuIndex) {
            var ref, ref7, ref8, ref9, ref10;
            var child_menu = (childmenu === null || childmenu === void 0 ? void 0 : childmenu.child_menu) || [];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "level-2 my-2.5".concat((childmenu === null || childmenu === void 0 ? void 0 : childmenu.bold_underline) === true ? " mt-3" : ""),
                role: "presentation",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: (childmenu === null || childmenu === void 0 ? void 0 : (ref = childmenu.link) === null || ref === void 0 ? void 0 : ref.url) ? childmenu === null || childmenu === void 0 ? void 0 : (ref7 = childmenu.link) === null || ref7 === void 0 ? void 0 : ref7.url : "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "relative block inline-block text-sm no-underline underline-offset-4 leading-normal".concat((childmenu === null || childmenu === void 0 ? void 0 : childmenu.link_icon) ? " flex items-center" : "").concat((childmenu === null || childmenu === void 0 ? void 0 : childmenu.bold_underline) === true ? " border-b-2 border-black !pb-1 font-hafferBold hover:border-transparent hover:text-black" : " hover:underline").concat(child_menu.length && (childmenu === null || childmenu === void 0 ? void 0 : childmenu.bold_underline) === false ? " font-hafferBold" : ""),
                        role: "menuitem",
                        children: [
                            (childmenu === null || childmenu === void 0 ? void 0 : childmenu.link_icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "mr-3 h-6 w-6 object-cover",
                                src: childmenu === null || childmenu === void 0 ? void 0 : (ref8 = childmenu.link_icon) === null || ref8 === void 0 ? void 0 : ref8.src,
                                alt: childmenu === null || childmenu === void 0 ? void 0 : (ref9 = childmenu.link) === null || ref9 === void 0 ? void 0 : ref9.text,
                                width: "24",
                                height: "24"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (ref10 = childmenu.link) === null || ref10 === void 0 ? void 0 : ref10.text
                                    }),
                                    (childmenu === null || childmenu === void 0 ? void 0 : childmenu.promo_text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "promo-text ml-2 uppercase text-primary-2",
                                        children: childmenu === null || childmenu === void 0 ? void 0 : childmenu.promo_text
                                    }) : ""
                                ]
                            })
                        ]
                    })
                })
            }, "menu-item-".concat(childmenuIndex));
        })
    }) : !1;
}
function ChildMegaMenu(param) {
    var menuItem = param.menuItem, ColNumber = param.ColNumber;
    var ref26, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    var country = (0,dist.useCountry)().country;
    var isUs = (country === null || country === void 0 ? void 0 : country.isoCode) === "US";
    // Note: added logic to hide virtual bundles from non-US countries (see line 326)
    if (!menuItem || !(menuItem === null || menuItem === void 0 ? void 0 : menuItem.cta) && !(menuItem === null || menuItem === void 0 ? void 0 : menuItem.menu)) return null;
    var has_cta = (menuItem === null || menuItem === void 0 ? void 0 : menuItem.cta) && (menuItem === null || menuItem === void 0 ? void 0 : (ref26 = menuItem.cta) === null || ref26 === void 0 ? void 0 : ref26.image);
    var featured_column = (menuItem === null || menuItem === void 0 ? void 0 : menuItem.featured_column) || false;
    var temp_class = "w-1/2 w-1/3 w-1/4 w-1/5 xl:w-1/2 xl:w-1/3 xl:w-1/4 xl:w-1/5 xl:w-2/3 xl:w-2/4 xl:w-2/5";
    var w_class = "w-1/".concat(Math.max(ColNumber, 3));
    if (ColNumber === 1) {
        w_class = has_cta ? "w-full" : "w-1/".concat(Math.max(ColNumber, 3));
    } else {
        w_class = has_cta == true || featured_column == true ? "w-1/".concat(Math.max(ColNumber - 1, 3), " xl:w-2/").concat(Math.max(ColNumber, 3)) : "w-1/".concat(Math.max(ColNumber - 1, 3), " xl:w-1/").concat(Math.max(ColNumber, 3));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(w_class, " ").concat(has_cta ? "" : " border-l border-grey-7 first:border-l-0"),
        children: [
            has_cta ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "menu-item-cta",
                children: (menuItem === null || menuItem === void 0 ? void 0 : menuItem.cta.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: menuItem === null || menuItem === void 0 ? void 0 : menuItem.cta.url,
                    "aria-label": lmenuItem === null || lmenuItem === void 0 ? void 0 : (ref11 = lmenuItem.cta) === null || ref11 === void 0 ? void 0 : ref11.title,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "no-underline hover:underline",
                        role: "menuitem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: menuItem === null || menuItem === void 0 ? void 0 : (ref12 = menuItem.cta) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.image) === null || ref13 === void 0 ? void 0 : ref13.src,
                                className: "h-full w-full object-cover",
                                alt: menuItem === null || menuItem === void 0 ? void 0 : (ref14 = menuItem.cta) === null || ref14 === void 0 ? void 0 : ref14.title,
                                width: "1000",
                                height: "1000"
                            }),
                            (menuItem === null || menuItem === void 0 ? void 0 : (ref15 = menuItem.cta) === null || ref15 === void 0 ? void 0 : ref15.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "my-3 mx-4 block font-hafferBold",
                                children: menuItem === null || menuItem === void 0 ? void 0 : (ref16 = menuItem.cta) === null || ref16 === void 0 ? void 0 : ref16.title
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: menuItem === null || menuItem === void 0 ? void 0 : (ref17 = menuItem.cta) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.image) === null || ref18 === void 0 ? void 0 : ref18.src,
                            className: "h-full w-full object-cover",
                            alt: menuItem === null || menuItem === void 0 ? void 0 : (ref19 = menuItem.cta) === null || ref19 === void 0 ? void 0 : ref19.title,
                            width: "1000",
                            height: "1000"
                        }),
                        (menuItem === null || menuItem === void 0 ? void 0 : (ref20 = menuItem.cta) === null || ref20 === void 0 ? void 0 : ref20.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "my-3 mx-4 block font-hafferBold",
                            children: menuItem === null || menuItem === void 0 ? void 0 : (ref21 = menuItem.cta) === null || ref21 === void 0 ? void 0 : ref21.title
                        })
                    ]
                })
            }) : null,
            (menuItem === null || menuItem === void 0 ? void 0 : menuItem.menu) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "pt-9 pb-9 ".concat(menuItem.featured_column ? "px-3 xl:px-14 flex flex-wrap" : "px-14"),
                role: "menu",
                children: (menuItem === null || menuItem === void 0 ? void 0 : menuItem.menu) && (menuItem === null || menuItem === void 0 ? void 0 : menuItem.menu.map(function(childmenu, childmenuIndex) {
                    var ref33, ref22, ref23, ref24, ref25;
                    var child_menu = (childmenu === null || childmenu === void 0 ? void 0 : childmenu.child_menu) || [];
                    return (childmenu === null || childmenu === void 0 ? void 0 : (ref33 = childmenu.link) === null || ref33 === void 0 ? void 0 : ref33.text) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            child_menu.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "presentation",
                                className: "level-2 mt-4 mb-3 ".concat(menuItem.featured_column ? "w-full px-2" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "m-0 font-hafferBold",
                                    children: childmenu.link.text
                                })
                            }, "menu-item-".concat(childmenuIndex)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "presentation",
                                className: "level-2 my-2.5".concat((childmenu === null || childmenu === void 0 ? void 0 : childmenu.bold_underline) === true ? " mt-3" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (childmenu === null || childmenu === void 0 ? void 0 : (ref22 = childmenu.link) === null || ref22 === void 0 ? void 0 : ref22.url) ? childmenu.link.url : "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "relative inline-block text-sm no-underline underline-offset-4 leading-normal".concat((childmenu === null || childmenu === void 0 ? void 0 : childmenu.link_icon) ? " flex items-center" : "").concat((childmenu === null || childmenu === void 0 ? void 0 : childmenu.bold_underline) === true ? " border-b-2 border-black !pb-1 font-hafferBold hover:border-transparent hover:text-black" : " hover:underline"),
                                        style: {
                                            color: childmenu === null || childmenu === void 0 ? void 0 : childmenu.link_color
                                        },
                                        role: "menuitem",
                                        children: [
                                            childmenu.link_icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", NavDesktop_objectSpread({
                                                className: "mr-3 object-cover",
                                                src: childmenu === null || childmenu === void 0 ? void 0 : (ref23 = childmenu.link_icon) === null || ref23 === void 0 ? void 0 : ref23.src,
                                                alt: childmenu === null || childmenu === void 0 ? void 0 : (ref24 = childmenu.link) === null || ref24 === void 0 ? void 0 : ref24.text,
                                                width: "50",
                                                height: "50"
                                            }, menuItem.featured_column ? {} : {
                                                role: "none"
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: childmenu === null || childmenu === void 0 ? void 0 : (ref25 = childmenu.link) === null || ref25 === void 0 ? void 0 : ref25.text
                                                    }),
                                                    (childmenu === null || childmenu === void 0 ? void 0 : childmenu.promo_text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "promo-text ml-2 uppercase text-primary-2",
                                                        children: childmenu === null || childmenu === void 0 ? void 0 : childmenu.promo_text
                                                    }) : ""
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, "menu-item-".concat(childmenuIndex)),
                            child_menu.map(function(item, itemIndex) {
                                var ref, ref27, ref28, ref29, ref30, ref31, ref32;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    role: "presentation",
                                    className: "level-2 my-2.5".concat((item === null || item === void 0 ? void 0 : item.bold_underline) === true ? " mt-3" : "", "\n                        ").concat(!isUs && (item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.text.toLowerCase()) === "bundles" ? "hidden" : "", "\n                        ").concat(menuItem.featured_column ? "w-1/2 xl:w-1/4 px-2 xl:w-1/4 text-center" : "", "\n                        "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: (item === null || item === void 0 ? void 0 : (ref27 = item.link) === null || ref27 === void 0 ? void 0 : ref27.url) ? item.link.url : "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                role: "menuitem",
                                                className: "relative inline-block text-sm no-underline underline-offset-4 leading-normal".concat((item === null || item === void 0 ? void 0 : item.link_icon) ? " flex items-center" : "", "\n                            ").concat(menuItem.featured_column ? "flex-col leading-[1.5] text-xs" : "", "\n                            ").concat((item === null || item === void 0 ? void 0 : item.bold_underline) === true ? " border-b-2 border-black !pb-1 font-hafferBold hover:border-transparent hover:text-black" : " hover:underline").concat((item === null || item === void 0 ? void 0 : item.link_hover_image) ? " has-hover-cta" : "", "\n                            "),
                                                style: {
                                                    color: item === null || item === void 0 ? void 0 : item.link_color
                                                },
                                                children: [
                                                    item.link_icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", NavDesktop_objectSpread({
                                                        className: "object-cover ".concat(menuItem.featured_column ? "block w-full mb-2" : "mr-3 h-6 w-6"),
                                                        src: item === null || item === void 0 ? void 0 : (ref28 = item.link_icon) === null || ref28 === void 0 ? void 0 : ref28.src,
                                                        alt: item === null || item === void 0 ? void 0 : (ref29 = item.link) === null || ref29 === void 0 ? void 0 : ref29.text,
                                                        width: "50",
                                                        height: "50"
                                                    }, menuItem.featured_column ? {} : {
                                                        role: "none"
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat(menuItem.featured_column ? "font-hafferBold" : ""),
                                                                children: item === null || item === void 0 ? void 0 : (ref30 = item.link) === null || ref30 === void 0 ? void 0 : ref30.text
                                                            }),
                                                            !!(item === null || item === void 0 ? void 0 : item.promo_text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "promo-text ml-2 uppercase text-primary-2",
                                                                children: item === null || item === void 0 ? void 0 : item.promo_text
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        (item === null || item === void 0 ? void 0 : item.link_hover_image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hover-cta",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "responsive-image !h-full",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item === null || item === void 0 ? void 0 : (ref31 = item.link_hover_image) === null || ref31 === void 0 ? void 0 : ref31.src,
                                                    className: "hidden w-full lg:block",
                                                    alt: item === null || item === void 0 ? void 0 : (ref32 = item.link) === null || ref32 === void 0 ? void 0 : ref32.text,
                                                    width: "1392",
                                                    height: "920"
                                                })
                                            })
                                        }) : null
                                    ]
                                }, "menu-item-".concat(itemIndex));
                            })
                        ]
                    }, childmenuIndex) : null;
                }))
            }) : null
        ]
    });
}
NavDesktop.displayName = "NavDesktop";
ChildMegaMenu.displayName = "ChildMegaMenu";
/* harmony default export */ var components_NavDesktop = (NavDesktop);

;// CONCATENATED MODULE: ./src/snippets/components/SwellPoints.jsx



function SwellPoints() {
    var ref;
    var customer = (0,dist.useCustomer)();
    var ref1 = (0,react.useState)(null), swellCustomer = ref1[0], setSwellCustomer = ref1[1];
    var customerMatches = customer && swellCustomer && (customer === null || customer === void 0 ? void 0 : customer.email) === (swellCustomer === null || swellCustomer === void 0 ? void 0 : swellCustomer.email);
    var refreshSwell = function() {
        if (typeof swellAPI === "undefined") return;
        if (!customer) {
            setSwellCustomer(null);
            return;
        }
        var customerDetails = swellAPI === null || swellAPI === void 0 ? void 0 : swellAPI.getCustomerDetails();
        setSwellCustomer(customerDetails);
        // swellAPI doesn't refresh the customer data correctly when an old user signs out and a new users signs in
        // force refresh if the customer info doesn't match
        if ((customer === null || customer === void 0 ? void 0 : customer.email) && (customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.email) && customer.email !== customerDetails.email) {
            if (typeof location !== "undefined") location.reload();
        }
    };
    (0,react.useEffect)(function() {
        refreshSwell();
        document.addEventListener("swell:setup", refreshSwell);
        return function() {
            document.removeEventListener("swell:setup", refreshSwell);
        };
    }, [
        customer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            customer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "swell-customer-identification",
                "data-authenticated": "true",
                "data-email": customer === null || customer === void 0 ? void 0 : customer.email,
                "data-id": customer === null || customer === void 0 ? void 0 : (ref = customer.id) === null || ref === void 0 ? void 0 : ref.replace("gid://shopify/Customer/", ""),
                "data-tags": '"[]"',
                style: {
                    display: "none"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    display: customerMatches && (swellCustomer === null || swellCustomer === void 0 ? void 0 : swellCustomer.pointsBalance) ? "" : "none",
                    marginLeft: "5px"
                },
                children: [
                    "(",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "swell-point-balance",
                        children: swellCustomer === null || swellCustomer === void 0 ? void 0 : swellCustomer.pointsBalance
                    }),
                    "pts)"
                ]
            })
        ]
    });
}
/* harmony default export */ var components_SwellPoints = (SwellPoints);

;// CONCATENATED MODULE: ./src/snippets/components/NavMobile.jsx






function NavMobile(param) {
    var menu = param.menu, navOpen = param.navOpen, closeNav = param.closeNav;
    var ref14, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var settings = (0,dist.useSettings)();
    var customer = (0,dist.useCustomer)();
    var menuDrawer = (0,react.useRef)(null);
    var ref12 = (0,react.useState)(0), menuActive = ref12[0], setMenuActive = ref12[1];
    var ref13 = (0,react.useState)(1), menuShopActive = ref13[0], setMenuShopActive = ref13[1];
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    (0,react.useEffect)(function() {
        return function() {};
    }, []);
    if (!menu) return null;
    var itemsWOcol = menu.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : item.column) && !(item === null || item === void 0 ? void 0 : (ref = item.column) === null || ref === void 0 ? void 0 : ref.length);
    });
    var itemsWcol = menu.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : item.column) && (item === null || item === void 0 ? void 0 : (ref = item.column) === null || ref === void 0 ? void 0 : ref.length);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block lg:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "menu-drawer",
            className: "left-min fixed top-0 z-[2005] flex h-full w-full max-w-[375px] flex-col bg-white transition-all duration-300".concat(navOpen ? " opacity-1 translate-x-0" : " -translate-x-full opacity-0"),
            "aria-hidden": !navOpen,
            ref: menuDrawer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "menu-drawer__header flex w-full items-start justify-between py-2.5 pl-4 pr-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            role: "menu",
                            className: "m-0 flex-grow p-0",
                            children: itemsWOcol.map(function(item, itemIndex) {
                                var ref, ref15, ref16;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                    role: "presentation",
                                    className: "mt-1 flex items-center justify-between first:mt-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.url) ? item === null || item === void 0 ? void 0 : (ref15 = item.link) === null || ref15 === void 0 ? void 0 : ref15.url : "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            role: "menuitem",
                                            className: "relative block border-b-2 border-black font-hafferBold text-sm no-underline",
                                            children: item === null || item === void 0 ? void 0 : (ref16 = item.link) === null || ref16 === void 0 ? void 0 : ref16.text
                                        })
                                    })
                                }, "m-menu-level1-".concat(itemIndex));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "px-4 py-2",
                            onClick: function() {
                                closeNav();
                            },
                            "aria-label": "Menu close",
                            "aria-controls": "menu-drawer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconClose */.bM, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: "Menu close"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "overflow-y-auto overflow-x-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative z-0 w-full bg-white",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    role: "menu",
                                    className: "m-0 flex w-full snap-x snap-proximity list-none flex-nowrap overflow-x-auto p-0",
                                    children: itemsWcol.map(function(item, itemIndex) {
                                        var ref18, ref17;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            role: "presentation",
                                            className: "m-0 w-1/2 shrink-0 snap-center first:mt-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: (item === null || item === void 0 ? void 0 : (ref18 = item.link) === null || ref18 === void 0 ? void 0 : ref18.url) ? item === null || item === void 0 ? void 0 : (ref17 = item.link) === null || ref17 === void 0 ? void 0 : ref17.url : "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    role: "menuitem",
                                                    className: "relative block border-t-2 border-b-2 border-yellow p-2.5 font-hafferBold text-base no-underline text-center".concat(menuActive === itemIndex ? " bg-yellow text-black" : ""),
                                                    onClick: function(evt) {
                                                        var ref;
                                                        evt.preventDefault();
                                                        setMenuActive(itemIndex);
                                                        ((ref = evt.target.innerText) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes("shop")) ? setMenuShopActive(1) : setMenuShopActive(0);
                                                    },
                                                    children: item.link.text
                                                })
                                            })
                                        }, "m-menu-level1-".concat(itemIndex));
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "m-0 w-full p-0",
                                    children: itemsWcol.map(function(item, itemIndex) {
                                        var columns = (item === null || item === void 0 ? void 0 : item.column) || [];
                                        return menuActive === itemIndex ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildMenu, {
                                            columns: columns,
                                            index: itemIndex
                                        }, "m-menu-column-".concat(itemIndex)) : null;
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "menu-drawer__footer px-4 py-6 pt-4",
                            children: [
                                !menuShopActive && (settings === null || settings === void 0 ? void 0 : (ref14 = settings.header) === null || ref14 === void 0 ? void 0 : (ref1 = ref14.cta) === null || ref1 === void 0 ? void 0 : ref1.link) && !(settings === null || settings === void 0 ? void 0 : (ref2 = settings.header) === null || ref2 === void 0 ? void 0 : ref2.rewards_enabled) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-8 block lg:hidden whitespace-nowrap text-center w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: settings === null || settings === void 0 ? void 0 : (ref3 = settings.header) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.cta) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.link) === null || ref5 === void 0 ? void 0 : ref5.url,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            role: "menuitem",
                                            className: "".concat(settings === null || settings === void 0 ? void 0 : (ref6 = settings.header) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.cta) === null || ref7 === void 0 ? void 0 : ref7.style, " text-center no-underline !text-sm"),
                                            children: settings === null || settings === void 0 ? void 0 : (ref8 = settings.header) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.cta) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.link) === null || ref10 === void 0 ? void 0 : ref10.text
                                        })
                                    })
                                }) : null,
                                !menuShopActive && isUs && (settings === null || settings === void 0 ? void 0 : (ref11 = settings.header) === null || ref11 === void 0 ? void 0 : ref11.rewards_enabled) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "button button--primary mb-8 block w-full whitespace-nowrap !border !px-5 !py-2 !text-sm lg:hidden",
                                    children: !customer ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/pages/rewards",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            role: "menuitem",
                                            className: "font-hafferBold no-underline",
                                            children: "earn rewards"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/pages/rewards",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            role: "menuitem",
                                            className: "font-hafferBold no-underline",
                                            children: [
                                                "redeem rewards",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SwellPoints, {}, customer.id)
                                            ]
                                        })
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "".concat(customer ? "/account" : "/account/login"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            role: "menuitem",
                                            className: "text-sm text-black no-underline hover:text-black",
                                            children: "".concat(customer ? "Account" : "Sign In")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/pages/privacy-policy",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            role: "menuitem",
                                            className: "text-sm text-black no-underline hover:text-black",
                                            children: "Return Policy"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function ChildMenu(param) {
    var columns = param.columns;
    var ref21;
    var country = (0,dist.useCountry)().country;
    var isUs = (country === null || country === void 0 ? void 0 : country.isoCode) === "US";
    // Note: added logic to hide virtual bundles from non-US countries (see line 228)
    var ColNumber = (columns === null || columns === void 0 ? void 0 : columns.length) || 0;
    if (!columns || !ColNumber) return false;
    var is_megamenu = ColNumber > 1 || ColNumber === 1 && ((ref21 = columns[0]) === null || ref21 === void 0 ? void 0 : ref21.cta);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: columns.map(function(col, colIndex) {
            var ref26, ref19, ref20;
            var menuItems = (col === null || col === void 0 ? void 0 : col.menu) || [];
            var cta = (col === null || col === void 0 ? void 0 : col.cta) || [];
            var has_cta = (col === null || col === void 0 ? void 0 : col.cta) && (col === null || col === void 0 ? void 0 : (ref26 = col.cta) === null || ref26 === void 0 ? void 0 : ref26.image);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                role: "menu",
                className: "m-0 list-none p-0",
                children: [
                    has_cta ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        role: "presentation",
                        className: "menu-item-cta".concat(menuItems.length ? " border-b border-grey-7" : ""),
                        children: cta.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: cta === null || cta === void 0 ? void 0 : cta.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                role: "menuitem",
                                className: "no-underline hover:underline",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: cta === null || cta === void 0 ? void 0 : (ref19 = cta.image) === null || ref19 === void 0 ? void 0 : ref19.src,
                                        loading: "lazy",
                                        className: "h-full w-full object-cover",
                                        alt: cta === null || cta === void 0 ? void 0 : cta.title,
                                        width: "1000",
                                        height: "1000"
                                    }),
                                    (cta === null || cta === void 0 ? void 0 : cta.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "my-3 block px-4 font-hafferBold",
                                        children: cta === null || cta === void 0 ? void 0 : cta.title
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: cta === null || cta === void 0 ? void 0 : (ref20 = cta.image) === null || ref20 === void 0 ? void 0 : ref20.src,
                                    loading: "lazy",
                                    className: "h-full w-full object-cover",
                                    alt: cta === null || cta === void 0 ? void 0 : cta.title,
                                    width: "1000",
                                    height: "1000"
                                }),
                                (cta === null || cta === void 0 ? void 0 : cta.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "my-3 block px-4 font-hafferBold",
                                    children: cta === null || cta === void 0 ? void 0 : cta.title
                                })
                            ]
                        })
                    }, "m-cta-".concat(colIndex)) : null,
                    menuItems.map(function(childmenu, childmenuIndex) {
                        var ref33, ref22, ref23, ref24, ref25;
                        var childItems = (childmenu === null || childmenu === void 0 ? void 0 : childmenu.child_menu) || [];
                        return (childmenu === null || childmenu === void 0 ? void 0 : (ref33 = childmenu.link) === null || ref33 === void 0 ? void 0 : ref33.text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            role: "presentation",
                            className: "level-2 m-0".concat(childItems.length ? " has-child border-b border-grey-7 p-0" : " first:mt-4", " ").concat((childmenu === null || childmenu === void 0 ? void 0 : childmenu.open_column) ? "is-open" : " "),
                            children: childItems.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        role: "menuitem",
                                        type: "button",
                                        className: "relative z-0 m-0 w-full p-4 text-left font-hafferBold",
                                        onClick: function(evt) {
                                            evt.target.parentNode.classList.toggle("is-open");
                                        },
                                        children: childmenu === null || childmenu === void 0 ? void 0 : (ref22 = childmenu.link) === null || ref22 === void 0 ? void 0 : ref22.text
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "menu",
                                        className: "m-0 -mt-1 list-none p-0 pb-3 ".concat(col.featured_column ? "featured-column px-2" : ""),
                                        children: childItems.map(function(item, itemIndex) {
                                            var ref, ref27, ref28, ref29, ref30, ref31, ref32;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                role: "presentation",
                                                className: "level-3 m-0 ".concat(col.featured_column ? "flex flex-col text-center w-1/3" : "", "\n                            ").concat(!isUs && (item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.text.toLowerCase()) === "bundles" ? "hidden" : ""),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (item === null || item === void 0 ? void 0 : (ref27 = item.link) === null || ref27 === void 0 ? void 0 : ref27.url) ? item === null || item === void 0 ? void 0 : (ref28 = item.link) === null || ref28 === void 0 ? void 0 : ref28.url : "/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        role: "menuitem",
                                                        className: "relative block px-4 py-1.5 text-sm no-underline leading-normal".concat((item === null || item === void 0 ? void 0 : item.link_icon) ? " flex items-center" : "", " ").concat(col.featured_column ? "flex-col px-2 text-xs" : ""),
                                                        style: {
                                                            color: item === null || item === void 0 ? void 0 : item.link_color
                                                        },
                                                        children: [
                                                            item.link_icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                className: "object-cover ".concat(col.featured_column ? "w-full block mb-2" : "mr-3 h-6 w-6 "),
                                                                loading: "lazy",
                                                                src: item === null || item === void 0 ? void 0 : (ref29 = item.link_icon) === null || ref29 === void 0 ? void 0 : ref29.src,
                                                                alt: item === null || item === void 0 ? void 0 : (ref30 = item.link) === null || ref30 === void 0 ? void 0 : ref30.text,
                                                                width: "50",
                                                                height: "50"
                                                            }),
                                                            (item === null || item === void 0 ? void 0 : item.bold_underline) === true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "border-b-2 border-black !pb-1 font-hafferBold hover:border-transparent",
                                                                children: [
                                                                    item === null || item === void 0 ? void 0 : (ref31 = item.link) === null || ref31 === void 0 ? void 0 : ref31.text,
                                                                    (item === null || item === void 0 ? void 0 : item.promo_text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "pl-2 uppercase text-primary-2",
                                                                        children: item === null || item === void 0 ? void 0 : item.promo_text
                                                                    }) : ""
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "".concat(col.featured_column ? "font-hafferBold" : ""),
                                                                children: [
                                                                    item === null || item === void 0 ? void 0 : (ref32 = item.link) === null || ref32 === void 0 ? void 0 : ref32.text,
                                                                    (item === null || item === void 0 ? void 0 : item.promo_text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "pl-2 uppercase text-primary-2",
                                                                        children: item === null || item === void 0 ? void 0 : item.promo_text
                                                                    }) : ""
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, "m-menu-level3-".concat(itemIndex));
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (childmenu === null || childmenu === void 0 ? void 0 : (ref23 = childmenu.link) === null || ref23 === void 0 ? void 0 : ref23.url) ? childmenu === null || childmenu === void 0 ? void 0 : (ref24 = childmenu.link) === null || ref24 === void 0 ? void 0 : ref24.url : "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    role: "menuitem",
                                    className: "relative block px-4 py-1.5 text-sm leading-normal no-underline",
                                    children: childmenu === null || childmenu === void 0 ? void 0 : (ref25 = childmenu.link) === null || ref25 === void 0 ? void 0 : ref25.text
                                })
                            })
                        }, "m-menu-level2-".concat(childmenuIndex)) : null;
                    })
                ]
            }, colIndex);
        })
    });
}
NavMobile.displayName = "NavMobile";
ChildMenu.displayName = "ChildMenu";
/* harmony default export */ var components_NavMobile = (NavMobile);

;// CONCATENATED MODULE: ./src/snippets/globals/layout/mobileQuickLinks.jsx



function MobileQuickLinks(cms) {
    for(var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        props[_key - 1] = arguments[_key];
    }
    var ref3, ref1;
    var settings = (0,dist.useSettings)();
    return (settings === null || settings === void 0 ? void 0 : (ref3 = settings.mobileStickyNavigation) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mobileQuickLinks border-b border-grey-4 lg:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "m-0 mt-0 flex list-none flex-nowrap items-center gap-x-5 overflow-x-auto p-0 px-5 pb-1.5 font-primary",
            children: settings === null || settings === void 0 ? void 0 : (ref1 = settings.mobileStickyNavigation) === null || ref1 === void 0 ? void 0 : ref1.map(function(linkItem, linkIndex) {
                var ref, ref2;
                return (linkItem === null || linkItem === void 0 ? void 0 : (ref = linkItem.link) === null || ref === void 0 ? void 0 : ref.url) && (linkItem === null || linkItem === void 0 ? void 0 : (ref2 = linkItem.link) === null || ref2 === void 0 ? void 0 : ref2.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "mt-0",
                    children: linkItem.link.url.indexOf("http") > -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: linkItem.link.url,
                        target: linkItem.link.newTab === true ? "_blank" : "_self",
                        className: "block whitespace-nowrap text-xs text-black no-underline",
                        rel: "noreferrer",
                        children: linkItem.link.text
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: linkItem.link.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            title: linkItem.link.text,
                            target: linkItem.link.newTab === true ? "_blank" : "_self",
                            className: "block whitespace-nowrap text-xs text-black no-underline",
                            children: linkItem.link.text
                        })
                    })
                }, "mobileQuickLink".concat(linkIndex));
            })
        })
    });
}
/* harmony default export */ var mobileQuickLinks = (MobileQuickLinks);

// EXTERNAL MODULE: ./src/hooks/useCartDiscountPrices.js
var useCartDiscountPrices = __webpack_require__(4911);
// EXTERNAL MODULE: ./src/snippets/sideCart/SideCart.module.css
var SideCart_module = __webpack_require__(10263);
var SideCart_module_default = /*#__PURE__*/__webpack_require__.n(SideCart_module);
;// CONCATENATED MODULE: ./src/snippets/sideCart/SideCartItem.jsx
function SideCartItem_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SideCartItem_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SideCartItem_arrayLikeToArray(arr);
}
function SideCartItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SideCartItem_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SideCartItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SideCartItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function SideCartItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SideCartItem_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SideCartItem_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SideCartItem_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SideCartItem_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SideCartItem_toConsumableArray(arr) {
    return SideCartItem_arrayWithoutHoles(arr) || SideCartItem_iterableToArray(arr) || SideCartItem_unsupportedIterableToArray(arr) || SideCartItem_nonIterableSpread();
}
function SideCartItem_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SideCartItem_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SideCartItem_arrayLikeToArray(o, minLen);
}









var SideCartItem = function(param1) {
    var item = param1.item, cartUpdateItem = param1.cartUpdateItem, cartRemoveItem = param1.cartRemoveItem, isUs = param1.isUs;
    var ref42, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37;
    var siteSettings = (0,dist.useSettings)();
    var country = (0,dist.useCountry)().country;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var product = (0,dist.useProductByHandle)({
        handle: item === null || item === void 0 ? void 0 : (ref42 = item.variant) === null || ref42 === void 0 ? void 0 : (ref1 = ref42.product) === null || ref1 === void 0 ? void 0 : ref1.handle
    }).product;
    var sellingPlans = ((product === null || product === void 0 ? void 0 : product.sellingPlanGroups) || []).filter(function(group) {
        return (group === null || group === void 0 ? void 0 : group.appName) === "294517";
    });
    var hasSellingPlan = item === null || item === void 0 ? void 0 : item.sellingPlanAllocation;
    var planAmount = parseFloat(item === null || item === void 0 ? void 0 : (ref2 = item.sellingPlanAllocation) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.priceAdjustments) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.price) === null || ref5 === void 0 ? void 0 : ref5.amount);
    var planText = item === null || item === void 0 ? void 0 : (ref6 = item.sellingPlanAllocation) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sellingPlan) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.name) === null || ref8 === void 0 ? void 0 : ref8.replace(/Delivery/i, "Ships");
    var planPrice = planAmount ? Math.min([
        parseFloat(planAmount),
        parseFloat(item.estimatedCost.totalAmount.amount)
    ]) : null;
    var planOptions = sellingPlans === null || sellingPlans === void 0 ? void 0 : sellingPlans.map(function(plan) {
        var ref, ref39, ref40, ref41;
        return {
            label: plan === null || plan === void 0 ? void 0 : (ref = plan.sellingPlans) === null || ref === void 0 ? void 0 : (ref39 = ref[0]) === null || ref39 === void 0 ? void 0 : ref39.name,
            value: plan === null || plan === void 0 ? void 0 : (ref40 = plan.sellingPlans) === null || ref40 === void 0 ? void 0 : (ref41 = ref40[0]) === null || ref41 === void 0 ? void 0 : ref41.id
        };
    });
    var sellingPlanOptions = (planOptions === null || planOptions === void 0 ? void 0 : planOptions.length) ? [
        {
            label: "One-time Purchase",
            value: "one-time"
        }
    ].concat(SideCartItem_toConsumableArray(planOptions)) : [];
    var ref38 = (0,dist.useLocalizedVariant)({
        variant: item.variant
    }), localizedVariant = ref38.localized;
    var metafieldMap = (0,Metafields/* getMetafieldMap */.x)(product);
    var comparePriceText = (metafieldMap === null || metafieldMap === void 0 ? void 0 : metafieldMap.custom_compare_at_price) || "";
    var selectedVariant = SideCartItem_objectSpread({}, item.variant, localizedVariant);
    var hasDiscount = Number.parseFloat(item.estimatedCost.totalAmount.amount) < Number.parseFloat(item.estimatedCost.subtotalAmount.amount);
    var lineDiscount = Number.parseFloat(item === null || item === void 0 ? void 0 : (ref9 = item.discountAllocations) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.discountedAmount.amount) / item.quantity;
    var variantAmount = item.estimatedCost.totalAmount.amount / item.quantity;
    var compareAmount = hasDiscount ? Number.parseFloat(item.estimatedCost.subtotalAmount.amount) / item.quantity : Number.parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref11 = selectedVariant.compareAtPriceV2) === null || ref11 === void 0 ? void 0 : ref11.amount);
    if (hasSellingPlan !== null) compareAmount = Number.parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref12 = selectedVariant.compareAtPriceV2) === null || ref12 === void 0 ? void 0 : ref12.amount) || Number.parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref13 = selectedVariant.priceV2) === null || ref13 === void 0 ? void 0 : ref13.amount);
    if (compareAmount < Number.parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref14 = selectedVariant.compareAtPriceV2) === null || ref14 === void 0 ? void 0 : ref14.amount)) compareAmount = Number.parseFloat(selectedVariant.compareAtPriceV2.amount);
    var isLocalized = !!(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref15 = selectedVariant.priceV2) === null || ref15 === void 0 ? void 0 : ref15.locale);
    var currencySymbol1 = isLocalized ? (country === null || country === void 0 ? void 0 : (ref16 = country.currency) === null || ref16 === void 0 ? void 0 : ref16.symbol) || "$" : "$";
    var comparePrice = compareAmount ? compareAmount : null;
    var variantPrice = variantAmount;
    var handlePlanChange = function() {
        var _ref = SideCartItem_asyncToGenerator(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(e.target.value == "one-time")) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 3;
                        return cartAddItem({
                            merchandiseId: item.variant.id,
                            quantity: item.quantity,
                            attributes: [
                                {
                                    key: "_sc",
                                    value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                                }
                            ]
                        });
                    case 3:
                        _ctx.next = 5;
                        return cartRemoveItem({
                            lineId: item.id
                        });
                    case 5:
                        _ctx.next = 9;
                        break;
                    case 7:
                        _ctx.next = 9;
                        return cartUpdateItem({
                            lineId: item.id,
                            sellingPlanId: btoa(e.target.value)
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePlanChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var upgradeToPlan = function() {
        var _ref = SideCartItem_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref43, firstPlan;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        firstPlan = sellingPlans === null || sellingPlans === void 0 ? void 0 : (ref = sellingPlans[0]) === null || ref === void 0 ? void 0 : (ref43 = ref.sellingPlans) === null || ref43 === void 0 ? void 0 : ref43[0];
                        if (!firstPlan) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 5;
                        return cartUpdateItem({
                            lineId: item.id,
                            sellingPlanId: btoa(firstPlan === null || firstPlan === void 0 ? void 0 : firstPlan.id)
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function upgradeToPlan() {
            return _ref.apply(this, arguments);
        };
    }();
    var ItemQuantity = function(param) {
        var className = param.className;
        if (!className) className = "";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(className, " rounded-xs flex w-[114px] justify-between border border-black"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "flex cursor-pointer items-center pl-3",
                    onClick: function() {
                        if (item.quantity === 1) {
                            return cartRemoveItem({
                                lineId: item.id
                            });
                        }
                        cartUpdateItem({
                            lineId: item.id,
                            quantity: item.quantity - 1
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconMinus */.Ur, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "flex-grow py-2 px-4 text-center",
                    children: item.quantity
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "flex cursor-pointer items-center pr-3 ".concat(item.quantity >= 5 ? "pointer-events-none opacity-50" : ""),
                    onClick: function() {
                        if (item.quantity >= 5) return;
                        cartUpdateItem({
                            lineId: item.id,
                            quantity: item.quantity + 1
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconPlus */.SC, {})
                })
            ]
        });
    };
    var ItemTotal = function(param) {
        var className = param.className, currencySymbol = param.currencySymbol;
        if (!className) className = "";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((SideCart_module_default()).lineItemPricing, " ").concat(className),
            children: [
                comparePrice > variantPrice && comparePriceText === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (SideCart_module_default()).lineItemCompareAtPrice,
                    children: (0,Helper/* formatMoney */.lb)(comparePrice === null || comparePrice === void 0 ? void 0 : comparePrice.toFixed(2)).replace("$", currencySymbol)
                }),
                comparePriceText !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "".concat((SideCart_module_default()).lineItemCompareAtPrice, " after:hidden"),
                    children: comparePriceText
                }),
                planPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,Helper/* formatMoney */.lb)((planPrice === null || planPrice === void 0 ? void 0 : planPrice.toFixed(2)) || 0).replace("$", currencySymbol)
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,Helper/* formatMoney */.lb)(variantPrice === null || variantPrice === void 0 ? void 0 : variantPrice.toFixed(2)).replace("$", currencySymbol)
                })
            ]
        });
    };
    var calcDiscountValue = function() {
        var discountValue = null;
        var currentAmount = item.estimatedCost.totalAmount.amount;
        if (planPrice) {
            currentAmount = parseFloat(item.estimatedCost.totalAmount.amount) < parseFloat(planPrice) ? parseFloat(item.estimatedCost.totalAmount.amount) : parseFloat(planPrice);
        }
        if (compareAmount) {
            discountValue = (compareAmount - currentAmount) / compareAmount * 100;
            discountValue = Math.round(discountValue);
        }
        return discountValue;
    };
    var discountValue1 = calcDiscountValue();
    var discountHighlight = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref17 = siteSettings.discountHighlight) === null || ref17 === void 0 ? void 0 : ref17.enableDiscountHighlight) && discountValue1 !== 0 && discountValue1 !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-start justify-between border-b border-grey-4 py-5 px-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-20 shrink-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/products/".concat(item === null || item === void 0 ? void 0 : (ref18 = item.variant) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.product) === null || ref19 === void 0 ? void 0 : ref19.handle),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "responsive-image pb-full bg-grey-9 no-underline",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,Images/* getSizedImageUrl */.M0)(item === null || item === void 0 ? void 0 : (ref20 = item.variant) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.image) === null || ref21 === void 0 ? void 0 : ref21.src, "100x100@2x"),
                            alt: item === null || item === void 0 ? void 0 : (ref22 = item.variant) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.product) === null || ref23 === void 0 ? void 0 : ref23.title,
                            width: "100",
                            height: "100"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex-grow pl-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/products/".concat(item === null || item === void 0 ? void 0 : (ref24 = item.variant) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.product) === null || ref25 === void 0 ? void 0 : ref25.handle),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "my-0 inline-block pr-8 font-hafferBold text-xs no-underline",
                            children: item === null || item === void 0 ? void 0 : (ref26 = item.variant) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.product) === null || ref27 === void 0 ? void 0 : ref27.title
                        })
                    }),
                    (item === null || item === void 0 ? void 0 : (ref28 = item.variant) === null || ref28 === void 0 ? void 0 : ref28.title) != "Default Title" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-1 mb-0 text-xs",
                        children: item === null || item === void 0 ? void 0 : (ref29 = item.variant) === null || ref29 === void 0 ? void 0 : ref29.title
                    }) : null,
                    planText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mt-1 mb-0 text-xs",
                        children: [
                            "".concat(planText),
                            discountHighlight && discountValue1 > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "lineItem__discount-percentage text-sub-xx-small border-primary-2 border border-solid rounded-sm text-primary-2 ml-1 inline-block px-1 py-[1px] font-hafferBold",
                                children: [
                                    discountValue1,
                                    "% off"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mt-1 mb-0 text-xs",
                        children: [
                            "One-time Purchase",
                            discountHighlight && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "lineItem__discount-percentage text-sub-xx-small border-primary-2 border border-solid rounded-sm text-primary-2 ml-1 inline-block px-1 py-[1px] font-hafferBold",
                                children: [
                                    discountValue1,
                                    "% off"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-6 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemQuantity, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTotal, {
                                className: "text-right font-hafferBold text-sm",
                                currencySymbol: currencySymbol1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute right-0 top-0 inline-block cursor-pointer",
                        onClick: function() {
                            return cartRemoveItem({
                                lineId: item.id
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconRemove */.HF, {})
                    }),
                    hasSellingPlan && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "select-wrap-3 relative flex flex-col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            className: "mt-[16px] h-[40px] w-full cursor-pointer border border-grey-5 py-2 px-3 text-[12px] text-black placeholder-black outline-0 transition-all placeholder-shown:border-grey-5 hover:border-black hover:placeholder-black focus:placeholder-black",
                            name: "selling-plan-select-".concat(item === null || item === void 0 ? void 0 : item.id),
                            id: "selling-plan-select-".concat(item === null || item === void 0 ? void 0 : item.id),
                            value: item === null || item === void 0 ? void 0 : (ref30 = item.sellingPlanAllocation) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.sellingPlan) === null || ref31 === void 0 ? void 0 : ref31.id,
                            onChange: handlePlanChange,
                            children: sellingPlanOptions === null || sellingPlanOptions === void 0 ? void 0 : sellingPlanOptions.map(function(option, optionIndex) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                    value: option.value,
                                    children: option.label
                                }, "option-".concat(item === null || item === void 0 ? void 0 : item.id, "-").concat(optionIndex));
                            })
                        })
                    }),
                    !hasSellingPlan && sellingPlans.length > 0 && isUs && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sidecart-upgrade-sub mt-5 inline-block cursor-pointer border-b-2 font-hafferBold text-sm",
                        onClick: upgradeToPlan,
                        children: "update to subscription & save ".concat(sellingPlans === null || sellingPlans === void 0 ? void 0 : (ref32 = sellingPlans[0]) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.sellingPlans) === null || ref33 === void 0 ? void 0 : (ref34 = ref33[0]) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.priceAdjustments) === null || ref35 === void 0 ? void 0 : (ref36 = ref35[0]) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.adjustmentValue) === null || ref37 === void 0 ? void 0 : ref37.adjustmentPercentage, "%")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var sideCart_SideCartItem = (SideCartItem);

;// CONCATENATED MODULE: ./src/snippets/sideCart/SideCartBundleItem.jsx
function SideCartBundleItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SideCartBundleItem_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SideCartBundleItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SideCartBundleItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function SideCartBundleItem(param) {
    var item = param.item;
    var cartRemoveItems = (0,dist.useCartRemoveItems)().cartRemoveItems;
    var discountValue = item.attributes.find(function(attribute) {
        return attribute.key === "_discount";
    }).value;
    var country = (0,dist.useCountry)().country;
    var currencySymbol = (country === null || country === void 0 ? void 0 : country.currency.symbol) || "$";
    var removeBundle = function() {
        var _ref = SideCartBundleItem_asyncToGenerator(runtime_default().mark(function _callee() {
            var lineItemsId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        lineItemsId = item.bundleItems.map(function(bundleItem) {
                            return bundleItem.id;
                        });
                        _ctx.next = 3;
                        return cartRemoveItems({
                            lineIds: lineItemsId
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function removeBundle() {
            return _ref.apply(this, arguments);
        };
    }();
    var buildBundleItems = function() {
        var bundleItems = item.bundleItems.map(function(bundleItem) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bundle-item flex justify-between py-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-16 shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            width: 100,
                            height: 100,
                            src: bundleItem.variant.image.src,
                            alt: bundleItem.variant.image.altText,
                            sizes: "10vw",
                            loading: "lazy"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative-flex-grow w-full pl-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "inline-block pr-4 font-hafferBold text-xs",
                            children: bundleItem.variant.product.title
                        })
                    })
                ]
            }, bundleItem.id);
        });
        return bundleItems;
    };
    var bundleFullPrice = item.bundleItems.reduce(function(acc, bundleItem) {
        return acc + Number.parseFloat(bundleItem.estimatedCost.subtotalAmount.amount);
    }, 0);
    var bundleDiscountedPrice = item.bundleItems.reduce(function(acc, bundleItem) {
        return acc + Number.parseFloat(bundleItem.estimatedCost.totalAmount.amount);
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "items start flex flex-col justify-between border-b border-grey-4 py-5 px-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bundle-line-item__header flex justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-0 block font-hafferBold text-xs",
                        children: [
                            "Bundled Items",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "relative top-[-1px] ml-1 inline-block rounded-sm border border-solid border-primary-2 px-1 font-hafferBold text-sub-xx-small text-primary-2",
                                children: [
                                    discountValue,
                                    "% off"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: removeBundle,
                        className: "ml-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconRemove */.HF, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bundle-line-item__body flex flex-col py-2",
                children: buildBundleItems()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bundle-line-item__price text-right",
                children: [
                    bundleFullPrice > bundleDiscountedPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                        className: "font-hafferBold text-sm text-grey-3",
                        children: (0,Helper/* formatMoney */.lb)(bundleFullPrice.toFixed(2) || 0).replace("$", currencySymbol)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat(bundleFullPrice > bundleDiscountedPrice ? "ml-2" : "", " font-hafferBold text-sm"),
                        children: (0,Helper/* formatMoney */.lb)(bundleDiscountedPrice.toFixed(2) || 0).replace("$", currencySymbol)
                    })
                ]
            })
        ]
    }, item === null || item === void 0 ? void 0 : item.attributes["_bundleId"]);
};

;// CONCATENATED MODULE: ./src/snippets/sideCart/FreeShipping.jsx




function FreeShipping(param) {
    var cartTotals = param.cartTotals, discountAmount = param.discountAmount;
    var ref;
    var settings1 = (0,dist.useSettings)();
    var cart = (0,dist.useCart)();
    var ref1 = (0,react.useState)(null), shipScoutSettings = ref1[0], setShipScoutSettings = ref1[1];
    var isBrowser = "object" !== "undefined";
    var shipScoutThreshold = (shipScoutSettings === null || shipScoutSettings === void 0 ? void 0 : shipScoutSettings.freeShippingThresholdCents) / 100;
    var hasSubscription = cart === null || cart === void 0 ? void 0 : cart.lines.find(function(line) {
        return !!(line === null || line === void 0 ? void 0 : line.sellingPlanAllocation);
    });
    var shippingSettings = (settings1 === null || settings1 === void 0 ? void 0 : (ref = settings1.sideCart) === null || ref === void 0 ? void 0 : ref.freeShippingThreshold) || {};
    var threshold = shipScoutThreshold || (shippingSettings === null || shippingSettings === void 0 ? void 0 : shippingSettings.Threshold) || 0;
    var cart_total = (cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) ? cartTotals.subtotal - discountAmount : 0;
    var leftAmount = Math.max(0, threshold - cart_total).toFixed(2);
    var leftAmountFormat = (0,Helper/* formatMoney */.lb)(leftAmount).split(".");
    if (leftAmountFormat.length === 1) {
        leftAmountFormat = "".concat(leftAmountFormat[0], ".00");
    } else {
        leftAmountFormat = leftAmountFormat.join(".");
    }
    var enableSubscriptionShipping = shippingSettings === null || shippingSettings === void 0 ? void 0 : shippingSettings.enableSubscriptionText;
    var useSubscriptionMessage = hasSubscription && enableSubscriptionShipping && (shippingSettings === null || shippingSettings === void 0 ? void 0 : shippingSettings.subscriptionThresoldText);
    var useSubscriptionShipping = hasSubscription && enableSubscriptionShipping;
    var information = (shippingSettings === null || shippingSettings === void 0 ? void 0 : shippingSettings.information) ? shippingSettings === null || shippingSettings === void 0 ? void 0 : shippingSettings.information.replace("[TOTAL]", leftAmountFormat) : "";
    var meetMessage = useSubscriptionMessage ? shippingSettings === null || shippingSettings === void 0 ? void 0 : shippingSettings.subscriptionThresoldText : (shippingSettings === null || shippingSettings === void 0 ? void 0 : shippingSettings.message) || "";
    var progress = Math.min(Math.floor(100 * cart_total / threshold), 100);
    var shippingMet = leftAmount <= 0 || useSubscriptionShipping;
    if (useSubscriptionShipping) progress = 100;
    (0,react.useEffect)(function() {
        if (isBrowser && window._shipScout && shipScoutSettings == null) {
            window._shipScout.push(function(settings) {
                setShipScoutSettings(settings);
            });
        }
    }, [
        cartTotals
    ]);
    if (threshold <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-grey-9 px-5 py-5 text-center text-sm",
        children: [
            !shippingMet && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4",
                dangerouslySetInnerHTML: {
                    __html: information
                }
            }),
            shippingMet && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4",
                dangerouslySetInnerHTML: {
                    __html: meetMessage
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "shipping-progress-bar mt-2 overflow-hidden rounded-[10px] border border-black",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "shipping-progress-bar-inner bg-quinary-2 py-1 rounded-[10px]".concat(progress < 100 ? " rounded-r-none" : ""),
                    style: {
                        width: "".concat(progress, "%"),
                        transition: "all 1s"
                    }
                })
            })
        ]
    });
}
/* harmony default export */ var sideCart_FreeShipping = (FreeShipping);

// EXTERNAL MODULE: ../node_modules/next/image.js
var next_image = __webpack_require__(38579);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/snippets/sideCart/SidecartUpsellItem.jsx





function SidecartUpsellItem(param) {
    var product = param.product;
    var ref, ref1, ref2;
    var ref3 = (0,dist.useProductByHandle)({
        handle: product.handle
    }), currentProduct = ref3.product;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "upsell-ltem flex items-center border-b border-grey-4 py-3 last-of-type:border-b-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "upsell-item__image-container aspect-square w-20 shrink-0",
                children: currentProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/products/".concat(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.handle),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: currentProduct === null || currentProduct === void 0 ? void 0 : (ref = currentProduct.featuredImage) === null || ref === void 0 ? void 0 : ref.src,
                            alt: currentProduct === null || currentProduct === void 0 ? void 0 : (ref1 = currentProduct.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.alt,
                            width: "80",
                            height: "80",
                            loading: "lazy",
                            sizes: ""
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "upsell-item__info px-2",
                children: product && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/products/".concat(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.handle),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "no-underline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "mb-0 font-hafferBold text-xs capitalize",
                                children: (product === null || product === void 0 ? void 0 : (ref2 = product.metafield) === null || ref2 === void 0 ? void 0 : ref2.value) || (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.title)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
                                variant: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.variants[0],
                                className: "text-xs"
                            }, currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.id)
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "button button--primary ml-auto !min-w-max !text-sm",
                onClick: function() {
                    cartAddItem({
                        merchandiseId: currentProduct.variants[0].id,
                        quantity: 1,
                        attributes: [
                            {
                                key: "_sc",
                                value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                            }
                        ]
                    });
                },
                children: [
                    " ",
                    "add",
                    " "
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/snippets/sideCart/MetafieldUpsell.jsx
function MetafieldUpsell_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function MetafieldUpsell_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                MetafieldUpsell_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                MetafieldUpsell_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function MetafieldUpsell(param) {
    var cartItems = param.cartItems;
    var ref, ref1;
    var ref2 = (0,react.useState)([]), upsellProducts = ref2[0], setUpsellProducts = ref2[1];
    var siteSettings = (0,dist.useSettings)();
    var ref3;
    var enableUpsellProducts = (ref3 = siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.sideCart) === null || ref === void 0 ? void 0 : ref.enableUpsellProducts) !== null && ref3 !== void 0 ? ref3 : true;
    var getProductsData = function() {
        var _ref = MetafieldUpsell_asyncToGenerator(runtime_default().mark(function _callee(productGids) {
            var productsData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch("https://".concat("briogeo-hair-care.myshopify.com", "/api/2023-01/graphql.json"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/graphql",
                                "X-Shopify-Storefront-Access-Token": "60385688208d54f843f3c3cb36d767b2"
                            },
                            body: "query getProductsByGid {\n        nodes (ids : [".concat(productGids.map(function(element) {
                                return '"'.concat(element, '"');
                            }).join(","), '] ) {\n          ...on Product {\n            title\n            handle\n            id\n            featuredImage {\n              width\n              height\n              url\n            }\n            variants (first: 10) {\n              nodes {\n                id\n                product {\n                  handle\n                }\n                compareAtPriceV2 {\n                  amount\n                  currencyCode\n                }\n                priceV2 {\n                  amount\n                  currencyCode\n                }\n              }\n            }\n            metafield (namespace: "c_f", key: "custom_product_title") {\n              key\n              namespace\n              value\n            }\n          }\n        }\n      }')
                        }).then(function(response) {
                            return response.json();
                        }).catch(function(error) {
                            return console.error(error);
                        });
                    case 2:
                        productsData = _ctx.sent;
                        return _ctx.abrupt("return", productsData.data.nodes);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getProductsData(productGids) {
            return _ref.apply(this, arguments);
        };
    }();
    var getUpsellProducts = function() {
        var _ref = MetafieldUpsell_asyncToGenerator(runtime_default().mark(function _callee(newItems) {
            var attributeList, products, filteredProducts;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        attributeList = newItems.map(function(item) {
                            var upsellAttribute = item.attributes.find(function(attribute) {
                                return attribute.key === "_upsellProduct";
                            });
                            return item = upsellAttribute.value;
                        });
                        attributeList = attributeList.filter(function(el) {
                            return !!el;
                        });
                        _ctx.next = 4;
                        return getProductsData(attributeList);
                    case 4:
                        products = _ctx.sent;
                        filteredProducts = products.filter(function(item) {
                            if (item) {
                                var existsInCart = cartItems.some(function(cartItem) {
                                    return cartItem.variant.product.handle === item.handle;
                                });
                                if (!existsInCart) {
                                    return true;
                                }
                            }
                            return false;
                        });
                        setUpsellProducts(filteredProducts);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getUpsellProducts(newItems) {
            return _ref.apply(this, arguments);
        };
    }();
    var buildProductItems = function() {
        var _ref = MetafieldUpsell_asyncToGenerator(runtime_default().mark(function _callee() {
            var newItems, product;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newItems = cartItems.filter(function(lineItem) {
                            var LineItemProperty = lineItem.attributes.find(function(property) {
                                return property.key === "_upsellProduct";
                            });
                            return LineItemProperty;
                        });
                        _ctx.next = 3;
                        return getUpsellProducts(newItems);
                    case 3:
                        product = _ctx.sent;
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function buildProductItems() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (enableUpsellProducts) {
            buildProductItems();
        }
    }, [
        cartItems,
        siteSettings
    ]);
    if (!enableUpsellProducts) {
        return null;
    }
    return upsellProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "metafield-upsell py-5 px-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "metafield-upsell__header font-hafferBold text-xs",
                children: (siteSettings === null || siteSettings === void 0 ? void 0 : (ref1 = siteSettings.sideCart) === null || ref1 === void 0 ? void 0 : ref1.upsellProductsLabel) || "You May Also Like"
            }),
            upsellProducts.map(function(product, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidecartUpsellItem, {
                    product: product
                }, index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/snippets/icons/ThinArrowLeft.jsx
function ThinArrowLeft_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ThinArrowLeft_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ThinArrowLeft_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function ThinArrowLeft(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", ThinArrowLeft_objectSpread({
        width: "8",
        height: "14",
        viewBox: "0 0 8 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.68421 13L1 7L6.68421 1",
            stroke: "currentColor"
        })
    }));
}

;// CONCATENATED MODULE: ./src/snippets/icons/ThinArrowRight.jsx
function ThinArrowRight_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ThinArrowRight_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ThinArrowRight_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function ThinArrowRight(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", ThinArrowRight_objectSpread({
        width: "8",
        height: "14",
        viewBox: "0 0 8 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.999871 0.999999L6.68408 7L0.99987 13",
            stroke: "currentColor"
        })
    }));
}

;// CONCATENATED MODULE: ./src/snippets/sideCart/PromoSlider.jsx
function PromoSlider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PromoSlider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PromoSlider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







function PromoSlider(param) {
    var settings = param.settings;
    var slider = (0,react.useRef)();
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode == "US";
    var slides = settings.slide.filter(function(slideObject) {
        var customerBase = slideObject.customerBase;
        return isUs ? [
            "all",
            "us"
        ].includes(customerBase) : [
            "all",
            "intl"
        ].includes(customerBase);
    });
    var sliderSettings = {
        infinte: true,
        autoplay: settings.enableAutoplay || false,
        autoplaySpeed: settings.autoplaySpeed * 1000,
        arrows: false,
        adaptiveHeight: true
    };
    (0,react.useEffect)(function() {
        if (sliderSettings.autoplay == true) {
            var ref;
            slider === null || slider === void 0 ? void 0 : (ref = slider.current) === null || ref === void 0 ? void 0 : ref.slickPlay();
        }
    }, [
        settings
    ]);
    if (slides.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "promo-slider relative",
        style: {
            backgroundColor: settings.backgroundColorHex
        },
        children: [
            slides.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "promo-slider-back-arrow absolute  left-2 top-1/2 z-[1] -translate-y-1/2 border-none shadow-none ".concat(settings === null || settings === void 0 ? void 0 : settings.textColor),
                onClick: function() {
                    return slider.current.slickPrev();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThinArrowLeft, {
                        className: "h-auto w-1.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sr-only",
                        children: "move one slide back"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, PromoSlider_objectSpread({
                ref: slider
            }, sliderSettings, {
                className: "leading-0 py-2",
                children: slides.map(function(slideObject, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown_Markdown, {
                        content: slideObject.text,
                        className: "leading-0 px-5 text-center text-xs ".concat(settings === null || settings === void 0 ? void 0 : settings.textColor)
                    }, "promo-slide-".concat(index));
                })
            })),
            slides.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "promo-slider-forward-arrow absolute right-2 top-1/2 -translate-y-1/2 border-none shadow-none ".concat(settings.textColor),
                onClick: function() {
                    return slider.current.slickNext();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThinArrowRight, {
                        className: "h-auto w-1.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sr-only",
                        children: "move one slide forward"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/snippets/cart/GWPHandler.jsx
var GWPHandler = __webpack_require__(50954);
;// CONCATENATED MODULE: ./src/snippets/sideCart/SideCart.jsx
function SideCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SideCart_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SideCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SideCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function SideCart_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SideCart_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SideCart_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













function SideCart(props) {
    var ref22, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var cart = (0,dist.useCart)();
    var cartCount = (0,dist.useCartCount)();
    var cartTotals = (0,dist.useCartTotals)();
    var discountAmount = (0,useCartDiscountPrices/* useCartDiscountPrices */.P)().discountAmount;
    var siteSettings = (0,dist.useSettings)();
    var cartCheckout = (0,dist.useCartCheckout)().cartCheckout;
    var cartRemoveItem = (0,dist.useCartRemoveItem)().cartRemoveItem;
    var cartRemoveItems = (0,dist.useCartRemoveItems)().cartRemoveItems;
    var cartUpdateItem = (0,dist.useCartUpdateItem)().cartUpdateItem;
    var cartUpdateItems = (0,dist.useCartUpdateItems)().cartUpdateItems;
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var currencySymbol = (country === null || country === void 0 ? void 0 : (ref22 = country.currency) === null || ref22 === void 0 ? void 0 : ref22.symbol) || "$";
    var isBrowser = "object" !== "undefined";
    var enablePromoSlider = siteSettings === null || siteSettings === void 0 ? void 0 : (ref1 = siteSettings.sideCart) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.promotionalSlider) === null || ref2 === void 0 ? void 0 : ref2.enable;
    var promoSliderSettings = siteSettings === null || siteSettings === void 0 ? void 0 : (ref3 = siteSettings.sideCart) === null || ref3 === void 0 ? void 0 : ref3.promotionalSlider;
    if (isBrowser) {
        localStorage.setItem("cartData", JSON.stringify(cart));
    }
    var gwpItems = cart === null || cart === void 0 ? void 0 : (ref4 = cart.lines) === null || ref4 === void 0 ? void 0 : ref4.filter(function(line) {
        return line.attributes.find(function(attr) {
            return attr.key === "_gwp";
        });
    });
    var hasBundleItems = cart === null || cart === void 0 ? void 0 : (ref5 = cart.lines) === null || ref5 === void 0 ? void 0 : ref5.some(function(line) {
        return line.attributes.find(function(attr) {
            return attr.key === "_bundleId";
        });
    });
    var lines = cart === null || cart === void 0 ? void 0 : (ref6 = cart.lines) === null || ref6 === void 0 ? void 0 : ref6.filter(function(line) {
        return !line.attributes.find(function(attr) {
            return [
                "_gwp"
            ].includes(attr.key);
        });
    });
    var compareAtPriceTotal = cart === null || cart === void 0 ? void 0 : (ref7 = cart.lines) === null || ref7 === void 0 ? void 0 : ref7.reduce(function(accumulator, cartItem) {
        var ref, ref14, ref15, ref16, ref17, ref18, ref19;
        var compareAmount = parseFloat(!!(cartItem === null || cartItem === void 0 ? void 0 : (ref = cartItem.variant) === null || ref === void 0 ? void 0 : (ref14 = ref.compareAtPriceV2) === null || ref14 === void 0 ? void 0 : ref14.amount) && (cartItem === null || cartItem === void 0 ? void 0 : (ref15 = cartItem.variant) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.compareAtPriceV2) === null || ref16 === void 0 ? void 0 : ref16.amount) !== "0.0" ? cartItem === null || cartItem === void 0 ? void 0 : (ref17 = cartItem.variant) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.compareAtPriceV2) === null || ref18 === void 0 ? void 0 : ref18.amount : cartItem === null || cartItem === void 0 ? void 0 : (ref19 = cartItem.variant) === null || ref19 === void 0 ? void 0 : ref19.priceV2.amount) * cartItem.quantity;
        if ((cartItem === null || cartItem === void 0 ? void 0 : cartItem.sellingPlanAllocation) && compareAmount == 0) {
            var ref20, ref21;
            compareAmount = parseFloat(cartItem === null || cartItem === void 0 ? void 0 : (ref20 = cartItem.variant) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.priceV2) === null || ref21 === void 0 ? void 0 : ref21.amount) * cartItem.quantity;
        }
        return compareAmount += accumulator;
    }, 0);
    var discountHighlight = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref8 = siteSettings.discountHighlight) === null || ref8 === void 0 ? void 0 : ref8.enableDiscountHighlight) === true && (siteSettings === null || siteSettings === void 0 ? void 0 : (ref9 = siteSettings.discountHighlight) === null || ref9 === void 0 ? void 0 : ref9.cartDiscountMessage) !== "" && compareAtPriceTotal - (cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) + discountAmount > 0;
    if (hasBundleItems) {
        // Morphs the lines array to identify bundle items
        lines = lines.map(function(line, index) {
            var newLine = SideCart_objectSpread({}, line);
            if (line.attributes.find(function(attr) {
                return attr.key === "_bundleId";
            })) {
                newLine.isBundle = true;
                newLine.bundleItems = cart === null || cart === void 0 ? void 0 : cart.lines.filter(function(lineItem) {
                    return lineItem.attributes.some(function(attr) {
                        return attr.key === "_bundleId";
                    });
                });
            }
            return newLine;
        });
    }
    var filteredCartCount = (lines === null || lines === void 0 ? void 0 : lines.length) || 0;
    var cartCountHeader = filteredCartCount === 0 ? filteredCartCount : cartCount;
    var subscriptions = cart === null || cart === void 0 ? void 0 : (ref10 = cart.lines) === null || ref10 === void 0 ? void 0 : ref10.filter(function(line) {
        return !!(line === null || line === void 0 ? void 0 : line.sellingPlanAllocation);
    });
    var overLimitLines = lines === null || lines === void 0 ? void 0 : lines.filter(function(line) {
        return line.quantity > 5;
    });
    var sideCartOpen = props.sideCartOpen, toggleSideCart = props.toggleSideCart;
    var closeSideCartBtn = (0,react.useRef)(null);
    var closeSideCart = function(evt) {
        if (evt.target.classList.contains("bg-overlay") && sideCartOpen && closeSideCartBtn.current) {
            closeSideCartBtn.current.click();
        }
    };
    var buildCartItems = function() {
        var skipItem = 0;
        var newLines = lines.map(function(item, index) {
            if (skipItem > 0) {
                skipItem = skipItem - 1;
                return null;
            }
            if (item.isBundle) {
                skipItem = item.bundleItems.length - 1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideCartBundleItem, {
                        item: item,
                        isUs: isUs
                    }, "lineItem-".concat(index))
                }, item.id);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sideCart_SideCartItem, {
                    item: item,
                    cartRemoveItem: cartRemoveItem,
                    cartUpdateItem: cartUpdateItem,
                    isUs: isUs
                }, "lineItem-".concat(index))
            }, item.id);
        });
        return newLines;
    };
    (0,react.useEffect)(function() {
        PubSub.publish("VIEW_SIDECART", sideCartOpen);
    }, [
        sideCartOpen
    ]);
    (0,react.useEffect)(function() {
        var body = document.body;
        body.addEventListener("click", closeSideCart);
        document.addEventListener("closeSideCart", closeSideCart);
        return function() {
            body.removeEventListener("click", closeSideCart);
            document.removeEventListener("closeSideCart", closeSideCart);
        };
    }, [
        sideCartOpen
    ]);
    (0,react.useEffect)(function() {
        // if user switches countries and they have subscriptions, clear the cart
        if (country && !isUs && (subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.length)) {
            var removeCartItems = function() {
                var _ref = SideCart_asyncToGenerator(runtime_default().mark(function _callee() {
                    var ref, lineIds;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                lineIds = cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                    var id = param.id;
                                    return id;
                                });
                                _ctx.next = 4;
                                return cartRemoveItems({
                                    lineIds: lineIds
                                });
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function removeCartItems() {
                    return _ref.apply(this, arguments);
                };
            }();
            removeCartItems();
        }
    }, [
        isUs,
        country
    ]);
    (0,react.useEffect)(function() {
        if (overLimitLines === null || overLimitLines === void 0 ? void 0 : overLimitLines.length) {
            var updateLimitLines = function() {
                var _ref = SideCart_asyncToGenerator(runtime_default().mark(function _callee() {
                    var lineItems;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                lineItems = overLimitLines === null || overLimitLines === void 0 ? void 0 : overLimitLines.map(function(param) {
                                    var id = param.id, sellingPlanId = param.sellingPlanId;
                                    return {
                                        lineId: id,
                                        quantity: 1,
                                        sellingPlanID: sellingPlanId
                                    };
                                });
                                _ctx.next = 3;
                                return cartUpdateItems({
                                    lines: lineItems
                                });
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function updateLimitLines() {
                    return _ref.apply(this, arguments);
                };
            }();
            updateLimitLines();
        }
    }, [
        gwpItems === null || gwpItems === void 0 ? void 0 : gwpItems.length,
        lines === null || lines === void 0 ? void 0 : lines.length,
        cartCount,
        isUs, 
    ]);
    (0,react.useEffect)(function() {
        if (cart) {
            var limit = 5;
            var lineOverLimit = cart.lines.find(function(line) {
                return line.quantity > limit;
            });
            if (lineOverLimit) {
                cartUpdateItem({
                    lineId: lineOverLimit.id,
                    quantity: limit
                });
            }
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    (0,react.useEffect)(function() {
        // Track cart creation event on VWO
        var storedCartId = localStorage.getItem("VWO_cart_id");
        if (typeof (cart === null || cart === void 0 ? void 0 : cart.id) !== "undefined" && (cart === null || cart === void 0 ? void 0 : cart.id) !== storedCartId && cartCount && cartCount > 0) {
            localStorage.setItem("VWO_cart_id", cart === null || cart === void 0 ? void 0 : cart.id);
            if (isBrowser) {
                window._vis_opt_queue = window._vis_opt_queue || [];
                window._vis_opt_queue.push(function() {
                    window._vis_opt_goal_conversion(200);
                });
            }
        }
    }, [
        cartCount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-[2001] absolute top-0 left-0 h-full w-full bg-black opacity-50 ".concat(sideCartOpen ? "visible" : "invisible"),
                onClick: function(evt) {
                    toggleSideCart(evt);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "sideCart",
                className: "fixed top-0 right-0 z-[2002] flex h-full w-full max-w-[390px] flex-col justify-between bg-white transition-all duration-300".concat(sideCartOpen ? " opacity-1 translate-x-0" : " translate-x-full opacity-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between border-b border-grey-9 px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                onClick: function(evt) {
                                    toggleSideCart(evt);
                                },
                                ref: closeSideCartBtn,
                                "aria-label": "Side Cart toggle",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconClose */.bM, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Side Cart toggle"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "m-0 flex-grow px-4 font-hafferBold text-base",
                                children: "Your Cart"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    cartCountHeader,
                                    " item",
                                    cartCountHeader === 1 ? "(s)" : "s"
                                ]
                            })
                        ]
                    }),
                    isUs && filteredCartCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(sideCart_FreeShipping, {
                        cartTotals: cartTotals,
                        cartCount: cartCount,
                        discountAmount: discountAmount
                    }),
                    filteredCartCount > 0 && enablePromoSlider == true && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoSlider, {
                        settings: promoSliderSettings
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 overflow-y-auto overflow-x-hidden",
                        children: [
                            filteredCartCount === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "m-0 text-center font-hafferBold text-base",
                                    children: "Oops! Your cart is currently empty."
                                })
                            }),
                            filteredCartCount > 0 && buildCartItems(),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GWPHandler/* GWPHandler */.e, {
                                gwpItems: gwpItems,
                                cartLines: lines
                            }),
                            filteredCartCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetafieldUpsell, {
                                cartItems: lines
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "border-t border-black px-4 py-3.5 text-sm",
                        children: [
                            discountHighlight && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between font-hafferBold",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "pr-4",
                                                children: "Before Savings"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: (ref11 = (0,Helper/* formatMoney */.lb)(compareAtPriceTotal.toFixed(2) || 0)) === null || ref11 === void 0 ? void 0 : ref11.replace("$", currencySymbol)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between font-hafferBold",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "pr-4",
                                                children: siteSettings === null || siteSettings === void 0 ? void 0 : (ref12 = siteSettings.discountHighlight) === null || ref12 === void 0 ? void 0 : ref12.cartDiscountMessage
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-primary-2",
                                                children: [
                                                    "-",
                                                    (ref13 = (0,Helper/* formatMoney */.lb)((compareAtPriceTotal - (cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) + discountAmount).toFixed(2))) === null || ref13 === void 0 ? void 0 : ref13.replace("$", currencySymbol)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between font-hafferBold",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pr-4",
                                        children: "Subtotal"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: (0,Helper/* formatMoney */.lb)(((cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) - discountAmount || 0).toFixed(2)).replace("$", currencySymbol)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "button button--checkout w-full",
                                    onClick: cartCheckout,
                                    children: "checkout"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "whitespace-normal pt-2 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-xs",
                                    children: "Any discounts, shipping & taxes calculated at checkout"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var sideCart_SideCart = (SideCart);

;// CONCATENATED MODULE: ./src/snippets/search/Search.jsx
function Search_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Search_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Search_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Search_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







function Search(param) {
    var searchOpen = param.searchOpen, closeSearch = param.closeSearch;
    var goToSearchPage = function goToSearchPage(e) {
        if (e.key !== "Enter") {
            return;
        }
        handleButtonClick(e.target.value);
    };
    var ref6, ref1, ref2;
    var settings = (0,dist.useSettings)();
    var router = (0,dist.useRouter)();
    var ref3 = (0,react.useState)(""), rawSearch = ref3[0], setRawSearch = ref3[1];
    var ref4 = (0,react.useState)(""), activeSearch = ref4[0], setActiveSearch = ref4[1];
    var ref5 = (0,react.useState)(null), searchProducts = ref5[0], setSearchProducts = ref5[1];
    var debouncedSearchTerm = (0,hooks/* useDebounce */.Nr)(rawSearch, 500);
    var sendViewSearchResultsEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewSearchResultsEvent;
    (0,react.useEffect)(function() {
        if (activeSearch !== debouncedSearchTerm) {
            setActiveSearch(debouncedSearchTerm);
        }
    }, [
        debouncedSearchTerm
    ]);
    (0,react.useEffect)(function() {
        if (!searchOpen) {
            setRawSearch("");
            setActiveSearch("");
            setSearchProducts(null);
        }
    }, [
        searchOpen
    ]);
    (0,react.useEffect)(function() {
        var searchShopify = function() {
            var _ref = Search_asyncToGenerator(runtime_default().mark(function _callee(term) {
                var ref7, options, request, response, shopifyProducts, filtered;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            options = {
                                method: "POST",
                                body: JSON.stringify({
                                    term: term
                                })
                            };
                            _ctx.next = 5;
                            return fetch("/api/shopify/search", options);
                        case 5:
                            request = _ctx.sent;
                            _ctx.next = 8;
                            return request.json();
                        case 8:
                            response = _ctx.sent.response;
                            shopifyProducts = (response === null || response === void 0 ? void 0 : (ref7 = response.results) === null || ref7 === void 0 ? void 0 : ref7.products) || [];
                            filtered = shopifyProducts === null || shopifyProducts === void 0 ? void 0 : shopifyProducts.filter(function(p) {
                                var ref;
                                return !(p === null || p === void 0 ? void 0 : (ref = p.tags) === null || ref === void 0 ? void 0 : ref.includes("findify-remove"));
                            });
                            setSearchProducts(filtered);
                            _ctx.next = 18;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error("searchShopify:error", _ctx.t0);
                            return _ctx.abrupt("return", []);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }));
            return function searchShopify(term) {
                return _ref.apply(this, arguments);
            };
        }();
        if (activeSearch && activeSearch.length > 1) {
            searchShopify(activeSearch);
        } else {
            setSearchProducts(null);
        }
    }, [
        activeSearch
    ]);
    (0,react.useEffect)(function() {
        sendViewSearchResultsEvent({
            products: searchProducts,
            isSearchPage: false,
            searchTerm: activeSearch
        });
    }, [
        searchProducts,
        sendViewSearchResultsEvent
    ]);
    var handleButtonClick = function(query) {
        closeSearch();
        setRawSearch("");
        setActiveSearch("");
        setSearchProducts(null);
        if (location === null || location === void 0 ? void 0 : location.pathname.includes("/search")) {
            window.location.assign("/search?search=".concat(activeSearch ? activeSearch : query));
        } else {
            router.push({
                pathname: "/search",
                query: {
                    search: activeSearch ? activeSearch : query
                }
            }, undefined, {
                shallow: true
            });
        }
    };
    var hasSearchProducts = activeSearch && (searchProducts === null || searchProducts === void 0 ? void 0 : searchProducts.length) > 0;
    var noProducts = searchProducts && (searchProducts === null || searchProducts === void 0 ? void 0 : searchProducts.length) === 0;
    var searchSettings = settings === null || settings === void 0 ? void 0 : settings.search;
    var terms = (searchSettings === null || searchSettings === void 0 ? void 0 : searchSettings.terms) || [];
    var products = (searchSettings === null || searchSettings === void 0 ? void 0 : searchSettings.products) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute w-full border-t border-b border-grey-7 bg-white transition-all".concat(searchOpen ? " opacity-100" : " pointer-events-none invisible opacity-0"),
                "aria-hidden": !searchOpen,
                style: {
                    zIndex: 1
                },
                id: "search-drawer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full border-b border-grey-7 px-4 md:px-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "z-2 relative w-full px-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    "aria-label": "search",
                                    className: "hidden py-2 px-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconSearch */.jV, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    id: "search-input",
                                    name: "search",
                                    value: rawSearch,
                                    placeholder: "search by typing keywords\u2026",
                                    autoComplete: "off",
                                    className: "w-full py-3 px-4 placeholder-grey-5 transition-all placeholder-shown:border-grey-7 hover:border-black",
                                    style: {
                                        outline: "none",
                                        color: "#000000"
                                    },
                                    onChange: function(e) {
                                        return setRawSearch(e.target.value);
                                    },
                                    onKeyDown: function(e) {
                                        return goToSearchPage(e);
                                    },
                                    "aria-label": "search"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    "aria-label": "cancel search",
                                    className: "absolute left-0 top-1/2 z-0 h-full -translate-y-1/2 py-2 px-0",
                                    onClick: function() {
                                        if (activeSearch && hasSearchProducts) {
                                            handleButtonClick();
                                        } else if (!activeSearch) {
                                            closeSearch();
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconSearch */.jV, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 pt-5 pr-0 md:px-10",
                        children: [
                            activeSearch && hasSearchProducts && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "overflow-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative m-auto grid max-w-[1000px] grid-cols-[repeat(4,_160px)] gap-[0px] pt-5 pr-3 md:grid-cols-4 md:gap-[24px]",
                                            children: (ref6 = searchProducts === null || searchProducts === void 0 ? void 0 : searchProducts.slice(0, 4)) === null || ref6 === void 0 ? void 0 : ref6.map(function(product, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    className: "max-w-[250px] pr-3 md:max-w-none md:pr-0",
                                                    style: {
                                                        width: "100%",
                                                        margin: "0px auto"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                                        handle: product === null || product === void 0 ? void 0 : product.handle,
                                                        isSearch: true,
                                                        searchTerm: activeSearch,
                                                        belowFold: true
                                                    })
                                                }, index);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-4 w-full text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "button button--outline mb-5",
                                            onClick: handleButtonClick,
                                            children: "view all results"
                                        })
                                    })
                                ]
                            }),
                            activeSearch && noProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-[20px] text-[18px] text-primary-1 md:text-h4",
                                            children: 'No results for "'.concat(activeSearch, '"')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-[40px] pr-5 font-hafferBold text-[16px] text-primary-1 md:text-[18px]",
                                            children: 'We couldn\u2019t find a match for "'.concat(activeSearch, '" but try these popular products')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "overflow-auto pr-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative grid max-w-[1000px] grid-cols-[repeat(4,_165px)] gap-[12px] pb-5 md:grid-cols-4 md:gap-[24px]",
                                                children: (ref1 = products === null || products === void 0 ? void 0 : products.slice(0, 4)) === null || ref1 === void 0 ? void 0 : ref1.map(function(product, index) {
                                                    var ref;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                        className: "max-w-[220px] pr-2 md:max-w-none",
                                                        style: {
                                                            width: "100%",
                                                            margin: "0px auto"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                                            handle: product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.handle,
                                                            isSearch: true,
                                                            searchTerm: activeSearch,
                                                            belowFold: true
                                                        })
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            (!activeSearch || !searchProducts) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-1 overflow-auto md:mt-5 md:grid-cols-[300px_1fr]",
                                style: {
                                    maxHeight: "calc(100vh - 160px)"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-2 font-hafferBold text-[12px] text-primary-1 md:mb-8 md:text-[18px]",
                                                children: (searchSettings === null || searchSettings === void 0 ? void 0 : searchSettings.termsHeading) || "Popular Searches"
                                            }),
                                            terms.map(function(term, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: "block",
                                                    onClick: function() {
                                                        return setRawSearch(term === null || term === void 0 ? void 0 : term.value);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-[3px] inline-block cursor-pointer text-[14px] text-grey-5 hover:text-black md:text-[16px]",
                                                        children: term === null || term === void 0 ? void 0 : term.label
                                                    })
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-5 font-hafferBold text-[12px] text-primary-1 md:mt-0 md:text-[18px]",
                                                children: (searchSettings === null || searchSettings === void 0 ? void 0 : searchSettings.productsHeading) || "Popular Products"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "overflow-auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative grid grid-cols-[repeat(4,_165px)] gap-[0px] md:flex md:grid-cols-4 md:gap-[24px]",
                                                    children: (ref2 = products === null || products === void 0 ? void 0 : products.slice(0, 3)) === null || ref2 === void 0 ? void 0 : ref2.map(function(product, index) {
                                                        var ref;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                            className: "max-w-[220px] pr-3 md:flex-1 md:pr-0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                                                handle: product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.handle,
                                                                isSearch: true,
                                                                searchTerm: activeSearch,
                                                                belowFold: true
                                                            })
                                                        }, index);
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            searchOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    background: "black",
                    opacity: 0.4,
                    position: "absolute",
                    bottom: 0,
                    top: 100,
                    left: 0,
                    right: 0,
                    width: "100%",
                    height: "100vh",
                    zIndex: 0
                }
            })
        ]
    });
}
/* harmony default export */ var search_Search = (Search);

;// CONCATENATED MODULE: ./src/snippets/components/DiscountCodeFromUrl.jsx
function DiscountCodeFromUrl_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function DiscountCodeFromUrl_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                DiscountCodeFromUrl_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                DiscountCodeFromUrl_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function DiscountCodeFromUrl_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = DiscountCodeFromUrl_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function DiscountCodeFromUrl_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function DiscountCodeFromUrl() {
    var isBrowser = "object" !== "undefined";
    var _ref1 = (0,dist.useCartAddDiscount)(), cartAddDiscount = _ref1.cartAddDiscount, addDiscountStatus = DiscountCodeFromUrl_objectWithoutProperties(_ref1, [
        "cartAddDiscount"
    ]);
    var urlSearchParams = isBrowser ? new URLSearchParams(document.location.search) : null;
    var discountCode = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get("discount_code");
    var router = (0,next_router.useRouter)();
    var addDiscount = function() {
        var _ref = DiscountCodeFromUrl_asyncToGenerator(runtime_default().mark(function _callee(discount) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return cartAddDiscount({
                            discountCode: discount
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addDiscount(discount) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (discountCode) {
            addDiscount(discountCode.toLowerCase());
        }
        if (isBrowser && addDiscountStatus.finished === true) {
            var searchParams = new URLSearchParams(document.location.search);
            searchParams.delete("discount_code");
            router.replace(document.location.origin + document.location.pathname + (searchParams.toString() !== "" ? "?".concat(searchParams.toString()) : ""), undefined, {
                shallow: true
            });
        }
    }, [
        addDiscountStatus.finished
    ]);
};

;// CONCATENATED MODULE: ./src/snippets/globals/layout/Header.jsx












function Header() {
    var ref24, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var settings = (0,dist.useSettings)();
    var ref17 = (0,dist.useRouter)(), route = ref17.route, events = ref17.events;
    var item_count = (0,dist.useCartCount)();
    var customer = (0,dist.useCustomer)();
    var HeaderEl = (0,react.useRef)(null);
    var headerFiller = (0,react.useRef)(null);
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var is_home = route === "/";
    var ref18 = (0,react.useState)(0), scrollPosition = ref18[0], setScrollPosition = ref18[1];
    var headerOffset =  true ? ((ref24 = HeaderEl.current) === null || ref24 === void 0 ? void 0 : ref24.offsetHeight) - window.scrollY : 0;
    var mainMenu = (settings === null || settings === void 0 ? void 0 : settings.header_menu) || [];
    mainMenu = mainMenu.map(function(item, itemIndex, menuArr) {
        var newItem = {
            link: item.link,
            column: []
        };
        var columns = item.column ? item.column.filter(function(col, index) {
            return ((col === null || col === void 0 ? void 0 : col.cta) || (col === null || col === void 0 ? void 0 : col.menu)) && (col === null || col === void 0 ? void 0 : col.enable_column) === true && index <= 3;
        }) : [];
        newItem.column = columns;
        return newItem;
    });
    var ref19 = (0,react.useState)(false), searchOpen = ref19[0], setSearchOpen = ref19[1];
    var ref20 = (0,react.useState)(true), displayAnnouncement = ref20[0], setDisplayAnnouncement = ref20[1];
    var ref21 = (0,react.useState)(false), navOpen = ref21[0], setNavOpen = ref21[1];
    var ref22 = (0,react.useState)(false), sideCartOpen = ref22[0], setSideCartOpen = ref22[1];
    var ref23 = (0,react.useState)(0), lastScroll = ref23[0], setLastScroll = ref23[1];
    var closeSearch = function(evt) {
        evt === null || evt === void 0 ? void 0 : evt.preventDefault();
        setSearchOpen(false);
    };
    var jsonSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: (ref1 = (0,dist.useStorefrontInit)()) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.shop) === null || ref2 === void 0 ? void 0 : ref2.name,
        url: "https://www.briogeohair.com",
        logo: settings === null || settings === void 0 ? void 0 : (ref3 = settings.header) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.logo) === null || ref4 === void 0 ? void 0 : ref4.src
    };
    var scrollLock = function() {
        var body = document.body;
        var currentScroll = window.scrollY;
        body.style.setProperty("--topPosition", "-".concat(currentScroll, "px"));
        body.classList.add("overflow-hidden", "bg-overlay");
    };
    var scrollUnlock = function() {
        var body = document.body;
        var scrollTop = body.style.getPropertyValue("--topPosition");
        body.classList.remove("overflow-hidden", "bg-overlay");
        body.style.removeProperty("--topPosition");
        if (scrollTop !== "") {
            window.scrollTo({
                top: parseInt(scrollTop.replace("px", "") || "0", 10) * -1
            });
        }
        window.lastSpot = parseInt(scrollTop.replace("px", "") || "0", 10) * -1;
    };
    var closeNav = function() {
        setNavOpen(false);
        scrollUnlock();
    };
    var toggleNav = function() {
        if (navOpen) {
            scrollUnlock();
            setNavOpen(false);
        } else {
            scrollLock();
            setNavOpen(true);
        }
    };
    var toggleSideCart = function(evt) {
        setSideCartOpen(function(oldSidecartOpen) {
            if (oldSidecartOpen) {
                scrollUnlock();
            } else {
                scrollLock();
            }
            return !oldSidecartOpen;
        });
    };
    var openSideCart = function() {
        if (!sideCartOpen) {
            setSideCartOpen(true);
            scrollLock();
        }
    };
    var closeSideCart = function() {
        setSideCartOpen(false);
        scrollUnlock();
    };
    var toggleSearch = function() {
        if (!searchOpen) {
            setTimeout(function() {
                var input = document.querySelector("#search-input");
                input === null || input === void 0 ? void 0 : input.focus();
            }, 250);
        }
        setSearchOpen(!searchOpen);
    };
    var closeNavDrawers = function() {
        closeNav();
        closeSearch();
        closeSideCart();
        scrollUnlock();
        var megaMenus = HeaderEl.current.querySelectorAll(".mega-menu");
        var dropdownMenus = HeaderEl.current.querySelectorAll(".dropdown-menu");
        megaMenus.forEach(function(menu) {
            menu.classList.add("!pointer-events-none");
        });
        dropdownMenus.forEach(function(menu) {
            menu.classList.add("!pointer-events-none");
        });
    };
    var scrollHandler = function() {
        setScrollPosition(window.scrollY);
    };
    var restoreMainNav = function() {
        if (!HeaderEl.current) return;
        var megaMenus = HeaderEl.current.querySelectorAll(".mega-menu");
        var dropdownMenus = HeaderEl.current.querySelectorAll(".dropdown-menu");
        megaMenus.forEach(function(menu) {
            menu.classList.remove("!pointer-events-none");
        });
        dropdownMenus.forEach(function(menu) {
            menu.classList.remove("!pointer-events-none");
        });
    };
    var onCloseSideCartEvent = function() {
        closeSideCart();
        restoreMainNav();
    };
    (0,react.useEffect)(function() {
        if (!window.lastSpot) window.lastSpot = window.scrollY;
        window.addEventListener("openSideCart", openSideCart);
        window.addEventListener("closeSideCart", onCloseSideCartEvent);
        window.addEventListener("scroll", scrollHandler, {
            passive: true
        });
        // Reset scroll classes on initial load
        document.body.classList.remove("hide-header", "show-header", "is-scrolling");
        return function() {
            window.removeEventListener("openSideCart", openSideCart);
            window.removeEventListener("closeSideCart", onCloseSideCartEvent);
            window.removeEventListener("scroll", scrollHandler);
        };
    }, []);
    (0,react.useEffect)(function() {
        events.on("routeChangeStart", closeNavDrawers);
        events.on("routeChangeComplete", restoreMainNav);
        return function() {
            events.off("routeChangeStart", closeNavDrawers);
            events.off("routeChangeComplete", restoreMainNav);
        };
    }, [
        events
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var body = document.querySelector("body");
        var header = document.querySelector(".site-header");
        if ((body === null || body === void 0 ? void 0 : (ref = body.className) === null || ref === void 0 ? void 0 : ref.indexOf("bg-overlay")) > -1 || window.innerWidth >= 1024) return;
        if (header) {
            header.classList.add("transition-all");
        }
        if (scrollPosition <= headerOffset) {
            body.classList.remove("show-header");
            body.classList.remove("is-scrolling");
            headerFiller.current.style.height = "0px";
            headerFiller.current.classList.add("hidden");
            return;
        }
        if (scrollPosition > headerOffset) {
            body.classList.add("is-scrolling");
            headerFiller.current.style.height = "".concat(HeaderEl.current.offsetHeight, "px");
            headerFiller.current.classList.remove("hidden");
            if (scrollPosition > lastScroll && !body.classList.contains("hide-header")) {
                // Scroll Down
                body.classList.remove("show-header");
                body.classList.add("hide-header");
            } else if (scrollPosition < lastScroll && body.classList.contains("hide-header")) {
                // Scroll Up
                body.classList.remove("hide-header");
                body.classList.add("show-header");
            }
            setLastScroll(scrollPosition);
        }
    }, [
        scrollPosition
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "site-header lg:sticky relative peer top-0 z-[2000] w-full border-b border-grey-7 bg-white",
                ref: HeaderEl,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "items-center1 relative z-0 flex justify-between py-4 px-4 md:px-12 lg:py-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-1 lg:hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "ml-0 block lg:hidden",
                                        onClick: function() {
                                            return toggleNav();
                                        },
                                        "aria-label": "Menu toggle",
                                        "aria-controls": "menu-drawer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Menu toggle"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconMenu */.dc, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "ml-4 mr-4 block md:ml-6 lg:hidden",
                                        onClick: toggleSearch,
                                        "aria-label": "Toggle search",
                                        "aria-controls": "search-drawer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Toggle search"
                                            }),
                                            searchOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconClose */.bM, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconSearch */.jV, {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-none flex-1 md:flex-grow-0",
                                children: is_home ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "header__logo mx-5 mb-0 md:mx-0 lg:px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                        settings: settings
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "header__logo mx-5 mb-0 md:mx-0 lg:px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                        settings: settings
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NavDesktop, {
                                menu: mainMenu
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-1 items-center justify-end lg:flex-grow-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "header__icons flex items-center",
                                    children: [
                                        (settings === null || settings === void 0 ? void 0 : (ref5 = settings.header) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.cta) === null || ref6 === void 0 ? void 0 : ref6.link) && !(settings === null || settings === void 0 ? void 0 : (ref7 = settings.header) === null || ref7 === void 0 ? void 0 : ref7.rewards_enabled) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-0 mr-9 mb-0 hidden lg:block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: settings === null || settings === void 0 ? void 0 : (ref8 = settings.header) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.cta) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.link) === null || ref10 === void 0 ? void 0 : ref10.url,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "".concat(settings === null || settings === void 0 ? void 0 : (ref11 = settings.header) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.cta) === null || ref12 === void 0 ? void 0 : ref12.style, " text-center no-underline !text-sm"),
                                                    children: settings === null || settings === void 0 ? void 0 : (ref13 = settings.header) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.cta) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.link) === null || ref15 === void 0 ? void 0 : ref15.text
                                                })
                                            })
                                        }) : null,
                                        isUs && (settings === null || settings === void 0 ? void 0 : (ref16 = settings.header) === null || ref16 === void 0 ? void 0 : ref16.rewards_enabled) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: !customer ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/pages/rewards",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "focus-link-rosehip mr-9 hidden lg:block w-[100px] text-center whitespace-nowrap",
                                                    children: "earn rewards"
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/pages/rewards",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "focus-link-rosehip mr-9 hidden lg:block text-center whitespace-nowrap",
                                                    children: [
                                                        "redeem rewards",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SwellPoints, {}, customer.id)
                                                    ]
                                                })
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            type: "button",
                                            className: "mr-4 hidden hover:text-grey-3 md:mr-7 lg:block",
                                            onClick: toggleSearch,
                                            "aria-label": "Toggle search",
                                            "aria-controls": "search-drawer",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Toggle search"
                                                }),
                                                searchOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconClose */.bM, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconSearch */.jV, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "".concat(customer ? "/pages/my-profile" : "/account/login"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "".concat(customer ? "/pages/my-profile" : "/account/login"),
                                                className: "text-black hover:text-grey-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: " Account Login "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconAccount */.Uu, {})
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                "aria-label": "open cart",
                                                className: "header__icon-cart relative z-0 ml-4 mr-0 flex items-center text-black no-underline hover:text-grey-3 md:ml-7",
                                                href: "/cart",
                                                onClick: function(evt) {
                                                    evt.preventDefault();
                                                    toggleSideCart(evt);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: " Account Login "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconCart */.k5, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "cart-count ml-2 align-middle md:ml-2 ".concat(item_count > 0 ? "" : "hidden"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            "data-cart-count": true,
                                                            className: "p-1 align-middle",
                                                            children: item_count
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(search_Search, {
                        searchOpen: searchOpen,
                        closeSearch: closeSearch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountCodeFromUrl, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobileQuickLinks, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-filler hidden",
                ref: headerFiller
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NavMobile, {
                menu: mainMenu,
                navOpen: navOpen,
                closeNav: closeNav
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sideCart_SideCart, {
                sideCartOpen: sideCartOpen,
                toggleSideCart: toggleSideCart
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(jsonSchema)
                }
            })
        ]
    });
}
function Logo(param) {
    var settings = param.settings;
    var ref, ref25, ref26, ref27, ref28;
    return (settings === null || settings === void 0 ? void 0 : (ref = settings.header) === null || ref === void 0 ? void 0 : ref.logo) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "logo-image m-auto block w-logo-m no-underline lg:w-logo",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: settings === null || settings === void 0 ? void 0 : (ref25 = settings.header) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.logo) === null || ref26 === void 0 ? void 0 : ref26.src,
                    className: "h-full w-full",
                    alt: (settings === null || settings === void 0 ? void 0 : (ref27 = settings.header) === null || ref27 === void 0 ? void 0 : ref27.tagline) || "briogeohair logo",
                    width: "126",
                    height: "42"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "visually-hidden",
                    children: settings === null || settings === void 0 ? void 0 : (ref28 = settings.header) === null || ref28 === void 0 ? void 0 : ref28.tagline
                })
            ]
        })
    });
}
/* harmony default export */ var layout_Header = (Header);

;// CONCATENATED MODULE: ./src/snippets/globals/layout/EmailSignup.jsx
function EmailSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function EmailSignup_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                EmailSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                EmailSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






var validateEmail = function(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
function EmailSignup() {
    var ref;
    var sendSubscribeEvent = (0,hooks/* useDataLayerActions */.KZ)().sendSubscribeEvent;
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(""), message = ref3[0], setMessage = ref3[1];
    var settings = (0,dist.useSettings)();
    var subscribeToList = (0,useKlaviyoApi/* useKlaviyoApi */.a)().subscribeToList;
    var emailSettings = settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.email;
    var listId = (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.listId) || "HQmQ53";
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = EmailSignup_asyncToGenerator(runtime_default().mark(function _callee(e) {
            var isEmailValid;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!isLoading) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (email) {
                            _ctx.next = 7;
                            break;
                        }
                        setMessage("Email is required");
                        setTimeout(function() {
                            setMessage("");
                        }, 3000);
                        return _ctx.abrupt("return");
                    case 7:
                        isEmailValid = validateEmail(email);
                        if (isEmailValid) {
                            _ctx.next = 12;
                            break;
                        }
                        setMessage("Email is invalid");
                        setTimeout(function() {
                            setMessage("");
                        }, 3000);
                        return _ctx.abrupt("return");
                    case 12:
                        setIsLoading(true);
                        _ctx.next = 15;
                        return subscribeToList({
                            email: email,
                            listId: listId,
                            source: "Footer subscription form",
                            callback: function(response) {
                                if (response === "success") {
                                    setIsLoading(false);
                                    setMessage((emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.successMessage) || "Email submitted!");
                                    sendSubscribeEvent({
                                        email: email
                                    });
                                    setEmail("");
                                    setTimeout(function() {
                                        setMessage("");
                                    }, 4000);
                                } else {
                                    setIsLoading(false);
                                    setEmail("");
                                    setMessage("Please try again later");
                                }
                            }
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        email,
        isLoading,
        message
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-2 font-hafferBold text-white",
                children: (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.title) || "sign up for our newsletter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-4 flex items-center justify-between bg-grey-3 p-1 pr-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-input relative flex w-auto md:w-[20.625rem] flex-col self-start",
                        style: {
                            marginBottom: message ? "1.75rem" : "0"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                name: "email-address",
                                id: "email-address",
                                type: "email",
                                value: email,
                                placeholder: "Email Address",
                                required: true,
                                style: {
                                    outline: "none"
                                },
                                className: "w-full cursor-pointer border-0 border-black bg-transparent py-2 px-4 text-white placeholder-grey-7 transition-all placeholder-shown:border-grey-7 placeholder-shown:text-white hover:border-black hover:text-white hover:placeholder-white focus:rounded-none focus:text-white focus:placeholder-white focus:outline-ada-outline",
                                onChange: function(e) {
                                    return setEmail(e.target.value);
                                },
                                "aria-required": "true",
                                "aria-label": "Email Address"
                            }),
                            message && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xsmall absolute top-[calc(100%+0.5rem)] w-full px-4 text-white",
                                children: message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        "aria-label": "submit",
                        className: "button--white button--small lowercase",
                        style: message ? {
                            marginBottom: "auto",
                            marginTop: "5px"
                        } : {},
                        onClick: handleSubmit,
                        children: (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.buttonText) || "Submit"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var layout_EmailSignup = (EmailSignup);

// EXTERNAL MODULE: ../node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31655);
;// CONCATENATED MODULE: ./src/snippets/globals/layout/CountrySelector.jsx
function CountrySelector_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CountrySelector_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CountrySelector_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CountrySelector_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function CountrySelector() {
    var countries = (0,dist.useCountries)();
    var ref1 = (0,dist.useCountry)(), country = ref1.country, updateCountry = ref1.updateCountry;
    var haveCountries = (countries === null || countries === void 0 ? void 0 : countries.length) > 0;
    var updateSelectedCountry = (0,react.useCallback)(function() {
        var _ref = CountrySelector_asyncToGenerator(runtime_default().mark(function _callee(selected) {
            var selectedCountry;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        selectedCountry = countries === null || countries === void 0 ? void 0 : countries.find(function(_country) {
                            return _country.isoCode === selected;
                        });
                        _ctx.next = 3;
                        return updateCountry({
                            country: selectedCountry
                        });
                    case 3:
                        js_cookie/* default.set */.Z.set("country-selector_customer-country", selectedCountry.isoCode);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(selected) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countries === null || countries === void 0 ? void 0 : countries.length
    ]);
    var handleCountrySelect = function(selected) {
        updateSelectedCountry(selected);
    };
    (0,react.useEffect)(function() {
        if ((countries === null || countries === void 0 ? void 0 : countries.length) && country) {
            var selectedCountry = countries === null || countries === void 0 ? void 0 : countries.find(function(_country) {
                return _country.isoCode === (country === null || country === void 0 ? void 0 : country.isoCode);
            });
            if (!selectedCountry) updateSelectedCountry("US");
        }
    }, [
        countries === null || countries === void 0 ? void 0 : countries.length,
        country
    ]);
    return haveCountries && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "select-wrap-4 relative bottom-[10px] my-[12px] inline-block md:absolute md:right-[24px] lg:right-[100px] md:my-[0px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                className: "h-[28px] w-[auto] cursor-pointer border border-grey-5 bg-[#696969] p-0 py-0 pl-[10px] pr-[40px] text-center text-[12px] text-[13px] text-[#F5F5F5] placeholder-black outline-0 placeholder-shown:border-grey-5 hover:border-grey-5",
                name: "country-select",
                id: "country-select",
                value: (country === null || country === void 0 ? void 0 : country.isoCode) || "US",
                onChange: function(e) {
                    return handleCountrySelect(e.target.value);
                },
                "aria-label": "Select a country",
                children: countries.slice().sort(function(a, b) {
                    return a.name.localeCompare(b.name);
                }).map(function(option, optionIndex) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                        value: option.isoCode,
                        children: "".concat(option.name, " ").concat(option === null || option === void 0 ? void 0 : (ref = option.locale) === null || ref === void 0 ? void 0 : ref.currency)
                    }, "option-".concat(optionIndex));
                })
            })
        })
    });
}
/* harmony default export */ var layout_CountrySelector = (CountrySelector);

;// CONCATENATED MODULE: ./src/snippets/icons/WhiteInstagram.jsx

function WhiteInstagram() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.70182 0.048C5.55491 0.00872726 5.82691 0 8 0C10.1731 0 10.4451 0.00945454 11.2975 0.048C12.1498 0.0865454 12.7316 0.222545 13.2407 0.419636C13.7738 0.621091 14.2575 0.936 14.6575 1.34327C15.0647 1.74255 15.3789 2.22545 15.5796 2.75927C15.7775 3.26836 15.9127 3.85018 15.952 4.70109C15.9913 5.55564 16 5.82764 16 8C16 10.1731 15.9905 10.4451 15.952 11.2982C15.9135 12.1491 15.7775 12.7309 15.5796 13.24C15.3789 13.7739 15.0642 14.2576 14.6575 14.6575C14.2575 15.0647 13.7738 15.3789 13.2407 15.5796C12.7316 15.7775 12.1498 15.9127 11.2989 15.952C10.4451 15.9913 10.1731 16 8 16C5.82691 16 5.55491 15.9905 4.70182 15.952C3.85091 15.9135 3.26909 15.7775 2.76 15.5796C2.22612 15.3789 1.74241 15.0642 1.34255 14.6575C0.935549 14.2579 0.620593 13.7745 0.419636 13.2407C0.222545 12.7316 0.0872727 12.1498 0.048 11.2989C0.00872726 10.4444 0 10.1724 0 8C0 5.82691 0.00945454 5.55491 0.048 4.70255C0.0865454 3.85018 0.222545 3.26836 0.419636 2.75927C0.620889 2.22551 0.936086 1.74205 1.34327 1.34255C1.74257 0.935637 2.2258 0.620686 2.75927 0.419636C3.26836 0.222545 3.85018 0.0872727 4.70109 0.048H4.70182ZM11.2327 1.488C10.3891 1.44945 10.136 1.44145 8 1.44145C5.864 1.44145 5.61091 1.44945 4.76727 1.488C3.98691 1.52364 3.56364 1.65382 3.28145 1.76364C2.90836 1.90909 2.64145 2.08145 2.36145 2.36145C2.09603 2.61967 1.89177 2.93402 1.76364 3.28145C1.65382 3.56364 1.52364 3.98691 1.488 4.76727C1.44945 5.61091 1.44145 5.864 1.44145 8C1.44145 10.136 1.44945 10.3891 1.488 11.2327C1.52364 12.0131 1.65382 12.4364 1.76364 12.7185C1.89164 13.0655 2.096 13.3804 2.36145 13.6385C2.61964 13.904 2.93455 14.1084 3.28145 14.2364C3.56364 14.3462 3.98691 14.4764 4.76727 14.512C5.61091 14.5505 5.86327 14.5585 8 14.5585C10.1367 14.5585 10.3891 14.5505 11.2327 14.512C12.0131 14.4764 12.4364 14.3462 12.7185 14.2364C13.0916 14.0909 13.3585 13.9185 13.6385 13.6385C13.904 13.3804 14.1084 13.0655 14.2364 12.7185C14.3462 12.4364 14.4764 12.0131 14.512 11.2327C14.5505 10.3891 14.5585 10.136 14.5585 8C14.5585 5.864 14.5505 5.61091 14.512 4.76727C14.4764 3.98691 14.3462 3.56364 14.2364 3.28145C14.0909 2.90836 13.9185 2.64145 13.6385 2.36145C13.3803 2.09605 13.066 1.89179 12.7185 1.76364C12.4364 1.65382 12.0131 1.52364 11.2327 1.488ZM6.97818 10.4662C7.54884 10.7037 8.18428 10.7358 8.77595 10.5569C9.36762 10.378 9.87883 9.99921 10.2223 9.48527C10.5657 8.97132 10.72 8.35409 10.6589 7.73899C10.5978 7.12388 10.3251 6.54907 9.88727 6.11273C9.60817 5.8338 9.2707 5.62023 8.89915 5.48738C8.5276 5.35453 8.13122 5.30572 7.73854 5.34445C7.34586 5.38318 6.96666 5.50849 6.62822 5.71137C6.28979 5.91424 6.00054 6.18963 5.78131 6.51771C5.56208 6.84579 5.41832 7.21839 5.36038 7.6087C5.30243 7.99901 5.33175 8.3973 5.44621 8.77492C5.56068 9.15254 5.75744 9.50008 6.02234 9.79253C6.28724 10.085 6.61369 10.315 6.97818 10.4662ZM5.09236 5.09236C5.4742 4.71053 5.92751 4.40764 6.4264 4.20099C6.92529 3.99434 7.46 3.88798 8 3.88798C8.54 3.88798 9.07471 3.99434 9.5736 4.20099C10.0725 4.40764 10.5258 4.71053 10.9076 5.09236C11.2895 5.4742 11.5924 5.92751 11.799 6.4264C12.0057 6.92529 12.112 7.46 12.112 8C12.112 8.54 12.0057 9.07471 11.799 9.5736C11.5924 10.0725 11.2895 10.5258 10.9076 10.9076C10.1365 11.6788 9.09058 12.112 8 12.112C6.90942 12.112 5.86352 11.6788 5.09236 10.9076C4.32121 10.1365 3.88798 9.09058 3.88798 8C3.88798 6.90942 4.32121 5.86352 5.09236 5.09236ZM13.024 4.50036C13.1186 4.41111 13.1944 4.30377 13.2468 4.18471C13.2992 4.06565 13.3271 3.93729 13.329 3.80722C13.3309 3.67716 13.3067 3.54803 13.2578 3.4275C13.2089 3.30696 13.1363 3.19746 13.0443 3.10548C12.9524 3.0135 12.8429 2.94091 12.7223 2.89201C12.6018 2.84311 12.4727 2.81889 12.3426 2.82079C12.2125 2.82268 12.0842 2.85066 11.9651 2.90305C11.8461 2.95545 11.7387 3.0312 11.6495 3.12582C11.4759 3.30984 11.3808 3.55427 11.3845 3.80722C11.3882 4.06017 11.4903 4.30173 11.6692 4.48061C11.8481 4.6595 12.0896 4.76162 12.3426 4.76531C12.5955 4.769 12.84 4.67396 13.024 4.50036Z",
            className: "fill-white hover:fill-grey-7"
        })
    });
}
/* harmony default export */ var icons_WhiteInstagram = (WhiteInstagram);

;// CONCATENATED MODULE: ./src/snippets/icons/WhiteFacebook.jsx

function WhiteFacebook() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "7",
        height: "14",
        viewBox: "0 0 7 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.54745 14V7.62433H6.62061L6.92877 5.12805H4.54745V3.53802C4.54745 2.81769 4.7409 2.3245 5.73736 2.3245H7V0.098925C6.38565 0.0306183 5.76814 -0.00236327 5.15028 0.000131594C3.3178 0.000131594 2.05966 1.16076 2.05966 3.29143V5.12338H0V7.61966H2.06416V14H4.54745Z",
            className: "fill-white hover:fill-grey-7"
        })
    });
}
/* harmony default export */ var icons_WhiteFacebook = (WhiteFacebook);

;// CONCATENATED MODULE: ./src/snippets/icons/WhiteTikTok.jsx

function WhiteTikTok() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "15",
        height: "17",
        viewBox: "0 0 15 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.1325 3.63539C13.0157 3.57605 12.9019 3.51099 12.7917 3.44048C12.4715 3.23251 12.1779 2.98749 11.9172 2.71068C11.2642 1.9771 11.0204 1.23295 10.9311 0.712422H10.9342C10.8596 0.279529 10.8904 0 10.8958 0H7.92295V11.2892C7.92295 11.4403 7.92295 11.5906 7.91679 11.7387C7.91679 11.7569 7.91448 11.7735 7.91372 11.7939C7.91372 11.8014 7.91372 11.8105 7.91141 11.8188V11.8256C7.88019 12.2306 7.74812 12.6218 7.52682 12.9648C7.30551 13.3079 7.00176 13.5922 6.64229 13.7929C6.26727 14.0024 5.8431 14.1123 5.41163 14.1117C4.02714 14.1117 2.90417 13.0026 2.90417 11.633C2.90417 10.2625 4.02714 9.15345 5.41163 9.15345C5.67392 9.15345 5.93466 9.19425 6.18387 9.27433L6.18772 6.30074C5.43087 6.20483 4.662 6.26408 3.92964 6.47473C3.19728 6.68538 2.51733 7.04287 1.93272 7.52463C1.42034 7.96171 0.989561 8.48326 0.659755 9.06582C0.534382 9.27811 0.0605786 10.1326 0.0036607 11.5181C-0.0324899 12.3038 0.208258 13.1197 0.322863 13.4559V13.4635C0.394395 13.6614 0.674369 14.3383 1.12971 14.9087C1.49691 15.3666 1.93076 15.7688 2.41729 16.1024V16.0948L2.42421 16.1024C3.86254 17.0619 5.45855 16.9992 5.45855 16.9992C5.73468 16.9878 6.65998 16.9992 7.71066 16.5104C8.87594 15.9679 9.53895 15.1603 9.53895 15.1603C9.96285 14.6777 10.2999 14.1276 10.5358 13.5338C10.805 12.8387 10.8942 12.0062 10.8942 11.6737V5.68351C10.9304 5.70466 11.4111 6.01668 11.4111 6.01668C11.4111 6.01668 12.1033 6.4526 13.1825 6.7359C13.9562 6.93762 15 6.98068 15 6.98068V4.08188C14.6346 4.12117 13.8924 4.00785 13.1317 3.63615L13.1325 3.63539Z",
            className: "fill-white hover:fill-grey-7"
        })
    });
}
/* harmony default export */ var icons_WhiteTikTok = (WhiteTikTok);

;// CONCATENATED MODULE: ./src/snippets/globals/layout/FooterMenu.jsx



function FooterMenu(cms) {
    for(var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        props[_key - 1] = arguments[_key];
    }
    var ref7, ref1, ref2, ref3, ref4, ref5;
    var settings = (0,dist.useSettings)();
    return (settings === null || settings === void 0 ? void 0 : (ref7 = settings.footer) === null || ref7 === void 0 ? void 0 : (ref1 = ref7.footerMenu1) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "footer-menu-1 flex w-full max-w-[432px] justify-between pt-4 md:pt-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-0 pl-0",
                children: settings === null || settings === void 0 ? void 0 : (ref2 = settings.footer) === null || ref2 === void 0 ? void 0 : ref2.footerMenu1.map(function(linkItem, linkIndex) {
                    var ref, ref6;
                    return (linkItem === null || linkItem === void 0 ? void 0 : (ref = linkItem.link) === null || ref === void 0 ? void 0 : ref.url) && (linkItem === null || linkItem === void 0 ? void 0 : (ref6 = linkItem.link) === null || ref6 === void 0 ? void 0 : ref6.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "mt-0 mb-2 list-none",
                        children: linkItem.link.url.indexOf("http") > -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: linkItem.link.url,
                            target: linkItem.link.newTab === true ? "_blank" : "_self",
                            className: "text-small lg:text-regular lowercase text-white no-underline hover:text-grey-7 hover:underline",
                            rel: "noreferrer",
                            children: linkItem.link.text
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: linkItem.link.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: linkItem.link.text,
                                target: linkItem.link.newTab === true ? "_blank" : "_self",
                                className: "text-small lg:text-regular lowercase text-white no-underline hover:text-grey-7 hover:underline",
                                children: linkItem.link.text
                            })
                        })
                    }, "footerMenu1".concat(linkIndex));
                })
            }),
            (settings === null || settings === void 0 ? void 0 : (ref3 = settings.footer) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.footerMenu2) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-0 pl-0 sm:pr-10 md:pr-0",
                children: settings === null || settings === void 0 ? void 0 : (ref5 = settings.footer) === null || ref5 === void 0 ? void 0 : ref5.footerMenu2.map(function(linkItem, linkIndex) {
                    var ref, ref8;
                    return (linkItem === null || linkItem === void 0 ? void 0 : (ref = linkItem.link) === null || ref === void 0 ? void 0 : ref.url) && (linkItem === null || linkItem === void 0 ? void 0 : (ref8 = linkItem.link) === null || ref8 === void 0 ? void 0 : ref8.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "mt-0 mb-2 list-none",
                        children: linkItem.link.url.indexOf("http") > -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: linkItem.link.url,
                            target: linkItem.link.newTab === true ? "_blank" : "_self",
                            className: "text-small lg:text-regular lowercase text-white no-underline hover:text-grey-7 hover:underline",
                            rel: "noreferrer",
                            children: linkItem.link.text
                        }) : linkItem.link.url && linkItem.link.url === "/pages/do-not-sell-my-information" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            id: "ot-sdk-btn",
                            className: "ot-sdk-show-settings",
                            children: linkItem.link.text
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: linkItem.link.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: linkItem.link.text,
                                target: linkItem.link.newTab === true ? "_blank" : "_self",
                                className: "text-small lg:text-regular lowercase text-white no-underline hover:text-grey-7 hover:underline",
                                children: linkItem.link.text
                            })
                        })
                    }, "footerMenu2".concat(linkIndex));
                })
            })
        ]
    });
}
/* harmony default export */ var layout_FooterMenu = (FooterMenu);

;// CONCATENATED MODULE: ./src/snippets/globals/layout/QuizBanner.jsx




function QuizBanner() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var settings = (0,dist.useSettings)();
    if (!(settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : (ref1 = ref.quizBanner) === null || ref1 === void 0 ? void 0 : ref1.sectionTitle) && !(settings === null || settings === void 0 ? void 0 : (ref2 = settings.footer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.quizBanner) === null || ref3 === void 0 ? void 0 : ref3.sectionDescription)) return null;
    var ref8 = settings === null || settings === void 0 ? void 0 : (ref4 = settings.footer) === null || ref4 === void 0 ? void 0 : ref4.quizBanner, sectionTitle = ref8.sectionTitle, fontSize = ref8.fontSize, sectionDescription = ref8.sectionDescription, cta = ref8.cta, textAlign = ref8.textAlign, textAlign_m = ref8.textAlign_m, lightText = ref8.lightText, bgColor = ref8.bgColor;
    var alignContainer = "";
    if (textAlign_m === "text-right") {
        alignContainer += "mr-0";
    } else if (textAlign_m === "text-left") {
        alignContainer += "ml-0";
    } else {
        alignContainer += "mx-auto";
    }
    if (textAlign === "md:text-right") {
        alignContainer += " md:flex-row-reverse md:gap-6 md:items-center md:mr-0";
    } else if (textAlign === "md:text-left") {
        alignContainer += " md:flex-row md:gap-6 md:items-center md:ml-0";
    } else {
        alignContainer += " md:mx-auto md:max-w-[55.5rem]";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "footer-quiz-banner",
        "data-comp": "footer-quiz-banner",
        className: bgColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "my-0 mx-auto flex w-full max-w-[496px] md:max-w-[1180px] items-center px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-9 lg:py-16 flex flex-col ".concat(lightText ? "text-grey-9" : "text-black", " ").concat(textAlign_m, " ").concat(textAlign, " ").concat(alignContainer),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "font-tiempos ".concat(fontSize, " mb-2"),
                                children: [
                                    " ",
                                    sectionTitle
                                ]
                            }),
                            sectionDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0",
                                dangerouslySetInnerHTML: {
                                    __html: (0,Helper/* newLineToBr */.td)(sectionDescription)
                                }
                            })
                        ]
                    }),
                    (cta === null || cta === void 0 ? void 0 : (ref5 = cta.link) === null || ref5 === void 0 ? void 0 : ref5.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(textAlign === "md:text-center" ? "mt-6" : "max-md:mt-6", " block"),
                        children: (cta === null || cta === void 0 ? void 0 : (ref6 = cta.link) === null || ref6 === void 0 ? void 0 : ref6.text) && (cta === null || cta === void 0 ? void 0 : (ref7 = cta.link) === null || ref7 === void 0 ? void 0 : ref7.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: cta.link.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "".concat(cta.style, " no-underline max-md:!min-w-[10rem] max-md:!py-1.5"),
                                target: cta.link.newTab ? "_blank" : null,
                                children: cta.link.text
                            })
                        })
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/snippets/globals/layout/Footer.jsx











function Footer() {
    var ref7, ref1, ref2, ref3, ref4, ref5, ref6;
    var settings = (0,dist.useSettings)();
    var router = (0,next_router.useRouter)();
    var hiddenPages = settings === null || settings === void 0 ? void 0 : (ref7 = settings.footer) === null || ref7 === void 0 ? void 0 : (ref1 = ref7.quizBanner) === null || ref1 === void 0 ? void 0 : ref1.bannerInvisibility;
    var bgColor = settings === null || settings === void 0 ? void 0 : (ref2 = settings.footer) === null || ref2 === void 0 ? void 0 : ref2.footerBgColor;
    var hideQuiz = (hiddenPages === null || hiddenPages === void 0 ? void 0 : hiddenPages.find(function(page) {
        var ref;
        return (page === null || page === void 0 ? void 0 : (ref = page.link) === null || ref === void 0 ? void 0 : ref.url) === router.asPath;
    })) ? true : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !hideQuiz && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                className: bgColor || "bg-black",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border-b border-white px-8 md:px-0 md:pb-6 pt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-0 mx-auto flex max-w-[1180px] flex-col justify-between md:flex-row md:pl-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block mt-0 pt-0 pb-4 pr-8 max-w-[90px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Monogram, {
                                            settings: settings
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex pt-4 md:pt-8 md:pb-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "footer-tagline md:h4 mb-0 font-tiempos text-h4-m !font-tiempos text-white md:mb-0",
                                                    role: "heading",
                                                    children: settings === null || settings === void 0 ? void 0 : (ref3 = settings.footer) === null || ref3 === void 0 ? void 0 : ref3.tagline
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col md:flex-row items-start justify-center md:mr-12 w-full md:justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_FooterMenu, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex items-start justify-center pb-6 md:w-auto md:py-0 md:py-8 md:pt-0 md:pr-8 lg:px-0 md:mr-8",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex md:w-full md:max-w-[432px] flex-col justify-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_EmailSignup, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            target: "blank",
                                                                            href: "https://www.instagram.com/briogeo/",
                                                                            className: "mr-6",
                                                                            "aria-label": "Instagram",
                                                                            "aria-hidden": true,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_WhiteInstagram, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            target: "blank",
                                                                            href: "https://www.facebook.com/Briogeo",
                                                                            className: "mr-6",
                                                                            "aria-label": "Facebook",
                                                                            "aria-hidden": true,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_WhiteFacebook, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            target: "blank",
                                                                            href: "https://www.tiktok.com/@briogeo?lang=en",
                                                                            "aria-label": "Tiktok",
                                                                            "aria-hidden": true,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_WhiteTikTok, {})
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-center py-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text-xsmall pr-2 pl-2 text-white",
                                            children: [
                                                "\xa9",
                                                new Date().getFullYear(),
                                                " Briogeo"
                                            ]
                                        }),
                                        (settings === null || settings === void 0 ? void 0 : (ref4 = settings.footer) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.footerSmallMenu) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "m-0 flex list-none p-0",
                                            children: settings === null || settings === void 0 ? void 0 : (ref6 = settings.footer) === null || ref6 === void 0 ? void 0 : ref6.footerSmallMenu.map(function(footerSmallMenuLink, footerSmallMenuLinkIndex) {
                                                var ref, ref8;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                    className: "mt-0 flex",
                                                    children: (footerSmallMenuLink === null || footerSmallMenuLink === void 0 ? void 0 : footerSmallMenuLink.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: footerSmallMenuLink === null || footerSmallMenuLink === void 0 ? void 0 : (ref = footerSmallMenuLink.link) === null || ref === void 0 ? void 0 : ref.url,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "text-xsmall pr-2 pl-2 text-white text-white no-underline hover:text-grey-7 hover:underline",
                                                            children: footerSmallMenuLink === null || footerSmallMenuLink === void 0 ? void 0 : (ref8 = footerSmallMenuLink.link) === null || ref8 === void 0 ? void 0 : ref8.text
                                                        })
                                                    })
                                                }, "menu-item-".concat(footerSmallMenuLinkIndex));
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_CountrySelector, {})
                        ]
                    })
                ]
            })
        ]
    });
}
function Monogram(param) {
    var settings = param.settings;
    var ref, ref9, ref10;
    return (settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.monogram) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "m-auto block no-underline",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: settings === null || settings === void 0 ? void 0 : (ref9 = settings.footer) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.monogram) === null || ref10 === void 0 ? void 0 : ref10.src,
                    className: "h-full w-full",
                    alt: "briogeohair footer monogram"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "visually-hidden",
                    children: "briogeohair footer monogram"
                })
            ]
        })
    });
}
/* harmony default export */ var layout_Footer = (Footer);

;// CONCATENATED MODULE: ./src/snippets/globals/layout/SkipLink.js

var SkipLink = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: "left-0 absolute -translate-x-full focus:translate-x-0 transition-transform duration-300 z-[10000] button button--primary inline-block",
        href: "#main-content",
        children: "Skip to content"
    });
};
/* harmony default export */ var layout_SkipLink = (SkipLink);

;// CONCATENATED MODULE: ./src/snippets/globals/RootStyles.jsx


function RootStyles() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42;
    var settings = (0,dist.useSettings)();
    var getButtonColor = function(buttonKey) {
        if ((settings === null || settings === void 0 ? void 0 : settings.themeColors) && settings.themeColors[buttonKey]) {
            var colorKey = settings.themeColors[buttonKey];
            return settings.themeColors[colorKey];
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
        children: "\n      :root {\n        --primary-1: ".concat((settings === null || settings === void 0 ? void 0 : (ref = settings.themeColors) === null || ref === void 0 ? void 0 : ref.primaryColor) || "#000000", ";\n        --primary-2: ").concat((settings === null || settings === void 0 ? void 0 : (ref1 = settings.themeColors) === null || ref1 === void 0 ? void 0 : ref1.primaryColorAlt) || "#E61A4F", ";\n        --secondary-1: ").concat((settings === null || settings === void 0 ? void 0 : (ref2 = settings.themeColors) === null || ref2 === void 0 ? void 0 : ref2.secondaryColor) || "#EB80A8", ";\n        --secondary-2: ").concat((settings === null || settings === void 0 ? void 0 : (ref3 = settings.themeColors) === null || ref3 === void 0 ? void 0 : ref3.secondaryColorAlt) || "#FF4713", ";\n        --tertiary-1: ").concat((settings === null || settings === void 0 ? void 0 : (ref4 = settings.themeColors) === null || ref4 === void 0 ? void 0 : ref4.tertiaryColor) || "#552E90", ";\n        --tertiary-2: ").concat((settings === null || settings === void 0 ? void 0 : (ref5 = settings.themeColors) === null || ref5 === void 0 ? void 0 : ref5.tertiaryColorAlt) || "#CEB4A8", ";\n        --quaternary-1: ").concat((settings === null || settings === void 0 ? void 0 : (ref6 = settings.themeColors) === null || ref6 === void 0 ? void 0 : ref6.quaternaryColor) || "#14A34A", ";\n        --quaternary-2: ").concat((settings === null || settings === void 0 ? void 0 : (ref7 = settings.themeColors) === null || ref7 === void 0 ? void 0 : ref7.quaternaryColorAlt) || "#00A19B", ";\n        --quinary-1: ").concat((settings === null || settings === void 0 ? void 0 : (ref8 = settings.themeColors) === null || ref8 === void 0 ? void 0 : ref8.quinaryColor) || "#5B9AC5", ";\n        --quinary-2: ").concat((settings === null || settings === void 0 ? void 0 : (ref9 = settings.themeColors) === null || ref9 === void 0 ? void 0 : ref9.quinaryColorAlt) || "#B8C5D6", ";\n        --quinary-2-alt: ").concat((settings === null || settings === void 0 ? void 0 : (ref10 = settings.themeColors) === null || ref10 === void 0 ? void 0 : ref10.quinaryColorTwoAlt) || "#5B7E96", ";\n        --senary-1: ").concat((settings === null || settings === void 0 ? void 0 : (ref11 = settings.themeColors) === null || ref11 === void 0 ? void 0 : ref11.senaryColor) || "#d0021b", ";\n        --senary-2: ").concat((settings === null || settings === void 0 ? void 0 : (ref12 = settings.themeColors) === null || ref12 === void 0 ? void 0 : ref12.senaryColorAlt) || "#218246", ";\n        --senary-3: ").concat((settings === null || settings === void 0 ? void 0 : (ref13 = settings.themeColors) === null || ref13 === void 0 ? void 0 : ref13.senaryColorThree) || "#9DD4CA", ";\n        --senary-4: ").concat((settings === null || settings === void 0 ? void 0 : (ref14 = settings.themeColors) === null || ref14 === void 0 ? void 0 : ref14.senaryColorFour) || "#936953", ";\n        --senary-5: ").concat((settings === null || settings === void 0 ? void 0 : (ref15 = settings.themeColors) === null || ref15 === void 0 ? void 0 : ref15.senaryColorFive) || "#57C1A5", ";\n        --stylers-1: ").concat((settings === null || settings === void 0 ? void 0 : (ref16 = settings.themeColors) === null || ref16 === void 0 ? void 0 : ref16.stylersColorOne) || "#00a7b5", ";\n        --stylers-2: ").concat((settings === null || settings === void 0 ? void 0 : (ref17 = settings.themeColors) === null || ref17 === void 0 ? void 0 : ref17.stylersColorTwo) || "#8094dd", ";\n        --stylers-3: ").concat((settings === null || settings === void 0 ? void 0 : (ref18 = settings.themeColors) === null || ref18 === void 0 ? void 0 : ref18.stylersColorThree) || "#ff585d", ";\n        --stylers-4: ").concat((settings === null || settings === void 0 ? void 0 : (ref19 = settings.themeColors) === null || ref19 === void 0 ? void 0 : ref19.stylersColorFour) || "#d74388", ";\n        --grey-1: ").concat((settings === null || settings === void 0 ? void 0 : (ref20 = settings.themeColors) === null || ref20 === void 0 ? void 0 : ref20.greyOne) || "#444444", ";\n        --grey-3: ").concat((settings === null || settings === void 0 ? void 0 : (ref21 = settings.themeColors) === null || ref21 === void 0 ? void 0 : ref21.greyThree) || "#757575", ";\n        --grey-4: ").concat((settings === null || settings === void 0 ? void 0 : (ref22 = settings.themeColors) === null || ref22 === void 0 ? void 0 : ref22.greyFour) || "#DFDFDF", ";\n        --grey-5: ").concat((settings === null || settings === void 0 ? void 0 : (ref23 = settings.themeColors) === null || ref23 === void 0 ? void 0 : ref23.greyFive) || "#979797", ";\n        --grey-7: ").concat((settings === null || settings === void 0 ? void 0 : (ref24 = settings.themeColors) === null || ref24 === void 0 ? void 0 : ref24.greySeven) || "#DFDFDF", ";\n        --grey-9: ").concat((settings === null || settings === void 0 ? void 0 : (ref25 = settings.themeColors) === null || ref25 === void 0 ? void 0 : ref25.greyNine) || "#F5F5F5", ";\n        --white: ").concat((settings === null || settings === void 0 ? void 0 : (ref26 = settings.themeColors) === null || ref26 === void 0 ? void 0 : ref26.white) || "#FFFFFF", ";\n        --black: ").concat((settings === null || settings === void 0 ? void 0 : (ref27 = settings.themeColors) === null || ref27 === void 0 ? void 0 : ref27.black) || "#000000", ";\n        --gray-black: ").concat((settings === null || settings === void 0 ? void 0 : (ref28 = settings.themeColors) === null || ref28 === void 0 ? void 0 : ref28.grayBlack) || "#444444", ";\n        --yellow: ").concat((settings === null || settings === void 0 ? void 0 : (ref29 = settings.themeColors) === null || ref29 === void 0 ? void 0 : ref29.yellow) || "#EDE757", ";\n        --light-blue: ").concat((settings === null || settings === void 0 ? void 0 : (ref30 = settings.themeColors) === null || ref30 === void 0 ? void 0 : ref30.lightBlue) || "#EDF0F5", ";\n        --scalp-blue: ").concat((settings === null || settings === void 0 ? void 0 : (ref31 = settings.themeColors) === null || ref31 === void 0 ? void 0 : ref31.scalpBlue) || "#597D95", ";\n        --magenta: ").concat((settings === null || settings === void 0 ? void 0 : (ref32 = settings.themeColors) === null || ref32 === void 0 ? void 0 : ref32.magenta) || "#c964cf", ";\n        --med-pink: ").concat((settings === null || settings === void 0 ? void 0 : (ref33 = settings.themeColors) === null || ref33 === void 0 ? void 0 : ref33.medPink) || "#FB83AD", ";\n        --brio-blue: ").concat((settings === null || settings === void 0 ? void 0 : (ref34 = settings.themeColors) === null || ref34 === void 0 ? void 0 : ref34.brioBlue) || "#BBE4FF", ";\n        --cloud: ").concat((settings === null || settings === void 0 ? void 0 : (ref35 = settings.themeColors) === null || ref35 === void 0 ? void 0 : ref35.cloud) || "#F1F7FE", ";\n        --mineral: ").concat((settings === null || settings === void 0 ? void 0 : (ref36 = settings.themeColors) === null || ref36 === void 0 ? void 0 : ref36.mineral) || "#AEBBD2", ";\n        --deep-sea: ").concat((settings === null || settings === void 0 ? void 0 : (ref37 = settings.themeColors) === null || ref37 === void 0 ? void 0 : ref37.deepSea) || "#858C9D", ";\n        --sandstone: ").concat((settings === null || settings === void 0 ? void 0 : (ref38 = settings.themeColors) === null || ref38 === void 0 ? void 0 : ref38.sandstone) || "#F8F6F1", ";\n        --sorrel: ").concat((settings === null || settings === void 0 ? void 0 : (ref39 = settings.themeColors) === null || ref39 === void 0 ? void 0 : ref39.sorrel) || "#F7D5BB", ";\n        --butter: ").concat((settings === null || settings === void 0 ? void 0 : (ref40 = settings.themeColors) === null || ref40 === void 0 ? void 0 : ref40.butter) || "#FCE8B3", ";\n        --rosehip: ").concat((settings === null || settings === void 0 ? void 0 : (ref41 = settings.themeColors) === null || ref41 === void 0 ? void 0 : ref41.rosehip) || "#AD2B30", ";\n        --chestnut: ").concat((settings === null || settings === void 0 ? void 0 : (ref42 = settings.themeColors) === null || ref42 === void 0 ? void 0 : ref42.chestnut) || "#7A3E39", ";\n\n        --button-primary-bg: ").concat(getButtonColor("buttonPrimaryBG") || "#000000", ";\n        --button-primary-bg-hover: ").concat(getButtonColor("buttonPrimaryBGHover") || "#757575", ";\n        --button-secondary-bg: ").concat(getButtonColor("buttonSecondaryBG") || "transparent", ";\n        --button-secondary-bg-hover: ").concat(getButtonColor("buttonSecondaryBGHover") || "#000000", ";\n        --button-outline-bg: ").concat(getButtonColor("buttonOutlineBG") || "#ffffff", ";\n        --button-outline-bg-hover: ").concat(getButtonColor("buttonOutlineBGHover") || "#000000", ";\n        --button-outline-dark-bg: ").concat(getButtonColor("buttonOutlineDarkBG") || "#000000", ";\n        --button-outline-dark-bg-hover: ").concat(getButtonColor("buttonOutlineDarkBGHover") || "#ffffff", ";\n        --button-atc: ").concat(getButtonColor("buttonATCBG") || "#000000", ";\n        --button-atc-hover: ").concat(getButtonColor("buttonATCHoverBG") || "#757575", ";\n        --button-checkout: ").concat(getButtonColor("buttonCheckoutBG") || "#E61A4F", ";\n        --button-checkout-hover: ").concat(getButtonColor("buttonCheckoutHoverBG") || "#EB80A8", ";\n\n        --error-state: #d0021b;\n        --success-state: #218246;\n        --ada-outline: #4D90FE;\n      }\n    ")
    });
}
/* harmony default export */ var globals_RootStyles = (RootStyles);

;// CONCATENATED MODULE: ./src/snippets/globals/layout/DiscountBanner.jsx




function DiscountBanner() {
    var ref7, ref1, ref2, ref3, ref4, ref5, ref6;
    var settings = (0,dist.useSettings)();
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var cart = (0,dist.useCart)();
    var overrides = settings === null || settings === void 0 ? void 0 : (ref7 = settings.discountBanner) === null || ref7 === void 0 ? void 0 : ref7.overrides;
    var rotateTimer = null;
    var stopTimer = function() {
        if (rotateTimer) clearInterval(rotateTimer);
    };
    var rotateMessage = function(step) {
        var ref10;
        var msgItems = document.querySelectorAll(".discount-banner-msg-item");
        var prevIdx = Array.from(msgItems).findIndex(function(e) {
            return e.classList.contains("active");
        });
        var nextIdx = (msgItems.length + (prevIdx + step) % msgItems.length) % msgItems.length;
        var prevItem = msgItems.item(prevIdx);
        var nextItem = msgItems.item(nextIdx);
        prevItem === null || prevItem === void 0 ? void 0 : (ref10 = prevItem.classList) === null || ref10 === void 0 ? void 0 : ref10.remove("active");
        setTimeout(function() {
            var ref, ref8, ref9;
            nextItem === null || nextItem === void 0 ? void 0 : (ref = nextItem.classList) === null || ref === void 0 ? void 0 : ref.add("active");
            prevItem === null || prevItem === void 0 ? void 0 : (ref8 = prevItem.classList) === null || ref8 === void 0 ? void 0 : ref8.add("hidden");
            nextItem === null || nextItem === void 0 ? void 0 : (ref9 = nextItem.classList) === null || ref9 === void 0 ? void 0 : ref9.remove("hidden");
        }, 150);
    };
    var startTimer = function() {
        stopTimer();
        rotateTimer = setInterval(function() {
            rotateMessage(1);
        }, 5000);
    };
    var rotatePrev = function() {
        stopTimer();
        rotateMessage(-1);
        setTimeout(startTimer, 5000);
    };
    var rotateNext = function() {
        stopTimer();
        rotateMessage(1);
        setTimeout(startTimer, 5000);
    };
    var applicableOverride = (0,Helper/* getApplicableOverride */.Nx)(cart, overrides);
    (0,react.useEffect)(function() {
        var ref, ref11;
        var autoRotate = countryCode === "US" ? settings === null || settings === void 0 ? void 0 : (ref = settings.discountBanner) === null || ref === void 0 ? void 0 : ref.toggleAutoRotate : settings === null || settings === void 0 ? void 0 : (ref11 = settings.discountBanner) === null || ref11 === void 0 ? void 0 : ref11.toggleAutoRotateInt;
        if (countryCode && autoRotate && !(applicableOverride === null || applicableOverride === void 0 ? void 0 : applicableOverride.length)) {
            startTimer();
        }
        return function() {
            return stopTimer();
        };
    }, [
        country,
        settings,
        applicableOverride
    ]);
    var bannerMessages = countryCode === "US" ? settings === null || settings === void 0 ? void 0 : (ref1 = settings.discountBanner) === null || ref1 === void 0 ? void 0 : ref1.messages : settings === null || settings === void 0 ? void 0 : (ref2 = settings.discountBanner) === null || ref2 === void 0 ? void 0 : ref2.messagesInt;
    if (applicableOverride === null || applicableOverride === void 0 ? void 0 : applicableOverride.length) {
        bannerMessages = applicableOverride;
    }
    var bgClass = countryCode === "US" ? settings === null || settings === void 0 ? void 0 : (ref3 = settings.discountBanner) === null || ref3 === void 0 ? void 0 : ref3.bgColor : settings === null || settings === void 0 ? void 0 : (ref4 = settings.discountBanner) === null || ref4 === void 0 ? void 0 : ref4.bgColorInt;
    var textClass = countryCode === "US" ? settings === null || settings === void 0 ? void 0 : (ref5 = settings.discountBanner) === null || ref5 === void 0 ? void 0 : ref5.textColor : settings === null || settings === void 0 ? void 0 : (ref6 = settings.discountBanner) === null || ref6 === void 0 ? void 0 : ref6.textColorInt;
    var messages = bannerMessages === null || bannerMessages === void 0 ? void 0 : bannerMessages.map(function(msg, idx) {
        var msgDesktop = msg.messageDesktop || msg.messageMobile;
        var msgMobile = msg.messageMobile || msg.messageDesktop;
        return {
            messageDesktop: msgDesktop,
            messageMobile: msgMobile
        };
    });
    return messages && messages.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-".concat(bgClass, " ").concat(textClass, " relative z-[2000] flex items-center justify-center px-3 py-[6px] md:py-[9px]"),
        children: [
            messages.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "mr-[6px] p-1",
                onClick: rotatePrev,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sr-only",
                        children: "Previous Promotion"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "5",
                        height: "8",
                        viewBox: "0 0 5 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M4 1L1 4L4 7",
                            stroke: "currentColor",
                            strokeLinecap: "square"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "discount-banner-msg-list w-full md:w-auto",
                children: messages.map(function(message, messageIdx) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "discount-banner-msg-item m-0 p-0 ".concat(messageIdx === 0 ? "active" : "hidden"),
                        children: [
                            (message === null || message === void 0 ? void 0 : message.messageDesktop) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden text-[14px] leading-[22px] md:block",
                                dangerouslySetInnerHTML: {
                                    __html: message.messageDesktop
                                }
                            }),
                            (message === null || message === void 0 ? void 0 : message.messageMobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "block text-center text-[12px] leading-normal md:hidden",
                                dangerouslySetInnerHTML: {
                                    __html: message.messageMobile
                                }
                            })
                        ]
                    }, "discount-banner-msg-".concat(messageIdx));
                })
            }),
            messages.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "ml-[6px] p-1",
                onClick: rotateNext,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sr-only",
                        children: "Next Promotion"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "5",
                        height: "8",
                        viewBox: "0 0 5 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M1 7L4 4L1 1",
                            stroke: "currentColor",
                            strokeLinecap: "square"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var layout_DiscountBanner = (DiscountBanner);

;// CONCATENATED MODULE: ./src/snippets/globals/layout/CountdownTimer.jsx
function CountdownTimer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || CountdownTimer_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function CountdownTimer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CountdownTimer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CountdownTimer_arrayLikeToArray(o, minLen);
}







function DateTimeDisplay(param) {
    var value = param.value, type = param.type, isDanger = param.isDanger, _className = param.className, className = _className === void 0 ? "" : _className, _timerLabelInline = param.timerLabelInline, timerLabelInline = _timerLabelInline === void 0 ? true : _timerLabelInline;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(isDanger ? "countdown danger" : "countdown", " flex items-center font-hafferBold ").concat(className),
        children: [
            value && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: value < 10 && value > 0 ? "0".concat(value) : Math.max(0, value)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "capitalize leading-none font-primary font-medium ".concat(timerLabelInline ? "max-md:hidden" : ""),
                children: type
            }),
            timerLabelInline ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "capitalize leading-none font-primary font-medium md:hidden",
                children: type === null || type === void 0 ? void 0 : type.substring(0, 1)
            }) : null
        ]
    });
}
function ExpiredNotice() {
    return null;
}
function ShowCountDown(props) {
    var days = props.days, hours = props.hours, minutes = props.minutes, seconds = props.seconds, backgroundColor = props.backgroundColor, clockColor = props.clockColor, _timerLabelInline = props.timerLabelInline, timerLabelInline = _timerLabelInline === void 0 ? true : _timerLabelInline, _className = props.className, className = _className === void 0 ? "" : _className;
    var ref = (0,react.useState)(null), second = ref[0], setSecond = ref[1];
    (0,react.useEffect)(function() {
        setSecond(seconds);
    }, [
        seconds
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "coundown-timer flex items-center gap-1.5 md:gap-2 font-bold font-primary text-xsmall md:text-small uppercase ".concat(className),
        style: {
            color: clockColor || "#000000"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                value: days,
                type: "Days",
                isDanger: days <= 3,
                className: timerLabelInline ? "gap-1" : "flex-col",
                timerLabelInline: timerLabelInline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center",
                children: ":"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                value: hours,
                type: "Hrs",
                isDanger: false,
                className: timerLabelInline ? "gap-1" : "flex-col",
                timerLabelInline: timerLabelInline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center",
                children: ":"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                value: minutes,
                type: "Min",
                isDanger: false,
                className: timerLabelInline ? "gap-1" : "flex-col",
                timerLabelInline: timerLabelInline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center",
                children: ":"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                value: second,
                type: "Sec",
                isDanger: false,
                className: timerLabelInline ? "gap-1" : "flex-col",
                timerLabelInline: timerLabelInline
            })
        ]
    });
}
function CountdownTimer(param) {
    var countdown = param.countdown;
    var ref, ref1, ref2;
    var settings = (0,dist.useSettings)();
    var pathname = (0,dist.useRouter)().pathname;
    var ref3 = (settings === null || settings === void 0 ? void 0 : settings.countdown) || {}, _enable = ref3.enable, enable = _enable === void 0 ? "global" : _enable, _enableExpired = ref3.enableExpired, enableExpired = _enableExpired === void 0 ? true : _enableExpired, layout = ref3.layout, backgroundColor = ref3.backgroundColor, clockColor = ref3.clockColor, _timerLabelInline = ref3.timerLabelInline, timerLabelInline = _timerLabelInline === void 0 ? true : _timerLabelInline, targetTime = ref3.targetTime, timezone = ref3.timezone, title = ref3.title;
    var cta = settings === null || settings === void 0 ? void 0 : (ref = settings.countdown) === null || ref === void 0 ? void 0 : ref.cta;
    var targetDate = targetTime;
    var targetDateZone = DateTime.fromFormat("".concat(targetDate, " ").concat(timezone || "America/Los_Angeles"), "yyyy-MM-dd TT z");
    var ref4 = _slicedToArray((0,hooks/* useCountdown */.au)(targetDateZone.toJSDate()), 4), days = ref4[0], hours = ref4[1], minutes = ref4[2], seconds = ref4[3];
    var buttonEnable = (cta === null || cta === void 0 ? void 0 : (ref1 = cta.link) === null || ref1 === void 0 ? void 0 : ref1.url) && (cta === null || cta === void 0 ? void 0 : (ref2 = cta.link) === null || ref2 === void 0 ? void 0 : ref2.text);
    var ctaPosition = cta === null || cta === void 0 ? void 0 : cta.ctaPosition;
    var layoutClass = (0,react.useMemo)(function() {
        var className = "";
        if (buttonEnable) {
            if (layout === "center") {
                className += "grid max-md:grid-rows-none max-md:grid-cols-[1fr_min-content] md:flex";
            } else {
                className += "grid max-md:grid-rows-none grid-cols-[1fr_min-content] md:grid-cols-[1fr_max-content_1fr]";
                if (ctaPosition !== "right") {
                    className += " md:flex";
                }
            }
        }
        if (layout === "center") {
            className += " flex flex-col md:flex-row justify-center";
        } else {
            className += " flex justify-between";
        }
        return className;
    }, [
        layout,
        buttonEnable,
        ctaPosition
    ]);
    var countDownClass = (0,react.useMemo)(function() {
        if (layout !== "center") {
            if (!buttonEnable) {
                return "md:ml-auto";
            }
            return ctaPosition === "right" ? "md:mx-auto" : "md:ml-auto";
        }
        return "";
    }, [
        ctaPosition,
        layout,
        buttonEnable
    ]);
    var countdownEnable = (0,react.useMemo)(function() {
        if (enable === "global") return true;
        if (enable === "homepage" && pathname === "/") {
            return true;
        }
        return false;
    }, [
        enable,
        pathname
    ]);
    if (!countdownEnable || !targetDateZone.isValid) return null;
    if (days + hours + minutes + seconds <= 0 && !enableExpired) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredNotice, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "countdown-timer items-center gap-x-6 gap-y-0 w-full px-4 md:px-12 py-2 ".concat(layoutClass),
        style: {
            backgroundColor: backgroundColor || "#EDF0F5",
            color: clockColor || "#000000"
        },
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "countdown__title mb-0 font-primary text-xsmall md:text-small max-md:row-start-1 [&>:first-child]:mt-0 [&>:last-child]:mb-0",
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }) : null,
            ctaPosition !== "right" && buttonEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-md:row-start-1 max-md:row-end-3 max-md:col-start-2 countdown__cta flex items-center ".concat(layout !== "center" && ctaPosition === "right" ? "md:ml-auto" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: cta.link.url,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "".concat((cta === null || cta === void 0 ? void 0 : cta.style) || "focus-link", " ").concat((cta === null || cta === void 0 ? void 0 : cta.style) !== "focus-link" ? "!py-2 !min-w-0" : "", " text-xsmall md:text-small font-normal whitespace-nowrap no-underline"),
                        children: cta.link.text
                    })
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowCountDown, {
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds,
                clockColor: clockColor,
                timerLabelInline: timerLabelInline,
                className: "max-md:row-start-2 ".concat(countDownClass)
            }),
            ctaPosition === "right" && buttonEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-md:row-start-1 max-md:row-end-3 max-md:col-start-2 countdown__cta flex items-center ".concat(layout !== "center" && ctaPosition === "right" ? "md:ml-auto" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: cta.link.url,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "".concat((cta === null || cta === void 0 ? void 0 : cta.style) || "focus-link", " ").concat((cta === null || cta === void 0 ? void 0 : cta.style) !== "focus-link" ? "!py-2 !min-w-0" : "", " text-xsmall md:text-small font-normal whitespace-nowrap no-underline"),
                        children: cta.link.text
                    })
                })
            }) : null
        ]
    });
}
/* harmony default export */ var layout_CountdownTimer = (CountdownTimer);

;// CONCATENATED MODULE: ../node_modules/nanoid/index.browser.js

let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  let step = -~((1.6 * mask * defaultSize) / alphabet.length)
  return (size = defaultSize) => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      let j = step
      while (j--) {
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}
let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random)
let nanoid = (size = 21) =>
  crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
    byte &= 63
    if (byte < 36) {
      id += byte.toString(36)
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte > 62) {
      id += '-'
    } else {
      id += '_'
    }
    return id
  }, '')


;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/hooks/useDataLayerAccount.js
function useDataLayerAccount_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useDataLayerAccount_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useDataLayerAccount_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useDataLayerAccount_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




function useDataLayerAccount(param1) {
    var baseEcommerce = param1.baseEcommerce, DEBUG = param1.DEBUG, generateUserProperties = param1.generateUserProperties, userDataEvent = param1.userDataEvent, userDataEventTriggered = param1.userDataEventTriggered;
    var customer = (0,dist.useCustomer)();
    var accessToken = dist.store.recoil.useRecoilValue(dist.store.state.accessToken);
    var ref = (0,react.useState)(false), loggedIn = ref[0], setLoggedIn = ref[1];
    var ref1 = (0,react.useState)(false), registered = ref1[0], setRegistered = ref1[1];
    var loggedInEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, userProperties = param.userProperties;
        var event = {
            event: "dl_login",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: userProperties,
            ecommerce: ecommerce
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
        setLoggedIn(false);
    }, []);
    var registeredEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, userProperties = param.userProperties;
        var event = {
            event: "dl_sign_up",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: userProperties,
            ecommerce: ecommerce
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
        setRegistered(false);
    }, []);
    var getUserPropertiesAndTriggerLoggedInEvents = (0,react.useCallback)(function() {
        var _ref = useDataLayerAccount_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var _customer, ecommerce, _accessToken, userProperties;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _customer = param.customer, ecommerce = param.ecommerce, _accessToken = param.accessToken;
                        _ctx.next = 3;
                        return generateUserProperties({
                            customer: _customer,
                            accessToken: _accessToken.token
                        });
                    case 3:
                        userProperties = _ctx.sent;
                        loggedInEvent({
                            ecommerce: ecommerce,
                            userProperties: userProperties
                        });
                        setTimeout(function() {
                            userDataEvent({
                                ecommerce: ecommerce,
                                userProperties: userProperties
                            });
                        }, 1000);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var getUserPropertiesAndTriggerRegisterEvents = (0,react.useCallback)(function() {
        var _ref = useDataLayerAccount_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var _customer, ecommerce, _accessToken, userProperties;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _customer = param.customer, ecommerce = param.ecommerce, _accessToken = param.accessToken;
                        _ctx.next = 3;
                        return generateUserProperties({
                            customer: _customer,
                            accessToken: _accessToken.token
                        });
                    case 3:
                        userProperties = _ctx.sent;
                        registeredEvent({
                            ecommerce: ecommerce,
                            userProperties: userProperties
                        });
                        setTimeout(function() {
                            userDataEvent({
                                ecommerce: ecommerce,
                                userProperties: userProperties
                            });
                        }, 1000);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        var customerLoggedIn = PubSub.subscribe("CUSTOMER_LOGGED_IN", useDataLayerAccount_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoggedIn(true);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })));
        var customerRegistered = PubSub.subscribe("CUSTOMER_REGISTERED", useDataLayerAccount_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setRegistered(true);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })));
        return function() {
            if (customerLoggedIn) {
                PubSub.unsubscribe(customerLoggedIn);
            }
            if (customerRegistered) {
                PubSub.unsubscribe(customerRegistered);
            }
        };
    }, []);
    // Generate new base data after customer login and customer profile is ready
    // Trigger 'dl_user_data' and 'login' events
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !customer || !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.token) || !loggedIn || !userDataEventTriggered) return;
        getUserPropertiesAndTriggerLoggedInEvents({
            accessToken: accessToken,
            customer: customer,
            ecommerce: baseEcommerce
        });
    }, [
        accessToken === null || accessToken === void 0 ? void 0 : accessToken.token,
        !!baseEcommerce,
        !!customer,
        loggedIn,
        userDataEventTriggered, 
    ]);
    // Generate new base data after customer register and customer profile is ready
    // Trigger 'dl_user_data' and 'dl_sign_up' events
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !customer || !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.token) || !registered || !userDataEventTriggered) return;
        getUserPropertiesAndTriggerRegisterEvents({
            accessToken: accessToken,
            customer: customer,
            ecommerce: baseEcommerce
        });
    }, [
        accessToken === null || accessToken === void 0 ? void 0 : accessToken.token,
        !!baseEcommerce,
        !!customer,
        registered,
        userDataEventTriggered, 
    ]);
}

// EXTERNAL MODULE: ../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(66471);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/hooks/utils.js
function utils_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function utils_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                utils_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                utils_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function utils_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function utils_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            utils_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var brand = "Briogeo" || 0;
var mapProductItemProduct = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(product) {
        var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        try {
            var ref, ref1, ref2, ref3;
            if (!product) return null;
            var firstVariant = (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
            return {
                sku: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku) || "",
                name: product.title || "",
                brand: product.vendor || brand,
                category: product.productType || "",
                variant: ((firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.title) === "Default Title" ? product.title : (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.title) || product.title) || "",
                price: "".concat((firstVariant === null || firstVariant === void 0 ? void 0 : (ref1 = firstVariant.priceV2) === null || ref1 === void 0 ? void 0 : ref1.amount) || ""),
                list: list,
                product_id: product.legacyResourceId || "",
                variant_id: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.legacyResourceId) || "",
                compare_at_price: "".concat((firstVariant === null || firstVariant === void 0 ? void 0 : (ref2 = firstVariant.compareAtPriceV2) === null || ref2 === void 0 ? void 0 : ref2.amount) || ""),
                image: ((ref3 = product.featuredImage) === null || ref3 === void 0 ? void 0 : ref3.src) || "",
                collections: product.collections || [],
                tags: product.tags || [],
                position: index + 1,
                url: "/products/".concat(product.handle)
            };
        } catch (error) {
            console.error("DataLayer:mapProductItemProduct error", error.message);
            console.error("DataLayer:mapProductItemProduct product", product);
            return null;
        }
    };
};
var mapProductItemVariant = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(variant) {
        var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        try {
            var ref, ref4, ref5;
            if (!variant) return null;
            var _index;
            return {
                sku: variant.sku || "",
                name: variant.product.title || "",
                brand: variant.product.vendor || brand,
                category: variant.product.productType || "",
                variant: (variant.title === "Default Title" ? variant.product.title : variant.title || variant.product.title) || "",
                price: "".concat(((ref = variant.priceV2) === null || ref === void 0 ? void 0 : ref.amount) || ""),
                list: list,
                product_id: variant.product.legacyResourceId || "",
                variant_id: variant.legacyResourceId || "",
                compare_at_price: "".concat(((ref4 = variant.compareAtPriceV2) === null || ref4 === void 0 ? void 0 : ref4.amount) || ""),
                image: ((ref5 = variant.image) === null || ref5 === void 0 ? void 0 : ref5.src) || "",
                collections: variant.product.collections || [],
                tags: variant.product.tags || [],
                position: ((_index = variant.index) !== null && _index !== void 0 ? _index : index) + 1,
                url: "/products/".concat(variant.product.handle)
            };
        } catch (error) {
            console.error("DataLayer:mapProductItemVariant error", error.message);
            console.error("DataLayer:mapProductItemVariant variant", variant);
            return null;
        }
    };
};
var mapProductPageVariant = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(variant) {
        try {
            var ref, ref6, ref7, ref8;
            if (!variant) return null;
            return {
                sku: variant.sku || "",
                name: variant.product.title || "",
                brand: variant.product.vendor || brand,
                category: variant.product.productType || "",
                variant: (variant.title === "Default Title" ? variant.product.title : variant.title || variant.product.title) || "",
                price: "".concat(((ref = variant.priceV2) === null || ref === void 0 ? void 0 : ref.amount) || ""),
                list: list,
                product_id: ((ref6 = variant.product.id) === null || ref6 === void 0 ? void 0 : ref6.split("/").pop()) || "",
                variant_id: variant.legacyResourceId || "",
                compare_at_price: "".concat(((ref7 = variant.compareAtPriceV2) === null || ref7 === void 0 ? void 0 : ref7.amount) || ""),
                image: ((ref8 = variant.image) === null || ref8 === void 0 ? void 0 : ref8.src) || "",
                collections: variant.product.collections || [],
                tags: variant.product.tags || [],
                url: "/products/".concat(variant.product.handle, "?variant=").concat(variant.legacyResourceId)
            };
        } catch (error) {
            console.error("DataLayer:mapProductPageVariant error", error.message);
            console.error("DataLayer:mapProductPageVariant variant", variant);
            return null;
        }
    };
};
var decodedId = function(id) {
    try {
        if (!id) return undefined;
        return window.atob(id);
    } catch (error) {
        return id;
    }
};
var mapLineItem = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(item) {
        var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        try {
            var ref, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
            var ref21 = utils_objectSpread({}, item), quantity = ref21.quantity, variant = ref21.variant;
            if (!variant) return null;
            return {
                sku: variant.sku || "",
                name: ((ref = variant.product) === null || ref === void 0 ? void 0 : ref.title) || "",
                brand: brand,
                category: ((ref9 = variant.product) === null || ref9 === void 0 ? void 0 : ref9.productType) || "",
                variant: (variant.title === "Default Title" ? (ref10 = variant.product) === null || ref10 === void 0 ? void 0 : ref10.title : variant.title || ((ref11 = variant.product) === null || ref11 === void 0 ? void 0 : ref11.title)) || "",
                price: "".concat(((ref12 = variant.priceV2) === null || ref12 === void 0 ? void 0 : ref12.amount) || ""),
                quantity: "".concat(quantity || ""),
                list: list,
                product_id: ((ref14 = decodedId((ref13 = variant.product) === null || ref13 === void 0 ? void 0 : ref13.id)) === null || ref14 === void 0 ? void 0 : ref14.split("/").pop()) || "",
                variant_id: ((ref15 = decodedId(variant.id)) === null || ref15 === void 0 ? void 0 : ref15.split("/").pop()) || "",
                compare_at_price: "".concat(((ref16 = variant.compareAtPriceV2) === null || ref16 === void 0 ? void 0 : ref16.amount) || ""),
                image: ((ref17 = variant.image) === null || ref17 === void 0 ? void 0 : ref17.src) || "",
                collections: ((ref18 = variant.product) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.collections) === null || ref19 === void 0 ? void 0 : ref19.nodes) || [],
                tags: ((ref20 = variant.product) === null || ref20 === void 0 ? void 0 : ref20.tags) || [],
                position: (item.index || index) + 1,
                url: "/products/".concat(variant.product.handle, "?variant=").concat(variant.id.split("/").pop())
            };
        } catch (error) {
            console.error("DataLayer:mapLineItem error", error.message);
            console.error("DataLayer:mapLineItem item", item);
            return null;
        }
    };
};
var fetchCustomerOrders = function() {
    var _ref = utils_asyncToGenerator(runtime_default().mark(function _callee(param) {
        var accessToken, url, request, data, ok, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    accessToken = param.accessToken;
                    _ctx.prev = 1;
                    if (accessToken) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 4:
                    url = "/api/customer/orders";
                    _ctx.next = 7;
                    return fetch(url, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            first: 100,
                            country: "US",
                            accessToken: accessToken
                        })
                    });
                case 7:
                    request = _ctx.sent;
                    if (request === null || request === void 0 ? void 0 : request.ok) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 10:
                    _ctx.next = 12;
                    return request.json();
                case 12:
                    data = _ctx.sent;
                    ok = data.ok, response = data.response;
                    if (ok) {
                        _ctx.next = 16;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 16:
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : response.orders);
                case 19:
                    _ctx.prev = 19;
                    _ctx.t0 = _ctx["catch"](1);
                    console.error("DataLayer:fetchCustomerOrders error", _ctx.t0.message);
                    return _ctx.abrupt("return", null);
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                19
            ]
        ]);
    }));
    return function fetchCustomerOrders(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/hooks/useDataLayerCart.js
function useDataLayerCart_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useDataLayerCart_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useDataLayerCart_arrayLikeToArray(arr);
}
function useDataLayerCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useDataLayerCart_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useDataLayerCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useDataLayerCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useDataLayerCart_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useDataLayerCart_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useDataLayerCart_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useDataLayerCart_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useDataLayerCart_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useDataLayerCart_toConsumableArray(arr) {
    return useDataLayerCart_arrayWithoutHoles(arr) || useDataLayerCart_iterableToArray(arr) || useDataLayerCart_unsupportedIterableToArray(arr) || useDataLayerCart_nonIterableSpread();
}
function useDataLayerCart_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useDataLayerCart_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useDataLayerCart_arrayLikeToArray(o, minLen);
}







function useDataLayerCart(param1) {
    var baseEcommerce = param1.baseEcommerce, DEBUG = param1.DEBUG, userDataEvent = param1.userDataEvent, userDataEventTriggered = param1.userDataEventTriggered, userProperties = param1.userProperties;
    var asPathRef = (0,react.useRef)(null);
    var cart = (0,dist.useCart)();
    var cartCount = (0,dist.useCartCount)();
    var cartItems = (0,dist.useCartItems)();
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var ref7 = (0,react.useState)(null), previousCartCount = ref7[0], setPreviousCartCount = ref7[1];
    var ref1 = (0,react.useState)(null), previousCartItems = ref1[0], setPreviousCartItems = ref1[1];
    var ref2 = (0,react.useState)(null), previousCartItemsMap = ref2[0], setPreviousCartItemsMap = ref2[1];
    var ref3 = (0,react.useState)(false), cartOpen = ref3[0], setCartOpen = ref3[1];
    var addToCartEvent = (0,react.useCallback)(function(param) {
        var _cart = param.cart, ecommerce = param.ecommerce, lineItems = param.lineItems, _userProperties = param.userProperties;
        var ref, ref4, ref5, ref6;
        if (!(lineItems === null || lineItems === void 0 ? void 0 : lineItems.length)) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_add_to_cart",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: useDataLayerCart_objectSpread({}, ecommerce, {
                cart_id: (ref = _cart.id) === null || ref === void 0 ? void 0 : ref.split("/").pop(),
                cart_total: (ref4 = _cart.estimatedCost) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.totalAmount) === null || ref5 === void 0 ? void 0 : ref5.amount,
                cart_count: ((ref6 = _cart.lines) === null || ref6 === void 0 ? void 0 : ref6.reduce(function(acc, line) {
                    return acc + line.quantity;
                }, 0)) || 0,
                add: {
                    actionField: {
                        list: list
                    },
                    products: lineItems.slice(0, 12).map(mapLineItem(list))
                }
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, []);
    var removeFromCartEvent = (0,react.useCallback)(function(param) {
        var _cart = param.cart, ecommerce = param.ecommerce, lineItems = param.lineItems, _userProperties = param.userProperties;
        var ref, ref8, ref9, ref10;
        if (!(lineItems === null || lineItems === void 0 ? void 0 : lineItems.length)) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_remove_from_cart",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: useDataLayerCart_objectSpread({}, ecommerce, {
                cart_id: (ref = _cart.id) === null || ref === void 0 ? void 0 : ref.split("/").pop(),
                cart_total: (ref8 = _cart.estimatedCost) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.totalAmount) === null || ref9 === void 0 ? void 0 : ref9.amount,
                cart_count: ((ref10 = _cart.lines) === null || ref10 === void 0 ? void 0 : ref10.reduce(function(acc, line) {
                    return acc + line.quantity;
                }, 0)) || 0,
                remove: {
                    actionField: {
                        list: list
                    },
                    products: lineItems.map(mapLineItem(list))
                }
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, []);
    var viewCartEvent = (0,react.useCallback)(function(param) {
        var _cart = param.cart, ecommerce = param.ecommerce, _userProperties = param.userProperties;
        var ref, ref11, ref12, ref13, ref14;
        if (!_cart) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_view_cart",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: useDataLayerCart_objectSpread({}, ecommerce, {
                actionField: {
                    list: "cart"
                },
                cart_id: (ref = _cart.id) === null || ref === void 0 ? void 0 : ref.split("/").pop(),
                cart_total: (ref11 = _cart.estimatedCost) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.totalAmount) === null || ref12 === void 0 ? void 0 : ref12.amount,
                cart_count: ((ref13 = _cart.lines) === null || ref13 === void 0 ? void 0 : ref13.reduce(function(acc, line) {
                    return acc + line.quantity;
                }, 0)) || 0,
                products: ((ref14 = _cart.lines) === null || ref14 === void 0 ? void 0 : ref14.map(mapLineItem(list))) || []
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, []);
    (0,react.useEffect)(function() {
        var viewSidecart = PubSub.subscribe("VIEW_SIDECART", function() {
            var _ref = useDataLayerCart_asyncToGenerator(runtime_default().mark(function _callee(event, isOpen) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setCartOpen(isOpen);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, isOpen) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (viewSidecart) {
                PubSub.unsubscribe(viewSidecart);
            }
        };
    }, []);
    // Trigger 'dl_view_cart' event on cart page
    (0,react.useEffect)(function() {
        if (!asPath.startsWith("/cart") || !cart || !baseEcommerce || !userProperties || asPath === asPathRef.current) return undefined;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewCartEvent({
            cart: cart,
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!cart,
        !!baseEcommerce,
        !!userProperties
    ]);
    // Trigger 'dl_view_cart' event when cart is opened
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !cartOpen || !userDataEventTriggered) return;
        viewCartEvent({
            cart: cart,
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
    }, [
        !!baseEcommerce,
        cartOpen,
        userDataEventTriggered
    ]);
    // Determine if a cart item was added, removed, or updated for events
    (0,react.useEffect)(function() {
        if (!cart || !baseEcommerce || !userDataEventTriggered) return;
        var cartItemsMap = cartItems.reduce(function(acc, line) {
            if (!line.variant) return acc;
            var variantId = line.variant.id;
            if (!acc[variantId]) {
                return useDataLayerCart_objectSpread({}, acc, useDataLayerCart_defineProperty({}, variantId, [
                    line
                ]));
            }
            return useDataLayerCart_objectSpread({}, acc, useDataLayerCart_defineProperty({}, variantId, useDataLayerCart_toConsumableArray(acc[variantId]).concat([
                line
            ])));
        }, {});
        if (!previousCartItems || previousCartCount === cartCount) {
            setPreviousCartItems(cartItems);
            setPreviousCartCount(cartCount);
            setPreviousCartItemsMap(cartItemsMap);
            return;
        }
        var isAddedItems = [];
        var isIncreasedItems = [];
        var isRemovedItems = [];
        var isDecreasedItems = [];
        if (cartCount > previousCartCount) {
            cartItems.forEach(function(line, index) {
                var ref19, ref15;
                var variantId = (ref19 = line.variant) === null || ref19 === void 0 ? void 0 : ref19.id;
                if (!variantId) return;
                var previousLine = (ref15 = previousCartItemsMap[variantId]) === null || ref15 === void 0 ? void 0 : ref15.find(function(prevLine) {
                    var ref, ref16, ref17, ref18;
                    var hasSameSellingPlanSelection = !prevLine.sellingPlanAllocation && !line.sellingPlanAllocation || ((ref = prevLine.sellingPlanAllocation) === null || ref === void 0 ? void 0 : (ref16 = ref.sellingPlan) === null || ref16 === void 0 ? void 0 : ref16.id) === ((ref17 = line.sellingPlanAllocation) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.sellingPlan) === null || ref18 === void 0 ? void 0 : ref18.id);
                    return hasSameSellingPlanSelection && fast_deep_equal_default()(prevLine.attributes.filter(function(attr) {
                        return attr.key !== "_addedAt";
                    }), line.attributes.filter(function(attr) {
                        return attr.key !== "_addedAt";
                    }));
                });
                if (!previousLine) {
                    isAddedItems.push(useDataLayerCart_objectSpread({}, line, {
                        index: index
                    }));
                    return;
                }
                if (line.quantity > previousLine.quantity) {
                    isIncreasedItems.push(useDataLayerCart_objectSpread({}, line, {
                        quantity: line.quantity - previousLine.quantity,
                        index: index
                    }));
                }
            });
        } else if (cartCount < previousCartCount) {
            previousCartItems.forEach(function(prevLine, index) {
                var ref24, ref20;
                var variantId = (ref24 = prevLine.variant) === null || ref24 === void 0 ? void 0 : ref24.id;
                if (!variantId) return;
                var currentLine = (ref20 = cartItemsMap[variantId]) === null || ref20 === void 0 ? void 0 : ref20.find(function(line) {
                    var ref, ref21, ref22, ref23;
                    var hasSameSellingPlanSelection = !prevLine.sellingPlanAllocation && !line.sellingPlanAllocation || ((ref = prevLine.sellingPlanAllocation) === null || ref === void 0 ? void 0 : (ref21 = ref.sellingPlan) === null || ref21 === void 0 ? void 0 : ref21.id) === ((ref22 = line.sellingPlanAllocation) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.sellingPlan) === null || ref23 === void 0 ? void 0 : ref23.id);
                    return hasSameSellingPlanSelection && fast_deep_equal_default()(prevLine.attributes.filter(function(attr) {
                        return attr.key !== "_addedAt";
                    }), line.attributes.filter(function(attr) {
                        return attr.key !== "_addedAt";
                    }));
                });
                if (!currentLine) {
                    isRemovedItems.push(useDataLayerCart_objectSpread({}, prevLine, {
                        index: index
                    }));
                    return;
                }
                if (currentLine.quantity < prevLine.quantity) {
                    isDecreasedItems.push(useDataLayerCart_objectSpread({}, prevLine, {
                        quantity: prevLine.quantity - currentLine.quantity,
                        index: index
                    }));
                }
            });
        }
        if (isAddedItems.length || isIncreasedItems.length) {
            useDataLayerCart_toConsumableArray(isAddedItems).concat(useDataLayerCart_toConsumableArray(isIncreasedItems)).forEach(function(line) {
                addToCartEvent({
                    cart: cart,
                    ecommerce: baseEcommerce,
                    lineItems: [
                        line
                    ],
                    userProperties: userProperties
                });
            });
        }
        if (isRemovedItems.length || isDecreasedItems.length) {
            removeFromCartEvent({
                cart: cart,
                ecommerce: baseEcommerce,
                lineItems: useDataLayerCart_toConsumableArray(isRemovedItems).concat(useDataLayerCart_toConsumableArray(isDecreasedItems)),
                userProperties: userProperties
            });
        }
        setPreviousCartItems(cartItems);
        setPreviousCartCount(cartCount);
        setPreviousCartItemsMap(cartItemsMap);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/hooks/useDataLayerCollection.js
function useDataLayerCollection_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useDataLayerCollection_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useDataLayerCollection_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useDataLayerCollection_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useDataLayerCollection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useDataLayerCollection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useDataLayerCollection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function useDataLayerCollection(param1) {
    var baseEcommerce = param1.baseEcommerce, DEBUG = param1.DEBUG, isPageAsCollection = param1.isPageAsCollection, userDataEvent = param1.userDataEvent, userDataEventTriggered = param1.userDataEventTriggered, userProperties = param1.userProperties;
    var collectionHandleRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), collectionProducts = ref[0], setCollectionProducts = ref[1];
    var ref1 = (0,react.useState)(null), collectionId = ref1[0], setCollectionId = ref1[1];
    var ref2 = (0,react.useState)(null), clickedCollectionItem = ref2[0], setClickedCollectionItem = ref2[1];
    var ref3 = (0,react.useState)(null), clickedBundleItemVariants = ref3[0], setClickedBundleItemVariants = ref3[1];
    var viewCollectionEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, products = param.products, _userProperties = param.userProperties;
        if (!(products === null || products === void 0 ? void 0 : products.length)) return;
        var list = window.location.pathname.startsWith("/collections") ? window.location.pathname : "";
        var event = {
            event: "dl_view_item_list",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: useDataLayerCollection_objectSpread({}, ecommerce, {
                products: products.slice(0, 12).map(mapProductItemProduct(list))
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, []);
    var clickCollectionItemEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, variant = param.variant;
        if (!variant) return;
        var list = variant.list || "";
        var event = {
            event: "dl_select_item",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: userProperties,
            ecommerce: useDataLayerCollection_objectSpread({}, ecommerce, {
                click: {
                    actionField: {
                        list: window.location.pathname.startsWith("/collection") ? window.location.pathname : "",
                        action: "click"
                    },
                    products: [
                        variant
                    ].map(mapProductItemVariant(list))
                }
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, [
        isPageAsCollection,
        userProperties
    ]);
    var clickBundleItemEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, variants = param.variants;
        if (!(variants === null || variants === void 0 ? void 0 : variants.length)) return;
        var list = variants[0].list || "";
        var event = {
            event: "dl_select_item",
            user_properties: userProperties,
            ecommerce: useDataLayerCollection_objectSpread({}, ecommerce, {
                click: {
                    actionField: {
                        list: window.location.pathname.startsWith("/collection") || isPageAsCollection ? window.location.pathname : "",
                        action: "click"
                    },
                    products: variants.map(mapProductItemVariant(list))
                }
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, [
        isPageAsCollection,
        userProperties
    ]);
    // Subscribe to PubSub topic for 'dl_view_item_list' and 'dl_select_item' events
    (0,react.useEffect)(function() {
        var viewCollection = PubSub.subscribe("VIEW_COLLECTION_PAGE", function() {
            var _ref = useDataLayerCollection_asyncToGenerator(runtime_default().mark(function _callee(event, param) {
                var products, id;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            products = param.products, id = param.id;
                            setCollectionProducts(products);
                            setCollectionId(id);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, _) {
                return _ref.apply(this, arguments);
            };
        }());
        var clickCollectionItem = PubSub.subscribe("CLICK_COLLECTION_ITEM", function() {
            var _ref = useDataLayerCollection_asyncToGenerator(runtime_default().mark(function _callee(event, variant) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setClickedCollectionItem(variant);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, variant) {
                return _ref.apply(this, arguments);
            };
        }());
        var clickBundleItem = PubSub.subscribe("CLICK_BUNDLE_ITEM", function() {
            var _ref = useDataLayerCollection_asyncToGenerator(runtime_default().mark(function _callee(event, variants) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setClickedBundleItemVariants(variants);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, variants) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (viewCollection) {
                PubSub.unsubscribe(viewCollection);
            }
            if (clickCollectionItem) {
                PubSub.unsubscribe(clickCollectionItem);
            }
            if (clickBundleItem) {
                PubSub.unsubscribe(clickBundleItem);
            }
        };
    }, []);
    // Trigger 'dl_user_data' and view 'dl_view_item_list'
    // events on collection page and after base data is ready
    (0,react.useEffect)(function() {
        var pageHandle = window.location.pathname.startsWith("/pages") ? "/pages/".concat(window.location.pathname.split("/").pop()) : window.location.pathname.split("/").pop();
        if (!collectionId || !(collectionProducts === null || collectionProducts === void 0 ? void 0 : collectionProducts.length) || !baseEcommerce || !userProperties || collectionHandleRef.current === pageHandle) return;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewCollectionEvent({
            ecommerce: useDataLayerCollection_objectSpread({}, baseEcommerce, {
                collection_id: collectionId
            }),
            products: collectionProducts,
            userProperties: userProperties
        });
        collectionHandleRef.current = pageHandle;
    }, [
        collectionId,
        collectionProducts,
        !!baseEcommerce,
        !!userProperties
    ]);
    // Trigger 'dl_select_item' event on clicked collection
    // item and after user event
    (0,react.useEffect)(function() {
        if (!clickedCollectionItem || !baseEcommerce || !userDataEventTriggered) return;
        clickCollectionItemEvent({
            ecommerce: baseEcommerce,
            variant: clickedCollectionItem
        });
    }, [
        clickedCollectionItem,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
    // Trigger 'dl_select_item' event on clicked collection
    // item and after user event
    (0,react.useEffect)(function() {
        if (!(clickedBundleItemVariants === null || clickedBundleItemVariants === void 0 ? void 0 : clickedBundleItemVariants.length) || !baseEcommerce || !userDataEventTriggered) return;
        clickBundleItemEvent({
            ecommerce: baseEcommerce,
            variants: clickedBundleItemVariants
        });
    }, [
        clickedBundleItemVariants,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/hooks/useDataLayerCustomer.js
function useDataLayerCustomer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useDataLayerCustomer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useDataLayerCustomer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var IGNORED_PATHS = [
    "account",
    "cart",
    "collections",
    "products"
];
var LOGGED_OUT_ACCOUNT_PATHS = [
    "/account/login",
    "/account/register",
    "/account/reset",
    "/account/activate", 
];
function useDataLayerCustomer(param1) {
    var baseEcommerce = param1.baseEcommerce, DEBUG = param1.DEBUG, isPageAsProduct = param1.isPageAsProduct, isPageAsCollection = param1.isPageAsCollection, userProperties = param1.userProperties;
    var asPathRef = (0,react.useRef)(null);
    var cart = (0,dist.useCart)();
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var ref4 = (0,react.useState)(false), delayForContextIsFinished = ref4[0], setDelayForContextIsFinished = ref4[1];
    var ref1 = (0,react.useState)(false), userDataEventTriggered = ref1[0], setUserDataEventTriggered = ref1[1];
    var userDataEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, _userProperties = param.userProperties;
        var ref, ref2, ref3;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_user_data",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: useDataLayerCustomer_objectSpread({}, ecommerce, {
                cart_total: (cart === null || cart === void 0 ? void 0 : (ref = cart.estimatedCost) === null || ref === void 0 ? void 0 : (ref2 = ref.totalAmount) === null || ref2 === void 0 ? void 0 : ref2.amount) || "0.0",
                cart_contents: {
                    products: (cart === null || cart === void 0 ? void 0 : (ref3 = cart.lines) === null || ref3 === void 0 ? void 0 : ref3.map(mapLineItem(list))) || []
                }
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
        setUserDataEventTriggered(true);
        setDelayForContextIsFinished(false);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    // Force delay on user data event
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setDelayForContextIsFinished(true);
        }, 1000);
    }, [
        asPath
    ]);
    // Trigger 'dl_user_data' event on path change after base data is ready,
    // excluding account and paths that trigger event directly before their respective events
    (0,react.useEffect)(function() {
        if (!delayForContextIsFinished || !baseEcommerce || !userProperties || IGNORED_PATHS.includes(asPath.split("/")[1]) || asPath.startsWith("/pages/search") || isPageAsProduct || isPageAsCollection || asPath === asPathRef.current) return undefined;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!baseEcommerce,
        delayForContextIsFinished,
        isPageAsProduct,
        isPageAsCollection,
        !!userProperties, 
    ]);
    // Trigger 'dl_user_data' event on account pages after base data is ready,
    // excluding after login/register events
    (0,react.useEffect)(function() {
        if (!delayForContextIsFinished || !baseEcommerce || !userProperties || !asPath.startsWith("/account") || asPath === asPathRef.current) return undefined;
        var prevPath = sessionStorage.getItem("PREVIOUS_PATH");
        var currentPath = sessionStorage.getItem("CURRENT_PATH");
        var prevPathInlcRefresh = sessionStorage.getItem("PREVIOUS_PATH_INLC_REFRESH");
        // On login or register, prevent event as it triggers directly from the login/register events
        var isFromLoginOrRegisterEvent = (prevPath.startsWith("/account/login") || prevPath.startsWith("/account/register")) && currentPath !== prevPathInlcRefresh;
        var isLoggedOutAccountPath = LOGGED_OUT_ACCOUNT_PATHS.some(function(path) {
            return asPath.startsWith(path);
        });
        if (isFromLoginOrRegisterEvent && !isLoggedOutAccountPath) return undefined;
        // On log out, trigger event with guest visitor type
        var isFromLogoutEvent = asPath.startsWith("/account/login") && prevPath.startsWith("/account");
        var prevPathIsLoggedOutAccountPath = LOGGED_OUT_ACCOUNT_PATHS.some(function(path) {
            return prevPath.startsWith(path);
        });
        if (isFromLogoutEvent && !prevPathIsLoggedOutAccountPath) {
            userDataEvent({
                ecommerce: baseEcommerce,
                userProperties: {
                    visitor_type: "guest",
                    user_consent: ""
                }
            });
        } else {
            // Else trigger event for all other instances
            userDataEvent({
                ecommerce: baseEcommerce,
                userProperties: userProperties
            });
        }
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!baseEcommerce,
        delayForContextIsFinished,
        !!userProperties
    ]);
    return {
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered
    };
}

;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/hooks/useDataLayerInit.js
function useDataLayerInit_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useDataLayerInit_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useDataLayerInit_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useDataLayerInit_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function useDataLayerInit(param1) {
    var baseEcommerce = param1.baseEcommerce, DEBUG = param1.DEBUG, pageTitle = param1.pageTitle, template = param1.template;
    var asPathRef = (0,react.useRef)(null);
    var customer = (0,dist.useCustomer)();
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var accessToken = (0,dist.useCustomerAccessToken)();
    var ref11 = (0,react.useState)(null), userProperties = ref11[0], setUserProperties = ref11[1];
    var customerPending = typeof customer === "undefined";
    var pathname = asPath === null || asPath === void 0 ? void 0 : asPath.split("?")[0];
    var generateUserProperties = (0,react.useCallback)(function() {
        var _ref = useDataLayerInit_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var _customer, _accessToken, _userProperties, ref12, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, orders;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _customer = param.customer, _accessToken = param.accessToken;
                        _userProperties = {};
                        if (!_customer) {
                            _ctx.next = 10;
                            break;
                        }
                        ;
                        _ctx.next = 6;
                        return fetchCustomerOrders({
                            accessToken: _accessToken
                        });
                    case 6:
                        orders = _ctx.sent;
                        _userProperties = {
                            visitor_type: "logged_in",
                            user_consent: "",
                            customer_address_1: ((ref12 = _customer.defaultAddress) === null || ref12 === void 0 ? void 0 : ref12.address1) || "",
                            customer_address_2: ((ref1 = _customer.defaultAddress) === null || ref1 === void 0 ? void 0 : ref1.address2) || "",
                            customer_city: ((ref2 = _customer.defaultAddress) === null || ref2 === void 0 ? void 0 : ref2.city) || "",
                            customer_country: ((ref3 = _customer.defaultAddress) === null || ref3 === void 0 ? void 0 : ref3.country) || "",
                            customer_country_code: ((ref4 = _customer.defaultAddress) === null || ref4 === void 0 ? void 0 : ref4.countryCode) || "",
                            customer_email: _customer.email,
                            customer_first_name: _customer.firstName,
                            customer_id: ((ref5 = _customer.id) === null || ref5 === void 0 ? void 0 : ref5.split("/").pop()) || "",
                            customer_last_name: _customer.lastName,
                            customer_order_count: (orders === null || orders === void 0 ? void 0 : orders.length) || 0,
                            customer_phone: ((ref6 = _customer.defaultAddress) === null || ref6 === void 0 ? void 0 : ref6.phone) || "",
                            customer_province_code: ((ref7 = _customer.defaultAddress) === null || ref7 === void 0 ? void 0 : ref7.provinceCode) || "",
                            customer_province: ((ref8 = _customer.defaultAddress) === null || ref8 === void 0 ? void 0 : ref8.province) || "",
                            customer_tags: ((ref9 = _customer.tags) === null || ref9 === void 0 ? void 0 : ref9.join(", ")) || "",
                            customer_total_spent: orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, order) {
                                var ref;
                                return acc + parseFloat(((ref = order.totalPriceV2) === null || ref === void 0 ? void 0 : ref.amount) || 0);
                            }, 0).toFixed(2),
                            customer_zip: ((ref10 = _customer.defaultAddress) === null || ref10 === void 0 ? void 0 : ref10.zip) || ""
                        };
                        _ctx.next = 11;
                        break;
                    case 10:
                        {
                            _userProperties = {
                                visitor_type: "guest",
                                user_consent: ""
                            };
                        }
                    case 11:
                        setUserProperties(_userProperties);
                        return _ctx.abrupt("return", _userProperties);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    // Set previous paths and current path in session storage
    (0,react.useEffect)(function() {
        var currentPath = sessionStorage.getItem("CURRENT_PATH");
        if (asPath === currentPath) {
            sessionStorage.setItem("PREVIOUS_PATH_INLC_REFRESH", asPath);
            return;
        }
        sessionStorage.setItem("PREVIOUS_PATH", currentPath);
        sessionStorage.setItem("PREVIOUS_PATH_INLC_REFRESH", currentPath);
        sessionStorage.setItem("CURRENT_PATH", asPath);
    }, [
        asPath
    ]);
    // generate user properties on customer ready and path change
    (0,react.useEffect)(function() {
        if (customerPending || customer && !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.token) || asPath === asPathRef.current // prevent multiple triggers on same path
        ) return undefined;
        generateUserProperties({
            customer: customer,
            accessToken: accessToken === null || accessToken === void 0 ? void 0 : accessToken.token
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        accessToken === null || accessToken === void 0 ? void 0 : accessToken.token,
        asPath,
        customerPending
    ]);
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !userProperties) return;
        var event = {
            event: "dl_route_update",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            page: {
                path: pathname,
                title: pageTitle,
                type: template,
                search: window.location.search
            },
            user_properties: userProperties,
            ecommerce: baseEcommerce
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, [
        !!baseEcommerce,
        pathname,
        !!userProperties
    ]);
    return {
        generateUserProperties: generateUserProperties,
        userProperties: userProperties
    };
}

;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/hooks/useDataLayerProduct.js
function useDataLayerProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useDataLayerProduct_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useDataLayerProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useDataLayerProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useDataLayerProduct_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useDataLayerProduct_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useDataLayerProduct_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function useDataLayerProduct(param1) {
    var baseEcommerce = param1.baseEcommerce, DEBUG = param1.DEBUG, userDataEvent = param1.userDataEvent, userProperties = param1.userProperties;
    var ref;
    var productHandleRef = (0,react.useRef)(null);
    var productBundleRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(null), viewedProductVariant = ref1[0], setViewedProductVariant = ref1[1];
    var ref2 = (0,react.useState)(null), viewedProductBundleVariants = ref2[0], setViewedProductBundleVariants = ref2[1];
    var viewProductEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, variant = param.variant, _userProperties = param.userProperties;
        if (!variant) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) ? previousPath : "";
        var event = {
            event: "dl_view_item",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: useDataLayerProduct_objectSpread({}, ecommerce, {
                detail: {
                    actionField: {
                        list: list,
                        action: "detail"
                    },
                    products: [
                        variant
                    ].map(mapProductPageVariant(list))
                }
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, []);
    var viewProductBundleEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, variants = param.variants, _userProperties = param.userProperties;
        if (!(variants === null || variants === void 0 ? void 0 : variants.length)) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/pages")) && (previousPath === null || previousPath === void 0 ? void 0 : previousPath.includes("kits")) ? previousPath : "";
        var event = {
            event: "dl_view_item",
            user_properties: _userProperties,
            ecommerce: useDataLayerProduct_objectSpread({}, ecommerce, {
                detail: {
                    actionField: {
                        list: list,
                        action: "detail"
                    },
                    products: variants.map(mapProductPageVariant(list))
                }
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, []);
    // Subscribe to PubSub topic for 'dl_view_item' event
    (0,react.useEffect)(function() {
        var viewProduct = PubSub.subscribe("VIEW_PRODUCT_PAGE", function() {
            var _ref = useDataLayerProduct_asyncToGenerator(runtime_default().mark(function _callee(event, variant) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setViewedProductVariant(variant);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, variant) {
                return _ref.apply(this, arguments);
            };
        }());
        var viewProductBundle = PubSub.subscribe("VIEW_PRODUCT_BUNDLE_PAGE", function() {
            var _ref = useDataLayerProduct_asyncToGenerator(runtime_default().mark(function _callee(event, variants) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setViewedProductBundleVariants(variants);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, variants) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (viewProduct) {
                PubSub.unsubscribe(viewProduct);
            }
            if (viewProductBundle) {
                PubSub.unsubscribe(viewProductBundle);
            }
        };
    }, []);
    // Trigger 'dl_user_data' and 'dl_view_item' events on product change after base data is ready
    (0,react.useEffect)(function() {
        var pageHandle = window.location.pathname.split("/").pop();
        if (!baseEcommerce || !userProperties || !viewedProductVariant || productHandleRef.current === pageHandle) return;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewProductEvent({
            ecommerce: baseEcommerce,
            variant: viewedProductVariant,
            userProperties: userProperties
        });
        productHandleRef.current = pageHandle;
    }, [
        !!baseEcommerce,
        viewedProductVariant === null || viewedProductVariant === void 0 ? void 0 : (ref = viewedProductVariant.product) === null || ref === void 0 ? void 0 : ref.id,
        !!userProperties
    ]);
    // Trigger 'dl_user_data' and 'dl_view_item' events on viewedProductVariant change after base data is ready
    (0,react.useEffect)(function() {
        var productBundlePathname = window.location.pathname;
        if (!baseEcommerce || !userProperties || !(viewedProductBundleVariants === null || viewedProductBundleVariants === void 0 ? void 0 : viewedProductBundleVariants.length) || productBundleRef.current === productBundlePathname) return;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewProductBundleEvent({
            ecommerce: baseEcommerce,
            variants: viewedProductBundleVariants,
            userProperties: userProperties
        });
        productBundleRef.current = productBundlePathname;
    }, [
        !!baseEcommerce,
        viewedProductBundleVariants,
        !!userProperties
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/hooks/useDataLayerSearch.js
function useDataLayerSearch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useDataLayerSearch_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useDataLayerSearch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useDataLayerSearch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useDataLayerSearch_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useDataLayerSearch_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useDataLayerSearch_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function useDataLayerSearch(param1) {
    var baseEcommerce = param1.baseEcommerce, DEBUG = param1.DEBUG, userDataEvent = param1.userDataEvent, userDataEventTriggered = param1.userDataEventTriggered, userProperties = param1.userProperties;
    var asPathRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var ref = (0,react.useState)(null), searchPageResults = ref[0], setSearchPageResults = ref[1];
    var ref1 = (0,react.useState)(null), searchResults = ref1[0], setSearchResults = ref1[1];
    var ref2 = (0,react.useState)(null), clickedSearchResultsItem = ref2[0], setClickedSearchResultsItem = ref2[1];
    var viewSearchResultsEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, results = param.results, _userProperties = param.userProperties;
        if (!(results === null || results === void 0 ? void 0 : results.length)) return;
        var event = {
            event: "dl_view_search_results",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: useDataLayerSearch_objectSpread({}, ecommerce, {
                actionField: {
                    list: "search_results",
                    search_term: results[0].searchTerm
                },
                products: results.slice(0, 12).map(mapProductItemProduct())
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, []);
    var clickSearchResultsItemEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, _userProperties = param.userProperties, variant = param.variant;
        if (!variant) return;
        var event = {
            event: "dl_select_item",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: useDataLayerSearch_objectSpread({}, ecommerce, {
                click: {
                    actionField: {
                        list: "search_results",
                        action: "click",
                        search_term: variant.searchTerm
                    },
                    products: [
                        variant
                    ].map(mapProductItemVariant())
                }
            })
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, []);
    // Subscribe to PubSub topics for 'view_search_results' and 'select_item' events
    (0,react.useEffect)(function() {
        var viewSearchPageResults = PubSub.subscribe("VIEW_SEARCH_PAGE_RESULTS", function() {
            var _ref = useDataLayerSearch_asyncToGenerator(runtime_default().mark(function _callee(event, results) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setSearchPageResults(results);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, results) {
                return _ref.apply(this, arguments);
            };
        }());
        var viewSearchResults = PubSub.subscribe("VIEW_SEARCH_RESULTS", function() {
            var _ref = useDataLayerSearch_asyncToGenerator(runtime_default().mark(function _callee(event, results) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setSearchResults(results);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, results) {
                return _ref.apply(this, arguments);
            };
        }());
        var clickSearchItem = PubSub.subscribe("CLICK_SEARCH_ITEM", function() {
            var _ref = useDataLayerSearch_asyncToGenerator(runtime_default().mark(function _callee(event, variant) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setClickedSearchResultsItem(variant);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, variant) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (viewSearchPageResults) {
                PubSub.unsubscribe(viewSearchPageResults);
            }
            if (viewSearchResults) {
                PubSub.unsubscribe(viewSearchResults);
            }
            if (clickSearchItem) {
                PubSub.unsubscribe(clickSearchItem);
            }
        };
    }, []);
    // Trigger 'dl_user_data' and 'dl_view_search_results' events after
    // new sidebar search results and base data is ready
    (0,react.useEffect)(function() {
        if (!asPath.startsWith("/pages/search") || !baseEcommerce || !(searchPageResults === null || searchPageResults === void 0 ? void 0 : searchPageResults.length) || !userProperties || asPath === asPathRef.current) return undefined;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewSearchResultsEvent({
            ecommerce: baseEcommerce,
            results: searchPageResults,
            userProperties: userProperties
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!baseEcommerce,
        searchPageResults === null || searchPageResults === void 0 ? void 0 : searchPageResults.map(function(p) {
            return p === null || p === void 0 ? void 0 : p.handle;
        }).join(""),
        !!userProperties, 
    ]);
    // Trigger 'dl_user_data' and 'dl_view_search_results' events after
    // new search page results and base data is ready
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !searchResults || !userDataEventTriggered) return;
        viewSearchResultsEvent({
            ecommerce: baseEcommerce,
            results: searchResults,
            userProperties: userProperties
        });
    }, [
        !!baseEcommerce,
        searchResults,
        userDataEventTriggered
    ]);
    // Trigger 'dl_select_item' after clicked search item and user event
    (0,react.useEffect)(function() {
        if (!clickedSearchResultsItem || !baseEcommerce || !userDataEventTriggered) return;
        clickSearchResultsItemEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties,
            variant: clickedSearchResultsItem
        });
    }, [
        clickedSearchResultsItem,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/hooks/useDataLayerSubscribe.js
function useDataLayerSubscribe_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useDataLayerSubscribe_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useDataLayerSubscribe_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useDataLayerSubscribe_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function useDataLayerSubscribe(param1) {
    var baseEcommerce = param1.baseEcommerce, DEBUG = param1.DEBUG, userDataEventTriggered = param1.userDataEventTriggered;
    var ref = (0,react.useState)(""), subscribedEmail = ref[0], setSubscribedEmail = ref[1];
    var ref1 = (0,react.useState)(""), subscribedPhone = ref1[0], setSubscribedPhone = ref1[1];
    var subscribeEmailEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, email = param.email;
        if (!email) return;
        var event = {
            event: "dl_subscribe",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            lead_type: "email",
            user_properties: {
                customer_email: email
            },
            ecommerce: ecommerce
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, []);
    var subscribePhoneEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, phone = param.phone;
        if (!phone) return;
        var event = {
            event: "dl_subscribe",
            event_id: nanoid(),
            event_time: new Date().toISOString(),
            lead_type: "phone",
            user_properties: {
                customer_phone: phone
            },
            ecommerce: ecommerce
        };
        window.dispatchEvent(new CustomEvent(event.event, {
            detail: event
        }));
        if (DEBUG) console.log("DataLayer:dispatch:".concat(event.event), event);
    }, []);
    // Subscribe to PubSub topic for 'dl_subscribe' event
    (0,react.useEffect)(function() {
        var subscribedWithEmail = PubSub.subscribe("SUBSCRIBE_EMAIL", function() {
            var _ref = useDataLayerSubscribe_asyncToGenerator(runtime_default().mark(function _callee(event, email) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setSubscribedEmail(email);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, email) {
                return _ref.apply(this, arguments);
            };
        }());
        var subscribedWithPhone = PubSub.subscribe("SUBSCRIBE_PHONE", function() {
            var _ref = useDataLayerSubscribe_asyncToGenerator(runtime_default().mark(function _callee(event, phone) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setSubscribedPhone(phone);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, phone) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (subscribedWithEmail) {
                PubSub.unsubscribe(subscribedWithEmail);
            }
            if (subscribedWithPhone) {
                PubSub.unsubscribe(subscribedWithPhone);
            }
        };
    }, []);
    // Trigger 'dl_subscribe' event after email submission
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !subscribedEmail || !userDataEventTriggered) return;
        subscribeEmailEvent({
            ecommerce: baseEcommerce,
            email: subscribedEmail
        });
    }, [
        !!baseEcommerce,
        subscribedEmail,
        userDataEventTriggered
    ]);
    // Trigger 'dl_subscribe' event after phone submission
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !subscribedPhone || !userDataEventTriggered) return;
        subscribePhoneEvent({
            ecommerce: baseEcommerce,
            phone: subscribedPhone
        });
    }, [
        !!baseEcommerce,
        subscribedPhone,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/hooks/index.js









;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/useDataLayerEventListeners.js



// Envs to set:
// * NEXT_PUBLIC_SITE_TITLE // provides backup brand name
// * NEXT_PUBLIC_ENABLE_DL_DEBUGGER // enables console logs for event dispatches
// * NEXT_PUBLIC_SHOPIFY_CUSTOM_APP_ID
var DEBUG = "true" === "true";
function useDataLayerEventListeners(param1) {
    var pageProp = param1.page, pageTitle = param1.pageTitle, template = param1.template;
    var currencyCode = (0,dist.useCurrency)();
    var page = template === "page" ? pageProp : undefined;
    var baseEcommerce = (0,react.useMemo)(function() {
        if (!currencyCode) return null;
        return {
            currency_code: currencyCode,
            app_id: "12074876929"
        };
    }, [
        currencyCode
    ]);
    var isPageAsProduct = (0,react.useMemo)(function() {
        var ref;
        if (!page) return false;
        var productTypeSections = [
            ""
        ];
        return (ref = page.sections) === null || ref === void 0 ? void 0 : ref.some(function(param) {
            var _template = param._template;
            return productTypeSections.includes(_template);
        });
    }, [
        page === null || page === void 0 ? void 0 : page.id
    ]);
    var isPageAsCollection = (0,react.useMemo)(function() {
        var ref;
        if (!page) return false;
        var colTypeSections = [
            ""
        ];
        return (ref = page.sections) === null || ref === void 0 ? void 0 : ref.some(function(param) {
            var _template = param._template;
            return colTypeSections.includes(_template);
        });
    }, [
        page === null || page === void 0 ? void 0 : page.id
    ]);
    var ref2 = useDataLayerInit({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        pageTitle: pageTitle,
        template: template
    }), generateUserProperties = ref2.generateUserProperties, userProperties = ref2.userProperties;
    var ref1 = useDataLayerCustomer({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        isPageAsProduct: isPageAsProduct,
        isPageAsCollection: isPageAsCollection,
        userProperties: userProperties
    }), userDataEvent = ref1.userDataEvent, userDataEventTriggered = ref1.userDataEventTriggered;
    useDataLayerAccount({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        generateUserProperties: generateUserProperties,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered
    });
    useDataLayerCart({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered,
        userProperties: userProperties
    });
    useDataLayerProduct({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        userDataEvent: userDataEvent,
        userProperties: userProperties
    });
    useDataLayerCollection({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        isPageAsCollection: isPageAsCollection,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered,
        userProperties: userProperties
    });
    useDataLayerSearch({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered,
        userProperties: userProperties
    });
    useDataLayerSubscribe({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        userDataEventTriggered: userDataEventTriggered
    });
}

;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/DataLayerEventListeners.jsx

// Envs to set:
// * NEXT_PUBLIC_SITE_TITLE // provides backup brand name
// * NEXT_PUBLIC_ENABLE_DL_DEBUGGER // enables console logs for event dispatches
// * NEXT_PUBLIC_SHOPIFY_CUSTOM_APP_ID
function DataLayerEventListeners(param) {
    var pageTitle = param.pageTitle, template = param.template;
    useDataLayerEventListeners({
        pageTitle: pageTitle,
        template: template
    });
    return null;
}
DataLayerEventListeners.displayName = "DataLayerEventListeners";

;// CONCATENATED MODULE: ./src/snippets/components/DataLayerEventListeners/index.js


;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledAccessibleScript.jsx


function FueledAccessibleScript() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        type: "text/javascript",
        dangerouslySetInnerHTML: {
            __html: "\n        (function(){ var s = document.createElement('script'), e = ! document.body ? document.querySelector('head') : document.body; s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; s.async = true; s.onload = function(){ acsbJS.init({ statementLink : '', footerHtml : '', hideMobile : false, hideTrigger : false, language : 'en', position : 'left', leadColor : '#36454f', triggerColor : '#ffb6c1', triggerRadius : '50%', triggerPositionX : 'left', triggerPositionY : 'bottom', triggerIcon : 'people', triggerSize : 'small', triggerOffsetX : 20, triggerOffsetY : 80, mobile : { triggerSize : 'small', triggerPositionX : 'right', triggerPositionY : 'bottom', triggerOffsetX : 10, triggerOffsetY : 80, triggerRadius : '50%' } }); }; e.appendChild(s);}());\n        "
        }
    });
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/hooks/useScriptLoad.js
function useScriptLoad_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useScriptLoad_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useScriptLoad_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useScriptLoad_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useScriptLoad_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useScriptLoad_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useScriptLoad_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useScriptLoad_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useScriptLoad_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = useScriptLoad_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function useScriptLoad_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function useScriptLoad_slicedToArray(arr, i) {
    return useScriptLoad_arrayWithHoles(arr) || useScriptLoad_iterableToArrayLimit(arr, i) || useScriptLoad_unsupportedIterableToArray(arr, i) || useScriptLoad_nonIterableRest();
}
function useScriptLoad_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useScriptLoad_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useScriptLoad_arrayLikeToArray(o, minLen);
}


var DEFAULT_TIMEOUT = 10000; // 10 seconds
var POLL_INTERVAL = 100; // 100ms
var MAX_RETRY = 100;
var SCRIPTS_LOADED = {};
var waitForCallback = function(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_TIMEOUT;
    var startTime = Date.now();
    var retry = 0;
    return new Promise(function(resolve, reject) {
        var check = function() {
            retry++;
            if (callback()) {
                resolve();
                return;
            }
            if (retry >= MAX_RETRY) {
                reject(new Error("Max retry attempts reached"));
                return;
            }
            if (Date.now() - startTime > timeout) {
                reject(new Error("Timeout waiting for callback"));
                return;
            }
            setTimeout(check, POLL_INTERVAL);
        };
        check();
    });
};
var loadScript = function(attributes) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "head";
    var scriptId = attributes.id || attributes.src || attributes.innerHTML || "";
    var isScriptLoaded = SCRIPTS_LOADED[scriptId];
    if (isScriptLoaded) {
        return isScriptLoaded;
    }
    var scriptPromise = new Promise(function(resolve, reject) {
        var innerHTML = attributes.innerHTML, waitFor = attributes.waitFor, attrs = useScriptLoad_objectWithoutProperties(attributes, [
            "innerHTML",
            "waitFor"
        ]);
        if (!attributes.src && !innerHTML) {
            reject(new Error("Either src or innerHTML must be provided"));
            return;
        }
        var script = document.createElement("script");
        Object.entries(attrs).forEach(function(param) {
            var _param = useScriptLoad_slicedToArray(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined && key !== "code") {
                script.setAttribute(key, String(value));
            }
        });
        if (attributes.src) {
            script.src = attributes.src;
            script.onload = useScriptLoad_asyncToGenerator(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (waitFor) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return", resolve());
                        case 2:
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return waitForCallback(waitFor);
                        case 5:
                            resolve();
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](2);
                            reject(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        8
                    ]
                ]);
            }));
        } else if (innerHTML) {
            script.innerHTML = innerHTML;
            useScriptLoad_asyncToGenerator(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (waitFor) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return", resolve());
                        case 2:
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return waitForCallback(waitFor);
                        case 5:
                            resolve();
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](2);
                            reject(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        8
                    ]
                ]);
            }))();
        }
        script.onerror = function(e) {
            return reject(new Error("Failed to load script: ".concat(e.message)));
        };
        var targetElement = target === "head" ? document.head : document.body;
        targetElement.appendChild(script);
    });
    SCRIPTS_LOADED[scriptId] = scriptPromise;
    return scriptPromise;
};
var useScriptLoad = function() {
    var attributes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "body";
    var ref = (0,react.useState)("idle"), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    (0,react.useEffect)(function() {
        var loadAndTrackScript = function() {
            var _ref = useScriptLoad_asyncToGenerator(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setStatus("loading");
                            _ctx.next = 4;
                            return loadScript(attributes, target);
                        case 4:
                            setStatus("ready");
                            _ctx.next = 11;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            setError(_ctx.t0);
                            setStatus("error");
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }));
            return function loadAndTrackScript() {
                return _ref.apply(this, arguments);
            };
        }();
        loadAndTrackScript();
    }, [
        attributes.src,
        attributes.innerHTML,
        target
    ]);
    return {
        status: status,
        error: error
    };
};
/* harmony default export */ var hooks_useScriptLoad = ((/* unused pure expression or super */ null && (useScriptLoad)));

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/hooks/useCustomerPrivacy.js
function useCustomerPrivacy_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useCustomerPrivacy_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useCustomerPrivacy_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useCustomerPrivacy_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = useCustomerPrivacy_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function useCustomerPrivacy_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var CONSENT_API = "https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js";
var CONSENT_API_WITH_BANNER = "https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js";
function useApisLoaded(param) {
    var withPrivacyBanner = param.withPrivacyBanner, onLoaded = param.onLoaded;
    var observing = (0,react.useRef)({
        customerPrivacy: false,
        privacyBanner: false
    });
    var ref = (0,react.useState)(withPrivacyBanner ? [
        false,
        false
    ] : [
        false
    ]), apisLoaded = ref[0], setApisLoaded = ref[1];
    var loaded = apisLoaded.every(Boolean);
    var setLoaded = {
        customerPrivacy: function() {
            if (withPrivacyBanner) {
                setApisLoaded(function(prev) {
                    return [
                        true,
                        prev[1]
                    ];
                });
            } else {
                setApisLoaded(function() {
                    return [
                        true
                    ];
                });
            }
        },
        privacyBanner: function() {
            if (!withPrivacyBanner) {
                return;
            }
            setApisLoaded(function(prev) {
                return [
                    prev[0],
                    true
                ];
            });
        }
    };
    (0,react.useEffect)(function() {
        if (loaded && onLoaded) {
            onLoaded();
        }
    }, [
        loaded,
        onLoaded
    ]);
    return {
        observing: observing,
        setLoaded: setLoaded
    };
}
function parseStoreDomain(checkoutDomain) {
    if (false) {}
    var host = window.document.location.host;
    var checkoutDomainParts = checkoutDomain.split(".").reverse();
    var currentDomainParts = host.split(".").reverse();
    var sameDomainParts = [];
    checkoutDomainParts.forEach(function(part, index) {
        if (part === currentDomainParts[index]) {
            sameDomainParts.push(part);
        }
    });
    return sameDomainParts.reverse().join("."); // eslint-disable-line
}
function overridePrivacyBannerMethods(param) {
    var privacyBanner = param.privacyBanner, config = param.config;
    var loadBanner = function loadBanner(userConfig) {
        if (typeof userConfig === "object") {
            originalLoadBanner(useCustomerPrivacy_objectSpread({}, config, userConfig));
            return;
        }
        originalLoadBanner(config);
    };
    var showPreferences = function showPreferences(userConfig) {
        if (typeof userConfig === "object") {
            originalShowPreferences(useCustomerPrivacy_objectSpread({}, config, userConfig));
            return;
        }
        originalShowPreferences(config);
    };
    var originalLoadBanner = privacyBanner.loadBanner;
    var originalShowPreferences = privacyBanner.showPreferences;
    return {
        loadBanner: loadBanner,
        showPreferences: showPreferences
    };
}
function overrideCustomerPrivacySetTrackingConsent(param) {
    var customerPrivacy = param.customerPrivacy, config = param.config;
    var updatedSetTrackingConsent = function updatedSetTrackingConsent(consent, callback) {
        original(useCustomerPrivacy_objectSpread({}, rest, {
            headlessStorefront: true
        }, consent), callback);
    };
    var original = customerPrivacy.setTrackingConsent;
    var locale = config.locale, country = config.country, rest = useCustomerPrivacy_objectWithoutProperties(config, [
        "locale",
        "country"
    ]);
    return updatedSetTrackingConsent;
}
var hasEmitted = false;
function emitCustomerPrivacyApiLoaded() {
    if (hasEmitted) return;
    hasEmitted = true;
    var event = new CustomEvent("shopifyCustomerPrivacyApiLoaded");
    document.dispatchEvent(event);
}
function getCustomerPrivacy() {
    try {
        var ref;
        return window.Shopify && window.Shopify.customerPrivacy ? (ref = window.Shopify) === null || ref === void 0 ? void 0 : ref.customerPrivacy : null;
    } catch (e) {
        return null;
    }
}
function getPrivacyBanner() {
    try {
        return window && (window === null || window === void 0 ? void 0 : window.privacyBanner) ? window.privacyBanner : null;
    } catch (e) {
        return null;
    }
}
function useCustomerPrivacy(props) {
    var _withPrivacyBanner = props.withPrivacyBanner, withPrivacyBanner = _withPrivacyBanner === void 0 ? false : _withPrivacyBanner, onVisitorConsentCollected = props.onVisitorConsentCollected, onReady = props.onReady, consentConfig = useCustomerPrivacy_objectWithoutProperties(props, [
        "withPrivacyBanner",
        "onVisitorConsentCollected",
        "onReady"
    ]);
    var status = useScriptLoad({
        src: withPrivacyBanner ? CONSENT_API_WITH_BANNER : CONSENT_API,
        id: "customer-privacy-api"
    }, "head").status;
    var ref = useApisLoaded({
        withPrivacyBanner: withPrivacyBanner,
        onLoaded: onReady
    }), observing = ref.observing, setLoaded = ref.setLoaded;
    var config = (0,react.useMemo)(function() {
        var checkoutDomain = consentConfig.checkoutDomain, storefrontAccessToken = consentConfig.storefrontAccessToken;
        return {
            checkoutRootDomain: checkoutDomain,
            storefrontAccessToken: storefrontAccessToken,
            storefrontRootDomain: parseStoreDomain(checkoutDomain),
            country: consentConfig.country,
            locale: consentConfig.locale
        };
    }, [
        consentConfig,
        parseStoreDomain
    ]);
    (0,react.useEffect)(function() {
        var consentCollectedHandler = function(event) {
            if (onVisitorConsentCollected) {
                onVisitorConsentCollected(event.detail);
            }
        };
        document.addEventListener("visitorConsentCollected", consentCollectedHandler);
        return function() {
            document.removeEventListener("visitorConsentCollected", consentCollectedHandler);
        };
    }, [
        onVisitorConsentCollected
    ]);
    (0,react.useEffect)(function() {
        if (!withPrivacyBanner || observing.current.privacyBanner) return;
        observing.current.privacyBanner = true;
        var customPrivacyBanner = window.privacyBanner || undefined;
        var privacyBannerWatcher = {
            configurable: true,
            get: function get() {
                return customPrivacyBanner;
            },
            set: function set(value) {
                if (typeof value === "object" && value !== null && "showPreferences" in value && "loadBanner" in value) {
                    var privacyBanner = value;
                    privacyBanner.loadBanner(config);
                    customPrivacyBanner = overridePrivacyBannerMethods({
                        privacyBanner: privacyBanner,
                        config: config
                    });
                    setLoaded.privacyBanner();
                    emitCustomerPrivacyApiLoaded();
                }
            }
        };
        Object.defineProperty(window, "privacyBanner", privacyBannerWatcher);
    }, [
        withPrivacyBanner,
        config,
        overridePrivacyBannerMethods,
        setLoaded.privacyBanner, 
    ]);
    (0,react.useEffect)(function() {
        if (observing.current.customerPrivacy) return;
        observing.current.customerPrivacy = true;
        var customCustomerPrivacy = null;
        var customShopify = window.Shopify || {};
        Object.defineProperty(window, "Shopify", {
            configurable: true,
            get: function get() {
                return customShopify;
            },
            set: function set(value1) {
                if (typeof value1 === "object" && value1 !== null && Object.keys(value1).length === 0) {
                    customShopify = value1;
                    Object.defineProperty(window.Shopify, "customerPrivacy", {
                        configurable: true,
                        get: function get() {
                            return customCustomerPrivacy;
                        },
                        // eslint-disable-next-line no-shadow
                        set: function set(value) {
                            if (typeof value === "object" && value !== null && "setTrackingConsent" in value) {
                                var customerPrivacy = value;
                                customCustomerPrivacy = useCustomerPrivacy_objectSpread({}, customerPrivacy, {
                                    setTrackingConsent: overrideCustomerPrivacySetTrackingConsent({
                                        customerPrivacy: customerPrivacy,
                                        config: config
                                    })
                                });
                                customShopify = useCustomerPrivacy_objectSpread({}, customShopify, {
                                    customerPrivacy: customCustomerPrivacy,
                                    shop: "briogeo-hair-care.myshopify.com",
                                    currency: {
                                        active: "USD",
                                        rate: "1.0"
                                    }
                                });
                                setLoaded.customerPrivacy();
                                emitCustomerPrivacyApiLoaded();
                            }
                        }
                    });
                }
            }
        });
    }, [
        config,
        overrideCustomerPrivacySetTrackingConsent,
        setLoaded.customerPrivacy, 
    ]);
    var result = {
        isReady: status === "ready",
        customerPrivacy: getCustomerPrivacy()
    };
    if (withPrivacyBanner) {
        result.privacyBanner = getPrivacyBanner();
    }
    return result;
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/hooks/useAnalytics.js

var TRACKING_EVENTS = {
    LOGIN: "dl_login",
    SIGN_UP: "dl_sign_up",
    VIEW_CART: "dl_view_cart",
    VIEW_ITEM: "dl_view_item",
    SUBSCRIBE: "dl_subscribe",
    USER_DATA: "dl_user_data",
    ADD_TO_CART: "dl_add_to_cart",
    SELECT_ITEM: "dl_select_item",
    PAGE_VIEW: "dl_route_update",
    VIEW_ITEM_LIST: "dl_view_item_list",
    REMOVE_FROM_CART: "dl_remove_from_cart",
    VIEW_SEARCH_RESULTS: "dl_view_search_results"
};
var clients = {};
var eventCache = new Map();
var subscribers = new Map();
var eventListeners = new Set();
var useAnalytics = function() {
    var areClientsReady = function() {
        return Object.values(clients).every(Boolean) && Object.keys(clients).length > 0;
    };
    var publishEvent = function(eventName, payload) {
        (subscribers.get(eventName) || new Set()).forEach(function(callback) {
            try {
                callback(payload);
            } catch (error) {
                console.error(error);
            }
        });
    };
    var subscribe = function(eventName, callback) {
        if (!subscribers.has(eventName)) {
            subscribers.set(eventName, new Set());
        }
        subscribers.get(eventName).add(callback);
        return function() {
            var callbacks = subscribers.get(eventName);
            if (callbacks) {
                callbacks.delete(callback);
                if (callbacks.size === 0) {
                    subscribers.delete(eventName);
                }
            }
        };
    };
    var publish = function(eventName, payload) {
        if (!areClientsReady()) {
            eventCache.set(eventName, payload);
            return;
        }
        publishEvent(eventName, payload);
    };
    var register = function(client) {
        if (typeof clients[client] === "undefined") {
            clients[client] = false;
        }
        return function() {
            clients[client] = true;
            if (areClientsReady() && eventCache.size > 0) {
                eventCache.forEach(function(payload, eventName) {
                    publishEvent(eventName, payload);
                });
                eventCache.clear();
            }
        };
    };
    (0,react.useEffect)(function() {
        var events = Object.values(TRACKING_EVENTS);
        var abortController = new AbortController();
        var handleEvent = function(event) {
            publish(event.type, event);
        };
        events.forEach(function(eventName) {
            if (eventListeners.has(eventName)) return;
            eventListeners.add(eventName);
            window.addEventListener(eventName, handleEvent, {
                signal: abortController.signal
            });
        });
        return function() {
            abortController.abort();
            eventListeners.clear();
        };
    }, []);
    return {
        clients: clients,
        register: register,
        subscribe: subscribe,
        publish: publish
    };
};

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/hooks/index.js




;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledBingScript.jsx
function FueledBingScript_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function FueledBingScript_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function FueledBingScript_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FueledBingScript_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function FueledBingScript_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FueledBingScript_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FueledBingScript_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FueledBingScript_slicedToArray(arr, i) {
    return FueledBingScript_arrayWithHoles(arr) || FueledBingScript_iterableToArrayLimit(arr, i) || FueledBingScript_unsupportedIterableToArray(arr, i) || FueledBingScript_nonIterableRest();
}
function FueledBingScript_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return FueledBingScript_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FueledBingScript_arrayLikeToArray(o, minLen);
}


var eventTypes = [
    TRACKING_EVENTS.ADD_TO_CART
];
function FueledBingScript(param) {
    var bingPixelId = param.withKey;
    var ref = useAnalytics(), subscribe = ref.subscribe, register = ref.register;
    var status = useScriptLoad({
        id: "bing-pixel-script",
        innerHTML: '\n        (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"'.concat(bingPixelId, '", enableAutoSpaTracking: true};\n        o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){\n        var s=this.readyState;s &&s!=="loaded"&& s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],\n        i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");'),
        waitFor: function() {
            return !!(window === null || window === void 0 ? void 0 : window.uetq);
        }
    }, "head").status;
    var ready = register("bing-pixel-script");
    (0,react.useEffect)(function() {
        if (status !== "ready") return;
        var eventHandler = function(event) {
            switch(event.type){
                case "dl_add_to_cart":
                    {
                        var _products = FueledBingScript_slicedToArray(event.detail.ecommerce.add.products, 1), product = _products[0];
                        window.uetq.push("event", "add_to_cart", FueledBingScript_objectSpread({
                            ecomm_prodid: product.product_id,
                            ecomm_pagetype: "product",
                            ecomm_totalvalue: product.price * product.quantity
                        }, product.quantity && {
                            ecomm_category: product.category
                        }, {
                            currency: event.detail.ecommerce.currency_code,
                            items: [
                                {
                                    id: product.product_id,
                                    name: product.name,
                                    price: product.price,
                                    quantity: product.quantity
                                }, 
                            ]
                        }));
                        break;
                    }
            }
        };
        eventTypes.forEach(function(eventType) {
            return subscribe(eventType, eventHandler);
        });
        ready();
    }, [
        status
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledClientScript.jsx
/* provided dependency */ var process = __webpack_require__(14284);
function FueledClientScript_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function FueledClientScript_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                FueledClientScript_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                FueledClientScript_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var fueledScriptUrl = process.env.NEXT_PUBLIC_FUELED_SCRIPT_URL || "https://mb-cdn.fueled.io/fueled/53616c7465645f5fcaa90562d5c47b67f0bf839814184b25bbd6cc8495722e955af76bdd9f94440c3b77ce32952c84ab40e260d4301faab4d3ef98b522323d4c/packdigital/js";
function FueledClientScript() {
    var cartId = (0,dist.useCartId)();
    var cart = (0,dist.useCart)();
    var cartUpdateAttributes = (0,dist.useCartUpdateAttributes)().cartUpdateAttributes;
    var cartRef = (0,react.useRef)(cart);
    var cartUpdateAttributesRef = (0,react.useRef)(cartUpdateAttributes);
    (0,react.useEffect)(function() {
        cartRef.current = cart;
    }, [
        cart
    ]);
    (0,react.useEffect)(function() {
        cartUpdateAttributesRef.current = cartUpdateAttributes;
    }, [
        cartUpdateAttributes
    ]);
    (0,react.useEffect)(function() {
        if (!cartId) return function() {
            return null;
        };
        var isStale = false;
        var setCartToken = function() {
            var _ref = FueledClientScript_asyncToGenerator(runtime_default().mark(function _callee() {
                var fueled, res, ref, _context, anonymousId, tmp, ref1, _clientId, clientId, _sessionId, sessionId, tmp1, ref2, _fbp, fbp, _fbc, fbc, currentCart, existingAttributes, attributesToUpdate;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            fueled = window.fueled || {};
                            _ctx.next = 3;
                            return fueled.setFrontendStorage(fueled.config.frontendStorageUrl, cartId.replace("gid://shopify/Cart/", ""));
                        case 3:
                            res = _ctx.sent;
                            _ctx.next = 6;
                            return res.json();
                        case 6:
                            ref = _ctx.sent;
                            _context = ref.context;
                            anonymousId = _context.anonymousId;
                            tmp = _context.ga4;
                            ref1 = tmp === void 0 ? {} : tmp;
                            _clientId = ref1.clientId;
                            clientId = _clientId === void 0 ? undefined : _clientId;
                            _sessionId = ref1.sessionId;
                            sessionId = _sessionId === void 0 ? undefined : _sessionId;
                            tmp1 = _context.fb;
                            ref2 = tmp1 === void 0 ? {} : tmp1;
                            _fbp = ref2.fbp;
                            fbp = _fbp === void 0 ? undefined : _fbp;
                            _fbc = ref2.fbc;
                            fbc = _fbc === void 0 ? undefined : _fbc;
                            if (!isStale) {
                                _ctx.next = 23;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 23:
                            currentCart = cartRef.current;
                            existingAttributes = (currentCart === null || currentCart === void 0 ? void 0 : currentCart.attributes) || [];
                            attributesToUpdate = existingAttributes.filter(function(attr) {
                                return attr.key !== "fueled_context";
                            }).concat([
                                {
                                    key: "fueled_context",
                                    value: JSON.stringify({
                                        anonymousId: anonymousId,
                                        ga4: {
                                            clientId: clientId,
                                            sessionId: sessionId
                                        },
                                        fb: {
                                            fbp: fbp,
                                            fbc: fbc
                                        }
                                    })
                                }, 
                            ]);
                            _ctx.next = 28;
                            return cartUpdateAttributesRef.current({
                                attributes: attributesToUpdate
                            });
                        case 28:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function setCartToken() {
                return _ref.apply(this, arguments);
            };
        }();
        if (window.fueled) {
            setCartToken();
        } else {
            window.addEventListener("fueled-ready", setCartToken);
        }
        return function() {
            isStale = true;
            window.removeEventListener("fueled-ready", setCartToken);
        };
    }, [
        cartId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        type: "text/javascript",
        src: fueledScriptUrl
    });
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledGtmScript.jsx


function FueledGtmScript(param) {
    var gtmContainerId = param.withKey;
    var ref = useAnalytics(), register = ref.register, subscribe = ref.subscribe;
    var ready = register("gmt-script");
    useScriptLoad({
        id: "gtm-pixel-script",
        innerHTML: "\n        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n        })(window,document,'script','dataLayer', '".concat(gtmContainerId, "');")
    }, "head");
    (0,react.useEffect)(function() {
        window.dataLayer = window.dataLayer || [];
        var pageViewListener = function(event) {
            window.dataLayer.push({
                event: "dl_route_update",
                page: event.detail.page,
                event_id: event.detail.event_id,
                event_time: event.detail.event_time,
                ecommerce: event.detail.ecommerce,
                user_properties: event.detail.user_properties
            });
        };
        subscribe(TRACKING_EVENTS.PAGE_VIEW, pageViewListener);
        ready();
    }, []);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledImpactScript.jsx
function FueledImpactScript_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function FueledImpactScript_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                FueledImpactScript_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                FueledImpactScript_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// Function to hash email using SHA-1
var hashEmail = function() {
    var _ref = FueledImpactScript_asyncToGenerator(runtime_default().mark(function _callee(email) {
        var encoder, data, hash;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    encoder = new TextEncoder();
                    data = encoder.encode(email);
                    _ctx.next = 4;
                    return crypto.subtle.digest("SHA-1", data);
                case 4:
                    hash = _ctx.sent;
                    return _ctx.abrupt("return", Array.from(new Uint8Array(hash)).map(function(b) {
                        return b.toString(16).padStart(2, "0");
                    }).join(""));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function hashEmail(email) {
        return _ref.apply(this, arguments);
    };
}();
function FueledImpactScript(param) {
    var impactPixelId = param.withKey;
    var ref = useAnalytics(), register = ref.register, subscribe = ref.subscribe;
    var status = useScriptLoad({
        id: "impact-script",
        src: "https://utt.impactcdn.com/".concat(impactPixelId, ".js"),
        waitFor: function() {
            return !!(window === null || window === void 0 ? void 0 : window.ire);
        }
    }, "head").status;
    var ready = register("impact");
    (0,react.useEffect)(function() {
        if (status !== "ready") return;
        var userDataListener = function() {
            var _ref = FueledImpactScript_asyncToGenerator(runtime_default().mark(function _callee(event) {
                var userProps, hashedEmail;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            console.log("User properties:", event.detail.user_properties);
                            userProps = event.detail.user_properties;
                            if (!(userProps === null || userProps === void 0 ? void 0 : userProps.customer_email)) {
                                _ctx.next = 10;
                                break;
                            }
                            _ctx.next = 5;
                            return hashEmail(userProps.customer_email);
                        case 5:
                            hashedEmail = _ctx.sent;
                            window.ire("identify", {
                                customerId: userProps === null || userProps === void 0 ? void 0 : userProps.customer_id,
                                customerEmail: hashedEmail
                            });
                            console.log("Firing identify event", {
                                customerId: userProps === null || userProps === void 0 ? void 0 : userProps.customer_id,
                                customerEmail: hashedEmail
                            });
                            _ctx.next = 11;
                            break;
                        case 10:
                            {
                                window.ire("identify", {
                                    customerId: "",
                                    customerEmail: ""
                                });
                                console.log("Firing identify event with empty data");
                            }
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function userDataListener(event) {
                return _ref.apply(this, arguments);
            };
        }();
        subscribe(TRACKING_EVENTS.PAGE_VIEW, userDataListener);
        ready();
    }, [
        status
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledKlaviyoScript.jsx
function FueledKlaviyoScript_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function FueledKlaviyoScript_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function FueledKlaviyoScript_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function FueledKlaviyoScript_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FueledKlaviyoScript_slicedToArray(arr, i) {
    return FueledKlaviyoScript_arrayWithHoles(arr) || FueledKlaviyoScript_iterableToArrayLimit(arr, i) || FueledKlaviyoScript_unsupportedIterableToArray(arr, i) || FueledKlaviyoScript_nonIterableRest();
}
function FueledKlaviyoScript_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return FueledKlaviyoScript_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FueledKlaviyoScript_arrayLikeToArray(o, minLen);
}


function FueledKlaviyoScript(param) {
    var klaviyoPixelId = param.withKey;
    var ref4 = useAnalytics(), register = ref4.register, subscribe = ref4.subscribe;
    var status = useScriptLoad({
        id: "klaviyo-script",
        src: "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=".concat(klaviyoPixelId),
        defer: true,
        waitFor: function() {
            return !!(window === null || window === void 0 ? void 0 : window.klaviyo);
        }
    }, "head").status;
    var ready = register("klaviyo");
    /* Specs:
   * https://developers.klaviyo.com/en/docs/javascript_api
   * https://developers.klaviyo.com/en/docs/guide_to_integrating_a_platform_without_a_pre_built_klaviyo_integration
   */ (0,react.useEffect)(function() {
        var identify = function(event) {
            var ref;
            // Identify a user
            if ((ref = event.detail.user_properties) === null || ref === void 0 ? void 0 : ref.customer_email) {
                var ref1, ref2, ref3;
                klaviyo.identify({
                    email: (ref1 = event.detail.user_properties) === null || ref1 === void 0 ? void 0 : ref1.customer_email,
                    first_name: (ref2 = event.detail.user_properties) === null || ref2 === void 0 ? void 0 : ref2.customer_first_name,
                    last_name: (ref3 = event.detail.user_properties) === null || ref3 === void 0 ? void 0 : ref3.customer_last_name
                });
            }
        };
        var viewItemListListener = function(event) {
            identify(event);
            klaviyo.push([
                "track",
                "Category View",
                {
                    CategoryName: window.location.pathname,
                    CategoryID: event.detail.ecommerce.collection_id
                }, 
            ]);
        };
        var viewItemListener = function(event) {
            identify(event);
            var _products = FueledKlaviyoScript_slicedToArray(event.detail.ecommerce.detail.products, 1), product = _products[0];
            klaviyo.push([
                "track",
                "Viewed Product",
                {
                    ProductName: product.name,
                    ProductID: product.product_id,
                    ImageURL: product.image,
                    URL: document.location.href,
                    Brand: product.brand,
                    Price: product.price,
                    CompareAtPrice: product.price
                }, 
            ]);
            klaviyo.push([
                "trackViewedItem",
                {
                    Title: product.name,
                    ItemId: product.product_id,
                    ImageUrl: product.image,
                    Url: document.location.href,
                    Metadata: {
                        Brand: product.brand,
                        Price: product.price,
                        CompareAtPrice: product.compare_at_price
                    }
                }, 
            ]);
        };
        var addToCartListener = function(event) {
            identify(event);
            var _products = FueledKlaviyoScript_slicedToArray(event.detail.ecommerce.add.products, 1), product = _products[0];
            klaviyo.push([
                "track",
                "Added to Cart",
                {
                    Name: product.name,
                    ProductID: product.product_id,
                    Categories: product.categories,
                    ImageURL: product.image,
                    URL: document.location.href,
                    Brand: product.brand,
                    Price: product.price,
                    Quantity: product.quantity,
                    CompareAtPrice: product.price
                }, 
            ]);
            klaviyo.push([
                "trackViewedItem",
                {
                    Title: product.name,
                    ItemId: product.product_id,
                    ImageUrl: product.image,
                    Url: document.location.href,
                    Metadata: {
                        Brand: product.brand,
                        Price: product.price,
                        Quantity: product.quantity,
                        CompareAtPrice: product.compare_at_price
                    }
                }, 
            ]);
        };
        var klaviyoFormsListener = function(e) {
            if (e.detail.type === "submit") {
                window.dataLayer.push({
                    event: "dl_subscribe",
                    formId: e.detail.formId,
                    formTitle: e.detail.metaData.$source
                });
            }
        };
        var viewSearchResultsListener = function(event) {
            identify(event);
            var products = event.detail.ecommerce.products.map(function(product) {
                return {
                    Name: product.name,
                    ProductID: product.product_id,
                    Price: product.price,
                    Categories: product.category
                };
            });
            window === null || window === void 0 ? void 0 : window.klaviyo.push([
                "track",
                "Searched Site",
                {
                    SearchTerm: event.detail.ecommerce.actionField.search_term,
                    ReturnedResults: products.length,
                    ReturnedProducts: products
                }, 
            ]);
        };
        subscribe(TRACKING_EVENTS.VIEW_ITEM, viewItemListener);
        subscribe(TRACKING_EVENTS.VIEW_ITEM_LIST, viewItemListListener);
        subscribe(TRACKING_EVENTS.ADD_TO_CART, addToCartListener);
        subscribe(TRACKING_EVENTS.VIEW_SEARCH_RESULTS, viewSearchResultsListener);
        window.addEventListener("klaviyoForms", klaviyoFormsListener);
        ready();
        return function() {
            window.removeEventListener("klaviyoForms", klaviyoFormsListener);
        };
    }, [
        status
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledMntnScript.jsx


function FueledMntnScript(param) {
    var mntnPixelId = param.withKey;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        type: "text/javascript",
        dangerouslySetInnerHTML: {
            __html: '\n        (function(){"use strict";var e=null,b="4.0.0",\n        n="'.concat(mntnPixelId, '",\n        additional="term=value",\n        t,r,i;try{t=top.document.referer!==""?encodeURIComponent(top.document.referrer.substring(0,2048)):""}catch(o){t=document.referrer!==null?document.referrer.toString().substring(0,2048):""}try{r=window&&window.top&&document.location&&window.top.location===document.location?document.location:window&&window.top&&window.top.location&&""!==window.top.location?window.top.location:document.location}catch(u){r=document.location}try{i=parent.location.href!==""?encodeURIComponent(parent.location.href.toString().substring(0,2048)):""}catch(a){try{i=r!==null?encodeURIComponent(r.toString().substring(0,2048)):""}catch(f){i=""}}var l,c=document.createElement("script"),h=null,p=document.getElementsByTagName("script"),d=Number(p.length)-1,v=document.getElementsByTagName("script")[d];if(typeof l==="undefined"){l=Math.floor(Math.random()*1e17)}h="dx.mountain.com/spx?"+"dxver="+b+"&shaid="+n+"&tdr="+t+"&plh="+i+"&cb="+l+additional;c.type="text/javascript";c.src=("https:"===document.location.protocol?"https://":"http://")+h;v.parentNode.insertBefore(c,v)})()\n        ')
        }
    });
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/fueled.utils.js
var getEventId = function(event) {
    var ref;
    return (((ref = event.detail) === null || ref === void 0 ? void 0 : ref.event_id) || "").replace(/_/g, "-");
};
var changeFueledConsent = function(consent) {
    var fueled = window.fueled || {};
    if (fueled.setConsent) {
        fueled.setConsent({
            analyticsAllowed: consent.analytics,
            preferencesAllowed: consent.preferences,
            firstPartyMarketingAllowed: consent.marketing,
            thirdPartyMarketingAllowed: consent.sale_of_data
        });
    } else if (typeof fueled.changeConsent === "function") {
        fueled.changeConsent({
            analytics: consent.analytics,
            preferences: consent.preferences,
            marketing: consent.marketing,
            saleOfData: consent.sale_of_data
        });
    }
};

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledTikTokScript.jsx
function FueledTikTokScript_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function FueledTikTokScript_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function FueledTikTokScript_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function FueledTikTokScript_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FueledTikTokScript_slicedToArray(arr, i) {
    return FueledTikTokScript_arrayWithHoles(arr) || FueledTikTokScript_iterableToArrayLimit(arr, i) || FueledTikTokScript_unsupportedIterableToArray(arr, i) || FueledTikTokScript_nonIterableRest();
}
function FueledTikTokScript_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return FueledTikTokScript_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FueledTikTokScript_arrayLikeToArray(o, minLen);
}




function FueledTikTokScript(param) {
    var tiktokPixelId = param.withKey;
    (0,react.useEffect)(function() {
        var identify = function(event) {
            var ref;
            if ((ref = event.detail.user_properties) === null || ref === void 0 ? void 0 : ref.customer_email) {
                var ref1, ref2;
                window.ttq.identify({
                    external_id: (ref1 = event.detail.user_properties) === null || ref1 === void 0 ? void 0 : ref1.customer_id,
                    email: (ref2 = event.detail.user_properties) === null || ref2 === void 0 ? void 0 : ref2.customer_email
                });
            }
        };
        var viewItemListener = function(event) {
            identify(event);
            var eventId = getEventId(event);
            var _products = FueledTikTokScript_slicedToArray(event.detail.ecommerce.detail.products, 1), product = _products[0];
            window.ttq.instance(tiktokPixelId).track("ViewContent", {
                content_name: product.name,
                content_category: product.category,
                content_id: product.product_id,
                content_type: "product_group",
                price: product.price,
                value: product.price,
                currency: event.detail.ecommerce.currency_code
            }, eventId ? {
                event_id: eventId
            } : undefined);
        };
        var addToCartListener = function(event) {
            identify(event);
            var eventId = getEventId(event);
            var _products = FueledTikTokScript_slicedToArray(event.detail.ecommerce.add.products, 1), product = _products[0];
            window.ttq.instance(tiktokPixelId).track("AddToCart", {
                content_name: product.name,
                content_category: product.category,
                content_id: product.product_id,
                content_type: "product_group",
                quantity: product.quantity,
                price: product.price,
                value: product.price * product.quantity,
                currency: event.detail.ecommerce.currency_code
            }, eventId ? {
                event_id: eventId
            } : undefined);
        };
        var viewSearchResultsListener = function(event) {
            try {
                var ref, ref3, ref4;
                identify(event);
                var eventId = getEventId(event);
                var searchTerm = event === null || event === void 0 ? void 0 : (ref = event.detail) === null || ref === void 0 ? void 0 : (ref3 = ref.ecommerce) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.actionField) === null || ref4 === void 0 ? void 0 : ref4.search_term;
                if (searchTerm) {
                    ttq.instance(tiktokPixelId).track("Search", {
                        query: searchTerm
                    }, eventId ? {
                        event_id: eventId
                    } : undefined);
                }
            } catch (e) {
                console.log(e);
            }
        };
        var signUpListener = function(event) {
            try {
                identify(event);
                ttq.instance(tiktokPixelId).track("CompleteRegistration", {});
            } catch (e) {
                console.log(e);
            }
        };
        var viewItemListListener = function(event) {
            try {
                var ref, ref5;
                identify(event);
                var eventId = getEventId(event);
                var collectionProducts = event === null || event === void 0 ? void 0 : (ref = event.detail) === null || ref === void 0 ? void 0 : (ref5 = ref.ecommerce) === null || ref5 === void 0 ? void 0 : ref5.products;
                var contentProducts = collectionProducts.map(function(product) {
                    return {
                        content_name: product.name,
                        content_category: product.category,
                        content_id: product.product_id,
                        content_type: "product_group",
                        price: product.price
                    };
                });
                if (collectionProducts) {
                    var ref6, ref7;
                    ttq.instance(tiktokPixelId).track("ViewContent", {
                        contents: contentProducts,
                        content_type: "product_group",
                        currency: event === null || event === void 0 ? void 0 : (ref6 = event.detail) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.ecommerce) === null || ref7 === void 0 ? void 0 : ref7.currency_code,
                        value: (collectionProducts === null || collectionProducts === void 0 ? void 0 : collectionProducts.reduce(function(acc, item) {
                            return acc += parseFloat(item.price);
                        }, 0)) || []
                    }, eventId ? {
                        event_id: eventId
                    } : undefined);
                }
            } catch (e) {
                console.log(e);
            }
        };
        window.addEventListener("dl_view_item", viewItemListener);
        window.addEventListener("dl_add_to_cart", addToCartListener);
        window.addEventListener("dl_view_search_results", viewSearchResultsListener);
        window.addEventListener("dl_sign_up", signUpListener);
        window.addEventListener("dl_view_item_list", viewItemListListener);
        return function() {
            window.removeEventListener("dl_view_item", viewItemListener);
            window.removeEventListener("dl_add_to_cart", addToCartListener);
            window.removeEventListener("dl_view_search_results", viewSearchResultsListener);
            window.removeEventListener("dl_sign_up", signUpListener);
            window.removeEventListener("dl_view_item_list", viewItemListListener);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        type: "text/javascript",
        dangerouslySetInnerHTML: {
            __html: '\n    !function (w, d, t) { w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];\n    ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],\n    ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};\n    for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);\n    ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},\n    ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";\n    ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};\n    var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;\n    var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}; ttq.load(\''.concat(tiktokPixelId, "'); ttq.page(); }(window, document, 'ttq');")
        }
    });
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledCuVimeoTracking.jsx



var VimeoTrackingScript = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        type: "text/javascript",
        dangerouslySetInnerHTML: {
            __html: "\n        ;(function(document, window, config) {\n\n          'use strict';\n          // The API won't work on LT IE9, so we bail if we detect those UAs\n          if (navigator.userAgent.match(/MSIE [678]./gi)) return;\n\n          config = cleanConfig(config);\n\n          var handle = getHandler(config.syntax);\n\n          if (document.readyState !== 'loading') {\n\n            init();\n\n          } else {\n\n            document.addEventListener('DOMContentLoaded', init);\n\n          }\n\n          // Watch for new iframes popping in\n          document.addEventListener('load', init, true);\n\n          function init() {\n\n            var videos = filter_(selectAllTags_('iframe'), isVimeo);\n\n            if (!videos.length) return;\n\n            loadApi(function() {\n\n              forEach_(videos, listenTo);\n\n            });\n\n          }\n\n          function isVimeo(el) {\n\n            return el.src.indexOf('player.vimeo.com/video/') > -1;\n\n          }\n\n          function loadApi(callback) {\n\n            if (isUndefined_(window.Vimeo)) {\n\n              loadScript('https://player.vimeo.com/api/player.js', callback);\n\n            } else {\n\n              callback();\n\n            }\n\n          }\n\n          function listenTo(el) {\n\n            if (el.__vimeoTracked) return;\n\n            el.__vimeoTracked = true;\n\n            var video = new Vimeo.Player(el);\n            var percentages = config._track.percentages;\n            var eventNameDict = {\n              'Play': 'play',\n              'Pause': 'pause',\n              'Watch to End': 'ended'\n            };\n            var cache = {};\n\n            video.getVideoTitle()\n              .then(function(title) {\n\n                forEach_(['Play', 'Pause', 'Watch to End'], function(key) {\n\n                  if (config.events[key]) {\n\n                    video.on(eventNameDict[key], function() {\n\n                      handle(key, title);\n\n                    });\n\n                  }\n\n                });\n\n                if (percentages) {\n\n                  video.on('timeupdate', function(evt) {\n\n                    var percentage = evt.percent;\n                    var key;\n\n                    for (key in percentages) {\n\n                      if (percentage >= percentages[key] && !cache[key]) {\n\n                        cache[key] = true;\n                        handle(key, title);\n\n                      }\n\n                    }\n\n                  });\n\n                }\n\n              });\n\n          }\n\n          function cleanConfig(config) {\n\n            config = extend_({}, {\n              events: {\n                'Play': true,\n                'Pause': true,\n                'Watch to End': true\n              },\n              percentages: {\n                each: [],\n                every: []\n              }\n            }, config);\n\n            forEach_(['each', 'every'], function(setting) {\n\n              var vals = config.percentages[setting];\n\n              if (!isArray_(vals)) vals = [vals];\n\n              if (vals) config.percentages[setting] = map_(vals, Number);\n\n            });\n\n            var points = [].concat(config.percentages.each);\n\n            if (config.percentages.every) {\n\n              forEach_(config.percentages.every, function(val) {\n\n                var n = 100 / val;\n                var every = [];\n                var i;\n\n                for (i = 1; i < n; i++) every.push(val * i);\n\n                points = points.concat(filter_(every, function(val) {\n\n                  return val > 0.0 && val < 100.0;\n\n                }));\n\n              });\n\n            }\n\n            var percentages = reduce_(points, function(prev, curr) {\n\n              prev[curr + '%'] = curr / 100.0;\n              return prev;\n\n            }, {});\n\n            config._track = {\n              percentages: percentages\n            };\n\n            return config;\n\n          }\n\n          function getHandler(syntax) {\n\n            syntax = syntax || {};\n\n            var gtmGlobal = syntax.name || 'dataLayer';\n            var uaGlobal = syntax.name || window.GoogleAnalyticsObject || 'ga';\n            var clGlobal = '_gaq';\n            var dataLayer;\n\n            var handlers = {\n              'gtm': function(state, title) {\n\n                dataLayer.push({\n                  event: 'vimeoTrack',\n                  attributes: {\n                    videoAction: state,\n                    videoName: title\n                  }\n                });\n\n              },\n              'cl': function(state, title) {\n\n                window[clGlobal].push(['_trackEvent', 'Videos', state, title]);\n\n              },\n              'ua': function(state, title) {\n\n                window[uaGlobal]('send', 'event', 'Videos', state, title);\n\n              }\n            };\n\n            switch(syntax.type) {\n\n              case 'gtm':\n\n                dataLayer = window[gtmGlobal] = window[gtmGlobal] || [];\n                break;\n\n              case 'ua':\n\n                window[uaGlobal] = window[uaGlobal] || function() {\n\n                  (window[uaGlobal].q = window[uaGlobal].q || []).push(arguments);\n\n                };\n                window[uaGlobal].l = +new Date();\n                break;\n\n              case 'cl':\n\n                window[clGlobal] = window[clGlobal] || [];\n                break;\n\n              default:\n\n                if (!isUndefined_(window[gtmGlobal])) {\n\n                  syntax.type = 'gtm';\n                  dataLayer = window[gtmGlobal] = window[gtmGlobal] || [];\n\n                } else if (uaGlobal&& !isUndefined_(window[uaGlobal])) {\n\n                  syntax.type = 'ua';\n\n                } else if (!isUndefined_(window[clGlobal]) && !isUndefined_(window[clGlobal].push)) {\n\n                  syntax.type = 'cl';\n\n                }\n                break;\n            }\n\n            return handlers[syntax.type];\n\n          }\n\n          function extend_() {\n\n            var args = [].slice.call(arguments);\n            var dst = args.shift();\n            var src;\n            var key;\n            var i;\n\n            for (i = 0; i < args.length; i++) {\n\n              src = args[i];\n\n              for (key in src) {\n\n                dst[key] = src[key];\n\n              }\n\n            }\n\n            return dst;\n\n          }\n\n          function isArray_(o) {\n\n            if (Array.isArray_) return Array.isArray_(o);\n\n            return Object.prototype.toString.call(o) === '[object Array]';\n\n          }\n\n          function forEach_(arr, fn) {\n\n            if (Array.prototype.forEach_) return arr.forEach.call(arr, fn);\n\n            var i;\n\n            for (i = 0; i < arr.length; i++) {\n\n              fn.call(window, arr[i], i, arr);\n\n            }\n\n          }\n\n          function map_(arr, fn) {\n\n            if (Array.prototype.map_) return arr.map.call(arr, fn);\n\n            var newArr = [];\n\n            forEach_(arr, function(el, ind, arr) {\n\n              newArr.push(fn.call(window, el, ind, arr));\n\n            });\n\n            return newArr;\n\n          }\n\n\n          function filter_(arr, fn) {\n\n            if (Array.prototype.filter) return arr.filter.call(arr, fn);\n\n            var newArr = [];\n\n            forEach_(arr, function(el, ind, arr) {\n\n              if (fn.call(window, el, ind, arr)) newArr.push(el);\n\n            });\n\n            return newArr;\n\n          }\n\n          function reduce_(arr, fn, init) {\n\n            if (Array.prototype.reduce) return arr.reduce.call(arr, fn, init);\n\n            var result = init;\n            var el;\n            var i;\n\n            for (i = 0; i < arr.length; i++) {\n\n              el = arr[i];\n              result = fn.call(window, result, el, arr, i);\n\n            }\n\n            return result;\n\n          }\n\n          function isUndefined_(thing) {\n\n            return typeof thing === 'undefined';\n\n          }\n\n          function selectAllTags_(tags) {\n\n            if (!isArray_(tags)) tags = [tags];\n\n            return [].slice.call(document.querySelectorAll(tags.join()));\n\n          }\n\n          function loadScript(src, callback) {\n\n            var f, s;\n\n            f = document.getElementsByTagName('script')[0];\n            s = document.createElement('script');\n            s.onload = callCallback;\n            s.src = src;\n            s.async = true;\n\n            f.parentNode.insertBefore(s, f);\n\n            function callCallback() {\n\n              if (callback) {\n\n                callback();\n                s.onload = null;\n\n              }\n\n            }\n\n          }\n\n        })(document, window, {\n          'events': {\n            'Play': true,\n            'Pause': true,\n            'Watch to End': true\n          },\n          'percentages': {\n            'every': 25,\n            'each': [10, 90]\n          }\n        });\n        /*\n          * Configuration Details\n          *\n          * @property events object\n          * Defines which events emitted by YouTube API\n          * will be turned into Google Analytics or GTM events\n          *\n          * @property percentages object\n          * Object with configurations for percentage viewed events\n          *\n          *   @property each Array|Number|String\n          *   Fires an event once each percentage ahs been reached\n          *\n          *   @property every Array|Number|String\n          *   Fires an event for every n% viewed\n          *\n          * @property syntax object\n          * Object with configurations for syntax\n          *\n          *   @property type ('gtm'|'cl'|'ua')\n          *   Forces script to use GTM ('gtm'), Universal Analytics ('ul'), or\n          *   Classic Analytics ('cl'); defaults to auto-detection\n          *\n          *   @property name string\n          *   THIS IS USUALLY UNNECESSARY! Optionally instantiate command queue for syntax\n          *   in question. Useful if the tracking library and tracked events can fire\n          *   before GTM or Google Analytics can be loaded. Be careful with this setting\n          *   if you're new to GA/GTM. GTM or Universal Analytics Only!\n          */\n        "
        }
    });
};
function FueledCuVimeoTracking(param) {
    var withKey = param.withKey;
    var ref = (0,react.useState)(false), isScriptLoaded = ref[0], setIsScriptLoaded = ref[1];
    (0,react.useEffect)(function() {
        if (!isScriptLoaded) {
            setIsScriptLoaded(true);
        }
    }, [
        isScriptLoaded
    ]);
    return isScriptLoaded ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(VimeoTrackingScript, {});
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/useWaitForLoadScript.js

var useWaitForLoadScript_POLL_INTERVAL = 100; // ms
var useWaitForLoadScript_MAX_RETRY = 100; // attempts
function useWaitForLoadScript(callback) {
    var pollInterval = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : useWaitForLoadScript_POLL_INTERVAL, maxRetry = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : useWaitForLoadScript_MAX_RETRY;
    var ref = (0,react.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var attemptsRef = (0,react.useRef)(0);
    var timeoutRef = (0,react.useRef)(null);
    var callbackRef = (0,react.useRef)(callback);
    (0,react.useEffect)(function() {
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0,react.useEffect)(function() {
        var clearTimer = function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
        if (isLoaded || attemptsRef.current >= maxRetry) {
            clearTimer();
            return;
        }
        var check = function() {
            if (callbackRef.current()) {
                setIsLoaded(true);
                clearTimer();
                return;
            }
            attemptsRef.current += 1;
            if (attemptsRef.current < maxRetry) {
                clearTimer();
                timeoutRef.current = setTimeout(check, pollInterval);
            }
        };
        check();
        return function() {
            clearTimer();
        };
    }, [
        callbackRef,
        isLoaded,
        maxRetry,
        pollInterval
    ]);
    return isLoaded;
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledOneTrustScript.jsx





var CONSENT_GROUPS = {
    STRICTLY_NECESSARY: "C0001",
    PERFORMANCE: "C0002",
    FUNCTIONAL: "C0003",
    TARGETING: "C0004"
};
var useGetOneTrustConsent = function() {
    var ref = (0,react.useState)(null), consent = ref[0], setConsent = ref[1];
    var customerPrivacy = useCustomerPrivacy({
        checkoutDomain: "shop.briogeohair.com" || 0,
        storefrontAccessToken: "60385688208d54f843f3c3cb36d767b2",
        onVisitorConsentCollected: function(newConsent) {
            console.log("Visitor consent collected:", newConsent);
            setConsent({
                marketing: newConsent.marketingAllowed,
                analytics: newConsent.analyticsAllowed,
                preferences: newConsent.preferencesAllowed,
                sale_of_data: newConsent.saleOfDataAllowed
            });
        }
    }).customerPrivacy;
    var isOneTrustLoaded = useWaitForLoadScript(function() {
        return window.OneTrust;
    });
    var oneTrustConsentCallback = (0,react.useCallback)(function() {
        if (!(customerPrivacy === null || customerPrivacy === void 0 ? void 0 : customerPrivacy.setTrackingConsent)) {
            return;
        }
        var trackingConsent = {
            marketing: getOneTrustConsentStatus(CONSENT_GROUPS.TARGETING),
            analytics: getOneTrustConsentStatus(CONSENT_GROUPS.PERFORMANCE),
            preferences: getOneTrustConsentStatus(CONSENT_GROUPS.STRICTLY_NECESSARY) || getOneTrustConsentStatus(CONSENT_GROUPS.FUNCTIONAL),
            sale_of_data: getOneTrustConsentStatus(CONSENT_GROUPS.PERFORMANCE) && getOneTrustConsentStatus(CONSENT_GROUPS.TARGETING)
        };
        customerPrivacy.setTrackingConsent(trackingConsent, function() {});
    }, [
        customerPrivacy
    ]);
    (0,react.useEffect)(function() {
        window.OptanonWrapper = oneTrustConsentCallback;
        if (isOneTrustLoaded) {
            oneTrustConsentCallback();
            window.OneTrust.OnConsentChanged(oneTrustConsentCallback);
            return function() {
                window.removeEventListener("OnConsentChanged", oneTrustConsentCallback);
            };
        }
    }, [
        isOneTrustLoaded,
        oneTrustConsentCallback
    ]);
    (0,react.useEffect)(function() {
        if (consent) {
            changeFueledConsent(consent);
        }
        var handleFueledReady = function() {
            if (!consent) return;
            changeFueledConsent(consent);
        };
        window.addEventListener("fueled-ready", handleFueledReady);
        return function() {
            window.removeEventListener("fueled-ready", handleFueledReady);
        };
    }, [
        consent
    ]);
    return consent;
};
var FueledOneTrustScript = function(param) {
    var openTrustId = param.withKey;
    useScriptLoad({
        id: "fueled-open-trust",
        charset: "UTF-8",
        src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
        "data-domain-script": openTrustId
    }, "head");
    return null;
};
function getOneTrustConsentStatus(groupId) {
    try {
        var ref;
        return ((ref = window.OnetrustActiveGroups) === null || ref === void 0 ? void 0 : ref.includes(groupId)) || false;
    } catch (e) {
        console.error("Error checking OneTrust consent status:", e);
        return false;
    }
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledShopMyScript.jsx


function FueledShopMyScript(param) {
    var shopMyScriptId = param.withKey;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        src: "https://static.shopmy.us/Affiliates/".concat(shopMyScriptId, ".js")
    });
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledAmazonScript.jsx


function FueledAmazonScript(param) {
    var amazonTagId = param.withKey;
    var register = useAnalytics().register;
    var status = useScriptLoad({
        id: "fueled-amazon-script",
        innerHTML: '\n        !function(w,d,s,t,a){if(w.amzn)return;w.amzn=a=function(){w.amzn.q.push([arguments,(new Date).getTime()])};a.q=[];a.version="0.0";s=d.createElement("script");s.src="https://c.amazon-adsystem.com/aat/amzn.js";s.id="amzn-pixel";s.async=true;t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t)}(window,document);\n        amzn("setRegion", "NA");\n        amzn("addTag", "'.concat(amazonTagId, '");\n      '),
        waitFor: function() {
            return !!(window === null || window === void 0 ? void 0 : window.amzn);
        }
    }, "head").status;
    var ready = register("fueled-amazon-script");
    (0,react.useEffect)(function() {
        if (status !== "ready") return;
        var pageVisitListener = function() {
            window === null || window === void 0 ? void 0 : window.amzn("trackEvent", "PageView");
        };
        var signUpListener = function() {
            window === null || window === void 0 ? void 0 : window.amzn("trackEvent", "Signup");
        };
        var contactListener = function() {
            window === null || window === void 0 ? void 0 : window.amzn("trackEvent", "Contact");
        };
        var subscribeListener = function() {
            window === null || window === void 0 ? void 0 : window.amzn("trackEvent", "Subscribe");
        };
        var viewSearchResultsListener = function(event) {
            var ref, ref1, ref2;
            var searchTerm = event === null || event === void 0 ? void 0 : (ref = event.detail) === null || ref === void 0 ? void 0 : (ref1 = ref.ecommerce) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.actionField) === null || ref2 === void 0 ? void 0 : ref2.search_term;
            if (searchTerm) {
                window === null || window === void 0 ? void 0 : window.amzn("trackEvent", "Search");
            }
        };
        var leadListener = function() {
            window === null || window === void 0 ? void 0 : window.amzn("trackEvent", "Lead");
        };
        window.addEventListener("dl_route_update", pageVisitListener);
        window.addEventListener("dl_sign_up", signUpListener);
        window.addEventListener("dl_subscribe", contactListener);
        window.addEventListener("dl_subscribe", subscribeListener);
        window.addEventListener("dl_view_search_results", viewSearchResultsListener);
        window.addEventListener("dl_subscribe", leadListener);
        ready();
        return function() {
            window.removeEventListener("dl_route_update", pageVisitListener);
            window.removeEventListener("dl_sign_up", signUpListener);
            window.removeEventListener("dl_subscribe", contactListener);
            window.removeEventListener("dl_subscribe", subscribeListener);
            window.removeEventListener("dl_view_search_results", viewSearchResultsListener);
            window.removeEventListener("dl_subscribe", leadListener);
        };
    }, [
        status
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledCheckmateScript.jsx

function FueledCheckmateScript(param) {
    var storeDomain = param.withKey;
    useScriptLoad({
        id: "fueled-checkmate",
        src: "https://".concat(storeDomain, "/apps/cm/v1/load?source=gtm")
    }, "head");
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/fueled.events.js
var fueled_events_TRACKING_EVENTS = {
    LOGIN: "dl_login",
    SIGN_UP: "dl_sign_up",
    VIEW_CART: "dl_view_cart",
    VIEW_ITEM: "dl_view_item",
    SUBSCRIBE: "dl_subscribe",
    USER_DATA: "dl_user_data",
    ADD_TO_CART: "dl_add_to_cart",
    SELECT_ITEM: "dl_select_item",
    PAGE_VIEW: "dl_route_update",
    VIEW_ITEM_LIST: "dl_view_item_list",
    REMOVE_FROM_CART: "dl_remove_from_cart",
    VIEW_SEARCH_RESULTS: "dl_view_search_results",
    EXPERIMENT_EXPOSURE: "dl_experiment_exposure",
    VIEW_PROMOTION: "dl_view_promotion",
    SELECT_PROMOTION: "dl_select_promotion",
    SELECT_ITEM_LIST_FILTER: "dl_select_item_list_filter",
    DESELECT_ITEM_LIST_FILTER: "dl_deselect_item_list_filter"
};

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/FueledDataLayer.jsx


function FueledDataLayer() {
    // accumulate events until the fueled script is loaded
    (0,react.useEffect)(function() {
        var ref;
        var eventTypes = Object.values(fueled_events_TRACKING_EVENTS);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.packdigital = ((ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.packdigital) || [];
        var eventHandler = function(event) {
            window.dataLayer.packdigital.push({
                type: event.type,
                detail: event.detail
            });
        };
        eventTypes.forEach(function(eventType) {
            return window.addEventListener(eventType, eventHandler);
        });
        return function() {
            eventTypes.forEach(function(eventType) {
                window.removeEventListener(eventType, eventHandler);
            });
        };
    }, []);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/Fueled.jsx








//import { FueledPinterestScript } from './FueledPinterestScript';








var gtmContainerId = "GTM-WPGVRLTQ";
var bingId = "5797150";
var impactPixelId = "A1806740-b579-4dc0-ad40-78a08792fad51";
var klaviyoId = "H6yLPD";
var mntnPixelId = "34984";
var openTrustId = "01936375-4867-7f55-a10f-2e17bf6f641a";
//const pinterestPixelId = '2612642693140';
var tiktokPixelId = "C594AM16C8J46GAV3TH0";
var shopMyScriptId = "sms_aff_clicktrack_briogeo";
var amazonTagId = "95b48d78-c0e2-4811-aa07-5e0ea88ebceb";
var storeDomain = "briogeo-hair-care.myshopify.com" || 0;
var scripts = [
    {
        Component: FueledAccessibleScript,
        consent: [
            "all"
        ]
    },
    {
        withKey: openTrustId,
        Component: FueledOneTrustScript,
        consent: [
            "all"
        ]
    },
    {
        Component: FueledClientScript,
        consent: [
            "all"
        ]
    },
    {
        Component: FueledDataLayer,
        consent: [
            "all"
        ]
    },
    {
        withKey: bingId,
        Component: FueledBingScript,
        consent: [
            "marketing"
        ]
    },
    {
        withKey: impactPixelId,
        Component: FueledImpactScript,
        consent: [
            "marketing"
        ]
    },
    {
        withKey: klaviyoId,
        Component: FueledKlaviyoScript,
        consent: [
            "marketing"
        ]
    },
    {
        withKey: mntnPixelId,
        Component: FueledMntnScript,
        consent: [
            "marketing"
        ]
    },
    {
        withKey: gtmContainerId,
        Component: FueledGtmScript,
        consent: [
            "all"
        ]
    },
    //{ withKey: pinterestPixelId, Component: FueledPinterestScript },
    {
        withKey: tiktokPixelId,
        Component: FueledTikTokScript,
        consent: [
            "marketing"
        ]
    },
    {
        Component: FueledCuVimeoTracking,
        consent: [
            "analytics"
        ]
    },
    {
        withKey: shopMyScriptId,
        Component: FueledShopMyScript,
        // consent: ['marketing'],
        consent: [
            "all"
        ]
    },
    {
        withKey: amazonTagId,
        Component: FueledAmazonScript,
        consent: [
            "marketing"
        ]
    },
    {
        withKey: storeDomain,
        Component: FueledCheckmateScript,
        consent: [
            "marketing"
        ],
        requiresKey: true
    }, 
];
var Fueled = function() {
    var consent = useGetOneTrustConsent();
    useAnalytics(consent); // init analytics
    if (!consent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FueledDataLayer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FueledOneTrustScript, {
                    withKey: openTrustId
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: scripts.filter(function(param) {
            var componentConsent = param.consent;
            return componentConsent.includes("all") || componentConsent.every(function(c) {
                return consent[c];
            });
        }).map(function(param, index) {
            var withKey = param.withKey, Component = param.Component, key = param.key;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                withKey: withKey ? withKey : ""
            }, key ? key : index);
        })
    });
};

;// CONCATENATED MODULE: ./src/snippets/components/Fueled/index.js


;// CONCATENATED MODULE: ./src/snippets/components/Visually.jsx



function Visually() {
    var customer = (0,dist.useCustomer)();
    var router = (0,next_router.useRouter)();
    var pageRoute = router.asPath;
    var cart1 = (0,dist.useCart)();
    var pageType = "other";
    var country = (0,dist.useCountry)().country;
    var product1 = (0,dist.useProduct)();
    var cartAddAttributes = (0,dist.useCartAddAttributes)().cartAddAttributes;
    var cartClear = (0,dist.useCartClear)().cartClear;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    if (pageRoute.indexOf("/products/") > -1) {
        pageType = "product";
    }
    if (pageRoute.indexOf("/collections/") > -1) {
        pageType = "catalog";
    }
    if (pageRoute == "/") {
        pageType = "home";
    }
    var transformCart = function(cart) {
        return cart ? {
            item_count: cart.lines.reduce(function(acc, line) {
                return acc + line.quantity;
            }, 0),
            attributes: cart.attributes || [],
            currency: cart.estimatedCost.totalAmount.currencyCode,
            total_price: cart.estimatedCost.totalAmount.amount * 100,
            original_total_price: cart.estimatedCost.totalAmount.amount * 100,
            token: cart.id.replace("gid://shopify/Cart/", ""),
            items: cart.lines.map(function(line) {
                var ref;
                return {
                    handle: line.variant.product.handle,
                    price: line.variant.priceV2.amount * 100,
                    compare_at_price: ((ref = line.variant.comparePriceV2) === null || ref === void 0 ? void 0 : ref.amount) ? line.variant.comparePriceV2.amount * 100 : null,
                    product_id: parseInt(line.variant.product.id.replace("gid://shopify/Product/", ""), 10),
                    quantity: line.quantity,
                    variant_id: parseInt(line.variant.id.replace("gid://shopify/ProductVariant/", ""), 10),
                    selling_plan_allocation: line.variant.sellingPlanAllocation ? {
                        selling_plan: {
                            name: line.variant.sellingPlanAllocation.name
                        }
                    } : undefined
                };
            })
        } : undefined;
    };
    var transformProduct = function(product) {
        return product ? {
            variants: product === null || product === void 0 ? void 0 : product.variants.map(function(variant) {
                return {
                    id: parseInt(variant.legacyResourceId, 10),
                    iq: variant.quantityAvailable,
                    price: variant.priceV2.amount * 100
                };
            }),
            id: parseInt(product.legacyResourceId, 10),
            oos: !product.variants.some(function(variant) {
                return variant.availableForSale === true;
            })
        } : undefined;
    };
    var visuallyInstrument = (0,react.useMemo)(function() {
        var visuallyObject = {
            addToCart: function(variantId, quantity) {
                cartAddItem({
                    merchandiseId: "gid://shopify/ProductVariant/".concat(variantId),
                    quantity: quantity
                });
            },
            openCartDrawer: function() {
                window.dispatchEvent(new CustomEvent("openSideCart"));
            },
            closeCartDrawer: function() {
                window.dispatchEvent(new CustomEvent("closeSideCart"));
            },
            cartAddAttributes: function(param) {
                var attributes = param.attributes;
                cartAddAttributes({
                    attributes: attributes
                });
            },
            cartClear: function() {
                cartClear();
            },
            pageType: pageType,
            initialLocale: country === null || country === void 0 ? void 0 : country.isoCode,
            initialCurrency: country === null || country === void 0 ? void 0 : country.currency.isoCode,
            initialCart: transformCart(cart1)
        };
        if (!!product1) {
            var ref, ref1;
            visuallyObject.currentProduct = transformProduct(product1);
            visuallyObject.initialProductId = parseInt(product1 === null || product1 === void 0 ? void 0 : product1.legacyResourceId, 10);
            visuallyObject.initialVariantId = parseInt((ref = product1 === null || product1 === void 0 ? void 0 : product1.variants[0]) === null || ref === void 0 ? void 0 : ref.legacyResourceId, 10);
            visuallyObject.initialVariantPrice = parseInt(((ref1 = product1 === null || product1 === void 0 ? void 0 : product1.variants[0]) === null || ref1 === void 0 ? void 0 : ref1.priceV2.amount) * 100, 10);
        }
        if (!!customer) {
            visuallyObject.initialUserId = customer === null || customer === void 0 ? void 0 : customer.id;
            visuallyObject.customerTags = customer === null || customer === void 0 ? void 0 : customer.tags;
        }
        return visuallyObject;
    }, []);
    (0,react.useEffect)(function() {
        if (window.visually) {
            window.visually.visuallyConnect(visuallyInstrument);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (window.visually) {
            window.visually.onUserIdChange(customer === null || customer === void 0 ? void 0 : customer.id);
        }
    }, [
        customer
    ]);
    (0,react.useEffect)(function() {
        if (window.visually && window.visually.pageTypeChanged) {
            window.visually.pageTypeChanged(pageType);
        }
    }, [
        pageType
    ]);
    (0,react.useEffect)(function() {
        if (window.visually && country) {
            window.visually.localeChanged(country.isoCode);
            if (window.visually.currencyChanged) {
                window.visually.currencyChanged(country.currency.isoCode);
            }
        }
    }, [
        country
    ]);
    (0,react.useEffect)(function() {
        if (window.visually) {
            window.visually.productChanged(transformProduct(product1));
        }
    }, [
        product1 === null || product1 === void 0 ? void 0 : product1.id
    ]);
    (0,react.useEffect)(function() {
        if (window.visually) {
            window.visually.onCartChanged(transformCart(cart1));
        }
    }, [
        cart1
    ]);
}
Visually.displayName = "Visually";
/* harmony default export */ var components_Visually = (Visually);

;// CONCATENATED MODULE: ./src/snippets/globals/layout/HeadMeta.jsx

var families = [
    "Plus+Jakarta+Sans",
    "Albert+Sans"
];
var familiesQuery = families.map(function(family) {
    return "family=".concat(family, ":ital,wght@0,400;0,500;0,600;1,400;1,500;1,600");
});
function HeadMeta() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Briogeo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: "/favicon.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://cdn.shopify.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.googleapis.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.gstatic.com",
                crossOrigin: "true"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "stylesheet",
                href: "https://fonts.googleapis.com/css2?".concat(familiesQuery.join("&"), "&display=swap")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: "Briogeo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: "#FFFFFF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "192x192",
                href: "/icons/icon-384x384.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "application-name",
                content: "Briogeo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "default"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-title",
                content: "Briogeo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "format-detection",
                content: "telephone=no"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#FFFFFF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-tap-highlight",
                content: "no"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "google-site-verification",
                content: "5UaEMTGUQlRvHCVHLcQvgjYH3jzxiSlgyg0HRUQ77Go"
            })
        ]
    });
}
/* harmony default export */ var layout_HeadMeta = (HeadMeta);

;// CONCATENATED MODULE: ./src/snippets/components/GeoLocation.jsx
function GeoLocation_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function GeoLocation_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                GeoLocation_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                GeoLocation_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









function GeoLocation() {
    var ref9, ref1;
    var ref2 = (0,dist.useCountry)(), country = ref2.country, updateCountry = ref2.updateCountry;
    var countries = (0,dist.useCountries)();
    var haveCountries = countries === null || countries === void 0 ? void 0 : countries.length;
    var countrySelector = (0,react.useRef)();
    var ref3 = (0,react.useState)(false), enablePrompt = ref3[0], setEnablePrompt = ref3[1];
    var ref4 = (0,react.useState)(), customerCountry = ref4[0], setCustomerCountry = ref4[1];
    var settings = (0,dist.useSettings)();
    var modalDismissed = js_cookie/* default.get */.Z.get("country-selector_modal-dismissed") || false;
    var countryChanged = js_cookie/* default.get */.Z.get("country-selector_country-changed") || false;
    var ref5 = (0,react.useState)(), selectedCountry = ref5[0], setSelectedCountry = ref5[1];
    var getCountry = function() {
        var isoCode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "US";
        return countries.find(function(loopCountry) {
            return loopCountry.isoCode === isoCode;
        });
    };
    var getCustomerCountry = function() {
        var _ref = GeoLocation_asyncToGenerator(runtime_default().mark(function _callee() {
            var customerIsoCode, newCountry, resolvedCountry, newCountry1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        customerIsoCode = js_cookie/* default.get */.Z.get("country-selector_customer-country");
                        if (!(customerIsoCode !== undefined)) {
                            _ctx.next = 5;
                            break;
                        }
                        {
                            setCustomerCountry(customerIsoCode);
                            newCountry = countries === null || countries === void 0 ? void 0 : countries.find(function(loopCountry) {
                                return loopCountry.isoCode === customerIsoCode;
                            });
                            setSelectedCountry(newCountry);
                        }
                        _ctx.next = 12;
                        break;
                    case 5:
                        _ctx.next = 7;
                        return fetch("https://geo-location.chauncey-bad.workers.dev/").then(function(response) {
                            return response.json();
                        }).then(function(response) {
                            return response;
                        });
                    case 7:
                        resolvedCountry = _ctx.sent;
                        js_cookie/* default.set */.Z.set("country-selector_customer-country", resolvedCountry.country);
                        newCountry1 = countries === null || countries === void 0 ? void 0 : countries.find(function(loopCountry) {
                            return loopCountry.isoCode === resolvedCountry.country;
                        });
                        setCustomerCountry(resolvedCountry.country);
                        setSelectedCountry(newCountry1);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getCustomerCountry() {
            return _ref.apply(this, arguments);
        };
    }();
    var closeModal = function() {
        setEnablePrompt(false);
        js_cookie/* default.set */.Z.set("country-selector_modal-dismissed", true);
    };
    var changeSelectedCountry = function(ev) {
        var countryCode = ev.target.value;
        var newCountry = getCountry(countryCode);
        setSelectedCountry(newCountry);
    };
    var changeCountry = function() {
        var _ref = GeoLocation_asyncToGenerator(runtime_default().mark(function _callee(countryCode) {
            var newCountry;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newCountry = getCountry(countryCode);
                        _ctx.next = 3;
                        return updateCountry({
                            country: newCountry
                        });
                    case 3:
                        if (enablePrompt) {
                            closeModal();
                        } else {
                            js_cookie/* default.set */.Z.set("country-selector_country-changed", true);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeCountry(countryCode) {
            return _ref.apply(this, arguments);
        };
    }();
    var replaceVariables = function(text) {
        var ref, ref6, ref7, ref8;
        var updatedText = text;
        updatedText = updatedText.replace(/\\\[currentCountry\\\]|\[currentCountry\]/g, country === null || country === void 0 ? void 0 : country.name);
        updatedText = updatedText.replace(/\\\[storeCurrency\\\]|\[storeCurrency\]/g, "".concat(country === null || country === void 0 ? void 0 : (ref = country.currency) === null || ref === void 0 ? void 0 : ref.isoCode, " ").concat(country === null || country === void 0 ? void 0 : (ref6 = country.currency) === null || ref6 === void 0 ? void 0 : ref6.symbol));
        updatedText = updatedText.replace(/\\\[customerCountry\\\]|\[customerCountry\]/g, selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.name);
        updatedText = updatedText.replace(/\\\[customerCurrency\\\]|\[customerCurrency\]/g, "".concat(selectedCountry === null || selectedCountry === void 0 ? void 0 : (ref7 = selectedCountry.currency) === null || ref7 === void 0 ? void 0 : ref7.isoCode, " ").concat(selectedCountry === null || selectedCountry === void 0 ? void 0 : (ref8 = selectedCountry.currency) === null || ref8 === void 0 ? void 0 : ref8.symbol));
        return updatedText;
    };
    (0,react.useEffect)(function() {
        getCustomerCountry();
    }, []);
    (0,react.useEffect)(function() {
        if (countryChanged || !customerCountry || (countries === null || countries === void 0 ? void 0 : countries.length) === 0 || !country) {
            return function() {};
        }
        if (customerCountry !== (country === null || country === void 0 ? void 0 : country.isoCode)) {
            var ref;
            if ((settings === null || settings === void 0 ? void 0 : (ref = settings.geoLocalization) === null || ref === void 0 ? void 0 : ref.enableNotification) === true) {
                setSelectedCountry(getCountry(customerCountry));
                setEnablePrompt(true);
            } else {
                var countryData = getCountry(customerCountry);
                changeCountry(countryData);
            }
        }
    }, [
        haveCountries,
        country,
        customerCountry,
        settings
    ]);
    return enablePrompt && !modalDismissed && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "geolocation-modal-backdrop fixed z-[5000] flex h-full w-full items-center justify-center before:absolute before:h-full before:w-full before:bg-black before:opacity-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "geolocation-modal z-1 w-[530px] max-w-[90%] bg-white px-5 pt-5 pb-10 text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-header text-right",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "backInStockModalClose",
                        onClick: closeModal,
                        "aria-label": "back In Stock modal close",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconClose */.bM, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: replaceVariables(settings === null || settings === void 0 ? void 0 : (ref9 = settings.geoLocalization) === null || ref9 === void 0 ? void 0 : ref9.modalTitle)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modalBody",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactMarkdown, {
                        rehypePlugins: [
                            rehypeRaw,
                            [
                                (rehype_wrap_default()),
                                {
                                    wrapper: "ul.text-left.pl-0",
                                    selector: "ul"
                                }
                            ], 
                        ],
                        children: replaceVariables(settings === null || settings === void 0 ? void 0 : (ref1 = settings.geoLocalization) === null || ref1 === void 0 ? void 0 : ref1.modalBody)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "select-wrap relative flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "sub-small mb-2 text-left font-hafferBold",
                                htmlFor: "modal-country-selector",
                                children: "Select country"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                className: "w-full cursor-pointer border border-grey-5 py-3 px-4 text-black placeholder-black transition-all placeholder-shown:border-grey-5 hover:border-black hover:placeholder-black focus:placeholder-black focus:outline-ada-outline",
                                name: "modal-country-selector",
                                id: "modal-country-selector",
                                ref: countrySelector,
                                onChange: changeSelectedCountry,
                                defaultValue: customerCountry,
                                children: countries.map(function(loopCountry) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: loopCountry.isoCode,
                                        children: "".concat(loopCountry.name, " (").concat(loopCountry.currency.isoCode, " ").concat(loopCountry.currency.symbol, ")")
                                    }, loopCountry.isoCode);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-5 flex flex-col items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            if ((selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.isoCode) === (country === null || country === void 0 ? void 0 : country.isoCode)) {
                                closeModal();
                            } else {
                                changeCountry(countrySelector.current.value);
                            }
                        },
                        className: "button button--primary",
                        children: (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.isoCode) === (country === null || country === void 0 ? void 0 : country.isoCode) ? "Continue" : "Change Country"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-constants.mjs
const AnalyticsEventName = {
  PAGE_VIEW: "PAGE_VIEW",
  ADD_TO_CART: "ADD_TO_CART",
  PAGE_VIEW_2: "PAGE_VIEW_2",
  COLLECTION_VIEW: "COLLECTION_VIEW",
  PRODUCT_VIEW: "PRODUCT_VIEW",
  SEARCH_VIEW: "SEARCH_VIEW"
};
const AnalyticsPageType = {
  article: "article",
  blog: "blog",
  captcha: "captcha",
  cart: "cart",
  collection: "collection",
  customersAccount: "customers/account",
  customersActivateAccount: "customers/activate_account",
  customersAddresses: "customers/addresses",
  customersLogin: "customers/login",
  customersOrder: "customers/order",
  customersRegister: "customers/register",
  customersResetPassword: "customers/reset_password",
  giftCard: "gift_card",
  home: "index",
  listCollections: "list-collections",
  forbidden: "403",
  notFound: "404",
  page: "page",
  password: "password",
  product: "product",
  policy: "policy",
  search: "search"
};
const ShopifySalesChannel = {
  hydrogen: "hydrogen",
  headless: "headless"
};
const ShopifyAppId = {
  hydrogen: "6167201",
  headless: "12875497473"
};

//# sourceMappingURL=analytics-constants.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-utils.mjs
function schemaWrapper(schemaId, payload) {
  return {
    schema_id: schemaId,
    payload,
    metadata: {
      event_created_at_ms: Date.now()
    }
  };
}
function parseGid(gid) {
  const defaultReturn = {
    id: "",
    resource: null,
    resourceId: null,
    search: "",
    searchParams: new URLSearchParams(),
    hash: ""
  };
  if (typeof gid !== "string") {
    return defaultReturn;
  }
  try {
    const { search, searchParams, pathname, hash } = new URL(gid);
    const pathnameParts = pathname.split("/");
    const lastPathnamePart = pathnameParts[pathnameParts.length - 1];
    const resourcePart = pathnameParts[pathnameParts.length - 2];
    if (!lastPathnamePart || !resourcePart) {
      return defaultReturn;
    }
    const id = `${lastPathnamePart}${search}${hash}` || "";
    const resourceId = lastPathnamePart || null;
    const resource = resourcePart ?? null;
    return { id, resource, resourceId, search, searchParams, hash };
  } catch {
    return defaultReturn;
  }
}
function addDataIf(keyValuePairs, formattedData) {
  if (typeof keyValuePairs !== "object") {
    return {};
  }
  Object.entries(keyValuePairs).forEach(([key, value]) => {
    if (value) {
      formattedData[key] = value;
    }
  });
  return formattedData;
}
function errorIfServer(fnName) {
  if (typeof document === "undefined") {
    console.error(
      `${fnName} should only be used within the useEffect callback or event handlers`
    );
    return true;
  }
  return false;
}

//# sourceMappingURL=analytics-utils.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/tracking-utils.mjs
const SHOPIFY_VISIT_TOKEN_HEADER = "X-Shopify-VisitToken";
const SHOPIFY_UNIQUE_TOKEN_HEADER = "X-Shopify-UniqueToken";
const cachedTrackingValues = { current: null };
function tracking_utils_getTrackingValues(cookieString) {
  var _a, _b, _c;
  let trackingValues;
  if (typeof window !== "undefined" && typeof window.performance !== "undefined") {
    try {
      const resourceRE = /^https?:\/\/([^/]+)(\/api\/(?:unstable|2\d{3}-\d{2})\/graphql\.json(?=$|\?))?/;
      const entries = performance.getEntriesByType(
        "resource"
      );
      let matchedValues;
      for (let i = entries.length - 1; i >= 0; i--) {
        const entry = entries[i];
        if (entry.initiatorType !== "fetch")
          continue;
        const currentHost = window.location.host;
        const match = entry.name.match(resourceRE);
        if (!match)
          continue;
        const [, matchedHost, sfapiPath] = match;
        const isMatch = (
          // Same origin (exact host match)
          matchedHost === currentHost || // Subdomain with SFAPI path
          sfapiPath && (matchedHost == null ? void 0 : matchedHost.endsWith(`.${currentHost}`))
        );
        if (isMatch) {
          const values = extractFromPerformanceEntry(entry);
          if (values) {
            matchedValues = values;
            break;
          }
        }
      }
      if (matchedValues) {
        trackingValues = matchedValues;
      }
      if (trackingValues) {
        cachedTrackingValues.current = trackingValues;
      } else if (cachedTrackingValues.current) {
        trackingValues = cachedTrackingValues.current;
      }
      if (!trackingValues) {
        const navigationEntries = performance.getEntriesByType(
          "navigation"
        )[0];
        trackingValues = extractFromPerformanceEntry(navigationEntries, false);
      }
    } catch {
    }
  }
  if (!trackingValues) {
    const cookie = typeof cookieString === "string" ? cookieString : typeof document !== "undefined" ? document.cookie : "";
    trackingValues = {
      uniqueToken: ((_a = cookie.match(/\b_shopify_y=([^;]+)/)) == null ? void 0 : _a[1]) || "",
      visitToken: ((_b = cookie.match(/\b_shopify_s=([^;]+)/)) == null ? void 0 : _b[1]) || "",
      consent: ((_c = cookie.match(/\b_tracking_consent=([^;]+)/)) == null ? void 0 : _c[1]) || ""
    };
  }
  return trackingValues;
}
function extractFromPerformanceEntry(entry, isConsentRequired = true) {
  let uniqueToken = "";
  let visitToken = "";
  let consent = "";
  const serverTiming = entry.serverTiming;
  if (serverTiming && serverTiming.length >= 3) {
    for (let i = serverTiming.length - 1; i >= 0; i--) {
      const { name, description } = serverTiming[i];
      if (!name || !description)
        continue;
      if (name === "_y") {
        uniqueToken = description;
      } else if (name === "_s") {
        visitToken = description;
      } else if (name === "_cmp") {
        consent = description;
      }
      if (uniqueToken && visitToken && consent)
        break;
    }
  }
  return uniqueToken && visitToken && (isConsentRequired ? consent : true) ? { uniqueToken, visitToken, consent } : void 0;
}

//# sourceMappingURL=tracking-utils.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/cookies-utils.mjs


const tokenHash = "xxxx-4xxx-xxxx-xxxxxxxxxxxx";
function buildUUID() {
  let hash = "";
  try {
    const crypto = window.crypto;
    const randomValuesArray = new Uint16Array(31);
    crypto.getRandomValues(randomValuesArray);
    let i = 0;
    hash = tokenHash.replace(/[x]/g, (c) => {
      const r = randomValuesArray[i] % 16;
      const v = c === "x" ? r : r & 3 | 8;
      i++;
      return v.toString(16);
    }).toUpperCase();
  } catch (err) {
    hash = tokenHash.replace(/[x]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === "x" ? r : r & 3 | 8;
      return v.toString(16);
    }).toUpperCase();
  }
  return `${hexTime()}-${hash}`;
}
function hexTime() {
  let dateNumber = 0;
  let perfNumber = 0;
  dateNumber = (/* @__PURE__ */ new Date()).getTime() >>> 0;
  try {
    perfNumber = performance.now() >>> 0;
  } catch (err) {
    perfNumber = 0;
  }
  const output = Math.abs(dateNumber + perfNumber).toString(16).toLowerCase();
  return output.padStart(8, "0");
}
function getShopifyCookies(cookies) {
  const trackingValues = getTrackingValues(cookies);
  return {
    [SHOPIFY_Y]: trackingValues.uniqueToken,
    [SHOPIFY_S]: trackingValues.visitToken
  };
}

//# sourceMappingURL=cookies-utils.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-schema-trekkie-storefront-page-view.mjs



const SCHEMA_ID = "trekkie_storefront_page_view/1.4";
const OXYGEN_DOMAIN = "myshopify.dev";
function pageView(payload) {
  const pageViewPayload = payload;
  const { id, resource } = parseGid(pageViewPayload.resourceId);
  const resourceType = resource ? resource.toLowerCase() : void 0;
  return [
    schemaWrapper(
      SCHEMA_ID,
      addDataIf(
        {
          pageType: pageViewPayload.pageType,
          customerId: parseInt(parseGid(pageViewPayload.customerId).id || "0"),
          resourceType,
          resourceId: parseInt(id)
        },
        formatPayload(pageViewPayload)
      )
    )
  ];
}
function formatPayload(payload) {
  return {
    appClientId: payload.shopifySalesChannel ? ShopifyAppId[payload.shopifySalesChannel] : ShopifyAppId.headless,
    isMerchantRequest: isMerchantRequest(payload.url),
    hydrogenSubchannelId: payload.storefrontId || payload.hydrogenSubchannelId || "0",
    isPersistentCookie: payload.hasUserConsent,
    uniqToken: payload.uniqueToken,
    visitToken: payload.visitToken,
    microSessionId: buildUUID(),
    microSessionCount: 1,
    url: payload.url,
    path: payload.path,
    search: payload.search,
    referrer: payload.referrer,
    title: payload.title,
    shopId: parseInt(parseGid(payload.shopId).id),
    currency: payload.currency,
    contentLanguage: payload.acceptedLanguage || "en"
  };
}
function isMerchantRequest(url) {
  if (typeof url !== "string") {
    return false;
  }
  const hostname = new URL(url).hostname;
  if (hostname.indexOf(OXYGEN_DOMAIN) !== -1 || hostname === "localhost") {
    return true;
  }
  return false;
}

//# sourceMappingURL=analytics-schema-trekkie-storefront-page-view.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/packages/hydrogen-react/package.json.mjs
const version = "2024.10.2";

//# sourceMappingURL=package.json.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-schema-custom-storefront-customer-tracking.mjs




const analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID = "custom_storefront_customer_tracking/1.2";
const PAGE_RENDERED_EVENT_NAME = "page_rendered";
const COLLECTION_PAGE_RENDERED_EVENT_NAME = "collection_page_rendered";
const PRODUCT_PAGE_RENDERED_EVENT_NAME = "product_page_rendered";
const PRODUCT_ADDED_TO_CART_EVENT_NAME = "product_added_to_cart";
const SEARCH_SUBMITTED_EVENT_NAME = "search_submitted";
function prepareAdditionalPayload(payload) {
  return {
    canonical_url: payload.canonicalUrl || payload.url,
    customer_id: parseInt(parseGid(payload.customerId).id || "0")
  };
}
function analytics_schema_custom_storefront_customer_tracking_pageView(payload) {
  const pageViewPayload = payload;
  const additionalPayload = prepareAdditionalPayload(pageViewPayload);
  const pageType = pageViewPayload.pageType;
  const pageViewEvents = [];
  pageViewEvents.push(
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: PAGE_RENDERED_EVENT_NAME,
          ...additionalPayload
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  );
  switch (pageType) {
    case AnalyticsPageType.collection:
      pageViewEvents.push(
        schemaWrapper(
          analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
          addDataIf(
            {
              event_name: COLLECTION_PAGE_RENDERED_EVENT_NAME,
              ...additionalPayload,
              collection_name: pageViewPayload.collectionHandle,
              collection_id: parseInt(
                parseGid(pageViewPayload.collectionId).id
              )
            },
            analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
          )
        )
      );
      break;
    case AnalyticsPageType.product:
      pageViewEvents.push(
        schemaWrapper(
          analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
          addDataIf(
            {
              event_name: PRODUCT_PAGE_RENDERED_EVENT_NAME,
              ...additionalPayload,
              products: formatProductPayload(pageViewPayload.products),
              total_value: pageViewPayload.totalValue
            },
            analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
          )
        )
      );
      break;
    case AnalyticsPageType.search:
      pageViewEvents.push(
        schemaWrapper(
          analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
          addDataIf(
            {
              event_name: SEARCH_SUBMITTED_EVENT_NAME,
              ...additionalPayload,
              search_string: pageViewPayload.searchString
            },
            analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
          )
        )
      );
      break;
  }
  return pageViewEvents;
}
function pageView2(payload) {
  const pageViewPayload = payload;
  const additionalPayload = prepareAdditionalPayload(pageViewPayload);
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: PAGE_RENDERED_EVENT_NAME,
          ...additionalPayload
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  ];
}
function collectionView(payload) {
  const pageViewPayload = payload;
  const additionalPayload = prepareAdditionalPayload(pageViewPayload);
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: COLLECTION_PAGE_RENDERED_EVENT_NAME,
          ...additionalPayload,
          collection_name: pageViewPayload.collectionHandle,
          collection_id: parseInt(parseGid(pageViewPayload.collectionId).id)
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  ];
}
function productView(payload) {
  const pageViewPayload = payload;
  const additionalPayload = prepareAdditionalPayload(pageViewPayload);
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: PRODUCT_PAGE_RENDERED_EVENT_NAME,
          ...additionalPayload,
          products: formatProductPayload(pageViewPayload.products),
          total_value: pageViewPayload.totalValue
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  ];
}
function searchView(payload) {
  const pageViewPayload = payload;
  const additionalPayload = prepareAdditionalPayload(pageViewPayload);
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: SEARCH_SUBMITTED_EVENT_NAME,
          ...additionalPayload,
          search_string: pageViewPayload.searchString
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  ];
}
function addToCart(payload) {
  const addToCartPayload = payload;
  const cartToken = parseGid(addToCartPayload.cartId);
  const cart_token = (cartToken == null ? void 0 : cartToken.id) ? `${cartToken.id}` : null;
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: PRODUCT_ADDED_TO_CART_EVENT_NAME,
          customerId: addToCartPayload.customerId,
          cart_token,
          total_value: addToCartPayload.totalValue,
          products: formatProductPayload(addToCartPayload.products),
          customer_id: parseInt(
            parseGid(addToCartPayload.customerId).id || "0"
          )
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(addToCartPayload)
      )
    )
  ];
}
function analytics_schema_custom_storefront_customer_tracking_formatPayload(payload) {
  return {
    source: payload.shopifySalesChannel || ShopifySalesChannel.headless,
    asset_version_id: payload.assetVersionId || version,
    hydrogenSubchannelId: payload.storefrontId || payload.hydrogenSubchannelId || "0",
    is_persistent_cookie: payload.hasUserConsent,
    deprecated_visit_token: payload.visitToken,
    unique_token: payload.uniqueToken,
    event_time: Date.now(),
    event_id: buildUUID(),
    event_source_url: payload.url,
    referrer: payload.referrer,
    user_agent: payload.userAgent,
    navigation_type: payload.navigationType,
    navigation_api: payload.navigationApi,
    shop_id: parseInt(parseGid(payload.shopId).id),
    currency: payload.currency,
    ccpa_enforced: payload.ccpaEnforced || false,
    gdpr_enforced: payload.gdprEnforced || false,
    gdpr_enforced_as_string: payload.gdprEnforced ? "true" : "false",
    analytics_allowed: payload.analyticsAllowed || false,
    marketing_allowed: payload.marketingAllowed || false,
    sale_of_data_allowed: payload.saleOfDataAllowed || false
  };
}
function formatProductPayload(products) {
  return products ? products.map((p) => {
    const product = addDataIf(
      {
        variant_gid: p.variantGid,
        category: p.category,
        sku: p.sku,
        product_id: parseInt(parseGid(p.productGid).id),
        variant_id: parseInt(parseGid(p.variantGid).id)
      },
      {
        product_gid: p.productGid,
        name: p.name,
        variant: p.variantName || "",
        brand: p.brand,
        price: parseFloat(p.price),
        quantity: Number(p.quantity || 0)
      }
    );
    return JSON.stringify(product);
  }) : [];
}

//# sourceMappingURL=analytics-schema-custom-storefront-customer-tracking.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics.mjs





function sendShopifyAnalytics(event, shopDomain) {
  const { eventName, payload } = event;
  if (!payload.hasUserConsent)
    return Promise.resolve();
  let events = [];
  const pageViewPayload = payload;
  if (eventName === AnalyticsEventName.PAGE_VIEW) {
    events = events.concat(
      pageView(pageViewPayload),
      analytics_schema_custom_storefront_customer_tracking_pageView(pageViewPayload)
    );
  } else if (eventName === AnalyticsEventName.ADD_TO_CART) {
    events = events.concat(
      addToCart(payload)
    );
  } else if (eventName === AnalyticsEventName.PAGE_VIEW_2) {
    events = events.concat(
      pageView(pageViewPayload),
      pageView2(pageViewPayload)
    );
  } else if (eventName === AnalyticsEventName.COLLECTION_VIEW) {
    events = events.concat(collectionView(pageViewPayload));
  } else if (eventName === AnalyticsEventName.PRODUCT_VIEW) {
    events = events.concat(productView(pageViewPayload));
  } else if (eventName === AnalyticsEventName.SEARCH_VIEW) {
    events = events.concat(searchView(pageViewPayload));
  }
  if (events.length) {
    return sendToShopify(events, shopDomain);
  } else {
    return Promise.resolve();
  }
}
function isLighthouseUserAgent() {
  if (typeof window === "undefined" || !window.navigator)
    return false;
  return /Chrome-Lighthouse/.test(window.navigator.userAgent);
}
const ERROR_MESSAGE = "sendShopifyAnalytics request is unsuccessful";
function sendToShopify(events, shopDomain) {
  if (isLighthouseUserAgent()) {
    return Promise.resolve();
  }
  const eventsToBeSent = {
    events,
    metadata: {
      event_sent_at_ms: Date.now()
    }
  };
  try {
    return fetch(
      shopDomain ? `https://${shopDomain}/.well-known/shopify/monorail/unstable/produce_batch` : "https://monorail-edge.shopifysvc.com/unstable/produce_batch",
      {
        method: "post",
        headers: {
          "content-type": "text/plain"
        },
        body: JSON.stringify(eventsToBeSent)
      }
    ).then((response) => {
      if (!response.ok) {
        throw new Error("Response failed");
      }
      return response.text();
    }).then((data) => {
      if (data) {
        const jsonResponse = JSON.parse(data);
        jsonResponse.result.forEach((eventResponse) => {
          if (eventResponse.status !== 200) {
            console.error(ERROR_MESSAGE, "\n\n", eventResponse.message);
          }
        });
      }
    }).catch((err) => {
      console.error(ERROR_MESSAGE, err);
      if (false)
        {}
    });
  } catch (error) {
    return Promise.resolve();
  }
}
function getClientBrowserParameters() {
  if (errorIfServer("getClientBrowserParameters")) {
    return {
      uniqueToken: "",
      visitToken: "",
      url: "",
      path: "",
      search: "",
      referrer: "",
      title: "",
      userAgent: "",
      navigationType: "",
      navigationApi: ""
    };
  }
  const [navigationType, navigationApi] = getNavigationType();
  const trackingValues = tracking_utils_getTrackingValues();
  return {
    uniqueToken: trackingValues.uniqueToken,
    visitToken: trackingValues.visitToken,
    url: location.href,
    path: location.pathname,
    search: location.search,
    referrer: document.referrer,
    title: document.title,
    userAgent: navigator.userAgent,
    navigationType,
    navigationApi
  };
}
function getNavigationTypeExperimental() {
  try {
    const navigationEntries = (performance == null ? void 0 : performance.getEntriesByType) && (performance == null ? void 0 : performance.getEntriesByType("navigation"));
    if (navigationEntries && navigationEntries[0]) {
      const rawType = window.performance.getEntriesByType(
        "navigation"
      )[0]["type"];
      const navType = rawType && rawType.toString();
      return navType;
    }
  } catch (err) {
  }
  return void 0;
}
function getNavigationTypeLegacy() {
  var _a, _b;
  try {
    if (PerformanceNavigation && ((_a = performance == null ? void 0 : performance.navigation) == null ? void 0 : _a.type) !== null && ((_b = performance == null ? void 0 : performance.navigation) == null ? void 0 : _b.type) !== void 0) {
      const rawType = performance.navigation.type;
      switch (rawType) {
        case PerformanceNavigation.TYPE_NAVIGATE:
          return "navigate";
          break;
        case PerformanceNavigation.TYPE_RELOAD:
          return "reload";
          break;
        case PerformanceNavigation.TYPE_BACK_FORWARD:
          return "back_forward";
          break;
        default:
          return `unknown: ${rawType}`;
      }
    }
  } catch (err) {
  }
  return void 0;
}
function getNavigationType() {
  try {
    let navApi = "PerformanceNavigationTiming";
    let navType = getNavigationTypeExperimental();
    if (!navType) {
      navType = getNavigationTypeLegacy();
      navApi = "performance.navigation";
    }
    if (navType) {
      return [navType, navApi];
    } else {
      return ["unknown", "unknown"];
    }
  } catch (err) {
  }
  return ["error", "error"];
}

//# sourceMappingURL=analytics.mjs.map

;// CONCATENATED MODULE: ../node_modules/worktop/cookie/index.mjs
// src/cookie.ts
var g = new Set([
  "domain",
  "path",
  "max-age",
  "expires",
  "samesite",
  "secure",
  "httponly"
]);
function cookie_u(a) {
  let r = {}, e, t, n = 0, m = a.split(/;\s*/g), s, i;
  for (; n < m.length; n++)
    if (t = m[n], e = t.indexOf("="), ~e) {
      if (s = t.substring(0, e++).trim(), i = t.substring(e).trim(), i[0] === '"' && (i = i.substring(1, i.length - 1)), ~i.indexOf("%"))
        try {
          i = decodeURIComponent(i);
        } catch (f) {
        }
      g.has(t = s.toLowerCase()) ? t === "expires" ? r.expires = new Date(i) : t === "max-age" ? r.maxage = +i : r[t] = i : r[s] = i;
    } else
      (s = t.trim().toLowerCase()) && (s === "httponly" || s === "secure") && (r[s] = !0);
  return r;
}
function cookie_l(a, r, e = {}) {
  let t = a + "=" + encodeURIComponent(r);
  return e.expires && (t += "; Expires=" + new Date(e.expires).toUTCString()), e.maxage != null && e.maxage >= 0 && (t += "; Max-Age=" + (e.maxage | 0)), e.domain && (t += "; Domain=" + e.domain), e.path && (t += "; Path=" + e.path), e.samesite && (t += "; SameSite=" + e.samesite), (e.secure || e.samesite === "None") && (t += "; Secure"), e.httponly && (t += "; HttpOnly"), t;
}


;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/cart-constants.mjs
const CART_ID_STORAGE_KEY = "shopifyCartId";
const SHOPIFY_STOREFRONT_ID_HEADER = "Shopify-Storefront-Id";
const SHOPIFY_STOREFRONT_Y_HEADER = "Shopify-Storefront-Y";
const SHOPIFY_STOREFRONT_S_HEADER = "Shopify-Storefront-S";
const cart_constants_SHOPIFY_Y = "_shopify_y";
const cart_constants_SHOPIFY_S = "_shopify_s";

//# sourceMappingURL=cart-constants.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/useShopifyCookies.mjs





const longTermLength = 60 * 60 * 24 * 360 * 1;
const shortTermLength = 60 * 30;
function useShopifyCookies(options) {
  const {
    hasUserConsent,
    domain = "",
    checkoutDomain = "",
    storefrontAccessToken,
    fetchTrackingValues,
    ignoreDeprecatedCookies = false
  } = options || {};
  const coreCookiesReady = useCoreShopifyCookies({
    storefrontAccessToken,
    fetchTrackingValues,
    checkoutDomain
  });
  (0,react.useEffect)(() => {
    if (ignoreDeprecatedCookies || !coreCookiesReady)
      return;
    let currentDomain = domain || window.location.host;
    if (checkoutDomain) {
      const checkoutDomainParts = checkoutDomain.split(".").reverse();
      const currentDomainParts = currentDomain.split(".").reverse();
      const sameDomainParts = [];
      checkoutDomainParts.forEach((part, index) => {
        if (part === currentDomainParts[index]) {
          sameDomainParts.push(part);
        }
      });
      currentDomain = sameDomainParts.reverse().join(".");
    }
    if (/^localhost/.test(currentDomain))
      currentDomain = "";
    const domainWithLeadingDot = currentDomain ? /^\./.test(currentDomain) ? currentDomain : `.${currentDomain}` : "";
    if (hasUserConsent) {
      const trackingValues = tracking_utils_getTrackingValues();
      if ((trackingValues.uniqueToken || trackingValues.visitToken || "").startsWith("00000000-")) {
        return;
      }
      setCookie(
        cart_constants_SHOPIFY_Y,
        trackingValues.uniqueToken || buildUUID(),
        longTermLength,
        domainWithLeadingDot
      );
      setCookie(
        cart_constants_SHOPIFY_S,
        trackingValues.visitToken || buildUUID(),
        shortTermLength,
        domainWithLeadingDot
      );
    } else {
      setCookie(cart_constants_SHOPIFY_Y, "", 0, domainWithLeadingDot);
      setCookie(cart_constants_SHOPIFY_S, "", 0, domainWithLeadingDot);
    }
  }, [
    coreCookiesReady,
    hasUserConsent,
    domain,
    checkoutDomain,
    ignoreDeprecatedCookies
  ]);
  return coreCookiesReady;
}
function setCookie(name, value, maxage, domain) {
  document.cookie = cookie_l(name, value, {
    maxage,
    domain,
    samesite: "Lax",
    path: "/"
  });
}
async function fetchTrackingValuesFromBrowser(storefrontAccessToken, storefrontApiDomain = "") {
  const { uniqueToken, visitToken } = tracking_utils_getTrackingValues();
  const response = await fetch(
    // TODO: update this endpoint when it becomes stable
    `${storefrontApiDomain.replace(/\/+$/, "")}/api/unstable/graphql.json`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...storefrontAccessToken && {
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken
        },
        ...visitToken || uniqueToken ? {
          [SHOPIFY_VISIT_TOKEN_HEADER]: visitToken,
          [SHOPIFY_UNIQUE_TOKEN_HEADER]: uniqueToken
        } : void 0
      },
      body: JSON.stringify({
        query: (
          // This query ensures we get _cmp (consent) server-timing header, which is not available in other queries.
          // This value can be passed later to consent-tracking-api and privacy-banner scripts to avoid extra requests.
          "query ensureCookies { consentManagement { cookies(visitorConsent:{}) { cookieDomain } } }"
        )
      })
    }
  );
  if (!response.ok) {
    throw new Error(
      `Failed to fetch consent from browser: ${response.status} ${response.statusText}`
    );
  }
  await response.json();
  tracking_utils_getTrackingValues();
}
function useCoreShopifyCookies({
  checkoutDomain,
  storefrontAccessToken,
  fetchTrackingValues = false
}) {
  const [cookiesReady, setCookiesReady] = (0,react.useState)(!fetchTrackingValues);
  const hasFetchedTrackingValues = (0,react.useRef)(false);
  (0,react.useEffect)(() => {
    if (!fetchTrackingValues) {
      setCookiesReady(true);
      return;
    }
    if (hasFetchedTrackingValues.current)
      return;
    hasFetchedTrackingValues.current = true;
    fetchTrackingValuesFromBrowser(storefrontAccessToken).catch(
      (error) => checkoutDomain ? (
        // Retry with checkout domain if available to at least
        // get the server-timing values for tracking.
        fetchTrackingValuesFromBrowser(
          storefrontAccessToken,
          checkoutDomain
        )
      ) : Promise.reject(error)
    ).catch((error) => {
      console.warn(
        "[h2:warn:useShopifyCookies] Failed to fetch tracking values from browser: " + (error instanceof Error ? error.message : String(error))
      );
    }).finally(() => {
      setCookiesReady(true);
    });
  }, [checkoutDomain, fetchTrackingValues, storefrontAccessToken]);
  return cookiesReady;
}

//# sourceMappingURL=useShopifyCookies.mjs.map

;// CONCATENATED MODULE: ./src/hooks/shopifyAnalytics/useShopifyAnalyticsAddToCart.js
function useShopifyAnalyticsAddToCart_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useShopifyAnalyticsAddToCart_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useShopifyAnalyticsAddToCart_arrayLikeToArray(arr);
}
function useShopifyAnalyticsAddToCart_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useShopifyAnalyticsAddToCart_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useShopifyAnalyticsAddToCart_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useShopifyAnalyticsAddToCart_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useShopifyAnalyticsAddToCart_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useShopifyAnalyticsAddToCart_toConsumableArray(arr) {
    return useShopifyAnalyticsAddToCart_arrayWithoutHoles(arr) || useShopifyAnalyticsAddToCart_iterableToArray(arr) || useShopifyAnalyticsAddToCart_unsupportedIterableToArray(arr) || useShopifyAnalyticsAddToCart_nonIterableSpread();
}
function useShopifyAnalyticsAddToCart_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useShopifyAnalyticsAddToCart_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useShopifyAnalyticsAddToCart_arrayLikeToArray(o, minLen);
}



function useShopifyAnalyticsAddToCart(param) {
    var basePayload = param.basePayload, sendShopifyAnalyticsEvent = param.sendShopifyAnalyticsEvent;
    var cart = (0,dist.useCart)();
    var cartCount = (0,dist.useCartCount)();
    var cartItems = (0,dist.useCartItems)();
    var ref8 = (0,react.useState)(null), previousCartCount = ref8[0], setPreviousCartCount = ref8[1];
    var ref1 = (0,react.useState)(null), previousCartItems = ref1[0], setPreviousCartItems = ref1[1];
    var ref2 = (0,react.useState)(null), previousCartItemsMap = ref2[0], setPreviousCartItemsMap = ref2[1];
    (0,react.useEffect)(function() {
        if (!basePayload || !cart) return;
        var cartItemsMap = cartItems.reduce(function(acc, line) {
            if (!line.variant) return acc;
            var variantId = line.variant.id;
            if (!acc[variantId]) {
                return useShopifyAnalyticsAddToCart_objectSpread({}, acc, useShopifyAnalyticsAddToCart_defineProperty({}, variantId, [
                    line
                ]));
            }
            return useShopifyAnalyticsAddToCart_objectSpread({}, acc, useShopifyAnalyticsAddToCart_defineProperty({}, variantId, useShopifyAnalyticsAddToCart_toConsumableArray(acc[variantId]).concat([
                line
            ])));
        }, {});
        if (!previousCartItems || cartCount <= previousCartCount) {
            setPreviousCartItems(cartItems);
            setPreviousCartCount(cartCount);
            setPreviousCartItemsMap(cartItemsMap);
            return;
        }
        var isAddedItems = [];
        var isIncreasedItems = [];
        cartItems.forEach(function(line, index) {
            var ref, ref3;
            var variantId = (ref = line.variant) === null || ref === void 0 ? void 0 : ref.id;
            if (!variantId) return;
            var previousLine = (ref3 = previousCartItemsMap[variantId]) === null || ref3 === void 0 ? void 0 : ref3.find(function(prevLine) {
                return fast_deep_equal_default()(prevLine.attributes.filter(function(attr) {
                    return attr.key !== "_addedAt";
                }), line.attributes.filter(function(attr) {
                    return attr.key !== "_addedAt";
                }));
            });
            if (!previousLine) {
                var ref4, ref5;
                isAddedItems.push(useShopifyAnalyticsAddToCart_objectSpread({}, line, {
                    index: index,
                    quantityAdded: line.quantity,
                    totalPrice: (ref4 = line.estimatedCost) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.totalAmount) === null || ref5 === void 0 ? void 0 : ref5.amount
                }));
                return;
            }
            if (line.quantity > previousLine.quantity) {
                var ref6, ref7;
                var quantityAdded = line.quantity - previousLine.quantity;
                var totalAmount = ((ref6 = line.estimatedCost) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.totalAmount) === null || ref7 === void 0 ? void 0 : ref7.amount) || "0";
                isIncreasedItems.push(useShopifyAnalyticsAddToCart_objectSpread({}, line, {
                    index: index,
                    quantityAdded: quantityAdded,
                    totalPrice: (parseFloat(totalAmount) / line.quantity * quantityAdded).toFixed(2)
                }));
            }
        });
        var updatedCartItems = useShopifyAnalyticsAddToCart_toConsumableArray(isAddedItems).concat(useShopifyAnalyticsAddToCart_toConsumableArray(isIncreasedItems));
        if (!updatedCartItems.length) return;
        var totalValue = updatedCartItems.reduce(function(acc, line) {
            return acc + parseFloat(line.totalPrice || "0");
        }, 0);
        var products = updatedCartItems.map(function(line) {
            return useShopifyAnalyticsAddToCart_objectSpread({
                productGid: line.variant.product.id,
                name: line.variant.product.title,
                price: line.totalPrice,
                variantGid: line.variant.id,
                variantName: line.variant.title,
                category: line.variant.product.productType,
                brand: "Briogeo" || 0
            }, line.variant.sku ? {
                sku: line.variant.sku
            } : null, {
                quantity: line.quantityAdded
            });
        });
        sendShopifyAnalyticsEvent(// payload
        useShopifyAnalyticsAddToCart_objectSpread({}, basePayload, {
            cartId: cart.id,
            totalValue: totalValue,
            products: products
        }), // event name
        "ADD_TO_CART", // callback
        function() {
            setPreviousCartItems(cartItems);
            setPreviousCartCount(cartCount);
            setPreviousCartItemsMap(cartItemsMap);
        });
        if (typeof window.ShipScoutTrackAddToCart === "function") {
            ShipScoutTrackAddToCart(updatedCartItems);
        }
    }, [
        basePayload,
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/shopifyAnalytics/useShopifyAnalyticsPageView.js
function useShopifyAnalyticsPageView_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useShopifyAnalyticsPageView_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useShopifyAnalyticsPageView_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var PAGE_TYPES = {
    "/": "home",
    "/account": "customersAccount",
    "/account/activate": "customersActivateAccount",
    "/account/address-book": "customersAddresses",
    "/account/login": "customersLogin",
    "/account/orders/": "customersOrders",
    "/account/register": "customersRegister",
    "/account/reset-password": "customersResetPassword",
    "/articles": "article",
    "/blogs": "blog",
    "/cart": "cart",
    "/collections": "collection",
    "/not-found": "notFound",
    "/pages": "page",
    "/pages/404": "notFound",
    "/pages/privacy-policy": "policy",
    "/pages/search": "search",
    "/products": "product"
};
function useShopifyAnalyticsPageView(param) {
    var basePayload = param.basePayload, collection = param.collection, product = param.product, sendShopifyAnalyticsEvent = param.sendShopifyAnalyticsEvent;
    var pathnameRef = (0,react.useRef)(null);
    var ref = (0,next_router.useRouter)(), asPath = ref.asPath, query = ref.query;
    var pathname = asPath.split("?")[0];
    var searchString = pathname === "/pages/search" && query.term;
    (0,react.useEffect)(function() {
        if (!basePayload || pathnameRef.current === pathname && !searchString) return undefined;
        sendShopifyAnalyticsEvent(// payload
        useShopifyAnalyticsPageView_objectSpread({}, basePayload, {
            canonicalUrl: "".concat("https://www.briogeohair.com").concat(window.location.pathname === "/" ? "" : window.location.pathname),
            pageType: pathname.startsWith("/account/orders/") ? PAGE_TYPES["/account/orders/"] : PAGE_TYPES[pathname] || PAGE_TYPES[pathname.split("/").slice(0, -1).join("/")] || ""
        }, searchString ? {
            searchString: searchString
        } : null, collection ? {
            collectionHandle: collection.handle,
            resourceId: collection.id
        } : null, product ? {
            totalValue: parseFloat(product.priceRange.min),
            resourceId: product.id,
            products: [
                {
                    productGid: product.id,
                    name: product.title,
                    brand: product.vendor,
                    price: product.priceRange.min,
                    category: product.productType
                }, 
            ]
        } : null), // event name
        "PAGE_VIEW");
        pathnameRef.current = pathname;
        return function() {
            pathnameRef.current = pathname;
        };
    }, [
        basePayload,
        pathname,
        searchString
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/shopifyAnalytics/useShopifyAnalytics.js
function useShopifyAnalytics_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useShopifyAnalytics_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useShopifyAnalytics_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useShopifyAnalytics_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useShopifyAnalytics_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useShopifyAnalytics_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useShopifyAnalytics_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






// Envs to set:
// * NEXT_PUBLIC_SHOPIFY_SHOP_ID // see readme on where to obtain
// * NEXT_PUBLIC_SITE_TITLE // provides brand name
var useShopifyAnalytics_DEBUG = true;
var sendShopifyAnalyticsEvent = function() {
    var _ref = useShopifyAnalytics_asyncToGenerator(runtime_default().mark(function _callee(analyticsPageData, eventName, callback) {
        var payload, event;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (AnalyticsEventName[eventName]) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    payload = useShopifyAnalytics_objectSpread({}, getClientBrowserParameters(), analyticsPageData);
                    event = {
                        eventName: AnalyticsEventName[eventName],
                        payload: payload
                    };
                    _ctx.next = 7;
                    return sendShopifyAnalytics(event);
                case 7:
                    if (typeof callback === "function") callback(event);
                    if (useShopifyAnalytics_DEBUG) console.log("sendShopifyAnalytics:event", event);
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("sendShopifyAnalyticsEvent:error", _ctx.t0.message);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function sendShopifyAnalyticsEvent(analyticsPageData, eventName, callback) {
        return _ref.apply(this, arguments);
    };
}();
var hasUserConsent = true;
function useShopifyAnalytics(param) {
    var collection = param.collection, product = param.product;
    var currency = (0,dist.useCurrency)();
    var customer = (0,dist.useCustomer)();
    var settings = (0,dist.useSettings)();
    var enabled = useShopifyAnalytics_objectSpread({}, settings === null || settings === void 0 ? void 0 : settings.analytics).enabled;
    var customerPending = typeof customer === "undefined";
    var basePayload = (0,react.useMemo)(function() {
        if (!currency || customerPending || !enabled || !"9053204") return null;
        return useShopifyAnalytics_objectSpread({
            hasUserConsent: hasUserConsent,
            shopId: "gid://shopify/Shop/".concat("9053204"),
            currency: currency,
            acceptedLanguage: "en",
            shopifySalesChannel: "headless"
        }, customer ? {
            customerId: parseInt(customer.id.split("/").pop(), 10)
        } : null);
    }, [
        currency,
        customer,
        enabled,
        hasUserConsent
    ]);
    useShopifyCookies({
        hasUserConsent: hasUserConsent && !!enabled
    });
    useShopifyAnalyticsPageView({
        basePayload: basePayload,
        collection: collection,
        product: product,
        sendShopifyAnalyticsEvent: sendShopifyAnalyticsEvent
    });
    useShopifyAnalyticsAddToCart({
        basePayload: basePayload,
        sendShopifyAnalyticsEvent: sendShopifyAnalyticsEvent
    });
}

;// CONCATENATED MODULE: ./src/hooks/shopifyAnalytics/index.js


;// CONCATENATED MODULE: ./src/snippets/components/productOptions.jsx
function productOptions_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function productOptions_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return productOptions_arrayLikeToArray(arr);
}
function productOptions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function productOptions_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function productOptions_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function productOptions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            productOptions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function productOptions_toConsumableArray(arr) {
    return productOptions_arrayWithoutHoles(arr) || productOptions_iterableToArray(arr) || productOptions_unsupportedIterableToArray(arr) || productOptions_nonIterableSpread();
}
function productOptions_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return productOptions_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return productOptions_arrayLikeToArray(o, minLen);
}



function ProductOptions(param) {
    var activeVariant = param.activeVariant, product = param.product, _updateUrl = param.updateUrl, updateUrl = _updateUrl === void 0 ? true : _updateUrl, onVariantChange = param.onVariantChange;
    var router = (0,dist.useRouter)();
    var ref = (0,react.useState)((activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.title.split(" / ").map(function(value) {
        return value.trim();
    })) || null), selectedOptions1 = ref[0], setSelectedOptions = ref[1];
    (0,react.useEffect)(function() {
        if (selectedOptions1) {
            var variantTitle = selectedOptions1.join(" / ");
            var selectedVariant = product.variants.find(function(variant) {
                return variant.title === variantTitle;
            });
            if (onVariantChange) {
                onVariantChange(selectedVariant);
            }
            if (updateUrl) {
                router.push({
                    pathname: router.pathname,
                    query: productOptions_objectSpread({}, router.query, {
                        variant: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId
                    })
                }, undefined, {
                    shallow: true
                });
            }
        }
        if ( true && window.hasOwnProperty("updateYotpoWidgets")) {
            updateYotpoWidgets();
        }
    }, [
        selectedOptions1
    ]);
    (0,react.useEffect)(function() {
        setSelectedOptions(activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.title.split(" / ").map(function(value) {
            return value.trim();
        }));
    }, [
        activeVariant
    ]);
    var checkCurrentVariant = function(value, nameIndex) {
        if (!selectedOptions1) return false;
        if (selectedOptions1[nameIndex] === value) {
            return true;
        }
    };
    if (!product || !product.options || product.variants.length <= 1) {
        return null;
    }
    return product.options.map(function(option, nameIndex) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "text-small mb-1 font-hafferBold text-black",
                    children: [
                        " ",
                        option.name,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto flex w-full",
                    children: option.values.map(function(value, valueIndex) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "w-1/6 border border py-2 px-1 font-hafferBold text-[12px] duration-200 hover:border-black hover:bg-grey-9 hover:text-black lg:text-base  xl:text-[14px] ".concat(checkCurrentVariant(value, nameIndex) ? "border-black bg-grey-9 text-black" : "border-grey-4 text-grey-3"),
                            onClick: function() {
                                setSelectedOptions(function(curr) {
                                    var selectedOptions = productOptions_toConsumableArray(curr);
                                    selectedOptions[nameIndex] = value.trim();
                                    return selectedOptions;
                                });
                            },
                            children: value
                        }, valueIndex);
                    })
                })
            ]
        }, nameIndex);
    });
}

// EXTERNAL MODULE: ./src/snippets/icons/DarkCircleCheckmark.jsx
var DarkCircleCheckmark = __webpack_require__(64647);
;// CONCATENATED MODULE: ./src/snippets/globals/layout/QuickViewModal.jsx
function QuickViewModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function QuickViewModal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function QuickViewModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function QuickViewModal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                QuickViewModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                QuickViewModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function QuickViewModal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function QuickViewModal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function QuickViewModal_slicedToArray(arr, i) {
    return QuickViewModal_arrayWithHoles(arr) || QuickViewModal_iterableToArrayLimit(arr, i) || QuickViewModal_unsupportedIterableToArray(arr, i) || QuickViewModal_nonIterableRest();
}
function QuickViewModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return QuickViewModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return QuickViewModal_arrayLikeToArray(o, minLen);
}













function QuickViewModal() {
    var ref41, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
    var settings = (0,dist.useSettings)();
    var ref30 = (0,react.useState)(false), isOpen = ref30[0], setIsOpen = ref30[1];
    var ref31 = (0,react.useState)(null), product1 = ref31[0], setProduct = ref31[1];
    var ref32 = (0,react.useState)(null), selectedPlanId = ref32[0], setSelectedPlanId = ref32[1];
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var inventory = (0,dist.useProductInventoryByHandle)({
        handle: (product1 === null || product1 === void 0 ? void 0 : product1.handle) || "empty"
    }).inventory;
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product1);
    }, [
        product1 === null || product1 === void 0 ? void 0 : product1.id
    ]);
    var promo = metafieldMap.promo_message;
    var comparePriceText = (metafieldMap === null || metafieldMap === void 0 ? void 0 : metafieldMap.custom_compare_at_price) || "";
    var modalFooter = (0,react.useRef)(null);
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var firstUpsellProduct = metafieldMap.product_upsell_1;
    var isComingSoon = metafieldMap.coming_soon;
    var getInitialVariant = function(product) {
        var ref;
        if (!product) return null;
        //! We will find the first avaiable, and set that as the variant
        var firstAvailableVariant = product.variants.find(function(param) {
            var availableForSale = param.availableForSale;
            return availableForSale;
        });
        if (firstAvailableVariant) {
            return firstAvailableVariant;
        }
        if (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) {
            return product.variants[0];
        }
    };
    var ref33 = (0,react.useState)(getInitialVariant(product1)), currentVariant = ref33[0], setCurrentVariant = ref33[1];
    var openModal = function(evt) {
        setProduct(evt.detail.product);
        setIsOpen(true);
    };
    var closeModal = function() {
        setProduct(null);
        setIsOpen(false);
        setSelectedPlanId(null);
    };
    var onVariantChange = function(variant) {
        setCurrentVariant(variant);
    };
    var buildValueProps = function() {
        var valueProps = [];
        for(var i = 1; i <= 3; i++){
            var index = "subscription_value_prop_".concat(i);
            var propValue = metafieldMap[index];
            if (propValue) {
                valueProps.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mr-4 lg:mr-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DarkCircleCheckmark/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-small mb-0",
                            children: propValue
                        })
                    ]
                }));
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mt-8 !hidden flex-col gap-2 md:!flex lg:flex-row justify-between",
            children: valueProps
        });
    };
    if (true) {
        var observer = new IntersectionObserver(function(param) {
            var _param = QuickViewModal_slicedToArray(param, 1), e = _param[0];
            var action = "remove";
            if (e.intersectionRatio < 1) {
                action = "add";
            }
            e.target.classList.toggle("mt-4", e.intersectionRatio === 1);
            e.target.classList[action]("border-t", "border-black", "pt-4", "px-6", "-mx-6");
        }, {
            threshold: [
                1
            ]
        });
    }
    (0,react.useEffect)(function() {
        document.addEventListener("quickViewModal:open", openModal);
        return function() {
            document.removeEventListener("quickViewModal:open", openModal);
        };
    });
    (0,react.useEffect)(function() {
        setCurrentVariant(getInitialVariant(product1));
        if ( true && typeof observer !== "undefined" && modalFooter.current) {
            observer.observe(modalFooter.current);
        }
    }, [
        product1
    ]);
    (0,react.useEffect)(function() {
        var action = "remove";
        if (isOpen) {
            action = "add";
        }
        document.querySelector("body").classList[action]("overflow-hidden");
    }, [
        isOpen
    ]);
    var hasInventory = !(product1 === null || product1 === void 0 ? void 0 : product1.tracksInventory) || ((inventory === null || inventory === void 0 ? void 0 : inventory.totalInventory) || 0) > 0;
    var variantIsAvailable = ((ref41 = inventory === null || inventory === void 0 ? void 0 : inventory.variants[currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.id]) === null || ref41 === void 0 ? void 0 : ref41.availableForSale) && hasInventory || !(product1 === null || product1 === void 0 ? void 0 : product1.tracksInventory);
    var selectedPlan = currentVariant === null || currentVariant === void 0 ? void 0 : (ref1 = currentVariant.sellingPlanAllocations) === null || ref1 === void 0 ? void 0 : ref1.find(function(plan) {
        return (plan === null || plan === void 0 ? void 0 : plan.sellingPlan.id) === selectedPlanId && isUs;
    });
    var isLocalized = !!(currentVariant === null || currentVariant === void 0 ? void 0 : (ref2 = currentVariant.priceV2) === null || ref2 === void 0 ? void 0 : ref2.locale);
    var currencySymbol = isLocalized ? (country === null || country === void 0 ? void 0 : (ref3 = country.currency) === null || ref3 === void 0 ? void 0 : ref3.symbol) || "$" : "$";
    var firstPlan = currentVariant === null || currentVariant === void 0 ? void 0 : (ref4 = currentVariant.sellingPlanAllocations) === null || ref4 === void 0 ? void 0 : ref4[0];
    var planAmount = (selectedPlan === null || selectedPlan === void 0 ? void 0 : (ref5 = selectedPlan.priceAdjustments) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.price) === null || ref7 === void 0 ? void 0 : ref7.amount) || (firstPlan === null || firstPlan === void 0 ? void 0 : (ref8 = firstPlan.priceAdjustments) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.price) === null || ref10 === void 0 ? void 0 : ref10.amount);
    var planPrice = planAmount ? "".concat(currencySymbol).concat(parseFloat(planAmount).toFixed(2)) : null;
    var planOptions = currentVariant === null || currentVariant === void 0 ? void 0 : (ref11 = currentVariant.sellingPlanAllocations) === null || ref11 === void 0 ? void 0 : ref11.map(function(plan) {
        var ref, ref42, ref43;
        return {
            label: plan === null || plan === void 0 ? void 0 : (ref = plan.sellingPlan) === null || ref === void 0 ? void 0 : (ref42 = ref.name) === null || ref42 === void 0 ? void 0 : ref42.replace(/Delivery/i, ""),
            value: plan === null || plan === void 0 ? void 0 : (ref43 = plan.sellingPlan) === null || ref43 === void 0 ? void 0 : ref43.id
        };
    });
    (0,react.useEffect)(function() {
        if (currentVariant) {
            var ref;
            var search = window.location.search;
            var searchParams = new URLSearchParams(search);
            var planId = searchParams.get("selling_plan");
            var activePlan = currentVariant === null || currentVariant === void 0 ? void 0 : (ref = currentVariant.sellingPlanAllocations) === null || ref === void 0 ? void 0 : ref.find(function(plan) {
                return plan.sellingPlan.id.includes(planId);
            });
            if (activePlan) setSelectedPlanId(planId);
            if (product1.enableSubscription && (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.sellingPlanAllocations.length)) {
                var ref44, ref45, ref46;
                setSelectedPlanId(currentVariant === null || currentVariant === void 0 ? void 0 : (ref44 = currentVariant.sellingPlanAllocations) === null || ref44 === void 0 ? void 0 : (ref45 = ref44[0]) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.sellingPlan) === null || ref46 === void 0 ? void 0 : ref46.id);
            }
        }
    }, [
        currentVariant
    ]);
    var variantPrice = "".concat(currencySymbol).concat((currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.priceV2.amount) || 0);
    var compareAmount = parseFloat((currentVariant === null || currentVariant === void 0 ? void 0 : (ref12 = currentVariant.compareAtPriceV2) === null || ref12 === void 0 ? void 0 : ref12.amount) || 0);
    var comparePrice = compareAmount ? "".concat(currencySymbol).concat(compareAmount).replace(".00", "") : null;
    if (selectedPlan) {
        var ref34, ref35, ref36, ref37, ref38, ref39, ref40;
        compareAmount = (currentVariant === null || currentVariant === void 0 ? void 0 : (ref34 = currentVariant.compareAtPriceV2) === null || ref34 === void 0 ? void 0 : ref34.amount) || (selectedPlan === null || selectedPlan === void 0 ? void 0 : (ref35 = selectedPlan.priceAdjustments) === null || ref35 === void 0 ? void 0 : (ref36 = ref35[0]) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.compareAtPrice) === null || ref37 === void 0 ? void 0 : ref37.amount);
        variantPrice = "".concat(currencySymbol).concat((selectedPlan === null || selectedPlan === void 0 ? void 0 : (ref38 = selectedPlan.priceAdjustments) === null || ref38 === void 0 ? void 0 : (ref39 = ref38[0]) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.price) === null || ref40 === void 0 ? void 0 : ref40.amount) || 0);
    }
    var discountValue = null;
    if (compareAmount > 0) {
        discountValue = Math.floor((compareAmount - parseFloat(variantPrice.replace(currencySymbol, ""))) / compareAmount * 100);
    }
    var discountHighlight = (settings === null || settings === void 0 ? void 0 : (ref13 = settings.discountHighlight) === null || ref13 === void 0 ? void 0 : ref13.enableDiscountHighlight) && (settings === null || settings === void 0 ? void 0 : (ref14 = settings.discountHighlight) === null || ref14 === void 0 ? void 0 : ref14.pdpDiscountMessage) && discountValue !== 0 && discountValue !== null;
    (0,react.useEffect)(function() {
        if (vpWidth < 1023) {
            closeModal();
        }
    }, [
        vpWidth
    ]);
    var discountedPrice = (0,Helper/* getDiscountedPrice */._L)(settings === null || settings === void 0 ? void 0 : settings.automaticDiscountCollections, product1, currentVariant, currencySymbol, planAmount);
    if ((discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.productPrice) && (discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.comparePrice)) {
        variantPrice = discountedPrice.productPrice;
        compareAmount = discountedPrice.comparePrice;
        comparePrice = discountedPrice.comparePrice;
        if (planPrice) {
            planPrice = discountedPrice.sellingPlanPrice;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "QuickViewModal fixed top-0 left-0 z-[10000] flex h-full w-full items-center justify-center ".concat(isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-body relative z-[101] mx-auto h-full w-[1075px] max-w-[80%] justify-self-center bg-white p-6 pr-0 pb-12 md:max-h-[590px] md:overflow-y-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-header mb-2 w-full pr-4 text-right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "quickViewModalClose relative -top-2",
                            onClick: closeModal,
                            "aria-label": "Close Quick View",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconClose */.bM, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: "Close Quick View"
                                })
                            ]
                        })
                    }),
                    product1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-body-content quickview-modal-content-container flex h-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-6/12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGallery/* default */.Z, {
                                    product: product1,
                                    quickView: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "h-full w-6/12 overflow-y-auto overflow-x-hidden border-b-transparent px-6 text-left",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInformation/* default */.Z, {
                                        product: product1
                                    }),
                                    !discountHighlight && promo && isUs && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-xsmall md:sub-small text-pink mb-4 quickview-promo-message",
                                        children: promo
                                    }),
                                    discountHighlight && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sub-xsmall md:sub-small text-pink mb-4 quickview-discount-message",
                                        children: settings === null || settings === void 0 ? void 0 : (ref15 = settings.discountHighlight) === null || ref15 === void 0 ? void 0 : ref15.pdpDiscountMessage.replace("[discount]", "".concat(discountValue, "%"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptions, {
                                        product: product1,
                                        updateUrl: false,
                                        onVariantChange: onVariantChange,
                                        activeVariant: currentVariant
                                    }),
                                    isUs && (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.sellingPlanAllocations) && (currentVariant === null || currentVariant === void 0 ? void 0 : (ref16 = currentVariant.sellingPlanAllocations) === null || ref16 === void 0 ? void 0 : ref16.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-7 overflow-hidden border",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "grid w-full grid-cols-[auto_auto_1fr] border-b px-[12px] py-[15px] md:px-[20px] quickViewATC__onetime bg-[#F5F5F5]  ".concat(!selectedPlanId && "bg-[#FFFFFF]"),
                                                type: "button",
                                                onClick: function() {
                                                    setSelectedPlanId(null);
                                                    window.dataLayer.push({
                                                        "event": "Quick View - One time select"
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "relative top-[2px] mr-[10px] h-[18px] w-[18px] cursor-pointer rounded-full border md:top-0 md:mr-[12px] md:h-[20px] md:w-[20px]",
                                                        children: !selectedPlanId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "relative top-[2px] left-[2px] h-[12px] w-[12px] rounded-full bg-black md:h-[14px] md:w-[14px]"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-0 font-hafferBold text-[14px]",
                                                        children: "One-time purchase"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "ml-auto font-hafferBold text-[14px]",
                                                        children: [
                                                            comparePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "product-original-price mr-2 font-hafferBold text-[14px] text-[#757575] line-through",
                                                                        children: "".concat(comparePrice)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "sr-only",
                                                                        children: [
                                                                            "Previous price ",
                                                                            "".concat(comparePrice)
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "".concat((discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.productPrice) ? variantPrice : "$".concat(currentVariant === null || currentVariant === void 0 ? void 0 : (ref17 = currentVariant.price) === null || ref17 === void 0 ? void 0 : ref17.replace(".00", "")))
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "sr-only",
                                                                children: [
                                                                    "Current price ",
                                                                    "".concat((discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.productPrice) ? variantPrice : "$".concat(currentVariant === null || currentVariant === void 0 ? void 0 : (ref18 = currentVariant.price) === null || ref18 === void 0 ? void 0 : ref18.replace(".00", "")))
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(selectedPlanId ? "bg-[#FFFFFF]" : "bg-[#F5F5F5]"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "grid w-full grid-cols-[auto_auto_1fr] px-[12px] py-[15px] md:px-[20px] quickViewATC__subscription",
                                                        onClick: function() {
                                                            var ref;
                                                            setSelectedPlanId(firstPlan === null || firstPlan === void 0 ? void 0 : (ref = firstPlan.sellingPlan) === null || ref === void 0 ? void 0 : ref.id);
                                                            window.dataLayer.push({
                                                                "event": "Quick View - Subscribe & Save select"
                                                            });
                                                        },
                                                        type: "button",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "relative top-[2px] mr-[10px] h-[18px] w-[18px] cursor-pointer rounded-full border md:top-0 md:mr-[12px] md:h-[20px] md:w-[20px]",
                                                                children: selectedPlanId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "relative top-[2px] left-[2px] h-[12px] w-[12px] rounded-full bg-black md:h-[14px] md:w-[14px]"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        className: "mb-0 font-hafferBold text-[14px]",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "whitespace-nowrap",
                                                                                children: ((ref20 = firstPlan === null || firstPlan === void 0 ? void 0 : (ref19 = firstPlan.sellingPlan) === null || ref19 === void 0 ? void 0 : ref19.priceAdjustments[0]) === null || ref20 === void 0 ? void 0 : ref20.adjustmentValue) ? "Subscribe & save ".concat((ref22 = firstPlan === null || firstPlan === void 0 ? void 0 : (ref21 = firstPlan.sellingPlan) === null || ref21 === void 0 ? void 0 : ref21.priceAdjustments[0].adjustmentValue) === null || ref22 === void 0 ? void 0 : ref22.adjustmentPercentage, "%") : "Subscribe"
                                                                            }),
                                                                            (settings === null || settings === void 0 ? void 0 : (ref23 = settings.subscriptions) === null || ref23 === void 0 ? void 0 : ref23.freeShippingText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "ml-[20px] hidden whitespace-nowrap bg-[#E61A4F] px-[7px] py-[4px] text-[11px] text-white xl:inline",
                                                                                children: (settings === null || settings === void 0 ? void 0 : (ref24 = settings.subscriptions) === null || ref24 === void 0 ? void 0 : ref24.freeShippingText) || "Free Shipping"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    (settings === null || settings === void 0 ? void 0 : (ref25 = settings.subscriptions) === null || ref25 === void 0 ? void 0 : ref25.freeShippingText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "whitespace-nowrap bg-[#E61A4F] px-[7px] py-[4px] font-hafferBold text-[11px] text-white xl:hidden",
                                                                        children: (settings === null || settings === void 0 ? void 0 : (ref26 = settings.subscriptions) === null || ref26 === void 0 ? void 0 : ref26.freeShippingText) || "Free Shipping"
                                                                    })
                                                                ]
                                                            }),
                                                            planPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "ml-auto",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "product-original-price ml-4 font-hafferBold text-[14px] text-[#757575] line-through",
                                                                        children: "".concat((discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.productPrice) ? variantPrice : "$".concat(currentVariant === null || currentVariant === void 0 ? void 0 : (ref27 = currentVariant.price) === null || ref27 === void 0 ? void 0 : ref27.replace(".00", "")))
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "sr-only",
                                                                        children: [
                                                                            "Previous price ",
                                                                            "".concat((discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.productPrice) ? variantPrice : "$".concat(currentVariant === null || currentVariant === void 0 ? void 0 : (ref28 = currentVariant.price) === null || ref28 === void 0 ? void 0 : ref28.replace(".00", "")))
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "ml-2 font-hafferBold text-[14px]",
                                                                        children: planPrice
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "sr-only",
                                                                        children: [
                                                                            "Current price ",
                                                                            "".concat(planPrice)
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "ml-auto",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-hafferBold text-[14px]",
                                                                    children: variantPrice
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    selectedPlanId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "px-[12px] pb-[15px] md:px-[20px]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mb-[8px] flex items-end whitespace-nowrap",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-[12px] text-black",
                                                                        children: "Ships every:"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "select-wrap-2 relative flex flex-col",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                                            className: "ml-2 cursor-pointer border-0 border-b bg-transparent px-2 pb-0 pr-4 pt-0 font-hafferBold text-[12px] text-black text-black placeholder-black outline-0 hover:placeholder-black focus:placeholder-black",
                                                                            name: "selling-plan-select",
                                                                            id: "selling-plan-select",
                                                                            value: selectedPlanId,
                                                                            onChange: function(e) {
                                                                                setSelectedPlanId(e.target.value);
                                                                            },
                                                                            children: planOptions.map(function(option, optionIndex) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                    value: option.value,
                                                                                    children: option.label
                                                                                }, "option-selling-plan-select-".concat(optionIndex));
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "mt-[10px] flex items-baseline whitespace-nowrap",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-[11px] text-black ",
                                                                    children: (settings === null || settings === void 0 ? void 0 : (ref29 = settings.subscriptions) === null || ref29 === void 0 ? void 0 : ref29.cancelText) || "Cancel anytime + membership perks."
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "quick-view__footer sticky bottom-[-2px] mt-6 bg-white",
                                        ref: modalFooter,
                                        children: [
                                            variantIsAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                type: "button",
                                                className: "button button--checkout flex w-full justify-center md:px-4 md:text-[12px] lg:text-[16px]",
                                                onClick: QuickViewModal_asyncToGenerator(runtime_default().mark(function _callee() {
                                                    var addItem;
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                _ctx.prev = 0;
                                                                addItem = selectedPlanId && isUs ? {
                                                                    merchandiseId: currentVariant.id,
                                                                    sellingPlanId: btoa(selectedPlanId),
                                                                    quantity: 1,
                                                                    attributes: [
                                                                        {
                                                                            key: "_sellingPlan",
                                                                            value: selectedPlanId
                                                                        }, 
                                                                    ]
                                                                } : {
                                                                    merchandiseId: currentVariant.id,
                                                                    quantity: 1,
                                                                    attributes: []
                                                                };
                                                                if (firstUpsellProduct) {
                                                                    addItem.attributes.push({
                                                                        key: "_upsellProduct",
                                                                        value: firstUpsellProduct
                                                                    });
                                                                }
                                                                if (typeof window.ShipScoutLineItemProperty !== "undefined") {
                                                                    addItem.attributes.push({
                                                                        key: "_sc",
                                                                        value: window.ShipScoutLineItemProperty
                                                                    });
                                                                }
                                                                _ctx.next = 6;
                                                                return cartAddItem(addItem, function() {
                                                                    window.dispatchEvent(new CustomEvent("openSideCart"));
                                                                    closeModal();
                                                                    if (selectedPlanId) {
                                                                        window.dataLayer.push({
                                                                            "event": "Quick View - Add_to_cart Subscribe & Save"
                                                                        });
                                                                    } else {
                                                                        window.dataLayer.push({
                                                                            "event": "Quick View - Add_to_cart One Time"
                                                                        });
                                                                    }
                                                                });
                                                            case 6:
                                                                _ctx.next = 12;
                                                                break;
                                                            case 8:
                                                                _ctx.prev = 8;
                                                                _ctx.t0 = _ctx["catch"](0);
                                                                console.error(_ctx.t0);
                                                                alert("Something went wrong while adding to cart, please try again.");
                                                            case 12:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee, null, [
                                                        [
                                                            0,
                                                            8
                                                        ]
                                                    ]);
                                                })),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-hafferBold tracking-side",
                                                        children: "add to cart"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
                                                        product: product1,
                                                        variant: currentVariant,
                                                        className: "ml-4 !text-base !text-currentcolor",
                                                        compareStyles: "!text-currentcolor !mr-2",
                                                        selectedPlan: selectedPlan,
                                                        planPrice: planPrice,
                                                        comparePriceText: comparePriceText
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                className: "button button--primary flex w-full justify-center md:px-4 md:text-[12px] lg:text-[16px]",
                                                children: isComingSoon !== "true" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-hafferBold tracking-side",
                                                    children: hasInventory ? "unavailable" : "out of stock"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-hafferBold tracking-side",
                                                    children: "Coming Soon"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-2 text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/products/".concat(product1.handle).concat(isUs === true && product1.enableSubscription === true ? "?subscription" : ""),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "focus-link text-sm",
                                                        onClick: function() {
                                                            closeModal();
                                                        },
                                                        children: "more details"
                                                    })
                                                })
                                            }),
                                            isUs === true && product1.enableSubscription === true && buildValueProps()
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modalBackdrop z-103 fixed top-0 left-0 h-full w-full cursor-pointer bg-black ".concat(isOpen ? "pointer-events-auto opacity-50" : "opacity-0"),
                onClick: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    onClick: function() {
                        closeModal();
                    },
                    children: "Close Quick View"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/cart/GiftProductCard.jsx



function GiftProductcard(param) {
    var giftProduct = param.giftProduct, selectedProduct = param.selectedProduct, setSelectedProduct = param.setSelectedProduct;
    var product = (0,dist.useProductByHandle)({
        handle: giftProduct.handle
    }).product;
    var metafieldMap = (0,Metafields/* getMetafieldMap */.x)(product);
    if (!product) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        label: metafieldMap === null || metafieldMap === void 0 ? void 0 : metafieldMap.custom_title,
        className: "flex md:items-center cursor-pointer border border-primary-1 px-5 py-3 mb-[-1px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "input-container flex-shrink-0 pr-3 mt-4 md:mt-0 leading-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "radio",
                    name: "gift",
                    value: product.id,
                    defaultChecked: product.id == (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id),
                    onChange: function() {
                        setSelectedProduct({
                            id: product.id,
                            object: product
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-[1fr] md:grid-cols-[56px_1fr_auto] items-center w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-container aspect-square w-14 self-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: product.images[0].src,
                            alt: product.images[0].altText,
                            width: "56",
                            height: "56"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content-container -ml-9 md:ml-0 mt-2 md:mt-0 md:px-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-sm font-hafferBold mb-0",
                                children: (metafieldMap === null || metafieldMap === void 0 ? void 0 : metafieldMap.custom_product_title) || product.title
                            }),
                            metafieldMap.short_description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs font-primary mb-0",
                                children: metafieldMap === null || metafieldMap === void 0 ? void 0 : metafieldMap.short_description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "price-container -ml-9 md:ml-0 font-hafferBold text-base pl-0 ",
                        children: "Free"
                    })
                ]
            })
        ]
    }, giftProduct.handle);
};

;// CONCATENATED MODULE: ./src/snippets/cart/GiftSelector.jsx
function GiftSelector_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function GiftSelector_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                GiftSelector_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                GiftSelector_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function GiftSelector() {
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var ref1 = (0,react.useState)(null), modalData = ref1[0], setModalData = ref1[1];
    var ref2 = (0,react.useState)(null), selectedProduct = ref2[0], setSelectedProduct = ref2[1];
    var ref3 = (0,react.useState)(null), errrorMessage = ref3[0], setErrorMessage = ref3[1];
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var buildProductCards = function() {
        return modalData.gwpProduct.map(function(product) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftProductcard, {
                giftProduct: product,
                selectedProduct: selectedProduct,
                setSelectedProduct: setSelectedProduct
            }, "product-".concat(product.id));
        });
    };
    var closeModal = function() {
        setModalData(null);
    };
    var optOutFreeGift = function() {
        closeModal();
        document.dispatchEvent(new CustomEvent("gwp:optOutFreeGift", {
            detail: {
                campaign: modalData.campaign
            }
        }));
    };
    var addFreeGiftToCart = function() {
        if (selectedProduct === null) {
            setErrorMessage("Please select a product");
        } else {
            cartAddItem({
                merchandiseId: selectedProduct.object.variants[0].id,
                quantity: 1,
                attributes: [
                    {
                        key: "_campaign",
                        value: modalData.campaign
                    },
                    {
                        key: "_gwp",
                        value: "true"
                    },
                    {
                        key: "_sc",
                        value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                    }, 
                ]
            }).then(function() {
                closeModal();
                document.dispatchEvent(new CustomEvent("openSideCart", {
                    bubbles: true
                }));
            });
        }
    };
    (0,react.useEffect)(function() {
        if (selectedProduct !== null) {
            setErrorMessage(null);
        }
    }, [
        selectedProduct
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("bwp:openGiftSelector", function() {
            var _ref = GiftSelector_asyncToGenerator(runtime_default().mark(function _callee(evt) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setModalOpen(true);
                            setModalData(evt.detail);
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(evt) {
                return _ref.apply(this, arguments);
            };
        }());
    }, []);
    (0,react.useEffect)(function() {
        if (!modalOpen) {
            setModalData(null);
        }
    }, [
        modalOpen
    ]);
    if (modalData == null) {
        return;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "before-after__product-modal fixed bottom-0 top-1/2 left-1/2 z-[1000000] max-h-[90dvh] w-full max-w-[90%] -translate-y-1/2\n          -translate-x-1/2 overflow-y-auto bg-white px-5 pt-7 pb-5 h-min lg:w-max lg:max-w-2xl lg:px-12 lg:pt-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-header text-center mb-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mb-4 font-tiempos text-h3-m lg:text-h3",
                                children: modalData.modalSettings.title
                            }),
                            modalData.modalSettings.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0",
                                children: modalData.modalSettings.subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-body",
                        children: buildProductCards()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-footer flex flex-col justify-center items-center mt-4 lg:mt-5 gap-3 lg:gap-4",
                        children: [
                            errrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-error",
                                children: errrorMessage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "button ".concat(selectedProduct ? "button--checkout" : "button--disabled"),
                                onClick: addFreeGiftToCart,
                                disabled: !selectedProduct,
                                children: modalData.modalSettings.atcText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "focus-link",
                                onClick: optOutFreeGift,
                                children: modalData.modalSettings.skipButtonText
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: optOutFreeGift,
                className: "modalBackdrop z-[2002] fixed top-0 left-0 h-full w-full cursor-pointer bg-black opacity-50"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/Storefront.jsx
function Storefront_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function Storefront_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Storefront_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





















function StorefrontLayout(_param) {
    var props = _extends({}, _param);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ContentForLayout = props.ContentForLayout, settings = props.settings, page = props.page;
    var ref9 = (0,next_router.useRouter)(), events = ref9.events, asPath = ref9.asPath;
    var ref10 = (0,react.useState)(0), count = ref10[0], setCount = ref10[1];
    // initialize customer, cart, shop and markets
    (0,dist.useStorefrontInit)();
    // send page view and add to cart events to Shopify analytics
    useShopifyAnalytics({
        collection: props.collection,
        product: props.product
    });
    // auto applies cart discount found on the landing url
    (0,dist.useCartAddDiscountUrl)();
    // set pack session cookie
    (0,hooks/* usePackCookie */.ws)();
    var fadeIntoWhite = function() {
        document.querySelector("main").classList.add("is-loading");
    };
    var fadeOutOfWhite = function() {
        document.querySelector("main").classList.remove("is-loading");
        setCount(function(prev) {
            return prev > 0 ? 0 : 1;
        });
    };
    var preloadImages = ((ref2 = settings === null || settings === void 0 ? void 0 : (ref = settings.settings) === null || ref === void 0 ? void 0 : (ref1 = ref.preloadImages) === null || ref1 === void 0 ? void 0 : ref1.split(",")) === null || ref2 === void 0 ? void 0 : ref2.map(function(url) {
        return url.trim();
    })) || [];
    (0,react.useEffect)(function() {
        events.on("routeChangeStart", fadeIntoWhite);
        events.on("routeChangeComplete", fadeOutOfWhite);
        return function() {
            events.off("routeChangeStart", fadeIntoWhite);
            events.off("routeChangeComplete", fadeOutOfWhite);
        };
    });
    (0,react.useEffect)(function() {
        var t = window.setInterval(function() {
            if (count > 10) {
                clearInterval(t);
            }
            if (typeof window.OneTrust === "object" && typeof window.OneTrust.initializeCookiePolicyHtml === "function") {
                clearInterval(t);
                window.OneTrust.initializeCookiePolicyHtml();
            } else {
                setCount(function(prev) {
                    return prev + 1;
                });
            }
        }, 300);
        return function() {
            return clearInterval(t);
        };
    }, [
        count
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_HeadMeta, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: (page === null || page === void 0 ? void 0 : (ref3 = page.seo) === null || ref3 === void 0 ? void 0 : ref3.image) || ((ref4 = props.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.featuredImage) === null || ref5 === void 0 ? void 0 : ref5.src) || (settings === null || settings === void 0 ? void 0 : (ref6 = settings.settings) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.globalShareImage) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.image) === null || ref8 === void 0 ? void 0 : ref8.src)
                    }, "page:fb:image"),
                    preloadImages ? preloadImages.map(function(url, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "preload",
                            as: "image",
                            href: url
                        }, "preload-img-".concat(index));
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                id: "url-params-cookie-script",
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: "\n          (function () {\n            const maxAge = '7776000';\n            const getDomain = (url) => {\n              const domainParts = url.split('.');\n              return domainParts.length > 2 ? domainParts.slice(-2).join('.') : url;\n            };\n            const getSubdomainIndex = (url) => {\n              if (!url) return 1;\n              const parts = url.split(\".\");\n              if (parts[0] === 'www') return 1;\n              return parts.length === 1 ? 0 : parts.length === 2 ? 1 : 2;\n            };\n            const subdomainIndex = getSubdomainIndex(window.location.host);\n            const generateFbc = (fbclid) => 'fb.' + subdomainIndex + '.' + Date.now() + '.' + fbclid;\n\n            const fbclid = new URLSearchParams(window.location.search).get('fbclid');\n            if (fbclid) {\n              const fbc = generateFbc(fbclid);\n              document.cookie = '_fbc=' + fbc + '; path=/; domain=.' + getDomain(window.location.hostname) + '; max-age=' + maxAge + '; samesite=lax';\n            }\n          })();"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://live.visually-io.com/widgets/vsly-preact.min.js?k=js.9053204&e=2&s=BRIOGEO_HAIR_CARE",
                strategy: "beforeInteractive",
                rel: "preconnect prefetch"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://live.visually-io.com/v/visually-spa.js",
                strategy: "beforeInteractive",
                rel: "preconnect prefetch"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://live.visually-io.com/v/visually-a-spa.js",
                defer: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Visually, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataLayerEventListeners, Storefront_objectSpread({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fueled, {}),
            (asPath === null || asPath === void 0 ? void 0 : asPath.indexOf("/pages/privacy-policy")) === -1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
                        id: "otSDKStub-01936375-4867-7f55-a10f-2e17bf6f641a",
                        strategy: "beforeInteractive",
                        charset: "UTF-8",
                        "data-domain-script": "01936375-4867-7f55-a10f-2e17bf6f641a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        strategy: "beforeInteractive",
                        id: "otSDKStub-inline-01936375-4867-7f55-a10f-2e17bf6f641a",
                        dangerouslySetInnerHTML: {
                            __html: "function OptanonWrapper() { }"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://js.afterpay.com/afterpay-1.x.js",
                strategy: "beforeInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://cdn-widgetsrepository.yotpo.com/v1/loader/sjzt7N108GUzJ96g4WqUxg",
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: "\n          var createReplacementCookie = function (cookieDomain) {\n            function getParameterByName(name, url = window.location.href) {\n                name = name.replace(/[\\[\\]]/g, '\\$&');\n                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);\n                if (!results) return null;\n                if (!results[2]) return '';\n                return decodeURIComponent(results[2].replace(/\\+/g, ' '));\n            }\n\n            function ticksToDate(ticks) {\n                return Number.isInteger(ticks) ? new Date(ticks / 1e+4 + new Date('0001-01-01T00:00:00Z').getTime()) : null;\n            }\n\n            //* If URL contains the query parameter replacementExpire, create cookie GE_Replacement\n            let replacementExpireParam = parseInt(getParameterByName('replacementExpire'));\n            if (replacementExpireParam !== null && replacementExpireParam > Date.now()) {\n                var cookieStringifiedValue = encodeURIComponent(JSON.stringify({ glCountry: getParameterByName('glCountry'), glCurrency: getParameterByName('glCurrency') }));\n                var expirationInUTC = ticksToDate(replacementExpireParam).toUTCString();\n                document.cookie = 'GE_Replacement=' + cookieStringifiedValue + ';expires=' + expirationInUTC + ';path=/;domain=.' +cookieDomain;\n              }\n            };\n\n            var cookieDomain = window.location.hostname\n            //can require custom value on stores whene checkout page domain is different\n            createReplacementCookie(cookieDomain);"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                id: "ship-scout-config",
                strategy: "beforInteractive",
                dangerouslySetInnerHTML: {
                    __html: "\n            window._shipScout = window._shipScout || [];\n            window.Shopify = window.Shopify || {};\n\n            Shopify.shop = 'briogeo-hair-care.myshopify.com';\n\n            window.shipScoutCookieDomain = document.domain.indexOf('netlify') > -1 ? 'netlify.app' : 'briogeohair.com';\n          "
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                id: "ship-scout-script",
                strategy: "afterInteractive",
                src: "https://web.shipscout.app/app.min.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(globals_RootStyles, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_SkipLink, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_CountdownTimer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_DiscountBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "main-content",
                className: "main-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentForLayout, Storefront_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickViewModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Footer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GeoLocation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSelector, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                src: "https://cdn.swellrewards.com/loader/sjzt7N108GUzJ96g4WqUxg.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://cdn.crazyrocket.io/widget/scripts/crazyrocket.start.js?id=64e37206117cee01887d7b67&shop=briogeo-hair-care.myshopify.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "gorgias-chat-widget-install-v2",
                src: "https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=10623"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://static.myshlf.us/Affiliates/sms_aff_clicktrack.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: "\n          (function(){ var s = document.createElement('script'); var h = document.querySelector('head') || document.body; s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; s.async = true; s.onload = function(){ acsbJS.init({ statementLink : '', footerHtml : '', hideMobile : false, hideTrigger : false, disableBgProcess : false, language : 'en', position : 'left', leadColor : '#000000', triggerColor : '#000000', triggerRadius : '50%', triggerPositionX : 'left', triggerPositionY : 'bottom', triggerIcon : 'people', triggerSize : 'bottom', triggerOffsetX : 20, triggerOffsetY : 80, mobile : { triggerSize : 'small', triggerPositionX : 'left', triggerPositionY : 'bottom', triggerOffsetX : 10, triggerOffsetY : 80, triggerRadius : '20' } }); }; h.appendChild(s); })();"
                }
            })
        ]
    });
}
// eslint-disable-next-line import/no-default-export
/* harmony default export */ var Storefront = (StorefrontLayout);

// EXTERNAL MODULE: ./src/styles/storefront.css
var storefront = __webpack_require__(53566);
;// CONCATENATED MODULE: ./src/pages/_app.jsx
function _app_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _app_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _app_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

/* eslint-disable react/destructuring-assignment */ /* eslint-disable import/no-unresolved */ 



// This is new customizer bridge






(0,utils/* rafTimeoutInterval */.N$)();
function StorefrontApp(param) {
    var Component = param.Component, pageData = param.pageData, pageProps = param.pageProps, router = param.router, storefrontSettings = param.storefrontSettings;
    var setRoute = dist.store.recoil.useSetRecoilState(dist.store.state.route);
    var setStorefrontSettings = dist.store.recoil.useSetRecoilState(dist.store.state.storefrontSettings);
    var config = (0,telejson_dist/* parse */.Qc)((pageProps === null || pageProps === void 0 ? void 0 : pageProps.config) || "{}");
    // update ROUTE_VIEW state
    // this is responsible for sending all the VIEW_X events
    (0,react.useEffect)(function() {
        setRoute(router.asPath);
    }, [
        router.asPath,
        setRoute
    ]);
    // update the storefront settings in recoil store
    (0,react.useEffect)(function() {
        setStorefrontSettings(storefrontSettings);
    }, [
        storefrontSettings,
        setStorefrontSettings
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* Partytown */.iA, _app_objectSpread({}, config === null || config === void 0 ? void 0 : config.partytown)),
            pageProps.isPreview && pageProps.isShareableToken && /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PreviewModeToast */.UZ, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Storefront, _app_objectSpread({
                ContentForLayout: Component
            }, pageProps, {
                config: config,
                renderSections: (0,customizerUtils.renderSections)(_app_objectSpread({}, pageProps, {
                    page: pageData
                }), sections)
            }))
        ]
    });
}
var useOverlayScript = function(param) {
    var isPreview = param.isPreview, overlay = param.overlay;
    (0,react.useEffect)(function() {
        if (isPreview && ((overlay === null || overlay === void 0 ? void 0 : overlay.src) || (overlay === null || overlay === void 0 ? void 0 : overlay.version)) && !window.isOverlayScriptInjected) {
            var script = document.createElement("script");
            script.src = (overlay === null || overlay === void 0 ? void 0 : overlay.src) || "https://d3dizc9fcooe02.cloudfront.net/overlay@".concat(overlay === null || overlay === void 0 ? void 0 : overlay.version, "/dist/overlay.js");
            script.async = true;
            document.head.appendChild(script);
            window.isOverlayScriptInjected = true;
        }
    }, [
        isPreview,
        overlay
    ]);
};
function App(props) {
    var ref;
    var Component = props.Component, pageProps = props.pageProps, router = props.router;
    var ref1 = (0,customizerUtils.useCustomizerShell)({
        environment: pageProps.environment,
        isPreview: pageProps.isPreview,
        isShareableToken: pageProps.isShareableToken,
        sectionComponents: sections,
        staticProps: pageProps,
        storefrontSettingsSchema: settings
    }), pageData = ref1.pageData, storefrontSettings = ref1.storefrontSettings;
    useOverlayScript({
        isPreview: pageProps.isPreview,
        overlay: (ref = pageProps.customizerMeta) === null || ref === void 0 ? void 0 : ref.overlay
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.StateProvider, {
            pageData: pageData,
            pageProps: pageProps,
            route: router.asPath,
            storefrontSettings: storefrontSettings,
            children: /*#__PURE__*/ react.cloneElement(/*#__PURE__*/ (0,jsx_runtime.jsx)(StorefrontApp, {}), {
                Component: Component,
                pageData: pageData,
                pageProps: pageProps,
                router: router,
                storefrontSettings: storefrontSettings
            }, null)
        })
    });
}
/* harmony default export */ var _app = (App);


/***/ }),

/***/ 77350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* reexport */ AccountNav; }
});

// EXTERNAL MODULE: ../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(35230);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/snippets/account/AccountNav/AccountNav.jsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function AccountNav() {
    var ref = (0,dist.useCustomerAuth)(), customerInit = ref.customerInit, customer = ref.customer;
    var rewardsPopupBtn = (0,react.useRef)(null);
    var customerLogout = (0,dist.useCustomerLogout)().customerLogout;
    var getPage = function() {
        if (window.location.pathname === "/account" || window.location.pathname === "/pages/order-history") {
            return "orders";
        }
        if (window.location.pathname === "/pages/my-profile") {
            return "profile";
        }
        if (window.location.pathname === "/account/address-book") {
            return "addresses";
        }
        if (window.location.pathname === "/account/referral") {
            return "referral";
        }
    };
    (0,react.useEffect)(function() {
        if (customerInit) {
            if (typeof yotpoWidgetsContainer !== "undefined" && typeof (yotpoWidgetsContainer === null || yotpoWidgetsContainer === void 0 ? void 0 : yotpoWidgetsContainer.initWidgets) !== "undefined") {
                window.yotpoWidgetsContainer.initWidgets();
            }
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "account-nav",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "flex flex-nowrap items-center gap-x-5 overflow-x-auto lg:block lg:overflow-hidden border-b lg:border-b-0 border-grey-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "".concat(getPage() === "profile" ? "border-b-[3px] border-black lg:border-b-0" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "".concat(getPage() === "profile" ? "#" : "/pages/my-profile"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "".concat(getPage() === "profile" ? "active" : ""),
                                    children: "My Profile"
                                })
                            }),
                            getPage() === "profile" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "!pl-4 hidden lg:block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/pages/my-profile#rewards",
                                            className: "!mb-3",
                                            children: "Rewards"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/pages/my-profile#products",
                                            className: "!mb-3",
                                            children: "Products"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/pages/my-profile#discover",
                                            className: "!mb-3",
                                            children: "Discover"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat(getPage() === "orders" ? "border-b-[3px] border-black lg:border-b-0" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(getPage() === "orders" ? "#" : "/pages/order-history"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "".concat(getPage() === "orders" ? "active" : ""),
                                children: "Order History"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            href: "https://shop.briogeohair.com/tools/recurring/login",
                            children: "Subscriptions"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat(getPage() === "addresses" ? "border-b-[3px] border-black lg:border-b-0" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(getPage() === "addresses" ? "#" : "/account/address-book"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "".concat(getPage() === "addresses" ? "active" : ""),
                                children: "Addresses"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "hidden lg:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            "aria-label": "Sign out",
                            className: "text-xs text-black lg:text-regular underline hover:no-underline whitespace-nowrap",
                            onClick: _asyncToGenerator(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return customerLogout(null, function() {
                                                console.log("Signed Out");
                                            });
                                        case 2:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })),
                            children: "Sign Out"
                        })
                    })
                ]
            }),
            getPage() === "profile" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "account-subnav !px-0 !mx-5 flex justify-center lg:hidden !mt-3 bg-grey-9",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/pages/my-profile#rewards",
                            children: "Rewards"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/pages/my-profile#products",
                            children: "Products"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/pages/my-profile#discover",
                            children: "Discover"
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/account/AccountNav/index.js



/***/ }),

/***/ 50954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ GWPHandler; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46995);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31655);
/* harmony import */ var _utils_Images__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80152);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91588);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







function GWPHandler(param1) {
    var gwpItems = param1.gwpItems, cartLines = param1.cartLines, _cartView = param1.cartView, cartView = _cartView === void 0 ? false : _cartView;
    var ref9, ref1;
    var siteSettings = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useSettings)();
    var country = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode == "US";
    var gwpScenarios = siteSettings === null || siteSettings === void 0 ? void 0 : (ref9 = siteSettings.newFreeProducts) === null || ref9 === void 0 ? void 0 : ref9.gwpScenarios;
    var subtotal = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCartTotals)().subtotal;
    var fetchCollectionByHandle = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCollectionByHandle)({
        handle: null
    }).fetchCollectionByHandle;
    var cartAddItems = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCartAddItems)().cartAddItems;
    var cartRemoveItems = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCartRemoveItems)().cartRemoveItems;
    var cartUpdateItem = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCartUpdateItem)().cartUpdateItem;
    var optedOutCampaigns = ((ref1 = js_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("OptedOutCampaigns")) === null || ref1 === void 0 ? void 0 : ref1.split(",")) || [];
    var activeGWPs = gwpScenarios === null || gwpScenarios === void 0 ? void 0 : gwpScenarios.filter(function(scenario) {
        return scenario.enabled == true;
    });
    var collectionBasedGwps = activeGWPs === null || activeGWPs === void 0 ? void 0 : activeGWPs.filter(function(gwp) {
        return gwp._template == "buyFromCollectionGetY";
    });
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), gwpProducts = ref2[0], setGwpProducts = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), gwpCollections = ref3[0], setGwpCollections = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), reviewedScenarios = ref4[0], setReviewedScenarios = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), giftsToAdd = ref5[0], setGiftsToAdd = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), giftsToRemove = ref6[0], setGiftsToRemove = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoading = ref7[0], setIsLoading = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), optInButtons = ref8[0], setOptInButtons = ref8[1];
    var validateProductInCart = function(handle, enableSubQualify) {
        var qualifies = cartLines === null || cartLines === void 0 ? void 0 : cartLines.some(function(line) {
            var lineQualifies = line.variant.product.handle === handle;
            if (lineQualifies && enableSubQualify) {
                var ref;
                lineQualifies = (line === null || line === void 0 ? void 0 : (ref = line.sellingPlanAllocation) === null || ref === void 0 ? void 0 : ref.sellingPlan) || false;
            }
            return lineQualifies;
        });
        // console.log('validate product in cart?: ', qualifies, 'enableSubQualify?: ', enableSubQualify);
        setReviewedScenarios(function(currentReviewedScenarios) {
            return currentReviewedScenarios + 1;
        });
        return qualifies || false;
    };
    var validateProductInCollection = function(handle) {
        var collection1 = gwpCollections.find(function(collection) {
            return collection.handle === handle;
        });
        var cartProducts = cartLines === null || cartLines === void 0 ? void 0 : cartLines.map(function(line) {
            return line.variant.product.handle;
        });
        var qualifies = (cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.length) > 0 && (cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.some(function(product) {
            var ref;
            return collection1 === null || collection1 === void 0 ? void 0 : (ref = collection1.products) === null || ref === void 0 ? void 0 : ref.includes(product);
        }));
        setReviewedScenarios(function(currentReviewedScenarios) {
            return currentReviewedScenarios + 1;
        });
        return qualifies || false;
    };
    var validateCartTotal = function(requiredTotal) {
        // console.log('Validate cart total is larger?:', parseFloat(subtotal) >= requiredTotal, 'subtotal:', parseFloat(subtotal), 'requiredTotal:', requiredTotal)
        setReviewedScenarios(function(currentReviewedScenarios) {
            return currentReviewedScenarios + 1;
        });
        return parseFloat(subtotal) >= requiredTotal;
    };
    var validateSubscriptionsInCart = function() {
        var gwpAllSubsQualify = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var method = gwpAllSubsQualify ? "every" : "some";
        var qualifies = (cartLines === null || cartLines === void 0 ? void 0 : cartLines.length) > 0 && (cartLines === null || cartLines === void 0 ? void 0 : cartLines[method](function(line) {
            var ref;
            return line === null || line === void 0 ? void 0 : (ref = line.sellingPlanAllocation) === null || ref === void 0 ? void 0 : ref.sellingPlan;
        }));
        // console.log('validate subscriptions in cart?: ', qualifies, 'All products must be subscriptions?: ', gwpAllSubsQualify);
        setReviewedScenarios(function(currentReviewedScenarios) {
            return currentReviewedScenarios + 1;
        });
        return qualifies;
    };
    var validateBundleIncart = function(bundleLength, productHandles, campaign) {
        var ref;
        var qualifies = false;
        var bundleItem = cartLines === null || cartLines === void 0 ? void 0 : cartLines.find(function(line) {
            return line.isBundle;
        });
        var bundleItemCampaign = (ref = bundleItem === null || bundleItem === void 0 ? void 0 : bundleItem.attributes.find(function(attribute) {
            return attribute.key === "_campaign";
        })) === null || ref === void 0 ? void 0 : ref.value;
        if (bundleItemCampaign && bundleItemCampaign !== campaign) {
            setReviewedScenarios(function(currentReviewedScenarios) {
                return currentReviewedScenarios + 1;
            });
            return false;
        }
        if (bundleItem) {
            qualifies = bundleItem.bundleItems.length >= bundleLength;
        }
        if (productHandles && productHandles.length > 0) {
            var ref10;
            qualifies = bundleItem === null || bundleItem === void 0 ? void 0 : (ref10 = bundleItem.bundleItems) === null || ref10 === void 0 ? void 0 : ref10.some(function(line) {
                return productHandles.includes(line.variant.product.handle);
            });
        }
        // console.log('validate bundle in cart?: ', qualifies, 'bundle length: ', bundleLength, 'items in bundle: ', bundleItem?.bundleItems?.length, 'Qualifier product:', productHandle);
        setReviewedScenarios(function(currentReviewedScenarios) {
            return currentReviewedScenarios + 1;
        });
        return qualifies;
    };
    var checkFreeGiftAdded = function(gwpProduct, campaign) {
        var handles = [];
        if (Array.isArray(gwpProduct)) {
            handles = gwpProduct.map(function(product) {
                return product.handle;
            });
        } else {
            handles = [
                gwpProduct === null || gwpProduct === void 0 ? void 0 : gwpProduct.handle
            ];
        }
        var item1 = gwpItems === null || gwpItems === void 0 ? void 0 : gwpItems.find(function(item) {
            var validProduct = false;
            // Validate the handle exists in the cart
            var validHandle = handles.some(function(handle) {
                return item.variant.product.handle === handle;
            });
            // Validate the item matches with the campaign
            if (validHandle) {
                var ref;
                var validCampaign = (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.some(function(attribute) {
                    return attribute.key === "_campaign" && attribute.value === campaign;
                });
                if (validCampaign) {
                    validProduct = true;
                }
            }
            return validProduct;
        });
        return item1;
    };
    var checkCampaignOptedOut = function(campaign) {
        return optedOutCampaigns.some(function(optedOutCampaign) {
            return optedOutCampaign === campaign;
        });
    };
    var optOutCampaignProduct = function(param) {
        var cartLine = param.cartLine, _removeFromCart = param.removeFromCart, removeFromCart = _removeFromCart === void 0 ? false : _removeFromCart, eventData = param.eventData;
        var campaign;
        if (cartLine) {
            var ref;
            campaign = (ref = cartLine.attributes.find(function(attribute) {
                return attribute.key === "_campaign";
            })) === null || ref === void 0 ? void 0 : ref.value;
        }
        if (eventData) {
            campaign = eventData.campaign;
        }
        var optedOutCampaignObject = gwpScenarios.find(function(scenario) {
            return scenario.campaign == campaign;
        });
        var newOptedOutCampaigns = _toConsumableArray(optedOutCampaigns.filter(function(loopCampaign) {
            return campaign !== loopCampaign;
        })).concat([
            campaign
        ]);
        if (cartLine && removeFromCart) {
            setIsLoading(true);
            cartRemoveItems({
                lineIds: [
                    cartLine.id
                ]
            }).then(function() {
                setIsLoading(false);
                js_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"].set */ .Z.set("OptedOutCampaigns", newOptedOutCampaigns);
                setOptInButtons(function(oldCampaigns) {
                    return _toConsumableArray(oldCampaigns).concat([
                        optedOutCampaignObject, 
                    ]);
                });
            });
            return;
        }
        js_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"].set */ .Z.set("OptedOutCampaigns", newOptedOutCampaigns);
        setOptInButtons(function(oldCampaigns) {
            return _toConsumableArray(oldCampaigns.filter(function(loopCampaign) {
                return optedOutCampaignObject.campaign !== loopCampaign.campaign;
            })).concat([
                optedOutCampaignObject, 
            ]);
        });
    };
    var optInCampaignProduct = function(campaign) {
        var filteredOptedOutCampaigns = optedOutCampaigns.filter(function(optedOutCampaign) {
            return optedOutCampaign !== campaign.campaign;
        });
        var isMultipleProductCampaign = Array.isArray(campaign.gwpProduct);
        if (isMultipleProductCampaign) {
            document.dispatchEvent(new CustomEvent("bwp:openGiftSelector", {
                detail: campaign
            }));
        } else {
            var product = gwpProducts.find(function(gwpProduct) {
                return gwpProduct.handle == campaign.gwpProduct.handle;
            });
            var itemsToAdd = [
                {
                    merchandiseId: product.variants[0].id,
                    quantity: 1,
                    attributes: [
                        {
                            key: "_gwp",
                            value: "true"
                        },
                        {
                            key: "_campaign",
                            value: campaign.campaign
                        }
                    ]
                }
            ];
            setIsLoading(true);
            cartAddItems(itemsToAdd).then(function() {
                setIsLoading(false);
            });
        }
        if (filteredOptedOutCampaigns.length > 0) {
            js_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"].set */ .Z.set("OptedOutCampaigns", filteredOptedOutCampaigns);
        } else {
            js_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"].remove */ .Z.remove("OptedOutCampaigns");
        }
        setOptInButtons(function(oldCampaigns) {
            return oldCampaigns.filter(function(optedOutCampaign) {
                return optedOutCampaign.campaign !== campaign.campaign;
            });
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var activeGWPProductsHandles = activeGWPs === null || activeGWPs === void 0 ? void 0 : activeGWPs.map(function(gwp) {
            if (Array.isArray(gwp.gwpProduct)) {
                return gwp.gwpProduct.map(function(product) {
                    return product.handle;
                });
            } else {
                return gwp.gwpProduct.handle;
            }
        }).filter(function(value) {
            return !!value && value !== "";
        });
        if (activeGWPProductsHandles === null || activeGWPProductsHandles === void 0 ? void 0 : activeGWPProductsHandles.length) {
            (0,_utils_product__WEBPACK_IMPORTED_MODULE_2__/* .fetchProductsFromHandles */ .H)(activeGWPProductsHandles.flat()).then(function(products) {
                var filteredProducts = products.filter(function(product) {
                    return product;
                });
                setGwpProducts(filteredProducts);
            });
        }
        var gwpCollectionValidations = (activeGWPs === null || activeGWPs === void 0 ? void 0 : activeGWPs.filter(function(gwp) {
            return gwp._template == "buyFromCollectionGetY";
        })) || [];
        var collectionsObjects = gwpCollectionValidations === null || gwpCollectionValidations === void 0 ? void 0 : gwpCollectionValidations.map(function(gwp) {
            return fetchCollectionByHandle({
                handle: gwp.gwpCollectionQualify
            });
        });
        Promise.all(collectionsObjects).then(function(collections) {
            setGwpCollections(function() {
                return collections.map(function(collection) {
                    return {
                        handle: collection.handle,
                        products: collection.products.map(function(product) {
                            return product.handle;
                        })
                    };
                });
            });
        });
        document.addEventListener("gwp:optOutFreeGift", function(evt) {
            optOutCampaignProduct({
                eventData: evt.detail
            });
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // Removes all gifts when the store is not in US or the cart is empty
        if (cartLines == 0 || !isUs && !cartView) {
            var lineIds = gwpItems === null || gwpItems === void 0 ? void 0 : gwpItems.map(function(lineItem) {
                return lineItem.id;
            });
            if (lineIds.length) {
                cartRemoveItems({
                    lineIds: lineIds
                });
            }
            setOptInButtons([]);
            return;
        }
        if (gwpProducts.length > 0 && !isLoading && gwpCollections.length == collectionBasedGwps.length && isUs) {
            var newOptinButtons = [];
            activeGWPs = activeGWPs === null || activeGWPs === void 0 ? void 0 : activeGWPs.map(function(gwp) {
                var newProduct;
                if (Array.isArray(gwp.gwpProduct)) {
                    newProduct = gwp.gwpProduct.filter(function(product) {
                        return gwpProducts.some(function(gwpProduct) {
                            return gwpProduct.handle == product.handle;
                        });
                    });
                } else {
                    newProduct = gwpProducts.find(function(gwpProduct) {
                        var ref;
                        return (gwpProduct === null || gwpProduct === void 0 ? void 0 : gwpProduct.handle) == (gwp === null || gwp === void 0 ? void 0 : (ref = gwp.gwpProduct) === null || ref === void 0 ? void 0 : ref.handle);
                    });
                }
                return _objectSpread({}, gwp, {
                    gwpProduct: newProduct
                });
            });
            var invalidGWP = gwpItems === null || gwpItems === void 0 ? void 0 : gwpItems.filter(function(gwp) {
                var isInvalid = false;
                var campaign = gwp.attributes.find(function(attribute) {
                    return attribute.key === "_campaign";
                });
                if (!campaign) {
                    isInvalid = true;
                } else {
                    isInvalid = !(activeGWPs === null || activeGWPs === void 0 ? void 0 : activeGWPs.some(function(gwpScenario) {
                        return gwpScenario.campaign === campaign.value;
                    }));
                }
                return isInvalid;
            });
            if ((invalidGWP === null || invalidGWP === void 0 ? void 0 : invalidGWP.length) > 0) {
                setGiftsToRemove(function(prevGiftsToRemove) {
                    return _toConsumableArray(prevGiftsToRemove).concat(_toConsumableArray(invalidGWP));
                });
            }
            activeGWPs === null || activeGWPs === void 0 ? void 0 : activeGWPs.forEach(function(gwpScenario) {
                var ref, ref11;
                var qualifies = false;
                var freeGiftAdded = checkFreeGiftAdded(gwpScenario.gwpProduct, gwpScenario.campaign);
                var campaignOptedOut = checkCampaignOptedOut(gwpScenario.campaign);
                var productHandles = [];
                if ((ref = gwpScenario.gwpProductQualify) === null || ref === void 0 ? void 0 : ref.handle) {
                    var ref12;
                    productHandles.push((ref12 = gwpScenario.gwpProductQualify) === null || ref12 === void 0 ? void 0 : ref12.handle);
                }
                if ((ref11 = gwpScenario.gwpProductQualifySecondary) === null || ref11 === void 0 ? void 0 : ref11.handle) {
                    var ref13;
                    productHandles.push((ref13 = gwpScenario.gwpProductQualifySecondary) === null || ref13 === void 0 ? void 0 : ref13.handle);
                }
                switch(gwpScenario._template){
                    case "buyXGetY":
                        var ref14;
                        qualifies = validateProductInCart((ref14 = gwpScenario.gwpProductQualify) === null || ref14 === void 0 ? void 0 : ref14.handle, gwpScenario.enableSubQualify);
                        break;
                    case "buyFromCollectionGetY":
                        qualifies = validateProductInCollection(gwpScenario.gwpCollectionQualify);
                        break;
                    case "spendXGetY":
                        qualifies = validateCartTotal(gwpScenario.gwpCartMinimum);
                        break;
                    case "spendXandChooseY":
                        qualifies = validateCartTotal(gwpScenario.gwpCartMinimum);
                        break;
                    case "buySubscriptionGetY":
                        qualifies = validateSubscriptionsInCart(gwpScenario.gwpAllSubsQualify);
                        break;
                    case "buyBundleGetY":
                        qualifies = validateBundleIncart(gwpScenario.gwpBundleCount, productHandles, gwpScenario.campaign);
                        break;
                    case "freeSamples":
                        qualifies = validateCartTotal(gwpScenario.samplesCartMinimum);
                        break;
                }
                if (qualifies == true) {
                    if (campaignOptedOut) {
                        newOptinButtons.push(gwpScenario);
                    } else {
                        if (!freeGiftAdded && !cartView) {
                            setGiftsToAdd(function(prevGiftsToAdd) {
                                return _toConsumableArray(prevGiftsToAdd).concat([
                                    gwpScenario
                                ]);
                            });
                        }
                    }
                } else {
                    if (freeGiftAdded && !cartView) {
                        setGiftsToRemove(function(prevGiftsToRemove) {
                            return _toConsumableArray(prevGiftsToRemove).concat([
                                freeGiftAdded
                            ]);
                        });
                    }
                }
            });
            setOptInButtons(newOptinButtons);
        }
        return function() {
            setReviewedScenarios(0);
            setGiftsToAdd([]);
            setGiftsToRemove([]);
        };
    }, [
        cartLines,
        gwpCollections.length,
        gwpProducts.length,
        isLoading,
        isUs,
        gwpScenarios
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (reviewedScenarios < (activeGWPs === null || activeGWPs === void 0 ? void 0 : activeGWPs.length)) return;
        if (giftsToAdd.length > 0) {
            var multipleGiftScenarios = [];
            var itemsToAdd = [];
            // Switch map for forEach
            giftsToAdd.forEach(function(scenario) {
                var ref;
                // if scenario has multiple gift push it to a different variable
                if (Array.isArray(scenario.gwpProduct)) {
                    multipleGiftScenarios.push(scenario);
                } else if (((ref = scenario.gwpProduct.variants) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                    itemsToAdd.push({
                        merchandiseId: scenario.gwpProduct.variants[0].id,
                        quantity: 1,
                        attributes: [
                            {
                                key: "_gwp",
                                value: "true"
                            },
                            {
                                key: "_campaign",
                                value: scenario.campaign
                            },
                            {
                                key: "_sc",
                                value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                            }
                        ]
                    });
                }
            });
            if ((itemsToAdd === null || itemsToAdd === void 0 ? void 0 : itemsToAdd.length) > 0) {
                cartAddItems(itemsToAdd).then(function() {
                    if (giftsToRemove.length > 0) {
                        var linesToRemove = giftsToRemove.map(function(item) {
                            return item.id;
                        });
                        cartRemoveItems({
                            lineIds: linesToRemove
                        });
                    }
                });
            }
            if (multipleGiftScenarios.length > 0) {
                document.dispatchEvent(new CustomEvent("bwp:openGiftSelector", {
                    detail: multipleGiftScenarios[0]
                }));
            }
        } else {
            if (giftsToRemove.length > 0) {
                var linesToRemove1 = giftsToRemove.map(function(item) {
                    return item.id;
                });
                cartRemoveItems({
                    lineIds: linesToRemove1
                });
            }
        }
    }, [
        giftsToAdd.length,
        giftsToRemove.length,
        reviewedScenarios
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var moreThanOneGwp = gwpItems === null || gwpItems === void 0 ? void 0 : gwpItems.find(function(gwp) {
            return gwp.quantity > 1;
        });
        if (moreThanOneGwp) {
            cartUpdateItem({
                lineId: moreThanOneGwp.id,
                quantity: 1,
                attributes: moreThanOneGwp.attributes
            });
        }
    }, [
        gwpItems,
        cartLines
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !cartView && (gwpItems === null || gwpItems === void 0 ? void 0 : gwpItems.map(function(gwpLine) {
                var ref, ref15, ref16, ref17, ref18, ref19;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "gwp-line-item-container relative flex items-center justify-between border-b border-grey-4 py-5 px-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-20 shrink-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (0,_utils_Images__WEBPACK_IMPORTED_MODULE_6__/* .getSizedImageUrl */ .M0)(gwpLine === null || gwpLine === void 0 ? void 0 : (ref = gwpLine.variant) === null || ref === void 0 ? void 0 : (ref15 = ref.image) === null || ref15 === void 0 ? void 0 : ref15.src, "100x100@2x"),
                                alt: gwpLine === null || gwpLine === void 0 ? void 0 : (ref16 = gwpLine.variant) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.product) === null || ref17 === void 0 ? void 0 : ref17.title,
                                width: "80",
                                height: "80"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "z-1 absolute right-4 top-5 inline-block cursor-pointer",
                            onClick: function() {
                                optOutCampaignProduct({
                                    cartLine: gwpLine,
                                    removeFromCart: true
                                });
                            },
                            type: "button",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .IconRemove */ .HF, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative flex-grow pl-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "my-0 inline-block pr-8 font-hafferBold text-xs no-underline",
                                    children: gwpLine === null || gwpLine === void 0 ? void 0 : (ref18 = gwpLine.variant) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.product) === null || ref19 === void 0 ? void 0 : ref19.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mt-0 mb-0 text-xs lg:mt-1",
                                    children: "one-time purchase"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-6 flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-right font-hafferBold text-sm",
                                            children: "FREE"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, gwpLine.id);
            })),
            isUs && optInButtons.map(function(campaign) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "line-item-add-gwp relative flex items-center justify-between border-b border-grey-4 py-5 px-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "border-b-2 font-hafferBold text-sm",
                        onClick: function() {
                            optInCampaignProduct(campaign);
                        },
                        children: campaign === null || campaign === void 0 ? void 0 : campaign.gwpAddBack
                    })
                }, campaign.campaign);
            })
        ]
    });
}


/***/ }),

/***/ 85634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var _icons_ArrowUp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90107);
/* harmony import */ var _icons_Filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15776);
/* harmony import */ var _icons_SortBy__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54591);
/* harmony import */ var _icons_Close__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54059);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







function CollectionHeader(param) {
    var sort = param.sort, setMobileFilterOpen = param.setMobileFilterOpen, setLayoutParams = param.setLayoutParams, currentFilters = param.currentFilters, enableFilters = param.enableFilters, itemsPerPage = param.itemsPerPage, browserHistory = param.browserHistory, enableLoadMore = param.enableLoadMore, currentPage = param.currentPage, itemCount = param.itemCount, productCount = param.productCount;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var sortOptions = [
        {
            label: "Price, Low To High",
            value: "price:asc"
        },
        {
            label: "Price, High To Low",
            value: "price:desc"
        },
        {
            label: "Alphabetically, A-Z",
            value: "alpha:asc"
        },
        {
            label: "Alphabetically, Z-A",
            value: "alpha:desc"
        },
        {
            label: "Most Popular",
            value: "pop:desc"
        }, 
    ];
    var initialIndex = enableLoadMore === true || currentPage === 1 ? 1 : (currentPage - 1) * itemsPerPage + 1;
    var finalIndex = enableLoadMore === true ? productCount : (currentPage - 1) * itemsPerPage + productCount;
    var getCurrentSortLabel = function() {
        var option1 = sortOptions.find(function(option) {
            return option.value === sort;
        });
        return option1 === null || option1 === void 0 ? void 0 : option1.label;
    };
    var updateSortOption = function(option) {
        setIsOpen(false);
        setLayoutParams(function(layoutParams) {
            var newParams = _objectSpread({}, layoutParams, {
                sort: option
            });
            if (browserHistory) {
                var urlParams = new URLSearchParams(document.location.search);
                urlParams.set("sort", option);
                router.push({
                    query: _objectSpread({}, router.query, {
                        sort: option
                    })
                }, undefined, {
                    shallow: true
                });
            }
            return newParams;
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative z-20 mb-4 mt-5 flex items-center justify-between md:border-t-0 md:border-b-0",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "collection__product-count mr-auto",
                children: [
                    "showing ",
                    initialIndex,
                    " - ",
                    finalIndex,
                    " of ",
                    itemCount,
                    " products"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sort-container relative z-10 ml-auto hidden max-w-[350px] overflow-visible lg:flex xl:hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "mr-4 flex flex-shrink-0 items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_SortBy__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                            "sort by"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        type: "button",
                        className: "sort-box flex h-[50px] w-[250px] items-center justify-center px-2 md:border md:border-black md:px-0",
                        onClick: function() {
                            setIsOpen(function(currentIsOpen) {
                                return !currentIsOpen;
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-xs md:w-full md:px-4 md:text-left md:font-hafferBold",
                                children: getCurrentSortLabel() || "Sort By"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex h-full w-[50px] shrink-0 items-center justify-center self-end md:border-l",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "transition-transform duration-150 ".concat(!isOpen ? "rotate-180" : ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_ArrowUp__WEBPACK_IMPORTED_MODULE_3__/* .ArrowUp */ .a, {
                                        className: "w-3 md:w-4"
                                    })
                                })
                            })
                        ]
                    }),
                    isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "sort-options absolute top-full right-0 m-0 w-full border border-grey-4 bg-white p-0 md:border-black",
                        children: sortOptions.map(function(option) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "my-4 list-none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    className: "w-full border-0 bg-transparent px-4 text-left text-xs hover:font-hafferBold ".concat(option.value === sort ? "font-hafferBold" : ""),
                                    onClick: function() {
                                        updateSortOption(option.value);
                                    },
                                    children: option.label
                                })
                            }, option.value);
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CollectionHeader);


/***/ }),

/***/ 69342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ Image; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/snippets/components/Image/ImageElement.jsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var IMAGE_SIZES = [
    16,
    32,
    48,
    64,
    96,
    128,
    256,
    384
];
var DEVICE_SIZES = [
    640,
    768,
    960,
    1280,
    1536,
    2048,
    2560,
    3072,
    3840
];
var ALL_SIZES = _toConsumableArray(IMAGE_SIZES).concat(_toConsumableArray(DEVICE_SIZES)).sort(function(a, b) {
    return a - b;
});
var DEFAULT_QUALITY = 75; // 1 - 100
function getWidths(param) {
    var config = param.config, sizes = param.sizes, width = param.width;
    var ref = _objectSpread({}, config), _deviceSizes = ref.deviceSizes, deviceSizes = _deviceSizes === void 0 ? [] : _deviceSizes, _allSizes = ref.allSizes, allSizes = _allSizes === void 0 ? [] : _allSizes;
    if (sizes) {
        // Find all the "vw" percent sizes used in the sizes prop
        var percentSizes = (sizes.match(/(1?\d?\d)vw/g) || []).map(function(size) {
            return parseInt(size, 10);
        });
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    // For "fill" images with no "sizes" prop, return all device sizes
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    // For images with set widths, find first size at least twice the width
    var widths = _toConsumableArray(new Set([
        width,
        width * 2
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, loader = param.loader, quality = param.quality, sizes = param.sizes, src = param.src, width = param.width;
    var ref = getWidths({
        config: config,
        sizes: sizes,
        width: width
    }), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        src: loader({
            quality: quality,
            src: src,
            width: widths[last]
        })
    };
}
function getInt(value) {
    if (typeof value === "number" || typeof value === "undefined") {
        return value;
    }
    if (typeof value === "string") {
        return parseInt(value, 10);
    }
    return NaN;
}
// Shopify CDN specific url param mutations
// For other CDNs, create another custom loader
function shopifyCdnLoader(param) {
    var src = param.src, quality = param.quality, width = param.width;
    if (!src) return "";
    var params = new URLSearchParams(src.split("?")[1] || "");
    params.set("width", width);
    params.set("quality", quality < 1 || quality > 100 ? DEFAULT_QUALITY : quality);
    return "".concat(src.split("?")[0], "?").concat(params);
}
var ImageElement = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var alt = _param.alt, className = _param.className, fill = _param.fill, height = _param.height, loading = _param.loading, priority = _param.priority, _quality = _param.quality, quality = _quality === void 0 ? DEFAULT_QUALITY : _quality, sizes = _param.sizes, src = _param.src, width = _param.width, props = _objectWithoutProperties(_param, [
        "alt",
        "className",
        "fill",
        "height",
        "loading",
        "priority",
        "quality",
        "sizes",
        "src",
        "width"
    ]);
    var config = {
        allSizes: ALL_SIZES,
        deviceSizes: DEVICE_SIZES
    };
    var qualityInt = getInt(quality);
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var imgAttributes = generateImgAttrs({
        config: config,
        loader: shopifyCdnLoader,
        quality: qualityInt,
        sizes: sizes,
        src: src,
        width: widthInt
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            priority && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", _objectSpread({
                    rel: "preload",
                    as: "image",
                    href: imgAttributes.src
                }, fill ? {
                    imageSrcSet: imgAttributes.srcSet,
                    imageSizes: imgAttributes.sizes
                } : null))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", _objectSpread({
                alt: alt,
                className: "".concat(fill ? "absolute inset-0 m-auto box-border block h-0 max-h-full min-h-full w-0 min-w-full max-w-full border-none object-cover p-0" : "", " ").concat(className),
                decoding: "async",
                loading: priority ? "eager" : loading,
                ref: ref,
                src: imgAttributes.src
            }, fill && {
                sizes: imgAttributes.sizes,
                srcSet: imgAttributes.srcSet
            }, {
                width: widthInt,
                height: heightInt
            }, props))
        ]
    });
});

ImageElement.displayName = "ImageElement";

;// CONCATENATED MODULE: ./src/snippets/components/Image/Image.jsx
function Image_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Image_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Image_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Image_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Image_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Image_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};




// Intended for use with images hosted by a CDN only
// For local images (e.g. `import Image from './image.jpg'`) and remote images (e.g. `/image.jpg`), use the <img> html tag directly
var DOMAIN = "cdn.shopify.com";
var Image = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var alt = _param.alt, className = _param.className, fill = _param.fill, height = _param.height, loading = _param.loading, priority = _param.priority, quality = _param.quality, sizes = _param.sizes, src = _param.src, width = _param.width, props = Image_objectWithoutProperties(_param, [
        "alt",
        "className",
        "fill",
        "height",
        "loading",
        "priority",
        "quality",
        "sizes",
        "src",
        "width"
    ]);
    if (false) { var url, _$ref; }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageElement, Image_objectSpread({
        alt: alt,
        className: className,
        fill: fill,
        height: height,
        loading: loading,
        priority: priority,
        quality: quality,
        ref: ref,
        sizes: sizes,
        src: src,
        width: width
    }, props));
});

Image.displayName = "Image";
Image.defaultProps = {
    alt: "",
    className: "",
    fill: false,
    height: undefined,
    loading: "auto",
    priority: false,
    quality: undefined,
    sizes: "",
    src: "",
    width: undefined
};
Image.propTypes = {
    alt: (prop_types_default()).string,
    className: (prop_types_default()).string,
    fill: (prop_types_default()).bool,
    height: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    loading: prop_types_default().oneOf([
        "auto",
        "eager",
        "lazy"
    ]),
    priority: (prop_types_default()).bool,
    quality: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    sizes: (prop_types_default()).string,
    src: (prop_types_default()).string,
    width: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ])
};

;// CONCATENATED MODULE: ./src/snippets/components/Image/index.js



/***/ }),

/***/ 8693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ YotpoStars; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/snippets/components/Svg.jsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var Svg = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var src = _param.src, title = _param.title, viewBox = _param.viewBox, props = _objectWithoutProperties(_param, [
        "src",
        "title",
        "viewBox"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", _objectSpread({
        ref: ref,
        viewBox: viewBox,
        className: "h-full w-full"
    }, props, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                href: src,
                className: "pointer-events-none"
            })
        ]
    }));
});

Svg.displayName = "Svg";
Svg.propTypes = {
    src: function src(props, propName, componentName) {
        if (!props[propName]) {
            return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(props[propName], "`."));
        }
        if (!/.+#[a-zA-Z][a-zA-Z0-9-_:.]+$/.test(props[propName])) {
            return new Error("Invalid prop `".concat(propName, "` supplied to' `").concat(componentName, "`. Must end with `#` followed by the `id` attributed to the svg, e.g. `icon-name.svg#icon-name`."));
        }
        return undefined;
    },
    title: (prop_types_default()).string,
    viewBox: (prop_types_default()).string.isRequired
};

;// CONCATENATED MODULE: ./src/snippets/components/YotpoStars.jsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




function YotpoStars(param1) {
    var _rating = param1.rating, rating = _rating === void 0 ? 0 : _rating;
    var stars = (0,react.useMemo)(function() {
        var fullStar = {
            key: "star-full",
            label: "Full Star"
        };
        var emptyStar = {
            key: "star-empty",
            label: "Empty Star"
        };
        var halfStar = {
            key: "star-half-empty",
            label: "Half Star"
        };
        return _toConsumableArray(Array(5).keys()).map(function(index) {
            var diff = rating - index;
            if (diff >= 0.75) {
                return fullStar;
            }
            if (diff >= 0.25) {
                return halfStar;
            }
            return emptyStar;
        });
    }, [
        rating
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center gap-0.5",
        children: stars.map(function(param, index) {
            var key = param.key, label = param.label;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    className: "w-4 text-currentcolor",
                    src: "/icons/".concat(key, ".svg#").concat(key),
                    title: label,
                    viewBox: "0 0 24 24"
                })
            }, index);
        })
    });
}
YotpoStars.displayName = "YotpoStars";
YotpoStars.propTypes = {
    color: (prop_types_default()).string,
    rating: (prop_types_default()).number
};


/***/ }),

/***/ 34115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);

function Checkbox(param) {
    var label = param.label, name = param.name, value = param.value, _disabled = param.disabled, disabled = _disabled === void 0 ? "false" : _disabled, checked = param.checked, className = param.className, onClick = param.onClick, Icon = param.Icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "my-3 flex items-center ".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "checkbox",
                value: value,
                name: name,
                id: name,
                className: "shrink-0",
                disabled: disabled === "true",
                checked: checked,
                readOnly: true,
                onClick: onClick
            }, value),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "ml-4 flex items-center gap-3 pl-0.5 leading-none",
                htmlFor: name,
                children: [
                    Icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {}),
                    label
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 51422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98702);
/* harmony import */ var _inputs_Checkbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34115);
/* harmony import */ var _snippets_icons_ArrowUp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90107);
/* harmony import */ var _snippets_icons_Filter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15776);
/* harmony import */ var _snippets_icons_SortBy__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54591);
/* harmony import */ var _snippets_icons_Close__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54059);
/* harmony import */ var _utils_Helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41717);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










function FilterBar(param) {
    var sort = param.sort, items = param.items, mobileFilterOpen = param.mobileFilterOpen, setMobileFilterOpen = param.setMobileFilterOpen, currentFilters = param.currentFilters, setLayoutParams = param.setLayoutParams, browserHistory = param.browserHistory, enableFilters = param.enableFilters, disableSort = param.disableSort;
    var filterPrefix = [
        "Discounts:",
        "Prime Day Deals:",
        "Collection:",
        "Product Type:",
        "Hair Concern:",
        "Hair Type:", 
    ];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), sortOpen = ref3[0], setSortOpen = ref3[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), desktopOpenFilter = ref1[0], setDesktopOpenfilter = ref1[1];
    var vpWidth = (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_9__/* .useWindowDimensions */ .dz)().vpWidth;
    var scrollDirection = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useScrollDirection */ .C7)();
    var filtersContainer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var stickySentinel = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var isBrowser = "object" !== "undefined";
    var header = isBrowser ? document.querySelector(".site-header") : null;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), enableShadow = ref2[0], setEnableShadow = ref2[1];
    var sortOptions = [
        {
            label: "Price, Low To High",
            value: "price:asc"
        },
        {
            label: "Price, High To Low",
            value: "price:desc"
        },
        {
            label: "Alphabetically, A-Z",
            value: "alpha:asc"
        },
        {
            label: "Alphabetically, Z-A",
            value: "alpha:desc"
        },
        {
            label: "Most Popular",
            value: "pop:desc"
        }, 
    ];
    var collectionIndex = [
        {
            ref: "don't despair, repair!",
            label: "Don't Despair, Repair!",
            color: "text-pink",
            order: 1
        },
        {
            ref: "don't despair repair!",
            label: "Don't Despair Repair!",
            color: "text-pink",
            order: 1
        },
        {
            ref: "scalp revival",
            label: "Scalp Revival",
            color: "text-blue-2-alt",
            order: 2
        },
        {
            ref: "curl charisma",
            label: "Curl Charisma",
            color: "text-purple",
            order: 3
        },
        {
            ref: "destined for density",
            label: "Destined for Density",
            color: "text-seafoam",
            order: 4
        },
        {
            ref: "briogeo superfoods",
            label: "Briogeo Superfoods",
            color: "text-green",
            order: 5
        },
        {
            ref: "farewell frizz",
            label: "Farewell Frizz",
            color: "text-pink-2",
            order: 6
        },
        {
            ref: "be gentle, be kind",
            label: "Be Gentle, Be Kind",
            color: "text-brown",
            order: 7
        },
        {
            ref: "be gentle be kind",
            label: "Be Gentle Be Kind",
            color: "text-brown",
            order: 7
        },
        {
            ref: "color me brilliant",
            label: "Color Me Brilliant",
            color: "text-blue-1",
            order: 8
        },
        {
            ref: "blossom & bloom",
            label: "Blossom & Bloom",
            color: "text-orange",
            order: 9
        }, 
    ];
    var productTypeIndex = [
        {
            ref: "shampoos",
            label: "Shampoos",
            order: 1
        },
        {
            ref: "conditioners",
            label: "Conditioners",
            order: 2
        },
        {
            ref: "treatment masks",
            label: "Treatments + masks",
            order: 3
        },
        {
            ref: "oils",
            label: "Oils + serums",
            order: 4
        },
        {
            ref: "styling & finishing",
            label: "Styling",
            order: 5
        },
        {
            ref: "supplements",
            label: "Supplements",
            order: 6
        },
        {
            ref: "value sets (save 15%+)",
            label: "Bundles",
            order: 7
        },
        {
            ref: "jumbos (save 40%)",
            label: "Jumbo sizes",
            order: 8
        },
        {
            ref: "trial kits (under $35)",
            label: "Travel",
            order: 9
        },
        {
            ref: "brushes & tools",
            label: "Tools + accessories",
            order: 10
        }, 
    ];
    var concernIndex = [
        {
            ref: "dry damaged",
            label: "Repair",
            order: 1
        },
        {
            ref: "dry flaky scalp",
            label: "Scalp",
            order: 2
        },
        {
            ref: "frizz",
            label: "Frizz",
            order: 3
        },
        {
            ref: "thinning",
            label: "Thicken",
            order: 4
        },
        {
            ref: "frizzy curls/coils",
            label: "Curls",
            order: 5
        },
        {
            ref: "color protect",
            label: "Color treated",
            order: 6
        },
        {
            ref: "volumize",
            label: "Volumize",
            order: 7
        },
        {
            ref: "sensitive skin",
            label: "Hypoallergenic",
            order: 8
        },
        {
            ref: "dull",
            label: "Moisturize",
            order: 9
        }, 
    ];
    var typeIndex = [
        {
            ref: "straight",
            label: "Straight (1A - 1C)",
            order: 1
        },
        {
            ref: "wavy",
            label: "Wavy (2A - 2C)",
            order: 2
        },
        {
            ref: "curly",
            label: "Curly (3A - 3C)",
            order: 3
        },
        {
            ref: "coily",
            label: "Coily (4A - 4C)",
            order: 4
        }, 
    ];
    var dealsOrder = [
        {
            ref: "50% off",
            label: "50% off",
            order: 1
        },
        {
            ref: "40% off",
            label: "40% off",
            order: 2
        },
        {
            ref: "35% off",
            label: "35% off",
            order: 3
        },
        {
            ref: "30% off",
            label: "30% off",
            order: 4
        },
        {
            ref: "25% off",
            label: "25% off",
            order: 5
        },
        {
            ref: "20% off",
            label: "20% off",
            order: 6
        }, 
    ];
    var discountsOrder = [
        {
            ref: "50% off",
            label: "50% off",
            order: 1
        },
        {
            ref: "40% off",
            label: "40% off",
            order: 2
        },
        {
            ref: "35% off",
            label: "35% off",
            order: 3
        },
        {
            ref: "30% off",
            label: "30% off",
            order: 4
        }, 
    ];
    var setFilterList = function() {
        if (!Array.isArray(items)) return [];
        var tagList = [];
        items === null || items === void 0 ? void 0 : items.forEach(function(product) {
            var ref;
            product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.forEach(function(tag) {
                var tagFound = tagList.find(function(item) {
                    return item === tag;
                });
                if (!tagFound) {
                    tagList.push(tag);
                }
            });
        });
        var filterList = tagList.filter(function(item) {
            return filterPrefix.some(function(value) {
                return item.includes(value);
            });
        });
        return filterList;
    };
    var filterList1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(setFilterList);
    var getItemsByFilter = function(filter) {
        var currentFilterList = filterList1.filter(function(item) {
            return item.includes(filter);
        });
        if (filter === "Collection:") {
            currentFilterList = currentFilterList.map(function(item) {
                var indexedItem = collectionIndex.find(function(mapItem) {
                    return mapItem.ref === item.replace(filter, "").toLowerCase();
                });
                if (indexedItem) {
                    indexedItem.originalText = item;
                }
                return indexedItem;
            });
        }
        if (filter === "Hair Concern:") {
            currentFilterList = currentFilterList.map(function(item) {
                var indexedItem = concernIndex.find(function(mapItem) {
                    return mapItem.ref === item.replace(filter, "").toLowerCase();
                });
                if (indexedItem) {
                    indexedItem.originalText = item;
                }
                return indexedItem;
            });
        }
        if (filter === "Hair Type:") {
            currentFilterList = currentFilterList.map(function(item) {
                var indexedItem = typeIndex.find(function(mapItem) {
                    return mapItem.ref === item.replace(filter, "").toLowerCase();
                });
                if (indexedItem) {
                    indexedItem.originalText = item;
                }
                return indexedItem;
            });
        }
        if (filter === "Product Type:") {
            currentFilterList = currentFilterList.map(function(item) {
                var indexedItem = productTypeIndex.find(function(mapItem) {
                    return mapItem.ref === item.replace(filter, "").toLowerCase();
                });
                if (indexedItem) {
                    indexedItem.originalText = item;
                }
                return indexedItem;
            });
        }
        if (filter === "Prime Day Deals:") {
            currentFilterList = currentFilterList.map(function(item) {
                var indexedItem = dealsOrder.find(function(mapItem) {
                    return mapItem.ref === item.replace(filter, "").toLowerCase();
                });
                if (indexedItem) {
                    indexedItem.originalText = item;
                }
                return indexedItem;
            });
        }
        if (filter === "Discounts:") {
            currentFilterList = currentFilterList.map(function(item) {
                var indexedItem = dealsOrder.find(function(mapItem) {
                    return mapItem.ref === item.replace(filter, "").toLowerCase();
                });
                if (indexedItem) {
                    indexedItem.originalText = item;
                }
                return indexedItem;
            });
        }
        return currentFilterList.filter(function(item) {
            return !!item;
        });
    };
    var getItemData = function(filter) {
        var group = filter.split(":")[0];
        var item = filter.split(":")[1];
        var currentFilter = {};
        if (group === "Collection") {
            currentFilter = collectionIndex.find(function(mapItem) {
                return mapItem.ref.indexOf(item.toLowerCase()) > -1;
            });
        }
        if (group === "Hair Concern") {
            currentFilter = concernIndex.find(function(mapItem) {
                return mapItem.ref === item.toLowerCase();
            });
        }
        if (group === "Hair Type") {
            currentFilter = typeIndex.find(function(mapItem) {
                return mapItem.ref === item.toLowerCase();
            });
        }
        if (group === "Product Type") {
            currentFilter = productTypeIndex.find(function(mapItem) {
                return mapItem.ref === item.toLowerCase();
            });
        }
        if (group === "Prime Day Deals") {
            currentFilter = dealsOrder.find(function(mapItem) {
                return mapItem.ref === item.toLowerCase();
            });
        }
        if (group === "Discounts") {
            currentFilter = discountsOrder.find(function(mapItem) {
                return mapItem.ref === item.toLowerCase();
            });
        }
        return currentFilter;
    };
    var toggleFilter = function(evt) {
        var filter = evt.target.value;
        var filterIndex = currentFilters.indexOf(filter);
        var addFilter = evt.target.checked;
        var newFilters = currentFilters;
        var urlParams = new URLSearchParams(document.location.search);
        if (addFilter) {
            newFilters.push(filter);
        } else {
            newFilters.splice(filterIndex, 1);
        }
        if (newFilters.length > 0) {
            urlParams.set("filter", newFilters.join("|"));
        } else {
            urlParams.delete("filter");
        }
        urlParams.delete("page");
        setLayoutParams(function(layoutParams) {
            if (browserHistory) {
                var customState = _objectSpread({}, window.history.state, {
                    url: router.pathname + "?" + urlParams.toString(),
                    as: router.pathname.replace("[handle]", router.query.handle) + "?" + urlParams.toString()
                });
                window.history.replaceState(customState, "", customState.as);
            }
            var newParams = _objectSpread({}, layoutParams, {
                filters: newFilters,
                page: 1
            });
            return newParams;
        });
    };
    var clearFilters = function() {
        setLayoutParams(function(layoutParams) {
            return _objectSpread({}, layoutParams, {
                handle: router.query.handle,
                filters: [],
                page: 1
            });
        });
    };
    var toggleGroup = function(evt) {
        evt.currentTarget.parentNode.classList.toggle("is-closed");
    };
    var buildFilterItemList = function(filter) {
        var currentItems = getItemsByFilter(filter).sort(function(a, b) {
            return a.order - b.order;
        });
        var filterItems = currentItems.map(function(filterItem) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: "my-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_inputs_Checkbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    name: "".concat(filterItem.originalText),
                    value: "".concat(filterItem.originalText),
                    Icon: filterItem === null || filterItem === void 0 ? void 0 : filterItem.icon,
                    label: "".concat(filterItem === null || filterItem === void 0 ? void 0 : filterItem.label),
                    className: "".concat(filterItem === null || filterItem === void 0 ? void 0 : filterItem.color),
                    onClick: toggleFilter,
                    checked: currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters.includes(filterItem.originalText)
                })
            }, "".concat(filterItem.originalText));
        });
        return filterItems;
    };
    var getCurrentFilters = function(filter) {
        var activeFilters = currentFilters.filter(function(currentFilter) {
            return currentFilter.includes(filter);
        });
        return (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) || 0;
    };
    var getCurrentSortLabel = function() {
        var option1 = sortOptions.find(function(option) {
            return option.value === sort;
        });
        return option1 === null || option1 === void 0 ? void 0 : option1.label;
    };
    var buildDesktopFilterGroups = function() {
        var filterGroups = filterPrefix.map(function(filter) {
            var title = filter.replace(":", "").replace("Hair ", "");
            var currentActiveFilters = getCurrentFilters(filter);
            var filterItemList = buildFilterItemList(filter);
            if (filterItemList.length > 0) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "filter-group group relative border-grey-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "filter-button relative flex h-[50px] min-w-[200px] items-center border border-black pl-4 pr-16 text-left font-hafferBold text-xs",
                            type: "button",
                            onClick: function() {
                                setDesktopOpenfilter(function(actualFilter) {
                                    if (document.location.href.indexOf("/collections/") > -1) {
                                        window.dataLayer.push({
                                            event: "Click - Desktop PLP Filter"
                                        });
                                    }
                                    return actualFilter === filter ? null : filter;
                                });
                            },
                            children: [
                                title,
                                currentActiveFilters > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "ml-1",
                                    children: [
                                        "(",
                                        currentActiveFilters,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "align-center t-1/2 absolute right-0 ml-auto flex justify-center border-l border-l-black px-4 py-5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_icons_ArrowUp__WEBPACK_IMPORTED_MODULE_5__/* .ArrowUp */ .a, {
                                        className: "rotate-180\n                    ".concat(desktopOpenFilter === filter ? "rotate-0" : "", "\n                  ")
                                    })
                                })
                            ]
                        }),
                        desktopOpenFilter === filter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "filter-list absolute left-0 top-full z-50 mb-0 mt-5 min-w-[250px] list-none border border-black bg-white px-5 py-3 text-sm before:absolute before:top-[-11px] before:block before:h-5 before:w-5 before:-rotate-45 before:border-t before:border-r before:border-black before:bg-white",
                            children: filterItemList
                        })
                    ]
                }, title);
            }
        });
        return filterGroups;
    };
    var buildMobilefilterGroups = function() {
        var printed = 0;
        var filterGroups = filterPrefix.map(function(filter) {
            var title = filter.replace(":", "").replace("Hair ", "");
            var currentActiveFilters = getCurrentFilters(filter);
            var filterItemList = buildFilterItemList(filter);
            if (filterItemList.length > 0) {
                printed++;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "filter-group group border-grey-4 px-5 ".concat(printed === 1 ? "border-t-0 md:border-t" : "border-t"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            type: "button",
                            className: "filter-header flex w-full items-center py-3",
                            onClick: toggleGroup,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
                                    className: "mb-0 text-left",
                                    children: [
                                        title,
                                        currentActiveFilters > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "ml-1",
                                            children: [
                                                "(",
                                                currentActiveFilters,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "ml-auto rotate-180 transition-transform duration-150 group-[.is-closed]:rotate-0",
                                    "aria-hidden": true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_icons_ArrowUp__WEBPACK_IMPORTED_MODULE_5__/* .ArrowUp */ .a, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "m-0 mb-8 list-none overflow-hidden p-0 group-[.is-closed]:mb-0 group-[.is-closed]:max-h-0",
                            children: filterItemList
                        })
                    ]
                }, title);
            }
        });
        return filterGroups;
    };
    var buildActivefilters = function() {
        var currentFilterItems = currentFilters.map(function(filter) {
            var item = getItemData(filter);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: "filter__active-item flex items-center gap-2 rounded-full border-2 py-1 px-5 font-hafferBold text-xs",
                onClick: function() {
                    toggleFilter({
                        target: {
                            value: filter,
                            checked: false
                        }
                    });
                },
                children: [
                    item === null || item === void 0 ? void 0 : item.label,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "ml-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_icons_Close__WEBPACK_IMPORTED_MODULE_8__/* .Close */ .x, {
                            className: "w-2.5"
                        })
                    })
                ]
            }, filter);
        });
        return currentFilterItems;
    };
    var toggleMobileFilter = function() {
        setMobileFilterOpen(function(filterOpen) {
            return !filterOpen;
        });
    };
    var updateSortOption = function(option) {
        setSortOpen(false);
        setLayoutParams(function(layoutParams) {
            var newParams = _objectSpread({}, layoutParams, {
                sort: option
            });
            if (browserHistory) {
                var urlParams = new URLSearchParams(document.location.search);
                urlParams.set("sort", option);
                router.push({
                    query: _objectSpread({}, router.query, {
                        sort: option
                    })
                }, undefined, {
                    shallow: true
                });
            }
            return newParams;
        });
    };
    var escapeListener = function(evt) {
        if (evt.key === "Escape") {
            setMobileFilterOpen(false);
            setDesktopOpenfilter(null);
        }
    };
    var clickListener = function(evt) {
        if (evt.target.closest(".filter-button")) return null;
        if (!evt.target.closest(".filter-list") && desktopOpenFilter) {
            setDesktopOpenfilter(null);
        }
    };
    var observerCallback = function(evt) {
        evt.forEach(function(entry) {
            if (entry.intersectionRatio < 1) {
                setEnableShadow(true);
            } else {
                setEnableShadow(false);
            }
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var observer = new IntersectionObserver(observerCallback, {
            threshold: [
                1,
                0
            ]
        });
        observer.observe(stickySentinel.current);
        return function() {
            observer.disconnect(stickySentinel.current);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.addEventListener("keyup", escapeListener);
        document.addEventListener("click", clickListener);
        return function() {
            document.removeEventListener("keyup", escapeListener);
            document.removeEventListener("click", clickListener);
        };
    }, [
        desktopOpenFilter
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var action = "remove";
        if (mobileFilterOpen) {
            action = "add";
        }
        if (isBrowser) {
            document.querySelector("body").classList[action]("overflow-hidden");
        }
    }, [
        mobileFilterOpen
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!header) return;
        var headerHeight = header.offsetHeight;
        if (vpWidth < 1024) {
            if (scrollDirection === "up") {
                header.style.top = "0";
                filtersContainer.current.style.top = headerHeight - 1 + "px";
                stickySentinel.current.style.height = headerHeight + 1 + "px";
            } else if (scrollDirection === "down") {
                header.style.top = "-".concat(headerHeight, "px");
                filtersContainer.current.style.top = "0";
                stickySentinel.current.style.height = "1px";
            }
        } else {
            header.style.top = "0";
            filtersContainer.current.style.top = headerHeight + "px";
            stickySentinel.current.style.height = headerHeight + 1 + "px";
        }
    }, [
        vpWidth,
        scrollDirection
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "filters__desktop-container sticky z-30 mx-auto mb-5 bg-white transition-all duration-150 ease-in-out",
                ref: filtersContainer,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "sticky_sentinel absolute bottom-full block w-5",
                        ref: stickySentinel
                    }),
                    enableShadow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "absolute left-1/2 top-0 hidden h-full w-full -translate-x-1/2 opacity-25 shadow-md shadow-black lg:block"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex border-t border-b border-grey-4 lg:container lg:mx-auto lg:border-b-0 lg:border-t-0 lg:px-5 lg:py-7",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "filters__mobile-toggler-container lg:hidden ".concat(disableSort ? "w-full" : "w-1/2"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    type: "button",
                                    className: "flex h-[50px] w-full items-center justify-center text-xs",
                                    onClick: toggleMobileFilter,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "icon-container mb-0.5",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_icons_Filter__WEBPACK_IMPORTED_MODULE_6__/* .Filters */ .x, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "ml-2",
                                            children: "Filter"
                                        }),
                                        (currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "ml-1",
                                            children: [
                                                "(",
                                                currentFilters.length,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "filters__desktop-container hidden items-center lg:flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "filters__label mr-5 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_icons_Filter__WEBPACK_IMPORTED_MODULE_6__/* .Filters */ .x, {}),
                                            "filter"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "filters__desktop-container flex gap-5",
                                        children: buildDesktopFilterGroups()
                                    })
                                ]
                            }),
                            disableSort !== true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "filters__desktop-sort-container relative ml-auto w-1/2 lg:hidden lg:w-auto xl:flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "mr-4 ml-4 hidden flex-shrink-0 items-center gap-4 lg:flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_icons_SortBy__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                                            "sort by"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        type: "button",
                                        className: "sort-box flex h-[50px] w-full items-center justify-center px-2 lg:w-[205px] lg:border lg:border-black lg:px-0 ".concat(enableFilters !== false && "border-l border-grey-4"),
                                        onClick: function() {
                                            if (document.location.href.indexOf("/collections/") > -1) {
                                                window.dataLayer.push({
                                                    event: "Click - Desktop Sort By"
                                                });
                                            }
                                            setSortOpen(function(curentSortOpen) {
                                                return !curentSortOpen;
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-xs lg:w-full lg:px-4 lg:text-left lg:font-hafferBold",
                                                children: getCurrentSortLabel() || "Sort By"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex h-full w-[50px] shrink-0 items-center justify-center self-end lg:border-l",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "transition-transform duration-150 ".concat(!sortOpen ? "rotate-180" : ""),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_icons_ArrowUp__WEBPACK_IMPORTED_MODULE_5__/* .ArrowUp */ .a, {
                                                        className: "w-3 md:w-4"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    sortOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "sort-options absolute top-full right-0 z-50 m-0 w-full border border-grey-4 bg-white p-0 md:border-black",
                                        children: sortOptions.map(function(option) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                className: "my-4 list-none",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    type: "button",
                                                    className: "w-full border-0 bg-transparent px-4 text-left text-xs hover:font-hafferBold ".concat(option.value === sort ? "font-hafferBold" : ""),
                                                    onClick: function() {
                                                        updateSortOption(option.value);
                                                    },
                                                    children: option.label
                                                })
                                            }, option.value);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            currentFilters.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "filters__active-list my-5 hidden items-start gap-5 px-5 lg:container lg:mx-auto lg:flex lg:px-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "filters__active-label shrink-0 font-hafferBold text-xs leading-8",
                        children: "Refine By"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "filter__active-items flex flex-wrap gap-5",
                        children: [
                            buildActivefilters(),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "font-hafferBold text-sm underline hover:no-underline",
                                onClick: clearFilters,
                                children: "clear all"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "filters__mobile-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
                        className: "md:min-w[250px] fixed top-0 left-0 z-[2147483648] flex h-full w-full max-w-md flex-col overflow-hidden bg-white transition-all duration-300\n          ".concat(mobileFilterOpen ? "translate-x-0" : "-translate-x-full"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "filter-header-mobile sticky top-0 z-10 flex items-center border-b bg-white px-7 py-5",
                                children: [
                                    currentFilters.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "button",
                                        className: "focus-link",
                                        onClick: clearFilters,
                                        children: "clear filters"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        type: "button",
                                        className: "close-button ml-auto flex items-center gap-6 font-hafferBold",
                                        onClick: toggleMobileFilter,
                                        children: [
                                            "close",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_icons_Close__WEBPACK_IMPORTED_MODULE_8__/* .Close */ .x, {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "overflow-y-auto",
                                children: buildMobilefilterGroups()
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "filter-footer-mobile sticky bottom-0 mt-auto bg-grey-9 px-4 py-5",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    className: "button button--primary w-full font-hafferBold",
                                    onClick: toggleMobileFilter,
                                    children: "apply filters"
                                })
                            })
                        ]
                    }, "filter-sidebar"),
                    mobileFilterOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        "aria-label": "Toggle mobile filter",
                        className: "mobile-filter-backdrop fixed top-0 left-0 z-[214748364] h-full w-full cursor-pointer bg-black transition-all duration-300 ".concat(mobileFilterOpen ? "pointer-events-auto opacity-50" : "pointer-events-none opacity-0"),
                        onClick: toggleMobileFilter
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FilterBar);


/***/ }),

/***/ 99666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35230);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12393);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98702);
/* harmony import */ var _ProductPrice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13491);
/* harmony import */ var _utils_Metafields__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86501);
/* harmony import */ var _utils_Images__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80152);
/* harmony import */ var _snippets_products_ProductBadge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36092);
/* harmony import */ var _snippets_components_YotpoStars__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8693);
/* harmony import */ var _snippets_components_Image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69342);
/* harmony import */ var _snippets_products_BuyWithPrimeBadge__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76731);
/* harmony import */ var _utils_Helper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41717);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}















function ProductCard(param) {
    var passedProduct = param.product, handle = param.handle, index = param.index, searchTerm = param.searchTerm, _showReviews = param.showReviews, showReviews = _showReviews === void 0 ? true : _showReviews, _quickViewButton = param.quickViewButton, quickViewButton = _quickViewButton === void 0 ? "top" : _quickViewButton, showBWPBadge = param.showBWPBadge, isSearch = param.isSearch, _showSubscriptionPrice = param.showSubscriptionPrice, showSubscriptionPrice = _showSubscriptionPrice === void 0 ? false : _showSubscriptionPrice, _showQuickBuyButton = param.showQuickBuyButton, showQuickBuyButton = _showQuickBuyButton === void 0 ? false : _showQuickBuyButton, tmp = param.belowFold, initBelowFold = tmp === void 0 ? false : tmp, _isSection = param.isSection, isSection = _isSection === void 0 ? false : _isSection;
    var ref14, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_13__/* .useInView */ .YD)({
        rootMargin: "400px",
        triggerOnce: true
    }), ref11 = ref10.ref, inView = ref10.inView;
    var settings = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useSettings)();
    var country = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var sendClickProductItemEvent = (0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useDataLayerActions */ .KZ)().sendClickProductItemEvent;
    var ref12 = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useProductByHandle)({
        handle: handle,
        fetchOnMount: inView
    }), fetchedProduct = ref12.product;
    var product = fetchedProduct || ((passedProduct === null || passedProduct === void 0 ? void 0 : passedProduct.loaded) ? passedProduct : null);
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), adding = ref13[0], setAdding = ref13[1];
    var firstSellingPlan = showSubscriptionPrice ? product === null || product === void 0 ? void 0 : (ref14 = product.variants) === null || ref14 === void 0 ? void 0 : (ref1 = ref14[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sellingPlanAllocations) === null || ref2 === void 0 ? void 0 : ref2[0] : null;
    var vpWidth = (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_12__/* .useWindowDimensions */ .dz)().vpWidth;
    var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return vpWidth < 1024;
    }, [
        vpWidth
    ]);
    var taggedBWP = (product === null || product === void 0 ? void 0 : (ref3 = product.tags) === null || ref3 === void 0 ? void 0 : ref3.indexOf("BWP")) > -1;
    var bottomline = (0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useYotpoProductBottomline */ .zs)({
        legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId
    }).bottomline;
    var localized = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useLocalizedVariant)({
        variant: product === null || product === void 0 ? void 0 : (ref4 = product.variants) === null || ref4 === void 0 ? void 0 : ref4[0]
    }).localized;
    var ShowBuyWithPrime = false;
    if (showBWPBadge && taggedBWP) {
        ShowBuyWithPrime = true;
    }
    var metafieldMap = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,_utils_Metafields__WEBPACK_IMPORTED_MODULE_7__/* .getMetafieldMap */ .x)(product);
    }, [
        product,
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var primaryImgSrc = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        if (!((ref = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref === void 0 ? void 0 : ref.src)) return null;
        return (0,_utils_Images__WEBPACK_IMPORTED_MODULE_14__/* .getSizedImageUrl */ .M0)(product.images[0].src, "750x");
    }, [
        (ref5 = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref5 === void 0 ? void 0 : ref5.src
    ]);
    var primaryImgAlt = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        return (ref = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref === void 0 ? void 0 : ref.alt;
    }, [
        (ref6 = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref6 === void 0 ? void 0 : ref6.alt
    ]);
    var hoverImgSrc = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        if (!((ref = product === null || product === void 0 ? void 0 : product.images[1]) === null || ref === void 0 ? void 0 : ref.src)) return null;
        return (0,_utils_Images__WEBPACK_IMPORTED_MODULE_14__/* .getSizedImageUrl */ .M0)(product.images[1].src, "750x");
    }, [
        (ref7 = product === null || product === void 0 ? void 0 : product.images[1]) === null || ref7 === void 0 ? void 0 : ref7.src
    ]);
    var hoverImgAlt = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        return (ref = product === null || product === void 0 ? void 0 : product.images[1]) === null || ref === void 0 ? void 0 : ref.alt;
    }, [
        (ref8 = product === null || product === void 0 ? void 0 : product.images[1]) === null || ref8 === void 0 ? void 0 : ref8.alt
    ]);
    var belowFold = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (isSearch) return false;
        if (!isSection) {
            if (vpWidth < 768) return index >= 2 ? true : false;
            else return index >= 4 ? true : false;
        }
        return initBelowFold;
    }, [
        initBelowFold,
        isMobile,
        vpWidth,
        isSearch,
        index,
        isSection
    ]);
    var toggleQuickViewModal = function(e) {
        var ref;
        e.preventDefault();
        e.stopPropagation();
        document.dispatchEvent(new CustomEvent("quickViewModal:open", {
            detail: {
                product: _objectSpread({}, product, {
                    enableSubscription: settings === null || settings === void 0 ? void 0 : (ref = settings.subscriptions) === null || ref === void 0 ? void 0 : ref.selectSubscriptionOnLoad
                })
            }
        }));
    };
    var collection = metafieldMap.custom_collection_title;
    var comparePriceText = (metafieldMap === null || metafieldMap === void 0 ? void 0 : metafieldMap.custom_compare_at_price) || "";
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var ref;
        sendClickProductItemEvent({
            isSearchResult: isSearch,
            listIndex: index,
            localized: localized,
            product: product,
            searchTerm: searchTerm,
            selectedVariant: product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0]
        });
        if (typeof onClick === "function") onClick();
    }, [
        index,
        localized,
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var cartAddItem = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCartAddItem)().cartAddItem;
    var addItemToCart = function() {
        var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
            var openMiniCart, _args = arguments;
            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        openMiniCart = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                        _ctx.next = 3;
                        return cartAddItem({
                            merchandiseId: id,
                            quantity: 1,
                            attributes: [
                                {
                                    key: "_sc",
                                    value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                                }
                            ]
                        }, function() {
                            if (openMiniCart) {
                                window.dispatchEvent(new CustomEvent("openSideCart"));
                            }
                            setAdding(false);
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addItemToCart(id) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "product-card flex h-full flex-col",
        ref: ref11,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                    className: "flex h-full flex-col no-underline pt-[45px] lg:pt-0 bg-[#f8f8f8] lg:bg-transparent",
                    "aria-label": "Go to product ".concat(product === null || product === void 0 ? void 0 : product.title),
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "product-card__image group relative block aspect-square shrink-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "pdp-custom-badges flex flex-col items-end absolute top-[-40px] lg:top-0 right-[2px] md:right-0 mt-2 md:mt-6",
                                    children: [
                                        metafieldMap.custom_badge_label_1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "pdp-custom-badge-container-2 z-[1]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                className: "pdp-custom-badge-1 rounded-tl-md rounded-bl-md tracking-wide font-hafferBold text-[12px] pt-[8px] pr-[10px] pb-[8px] pl-[12px]",
                                                style: {
                                                    backgroundColor: metafieldMap.custom_badge_label_bg_1,
                                                    color: metafieldMap.custom_badge_label_color_1
                                                },
                                                children: metafieldMap.custom_badge_label_1
                                            })
                                        }),
                                        metafieldMap.custom_badge_label_2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "pdp-custom-badge-container-2 mt-2 md:mt-4 z-[1]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                className: "pdp-custom-badge-2 rounded-tl-md rounded-bl-md tracking-wide font-hafferBold text-[12px] pt-[8px] pr-[10px] pb-[8px] pl-[12px]",
                                                style: {
                                                    backgroundColor: metafieldMap.custom_badge_label_bg_2,
                                                    color: metafieldMap.custom_badge_label_color_2
                                                },
                                                children: metafieldMap.custom_badge_label_2
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_snippets_products_ProductBadge__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    product: product,
                                    className: "md:!h-13 md:!w-13 z-[8] !h-11 !w-11 ".concat(ShowBuyWithPrime ? "!bottom-[50px] md:!bottom-[75px]" : "!bottom-[-0.25rem] lg:!bottom-3"),
                                    forceSaveBadge: showSubscriptionPrice,
                                    belowFold: belowFold
                                }),
                                ShowBuyWithPrime === true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_snippets_products_BuyWithPrimeBadge__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    className: "z-[8] md:w-13 md:h-13 absolute bottom-[-0.25rem] lg:bottom-3 left-3 h-11 w-11"
                                }),
                                primaryImgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "top-0 left-0 absolute aspect-square h-full w-full object-cover transition-opacity duration-300 lg:group-hover:opacity-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_snippets_components_Image__WEBPACK_IMPORTED_MODULE_10__/* .Image */ .E, {
                                        src: primaryImgSrc,
                                        width: "750",
                                        height: "750",
                                        alt: primaryImgAlt || "".concat(product === null || product === void 0 ? void 0 : product.title, " primary image"),
                                        loading: belowFold ? "lazy" : "eager",
                                        sizes: "(max-width: 768px) 50vw, (max-width: 1024) 35vw, 27vw",
                                        "data-primary-image": true
                                    })
                                }),
                                hoverImgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "l-0 t-0 absolute aspect-square h-full w-full object-cover opacity-0 transition-opacity duration-300 lg:group-hover:opacity-100",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_snippets_components_Image__WEBPACK_IMPORTED_MODULE_10__/* .Image */ .E, {
                                        src: hoverImgSrc,
                                        alt: hoverImgAlt || "".concat(product === null || product === void 0 ? void 0 : product.title, " secondary image"),
                                        fill: true,
                                        width: "500",
                                        height: "500",
                                        sizes: "(max-width: 768px) 50vw, (max-width: 1024) 35vw, 27vw",
                                        loading: belowFold ? "lazy" : "eager",
                                        "data-hover-image": true
                                    })
                                }),
                                quickViewButton === "top" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                    type: "button",
                                    className: "z-[8] button button--outline pointer-events-none absolute bottom-5 left-0 right-0 mx-auto hidden w-[225px] max-w-[80%] opacity-0 transition-opacity duration-300 group-hover:pointer-events-auto group-hover:opacity-100 lg+:block",
                                    onClick: toggleQuickViewModal,
                                    children: showSubscriptionPrice === true ? "subscribe & save" : "quick view"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "product-card__body mt-3.5 pt-3 lg:pt-0 flex h-full flex-col bg-white",
                            children: [
                                collection && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "mb-0 font-hafferBold text-[11px] ".concat((0,_utils_Metafields__WEBPACK_IMPORTED_MODULE_7__/* .getMetafieldColor */ .O)(metafieldMap)),
                                    children: collection
                                }),
                                metafieldMap.custom_ingredient_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "mb-0.5 block font-tiempos text-sm italic",
                                    children: metafieldMap.custom_ingredient_title
                                }),
                                (metafieldMap.custom_product_title || (product === null || product === void 0 ? void 0 : product.title)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                    className: "mb-2 font-hafferBold text-sm text-black",
                                    children: metafieldMap.custom_product_title || (product === null || product === void 0 ? void 0 : product.title)
                                }),
                                showReviews && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "yotpo-reviews pointer-events-none mb-2.5 min-h-[17.5px] ".concat(showSubscriptionPrice === true ? "hidden lg:block" : ""),
                                    children: bottomline && bottomline.total_reviews > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "flex flex-wrap items-center gap-1.5",
                                        children: bottomline.total_reviews ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_snippets_components_YotpoStars__WEBPACK_IMPORTED_MODULE_9__/* .YotpoStars */ .M, {
                                                    rating: bottomline.average_score
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                    className: "mb-0 flex-1 text-[13px] leading-[17.5px] underline max-md:hidden",
                                                    children: [
                                                        bottomline.total_reviews,
                                                        " Review",
                                                        bottomline.total_reviews === 1 ? "" : "s"
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "mb-0 text-[13px] leading-[17.5px] underline",
                                            children: "No reviews"
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "yotpo-no-reviews text-sm text-black underline",
                                        children: "No reviews"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ProductPrice__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    product: product,
                                    variant: product === null || product === void 0 ? void 0 : product.variants[0],
                                    planPrice: (ref9 = firstSellingPlan === null || firstSellingPlan === void 0 ? void 0 : firstSellingPlan.priceAdjustments[0].price) === null || ref9 === void 0 ? void 0 : ref9.amount,
                                    selectedPlan: firstSellingPlan,
                                    comparePriceText: comparePriceText,
                                    className: "mb-5"
                                }),
                                showSubscriptionPrice === true && metafieldMap.annual_savings_message !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "product-card__savings-message mb-5 -mt-3 block font-hafferBold text-sm font-bold text-primary-2",
                                    children: metafieldMap.annual_savings_message
                                }),
                                quickViewButton === "bottom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                    type: "button",
                                    className: "button button--outline bottom-5 mx-auto mt-auto hidden w-full lg+:block",
                                    onClick: toggleQuickViewModal,
                                    children: showSubscriptionPrice === true ? "subscribe + save" : "quick view"
                                }),
                                showSubscriptionPrice === true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle, "?subscription"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        className: "button button--secondary mt-auto !min-w-0 !text-xs no-underline lg:hidden",
                                        children: "subscribe & save"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            showQuickBuyButton === true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                type: "button",
                className: "product-mobile-plp-add-to-cart button button--checkout mt-auto h-[44px] !min-w-0 !text-xs !leading-none no-underline",
                onClick: function(e) {
                    addItemToCart(product === null || product === void 0 ? void 0 : product.variants[0].id, false);
                    setAdding(true);
                },
                children: adding ? "adding..." : "add to cart"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductCard);


/***/ }),

/***/ 5011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_ProductGrid; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/snippets/globals/layout/ProductCard.jsx
var ProductCard = __webpack_require__(99666);
// EXTERNAL MODULE: ../node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(12393);
// EXTERNAL MODULE: ./src/snippets/components/Image/index.js + 2 modules
var Image = __webpack_require__(69342);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utilities/Helper.js
var Helper = __webpack_require__(41717);
;// CONCATENATED MODULE: ./src/snippets/components/CollectionPromoTile.jsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function CollectionPromoTile(param) {
    var tile = param.tile, _index = param.index, index = _index === void 0 ? 0 : _index;
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)({
        rootMargin: "0px",
        triggerOnce: true
    }), ref1 = ref.ref, inView = ref.inView;
    var aspectRatio = tile.aspectRatio, background = tile.background, link = tile.link;
    var ref2 = _objectSpread({}, background), alt = ref2.alt, d_image = ref2.d_image, m_image = ref2.m_image;
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var belowFold = (0,react.useMemo)(function() {
        if (vpWidth < 768) return index >= 2 ? true : false;
        else return index >= 5 ? true : false;
        return true;
    }, [
        vpWidth,
        index
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full",
        children: (link === null || link === void 0 ? void 0 : link.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative ".concat(aspectRatio, " overflow-hidden plp-promo-image-cta"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: link === null || link === void 0 ? void 0 : link.url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "no-underline hover:underline",
                    "aria-label": (link === null || link === void 0 ? void 0 : link.text) || alt || (link === null || link === void 0 ? void 0 : link.url),
                    children: [
                        (d_image === null || d_image === void 0 ? void 0 : d_image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            alt: alt,
                            fill: true,
                            sizes: "(min-width: 768px) 33vw, 50vw",
                            src: d_image.src,
                            width: "400",
                            height: "500",
                            className: "hidden md:block",
                            loading: belowFold ? "lazy" : "eager"
                        }),
                        (m_image === null || m_image === void 0 ? void 0 : m_image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            alt: alt,
                            fill: true,
                            sizes: "(max-width: 767px) 33vw, 50vw",
                            width: "337",
                            height: "555",
                            src: m_image.src,
                            className: "block md:hidden",
                            loading: belowFold ? "lazy" : "eager"
                        }),
                        (link === null || link === void 0 ? void 0 : link.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute bottom-0 w-full p-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "button button--primary !min-w-full",
                                children: link === null || link === void 0 ? void 0 : link.text
                            })
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative ".concat(aspectRatio, " overflow-hidden plp-promo-image-only"),
            children: [
                (d_image === null || d_image === void 0 ? void 0 : d_image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    alt: alt,
                    fill: true,
                    sizes: "(min-width: 768px) 33vw, 50vw",
                    width: "400",
                    height: "500",
                    src: d_image.src,
                    className: "hidden md:block",
                    loading: belowFold ? "lazy" : "eager"
                }),
                (m_image === null || m_image === void 0 ? void 0 : m_image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    alt: alt,
                    fill: true,
                    sizes: "(max-width: 767px) 33vw, 50vw",
                    width: "337",
                    height: "555",
                    src: m_image.src,
                    className: "block md:hidden",
                    loading: belowFold ? "lazy" : "eager"
                })
            ]
        })
    });
}
CollectionPromoTile.displayName = "CollectionPromoTile";

;// CONCATENATED MODULE: ./src/snippets/globals/layout/ProductGrid.jsx





function ProductGrid(param) {
    var productList = param.productList, isSearch = param.isSearch, showSubscriptionPrice = param.showSubscriptionPrice, collection = param.collection;
    var isBrowser = "object" !== "undefined";
    var siteSettings = (0,dist.useSettings)();
    var bwpSettings = siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.buyWithPrime;
    var country = (0,dist.useCountry)().country;
    var isUs = (country === null || country === void 0 ? void 0 : country.isoCode) === "US";
    var showBWPBadge = (0,react.useMemo)(function() {
        var ref;
        if ((bwpSettings === null || bwpSettings === void 0 ? void 0 : bwpSettings.bwpLocation) === "global" && isUs) {
            return true;
        }
        if ((bwpSettings === null || bwpSettings === void 0 ? void 0 : bwpSettings.bwpLocation) === "local" && (bwpSettings === null || bwpSettings === void 0 ? void 0 : (ref = bwpSettings.collectionList) === null || ref === void 0 ? void 0 : ref.indexOf(collection === null || collection === void 0 ? void 0 : collection.handle)) > -1 && isUs) {
            return true;
        }
        return false;
    }, [
        collection === null || collection === void 0 ? void 0 : collection.handle,
        isUs,
        bwpSettings === null || bwpSettings === void 0 ? void 0 : bwpSettings.bwpLocation,
        bwpSettings === null || bwpSettings === void 0 ? void 0 : bwpSettings.collectionList
    ]);
    var checkScrollIntoView = function(id) {
        var enableScrollIntoView = false;
        if (isBrowser && window.location.hash.replace("#", "") === id) {
            enableScrollIntoView = true;
        }
        return enableScrollIntoView;
    };
    var buildGridItem = function(item, index) {
        if (item.handle) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "mt-0 w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                    product: item,
                    handle: item.handle,
                    scrollIntoView: checkScrollIntoView(item === null || item === void 0 ? void 0 : item.legacyResourceId),
                    index: index,
                    showBWPBadge: showBWPBadge,
                    isSearch: isSearch,
                    showSubscriptionPrice: showSubscriptionPrice
                })
            }, "grid-item-".concat(index));
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "mt-0 w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionPromoTile, {
                    tile: item,
                    index: index
                })
            }, "cta-item-".concat(index));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "m-0 grid w-full list-none grid-cols-2 gap-y-9 gap-x-6 p-0 md:grid-cols-3 lg:grid-cols-4 mb-10",
        children: productList.map(function(product, index) {
            return buildGridItem(product, index);
        })
    }, "product-grid");
}
/* harmony default export */ var layout_ProductGrid = (ProductGrid);


/***/ }),

/***/ 13491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_Helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41717);
/* harmony import */ var _utils_Metafields__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86501);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function ProductPrice(param) {
    var product = param.product, variant = param.variant, selectedPlan = param.selectedPlan, planPrice = param.planPrice, _comparePriceText = param.comparePriceText, comparePriceText = _comparePriceText === void 0 ? "" : _comparePriceText, _className = param.className, className = _className === void 0 ? "" : _className, _compareStyles = param.compareStyles, compareStyles = _compareStyles === void 0 ? "" : _compareStyles;
    var ref5, ref1;
    var settings = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__.useSettings)();
    var country = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__.useCountry)().country;
    var ref2 = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__.useLocalizedVariant)({
        variant: variant
    }), localizedVariant = ref2.localized;
    var selectedVariant = _objectSpread({}, variant, localizedVariant);
    var isLocalized = !!(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref5 = selectedVariant.priceV2) === null || ref5 === void 0 ? void 0 : ref5.locale);
    var currencySymbol = isLocalized ? (country === null || country === void 0 ? void 0 : (ref1 = country.currency) === null || ref1 === void 0 ? void 0 : ref1.symbol) || "$" : "$";
    var getCompareAtPrice = function() {
        var ref;
        var comparePrice;
        if (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.compareAtPriceV2) === null || ref === void 0 ? void 0 : ref.amount) {
            var ref3;
            comparePrice = parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.compareAtPriceV2) === null || ref3 === void 0 ? void 0 : ref3.amount).toFixed(2);
        }
        if (selectedPlan && planPrice) {
            var ref4;
            comparePrice = parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref4 = selectedVariant.priceV2) === null || ref4 === void 0 ? void 0 : ref4.amount).toFixed(2);
        }
        if (comparePrice === 0) return null;
        return comparePrice;
    };
    var getProductPrice = function() {
        var ref;
        var price = parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.priceV2) === null || ref === void 0 ? void 0 : ref.amount).toFixed(2);
        if (selectedPlan && planPrice) {
            price = parseFloat(planPrice.replace(currencySymbol, "")).toFixed(2);
        }
        return price;
    };
    var compareAmount = getCompareAtPrice();
    var comparePrice1 = compareAmount ? "".concat(currencySymbol).concat(compareAmount).replace(".00", "") : compareAmount;
    var productPrice = "".concat(currencySymbol).concat(getProductPrice()).replace(".00", "");
    var discountedPrice = (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_2__/* .getDiscountedPrice */ ._L)(settings === null || settings === void 0 ? void 0 : settings.automaticDiscountCollections, product, selectedVariant, currencySymbol, planPrice);
    if ((discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.productPrice) && (discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.comparePrice)) {
        productPrice = discountedPrice.productPrice;
        compareAmount = discountedPrice.comparePrice.replace(currencySymbol, "").replace(".00", "");
        comparePrice1 = discountedPrice.comparePrice;
    }
    // hide price is not us and currency conversion not found
    // if (!isUs && !isLocalized) return null;
    if (!variant) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "product-price font-hafferBold text-sm ".concat(className),
        children: [
            compareAmount && comparePriceText === "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "mr-1 text-grey-3 line-through ".concat(compareStyles),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "sr-only",
                        children: "Previous Price"
                    }),
                    selectedPlan && (discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.productPrice) ? productPrice : comparePrice1
                ]
            }),
            comparePriceText !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mr-1 text-grey-3 ".concat(compareStyles),
                children: comparePriceText
            }),
            productPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "sr-only text-black",
                        children: "Current price"
                    }),
                    selectedPlan ? planPrice : productPrice
                ]
            })
        ]
    }, "product-price");
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductPrice);


/***/ }),

/***/ 92301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ArrowLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);

function ArrowLeft() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "7",
        height: "11",
        viewBox: "0 0 7 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6 1L2 5.5L6 10",
            stroke: "currentcolor",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
}


/***/ }),

/***/ 14604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);

function ArrowRight() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "7",
        height: "11",
        viewBox: "0 0 7 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1 10L5 5.5L1 1",
            stroke: "currentcolor",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
}


/***/ }),

/***/ 90107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ ArrowUp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function ArrowUp(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", _objectSpread({
        width: "17",
        height: "10",
        viewBox: "0 0 17 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15 8.5L8.5 2L2 8.5",
            stroke: "currentcolor",
            strokeWidth: "2",
            strokeLinecap: "square"
        })
    }));
}


/***/ }),

/***/ 54059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Close; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function Close(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", _objectSpread({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "14.5455",
                y1: "1.41476",
                x2: "1.41422",
                y2: "14.546",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "14.5858",
                y1: "14.5455",
                x2: "1.45453",
                y2: "1.41423",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "square"
            })
        ]
    }));
}


/***/ }),

/***/ 64647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);

function DarkCircleCheckmark() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "11.25",
                stroke: "black",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8 12.5714L11.2727 16L16 8",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DarkCircleCheckmark);


/***/ }),

/***/ 15776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Filters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);

function Filters() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "15",
        height: "10",
        viewBox: "0 0 15 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.54167 9.5V7.91667H8.70833V9.5H5.54167ZM2.375 5.54167V3.95833H11.875V5.54167H2.375ZM0 1.58333V0H14.25V1.58333H0Z",
            fill: "currentcolor"
        })
    });
}


/***/ }),

/***/ 42004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Info; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function Info(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", _objectSpread({
        width: "100%",
        height: "100%",
        viewBox: "0 0 14 14",
        version: "1.1",
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            transform: "matrix(1,0,0,1,-0.073459,-0.0462351)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "matrix(0.840453,0,0,0.95131,-570.136,-281.721)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    transform: "matrix(1.18984,0,0,1.05118,678.368,296.141)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M13.164,6.592C13.164,2.977 10.234,0.046 6.619,0.046C3.004,0.046 0.073,2.977 0.073,6.592C0.073,10.207 3.004,13.137 6.619,13.137C10.234,13.137 13.164,10.207 13.164,6.592ZM12.164,6.592C12.164,9.654 9.682,12.137 6.619,12.137C3.556,12.137 1.073,9.654 1.073,6.592C1.073,3.529 3.556,1.046 6.619,1.046C9.682,1.046 12.164,3.529 12.164,6.592ZM6.219,9.251L7.187,9.251L7.187,5.027L6.219,5.027L6.219,9.251ZM6.179,4.379L7.219,4.379L7.219,3.459L6.179,3.459L6.179,4.379Z",
                        fill: "currentColor",
                        fillRule: "nonzero"
                    })
                })
            })
        })
    }));
}


/***/ }),

/***/ 54591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function SortBy(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", _objectSpread({
        width: "19",
        height: "18",
        viewBox: "0 0 19 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 16V3",
                stroke: "currentColor",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14 2L14 15",
                stroke: "currentColor",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1 6L5 2L9 6",
                stroke: "currentColor",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18 12L14 16L10 12",
                stroke: "currentColor",
                strokeWidth: "1.5"
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (SortBy);


/***/ }),

/***/ 91588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uu": function() { return /* reexport */ icon_account; },
  "BD": function() { return /* reexport */ arrow_down; },
  "D6": function() { return /* reexport */ arrow_left; },
  "Ec": function() { return /* reexport */ arrow_right; },
  "k5": function() { return /* reexport */ icon_cart; },
  "C2": function() { return /* reexport */ icon_chevron_down; },
  "bM": function() { return /* reexport */ icon_close/* default */.Z; },
  "dc": function() { return /* reexport */ icon_menu; },
  "Ur": function() { return /* reexport */ icon_minus; },
  "SC": function() { return /* reexport */ icon_plus; },
  "HF": function() { return /* reexport */ icon_remove; },
  "jV": function() { return /* reexport */ icon_search; },
  "WM": function() { return /* reexport */ icon_zoom_in; }
});

// UNUSED EXPORTS: IconError, IconStar

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
;// CONCATENATED MODULE: ./public/icons/icon-menu.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconMenu = function SvgIconMenu(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    d: "M1 1h18M1 17h18M1 9h18"
  })));
};
/* harmony default export */ var icon_menu = (SvgIconMenu);
;// CONCATENATED MODULE: ./public/icons/icon-search.svg
var _circle, icon_search_path;
function icon_search_extends() { icon_search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_search_extends.apply(this, arguments); }

var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/react.createElement("svg", icon_search_extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    stroke: "currentColor",
    strokeWidth: 2
  })), icon_search_path || (icon_search_path = /*#__PURE__*/react.createElement("path", {
    d: "m21 21-5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
/* harmony default export */ var icon_search = (SvgIconSearch);
;// CONCATENATED MODULE: ./public/icons/icon-account.svg
var icon_account_path, icon_account_circle;
function icon_account_extends() { icon_account_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_account_extends.apply(this, arguments); }

var SvgIconAccount = function SvgIconAccount(props) {
  return /*#__PURE__*/react.createElement("svg", icon_account_extends({
    width: 20,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_account_path || (icon_account_path = /*#__PURE__*/react.createElement("path", {
    d: "M19 22H1v-4a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v4Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), icon_account_circle || (icon_account_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 10,
    cy: 5.5,
    r: 4.5,
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
/* harmony default export */ var icon_account = (SvgIconAccount);
;// CONCATENATED MODULE: ./public/icons/icon-cart.svg
var icon_cart_path, _path2;
function icon_cart_extends() { icon_cart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_cart_extends.apply(this, arguments); }

var SvgIconCart = function SvgIconCart(props) {
  return /*#__PURE__*/react.createElement("svg", icon_cart_extends({
    width: 20,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_cart_path || (icon_cart_path = /*#__PURE__*/react.createElement("path", {
    d: "M1.448 21V7.62h17.38V21a4 4 0 0 1-4 4h-9.38a4 4 0 0 1-4-4Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M6.414 10.103V4.724A3.724 3.724 0 0 1 10.138 1v0a3.724 3.724 0 0 1 3.724 3.724v5.38",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
/* harmony default export */ var icon_cart = (SvgIconCart);
;// CONCATENATED MODULE: ./public/icons/icon-chevron-down.svg
var icon_chevron_down_path;
function icon_chevron_down_extends() { icon_chevron_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_chevron_down_extends.apply(this, arguments); }

var SvgIconChevronDown = function SvgIconChevronDown(props) {
  return /*#__PURE__*/react.createElement("svg", icon_chevron_down_extends({
    width: 10,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_chevron_down_path || (icon_chevron_down_path = /*#__PURE__*/react.createElement("path", {
    d: "m2 2 3 3 3-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
/* harmony default export */ var icon_chevron_down = (SvgIconChevronDown);
// EXTERNAL MODULE: ./public/icons/icon-close.svg
var icon_close = __webpack_require__(23278);
;// CONCATENATED MODULE: ./public/icons/arrow-down.svg
var arrow_down_path;
function arrow_down_extends() { arrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_down_extends.apply(this, arguments); }

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_down_extends({
    width: 17,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_down_path || (arrow_down_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.11 1.6 8.64 8.1l6.528-6.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
/* harmony default export */ var arrow_down = (SvgArrowDown);
;// CONCATENATED MODULE: ./public/icons/arrow-left.svg
var arrow_left_path;
function arrow_left_extends() { arrow_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_left_extends.apply(this, arguments); }

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_left_extends({
    width: 10,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_left_path || (arrow_left_path = /*#__PURE__*/react.createElement("path", {
    d: "m8.229 2-6.5 6.5 6.5 6.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
/* harmony default export */ var arrow_left = (SvgArrowLeft);
;// CONCATENATED MODULE: ./public/icons/arrow-right.svg
var arrow_right_path;
function arrow_right_extends() { arrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_right_extends.apply(this, arguments); }

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_right_extends({
    width: 10,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_right_path || (arrow_right_path = /*#__PURE__*/react.createElement("path", {
    d: "m2 2 6.5 6.5L2 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
/* harmony default export */ var arrow_right = (SvgArrowRight);
;// CONCATENATED MODULE: ./public/icons/icon-zoom-in.svg
var icon_zoom_in_path, icon_zoom_in_path2;
function icon_zoom_in_extends() { icon_zoom_in_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_zoom_in_extends.apply(this, arguments); }

var SvgIconZoomIn = function SvgIconZoomIn(props) {
  return /*#__PURE__*/react.createElement("svg", icon_zoom_in_extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_zoom_in_path || (icon_zoom_in_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.898 7.57a7.618 7.618 0 0 1-1.316 4.294L18 16.354 16.38 18l-4.374-4.444A7.34 7.34 0 0 1 7.45 15.14C3.334 15.14 0 11.75 0 7.57S3.334 0 7.449 0c4.114 0 7.449 3.39 7.449 7.57Zm-13.294 0c0 3.275 2.622 5.94 5.845 5.94s5.844-2.665 5.844-5.94c0-3.275-2.621-5.94-5.844-5.94-3.223 0-5.845 2.665-5.845 5.94Z",
    fill: "currentColor"
  })), icon_zoom_in_path2 || (icon_zoom_in_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M8.251 6.871V3.96H6.647v2.912H3.782v1.63h2.865v2.912H8.25V8.502h2.865v-1.63H8.251Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var icon_zoom_in = (SvgIconZoomIn);
;// CONCATENATED MODULE: ./public/icons/icon-remove.svg
var icon_remove_path, icon_remove_path2;
function icon_remove_extends() { icon_remove_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_remove_extends.apply(this, arguments); }

var SvgIconRemove = function SvgIconRemove(props) {
  return /*#__PURE__*/react.createElement("svg", icon_remove_extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_remove_path || (icon_remove_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.52 16.308 2.6 4h13l-1.823 12.293A2 2 0 0 1 11.8 18H6.497a2 2 0 0 1-1.976-1.692Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), icon_remove_path2 || (icon_remove_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M1 4h16M5.6 4V1h7v3",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
/* harmony default export */ var icon_remove = (SvgIconRemove);
;// CONCATENATED MODULE: ./public/icons/icon-plus.svg
var icon_plus_path;
function icon_plus_extends() { icon_plus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_plus_extends.apply(this, arguments); }

var SvgIconPlus = function SvgIconPlus(props) {
  return /*#__PURE__*/react.createElement("svg", icon_plus_extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_plus_path || (icon_plus_path = /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M6.4 1v10M1.4 5.85h10"
  })));
};
/* harmony default export */ var icon_plus = (SvgIconPlus);
;// CONCATENATED MODULE: ./public/icons/icon-minus.svg
var icon_minus_path;
function icon_minus_extends() { icon_minus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_minus_extends.apply(this, arguments); }

var SvgIconMinus = function SvgIconMinus(props) {
  return /*#__PURE__*/react.createElement("svg", icon_minus_extends({
    width: 12,
    height: 2,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_minus_path || (icon_minus_path = /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M1 1h10"
  })));
};
/* harmony default export */ var icon_minus = (SvgIconMinus);
;// CONCATENATED MODULE: ./public/icons/icon-star.svg
var icon_star_path;
function icon_star_extends() { icon_star_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_star_extends.apply(this, arguments); }

var SvgIconStar = function SvgIconStar(props) {
  return /*#__PURE__*/React.createElement("svg", icon_star_extends({
    width: 46,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_star_path || (icon_star_path = /*#__PURE__*/React.createElement("path", {
    d: "m23 3.58 5.078 12.21.323.776.837.067L42.42 17.69l-10.043 8.603-.638.547.195.816 3.068 12.864-11.285-6.893-.717-.438-.717.438-11.285 6.893 3.068-12.864.195-.816-.638-.547L3.58 17.69l13.182-1.057.837-.067.323-.775L23 3.58Z",
    stroke: "currentColor",
    strokeWidth: 2.75
  })));
};
/* harmony default export */ var icon_star = ((/* unused pure expression or super */ null && (SvgIconStar)));
// EXTERNAL MODULE: ./public/icons/error-icon.svg
var error_icon = __webpack_require__(48438);
;// CONCATENATED MODULE: ./src/snippets/index.js


















/***/ }),

/***/ 76731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BuyWithPrimeBadge; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
;// CONCATENATED MODULE: ./src/snippets/icons/BWPBadge.jsx

function BWPBadge(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 635 636",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M317.4,635.2C492.7,635.2 634.8,493.1 634.8,317.8C634.8,142.5 492.7,0.4 317.4,0.4C142.1,0.4 0,142.5 0,317.8C0,493.1 142.1,635.2 317.4,635.2Z",
                fill: "rgb(35,47,62)",
                fillRule: "nonzero"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M484.2,477C440,509.7 375.8,527 320.6,527C243.2,527 173.5,498.4 120.8,450.7C116.7,447 120.4,441.9 125.3,444.7C182.2,477.8 252.5,497.8 325.2,497.8C374.2,497.8 428.1,487.6 477.7,466.6C485.2,463.5 491.5,471.6 484.2,477ZM502.6,456C497,448.8 465.2,452.6 451,454.3C446.7,454.8 446,451.1 449.9,448.3C475.2,430.5 516.7,435.6 521.5,441.6C526.4,447.6 520.2,489.2 496.5,509.1C492.8,512.2 489.4,510.5 491,506.5C496.3,493.1 508.2,463.2 502.6,456ZM122.4,421.7C121.3,421.8 120.3,421.5 119.5,420.8C119.1,420.4 118.9,419.9 118.7,419.4C118.5,418.9 118.5,418.3 118.5,417.8L118.5,314.6C118.4,314.1 118.5,313.5 118.7,313C118.9,312.5 119.1,312 119.5,311.6C120.3,311 121.4,310.7 122.4,310.8L133.5,310.8C134.5,310.7 135.5,311 136.3,311.6C137.1,312.2 137.6,313.1 137.8,314.2L138.8,318.2C142,315.1 145.8,312.7 150,311.1C154.3,309.4 158.8,308.5 163.4,308.5C173.4,308.5 181.3,312.2 187.1,319.5C192.9,326.8 195.8,336.7 195.8,349.2C195.8,357.8 194.4,365.2 191.5,371.6C189,377.5 185,382.6 179.8,386.4C174.8,389.9 168.9,391.7 162.8,391.6C158.7,391.6 154.6,390.9 150.7,389.6C147.1,388.4 143.8,386.5 140.9,384L140.9,417.9C141,418.4 141,419 140.9,419.5C140.8,420 140.5,420.5 140.1,420.9C139.7,421.3 139.2,421.6 138.7,421.7C138.2,421.8 137.6,421.9 137.1,421.7L122.4,421.7ZM488.41,308.398C488.507,308.399 488.603,308.399 488.7,308.4C498.3,308.4 505.8,310.7 511.2,315.4C516.6,320 519.3,326.2 519.3,334C519.3,341.7 516.4,347.6 510.6,351.5C504.8,355.5 496.2,357.5 484.8,357.5C479.6,357.6 474.5,357 469.5,355.8C470.1,362.7 472.2,367.7 475.7,370.6C479.2,373.5 484.6,375.1 491.9,375.1C494.7,375.1 497.5,374.9 500.3,374.6C504.1,374 507.9,373.2 511.7,372.2C512,372.1 512.3,372 512.6,372C512.712,372 512.811,371.986 512.906,371.968L513.094,371.932C513.189,371.914 513.287,371.9 513.4,371.9C515.1,371.9 516,373.1 516,375.5L516,382.6C516.1,383.8 515.9,385 515.3,386.1C514.6,386.9 513.7,387.6 512.6,387.9C505.1,390.7 497,392.2 488.8,392.1C476,392.1 466.2,388.6 459.3,381.6C452.4,374.6 449,364.5 449,351.4C449,338 452.5,327.5 459.5,319.8C466.391,312.319 475.995,308.423 488.121,308.398L488.41,308.398ZM318.6,389.8C318.1,389.9 317.5,389.9 317,389.7C316.5,389.5 316,389.3 315.6,388.9C315.2,388.5 314.9,388.1 314.8,387.5C314.6,387 314.6,386.4 314.7,385.9L314.7,314.6C314.6,314.1 314.7,313.5 314.9,313C315.1,312.5 315.3,312 315.7,311.6C316.5,311 317.6,310.7 318.6,310.7L329.7,310.7C330.7,310.6 331.7,310.9 332.5,311.5C333.3,312.1 333.8,313 334,314.1L335.2,318.3C339.8,315.1 344.7,312.6 350,310.6C354.4,309.1 358.9,308.3 363.5,308.4C372.8,308.4 379.3,311.7 383.1,318.3C387.7,315.1 392.7,312.6 398,310.7C402.6,309.2 407.5,308.4 412.4,308.4C419.6,308.4 425.2,310.4 429.2,314.4C433.2,318.4 435.2,324 435.2,331.3L435.2,386C435.3,387 435,388.1 434.3,388.9C433.9,389.3 433.4,389.5 432.9,389.7C432.4,389.9 431.8,389.9 431.3,389.9L416.4,389.9C415.9,390 415.3,390 414.8,389.8C414.3,389.6 413.8,389.4 413.4,389C413,388.6 412.7,388.2 412.6,387.6C412.4,387.1 412.4,386.5 412.5,386L412.5,336.4C412.5,329.4 409.4,325.9 403.1,325.9C397.3,326 391.5,327.3 386.2,329.9L386.2,386C386.3,387.1 386,388.1 385.3,388.9C384.9,389.3 384.4,389.5 383.9,389.7C383.4,389.9 382.8,389.9 382.3,389.9L367.5,389.9C367,390 366.4,390 365.9,389.8C365.4,389.6 364.9,389.4 364.5,389C364.1,388.6 363.8,388.2 363.7,387.6C363.5,387.1 363.5,386.5 363.6,386L363.6,336.4C363.6,329.4 360.5,325.9 354.2,325.9C348.3,325.9 342.5,327.4 337.2,330.1L337.2,386.1C337.3,387.1 337,388.2 336.3,389C335.9,389.4 335.4,389.6 334.9,389.8C334.4,390 333.8,390 333.3,390L318.6,389.8ZM276.8,389.8C276.3,389.9 275.7,389.9 275.2,389.7C274.7,389.5 274.2,389.3 273.8,388.9C273.4,388.5 273.1,388.1 273,387.5C272.8,387 272.8,386.4 272.9,385.9L272.9,314.6C272.8,314.1 272.9,313.5 273.1,313C273.3,312.5 273.5,312 273.9,311.6C274.7,311 275.8,310.7 276.8,310.7L291.6,310.7C292.1,310.6 292.7,310.6 293.2,310.7C293.7,310.8 294.2,311.1 294.6,311.5C295,311.9 295.3,312.4 295.4,312.9C295.5,313.4 295.6,314 295.4,314.5L295.4,386C295.5,387.1 295.2,388.1 294.5,388.9C294.1,389.3 293.6,389.5 293.1,389.7C292.6,389.9 292,389.9 291.5,389.9L276.8,389.9L276.8,389.8ZM215.1,389.8C214.6,389.9 214,389.8 213.5,389.7C213,389.5 212.5,389.3 212.1,388.9C211.7,388.5 211.4,388.1 211.3,387.5C211.1,387 211.1,386.4 211.2,385.9L211.2,314.6C211.1,314.1 211.2,313.5 211.4,313C211.6,312.5 211.8,312 212.2,311.6C213,311 214.1,310.7 215.1,310.7L226.2,310.7C227.2,310.6 228.2,310.9 229,311.5C229.8,312.1 230.3,313 230.5,314.1L232.5,322.4C236.7,317.9 240.6,314.6 244.2,312.7C247.8,310.8 251.8,309.8 255.9,309.8L258.1,309.8C259.2,309.7 260.3,310 261.2,310.7C261.6,311.1 261.8,311.6 262,312.1C262.2,312.6 262.2,313.2 262.1,313.7L262.1,326.7C262.2,327.7 261.9,328.8 261.3,329.6C260.9,330 260.4,330.2 259.9,330.4C259.4,330.6 258.8,330.6 258.3,330.6C257.6,330.6 256.6,330.6 255.5,330.4C254.4,330.2 252.9,330.3 251.2,330.3C248.3,330.4 245.4,330.7 242.5,331.3C239.5,331.8 236.6,332.7 233.8,333.9L233.8,385.9C233.9,387 233.6,388 232.9,388.8C232.5,389.2 232,389.4 231.5,389.6C231,389.8 230.4,389.8 229.9,389.8L215.1,389.8ZM156.3,374.5C162.1,374.5 166.3,372.5 169.1,368.6C171.8,364.7 173.2,358.5 173.2,350C173.2,341.4 171.9,335.2 169.2,331.3C166.5,327.4 162.2,325.4 156.4,325.5C151.1,325.5 145.8,326.9 141.2,329.7L141.2,370.4C145.7,373.1 150.9,374.5 156.3,374.5ZM483.7,343.6C489,343.6 492.8,342.8 495.1,341.2C497.5,339.6 498.6,337.2 498.7,333.8C498.7,327.3 494.8,324.1 487.1,324.1C477.2,324.1 471.5,330.2 469.9,342.3C474.5,343.2 479.1,343.6 483.7,343.6ZM284.3,298.6C280.9,298.8 277.5,297.6 274.9,295.4C272.6,293 271.3,289.9 271.3,286.6C271.3,283.3 272.6,280.1 274.9,277.8C277.6,275.7 280.9,274.6 284.3,274.6C287.7,274.6 291,275.7 293.7,277.8C296,280.2 297.3,283.3 297.3,286.6C297.3,289.9 296,293.1 293.7,295.4C291.1,297.6 287.7,298.7 284.3,298.6ZM247.3,252.5C244.7,252.5 242.2,252.1 239.7,251.5C239,251.3 238.4,251 237.9,250.4C237.5,249.7 237.4,248.9 237.5,248.1L237.5,243.4C237.5,241.9 238.1,241.1 239.4,241.1C240,241.1 240.6,241.1 241.2,241.2C241.9,241.3 242.6,241.3 243.3,241.3C245.7,241.4 248,240.7 249.9,239.3C251.5,238 252.8,235.7 253.8,232.5L254.1,231.4L235.1,183C234.7,182.2 234.5,181.3 234.4,180.5C234.4,179.5 235,179 236.3,179L246.5,179C247.3,178.9 248.1,179.1 248.8,179.6C249.4,180.1 249.9,180.9 250,181.7L260.8,217.7L271,181.7C271.2,180.9 271.6,180.2 272.3,179.7C273,179.2 273.8,179 274.6,179.1L284.5,179.1C285.8,179.1 286.4,179.6 286.4,180.6C286.3,181.5 286.1,182.3 285.7,183.1L265.2,237.7C263.2,243 260.9,246.9 258.1,249.2C255,251.4 251.2,252.6 247.3,252.5ZM193.8,231.9C189.2,231.9 185.6,230.5 183.1,227.8C180.5,225.1 179.3,221.3 179.3,216.5L179.3,181.2C179.3,180.9 179.3,180.5 179.4,180.2C179.5,179.9 179.7,179.6 179.9,179.3C180.1,179 180.4,178.9 180.8,178.8C181.1,178.7 181.5,178.7 181.8,178.7L191.5,178.7C191.8,178.7 192.2,178.7 192.5,178.8C192.8,178.9 193.1,179.1 193.4,179.3C193.6,179.5 193.8,179.8 193.9,180.2C194,180.5 194,180.9 194,181.2L194,212.4C194,217.9 196.4,220.6 201.1,220.6C204.8,220.5 208.4,219.4 211.4,217.4L211.4,181.3C211.4,181 211.4,180.6 211.5,180.3C211.6,180 211.8,179.7 212,179.4C212.2,179.2 212.5,179 212.9,178.9C213.2,178.8 213.6,178.8 213.9,178.8L223.6,178.8C223.9,178.7 224.3,178.8 224.6,178.9C224.9,179 225.2,179.2 225.5,179.4C225.7,179.6 225.9,179.9 226,180.3C226.1,180.6 226.1,181 226.1,181.3L226.1,227.9C226.1,228.2 226.1,228.6 226,228.9C225.9,229.2 225.7,229.5 225.5,229.8C225.3,230 225,230.2 224.6,230.3C224.3,230.4 223.9,230.4 223.6,230.4L216.3,230.4C215.6,230.4 215,230.2 214.5,229.8C214,229.4 213.6,228.8 213.5,228.1L212.6,224.9C209.8,227.2 206.7,228.9 203.3,230.2C200.3,231.4 197,231.9 193.8,231.9ZM450.1,231.2C444.4,231.2 440.1,229.9 437.4,227.2C434.7,224.5 433.3,220.3 433.3,214.7L433.3,189.7L428,189.7C427.7,189.7 427.3,189.7 427,189.6C426.7,189.5 426.4,189.3 426.1,189.1C425.9,188.9 425.7,188.6 425.6,188.2C425.5,187.9 425.5,187.5 425.5,187.2L425.5,183C425.5,182.3 425.7,181.6 426.1,181.1C426.6,180.6 427.2,180.2 427.9,180.2L433.7,179L435.5,167.5C435.5,166.7 435.8,166 436.4,165.4C437,165 437.6,164.8 438.3,164.8L445.5,164.8C445.8,164.8 446.2,164.8 446.5,164.9C446.8,165 447.1,165.2 447.4,165.4C447.7,165.6 447.8,165.9 447.9,166.3C448,166.6 448,167 448,167.3L448,178.7L459.4,178.7C459.7,178.7 460.1,178.7 460.4,178.8C460.7,178.9 461,179.1 461.3,179.3C461.5,179.5 461.7,179.8 461.8,180.2C461.9,180.5 461.9,180.9 461.9,181.2L461.9,187.1C461.9,187.4 461.9,187.8 461.8,188.1C461.7,188.4 461.5,188.7 461.3,189C461.1,189.2 460.8,189.4 460.4,189.5C460.1,189.6 459.7,189.6 459.4,189.6L448,189.6L448,214C448,216.2 448.5,217.7 449.6,218.5C450.7,219.4 452.5,219.8 455.1,219.8C456.1,219.8 457.2,219.7 458.2,219.5C459,219.4 459.7,219.3 460.5,219.3C461.6,219.3 462.2,220 462.2,221.5L462.2,226.4C462.3,227.2 462.1,228 461.8,228.7C461.4,229.3 460.7,229.7 460,229.8C458.5,230.2 457,230.6 455.4,230.8C453.7,231.1 451.9,231.2 450.1,231.2ZM119.3,230.4C119,230.4 118.6,230.4 118.3,230.3C118,230.2 117.7,230 117.4,229.8C117.2,229.6 117,229.3 116.9,228.9C116.8,228.6 116.8,228.2 116.8,227.9L116.8,162.9C116.8,162.6 116.8,162.2 116.9,161.9C117,161.6 117.2,161.3 117.4,161C117.6,160.8 117.9,160.6 118.3,160.5C118.6,160.4 119,160.4 119.3,160.4L141.9,160.4C146,160.3 150,161.1 153.7,162.7C156.9,164.1 159.6,166.4 161.6,169.2C163.5,172.1 164.5,175.5 164.4,179C164.4,186 161.3,190.9 155,193.6C158.9,194.6 162.3,196.8 164.9,199.8C167.2,202.9 168.4,206.8 168.2,210.7C168.3,213.5 167.7,216.2 166.6,218.7C165.4,221.2 163.7,223.4 161.5,225.1C157,228.7 150.9,230.5 143.3,230.5L119.3,230.5L119.3,230.4ZM483.6,230.4L473.9,230.4C473.6,230.4 473.2,230.4 472.9,230.3C472.6,230.2 472.3,230 472,229.8C471.8,229.6 471.6,229.3 471.5,228.9C471.4,228.6 471.4,228.2 471.4,227.9L471.4,158.1C471.4,157.8 471.4,157.4 471.5,157.1C471.6,156.8 471.8,156.5 472,156.2C472.2,156 472.5,155.8 472.9,155.7C473.2,155.6 473.6,155.6 473.9,155.6L483.6,155.6C483.9,155.6 484.3,155.6 484.6,155.7C484.9,155.8 485.2,156 485.5,156.2C485.7,156.4 485.9,156.7 486,157.1C486.1,157.4 486.1,157.8 486.1,158.1L486.1,183.4C491.4,179.5 497.7,177.3 504.3,177.2C509.1,177.2 512.8,178.5 515.4,181.1C518,183.7 519.3,187.4 519.3,192.2L519.3,227.9C519.3,228.2 519.3,228.6 519.2,228.9C519.1,229.2 518.9,229.5 518.7,229.8C518.5,230 518.2,230.2 517.8,230.3C517.5,230.4 517.1,230.4 516.8,230.4L507.1,230.4C506.8,230.4 506.4,230.4 506.1,230.3C505.8,230.2 505.5,230 505.2,229.8C505,229.6 504.8,229.3 504.7,228.9C504.6,228.6 504.6,228.2 504.6,227.9L504.6,196.6C504.6,191.3 502.1,188.6 497.2,188.6C493.3,188.7 489.4,189.9 486.2,192L486.2,227.9C486.2,228.2 486.2,228.6 486.1,228.9C486,229.2 485.8,229.5 485.6,229.8C485.4,230 485.1,230.2 484.7,230.3C484.3,230.4 483.9,230.5 483.6,230.4ZM342.4,230.4L333.8,230.4C333,230.5 332.2,230.3 331.5,229.8C330.9,229.2 330.5,228.5 330.3,227.8L315.7,182.8C315.4,182 315.2,181.2 315.2,180.4C315.2,179.3 315.9,178.8 317.2,178.8L327.4,178.8C328.2,178.7 329,179 329.6,179.4C330.2,179.9 330.6,180.6 330.7,181.4L338.8,216L347.5,181.3C347.7,180.5 348.1,179.8 348.8,179.3C349.5,178.8 350.3,178.6 351.1,178.7L358.5,178.7C359.3,178.6 360.1,178.8 360.8,179.3C361.5,179.8 361.9,180.5 362.1,181.3L371,216.1L378.6,181.3C378.7,180.5 379.1,179.8 379.7,179.3C380.3,178.8 381.1,178.6 381.9,178.7L391.7,178.7C393.1,178.7 393.7,179.2 393.7,180.3C393.7,181.1 393.5,181.9 393.2,182.7L378.5,227.7C378.4,228.5 377.9,229.3 377.3,229.7C376.6,230.2 375.8,230.4 375,230.3L366.4,230.3C365.6,230.4 364.8,230.1 364.2,229.6C363.6,229.1 363.1,228.4 363,227.6L354.7,193.9L346.3,227.6C346.1,228.4 345.7,229.1 345,229.6C344.1,230.3 343.3,230.5 342.4,230.4ZM404.7,230.4C404.4,230.4 404,230.4 403.7,230.3C403.4,230.2 403.1,230 402.8,229.8C402.6,229.6 402.4,229.3 402.3,228.9C402.2,228.6 402.2,228.2 402.2,227.9L402.2,181.3C402.2,181 402.2,180.6 402.3,180.3C402.4,180 402.6,179.7 402.8,179.4C403,179.1 403.3,179 403.7,178.9C404,178.8 404.4,178.8 404.7,178.8L414.4,178.8C414.7,178.8 415.1,178.8 415.4,178.9C415.7,179 416,179.2 416.3,179.4C416.5,179.6 416.7,179.9 416.8,180.3C416.9,180.6 416.9,181 416.9,181.3L416.9,227.9C416.9,228.2 416.9,228.6 416.8,228.9C416.7,229.2 416.5,229.5 416.3,229.8C416.1,230 415.8,230.2 415.4,230.3C415.1,230.4 414.7,230.4 414.4,230.4L404.7,230.4ZM131.1,219.6L143,219.6C149.9,219.6 153.3,216.4 153.3,209.9C153.3,203.2 149.6,199.9 142.3,199.9L131.1,199.9L131.1,219.6ZM131.1,189.6L139.9,189.6C146.4,189.6 149.7,186.6 149.7,180.5C149.7,174.3 146.7,171.2 140.7,171.2L131.1,171.2L131.1,189.6ZM409.6,170.8C407.4,170.9 405.1,170.2 403.4,168.7C401.9,167.2 401.1,165.1 401.1,162.9C401.1,160.8 401.9,158.7 403.4,157.1C405.2,155.7 407.3,155 409.6,154.9C411.8,154.9 414,155.6 415.8,157C417.3,158.6 418.1,160.6 418.1,162.8C418.1,164.9 417.3,167 415.8,168.6C414,170.1 411.8,170.9 409.6,170.8Z",
                    fill: "white",
                    fillRule: "nonzero"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/snippets/products/BuyWithPrimeBadge.jsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function BuyWithPrimeBadge(_param) {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "bwpContainer",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BWPBadge, {
            className: "h-full w-full"
        })
    });
};


/***/ }),

/***/ 36092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);

function ProductBadge(props) {
    var ref;
    var product = props.product, className = props.className, forceSaveBadge = props.forceSaveBadge, _belowFold = props.belowFold, belowFold = _belowFold === void 0 ? false : _belowFold;
    var metafields = (product === null || product === void 0 ? void 0 : product.metafields) || [];
    var badges = metafields.filter(function(badge) {
        return badge.namespace === "custom_fields" && badge.key === "badge";
    });
    var imageBadges = metafields.filter(function(badge) {
        return badge.namespace === "custom_fields" && badge.key === "badge_image";
    });
    var badgeText = badges === null || badges === void 0 ? void 0 : (ref = badges[0]) === null || ref === void 0 ? void 0 : ref.value;
    if (!badges.length && !imageBadges.length && !forceSaveBadge) {
        return null;
    }
    var badgeTextcolor = "text-black";
    var bgClass = "bg-yellow";
    if (badges.length && badges[0].value.toLowerCase() === "best seller") {
        bgClass = "bg-primary-1";
        badgeTextcolor = "text-white";
    }
    if (badges.length && badges[0].value.toLowerCase() === "save") {
        bgClass = "bg-primary-2";
        badgeTextcolor = "text-white";
    }
    if (forceSaveBadge) {
        bgClass = "bg-primary-2";
        badgeTextcolor = "text-white";
        badgeText = "save";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "pdp-badges left-right-rotate font-hafferBold tracking-wide ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "pdp-badge m-0".concat(imageBadges.length && !forceSaveBadge ? " !p-0" : " ".concat(bgClass, " ").concat(badgeTextcolor)),
            children: [
                imageBadges.length && !forceSaveBadge ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: imageBadges[0].value,
                    className: "block w-[63px] rounded-full lg:w-[73px]",
                    alt: product.title,
                    loading: belowFold ? "lazy" : "eager",
                    width: "73",
                    height: "73"
                }) : null,
                !imageBadges.length && badges.length || forceSaveBadge ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: badgeText
                    }
                }) : null
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductBadge);


/***/ }),

/***/ 72936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _utils_Metafields__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86501);



function ProductCustomBadges(props) {
    var product = props.product;
    var metafieldMap = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_Metafields__WEBPACK_IMPORTED_MODULE_2__/* .getMetafieldMap */ .x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pdp-custom-badges flex flex-col items-end absolute top-0 right-[2px] md:right-0 mt-2 md:mt-6",
        children: [
            metafieldMap.custom_badge_label_1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pdp-custom-badge-container-2 z-[1]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "pdp-custom-badge-1 rounded-tl-md rounded-bl-md tracking-wide font-hafferBold text-[12px] pt-[8px] pr-[10px] pb-[8px] pl-[12px]",
                    style: {
                        backgroundColor: metafieldMap.custom_badge_label_bg_1,
                        color: metafieldMap.custom_badge_label_color_1
                    },
                    children: metafieldMap.custom_badge_label_1
                })
            }),
            metafieldMap.custom_badge_label_2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pdp-custom-badge-container-2 mt-2 md:mt-4 z-[1]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "pdp-custom-badge-2 rounded-tl-md rounded-bl-md tracking-wide font-hafferBold text-[12px] pt-[8px] pr-[10px] pb-[8px] pl-[12px]",
                    style: {
                        backgroundColor: metafieldMap.custom_badge_label_bg_2,
                        color: metafieldMap.custom_badge_label_color_2
                    },
                    children: metafieldMap.custom_badge_label_2
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductCustomBadges);


/***/ }),

/***/ 3052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35301);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88038);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_fslightbox_react_pro__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11280);
/* harmony import */ var _utils_fslightbox_react_pro__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_utils_fslightbox_react_pro__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utilities_Images__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80152);
/* harmony import */ var _snippets_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91588);
/* harmony import */ var _utilities_Helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41717);
/* harmony import */ var _snippets_products_ProductBadge__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36092);
/* harmony import */ var _snippets_products_ProductCustomBadges__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72936);
/* harmony import */ var _BuyWithPrimeBadge__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76731);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













function NextArrow(param) {
    var className = param.className, onClick = param.onClick, quickView = param.quickView;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: "".concat(className, " slick-next pdp-thumbnails-slider-next absolute bottom-0 border border-black border-r-transparent ").concat(!quickView ? "left-2 h-12 w-[50px]" : "left-0 h-10 w-[39px]"),
        "aria-label": "View next image",
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_index__WEBPACK_IMPORTED_MODULE_7__/* .IconArrowDown */ .BD, {})
    });
}
function PrevArrow(param) {
    var className = param.className, onClick = param.onClick, quickView = param.quickView;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: "".concat(className, " slick-prev pdp-thumbnails-slider-prev absolute bottom-0 rotate-180 border border-black ").concat(!quickView ? "right-2 h-12 w-[50px]" : "right-0 h-10 w-[42px]"),
        "aria-label": "View previous image",
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_index__WEBPACK_IMPORTED_MODULE_7__/* .IconArrowDown */ .BD, {})
    });
}
function ProductGallery(param) {
    var product = param.product, _quickView = param.quickView, quickView = _quickView === void 0 ? false : _quickView, _bundleBuilder = param.bundleBuilder, bundleBuilder = _bundleBuilder === void 0 ? false : _bundleBuilder;
    var ref5;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), slider1 = ref1[0], setSlider1 = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), slider2 = ref2[0], setSlider2 = ref2[1];
    var taggedBWP = product.tags.indexOf("BWP") > -1;
    var settings = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_5__.useSettings)();
    var bwpSettings = settings === null || settings === void 0 ? void 0 : settings.buyWithPrime;
    var country = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_5__.useCountry)().country;
    var isUs = (country === null || country === void 0 ? void 0 : country.isoCode) === "US";
    var showBWPBadge = false;
    if ((bwpSettings === null || bwpSettings === void 0 ? void 0 : bwpSettings.bwpLocation) !== "disabled" && taggedBWP && isUs) {
        showBWPBadge = true;
    }
    var isHorizontal = false;
    var mgSettings = {
        mobileFirst: true,
        infinite: true,
        centerMode: false,
        centerPadding: "0",
        arrows: false,
        dots: false,
        swipeToSlide: true,
        swipe: true,
        adaptiveHeight: true,
        asNavFor: slider2 || null,
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            type: "button",
            className: "border-0",
            "aria-label": "View previous image",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_index__WEBPACK_IMPORTED_MODULE_7__/* .IconArrowLeft */ .D6, {})
        }),
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            type: "button",
            className: "border-0",
            "aria-label": "View next image",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_index__WEBPACK_IMPORTED_MODULE_7__/* .IconArrowRight */ .Ec, {})
        }),
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    arrows: true,
                    swipeToSlide: false,
                    swipe: true,
                    centerMode: !isHorizontal,
                    centerPadding: 0,
                    fade: true,
                    waitForAnimate: false
                }
            }, 
        ]
    };
    var thumbSettings = {
        infinite: true,
        mobileFirst: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        waitForAnimate: false,
        asNavFor: slider1 || null,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        resizeObserver: true,
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrevArrow, {
            quickView: quickView
        }),
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextArrow, {
            quickView: quickView
        }),
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 5.3,
                    arrows: false,
                    focusOnSelect: true,
                    swipeToSlide: true
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: bundleBuilder ? 4 : 4.5,
                    arrows: false,
                    focusOnSelect: true,
                    swipeToSlide: true
                }
            }, 
        ]
    };
    var vpWidth = (0,_utilities_Helper__WEBPACK_IMPORTED_MODULE_8__/* .useWindowDimensions */ .dz)().vpWidth;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        toggler: false,
        slide: 1
    }), lightboxController = ref3[0], setLightboxController = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), thumbsSliderReady = ref4[0], setThumbsSliderReady = ref4[1];
    var handleFsLightbox = function(evt) {
        evt.preventDefault();
        if (quickView) return false;
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: parseInt(evt.target.dataset.index, 10)
        });
    };
    var productImages = product === null || product === void 0 ? void 0 : product.media.map(function(media, index) {
        var image = null;
        if ((media === null || media === void 0 ? void 0 : media.mediaContentType) === "IMAGE") {
            var image_alt = (media === null || media === void 0 ? void 0 : media.altText) || "";
            var image_video = "";
            var video_url = "";
            if (image_alt.indexOf("Video: ") !== -1) {
                image_video = image_alt;
                image_video = image_video.replace(/Video:\s|Standard\sSize|Jumbo\sSize|\,|\s/gi, "");
            }
            if (image_video.includes("youtube.com")) {
                video_url = image_video;
            } else if (image_video.includes("vimeo.com")) {
                var image_video_id = image_video.replace("https://vimeo.com/", "");
                video_url = "https://player.vimeo.com/video/".concat(image_video_id);
            }
            image = _objectSpread({}, media === null || media === void 0 ? void 0 : media.image, {
                video: video_url
            });
        } else if ((media === null || media === void 0 ? void 0 : media.mediaContentType) === "VIDEO") {
            var ref;
            var video_url1 = "";
            for(var i = 0; i < media.sources.length; i++){
                if (media.sources[i].format === "mp4") {
                    video_url1 = media.sources[i].url;
                    break;
                }
            }
            image = _objectSpread({}, media === null || media === void 0 ? void 0 : (ref = media.preview) === null || ref === void 0 ? void 0 : ref.image, {
                video: video_url1
            });
        }
        return image;
    });
    productImages = (0,_utilities_Helper__WEBPACK_IMPORTED_MODULE_8__/* .compact */ .oA)(productImages);
    var sourcesFSLB = productImages.map(function(productImage, index) {
        var image_video = (productImage === null || productImage === void 0 ? void 0 : productImage.video) || "";
        if (image_video !== "") {
            if (image_video.includes("youtube.com") || image_video.includes(".mp4")) {
                return image_video;
            }
            if (image_video.includes("vimeo.com")) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                    src: "".concat(image_video),
                    className: "pdp-slider-iframe",
                    width: "1920",
                    height: "1080",
                    frameBorder: "0",
                    allow: "autoplay; fullscreen",
                    allowFullScreen: true
                });
            }
        } else {
            return productImage === null || productImage === void 0 ? void 0 : productImage.src;
        }
    });
    var thumnsFSLB = productImages.map(function(productImage, index) {
        return (0,_utilities_Images__WEBPACK_IMPORTED_MODULE_12__/* .getSizedImageUrl */ .M0)(productImage === null || productImage === void 0 ? void 0 : productImage.src, "115x115@2x");
    });
    var thumbnails_fix = false;
    if (productImages.length <= 5 || vpWidth <= 1224 && productImages.length <= 4) {
        thumbnails_fix = true;
    }
    var elementIsVisibleInViewport = function(el) {
        var partiallyVisible = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref = el.getBoundingClientRect(), top = ref.top, left = ref.left, bottom = ref.bottom, right = ref.right;
        var innerHeight = window.innerHeight, innerWidth = window.innerWidth;
        return partiallyVisible ? (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth) : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
    };
    var customAttributes = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return productImages.reduce(function(acc, img) {
            if ((img === null || img === void 0 ? void 0 : img.video) !== "") {
                var onLoadedData = function(evt) {
                    if ((evt === null || evt === void 0 ? void 0 : evt.target.nodeName) === "VIDEO" && !elementIsVisibleInViewport(evt.target)) {
                        evt.target.pause();
                    }
                };
                return _toConsumableArray(acc).concat([
                    {
                        playsInline: true,
                        autoPlay: true,
                        onLoadedData: onLoadedData
                    }
                ]);
            }
            return _toConsumableArray(acc).concat([
                {}
            ]);
        }, []);
    }, [
        productImages
    ]);
    var handleFsLightboxVideos = function(instance) {
        var ref, ref6, ref7, ref8;
        if (!(instance === null || instance === void 0 ? void 0 : (ref = instance.elements) === null || ref === void 0 ? void 0 : (ref6 = ref.sourceWrappersContainer) === null || ref6 === void 0 ? void 0 : ref6.current)) return;
        var slides = (instance === null || instance === void 0 ? void 0 : (ref7 = instance.elements) === null || ref7 === void 0 ? void 0 : ref7.sourceMainWrappers) || [];
        var videos = instance.elements.sourceWrappersContainer.current.querySelector("video") ? _toConsumableArray(instance.elements.sourceWrappersContainer.current.querySelectorAll("video")) : [];
        var currIndex = (instance === null || instance === void 0 ? void 0 : (ref8 = instance.stageIndexes) === null || ref8 === void 0 ? void 0 : ref8.current) || -1;
        videos.forEach(function(video) {
            video.setAttribute("autoplay", false);
            if (!(video === null || video === void 0 ? void 0 : video.paused)) video.pause();
        });
        if (currIndex > -1 && (slides === null || slides === void 0 ? void 0 : slides[currIndex])) {
            var ref9, ref10;
            var curSlide = (ref9 = slides[currIndex]) === null || ref9 === void 0 ? void 0 : ref9.current;
            if (curSlide && curSlide.querySelector("video") && ((ref10 = curSlide.querySelector("video")) === null || ref10 === void 0 ? void 0 : ref10.paused)) {
                curSlide.querySelector("video").play();
            }
        }
    };
    var firstImageUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        if (!(productImages === null || productImages === void 0 ? void 0 : (ref = productImages[0]) === null || ref === void 0 ? void 0 : ref.src)) return null;
        return (0,_utilities_Images__WEBPACK_IMPORTED_MODULE_12__/* .getSizedImageUrl */ .M0)(productImages[0].src, "600x@2x");
    }, [
        productImages === null || productImages === void 0 ? void 0 : (ref5 = productImages[0]) === null || ref5 === void 0 ? void 0 : ref5.src
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mx-auto w-full max-w-[642px] lg:max-w-none ".concat(!quickView ? "lg:pl-8" : ""),
        children: [
            firstImageUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: firstImageUrl
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex md:flex-nowrap md:items-start lg:top-[80px] lg:sticky ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-shrink-0 ".concat(!quickView ? "pdp-thumbnails-slider-container w-[20%] max-w-[110px] lg:block lg:w-[110px] lg:pt-8" : "w-20"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat(bundleBuilder ? "bb-qv-thumbnails-slider" : "pdp-thumbnails-slider", " ").concat(thumbnails_fix ? "pdp-thumbnails-fix" : ""),
                            children: [
                                !thumbsSliderReady && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-col gap-2 px-px pt-px",
                                    children: productImages.slice(0, 4).map(function(productImage, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductThumbnail, {
                                            productImage: productImage,
                                            title: product === null || product === void 0 ? void 0 : product.title,
                                            index: index
                                        }, "pdp-thumbnail-image-".concat(index));
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, thumbSettings, {
                                    ref: function(slider) {
                                        return setSlider2(slider);
                                    },
                                    infinite: !thumbnails_fix,
                                    onInit: function() {
                                        return setThumbsSliderReady(true);
                                    },
                                    children: thumbsSliderReady && productImages.map(function(productImage, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductThumbnail, {
                                                productImage: productImage,
                                                title: product === null || product === void 0 ? void 0 : product.title,
                                                index: index
                                            })
                                        }, "pdp-thumbnail-image-".concat(index));
                                    })
                                }))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex w-full flex-1 overflow-hidden ".concat(quickView ? "lg:pl-6" : "lg:pl-8"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "pdp-slider",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "aspect-square",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, mgSettings, {
                                        ref: function(slider) {
                                            return setSlider1(slider);
                                        },
                                        children: productImages.map(function(productImage, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductImage, {
                                                productImage: productImage,
                                                handleFsLightbox: handleFsLightbox,
                                                index: index,
                                                title: product === null || product === void 0 ? void 0 : product.title
                                            }, index);
                                        })
                                    }))
                                }),
                                !quickView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "pdp-zoom-icon pointer-events-none absolute right-5 bottom-[68px] md:right-6 lg:bottom-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_index__WEBPACK_IMPORTED_MODULE_7__/* .IconZoomIn */ .WM, {})
                                }),
                                !showBWPBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_products_ProductBadge__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    product: product,
                                    className: "".concat(quickView ? "left-3" : "no-bwp-badge")
                                }),
                                showBWPBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_products_ProductBadge__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    product: product,
                                    className: "".concat(quickView ? "left-3" : "has-bwp-badge")
                                }),
                                showBWPBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BuyWithPrimeBadge__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    className: "absolute top-auto bottom-[5.5rem] md:bottom-[5.75rem] lg:bottom-[6.5rem] left-3 lg:left-5 right-auto h-[60px] w-[60px] lg:h-[73px] lg:w-[73px]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_products_ProductCustomBadges__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    product: product
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_utils_fslightbox_react_pro__WEBPACK_IMPORTED_MODULE_6___default()), {
                toggler: lightboxController.toggler,
                sources: sourcesFSLB,
                thumbs: thumnsFSLB,
                showThumbsOnMount: true,
                slide: lightboxController.slide,
                customAttributes: customAttributes,
                onOpen: handleFsLightboxVideos,
                onSlideChange: handleFsLightboxVideos
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductGallery);
function ProductThumbnail(param) {
    var productImage = param.productImage, title = param.title, index = param.index;
    var image_alt = (productImage === null || productImage === void 0 ? void 0 : productImage.altText) || title || "";
    var image_video = (productImage === null || productImage === void 0 ? void 0 : productImage.video) || "";
    var imageSrc = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utilities_Images__WEBPACK_IMPORTED_MODULE_12__/* .getSizedImageUrl */ .M0)(productImage === null || productImage === void 0 ? void 0 : productImage.src, "115x115@2x");
    }, [
        productImage === null || productImage === void 0 ? void 0 : productImage.src
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "pdp-thumbnails-image ".concat(image_video !== "" ? "pdp-thumbnails-image--video" : ""),
        role: "button",
        tabIndex: "0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "responsive-image pb-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: imageSrc,
                alt: image_alt,
                loading: "eager",
                priority: true,
                fetchpriority: "high",
                width: "115",
                height: "115"
            })
        })
    });
}
function ProductImage(param) {
    var productImage = param.productImage, title = param.title, index = param.index, handleFsLightbox = param.handleFsLightbox;
    var image_alt = (productImage === null || productImage === void 0 ? void 0 : productImage.altText) || title || "Product Image ".concat(index + 1);
    var image_video = (productImage === null || productImage === void 0 ? void 0 : productImage.video) || "";
    var imageUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utilities_Images__WEBPACK_IMPORTED_MODULE_12__/* .getSizedImageUrl */ .M0)(productImage === null || productImage === void 0 ? void 0 : productImage.src, "600x@2x");
    }, [
        productImage === null || productImage === void 0 ? void 0 : productImage.src
    ]);
    var HTMLoutput = null;
    if (image_video !== "") {
        if (image_video.includes("youtube.com")) {
            HTMLoutput = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: "".concat(image_video),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "pdp-slider-slide aspect-square pdp-slider-slide--video",
                    title: image_alt,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: imageUrl,
                        alt: image_alt,
                        "data-index": index + 1,
                        onClick: function(evt) {
                            return handleFsLightbox(evt);
                        },
                        priority: true,
                        fetchpriority: "high",
                        width: "1200",
                        height: "1200"
                    })
                }, "product-image-".concat(index))
            });
        } else if (image_video.includes("vimeo.com")) {
            HTMLoutput = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: "".concat(image_video),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "pdp-slider-slide aspect-square pdp-slider-slide--video",
                    title: image_alt,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: imageUrl,
                        alt: image_alt,
                        "data-index": index + 1,
                        onClick: function(evt) {
                            return handleFsLightbox(evt);
                        },
                        priority: true,
                        fetchpriority: "high",
                        width: "1200",
                        height: "1200"
                    })
                }, "product-image-".concat(index))
            });
        } else if (image_video.includes(".mp4")) {
            HTMLoutput = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: "".concat(image_video),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "pdp-slider-slide aspect-square pdp-slider-slide--video",
                    title: image_alt,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: imageUrl,
                        alt: image_alt,
                        "data-index": index + 1,
                        onClick: function(evt) {
                            return handleFsLightbox(evt);
                        },
                        priority: true,
                        fetchpriority: "high",
                        width: "1200",
                        height: "1200"
                    })
                }, "product-image-".concat(index))
            });
        }
    } else {
        HTMLoutput = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "".concat(imageUrl),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                "data-type": "image",
                className: "pdp-slider-slide aspect-square",
                title: image_alt,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: imageUrl,
                    alt: image_alt,
                    "data-index": index + 1,
                    onClick: function(evt) {
                        return handleFsLightbox(evt);
                    },
                    priority: true,
                    fetchpriority: "high",
                    width: "1200",
                    height: "1200"
                })
            }, "product-image-".concat(index))
        });
    }
    return HTMLoutput;
}


/***/ }),

/***/ 53748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ products_ProductInformation; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/hooks/index.js + 13 modules
var hooks = __webpack_require__(98702);
// EXTERNAL MODULE: ./src/utilities/Metafields.js
var Metafields = __webpack_require__(86501);
;// CONCATENATED MODULE: ./src/snippets/icons/EmptyStar.jsx

function EmptyStar() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z",
            fill: "#DFDFDF"
        })
    });
}
/* harmony default export */ var icons_EmptyStar = (EmptyStar);

// EXTERNAL MODULE: ./src/snippets/components/YotpoStars.jsx + 1 modules
var YotpoStars = __webpack_require__(8693);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/snippets/icons/Info.jsx
var Info = __webpack_require__(42004);
// EXTERNAL MODULE: ./src/snippets/products/InfoPopup.module.css
var InfoPopup_module = __webpack_require__(48278);
var InfoPopup_module_default = /*#__PURE__*/__webpack_require__.n(InfoPopup_module);
// EXTERNAL MODULE: ./src/snippets/icons/Close.jsx
var Close = __webpack_require__(54059);
;// CONCATENATED MODULE: ./src/snippets/products/InfoPopup.jsx





function InfoPopup(param) {
    var settings = param.settings;
    var closeButton = (0,react.useRef)();
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var textColor = (settings === null || settings === void 0 ? void 0 : settings.text_color) == "White" ? "text-white" : "text-black";
    (0,react.useEffect)(function() {
        if (isOpen == true) {
            closeButton.current.focus();
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: function() {
                    setIsOpen(!isOpen);
                },
                className: "info-popup__trigger mt-4 flex rounded-full border border-black px-3.5 py-1 font-hafferBold text-sm",
                style: {
                    backgroundColor: settings === null || settings === void 0 ? void 0 : settings.label_background
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-2 rounded-full bg-white leading-none tracking-[0]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* Info */.k, {
                            className: "-mr-0.5 -mb-0.5 block w-6"
                        })
                    }),
                    settings === null || settings === void 0 ? void 0 : settings.tooltip_label
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info-popup__content absolute top-full z-10 mt-4 w-[295px] max-w-full border border-grey-4 p-4 shadow-md shadow-grey-4",
                style: {
                    backgroundColor: settings === null || settings === void 0 ? void 0 : settings.bubble_background
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "bt-1 br-1 absolute -top-2 z-[1] block h-4 w-4 rotate-45 border-t border-l border-grey-4",
                        style: {
                            backgroundColor: settings === null || settings === void 0 ? void 0 : settings.bubble_background
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        onClick: function() {
                            setIsOpen(false);
                        },
                        ref: closeButton,
                        className: "".concat(textColor, " absolute right-4 top-4"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sr-only",
                                children: "Close tooltip"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {
                                className: "h-3 w-3 text-currentcolor"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "info-popup__content ".concat(textColor, " ").concat((InfoPopup_module_default())["info-popup"], " pr-5 text-sm"),
                        dangerouslySetInnerHTML: {
                            __html: settings === null || settings === void 0 ? void 0 : settings.body_content.replaceAll("<img", '<img class="inline-block mr-2 h-[16px] aspect-square" width="16" height="16" ').replaceAll("<p", '<p class="mb-0" ')
                        }
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/snippets/components/Image/index.js + 2 modules
var Image = __webpack_require__(69342);
;// CONCATENATED MODULE: ./src/snippets/products/DiscountMessage.jsx

function DiscountMessage(param) {
    var hideDiscount = param.hideDiscount, discountHighlight = param.discountHighlight, promo = param.promo, isUs = param.isUs, siteSettings = param.siteSettings, handle = param.handle, discountValue = param.discountValue;
    var ref, ref1, ref2, ref3;
    var promoMessage = null;
    var pdpDiscountMessage = siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.discountHighlight) === null || ref === void 0 ? void 0 : ref.pdpDiscountMessage;
    var enableGlobalDiscount = siteSettings === null || siteSettings === void 0 ? void 0 : (ref1 = siteSettings.product) === null || ref1 === void 0 ? void 0 : ref1.enableGlobalDiscountMessage;
    var globalDiscountMessage = siteSettings === null || siteSettings === void 0 ? void 0 : (ref2 = siteSettings.product) === null || ref2 === void 0 ? void 0 : ref2.globalDiscountMessage;
    var globalDiscountExceptions = siteSettings === null || siteSettings === void 0 ? void 0 : (ref3 = siteSettings.product) === null || ref3 === void 0 ? void 0 : ref3.globalDiscountExceptions;
    if (!hideDiscount && !discountHighlight && promo && isUs) {
        promoMessage = promo;
    }
    if (!hideDiscount && discountHighlight && discountValue) {
        promoMessage = pdpDiscountMessage.replace("[discount]", "".concat(discountValue, "%"));
    }
    if (enableGlobalDiscount && globalDiscountMessage) {
        var isException = globalDiscountExceptions === null || globalDiscountExceptions === void 0 ? void 0 : globalDiscountExceptions.some(function(exception) {
            return (exception === null || exception === void 0 ? void 0 : exception.handle) == handle;
        });
        if (!isException) {
            promoMessage = globalDiscountMessage;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "sub-xsmall md:sub-small text-pink product-discount-message mb-2",
        children: promoMessage
    });
};

;// CONCATENATED MODULE: ./src/snippets/products/ProductInformation.jsx













function ProductInformation(props) {
    var ref12, ref1, ref2, ref3;
    var product = props.product, selectedVariant = props.selectedVariant, selectedPlan = props.selectedPlan, hideDiscount = props.hideDiscount;
    var bottomline = (0,hooks/* useYotpoProductBottomline */.zs)({
        legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId
    }).bottomline;
    var closeButton = (0,react.useRef)();
    var ref4 = (0,react.useState)(false), isOpen = ref4[0], setIsOpen = ref4[1];
    (0,react.useEffect)(function() {
        if (isOpen == true) {
            closeButton.current.focus();
        }
    }, [
        isOpen
    ]);
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var popupData = (0,react.useMemo)(function() {
        return metafieldMap.getMetafieldsByNamespace("tooltip");
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var siteSettings = (0,dist.useSettings)();
    var collectionTitle = metafieldMap.custom_collection_title;
    var collectionUrl = metafieldMap.custom_collection_url;
    var collectionLinkActive = !!(collectionUrl && (collectionTitle === null || collectionTitle === void 0 ? void 0 : collectionTitle.length));
    var ingredient = metafieldMap.custom_ingredient_title;
    var productTitle = metafieldMap.custom_product_title || product.title;
    var promo = metafieldMap.promo_message;
    var shortDescription = metafieldMap.short_description;
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var HasInfoPopup = false;
    if ((popupData === null || popupData === void 0 ? void 0 : popupData.tooltip_label) && (popupData === null || popupData === void 0 ? void 0 : popupData.body_content)) {
        HasInfoPopup = true;
    }
    var buildProductTitle = function() {
        var title;
        if (props.LinkToProduct === true) {
            title = /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/products/".concat(product.handle),
                className: "md:h3 !mb-4 font-tiempos text-h2-m no-underline md:!mb-4",
                onClick: props.onTitleClick,
                children: productTitle
            });
        } else {
            title = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "md:h3 !mb-4 font-tiempos text-h2-m md:!mb-4",
                children: productTitle
            });
        }
        return title;
    };
    var compareValue = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref12 = selectedVariant.compareAtPriceV2) === null || ref12 === void 0 ? void 0 : ref12.amount) || 0;
    var variantPrice = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.priceV2) === null || ref1 === void 0 ? void 0 : ref1.amount) || 0;
    if (selectedPlan) {
        var ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        compareValue = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref5 = selectedVariant.compareAtPriceV2) === null || ref5 === void 0 ? void 0 : ref5.amount) || (selectedPlan === null || selectedPlan === void 0 ? void 0 : (ref6 = selectedPlan.priceAdjustments) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.compareAtPrice) === null || ref8 === void 0 ? void 0 : ref8.amount);
        variantPrice = selectedPlan === null || selectedPlan === void 0 ? void 0 : (ref9 = selectedPlan.priceAdjustments) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.price) === null || ref11 === void 0 ? void 0 : ref11.amount;
    }
    var discountValue = null;
    if (compareValue > 0) {
        discountValue = Math.floor((compareValue - variantPrice) / compareValue * 100);
    }
    var discountHighlight = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref2 = siteSettings.discountHighlight) === null || ref2 === void 0 ? void 0 : ref2.enableDiscountHighlight) && (siteSettings === null || siteSettings === void 0 ? void 0 : (ref3 = siteSettings.discountHighlight) === null || ref3 === void 0 ? void 0 : ref3.pdpDiscountMessage) && discountValue !== 0 && discountValue !== null;
    var ingredientsPills = metafieldMap["ingredients_pills"] ? JSON.parse(metafieldMap["ingredients_pills"]) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-info-container--header mb-6 lg:relative",
        children: [
            !collectionLinkActive && !collectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "hidden h-3 lg:mb-4 lg:block"
            }),
            !collectionUrl && collectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "sub-xsmall mb-2 md:mb-4 ".concat((0,Metafields/* getMetafieldColor */.O)(metafieldMap)),
                children: collectionTitle
            }),
            collectionLinkActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: collectionUrl,
                className: "sub-xsmall !mb-2 flex no-underline md:!mb-4 ".concat((0,Metafields/* getMetafieldColor */.O)(metafieldMap)),
                children: collectionTitle
            }),
            ingredient && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "ingredient-label mb-2 font-tiempos text-h3-m italic text-black md:mb-2 md:text-[28px]",
                children: ingredient
            }),
            productTitle && buildProductTitle(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "yotpo-badge-container lg:absolute lg:top-0 lg:right-0 lg:bottom-0",
                children: bottomline && bottomline.total_reviews > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "#pdp-yotpo-reviews-widget",
                    className: "flex flex-wrap items-center gap-1.5",
                    "aria-label": "Scroll to product reviews",
                    children: bottomline.total_reviews ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YotpoStars/* YotpoStars */.M, {
                                rating: bottomline.average_score
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mb-0 flex-1 text-[13px] leading-[17.5px] underline",
                                children: [
                                    bottomline.total_reviews,
                                    " Review",
                                    bottomline.total_reviews === 1 ? "" : "s"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-0 text-[13px] leading-[17.5px] underline",
                        children: "No reviews"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "#pdp-yotpo-reviews-widget",
                    className: "yotpo-no-reviews text-xsmall flex cursor-pointer items-center leading-none text-black underline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mr-2 flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_EmptyStar, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_EmptyStar, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_EmptyStar, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_EmptyStar, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_EmptyStar, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Write a Review"
                        })
                    ]
                })
            }),
            Array.isArray(ingredientsPills) && ingredientsPills.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ingredients-badges mb-6 flex hidden flex-wrap gap-x-2 gap-y-3",
                children: ingredientsPills.map(function(pill, index) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("span", {
                        className: "ingredients-badge flex items-center justify-center rounded-full border-2 border-grey-4 bg-grey-9 px-3.5 py-1 font-hafferBold text-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ingredients-badge__image mr-2 h-5 w-5 shrink-0 overflow-hidden rounded-full border border-black",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: pill.image,
                                    width: "20",
                                    height: "20",
                                    className: "block h-full w-full object-cover",
                                    alt: (ref = pill.image) === null || ref === void 0 ? void 0 : ref.alt
                                })
                            }),
                            pill["ingredient_name"]
                        ]
                    }, "ingredient-".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountMessage, {
                siteSettings: siteSettings,
                promo: promo,
                discountHighlight: discountHighlight,
                hideDiscount: hideDiscount,
                isUs: isUs,
                handle: product.handle,
                discountValue: discountValue
            }),
            shortDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-xsmall md:text-small mb-2 flex flex-col text-black",
                children: shortDescription
            }),
            HasInfoPopup == true && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPopup, {
                settings: popupData
            })
        ]
    });
}
/* harmony default export */ var products_ProductInformation = (ProductInformation);


/***/ }),

/***/ 41717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nx": function() { return /* binding */ getApplicableOverride; },
/* harmony export */   "Qj": function() { return /* binding */ scrollToSection; },
/* harmony export */   "_L": function() { return /* binding */ getDiscountedPrice; },
/* harmony export */   "dz": function() { return /* binding */ useWindowDimensions; },
/* harmony export */   "lb": function() { return /* binding */ formatMoney; },
/* harmony export */   "oA": function() { return /* binding */ compact; },
/* harmony export */   "os": function() { return /* binding */ getOffset; },
/* harmony export */   "td": function() { return /* binding */ newLineToBr; },
/* harmony export */   "v8": function() { return /* binding */ handleize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

function useWindowDimensions() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        vpWidth: undefined,
        vpHeight: undefined
    }), windowDimensions = ref[0], setWindowDimensions = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function handleResize() {
            setWindowDimensions({
                vpWidth: window.innerWidth,
                vpHeight: window.innerHeight
            });
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return windowDimensions;
}
var formatMoney = function(cents, format) {
    var amountToCents = function amountToCents(e) {
        return e || (e = 0), typeof e !== "string" && (e = e.toString()), e = e.indexOf(".") !== -1 ? 100 * parseFloat(e).toFixed(2) : parseInt(e), parseInt(e);
    };
    var defaultOption = function defaultOption(opt, def) {
        return typeof opt === "undefined" ? def : opt;
    };
    var formatWithDelimiters = function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");
        if (isNaN(number) || number === null) {
            return 0;
        }
        number = (number / 100).toFixed(precision);
        var parts = number.split(".");
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(thousands));
        var _$cents = parts[1] ? decimal + parts[1] : "";
        return dollars + _$cents;
    };
    var ref;
    cents = amountToCents(cents);
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || "${{amount}}";
    switch(formatString.match(placeholderRegex)[1]){
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
    }
    value = typeof value === "string" ? value === null || value === void 0 ? void 0 : (ref = value.replace) === null || ref === void 0 ? void 0 : ref.call(value, ".00", "") : value;
    return formatString.replace(placeholderRegex, value);
};
var compact = function(array) {
    var index = -1;
    var length = array === null ? 0 : array.length;
    var resIndex = 0;
    var result = [];
    while(++index < length){
        var value = array[index];
        if (value) {
            result[resIndex++] = value;
        }
    }
    return result;
};
var handleize = function(string) {
    var handleizedValue;
    if (string) {
        handleizedValue = string.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
    }
    return handleizedValue;
};
var getOffset = function(el) {
    var rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
    };
};
var newLineToBr = function(text) {
    if (!text) return "";
    return text.replace(/\n/gm, "<br />");
};
var scrollToSection = function(id) {
    if ( true && typeof id !== "undefined") {
        var hash = document.location.hash.replace("#", "");
        if (hash && hash === id) {
            var target = document.getElementById(id);
            var header = document.querySelector(".site-header");
            var headerOffset = 0;
            if (header) {
                headerOffset = header.clientHeight;
            }
            if (target) {
                console.warn("Section with id ".concat(id, " has been rendered/re-rendered"));
                setTimeout(function() {
                    window.scrollTo({
                        top: target.offsetTop - window.getComputedStyle(target).marginTop.replace("px", "") - headerOffset
                    });
                }, 1000);
            }
        }
    }
};
var getApplicableOverride = function(cart, overrides) {
    var ref1;
    var override = null;
    if (cart === null || cart === void 0 ? void 0 : (ref1 = cart.discountCodes) === null || ref1 === void 0 ? void 0 : ref1.length) {
        override = overrides === null || overrides === void 0 ? void 0 : overrides.filter(function(overrideData) {
            var ref;
            return ((ref = overrideData.discountCode) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (cart === null || cart === void 0 ? void 0 : cart.discountCodes[0].code.toLowerCase());
        });
    }
    return override;
};
/** Calculates discounted prices based on automatic discount collections.
  * @param {Object} automaticDiscountCollections - Settings object containing collections array
  * @param {Object} product - Product object with collections property
  * @param {Object} selectedVariant - Selected variant object with priceV2 property
  * @param {string} currencySymbol - Currency symbol to use for formatting (e.g., '$')
  * @param {number} [planAmount] - Optional plan amount for subscription pricing
  * @returns {Object|undefined} Object with productPrice, comparePrice, and sellingPlanPrice properties, or undefined if inputs are invalid
*/ var getDiscountedPrice = function(automaticDiscountCollections, product, selectedVariant, currencySymbol, planAmount) {
    var ref3;
    if (!automaticDiscountCollections || !product || !selectedVariant || !currencySymbol) {
        return null;
    }
    var productHasAutomaticDiscount = false;
    var discountPercentage = null;
    var productPrice = null;
    var comparePrice = null;
    var sellingPlanPrice = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function(_iterator, _step) {
            var automaticDiscountCollection = _step.value;
            var ref, ref2;
            var currentDate = new Date();
            var startDate = new Date(automaticDiscountCollection.startDate);
            var endDate = new Date(automaticDiscountCollection.endDate);
            if (currentDate < startDate || currentDate > endDate) {
                return "continue";
            }
            var collectionHandle = automaticDiscountCollection === null || automaticDiscountCollection === void 0 ? void 0 : (ref = automaticDiscountCollection.collection) === null || ref === void 0 ? void 0 : ref.handle;
            var productIsInCollection = product === null || product === void 0 ? void 0 : (ref2 = product.collections) === null || ref2 === void 0 ? void 0 : ref2.find(function(collection) {
                return (collection === null || collection === void 0 ? void 0 : collection.handle) === collectionHandle;
            });
            if (!productIsInCollection) {
                return "continue";
            }
            productHasAutomaticDiscount = true;
            discountPercentage = automaticDiscountCollection.discountPercentage;
            return "break";
        };
        for(var _iterator = automaticDiscountCollections.collections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop(_iterator, _step);
            if (_ret === "break") break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ;
    if (productHasAutomaticDiscount && (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.priceV2) === null || ref3 === void 0 ? void 0 : ref3.amount)) {
        var discountInteger = (100 - discountPercentage) / 100;
        productPrice = "".concat(currencySymbol).concat(roundNumber(parseFloat(selectedVariant.priceV2.amount * discountInteger)).toFixed(2)).replace(".00", "");
        comparePrice = "".concat(currencySymbol).concat(parseFloat(selectedVariant.priceV2.amount).toFixed(2)).replace(".00", "");
        if (planAmount) {
            sellingPlanPrice = "".concat(currencySymbol).concat((planAmount * discountInteger).toFixed(2)).replace(".00", "");
        }
    }
    return {
        productPrice: productPrice,
        comparePrice: comparePrice,
        sellingPlanPrice: sellingPlanPrice
    };
};
function roundNumber(num) {
    return +(Math.round(num + "e+1") + "e-1");
}


/***/ }),

/***/ 80152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M0": function() { return /* binding */ getSizedImageUrl; }
/* harmony export */ });
/* unused harmony exports preload, loadImage, imageSize, removeProtocol */
/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * https://github.com/Shopify/slate.git.
 *
 */ /**
 * Preloads an image in memory and uses the browsers cache to store it until needed.
 *
 * @param {Array} images - A list of image urls
 * @param {String} size - A shopify image size attribute
 */ function preload(images, size) {
    if (typeof images === "string") {
        images = [
            images
        ];
    }
    for(var i = 0; i < images.length; i++){
        var image = images[i];
        loadImage(getSizedImageUrl(image, size));
    }
}
/**
 * Loads and caches an image in the browsers cache.
 * @param {string} path - An image url
 */ function loadImage(path) {
    new Image().src = path;
}
/**
 * Find the Shopify image attribute size
 *
 * @param {string} src
 * @returns {null}
 */ function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
    if (match) {
        return match[1];
    }
    return null;
}
/**
 * Adds a Shopify size attribute to a URL
 *
 * @param src
 * @param size
 * @returns {*}
 */ function getSizedImageUrl(src, size) {
    if (size === null) {
        return src;
    }
    if (size === "master") {
        return removeProtocol(src);
    }
    var match = src === null || src === void 0 ? void 0 : src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return removeProtocol("".concat(prefix[0], "_").concat(size).concat(suffix));
    }
    return null;
}
function removeProtocol(path) {
    return path;
}


/***/ }),

/***/ 86501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getMetafieldColor; },
/* harmony export */   "x": function() { return /* binding */ getMetafieldMap; }
/* harmony export */ });
/* harmony import */ var _utils_Helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41717);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var getMetafieldMap = function(product) {
    var getMetafield = function getMetafield(param) {
        var namespace = param.namespace, key = param.key;
        return ogMetafields.find(function(metafield) {
            return metafield.namespace === namespace && metafield.key === key;
        });
    };
    var getMetafieldsByNamespace = function getMetafieldsByNamespace(namespace) {
        var metafieldsList = ogMetafields.filter(function(metafield) {
            return metafield.namespace === namespace;
        });
        return metafieldsList.reduce(function(acc, param) {
            var key = param.key, value = param.value;
            return _objectSpread({}, acc, _defineProperty({}, key, value));
        }, {});
    };
    var ref;
    if (!(product === null || product === void 0 ? void 0 : (ref = product.metafields) === null || ref === void 0 ? void 0 : ref.length)) return {
        getMetafield: function() {
            return undefined;
        },
        getMetafieldsByNamespace: function() {
            return {};
        },
        ogMetafields: []
    };
    var ogMetafields = product.metafields;
    return _objectSpread({}, product.metafields.reduce(function(acc, param) {
        var key = param.key, value = param.value;
        return _objectSpread({}, acc, _defineProperty({}, key, value));
    }, {}), {
        getMetafield: getMetafield,
        getMetafieldsByNamespace: getMetafieldsByNamespace,
        ogMetafields: ogMetafields
    });
};
var getMetafieldColor = function(metafieldMap) {
    var metafieldColor = metafieldMap.custom_collection_title_color;
    if (metafieldColor) {
        var colorHandle = (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_0__/* .handleize */ .v8)(metafieldColor);
        if (colorHandle == "air-dry-cream") {
            colorHandle = "stylers-1";
        } else if (colorHandle == "sculpting-cream") {
            colorHandle = "stylers-2";
        } else if (colorHandle == "texture-foam") {
            colorHandle = "stylers-3";
        } else if (colorHandle == "sleek-stick") {
            colorHandle = "stylers-4";
        }
        metafieldColor = "text-".concat(colorHandle);
    } else {
        metafieldColor = "text-black";
    }
    return metafieldColor;
};


/***/ }),

/***/ 11280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
module.exports = function(e1) {
    var t1 = {};
    function n(r) {
        if (t1[r]) return t1[r].exports;
        var o = t1[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return e1[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e1, n.c = t1, n.d = function(e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
        });
    }, n.r = function(e) {
        typeof Symbol !== "undefined" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, n.t = function(e, t2) {
        if (1 & t2 && (e = n(e)), 8 & t2) return e;
        if (4 & t2 && typeof e === "object" && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
        }), 2 & t2 && typeof e !== "string") for(var o in e)n.d(r, o, (function(t) {
            return e[t];
        }).bind(null, o));
        return r;
    }, n.n = function(e) {
        var t = e && e.__esModule ? function t() {
            return e.default;
        } : function() {
            return e;
        };
        return n.d(t, "a", t), t;
    }, n.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 2);
}([
    function(e, t) {
        e.exports = __webpack_require__(27378);
    },
    function(e, t) {
        e.exports = __webpack_require__(23615);
    },
    function(e2, t3, n1) {
        var o = function o() {
            var e = document.createElement("style");
            e.className = "fslightbox-styles", e.appendChild(document.createTextNode(".fslightbox-fade-in{animation:fslightbox-fade-in .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .3s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .3s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-absoluted{position:absolute;top:0;left:0}.fslightbox-cursor-grabbing{cursor:grabbing}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightbox-transform-transition{transition:transform .3s}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);z-index:1000000000;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightbox-svg-path{transition:fill .15s ease;fill:#d1d2d2}.fslightbox-loader{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightbox-loader div{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightbox-loader 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightbox-loader div:nth-child(1){animation-delay:-.45s}.fslightbox-loader div:nth-child(2){animation-delay:-.3s}.fslightbox-loader div:nth-child(3){animation-delay:-.15s}@keyframes fslightbox-loader{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightbox-thumbs-loader{width:54px!important;height:54px!important}.fslightbox-thumbs-loader div{border-width:4px!important;width:44px!important;height:44px!important}.fslightbox-source-wrappers-container{transition:transform .2s linear;z-index:2}.fslightbox-source-wrappers-container-pinching{transition:none!important}.fslightbox-nav{height:45px;width:100%;transition:opacity .3s}.fslightbox-slide-number-container{display:flex;justify-content:center;align-items:center;position:relative;height:100%;font-size:15px;color:#d7d7d7;z-index:0;max-width:55px;text-align:left}.fslightbox-slide-number-container .fslightbox-flex-centered{height:100%}.fslightbox-slash{display:block;margin:0 5px;width:1px;height:12px;transform:rotate(15deg);background:#fff}.fslightbox-toolbar{position:absolute;z-index:3;right:0;top:0;height:100%;display:flex;background:rgba(35,35,35,.65)}.fslightbox-toolbar-button{height:100%;width:45px;cursor:pointer}.fslightbox-toolbar-button:hover .fslightbox-svg-path{fill:#fff}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:3;transform:translateY(-50%);transition:opacity .3s}@media (min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}}.fslightbox-slide-btn-container:hover .fslightbox-svg-path{fill:#f1f1f1}.fslightbox-slide-btn{padding:9px;font-size:26px;background:rgba(35,35,35,.65)}@media (min-width:768px){.fslightbox-slide-btn{padding:10px}}@media (min-width:1600px){.fslightbox-slide-btn{padding:11px}}.fslightbox-slide-btn-container-previous{left:0}@media (max-width:475.99px){.fslightbox-slide-btn-container-previous{padding-left:3px!important}}.fslightbox-slide-btn-container-next{right:0;padding-left:12px!important;padding-right:3px!important}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-left:22px!important}}@media (min-width:768px){.fslightbox-slide-btn-container-next{padding-left:30px!important}}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-right:6px!important}}.fslightbox-down-event-detector{position:absolute;z-index:1}.fslightbox-slide-swiping-hoverer{z-index:4}.fslightbox-slideshow-bar{width:0;height:2px;z-index:4;opacity:0;background:#fff;transition:opacity .4s}.fslightbox-invalid-file-wrapper{font-size:26px;color:#eaebeb;margin:auto}.fslightbox-video{object-fit:cover}.fslightbox-source{position:relative;z-index:2;display:block;opacity:0;transform:translateZ(0);margin:auto;cursor:zoom-in;backface-visibility:hidden}.fslightbox-thumbs{position:absolute;bottom:0;left:0;width:100%;z-index:3;background:linear-gradient(180deg,rgba(0,0,0,0),#1e1e1e 100%);opacity:0;transition:opacity .2s;backface-visibility:hidden;padding:0 5px 12px 5px;height:114px}@media (min-width:992px){.fslightbox-thumbs{padding-bottom:13px;height:120px}}@media (min-width:1600px){.fslightbox-thumbs{padding-bottom:14px;height:126px}}.fslightbox-thumbs-active{opacity:1;z-index:3}.fslightbox-thumbs-inner{display:inline-flex;justify-content:flex-start;align-items:center;height:100%}.fslightbox-thumb-wrapper{position:relative;height:100%;margin:0 4px;opacity:0;transition:opacity .3s}.fslightbox-thumb-wrapper svg{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer;z-index:1}.fslightbox-thumb-wrapper path{fill:#fff}.fslightbox-thumb-wrapper-darkener{position:absolute;top:2px;left:2px;width:calc(100% - 4px);height:calc(100% - 4px);background:rgba(0,0,0,.4);cursor:pointer}.fslightbox-thumb{cursor:pointer;border-radius:1px;height:100%;width:auto!important;border:2px solid transparent;max-width:unset;max-height:unset}.fslightbox-thumb-active{border:2px solid #fff!important}.fslightbox-thumb-invalid{background:linear-gradient(to bottom,#0f0f0f,rgba(15,15,15,.5));display:inline-block;min-width:155px}.fslightbox-thumbs-cursorer{z-index:4;cursor:grabbing}.fslightbox-caption{position:absolute;bottom:0;left:50%;width:100%;background:linear-gradient(180deg,rgba(0,0,0,0),#1e1e1e 100%);transform:translateX(-50%);opacity:0;transition:opacity .2s;z-index:-1}.fslightbox-caption-inner{padding:25px;max-width:1200px;color:#eee;text-align:center;font-size:14px}@media (min-width:768px){.fslightbox-caption-inner{padding:30px 25px}}.fslightbox-caption-active{opacity:1;z-index:3}")), document.head.appendChild(e);
        };
        var f = function f(e) {
            var _$t = e.onClick;
            var _$n = e.viewBox;
            var r = e.width;
            var o = e.height;
            var _$i = e.d;
            var s = e.title;
            return a1.a.createElement("div", {
                className: "fslightbox-toolbar-button fslightbox-flex-centered",
                title: s,
                onClick: _$t
            }, a1.a.createElement(l1, {
                viewBox: _$n,
                width: r,
                height: o,
                d: _$i
            }));
        };
        var h = function h(e3, t4) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e3) || function(e, t) {
                var _$n = e == null ? null : typeof Symbol !== "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (_$n == null) return;
                var r;
                var o;
                var _$i = [];
                var s = !0;
                var a = !1;
                try {
                    for(_$n = _$n.call(e); !(s = (r = _$n.next()).done) && (_$i.push(r.value), !t || _$i.length !== t); s = !0);
                } catch (e4) {
                    a = !0, o = e4;
                } finally{
                    try {
                        s || _$n.return == null || _$n.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return _$i;
            }(e3, t4) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return p(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return p(e, t);
            }(e3, t4) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var p = function p(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var m = function m(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.componentsServices.toolbarButtons.fullscreen;
            var r = _$t.core.fullscreenToggler;
            var o = r.exitFullscreen;
            var _$i = r.enterFullscreen;
            var c = _$t.data.toolbarButtons.fullscreen;
            var u = c.enter;
            var l = c.exit;
            var p = h(Object(s1.useState)(!1), 2);
            var m1 = p[0];
            var b = p[1];
            _$n.get = function() {
                return m1;
            }, _$n.set = b;
            var g = m1 ? l : u;
            return a1.a.createElement(f, _objectSpread({
                onClick: m1 ? o : _$i
            }, g));
        };
        var g1 = function g1(e5, t5) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e5) || function(e, t) {
                var _$n = e == null ? null : typeof Symbol !== "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (_$n == null) return;
                var r;
                var o;
                var _$i = [];
                var s = !0;
                var a = !1;
                try {
                    for(_$n = _$n.call(e); !(s = (r = _$n.next()).done) && (_$i.push(r.value), !t || _$i.length !== t); s = !0);
                } catch (e6) {
                    a = !0, o = e6;
                } finally{
                    try {
                        s || _$n.return == null || _$n.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return _$i;
            }(e5, t5) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return v(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return v(e, t);
            }(e5, t5) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var v = function v(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var x = function x(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.componentsServices;
            var r = _$t.core.slideshowManager;
            var o = _$t.data.toolbarButtons.slideshow;
            var _$i = o.start;
            var c = o.pause;
            var u = g1(Object(s1.useState)(!1), 2);
            var l = u[0];
            var d = u[1];
            _$n.startSlideshow = function() {
                return d(!0);
            }, _$n.stopSlideshow = function() {
                return d(!1);
            };
            var h = l ? c : _$i;
            return a1.a.createElement(f, _objectSpread({
                onClick: r.toggleSlideshow
            }, h));
        };
        var S = function S(e7, t6) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e7) || function(e, t) {
                var _$n = e == null ? null : typeof Symbol !== "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (_$n == null) return;
                var r;
                var o;
                var _$i = [];
                var s = !0;
                var a = !1;
                try {
                    for(_$n = _$n.call(e); !(s = (r = _$n.next()).done) && (_$i.push(r.value), !t || _$i.length !== t); s = !0);
                } catch (e8) {
                    a = !0, o = e8;
                } finally{
                    try {
                        s || _$n.return == null || _$n.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return _$i;
            }(e7, t6) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return A(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return A(e, t);
            }(e7, t6) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var A = function A(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var E = function E(e9, t7) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e9) || function(e, t) {
                var _$n = e == null ? null : typeof Symbol !== "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (_$n == null) return;
                var r;
                var o;
                var _$i = [];
                var s = !0;
                var a = !1;
                try {
                    for(_$n = _$n.call(e); !(s = (r = _$n.next()).done) && (_$i.push(r.value), !t || _$i.length !== t); s = !0);
                } catch (e10) {
                    a = !0, o = e10;
                } finally{
                    try {
                        s || _$n.return == null || _$n.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return _$i;
            }(e9, t7) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return I(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return I(e, t);
            }(e9, t7) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var I = function I(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var O = function O(e11, t8) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e11) || function(e, t) {
                var _$n = e == null ? null : typeof Symbol !== "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (_$n == null) return;
                var r;
                var o;
                var _$i = [];
                var s = !0;
                var a = !1;
                try {
                    for(_$n = _$n.call(e); !(s = (r = _$n.next()).done) && (_$i.push(r.value), !t || _$i.length !== t); s = !0);
                } catch (e12) {
                    a = !0, o = e12;
                } finally{
                    try {
                        s || _$n.return == null || _$n.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return _$i;
            }(e11, t8) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return M(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return M(e, t);
            }(e11, t8) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var M = function M(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var j = function j(e, t) {
            var _$n = e.sourcePointerProps;
            _$n.pointers[t.pointerId] = {
                screenX: t.screenX,
                screenY: t.screenY
            };
            var r = Object.keys(_$n.pointers).length;
            return _$n.pointersCount = r, r <= 2;
        };
        var F = function F(e) {
            for(var _$t = e.fsLightbox, _$n = _$t.core.sourcesPointerDown.listener, r = _$t.elements.sourceWrappersContainer, o = _$t.middleware, _$i = _$t.props.sources, s = [], c = 0; c < _$i.length; c++)s.push(a1.a.createElement(P, {
                fsLightbox: _$t,
                i: c,
                key: c
            }));
            return a1.a.createElement("div", {
                className: "fslightbox-source-wrappers-container fslightbox-absoluted fslightbox-full-dimension",
                ref: r,
                onPointerDown: o(_$n, j)
            }, s);
        };
        var k = function k(e13, t9) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e13) || function(e, t) {
                var _$n = e == null ? null : typeof Symbol !== "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (_$n == null) return;
                var r;
                var o;
                var _$i = [];
                var s = !0;
                var a = !1;
                try {
                    for(_$n = _$n.call(e); !(s = (r = _$n.next()).done) && (_$i.push(r.value), !t || _$i.length !== t); s = !0);
                } catch (e14) {
                    a = !0, o = e14;
                } finally{
                    try {
                        s || _$n.return == null || _$n.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return _$i;
            }(e13, t9) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return N(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return N(e, t);
            }(e13, t9) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var N = function N(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var H = function H(e) {
            var _$t1 = e.props.disableLocalStorage;
            if (!_$t1) {
                var _$n = localStorage.getItem("fslightbox-scrollbar-width");
                if (_$n) return _$n;
            }
            var r = function() {
                var _$e = document.createElement("div");
                var _$t = _$e.style;
                return _$t.visibility = "hidden", _$t.width = "100px", _$t.msOverflowStyle = "scrollbar", _$t.overflow = "scroll", _$e;
            }();
            var o = function() {
                var _$e = document.createElement("div");
                return _$e.style.width = "100%", _$e;
            }();
            document.body.appendChild(r);
            var _$i = r.offsetWidth;
            r.appendChild(o);
            var s = o.offsetWidth;
            document.body.removeChild(r);
            var a = _$i - s;
            return _$t1 || localStorage.setItem("fslightbox-scrollbar-width", a.toString()), a;
        };
        var R = function R(e) {
            var _$t = e.core.lightboxOpener;
            var _$n = e.data;
            var r = e.props.openOnMount;
            document.getElementsByClassName("fslightbox-styles").length || o(), _$n.scrollbarWidth = H(e), r && _$t.initializeAndOpen();
        };
        var D = function D(e15, t10) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e15) || function(e, t) {
                var _$n = e == null ? null : typeof Symbol !== "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (_$n == null) return;
                var r;
                var o;
                var _$i = [];
                var s = !0;
                var a = !1;
                try {
                    for(_$n = _$n.call(e); !(s = (r = _$n.next()).done) && (_$i.push(r.value), !t || _$i.length !== t); s = !0);
                } catch (e16) {
                    a = !0, o = e16;
                } finally{
                    try {
                        s || _$n.return == null || _$n.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return _$i;
            }(e15, t10) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return Y(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return Y(e, t);
            }(e15, t10) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var Y = function Y(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var X = function X(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.componentsServices;
            var r = _$t.core.thumbsSwipingDown.listener;
            var o = _$t.elements;
            var _$i = o.thumbsComponents;
            var c = o.thumbsInner;
            var u = D(Object(s1.useState)(!1), 2);
            var l = u[0];
            var f = u[1];
            return _$n.updateThumbsInner = function() {
                f(!l);
            }, a1.a.createElement("div", {
                className: "fslightbox-thumbs-inner",
                ref: c,
                onPointerDown: r
            }, _$i);
        };
        var Z = function Z(e17, t11) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e17) || function(e, t) {
                var _$n = e == null ? null : typeof Symbol !== "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (_$n == null) return;
                var r;
                var o;
                var _$i = [];
                var s = !0;
                var a = !1;
                try {
                    for(_$n = _$n.call(e); !(s = (r = _$n.next()).done) && (_$i.push(r.value), !t || _$i.length !== t); s = !0);
                } catch (e18) {
                    a = !0, o = e18;
                } finally{
                    try {
                        s || _$n.return == null || _$n.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return _$i;
            }(e17, t11) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return V(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return V(e, t);
            }(e17, t11) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var V = function V(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var q = function q(e19, t12) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e19) || function(e, t) {
                var _$n = e == null ? null : typeof Symbol !== "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (_$n == null) return;
                var r;
                var o;
                var _$i = [];
                var s = !0;
                var a = !1;
                try {
                    for(_$n = _$n.call(e); !(s = (r = _$n.next()).done) && (_$i.push(r.value), !t || _$i.length !== t); s = !0);
                } catch (e20) {
                    a = !0, o = e20;
                } finally{
                    try {
                        s || _$n.return == null || _$n.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return _$i;
            }(e19, t12) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return $(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return $(e, t);
            }(e19, t12) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var $ = function $(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var Q = function Q(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.componentsServices;
            var r = _$t.data.isThumbing;
            var o = _$t.elements.thumbsContainer;
            var _$i = q(Object(s1.useState)(!0), 2);
            var c = _$i[0];
            var u = _$i[1];
            _$n.hideThumbsLoader = function() {
                return u(!1);
            };
            var l = "fslightbox-thumbs";
            return r && (l += " fslightbox-thumbs-active"), a1.a.createElement("div", {
                className: l,
                ref: o
            }, a1.a.createElement(_, {
                fsLightbox: _$t
            }), a1.a.createElement(X, {
                fsLightbox: _$t
            }), c && a1.a.createElement(C, {
                testId: "thumbs-loader",
                additionalClassName: "fslightbox-thumbs-loader",
                key: "loader"
            }));
        };
        var K = function K(e21) {
            var _$t = e21.componentsServices.isLightboxOpenManager;
            var _$n = e21.core;
            var r = _$n.lightboxCloser;
            var o = _$n.lightboxOpener;
            var _$i = _$n.slideIndexChanger;
            var s = e21.data;
            var a = e21.stageIndexes;
            this.runTogglerUpdateActions = function() {
                _$t.get() ? r.close() : s.isInitialized ? o.open() : o.initializeAndOpen();
            }, this.runCurrentStageIndexUpdateActionsFor = function(e) {
                e !== a.current && (_$t.get() ? _$i.jumpTo(e) : a.current = e);
            };
        };
        var ee = function ee(e) {
            var _$t = e.core.lightboxUpdater;
            var _$n = (0, e.resolve)(K);
            _$t.handleUpdate = function(t) {
                var r = e.props;
                typeof r.sourceIndex === "number" ? _$n.runCurrentStageIndexUpdateActionsFor(r.sourceIndex) : typeof r.source === "string" ? _$n.runCurrentStageIndexUpdateActionsFor(r.sources.indexOf(r.source)) : typeof r.slide === "number" && _$n.runCurrentStageIndexUpdateActionsFor(r.slide - 1), t.toggler !== r.toggler && _$n.runTogglerUpdateActions();
            };
        };
        var te = function te(e22) {
            var _$t;
            var _$n1 = e22.props;
            var r = 0;
            var o = {};
            this.getSourceTypeFromLocalStorageByUrl = function(e) {
                return _$t[e] ? _$t[e] : _$i(e);
            }, this.handleReceivedSourceTypeForUrl = function(e23, n) {
                !1 === o[n] && (r--, e23 !== "invalid" ? o[n] = e23 : delete o[n], r === 0 && (!function(e, t) {
                    for(var _$n in t)e[_$n] = t[_$n];
                }(_$t, o), localStorage.setItem("fslightbox-types", JSON.stringify(_$t))));
            };
            var _$i = function _$i(e) {
                r++, o[e] = !1;
            };
            _$n1.disableLocalStorage ? (this.getSourceTypeFromLocalStorageByUrl = function() {}, this.handleReceivedSourceTypeForUrl = function() {}) : (_$t = JSON.parse(localStorage.getItem("fslightbox-types"))) || (_$t = {}, this.getSourceTypeFromLocalStorageByUrl = _$i);
        };
        var de = function de(e) {
            var _$t = e.componentsServices;
            var _$n = e.core.thumbsRenderDispatcher;
            var r = e.data;
            var o = e.elements.thumbsComponents;
            var _$i = e.props;
            var s = _$i.showThumbsOnMount;
            var c = _$i.sources;
            var u = _$i.thumbs;
            this.buildComponentForTypeAndIndex = function(i, f) {
                u && u[f] ? o[f] = l(u, f) : o[f] = i === "image" ? l(c, f) : a1.a.createElement(fe, {
                    fsLightbox: e,
                    i: f,
                    key: f
                }), _$n.countBuiltThumb(), _$t.isLightboxOpenManager.get() && (s || r.isThumbing) && _$n.renderThumbsIfNotYetAndAllBuilt();
            };
            var l = function l(t, n) {
                return a1.a.createElement(le, {
                    fsLightbox: e,
                    src: t[n],
                    i: n,
                    key: n
                });
            };
        };
        var he = function he(e) {
            var _$t;
            var _$n = e.componentsServices;
            var r = _$n.isLightboxOpenManager;
            var o = _$n.updateSourceDirectWrapperCollection;
            var _$i = e.elements.sourceComponents;
            var s = e.props.disableThumbs;
            var c2 = e.resolve;
            s || (_$t = c2(de)), this.runActionsForSourceTypeAndIndex = function(n, c) {
                var u;
                switch(n){
                    case "image":
                        u = re;
                        break;
                    case "video":
                        u = ie;
                        break;
                    case "youtube":
                        u = ae;
                        break;
                    case "custom":
                        u = ce;
                        break;
                    default:
                        u = ue;
                }
                _$i[c] = a1.a.createElement(u, {
                    fsLightbox: e,
                    i: c
                }), s || _$t.buildComponentForTypeAndIndex(n, c), r.get() && o[c]();
            };
        };
        var pe = function pe() {
            var e24;
            var _$t2;
            var _$n;
            var r = {
                isUrlYoutubeOne: function isUrlYoutubeOne(e) {
                    var _$t = document.createElement("a");
                    return _$t.href = e, _$t.hostname === "www.youtube.com";
                },
                getTypeFromResponseContentType: function getTypeFromResponseContentType(e) {
                    return e.slice(0, e.indexOf("/"));
                }
            };
            function o() {
                if (_$n.readyState !== 4) {
                    if (_$n.readyState === 2) {
                        var e;
                        switch(r.getTypeFromResponseContentType(_$n.getResponseHeader("content-type"))){
                            case "image":
                                e = "image";
                                break;
                            case "video":
                                e = "video";
                                break;
                            default:
                                e = "invalid";
                        }
                        _$n.onreadystatechange = null, _$n.abort(), _$t2(e);
                    }
                } else _$t2("invalid");
            }
            this.setUrlToCheck = function(t) {
                e24 = t;
            }, this.getSourceType = function(i) {
                if (r.isUrlYoutubeOne(e24)) return i("youtube");
                _$t2 = i, (_$n = new XMLHttpRequest()).onreadystatechange = o, _$n.open("GET", e24, !0), _$n.send();
            };
        };
        var me = function me(e25, t, n) {
            var r2 = e25.props;
            var o = r2.types;
            var _$i = r2.type;
            var s = r2.sources;
            var a = e25.resolve;
            this.getTypeSetByClientForIndex = function(e) {
                var _$t;
                return o && o[e] ? _$t = o[e] : _$i && (_$t = _$i), _$t;
            }, this.retrieveTypeWithXhrForIndex = function(e) {
                var r3 = a(pe);
                r3.setUrlToCheck(s[e]), r3.getSourceType(function(r) {
                    t.handleReceivedSourceTypeForUrl(r, s[e]), n.runActionsForSourceTypeAndIndex(r, e);
                });
            };
        };
        var be = function be(e) {
            var _$t = Object.keys(e.pointers);
            var _$n = e.pointers[_$t[0]];
            var r = e.pointers[_$t[1]];
            return Math.hypot(_$n.screenX - r.screenX, _$n.screenY - r.screenY);
        };
        var ge = function ge(e, t) {
            var _$n = e.current.classList;
            _$n.contains(t) || _$n.add(t);
        };
        var ve = function ve(e) {
            var _$t = e.core.zoomer;
            var _$n = e.data;
            var r = e.elements;
            var o = e.sourcePointerProps;
            this.runPinchActions = function() {
                o.isPinching = !0, o.pinchedHypot = be(o), ge(r.sourceWrappersContainer, "fslightbox-source-wrappers-container-pinching"), _$n.zoom === 1 && _$t.startZooming();
            };
        };
        var xe = function xe(e26) {
            var _$t;
            var _$n = e26.core;
            var r = _$n.slideshowManager;
            var o = _$n.slideChangeFacade;
            var _$i = e26.componentsServices;
            var s = e26.elements.slideshowBar;
            var a = e26.props;
            var c = !1;
            function u() {
                c = !1, clearTimeout(_$t), s.current.classList.remove("fslightbox-opacity-1"), _$i.stopSlideshow();
            }
            r.toggleSlideshow = function() {
                c ? u() : (c = !0, _$i.startSlideshow(), s.current.classList.add("fslightbox-opacity-1"), function e() {
                    s.current.style.transition = "opacity .2s", s.current.style.width = "0px", s.current.offsetWidth, s.current.style.transition = "opacity .2s, width linear ".concat(a.slideshowTime, "ms"), s.current.style.width = "".concat(innerWidth, "px"), _$t = setTimeout(function() {
                        o.changeToNext(), e();
                    }, a.slideshowTime);
                }());
            }, r.resetSlideshow = function() {
                c && u();
            };
        };
        var ye = function ye(e, t) {
            var _$n = e.current.classList;
            _$n.contains(t) && _$n.remove(t);
        };
        var we = function we(e27) {
            var _$t = e27.elements.captions;
            this.runSlideChangeActions = function(e, t) {
                _$n(e, "remove"), _$n(t, "add");
            };
            var _$n = function _$n(e, n) {
                _$t[e].current && _$t[e].current.classList[n]("fslightbox-caption-active");
            };
        };
        var Se = function Se(e28) {
            var _$t = e28.core;
            var _$n = _$t.clickZoomer;
            var r = _$t.lightboxCloser;
            var o = _$t.fullscreenToggler;
            var _$i = _$t.slideChangeFacade;
            var s = _$t.slideshowManager;
            var a = _$t.thumbsToggler;
            var c = e28.props.disableThumbs;
            this.listener = function(e) {
                if (e.code !== "Space") switch(e.key){
                    case "Escape":
                        r.close();
                        break;
                    case "ArrowLeft":
                        _$i.changeToPrevious();
                        break;
                    case "ArrowRight":
                        _$i.changeToNext();
                        break;
                    case "t":
                        c || a.toggleThumbs();
                        break;
                    case "+":
                        _$n.zoomIn();
                        break;
                    case "-":
                        _$n.zoomOut();
                        break;
                    case "F11":
                        e.preventDefault(), o.enterFullscreen();
                }
                else s.toggleSlideshow();
            };
        };
        var Ae = function Ae(e29) {
            var _$t = e29.componentsServices;
            var _$n = e29.core.pointeringBucket;
            var r = e29.data;
            var o = e29.elements.thumbsInner;
            var _$i = e29.thumbsSwipingProps;
            this.runActions = function(e) {
                _$n.runSwipingMoveActionsForPropsAndEvent(_$i, e), o.current.style.transform = "translateX(".concat(r.thumbsTransform + _$i.swipedX, "px)"), _$t.showThumbsCursorerIfNotYet();
            };
        };
        var Te = function Te(e30) {
            var _$t = e30.data;
            var _$n = e30.resolve;
            var r = e30.thumbsSwipingProps;
            var o = _$n(Ae);
            this.listener = function(e) {
                _$t.thumbsInnerWidth > innerWidth && r.isPointering && o.runActions(e);
            };
        };
        var Le = function Le(e31) {
            var _$t = e31.componentsServices;
            var _$n2 = e31.data;
            var r = e31.core;
            var o = r.slideIndexChanger;
            var _$i = r.thumbsTransformTransitioner;
            var s = r.pointeringBucket;
            var a = e31.elements;
            var c = a.thumbsWrappers;
            var u = a.thumbsInner;
            var l = e31.thumbsSwipingProps;
            function f(e) {
                _$n2.thumbsTransform = e, _$i.callActionWithTransition(function() {
                    u.current.style.transform = "translateX(".concat(e, "px)");
                });
            }
            this.runNoSwipeActionsForEvent = function(e) {
                _$t.hideThumbsCursorerIfShown(), l.isPointering = !1;
                for(var _$n = 0; _$n < c.length; _$n++)if (c[_$n].current && c[_$n].current.contains(e.target)) return void o.jumpTo(_$n);
            }, this.runActions = function() {
                if (_$t.hideThumbsCursorerIfShown(), _$n2.thumbsTransform += l.swipedX, s.runSwipingTopActionsForPropsAndEvent(l), _$n2.thumbsTransform > 0) return f(0);
                _$n2.thumbsTransform < innerWidth - _$n2.thumbsInnerWidth - 9 && f(innerWidth - _$n2.thumbsInnerWidth - 9);
            };
        };
        var Ce = function Ce(e32) {
            var _$t = e32.resolve;
            var _$n = e32.thumbsSwipingProps;
            var r = _$t(Le);
            this.listener = function(e) {
                _$n.isPointering && (_$n.swipedX ? r.runActions() : r.runNoSwipeActionsForEvent(e));
            };
        };
        var Ee = function Ee(e33) {
            var _$t3 = e33.collections.sourceMainWrapperTransformers;
            var _$n = e33.core.zoomer;
            var r = e33.data;
            var o = e33.sourcePointerProps;
            this.runZoomingPinchActionsForHypot = function(e) {
                var _$t = e - o.pinchedHypot;
                var _$i = r.zoom + _$t / Math.hypot(innerWidth, innerHeight) * 10;
                _$i < 0.9 && (_$i = 0.9), _$n.zoomTo(_$i), o.pinchedHypot = e;
            }, this.translateSourceMainWrapperAtIndexUsingMethod = function(e, n) {
                _$t3[e].translate(o.swipedX)[n]();
            };
        };
        var Ie = function Ie(e34) {
            var _$t = e34.collections.sourceMainWrapperTransformers;
            var _$n = e34.componentsServices;
            var r = e34.core.pointeringBucket;
            var o = e34.data;
            var _$i = e34.resolve;
            var s = e34.sourcePointerProps;
            var a = e34.stageIndexes;
            var c = _$i(Ee);
            this.runActions = function(e) {
                r.runSwipingMoveActionsForPropsAndEvent(s, e), _$n.showSlideSwipingHovererIfNotYet();
            }, this.runPinchActions = function() {
                var _$e = be(s);
                s.pinchedHypot ? c.runZoomingPinchActionsForHypot(_$e) : s.pinchedHypot = _$e;
            }, this.runNormalSwipeActions = function() {
                c.translateSourceMainWrapperAtIndexUsingMethod(a.current, "zero"), void 0 !== a.previous && s.swipedX > 0 ? c.translateSourceMainWrapperAtIndexUsingMethod(a.previous, "negative") : void 0 !== a.next && s.swipedX < 0 && c.translateSourceMainWrapperAtIndexUsingMethod(a.next, "positive");
            }, this.runZoomSwipeActions = function(e) {
                s.swipedX = (e.screenX - s.downScreenX) / o.zoom, s.swipedY = (e.screenY - s.downScreenY) / o.zoom, _$t[a.current].translate(s.upSwipedX + s.swipedX, s.upSwipedY + s.swipedY).zero();
            };
        };
        var ze = function ze(e35) {
            var _$t = e35.data;
            var _$n = e35.props.sources;
            var r = e35.resolve;
            var o = e35.sourcePointerProps;
            var _$i = r(Ie);
            this.listener = function(e) {
                if (o.isPinching) return _$i.runActions(e), void _$i.runPinchActions();
                o.pointersCount !== 2 && (_$i.runActions(e), _$t.zoom === 1 ? _$n.length === 1 ? o.swipedX = 1 : _$i.runNormalSwipeActions() : _$i.runZoomSwipeActions(e));
            };
        };
        var We = function We(e36) {
            var _$t = e36.collections.sourceMainWrapperTransformers;
            var _$n = e36.core;
            var r = _$n.slideIndexChanger;
            var o = _$n.clickZoomer;
            var _$i = e36.data;
            var s = e36.elements.sourceMainWrappers;
            var a = e36.sourcePointerProps;
            var c = e36.stageIndexes;
            this.runPositiveSwipedXActions = function() {
                void 0 === c.previous || (u("positive"), r.changeTo(c.previous)), u("zero");
            }, this.runNegativeSwipedXActions = function() {
                void 0 === c.next || (u("negative"), r.changeTo(c.next)), u("zero");
            }, this.saveCurrentSourceMainWrapperPosition = function() {
                a.upSwipedX = _$t[c.current].getTranslateX(), a.upSwipedY = _$t[c.current].getTranslateY();
            }, this.runSourceDownEventTargetActions = function() {
                _$i.zoom <= 1 ? o.zoomIn() : o.zoomOut();
            };
            var u = function u(e) {
                s[c.current].current.classList.add("fslightbox-transform-transition"), _$t[c.current][e]();
            };
        };
        var Oe = function Oe(e) {
            var _$t = e.componentsServices;
            var _$n = e.core;
            var r = _$n.lightboxCloser;
            var o = _$n.pointeringBucket;
            var _$i = e.data;
            var s = e.elements.sourceWrappersContainer;
            var a = e.resolve;
            var c = e.sourcePointerProps;
            var u = a(We);
            this.runActions = function() {
                _$t.hideSlideSwipingHoverer(), c.isPinching = !1, c.pinchedHypot = 0, o.runSwipingTopActionsForPropsAndEvent(c), ye(s, "fslightbox-source-wrappers-container-pinching");
            }, this.runSwipeActions = function() {
                _$i.zoom === 1 ? c.swipedX > 0 ? u.runPositiveSwipedXActions() : u.runNegativeSwipedXActions() : u.saveCurrentSourceMainWrapperPosition();
            }, this.runNoSwipeActions = function() {
                c.isSourceDownEventTarget ? u.runSourceDownEventTargetActions() : r.close();
            };
        };
        var Me = function Me(e37) {
            var _$t = e37.data;
            var _$n = e37.resolve;
            var r = e37.sourcePointerProps;
            var o = e37.core.zoomer;
            var _$i = _$n(Oe);
            this.listener = function(e) {
                r.pointers = {}, r.isPointering && (r.isPinching || (r.swipedX ? _$i.runSwipeActions() : _$i.runNoSwipeActions()), _$i.runActions(e), _$t.zoom < 1 && (o.zoomTo(1), o.endZooming()));
            };
        };
        var Pe = function Pe(e) {
            return e.sourcePointerProps.isPointering;
        };
        var je = function je(e38) {
            var _$t = e38.core.inactiver;
            var _$n = e38.middleware;
            var r = e38.props;
            var o = e38.resolve;
            var _$i = o(ze);
            var s = o(Me);
            var a = o(Te);
            var c = o(Ce);
            this.moveListener = function(e) {
                _$t.listener(e), _$n(_$n(_$i.listener, j), Pe)(e), r.disableThumbs || a.listener(e);
            }, this.upListener = function(e) {
                s.listener(e), r.disableThumbs || c.listener(e);
            };
        };
        var Fe = function Fe(e39) {
            var _$t = e39.core.zoomer;
            var _$n = e39.data;
            this.listener = function(e) {
                if (_$n.zoom === 1) {
                    if (e.deltaY > 0) return;
                    _$t.startZooming();
                }
                var r = 0.1 * _$n.zoom;
                var o = _$n.zoom;
                e.deltaY < 0 ? o += r : (o -= r) < 1 && (o = 1), _$t.zoomTo(o), o === 1 && _$t.endZooming();
            };
        };
        var ke = function ke(e) {
            return !e.sourcePointerProps.isPointering;
        };
        var Ne = function Ne(e40) {
            var _$t;
            var _$n3 = e40.core;
            var r = _$n3.inactiver;
            var o = _$n3.globalEventsController;
            var _$i = _$n3.windowResizeActioner;
            var s = e40.middleware;
            var a = e40.resolve;
            var c = a(je);
            var u = a(Se);
            var l = a(Fe);
            o.addListeners = function() {
                document.addEventListener("pointerdown", r.listener), document.addEventListener("pointermove", c.moveListener), document.addEventListener("pointerup", c.upListener), addEventListener("resize", _$i.runActions), document.addEventListener("keydown", u.listener);
                var _$e;
                var _$n = (_$e = !1, function _$n() {
                    return !_$e && (_$e = !0, requestAnimationFrame(function() {
                        _$e = !1;
                    }), !0);
                });
                _$t = s(_$t = function _$t(e) {
                    return _$n() && l.listener(e);
                }, ke), document.addEventListener("wheel", _$t);
            }, o.removeListeners = function() {
                document.removeEventListener("pointerdown", r.listener), document.removeEventListener("pointermove", c.moveListener), document.removeEventListener("pointerup", c.upListener), removeEventListener("resize", _$i.runActions), document.removeEventListener("keydown", u.listener), document.removeEventListener("wheel", _$t);
            };
        };
        var Be = function Be(e41) {
            var _$t = e41.data;
            var _$n = e41.elements;
            var r = _$n.captions;
            var o = _$n.slideButtonPrevious;
            var _$i = _$n.slideButtonNext;
            var s = _$n.thumbsContainer;
            var a = e41.stageIndexes;
            this.runOpacity0ActionUsingMethod = function(e) {
                o.current && (o.current.classList[e]("fslightbox-opacity-0"), _$i.current.classList[e]("fslightbox-opacity-0"));
            }, this.runActiveEnhancementActionUsingMethod = function(e) {
                _$t.isThumbing ? s.current.classList[e]("fslightbox-thumbs-active") : r[a.current].current && r[a.current].current.classList[e]("fslightbox-caption-active");
            };
        };
        var He = function He(e42) {
            var _$t;
            var _$n;
            var r;
            var o = e42.data;
            var _$i = e42.elements;
            var s = _$i.sourceEnhancementWrappers;
            var a = _$i.sources;
            var c = _$i.thumbsContainer;
            var u = o.captionHeights;
            var l = o.notThumbedSourceEnhancementWrapperScales;
            var f = o.notThumbedSourceEnhancementWrapperTranslatesY;
            this.setUpThumbedEnhancementWrapperTransform = function() {
                _$t = c.current.offsetHeight, _$n = o.thumbedSourceEnhancementWrapperTranslateY, r = "translateY(".concat(_$n, "px) scale(").concat(o.thumbedSourceEnhancementWrapperScale, ")");
            }, this.setUpNotThumbedEnhancementWrapperTransformAtIndex = function(e) {
                _$t = u[e], _$n = f[e], r = "translateY(".concat(_$n, "px) scale(").concat(l[e], ")");
            }, this.ifSourceIsLoadedTransformEnhancementWrapperAtIndex = function(e) {
                a[e].current && (innerWidth < innerHeight && a[e].current.offsetWidth > a[e].current.offsetHeight + _$t ? s[e].current.style.transform = "translateY(".concat(_$n / 2, "px) scale(1)") : s[e].current.style.transform = r);
            };
        };
        var Re = function Re(e43) {
            var _$t4;
            var _$n4;
            var r4;
            _$n4 = (_$t4 = e43).core.classFacade, r4 = _$t4.elements, _$n4.removeFromEachElementClassIfContains = function(e, t) {
                for(var _$n = 0; _$n < 100; _$n++)for(var o = 0; o < r4[e].length; o++)ye(r4[e][o], t);
            }, function(e44) {
                var _$t = e44.core;
                var _$n = _$t.clickZoomer;
                var r = _$t.zoomer;
                var o = e44.data;
                var _$i = e44.elements.sourceWrappersContainer;
                var s = e44.getQueuedAction;
                var a = e44.props.zoomIncrement;
                var c = s(function() {
                    ye(_$i, "fslightbox-transform-transition");
                }, 300);
                function u() {
                    o.zoom === 1 && r.startZooming();
                }
                function l(e) {
                    ge(_$i, "fslightbox-transform-transition"), r.zoomTo(e), c();
                }
                _$n.zoomIn = function() {
                    u(), l(o.zoom + a);
                }, _$n.zoomOut = function() {
                    o.zoom - a <= 1 ? o.zoom !== 1 && (l(1), r.endZooming()) : (u(), l(o.zoom - a), o.zoom === 1 && r.endZooming());
                };
            }(e43), function(e) {
                var _$t = e.core.eventsDispatcher;
                var _$n = e.props;
                _$t.dispatch = function(t) {
                    _$n[t] && _$n[t](e);
                };
            }(e43), function(e) {
                var _$t = e.componentsServices.toolbarButtons.fullscreen;
                var _$n = e.core.fullscreenToggler;
                _$n.enterFullscreen = function() {
                    _$t.set(!0);
                    var _$e = document.documentElement;
                    _$e.requestFullscreen ? _$e.requestFullscreen() : _$e.mozRequestFullScreen ? _$e.mozRequestFullScreen() : _$e.webkitRequestFullscreen ? _$e.webkitRequestFullscreen() : _$e.msRequestFullscreen && _$e.msRequestFullscreen();
                }, _$n.exitFullscreen = function() {
                    _$t.set(!1), document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
                };
            }(e43), Ne(e43), function(e45) {
                var _$t = e45.core.inactiver;
                var _$n = e45.data;
                var r = e45.elements;
                var o = r.nav;
                var _$i = r.slideButtonPrevious;
                var s = r.slideButtonNext;
                var a = r.thumbsContainer;
                var c = e45.getQueuedAction;
                var u = e45.props.UIFadeOutTime;
                var l = !1;
                var f = c(function() {
                    l = !0, d(h);
                }, u);
                f(), _$t.listener = function() {
                    f(), l && (d(p), l = !1);
                };
                var d = function d(e) {
                    try {
                        e(o), _$n.zoom === 1 && _$i.current && (e(_$i), e(s)), _$n.isThumbing && e(a);
                    } catch (e46) {}
                };
                var h = function h(e) {
                    e.current.classList.add("fslightbox-opacity-0");
                };
                var p = function p(e) {
                    e.current.classList.remove("fslightbox-opacity-0");
                };
            }(e43), function(e) {
                var _$t = e.core;
                var _$n = _$t.lightboxCloser;
                var r = _$t.lightboxCloseActioner;
                _$n.close = function() {
                    r.isLightboxFadingOut || r.runActions();
                };
            }(e43), function(e) {
                var _$t = e.componentsServices;
                var _$n = _$t.isLightboxOpenManager;
                var r = _$t.toolbarButtons.fullscreen;
                var o = e.core;
                var _$i = o.eventsDispatcher;
                var s = o.globalEventsController;
                var a = o.fullscreenToggler;
                var c = o.lightboxCloseActioner;
                var u = o.scrollbarRecompensor;
                var l = o.slideshowManager;
                var f = o.zoomer;
                var d = e.elements.container;
                var h = e.props;
                var p = e.sourcePointerProps;
                var m = e.timeout;
                var b = e.thumbsSwipingProps;
                c.isLightboxFadingOut = !1, c.runActions = function() {
                    c.isLightboxFadingOut = !0, d.current.classList.add("fslightbox-fade-out-strong"), s.removeListeners(), l.resetSlideshow(), h.exitFullscreenOnClose && r.get() && a.exitFullscreen(), f.ifZoomingResetZoom(), m(function() {
                        c.isLightboxFadingOut = !1, p.isPointering = !1, b && (b.isPointering = !1), d.current.classList.remove("fslightbox-fade-out-strong"), document.documentElement.classList.remove("fslightbox-open"), u.removeRecompense(), _$n.set(!1), _$i.dispatch("onClose");
                    }, 270);
                };
            }(e43), Ge(e43), function(e) {
                var _$t = e.collections.sourceMainWrapperTransformers;
                var _$n = e.core;
                var r = _$n.eventsDispatcher;
                var o = _$n.lightboxOpenActioner;
                var _$i = _$n.globalEventsController;
                var s = _$n.scrollbarRecompensor;
                var a = _$n.sourceDisplayFacade;
                var c = _$n.stageManager;
                var u = _$n.windowResizeActioner;
                var l = e.data;
                var f = e.props.sources;
                var d = e.stageIndexes;
                o.runInitializedLightboxActions = function() {
                    l.unloadedThumbsCount = f.length, c.updateStageIndexes(), a.displaySourcesWhichShouldBeDisplayed(), document.documentElement.classList.add("fslightbox-open"), s.addRecompense(), _$i.addListeners(), u.runActions(), _$t[d.current].zero(), r.dispatch("onOpen");
                };
            }(e43), ee(e43), function(e) {
                var _$t = e.data;
                var _$n = e.core.scrollbarRecompensor;
                _$n.addRecompense = function() {
                    document.readyState === "complete" ? r() : window.addEventListener("load", function() {
                        r(), _$n.addRecompense = r;
                    });
                };
                var r = function r() {
                    document.body.offsetHeight > window.innerHeight && (document.body.style.marginRight = "".concat(_$t.scrollbarWidth, "px"));
                };
                _$n.removeRecompense = function() {
                    document.body.style.removeProperty("margin-right");
                };
            }(e43), xe(e43), function(e) {
                var _$t = e.core;
                var _$n = _$t.slideChangeFacade;
                var r = _$t.slideIndexChanger;
                var o = _$t.stageManager;
                e.props.sources.length > 1 ? (_$n.changeToPrevious = function() {
                    r.jumpTo(o.getPreviousSlideIndex());
                }, _$n.changeToNext = function() {
                    r.jumpTo(o.getNextSlideIndex());
                }) : (_$n.changeToPrevious = function() {}, _$n.changeToNext = function() {});
            }(e43), function(e47) {
                var _$t = e47.collections.sourceMainWrapperTransformers;
                var _$n5 = e47.componentsServices;
                var r = e47.core;
                var o = r.classFacade;
                var _$i = r.eventsDispatcher;
                var s = r.slideIndexChanger;
                var a = r.sourceDisplayFacade;
                var c = r.stageManager;
                var u = r.thumbsTransformer;
                var l = r.zoomer;
                var f = e47.data;
                var d = e47.elements;
                var h = d.sourceAnimationWrappers;
                var p = d.sources;
                var m = d.thumbs;
                var b = e47.getQueuedAction;
                var g = e47.props;
                var v = g.disableThumbs;
                var x = g.initialAnimation;
                var y = g.slideChangeAnimation;
                var w = e47.resolve;
                var S = e47.stageIndexes;
                var A = e47.timeout;
                var T = w(we);
                var L = b(function() {
                    o.removeFromEachElementClassIfContains("sourceAnimationWrappers", "fslightbox-fade-out");
                }, 300);
                s.changeTo = function(e) {
                    v || (m[S.current].current && m[S.current].current.classList.remove("fslightbox-thumb-active"), m[e].current && m[e].current.classList.add("fslightbox-thumb-active")), l.ifZoomingResetZoom(), f.isThumbing || T.runSlideChangeActions(S.current, e), S.current = e, c.updateStageIndexes(), !v && m[S.current].current && u.transformToCurrentWithTransition(), _$n5.setSlideNumber(e + 1), a.displaySourcesWhichShouldBeDisplayed(), _$i.dispatch("onSlideChange");
                }, s.jumpTo = function(e) {
                    var _$n = S.current;
                    o.removeFromEachElementClassIfContains("sourceMainWrappers", "fslightbox-transform-transition"), ye(h[_$n], x), ye(h[_$n], y), h[_$n].current.classList.add("fslightbox-fade-out"), ye(h[e], x), ye(h[e], "fslightbox-fade-out"), p[e].current && h[e].current.classList.add(y), s.changeTo(e), L(), _$t[e].zero(), A(function() {
                        _$n !== S.current && _$t[_$n].negative();
                    }, 270);
                };
            }(e43), function(e48) {
                var _$t = e48.core.sourceEnhancementWrappersTransformer;
                var _$n = e48.data;
                var r = (0, e48.resolve)(He);
                _$t.ifSourceIsLoadedTransformEnhancementWrapperAtIndex = function(e) {
                    _$n.isThumbing ? r.setUpThumbedEnhancementWrapperTransform() : r.setUpNotThumbedEnhancementWrapperTransformAtIndex(e), r.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(e);
                }, _$t.ifSourceIsLoadedTransformThumbedEnhancementWrapperAtIndex = function(e) {
                    r.setUpThumbedEnhancementWrapperTransform(e), r.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(e);
                }, _$t.ifSourceIsLoadedTransformNotThumbedEnhancementWrapperAtIndex = function(e) {
                    r.setUpNotThumbedEnhancementWrapperTransformAtIndex(e), r.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(e);
                };
            }(e43), function(e) {
                var _$t = e.core.sourceDisplayFacade;
                var _$n = e.componentsServices.updateSourceDirectWrapperCollection;
                var r = e.stageIndexes;
                var o = e.props.loadOnlyCurrentSource;
                _$t.displaySourcesWhichShouldBeDisplayed = function() {
                    if (o) _$n[r.current]();
                    else for(var _$e in r)void 0 !== r[_$e] && _$n[r[_$e]]();
                };
            }(e43), function(e49) {
                var _$t5 = e49.core;
                var _$n = _$t5.classFacade;
                var r = _$t5.sourcesPointerDown;
                var o = _$t5.pointeringBucket;
                var _$i = e49.elements.sources;
                var s = e49.resolve;
                var a = e49.sourcePointerProps;
                var c = e49.stageIndexes;
                var u = s(ve);
                r.listener = function(e) {
                    e.pointerType !== "touch" && e.target.tagName !== "VIDEO" && e.preventDefault(), o.runSwipingDownActionsForPropsAndEvent(a, e), a.downScreenY = e.screenY, a.pointersCount === 2 ? u.runPinchActions() : _$n.removeFromEachElementClassIfContains("sourceMainWrappers", "fslightbox-transform-transition");
                    var _$t = _$i[c.current].current;
                    _$t && _$t.contains(e.target) ? a.isSourceDownEventTarget = !0 : a.isSourceDownEventTarget = !1;
                };
            }(e43), function(e50) {
                var _$t = e50.stageIndexes;
                var _$n6 = e50.core.stageManager;
                var r = e50.props.sources.length - 1;
                _$n6.getPreviousSlideIndex = function() {
                    return _$t.current === 0 ? r : _$t.current - 1;
                }, _$n6.getNextSlideIndex = function() {
                    return _$t.current === r ? 0 : _$t.current + 1;
                }, _$n6.updateStageIndexes = r === 0 ? function() {} : r === 1 ? function() {
                    _$t.current === 0 ? (_$t.next = 1, delete _$t.previous) : (_$t.previous = 0, delete _$t.next);
                } : function() {
                    _$t.previous = _$n6.getPreviousSlideIndex(), _$t.next = _$n6.getNextSlideIndex();
                }, _$n6.isSourceInStage = r <= 2 ? function() {
                    return !0;
                } : function(e) {
                    var _$n = _$t.current;
                    if (_$n === 0 && e === r || _$n === r && e === 0) return !0;
                    var o = _$n - e;
                    return o === -1 || o === 0 || o === 1;
                };
            }(e43), function(e51) {
                var _$t = e51.core.pointeringBucket;
                var _$n = e51.elements.container;
                _$t.runSwipingDownActionsForPropsAndEvent = function(e, t) {
                    e.isPointering = !0, e.downScreenX = t.screenX, e.swipedX = 0;
                }, _$t.runSwipingMoveActionsForPropsAndEvent = function(e, t) {
                    ge(_$n, "fslightbox-cursor-grabbing"), e.swipedX = t.screenX - e.downScreenX;
                }, _$t.runSwipingTopActionsForPropsAndEvent = function(e) {
                    ye(_$n, "fslightbox-cursor-grabbing"), e.isPointering = !1;
                };
            }(e43), function(e) {
                var _$t6 = e.collections;
                var _$n = _$t6.sourceMainWrapperTransformers;
                var r = _$t6.sourceSizers;
                var o = e.core;
                var _$i = o.sourceEnhancementWrappersTransformer;
                var s = o.windowResizeActioner;
                var a = o.thumbsTransformer;
                var c = e.data;
                var u = e.elements;
                var l = u.captions;
                var f = u.sourceMainWrappers;
                var d = u.sources;
                var h = u.thumbs;
                var p = u.thumbsContainer;
                var m = e.props.disableThumbs;
                var b = e.stageIndexes;
                var g = c.captionHeights;
                var v = c.notThumbedSourceEnhancementWrapperScales;
                var x = c.notThumbedSourceEnhancementWrapperTranslatesY;
                s.runActions = function() {
                    innerWidth < 992 ? c.maxSourceWidth = innerWidth : c.maxSourceWidth = 0.9 * innerWidth, c.maxSourceHeight = 0.9 * innerHeight, m || (c.thumbedSourceEnhancementWrapperScale = 1 - p.current.offsetHeight / innerHeight, c.thumbedSourceEnhancementWrapperTranslateY = -p.current.offsetHeight / 2), c.unloadedThumbsCount === 0 && s.runThumbsActions();
                    for(var _$e = 0; _$e < d.length; _$e++){
                        if (l[_$e].current) {
                            g[_$e] = l[_$e].current.offsetHeight;
                            var _$t = g[_$e] - 25;
                            v[_$e] = 1 - _$t / innerHeight, x[_$e] = -_$t / 2;
                        } else v[_$e] = 1, x[_$e] = 0;
                        ye(f[_$e], "fslightbox-transform-transition"), _$i.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(_$e), _$e !== b.current && _$n[_$e].negative(), r[_$e] && d[_$e].current && r[_$e].adjustSize();
                    }
                }, s.runThumbsActions = function() {
                    c.thumbsInnerWidth = 0;
                    for(var _$e = 0; _$e < d.length; _$e++)c.thumbsInnerWidth += h[_$e].current.offsetWidth + 8;
                    a.transformToCurrent();
                };
            }(e43), function(e52) {
                var _$t = e52.collections.sourceMainWrapperTransformers;
                var _$n = e52.core;
                var r = _$n.eventsDispatcher;
                var o = _$n.zoomer;
                var _$i = e52.data;
                var s = e52.elements;
                var a = s.sourceMainWrappers;
                var c = s.sourceWrappersContainer;
                var u = s.sources;
                var l = e52.resolve;
                var f = e52.sourcePointerProps;
                var d = e52.stageIndexes;
                var h = l(Be);
                o.zoomTo = function(e) {
                    _$i.zoom = m(e), c.current.style.transform = "scale(".concat(_$i.zoom, ")");
                }, o.ifZoomingResetZoom = function() {
                    _$i.zoom !== 1 && (o.zoomTo(1), o.endZooming());
                }, o.startZooming = function() {
                    p("grab"), h.runOpacity0ActionUsingMethod("add"), h.runActiveEnhancementActionUsingMethod("remove"), r.dispatch("onZoomingStart");
                }, o.endZooming = function() {
                    p("zoom-in"), h.runOpacity0ActionUsingMethod("remove"), h.runActiveEnhancementActionUsingMethod("add"), a[d.current].current.classList.add("fslightbox-transform-transition"), _$t[d.current].translate(0, 0).zero(), f.upSwipedX = 0, f.upSwipedY = 0, r.dispatch("onZoomingEnd");
                };
                var p = function p(e) {
                    u[d.current].current && (u[d.current].current.style.cursor = e);
                };
                var m = function m(e) {
                    return parseFloat(e.toPrecision(12));
                };
            }(e43);
        };
        var Ue = function Ue(e) {
            for(var _$t = e.props.sources, _$n = [], r = 0; r < _$t.length; r++)_$n.push(a1.a.createRef());
            return _$n;
        };
        var De = function De(e53) {
            var _$t = e53.core;
            var _$n = _$t.sourceEnhancementWrappersTransformer;
            var r = _$t.thumbsRenderDispatcher;
            var o = _$t.zoomer;
            var _$i = e53.data;
            var s = e53.elements;
            var a = s.captions;
            var c = s.thumbsContainer;
            var u = e53.props.sources;
            var l = e53.stageIndexes;
            function f() {
                for(var _$e = 0; _$e < u.length; _$e++)_$n.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(_$e);
            }
            function d(e) {
                a[l.current].current && a[l.current].current.classList[e]("fslightbox-caption-active");
            }
            this.openThumbs = function() {
                o.ifZoomingResetZoom(), _$i.isThumbing = !0, c.current.classList.add("fslightbox-thumbs-active"), f(), d("remove"), r.renderThumbsIfNotYetAndAllBuilt();
            }, this.closeThumbs = function() {
                o.ifZoomingResetZoom(), _$i.isThumbing = !1, c.current.classList.remove("fslightbox-thumbs-active"), f(), d("add");
            };
        };
        var Ye = function Ye(e54) {
            var _$t = e54.data;
            var _$n7 = e54.elements;
            var r = _$n7.thumbsWrappers;
            var o = _$n7.thumbsContainer;
            var _$i1 = _$n7.thumbsInner;
            var s = e54.stageIndexes;
            var a2 = e54.timeout;
            this.runActions = function() {
                ye(o, "fslightbox-flex-centered");
                var _$e = innerWidth / 2;
                var _$n = r[s.current].current;
                var _$i = _$n.offsetLeft + _$n.offsetWidth / 2;
                var a = _$t.thumbsInnerWidth - _$i;
                _$i > _$e && a > _$e ? c(_$e - _$i) : _$i > _$e ? c(innerWidth - _$t.thumbsInnerWidth - 9) : a > _$e && c(0);
            }, this.runToThinThumbsActions = function() {
                a2(function() {
                    return ge(o, "fslightbox-flex-centered");
                }), c(0);
            };
            var c = function c(e) {
                _$t.thumbsTransform = e, _$i1.current.style.transform = "translateX(".concat(e, "px)");
            };
        };
        var Xe = function Xe(e55) {
            var _$t7;
            var _$n8;
            var r5;
            var o1;
            var _$i2;
            var s2 = e55.componentsServices;
            var c = e55.core;
            var u = e55.data;
            var l = e55.elements;
            var f = e55.props;
            s2.updateThumbsInner = null, s2.showThumbsCursorerIfNotYet = null, s2.hideThumbsCursorerIfShown = null, s2.hideThumbsLoader = null, u.isThumbing = f.showThumbsOnMount, u.thumbsInnerWidth = null, u.thumbsTransform = 0, u.thumbedSourceEnhancementWrapperScale = null, u.thumbedSourceEnhancementWrapperTranslateY = null, u.unloadedThumbsCount = null, e55.thumbsSwipingProps = {
                isPointering: !1,
                downScreenX: null,
                swipedX: null
            }, c.thumbLoadHandler = {}, c.thumbsRenderDispatcher = {}, c.thumbsSwipingDown = {}, c.thumbsToggler = {}, c.thumbsTransformer = {}, c.thumbsTransformTransitioner = {}, l.thumbsContainer = a1.a.createRef(), l.thumbs = Ue(e55), l.thumbsWrappers = Ue(e55), l.thumbsComponents = [], l.thumbsInner = a1.a.createRef(), function(e) {
                var _$t = e.core;
                var _$n = _$t.thumbLoadHandler;
                var r = _$t.windowResizeActioner;
                var o = e.componentsServices;
                var _$i = e.data;
                var s = e.elements.thumbsWrappers;
                _$n.handleLoad = function() {
                    if (_$i.unloadedThumbsCount--, _$i.unloadedThumbsCount === 0) {
                        for(var _$e = 0; _$e < s.length; _$e++)s[_$e].current.classList.add("fslightbox-opacity-1");
                        r.runThumbsActions(), o.hideThumbsLoader();
                    }
                };
            }(e55), function(e) {
                var _$t = e.componentsServices;
                var _$n = e.core.thumbsRenderDispatcher;
                var r = e.props.sources;
                var o = !1;
                var _$i = 0;
                _$n.countBuiltThumb = function() {
                    _$i++;
                }, _$n.renderThumbsIfNotYetAndAllBuilt = function() {
                    o || _$i !== r.length || (o = !0, _$t.updateThumbsInner());
                };
            }(e55), _$n8 = (_$t7 = e55).core, r5 = _$n8.thumbsSwipingDown, o1 = _$n8.pointeringBucket, _$i2 = _$t7.thumbsSwipingProps, r5.listener = function(e) {
                e.preventDefault(), o1.runSwipingDownActionsForPropsAndEvent(_$i2, e);
            }, function(e) {
                var _$t = e.core;
                var _$n = _$t.thumbsTransformer;
                var r = _$t.thumbsTransformTransitioner;
                var o = e.data;
                var _$i = (0, e.resolve)(Ye);
                _$n.transformToCurrent = function() {
                    o.thumbsInnerWidth > innerWidth ? _$i.runActions() : _$i.runToThinThumbsActions();
                }, _$n.transformToCurrentWithTransition = function() {
                    o.thumbsInnerWidth > innerWidth && r.callActionWithTransition(_$i.runActions);
                };
            }(e55), function(e56) {
                var _$t = e56.core.thumbsTransformTransitioner;
                var _$n = e56.elements.thumbsInner;
                var r = (0, e56.getQueuedAction)(function() {
                    _$n.current.classList.remove("fslightbox-transform-transition");
                }, 300);
                _$t.callActionWithTransition = function(e) {
                    _$n.current.classList.add("fslightbox-transform-transition"), e(), r();
                };
            }(e55), function(e) {
                var _$t = e.core.thumbsToggler;
                var _$n = e.data;
                var r = (0, e.resolve)(De);
                _$t.toggleThumbs = function() {
                    _$n.isThumbing ? r.closeThumbs() : r.openThumbs();
                };
            }(e55);
        };
        var _e = function _e(e, t, n) {
            for(var r = 0; r < e.props.sources.length; r++)e.collections[t][r] = e.resolve(n, [
                r
            ]);
        };
        var qe = function qe(e, t, n, r) {
            var o = e.data;
            var _$i = e.elements.sources;
            var s = n / r;
            var a = 0;
            this.adjustSize = function() {
                if ((a = o.maxSourceWidth / s) < o.maxSourceHeight) return n < o.maxSourceWidth && (a = r), c();
                a = r > o.maxSourceHeight ? o.maxSourceHeight : r, c();
            };
            var c = function c() {
                var _$e = _$i[t].current.style;
                _$e.width = "".concat(a * s, "px"), _$e.height = "".concat(a, "px");
            };
        };
        var $e = function $e(e57, t) {
            var _$n = this;
            var r6 = e57.collections.sourceSizers;
            var o = e57.componentsServices.hideSourceLoaderCollection;
            var _$i = e57.core.sourceEnhancementWrappersTransformer;
            var s = e57.elements;
            var a = s.sourceAnimationWrappers;
            var c = s.sourceEnhancementWrappers;
            var u = s.sources;
            var l = e57.props.initialAnimation;
            var f = e57.resolve;
            function d(e, n) {
                r6[t] = f(qe, [
                    t,
                    e,
                    n
                ]), r6[t].adjustSize();
            }
            this.runActions = function(e, r) {
                u[t].current.classList.add("fslightbox-opacity-1"), a[t].current.classList.add(l), o[t](), _$i.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(t), c[t].current.offsetWidth, c[t].current.classList.add("fslightbox-transform-transition"), d(e, r), _$n.runActions = d;
            };
        };
        var Qe = function Qe(e58, t) {
            var _$n9;
            var r7 = this;
            var o2 = e58.elements.sources;
            var _$i = e58.props;
            var s = e58.resolve;
            var a = e58.timeout;
            var c = s($e, [
                t
            ]);
            this.handleImageLoad = function(e) {
                var _$t = e.target;
                var _$n = _$t.naturalWidth;
                var r = _$t.naturalHeight;
                c.runActions(_$n, r);
            }, this.handleVideoLoad = function(e) {
                var _$t = e.target;
                var r = _$t.videoWidth;
                var o = _$t.videoHeight;
                _$n9 = !0, c.runActions(r, o);
            }, this.handleNotMetaDatedVideoLoad = function() {
                _$n9 || r7.handleYoutubeLoad();
            }, this.handleYoutubeLoad = function() {
                var _$e = 1920;
                var _$t = 1080;
                _$i.maxYoutubeVideoDimensions && (_$e = _$i.maxYoutubeVideoDimensions.width, _$t = _$i.maxYoutubeVideoDimensions.height), c.runActions(_$e, _$t);
            }, this.handleCustomLoad = function() {
                a(function() {
                    var _$e = o2[t].current;
                    c.runActions(_$e.offsetWidth, _$e.offsetHeight);
                });
            };
        };
        var Je = function Je(e59, t13) {
            var _$n = this;
            var r = e59.elements.sourceMainWrappers;
            var o = e59.props.slideDistance;
            var _$i = 0;
            var s = 0;
            var a = 0;
            this.translate = function(e, t) {
                return s = e, void 0 !== t && (a = t), _$n;
            }, this.getTranslateX = function() {
                return _$i;
            }, this.getTranslateY = function() {
                return a;
            }, this.negative = function() {
                c(-(1 + o) * innerWidth);
            }, this.zero = function() {
                c(0);
            }, this.positive = function() {
                c((1 + o) * innerWidth);
            };
            var c = function c(e) {
                _$i = e + s, u(), s = 0;
            };
            var u = function u() {
                r[t13].current.style.transform = "translate(".concat(_$i, "px, ").concat(a, "px)");
            };
        };
        var Ge = function Ge(e60) {
            var _$t8 = e60.componentsServices.isLightboxOpenManager;
            var _$n10 = e60.core;
            var r8 = _$n10.eventsDispatcher;
            var o3 = _$n10.lightboxOpener;
            var _$i3 = _$n10.lightboxOpenActioner;
            var s3 = e60.data;
            var a3 = e60.elements;
            var c3 = e60.props;
            o3.open = function() {
                r8.dispatch("onShow"), _e(e60, "sourceLoadHandlers", Qe), _$t8.set(!0, _$i3.runInitializedLightboxActions);
            }, o3.initializeAndOpen = function() {
                s3.isInitialized = !0, a3.captions = Ue(e60), a3.sourceAnimationWrappers = Ue(e60), a3.sourceEnhancementWrappers = Ue(e60), a3.sourceMainWrappers = Ue(e60), a3.sources = Ue(e60), _e(e60, "sourceLoadHandlers", Qe), _e(e60, "sourceMainWrapperTransformers", Je), Ve(s3.slideButtons, c3.svg.slideButtons), Ve(s3.toolbarButtons, c3.svg.toolbarButtons), c3.disableThumbs || Xe(e60), Re(e60), r8.dispatch("onInit"), _$t8.set(!0, function() {
                    _$i3.runInitializedLightboxActions(), function(e) {
                        for(var _$t = e.props.sources, _$n = e.resolve, r = _$n(te), o = _$n(he), _$i = _$n(me, [
                            r,
                            o
                        ]), s = 0; s < _$t.length; s++)if (typeof _$t[s] === "string") {
                            var a = _$i.getTypeSetByClientForIndex(s);
                            if (a) o.runActionsForSourceTypeAndIndex(a, s);
                            else {
                                var c = r.getSourceTypeFromLocalStorageByUrl(_$t[s]);
                                c ? o.runActionsForSourceTypeAndIndex(c, s) : _$i.retrieveTypeWithXhrForIndex(s);
                            }
                        } else o.runActionsForSourceTypeAndIndex("custom", s);
                    }(e60);
                });
            };
        };
        var Ke = function Ke(e61) {
            return function(e) {
                if (Array.isArray(e)) return et(e);
            }(e61) || function(e) {
                if (typeof Symbol !== "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
            }(e61) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return et(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return et(e, t);
            }(e61) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var et = function et(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var rt = function rt(e) {
            var _$t = e.additionalClassName;
            var _$n = e.reference;
            var r = e.onClick;
            var o = e.viewBox;
            var _$i = e.width;
            var s = e.height;
            var c = e.d;
            var u = e.title;
            return a1.a.createElement("div", {
                ref: _$n,
                onClick: r,
                title: u,
                className: "fslightbox-slide-btn-container ".concat(_$t)
            }, a1.a.createElement("div", {
                className: "fslightbox-slide-btn fslightbox-flex-centered"
            }, a1.a.createElement(l1, {
                viewBox: o,
                width: _$i,
                height: s,
                d: c
            })));
        };
        var it = function it(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.core.slideChangeFacade;
            var r = _$n.changeToPrevious;
            var o = _$n.changeToNext;
            var _$i = _$t.data.slideButtons;
            var s = _$i.previous;
            var c = _$i.next;
            var u = _$t.elements;
            var l = u.slideButtonPrevious;
            var f = u.slideButtonNext;
            return _$t.props.sources.length > 1 && a1.a.createElement(a1.a.Fragment, null, a1.a.createElement(rt, _objectSpread({
                reference: l,
                additionalClassName: "fslightbox-slide-btn-container-previous",
                onClick: r
            }, s)), a1.a.createElement(rt, _objectSpread({
                reference: f,
                additionalClassName: "fslightbox-slide-btn-container-next",
                onClick: o
            }, c)));
        };
        var ct = function ct(e62) {
            return function(e) {
                if (Array.isArray(e)) return ut(e);
            }(e62) || function(e) {
                if (typeof Symbol !== "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
            }(e62) || function(e, t) {
                if (!e) return;
                if (typeof e === "string") return ut(e, t);
                var _$n = Object.prototype.toString.call(e).slice(8, -1);
                _$n === "Object" && e.constructor && (_$n = e.constructor.name);
                if (_$n === "Map" || _$n === "Set") return Array.from(e);
                if (_$n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return ut(e, t);
            }(e62) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        };
        var ut = function ut(e, t) {
            (t == null || t > e.length) && (t = e.length);
            for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
            return r;
        };
        var lt = function lt(e, t) {
            for(var _$n = 0; _$n < t.length; _$n++){
                var r = t[_$n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        };
        var dt = function dt(e, t) {
            return !t || st(t) !== "object" && typeof t !== "function" ? ht(e) : t;
        };
        var ht = function ht(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        };
        var pt = function pt() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if (typeof Proxy === "function") return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        };
        n1.r(t3);
        var r1 = "fslightbox-";
        function i1(e63) {
            return (i1 = typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol" ? function i1(e) {
                return typeof e === "undefined" ? "undefined" : _typeof(e);
            } : function(e) {
                return e && typeof Symbol === "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
            })(e63);
        }
        (typeof document === "undefined" ? "undefined" : i1(document)) === "object" && o();
        var s1 = n1(0);
        var a1 = n1.n(s1);
        var c1 = n1(1);
        var u1 = n1.n(c1);
        var l1 = function l1(e) {
            var _$t = e.viewBox;
            var _$n = e.width;
            var o = e.height;
            var _$i = e.d;
            return a1.a.createElement("svg", {
                width: _$n,
                height: o,
                viewBox: _$t,
                xmlns: "http://www.w3.org/2000/svg"
            }, a1.a.createElement("path", {
                className: "".concat(r1, "svg-path"),
                d: _$i
            }));
        };
        function d1() {
            return (d1 = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$n = arguments[_$t];
                    for(var r in _$n)Object.prototype.hasOwnProperty.call(_$n, r) && (e[r] = _$n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function b1() {
            return (b1 = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$n = arguments[_$t];
                    for(var r in _$n)Object.prototype.hasOwnProperty.call(_$n, r) && (e[r] = _$n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function y1() {
            return (y1 = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$n = arguments[_$t];
                    for(var r in _$n)Object.prototype.hasOwnProperty.call(_$n, r) && (e[r] = _$n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        var w1 = function w1(e64) {
            var _$t = e64.fsLightbox;
            var _$n11 = _$t.core;
            var r = _$n11.clickZoomer;
            var o = r.zoomIn;
            var _$i = r.zoomOut;
            var s = _$n11.lightboxCloser.close;
            var c = _$t.data.toolbarButtons;
            var u = _$t.props;
            var l = u.customToolbarButtons;
            var d = u.disableThumbs;
            var h = [];
            if (d || h.push(a1.a.createElement(f, _objectSpread({
                onClick: _$t.core.thumbsToggler.toggleThumbs
            }, c.thumbs, {
                key: c.thumbs.title
            }))), l) for(var p = function p(e) {
                var _$n = l[e];
                h.unshift(a1.a.createElement(f, {
                    onClick: function onClick() {
                        return _$n.onClick(_$t);
                    },
                    viewBox: _$n.viewBox,
                    width: _$n.width,
                    height: _$n.height,
                    d: _$n.d,
                    title: _$n.title,
                    key: _$n.title
                }));
            }, b = 0; b < l.length; b++)p(b);
            return a1.a.createElement("div", {
                className: "fslightbox-toolbar"
            }, h, a1.a.createElement(f, _objectSpread({
                onClick: o
            }, c.zoomIn)), a1.a.createElement(f, _objectSpread({
                onClick: _$i
            }, c.zoomOut)), a1.a.createElement(x, {
                fsLightbox: _$t
            }), a1.a.createElement(m, {
                fsLightbox: _$t
            }), a1.a.createElement(f, _objectSpread({
                onClick: s
            }, c.close)));
        };
        var T1 = function T1(e65) {
            var _$t = e65.fsLightbox;
            var _$n = _$t.componentsServices;
            var o = _$t.props.sources;
            var _$i = _$t.stageIndexes;
            var c = S(Object(s1.useState)(_$i.current + 1), 2);
            var u = c[0];
            var l = c[1];
            _$n.setSlideNumber = function(e) {
                l(e);
            };
            var f = a1.a.createRef();
            var d = a1.a.createRef();
            return Object(s1.useEffect)(function() {
                d.current.offsetWidth > 55 && (f.current.style.justifyContent = "flex-start");
            }, []), a1.a.createElement("div", {
                ref: f,
                className: "".concat(r1, "slide-number-container")
            }, a1.a.createElement("div", {
                ref: d,
                className: "fslightbox-flex-centered"
            }, a1.a.createElement("span", null, u), a1.a.createElement("span", {
                className: "".concat(r1, "slash")
            }), a1.a.createElement("span", null, o.length)));
        };
        var L1 = function L1(e) {
            var _$t = e.fsLightbox;
            return a1.a.createElement("div", {
                ref: _$t.elements.nav,
                className: "".concat(r1, "nav fslightbox-absoluted")
            }, a1.a.createElement(w1, {
                fsLightbox: _$t
            }), _$t.props.sources.length > 1 && a1.a.createElement(T1, {
                fsLightbox: _$t
            }));
        };
        var C = function C(e) {
            var _$t = e.additionalClassName;
            var _$n = (e.testId, "".concat(r1, "loader"));
            return _$t && (_$n += " ".concat(_$t)), a1.a.createElement("div", {
                className: _$n
            }, a1.a.createElement("div", null), a1.a.createElement("div", null), a1.a.createElement("div", null), a1.a.createElement("div", null));
        };
        var z = function z(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.componentsServices.updateSourceDirectWrapperCollection;
            var r = _$t.core.stageManager.isSourceInStage;
            var o = _$t.elements;
            var _$i = o.sourceComponents;
            var c = o.sourceAnimationWrappers;
            var u = _$t.props.loadOnlyCurrentSource;
            var l = _$t.stageIndexes.current;
            var f = e.i;
            var d = E(Object(s1.useState)(!1), 2);
            var h = d[0];
            var p = d[1];
            return _$n[f] = function() {
                p(!h);
            }, a1.a.createElement("div", {
                ref: c[f]
            }, f === l || !u && r(f) ? _$i[f] : null);
        };
        var W = function W(e) {
            var _$t = e.fsLightbox;
            var _$n = e.i;
            return a1.a.createElement("div", {
                ref: _$t.elements.sourceEnhancementWrappers[_$n]
            }, a1.a.createElement(z, {
                fsLightbox: _$t,
                i: _$n
            }));
        };
        var P = function P(e) {
            var _$t = e.fsLightbox;
            var _$n = e.i;
            var r = _$t.componentsServices.hideSourceLoaderCollection;
            var o = _$t.elements.sourceMainWrappers;
            var _$i = O(Object(s1.useState)(!1), 2);
            var c = _$i[0];
            var u = _$i[1];
            return r[_$n] = function() {
                return u(!0);
            }, a1.a.createElement("div", {
                ref: o[_$n],
                className: "fslightbox-absoluted fslightbox-full-dimension fslightbox-flex-centered"
            }, !c && a1.a.createElement(C, null), a1.a.createElement(W, {
                fsLightbox: _$t,
                i: _$n
            }));
        };
        var B = function B(e) {
            var _$t = e.fsLightbox.componentsServices;
            var _$n = k(Object(s1.useState)(!1), 2);
            var o = _$n[0];
            var _$i = _$n[1];
            return _$t.showSlideSwipingHovererIfNotYet = function() {
                o || _$i(!0);
            }, _$t.hideSlideSwipingHoverer = function() {
                _$i(!1);
            }, o && a1.a.createElement("div", {
                className: "".concat(r1, "slide-swiping-hoverer fslightbox-full-dimension fslightbox-absoluted")
            });
        };
        var U = function U(e) {
            var _$t = e.fsLightbox.elements.slideshowBar;
            return a1.a.createElement("div", {
                className: "".concat(r1, "slideshow-bar fslightbox-absoluted"),
                ref: _$t
            });
        };
        var _ = function _(e) {
            var _$t = e.fsLightbox.componentsServices;
            var _$n = Z(Object(s1.useState)(!1), 2);
            var r = _$n[0];
            var o = _$n[1];
            return _$t.showThumbsCursorerIfNotYet = function() {
                r || o(!0);
            }, _$t.hideThumbsCursorerIfShown = function() {
                r && o(!1);
            }, r ? a1.a.createElement("div", {
                className: "fslightbox-thumbs-cursorer fslightbox-full-dimension fslightbox-absoluted"
            }) : null;
        };
        var J = function J(e) {
            var _$t = e.fsLightbox;
            var _$n = e.index;
            var r = e.children;
            var o = _$t.data.isThumbing;
            var _$i = _$t.elements.captions;
            var s = "fslightbox-caption";
            return _$n !== _$t.stageIndexes.current || o || (s += " fslightbox-caption-active"), a1.a.createElement("div", {
                ref: _$i[_$n],
                className: "".concat(s, " fslightbox-flex-centered")
            }, a1.a.createElement("div", {
                className: "fslightbox-caption-inner"
            }, r));
        };
        var G = function G(e66) {
            var _$t = e66.fsLightbox;
            var _$n = _$t.props.captions;
            return _$n ? _$n.map(function(e, n) {
                return e && a1.a.createElement(J, {
                    fsLightbox: _$t,
                    index: n,
                    key: n
                }, e);
            }) : null;
        };
        function ne() {
            return (ne = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$n = arguments[_$t];
                    for(var r in _$n)Object.prototype.hasOwnProperty.call(_$n, r) && (e[r] = _$n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        var re = function re(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.collections.sourceLoadHandlers;
            var r = _$t.elements.sources;
            var o = _$t.props;
            var _$i = o.customAttributes;
            var s = o.sources;
            var c = e.i;
            return a1.a.createElement("img", _objectSpread({
                onLoad: _$n[c].handleImageLoad,
                ref: r[c],
                className: "fslightbox-source",
                src: s[c]
            }, _$i && _$i[c] ? _$i[c] : {}));
        };
        function oe() {
            return (oe = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$n = arguments[_$t];
                    for(var r in _$n)Object.prototype.hasOwnProperty.call(_$n, r) && (e[r] = _$n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        var ie = function ie(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.collections.sourceLoadHandlers;
            var o = _$t.elements.sources;
            var _$i = _$t.props;
            var s = _$i.customAttributes;
            var c = _$i.sources;
            var u = _$t.timeout;
            var l = e.i;
            return u(_$n[l].handleNotMetaDatedVideoLoad, 3e3), a1.a.createElement("video", _objectSpread({
                onLoadedMetadata: _$n[l].handleVideoLoad,
                className: "fslightbox-source ".concat(r1, "video"),
                controls: !0,
                ref: o[l]
            }, s && s[l] ? s[l] : {}), a1.a.createElement("source", {
                src: c[l]
            }));
        };
        function se() {
            return (se = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$n = arguments[_$t];
                    for(var r in _$n)Object.prototype.hasOwnProperty.call(_$n, r) && (e[r] = _$n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        var ae = function ae(e) {
            var _$t;
            var _$n = e.fsLightbox;
            var o = _$n.props;
            var _$i = o.customAttributes;
            var c = o.sources;
            var u = _$n.elements.sources;
            var l = _$n.collections.sourceLoadHandlers;
            var f = e.i;
            return Object(s1.useEffect)(l[f].handleYoutubeLoad), a1.a.createElement("iframe", _objectSpread({
                ref: u[f],
                className: "fslightbox-source ".concat(r1, "youtube-iframe"),
                src: "https://www.youtube.com/embed/".concat((_$t = c[f], "".concat(_$t.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)[2], "?enablejsapi=1"))),
                allowFullScreen: !0
            }, _$i && _$i[f] ? _$i[f] : {}));
        };
        var ce = function ce(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.collections.sourceLoadHandlers;
            var r = _$t.elements.sources;
            var o = _$t.props.sources;
            var _$i = e.i;
            Object(s1.useEffect)(_$n[_$i].handleCustomLoad);
            var c = o[_$i].props.className;
            return a1.a.cloneElement(o[_$i], {
                ref: r[_$i],
                className: c ? "".concat(c, " fslightbox-source") : "fslightbox-source"
            });
        };
        var ue = function ue(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.componentsServices.hideSourceLoaderCollection;
            var o = _$t.elements.sourceAnimationWrappers;
            var _$i = _$t.props.initialAnimation;
            var c = e.i;
            return Object(s1.useEffect)(function() {
                _$n[c](), o[c].current.classList.add(_$i);
            }), a1.a.createElement("div", {
                className: "".concat(r1, "invalid-file-wrapper fslightbox-flex-centered")
            }, "Invalid source");
        };
        var le = function le(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.core.thumbLoadHandler;
            var r = _$t.elements;
            var o = r.thumbs;
            var _$i = r.thumbsWrappers;
            var s = _$t.props.thumbsIcons;
            var c = _$t.stageIndexes.current;
            var u = e.src;
            var l = e.i;
            var f = "fslightbox-thumb";
            c === l && (f += " fslightbox-thumb-active");
            var d = s && s[l];
            return a1.a.createElement("div", {
                ref: _$i[l],
                className: "fslightbox-thumb-wrapper"
            }, d, d && a1.a.createElement("div", {
                className: "fslightbox-thumb-wrapper-darkener"
            }), a1.a.createElement("img", {
                ref: o[l],
                className: f,
                src: u,
                alt: u,
                onLoad: _$n.handleLoad
            }));
        };
        var fe = function fe(e) {
            var _$t = e.fsLightbox;
            var _$n = _$t.core.thumbLoadHandler;
            var r = _$t.elements;
            var o = r.thumbs;
            var _$i = r.thumbsWrappers;
            var c = _$t.stageIndexes.current;
            var u = e.i;
            Object(s1.useEffect)(_$n.handleLoad);
            var f = "fslightbox-thumb fslightbox-flex-centered";
            return u === c && (f += " fslightbox-thumb-active"), a1.a.createElement("div", {
                ref: _$i[u],
                className: "fslightbox-thumb-invalid fslightbox-thumb-wrapper"
            }, a1.a.createElement("div", {
                ref: o[u],
                className: f
            }, a1.a.createElement(l1, {
                viewBox: "0 0 30 30",
                height: "22px",
                width: "22px",
                d: "M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16.212,8l-0.2,9h-2.024l-0.2-9 H16.212z M15.003,22.189c-0.828,0-1.323-0.441-1.323-1.182c0-0.755,0.494-1.196,1.323-1.196c0.822,0,1.316,0.441,1.316,1.196 C16.319,21.748,15.825,22.189,15.003,22.189z"
            })));
        };
        function Ze(e67) {
            return (Ze = typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol" ? function Ze(e) {
                return typeof e === "undefined" ? "undefined" : _typeof(e);
            } : function(e) {
                return e && typeof Symbol === "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
            })(e67);
        }
        function Ve(e, t) {
            if (Ze(t) === "object") for(var _$n in e)Ze(t[_$n]) === "object" ? Ve(e[_$n], t[_$n]) : t[_$n] && (e[_$n] = t[_$n]);
        }
        var tt = {
            thumbs: {
                width: "17px",
                height: "17px",
                viewBox: "0 0 22 22",
                d: "M 3 2 C 2.448 2 2 2.448 2 3 L 2 6 C 2 6.552 2.448 7 3 7 L 6 7 C 6.552 7 7 6.552 7 6 L 7 3 C 7 2.448 6.552 2 6 2 L 3 2 z M 10 2 C 9.448 2 9 2.448 9 3 L 9 6 C 9 6.552 9.448 7 10 7 L 13 7 C 13.552 7 14 6.552 14 6 L 14 3 C 14 2.448 13.552 2 13 2 L 10 2 z M 17 2 C 16.448 2 16 2.448 16 3 L 16 6 C 16 6.552 16.448 7 17 7 L 20 7 C 20.552 7 21 6.552 21 6 L 21 3 C 21 2.448 20.552 2 20 2 L 17 2 z M 3 9 C 2.448 9 2 9.448 2 10 L 2 13 C 2 13.552 2.448 14 3 14 L 6 14 C 6.552 14 7 13.552 7 13 L 7 10 C 7 9.448 6.552 9 6 9 L 3 9 z M 10 9 C 9.448 9 9 9.448 9 10 L 9 13 C 9 13.552 9.448 14 10 14 L 13 14 C 13.552 14 14 13.552 14 13 L 14 10 C 14 9.448 13.552 9 13 9 L 10 9 z M 17 9 C 16.448 9 16 9.448 16 10 L 16 13 C 16 13.552 16.448 14 17 14 L 20 14 C 20.552 14 21 13.552 21 13 L 21 10 C 21 9.448 20.552 9 20 9 L 17 9 z M 3 16 C 2.448 16 2 16.448 2 17 L 2 20 C 2 20.552 2.448 21 3 21 L 6 21 C 6.552 21 7 20.552 7 20 L 7 17 C 7 16.448 6.552 16 6 16 L 3 16 z M 10 16 C 9.448 16 9 16.448 9 17 L 9 20 C 9 20.552 9.448 21 10 21 L 13 21 C 13.552 21 14 20.552 14 20 L 14 17 C 14 16.448 13.552 16 13 16 L 10 16 z M 17 16 C 16.448 16 16 16.448 16 17 L 16 20 C 16 20.552 16.448 21 17 21 L 20 21 C 20.552 21 21 20.552 21 20 L 21 17 C 21 16.448 20.552 16 20 16 L 17 16 z",
                title: "Thumbnails"
            },
            zoomIn: {
                width: "20px",
                height: "20px",
                viewBox: "0 0 30 30",
                d: "M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z M 12.984375 7.9863281 A 1.0001 1.0001 0 0 0 12 9 L 12 12 L 9 12 A 1.0001 1.0001 0 1 0 9 14 L 12 14 L 12 17 A 1.0001 1.0001 0 1 0 14 17 L 14 14 L 17 14 A 1.0001 1.0001 0 1 0 17 12 L 14 12 L 14 9 A 1.0001 1.0001 0 0 0 12.984375 7.9863281 z",
                title: "Zoom In"
            },
            zoomOut: {
                width: "20px",
                height: "20px",
                viewBox: "0 0 30 30",
                d: "M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z M 9 12 A 1.0001 1.0001 0 1 0 9 14 L 17 14 A 1.0001 1.0001 0 1 0 17 12 L 9 12 z",
                title: "Zoom Out"
            },
            slideshow: {
                start: {
                    width: "16px",
                    height: "16px",
                    viewBox: "0 0 30 30",
                    d: "M 6 3 A 1 1 0 0 0 5 4 A 1 1 0 0 0 5 4.0039062 L 5 15 L 5 25.996094 A 1 1 0 0 0 5 26 A 1 1 0 0 0 6 27 A 1 1 0 0 0 6.5800781 26.8125 L 6.5820312 26.814453 L 26.416016 15.908203 A 1 1 0 0 0 27 15 A 1 1 0 0 0 26.388672 14.078125 L 6.5820312 3.1855469 L 6.5800781 3.1855469 A 1 1 0 0 0 6 3 z",
                    title: "Turn on slideshow"
                },
                pause: {
                    width: "14px",
                    height: "14px",
                    viewBox: "0 0 356.19 356.19",
                    d: "M121,0c18,0,33,15,33,33v372c0,18-15,33-33,33s-32-15-32-33V33C89,15,103,0,121,0zM317,0c18,0,32,15,32,33v372c0,18-14,33-32,33s-33-15-33-33V33C284,15,299,0,317,0z",
                    title: "Turn off slideshow"
                }
            },
            fullscreen: {
                enter: {
                    width: "20px",
                    height: "20px",
                    viewBox: "0 0 18 18",
                    d: "M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z",
                    title: "Enter fullscreen"
                },
                exit: {
                    width: "24px",
                    height: "24px",
                    viewBox: "0 0 950 1024",
                    d: "M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z",
                    title: "Exit fullscreen"
                }
            },
            close: {
                width: "20px",
                height: "20px",
                viewBox: "0 0 24 24",
                d: "M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z",
                title: "Close"
            }
        };
        var nt = {
            previous: {
                width: "20px",
                height: "20px",
                viewBox: "0 0 20 20",
                d: "M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z",
                title: "Previous"
            },
            next: {
                width: "20px",
                height: "20px",
                viewBox: "0 0 20 20",
                d: "M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z",
                title: "Next"
            }
        };
        function ot() {
            return (ot = Object.assign || function(e) {
                for(var _$t = 1; _$t < arguments.length; _$t++){
                    var _$n = arguments[_$t];
                    for(var r in _$n)Object.prototype.hasOwnProperty.call(_$n, r) && (e[r] = _$n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function st(e68) {
            return (st = typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol" ? function st(e) {
                return typeof e === "undefined" ? "undefined" : _typeof(e);
            } : function(e) {
                return e && typeof Symbol === "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
            })(e68);
        }
        function at(e69, t14, n2) {
            return (at = pt() ? Reflect.construct : function at(e, t, n) {
                var r = [
                    null
                ];
                r.push.apply(r, t);
                var o = new (Function.bind.apply(e, r))();
                return n && ft(o, n.prototype), o;
            }).apply(null, arguments);
        }
        function ft(e70, t15) {
            return (ft = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e70, t15);
        }
        function mt(e71) {
            return (mt = Object.setPrototypeOf ? Object.getPrototypeOf : function mt(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e71);
        }
        var bt = function(e72) {
            !function(e, t) {
                if (typeof t !== "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ft(e, t);
            }(u, e72);
            var _$t9;
            var _$n12;
            var o4;
            var _$i4;
            var s;
            var c = (_$t9 = u, _$n12 = pt(), function c() {
                var _$e;
                var r = mt(_$t9);
                if (_$n12) {
                    var o = mt(this).constructor;
                    _$e = Reflect.construct(r, arguments, o);
                } else _$e = r.apply(this, arguments);
                return dt(this, _$e);
            });
            function u(e73) {
                var _$t;
                return function(e, t) {
                    if (!_instanceof(e, t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), (_$t = c.call(this, e73)).state = {
                    isOpen: !1
                }, _$t.data = {
                    isInitialized: !1,
                    maxSourceWidth: 0,
                    maxSourceHeight: 0,
                    scrollbarWidth: 0,
                    toolbarButtons: tt,
                    slideButtons: nt,
                    captionHeights: [],
                    notThumbedSourceEnhancementWrapperScales: [],
                    notThumbedSourceEnhancementWrapperTranslatesY: [],
                    thumbedSourceEnhancementWrapperTranslateY: null,
                    zoom: 1
                }, _$t.sourcePointerProps = {
                    isPointering: !1,
                    pointers: {},
                    pointersCount: 0,
                    downScreenX: null,
                    downScreenY: null,
                    isSourceDownEventTarget: !1,
                    swipedX: 0,
                    swipedY: 0,
                    upSwipedX: 0,
                    upSwipedY: 0,
                    pinchedHypot: 0
                }, _$t.stageIndexes = {
                    current: 0
                }, _$t.componentsServices = {
                    showSlideSwipingHovererIfNotYet: null,
                    hideSlideSwipingHoverer: null,
                    hideSourceLoaderCollection: [],
                    updateSourceDirectWrapperCollection: [],
                    isFullscreenOpen: {},
                    startSlideshow: null,
                    stopSlideshow: null,
                    isSlideShowOn: {},
                    slideNumberUpdater: {},
                    toolbarButtons: {
                        fullscreen: {},
                        slideshow: {}
                    },
                    isLightboxOpenManager: {
                        get: function get() {
                            return _$t.state.isOpen;
                        },
                        set: function set(e, n) {
                            _$t.setState({
                                isOpen: e
                            }, n);
                        }
                    }
                }, _$t.elements = {
                    captions: null,
                    container: a1.a.createRef(),
                    nav: a1.a.createRef(),
                    slideButtonPrevious: a1.a.createRef(),
                    slideButtonNext: a1.a.createRef(),
                    slideshowBar: a1.a.createRef(),
                    sourceAnimationWrappers: null,
                    sourceEnhancementWrappers: null,
                    sourceMainWrappers: null,
                    sourceWrappersContainer: a1.a.createRef(),
                    sources: null,
                    sourceComponents: []
                }, _$t.core = {
                    classFacade: {},
                    clickZoomer: {},
                    eventsDispatcher: {},
                    fullscreenToggler: {},
                    globalEventsController: {},
                    inactiver: {},
                    lightboxCloser: {},
                    lightboxCloseActioner: {},
                    lightboxOpener: {},
                    lightboxOpenActioner: {},
                    lightboxUpdater: {},
                    scrollbarRecompensor: {},
                    slideshowManager: {},
                    slideChangeFacade: {},
                    slideIndexChanger: {},
                    sourceEnhancementWrappersTransformer: {},
                    sourceDisplayFacade: {},
                    sourcesPointerDown: {},
                    stageManager: {},
                    pointeringBucket: {},
                    windowResizeActioner: {},
                    zoomer: {}
                }, _$t.collections = {
                    sourceMainWrapperTransformers: [],
                    sourceLoadHandlers: [],
                    sourceSizers: [],
                    xhrs: []
                }, _$t.getQueuedAction = _$t.getQueuedAction.bind(ht(_$t)), _$t.middleware = _$t.middleware.bind(ht(_$t)), _$t.resolve = _$t.resolve.bind(ht(_$t)), _$t.timeout = _$t.timeout.bind(ht(_$t)), ee(ht(_$t)), Ge(ht(_$t)), _$t;
            }
            return o4 = u, (_$i4 = [
                {
                    key: "getQueuedAction",
                    value: function value(e, t) {
                        var _$n = this;
                        var r = [];
                        return function() {
                            r.push(!0), _$n.timeout(function() {
                                r.pop(), r.length || e();
                            }, t);
                        };
                    }
                },
                {
                    key: "middleware",
                    value: function value(e74, t16) {
                        return function(e, t) {
                            var _$n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
                            return function() {
                                for(var r = arguments.length, o = new Array(r), _$i = 0; _$i < r; _$i++)o[_$i] = arguments[_$i];
                                t.apply(void 0, Ke(_$n.concat(o))) && e.apply(void 0, o);
                            };
                        }(e74, t16, [
                            this
                        ]);
                    }
                },
                {
                    key: "resolve",
                    value: function value(e) {
                        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                        return _$t.unshift(this), at(e, ct(_$t));
                    }
                },
                {
                    key: "timeout",
                    value: function value(e, t) {
                        var _$n = this;
                        setTimeout(function() {
                            _$n.elements.container.current && e();
                        }, t);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function value(e) {
                        this.core.lightboxUpdater.handleUpdate(e);
                    }
                },
                {
                    key: "componentDidMount",
                    value: function value() {
                        R(this);
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function value() {
                        !function(e) {
                            for(var _$t = e.collections.xhrs, _$n = e.componentsServices.isLightboxOpenManager, r = e.core.globalEventsController, o = 0; o < _$t.length; o++)_$t[o].abort();
                            _$n.get() && r.removeListeners();
                        }(this);
                    }
                },
                {
                    key: "render",
                    value: function value() {
                        return this.state.isOpen ? a1.a.createElement("div", {
                            className: "".concat(r1, "container fslightbox-full-dimension fslightbox-fade-in-strong"),
                            ref: this.elements.container
                        }, a1.a.createElement(B, {
                            fsLightbox: this
                        }), a1.a.createElement(L1, {
                            fsLightbox: this
                        }), a1.a.createElement(U, {
                            fsLightbox: this
                        }), a1.a.createElement(it, {
                            fsLightbox: this
                        }), a1.a.createElement(F, {
                            fsLightbox: this
                        }), a1.a.createElement(G, {
                            fsLightbox: this
                        }), this.props.disableThumbs ? null : a1.a.createElement(Q, {
                            fsLightbox: this
                        })) : null;
                    }
                }, 
            ]) && lt(o4.prototype, _$i4), s && lt(o4, s), u;
        }(s1.Component);
        bt.propTypes = {
            toggler: u1.a.bool,
            sources: u1.a.array,
            initialAnimation: u1.a.string,
            slideChangeAnimation: u1.a.string,
            captions: u1.a.array,
            onOpen: u1.a.func,
            onClose: u1.a.func,
            onInit: u1.a.func,
            onShow: u1.a.func,
            onSlideChange: u1.a.func,
            onZoomingStart: u1.a.func,
            onZoomingEnd: u1.a.func,
            source: u1.a.string,
            sourceIndex: u1.a.number,
            slide: u1.a.number,
            customAttributes: u1.a.array,
            maxYoutubeVideoDimensions: u1.a.object,
            svg: u1.a.object,
            disableLocalStorage: u1.a.bool,
            types: u1.a.array,
            type: u1.a.string,
            thumbs: u1.a.array,
            disableThumbs: u1.a.bool,
            showThumbsOnMount: u1.a.bool,
            thumbsIcons: u1.a.array,
            customToolbarButtons: u1.a.array,
            exitFullscreenOnClose: u1.a.bool,
            loadOnlyCurrentSource: u1.a.bool,
            openOnMount: u1.a.bool,
            slideDistance: u1.a.number,
            slideshowTime: u1.a.number,
            UIFadeOutTime: u1.a.number,
            zoomIncrement: u1.a.number
        }, bt.defaultProps = {
            svg: {},
            initialAnimation: "fslightbox-fade-in-strong",
            slideChangeAnimation: "fslightbox-fade-in",
            slideDistance: 0.3,
            slideshowTime: 8e3,
            UIFadeOutTime: 8e3,
            zoomIncrement: 0.25
        };
        t3.default = bt;
    }, 
]);


/***/ }),

/***/ 46995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ fetchProductsFromHandles; }
/* harmony export */ });
/* unused harmony export fetchProductFromHandle */
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35230);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

var fetchProductFromHandle = function() {
    var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(handle) {
        var endpoint, response;
        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (handle) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 3:
                    endpoint = "/json/products/".concat(handle, ".json");
                    _ctx.next = 6;
                    return fetch(endpoint);
                case 6:
                    response = _ctx.sent;
                    _ctx.next = 9;
                    return response.json();
                case 9:
                    return _ctx.abrupt("return", _ctx.sent);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0.message);
                    return _ctx.abrupt("return", null);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchProductFromHandle(handle) {
        return _ref.apply(this, arguments);
    };
}();
var fetchProductsFromHandles = function() {
    var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(handles) {
        var productPromises;
        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (!(!Array.isArray(handles) || !(handles === null || handles === void 0 ? void 0 : handles.length))) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", []);
                case 3:
                    productPromises = handles.map(fetchProductFromHandle);
                    return _ctx.abrupt("return", Promise.all(productPromises));
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0.message);
                    return _ctx.abrupt("return", []);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchProductsFromHandles(handles) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 51569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _react = _interopRequireWildcard(__webpack_require__(27378));
var _head = _interopRequireDefault(__webpack_require__(3057));
var _imageConfig = __webpack_require__(48252);
var _useIntersection = __webpack_require__(48315);
var _imageConfigContext = __webpack_require__(7742);
var _utils = __webpack_require__(36988);
var _normalizeTrailingSlash = __webpack_require__(71419);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "200px" : _lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _objectWithoutProperties(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _objectSpread({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _objectWithoutProperties(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    var ref2 = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref2[0], setBlurComplete = ref2[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary,
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    if (false) {}
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layout === "raw" ? {} : layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        filter: "blur(20px)",
        backgroundSize: objectFit || "cover",
        backgroundImage: 'url("'.concat(blurDataURL, '")'),
        backgroundPosition: objectPosition || "0% 0%"
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _objectSpread({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, layout === "raw" ? /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)) : /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
function _defineProperty1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty1(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ref;
var experimentalLayoutRaw = (ref = {"deviceSizes":[640,750,828,1080,1200,1920,2400],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","experimentalLayoutRaw":false}) === null || ref === void 0 ? void 0 : ref.experimentalLayoutRaw;
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2400],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","experimentalLayoutRaw":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    "raw",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive" || layout === "raw")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref3 = getWidths(config, width, layout, sizes), widths = ref3.widths, kind = ref3.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref2;
    var loaderKey = ((ref2 = loaderProps.config) === null || ref2 === void 0 ? void 0 : ref2.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef === null || onLoadingCompleteRef === void 0 ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, widthModified, heightModified, ref3; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, rest = _objectWithoutProperties(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible"
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, layout === "raw" ? {
        height: heightInt,
        width: widthInt
    } : {}, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _objectSpread({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            setIntersection(img);
            if (img === null || img === void 0 ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: imgAttributes.sizes,
        loader: loader
    }), layout === "raw" ? {
        height: heightInt,
        width: widthInt
    } : {}, {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading || "lazy"
    }))));
};
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    params.set("auto", params.get("auto") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 93853:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(27378));
var _router = __webpack_require__(31398);
var _router1 = __webpack_require__(87895);
var _useIntersection = __webpack_require__(48315);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? "replace" : "push"](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function(props, forwardedRef) {
    var _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior;
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, restProps = _objectWithoutProperties(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter"
    ]);
    children = childrenProp;
    if (legacyBehavior && typeof children === "string") {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref2.href, as = ref2.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale1 = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 48315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(27378);
var _requestIdleCallback = __webpack_require__(38404);
var hasIntersectionObserver = typeof IntersectionObserver !== "undefined";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(rootRef ? rootRef.current : null), 2), root = ref1[0], setRoot = ref1[1];
    var setRef = (0, _react).useCallback(function(el) {
        if (unobserve.current) {
            unobserve.current();
            unobserve.current = undefined;
        }
        if (isDisabled || visible) return;
        if (el && el.tagName) {
            unobserve.current = observe(el, function(isVisible) {
                return isVisible && setVisible(isVisible);
            }, {
                root: root,
                rootMargin: rootMargin
            });
        }
    }, [
        isDisabled,
        root,
        rootMargin,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    (0, _react).useEffect(function() {
        if (!hasIntersectionObserver) {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        visible
    ]);
    (0, _react).useEffect(function() {
        if (rootRef) setRoot(rootRef.current);
    }, [
        rootRef
    ]);
    return [
        setRef,
        visible,
        resetVisible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
    } else {
        instance = observers.get(id);
        idList.push(id);
    }
    if (instance) {
        return instance;
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    observers.set(id, instance = {
        id: id,
        observer: observer,
        elements: elements
    });
    return instance;
}
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 1070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeletonBox":"PageErrorBoundary_skeletonBox__RAWh4","shimmer":"PageErrorBoundary_shimmer__7u3Mk"};

/***/ }),

/***/ 3949:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PreviewModeToast_container__uXpwm","message":"PreviewModeToast_message___V_Uy"};

/***/ }),

/***/ 70127:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__lbC1D","spin":"Spinner_spin__rcHsC"};

/***/ }),

/***/ 71413:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bundle-builder__disclaimer":"BuilderHeader_bundle-builder__disclaimer__Z7_5l"};

/***/ }),

/***/ 97765:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bundle-builder__sidebar-container":"BuilderSteps_bundle-builder__sidebar-container__xtzLG"};

/***/ }),

/***/ 9528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pulse":"hotspot_pulse__FsYG_"};

/***/ }),

/***/ 48132:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"category-carousel":"CategoryCarousel_category-carousel__7NFbx","category__image":"CategoryCarousel_category__image__ThvOr","slick-dots":"CategoryCarousel_slick-dots__sAKuV","categoryTileBorder":"CategoryCarousel_categoryTileBorder__P9YGB","category__title":"CategoryCarousel_category__title__UK6Q9","category__hoverImage":"CategoryCarousel_category__hoverImage__aBP_R","category":"CategoryCarousel_category__FGRNi","category-grid":"CategoryCarousel_category-grid__bvgUZ"};

/***/ }),

/***/ 35193:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"four-up-cta":"FourUpCta_four-up-cta__YDSHR","slick-dots":"FourUpCta_slick-dots__V54kk","ctaContainer":"FourUpCta_ctaContainer__oBawI","readmoreLink":"FourUpCta_readmoreLink__asNTi"};

/***/ }),

/***/ 62132:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markdownContainer":"Markdown_markdownContainer__PreVM"};

/***/ }),

/***/ 78655:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"ProductSpotlight_iconContainer__DP9PI"};

/***/ }),

/***/ 71915:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"quiz-result__product-grid--odd":"Quiz_quiz-result__product-grid--odd__KDelY"};

/***/ }),

/***/ 74190:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studyStatistics":"StudyStatistics_studyStatistics__s8fom"};

/***/ }),

/***/ 14478:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tableBuilder":"TableBuilder_tableBuilder__m8jxc"};

/***/ }),

/***/ 48278:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info-popup":"InfoPopup_info-popup__vAU3z"};

/***/ }),

/***/ 10263:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lineItemPricing":"SideCart_lineItemPricing__a_4rk","lineItemCompareAtPrice":"SideCart_lineItemCompareAtPrice__Qqurt"};

/***/ }),

/***/ 53566:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 66118:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={162:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(162);module.exports=r})();

/***/ }),

/***/ 88038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3057)


/***/ }),

/***/ 38579:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51569)


/***/ }),

/***/ 79894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93853)


/***/ }),

/***/ 86677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(87895)


/***/ }),

/***/ 43218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(41197)


/***/ }),

/***/ 25608:
/***/ (function(module) {

module.exports = not

function not(f) {
    return negation

    function negation() {
        return !f.apply(this, arguments)
    }
}


/***/ }),

/***/ 1404:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.generate = exports.compile = void 0;
var boolbase_1 = __importDefault(__webpack_require__(19377));
/**
 * Returns a function that checks if an elements index matches the given rule
 * highly optimized to return the fastest solution.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A highly optimized function that returns whether an index matches the nth-check.
 * @example
 *
 * ```js
 * const check = nthCheck.compile([2, 3]);
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 * ```
 */
function compile(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    /*
     * When `b <= 0`, `a * n` won't be lead to any matches for `a < 0`.
     * Besides, the specification states that no elements are
     * matched when `a` and `b` are 0.
     *
     * `b < 0` here as we subtracted 1 from `b` above.
     */
    if (b < 0 && a <= 0)
        return boolbase_1.default.falseFunc;
    // When `a` is in the range -1..1, it matches any element (so only `b` is checked).
    if (a === -1)
        return function (index) { return index <= b; };
    if (a === 0)
        return function (index) { return index === b; };
    // When `b <= 0` and `a === 1`, they match any element.
    if (a === 1)
        return b < 0 ? boolbase_1.default.trueFunc : function (index) { return index >= b; };
    /*
     * Otherwise, modulo can be used to check if there is a match.
     *
     * Modulo doesn't care about the sign, so let's use `a`s absolute value.
     */
    var absA = Math.abs(a);
    // Get `b mod a`, + a if this is negative.
    var bMod = ((b % absA) + absA) % absA;
    return a > 1
        ? function (index) { return index >= b && index % absA === bMod; }
        : function (index) { return index <= b && index % absA === bMod; };
}
exports.compile = compile;
/**
 * Returns a function that produces a monotonously increasing sequence of indices.
 *
 * If the sequence has an end, the returned function will return `null` after
 * the last index in the sequence.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A function that produces a sequence of indices.
 * @example <caption>Always increasing (2n+3)</caption>
 *
 * ```js
 * const gen = nthCheck.generate([2, 3])
 *
 * gen() // `1`
 * gen() // `3`
 * gen() // `5`
 * gen() // `8`
 * gen() // `11`
 * ```
 *
 * @example <caption>With end value (-2n+10)</caption>
 *
 * ```js
 *
 * const gen = nthCheck.generate([-2, 5]);
 *
 * gen() // 0
 * gen() // 2
 * gen() // 4
 * gen() // null
 * ```
 */
function generate(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    var n = 0;
    // Make sure to always return an increasing sequence
    if (a < 0) {
        var aPos_1 = -a;
        // Get `b mod a`
        var minValue_1 = ((b % aPos_1) + aPos_1) % aPos_1;
        return function () {
            var val = minValue_1 + aPos_1 * n++;
            return val > b ? null : val;
        };
    }
    if (a === 0)
        return b < 0
            ? // There are no result — always return `null`
                function () { return null; }
            : // Return `b` exactly once
                function () { return (n++ === 0 ? b : null); };
    if (b < 0) {
        b += a * Math.ceil(-b / a);
    }
    return function () { return a * n++ + b; };
}
exports.generate = generate;
//# sourceMappingURL=compile.js.map

/***/ }),

/***/ 80364:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var parse_js_1 = __webpack_require__(54912);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return parse_js_1.parse; } });
var compile_js_1 = __webpack_require__(1404);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return compile_js_1.compile; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return compile_js_1.generate; } });
/**
 * Parses and compiles a formula to a highly optimized function.
 * Combination of {@link parse} and {@link compile}.
 *
 * If the formula doesn't match any elements,
 * it returns [`boolbase`](https://github.com/fb55/boolbase)'s `falseFunc`.
 * Otherwise, a function accepting an _index_ is returned, which returns
 * whether or not the passed _index_ matches the formula.
 *
 * Note: The nth-rule starts counting at `1`, the returned function at `0`.
 *
 * @param formula The formula to compile.
 * @example
 * const check = nthCheck("2n+3");
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 */
function nthCheck(formula) {
    return (0, compile_js_1.compile)((0, parse_js_1.parse)(formula));
}
exports.ZP = nthCheck;
/**
 * Parses and compiles a formula to a generator that produces a sequence of indices.
 * Combination of {@link parse} and {@link generate}.
 *
 * @param formula The formula to compile.
 * @returns A function that produces a sequence of indices.
 * @example <caption>Always increasing</caption>
 *
 * ```js
 * const gen = nthCheck.sequence('2n+3')
 *
 * gen() // `1`
 * gen() // `3`
 * gen() // `5`
 * gen() // `8`
 * gen() // `11`
 * ```
 *
 * @example <caption>With end value</caption>
 *
 * ```js
 *
 * const gen = nthCheck.sequence('-2n+5');
 *
 * gen() // 0
 * gen() // 2
 * gen() // 4
 * gen() // null
 * ```
 */
function sequence(formula) {
    return (0, compile_js_1.generate)((0, parse_js_1.parse)(formula));
}
__webpack_unused_export__ = sequence;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 54912:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// Following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parse = void 0;
// Whitespace as per https://www.w3.org/TR/selectors-3/#lex is " \t\r\n\f"
var whitespace = new Set([9, 10, 12, 13, 32]);
var ZERO = "0".charCodeAt(0);
var NINE = "9".charCodeAt(0);
/**
 * Parses an expression.
 *
 * @throws An `Error` if parsing fails.
 * @returns An array containing the integer step size and the integer offset of the nth rule.
 * @example nthCheck.parse("2n+3"); // returns [2, 3]
 */
function parse(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") {
        return [2, 0];
    }
    else if (formula === "odd") {
        return [2, 1];
    }
    // Parse [ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
    var idx = 0;
    var a = 0;
    var sign = readSign();
    var number = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
        idx++;
        a = sign * (number !== null && number !== void 0 ? number : 1);
        skipWhitespace();
        if (idx < formula.length) {
            sign = readSign();
            skipWhitespace();
            number = readNumber();
        }
        else {
            sign = number = 0;
        }
    }
    // Throw if there is anything else
    if (number === null || idx < formula.length) {
        throw new Error("n-th rule couldn't be parsed ('".concat(formula, "')"));
    }
    return [a, sign * number];
    function readSign() {
        if (formula.charAt(idx) === "-") {
            idx++;
            return -1;
        }
        if (formula.charAt(idx) === "+") {
            idx++;
        }
        return 1;
    }
    function readNumber() {
        var start = idx;
        var value = 0;
        while (idx < formula.length &&
            formula.charCodeAt(idx) >= ZERO &&
            formula.charCodeAt(idx) <= NINE) {
            value = value * 10 + (formula.charCodeAt(idx) - ZERO);
            idx++;
        }
        // Return `null` if we didn't read anything.
        return idx === start ? null : value;
    }
    function skipWhitespace() {
        while (idx < formula.length &&
            whitespace.has(formula.charCodeAt(idx))) {
            idx++;
        }
    }
}
exports.parse = parse;
//# sourceMappingURL=parse.js.map

/***/ }),

/***/ 75323:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


const { DOCUMENT_MODE } = __webpack_require__(76256);

//Const
const VALID_DOCTYPE_NAME = 'html';
const VALID_SYSTEM_ID = 'about:legacy-compat';
const QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd';

const QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
    '+//silmaril//dtd html pro v0r11 19970101//',
    '-//as//dtd html 3.0 aswedit + extensions//',
    '-//advasoft ltd//dtd html 3.0 aswedit + extensions//',
    '-//ietf//dtd html 2.0 level 1//',
    '-//ietf//dtd html 2.0 level 2//',
    '-//ietf//dtd html 2.0 strict level 1//',
    '-//ietf//dtd html 2.0 strict level 2//',
    '-//ietf//dtd html 2.0 strict//',
    '-//ietf//dtd html 2.0//',
    '-//ietf//dtd html 2.1e//',
    '-//ietf//dtd html 3.0//',
    '-//ietf//dtd html 3.2 final//',
    '-//ietf//dtd html 3.2//',
    '-//ietf//dtd html 3//',
    '-//ietf//dtd html level 0//',
    '-//ietf//dtd html level 1//',
    '-//ietf//dtd html level 2//',
    '-//ietf//dtd html level 3//',
    '-//ietf//dtd html strict level 0//',
    '-//ietf//dtd html strict level 1//',
    '-//ietf//dtd html strict level 2//',
    '-//ietf//dtd html strict level 3//',
    '-//ietf//dtd html strict//',
    '-//ietf//dtd html//',
    '-//metrius//dtd metrius presentational//',
    '-//microsoft//dtd internet explorer 2.0 html strict//',
    '-//microsoft//dtd internet explorer 2.0 html//',
    '-//microsoft//dtd internet explorer 2.0 tables//',
    '-//microsoft//dtd internet explorer 3.0 html strict//',
    '-//microsoft//dtd internet explorer 3.0 html//',
    '-//microsoft//dtd internet explorer 3.0 tables//',
    '-//netscape comm. corp.//dtd html//',
    '-//netscape comm. corp.//dtd strict html//',
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    '-//sq//dtd html 2.0 hotmetal + extensions//',
    '-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//',
    '-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//',
    '-//spyglass//dtd html 2.0 extended//',
    '-//sun microsystems corp.//dtd hotjava html//',
    '-//sun microsystems corp.//dtd hotjava strict html//',
    '-//w3c//dtd html 3 1995-03-24//',
    '-//w3c//dtd html 3.2 draft//',
    '-//w3c//dtd html 3.2 final//',
    '-//w3c//dtd html 3.2//',
    '-//w3c//dtd html 3.2s draft//',
    '-//w3c//dtd html 4.0 frameset//',
    '-//w3c//dtd html 4.0 transitional//',
    '-//w3c//dtd html experimental 19960712//',
    '-//w3c//dtd html experimental 970421//',
    '-//w3c//dtd w3 html//',
    '-//w3o//dtd w3 html 3.0//',
    '-//webtechs//dtd mozilla html 2.0//',
    '-//webtechs//dtd mozilla html//'
];

const QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = QUIRKS_MODE_PUBLIC_ID_PREFIXES.concat([
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
]);

const QUIRKS_MODE_PUBLIC_IDS = ['-//w3o//dtd w3 html strict 3.0//en//', '-/w3c/dtd html 4.0 transitional/en', 'html'];
const LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = ['-//w3c//dtd xhtml 1.0 frameset//', '-//w3c//dtd xhtml 1.0 transitional//'];

const LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = LIMITED_QUIRKS_PUBLIC_ID_PREFIXES.concat([
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
]);

//Utils
function enquoteDoctypeId(id) {
    const quote = id.indexOf('"') !== -1 ? "'" : '"';

    return quote + id + quote;
}

function hasPrefix(publicId, prefixes) {
    for (let i = 0; i < prefixes.length; i++) {
        if (publicId.indexOf(prefixes[i]) === 0) {
            return true;
        }
    }

    return false;
}

//API
exports.isConforming = function(token) {
    return (
        token.name === VALID_DOCTYPE_NAME &&
        token.publicId === null &&
        (token.systemId === null || token.systemId === VALID_SYSTEM_ID)
    );
};

exports.getDocumentMode = function(token) {
    if (token.name !== VALID_DOCTYPE_NAME) {
        return DOCUMENT_MODE.QUIRKS;
    }

    const systemId = token.systemId;

    if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID) {
        return DOCUMENT_MODE.QUIRKS;
    }

    let publicId = token.publicId;

    if (publicId !== null) {
        publicId = publicId.toLowerCase();

        if (QUIRKS_MODE_PUBLIC_IDS.indexOf(publicId) > -1) {
            return DOCUMENT_MODE.QUIRKS;
        }

        let prefixes = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes)) {
            return DOCUMENT_MODE.QUIRKS;
        }

        prefixes =
            systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes)) {
            return DOCUMENT_MODE.LIMITED_QUIRKS;
        }
    }

    return DOCUMENT_MODE.NO_QUIRKS;
};

exports.serializeContent = function(name, publicId, systemId) {
    let str = '!DOCTYPE ';

    if (name) {
        str += name;
    }

    if (publicId) {
        str += ' PUBLIC ' + enquoteDoctypeId(publicId);
    } else if (systemId) {
        str += ' SYSTEM';
    }

    if (systemId !== null) {
        str += ' ' + enquoteDoctypeId(systemId);
    }

    return str;
};


/***/ }),

/***/ 84166:
/***/ (function(module) {

"use strict";


module.exports = {
    controlCharacterInInputStream: 'control-character-in-input-stream',
    noncharacterInInputStream: 'noncharacter-in-input-stream',
    surrogateInInputStream: 'surrogate-in-input-stream',
    nonVoidHtmlElementStartTagWithTrailingSolidus: 'non-void-html-element-start-tag-with-trailing-solidus',
    endTagWithAttributes: 'end-tag-with-attributes',
    endTagWithTrailingSolidus: 'end-tag-with-trailing-solidus',
    unexpectedSolidusInTag: 'unexpected-solidus-in-tag',
    unexpectedNullCharacter: 'unexpected-null-character',
    unexpectedQuestionMarkInsteadOfTagName: 'unexpected-question-mark-instead-of-tag-name',
    invalidFirstCharacterOfTagName: 'invalid-first-character-of-tag-name',
    unexpectedEqualsSignBeforeAttributeName: 'unexpected-equals-sign-before-attribute-name',
    missingEndTagName: 'missing-end-tag-name',
    unexpectedCharacterInAttributeName: 'unexpected-character-in-attribute-name',
    unknownNamedCharacterReference: 'unknown-named-character-reference',
    missingSemicolonAfterCharacterReference: 'missing-semicolon-after-character-reference',
    unexpectedCharacterAfterDoctypeSystemIdentifier: 'unexpected-character-after-doctype-system-identifier',
    unexpectedCharacterInUnquotedAttributeValue: 'unexpected-character-in-unquoted-attribute-value',
    eofBeforeTagName: 'eof-before-tag-name',
    eofInTag: 'eof-in-tag',
    missingAttributeValue: 'missing-attribute-value',
    missingWhitespaceBetweenAttributes: 'missing-whitespace-between-attributes',
    missingWhitespaceAfterDoctypePublicKeyword: 'missing-whitespace-after-doctype-public-keyword',
    missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers:
        'missing-whitespace-between-doctype-public-and-system-identifiers',
    missingWhitespaceAfterDoctypeSystemKeyword: 'missing-whitespace-after-doctype-system-keyword',
    missingQuoteBeforeDoctypePublicIdentifier: 'missing-quote-before-doctype-public-identifier',
    missingQuoteBeforeDoctypeSystemIdentifier: 'missing-quote-before-doctype-system-identifier',
    missingDoctypePublicIdentifier: 'missing-doctype-public-identifier',
    missingDoctypeSystemIdentifier: 'missing-doctype-system-identifier',
    abruptDoctypePublicIdentifier: 'abrupt-doctype-public-identifier',
    abruptDoctypeSystemIdentifier: 'abrupt-doctype-system-identifier',
    cdataInHtmlContent: 'cdata-in-html-content',
    incorrectlyOpenedComment: 'incorrectly-opened-comment',
    eofInScriptHtmlCommentLikeText: 'eof-in-script-html-comment-like-text',
    eofInDoctype: 'eof-in-doctype',
    nestedComment: 'nested-comment',
    abruptClosingOfEmptyComment: 'abrupt-closing-of-empty-comment',
    eofInComment: 'eof-in-comment',
    incorrectlyClosedComment: 'incorrectly-closed-comment',
    eofInCdata: 'eof-in-cdata',
    absenceOfDigitsInNumericCharacterReference: 'absence-of-digits-in-numeric-character-reference',
    nullCharacterReference: 'null-character-reference',
    surrogateCharacterReference: 'surrogate-character-reference',
    characterReferenceOutsideUnicodeRange: 'character-reference-outside-unicode-range',
    controlCharacterReference: 'control-character-reference',
    noncharacterCharacterReference: 'noncharacter-character-reference',
    missingWhitespaceBeforeDoctypeName: 'missing-whitespace-before-doctype-name',
    missingDoctypeName: 'missing-doctype-name',
    invalidCharacterSequenceAfterDoctypeName: 'invalid-character-sequence-after-doctype-name',
    duplicateAttribute: 'duplicate-attribute',
    nonConformingDoctype: 'non-conforming-doctype',
    missingDoctype: 'missing-doctype',
    misplacedDoctype: 'misplaced-doctype',
    endTagWithoutMatchingOpenElement: 'end-tag-without-matching-open-element',
    closingOfElementWithOpenChildElements: 'closing-of-element-with-open-child-elements',
    disallowedContentInNoscriptInHead: 'disallowed-content-in-noscript-in-head',
    openElementsLeftAfterEof: 'open-elements-left-after-eof',
    abandonedHeadElementChild: 'abandoned-head-element-child',
    misplacedStartTagForHeadElement: 'misplaced-start-tag-for-head-element',
    nestedNoscriptInHead: 'nested-noscript-in-head',
    eofInElementThatCanContainOnlyText: 'eof-in-element-that-can-contain-only-text'
};


/***/ }),

/***/ 11848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


const Tokenizer = __webpack_require__(19677);
const HTML = __webpack_require__(76256);

//Aliases
const $ = HTML.TAG_NAMES;
const NS = HTML.NAMESPACES;
const ATTRS = HTML.ATTRS;

//MIME types
const MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml'
};

//Attributes
const DEFINITION_URL_ATTR = 'definitionurl';
const ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL';
const SVG_ATTRS_ADJUSTMENT_MAP = {
    attributename: 'attributeName',
    attributetype: 'attributeType',
    basefrequency: 'baseFrequency',
    baseprofile: 'baseProfile',
    calcmode: 'calcMode',
    clippathunits: 'clipPathUnits',
    diffuseconstant: 'diffuseConstant',
    edgemode: 'edgeMode',
    filterunits: 'filterUnits',
    glyphref: 'glyphRef',
    gradienttransform: 'gradientTransform',
    gradientunits: 'gradientUnits',
    kernelmatrix: 'kernelMatrix',
    kernelunitlength: 'kernelUnitLength',
    keypoints: 'keyPoints',
    keysplines: 'keySplines',
    keytimes: 'keyTimes',
    lengthadjust: 'lengthAdjust',
    limitingconeangle: 'limitingConeAngle',
    markerheight: 'markerHeight',
    markerunits: 'markerUnits',
    markerwidth: 'markerWidth',
    maskcontentunits: 'maskContentUnits',
    maskunits: 'maskUnits',
    numoctaves: 'numOctaves',
    pathlength: 'pathLength',
    patterncontentunits: 'patternContentUnits',
    patterntransform: 'patternTransform',
    patternunits: 'patternUnits',
    pointsatx: 'pointsAtX',
    pointsaty: 'pointsAtY',
    pointsatz: 'pointsAtZ',
    preservealpha: 'preserveAlpha',
    preserveaspectratio: 'preserveAspectRatio',
    primitiveunits: 'primitiveUnits',
    refx: 'refX',
    refy: 'refY',
    repeatcount: 'repeatCount',
    repeatdur: 'repeatDur',
    requiredextensions: 'requiredExtensions',
    requiredfeatures: 'requiredFeatures',
    specularconstant: 'specularConstant',
    specularexponent: 'specularExponent',
    spreadmethod: 'spreadMethod',
    startoffset: 'startOffset',
    stddeviation: 'stdDeviation',
    stitchtiles: 'stitchTiles',
    surfacescale: 'surfaceScale',
    systemlanguage: 'systemLanguage',
    tablevalues: 'tableValues',
    targetx: 'targetX',
    targety: 'targetY',
    textlength: 'textLength',
    viewbox: 'viewBox',
    viewtarget: 'viewTarget',
    xchannelselector: 'xChannelSelector',
    ychannelselector: 'yChannelSelector',
    zoomandpan: 'zoomAndPan'
};

const XML_ATTRS_ADJUSTMENT_MAP = {
    'xlink:actuate': { prefix: 'xlink', name: 'actuate', namespace: NS.XLINK },
    'xlink:arcrole': { prefix: 'xlink', name: 'arcrole', namespace: NS.XLINK },
    'xlink:href': { prefix: 'xlink', name: 'href', namespace: NS.XLINK },
    'xlink:role': { prefix: 'xlink', name: 'role', namespace: NS.XLINK },
    'xlink:show': { prefix: 'xlink', name: 'show', namespace: NS.XLINK },
    'xlink:title': { prefix: 'xlink', name: 'title', namespace: NS.XLINK },
    'xlink:type': { prefix: 'xlink', name: 'type', namespace: NS.XLINK },
    'xml:base': { prefix: 'xml', name: 'base', namespace: NS.XML },
    'xml:lang': { prefix: 'xml', name: 'lang', namespace: NS.XML },
    'xml:space': { prefix: 'xml', name: 'space', namespace: NS.XML },
    xmlns: { prefix: '', name: 'xmlns', namespace: NS.XMLNS },
    'xmlns:xlink': { prefix: 'xmlns', name: 'xlink', namespace: NS.XMLNS }
};

//SVG tag names adjustment map
const SVG_TAG_NAMES_ADJUSTMENT_MAP = (exports.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
    altglyph: 'altGlyph',
    altglyphdef: 'altGlyphDef',
    altglyphitem: 'altGlyphItem',
    animatecolor: 'animateColor',
    animatemotion: 'animateMotion',
    animatetransform: 'animateTransform',
    clippath: 'clipPath',
    feblend: 'feBlend',
    fecolormatrix: 'feColorMatrix',
    fecomponenttransfer: 'feComponentTransfer',
    fecomposite: 'feComposite',
    feconvolvematrix: 'feConvolveMatrix',
    fediffuselighting: 'feDiffuseLighting',
    fedisplacementmap: 'feDisplacementMap',
    fedistantlight: 'feDistantLight',
    feflood: 'feFlood',
    fefunca: 'feFuncA',
    fefuncb: 'feFuncB',
    fefuncg: 'feFuncG',
    fefuncr: 'feFuncR',
    fegaussianblur: 'feGaussianBlur',
    feimage: 'feImage',
    femerge: 'feMerge',
    femergenode: 'feMergeNode',
    femorphology: 'feMorphology',
    feoffset: 'feOffset',
    fepointlight: 'fePointLight',
    fespecularlighting: 'feSpecularLighting',
    fespotlight: 'feSpotLight',
    fetile: 'feTile',
    feturbulence: 'feTurbulence',
    foreignobject: 'foreignObject',
    glyphref: 'glyphRef',
    lineargradient: 'linearGradient',
    radialgradient: 'radialGradient',
    textpath: 'textPath'
});

//Tags that causes exit from foreign content
const EXITS_FOREIGN_CONTENT = {
    [$.B]: true,
    [$.BIG]: true,
    [$.BLOCKQUOTE]: true,
    [$.BODY]: true,
    [$.BR]: true,
    [$.CENTER]: true,
    [$.CODE]: true,
    [$.DD]: true,
    [$.DIV]: true,
    [$.DL]: true,
    [$.DT]: true,
    [$.EM]: true,
    [$.EMBED]: true,
    [$.H1]: true,
    [$.H2]: true,
    [$.H3]: true,
    [$.H4]: true,
    [$.H5]: true,
    [$.H6]: true,
    [$.HEAD]: true,
    [$.HR]: true,
    [$.I]: true,
    [$.IMG]: true,
    [$.LI]: true,
    [$.LISTING]: true,
    [$.MENU]: true,
    [$.META]: true,
    [$.NOBR]: true,
    [$.OL]: true,
    [$.P]: true,
    [$.PRE]: true,
    [$.RUBY]: true,
    [$.S]: true,
    [$.SMALL]: true,
    [$.SPAN]: true,
    [$.STRONG]: true,
    [$.STRIKE]: true,
    [$.SUB]: true,
    [$.SUP]: true,
    [$.TABLE]: true,
    [$.TT]: true,
    [$.U]: true,
    [$.UL]: true,
    [$.VAR]: true
};

//Check exit from foreign content
exports.causesExit = function(startTagToken) {
    const tn = startTagToken.tagName;
    const isFontWithAttrs =
        tn === $.FONT &&
        (Tokenizer.getTokenAttr(startTagToken, ATTRS.COLOR) !== null ||
            Tokenizer.getTokenAttr(startTagToken, ATTRS.SIZE) !== null ||
            Tokenizer.getTokenAttr(startTagToken, ATTRS.FACE) !== null);

    return isFontWithAttrs ? true : EXITS_FOREIGN_CONTENT[tn];
};

//Token adjustments
exports.adjustTokenMathMLAttrs = function(token) {
    for (let i = 0; i < token.attrs.length; i++) {
        if (token.attrs[i].name === DEFINITION_URL_ATTR) {
            token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
            break;
        }
    }
};

exports.adjustTokenSVGAttrs = function(token) {
    for (let i = 0; i < token.attrs.length; i++) {
        const adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrName) {
            token.attrs[i].name = adjustedAttrName;
        }
    }
};

exports.adjustTokenXMLAttrs = function(token) {
    for (let i = 0; i < token.attrs.length; i++) {
        const adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
};

exports.adjustTokenSVGTagName = function(token) {
    const adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP[token.tagName];

    if (adjustedTagName) {
        token.tagName = adjustedTagName;
    }
};

//Integration points
function isMathMLTextIntegrationPoint(tn, ns) {
    return ns === NS.MATHML && (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS || tn === $.MTEXT);
}

function isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === NS.MATHML && tn === $.ANNOTATION_XML) {
        for (let i = 0; i < attrs.length; i++) {
            if (attrs[i].name === ATTRS.ENCODING) {
                const value = attrs[i].value.toLowerCase();

                return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
            }
        }
    }

    return ns === NS.SVG && (tn === $.FOREIGN_OBJECT || tn === $.DESC || tn === $.TITLE);
}

exports.isIntegrationPoint = function(tn, ns, attrs, foreignNS) {
    if ((!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs)) {
        return true;
    }

    if ((!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns)) {
        return true;
    }

    return false;
};


/***/ }),

/***/ 76256:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


const NS = (exports.NAMESPACES = {
    HTML: 'http://www.w3.org/1999/xhtml',
    MATHML: 'http://www.w3.org/1998/Math/MathML',
    SVG: 'http://www.w3.org/2000/svg',
    XLINK: 'http://www.w3.org/1999/xlink',
    XML: 'http://www.w3.org/XML/1998/namespace',
    XMLNS: 'http://www.w3.org/2000/xmlns/'
});

exports.ATTRS = {
    TYPE: 'type',
    ACTION: 'action',
    ENCODING: 'encoding',
    PROMPT: 'prompt',
    NAME: 'name',
    COLOR: 'color',
    FACE: 'face',
    SIZE: 'size'
};

exports.DOCUMENT_MODE = {
    NO_QUIRKS: 'no-quirks',
    QUIRKS: 'quirks',
    LIMITED_QUIRKS: 'limited-quirks'
};

const $ = (exports.TAG_NAMES = {
    A: 'a',
    ADDRESS: 'address',
    ANNOTATION_XML: 'annotation-xml',
    APPLET: 'applet',
    AREA: 'area',
    ARTICLE: 'article',
    ASIDE: 'aside',

    B: 'b',
    BASE: 'base',
    BASEFONT: 'basefont',
    BGSOUND: 'bgsound',
    BIG: 'big',
    BLOCKQUOTE: 'blockquote',
    BODY: 'body',
    BR: 'br',
    BUTTON: 'button',

    CAPTION: 'caption',
    CENTER: 'center',
    CODE: 'code',
    COL: 'col',
    COLGROUP: 'colgroup',

    DD: 'dd',
    DESC: 'desc',
    DETAILS: 'details',
    DIALOG: 'dialog',
    DIR: 'dir',
    DIV: 'div',
    DL: 'dl',
    DT: 'dt',

    EM: 'em',
    EMBED: 'embed',

    FIELDSET: 'fieldset',
    FIGCAPTION: 'figcaption',
    FIGURE: 'figure',
    FONT: 'font',
    FOOTER: 'footer',
    FOREIGN_OBJECT: 'foreignObject',
    FORM: 'form',
    FRAME: 'frame',
    FRAMESET: 'frameset',

    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
    HEAD: 'head',
    HEADER: 'header',
    HGROUP: 'hgroup',
    HR: 'hr',
    HTML: 'html',

    I: 'i',
    IMG: 'img',
    IMAGE: 'image',
    INPUT: 'input',
    IFRAME: 'iframe',

    KEYGEN: 'keygen',

    LABEL: 'label',
    LI: 'li',
    LINK: 'link',
    LISTING: 'listing',

    MAIN: 'main',
    MALIGNMARK: 'malignmark',
    MARQUEE: 'marquee',
    MATH: 'math',
    MENU: 'menu',
    META: 'meta',
    MGLYPH: 'mglyph',
    MI: 'mi',
    MO: 'mo',
    MN: 'mn',
    MS: 'ms',
    MTEXT: 'mtext',

    NAV: 'nav',
    NOBR: 'nobr',
    NOFRAMES: 'noframes',
    NOEMBED: 'noembed',
    NOSCRIPT: 'noscript',

    OBJECT: 'object',
    OL: 'ol',
    OPTGROUP: 'optgroup',
    OPTION: 'option',

    P: 'p',
    PARAM: 'param',
    PLAINTEXT: 'plaintext',
    PRE: 'pre',

    RB: 'rb',
    RP: 'rp',
    RT: 'rt',
    RTC: 'rtc',
    RUBY: 'ruby',

    S: 's',
    SCRIPT: 'script',
    SECTION: 'section',
    SELECT: 'select',
    SOURCE: 'source',
    SMALL: 'small',
    SPAN: 'span',
    STRIKE: 'strike',
    STRONG: 'strong',
    STYLE: 'style',
    SUB: 'sub',
    SUMMARY: 'summary',
    SUP: 'sup',

    TABLE: 'table',
    TBODY: 'tbody',
    TEMPLATE: 'template',
    TEXTAREA: 'textarea',
    TFOOT: 'tfoot',
    TD: 'td',
    TH: 'th',
    THEAD: 'thead',
    TITLE: 'title',
    TR: 'tr',
    TRACK: 'track',
    TT: 'tt',

    U: 'u',
    UL: 'ul',

    SVG: 'svg',

    VAR: 'var',

    WBR: 'wbr',

    XMP: 'xmp'
});

exports.SPECIAL_ELEMENTS = {
    [NS.HTML]: {
        [$.ADDRESS]: true,
        [$.APPLET]: true,
        [$.AREA]: true,
        [$.ARTICLE]: true,
        [$.ASIDE]: true,
        [$.BASE]: true,
        [$.BASEFONT]: true,
        [$.BGSOUND]: true,
        [$.BLOCKQUOTE]: true,
        [$.BODY]: true,
        [$.BR]: true,
        [$.BUTTON]: true,
        [$.CAPTION]: true,
        [$.CENTER]: true,
        [$.COL]: true,
        [$.COLGROUP]: true,
        [$.DD]: true,
        [$.DETAILS]: true,
        [$.DIR]: true,
        [$.DIV]: true,
        [$.DL]: true,
        [$.DT]: true,
        [$.EMBED]: true,
        [$.FIELDSET]: true,
        [$.FIGCAPTION]: true,
        [$.FIGURE]: true,
        [$.FOOTER]: true,
        [$.FORM]: true,
        [$.FRAME]: true,
        [$.FRAMESET]: true,
        [$.H1]: true,
        [$.H2]: true,
        [$.H3]: true,
        [$.H4]: true,
        [$.H5]: true,
        [$.H6]: true,
        [$.HEAD]: true,
        [$.HEADER]: true,
        [$.HGROUP]: true,
        [$.HR]: true,
        [$.HTML]: true,
        [$.IFRAME]: true,
        [$.IMG]: true,
        [$.INPUT]: true,
        [$.LI]: true,
        [$.LINK]: true,
        [$.LISTING]: true,
        [$.MAIN]: true,
        [$.MARQUEE]: true,
        [$.MENU]: true,
        [$.META]: true,
        [$.NAV]: true,
        [$.NOEMBED]: true,
        [$.NOFRAMES]: true,
        [$.NOSCRIPT]: true,
        [$.OBJECT]: true,
        [$.OL]: true,
        [$.P]: true,
        [$.PARAM]: true,
        [$.PLAINTEXT]: true,
        [$.PRE]: true,
        [$.SCRIPT]: true,
        [$.SECTION]: true,
        [$.SELECT]: true,
        [$.SOURCE]: true,
        [$.STYLE]: true,
        [$.SUMMARY]: true,
        [$.TABLE]: true,
        [$.TBODY]: true,
        [$.TD]: true,
        [$.TEMPLATE]: true,
        [$.TEXTAREA]: true,
        [$.TFOOT]: true,
        [$.TH]: true,
        [$.THEAD]: true,
        [$.TITLE]: true,
        [$.TR]: true,
        [$.TRACK]: true,
        [$.UL]: true,
        [$.WBR]: true,
        [$.XMP]: true
    },
    [NS.MATHML]: {
        [$.MI]: true,
        [$.MO]: true,
        [$.MN]: true,
        [$.MS]: true,
        [$.MTEXT]: true,
        [$.ANNOTATION_XML]: true
    },
    [NS.SVG]: {
        [$.TITLE]: true,
        [$.FOREIGN_OBJECT]: true,
        [$.DESC]: true
    }
};


/***/ }),

/***/ 3749:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


const UNDEFINED_CODE_POINTS = [
    0xfffe,
    0xffff,
    0x1fffe,
    0x1ffff,
    0x2fffe,
    0x2ffff,
    0x3fffe,
    0x3ffff,
    0x4fffe,
    0x4ffff,
    0x5fffe,
    0x5ffff,
    0x6fffe,
    0x6ffff,
    0x7fffe,
    0x7ffff,
    0x8fffe,
    0x8ffff,
    0x9fffe,
    0x9ffff,
    0xafffe,
    0xaffff,
    0xbfffe,
    0xbffff,
    0xcfffe,
    0xcffff,
    0xdfffe,
    0xdffff,
    0xefffe,
    0xeffff,
    0xffffe,
    0xfffff,
    0x10fffe,
    0x10ffff
];

exports.REPLACEMENT_CHARACTER = '\uFFFD';

exports.CODE_POINTS = {
    EOF: -1,
    NULL: 0x00,
    TABULATION: 0x09,
    CARRIAGE_RETURN: 0x0d,
    LINE_FEED: 0x0a,
    FORM_FEED: 0x0c,
    SPACE: 0x20,
    EXCLAMATION_MARK: 0x21,
    QUOTATION_MARK: 0x22,
    NUMBER_SIGN: 0x23,
    AMPERSAND: 0x26,
    APOSTROPHE: 0x27,
    HYPHEN_MINUS: 0x2d,
    SOLIDUS: 0x2f,
    DIGIT_0: 0x30,
    DIGIT_9: 0x39,
    SEMICOLON: 0x3b,
    LESS_THAN_SIGN: 0x3c,
    EQUALS_SIGN: 0x3d,
    GREATER_THAN_SIGN: 0x3e,
    QUESTION_MARK: 0x3f,
    LATIN_CAPITAL_A: 0x41,
    LATIN_CAPITAL_F: 0x46,
    LATIN_CAPITAL_X: 0x58,
    LATIN_CAPITAL_Z: 0x5a,
    RIGHT_SQUARE_BRACKET: 0x5d,
    GRAVE_ACCENT: 0x60,
    LATIN_SMALL_A: 0x61,
    LATIN_SMALL_F: 0x66,
    LATIN_SMALL_X: 0x78,
    LATIN_SMALL_Z: 0x7a,
    REPLACEMENT_CHARACTER: 0xfffd
};

exports.CODE_POINT_SEQUENCES = {
    DASH_DASH_STRING: [0x2d, 0x2d], //--
    DOCTYPE_STRING: [0x44, 0x4f, 0x43, 0x54, 0x59, 0x50, 0x45], //DOCTYPE
    CDATA_START_STRING: [0x5b, 0x43, 0x44, 0x41, 0x54, 0x41, 0x5b], //[CDATA[
    SCRIPT_STRING: [0x73, 0x63, 0x72, 0x69, 0x70, 0x74], //script
    PUBLIC_STRING: [0x50, 0x55, 0x42, 0x4c, 0x49, 0x43], //PUBLIC
    SYSTEM_STRING: [0x53, 0x59, 0x53, 0x54, 0x45, 0x4d] //SYSTEM
};

//Surrogates
exports.isSurrogate = function(cp) {
    return cp >= 0xd800 && cp <= 0xdfff;
};

exports.isSurrogatePair = function(cp) {
    return cp >= 0xdc00 && cp <= 0xdfff;
};

exports.getSurrogatePairCodePoint = function(cp1, cp2) {
    return (cp1 - 0xd800) * 0x400 + 0x2400 + cp2;
};

//NOTE: excluding NULL and ASCII whitespace
exports.isControlCodePoint = function(cp) {
    return (
        (cp !== 0x20 && cp !== 0x0a && cp !== 0x0d && cp !== 0x09 && cp !== 0x0c && cp >= 0x01 && cp <= 0x1f) ||
        (cp >= 0x7f && cp <= 0x9f)
    );
};

exports.isUndefinedCodePoint = function(cp) {
    return (cp >= 0xfdd0 && cp <= 0xfdef) || UNDEFINED_CODE_POINTS.indexOf(cp) > -1;
};


/***/ }),

/***/ 98067:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Mixin = __webpack_require__(44315);

class ErrorReportingMixinBase extends Mixin {
    constructor(host, opts) {
        super(host);

        this.posTracker = null;
        this.onParseError = opts.onParseError;
    }

    _setErrorLocation(err) {
        err.startLine = err.endLine = this.posTracker.line;
        err.startCol = err.endCol = this.posTracker.col;
        err.startOffset = err.endOffset = this.posTracker.offset;
    }

    _reportError(code) {
        const err = {
            code: code,
            startLine: -1,
            startCol: -1,
            startOffset: -1,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };

        this._setErrorLocation(err);
        this.onParseError(err);
    }

    _getOverriddenMethods(mxn) {
        return {
            _err(code) {
                mxn._reportError(code);
            }
        };
    }
}

module.exports = ErrorReportingMixinBase;


/***/ }),

/***/ 986:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const ErrorReportingMixinBase = __webpack_require__(98067);
const ErrorReportingTokenizerMixin = __webpack_require__(60139);
const LocationInfoTokenizerMixin = __webpack_require__(3182);
const Mixin = __webpack_require__(44315);

class ErrorReportingParserMixin extends ErrorReportingMixinBase {
    constructor(parser, opts) {
        super(parser, opts);

        this.opts = opts;
        this.ctLoc = null;
        this.locBeforeToken = false;
    }

    _setErrorLocation(err) {
        if (this.ctLoc) {
            err.startLine = this.ctLoc.startLine;
            err.startCol = this.ctLoc.startCol;
            err.startOffset = this.ctLoc.startOffset;

            err.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine;
            err.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol;
            err.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset;
        }
    }

    _getOverriddenMethods(mxn, orig) {
        return {
            _bootstrap(document, fragmentContext) {
                orig._bootstrap.call(this, document, fragmentContext);

                Mixin.install(this.tokenizer, ErrorReportingTokenizerMixin, mxn.opts);
                Mixin.install(this.tokenizer, LocationInfoTokenizerMixin);
            },

            _processInputToken(token) {
                mxn.ctLoc = token.location;

                orig._processInputToken.call(this, token);
            },

            _err(code, options) {
                mxn.locBeforeToken = options && options.beforeToken;
                mxn._reportError(code);
            }
        };
    }
}

module.exports = ErrorReportingParserMixin;


/***/ }),

/***/ 68175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const ErrorReportingMixinBase = __webpack_require__(98067);
const PositionTrackingPreprocessorMixin = __webpack_require__(97046);
const Mixin = __webpack_require__(44315);

class ErrorReportingPreprocessorMixin extends ErrorReportingMixinBase {
    constructor(preprocessor, opts) {
        super(preprocessor, opts);

        this.posTracker = Mixin.install(preprocessor, PositionTrackingPreprocessorMixin);
        this.lastErrOffset = -1;
    }

    _reportError(code) {
        //NOTE: avoid reporting error twice on advance/retreat
        if (this.lastErrOffset !== this.posTracker.offset) {
            this.lastErrOffset = this.posTracker.offset;
            super._reportError(code);
        }
    }
}

module.exports = ErrorReportingPreprocessorMixin;


/***/ }),

/***/ 60139:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const ErrorReportingMixinBase = __webpack_require__(98067);
const ErrorReportingPreprocessorMixin = __webpack_require__(68175);
const Mixin = __webpack_require__(44315);

class ErrorReportingTokenizerMixin extends ErrorReportingMixinBase {
    constructor(tokenizer, opts) {
        super(tokenizer, opts);

        const preprocessorMixin = Mixin.install(tokenizer.preprocessor, ErrorReportingPreprocessorMixin, opts);

        this.posTracker = preprocessorMixin.posTracker;
    }
}

module.exports = ErrorReportingTokenizerMixin;


/***/ }),

/***/ 38945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Mixin = __webpack_require__(44315);

class LocationInfoOpenElementStackMixin extends Mixin {
    constructor(stack, opts) {
        super(stack);

        this.onItemPop = opts.onItemPop;
    }

    _getOverriddenMethods(mxn, orig) {
        return {
            pop() {
                mxn.onItemPop(this.current);
                orig.pop.call(this);
            },

            popAllUpToHtmlElement() {
                for (let i = this.stackTop; i > 0; i--) {
                    mxn.onItemPop(this.items[i]);
                }

                orig.popAllUpToHtmlElement.call(this);
            },

            remove(element) {
                mxn.onItemPop(this.current);
                orig.remove.call(this, element);
            }
        };
    }
}

module.exports = LocationInfoOpenElementStackMixin;


/***/ }),

/***/ 3738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Mixin = __webpack_require__(44315);
const Tokenizer = __webpack_require__(19677);
const LocationInfoTokenizerMixin = __webpack_require__(3182);
const LocationInfoOpenElementStackMixin = __webpack_require__(38945);
const HTML = __webpack_require__(76256);

//Aliases
const $ = HTML.TAG_NAMES;

class LocationInfoParserMixin extends Mixin {
    constructor(parser) {
        super(parser);

        this.parser = parser;
        this.treeAdapter = this.parser.treeAdapter;
        this.posTracker = null;
        this.lastStartTagToken = null;
        this.lastFosterParentingLocation = null;
        this.currentToken = null;
    }

    _setStartLocation(element) {
        let loc = null;

        if (this.lastStartTagToken) {
            loc = Object.assign({}, this.lastStartTagToken.location);
            loc.startTag = this.lastStartTagToken.location;
        }

        this.treeAdapter.setNodeSourceCodeLocation(element, loc);
    }

    _setEndLocation(element, closingToken) {
        const loc = this.treeAdapter.getNodeSourceCodeLocation(element);

        if (loc) {
            if (closingToken.location) {
                const ctLoc = closingToken.location;
                const tn = this.treeAdapter.getTagName(element);

                // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
                // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
                const isClosingEndTag = closingToken.type === Tokenizer.END_TAG_TOKEN && tn === closingToken.tagName;
                const endLoc = {};
                if (isClosingEndTag) {
                    endLoc.endTag = Object.assign({}, ctLoc);
                    endLoc.endLine = ctLoc.endLine;
                    endLoc.endCol = ctLoc.endCol;
                    endLoc.endOffset = ctLoc.endOffset;
                } else {
                    endLoc.endLine = ctLoc.startLine;
                    endLoc.endCol = ctLoc.startCol;
                    endLoc.endOffset = ctLoc.startOffset;
                }

                this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
            }
        }
    }

    _getOverriddenMethods(mxn, orig) {
        return {
            _bootstrap(document, fragmentContext) {
                orig._bootstrap.call(this, document, fragmentContext);

                mxn.lastStartTagToken = null;
                mxn.lastFosterParentingLocation = null;
                mxn.currentToken = null;

                const tokenizerMixin = Mixin.install(this.tokenizer, LocationInfoTokenizerMixin);

                mxn.posTracker = tokenizerMixin.posTracker;

                Mixin.install(this.openElements, LocationInfoOpenElementStackMixin, {
                    onItemPop: function(element) {
                        mxn._setEndLocation(element, mxn.currentToken);
                    }
                });
            },

            _runParsingLoop(scriptHandler) {
                orig._runParsingLoop.call(this, scriptHandler);

                // NOTE: generate location info for elements
                // that remains on open element stack
                for (let i = this.openElements.stackTop; i >= 0; i--) {
                    mxn._setEndLocation(this.openElements.items[i], mxn.currentToken);
                }
            },

            //Token processing
            _processTokenInForeignContent(token) {
                mxn.currentToken = token;
                orig._processTokenInForeignContent.call(this, token);
            },

            _processToken(token) {
                mxn.currentToken = token;
                orig._processToken.call(this, token);

                //NOTE: <body> and <html> are never popped from the stack, so we need to updated
                //their end location explicitly.
                const requireExplicitUpdate =
                    token.type === Tokenizer.END_TAG_TOKEN &&
                    (token.tagName === $.HTML || (token.tagName === $.BODY && this.openElements.hasInScope($.BODY)));

                if (requireExplicitUpdate) {
                    for (let i = this.openElements.stackTop; i >= 0; i--) {
                        const element = this.openElements.items[i];

                        if (this.treeAdapter.getTagName(element) === token.tagName) {
                            mxn._setEndLocation(element, token);
                            break;
                        }
                    }
                }
            },

            //Doctype
            _setDocumentType(token) {
                orig._setDocumentType.call(this, token);

                const documentChildren = this.treeAdapter.getChildNodes(this.document);
                const cnLength = documentChildren.length;

                for (let i = 0; i < cnLength; i++) {
                    const node = documentChildren[i];

                    if (this.treeAdapter.isDocumentTypeNode(node)) {
                        this.treeAdapter.setNodeSourceCodeLocation(node, token.location);
                        break;
                    }
                }
            },

            //Elements
            _attachElementToTree(element) {
                //NOTE: _attachElementToTree is called from _appendElement, _insertElement and _insertTemplate methods.
                //So we will use token location stored in this methods for the element.
                mxn._setStartLocation(element);
                mxn.lastStartTagToken = null;
                orig._attachElementToTree.call(this, element);
            },

            _appendElement(token, namespaceURI) {
                mxn.lastStartTagToken = token;
                orig._appendElement.call(this, token, namespaceURI);
            },

            _insertElement(token, namespaceURI) {
                mxn.lastStartTagToken = token;
                orig._insertElement.call(this, token, namespaceURI);
            },

            _insertTemplate(token) {
                mxn.lastStartTagToken = token;
                orig._insertTemplate.call(this, token);

                const tmplContent = this.treeAdapter.getTemplateContent(this.openElements.current);

                this.treeAdapter.setNodeSourceCodeLocation(tmplContent, null);
            },

            _insertFakeRootElement() {
                orig._insertFakeRootElement.call(this);
                this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
            },

            //Comments
            _appendCommentNode(token, parent) {
                orig._appendCommentNode.call(this, token, parent);

                const children = this.treeAdapter.getChildNodes(parent);
                const commentNode = children[children.length - 1];

                this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
            },

            //Text
            _findFosterParentingLocation() {
                //NOTE: store last foster parenting location, so we will be able to find inserted text
                //in case of foster parenting
                mxn.lastFosterParentingLocation = orig._findFosterParentingLocation.call(this);

                return mxn.lastFosterParentingLocation;
            },

            _insertCharacters(token) {
                orig._insertCharacters.call(this, token);

                const hasFosterParent = this._shouldFosterParentOnInsertion();

                const parent =
                    (hasFosterParent && mxn.lastFosterParentingLocation.parent) ||
                    this.openElements.currentTmplContent ||
                    this.openElements.current;

                const siblings = this.treeAdapter.getChildNodes(parent);

                const textNodeIdx =
                    hasFosterParent && mxn.lastFosterParentingLocation.beforeElement
                        ? siblings.indexOf(mxn.lastFosterParentingLocation.beforeElement) - 1
                        : siblings.length - 1;

                const textNode = siblings[textNodeIdx];

                //NOTE: if we have location assigned by another token, then just update end position
                const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);

                if (tnLoc) {
                    const { endLine, endCol, endOffset } = token.location;
                    this.treeAdapter.updateNodeSourceCodeLocation(textNode, { endLine, endCol, endOffset });
                } else {
                    this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
                }
            }
        };
    }
}

module.exports = LocationInfoParserMixin;


/***/ }),

/***/ 3182:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Mixin = __webpack_require__(44315);
const Tokenizer = __webpack_require__(19677);
const PositionTrackingPreprocessorMixin = __webpack_require__(97046);

class LocationInfoTokenizerMixin extends Mixin {
    constructor(tokenizer) {
        super(tokenizer);

        this.tokenizer = tokenizer;
        this.posTracker = Mixin.install(tokenizer.preprocessor, PositionTrackingPreprocessorMixin);
        this.currentAttrLocation = null;
        this.ctLoc = null;
    }

    _getCurrentLocation() {
        return {
            startLine: this.posTracker.line,
            startCol: this.posTracker.col,
            startOffset: this.posTracker.offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
    }

    _attachCurrentAttrLocationInfo() {
        this.currentAttrLocation.endLine = this.posTracker.line;
        this.currentAttrLocation.endCol = this.posTracker.col;
        this.currentAttrLocation.endOffset = this.posTracker.offset;

        const currentToken = this.tokenizer.currentToken;
        const currentAttr = this.tokenizer.currentAttr;

        if (!currentToken.location.attrs) {
            currentToken.location.attrs = Object.create(null);
        }

        currentToken.location.attrs[currentAttr.name] = this.currentAttrLocation;
    }

    _getOverriddenMethods(mxn, orig) {
        const methods = {
            _createStartTagToken() {
                orig._createStartTagToken.call(this);
                this.currentToken.location = mxn.ctLoc;
            },

            _createEndTagToken() {
                orig._createEndTagToken.call(this);
                this.currentToken.location = mxn.ctLoc;
            },

            _createCommentToken() {
                orig._createCommentToken.call(this);
                this.currentToken.location = mxn.ctLoc;
            },

            _createDoctypeToken(initialName) {
                orig._createDoctypeToken.call(this, initialName);
                this.currentToken.location = mxn.ctLoc;
            },

            _createCharacterToken(type, ch) {
                orig._createCharacterToken.call(this, type, ch);
                this.currentCharacterToken.location = mxn.ctLoc;
            },

            _createEOFToken() {
                orig._createEOFToken.call(this);
                this.currentToken.location = mxn._getCurrentLocation();
            },

            _createAttr(attrNameFirstCh) {
                orig._createAttr.call(this, attrNameFirstCh);
                mxn.currentAttrLocation = mxn._getCurrentLocation();
            },

            _leaveAttrName(toState) {
                orig._leaveAttrName.call(this, toState);
                mxn._attachCurrentAttrLocationInfo();
            },

            _leaveAttrValue(toState) {
                orig._leaveAttrValue.call(this, toState);
                mxn._attachCurrentAttrLocationInfo();
            },

            _emitCurrentToken() {
                const ctLoc = this.currentToken.location;

                //NOTE: if we have pending character token make it's end location equal to the
                //current token's start location.
                if (this.currentCharacterToken) {
                    this.currentCharacterToken.location.endLine = ctLoc.startLine;
                    this.currentCharacterToken.location.endCol = ctLoc.startCol;
                    this.currentCharacterToken.location.endOffset = ctLoc.startOffset;
                }

                if (this.currentToken.type === Tokenizer.EOF_TOKEN) {
                    ctLoc.endLine = ctLoc.startLine;
                    ctLoc.endCol = ctLoc.startCol;
                    ctLoc.endOffset = ctLoc.startOffset;
                } else {
                    ctLoc.endLine = mxn.posTracker.line;
                    ctLoc.endCol = mxn.posTracker.col + 1;
                    ctLoc.endOffset = mxn.posTracker.offset + 1;
                }

                orig._emitCurrentToken.call(this);
            },

            _emitCurrentCharacterToken() {
                const ctLoc = this.currentCharacterToken && this.currentCharacterToken.location;

                //NOTE: if we have character token and it's location wasn't set in the _emitCurrentToken(),
                //then set it's location at the current preprocessor position.
                //We don't need to increment preprocessor position, since character token
                //emission is always forced by the start of the next character token here.
                //So, we already have advanced position.
                if (ctLoc && ctLoc.endOffset === -1) {
                    ctLoc.endLine = mxn.posTracker.line;
                    ctLoc.endCol = mxn.posTracker.col;
                    ctLoc.endOffset = mxn.posTracker.offset;
                }

                orig._emitCurrentCharacterToken.call(this);
            }
        };

        //NOTE: patch initial states for each mode to obtain token start position
        Object.keys(Tokenizer.MODE).forEach(modeName => {
            const state = Tokenizer.MODE[modeName];

            methods[state] = function(cp) {
                mxn.ctLoc = mxn._getCurrentLocation();
                orig[state].call(this, cp);
            };
        });

        return methods;
    }
}

module.exports = LocationInfoTokenizerMixin;


/***/ }),

/***/ 97046:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Mixin = __webpack_require__(44315);

class PositionTrackingPreprocessorMixin extends Mixin {
    constructor(preprocessor) {
        super(preprocessor);

        this.preprocessor = preprocessor;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;

        this.offset = 0;
        this.col = 0;
        this.line = 1;
    }

    _getOverriddenMethods(mxn, orig) {
        return {
            advance() {
                const pos = this.pos + 1;
                const ch = this.html[pos];

                //NOTE: LF should be in the last column of the line
                if (mxn.isEol) {
                    mxn.isEol = false;
                    mxn.line++;
                    mxn.lineStartPos = pos;
                }

                if (ch === '\n' || (ch === '\r' && this.html[pos + 1] !== '\n')) {
                    mxn.isEol = true;
                }

                mxn.col = pos - mxn.lineStartPos + 1;
                mxn.offset = mxn.droppedBufferSize + pos;

                return orig.advance.call(this);
            },

            retreat() {
                orig.retreat.call(this);

                mxn.isEol = false;
                mxn.col = this.pos - mxn.lineStartPos + 1;
            },

            dropParsedChunk() {
                const prevPos = this.pos;

                orig.dropParsedChunk.call(this);

                const reduction = prevPos - this.pos;

                mxn.lineStartPos -= reduction;
                mxn.droppedBufferSize += reduction;
                mxn.offset = mxn.droppedBufferSize + this.pos;
            }
        };
    }
}

module.exports = PositionTrackingPreprocessorMixin;


/***/ }),

/***/ 72020:
/***/ (function(module) {

"use strict";


//Const
const NOAH_ARK_CAPACITY = 3;

//List of formatting elements
class FormattingElementList {
    constructor(treeAdapter) {
        this.length = 0;
        this.entries = [];
        this.treeAdapter = treeAdapter;
        this.bookmark = null;
    }

    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(newElement) {
        const candidates = [];

        if (this.length >= NOAH_ARK_CAPACITY) {
            const neAttrsLength = this.treeAdapter.getAttrList(newElement).length;
            const neTagName = this.treeAdapter.getTagName(newElement);
            const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);

            for (let i = this.length - 1; i >= 0; i--) {
                const entry = this.entries[i];

                if (entry.type === FormattingElementList.MARKER_ENTRY) {
                    break;
                }

                const element = entry.element;
                const elementAttrs = this.treeAdapter.getAttrList(element);

                const isCandidate =
                    this.treeAdapter.getTagName(element) === neTagName &&
                    this.treeAdapter.getNamespaceURI(element) === neNamespaceURI &&
                    elementAttrs.length === neAttrsLength;

                if (isCandidate) {
                    candidates.push({ idx: i, attrs: elementAttrs });
                }
            }
        }

        return candidates.length < NOAH_ARK_CAPACITY ? [] : candidates;
    }

    _ensureNoahArkCondition(newElement) {
        const candidates = this._getNoahArkConditionCandidates(newElement);
        let cLength = candidates.length;

        if (cLength) {
            const neAttrs = this.treeAdapter.getAttrList(newElement);
            const neAttrsLength = neAttrs.length;
            const neAttrsMap = Object.create(null);

            //NOTE: build attrs map for the new element so we can perform fast lookups
            for (let i = 0; i < neAttrsLength; i++) {
                const neAttr = neAttrs[i];

                neAttrsMap[neAttr.name] = neAttr.value;
            }

            for (let i = 0; i < neAttrsLength; i++) {
                for (let j = 0; j < cLength; j++) {
                    const cAttr = candidates[j].attrs[i];

                    if (neAttrsMap[cAttr.name] !== cAttr.value) {
                        candidates.splice(j, 1);
                        cLength--;
                    }

                    if (candidates.length < NOAH_ARK_CAPACITY) {
                        return;
                    }
                }
            }

            //NOTE: remove bottommost candidates until Noah's Ark condition will not be met
            for (let i = cLength - 1; i >= NOAH_ARK_CAPACITY - 1; i--) {
                this.entries.splice(candidates[i].idx, 1);
                this.length--;
            }
        }
    }

    //Mutations
    insertMarker() {
        this.entries.push({ type: FormattingElementList.MARKER_ENTRY });
        this.length++;
    }

    pushElement(element, token) {
        this._ensureNoahArkCondition(element);

        this.entries.push({
            type: FormattingElementList.ELEMENT_ENTRY,
            element: element,
            token: token
        });

        this.length++;
    }

    insertElementAfterBookmark(element, token) {
        let bookmarkIdx = this.length - 1;

        for (; bookmarkIdx >= 0; bookmarkIdx--) {
            if (this.entries[bookmarkIdx] === this.bookmark) {
                break;
            }
        }

        this.entries.splice(bookmarkIdx + 1, 0, {
            type: FormattingElementList.ELEMENT_ENTRY,
            element: element,
            token: token
        });

        this.length++;
    }

    removeEntry(entry) {
        for (let i = this.length - 1; i >= 0; i--) {
            if (this.entries[i] === entry) {
                this.entries.splice(i, 1);
                this.length--;
                break;
            }
        }
    }

    clearToLastMarker() {
        while (this.length) {
            const entry = this.entries.pop();

            this.length--;

            if (entry.type === FormattingElementList.MARKER_ENTRY) {
                break;
            }
        }
    }

    //Search
    getElementEntryInScopeWithTagName(tagName) {
        for (let i = this.length - 1; i >= 0; i--) {
            const entry = this.entries[i];

            if (entry.type === FormattingElementList.MARKER_ENTRY) {
                return null;
            }

            if (this.treeAdapter.getTagName(entry.element) === tagName) {
                return entry;
            }
        }

        return null;
    }

    getElementEntry(element) {
        for (let i = this.length - 1; i >= 0; i--) {
            const entry = this.entries[i];

            if (entry.type === FormattingElementList.ELEMENT_ENTRY && entry.element === element) {
                return entry;
            }
        }

        return null;
    }
}

//Entry types
FormattingElementList.MARKER_ENTRY = 'MARKER_ENTRY';
FormattingElementList.ELEMENT_ENTRY = 'ELEMENT_ENTRY';

module.exports = FormattingElementList;


/***/ }),

/***/ 66056:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Tokenizer = __webpack_require__(19677);
const OpenElementStack = __webpack_require__(24939);
const FormattingElementList = __webpack_require__(72020);
const LocationInfoParserMixin = __webpack_require__(3738);
const ErrorReportingParserMixin = __webpack_require__(986);
const Mixin = __webpack_require__(44315);
const defaultTreeAdapter = __webpack_require__(13408);
const mergeOptions = __webpack_require__(96399);
const doctype = __webpack_require__(75323);
const foreignContent = __webpack_require__(11848);
const ERR = __webpack_require__(84166);
const unicode = __webpack_require__(3749);
const HTML = __webpack_require__(76256);

//Aliases
const $ = HTML.TAG_NAMES;
const NS = HTML.NAMESPACES;
const ATTRS = HTML.ATTRS;

const DEFAULT_OPTIONS = {
    scriptingEnabled: true,
    sourceCodeLocationInfo: false,
    onParseError: null,
    treeAdapter: defaultTreeAdapter
};

//Misc constants
const HIDDEN_INPUT_TYPE = 'hidden';

//Adoption agency loops iteration count
const AA_OUTER_LOOP_ITER = 8;
const AA_INNER_LOOP_ITER = 3;

//Insertion modes
const INITIAL_MODE = 'INITIAL_MODE';
const BEFORE_HTML_MODE = 'BEFORE_HTML_MODE';
const BEFORE_HEAD_MODE = 'BEFORE_HEAD_MODE';
const IN_HEAD_MODE = 'IN_HEAD_MODE';
const IN_HEAD_NO_SCRIPT_MODE = 'IN_HEAD_NO_SCRIPT_MODE';
const AFTER_HEAD_MODE = 'AFTER_HEAD_MODE';
const IN_BODY_MODE = 'IN_BODY_MODE';
const TEXT_MODE = 'TEXT_MODE';
const IN_TABLE_MODE = 'IN_TABLE_MODE';
const IN_TABLE_TEXT_MODE = 'IN_TABLE_TEXT_MODE';
const IN_CAPTION_MODE = 'IN_CAPTION_MODE';
const IN_COLUMN_GROUP_MODE = 'IN_COLUMN_GROUP_MODE';
const IN_TABLE_BODY_MODE = 'IN_TABLE_BODY_MODE';
const IN_ROW_MODE = 'IN_ROW_MODE';
const IN_CELL_MODE = 'IN_CELL_MODE';
const IN_SELECT_MODE = 'IN_SELECT_MODE';
const IN_SELECT_IN_TABLE_MODE = 'IN_SELECT_IN_TABLE_MODE';
const IN_TEMPLATE_MODE = 'IN_TEMPLATE_MODE';
const AFTER_BODY_MODE = 'AFTER_BODY_MODE';
const IN_FRAMESET_MODE = 'IN_FRAMESET_MODE';
const AFTER_FRAMESET_MODE = 'AFTER_FRAMESET_MODE';
const AFTER_AFTER_BODY_MODE = 'AFTER_AFTER_BODY_MODE';
const AFTER_AFTER_FRAMESET_MODE = 'AFTER_AFTER_FRAMESET_MODE';

//Insertion mode reset map
const INSERTION_MODE_RESET_MAP = {
    [$.TR]: IN_ROW_MODE,
    [$.TBODY]: IN_TABLE_BODY_MODE,
    [$.THEAD]: IN_TABLE_BODY_MODE,
    [$.TFOOT]: IN_TABLE_BODY_MODE,
    [$.CAPTION]: IN_CAPTION_MODE,
    [$.COLGROUP]: IN_COLUMN_GROUP_MODE,
    [$.TABLE]: IN_TABLE_MODE,
    [$.BODY]: IN_BODY_MODE,
    [$.FRAMESET]: IN_FRAMESET_MODE
};

//Template insertion mode switch map
const TEMPLATE_INSERTION_MODE_SWITCH_MAP = {
    [$.CAPTION]: IN_TABLE_MODE,
    [$.COLGROUP]: IN_TABLE_MODE,
    [$.TBODY]: IN_TABLE_MODE,
    [$.TFOOT]: IN_TABLE_MODE,
    [$.THEAD]: IN_TABLE_MODE,
    [$.COL]: IN_COLUMN_GROUP_MODE,
    [$.TR]: IN_TABLE_BODY_MODE,
    [$.TD]: IN_ROW_MODE,
    [$.TH]: IN_ROW_MODE
};

//Token handlers map for insertion modes
const TOKEN_HANDLERS = {
    [INITIAL_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenInInitialMode,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenInInitialMode,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: doctypeInInitialMode,
        [Tokenizer.START_TAG_TOKEN]: tokenInInitialMode,
        [Tokenizer.END_TAG_TOKEN]: tokenInInitialMode,
        [Tokenizer.EOF_TOKEN]: tokenInInitialMode
    },
    [BEFORE_HTML_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenBeforeHtml,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenBeforeHtml,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagBeforeHtml,
        [Tokenizer.END_TAG_TOKEN]: endTagBeforeHtml,
        [Tokenizer.EOF_TOKEN]: tokenBeforeHtml
    },
    [BEFORE_HEAD_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenBeforeHead,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenBeforeHead,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: misplacedDoctype,
        [Tokenizer.START_TAG_TOKEN]: startTagBeforeHead,
        [Tokenizer.END_TAG_TOKEN]: endTagBeforeHead,
        [Tokenizer.EOF_TOKEN]: tokenBeforeHead
    },
    [IN_HEAD_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenInHead,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenInHead,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: misplacedDoctype,
        [Tokenizer.START_TAG_TOKEN]: startTagInHead,
        [Tokenizer.END_TAG_TOKEN]: endTagInHead,
        [Tokenizer.EOF_TOKEN]: tokenInHead
    },
    [IN_HEAD_NO_SCRIPT_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenInHeadNoScript,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenInHeadNoScript,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: misplacedDoctype,
        [Tokenizer.START_TAG_TOKEN]: startTagInHeadNoScript,
        [Tokenizer.END_TAG_TOKEN]: endTagInHeadNoScript,
        [Tokenizer.EOF_TOKEN]: tokenInHeadNoScript
    },
    [AFTER_HEAD_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenAfterHead,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenAfterHead,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: misplacedDoctype,
        [Tokenizer.START_TAG_TOKEN]: startTagAfterHead,
        [Tokenizer.END_TAG_TOKEN]: endTagAfterHead,
        [Tokenizer.EOF_TOKEN]: tokenAfterHead
    },
    [IN_BODY_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInBody,
        [Tokenizer.END_TAG_TOKEN]: endTagInBody,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [TEXT_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.NULL_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: ignoreToken,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: ignoreToken,
        [Tokenizer.END_TAG_TOKEN]: endTagInText,
        [Tokenizer.EOF_TOKEN]: eofInText
    },
    [IN_TABLE_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.NULL_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInTable,
        [Tokenizer.END_TAG_TOKEN]: endTagInTable,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_TABLE_TEXT_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInTableText,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInTableText,
        [Tokenizer.COMMENT_TOKEN]: tokenInTableText,
        [Tokenizer.DOCTYPE_TOKEN]: tokenInTableText,
        [Tokenizer.START_TAG_TOKEN]: tokenInTableText,
        [Tokenizer.END_TAG_TOKEN]: tokenInTableText,
        [Tokenizer.EOF_TOKEN]: tokenInTableText
    },
    [IN_CAPTION_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInCaption,
        [Tokenizer.END_TAG_TOKEN]: endTagInCaption,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_COLUMN_GROUP_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenInColumnGroup,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenInColumnGroup,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInColumnGroup,
        [Tokenizer.END_TAG_TOKEN]: endTagInColumnGroup,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_TABLE_BODY_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.NULL_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInTableBody,
        [Tokenizer.END_TAG_TOKEN]: endTagInTableBody,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_ROW_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.NULL_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInRow,
        [Tokenizer.END_TAG_TOKEN]: endTagInRow,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_CELL_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInCell,
        [Tokenizer.END_TAG_TOKEN]: endTagInCell,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_SELECT_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInSelect,
        [Tokenizer.END_TAG_TOKEN]: endTagInSelect,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_SELECT_IN_TABLE_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInSelectInTable,
        [Tokenizer.END_TAG_TOKEN]: endTagInSelectInTable,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_TEMPLATE_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInTemplate,
        [Tokenizer.END_TAG_TOKEN]: endTagInTemplate,
        [Tokenizer.EOF_TOKEN]: eofInTemplate
    },
    [AFTER_BODY_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenAfterBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenAfterBody,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendCommentToRootHtmlElement,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagAfterBody,
        [Tokenizer.END_TAG_TOKEN]: endTagAfterBody,
        [Tokenizer.EOF_TOKEN]: stopParsing
    },
    [IN_FRAMESET_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInFrameset,
        [Tokenizer.END_TAG_TOKEN]: endTagInFrameset,
        [Tokenizer.EOF_TOKEN]: stopParsing
    },
    [AFTER_FRAMESET_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagAfterFrameset,
        [Tokenizer.END_TAG_TOKEN]: endTagAfterFrameset,
        [Tokenizer.EOF_TOKEN]: stopParsing
    },
    [AFTER_AFTER_BODY_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenAfterAfterBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenAfterAfterBody,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendCommentToDocument,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagAfterAfterBody,
        [Tokenizer.END_TAG_TOKEN]: tokenAfterAfterBody,
        [Tokenizer.EOF_TOKEN]: stopParsing
    },
    [AFTER_AFTER_FRAMESET_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendCommentToDocument,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagAfterAfterFrameset,
        [Tokenizer.END_TAG_TOKEN]: ignoreToken,
        [Tokenizer.EOF_TOKEN]: stopParsing
    }
};

//Parser
class Parser {
    constructor(options) {
        this.options = mergeOptions(DEFAULT_OPTIONS, options);

        this.treeAdapter = this.options.treeAdapter;
        this.pendingScript = null;

        if (this.options.sourceCodeLocationInfo) {
            Mixin.install(this, LocationInfoParserMixin);
        }

        if (this.options.onParseError) {
            Mixin.install(this, ErrorReportingParserMixin, { onParseError: this.options.onParseError });
        }
    }

    // API
    parse(html) {
        const document = this.treeAdapter.createDocument();

        this._bootstrap(document, null);
        this.tokenizer.write(html, true);
        this._runParsingLoop(null);

        return document;
    }

    parseFragment(html, fragmentContext) {
        //NOTE: use <template> element as a fragment context if context element was not provided,
        //so we will parse in "forgiving" manner
        if (!fragmentContext) {
            fragmentContext = this.treeAdapter.createElement($.TEMPLATE, NS.HTML, []);
        }

        //NOTE: create fake element which will be used as 'document' for fragment parsing.
        //This is important for jsdom there 'document' can't be recreated, therefore
        //fragment parsing causes messing of the main `document`.
        const documentMock = this.treeAdapter.createElement('documentmock', NS.HTML, []);

        this._bootstrap(documentMock, fragmentContext);

        if (this.treeAdapter.getTagName(fragmentContext) === $.TEMPLATE) {
            this._pushTmplInsertionMode(IN_TEMPLATE_MODE);
        }

        this._initTokenizerForFragmentParsing();
        this._insertFakeRootElement();
        this._resetInsertionMode();
        this._findFormInFragmentContext();
        this.tokenizer.write(html, true);
        this._runParsingLoop(null);

        const rootElement = this.treeAdapter.getFirstChild(documentMock);
        const fragment = this.treeAdapter.createDocumentFragment();

        this._adoptNodes(rootElement, fragment);

        return fragment;
    }

    //Bootstrap parser
    _bootstrap(document, fragmentContext) {
        this.tokenizer = new Tokenizer(this.options);

        this.stopped = false;

        this.insertionMode = INITIAL_MODE;
        this.originalInsertionMode = '';

        this.document = document;
        this.fragmentContext = fragmentContext;

        this.headElement = null;
        this.formElement = null;

        this.openElements = new OpenElementStack(this.document, this.treeAdapter);
        this.activeFormattingElements = new FormattingElementList(this.treeAdapter);

        this.tmplInsertionModeStack = [];
        this.tmplInsertionModeStackTop = -1;
        this.currentTmplInsertionMode = null;

        this.pendingCharacterTokens = [];
        this.hasNonWhitespacePendingCharacterToken = false;

        this.framesetOk = true;
        this.skipNextNewLine = false;
        this.fosterParentingEnabled = false;
    }

    //Errors
    _err() {
        // NOTE: err reporting is noop by default. Enabled by mixin.
    }

    //Parsing loop
    _runParsingLoop(scriptHandler) {
        while (!this.stopped) {
            this._setupTokenizerCDATAMode();

            const token = this.tokenizer.getNextToken();

            if (token.type === Tokenizer.HIBERNATION_TOKEN) {
                break;
            }

            if (this.skipNextNewLine) {
                this.skipNextNewLine = false;

                if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
                    if (token.chars.length === 1) {
                        continue;
                    }

                    token.chars = token.chars.substr(1);
                }
            }

            this._processInputToken(token);

            if (scriptHandler && this.pendingScript) {
                break;
            }
        }
    }

    runParsingLoopForCurrentChunk(writeCallback, scriptHandler) {
        this._runParsingLoop(scriptHandler);

        if (scriptHandler && this.pendingScript) {
            const script = this.pendingScript;

            this.pendingScript = null;

            scriptHandler(script);

            return;
        }

        if (writeCallback) {
            writeCallback();
        }
    }

    //Text parsing
    _setupTokenizerCDATAMode() {
        const current = this._getAdjustedCurrentElement();

        this.tokenizer.allowCDATA =
            current &&
            current !== this.document &&
            this.treeAdapter.getNamespaceURI(current) !== NS.HTML &&
            !this._isIntegrationPoint(current);
    }

    _switchToTextParsing(currentToken, nextTokenizerState) {
        this._insertElement(currentToken, NS.HTML);
        this.tokenizer.state = nextTokenizerState;
        this.originalInsertionMode = this.insertionMode;
        this.insertionMode = TEXT_MODE;
    }

    switchToPlaintextParsing() {
        this.insertionMode = TEXT_MODE;
        this.originalInsertionMode = IN_BODY_MODE;
        this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
    }

    //Fragment parsing
    _getAdjustedCurrentElement() {
        return this.openElements.stackTop === 0 && this.fragmentContext
            ? this.fragmentContext
            : this.openElements.current;
    }

    _findFormInFragmentContext() {
        let node = this.fragmentContext;

        do {
            if (this.treeAdapter.getTagName(node) === $.FORM) {
                this.formElement = node;
                break;
            }

            node = this.treeAdapter.getParentNode(node);
        } while (node);
    }

    _initTokenizerForFragmentParsing() {
        if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === NS.HTML) {
            const tn = this.treeAdapter.getTagName(this.fragmentContext);

            if (tn === $.TITLE || tn === $.TEXTAREA) {
                this.tokenizer.state = Tokenizer.MODE.RCDATA;
            } else if (
                tn === $.STYLE ||
                tn === $.XMP ||
                tn === $.IFRAME ||
                tn === $.NOEMBED ||
                tn === $.NOFRAMES ||
                tn === $.NOSCRIPT
            ) {
                this.tokenizer.state = Tokenizer.MODE.RAWTEXT;
            } else if (tn === $.SCRIPT) {
                this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;
            } else if (tn === $.PLAINTEXT) {
                this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
            }
        }
    }

    //Tree mutation
    _setDocumentType(token) {
        const name = token.name || '';
        const publicId = token.publicId || '';
        const systemId = token.systemId || '';

        this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
    }

    _attachElementToTree(element) {
        if (this._shouldFosterParentOnInsertion()) {
            this._fosterParentElement(element);
        } else {
            const parent = this.openElements.currentTmplContent || this.openElements.current;

            this.treeAdapter.appendChild(parent, element);
        }
    }

    _appendElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

        this._attachElementToTree(element);
    }

    _insertElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

        this._attachElementToTree(element);
        this.openElements.push(element);
    }

    _insertFakeElement(tagName) {
        const element = this.treeAdapter.createElement(tagName, NS.HTML, []);

        this._attachElementToTree(element);
        this.openElements.push(element);
    }

    _insertTemplate(token) {
        const tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs);
        const content = this.treeAdapter.createDocumentFragment();

        this.treeAdapter.setTemplateContent(tmpl, content);
        this._attachElementToTree(tmpl);
        this.openElements.push(tmpl);
    }

    _insertFakeRootElement() {
        const element = this.treeAdapter.createElement($.HTML, NS.HTML, []);

        this.treeAdapter.appendChild(this.openElements.current, element);
        this.openElements.push(element);
    }

    _appendCommentNode(token, parent) {
        const commentNode = this.treeAdapter.createCommentNode(token.data);

        this.treeAdapter.appendChild(parent, commentNode);
    }

    _insertCharacters(token) {
        if (this._shouldFosterParentOnInsertion()) {
            this._fosterParentText(token.chars);
        } else {
            const parent = this.openElements.currentTmplContent || this.openElements.current;

            this.treeAdapter.insertText(parent, token.chars);
        }
    }

    _adoptNodes(donor, recipient) {
        for (let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)) {
            this.treeAdapter.detachNode(child);
            this.treeAdapter.appendChild(recipient, child);
        }
    }

    //Token processing
    _shouldProcessTokenInForeignContent(token) {
        const current = this._getAdjustedCurrentElement();

        if (!current || current === this.document) {
            return false;
        }

        const ns = this.treeAdapter.getNamespaceURI(current);

        if (ns === NS.HTML) {
            return false;
        }

        if (
            this.treeAdapter.getTagName(current) === $.ANNOTATION_XML &&
            ns === NS.MATHML &&
            token.type === Tokenizer.START_TAG_TOKEN &&
            token.tagName === $.SVG
        ) {
            return false;
        }

        const isCharacterToken =
            token.type === Tokenizer.CHARACTER_TOKEN ||
            token.type === Tokenizer.NULL_CHARACTER_TOKEN ||
            token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN;

        const isMathMLTextStartTag =
            token.type === Tokenizer.START_TAG_TOKEN && token.tagName !== $.MGLYPH && token.tagName !== $.MALIGNMARK;

        if ((isMathMLTextStartTag || isCharacterToken) && this._isIntegrationPoint(current, NS.MATHML)) {
            return false;
        }

        if (
            (token.type === Tokenizer.START_TAG_TOKEN || isCharacterToken) &&
            this._isIntegrationPoint(current, NS.HTML)
        ) {
            return false;
        }

        return token.type !== Tokenizer.EOF_TOKEN;
    }

    _processToken(token) {
        TOKEN_HANDLERS[this.insertionMode][token.type](this, token);
    }

    _processTokenInBodyMode(token) {
        TOKEN_HANDLERS[IN_BODY_MODE][token.type](this, token);
    }

    _processTokenInForeignContent(token) {
        if (token.type === Tokenizer.CHARACTER_TOKEN) {
            characterInForeignContent(this, token);
        } else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN) {
            nullCharacterInForeignContent(this, token);
        } else if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN) {
            insertCharacters(this, token);
        } else if (token.type === Tokenizer.COMMENT_TOKEN) {
            appendComment(this, token);
        } else if (token.type === Tokenizer.START_TAG_TOKEN) {
            startTagInForeignContent(this, token);
        } else if (token.type === Tokenizer.END_TAG_TOKEN) {
            endTagInForeignContent(this, token);
        }
    }

    _processInputToken(token) {
        if (this._shouldProcessTokenInForeignContent(token)) {
            this._processTokenInForeignContent(token);
        } else {
            this._processToken(token);
        }

        if (token.type === Tokenizer.START_TAG_TOKEN && token.selfClosing && !token.ackSelfClosing) {
            this._err(ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
        }
    }

    //Integration points
    _isIntegrationPoint(element, foreignNS) {
        const tn = this.treeAdapter.getTagName(element);
        const ns = this.treeAdapter.getNamespaceURI(element);
        const attrs = this.treeAdapter.getAttrList(element);

        return foreignContent.isIntegrationPoint(tn, ns, attrs, foreignNS);
    }

    //Active formatting elements reconstruction
    _reconstructActiveFormattingElements() {
        const listLength = this.activeFormattingElements.length;

        if (listLength) {
            let unopenIdx = listLength;
            let entry = null;

            do {
                unopenIdx--;
                entry = this.activeFormattingElements.entries[unopenIdx];

                if (entry.type === FormattingElementList.MARKER_ENTRY || this.openElements.contains(entry.element)) {
                    unopenIdx++;
                    break;
                }
            } while (unopenIdx > 0);

            for (let i = unopenIdx; i < listLength; i++) {
                entry = this.activeFormattingElements.entries[i];
                this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
                entry.element = this.openElements.current;
            }
        }
    }

    //Close elements
    _closeTableCell() {
        this.openElements.generateImpliedEndTags();
        this.openElements.popUntilTableCellPopped();
        this.activeFormattingElements.clearToLastMarker();
        this.insertionMode = IN_ROW_MODE;
    }

    _closePElement() {
        this.openElements.generateImpliedEndTagsWithExclusion($.P);
        this.openElements.popUntilTagNamePopped($.P);
    }

    //Insertion modes
    _resetInsertionMode() {
        for (let i = this.openElements.stackTop, last = false; i >= 0; i--) {
            let element = this.openElements.items[i];

            if (i === 0) {
                last = true;

                if (this.fragmentContext) {
                    element = this.fragmentContext;
                }
            }

            const tn = this.treeAdapter.getTagName(element);
            const newInsertionMode = INSERTION_MODE_RESET_MAP[tn];

            if (newInsertionMode) {
                this.insertionMode = newInsertionMode;
                break;
            } else if (!last && (tn === $.TD || tn === $.TH)) {
                this.insertionMode = IN_CELL_MODE;
                break;
            } else if (!last && tn === $.HEAD) {
                this.insertionMode = IN_HEAD_MODE;
                break;
            } else if (tn === $.SELECT) {
                this._resetInsertionModeForSelect(i);
                break;
            } else if (tn === $.TEMPLATE) {
                this.insertionMode = this.currentTmplInsertionMode;
                break;
            } else if (tn === $.HTML) {
                this.insertionMode = this.headElement ? AFTER_HEAD_MODE : BEFORE_HEAD_MODE;
                break;
            } else if (last) {
                this.insertionMode = IN_BODY_MODE;
                break;
            }
        }
    }

    _resetInsertionModeForSelect(selectIdx) {
        if (selectIdx > 0) {
            for (let i = selectIdx - 1; i > 0; i--) {
                const ancestor = this.openElements.items[i];
                const tn = this.treeAdapter.getTagName(ancestor);

                if (tn === $.TEMPLATE) {
                    break;
                } else if (tn === $.TABLE) {
                    this.insertionMode = IN_SELECT_IN_TABLE_MODE;
                    return;
                }
            }
        }

        this.insertionMode = IN_SELECT_MODE;
    }

    _pushTmplInsertionMode(mode) {
        this.tmplInsertionModeStack.push(mode);
        this.tmplInsertionModeStackTop++;
        this.currentTmplInsertionMode = mode;
    }

    _popTmplInsertionMode() {
        this.tmplInsertionModeStack.pop();
        this.tmplInsertionModeStackTop--;
        this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
    }

    //Foster parenting
    _isElementCausesFosterParenting(element) {
        const tn = this.treeAdapter.getTagName(element);

        return tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR;
    }

    _shouldFosterParentOnInsertion() {
        return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
    }

    _findFosterParentingLocation() {
        const location = {
            parent: null,
            beforeElement: null
        };

        for (let i = this.openElements.stackTop; i >= 0; i--) {
            const openElement = this.openElements.items[i];
            const tn = this.treeAdapter.getTagName(openElement);
            const ns = this.treeAdapter.getNamespaceURI(openElement);

            if (tn === $.TEMPLATE && ns === NS.HTML) {
                location.parent = this.treeAdapter.getTemplateContent(openElement);
                break;
            } else if (tn === $.TABLE) {
                location.parent = this.treeAdapter.getParentNode(openElement);

                if (location.parent) {
                    location.beforeElement = openElement;
                } else {
                    location.parent = this.openElements.items[i - 1];
                }

                break;
            }
        }

        if (!location.parent) {
            location.parent = this.openElements.items[0];
        }

        return location;
    }

    _fosterParentElement(element) {
        const location = this._findFosterParentingLocation();

        if (location.beforeElement) {
            this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
        } else {
            this.treeAdapter.appendChild(location.parent, element);
        }
    }

    _fosterParentText(chars) {
        const location = this._findFosterParentingLocation();

        if (location.beforeElement) {
            this.treeAdapter.insertTextBefore(location.parent, chars, location.beforeElement);
        } else {
            this.treeAdapter.insertText(location.parent, chars);
        }
    }

    //Special elements
    _isSpecialElement(element) {
        const tn = this.treeAdapter.getTagName(element);
        const ns = this.treeAdapter.getNamespaceURI(element);

        return HTML.SPECIAL_ELEMENTS[ns][tn];
    }
}

module.exports = Parser;

//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------

//Steps 5-8 of the algorithm
function aaObtainFormattingElementEntry(p, token) {
    let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);

    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        } else if (!p.openElements.hasInScope(token.tagName)) {
            formattingElementEntry = null;
        }
    } else {
        genericEndTagInBody(p, token);
    }

    return formattingElementEntry;
}

//Steps 9 and 10 of the algorithm
function aaObtainFurthestBlock(p, formattingElementEntry) {
    let furthestBlock = null;

    for (let i = p.openElements.stackTop; i >= 0; i--) {
        const element = p.openElements.items[i];

        if (element === formattingElementEntry.element) {
            break;
        }

        if (p._isSpecialElement(element)) {
            furthestBlock = element;
        }
    }

    if (!furthestBlock) {
        p.openElements.popUntilElementPopped(formattingElementEntry.element);
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }

    return furthestBlock;
}

//Step 13 of the algorithm
function aaInnerLoop(p, furthestBlock, formattingElement) {
    let lastElement = furthestBlock;
    let nextElement = p.openElements.getCommonAncestor(furthestBlock);

    for (let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
        //NOTE: store next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);

        const elementEntry = p.activeFormattingElements.getElementEntry(element);
        const counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER;
        const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;

        if (shouldRemoveFromOpenElements) {
            if (counterOverflow) {
                p.activeFormattingElements.removeEntry(elementEntry);
            }

            p.openElements.remove(element);
        } else {
            element = aaRecreateElementFromEntry(p, elementEntry);

            if (lastElement === furthestBlock) {
                p.activeFormattingElements.bookmark = elementEntry;
            }

            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }

    return lastElement;
}

//Step 13.7 of the algorithm
function aaRecreateElementFromEntry(p, elementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
    const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);

    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;

    return newElement;
}

//Step 14 of the algorithm
function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    if (p._isElementCausesFosterParenting(commonAncestor)) {
        p._fosterParentElement(lastElement);
    } else {
        const tn = p.treeAdapter.getTagName(commonAncestor);
        const ns = p.treeAdapter.getNamespaceURI(commonAncestor);

        if (tn === $.TEMPLATE && ns === NS.HTML) {
            commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
        }

        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}

//Steps 15-19 of the algorithm
function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
    const token = formattingElementEntry.token;
    const newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);

    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);

    p.activeFormattingElements.insertElementAfterBookmark(newElement, formattingElementEntry.token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);

    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement);
}

//Algorithm entry point
function callAdoptionAgency(p, token) {
    let formattingElementEntry;

    for (let i = 0; i < AA_OUTER_LOOP_ITER; i++) {
        formattingElementEntry = aaObtainFormattingElementEntry(p, token, formattingElementEntry);

        if (!formattingElementEntry) {
            break;
        }

        const furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);

        if (!furthestBlock) {
            break;
        }

        p.activeFormattingElements.bookmark = formattingElementEntry;

        const lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
        const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);

        p.treeAdapter.detachNode(lastElement);
        aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}

//Generic token handlers
//------------------------------------------------------------------
function ignoreToken() {
    //NOTE: do nothing =)
}

function misplacedDoctype(p) {
    p._err(ERR.misplacedDoctype);
}

function appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContent || p.openElements.current);
}

function appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}

function appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}

function insertCharacters(p, token) {
    p._insertCharacters(token);
}

function stopParsing(p) {
    p.stopped = true;
}

// The "initial" insertion mode
//------------------------------------------------------------------
function doctypeInInitialMode(p, token) {
    p._setDocumentType(token);

    const mode = token.forceQuirks ? HTML.DOCUMENT_MODE.QUIRKS : doctype.getDocumentMode(token);

    if (!doctype.isConforming(token)) {
        p._err(ERR.nonConformingDoctype);
    }

    p.treeAdapter.setDocumentMode(p.document, mode);

    p.insertionMode = BEFORE_HTML_MODE;
}

function tokenInInitialMode(p, token) {
    p._err(ERR.missingDoctype, { beforeToken: true });
    p.treeAdapter.setDocumentMode(p.document, HTML.DOCUMENT_MODE.QUIRKS);
    p.insertionMode = BEFORE_HTML_MODE;
    p._processToken(token);
}

// The "before html" insertion mode
//------------------------------------------------------------------
function startTagBeforeHtml(p, token) {
    if (token.tagName === $.HTML) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = BEFORE_HEAD_MODE;
    } else {
        tokenBeforeHtml(p, token);
    }
}

function endTagBeforeHtml(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML || tn === $.HEAD || tn === $.BODY || tn === $.BR) {
        tokenBeforeHtml(p, token);
    }
}

function tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = BEFORE_HEAD_MODE;
    p._processToken(token);
}

// The "before head" insertion mode
//------------------------------------------------------------------
function startTagBeforeHead(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.HEAD) {
        p._insertElement(token, NS.HTML);
        p.headElement = p.openElements.current;
        p.insertionMode = IN_HEAD_MODE;
    } else {
        tokenBeforeHead(p, token);
    }
}

function endTagBeforeHead(p, token) {
    const tn = token.tagName;

    if (tn === $.HEAD || tn === $.BODY || tn === $.HTML || tn === $.BR) {
        tokenBeforeHead(p, token);
    } else {
        p._err(ERR.endTagWithoutMatchingOpenElement);
    }
}

function tokenBeforeHead(p, token) {
    p._insertFakeElement($.HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = IN_HEAD_MODE;
    p._processToken(token);
}

// The "in head" insertion mode
//------------------------------------------------------------------
function startTagInHead(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META) {
        p._appendElement(token, NS.HTML);
        token.ackSelfClosing = true;
    } else if (tn === $.TITLE) {
        p._switchToTextParsing(token, Tokenizer.MODE.RCDATA);
    } else if (tn === $.NOSCRIPT) {
        if (p.options.scriptingEnabled) {
            p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
        } else {
            p._insertElement(token, NS.HTML);
            p.insertionMode = IN_HEAD_NO_SCRIPT_MODE;
        }
    } else if (tn === $.NOFRAMES || tn === $.STYLE) {
        p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
    } else if (tn === $.SCRIPT) {
        p._switchToTextParsing(token, Tokenizer.MODE.SCRIPT_DATA);
    } else if (tn === $.TEMPLATE) {
        p._insertTemplate(token, NS.HTML);
        p.activeFormattingElements.insertMarker();
        p.framesetOk = false;
        p.insertionMode = IN_TEMPLATE_MODE;
        p._pushTmplInsertionMode(IN_TEMPLATE_MODE);
    } else if (tn === $.HEAD) {
        p._err(ERR.misplacedStartTagForHeadElement);
    } else {
        tokenInHead(p, token);
    }
}

function endTagInHead(p, token) {
    const tn = token.tagName;

    if (tn === $.HEAD) {
        p.openElements.pop();
        p.insertionMode = AFTER_HEAD_MODE;
    } else if (tn === $.BODY || tn === $.BR || tn === $.HTML) {
        tokenInHead(p, token);
    } else if (tn === $.TEMPLATE) {
        if (p.openElements.tmplCount > 0) {
            p.openElements.generateImpliedEndTagsThoroughly();

            if (p.openElements.currentTagName !== $.TEMPLATE) {
                p._err(ERR.closingOfElementWithOpenChildElements);
            }

            p.openElements.popUntilTagNamePopped($.TEMPLATE);
            p.activeFormattingElements.clearToLastMarker();
            p._popTmplInsertionMode();
            p._resetInsertionMode();
        } else {
            p._err(ERR.endTagWithoutMatchingOpenElement);
        }
    } else {
        p._err(ERR.endTagWithoutMatchingOpenElement);
    }
}

function tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = AFTER_HEAD_MODE;
    p._processToken(token);
}

// The "in head no script" insertion mode
//------------------------------------------------------------------
function startTagInHeadNoScript(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (
        tn === $.BASEFONT ||
        tn === $.BGSOUND ||
        tn === $.HEAD ||
        tn === $.LINK ||
        tn === $.META ||
        tn === $.NOFRAMES ||
        tn === $.STYLE
    ) {
        startTagInHead(p, token);
    } else if (tn === $.NOSCRIPT) {
        p._err(ERR.nestedNoscriptInHead);
    } else {
        tokenInHeadNoScript(p, token);
    }
}

function endTagInHeadNoScript(p, token) {
    const tn = token.tagName;

    if (tn === $.NOSCRIPT) {
        p.openElements.pop();
        p.insertionMode = IN_HEAD_MODE;
    } else if (tn === $.BR) {
        tokenInHeadNoScript(p, token);
    } else {
        p._err(ERR.endTagWithoutMatchingOpenElement);
    }
}

function tokenInHeadNoScript(p, token) {
    const errCode =
        token.type === Tokenizer.EOF_TOKEN ? ERR.openElementsLeftAfterEof : ERR.disallowedContentInNoscriptInHead;

    p._err(errCode);
    p.openElements.pop();
    p.insertionMode = IN_HEAD_MODE;
    p._processToken(token);
}

// The "after head" insertion mode
//------------------------------------------------------------------
function startTagAfterHead(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.BODY) {
        p._insertElement(token, NS.HTML);
        p.framesetOk = false;
        p.insertionMode = IN_BODY_MODE;
    } else if (tn === $.FRAMESET) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    } else if (
        tn === $.BASE ||
        tn === $.BASEFONT ||
        tn === $.BGSOUND ||
        tn === $.LINK ||
        tn === $.META ||
        tn === $.NOFRAMES ||
        tn === $.SCRIPT ||
        tn === $.STYLE ||
        tn === $.TEMPLATE ||
        tn === $.TITLE
    ) {
        p._err(ERR.abandonedHeadElementChild);
        p.openElements.push(p.headElement);
        startTagInHead(p, token);
        p.openElements.remove(p.headElement);
    } else if (tn === $.HEAD) {
        p._err(ERR.misplacedStartTagForHeadElement);
    } else {
        tokenAfterHead(p, token);
    }
}

function endTagAfterHead(p, token) {
    const tn = token.tagName;

    if (tn === $.BODY || tn === $.HTML || tn === $.BR) {
        tokenAfterHead(p, token);
    } else if (tn === $.TEMPLATE) {
        endTagInHead(p, token);
    } else {
        p._err(ERR.endTagWithoutMatchingOpenElement);
    }
}

function tokenAfterHead(p, token) {
    p._insertFakeElement($.BODY);
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

// The "in body" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}

function characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}

function htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0) {
        p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
    }
}

function bodyStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}

function framesetStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    }
}

function addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
}

function numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    const tn = p.openElements.currentTagName;

    if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
        p.openElements.pop();
    }

    p._insertElement(token, NS.HTML);
}

function preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}

function formStartTagInBody(p, token) {
    const inTemplate = p.openElements.tmplCount > 0;

    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope($.P)) {
            p._closePElement();
        }

        p._insertElement(token, NS.HTML);

        if (!inTemplate) {
            p.formElement = p.openElements.current;
        }
    }
}

function listItemStartTagInBody(p, token) {
    p.framesetOk = false;

    const tn = token.tagName;

    for (let i = p.openElements.stackTop; i >= 0; i--) {
        const element = p.openElements.items[i];
        const elementTn = p.treeAdapter.getTagName(element);
        let closeTn = null;

        if (tn === $.LI && elementTn === $.LI) {
            closeTn = $.LI;
        } else if ((tn === $.DD || tn === $.DT) && (elementTn === $.DD || elementTn === $.DT)) {
            closeTn = elementTn;
        }

        if (closeTn) {
            p.openElements.generateImpliedEndTagsWithExclusion(closeTn);
            p.openElements.popUntilTagNamePopped(closeTn);
            break;
        }

        if (elementTn !== $.ADDRESS && elementTn !== $.DIV && elementTn !== $.P && p._isSpecialElement(element)) {
            break;
        }
    }

    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
}

function plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
    p.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
}

function buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.BUTTON);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
}

function aStartTagInBody(p, token) {
    const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName($.A);

    if (activeElementEntry) {
        callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    if (p.openElements.hasInScope($.NOBR)) {
        callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }

    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}

function tableStartTagInBody(p, token) {
    if (
        p.treeAdapter.getDocumentMode(p.document) !== HTML.DOCUMENT_MODE.QUIRKS &&
        p.openElements.hasInButtonScope($.P)
    ) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    p.insertionMode = IN_TABLE_MODE;
}

function areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}

function inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);

    const inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (!inputType || inputType.toLowerCase() !== HIDDEN_INPUT_TYPE) {
        p.framesetOk = false;
    }

    token.ackSelfClosing = true;
}

function paramStartTagInBody(p, token) {
    p._appendElement(token, NS.HTML);
    token.ackSelfClosing = true;
}

function hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}

function imageStartTagInBody(p, token) {
    token.tagName = $.IMG;
    areaStartTagInBody(p, token);
}

function textareaStartTagInBody(p, token) {
    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = Tokenizer.MODE.RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = TEXT_MODE;
}

function xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

//NOTE: here we assume that we always act as an user agent with enabled plugins, so we parse
//<noembed> as a rawtext.
function noembedStartTagInBody(p, token) {
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;

    if (
        p.insertionMode === IN_TABLE_MODE ||
        p.insertionMode === IN_CAPTION_MODE ||
        p.insertionMode === IN_TABLE_BODY_MODE ||
        p.insertionMode === IN_ROW_MODE ||
        p.insertionMode === IN_CELL_MODE
    ) {
        p.insertionMode = IN_SELECT_IN_TABLE_MODE;
    } else {
        p.insertionMode = IN_SELECT_MODE;
    }
}

function optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.OPTION) {
        p.openElements.pop();
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

function rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY)) {
        p.openElements.generateImpliedEndTags();
    }

    p._insertElement(token, NS.HTML);
}

function rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY)) {
        p.openElements.generateImpliedEndTagsWithExclusion($.RTC);
    }

    p._insertElement(token, NS.HTML);
}

function menuStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
}

function mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenMathMLAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing) {
        p._appendElement(token, NS.MATHML);
    } else {
        p._insertElement(token, NS.MATHML);
    }

    token.ackSelfClosing = true;
}

function svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenSVGAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing) {
        p._appendElement(token, NS.SVG);
    } else {
        p._insertElement(token, NS.SVG);
    }

    token.ackSelfClosing = true;
}

function genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function startTagInBody(p, token) {
    const tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.I || tn === $.S || tn === $.B || tn === $.U) {
                bStartTagInBody(p, token);
            } else if (tn === $.P) {
                addressStartTagInBody(p, token);
            } else if (tn === $.A) {
                aStartTagInBody(p, token);
            } else {
                genericStartTagInBody(p, token);
            }

            break;

        case 2:
            if (tn === $.DL || tn === $.OL || tn === $.UL) {
                addressStartTagInBody(p, token);
            } else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
                numberedHeaderStartTagInBody(p, token);
            } else if (tn === $.LI || tn === $.DD || tn === $.DT) {
                listItemStartTagInBody(p, token);
            } else if (tn === $.EM || tn === $.TT) {
                bStartTagInBody(p, token);
            } else if (tn === $.BR) {
                areaStartTagInBody(p, token);
            } else if (tn === $.HR) {
                hrStartTagInBody(p, token);
            } else if (tn === $.RB) {
                rbStartTagInBody(p, token);
            } else if (tn === $.RT || tn === $.RP) {
                rtStartTagInBody(p, token);
            } else if (tn !== $.TH && tn !== $.TD && tn !== $.TR) {
                genericStartTagInBody(p, token);
            }

            break;

        case 3:
            if (tn === $.DIV || tn === $.DIR || tn === $.NAV) {
                addressStartTagInBody(p, token);
            } else if (tn === $.PRE) {
                preStartTagInBody(p, token);
            } else if (tn === $.BIG) {
                bStartTagInBody(p, token);
            } else if (tn === $.IMG || tn === $.WBR) {
                areaStartTagInBody(p, token);
            } else if (tn === $.XMP) {
                xmpStartTagInBody(p, token);
            } else if (tn === $.SVG) {
                svgStartTagInBody(p, token);
            } else if (tn === $.RTC) {
                rbStartTagInBody(p, token);
            } else if (tn !== $.COL) {
                genericStartTagInBody(p, token);
            }

            break;

        case 4:
            if (tn === $.HTML) {
                htmlStartTagInBody(p, token);
            } else if (tn === $.BASE || tn === $.LINK || tn === $.META) {
                startTagInHead(p, token);
            } else if (tn === $.BODY) {
                bodyStartTagInBody(p, token);
            } else if (tn === $.MAIN || tn === $.MENU) {
                addressStartTagInBody(p, token);
            } else if (tn === $.FORM) {
                formStartTagInBody(p, token);
            } else if (tn === $.CODE || tn === $.FONT) {
                bStartTagInBody(p, token);
            } else if (tn === $.NOBR) {
                nobrStartTagInBody(p, token);
            } else if (tn === $.AREA) {
                areaStartTagInBody(p, token);
            } else if (tn === $.MATH) {
                mathStartTagInBody(p, token);
            } else if (tn === $.MENU) {
                menuStartTagInBody(p, token);
            } else if (tn !== $.HEAD) {
                genericStartTagInBody(p, token);
            }

            break;

        case 5:
            if (tn === $.STYLE || tn === $.TITLE) {
                startTagInHead(p, token);
            } else if (tn === $.ASIDE) {
                addressStartTagInBody(p, token);
            } else if (tn === $.SMALL) {
                bStartTagInBody(p, token);
            } else if (tn === $.TABLE) {
                tableStartTagInBody(p, token);
            } else if (tn === $.EMBED) {
                areaStartTagInBody(p, token);
            } else if (tn === $.INPUT) {
                inputStartTagInBody(p, token);
            } else if (tn === $.PARAM || tn === $.TRACK) {
                paramStartTagInBody(p, token);
            } else if (tn === $.IMAGE) {
                imageStartTagInBody(p, token);
            } else if (tn !== $.FRAME && tn !== $.TBODY && tn !== $.TFOOT && tn !== $.THEAD) {
                genericStartTagInBody(p, token);
            }

            break;

        case 6:
            if (tn === $.SCRIPT) {
                startTagInHead(p, token);
            } else if (
                tn === $.CENTER ||
                tn === $.FIGURE ||
                tn === $.FOOTER ||
                tn === $.HEADER ||
                tn === $.HGROUP ||
                tn === $.DIALOG
            ) {
                addressStartTagInBody(p, token);
            } else if (tn === $.BUTTON) {
                buttonStartTagInBody(p, token);
            } else if (tn === $.STRIKE || tn === $.STRONG) {
                bStartTagInBody(p, token);
            } else if (tn === $.APPLET || tn === $.OBJECT) {
                appletStartTagInBody(p, token);
            } else if (tn === $.KEYGEN) {
                areaStartTagInBody(p, token);
            } else if (tn === $.SOURCE) {
                paramStartTagInBody(p, token);
            } else if (tn === $.IFRAME) {
                iframeStartTagInBody(p, token);
            } else if (tn === $.SELECT) {
                selectStartTagInBody(p, token);
            } else if (tn === $.OPTION) {
                optgroupStartTagInBody(p, token);
            } else {
                genericStartTagInBody(p, token);
            }

            break;

        case 7:
            if (tn === $.BGSOUND) {
                startTagInHead(p, token);
            } else if (
                tn === $.DETAILS ||
                tn === $.ADDRESS ||
                tn === $.ARTICLE ||
                tn === $.SECTION ||
                tn === $.SUMMARY
            ) {
                addressStartTagInBody(p, token);
            } else if (tn === $.LISTING) {
                preStartTagInBody(p, token);
            } else if (tn === $.MARQUEE) {
                appletStartTagInBody(p, token);
            } else if (tn === $.NOEMBED) {
                noembedStartTagInBody(p, token);
            } else if (tn !== $.CAPTION) {
                genericStartTagInBody(p, token);
            }

            break;

        case 8:
            if (tn === $.BASEFONT) {
                startTagInHead(p, token);
            } else if (tn === $.FRAMESET) {
                framesetStartTagInBody(p, token);
            } else if (tn === $.FIELDSET) {
                addressStartTagInBody(p, token);
            } else if (tn === $.TEXTAREA) {
                textareaStartTagInBody(p, token);
            } else if (tn === $.TEMPLATE) {
                startTagInHead(p, token);
            } else if (tn === $.NOSCRIPT) {
                if (p.options.scriptingEnabled) {
                    noembedStartTagInBody(p, token);
                } else {
                    genericStartTagInBody(p, token);
                }
            } else if (tn === $.OPTGROUP) {
                optgroupStartTagInBody(p, token);
            } else if (tn !== $.COLGROUP) {
                genericStartTagInBody(p, token);
            }

            break;

        case 9:
            if (tn === $.PLAINTEXT) {
                plaintextStartTagInBody(p, token);
            } else {
                genericStartTagInBody(p, token);
            }

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION) {
                addressStartTagInBody(p, token);
            } else {
                genericStartTagInBody(p, token);
            }

            break;

        default:
            genericStartTagInBody(p, token);
    }
}

function bodyEndTagInBody(p) {
    if (p.openElements.hasInScope($.BODY)) {
        p.insertionMode = AFTER_BODY_MODE;
    }
}

function htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope($.BODY)) {
        p.insertionMode = AFTER_BODY_MODE;
        p._processToken(token);
    }
}

function addressEndTagInBody(p, token) {
    const tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function formEndTagInBody(p) {
    const inTemplate = p.openElements.tmplCount > 0;
    const formElement = p.formElement;

    if (!inTemplate) {
        p.formElement = null;
    }

    if ((formElement || inTemplate) && p.openElements.hasInScope($.FORM)) {
        p.openElements.generateImpliedEndTags();

        if (inTemplate) {
            p.openElements.popUntilTagNamePopped($.FORM);
        } else {
            p.openElements.remove(formElement);
        }
    }
}

function pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope($.P)) {
        p._insertFakeElement($.P);
    }

    p._closePElement();
}

function liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope($.LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion($.LI);
        p.openElements.popUntilTagNamePopped($.LI);
    }
}

function ddEndTagInBody(p, token) {
    const tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}

function appletEndTagInBody(p, token) {
    const tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}

function brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement($.BR);
    p.openElements.pop();
    p.framesetOk = false;
}

function genericEndTagInBody(p, token) {
    const tn = token.tagName;

    for (let i = p.openElements.stackTop; i > 0; i--) {
        const element = p.openElements.items[i];

        if (p.treeAdapter.getTagName(element) === tn) {
            p.openElements.generateImpliedEndTagsWithExclusion(tn);
            p.openElements.popUntilElementPopped(element);
            break;
        }

        if (p._isSpecialElement(element)) {
            break;
        }
    }
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function endTagInBody(p, token) {
    const tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.A || tn === $.B || tn === $.I || tn === $.S || tn === $.U) {
                callAdoptionAgency(p, token);
            } else if (tn === $.P) {
                pEndTagInBody(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 2:
            if (tn === $.DL || tn === $.UL || tn === $.OL) {
                addressEndTagInBody(p, token);
            } else if (tn === $.LI) {
                liEndTagInBody(p, token);
            } else if (tn === $.DD || tn === $.DT) {
                ddEndTagInBody(p, token);
            } else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
                numberedHeaderEndTagInBody(p, token);
            } else if (tn === $.BR) {
                brEndTagInBody(p, token);
            } else if (tn === $.EM || tn === $.TT) {
                callAdoptionAgency(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 3:
            if (tn === $.BIG) {
                callAdoptionAgency(p, token);
            } else if (tn === $.DIR || tn === $.DIV || tn === $.NAV || tn === $.PRE) {
                addressEndTagInBody(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 4:
            if (tn === $.BODY) {
                bodyEndTagInBody(p, token);
            } else if (tn === $.HTML) {
                htmlEndTagInBody(p, token);
            } else if (tn === $.FORM) {
                formEndTagInBody(p, token);
            } else if (tn === $.CODE || tn === $.FONT || tn === $.NOBR) {
                callAdoptionAgency(p, token);
            } else if (tn === $.MAIN || tn === $.MENU) {
                addressEndTagInBody(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 5:
            if (tn === $.ASIDE) {
                addressEndTagInBody(p, token);
            } else if (tn === $.SMALL) {
                callAdoptionAgency(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 6:
            if (
                tn === $.CENTER ||
                tn === $.FIGURE ||
                tn === $.FOOTER ||
                tn === $.HEADER ||
                tn === $.HGROUP ||
                tn === $.DIALOG
            ) {
                addressEndTagInBody(p, token);
            } else if (tn === $.APPLET || tn === $.OBJECT) {
                appletEndTagInBody(p, token);
            } else if (tn === $.STRIKE || tn === $.STRONG) {
                callAdoptionAgency(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 7:
            if (
                tn === $.ADDRESS ||
                tn === $.ARTICLE ||
                tn === $.DETAILS ||
                tn === $.SECTION ||
                tn === $.SUMMARY ||
                tn === $.LISTING
            ) {
                addressEndTagInBody(p, token);
            } else if (tn === $.MARQUEE) {
                appletEndTagInBody(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 8:
            if (tn === $.FIELDSET) {
                addressEndTagInBody(p, token);
            } else if (tn === $.TEMPLATE) {
                endTagInHead(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION) {
                addressEndTagInBody(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        default:
            genericEndTagInBody(p, token);
    }
}

function eofInBody(p, token) {
    if (p.tmplInsertionModeStackTop > -1) {
        eofInTemplate(p, token);
    } else {
        p.stopped = true;
    }
}

// The "text" insertion mode
//------------------------------------------------------------------
function endTagInText(p, token) {
    if (token.tagName === $.SCRIPT) {
        p.pendingScript = p.openElements.current;
    }

    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}

function eofInText(p, token) {
    p._err(ERR.eofInElementThatCanContainOnlyText);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}

// The "in table" insertion mode
//------------------------------------------------------------------
function characterInTable(p, token) {
    const curTn = p.openElements.currentTagName;

    if (curTn === $.TABLE || curTn === $.TBODY || curTn === $.TFOOT || curTn === $.THEAD || curTn === $.TR) {
        p.pendingCharacterTokens = [];
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = IN_TABLE_TEXT_MODE;
        p._processToken(token);
    } else {
        tokenInTable(p, token);
    }
}

function captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_CAPTION_MODE;
}

function colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
}

function colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.COLGROUP);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
    p._processToken(token);
}

function tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_TABLE_BODY_MODE;
}

function tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.TBODY);
    p.insertionMode = IN_TABLE_BODY_MODE;
    p._processToken(token);
}

function tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope($.TABLE)) {
        p.openElements.popUntilTagNamePopped($.TABLE);
        p._resetInsertionMode();
        p._processToken(token);
    }
}

function inputStartTagInTable(p, token) {
    const inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (inputType && inputType.toLowerCase() === HIDDEN_INPUT_TYPE) {
        p._appendElement(token, NS.HTML);
    } else {
        tokenInTable(p, token);
    }

    token.ackSelfClosing = true;
}

function formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, NS.HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}

function startTagInTable(p, token) {
    const tn = token.tagName;

    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH || tn === $.TR) {
                tdStartTagInTable(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 3:
            if (tn === $.COL) {
                colStartTagInTable(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 4:
            if (tn === $.FORM) {
                formStartTagInTable(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 5:
            if (tn === $.TABLE) {
                tableStartTagInTable(p, token);
            } else if (tn === $.STYLE) {
                startTagInHead(p, token);
            } else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
                tbodyStartTagInTable(p, token);
            } else if (tn === $.INPUT) {
                inputStartTagInTable(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 6:
            if (tn === $.SCRIPT) {
                startTagInHead(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 7:
            if (tn === $.CAPTION) {
                captionStartTagInTable(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 8:
            if (tn === $.COLGROUP) {
                colgroupStartTagInTable(p, token);
            } else if (tn === $.TEMPLATE) {
                startTagInHead(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        default:
            tokenInTable(p, token);
    }
}

function endTagInTable(p, token) {
    const tn = token.tagName;

    if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TABLE)) {
            p.openElements.popUntilTagNamePopped($.TABLE);
            p._resetInsertionMode();
        }
    } else if (tn === $.TEMPLATE) {
        endTagInHead(p, token);
    } else if (
        tn !== $.BODY &&
        tn !== $.CAPTION &&
        tn !== $.COL &&
        tn !== $.COLGROUP &&
        tn !== $.HTML &&
        tn !== $.TBODY &&
        tn !== $.TD &&
        tn !== $.TFOOT &&
        tn !== $.TH &&
        tn !== $.THEAD &&
        tn !== $.TR
    ) {
        tokenInTable(p, token);
    }
}

function tokenInTable(p, token) {
    const savedFosterParentingState = p.fosterParentingEnabled;

    p.fosterParentingEnabled = true;
    p._processTokenInBodyMode(token);
    p.fosterParentingEnabled = savedFosterParentingState;
}

// The "in table text" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}

function characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}

function tokenInTableText(p, token) {
    let i = 0;

    if (p.hasNonWhitespacePendingCharacterToken) {
        for (; i < p.pendingCharacterTokens.length; i++) {
            tokenInTable(p, p.pendingCharacterTokens[i]);
        }
    } else {
        for (; i < p.pendingCharacterTokens.length; i++) {
            p._insertCharacters(p.pendingCharacterTokens[i]);
        }
    }

    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}

// The "in caption" insertion mode
//------------------------------------------------------------------
function startTagInCaption(p, token) {
    const tn = token.tagName;

    if (
        tn === $.CAPTION ||
        tn === $.COL ||
        tn === $.COLGROUP ||
        tn === $.TBODY ||
        tn === $.TD ||
        tn === $.TFOOT ||
        tn === $.TH ||
        tn === $.THEAD ||
        tn === $.TR
    ) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    } else {
        startTagInBody(p, token);
    }
}

function endTagInCaption(p, token) {
    const tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;

            if (tn === $.TABLE) {
                p._processToken(token);
            }
        }
    } else if (
        tn !== $.BODY &&
        tn !== $.COL &&
        tn !== $.COLGROUP &&
        tn !== $.HTML &&
        tn !== $.TBODY &&
        tn !== $.TD &&
        tn !== $.TFOOT &&
        tn !== $.TH &&
        tn !== $.THEAD &&
        tn !== $.TR
    ) {
        endTagInBody(p, token);
    }
}

// The "in column group" insertion mode
//------------------------------------------------------------------
function startTagInColumnGroup(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.COL) {
        p._appendElement(token, NS.HTML);
        token.ackSelfClosing = true;
    } else if (tn === $.TEMPLATE) {
        startTagInHead(p, token);
    } else {
        tokenInColumnGroup(p, token);
    }
}

function endTagInColumnGroup(p, token) {
    const tn = token.tagName;

    if (tn === $.COLGROUP) {
        if (p.openElements.currentTagName === $.COLGROUP) {
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    } else if (tn === $.TEMPLATE) {
        endTagInHead(p, token);
    } else if (tn !== $.COL) {
        tokenInColumnGroup(p, token);
    }
}

function tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagName === $.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = IN_TABLE_MODE;
        p._processToken(token);
    }
}

// The "in table body" insertion mode
//------------------------------------------------------------------
function startTagInTableBody(p, token) {
    const tn = token.tagName;

    if (tn === $.TR) {
        p.openElements.clearBackToTableBodyContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_ROW_MODE;
    } else if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableBodyContext();
        p._insertFakeElement($.TR);
        p.insertionMode = IN_ROW_MODE;
        p._processToken(token);
    } else if (
        tn === $.CAPTION ||
        tn === $.COL ||
        tn === $.COLGROUP ||
        tn === $.TBODY ||
        tn === $.TFOOT ||
        tn === $.THEAD
    ) {
        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    } else {
        startTagInTable(p, token);
    }
}

function endTagInTableBody(p, token) {
    const tn = token.tagName;

    if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    } else if (tn === $.TABLE) {
        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    } else if (
        (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP) ||
        (tn !== $.HTML && tn !== $.TD && tn !== $.TH && tn !== $.TR)
    ) {
        endTagInTable(p, token);
    }
}

// The "in row" insertion mode
//------------------------------------------------------------------
function startTagInRow(p, token) {
    const tn = token.tagName;

    if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableRowContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_CELL_MODE;
        p.activeFormattingElements.insertMarker();
    } else if (
        tn === $.CAPTION ||
        tn === $.COL ||
        tn === $.COLGROUP ||
        tn === $.TBODY ||
        tn === $.TFOOT ||
        tn === $.THEAD ||
        tn === $.TR
    ) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    } else {
        startTagInTable(p, token);
    }
}

function endTagInRow(p, token) {
    const tn = token.tagName;

    if (tn === $.TR) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
        }
    } else if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    } else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn) || p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    } else if (
        (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP) ||
        (tn !== $.HTML && tn !== $.TD && tn !== $.TH)
    ) {
        endTagInTable(p, token);
    }
}

// The "in cell" insertion mode
//------------------------------------------------------------------
function startTagInCell(p, token) {
    const tn = token.tagName;

    if (
        tn === $.CAPTION ||
        tn === $.COL ||
        tn === $.COLGROUP ||
        tn === $.TBODY ||
        tn === $.TD ||
        tn === $.TFOOT ||
        tn === $.TH ||
        tn === $.THEAD ||
        tn === $.TR
    ) {
        if (p.openElements.hasInTableScope($.TD) || p.openElements.hasInTableScope($.TH)) {
            p._closeTableCell();
            p._processToken(token);
        }
    } else {
        startTagInBody(p, token);
    }
}

function endTagInCell(p, token) {
    const tn = token.tagName;

    if (tn === $.TD || tn === $.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped(tn);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_ROW_MODE;
        }
    } else if (tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope(tn)) {
            p._closeTableCell();
            p._processToken(token);
        }
    } else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML) {
        endTagInBody(p, token);
    }
}

// The "in select" insertion mode
//------------------------------------------------------------------
function startTagInSelect(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION) {
            p.openElements.pop();
        }

        p._insertElement(token, NS.HTML);
    } else if (tn === $.OPTGROUP) {
        if (p.openElements.currentTagName === $.OPTION) {
            p.openElements.pop();
        }

        if (p.openElements.currentTagName === $.OPTGROUP) {
            p.openElements.pop();
        }

        p._insertElement(token, NS.HTML);
    } else if (tn === $.INPUT || tn === $.KEYGEN || tn === $.TEXTAREA || tn === $.SELECT) {
        if (p.openElements.hasInSelectScope($.SELECT)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();

            if (tn !== $.SELECT) {
                p._processToken(token);
            }
        }
    } else if (tn === $.SCRIPT || tn === $.TEMPLATE) {
        startTagInHead(p, token);
    }
}

function endTagInSelect(p, token) {
    const tn = token.tagName;

    if (tn === $.OPTGROUP) {
        const prevOpenElement = p.openElements.items[p.openElements.stackTop - 1];
        const prevOpenElementTn = prevOpenElement && p.treeAdapter.getTagName(prevOpenElement);

        if (p.openElements.currentTagName === $.OPTION && prevOpenElementTn === $.OPTGROUP) {
            p.openElements.pop();
        }

        if (p.openElements.currentTagName === $.OPTGROUP) {
            p.openElements.pop();
        }
    } else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION) {
            p.openElements.pop();
        }
    } else if (tn === $.SELECT && p.openElements.hasInSelectScope($.SELECT)) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
    } else if (tn === $.TEMPLATE) {
        endTagInHead(p, token);
    }
}

//12.2.5.4.17 The "in select in table" insertion mode
//------------------------------------------------------------------
function startTagInSelectInTable(p, token) {
    const tn = token.tagName;

    if (
        tn === $.CAPTION ||
        tn === $.TABLE ||
        tn === $.TBODY ||
        tn === $.TFOOT ||
        tn === $.THEAD ||
        tn === $.TR ||
        tn === $.TD ||
        tn === $.TH
    ) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
        p._processToken(token);
    } else {
        startTagInSelect(p, token);
    }
}

function endTagInSelectInTable(p, token) {
    const tn = token.tagName;

    if (
        tn === $.CAPTION ||
        tn === $.TABLE ||
        tn === $.TBODY ||
        tn === $.TFOOT ||
        tn === $.THEAD ||
        tn === $.TR ||
        tn === $.TD ||
        tn === $.TH
    ) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();
            p._processToken(token);
        }
    } else {
        endTagInSelect(p, token);
    }
}

// The "in template" insertion mode
//------------------------------------------------------------------
function startTagInTemplate(p, token) {
    const tn = token.tagName;

    if (
        tn === $.BASE ||
        tn === $.BASEFONT ||
        tn === $.BGSOUND ||
        tn === $.LINK ||
        tn === $.META ||
        tn === $.NOFRAMES ||
        tn === $.SCRIPT ||
        tn === $.STYLE ||
        tn === $.TEMPLATE ||
        tn === $.TITLE
    ) {
        startTagInHead(p, token);
    } else {
        const newInsertionMode = TEMPLATE_INSERTION_MODE_SWITCH_MAP[tn] || IN_BODY_MODE;

        p._popTmplInsertionMode();
        p._pushTmplInsertionMode(newInsertionMode);
        p.insertionMode = newInsertionMode;
        p._processToken(token);
    }
}

function endTagInTemplate(p, token) {
    if (token.tagName === $.TEMPLATE) {
        endTagInHead(p, token);
    }
}

function eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
        p._processToken(token);
    } else {
        p.stopped = true;
    }
}

// The "after body" insertion mode
//------------------------------------------------------------------
function startTagAfterBody(p, token) {
    if (token.tagName === $.HTML) {
        startTagInBody(p, token);
    } else {
        tokenAfterBody(p, token);
    }
}

function endTagAfterBody(p, token) {
    if (token.tagName === $.HTML) {
        if (!p.fragmentContext) {
            p.insertionMode = AFTER_AFTER_BODY_MODE;
        }
    } else {
        tokenAfterBody(p, token);
    }
}

function tokenAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

// The "in frameset" insertion mode
//------------------------------------------------------------------
function startTagInFrameset(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.FRAMESET) {
        p._insertElement(token, NS.HTML);
    } else if (tn === $.FRAME) {
        p._appendElement(token, NS.HTML);
        token.ackSelfClosing = true;
    } else if (tn === $.NOFRAMES) {
        startTagInHead(p, token);
    }
}

function endTagInFrameset(p, token) {
    if (token.tagName === $.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();

        if (!p.fragmentContext && p.openElements.currentTagName !== $.FRAMESET) {
            p.insertionMode = AFTER_FRAMESET_MODE;
        }
    }
}

// The "after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterFrameset(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.NOFRAMES) {
        startTagInHead(p, token);
    }
}

function endTagAfterFrameset(p, token) {
    if (token.tagName === $.HTML) {
        p.insertionMode = AFTER_AFTER_FRAMESET_MODE;
    }
}

// The "after after body" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterBody(p, token) {
    if (token.tagName === $.HTML) {
        startTagInBody(p, token);
    } else {
        tokenAfterAfterBody(p, token);
    }
}

function tokenAfterAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

// The "after after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterFrameset(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.NOFRAMES) {
        startTagInHead(p, token);
    }
}

// The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function nullCharacterInForeignContent(p, token) {
    token.chars = unicode.REPLACEMENT_CHARACTER;
    p._insertCharacters(token);
}

function characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}

function startTagInForeignContent(p, token) {
    if (foreignContent.causesExit(token) && !p.fragmentContext) {
        while (
            p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML &&
            !p._isIntegrationPoint(p.openElements.current)
        ) {
            p.openElements.pop();
        }

        p._processToken(token);
    } else {
        const current = p._getAdjustedCurrentElement();
        const currentNs = p.treeAdapter.getNamespaceURI(current);

        if (currentNs === NS.MATHML) {
            foreignContent.adjustTokenMathMLAttrs(token);
        } else if (currentNs === NS.SVG) {
            foreignContent.adjustTokenSVGTagName(token);
            foreignContent.adjustTokenSVGAttrs(token);
        }

        foreignContent.adjustTokenXMLAttrs(token);

        if (token.selfClosing) {
            p._appendElement(token, currentNs);
        } else {
            p._insertElement(token, currentNs);
        }

        token.ackSelfClosing = true;
    }
}

function endTagInForeignContent(p, token) {
    for (let i = p.openElements.stackTop; i > 0; i--) {
        const element = p.openElements.items[i];

        if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
            p._processToken(token);
            break;
        }

        if (p.treeAdapter.getTagName(element).toLowerCase() === token.tagName) {
            p.openElements.popUntilElementPopped(element);
            break;
        }
    }
}


/***/ }),

/***/ 24939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const HTML = __webpack_require__(76256);

//Aliases
const $ = HTML.TAG_NAMES;
const NS = HTML.NAMESPACES;

//Element utils

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function isImpliedEndTagRequired(tn) {
    switch (tn.length) {
        case 1:
            return tn === $.P;

        case 2:
            return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI;

        case 3:
            return tn === $.RTC;

        case 6:
            return tn === $.OPTION;

        case 8:
            return tn === $.OPTGROUP;
    }

    return false;
}

function isImpliedEndTagRequiredThoroughly(tn) {
    switch (tn.length) {
        case 1:
            return tn === $.P;

        case 2:
            return (
                tn === $.RB ||
                tn === $.RP ||
                tn === $.RT ||
                tn === $.DD ||
                tn === $.DT ||
                tn === $.LI ||
                tn === $.TD ||
                tn === $.TH ||
                tn === $.TR
            );

        case 3:
            return tn === $.RTC;

        case 5:
            return tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD;

        case 6:
            return tn === $.OPTION;

        case 7:
            return tn === $.CAPTION;

        case 8:
            return tn === $.OPTGROUP || tn === $.COLGROUP;
    }

    return false;
}

function isScopingElement(tn, ns) {
    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH) {
                return ns === NS.HTML;
            } else if (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS) {
                return ns === NS.MATHML;
            }

            break;

        case 4:
            if (tn === $.HTML) {
                return ns === NS.HTML;
            } else if (tn === $.DESC) {
                return ns === NS.SVG;
            }

            break;

        case 5:
            if (tn === $.TABLE) {
                return ns === NS.HTML;
            } else if (tn === $.MTEXT) {
                return ns === NS.MATHML;
            } else if (tn === $.TITLE) {
                return ns === NS.SVG;
            }

            break;

        case 6:
            return (tn === $.APPLET || tn === $.OBJECT) && ns === NS.HTML;

        case 7:
            return (tn === $.CAPTION || tn === $.MARQUEE) && ns === NS.HTML;

        case 8:
            return tn === $.TEMPLATE && ns === NS.HTML;

        case 13:
            return tn === $.FOREIGN_OBJECT && ns === NS.SVG;

        case 14:
            return tn === $.ANNOTATION_XML && ns === NS.MATHML;
    }

    return false;
}

//Stack of open elements
class OpenElementStack {
    constructor(document, treeAdapter) {
        this.stackTop = -1;
        this.items = [];
        this.current = document;
        this.currentTagName = null;
        this.currentTmplContent = null;
        this.tmplCount = 0;
        this.treeAdapter = treeAdapter;
    }

    //Index of element
    _indexOf(element) {
        let idx = -1;

        for (let i = this.stackTop; i >= 0; i--) {
            if (this.items[i] === element) {
                idx = i;
                break;
            }
        }
        return idx;
    }

    //Update current element
    _isInTemplate() {
        return this.currentTagName === $.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
    }

    _updateCurrentElement() {
        this.current = this.items[this.stackTop];
        this.currentTagName = this.current && this.treeAdapter.getTagName(this.current);

        this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
    }

    //Mutations
    push(element) {
        this.items[++this.stackTop] = element;
        this._updateCurrentElement();

        if (this._isInTemplate()) {
            this.tmplCount++;
        }
    }

    pop() {
        this.stackTop--;

        if (this.tmplCount > 0 && this._isInTemplate()) {
            this.tmplCount--;
        }

        this._updateCurrentElement();
    }

    replace(oldElement, newElement) {
        const idx = this._indexOf(oldElement);

        this.items[idx] = newElement;

        if (idx === this.stackTop) {
            this._updateCurrentElement();
        }
    }

    insertAfter(referenceElement, newElement) {
        const insertionIdx = this._indexOf(referenceElement) + 1;

        this.items.splice(insertionIdx, 0, newElement);

        if (insertionIdx === ++this.stackTop) {
            this._updateCurrentElement();
        }
    }

    popUntilTagNamePopped(tagName) {
        while (this.stackTop > -1) {
            const tn = this.currentTagName;
            const ns = this.treeAdapter.getNamespaceURI(this.current);

            this.pop();

            if (tn === tagName && ns === NS.HTML) {
                break;
            }
        }
    }

    popUntilElementPopped(element) {
        while (this.stackTop > -1) {
            const poppedElement = this.current;

            this.pop();

            if (poppedElement === element) {
                break;
            }
        }
    }

    popUntilNumberedHeaderPopped() {
        while (this.stackTop > -1) {
            const tn = this.currentTagName;
            const ns = this.treeAdapter.getNamespaceURI(this.current);

            this.pop();

            if (
                tn === $.H1 ||
                tn === $.H2 ||
                tn === $.H3 ||
                tn === $.H4 ||
                tn === $.H5 ||
                (tn === $.H6 && ns === NS.HTML)
            ) {
                break;
            }
        }
    }

    popUntilTableCellPopped() {
        while (this.stackTop > -1) {
            const tn = this.currentTagName;
            const ns = this.treeAdapter.getNamespaceURI(this.current);

            this.pop();

            if (tn === $.TD || (tn === $.TH && ns === NS.HTML)) {
                break;
            }
        }
    }

    popAllUpToHtmlElement() {
        //NOTE: here we assume that root <html> element is always first in the open element stack, so
        //we perform this fast stack clean up.
        this.stackTop = 0;
        this._updateCurrentElement();
    }

    clearBackToTableContext() {
        while (
            (this.currentTagName !== $.TABLE && this.currentTagName !== $.TEMPLATE && this.currentTagName !== $.HTML) ||
            this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML
        ) {
            this.pop();
        }
    }

    clearBackToTableBodyContext() {
        while (
            (this.currentTagName !== $.TBODY &&
                this.currentTagName !== $.TFOOT &&
                this.currentTagName !== $.THEAD &&
                this.currentTagName !== $.TEMPLATE &&
                this.currentTagName !== $.HTML) ||
            this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML
        ) {
            this.pop();
        }
    }

    clearBackToTableRowContext() {
        while (
            (this.currentTagName !== $.TR && this.currentTagName !== $.TEMPLATE && this.currentTagName !== $.HTML) ||
            this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML
        ) {
            this.pop();
        }
    }

    remove(element) {
        for (let i = this.stackTop; i >= 0; i--) {
            if (this.items[i] === element) {
                this.items.splice(i, 1);
                this.stackTop--;
                this._updateCurrentElement();
                break;
            }
        }
    }

    //Search
    tryPeekProperlyNestedBodyElement() {
        //Properly nested <body> element (should be second element in stack).
        const element = this.items[1];

        return element && this.treeAdapter.getTagName(element) === $.BODY ? element : null;
    }

    contains(element) {
        return this._indexOf(element) > -1;
    }

    getCommonAncestor(element) {
        let elementIdx = this._indexOf(element);

        return --elementIdx >= 0 ? this.items[elementIdx] : null;
    }

    isRootHtmlElementCurrent() {
        return this.stackTop === 0 && this.currentTagName === $.HTML;
    }

    //Element in scope
    hasInScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (tn === tagName && ns === NS.HTML) {
                return true;
            }

            if (isScopingElement(tn, ns)) {
                return false;
            }
        }

        return true;
    }

    hasNumberedHeaderInScope() {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (
                (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) &&
                ns === NS.HTML
            ) {
                return true;
            }

            if (isScopingElement(tn, ns)) {
                return false;
            }
        }

        return true;
    }

    hasInListItemScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (tn === tagName && ns === NS.HTML) {
                return true;
            }

            if (((tn === $.UL || tn === $.OL) && ns === NS.HTML) || isScopingElement(tn, ns)) {
                return false;
            }
        }

        return true;
    }

    hasInButtonScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (tn === tagName && ns === NS.HTML) {
                return true;
            }

            if ((tn === $.BUTTON && ns === NS.HTML) || isScopingElement(tn, ns)) {
                return false;
            }
        }

        return true;
    }

    hasInTableScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (ns !== NS.HTML) {
                continue;
            }

            if (tn === tagName) {
                return true;
            }

            if (tn === $.TABLE || tn === $.TEMPLATE || tn === $.HTML) {
                return false;
            }
        }

        return true;
    }

    hasTableBodyContextInTableScope() {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (ns !== NS.HTML) {
                continue;
            }

            if (tn === $.TBODY || tn === $.THEAD || tn === $.TFOOT) {
                return true;
            }

            if (tn === $.TABLE || tn === $.HTML) {
                return false;
            }
        }

        return true;
    }

    hasInSelectScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (ns !== NS.HTML) {
                continue;
            }

            if (tn === tagName) {
                return true;
            }

            if (tn !== $.OPTION && tn !== $.OPTGROUP) {
                return false;
            }
        }

        return true;
    }

    //Implied end tags
    generateImpliedEndTags() {
        while (isImpliedEndTagRequired(this.currentTagName)) {
            this.pop();
        }
    }

    generateImpliedEndTagsThoroughly() {
        while (isImpliedEndTagRequiredThoroughly(this.currentTagName)) {
            this.pop();
        }
    }

    generateImpliedEndTagsWithExclusion(exclusionTagName) {
        while (isImpliedEndTagRequired(this.currentTagName) && this.currentTagName !== exclusionTagName) {
            this.pop();
        }
    }
}

module.exports = OpenElementStack;


/***/ }),

/***/ 19677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Preprocessor = __webpack_require__(30909);
const unicode = __webpack_require__(3749);
const neTree = __webpack_require__(6645);
const ERR = __webpack_require__(84166);

//Aliases
const $ = unicode.CODE_POINTS;
const $$ = unicode.CODE_POINT_SEQUENCES;

//C1 Unicode control character reference replacements
const C1_CONTROLS_REFERENCE_REPLACEMENTS = {
    0x80: 0x20ac,
    0x82: 0x201a,
    0x83: 0x0192,
    0x84: 0x201e,
    0x85: 0x2026,
    0x86: 0x2020,
    0x87: 0x2021,
    0x88: 0x02c6,
    0x89: 0x2030,
    0x8a: 0x0160,
    0x8b: 0x2039,
    0x8c: 0x0152,
    0x8e: 0x017d,
    0x91: 0x2018,
    0x92: 0x2019,
    0x93: 0x201c,
    0x94: 0x201d,
    0x95: 0x2022,
    0x96: 0x2013,
    0x97: 0x2014,
    0x98: 0x02dc,
    0x99: 0x2122,
    0x9a: 0x0161,
    0x9b: 0x203a,
    0x9c: 0x0153,
    0x9e: 0x017e,
    0x9f: 0x0178
};

// Named entity tree flags
const HAS_DATA_FLAG = 1 << 0;
const DATA_DUPLET_FLAG = 1 << 1;
const HAS_BRANCHES_FLAG = 1 << 2;
const MAX_BRANCH_MARKER_VALUE = HAS_DATA_FLAG | DATA_DUPLET_FLAG | HAS_BRANCHES_FLAG;

//States
const DATA_STATE = 'DATA_STATE';
const RCDATA_STATE = 'RCDATA_STATE';
const RAWTEXT_STATE = 'RAWTEXT_STATE';
const SCRIPT_DATA_STATE = 'SCRIPT_DATA_STATE';
const PLAINTEXT_STATE = 'PLAINTEXT_STATE';
const TAG_OPEN_STATE = 'TAG_OPEN_STATE';
const END_TAG_OPEN_STATE = 'END_TAG_OPEN_STATE';
const TAG_NAME_STATE = 'TAG_NAME_STATE';
const RCDATA_LESS_THAN_SIGN_STATE = 'RCDATA_LESS_THAN_SIGN_STATE';
const RCDATA_END_TAG_OPEN_STATE = 'RCDATA_END_TAG_OPEN_STATE';
const RCDATA_END_TAG_NAME_STATE = 'RCDATA_END_TAG_NAME_STATE';
const RAWTEXT_LESS_THAN_SIGN_STATE = 'RAWTEXT_LESS_THAN_SIGN_STATE';
const RAWTEXT_END_TAG_OPEN_STATE = 'RAWTEXT_END_TAG_OPEN_STATE';
const RAWTEXT_END_TAG_NAME_STATE = 'RAWTEXT_END_TAG_NAME_STATE';
const SCRIPT_DATA_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_LESS_THAN_SIGN_STATE';
const SCRIPT_DATA_END_TAG_OPEN_STATE = 'SCRIPT_DATA_END_TAG_OPEN_STATE';
const SCRIPT_DATA_END_TAG_NAME_STATE = 'SCRIPT_DATA_END_TAG_NAME_STATE';
const SCRIPT_DATA_ESCAPE_START_STATE = 'SCRIPT_DATA_ESCAPE_START_STATE';
const SCRIPT_DATA_ESCAPE_START_DASH_STATE = 'SCRIPT_DATA_ESCAPE_START_DASH_STATE';
const SCRIPT_DATA_ESCAPED_STATE = 'SCRIPT_DATA_ESCAPED_STATE';
const SCRIPT_DATA_ESCAPED_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_STATE';
const SCRIPT_DATA_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_DASH_STATE';
const SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE';
const SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE';
const SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPED_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE';
const BEFORE_ATTRIBUTE_NAME_STATE = 'BEFORE_ATTRIBUTE_NAME_STATE';
const ATTRIBUTE_NAME_STATE = 'ATTRIBUTE_NAME_STATE';
const AFTER_ATTRIBUTE_NAME_STATE = 'AFTER_ATTRIBUTE_NAME_STATE';
const BEFORE_ATTRIBUTE_VALUE_STATE = 'BEFORE_ATTRIBUTE_VALUE_STATE';
const ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE';
const ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE';
const ATTRIBUTE_VALUE_UNQUOTED_STATE = 'ATTRIBUTE_VALUE_UNQUOTED_STATE';
const AFTER_ATTRIBUTE_VALUE_QUOTED_STATE = 'AFTER_ATTRIBUTE_VALUE_QUOTED_STATE';
const SELF_CLOSING_START_TAG_STATE = 'SELF_CLOSING_START_TAG_STATE';
const BOGUS_COMMENT_STATE = 'BOGUS_COMMENT_STATE';
const MARKUP_DECLARATION_OPEN_STATE = 'MARKUP_DECLARATION_OPEN_STATE';
const COMMENT_START_STATE = 'COMMENT_START_STATE';
const COMMENT_START_DASH_STATE = 'COMMENT_START_DASH_STATE';
const COMMENT_STATE = 'COMMENT_STATE';
const COMMENT_LESS_THAN_SIGN_STATE = 'COMMENT_LESS_THAN_SIGN_STATE';
const COMMENT_LESS_THAN_SIGN_BANG_STATE = 'COMMENT_LESS_THAN_SIGN_BANG_STATE';
const COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE = 'COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE';
const COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE = 'COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE';
const COMMENT_END_DASH_STATE = 'COMMENT_END_DASH_STATE';
const COMMENT_END_STATE = 'COMMENT_END_STATE';
const COMMENT_END_BANG_STATE = 'COMMENT_END_BANG_STATE';
const DOCTYPE_STATE = 'DOCTYPE_STATE';
const BEFORE_DOCTYPE_NAME_STATE = 'BEFORE_DOCTYPE_NAME_STATE';
const DOCTYPE_NAME_STATE = 'DOCTYPE_NAME_STATE';
const AFTER_DOCTYPE_NAME_STATE = 'AFTER_DOCTYPE_NAME_STATE';
const AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE = 'AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE';
const BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE';
const DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE';
const DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE';
const AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE';
const BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE = 'BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE';
const AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE = 'AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE';
const BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE';
const DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE';
const DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE';
const AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE';
const BOGUS_DOCTYPE_STATE = 'BOGUS_DOCTYPE_STATE';
const CDATA_SECTION_STATE = 'CDATA_SECTION_STATE';
const CDATA_SECTION_BRACKET_STATE = 'CDATA_SECTION_BRACKET_STATE';
const CDATA_SECTION_END_STATE = 'CDATA_SECTION_END_STATE';
const CHARACTER_REFERENCE_STATE = 'CHARACTER_REFERENCE_STATE';
const NAMED_CHARACTER_REFERENCE_STATE = 'NAMED_CHARACTER_REFERENCE_STATE';
const AMBIGUOUS_AMPERSAND_STATE = 'AMBIGUOS_AMPERSAND_STATE';
const NUMERIC_CHARACTER_REFERENCE_STATE = 'NUMERIC_CHARACTER_REFERENCE_STATE';
const HEXADEMICAL_CHARACTER_REFERENCE_START_STATE = 'HEXADEMICAL_CHARACTER_REFERENCE_START_STATE';
const DECIMAL_CHARACTER_REFERENCE_START_STATE = 'DECIMAL_CHARACTER_REFERENCE_START_STATE';
const HEXADEMICAL_CHARACTER_REFERENCE_STATE = 'HEXADEMICAL_CHARACTER_REFERENCE_STATE';
const DECIMAL_CHARACTER_REFERENCE_STATE = 'DECIMAL_CHARACTER_REFERENCE_STATE';
const NUMERIC_CHARACTER_REFERENCE_END_STATE = 'NUMERIC_CHARACTER_REFERENCE_END_STATE';

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isWhitespace(cp) {
    return cp === $.SPACE || cp === $.LINE_FEED || cp === $.TABULATION || cp === $.FORM_FEED;
}

function isAsciiDigit(cp) {
    return cp >= $.DIGIT_0 && cp <= $.DIGIT_9;
}

function isAsciiUpper(cp) {
    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_Z;
}

function isAsciiLower(cp) {
    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_Z;
}

function isAsciiLetter(cp) {
    return isAsciiLower(cp) || isAsciiUpper(cp);
}

function isAsciiAlphaNumeric(cp) {
    return isAsciiLetter(cp) || isAsciiDigit(cp);
}

function isAsciiUpperHexDigit(cp) {
    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_F;
}

function isAsciiLowerHexDigit(cp) {
    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_F;
}

function isAsciiHexDigit(cp) {
    return isAsciiDigit(cp) || isAsciiUpperHexDigit(cp) || isAsciiLowerHexDigit(cp);
}

function toAsciiLowerCodePoint(cp) {
    return cp + 0x0020;
}

//NOTE: String.fromCharCode() function can handle only characters from BMP subset.
//So, we need to workaround this manually.
//(see: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/String/fromCharCode#Getting_it_to_work_with_higher_values)
function toChar(cp) {
    if (cp <= 0xffff) {
        return String.fromCharCode(cp);
    }

    cp -= 0x10000;
    return String.fromCharCode(((cp >>> 10) & 0x3ff) | 0xd800) + String.fromCharCode(0xdc00 | (cp & 0x3ff));
}

function toAsciiLowerChar(cp) {
    return String.fromCharCode(toAsciiLowerCodePoint(cp));
}

function findNamedEntityTreeBranch(nodeIx, cp) {
    const branchCount = neTree[++nodeIx];
    let lo = ++nodeIx;
    let hi = lo + branchCount - 1;

    while (lo <= hi) {
        const mid = (lo + hi) >>> 1;
        const midCp = neTree[mid];

        if (midCp < cp) {
            lo = mid + 1;
        } else if (midCp > cp) {
            hi = mid - 1;
        } else {
            return neTree[mid + branchCount];
        }
    }

    return -1;
}

//Tokenizer
class Tokenizer {
    constructor() {
        this.preprocessor = new Preprocessor();

        this.tokenQueue = [];

        this.allowCDATA = false;

        this.state = DATA_STATE;
        this.returnState = '';

        this.charRefCode = -1;
        this.tempBuff = [];
        this.lastStartTagName = '';

        this.consumedAfterSnapshot = -1;
        this.active = false;

        this.currentCharacterToken = null;
        this.currentToken = null;
        this.currentAttr = null;
    }

    //Errors
    _err() {
        // NOTE: err reporting is noop by default. Enabled by mixin.
    }

    _errOnNextCodePoint(err) {
        this._consume();
        this._err(err);
        this._unconsume();
    }

    //API
    getNextToken() {
        while (!this.tokenQueue.length && this.active) {
            this.consumedAfterSnapshot = 0;

            const cp = this._consume();

            if (!this._ensureHibernation()) {
                this[this.state](cp);
            }
        }

        return this.tokenQueue.shift();
    }

    write(chunk, isLastChunk) {
        this.active = true;
        this.preprocessor.write(chunk, isLastChunk);
    }

    insertHtmlAtCurrentPos(chunk) {
        this.active = true;
        this.preprocessor.insertHtmlAtCurrentPos(chunk);
    }

    //Hibernation
    _ensureHibernation() {
        if (this.preprocessor.endOfChunkHit) {
            for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--) {
                this.preprocessor.retreat();
            }

            this.active = false;
            this.tokenQueue.push({ type: Tokenizer.HIBERNATION_TOKEN });

            return true;
        }

        return false;
    }

    //Consumption
    _consume() {
        this.consumedAfterSnapshot++;
        return this.preprocessor.advance();
    }

    _unconsume() {
        this.consumedAfterSnapshot--;
        this.preprocessor.retreat();
    }

    _reconsumeInState(state) {
        this.state = state;
        this._unconsume();
    }

    _consumeSequenceIfMatch(pattern, startCp, caseSensitive) {
        let consumedCount = 0;
        let isMatch = true;
        const patternLength = pattern.length;
        let patternPos = 0;
        let cp = startCp;
        let patternCp = void 0;

        for (; patternPos < patternLength; patternPos++) {
            if (patternPos > 0) {
                cp = this._consume();
                consumedCount++;
            }

            if (cp === $.EOF) {
                isMatch = false;
                break;
            }

            patternCp = pattern[patternPos];

            if (cp !== patternCp && (caseSensitive || cp !== toAsciiLowerCodePoint(patternCp))) {
                isMatch = false;
                break;
            }
        }

        if (!isMatch) {
            while (consumedCount--) {
                this._unconsume();
            }
        }

        return isMatch;
    }

    //Temp buffer
    _isTempBufferEqualToScriptString() {
        if (this.tempBuff.length !== $$.SCRIPT_STRING.length) {
            return false;
        }

        for (let i = 0; i < this.tempBuff.length; i++) {
            if (this.tempBuff[i] !== $$.SCRIPT_STRING[i]) {
                return false;
            }
        }

        return true;
    }

    //Token creation
    _createStartTagToken() {
        this.currentToken = {
            type: Tokenizer.START_TAG_TOKEN,
            tagName: '',
            selfClosing: false,
            ackSelfClosing: false,
            attrs: []
        };
    }

    _createEndTagToken() {
        this.currentToken = {
            type: Tokenizer.END_TAG_TOKEN,
            tagName: '',
            selfClosing: false,
            attrs: []
        };
    }

    _createCommentToken() {
        this.currentToken = {
            type: Tokenizer.COMMENT_TOKEN,
            data: ''
        };
    }

    _createDoctypeToken(initialName) {
        this.currentToken = {
            type: Tokenizer.DOCTYPE_TOKEN,
            name: initialName,
            forceQuirks: false,
            publicId: null,
            systemId: null
        };
    }

    _createCharacterToken(type, ch) {
        this.currentCharacterToken = {
            type: type,
            chars: ch
        };
    }

    _createEOFToken() {
        this.currentToken = { type: Tokenizer.EOF_TOKEN };
    }

    //Tag attributes
    _createAttr(attrNameFirstCh) {
        this.currentAttr = {
            name: attrNameFirstCh,
            value: ''
        };
    }

    _leaveAttrName(toState) {
        if (Tokenizer.getTokenAttr(this.currentToken, this.currentAttr.name) === null) {
            this.currentToken.attrs.push(this.currentAttr);
        } else {
            this._err(ERR.duplicateAttribute);
        }

        this.state = toState;
    }

    _leaveAttrValue(toState) {
        this.state = toState;
    }

    //Token emission
    _emitCurrentToken() {
        this._emitCurrentCharacterToken();

        const ct = this.currentToken;

        this.currentToken = null;

        //NOTE: store emited start tag's tagName to determine is the following end tag token is appropriate.
        if (ct.type === Tokenizer.START_TAG_TOKEN) {
            this.lastStartTagName = ct.tagName;
        } else if (ct.type === Tokenizer.END_TAG_TOKEN) {
            if (ct.attrs.length > 0) {
                this._err(ERR.endTagWithAttributes);
            }

            if (ct.selfClosing) {
                this._err(ERR.endTagWithTrailingSolidus);
            }
        }

        this.tokenQueue.push(ct);
    }

    _emitCurrentCharacterToken() {
        if (this.currentCharacterToken) {
            this.tokenQueue.push(this.currentCharacterToken);
            this.currentCharacterToken = null;
        }
    }

    _emitEOFToken() {
        this._createEOFToken();
        this._emitCurrentToken();
    }

    //Characters emission

    //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(type, ch) {
        if (this.currentCharacterToken && this.currentCharacterToken.type !== type) {
            this._emitCurrentCharacterToken();
        }

        if (this.currentCharacterToken) {
            this.currentCharacterToken.chars += ch;
        } else {
            this._createCharacterToken(type, ch);
        }
    }

    _emitCodePoint(cp) {
        let type = Tokenizer.CHARACTER_TOKEN;

        if (isWhitespace(cp)) {
            type = Tokenizer.WHITESPACE_CHARACTER_TOKEN;
        } else if (cp === $.NULL) {
            type = Tokenizer.NULL_CHARACTER_TOKEN;
        }

        this._appendCharToCurrentCharacterToken(type, toChar(cp));
    }

    _emitSeveralCodePoints(codePoints) {
        for (let i = 0; i < codePoints.length; i++) {
            this._emitCodePoint(codePoints[i]);
        }
    }

    //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
    //So we can avoid additional checks here.
    _emitChars(ch) {
        this._appendCharToCurrentCharacterToken(Tokenizer.CHARACTER_TOKEN, ch);
    }

    // Character reference helpers
    _matchNamedCharacterReference(startCp) {
        let result = null;
        let excess = 1;
        let i = findNamedEntityTreeBranch(0, startCp);

        this.tempBuff.push(startCp);

        while (i > -1) {
            const current = neTree[i];
            const inNode = current < MAX_BRANCH_MARKER_VALUE;
            const nodeWithData = inNode && current & HAS_DATA_FLAG;

            if (nodeWithData) {
                //NOTE: we use greedy search, so we continue lookup at this point
                result = current & DATA_DUPLET_FLAG ? [neTree[++i], neTree[++i]] : [neTree[++i]];
                excess = 0;
            }

            const cp = this._consume();

            this.tempBuff.push(cp);
            excess++;

            if (cp === $.EOF) {
                break;
            }

            if (inNode) {
                i = current & HAS_BRANCHES_FLAG ? findNamedEntityTreeBranch(i, cp) : -1;
            } else {
                i = cp === current ? ++i : -1;
            }
        }

        while (excess--) {
            this.tempBuff.pop();
            this._unconsume();
        }

        return result;
    }

    _isCharacterReferenceInAttribute() {
        return (
            this.returnState === ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE ||
            this.returnState === ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE ||
            this.returnState === ATTRIBUTE_VALUE_UNQUOTED_STATE
        );
    }

    _isCharacterReferenceAttributeQuirk(withSemicolon) {
        if (!withSemicolon && this._isCharacterReferenceInAttribute()) {
            const nextCp = this._consume();

            this._unconsume();

            return nextCp === $.EQUALS_SIGN || isAsciiAlphaNumeric(nextCp);
        }

        return false;
    }

    _flushCodePointsConsumedAsCharacterReference() {
        if (this._isCharacterReferenceInAttribute()) {
            for (let i = 0; i < this.tempBuff.length; i++) {
                this.currentAttr.value += toChar(this.tempBuff[i]);
            }
        } else {
            this._emitSeveralCodePoints(this.tempBuff);
        }

        this.tempBuff = [];
    }

    // State machine

    // Data state
    //------------------------------------------------------------------
    [DATA_STATE](cp) {
        this.preprocessor.dropParsedChunk();

        if (cp === $.LESS_THAN_SIGN) {
            this.state = TAG_OPEN_STATE;
        } else if (cp === $.AMPERSAND) {
            this.returnState = DATA_STATE;
            this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitCodePoint(cp);
        } else if (cp === $.EOF) {
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    //  RCDATA state
    //------------------------------------------------------------------
    [RCDATA_STATE](cp) {
        this.preprocessor.dropParsedChunk();

        if (cp === $.AMPERSAND) {
            this.returnState = RCDATA_STATE;
            this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = RCDATA_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // RAWTEXT state
    //------------------------------------------------------------------
    [RAWTEXT_STATE](cp) {
        this.preprocessor.dropParsedChunk();

        if (cp === $.LESS_THAN_SIGN) {
            this.state = RAWTEXT_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // Script data state
    //------------------------------------------------------------------
    [SCRIPT_DATA_STATE](cp) {
        this.preprocessor.dropParsedChunk();

        if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // PLAINTEXT state
    //------------------------------------------------------------------
    [PLAINTEXT_STATE](cp) {
        this.preprocessor.dropParsedChunk();

        if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // Tag open state
    //------------------------------------------------------------------
    [TAG_OPEN_STATE](cp) {
        if (cp === $.EXCLAMATION_MARK) {
            this.state = MARKUP_DECLARATION_OPEN_STATE;
        } else if (cp === $.SOLIDUS) {
            this.state = END_TAG_OPEN_STATE;
        } else if (isAsciiLetter(cp)) {
            this._createStartTagToken();
            this._reconsumeInState(TAG_NAME_STATE);
        } else if (cp === $.QUESTION_MARK) {
            this._err(ERR.unexpectedQuestionMarkInsteadOfTagName);
            this._createCommentToken();
            this._reconsumeInState(BOGUS_COMMENT_STATE);
        } else if (cp === $.EOF) {
            this._err(ERR.eofBeforeTagName);
            this._emitChars('<');
            this._emitEOFToken();
        } else {
            this._err(ERR.invalidFirstCharacterOfTagName);
            this._emitChars('<');
            this._reconsumeInState(DATA_STATE);
        }
    }

    // End tag open state
    //------------------------------------------------------------------
    [END_TAG_OPEN_STATE](cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState(TAG_NAME_STATE);
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingEndTagName);
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofBeforeTagName);
            this._emitChars('</');
            this._emitEOFToken();
        } else {
            this._err(ERR.invalidFirstCharacterOfTagName);
            this._createCommentToken();
            this._reconsumeInState(BOGUS_COMMENT_STATE);
        }
    }

    // Tag name state
    //------------------------------------------------------------------
    [TAG_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = BEFORE_ATTRIBUTE_NAME_STATE;
        } else if (cp === $.SOLIDUS) {
            this.state = SELF_CLOSING_START_TAG_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (isAsciiUpper(cp)) {
            this.currentToken.tagName += toAsciiLowerChar(cp);
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.tagName += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this.currentToken.tagName += toChar(cp);
        }
    }

    // RCDATA less-than sign state
    //------------------------------------------------------------------
    [RCDATA_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.SOLIDUS) {
            this.tempBuff = [];
            this.state = RCDATA_END_TAG_OPEN_STATE;
        } else {
            this._emitChars('<');
            this._reconsumeInState(RCDATA_STATE);
        }
    }

    // RCDATA end tag open state
    //------------------------------------------------------------------
    [RCDATA_END_TAG_OPEN_STATE](cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState(RCDATA_END_TAG_NAME_STATE);
        } else {
            this._emitChars('</');
            this._reconsumeInState(RCDATA_STATE);
        }
    }

    // RCDATA end tag name state
    //------------------------------------------------------------------
    [RCDATA_END_TAG_NAME_STATE](cp) {
        if (isAsciiUpper(cp)) {
            this.currentToken.tagName += toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
            this.currentToken.tagName += toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if (isWhitespace(cp)) {
                    this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                }

                if (cp === $.SOLIDUS) {
                    this.state = SELF_CLOSING_START_TAG_STATE;
                    return;
                }

                if (cp === $.GREATER_THAN_SIGN) {
                    this.state = DATA_STATE;
                    this._emitCurrentToken();
                    return;
                }
            }

            this._emitChars('</');
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState(RCDATA_STATE);
        }
    }

    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    [RAWTEXT_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.SOLIDUS) {
            this.tempBuff = [];
            this.state = RAWTEXT_END_TAG_OPEN_STATE;
        } else {
            this._emitChars('<');
            this._reconsumeInState(RAWTEXT_STATE);
        }
    }

    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    [RAWTEXT_END_TAG_OPEN_STATE](cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState(RAWTEXT_END_TAG_NAME_STATE);
        } else {
            this._emitChars('</');
            this._reconsumeInState(RAWTEXT_STATE);
        }
    }

    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    [RAWTEXT_END_TAG_NAME_STATE](cp) {
        if (isAsciiUpper(cp)) {
            this.currentToken.tagName += toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
            this.currentToken.tagName += toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if (isWhitespace(cp)) {
                    this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                }

                if (cp === $.SOLIDUS) {
                    this.state = SELF_CLOSING_START_TAG_STATE;
                    return;
                }

                if (cp === $.GREATER_THAN_SIGN) {
                    this._emitCurrentToken();
                    this.state = DATA_STATE;
                    return;
                }
            }

            this._emitChars('</');
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState(RAWTEXT_STATE);
        }
    }

    // Script data less-than sign state
    //------------------------------------------------------------------
    [SCRIPT_DATA_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.SOLIDUS) {
            this.tempBuff = [];
            this.state = SCRIPT_DATA_END_TAG_OPEN_STATE;
        } else if (cp === $.EXCLAMATION_MARK) {
            this.state = SCRIPT_DATA_ESCAPE_START_STATE;
            this._emitChars('<!');
        } else {
            this._emitChars('<');
            this._reconsumeInState(SCRIPT_DATA_STATE);
        }
    }

    // Script data end tag open state
    //------------------------------------------------------------------
    [SCRIPT_DATA_END_TAG_OPEN_STATE](cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState(SCRIPT_DATA_END_TAG_NAME_STATE);
        } else {
            this._emitChars('</');
            this._reconsumeInState(SCRIPT_DATA_STATE);
        }
    }

    // Script data end tag name state
    //------------------------------------------------------------------
    [SCRIPT_DATA_END_TAG_NAME_STATE](cp) {
        if (isAsciiUpper(cp)) {
            this.currentToken.tagName += toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
            this.currentToken.tagName += toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if (isWhitespace(cp)) {
                    this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                } else if (cp === $.SOLIDUS) {
                    this.state = SELF_CLOSING_START_TAG_STATE;
                    return;
                } else if (cp === $.GREATER_THAN_SIGN) {
                    this._emitCurrentToken();
                    this.state = DATA_STATE;
                    return;
                }
            }

            this._emitChars('</');
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState(SCRIPT_DATA_STATE);
        }
    }

    // Script data escape start state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPE_START_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_ESCAPE_START_DASH_STATE;
            this._emitChars('-');
        } else {
            this._reconsumeInState(SCRIPT_DATA_STATE);
        }
    }

    // Script data escape start dash state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPE_START_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
            this._emitChars('-');
        } else {
            this._reconsumeInState(SCRIPT_DATA_STATE);
        }
    }

    // Script data escaped state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_ESCAPED_DASH_STATE;
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // Script data escaped dash state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.state = SCRIPT_DATA_ESCAPED_STATE;
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = SCRIPT_DATA_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }

    // Script data escaped dash dash state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_DASH_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = SCRIPT_DATA_STATE;
            this._emitChars('>');
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.state = SCRIPT_DATA_ESCAPED_STATE;
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = SCRIPT_DATA_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }

    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.SOLIDUS) {
            this.tempBuff = [];
            this.state = SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE;
        } else if (isAsciiLetter(cp)) {
            this.tempBuff = [];
            this._emitChars('<');
            this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE);
        } else {
            this._emitChars('<');
            this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
    }

    // Script data escaped end tag open state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE](cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState(SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE);
        } else {
            this._emitChars('</');
            this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
    }

    // Script data escaped end tag name state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE](cp) {
        if (isAsciiUpper(cp)) {
            this.currentToken.tagName += toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
            this.currentToken.tagName += toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if (isWhitespace(cp)) {
                    this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                }

                if (cp === $.SOLIDUS) {
                    this.state = SELF_CLOSING_START_TAG_STATE;
                    return;
                }

                if (cp === $.GREATER_THAN_SIGN) {
                    this._emitCurrentToken();
                    this.state = DATA_STATE;
                    return;
                }
            }

            this._emitChars('</');
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
    }

    // Script data double escape start state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE](cp) {
        if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
            this.state = this._isTempBufferEqualToScriptString()
                ? SCRIPT_DATA_DOUBLE_ESCAPED_STATE
                : SCRIPT_DATA_ESCAPED_STATE;
            this._emitCodePoint(cp);
        } else if (isAsciiUpper(cp)) {
            this.tempBuff.push(toAsciiLowerCodePoint(cp));
            this._emitCodePoint(cp);
        } else if (isAsciiLower(cp)) {
            this.tempBuff.push(cp);
            this._emitCodePoint(cp);
        } else {
            this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
    }

    // Script data double escaped state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPED_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE;
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
            this._emitChars('<');
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // Script data double escaped dash state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE;
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
            this._emitChars('<');
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }

    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
            this._emitChars('<');
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = SCRIPT_DATA_STATE;
            this._emitChars('>');
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }

    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.SOLIDUS) {
            this.tempBuff = [];
            this.state = SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE;
            this._emitChars('/');
        } else {
            this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
        }
    }

    // Script data double escape end state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE](cp) {
        if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
            this.state = this._isTempBufferEqualToScriptString()
                ? SCRIPT_DATA_ESCAPED_STATE
                : SCRIPT_DATA_DOUBLE_ESCAPED_STATE;

            this._emitCodePoint(cp);
        } else if (isAsciiUpper(cp)) {
            this.tempBuff.push(toAsciiLowerCodePoint(cp));
            this._emitCodePoint(cp);
        } else if (isAsciiLower(cp)) {
            this.tempBuff.push(cp);
            this._emitCodePoint(cp);
        } else {
            this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
        }
    }

    // Before attribute name state
    //------------------------------------------------------------------
    [BEFORE_ATTRIBUTE_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
            this._reconsumeInState(AFTER_ATTRIBUTE_NAME_STATE);
        } else if (cp === $.EQUALS_SIGN) {
            this._err(ERR.unexpectedEqualsSignBeforeAttributeName);
            this._createAttr('=');
            this.state = ATTRIBUTE_NAME_STATE;
        } else {
            this._createAttr('');
            this._reconsumeInState(ATTRIBUTE_NAME_STATE);
        }
    }

    // Attribute name state
    //------------------------------------------------------------------
    [ATTRIBUTE_NAME_STATE](cp) {
        if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
            this._leaveAttrName(AFTER_ATTRIBUTE_NAME_STATE);
            this._unconsume();
        } else if (cp === $.EQUALS_SIGN) {
            this._leaveAttrName(BEFORE_ATTRIBUTE_VALUE_STATE);
        } else if (isAsciiUpper(cp)) {
            this.currentAttr.name += toAsciiLowerChar(cp);
        } else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN) {
            this._err(ERR.unexpectedCharacterInAttributeName);
            this.currentAttr.name += toChar(cp);
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.name += unicode.REPLACEMENT_CHARACTER;
        } else {
            this.currentAttr.name += toChar(cp);
        }
    }

    // After attribute name state
    //------------------------------------------------------------------
    [AFTER_ATTRIBUTE_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.SOLIDUS) {
            this.state = SELF_CLOSING_START_TAG_STATE;
        } else if (cp === $.EQUALS_SIGN) {
            this.state = BEFORE_ATTRIBUTE_VALUE_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this._createAttr('');
            this._reconsumeInState(ATTRIBUTE_NAME_STATE);
        }
    }

    // Before attribute value state
    //------------------------------------------------------------------
    [BEFORE_ATTRIBUTE_VALUE_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.QUOTATION_MARK) {
            this.state = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this.state = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingAttributeValue);
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else {
            this._reconsumeInState(ATTRIBUTE_VALUE_UNQUOTED_STATE);
        }
    }

    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    [ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE](cp) {
        if (cp === $.QUOTATION_MARK) {
            this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
        } else if (cp === $.AMPERSAND) {
            this.returnState = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
            this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.value += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this.currentAttr.value += toChar(cp);
        }
    }

    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    [ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE](cp) {
        if (cp === $.APOSTROPHE) {
            this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
        } else if (cp === $.AMPERSAND) {
            this.returnState = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
            this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.value += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this.currentAttr.value += toChar(cp);
        }
    }

    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    [ATTRIBUTE_VALUE_UNQUOTED_STATE](cp) {
        if (isWhitespace(cp)) {
            this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);
        } else if (cp === $.AMPERSAND) {
            this.returnState = ATTRIBUTE_VALUE_UNQUOTED_STATE;
            this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._leaveAttrValue(DATA_STATE);
            this._emitCurrentToken();
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.value += unicode.REPLACEMENT_CHARACTER;
        } else if (
            cp === $.QUOTATION_MARK ||
            cp === $.APOSTROPHE ||
            cp === $.LESS_THAN_SIGN ||
            cp === $.EQUALS_SIGN ||
            cp === $.GRAVE_ACCENT
        ) {
            this._err(ERR.unexpectedCharacterInUnquotedAttributeValue);
            this.currentAttr.value += toChar(cp);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this.currentAttr.value += toChar(cp);
        }
    }

    // After attribute value (quoted) state
    //------------------------------------------------------------------
    [AFTER_ATTRIBUTE_VALUE_QUOTED_STATE](cp) {
        if (isWhitespace(cp)) {
            this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);
        } else if (cp === $.SOLIDUS) {
            this._leaveAttrValue(SELF_CLOSING_START_TAG_STATE);
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._leaveAttrValue(DATA_STATE);
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this._err(ERR.missingWhitespaceBetweenAttributes);
            this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
        }
    }

    // Self-closing start tag state
    //------------------------------------------------------------------
    [SELF_CLOSING_START_TAG_STATE](cp) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.currentToken.selfClosing = true;
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this._err(ERR.unexpectedSolidusInTag);
            this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
        }
    }

    // Bogus comment state
    //------------------------------------------------------------------
    [BOGUS_COMMENT_STATE](cp) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._emitCurrentToken();
            this._emitEOFToken();
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.data += unicode.REPLACEMENT_CHARACTER;
        } else {
            this.currentToken.data += toChar(cp);
        }
    }

    // Markup declaration open state
    //------------------------------------------------------------------
    [MARKUP_DECLARATION_OPEN_STATE](cp) {
        if (this._consumeSequenceIfMatch($$.DASH_DASH_STRING, cp, true)) {
            this._createCommentToken();
            this.state = COMMENT_START_STATE;
        } else if (this._consumeSequenceIfMatch($$.DOCTYPE_STRING, cp, false)) {
            this.state = DOCTYPE_STATE;
        } else if (this._consumeSequenceIfMatch($$.CDATA_START_STRING, cp, true)) {
            if (this.allowCDATA) {
                this.state = CDATA_SECTION_STATE;
            } else {
                this._err(ERR.cdataInHtmlContent);
                this._createCommentToken();
                this.currentToken.data = '[CDATA[';
                this.state = BOGUS_COMMENT_STATE;
            }
        }

        //NOTE: sequence lookup can be abrupted by hibernation. In that case lookup
        //results are no longer valid and we will need to start over.
        else if (!this._ensureHibernation()) {
            this._err(ERR.incorrectlyOpenedComment);
            this._createCommentToken();
            this._reconsumeInState(BOGUS_COMMENT_STATE);
        }
    }

    // Comment start state
    //------------------------------------------------------------------
    [COMMENT_START_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_START_DASH_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptClosingOfEmptyComment);
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else {
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment start dash state
    //------------------------------------------------------------------
    [COMMENT_START_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_END_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptClosingOfEmptyComment);
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += '-';
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment state
    //------------------------------------------------------------------
    [COMMENT_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_END_DASH_STATE;
        } else if (cp === $.LESS_THAN_SIGN) {
            this.currentToken.data += '<';
            this.state = COMMENT_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.data += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += toChar(cp);
        }
    }

    // Comment less-than sign state
    //------------------------------------------------------------------
    [COMMENT_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.EXCLAMATION_MARK) {
            this.currentToken.data += '!';
            this.state = COMMENT_LESS_THAN_SIGN_BANG_STATE;
        } else if (cp === $.LESS_THAN_SIGN) {
            this.currentToken.data += '!';
        } else {
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment less-than sign bang state
    //------------------------------------------------------------------
    [COMMENT_LESS_THAN_SIGN_BANG_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE;
        } else {
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    [COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE;
        } else {
            this._reconsumeInState(COMMENT_END_DASH_STATE);
        }
    }

    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    [COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE](cp) {
        if (cp !== $.GREATER_THAN_SIGN && cp !== $.EOF) {
            this._err(ERR.nestedComment);
        }

        this._reconsumeInState(COMMENT_END_STATE);
    }

    // Comment end dash state
    //------------------------------------------------------------------
    [COMMENT_END_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_END_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += '-';
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment end state
    //------------------------------------------------------------------
    [COMMENT_END_STATE](cp) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EXCLAMATION_MARK) {
            this.state = COMMENT_END_BANG_STATE;
        } else if (cp === $.HYPHEN_MINUS) {
            this.currentToken.data += '-';
        } else if (cp === $.EOF) {
            this._err(ERR.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += '--';
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment end bang state
    //------------------------------------------------------------------
    [COMMENT_END_BANG_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.currentToken.data += '--!';
            this.state = COMMENT_END_DASH_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.incorrectlyClosedComment);
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += '--!';
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // DOCTYPE state
    //------------------------------------------------------------------
    [DOCTYPE_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = BEFORE_DOCTYPE_NAME_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._reconsumeInState(BEFORE_DOCTYPE_NAME_STATE);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this._createDoctypeToken(null);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingWhitespaceBeforeDoctypeName);
            this._reconsumeInState(BEFORE_DOCTYPE_NAME_STATE);
        }
    }

    // Before DOCTYPE name state
    //------------------------------------------------------------------
    [BEFORE_DOCTYPE_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (isAsciiUpper(cp)) {
            this._createDoctypeToken(toAsciiLowerChar(cp));
            this.state = DOCTYPE_NAME_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._createDoctypeToken(unicode.REPLACEMENT_CHARACTER);
            this.state = DOCTYPE_NAME_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingDoctypeName);
            this._createDoctypeToken(null);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this._createDoctypeToken(null);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._createDoctypeToken(toChar(cp));
            this.state = DOCTYPE_NAME_STATE;
        }
    }

    // DOCTYPE name state
    //------------------------------------------------------------------
    [DOCTYPE_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = AFTER_DOCTYPE_NAME_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (isAsciiUpper(cp)) {
            this.currentToken.name += toAsciiLowerChar(cp);
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.name += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.name += toChar(cp);
        }
    }

    // After DOCTYPE name state
    //------------------------------------------------------------------
    [AFTER_DOCTYPE_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else if (this._consumeSequenceIfMatch($$.PUBLIC_STRING, cp, false)) {
            this.state = AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE;
        } else if (this._consumeSequenceIfMatch($$.SYSTEM_STRING, cp, false)) {
            this.state = AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE;
        }
        //NOTE: sequence lookup can be abrupted by hibernation. In that case lookup
        //results are no longer valid and we will need to start over.
        else if (!this._ensureHibernation()) {
            this._err(ERR.invalidCharacterSequenceAfterDoctypeName);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    [AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        } else if (cp === $.QUOTATION_MARK) {
            this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
            this.currentToken.publicId = '';
            this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
            this.currentToken.publicId = '';
            this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    [BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.QUOTATION_MARK) {
            this.currentToken.publicId = '';
            this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this.currentToken.publicId = '';
            this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    [DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE](cp) {
        if (cp === $.QUOTATION_MARK) {
            this.state = AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.publicId += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.publicId += toChar(cp);
        }
    }

    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    [DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE](cp) {
        if (cp === $.APOSTROPHE) {
            this.state = AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.publicId += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.publicId += toChar(cp);
        }
    }

    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    [AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.QUOTATION_MARK) {
            this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    [BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.QUOTATION_MARK) {
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    [AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        } else if (cp === $.QUOTATION_MARK) {
            this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    [BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.QUOTATION_MARK) {
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    [DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE](cp) {
        if (cp === $.QUOTATION_MARK) {
            this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.systemId += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.systemId += toChar(cp);
        }
    }

    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    [DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE](cp) {
        if (cp === $.APOSTROPHE) {
            this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.systemId += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.systemId += toChar(cp);
        }
    }

    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    [AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.unexpectedCharacterAfterDoctypeSystemIdentifier);
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    [BOGUS_DOCTYPE_STATE](cp) {
        if (cp === $.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
        } else if (cp === $.EOF) {
            this._emitCurrentToken();
            this._emitEOFToken();
        }
    }

    // CDATA section state
    //------------------------------------------------------------------
    [CDATA_SECTION_STATE](cp) {
        if (cp === $.RIGHT_SQUARE_BRACKET) {
            this.state = CDATA_SECTION_BRACKET_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInCdata);
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // CDATA section bracket state
    //------------------------------------------------------------------
    [CDATA_SECTION_BRACKET_STATE](cp) {
        if (cp === $.RIGHT_SQUARE_BRACKET) {
            this.state = CDATA_SECTION_END_STATE;
        } else {
            this._emitChars(']');
            this._reconsumeInState(CDATA_SECTION_STATE);
        }
    }

    // CDATA section end state
    //------------------------------------------------------------------
    [CDATA_SECTION_END_STATE](cp) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
        } else if (cp === $.RIGHT_SQUARE_BRACKET) {
            this._emitChars(']');
        } else {
            this._emitChars(']]');
            this._reconsumeInState(CDATA_SECTION_STATE);
        }
    }

    // Character reference state
    //------------------------------------------------------------------
    [CHARACTER_REFERENCE_STATE](cp) {
        this.tempBuff = [$.AMPERSAND];

        if (cp === $.NUMBER_SIGN) {
            this.tempBuff.push(cp);
            this.state = NUMERIC_CHARACTER_REFERENCE_STATE;
        } else if (isAsciiAlphaNumeric(cp)) {
            this._reconsumeInState(NAMED_CHARACTER_REFERENCE_STATE);
        } else {
            this._flushCodePointsConsumedAsCharacterReference();
            this._reconsumeInState(this.returnState);
        }
    }

    // Named character reference state
    //------------------------------------------------------------------
    [NAMED_CHARACTER_REFERENCE_STATE](cp) {
        const matchResult = this._matchNamedCharacterReference(cp);

        //NOTE: matching can be abrupted by hibernation. In that case match
        //results are no longer valid and we will need to start over.
        if (this._ensureHibernation()) {
            this.tempBuff = [$.AMPERSAND];
        } else if (matchResult) {
            const withSemicolon = this.tempBuff[this.tempBuff.length - 1] === $.SEMICOLON;

            if (!this._isCharacterReferenceAttributeQuirk(withSemicolon)) {
                if (!withSemicolon) {
                    this._errOnNextCodePoint(ERR.missingSemicolonAfterCharacterReference);
                }

                this.tempBuff = matchResult;
            }

            this._flushCodePointsConsumedAsCharacterReference();
            this.state = this.returnState;
        } else {
            this._flushCodePointsConsumedAsCharacterReference();
            this.state = AMBIGUOUS_AMPERSAND_STATE;
        }
    }

    // Ambiguos ampersand state
    //------------------------------------------------------------------
    [AMBIGUOUS_AMPERSAND_STATE](cp) {
        if (isAsciiAlphaNumeric(cp)) {
            if (this._isCharacterReferenceInAttribute()) {
                this.currentAttr.value += toChar(cp);
            } else {
                this._emitCodePoint(cp);
            }
        } else {
            if (cp === $.SEMICOLON) {
                this._err(ERR.unknownNamedCharacterReference);
            }

            this._reconsumeInState(this.returnState);
        }
    }

    // Numeric character reference state
    //------------------------------------------------------------------
    [NUMERIC_CHARACTER_REFERENCE_STATE](cp) {
        this.charRefCode = 0;

        if (cp === $.LATIN_SMALL_X || cp === $.LATIN_CAPITAL_X) {
            this.tempBuff.push(cp);
            this.state = HEXADEMICAL_CHARACTER_REFERENCE_START_STATE;
        } else {
            this._reconsumeInState(DECIMAL_CHARACTER_REFERENCE_START_STATE);
        }
    }

    // Hexademical character reference start state
    //------------------------------------------------------------------
    [HEXADEMICAL_CHARACTER_REFERENCE_START_STATE](cp) {
        if (isAsciiHexDigit(cp)) {
            this._reconsumeInState(HEXADEMICAL_CHARACTER_REFERENCE_STATE);
        } else {
            this._err(ERR.absenceOfDigitsInNumericCharacterReference);
            this._flushCodePointsConsumedAsCharacterReference();
            this._reconsumeInState(this.returnState);
        }
    }

    // Decimal character reference start state
    //------------------------------------------------------------------
    [DECIMAL_CHARACTER_REFERENCE_START_STATE](cp) {
        if (isAsciiDigit(cp)) {
            this._reconsumeInState(DECIMAL_CHARACTER_REFERENCE_STATE);
        } else {
            this._err(ERR.absenceOfDigitsInNumericCharacterReference);
            this._flushCodePointsConsumedAsCharacterReference();
            this._reconsumeInState(this.returnState);
        }
    }

    // Hexademical character reference state
    //------------------------------------------------------------------
    [HEXADEMICAL_CHARACTER_REFERENCE_STATE](cp) {
        if (isAsciiUpperHexDigit(cp)) {
            this.charRefCode = this.charRefCode * 16 + cp - 0x37;
        } else if (isAsciiLowerHexDigit(cp)) {
            this.charRefCode = this.charRefCode * 16 + cp - 0x57;
        } else if (isAsciiDigit(cp)) {
            this.charRefCode = this.charRefCode * 16 + cp - 0x30;
        } else if (cp === $.SEMICOLON) {
            this.state = NUMERIC_CHARACTER_REFERENCE_END_STATE;
        } else {
            this._err(ERR.missingSemicolonAfterCharacterReference);
            this._reconsumeInState(NUMERIC_CHARACTER_REFERENCE_END_STATE);
        }
    }

    // Decimal character reference state
    //------------------------------------------------------------------
    [DECIMAL_CHARACTER_REFERENCE_STATE](cp) {
        if (isAsciiDigit(cp)) {
            this.charRefCode = this.charRefCode * 10 + cp - 0x30;
        } else if (cp === $.SEMICOLON) {
            this.state = NUMERIC_CHARACTER_REFERENCE_END_STATE;
        } else {
            this._err(ERR.missingSemicolonAfterCharacterReference);
            this._reconsumeInState(NUMERIC_CHARACTER_REFERENCE_END_STATE);
        }
    }

    // Numeric character reference end state
    //------------------------------------------------------------------
    [NUMERIC_CHARACTER_REFERENCE_END_STATE]() {
        if (this.charRefCode === $.NULL) {
            this._err(ERR.nullCharacterReference);
            this.charRefCode = $.REPLACEMENT_CHARACTER;
        } else if (this.charRefCode > 0x10ffff) {
            this._err(ERR.characterReferenceOutsideUnicodeRange);
            this.charRefCode = $.REPLACEMENT_CHARACTER;
        } else if (unicode.isSurrogate(this.charRefCode)) {
            this._err(ERR.surrogateCharacterReference);
            this.charRefCode = $.REPLACEMENT_CHARACTER;
        } else if (unicode.isUndefinedCodePoint(this.charRefCode)) {
            this._err(ERR.noncharacterCharacterReference);
        } else if (unicode.isControlCodePoint(this.charRefCode) || this.charRefCode === $.CARRIAGE_RETURN) {
            this._err(ERR.controlCharacterReference);

            const replacement = C1_CONTROLS_REFERENCE_REPLACEMENTS[this.charRefCode];

            if (replacement) {
                this.charRefCode = replacement;
            }
        }

        this.tempBuff = [this.charRefCode];

        this._flushCodePointsConsumedAsCharacterReference();
        this._reconsumeInState(this.returnState);
    }
}

//Token types
Tokenizer.CHARACTER_TOKEN = 'CHARACTER_TOKEN';
Tokenizer.NULL_CHARACTER_TOKEN = 'NULL_CHARACTER_TOKEN';
Tokenizer.WHITESPACE_CHARACTER_TOKEN = 'WHITESPACE_CHARACTER_TOKEN';
Tokenizer.START_TAG_TOKEN = 'START_TAG_TOKEN';
Tokenizer.END_TAG_TOKEN = 'END_TAG_TOKEN';
Tokenizer.COMMENT_TOKEN = 'COMMENT_TOKEN';
Tokenizer.DOCTYPE_TOKEN = 'DOCTYPE_TOKEN';
Tokenizer.EOF_TOKEN = 'EOF_TOKEN';
Tokenizer.HIBERNATION_TOKEN = 'HIBERNATION_TOKEN';

//Tokenizer initial states for different modes
Tokenizer.MODE = {
    DATA: DATA_STATE,
    RCDATA: RCDATA_STATE,
    RAWTEXT: RAWTEXT_STATE,
    SCRIPT_DATA: SCRIPT_DATA_STATE,
    PLAINTEXT: PLAINTEXT_STATE
};

//Static
Tokenizer.getTokenAttr = function(token, attrName) {
    for (let i = token.attrs.length - 1; i >= 0; i--) {
        if (token.attrs[i].name === attrName) {
            return token.attrs[i].value;
        }
    }

    return null;
};

module.exports = Tokenizer;


/***/ }),

/***/ 6645:
/***/ (function(module) {

"use strict";


//NOTE: this file contains auto-generated array mapped radix tree that is used for the named entity references consumption
//(details: https://github.com/inikulin/parse5/tree/master/scripts/generate-named-entity-data/README.md)
module.exports = new Uint16Array([4,52,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,106,303,412,810,1432,1701,1796,1987,2114,2360,2420,2484,3170,3251,4140,4393,4575,4610,5106,5512,5728,6117,6274,6315,6345,6427,6516,7002,7910,8733,9323,9870,10170,10631,10893,11318,11386,11467,12773,13092,14474,14922,15448,15542,16419,17666,18166,18611,19004,19095,19298,19397,4,16,69,77,97,98,99,102,103,108,109,110,111,112,114,115,116,117,140,150,158,169,176,194,199,210,216,222,226,242,256,266,283,294,108,105,103,5,198,1,59,148,1,198,80,5,38,1,59,156,1,38,99,117,116,101,5,193,1,59,167,1,193,114,101,118,101,59,1,258,4,2,105,121,182,191,114,99,5,194,1,59,189,1,194,59,1,1040,114,59,3,55349,56580,114,97,118,101,5,192,1,59,208,1,192,112,104,97,59,1,913,97,99,114,59,1,256,100,59,1,10835,4,2,103,112,232,237,111,110,59,1,260,102,59,3,55349,56632,112,108,121,70,117,110,99,116,105,111,110,59,1,8289,105,110,103,5,197,1,59,264,1,197,4,2,99,115,272,277,114,59,3,55349,56476,105,103,110,59,1,8788,105,108,100,101,5,195,1,59,292,1,195,109,108,5,196,1,59,301,1,196,4,8,97,99,101,102,111,114,115,117,321,350,354,383,388,394,400,405,4,2,99,114,327,336,107,115,108,97,115,104,59,1,8726,4,2,118,119,342,345,59,1,10983,101,100,59,1,8966,121,59,1,1041,4,3,99,114,116,362,369,379,97,117,115,101,59,1,8757,110,111,117,108,108,105,115,59,1,8492,97,59,1,914,114,59,3,55349,56581,112,102,59,3,55349,56633,101,118,101,59,1,728,99,114,59,1,8492,109,112,101,113,59,1,8782,4,14,72,79,97,99,100,101,102,104,105,108,111,114,115,117,442,447,456,504,542,547,569,573,577,616,678,784,790,796,99,121,59,1,1063,80,89,5,169,1,59,454,1,169,4,3,99,112,121,464,470,497,117,116,101,59,1,262,4,2,59,105,476,478,1,8914,116,97,108,68,105,102,102,101,114,101,110,116,105,97,108,68,59,1,8517,108,101,121,115,59,1,8493,4,4,97,101,105,111,514,520,530,535,114,111,110,59,1,268,100,105,108,5,199,1,59,528,1,199,114,99,59,1,264,110,105,110,116,59,1,8752,111,116,59,1,266,4,2,100,110,553,560,105,108,108,97,59,1,184,116,101,114,68,111,116,59,1,183,114,59,1,8493,105,59,1,935,114,99,108,101,4,4,68,77,80,84,591,596,603,609,111,116,59,1,8857,105,110,117,115,59,1,8854,108,117,115,59,1,8853,105,109,101,115,59,1,8855,111,4,2,99,115,623,646,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8754,101,67,117,114,108,121,4,2,68,81,658,671,111,117,98,108,101,81,117,111,116,101,59,1,8221,117,111,116,101,59,1,8217,4,4,108,110,112,117,688,701,736,753,111,110,4,2,59,101,696,698,1,8759,59,1,10868,4,3,103,105,116,709,717,722,114,117,101,110,116,59,1,8801,110,116,59,1,8751,111,117,114,73,110,116,101,103,114,97,108,59,1,8750,4,2,102,114,742,745,59,1,8450,111,100,117,99,116,59,1,8720,110,116,101,114,67,108,111,99,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8755,111,115,115,59,1,10799,99,114,59,3,55349,56478,112,4,2,59,67,803,805,1,8915,97,112,59,1,8781,4,11,68,74,83,90,97,99,101,102,105,111,115,834,850,855,860,865,888,903,916,921,1011,1415,4,2,59,111,840,842,1,8517,116,114,97,104,100,59,1,10513,99,121,59,1,1026,99,121,59,1,1029,99,121,59,1,1039,4,3,103,114,115,873,879,883,103,101,114,59,1,8225,114,59,1,8609,104,118,59,1,10980,4,2,97,121,894,900,114,111,110,59,1,270,59,1,1044,108,4,2,59,116,910,912,1,8711,97,59,1,916,114,59,3,55349,56583,4,2,97,102,927,998,4,2,99,109,933,992,114,105,116,105,99,97,108,4,4,65,68,71,84,950,957,978,985,99,117,116,101,59,1,180,111,4,2,116,117,964,967,59,1,729,98,108,101,65,99,117,116,101,59,1,733,114,97,118,101,59,1,96,105,108,100,101,59,1,732,111,110,100,59,1,8900,102,101,114,101,110,116,105,97,108,68,59,1,8518,4,4,112,116,117,119,1021,1026,1048,1249,102,59,3,55349,56635,4,3,59,68,69,1034,1036,1041,1,168,111,116,59,1,8412,113,117,97,108,59,1,8784,98,108,101,4,6,67,68,76,82,85,86,1065,1082,1101,1189,1211,1236,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8751,111,4,2,116,119,1089,1092,59,1,168,110,65,114,114,111,119,59,1,8659,4,2,101,111,1107,1141,102,116,4,3,65,82,84,1117,1124,1136,114,114,111,119,59,1,8656,105,103,104,116,65,114,114,111,119,59,1,8660,101,101,59,1,10980,110,103,4,2,76,82,1149,1177,101,102,116,4,2,65,82,1158,1165,114,114,111,119,59,1,10232,105,103,104,116,65,114,114,111,119,59,1,10234,105,103,104,116,65,114,114,111,119,59,1,10233,105,103,104,116,4,2,65,84,1199,1206,114,114,111,119,59,1,8658,101,101,59,1,8872,112,4,2,65,68,1218,1225,114,114,111,119,59,1,8657,111,119,110,65,114,114,111,119,59,1,8661,101,114,116,105,99,97,108,66,97,114,59,1,8741,110,4,6,65,66,76,82,84,97,1264,1292,1299,1352,1391,1408,114,114,111,119,4,3,59,66,85,1276,1278,1283,1,8595,97,114,59,1,10515,112,65,114,114,111,119,59,1,8693,114,101,118,101,59,1,785,101,102,116,4,3,82,84,86,1310,1323,1334,105,103,104,116,86,101,99,116,111,114,59,1,10576,101,101,86,101,99,116,111,114,59,1,10590,101,99,116,111,114,4,2,59,66,1345,1347,1,8637,97,114,59,1,10582,105,103,104,116,4,2,84,86,1362,1373,101,101,86,101,99,116,111,114,59,1,10591,101,99,116,111,114,4,2,59,66,1384,1386,1,8641,97,114,59,1,10583,101,101,4,2,59,65,1399,1401,1,8868,114,114,111,119,59,1,8615,114,114,111,119,59,1,8659,4,2,99,116,1421,1426,114,59,3,55349,56479,114,111,107,59,1,272,4,16,78,84,97,99,100,102,103,108,109,111,112,113,115,116,117,120,1466,1470,1478,1489,1515,1520,1525,1536,1544,1593,1609,1617,1650,1664,1668,1677,71,59,1,330,72,5,208,1,59,1476,1,208,99,117,116,101,5,201,1,59,1487,1,201,4,3,97,105,121,1497,1503,1512,114,111,110,59,1,282,114,99,5,202,1,59,1510,1,202,59,1,1069,111,116,59,1,278,114,59,3,55349,56584,114,97,118,101,5,200,1,59,1534,1,200,101,109,101,110,116,59,1,8712,4,2,97,112,1550,1555,99,114,59,1,274,116,121,4,2,83,86,1563,1576,109,97,108,108,83,113,117,97,114,101,59,1,9723,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9643,4,2,103,112,1599,1604,111,110,59,1,280,102,59,3,55349,56636,115,105,108,111,110,59,1,917,117,4,2,97,105,1624,1640,108,4,2,59,84,1631,1633,1,10869,105,108,100,101,59,1,8770,108,105,98,114,105,117,109,59,1,8652,4,2,99,105,1656,1660,114,59,1,8496,109,59,1,10867,97,59,1,919,109,108,5,203,1,59,1675,1,203,4,2,105,112,1683,1689,115,116,115,59,1,8707,111,110,101,110,116,105,97,108,69,59,1,8519,4,5,99,102,105,111,115,1713,1717,1722,1762,1791,121,59,1,1060,114,59,3,55349,56585,108,108,101,100,4,2,83,86,1732,1745,109,97,108,108,83,113,117,97,114,101,59,1,9724,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9642,4,3,112,114,117,1770,1775,1781,102,59,3,55349,56637,65,108,108,59,1,8704,114,105,101,114,116,114,102,59,1,8497,99,114,59,1,8497,4,12,74,84,97,98,99,100,102,103,111,114,115,116,1822,1827,1834,1848,1855,1877,1882,1887,1890,1896,1978,1984,99,121,59,1,1027,5,62,1,59,1832,1,62,109,109,97,4,2,59,100,1843,1845,1,915,59,1,988,114,101,118,101,59,1,286,4,3,101,105,121,1863,1869,1874,100,105,108,59,1,290,114,99,59,1,284,59,1,1043,111,116,59,1,288,114,59,3,55349,56586,59,1,8921,112,102,59,3,55349,56638,101,97,116,101,114,4,6,69,70,71,76,83,84,1915,1933,1944,1953,1959,1971,113,117,97,108,4,2,59,76,1925,1927,1,8805,101,115,115,59,1,8923,117,108,108,69,113,117,97,108,59,1,8807,114,101,97,116,101,114,59,1,10914,101,115,115,59,1,8823,108,97,110,116,69,113,117,97,108,59,1,10878,105,108,100,101,59,1,8819,99,114,59,3,55349,56482,59,1,8811,4,8,65,97,99,102,105,111,115,117,2005,2012,2026,2032,2036,2049,2073,2089,82,68,99,121,59,1,1066,4,2,99,116,2018,2023,101,107,59,1,711,59,1,94,105,114,99,59,1,292,114,59,1,8460,108,98,101,114,116,83,112,97,99,101,59,1,8459,4,2,112,114,2055,2059,102,59,1,8461,105,122,111,110,116,97,108,76,105,110,101,59,1,9472,4,2,99,116,2079,2083,114,59,1,8459,114,111,107,59,1,294,109,112,4,2,68,69,2097,2107,111,119,110,72,117,109,112,59,1,8782,113,117,97,108,59,1,8783,4,14,69,74,79,97,99,100,102,103,109,110,111,115,116,117,2144,2149,2155,2160,2171,2189,2194,2198,2209,2245,2307,2329,2334,2341,99,121,59,1,1045,108,105,103,59,1,306,99,121,59,1,1025,99,117,116,101,5,205,1,59,2169,1,205,4,2,105,121,2177,2186,114,99,5,206,1,59,2184,1,206,59,1,1048,111,116,59,1,304,114,59,1,8465,114,97,118,101,5,204,1,59,2207,1,204,4,3,59,97,112,2217,2219,2238,1,8465,4,2,99,103,2225,2229,114,59,1,298,105,110,97,114,121,73,59,1,8520,108,105,101,115,59,1,8658,4,2,116,118,2251,2281,4,2,59,101,2257,2259,1,8748,4,2,103,114,2265,2271,114,97,108,59,1,8747,115,101,99,116,105,111,110,59,1,8898,105,115,105,98,108,101,4,2,67,84,2293,2300,111,109,109,97,59,1,8291,105,109,101,115,59,1,8290,4,3,103,112,116,2315,2320,2325,111,110,59,1,302,102,59,3,55349,56640,97,59,1,921,99,114,59,1,8464,105,108,100,101,59,1,296,4,2,107,109,2347,2352,99,121,59,1,1030,108,5,207,1,59,2358,1,207,4,5,99,102,111,115,117,2372,2386,2391,2397,2414,4,2,105,121,2378,2383,114,99,59,1,308,59,1,1049,114,59,3,55349,56589,112,102,59,3,55349,56641,4,2,99,101,2403,2408,114,59,3,55349,56485,114,99,121,59,1,1032,107,99,121,59,1,1028,4,7,72,74,97,99,102,111,115,2436,2441,2446,2452,2467,2472,2478,99,121,59,1,1061,99,121,59,1,1036,112,112,97,59,1,922,4,2,101,121,2458,2464,100,105,108,59,1,310,59,1,1050,114,59,3,55349,56590,112,102,59,3,55349,56642,99,114,59,3,55349,56486,4,11,74,84,97,99,101,102,108,109,111,115,116,2508,2513,2520,2562,2585,2981,2986,3004,3011,3146,3167,99,121,59,1,1033,5,60,1,59,2518,1,60,4,5,99,109,110,112,114,2532,2538,2544,2548,2558,117,116,101,59,1,313,98,100,97,59,1,923,103,59,1,10218,108,97,99,101,116,114,102,59,1,8466,114,59,1,8606,4,3,97,101,121,2570,2576,2582,114,111,110,59,1,317,100,105,108,59,1,315,59,1,1051,4,2,102,115,2591,2907,116,4,10,65,67,68,70,82,84,85,86,97,114,2614,2663,2672,2728,2735,2760,2820,2870,2888,2895,4,2,110,114,2620,2633,103,108,101,66,114,97,99,107,101,116,59,1,10216,114,111,119,4,3,59,66,82,2644,2646,2651,1,8592,97,114,59,1,8676,105,103,104,116,65,114,114,111,119,59,1,8646,101,105,108,105,110,103,59,1,8968,111,4,2,117,119,2679,2692,98,108,101,66,114,97,99,107,101,116,59,1,10214,110,4,2,84,86,2699,2710,101,101,86,101,99,116,111,114,59,1,10593,101,99,116,111,114,4,2,59,66,2721,2723,1,8643,97,114,59,1,10585,108,111,111,114,59,1,8970,105,103,104,116,4,2,65,86,2745,2752,114,114,111,119,59,1,8596,101,99,116,111,114,59,1,10574,4,2,101,114,2766,2792,101,4,3,59,65,86,2775,2777,2784,1,8867,114,114,111,119,59,1,8612,101,99,116,111,114,59,1,10586,105,97,110,103,108,101,4,3,59,66,69,2806,2808,2813,1,8882,97,114,59,1,10703,113,117,97,108,59,1,8884,112,4,3,68,84,86,2829,2841,2852,111,119,110,86,101,99,116,111,114,59,1,10577,101,101,86,101,99,116,111,114,59,1,10592,101,99,116,111,114,4,2,59,66,2863,2865,1,8639,97,114,59,1,10584,101,99,116,111,114,4,2,59,66,2881,2883,1,8636,97,114,59,1,10578,114,114,111,119,59,1,8656,105,103,104,116,97,114,114,111,119,59,1,8660,115,4,6,69,70,71,76,83,84,2922,2936,2947,2956,2962,2974,113,117,97,108,71,114,101,97,116,101,114,59,1,8922,117,108,108,69,113,117,97,108,59,1,8806,114,101,97,116,101,114,59,1,8822,101,115,115,59,1,10913,108,97,110,116,69,113,117,97,108,59,1,10877,105,108,100,101,59,1,8818,114,59,3,55349,56591,4,2,59,101,2992,2994,1,8920,102,116,97,114,114,111,119,59,1,8666,105,100,111,116,59,1,319,4,3,110,112,119,3019,3110,3115,103,4,4,76,82,108,114,3030,3058,3070,3098,101,102,116,4,2,65,82,3039,3046,114,114,111,119,59,1,10229,105,103,104,116,65,114,114,111,119,59,1,10231,105,103,104,116,65,114,114,111,119,59,1,10230,101,102,116,4,2,97,114,3079,3086,114,114,111,119,59,1,10232,105,103,104,116,97,114,114,111,119,59,1,10234,105,103,104,116,97,114,114,111,119,59,1,10233,102,59,3,55349,56643,101,114,4,2,76,82,3123,3134,101,102,116,65,114,114,111,119,59,1,8601,105,103,104,116,65,114,114,111,119,59,1,8600,4,3,99,104,116,3154,3158,3161,114,59,1,8466,59,1,8624,114,111,107,59,1,321,59,1,8810,4,8,97,99,101,102,105,111,115,117,3188,3192,3196,3222,3227,3237,3243,3248,112,59,1,10501,121,59,1,1052,4,2,100,108,3202,3213,105,117,109,83,112,97,99,101,59,1,8287,108,105,110,116,114,102,59,1,8499,114,59,3,55349,56592,110,117,115,80,108,117,115,59,1,8723,112,102,59,3,55349,56644,99,114,59,1,8499,59,1,924,4,9,74,97,99,101,102,111,115,116,117,3271,3276,3283,3306,3422,3427,4120,4126,4137,99,121,59,1,1034,99,117,116,101,59,1,323,4,3,97,101,121,3291,3297,3303,114,111,110,59,1,327,100,105,108,59,1,325,59,1,1053,4,3,103,115,119,3314,3380,3415,97,116,105,118,101,4,3,77,84,86,3327,3340,3365,101,100,105,117,109,83,112,97,99,101,59,1,8203,104,105,4,2,99,110,3348,3357,107,83,112,97,99,101,59,1,8203,83,112,97,99,101,59,1,8203,101,114,121,84,104,105,110,83,112,97,99,101,59,1,8203,116,101,100,4,2,71,76,3389,3405,114,101,97,116,101,114,71,114,101,97,116,101,114,59,1,8811,101,115,115,76,101,115,115,59,1,8810,76,105,110,101,59,1,10,114,59,3,55349,56593,4,4,66,110,112,116,3437,3444,3460,3464,114,101,97,107,59,1,8288,66,114,101,97,107,105,110,103,83,112,97,99,101,59,1,160,102,59,1,8469,4,13,59,67,68,69,71,72,76,78,80,82,83,84,86,3492,3494,3517,3536,3578,3657,3685,3784,3823,3860,3915,4066,4107,1,10988,4,2,111,117,3500,3510,110,103,114,117,101,110,116,59,1,8802,112,67,97,112,59,1,8813,111,117,98,108,101,86,101,114,116,105,99,97,108,66,97,114,59,1,8742,4,3,108,113,120,3544,3552,3571,101,109,101,110,116,59,1,8713,117,97,108,4,2,59,84,3561,3563,1,8800,105,108,100,101,59,3,8770,824,105,115,116,115,59,1,8708,114,101,97,116,101,114,4,7,59,69,70,71,76,83,84,3600,3602,3609,3621,3631,3637,3650,1,8815,113,117,97,108,59,1,8817,117,108,108,69,113,117,97,108,59,3,8807,824,114,101,97,116,101,114,59,3,8811,824,101,115,115,59,1,8825,108,97,110,116,69,113,117,97,108,59,3,10878,824,105,108,100,101,59,1,8821,117,109,112,4,2,68,69,3666,3677,111,119,110,72,117,109,112,59,3,8782,824,113,117,97,108,59,3,8783,824,101,4,2,102,115,3692,3724,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3709,3711,3717,1,8938,97,114,59,3,10703,824,113,117,97,108,59,1,8940,115,4,6,59,69,71,76,83,84,3739,3741,3748,3757,3764,3777,1,8814,113,117,97,108,59,1,8816,114,101,97,116,101,114,59,1,8824,101,115,115,59,3,8810,824,108,97,110,116,69,113,117,97,108,59,3,10877,824,105,108,100,101,59,1,8820,101,115,116,101,100,4,2,71,76,3795,3812,114,101,97,116,101,114,71,114,101,97,116,101,114,59,3,10914,824,101,115,115,76,101,115,115,59,3,10913,824,114,101,99,101,100,101,115,4,3,59,69,83,3838,3840,3848,1,8832,113,117,97,108,59,3,10927,824,108,97,110,116,69,113,117,97,108,59,1,8928,4,2,101,105,3866,3881,118,101,114,115,101,69,108,101,109,101,110,116,59,1,8716,103,104,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3900,3902,3908,1,8939,97,114,59,3,10704,824,113,117,97,108,59,1,8941,4,2,113,117,3921,3973,117,97,114,101,83,117,4,2,98,112,3933,3952,115,101,116,4,2,59,69,3942,3945,3,8847,824,113,117,97,108,59,1,8930,101,114,115,101,116,4,2,59,69,3963,3966,3,8848,824,113,117,97,108,59,1,8931,4,3,98,99,112,3981,4000,4045,115,101,116,4,2,59,69,3990,3993,3,8834,8402,113,117,97,108,59,1,8840,99,101,101,100,115,4,4,59,69,83,84,4015,4017,4025,4037,1,8833,113,117,97,108,59,3,10928,824,108,97,110,116,69,113,117,97,108,59,1,8929,105,108,100,101,59,3,8831,824,101,114,115,101,116,4,2,59,69,4056,4059,3,8835,8402,113,117,97,108,59,1,8841,105,108,100,101,4,4,59,69,70,84,4080,4082,4089,4100,1,8769,113,117,97,108,59,1,8772,117,108,108,69,113,117,97,108,59,1,8775,105,108,100,101,59,1,8777,101,114,116,105,99,97,108,66,97,114,59,1,8740,99,114,59,3,55349,56489,105,108,100,101,5,209,1,59,4135,1,209,59,1,925,4,14,69,97,99,100,102,103,109,111,112,114,115,116,117,118,4170,4176,4187,4205,4212,4217,4228,4253,4259,4292,4295,4316,4337,4346,108,105,103,59,1,338,99,117,116,101,5,211,1,59,4185,1,211,4,2,105,121,4193,4202,114,99,5,212,1,59,4200,1,212,59,1,1054,98,108,97,99,59,1,336,114,59,3,55349,56594,114,97,118,101,5,210,1,59,4226,1,210,4,3,97,101,105,4236,4241,4246,99,114,59,1,332,103,97,59,1,937,99,114,111,110,59,1,927,112,102,59,3,55349,56646,101,110,67,117,114,108,121,4,2,68,81,4272,4285,111,117,98,108,101,81,117,111,116,101,59,1,8220,117,111,116,101,59,1,8216,59,1,10836,4,2,99,108,4301,4306,114,59,3,55349,56490,97,115,104,5,216,1,59,4314,1,216,105,4,2,108,109,4323,4332,100,101,5,213,1,59,4330,1,213,101,115,59,1,10807,109,108,5,214,1,59,4344,1,214,101,114,4,2,66,80,4354,4380,4,2,97,114,4360,4364,114,59,1,8254,97,99,4,2,101,107,4372,4375,59,1,9182,101,116,59,1,9140,97,114,101,110,116,104,101,115,105,115,59,1,9180,4,9,97,99,102,104,105,108,111,114,115,4413,4422,4426,4431,4435,4438,4448,4471,4561,114,116,105,97,108,68,59,1,8706,121,59,1,1055,114,59,3,55349,56595,105,59,1,934,59,1,928,117,115,77,105,110,117,115,59,1,177,4,2,105,112,4454,4467,110,99,97,114,101,112,108,97,110,101,59,1,8460,102,59,1,8473,4,4,59,101,105,111,4481,4483,4526,4531,1,10939,99,101,100,101,115,4,4,59,69,83,84,4498,4500,4507,4519,1,8826,113,117,97,108,59,1,10927,108,97,110,116,69,113,117,97,108,59,1,8828,105,108,100,101,59,1,8830,109,101,59,1,8243,4,2,100,112,4537,4543,117,99,116,59,1,8719,111,114,116,105,111,110,4,2,59,97,4555,4557,1,8759,108,59,1,8733,4,2,99,105,4567,4572,114,59,3,55349,56491,59,1,936,4,4,85,102,111,115,4585,4594,4599,4604,79,84,5,34,1,59,4592,1,34,114,59,3,55349,56596,112,102,59,1,8474,99,114,59,3,55349,56492,4,12,66,69,97,99,101,102,104,105,111,114,115,117,4636,4642,4650,4681,4704,4763,4767,4771,5047,5069,5081,5094,97,114,114,59,1,10512,71,5,174,1,59,4648,1,174,4,3,99,110,114,4658,4664,4668,117,116,101,59,1,340,103,59,1,10219,114,4,2,59,116,4675,4677,1,8608,108,59,1,10518,4,3,97,101,121,4689,4695,4701,114,111,110,59,1,344,100,105,108,59,1,342,59,1,1056,4,2,59,118,4710,4712,1,8476,101,114,115,101,4,2,69,85,4722,4748,4,2,108,113,4728,4736,101,109,101,110,116,59,1,8715,117,105,108,105,98,114,105,117,109,59,1,8651,112,69,113,117,105,108,105,98,114,105,117,109,59,1,10607,114,59,1,8476,111,59,1,929,103,104,116,4,8,65,67,68,70,84,85,86,97,4792,4840,4849,4905,4912,4972,5022,5040,4,2,110,114,4798,4811,103,108,101,66,114,97,99,107,101,116,59,1,10217,114,111,119,4,3,59,66,76,4822,4824,4829,1,8594,97,114,59,1,8677,101,102,116,65,114,114,111,119,59,1,8644,101,105,108,105,110,103,59,1,8969,111,4,2,117,119,4856,4869,98,108,101,66,114,97,99,107,101,116,59,1,10215,110,4,2,84,86,4876,4887,101,101,86,101,99,116,111,114,59,1,10589,101,99,116,111,114,4,2,59,66,4898,4900,1,8642,97,114,59,1,10581,108,111,111,114,59,1,8971,4,2,101,114,4918,4944,101,4,3,59,65,86,4927,4929,4936,1,8866,114,114,111,119,59,1,8614,101,99,116,111,114,59,1,10587,105,97,110,103,108,101,4,3,59,66,69,4958,4960,4965,1,8883,97,114,59,1,10704,113,117,97,108,59,1,8885,112,4,3,68,84,86,4981,4993,5004,111,119,110,86,101,99,116,111,114,59,1,10575,101,101,86,101,99,116,111,114,59,1,10588,101,99,116,111,114,4,2,59,66,5015,5017,1,8638,97,114,59,1,10580,101,99,116,111,114,4,2,59,66,5033,5035,1,8640,97,114,59,1,10579,114,114,111,119,59,1,8658,4,2,112,117,5053,5057,102,59,1,8477,110,100,73,109,112,108,105,101,115,59,1,10608,105,103,104,116,97,114,114,111,119,59,1,8667,4,2,99,104,5087,5091,114,59,1,8475,59,1,8625,108,101,68,101,108,97,121,101,100,59,1,10740,4,13,72,79,97,99,102,104,105,109,111,113,115,116,117,5134,5150,5157,5164,5198,5203,5259,5265,5277,5283,5374,5380,5385,4,2,67,99,5140,5146,72,99,121,59,1,1065,121,59,1,1064,70,84,99,121,59,1,1068,99,117,116,101,59,1,346,4,5,59,97,101,105,121,5176,5178,5184,5190,5195,1,10940,114,111,110,59,1,352,100,105,108,59,1,350,114,99,59,1,348,59,1,1057,114,59,3,55349,56598,111,114,116,4,4,68,76,82,85,5216,5227,5238,5250,111,119,110,65,114,114,111,119,59,1,8595,101,102,116,65,114,114,111,119,59,1,8592,105,103,104,116,65,114,114,111,119,59,1,8594,112,65,114,114,111,119,59,1,8593,103,109,97,59,1,931,97,108,108,67,105,114,99,108,101,59,1,8728,112,102,59,3,55349,56650,4,2,114,117,5289,5293,116,59,1,8730,97,114,101,4,4,59,73,83,85,5306,5308,5322,5367,1,9633,110,116,101,114,115,101,99,116,105,111,110,59,1,8851,117,4,2,98,112,5329,5347,115,101,116,4,2,59,69,5338,5340,1,8847,113,117,97,108,59,1,8849,101,114,115,101,116,4,2,59,69,5358,5360,1,8848,113,117,97,108,59,1,8850,110,105,111,110,59,1,8852,99,114,59,3,55349,56494,97,114,59,1,8902,4,4,98,99,109,112,5395,5420,5475,5478,4,2,59,115,5401,5403,1,8912,101,116,4,2,59,69,5411,5413,1,8912,113,117,97,108,59,1,8838,4,2,99,104,5426,5468,101,101,100,115,4,4,59,69,83,84,5440,5442,5449,5461,1,8827,113,117,97,108,59,1,10928,108,97,110,116,69,113,117,97,108,59,1,8829,105,108,100,101,59,1,8831,84,104,97,116,59,1,8715,59,1,8721,4,3,59,101,115,5486,5488,5507,1,8913,114,115,101,116,4,2,59,69,5498,5500,1,8835,113,117,97,108,59,1,8839,101,116,59,1,8913,4,11,72,82,83,97,99,102,104,105,111,114,115,5536,5546,5552,5567,5579,5602,5607,5655,5695,5701,5711,79,82,78,5,222,1,59,5544,1,222,65,68,69,59,1,8482,4,2,72,99,5558,5563,99,121,59,1,1035,121,59,1,1062,4,2,98,117,5573,5576,59,1,9,59,1,932,4,3,97,101,121,5587,5593,5599,114,111,110,59,1,356,100,105,108,59,1,354,59,1,1058,114,59,3,55349,56599,4,2,101,105,5613,5631,4,2,114,116,5619,5627,101,102,111,114,101,59,1,8756,97,59,1,920,4,2,99,110,5637,5647,107,83,112,97,99,101,59,3,8287,8202,83,112,97,99,101,59,1,8201,108,100,101,4,4,59,69,70,84,5668,5670,5677,5688,1,8764,113,117,97,108,59,1,8771,117,108,108,69,113,117,97,108,59,1,8773,105,108,100,101,59,1,8776,112,102,59,3,55349,56651,105,112,108,101,68,111,116,59,1,8411,4,2,99,116,5717,5722,114,59,3,55349,56495,114,111,107,59,1,358,4,14,97,98,99,100,102,103,109,110,111,112,114,115,116,117,5758,5789,5805,5823,5830,5835,5846,5852,5921,5937,6089,6095,6101,6108,4,2,99,114,5764,5774,117,116,101,5,218,1,59,5772,1,218,114,4,2,59,111,5781,5783,1,8607,99,105,114,59,1,10569,114,4,2,99,101,5796,5800,121,59,1,1038,118,101,59,1,364,4,2,105,121,5811,5820,114,99,5,219,1,59,5818,1,219,59,1,1059,98,108,97,99,59,1,368,114,59,3,55349,56600,114,97,118,101,5,217,1,59,5844,1,217,97,99,114,59,1,362,4,2,100,105,5858,5905,101,114,4,2,66,80,5866,5892,4,2,97,114,5872,5876,114,59,1,95,97,99,4,2,101,107,5884,5887,59,1,9183,101,116,59,1,9141,97,114,101,110,116,104,101,115,105,115,59,1,9181,111,110,4,2,59,80,5913,5915,1,8899,108,117,115,59,1,8846,4,2,103,112,5927,5932,111,110,59,1,370,102,59,3,55349,56652,4,8,65,68,69,84,97,100,112,115,5955,5985,5996,6009,6026,6033,6044,6075,114,114,111,119,4,3,59,66,68,5967,5969,5974,1,8593,97,114,59,1,10514,111,119,110,65,114,114,111,119,59,1,8645,111,119,110,65,114,114,111,119,59,1,8597,113,117,105,108,105,98,114,105,117,109,59,1,10606,101,101,4,2,59,65,6017,6019,1,8869,114,114,111,119,59,1,8613,114,114,111,119,59,1,8657,111,119,110,97,114,114,111,119,59,1,8661,101,114,4,2,76,82,6052,6063,101,102,116,65,114,114,111,119,59,1,8598,105,103,104,116,65,114,114,111,119,59,1,8599,105,4,2,59,108,6082,6084,1,978,111,110,59,1,933,105,110,103,59,1,366,99,114,59,3,55349,56496,105,108,100,101,59,1,360,109,108,5,220,1,59,6115,1,220,4,9,68,98,99,100,101,102,111,115,118,6137,6143,6148,6152,6166,6250,6255,6261,6267,97,115,104,59,1,8875,97,114,59,1,10987,121,59,1,1042,97,115,104,4,2,59,108,6161,6163,1,8873,59,1,10982,4,2,101,114,6172,6175,59,1,8897,4,3,98,116,121,6183,6188,6238,97,114,59,1,8214,4,2,59,105,6194,6196,1,8214,99,97,108,4,4,66,76,83,84,6209,6214,6220,6231,97,114,59,1,8739,105,110,101,59,1,124,101,112,97,114,97,116,111,114,59,1,10072,105,108,100,101,59,1,8768,84,104,105,110,83,112,97,99,101,59,1,8202,114,59,3,55349,56601,112,102,59,3,55349,56653,99,114,59,3,55349,56497,100,97,115,104,59,1,8874,4,5,99,101,102,111,115,6286,6292,6298,6303,6309,105,114,99,59,1,372,100,103,101,59,1,8896,114,59,3,55349,56602,112,102,59,3,55349,56654,99,114,59,3,55349,56498,4,4,102,105,111,115,6325,6330,6333,6339,114,59,3,55349,56603,59,1,926,112,102,59,3,55349,56655,99,114,59,3,55349,56499,4,9,65,73,85,97,99,102,111,115,117,6365,6370,6375,6380,6391,6405,6410,6416,6422,99,121,59,1,1071,99,121,59,1,1031,99,121,59,1,1070,99,117,116,101,5,221,1,59,6389,1,221,4,2,105,121,6397,6402,114,99,59,1,374,59,1,1067,114,59,3,55349,56604,112,102,59,3,55349,56656,99,114,59,3,55349,56500,109,108,59,1,376,4,8,72,97,99,100,101,102,111,115,6445,6450,6457,6472,6477,6501,6505,6510,99,121,59,1,1046,99,117,116,101,59,1,377,4,2,97,121,6463,6469,114,111,110,59,1,381,59,1,1047,111,116,59,1,379,4,2,114,116,6483,6497,111,87,105,100,116,104,83,112,97,99,101,59,1,8203,97,59,1,918,114,59,1,8488,112,102,59,1,8484,99,114,59,3,55349,56501,4,16,97,98,99,101,102,103,108,109,110,111,112,114,115,116,117,119,6550,6561,6568,6612,6622,6634,6645,6672,6699,6854,6870,6923,6933,6963,6974,6983,99,117,116,101,5,225,1,59,6559,1,225,114,101,118,101,59,1,259,4,6,59,69,100,105,117,121,6582,6584,6588,6591,6600,6609,1,8766,59,3,8766,819,59,1,8767,114,99,5,226,1,59,6598,1,226,116,101,5,180,1,59,6607,1,180,59,1,1072,108,105,103,5,230,1,59,6620,1,230,4,2,59,114,6628,6630,1,8289,59,3,55349,56606,114,97,118,101,5,224,1,59,6643,1,224,4,2,101,112,6651,6667,4,2,102,112,6657,6663,115,121,109,59,1,8501,104,59,1,8501,104,97,59,1,945,4,2,97,112,6678,6692,4,2,99,108,6684,6688,114,59,1,257,103,59,1,10815,5,38,1,59,6697,1,38,4,2,100,103,6705,6737,4,5,59,97,100,115,118,6717,6719,6724,6727,6734,1,8743,110,100,59,1,10837,59,1,10844,108,111,112,101,59,1,10840,59,1,10842,4,7,59,101,108,109,114,115,122,6753,6755,6758,6762,6814,6835,6848,1,8736,59,1,10660,101,59,1,8736,115,100,4,2,59,97,6770,6772,1,8737,4,8,97,98,99,100,101,102,103,104,6790,6793,6796,6799,6802,6805,6808,6811,59,1,10664,59,1,10665,59,1,10666,59,1,10667,59,1,10668,59,1,10669,59,1,10670,59,1,10671,116,4,2,59,118,6821,6823,1,8735,98,4,2,59,100,6830,6832,1,8894,59,1,10653,4,2,112,116,6841,6845,104,59,1,8738,59,1,197,97,114,114,59,1,9084,4,2,103,112,6860,6865,111,110,59,1,261,102,59,3,55349,56658,4,7,59,69,97,101,105,111,112,6886,6888,6891,6897,6900,6904,6908,1,8776,59,1,10864,99,105,114,59,1,10863,59,1,8778,100,59,1,8779,115,59,1,39,114,111,120,4,2,59,101,6917,6919,1,8776,113,59,1,8778,105,110,103,5,229,1,59,6931,1,229,4,3,99,116,121,6941,6946,6949,114,59,3,55349,56502,59,1,42,109,112,4,2,59,101,6957,6959,1,8776,113,59,1,8781,105,108,100,101,5,227,1,59,6972,1,227,109,108,5,228,1,59,6981,1,228,4,2,99,105,6989,6997,111,110,105,110,116,59,1,8755,110,116,59,1,10769,4,16,78,97,98,99,100,101,102,105,107,108,110,111,112,114,115,117,7036,7041,7119,7135,7149,7155,7219,7224,7347,7354,7463,7489,7786,7793,7814,7866,111,116,59,1,10989,4,2,99,114,7047,7094,107,4,4,99,101,112,115,7058,7064,7073,7080,111,110,103,59,1,8780,112,115,105,108,111,110,59,1,1014,114,105,109,101,59,1,8245,105,109,4,2,59,101,7088,7090,1,8765,113,59,1,8909,4,2,118,119,7100,7105,101,101,59,1,8893,101,100,4,2,59,103,7113,7115,1,8965,101,59,1,8965,114,107,4,2,59,116,7127,7129,1,9141,98,114,107,59,1,9142,4,2,111,121,7141,7146,110,103,59,1,8780,59,1,1073,113,117,111,59,1,8222,4,5,99,109,112,114,116,7167,7181,7188,7193,7199,97,117,115,4,2,59,101,7176,7178,1,8757,59,1,8757,112,116,121,118,59,1,10672,115,105,59,1,1014,110,111,117,59,1,8492,4,3,97,104,119,7207,7210,7213,59,1,946,59,1,8502,101,101,110,59,1,8812,114,59,3,55349,56607,103,4,7,99,111,115,116,117,118,119,7241,7262,7288,7305,7328,7335,7340,4,3,97,105,117,7249,7253,7258,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,4,3,100,112,116,7270,7275,7281,111,116,59,1,10752,108,117,115,59,1,10753,105,109,101,115,59,1,10754,4,2,113,116,7294,7300,99,117,112,59,1,10758,97,114,59,1,9733,114,105,97,110,103,108,101,4,2,100,117,7318,7324,111,119,110,59,1,9661,112,59,1,9651,112,108,117,115,59,1,10756,101,101,59,1,8897,101,100,103,101,59,1,8896,97,114,111,119,59,1,10509,4,3,97,107,111,7362,7436,7458,4,2,99,110,7368,7432,107,4,3,108,115,116,7377,7386,7394,111,122,101,110,103,101,59,1,10731,113,117,97,114,101,59,1,9642,114,105,97,110,103,108,101,4,4,59,100,108,114,7411,7413,7419,7425,1,9652,111,119,110,59,1,9662,101,102,116,59,1,9666,105,103,104,116,59,1,9656,107,59,1,9251,4,2,49,51,7442,7454,4,2,50,52,7448,7451,59,1,9618,59,1,9617,52,59,1,9619,99,107,59,1,9608,4,2,101,111,7469,7485,4,2,59,113,7475,7478,3,61,8421,117,105,118,59,3,8801,8421,116,59,1,8976,4,4,112,116,119,120,7499,7504,7517,7523,102,59,3,55349,56659,4,2,59,116,7510,7512,1,8869,111,109,59,1,8869,116,105,101,59,1,8904,4,12,68,72,85,86,98,100,104,109,112,116,117,118,7549,7571,7597,7619,7655,7660,7682,7708,7715,7721,7728,7750,4,4,76,82,108,114,7559,7562,7565,7568,59,1,9559,59,1,9556,59,1,9558,59,1,9555,4,5,59,68,85,100,117,7583,7585,7588,7591,7594,1,9552,59,1,9574,59,1,9577,59,1,9572,59,1,9575,4,4,76,82,108,114,7607,7610,7613,7616,59,1,9565,59,1,9562,59,1,9564,59,1,9561,4,7,59,72,76,82,104,108,114,7635,7637,7640,7643,7646,7649,7652,1,9553,59,1,9580,59,1,9571,59,1,9568,59,1,9579,59,1,9570,59,1,9567,111,120,59,1,10697,4,4,76,82,108,114,7670,7673,7676,7679,59,1,9557,59,1,9554,59,1,9488,59,1,9484,4,5,59,68,85,100,117,7694,7696,7699,7702,7705,1,9472,59,1,9573,59,1,9576,59,1,9516,59,1,9524,105,110,117,115,59,1,8863,108,117,115,59,1,8862,105,109,101,115,59,1,8864,4,4,76,82,108,114,7738,7741,7744,7747,59,1,9563,59,1,9560,59,1,9496,59,1,9492,4,7,59,72,76,82,104,108,114,7766,7768,7771,7774,7777,7780,7783,1,9474,59,1,9578,59,1,9569,59,1,9566,59,1,9532,59,1,9508,59,1,9500,114,105,109,101,59,1,8245,4,2,101,118,7799,7804,118,101,59,1,728,98,97,114,5,166,1,59,7812,1,166,4,4,99,101,105,111,7824,7829,7834,7846,114,59,3,55349,56503,109,105,59,1,8271,109,4,2,59,101,7841,7843,1,8765,59,1,8909,108,4,3,59,98,104,7855,7857,7860,1,92,59,1,10693,115,117,98,59,1,10184,4,2,108,109,7872,7885,108,4,2,59,101,7879,7881,1,8226,116,59,1,8226,112,4,3,59,69,101,7894,7896,7899,1,8782,59,1,10926,4,2,59,113,7905,7907,1,8783,59,1,8783,4,15,97,99,100,101,102,104,105,108,111,114,115,116,117,119,121,7942,8021,8075,8080,8121,8126,8157,8279,8295,8430,8446,8485,8491,8707,8726,4,3,99,112,114,7950,7956,8007,117,116,101,59,1,263,4,6,59,97,98,99,100,115,7970,7972,7977,7984,7998,8003,1,8745,110,100,59,1,10820,114,99,117,112,59,1,10825,4,2,97,117,7990,7994,112,59,1,10827,112,59,1,10823,111,116,59,1,10816,59,3,8745,65024,4,2,101,111,8013,8017,116,59,1,8257,110,59,1,711,4,4,97,101,105,117,8031,8046,8056,8061,4,2,112,114,8037,8041,115,59,1,10829,111,110,59,1,269,100,105,108,5,231,1,59,8054,1,231,114,99,59,1,265,112,115,4,2,59,115,8069,8071,1,10828,109,59,1,10832,111,116,59,1,267,4,3,100,109,110,8088,8097,8104,105,108,5,184,1,59,8095,1,184,112,116,121,118,59,1,10674,116,5,162,2,59,101,8112,8114,1,162,114,100,111,116,59,1,183,114,59,3,55349,56608,4,3,99,101,105,8134,8138,8154,121,59,1,1095,99,107,4,2,59,109,8146,8148,1,10003,97,114,107,59,1,10003,59,1,967,114,4,7,59,69,99,101,102,109,115,8174,8176,8179,8258,8261,8268,8273,1,9675,59,1,10691,4,3,59,101,108,8187,8189,8193,1,710,113,59,1,8791,101,4,2,97,100,8200,8223,114,114,111,119,4,2,108,114,8210,8216,101,102,116,59,1,8634,105,103,104,116,59,1,8635,4,5,82,83,97,99,100,8235,8238,8241,8246,8252,59,1,174,59,1,9416,115,116,59,1,8859,105,114,99,59,1,8858,97,115,104,59,1,8861,59,1,8791,110,105,110,116,59,1,10768,105,100,59,1,10991,99,105,114,59,1,10690,117,98,115,4,2,59,117,8288,8290,1,9827,105,116,59,1,9827,4,4,108,109,110,112,8305,8326,8376,8400,111,110,4,2,59,101,8313,8315,1,58,4,2,59,113,8321,8323,1,8788,59,1,8788,4,2,109,112,8332,8344,97,4,2,59,116,8339,8341,1,44,59,1,64,4,3,59,102,108,8352,8354,8358,1,8705,110,59,1,8728,101,4,2,109,120,8365,8371,101,110,116,59,1,8705,101,115,59,1,8450,4,2,103,105,8382,8395,4,2,59,100,8388,8390,1,8773,111,116,59,1,10861,110,116,59,1,8750,4,3,102,114,121,8408,8412,8417,59,3,55349,56660,111,100,59,1,8720,5,169,2,59,115,8424,8426,1,169,114,59,1,8471,4,2,97,111,8436,8441,114,114,59,1,8629,115,115,59,1,10007,4,2,99,117,8452,8457,114,59,3,55349,56504,4,2,98,112,8463,8474,4,2,59,101,8469,8471,1,10959,59,1,10961,4,2,59,101,8480,8482,1,10960,59,1,10962,100,111,116,59,1,8943,4,7,100,101,108,112,114,118,119,8507,8522,8536,8550,8600,8697,8702,97,114,114,4,2,108,114,8516,8519,59,1,10552,59,1,10549,4,2,112,115,8528,8532,114,59,1,8926,99,59,1,8927,97,114,114,4,2,59,112,8545,8547,1,8630,59,1,10557,4,6,59,98,99,100,111,115,8564,8566,8573,8587,8592,8596,1,8746,114,99,97,112,59,1,10824,4,2,97,117,8579,8583,112,59,1,10822,112,59,1,10826,111,116,59,1,8845,114,59,1,10821,59,3,8746,65024,4,4,97,108,114,118,8610,8623,8663,8672,114,114,4,2,59,109,8618,8620,1,8631,59,1,10556,121,4,3,101,118,119,8632,8651,8656,113,4,2,112,115,8639,8645,114,101,99,59,1,8926,117,99,99,59,1,8927,101,101,59,1,8910,101,100,103,101,59,1,8911,101,110,5,164,1,59,8670,1,164,101,97,114,114,111,119,4,2,108,114,8684,8690,101,102,116,59,1,8630,105,103,104,116,59,1,8631,101,101,59,1,8910,101,100,59,1,8911,4,2,99,105,8713,8721,111,110,105,110,116,59,1,8754,110,116,59,1,8753,108,99,116,121,59,1,9005,4,19,65,72,97,98,99,100,101,102,104,105,106,108,111,114,115,116,117,119,122,8773,8778,8783,8821,8839,8854,8887,8914,8930,8944,9036,9041,9058,9197,9227,9258,9281,9297,9305,114,114,59,1,8659,97,114,59,1,10597,4,4,103,108,114,115,8793,8799,8805,8809,103,101,114,59,1,8224,101,116,104,59,1,8504,114,59,1,8595,104,4,2,59,118,8816,8818,1,8208,59,1,8867,4,2,107,108,8827,8834,97,114,111,119,59,1,10511,97,99,59,1,733,4,2,97,121,8845,8851,114,111,110,59,1,271,59,1,1076,4,3,59,97,111,8862,8864,8880,1,8518,4,2,103,114,8870,8876,103,101,114,59,1,8225,114,59,1,8650,116,115,101,113,59,1,10871,4,3,103,108,109,8895,8902,8907,5,176,1,59,8900,1,176,116,97,59,1,948,112,116,121,118,59,1,10673,4,2,105,114,8920,8926,115,104,116,59,1,10623,59,3,55349,56609,97,114,4,2,108,114,8938,8941,59,1,8643,59,1,8642,4,5,97,101,103,115,118,8956,8986,8989,8996,9001,109,4,3,59,111,115,8965,8967,8983,1,8900,110,100,4,2,59,115,8975,8977,1,8900,117,105,116,59,1,9830,59,1,9830,59,1,168,97,109,109,97,59,1,989,105,110,59,1,8946,4,3,59,105,111,9009,9011,9031,1,247,100,101,5,247,2,59,111,9020,9022,1,247,110,116,105,109,101,115,59,1,8903,110,120,59,1,8903,99,121,59,1,1106,99,4,2,111,114,9048,9053,114,110,59,1,8990,111,112,59,1,8973,4,5,108,112,116,117,119,9070,9076,9081,9130,9144,108,97,114,59,1,36,102,59,3,55349,56661,4,5,59,101,109,112,115,9093,9095,9109,9116,9122,1,729,113,4,2,59,100,9102,9104,1,8784,111,116,59,1,8785,105,110,117,115,59,1,8760,108,117,115,59,1,8724,113,117,97,114,101,59,1,8865,98,108,101,98,97,114,119,101,100,103,101,59,1,8966,110,4,3,97,100,104,9153,9160,9172,114,114,111,119,59,1,8595,111,119,110,97,114,114,111,119,115,59,1,8650,97,114,112,111,111,110,4,2,108,114,9184,9190,101,102,116,59,1,8643,105,103,104,116,59,1,8642,4,2,98,99,9203,9211,107,97,114,111,119,59,1,10512,4,2,111,114,9217,9222,114,110,59,1,8991,111,112,59,1,8972,4,3,99,111,116,9235,9248,9252,4,2,114,121,9241,9245,59,3,55349,56505,59,1,1109,108,59,1,10742,114,111,107,59,1,273,4,2,100,114,9264,9269,111,116,59,1,8945,105,4,2,59,102,9276,9278,1,9663,59,1,9662,4,2,97,104,9287,9292,114,114,59,1,8693,97,114,59,1,10607,97,110,103,108,101,59,1,10662,4,2,99,105,9311,9315,121,59,1,1119,103,114,97,114,114,59,1,10239,4,18,68,97,99,100,101,102,103,108,109,110,111,112,113,114,115,116,117,120,9361,9376,9398,9439,9444,9447,9462,9495,9531,9585,9598,9614,9659,9755,9771,9792,9808,9826,4,2,68,111,9367,9372,111,116,59,1,10871,116,59,1,8785,4,2,99,115,9382,9392,117,116,101,5,233,1,59,9390,1,233,116,101,114,59,1,10862,4,4,97,105,111,121,9408,9414,9430,9436,114,111,110,59,1,283,114,4,2,59,99,9421,9423,1,8790,5,234,1,59,9428,1,234,108,111,110,59,1,8789,59,1,1101,111,116,59,1,279,59,1,8519,4,2,68,114,9453,9458,111,116,59,1,8786,59,3,55349,56610,4,3,59,114,115,9470,9472,9482,1,10906,97,118,101,5,232,1,59,9480,1,232,4,2,59,100,9488,9490,1,10902,111,116,59,1,10904,4,4,59,105,108,115,9505,9507,9515,9518,1,10905,110,116,101,114,115,59,1,9191,59,1,8467,4,2,59,100,9524,9526,1,10901,111,116,59,1,10903,4,3,97,112,115,9539,9544,9564,99,114,59,1,275,116,121,4,3,59,115,118,9554,9556,9561,1,8709,101,116,59,1,8709,59,1,8709,112,4,2,49,59,9571,9583,4,2,51,52,9577,9580,59,1,8196,59,1,8197,1,8195,4,2,103,115,9591,9594,59,1,331,112,59,1,8194,4,2,103,112,9604,9609,111,110,59,1,281,102,59,3,55349,56662,4,3,97,108,115,9622,9635,9640,114,4,2,59,115,9629,9631,1,8917,108,59,1,10723,117,115,59,1,10865,105,4,3,59,108,118,9649,9651,9656,1,949,111,110,59,1,949,59,1,1013,4,4,99,115,117,118,9669,9686,9716,9747,4,2,105,111,9675,9680,114,99,59,1,8790,108,111,110,59,1,8789,4,2,105,108,9692,9696,109,59,1,8770,97,110,116,4,2,103,108,9705,9710,116,114,59,1,10902,101,115,115,59,1,10901,4,3,97,101,105,9724,9729,9734,108,115,59,1,61,115,116,59,1,8799,118,4,2,59,68,9741,9743,1,8801,68,59,1,10872,112,97,114,115,108,59,1,10725,4,2,68,97,9761,9766,111,116,59,1,8787,114,114,59,1,10609,4,3,99,100,105,9779,9783,9788,114,59,1,8495,111,116,59,1,8784,109,59,1,8770,4,2,97,104,9798,9801,59,1,951,5,240,1,59,9806,1,240,4,2,109,114,9814,9822,108,5,235,1,59,9820,1,235,111,59,1,8364,4,3,99,105,112,9834,9838,9843,108,59,1,33,115,116,59,1,8707,4,2,101,111,9849,9859,99,116,97,116,105,111,110,59,1,8496,110,101,110,116,105,97,108,101,59,1,8519,4,12,97,99,101,102,105,106,108,110,111,112,114,115,9896,9910,9914,9921,9954,9960,9967,9989,9994,10027,10036,10164,108,108,105,110,103,100,111,116,115,101,113,59,1,8786,121,59,1,1092,109,97,108,101,59,1,9792,4,3,105,108,114,9929,9935,9950,108,105,103,59,1,64259,4,2,105,108,9941,9945,103,59,1,64256,105,103,59,1,64260,59,3,55349,56611,108,105,103,59,1,64257,108,105,103,59,3,102,106,4,3,97,108,116,9975,9979,9984,116,59,1,9837,105,103,59,1,64258,110,115,59,1,9649,111,102,59,1,402,4,2,112,114,10000,10005,102,59,3,55349,56663,4,2,97,107,10011,10016,108,108,59,1,8704,4,2,59,118,10022,10024,1,8916,59,1,10969,97,114,116,105,110,116,59,1,10765,4,2,97,111,10042,10159,4,2,99,115,10048,10155,4,6,49,50,51,52,53,55,10062,10102,10114,10135,10139,10151,4,6,50,51,52,53,54,56,10076,10083,10086,10093,10096,10099,5,189,1,59,10081,1,189,59,1,8531,5,188,1,59,10091,1,188,59,1,8533,59,1,8537,59,1,8539,4,2,51,53,10108,10111,59,1,8532,59,1,8534,4,3,52,53,56,10122,10129,10132,5,190,1,59,10127,1,190,59,1,8535,59,1,8540,53,59,1,8536,4,2,54,56,10145,10148,59,1,8538,59,1,8541,56,59,1,8542,108,59,1,8260,119,110,59,1,8994,99,114,59,3,55349,56507,4,17,69,97,98,99,100,101,102,103,105,106,108,110,111,114,115,116,118,10206,10217,10247,10254,10268,10273,10358,10363,10374,10380,10385,10406,10458,10464,10470,10497,10610,4,2,59,108,10212,10214,1,8807,59,1,10892,4,3,99,109,112,10225,10231,10244,117,116,101,59,1,501,109,97,4,2,59,100,10239,10241,1,947,59,1,989,59,1,10886,114,101,118,101,59,1,287,4,2,105,121,10260,10265,114,99,59,1,285,59,1,1075,111,116,59,1,289,4,4,59,108,113,115,10283,10285,10288,10308,1,8805,59,1,8923,4,3,59,113,115,10296,10298,10301,1,8805,59,1,8807,108,97,110,116,59,1,10878,4,4,59,99,100,108,10318,10320,10324,10345,1,10878,99,59,1,10921,111,116,4,2,59,111,10332,10334,1,10880,4,2,59,108,10340,10342,1,10882,59,1,10884,4,2,59,101,10351,10354,3,8923,65024,115,59,1,10900,114,59,3,55349,56612,4,2,59,103,10369,10371,1,8811,59,1,8921,109,101,108,59,1,8503,99,121,59,1,1107,4,4,59,69,97,106,10395,10397,10400,10403,1,8823,59,1,10898,59,1,10917,59,1,10916,4,4,69,97,101,115,10416,10419,10434,10453,59,1,8809,112,4,2,59,112,10426,10428,1,10890,114,111,120,59,1,10890,4,2,59,113,10440,10442,1,10888,4,2,59,113,10448,10450,1,10888,59,1,8809,105,109,59,1,8935,112,102,59,3,55349,56664,97,118,101,59,1,96,4,2,99,105,10476,10480,114,59,1,8458,109,4,3,59,101,108,10489,10491,10494,1,8819,59,1,10894,59,1,10896,5,62,6,59,99,100,108,113,114,10512,10514,10527,10532,10538,10545,1,62,4,2,99,105,10520,10523,59,1,10919,114,59,1,10874,111,116,59,1,8919,80,97,114,59,1,10645,117,101,115,116,59,1,10876,4,5,97,100,101,108,115,10557,10574,10579,10599,10605,4,2,112,114,10563,10570,112,114,111,120,59,1,10886,114,59,1,10616,111,116,59,1,8919,113,4,2,108,113,10586,10592,101,115,115,59,1,8923,108,101,115,115,59,1,10892,101,115,115,59,1,8823,105,109,59,1,8819,4,2,101,110,10616,10626,114,116,110,101,113,113,59,3,8809,65024,69,59,3,8809,65024,4,10,65,97,98,99,101,102,107,111,115,121,10653,10658,10713,10718,10724,10760,10765,10786,10850,10875,114,114,59,1,8660,4,4,105,108,109,114,10668,10674,10678,10684,114,115,112,59,1,8202,102,59,1,189,105,108,116,59,1,8459,4,2,100,114,10690,10695,99,121,59,1,1098,4,3,59,99,119,10703,10705,10710,1,8596,105,114,59,1,10568,59,1,8621,97,114,59,1,8463,105,114,99,59,1,293,4,3,97,108,114,10732,10748,10754,114,116,115,4,2,59,117,10741,10743,1,9829,105,116,59,1,9829,108,105,112,59,1,8230,99,111,110,59,1,8889,114,59,3,55349,56613,115,4,2,101,119,10772,10779,97,114,111,119,59,1,10533,97,114,111,119,59,1,10534,4,5,97,109,111,112,114,10798,10803,10809,10839,10844,114,114,59,1,8703,116,104,116,59,1,8763,107,4,2,108,114,10816,10827,101,102,116,97,114,114,111,119,59,1,8617,105,103,104,116,97,114,114,111,119,59,1,8618,102,59,3,55349,56665,98,97,114,59,1,8213,4,3,99,108,116,10858,10863,10869,114,59,3,55349,56509,97,115,104,59,1,8463,114,111,107,59,1,295,4,2,98,112,10881,10887,117,108,108,59,1,8259,104,101,110,59,1,8208,4,15,97,99,101,102,103,105,106,109,110,111,112,113,115,116,117,10925,10936,10958,10977,10990,11001,11039,11045,11101,11192,11220,11226,11237,11285,11299,99,117,116,101,5,237,1,59,10934,1,237,4,3,59,105,121,10944,10946,10955,1,8291,114,99,5,238,1,59,10953,1,238,59,1,1080,4,2,99,120,10964,10968,121,59,1,1077,99,108,5,161,1,59,10975,1,161,4,2,102,114,10983,10986,59,1,8660,59,3,55349,56614,114,97,118,101,5,236,1,59,10999,1,236,4,4,59,105,110,111,11011,11013,11028,11034,1,8520,4,2,105,110,11019,11024,110,116,59,1,10764,116,59,1,8749,102,105,110,59,1,10716,116,97,59,1,8489,108,105,103,59,1,307,4,3,97,111,112,11053,11092,11096,4,3,99,103,116,11061,11065,11088,114,59,1,299,4,3,101,108,112,11073,11076,11082,59,1,8465,105,110,101,59,1,8464,97,114,116,59,1,8465,104,59,1,305,102,59,1,8887,101,100,59,1,437,4,5,59,99,102,111,116,11113,11115,11121,11136,11142,1,8712,97,114,101,59,1,8453,105,110,4,2,59,116,11129,11131,1,8734,105,101,59,1,10717,100,111,116,59,1,305,4,5,59,99,101,108,112,11154,11156,11161,11179,11186,1,8747,97,108,59,1,8890,4,2,103,114,11167,11173,101,114,115,59,1,8484,99,97,108,59,1,8890,97,114,104,107,59,1,10775,114,111,100,59,1,10812,4,4,99,103,112,116,11202,11206,11211,11216,121,59,1,1105,111,110,59,1,303,102,59,3,55349,56666,97,59,1,953,114,111,100,59,1,10812,117,101,115,116,5,191,1,59,11235,1,191,4,2,99,105,11243,11248,114,59,3,55349,56510,110,4,5,59,69,100,115,118,11261,11263,11266,11271,11282,1,8712,59,1,8953,111,116,59,1,8949,4,2,59,118,11277,11279,1,8948,59,1,8947,59,1,8712,4,2,59,105,11291,11293,1,8290,108,100,101,59,1,297,4,2,107,109,11305,11310,99,121,59,1,1110,108,5,239,1,59,11316,1,239,4,6,99,102,109,111,115,117,11332,11346,11351,11357,11363,11380,4,2,105,121,11338,11343,114,99,59,1,309,59,1,1081,114,59,3,55349,56615,97,116,104,59,1,567,112,102,59,3,55349,56667,4,2,99,101,11369,11374,114,59,3,55349,56511,114,99,121,59,1,1112,107,99,121,59,1,1108,4,8,97,99,102,103,104,106,111,115,11404,11418,11433,11438,11445,11450,11455,11461,112,112,97,4,2,59,118,11413,11415,1,954,59,1,1008,4,2,101,121,11424,11430,100,105,108,59,1,311,59,1,1082,114,59,3,55349,56616,114,101,101,110,59,1,312,99,121,59,1,1093,99,121,59,1,1116,112,102,59,3,55349,56668,99,114,59,3,55349,56512,4,23,65,66,69,72,97,98,99,100,101,102,103,104,106,108,109,110,111,112,114,115,116,117,118,11515,11538,11544,11555,11560,11721,11780,11818,11868,12136,12160,12171,12203,12208,12246,12275,12327,12509,12523,12569,12641,12732,12752,4,3,97,114,116,11523,11528,11532,114,114,59,1,8666,114,59,1,8656,97,105,108,59,1,10523,97,114,114,59,1,10510,4,2,59,103,11550,11552,1,8806,59,1,10891,97,114,59,1,10594,4,9,99,101,103,109,110,112,113,114,116,11580,11586,11594,11600,11606,11624,11627,11636,11694,117,116,101,59,1,314,109,112,116,121,118,59,1,10676,114,97,110,59,1,8466,98,100,97,59,1,955,103,4,3,59,100,108,11615,11617,11620,1,10216,59,1,10641,101,59,1,10216,59,1,10885,117,111,5,171,1,59,11634,1,171,114,4,8,59,98,102,104,108,112,115,116,11655,11657,11669,11673,11677,11681,11685,11690,1,8592,4,2,59,102,11663,11665,1,8676,115,59,1,10527,115,59,1,10525,107,59,1,8617,112,59,1,8619,108,59,1,10553,105,109,59,1,10611,108,59,1,8610,4,3,59,97,101,11702,11704,11709,1,10923,105,108,59,1,10521,4,2,59,115,11715,11717,1,10925,59,3,10925,65024,4,3,97,98,114,11729,11734,11739,114,114,59,1,10508,114,107,59,1,10098,4,2,97,107,11745,11758,99,4,2,101,107,11752,11755,59,1,123,59,1,91,4,2,101,115,11764,11767,59,1,10635,108,4,2,100,117,11774,11777,59,1,10639,59,1,10637,4,4,97,101,117,121,11790,11796,11811,11815,114,111,110,59,1,318,4,2,100,105,11802,11807,105,108,59,1,316,108,59,1,8968,98,59,1,123,59,1,1083,4,4,99,113,114,115,11828,11832,11845,11864,97,59,1,10550,117,111,4,2,59,114,11840,11842,1,8220,59,1,8222,4,2,100,117,11851,11857,104,97,114,59,1,10599,115,104,97,114,59,1,10571,104,59,1,8626,4,5,59,102,103,113,115,11880,11882,12008,12011,12031,1,8804,116,4,5,97,104,108,114,116,11895,11913,11935,11947,11996,114,114,111,119,4,2,59,116,11905,11907,1,8592,97,105,108,59,1,8610,97,114,112,111,111,110,4,2,100,117,11925,11931,111,119,110,59,1,8637,112,59,1,8636,101,102,116,97,114,114,111,119,115,59,1,8647,105,103,104,116,4,3,97,104,115,11959,11974,11984,114,114,111,119,4,2,59,115,11969,11971,1,8596,59,1,8646,97,114,112,111,111,110,115,59,1,8651,113,117,105,103,97,114,114,111,119,59,1,8621,104,114,101,101,116,105,109,101,115,59,1,8907,59,1,8922,4,3,59,113,115,12019,12021,12024,1,8804,59,1,8806,108,97,110,116,59,1,10877,4,5,59,99,100,103,115,12043,12045,12049,12070,12083,1,10877,99,59,1,10920,111,116,4,2,59,111,12057,12059,1,10879,4,2,59,114,12065,12067,1,10881,59,1,10883,4,2,59,101,12076,12079,3,8922,65024,115,59,1,10899,4,5,97,100,101,103,115,12095,12103,12108,12126,12131,112,112,114,111,120,59,1,10885,111,116,59,1,8918,113,4,2,103,113,12115,12120,116,114,59,1,8922,103,116,114,59,1,10891,116,114,59,1,8822,105,109,59,1,8818,4,3,105,108,114,12144,12150,12156,115,104,116,59,1,10620,111,111,114,59,1,8970,59,3,55349,56617,4,2,59,69,12166,12168,1,8822,59,1,10897,4,2,97,98,12177,12198,114,4,2,100,117,12184,12187,59,1,8637,4,2,59,108,12193,12195,1,8636,59,1,10602,108,107,59,1,9604,99,121,59,1,1113,4,5,59,97,99,104,116,12220,12222,12227,12235,12241,1,8810,114,114,59,1,8647,111,114,110,101,114,59,1,8990,97,114,100,59,1,10603,114,105,59,1,9722,4,2,105,111,12252,12258,100,111,116,59,1,320,117,115,116,4,2,59,97,12267,12269,1,9136,99,104,101,59,1,9136,4,4,69,97,101,115,12285,12288,12303,12322,59,1,8808,112,4,2,59,112,12295,12297,1,10889,114,111,120,59,1,10889,4,2,59,113,12309,12311,1,10887,4,2,59,113,12317,12319,1,10887,59,1,8808,105,109,59,1,8934,4,8,97,98,110,111,112,116,119,122,12345,12359,12364,12421,12446,12467,12474,12490,4,2,110,114,12351,12355,103,59,1,10220,114,59,1,8701,114,107,59,1,10214,103,4,3,108,109,114,12373,12401,12409,101,102,116,4,2,97,114,12382,12389,114,114,111,119,59,1,10229,105,103,104,116,97,114,114,111,119,59,1,10231,97,112,115,116,111,59,1,10236,105,103,104,116,97,114,114,111,119,59,1,10230,112,97,114,114,111,119,4,2,108,114,12433,12439,101,102,116,59,1,8619,105,103,104,116,59,1,8620,4,3,97,102,108,12454,12458,12462,114,59,1,10629,59,3,55349,56669,117,115,59,1,10797,105,109,101,115,59,1,10804,4,2,97,98,12480,12485,115,116,59,1,8727,97,114,59,1,95,4,3,59,101,102,12498,12500,12506,1,9674,110,103,101,59,1,9674,59,1,10731,97,114,4,2,59,108,12517,12519,1,40,116,59,1,10643,4,5,97,99,104,109,116,12535,12540,12548,12561,12564,114,114,59,1,8646,111,114,110,101,114,59,1,8991,97,114,4,2,59,100,12556,12558,1,8651,59,1,10605,59,1,8206,114,105,59,1,8895,4,6,97,99,104,105,113,116,12583,12589,12594,12597,12614,12635,113,117,111,59,1,8249,114,59,3,55349,56513,59,1,8624,109,4,3,59,101,103,12606,12608,12611,1,8818,59,1,10893,59,1,10895,4,2,98,117,12620,12623,59,1,91,111,4,2,59,114,12630,12632,1,8216,59,1,8218,114,111,107,59,1,322,5,60,8,59,99,100,104,105,108,113,114,12660,12662,12675,12680,12686,12692,12698,12705,1,60,4,2,99,105,12668,12671,59,1,10918,114,59,1,10873,111,116,59,1,8918,114,101,101,59,1,8907,109,101,115,59,1,8905,97,114,114,59,1,10614,117,101,115,116,59,1,10875,4,2,80,105,12711,12716,97,114,59,1,10646,4,3,59,101,102,12724,12726,12729,1,9667,59,1,8884,59,1,9666,114,4,2,100,117,12739,12746,115,104,97,114,59,1,10570,104,97,114,59,1,10598,4,2,101,110,12758,12768,114,116,110,101,113,113,59,3,8808,65024,69,59,3,8808,65024,4,14,68,97,99,100,101,102,104,105,108,110,111,112,115,117,12803,12809,12893,12908,12914,12928,12933,12937,13011,13025,13032,13049,13052,13069,68,111,116,59,1,8762,4,4,99,108,112,114,12819,12827,12849,12887,114,5,175,1,59,12825,1,175,4,2,101,116,12833,12836,59,1,9794,4,2,59,101,12842,12844,1,10016,115,101,59,1,10016,4,2,59,115,12855,12857,1,8614,116,111,4,4,59,100,108,117,12869,12871,12877,12883,1,8614,111,119,110,59,1,8615,101,102,116,59,1,8612,112,59,1,8613,107,101,114,59,1,9646,4,2,111,121,12899,12905,109,109,97,59,1,10793,59,1,1084,97,115,104,59,1,8212,97,115,117,114,101,100,97,110,103,108,101,59,1,8737,114,59,3,55349,56618,111,59,1,8487,4,3,99,100,110,12945,12954,12985,114,111,5,181,1,59,12952,1,181,4,4,59,97,99,100,12964,12966,12971,12976,1,8739,115,116,59,1,42,105,114,59,1,10992,111,116,5,183,1,59,12983,1,183,117,115,4,3,59,98,100,12995,12997,13000,1,8722,59,1,8863,4,2,59,117,13006,13008,1,8760,59,1,10794,4,2,99,100,13017,13021,112,59,1,10971,114,59,1,8230,112,108,117,115,59,1,8723,4,2,100,112,13038,13044,101,108,115,59,1,8871,102,59,3,55349,56670,59,1,8723,4,2,99,116,13058,13063,114,59,3,55349,56514,112,111,115,59,1,8766,4,3,59,108,109,13077,13079,13087,1,956,116,105,109,97,112,59,1,8888,97,112,59,1,8888,4,24,71,76,82,86,97,98,99,100,101,102,103,104,105,106,108,109,111,112,114,115,116,117,118,119,13142,13165,13217,13229,13247,13330,13359,13414,13420,13508,13513,13579,13602,13626,13631,13762,13767,13855,13936,13995,14214,14285,14312,14432,4,2,103,116,13148,13152,59,3,8921,824,4,2,59,118,13158,13161,3,8811,8402,59,3,8811,824,4,3,101,108,116,13173,13200,13204,102,116,4,2,97,114,13181,13188,114,114,111,119,59,1,8653,105,103,104,116,97,114,114,111,119,59,1,8654,59,3,8920,824,4,2,59,118,13210,13213,3,8810,8402,59,3,8810,824,105,103,104,116,97,114,114,111,119,59,1,8655,4,2,68,100,13235,13241,97,115,104,59,1,8879,97,115,104,59,1,8878,4,5,98,99,110,112,116,13259,13264,13270,13275,13308,108,97,59,1,8711,117,116,101,59,1,324,103,59,3,8736,8402,4,5,59,69,105,111,112,13287,13289,13293,13298,13302,1,8777,59,3,10864,824,100,59,3,8779,824,115,59,1,329,114,111,120,59,1,8777,117,114,4,2,59,97,13316,13318,1,9838,108,4,2,59,115,13325,13327,1,9838,59,1,8469,4,2,115,117,13336,13344,112,5,160,1,59,13342,1,160,109,112,4,2,59,101,13352,13355,3,8782,824,59,3,8783,824,4,5,97,101,111,117,121,13371,13385,13391,13407,13411,4,2,112,114,13377,13380,59,1,10819,111,110,59,1,328,100,105,108,59,1,326,110,103,4,2,59,100,13399,13401,1,8775,111,116,59,3,10861,824,112,59,1,10818,59,1,1085,97,115,104,59,1,8211,4,7,59,65,97,100,113,115,120,13436,13438,13443,13466,13472,13478,13494,1,8800,114,114,59,1,8663,114,4,2,104,114,13450,13454,107,59,1,10532,4,2,59,111,13460,13462,1,8599,119,59,1,8599,111,116,59,3,8784,824,117,105,118,59,1,8802,4,2,101,105,13484,13489,97,114,59,1,10536,109,59,3,8770,824,105,115,116,4,2,59,115,13503,13505,1,8708,59,1,8708,114,59,3,55349,56619,4,4,69,101,115,116,13523,13527,13563,13568,59,3,8807,824,4,3,59,113,115,13535,13537,13559,1,8817,4,3,59,113,115,13545,13547,13551,1,8817,59,3,8807,824,108,97,110,116,59,3,10878,824,59,3,10878,824,105,109,59,1,8821,4,2,59,114,13574,13576,1,8815,59,1,8815,4,3,65,97,112,13587,13592,13597,114,114,59,1,8654,114,114,59,1,8622,97,114,59,1,10994,4,3,59,115,118,13610,13612,13623,1,8715,4,2,59,100,13618,13620,1,8956,59,1,8954,59,1,8715,99,121,59,1,1114,4,7,65,69,97,100,101,115,116,13647,13652,13656,13661,13665,13737,13742,114,114,59,1,8653,59,3,8806,824,114,114,59,1,8602,114,59,1,8229,4,4,59,102,113,115,13675,13677,13703,13725,1,8816,116,4,2,97,114,13684,13691,114,114,111,119,59,1,8602,105,103,104,116,97,114,114,111,119,59,1,8622,4,3,59,113,115,13711,13713,13717,1,8816,59,3,8806,824,108,97,110,116,59,3,10877,824,4,2,59,115,13731,13734,3,10877,824,59,1,8814,105,109,59,1,8820,4,2,59,114,13748,13750,1,8814,105,4,2,59,101,13757,13759,1,8938,59,1,8940,105,100,59,1,8740,4,2,112,116,13773,13778,102,59,3,55349,56671,5,172,3,59,105,110,13787,13789,13829,1,172,110,4,4,59,69,100,118,13800,13802,13806,13812,1,8713,59,3,8953,824,111,116,59,3,8949,824,4,3,97,98,99,13820,13823,13826,59,1,8713,59,1,8951,59,1,8950,105,4,2,59,118,13836,13838,1,8716,4,3,97,98,99,13846,13849,13852,59,1,8716,59,1,8958,59,1,8957,4,3,97,111,114,13863,13892,13899,114,4,4,59,97,115,116,13874,13876,13883,13888,1,8742,108,108,101,108,59,1,8742,108,59,3,11005,8421,59,3,8706,824,108,105,110,116,59,1,10772,4,3,59,99,101,13907,13909,13914,1,8832,117,101,59,1,8928,4,2,59,99,13920,13923,3,10927,824,4,2,59,101,13929,13931,1,8832,113,59,3,10927,824,4,4,65,97,105,116,13946,13951,13971,13982,114,114,59,1,8655,114,114,4,3,59,99,119,13961,13963,13967,1,8603,59,3,10547,824,59,3,8605,824,103,104,116,97,114,114,111,119,59,1,8603,114,105,4,2,59,101,13990,13992,1,8939,59,1,8941,4,7,99,104,105,109,112,113,117,14011,14036,14060,14080,14085,14090,14106,4,4,59,99,101,114,14021,14023,14028,14032,1,8833,117,101,59,1,8929,59,3,10928,824,59,3,55349,56515,111,114,116,4,2,109,112,14045,14050,105,100,59,1,8740,97,114,97,108,108,101,108,59,1,8742,109,4,2,59,101,14067,14069,1,8769,4,2,59,113,14075,14077,1,8772,59,1,8772,105,100,59,1,8740,97,114,59,1,8742,115,117,4,2,98,112,14098,14102,101,59,1,8930,101,59,1,8931,4,3,98,99,112,14114,14157,14171,4,4,59,69,101,115,14124,14126,14130,14133,1,8836,59,3,10949,824,59,1,8840,101,116,4,2,59,101,14141,14144,3,8834,8402,113,4,2,59,113,14151,14153,1,8840,59,3,10949,824,99,4,2,59,101,14164,14166,1,8833,113,59,3,10928,824,4,4,59,69,101,115,14181,14183,14187,14190,1,8837,59,3,10950,824,59,1,8841,101,116,4,2,59,101,14198,14201,3,8835,8402,113,4,2,59,113,14208,14210,1,8841,59,3,10950,824,4,4,103,105,108,114,14224,14228,14238,14242,108,59,1,8825,108,100,101,5,241,1,59,14236,1,241,103,59,1,8824,105,97,110,103,108,101,4,2,108,114,14254,14269,101,102,116,4,2,59,101,14263,14265,1,8938,113,59,1,8940,105,103,104,116,4,2,59,101,14279,14281,1,8939,113,59,1,8941,4,2,59,109,14291,14293,1,957,4,3,59,101,115,14301,14303,14308,1,35,114,111,59,1,8470,112,59,1,8199,4,9,68,72,97,100,103,105,108,114,115,14332,14338,14344,14349,14355,14369,14376,14408,14426,97,115,104,59,1,8877,97,114,114,59,1,10500,112,59,3,8781,8402,97,115,104,59,1,8876,4,2,101,116,14361,14365,59,3,8805,8402,59,3,62,8402,110,102,105,110,59,1,10718,4,3,65,101,116,14384,14389,14393,114,114,59,1,10498,59,3,8804,8402,4,2,59,114,14399,14402,3,60,8402,105,101,59,3,8884,8402,4,2,65,116,14414,14419,114,114,59,1,10499,114,105,101,59,3,8885,8402,105,109,59,3,8764,8402,4,3,65,97,110,14440,14445,14468,114,114,59,1,8662,114,4,2,104,114,14452,14456,107,59,1,10531,4,2,59,111,14462,14464,1,8598,119,59,1,8598,101,97,114,59,1,10535,4,18,83,97,99,100,101,102,103,104,105,108,109,111,112,114,115,116,117,118,14512,14515,14535,14560,14597,14603,14618,14643,14657,14662,14701,14741,14747,14769,14851,14877,14907,14916,59,1,9416,4,2,99,115,14521,14531,117,116,101,5,243,1,59,14529,1,243,116,59,1,8859,4,2,105,121,14541,14557,114,4,2,59,99,14548,14550,1,8858,5,244,1,59,14555,1,244,59,1,1086,4,5,97,98,105,111,115,14572,14577,14583,14587,14591,115,104,59,1,8861,108,97,99,59,1,337,118,59,1,10808,116,59,1,8857,111,108,100,59,1,10684,108,105,103,59,1,339,4,2,99,114,14609,14614,105,114,59,1,10687,59,3,55349,56620,4,3,111,114,116,14626,14630,14640,110,59,1,731,97,118,101,5,242,1,59,14638,1,242,59,1,10689,4,2,98,109,14649,14654,97,114,59,1,10677,59,1,937,110,116,59,1,8750,4,4,97,99,105,116,14672,14677,14693,14698,114,114,59,1,8634,4,2,105,114,14683,14687,114,59,1,10686,111,115,115,59,1,10683,110,101,59,1,8254,59,1,10688,4,3,97,101,105,14709,14714,14719,99,114,59,1,333,103,97,59,1,969,4,3,99,100,110,14727,14733,14736,114,111,110,59,1,959,59,1,10678,117,115,59,1,8854,112,102,59,3,55349,56672,4,3,97,101,108,14755,14759,14764,114,59,1,10679,114,112,59,1,10681,117,115,59,1,8853,4,7,59,97,100,105,111,115,118,14785,14787,14792,14831,14837,14841,14848,1,8744,114,114,59,1,8635,4,4,59,101,102,109,14802,14804,14817,14824,1,10845,114,4,2,59,111,14811,14813,1,8500,102,59,1,8500,5,170,1,59,14822,1,170,5,186,1,59,14829,1,186,103,111,102,59,1,8886,114,59,1,10838,108,111,112,101,59,1,10839,59,1,10843,4,3,99,108,111,14859,14863,14873,114,59,1,8500,97,115,104,5,248,1,59,14871,1,248,108,59,1,8856,105,4,2,108,109,14884,14893,100,101,5,245,1,59,14891,1,245,101,115,4,2,59,97,14901,14903,1,8855,115,59,1,10806,109,108,5,246,1,59,14914,1,246,98,97,114,59,1,9021,4,12,97,99,101,102,104,105,108,109,111,114,115,117,14948,14992,14996,15033,15038,15068,15090,15189,15192,15222,15427,15441,114,4,4,59,97,115,116,14959,14961,14976,14989,1,8741,5,182,2,59,108,14968,14970,1,182,108,101,108,59,1,8741,4,2,105,108,14982,14986,109,59,1,10995,59,1,11005,59,1,8706,121,59,1,1087,114,4,5,99,105,109,112,116,15009,15014,15019,15024,15027,110,116,59,1,37,111,100,59,1,46,105,108,59,1,8240,59,1,8869,101,110,107,59,1,8241,114,59,3,55349,56621,4,3,105,109,111,15046,15057,15063,4,2,59,118,15052,15054,1,966,59,1,981,109,97,116,59,1,8499,110,101,59,1,9742,4,3,59,116,118,15076,15078,15087,1,960,99,104,102,111,114,107,59,1,8916,59,1,982,4,2,97,117,15096,15119,110,4,2,99,107,15103,15115,107,4,2,59,104,15110,15112,1,8463,59,1,8462,118,59,1,8463,115,4,9,59,97,98,99,100,101,109,115,116,15140,15142,15148,15151,15156,15168,15171,15179,15184,1,43,99,105,114,59,1,10787,59,1,8862,105,114,59,1,10786,4,2,111,117,15162,15165,59,1,8724,59,1,10789,59,1,10866,110,5,177,1,59,15177,1,177,105,109,59,1,10790,119,111,59,1,10791,59,1,177,4,3,105,112,117,15200,15208,15213,110,116,105,110,116,59,1,10773,102,59,3,55349,56673,110,100,5,163,1,59,15220,1,163,4,10,59,69,97,99,101,105,110,111,115,117,15244,15246,15249,15253,15258,15334,15347,15367,15416,15421,1,8826,59,1,10931,112,59,1,10935,117,101,59,1,8828,4,2,59,99,15264,15266,1,10927,4,6,59,97,99,101,110,115,15280,15282,15290,15299,15303,15329,1,8826,112,112,114,111,120,59,1,10935,117,114,108,121,101,113,59,1,8828,113,59,1,10927,4,3,97,101,115,15311,15319,15324,112,112,114,111,120,59,1,10937,113,113,59,1,10933,105,109,59,1,8936,105,109,59,1,8830,109,101,4,2,59,115,15342,15344,1,8242,59,1,8473,4,3,69,97,115,15355,15358,15362,59,1,10933,112,59,1,10937,105,109,59,1,8936,4,3,100,102,112,15375,15378,15404,59,1,8719,4,3,97,108,115,15386,15392,15398,108,97,114,59,1,9006,105,110,101,59,1,8978,117,114,102,59,1,8979,4,2,59,116,15410,15412,1,8733,111,59,1,8733,105,109,59,1,8830,114,101,108,59,1,8880,4,2,99,105,15433,15438,114,59,3,55349,56517,59,1,968,110,99,115,112,59,1,8200,4,6,102,105,111,112,115,117,15462,15467,15472,15478,15485,15491,114,59,3,55349,56622,110,116,59,1,10764,112,102,59,3,55349,56674,114,105,109,101,59,1,8279,99,114,59,3,55349,56518,4,3,97,101,111,15499,15520,15534,116,4,2,101,105,15506,15515,114,110,105,111,110,115,59,1,8461,110,116,59,1,10774,115,116,4,2,59,101,15528,15530,1,63,113,59,1,8799,116,5,34,1,59,15540,1,34,4,21,65,66,72,97,98,99,100,101,102,104,105,108,109,110,111,112,114,115,116,117,120,15586,15609,15615,15620,15796,15855,15893,15931,15977,16001,16039,16183,16204,16222,16228,16285,16312,16318,16363,16408,16416,4,3,97,114,116,15594,15599,15603,114,114,59,1,8667,114,59,1,8658,97,105,108,59,1,10524,97,114,114,59,1,10511,97,114,59,1,10596,4,7,99,100,101,110,113,114,116,15636,15651,15656,15664,15687,15696,15770,4,2,101,117,15642,15646,59,3,8765,817,116,101,59,1,341,105,99,59,1,8730,109,112,116,121,118,59,1,10675,103,4,4,59,100,101,108,15675,15677,15680,15683,1,10217,59,1,10642,59,1,10661,101,59,1,10217,117,111,5,187,1,59,15694,1,187,114,4,11,59,97,98,99,102,104,108,112,115,116,119,15721,15723,15727,15739,15742,15746,15750,15754,15758,15763,15767,1,8594,112,59,1,10613,4,2,59,102,15733,15735,1,8677,115,59,1,10528,59,1,10547,115,59,1,10526,107,59,1,8618,112,59,1,8620,108,59,1,10565,105,109,59,1,10612,108,59,1,8611,59,1,8605,4,2,97,105,15776,15781,105,108,59,1,10522,111,4,2,59,110,15788,15790,1,8758,97,108,115,59,1,8474,4,3,97,98,114,15804,15809,15814,114,114,59,1,10509,114,107,59,1,10099,4,2,97,107,15820,15833,99,4,2,101,107,15827,15830,59,1,125,59,1,93,4,2,101,115,15839,15842,59,1,10636,108,4,2,100,117,15849,15852,59,1,10638,59,1,10640,4,4,97,101,117,121,15865,15871,15886,15890,114,111,110,59,1,345,4,2,100,105,15877,15882,105,108,59,1,343,108,59,1,8969,98,59,1,125,59,1,1088,4,4,99,108,113,115,15903,15907,15914,15927,97,59,1,10551,100,104,97,114,59,1,10601,117,111,4,2,59,114,15922,15924,1,8221,59,1,8221,104,59,1,8627,4,3,97,99,103,15939,15966,15970,108,4,4,59,105,112,115,15950,15952,15957,15963,1,8476,110,101,59,1,8475,97,114,116,59,1,8476,59,1,8477,116,59,1,9645,5,174,1,59,15975,1,174,4,3,105,108,114,15985,15991,15997,115,104,116,59,1,10621,111,111,114,59,1,8971,59,3,55349,56623,4,2,97,111,16007,16028,114,4,2,100,117,16014,16017,59,1,8641,4,2,59,108,16023,16025,1,8640,59,1,10604,4,2,59,118,16034,16036,1,961,59,1,1009,4,3,103,110,115,16047,16167,16171,104,116,4,6,97,104,108,114,115,116,16063,16081,16103,16130,16143,16155,114,114,111,119,4,2,59,116,16073,16075,1,8594,97,105,108,59,1,8611,97,114,112,111,111,110,4,2,100,117,16093,16099,111,119,110,59,1,8641,112,59,1,8640,101,102,116,4,2,97,104,16112,16120,114,114,111,119,115,59,1,8644,97,114,112,111,111,110,115,59,1,8652,105,103,104,116,97,114,114,111,119,115,59,1,8649,113,117,105,103,97,114,114,111,119,59,1,8605,104,114,101,101,116,105,109,101,115,59,1,8908,103,59,1,730,105,110,103,100,111,116,115,101,113,59,1,8787,4,3,97,104,109,16191,16196,16201,114,114,59,1,8644,97,114,59,1,8652,59,1,8207,111,117,115,116,4,2,59,97,16214,16216,1,9137,99,104,101,59,1,9137,109,105,100,59,1,10990,4,4,97,98,112,116,16238,16252,16257,16278,4,2,110,114,16244,16248,103,59,1,10221,114,59,1,8702,114,107,59,1,10215,4,3,97,102,108,16265,16269,16273,114,59,1,10630,59,3,55349,56675,117,115,59,1,10798,105,109,101,115,59,1,10805,4,2,97,112,16291,16304,114,4,2,59,103,16298,16300,1,41,116,59,1,10644,111,108,105,110,116,59,1,10770,97,114,114,59,1,8649,4,4,97,99,104,113,16328,16334,16339,16342,113,117,111,59,1,8250,114,59,3,55349,56519,59,1,8625,4,2,98,117,16348,16351,59,1,93,111,4,2,59,114,16358,16360,1,8217,59,1,8217,4,3,104,105,114,16371,16377,16383,114,101,101,59,1,8908,109,101,115,59,1,8906,105,4,4,59,101,102,108,16394,16396,16399,16402,1,9657,59,1,8885,59,1,9656,116,114,105,59,1,10702,108,117,104,97,114,59,1,10600,59,1,8478,4,19,97,98,99,100,101,102,104,105,108,109,111,112,113,114,115,116,117,119,122,16459,16466,16472,16572,16590,16672,16687,16746,16844,16850,16924,16963,16988,17115,17121,17154,17206,17614,17656,99,117,116,101,59,1,347,113,117,111,59,1,8218,4,10,59,69,97,99,101,105,110,112,115,121,16494,16496,16499,16513,16518,16531,16536,16556,16564,16569,1,8827,59,1,10932,4,2,112,114,16505,16508,59,1,10936,111,110,59,1,353,117,101,59,1,8829,4,2,59,100,16524,16526,1,10928,105,108,59,1,351,114,99,59,1,349,4,3,69,97,115,16544,16547,16551,59,1,10934,112,59,1,10938,105,109,59,1,8937,111,108,105,110,116,59,1,10771,105,109,59,1,8831,59,1,1089,111,116,4,3,59,98,101,16582,16584,16587,1,8901,59,1,8865,59,1,10854,4,7,65,97,99,109,115,116,120,16606,16611,16634,16642,16646,16652,16668,114,114,59,1,8664,114,4,2,104,114,16618,16622,107,59,1,10533,4,2,59,111,16628,16630,1,8600,119,59,1,8600,116,5,167,1,59,16640,1,167,105,59,1,59,119,97,114,59,1,10537,109,4,2,105,110,16659,16665,110,117,115,59,1,8726,59,1,8726,116,59,1,10038,114,4,2,59,111,16679,16682,3,55349,56624,119,110,59,1,8994,4,4,97,99,111,121,16697,16702,16716,16739,114,112,59,1,9839,4,2,104,121,16708,16713,99,121,59,1,1097,59,1,1096,114,116,4,2,109,112,16724,16729,105,100,59,1,8739,97,114,97,108,108,101,108,59,1,8741,5,173,1,59,16744,1,173,4,2,103,109,16752,16770,109,97,4,3,59,102,118,16762,16764,16767,1,963,59,1,962,59,1,962,4,8,59,100,101,103,108,110,112,114,16788,16790,16795,16806,16817,16828,16832,16838,1,8764,111,116,59,1,10858,4,2,59,113,16801,16803,1,8771,59,1,8771,4,2,59,69,16812,16814,1,10910,59,1,10912,4,2,59,69,16823,16825,1,10909,59,1,10911,101,59,1,8774,108,117,115,59,1,10788,97,114,114,59,1,10610,97,114,114,59,1,8592,4,4,97,101,105,116,16860,16883,16891,16904,4,2,108,115,16866,16878,108,115,101,116,109,105,110,117,115,59,1,8726,104,112,59,1,10803,112,97,114,115,108,59,1,10724,4,2,100,108,16897,16900,59,1,8739,101,59,1,8995,4,2,59,101,16910,16912,1,10922,4,2,59,115,16918,16920,1,10924,59,3,10924,65024,4,3,102,108,112,16932,16938,16958,116,99,121,59,1,1100,4,2,59,98,16944,16946,1,47,4,2,59,97,16952,16954,1,10692,114,59,1,9023,102,59,3,55349,56676,97,4,2,100,114,16970,16985,101,115,4,2,59,117,16978,16980,1,9824,105,116,59,1,9824,59,1,8741,4,3,99,115,117,16996,17028,17089,4,2,97,117,17002,17015,112,4,2,59,115,17009,17011,1,8851,59,3,8851,65024,112,4,2,59,115,17022,17024,1,8852,59,3,8852,65024,117,4,2,98,112,17035,17062,4,3,59,101,115,17043,17045,17048,1,8847,59,1,8849,101,116,4,2,59,101,17056,17058,1,8847,113,59,1,8849,4,3,59,101,115,17070,17072,17075,1,8848,59,1,8850,101,116,4,2,59,101,17083,17085,1,8848,113,59,1,8850,4,3,59,97,102,17097,17099,17112,1,9633,114,4,2,101,102,17106,17109,59,1,9633,59,1,9642,59,1,9642,97,114,114,59,1,8594,4,4,99,101,109,116,17131,17136,17142,17148,114,59,3,55349,56520,116,109,110,59,1,8726,105,108,101,59,1,8995,97,114,102,59,1,8902,4,2,97,114,17160,17172,114,4,2,59,102,17167,17169,1,9734,59,1,9733,4,2,97,110,17178,17202,105,103,104,116,4,2,101,112,17188,17197,112,115,105,108,111,110,59,1,1013,104,105,59,1,981,115,59,1,175,4,5,98,99,109,110,112,17218,17351,17420,17423,17427,4,9,59,69,100,101,109,110,112,114,115,17238,17240,17243,17248,17261,17267,17279,17285,17291,1,8834,59,1,10949,111,116,59,1,10941,4,2,59,100,17254,17256,1,8838,111,116,59,1,10947,117,108,116,59,1,10945,4,2,69,101,17273,17276,59,1,10955,59,1,8842,108,117,115,59,1,10943,97,114,114,59,1,10617,4,3,101,105,117,17299,17335,17339,116,4,3,59,101,110,17308,17310,17322,1,8834,113,4,2,59,113,17317,17319,1,8838,59,1,10949,101,113,4,2,59,113,17330,17332,1,8842,59,1,10955,109,59,1,10951,4,2,98,112,17345,17348,59,1,10965,59,1,10963,99,4,6,59,97,99,101,110,115,17366,17368,17376,17385,17389,17415,1,8827,112,112,114,111,120,59,1,10936,117,114,108,121,101,113,59,1,8829,113,59,1,10928,4,3,97,101,115,17397,17405,17410,112,112,114,111,120,59,1,10938,113,113,59,1,10934,105,109,59,1,8937,105,109,59,1,8831,59,1,8721,103,59,1,9834,4,13,49,50,51,59,69,100,101,104,108,109,110,112,115,17455,17462,17469,17476,17478,17481,17496,17509,17524,17530,17536,17548,17554,5,185,1,59,17460,1,185,5,178,1,59,17467,1,178,5,179,1,59,17474,1,179,1,8835,59,1,10950,4,2,111,115,17487,17491,116,59,1,10942,117,98,59,1,10968,4,2,59,100,17502,17504,1,8839,111,116,59,1,10948,115,4,2,111,117,17516,17520,108,59,1,10185,98,59,1,10967,97,114,114,59,1,10619,117,108,116,59,1,10946,4,2,69,101,17542,17545,59,1,10956,59,1,8843,108,117,115,59,1,10944,4,3,101,105,117,17562,17598,17602,116,4,3,59,101,110,17571,17573,17585,1,8835,113,4,2,59,113,17580,17582,1,8839,59,1,10950,101,113,4,2,59,113,17593,17595,1,8843,59,1,10956,109,59,1,10952,4,2,98,112,17608,17611,59,1,10964,59,1,10966,4,3,65,97,110,17622,17627,17650,114,114,59,1,8665,114,4,2,104,114,17634,17638,107,59,1,10534,4,2,59,111,17644,17646,1,8601,119,59,1,8601,119,97,114,59,1,10538,108,105,103,5,223,1,59,17664,1,223,4,13,97,98,99,100,101,102,104,105,111,112,114,115,119,17694,17709,17714,17737,17742,17749,17754,17860,17905,17957,17964,18090,18122,4,2,114,117,17700,17706,103,101,116,59,1,8982,59,1,964,114,107,59,1,9140,4,3,97,101,121,17722,17728,17734,114,111,110,59,1,357,100,105,108,59,1,355,59,1,1090,111,116,59,1,8411,108,114,101,99,59,1,8981,114,59,3,55349,56625,4,4,101,105,107,111,17764,17805,17836,17851,4,2,114,116,17770,17786,101,4,2,52,102,17777,17780,59,1,8756,111,114,101,59,1,8756,97,4,3,59,115,118,17795,17797,17802,1,952,121,109,59,1,977,59,1,977,4,2,99,110,17811,17831,107,4,2,97,115,17818,17826,112,112,114,111,120,59,1,8776,105,109,59,1,8764,115,112,59,1,8201,4,2,97,115,17842,17846,112,59,1,8776,105,109,59,1,8764,114,110,5,254,1,59,17858,1,254,4,3,108,109,110,17868,17873,17901,100,101,59,1,732,101,115,5,215,3,59,98,100,17884,17886,17898,1,215,4,2,59,97,17892,17894,1,8864,114,59,1,10801,59,1,10800,116,59,1,8749,4,3,101,112,115,17913,17917,17953,97,59,1,10536,4,4,59,98,99,102,17927,17929,17934,17939,1,8868,111,116,59,1,9014,105,114,59,1,10993,4,2,59,111,17945,17948,3,55349,56677,114,107,59,1,10970,97,59,1,10537,114,105,109,101,59,1,8244,4,3,97,105,112,17972,17977,18082,100,101,59,1,8482,4,7,97,100,101,109,112,115,116,17993,18051,18056,18059,18066,18072,18076,110,103,108,101,4,5,59,100,108,113,114,18009,18011,18017,18032,18035,1,9653,111,119,110,59,1,9663,101,102,116,4,2,59,101,18026,18028,1,9667,113,59,1,8884,59,1,8796,105,103,104,116,4,2,59,101,18045,18047,1,9657,113,59,1,8885,111,116,59,1,9708,59,1,8796,105,110,117,115,59,1,10810,108,117,115,59,1,10809,98,59,1,10701,105,109,101,59,1,10811,101,122,105,117,109,59,1,9186,4,3,99,104,116,18098,18111,18116,4,2,114,121,18104,18108,59,3,55349,56521,59,1,1094,99,121,59,1,1115,114,111,107,59,1,359,4,2,105,111,18128,18133,120,116,59,1,8812,104,101,97,100,4,2,108,114,18143,18154,101,102,116,97,114,114,111,119,59,1,8606,105,103,104,116,97,114,114,111,119,59,1,8608,4,18,65,72,97,98,99,100,102,103,104,108,109,111,112,114,115,116,117,119,18204,18209,18214,18234,18250,18268,18292,18308,18319,18343,18379,18397,18413,18504,18547,18553,18584,18603,114,114,59,1,8657,97,114,59,1,10595,4,2,99,114,18220,18230,117,116,101,5,250,1,59,18228,1,250,114,59,1,8593,114,4,2,99,101,18241,18245,121,59,1,1118,118,101,59,1,365,4,2,105,121,18256,18265,114,99,5,251,1,59,18263,1,251,59,1,1091,4,3,97,98,104,18276,18281,18287,114,114,59,1,8645,108,97,99,59,1,369,97,114,59,1,10606,4,2,105,114,18298,18304,115,104,116,59,1,10622,59,3,55349,56626,114,97,118,101,5,249,1,59,18317,1,249,4,2,97,98,18325,18338,114,4,2,108,114,18332,18335,59,1,8639,59,1,8638,108,107,59,1,9600,4,2,99,116,18349,18374,4,2,111,114,18355,18369,114,110,4,2,59,101,18363,18365,1,8988,114,59,1,8988,111,112,59,1,8975,114,105,59,1,9720,4,2,97,108,18385,18390,99,114,59,1,363,5,168,1,59,18395,1,168,4,2,103,112,18403,18408,111,110,59,1,371,102,59,3,55349,56678,4,6,97,100,104,108,115,117,18427,18434,18445,18470,18475,18494,114,114,111,119,59,1,8593,111,119,110,97,114,114,111,119,59,1,8597,97,114,112,111,111,110,4,2,108,114,18457,18463,101,102,116,59,1,8639,105,103,104,116,59,1,8638,117,115,59,1,8846,105,4,3,59,104,108,18484,18486,18489,1,965,59,1,978,111,110,59,1,965,112,97,114,114,111,119,115,59,1,8648,4,3,99,105,116,18512,18537,18542,4,2,111,114,18518,18532,114,110,4,2,59,101,18526,18528,1,8989,114,59,1,8989,111,112,59,1,8974,110,103,59,1,367,114,105,59,1,9721,99,114,59,3,55349,56522,4,3,100,105,114,18561,18566,18572,111,116,59,1,8944,108,100,101,59,1,361,105,4,2,59,102,18579,18581,1,9653,59,1,9652,4,2,97,109,18590,18595,114,114,59,1,8648,108,5,252,1,59,18601,1,252,97,110,103,108,101,59,1,10663,4,15,65,66,68,97,99,100,101,102,108,110,111,112,114,115,122,18643,18648,18661,18667,18847,18851,18857,18904,18909,18915,18931,18937,18943,18949,18996,114,114,59,1,8661,97,114,4,2,59,118,18656,18658,1,10984,59,1,10985,97,115,104,59,1,8872,4,2,110,114,18673,18679,103,114,116,59,1,10652,4,7,101,107,110,112,114,115,116,18695,18704,18711,18720,18742,18754,18810,112,115,105,108,111,110,59,1,1013,97,112,112,97,59,1,1008,111,116,104,105,110,103,59,1,8709,4,3,104,105,114,18728,18732,18735,105,59,1,981,59,1,982,111,112,116,111,59,1,8733,4,2,59,104,18748,18750,1,8597,111,59,1,1009,4,2,105,117,18760,18766,103,109,97,59,1,962,4,2,98,112,18772,18791,115,101,116,110,101,113,4,2,59,113,18784,18787,3,8842,65024,59,3,10955,65024,115,101,116,110,101,113,4,2,59,113,18803,18806,3,8843,65024,59,3,10956,65024,4,2,104,114,18816,18822,101,116,97,59,1,977,105,97,110,103,108,101,4,2,108,114,18834,18840,101,102,116,59,1,8882,105,103,104,116,59,1,8883,121,59,1,1074,97,115,104,59,1,8866,4,3,101,108,114,18865,18884,18890,4,3,59,98,101,18873,18875,18880,1,8744,97,114,59,1,8891,113,59,1,8794,108,105,112,59,1,8942,4,2,98,116,18896,18901,97,114,59,1,124,59,1,124,114,59,3,55349,56627,116,114,105,59,1,8882,115,117,4,2,98,112,18923,18927,59,3,8834,8402,59,3,8835,8402,112,102,59,3,55349,56679,114,111,112,59,1,8733,116,114,105,59,1,8883,4,2,99,117,18955,18960,114,59,3,55349,56523,4,2,98,112,18966,18981,110,4,2,69,101,18973,18977,59,3,10955,65024,59,3,8842,65024,110,4,2,69,101,18988,18992,59,3,10956,65024,59,3,8843,65024,105,103,122,97,103,59,1,10650,4,7,99,101,102,111,112,114,115,19020,19026,19061,19066,19072,19075,19089,105,114,99,59,1,373,4,2,100,105,19032,19055,4,2,98,103,19038,19043,97,114,59,1,10847,101,4,2,59,113,19050,19052,1,8743,59,1,8793,101,114,112,59,1,8472,114,59,3,55349,56628,112,102,59,3,55349,56680,59,1,8472,4,2,59,101,19081,19083,1,8768,97,116,104,59,1,8768,99,114,59,3,55349,56524,4,14,99,100,102,104,105,108,109,110,111,114,115,117,118,119,19125,19146,19152,19157,19173,19176,19192,19197,19202,19236,19252,19269,19286,19291,4,3,97,105,117,19133,19137,19142,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,116,114,105,59,1,9661,114,59,3,55349,56629,4,2,65,97,19163,19168,114,114,59,1,10234,114,114,59,1,10231,59,1,958,4,2,65,97,19182,19187,114,114,59,1,10232,114,114,59,1,10229,97,112,59,1,10236,105,115,59,1,8955,4,3,100,112,116,19210,19215,19230,111,116,59,1,10752,4,2,102,108,19221,19225,59,3,55349,56681,117,115,59,1,10753,105,109,101,59,1,10754,4,2,65,97,19242,19247,114,114,59,1,10233,114,114,59,1,10230,4,2,99,113,19258,19263,114,59,3,55349,56525,99,117,112,59,1,10758,4,2,112,116,19275,19281,108,117,115,59,1,10756,114,105,59,1,9651,101,101,59,1,8897,101,100,103,101,59,1,8896,4,8,97,99,101,102,105,111,115,117,19316,19335,19349,19357,19362,19367,19373,19379,99,4,2,117,121,19323,19332,116,101,5,253,1,59,19330,1,253,59,1,1103,4,2,105,121,19341,19346,114,99,59,1,375,59,1,1099,110,5,165,1,59,19355,1,165,114,59,3,55349,56630,99,121,59,1,1111,112,102,59,3,55349,56682,99,114,59,3,55349,56526,4,2,99,109,19385,19389,121,59,1,1102,108,5,255,1,59,19395,1,255,4,10,97,99,100,101,102,104,105,111,115,119,19419,19426,19441,19446,19462,19467,19472,19480,19486,19492,99,117,116,101,59,1,378,4,2,97,121,19432,19438,114,111,110,59,1,382,59,1,1079,111,116,59,1,380,4,2,101,116,19452,19458,116,114,102,59,1,8488,97,59,1,950,114,59,3,55349,56631,99,121,59,1,1078,103,114,97,114,114,59,1,8669,112,102,59,3,55349,56683,99,114,59,3,55349,56527,4,2,106,110,19498,19501,59,1,8205,106,59,1,8204]);

/***/ }),

/***/ 30909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const unicode = __webpack_require__(3749);
const ERR = __webpack_require__(84166);

//Aliases
const $ = unicode.CODE_POINTS;

//Const
const DEFAULT_BUFFER_WATERLINE = 1 << 16;

//Preprocessor
//NOTE: HTML input preprocessing
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
class Preprocessor {
    constructor() {
        this.html = null;

        this.pos = -1;
        this.lastGapPos = -1;
        this.lastCharPos = -1;

        this.gapStack = [];

        this.skipNextNewLine = false;

        this.lastChunkWritten = false;
        this.endOfChunkHit = false;
        this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
    }

    _err() {
        // NOTE: err reporting is noop by default. Enabled by mixin.
    }

    _addGap() {
        this.gapStack.push(this.lastGapPos);
        this.lastGapPos = this.pos;
    }

    _processSurrogate(cp) {
        //NOTE: try to peek a surrogate pair
        if (this.pos !== this.lastCharPos) {
            const nextCp = this.html.charCodeAt(this.pos + 1);

            if (unicode.isSurrogatePair(nextCp)) {
                //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
                this.pos++;

                //NOTE: add gap that should be avoided during retreat
                this._addGap();

                return unicode.getSurrogatePairCodePoint(cp, nextCp);
            }
        }

        //NOTE: we are at the end of a chunk, therefore we can't infer surrogate pair yet.
        else if (!this.lastChunkWritten) {
            this.endOfChunkHit = true;
            return $.EOF;
        }

        //NOTE: isolated surrogate
        this._err(ERR.surrogateInInputStream);

        return cp;
    }

    dropParsedChunk() {
        if (this.pos > this.bufferWaterline) {
            this.lastCharPos -= this.pos;
            this.html = this.html.substring(this.pos);
            this.pos = 0;
            this.lastGapPos = -1;
            this.gapStack = [];
        }
    }

    write(chunk, isLastChunk) {
        if (this.html) {
            this.html += chunk;
        } else {
            this.html = chunk;
        }

        this.lastCharPos = this.html.length - 1;
        this.endOfChunkHit = false;
        this.lastChunkWritten = isLastChunk;
    }

    insertHtmlAtCurrentPos(chunk) {
        this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1, this.html.length);

        this.lastCharPos = this.html.length - 1;
        this.endOfChunkHit = false;
    }

    advance() {
        this.pos++;

        if (this.pos > this.lastCharPos) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return $.EOF;
        }

        let cp = this.html.charCodeAt(this.pos);

        //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
        //must be ignored.
        if (this.skipNextNewLine && cp === $.LINE_FEED) {
            this.skipNextNewLine = false;
            this._addGap();
            return this.advance();
        }

        //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
        if (cp === $.CARRIAGE_RETURN) {
            this.skipNextNewLine = true;
            return $.LINE_FEED;
        }

        this.skipNextNewLine = false;

        if (unicode.isSurrogate(cp)) {
            cp = this._processSurrogate(cp);
        }

        //OPTIMIZATION: first check if code point is in the common allowed
        //range (ASCII alphanumeric, whitespaces, big chunk of BMP)
        //before going into detailed performance cost validation.
        const isCommonValidRange =
            (cp > 0x1f && cp < 0x7f) || cp === $.LINE_FEED || cp === $.CARRIAGE_RETURN || (cp > 0x9f && cp < 0xfdd0);

        if (!isCommonValidRange) {
            this._checkForProblematicCharacters(cp);
        }

        return cp;
    }

    _checkForProblematicCharacters(cp) {
        if (unicode.isControlCodePoint(cp)) {
            this._err(ERR.controlCharacterInInputStream);
        } else if (unicode.isUndefinedCodePoint(cp)) {
            this._err(ERR.noncharacterInInputStream);
        }
    }

    retreat() {
        if (this.pos === this.lastGapPos) {
            this.lastGapPos = this.gapStack.pop();
            this.pos--;
        }

        this.pos--;
    }
}

module.exports = Preprocessor;


/***/ }),

/***/ 13408:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


const { DOCUMENT_MODE } = __webpack_require__(76256);

//Node construction
exports.createDocument = function() {
    return {
        nodeName: '#document',
        mode: DOCUMENT_MODE.NO_QUIRKS,
        childNodes: []
    };
};

exports.createDocumentFragment = function() {
    return {
        nodeName: '#document-fragment',
        childNodes: []
    };
};

exports.createElement = function(tagName, namespaceURI, attrs) {
    return {
        nodeName: tagName,
        tagName: tagName,
        attrs: attrs,
        namespaceURI: namespaceURI,
        childNodes: [],
        parentNode: null
    };
};

exports.createCommentNode = function(data) {
    return {
        nodeName: '#comment',
        data: data,
        parentNode: null
    };
};

const createTextNode = function(value) {
    return {
        nodeName: '#text',
        value: value,
        parentNode: null
    };
};

//Tree mutation
const appendChild = (exports.appendChild = function(parentNode, newNode) {
    parentNode.childNodes.push(newNode);
    newNode.parentNode = parentNode;
});

const insertBefore = (exports.insertBefore = function(parentNode, newNode, referenceNode) {
    const insertionIdx = parentNode.childNodes.indexOf(referenceNode);

    parentNode.childNodes.splice(insertionIdx, 0, newNode);
    newNode.parentNode = parentNode;
});

exports.setTemplateContent = function(templateElement, contentElement) {
    templateElement.content = contentElement;
};

exports.getTemplateContent = function(templateElement) {
    return templateElement.content;
};

exports.setDocumentType = function(document, name, publicId, systemId) {
    let doctypeNode = null;

    for (let i = 0; i < document.childNodes.length; i++) {
        if (document.childNodes[i].nodeName === '#documentType') {
            doctypeNode = document.childNodes[i];
            break;
        }
    }

    if (doctypeNode) {
        doctypeNode.name = name;
        doctypeNode.publicId = publicId;
        doctypeNode.systemId = systemId;
    } else {
        appendChild(document, {
            nodeName: '#documentType',
            name: name,
            publicId: publicId,
            systemId: systemId
        });
    }
};

exports.setDocumentMode = function(document, mode) {
    document.mode = mode;
};

exports.getDocumentMode = function(document) {
    return document.mode;
};

exports.detachNode = function(node) {
    if (node.parentNode) {
        const idx = node.parentNode.childNodes.indexOf(node);

        node.parentNode.childNodes.splice(idx, 1);
        node.parentNode = null;
    }
};

exports.insertText = function(parentNode, text) {
    if (parentNode.childNodes.length) {
        const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];

        if (prevNode.nodeName === '#text') {
            prevNode.value += text;
            return;
        }
    }

    appendChild(parentNode, createTextNode(text));
};

exports.insertTextBefore = function(parentNode, text, referenceNode) {
    const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];

    if (prevNode && prevNode.nodeName === '#text') {
        prevNode.value += text;
    } else {
        insertBefore(parentNode, createTextNode(text), referenceNode);
    }
};

exports.adoptAttributes = function(recipient, attrs) {
    const recipientAttrsMap = [];

    for (let i = 0; i < recipient.attrs.length; i++) {
        recipientAttrsMap.push(recipient.attrs[i].name);
    }

    for (let j = 0; j < attrs.length; j++) {
        if (recipientAttrsMap.indexOf(attrs[j].name) === -1) {
            recipient.attrs.push(attrs[j]);
        }
    }
};

//Tree traversing
exports.getFirstChild = function(node) {
    return node.childNodes[0];
};

exports.getChildNodes = function(node) {
    return node.childNodes;
};

exports.getParentNode = function(node) {
    return node.parentNode;
};

exports.getAttrList = function(element) {
    return element.attrs;
};

//Node data
exports.getTagName = function(element) {
    return element.tagName;
};

exports.getNamespaceURI = function(element) {
    return element.namespaceURI;
};

exports.getTextNodeContent = function(textNode) {
    return textNode.value;
};

exports.getCommentNodeContent = function(commentNode) {
    return commentNode.data;
};

exports.getDocumentTypeNodeName = function(doctypeNode) {
    return doctypeNode.name;
};

exports.getDocumentTypeNodePublicId = function(doctypeNode) {
    return doctypeNode.publicId;
};

exports.getDocumentTypeNodeSystemId = function(doctypeNode) {
    return doctypeNode.systemId;
};

//Node types
exports.isTextNode = function(node) {
    return node.nodeName === '#text';
};

exports.isCommentNode = function(node) {
    return node.nodeName === '#comment';
};

exports.isDocumentTypeNode = function(node) {
    return node.nodeName === '#documentType';
};

exports.isElementNode = function(node) {
    return !!node.tagName;
};

// Source code location
exports.setNodeSourceCodeLocation = function(node, location) {
    node.sourceCodeLocation = location;
};

exports.getNodeSourceCodeLocation = function(node) {
    return node.sourceCodeLocation;
};

exports.updateNodeSourceCodeLocation = function(node, endLocation) {
    node.sourceCodeLocation = Object.assign(node.sourceCodeLocation, endLocation);
};


/***/ }),

/***/ 96399:
/***/ (function(module) {

"use strict";


module.exports = function mergeOptions(defaults, options) {
    options = options || Object.create(null);

    return [defaults, options].reduce((merged, optObj) => {
        Object.keys(optObj).forEach(key => {
            merged[key] = optObj[key];
        });

        return merged;
    }, Object.create(null));
};


/***/ }),

/***/ 44315:
/***/ (function(module) {

"use strict";


class Mixin {
    constructor(host) {
        const originalMethods = {};
        const overriddenMethods = this._getOverriddenMethods(this, originalMethods);

        for (const key of Object.keys(overriddenMethods)) {
            if (typeof overriddenMethods[key] === 'function') {
                originalMethods[key] = host[key];
                host[key] = overriddenMethods[key];
            }
        }
    }

    _getOverriddenMethods() {
        throw new Error('Not implemented');
    }
}

Mixin.install = function(host, Ctor, opts) {
    if (!host.__mixins) {
        host.__mixins = [];
    }

    for (let i = 0; i < host.__mixins.length; i++) {
        if (host.__mixins[i].constructor === Ctor) {
            return host.__mixins[i];
        }
    }

    const mixin = new Ctor(host, opts);

    host.__mixins.push(mixin);

    return mixin;
};

module.exports = Mixin;


/***/ }),

/***/ 97221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ErrorCode": function() { return /* reexport */ ErrorCode; },
  "connectToChild": function() { return /* reexport */ connectToChild; },
  "connectToParent": function() { return /* reexport */ connectToParent; }
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/enums.js
var MessageType;
(function (MessageType) {
    MessageType["Call"] = "call";
    MessageType["Reply"] = "reply";
    MessageType["Syn"] = "syn";
    MessageType["SynAck"] = "synAck";
    MessageType["Ack"] = "ack";
})(MessageType || (MessageType = {}));
var Resolution;
(function (Resolution) {
    Resolution["Fulfilled"] = "fulfilled";
    Resolution["Rejected"] = "rejected";
})(Resolution || (Resolution = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ConnectionDestroyed"] = "ConnectionDestroyed";
    ErrorCode["ConnectionTimeout"] = "ConnectionTimeout";
    ErrorCode["NoIframeSrc"] = "NoIframeSrc";
})(ErrorCode || (ErrorCode = {}));
var NativeErrorName;
(function (NativeErrorName) {
    NativeErrorName["DataCloneError"] = "DataCloneError";
})(NativeErrorName || (NativeErrorName = {}));
var NativeEventType;
(function (NativeEventType) {
    NativeEventType["Message"] = "message";
})(NativeEventType || (NativeEventType = {}));

;// CONCATENATED MODULE: ../node_modules/penpal/lib/createDestructor.js
/* harmony default export */ var createDestructor = ((localName, log) => {
    const callbacks = [];
    let destroyed = false;
    return {
        destroy(error) {
            if (!destroyed) {
                destroyed = true;
                log(`${localName}: Destroying connection`);
                callbacks.forEach((callback) => {
                    callback(error);
                });
            }
        },
        onDestroy(callback) {
            destroyed ? callback() : callbacks.push(callback);
        },
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/createLogger.js
/* harmony default export */ var createLogger = ((debug) => {
    /**
     * Logs a message if debug is enabled.
     */
    return (...args) => {
        if (debug) {
            console.log('[Penpal]', ...args); // eslint-disable-line no-console
        }
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/getOriginFromSrc.js
const DEFAULT_PORT_BY_PROTOCOL = {
    'http:': '80',
    'https:': '443',
};
const URL_REGEX = /^(https?:)?\/\/([^/:]+)?(:(\d+))?/;
const opaqueOriginSchemes = ['file:', 'data:'];
/**
 * Converts a src value into an origin.
 */
/* harmony default export */ var getOriginFromSrc = ((src) => {
    if (src && opaqueOriginSchemes.find((scheme) => src.startsWith(scheme))) {
        // The origin of the child document is an opaque origin and its
        // serialization is "null"
        // https://html.spec.whatwg.org/multipage/origin.html#origin
        return 'null';
    }
    // Note that if src is undefined, then srcdoc is being used instead of src
    // and we can follow this same logic below to get the origin of the parent,
    // which is the origin that we will need to use.
    const location = document.location;
    const regexResult = URL_REGEX.exec(src);
    let protocol;
    let hostname;
    let port;
    if (regexResult) {
        // It's an absolute URL. Use the parsed info.
        // regexResult[1] will be undefined if the URL starts with //
        protocol = regexResult[1] ? regexResult[1] : location.protocol;
        hostname = regexResult[2];
        port = regexResult[4];
    }
    else {
        // It's a relative path. Use the current location's info.
        protocol = location.protocol;
        hostname = location.hostname;
        port = location.port;
    }
    // If the port is the default for the protocol, we don't want to add it to the origin string
    // or it won't match the message's event.origin.
    const portSuffix = port && port !== DEFAULT_PORT_BY_PROTOCOL[protocol] ? `:${port}` : '';
    return `${protocol}//${hostname}${portSuffix}`;
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/errorSerialization.js
/**
 * Converts an error object into a plain object.
 */
const serializeError = ({ name, message, stack, }) => ({
    name,
    message,
    stack,
});
/**
 * Converts a plain object into an error object.
 */
const deserializeError = (obj) => {
    const deserializedError = new Error();
    // @ts-ignore
    Object.keys(obj).forEach((key) => (deserializedError[key] = obj[key]));
    return deserializedError;
};

;// CONCATENATED MODULE: ../node_modules/penpal/lib/connectCallReceiver.js


/**
 * Listens for "call" messages coming from the remote, executes the corresponding method, and
 * responds with the return value.
 */
/* harmony default export */ var connectCallReceiver = ((info, serializedMethods, log) => {
    const { localName, local, remote, originForSending, originForReceiving, } = info;
    let destroyed = false;
    const handleMessageEvent = (event) => {
        if (event.source !== remote || event.data.penpal !== MessageType.Call) {
            return;
        }
        if (originForReceiving !== '*' && event.origin !== originForReceiving) {
            log(`${localName} received message from origin ${event.origin} which did not match expected origin ${originForReceiving}`);
            return;
        }
        const callMessage = event.data;
        const { methodName, args, id } = callMessage;
        log(`${localName}: Received ${methodName}() call`);
        const createPromiseHandler = (resolution) => {
            return (returnValue) => {
                log(`${localName}: Sending ${methodName}() reply`);
                if (destroyed) {
                    // It's possible to throw an error here, but it would need to be thrown asynchronously
                    // and would only be catchable using window.onerror. This is because the consumer
                    // is merely returning a value from their method and not calling any function
                    // that they could wrap in a try-catch. Even if the consumer were to catch the error,
                    // the value of doing so is questionable. Instead, we'll just log a message.
                    log(`${localName}: Unable to send ${methodName}() reply due to destroyed connection`);
                    return;
                }
                const message = {
                    penpal: MessageType.Reply,
                    id,
                    resolution,
                    returnValue,
                };
                if (resolution === Resolution.Rejected &&
                    returnValue instanceof Error) {
                    message.returnValue = serializeError(returnValue);
                    message.returnValueIsError = true;
                }
                try {
                    remote.postMessage(message, originForSending);
                }
                catch (err) {
                    // If a consumer attempts to send an object that's not cloneable (e.g., window),
                    // we want to ensure the receiver's promise gets rejected.
                    if (err.name === NativeErrorName.DataCloneError) {
                        const errorReplyMessage = {
                            penpal: MessageType.Reply,
                            id,
                            resolution: Resolution.Rejected,
                            returnValue: serializeError(err),
                            returnValueIsError: true,
                        };
                        remote.postMessage(errorReplyMessage, originForSending);
                    }
                    throw err;
                }
            };
        };
        new Promise((resolve) => resolve(serializedMethods[methodName].apply(serializedMethods, args))).then(createPromiseHandler(Resolution.Fulfilled), createPromiseHandler(Resolution.Rejected));
    };
    local.addEventListener(NativeEventType.Message, handleMessageEvent);
    return () => {
        destroyed = true;
        local.removeEventListener(NativeEventType.Message, handleMessageEvent);
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/generateId.js
let id = 0;
/**
 * @return {number} A unique ID (not universally unique)
 */
/* harmony default export */ var generateId = (() => ++id);

;// CONCATENATED MODULE: ../node_modules/penpal/lib/methodSerialization.js
const KEY_PATH_DELIMITER = '.';
const keyPathToSegments = (keyPath) => keyPath ? keyPath.split(KEY_PATH_DELIMITER) : [];
const segmentsToKeyPath = (segments) => segments.join(KEY_PATH_DELIMITER);
const createKeyPath = (key, prefix) => {
    const segments = keyPathToSegments(prefix || '');
    segments.push(key);
    return segmentsToKeyPath(segments);
};
/**
 * Given a `keyPath`, set it to be `value` on `subject`, creating any intermediate
 * objects along the way.
 *
 * @param {Object} subject The object on which to set value.
 * @param {string} keyPath The key path at which to set value.
 * @param {Object} value The value to store at the given key path.
 * @returns {Object} Updated subject.
 */
const setAtKeyPath = (subject, keyPath, value) => {
    const segments = keyPathToSegments(keyPath);
    segments.reduce((prevSubject, key, idx) => {
        if (typeof prevSubject[key] === 'undefined') {
            prevSubject[key] = {};
        }
        if (idx === segments.length - 1) {
            prevSubject[key] = value;
        }
        return prevSubject[key];
    }, subject);
    return subject;
};
/**
 * Given a dictionary of (nested) keys to function, flatten them to a map
 * from key path to function.
 *
 * @param {Object} methods The (potentially nested) object to serialize.
 * @param {string} prefix A string with which to prefix entries. Typically not intended to be used by consumers.
 * @returns {Object} An map from key path in `methods` to functions.
 */
const serializeMethods = (methods, prefix) => {
    const flattenedMethods = {};
    Object.keys(methods).forEach((key) => {
        const value = methods[key];
        const keyPath = createKeyPath(key, prefix);
        if (typeof value === 'object') {
            // Recurse into any nested children.
            Object.assign(flattenedMethods, serializeMethods(value, keyPath));
        }
        if (typeof value === 'function') {
            // If we've found a method, expose it.
            flattenedMethods[keyPath] = value;
        }
    });
    return flattenedMethods;
};
/**
 * Given a map of key paths to functions, unpack the key paths to an object.
 *
 * @param {Object} flattenedMethods A map of key paths to functions to unpack.
 * @returns {Object} A (potentially nested) map of functions.
 */
const deserializeMethods = (flattenedMethods) => {
    const methods = {};
    for (const keyPath in flattenedMethods) {
        setAtKeyPath(methods, keyPath, flattenedMethods[keyPath]);
    }
    return methods;
};

;// CONCATENATED MODULE: ../node_modules/penpal/lib/connectCallSender.js




/**
 * Augments an object with methods that match those defined by the remote. When these methods are
 * called, a "call" message will be sent to the remote, the remote's corresponding method will be
 * executed, and the method's return value will be returned via a message.
 * @param {Object} callSender Sender object that should be augmented with methods.
 * @param {Object} info Information about the local and remote windows.
 * @param {Array} methodKeyPaths Key paths of methods available to be called on the remote.
 * @param {Promise} destructionPromise A promise resolved when destroy() is called on the penpal
 * connection.
 * @returns {Object} The call sender object with methods that may be called.
 */
/* harmony default export */ var connectCallSender = ((callSender, info, methodKeyPaths, destroyConnection, log) => {
    const { localName, local, remote, originForSending, originForReceiving, } = info;
    let destroyed = false;
    log(`${localName}: Connecting call sender`);
    const createMethodProxy = (methodName) => {
        return (...args) => {
            log(`${localName}: Sending ${methodName}() call`);
            // This handles the case where the iframe has been removed from the DOM
            // (and therefore its window closed), the consumer has not yet
            // called destroy(), and the user calls a method exposed by
            // the remote. We detect the iframe has been removed and force
            // a destroy() immediately so that the consumer sees the error saying
            // the connection has been destroyed. We wrap this check in a try catch
            // because Edge throws an "Object expected" error when accessing
            // contentWindow.closed on a contentWindow from an iframe that's been
            // removed from the DOM.
            let iframeRemoved;
            try {
                if (remote.closed) {
                    iframeRemoved = true;
                }
            }
            catch (e) {
                iframeRemoved = true;
            }
            if (iframeRemoved) {
                destroyConnection();
            }
            if (destroyed) {
                const error = new Error(`Unable to send ${methodName}() call due ` + `to destroyed connection`);
                error.code = ErrorCode.ConnectionDestroyed;
                throw error;
            }
            return new Promise((resolve, reject) => {
                const id = generateId();
                const handleMessageEvent = (event) => {
                    if (event.source !== remote ||
                        event.data.penpal !== MessageType.Reply ||
                        event.data.id !== id) {
                        return;
                    }
                    if (originForReceiving !== '*' &&
                        event.origin !== originForReceiving) {
                        log(`${localName} received message from origin ${event.origin} which did not match expected origin ${originForReceiving}`);
                        return;
                    }
                    const replyMessage = event.data;
                    log(`${localName}: Received ${methodName}() reply`);
                    local.removeEventListener(NativeEventType.Message, handleMessageEvent);
                    let returnValue = replyMessage.returnValue;
                    if (replyMessage.returnValueIsError) {
                        returnValue = deserializeError(returnValue);
                    }
                    (replyMessage.resolution === Resolution.Fulfilled ? resolve : reject)(returnValue);
                };
                local.addEventListener(NativeEventType.Message, handleMessageEvent);
                const callMessage = {
                    penpal: MessageType.Call,
                    id,
                    methodName,
                    args,
                };
                remote.postMessage(callMessage, originForSending);
            });
        };
    };
    // Wrap each method in a proxy which sends it to the corresponding receiver.
    const flattenedMethods = methodKeyPaths.reduce((api, name) => {
        api[name] = createMethodProxy(name);
        return api;
    }, {});
    // Unpack the structure of the provided methods object onto the CallSender, exposing
    // the methods in the same shape they were provided.
    Object.assign(callSender, deserializeMethods(flattenedMethods));
    return () => {
        destroyed = true;
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/handleAckMessageFactory.js


/**
 * Handles an ACK handshake message.
 */
/* harmony default export */ var handleAckMessageFactory = ((serializedMethods, childOrigin, originForSending, destructor, log) => {
    const { destroy, onDestroy } = destructor;
    let destroyCallReceiver;
    let receiverMethodNames;
    // We resolve the promise with the call sender. If the child reconnects
    // (for example, after refreshing or navigating to another page that
    // uses Penpal, we'll update the call sender with methods that match the
    // latest provided by the child.
    const callSender = {};
    return (event) => {
        if (childOrigin !== '*' && event.origin !== childOrigin) {
            log(`Parent: Handshake - Received ACK message from origin ${event.origin} which did not match expected origin ${childOrigin}`);
            return;
        }
        log('Parent: Handshake - Received ACK');
        const info = {
            localName: 'Parent',
            local: window,
            remote: event.source,
            originForSending: originForSending,
            originForReceiving: childOrigin,
        };
        // If the child reconnected, we need to destroy the prior call receiver
        // before setting up a new one.
        if (destroyCallReceiver) {
            destroyCallReceiver();
        }
        destroyCallReceiver = connectCallReceiver(info, serializedMethods, log);
        onDestroy(destroyCallReceiver);
        // If the child reconnected, we need to remove the methods from the
        // previous call receiver off the sender.
        if (receiverMethodNames) {
            receiverMethodNames.forEach((receiverMethodName) => {
                delete callSender[receiverMethodName];
            });
        }
        receiverMethodNames = event.data.methodNames;
        const destroyCallSender = connectCallSender(callSender, info, receiverMethodNames, destroy, log);
        onDestroy(destroyCallSender);
        return callSender;
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/handleSynMessageFactory.js

/**
 * Handles a SYN handshake message.
 */
/* harmony default export */ var handleSynMessageFactory = ((log, serializedMethods, childOrigin, originForSending) => {
    return (event) => {
        // Under specific timing circumstances, we can receive an event
        // whose source is null. This seems to happen when the child iframe is
        // removed from the DOM about the same time it has sent the SYN event.
        // https://github.com/Aaronius/penpal/issues/85
        if (!event.source) {
            return;
        }
        if (childOrigin !== '*' && event.origin !== childOrigin) {
            log(`Parent: Handshake - Received SYN message from origin ${event.origin} which did not match expected origin ${childOrigin}`);
            return;
        }
        log('Parent: Handshake - Received SYN, responding with SYN-ACK');
        const synAckMessage = {
            penpal: MessageType.SynAck,
            methodNames: Object.keys(serializedMethods),
        };
        event.source.postMessage(synAckMessage, originForSending);
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/monitorIframeRemoval.js
const CHECK_IFRAME_IN_DOC_INTERVAL = 60000;
/**
 * Monitors for iframe removal and destroys connection if iframe
 * is found to have been removed from DOM. This is to prevent memory
 * leaks when the iframe is removed from the document and the consumer
 * hasn't called destroy(). Without this, event listeners attached to
 * the window would stick around and since the event handlers have a
 * reference to the iframe in their closures, the iframe would stick
 * around too.
 */
/* harmony default export */ var monitorIframeRemoval = ((iframe, destructor) => {
    const { destroy, onDestroy } = destructor;
    const checkIframeInDocIntervalId = setInterval(() => {
        if (!iframe.isConnected) {
            clearInterval(checkIframeInDocIntervalId);
            destroy();
        }
    }, CHECK_IFRAME_IN_DOC_INTERVAL);
    onDestroy(() => {
        clearInterval(checkIframeInDocIntervalId);
    });
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/startConnectionTimeout.js

/**
 * Starts a timeout and calls the callback with an error
 * if the timeout completes before the stop function is called.
 */
/* harmony default export */ var startConnectionTimeout = ((timeout, callback) => {
    let timeoutId;
    if (timeout !== undefined) {
        timeoutId = window.setTimeout(() => {
            const error = new Error(`Connection timed out after ${timeout}ms`);
            error.code = ErrorCode.ConnectionTimeout;
            callback(error);
        }, timeout);
    }
    return () => {
        clearTimeout(timeoutId);
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/validateIframeHasSrcOrSrcDoc.js

/* harmony default export */ var validateIframeHasSrcOrSrcDoc = ((iframe) => {
    if (!iframe.src && !iframe.srcdoc) {
        const error = new Error('Iframe must have src or srcdoc property defined.');
        error.code = ErrorCode.NoIframeSrc;
        throw error;
    }
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/connectToChild.js










/**
 * Attempts to establish communication with an iframe.
 */
/* harmony default export */ var connectToChild = ((options) => {
    let { iframe, methods = {}, childOrigin, timeout, debug = false } = options;
    const log = createLogger(debug);
    const destructor = createDestructor('Parent', log);
    const { onDestroy, destroy } = destructor;
    if (!childOrigin) {
        validateIframeHasSrcOrSrcDoc(iframe);
        childOrigin = getOriginFromSrc(iframe.src);
    }
    // If event.origin is "null", the remote protocol is file: or data: and we
    // must post messages with "*" as targetOrigin when sending messages.
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#Using_window.postMessage_in_extensions
    const originForSending = childOrigin === 'null' ? '*' : childOrigin;
    const serializedMethods = serializeMethods(methods);
    const handleSynMessage = handleSynMessageFactory(log, serializedMethods, childOrigin, originForSending);
    const handleAckMessage = handleAckMessageFactory(serializedMethods, childOrigin, originForSending, destructor, log);
    const promise = new Promise((resolve, reject) => {
        const stopConnectionTimeout = startConnectionTimeout(timeout, destroy);
        const handleMessage = (event) => {
            if (event.source !== iframe.contentWindow || !event.data) {
                return;
            }
            if (event.data.penpal === MessageType.Syn) {
                handleSynMessage(event);
                return;
            }
            if (event.data.penpal === MessageType.Ack) {
                const callSender = handleAckMessage(event);
                if (callSender) {
                    stopConnectionTimeout();
                    resolve(callSender);
                }
                return;
            }
        };
        window.addEventListener(NativeEventType.Message, handleMessage);
        log('Parent: Awaiting handshake');
        monitorIframeRemoval(iframe, destructor);
        onDestroy((error) => {
            window.removeEventListener(NativeEventType.Message, handleMessage);
            if (error) {
                reject(error);
            }
        });
    });
    return {
        promise,
        destroy() {
            // Don't allow consumer to pass an error into destroy.
            destroy();
        },
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/child/handleSynAckMessageFactory.js



/**
 * Handles a SYN-ACK handshake message.
 */
/* harmony default export */ var handleSynAckMessageFactory = ((parentOrigin, serializedMethods, destructor, log) => {
    const { destroy, onDestroy } = destructor;
    return (event) => {
        let originQualifies = parentOrigin instanceof RegExp
            ? parentOrigin.test(event.origin)
            : parentOrigin === '*' || parentOrigin === event.origin;
        if (!originQualifies) {
            log(`Child: Handshake - Received SYN-ACK from origin ${event.origin} which did not match expected origin ${parentOrigin}`);
            return;
        }
        log('Child: Handshake - Received SYN-ACK, responding with ACK');
        // If event.origin is "null", the remote protocol is file: or data: and we
        // must post messages with "*" as targetOrigin when sending messages.
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#Using_window.postMessage_in_extensions
        const originForSending = event.origin === 'null' ? '*' : event.origin;
        const ackMessage = {
            penpal: MessageType.Ack,
            methodNames: Object.keys(serializedMethods),
        };
        window.parent.postMessage(ackMessage, originForSending);
        const info = {
            localName: 'Child',
            local: window,
            remote: window.parent,
            originForSending,
            originForReceiving: event.origin,
        };
        const destroyCallReceiver = connectCallReceiver(info, serializedMethods, log);
        onDestroy(destroyCallReceiver);
        const callSender = {};
        const destroyCallSender = connectCallSender(callSender, info, event.data.methodNames, destroy, log);
        onDestroy(destroyCallSender);
        return callSender;
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/child/connectToParent.js






const areGlobalsAccessible = () => {
    try {
        clearTimeout();
    }
    catch (e) {
        return false;
    }
    return true;
};
/**
 * Attempts to establish communication with the parent window.
 */
/* harmony default export */ var connectToParent = ((options = {}) => {
    const { parentOrigin = '*', methods = {}, timeout, debug = false } = options;
    const log = createLogger(debug);
    const destructor = createDestructor('Child', log);
    const { destroy, onDestroy } = destructor;
    const serializedMethods = serializeMethods(methods);
    const handleSynAckMessage = handleSynAckMessageFactory(parentOrigin, serializedMethods, destructor, log);
    const sendSynMessage = () => {
        log('Child: Handshake - Sending SYN');
        const synMessage = { penpal: MessageType.Syn };
        const parentOriginForSyn = parentOrigin instanceof RegExp ? '*' : parentOrigin;
        window.parent.postMessage(synMessage, parentOriginForSyn);
    };
    const promise = new Promise((resolve, reject) => {
        const stopConnectionTimeout = startConnectionTimeout(timeout, destroy);
        const handleMessage = (event) => {
            // Under niche scenarios, we get into this function after
            // the iframe has been removed from the DOM. In Edge, this
            // results in "Object expected" errors being thrown when we
            // try to access properties on window (global properties).
            // For this reason, we try to access a global up front (clearTimeout)
            // and if it fails we can assume the iframe has been removed
            // and we ignore the message event.
            if (!areGlobalsAccessible()) {
                return;
            }
            if (event.source !== parent || !event.data) {
                return;
            }
            if (event.data.penpal === MessageType.SynAck) {
                const callSender = handleSynAckMessage(event);
                if (callSender) {
                    window.removeEventListener(NativeEventType.Message, handleMessage);
                    stopConnectionTimeout();
                    resolve(callSender);
                }
            }
        };
        window.addEventListener(NativeEventType.Message, handleMessage);
        sendSynMessage();
        onDestroy((error) => {
            window.removeEventListener(NativeEventType.Message, handleMessage);
            if (error) {
                reject(error);
            }
        });
    });
    return {
        promise,
        destroy() {
            // Don't allow consumer to pass an error into destroy.
            destroy();
        },
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/index.js





/***/ }),

/***/ 58772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(90331);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 23615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(58772)();
}


/***/ }),

/***/ 90331:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 67651:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
 * License: MIT - http://mrgnrdrck.mit-license.org
 *
 * https://github.com/mroderick/PubSubJS
 */

(function (root, factory){
    'use strict';

    var PubSub = {};

    if (root.PubSub) {
        PubSub = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
    } else {
        root.PubSub = PubSub;
        factory(PubSub);
    }
    // CommonJS and Node.js module support
    if (true){
        if (module !== undefined && module.exports) {
            exports = module.exports = PubSub; // Node.js specific `module.exports`
        }
        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
        module.exports = exports = PubSub; // CommonJS
    }
    // AMD support
    /* eslint-disable no-undef */
    else {}

}(( typeof window === 'object' && window ) || this, function (PubSub){
    'use strict';

    var messages = {},
        lastUid = -1,
        ALL_SUBSCRIBING_MSG = '*';

    function hasKeys(obj){
        var key;

        for (key in obj){
            if ( Object.prototype.hasOwnProperty.call(obj, key) ){
                return true;
            }
        }
        return false;
    }

    /**
     * Returns a function that throws the passed exception, for use as argument for setTimeout
     * @alias throwException
     * @function
     * @param { Object } ex An Error object
     */
    function throwException( ex ){
        return function reThrowException(){
            throw ex;
        };
    }

    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
        try {
            subscriber( message, data );
        } catch( ex ){
            setTimeout( throwException( ex ), 0);
        }
    }

    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
        subscriber( message, data );
    }

    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
        var subscribers = messages[matchedMessage],
            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
            s;

        if ( !Object.prototype.hasOwnProperty.call( messages, matchedMessage ) ) {
            return;
        }

        for (s in subscribers){
            if ( Object.prototype.hasOwnProperty.call(subscribers, s)){
                callSubscriber( subscribers[s], originalMessage, data );
            }
        }
    }

    function createDeliveryFunction( message, data, immediateExceptions ){
        return function deliverNamespaced(){
            var topic = String( message ),
                position = topic.lastIndexOf( '.' );

            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);

            // trim the hierarchy and deliver message to each level
            while( position !== -1 ){
                topic = topic.substr( 0, position );
                position = topic.lastIndexOf('.');
                deliverMessage( message, topic, data, immediateExceptions );
            }

            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
    }

    function hasDirectSubscribersFor( message ) {
        var topic = String( message ),
            found = Boolean(Object.prototype.hasOwnProperty.call( messages, topic ) && hasKeys(messages[topic]));

        return found;
    }

    function messageHasSubscribers( message ){
        var topic = String( message ),
            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
            position = topic.lastIndexOf( '.' );

        while ( !found && position !== -1 ){
            topic = topic.substr( 0, position );
            position = topic.lastIndexOf( '.' );
            found = hasDirectSubscribersFor(topic);
        }

        return found;
    }

    function publish( message, data, sync, immediateExceptions ){
        message = (typeof message === 'symbol') ? message.toString() : message;

        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
            hasSubscribers = messageHasSubscribers( message );

        if ( !hasSubscribers ){
            return false;
        }

        if ( sync === true ){
            deliver();
        } else {
            setTimeout( deliver, 0 );
        }
        return true;
    }

    /**
     * Publishes the message, passing the data to it's subscribers
     * @function
     * @alias publish
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publish = function( message, data ){
        return publish( message, data, false, PubSub.immediateExceptions );
    };

    /**
     * Publishes the message synchronously, passing the data to it's subscribers
     * @function
     * @alias publishSync
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publishSync = function( message, data ){
        return publish( message, data, true, PubSub.immediateExceptions );
    };

    /**
     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
     * @function
     * @alias subscribe
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { String }
     */
    PubSub.subscribe = function( message, func ){
        if ( typeof func !== 'function'){
            return false;
        }

        message = (typeof message === 'symbol') ? message.toString() : message;

        // message is not registered yet
        if ( !Object.prototype.hasOwnProperty.call( messages, message ) ){
            messages[message] = {};
        }

        // forcing token as String, to allow for future expansions without breaking usage
        // and allow for easy use as key names for the 'messages' object
        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;

        // return token for unsubscribing
        return token;
    };

    PubSub.subscribeAll = function( func ){
        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
    };

    /**
     * Subscribes the passed function to the passed message once
     * @function
     * @alias subscribeOnce
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { PubSub }
     */
    PubSub.subscribeOnce = function( message, func ){
        var token = PubSub.subscribe( message, function(){
            // before func apply, unsubscribe message
            PubSub.unsubscribe( token );
            func.apply( this, arguments );
        });
        return PubSub;
    };

    /**
     * Clears all subscriptions
     * @function
     * @public
     * @alias clearAllSubscriptions
     */
    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
        messages = {};
    };

    /**
     * Clear subscriptions by the topic
     * @function
     * @public
     * @alias clearAllSubscriptions
     * @return { int }
     */
    PubSub.clearSubscriptions = function clearSubscriptions(topic){
        var m;
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                delete messages[m];
            }
        }
    };

    /**
       Count subscriptions by the topic
     * @function
     * @public
     * @alias countSubscriptions
     * @return { Array }
    */
    PubSub.countSubscriptions = function countSubscriptions(topic){
        var m;
        // eslint-disable-next-line no-unused-vars
        var token;
        var count = 0;
        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                for (token in messages[m]) {
                    count++;
                }
                break;
            }
        }
        return count;
    };


    /**
       Gets subscriptions by the topic
     * @function
     * @public
     * @alias getSubscriptions
    */
    PubSub.getSubscriptions = function getSubscriptions(topic){
        var m;
        var list = [];
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                list.push(m);
            }
        }
        return list;
    };

    /**
     * Removes subscriptions
     *
     * - When passed a token, removes a specific subscription.
     *
	 * - When passed a function, removes all subscriptions for that function
     *
	 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
     * @function
     * @public
     * @alias subscribeOnce
     * @param { String | Function } value A token, function or topic to unsubscribe from
     * @example // Unsubscribing with a token
     * var token = PubSub.subscribe('mytopic', myFunc);
     * PubSub.unsubscribe(token);
     * @example // Unsubscribing with a function
     * PubSub.unsubscribe(myFunc);
     * @example // Unsubscribing from a topic
     * PubSub.unsubscribe('mytopic');
     */
    PubSub.unsubscribe = function(value){
        var descendantTopicExists = function(topic) {
                var m;
                for ( m in messages ){
                    if ( Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0 ){
                        // a descendant of the topic exists:
                        return true;
                    }
                }

                return false;
            },
            isTopic    = typeof value === 'string' && ( Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value) ),
            isToken    = !isTopic && typeof value === 'string',
            isFunction = typeof value === 'function',
            result = false,
            m, message, t;

        if (isTopic){
            PubSub.clearSubscriptions(value);
            return;
        }

        for ( m in messages ){
            if ( Object.prototype.hasOwnProperty.call( messages, m ) ){
                message = messages[m];

                if ( isToken && message[value] ){
                    delete message[value];
                    result = value;
                    // tokens are unique, so we can just stop here
                    break;
                }

                if (isFunction) {
                    for ( t in message ){
                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value){
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }

        return result;
    };
}));


/***/ }),

/***/ 21906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ErrorBoundary": function() { return /* binding */ ErrorBoundary; },
/* harmony export */   "ErrorBoundaryContext": function() { return /* binding */ ErrorBoundaryContext; },
/* harmony export */   "useErrorBoundary": function() { return /* binding */ useErrorBoundary; },
/* harmony export */   "withErrorBoundary": function() { return /* binding */ withErrorBoundary; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
'use client';


const ErrorBoundaryContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);

const initialState = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }
  static getDerivedStateFromError(error) {
    return {
      didCatch: true,
      error
    };
  }
  resetErrorBoundary() {
    const {
      error
    } = this.state;
    if (error !== null) {
      var _this$props$onReset, _this$props;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
        args,
        reason: "imperative-api"
      });
      this.setState(initialState);
    }
  }
  componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;

    // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
    // we'd end up resetting the error boundary immediately.
    // This would likely trigger a second error to be thrown.
    // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.

    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      var _this$props$onReset2, _this$props3;
      (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if ((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(fallback)) {
        childToRender = fallback;
      } else if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props);
      } else if (FallbackComponent) {
        childToRender = (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(FallbackComponent, props);
      } else {
        throw error;
      }
    }
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
}
function hasArrayChanged() {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return a.length !== b.length || a.some((item, index) => !Object.is(item, b[index]));
}

function assertErrorBoundaryContext(value) {
  if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") {
    throw new Error("ErrorBoundaryContext not found");
  }
  return true;
}

function useErrorBoundary() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ErrorBoundaryContext);
  assertErrorBoundaryContext(context);
  const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    error: null,
    hasError: false
  });
  const memoized = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    resetBoundary: () => {
      context === null || context === void 0 ? void 0 : context.resetErrorBoundary();
      setState({
        error: null,
        hasError: false
      });
    },
    showBoundary: error => setState({
      error,
      hasError: true
    })
  }), [context === null || context === void 0 ? void 0 : context.resetErrorBoundary]);
  if (state.hasError) {
    throw state.error;
  }
  return memoized;
}

function withErrorBoundary(component, errorBoundaryProps) {
  const Wrapped = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ErrorBoundary, errorBoundaryProps, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(component, {
    ...props,
    ref
  })));

  // Format for display in DevTools
  const name = component.displayName || component.name || "Unknown";
  Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
  return Wrapped;
}




/***/ }),

/***/ 12762:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}exports.ContextConsumer=h;exports.ContextProvider=g;exports.Element=b;exports.ForwardRef=l;exports.Fragment=d;exports.Lazy=q;exports.Memo=p;exports.Portal=c;exports.Profiler=f;exports.StrictMode=e;exports.Suspense=m;
exports.SuspenseList=n;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return v(a)===h};exports.isContextProvider=function(a){return v(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return v(a)===l};exports.isFragment=function(a){return v(a)===d};exports.isLazy=function(a){return v(a)===q};exports.isMemo=function(a){return v(a)===p};
exports.isPortal=function(a){return v(a)===c};exports.isProfiler=function(a){return v(a)===f};exports.isStrictMode=function(a){return v(a)===e};exports.isSuspense=function(a){return v(a)===m};exports.isSuspenseList=function(a){return v(a)===n};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};exports.typeOf=v;


/***/ }),

/***/ 90117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(12762);
} else {}


/***/ }),

/***/ 99156:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PrevArrow = exports.NextArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(27378));

var _classnames = _interopRequireDefault(__webpack_require__(60042));

var _innerSliderUtils = __webpack_require__(69725);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  var _super = _createSuper(PrevArrow);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _super.apply(this, arguments);
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  var _super2 = _createSuper(NextArrow);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _super2.apply(this, arguments);
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),

/***/ 74334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(27378));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),

/***/ 43339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(27378));

var _classnames = _interopRequireDefault(__webpack_require__(60042));

var _innerSliderUtils = __webpack_require__(69725);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  var _super = _createSuper(Dots);

  function Dots() {
    _classCallCheck(this, Dots);

    return _super.apply(this, arguments);
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),

/***/ 35301:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _slider = _interopRequireDefault(__webpack_require__(21021));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports.Z = _default;

/***/ }),

/***/ 48633:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),

/***/ 12441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(27378));

var _initialState = _interopRequireDefault(__webpack_require__(48633));

var _lodash = _interopRequireDefault(__webpack_require__(33198));

var _classnames = _interopRequireDefault(__webpack_require__(60042));

var _innerSliderUtils = __webpack_require__(69725);

var _track = __webpack_require__(45134);

var _dots = __webpack_require__(43339);

var _arrows = __webpack_require__(99156);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(97329));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }

  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),

/***/ 21021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(27378));

var _innerSlider = __webpack_require__(12441);

var _json2mq = _interopRequireDefault(__webpack_require__(99857));

var _defaultProps = _interopRequireDefault(__webpack_require__(74334));

var _innerSliderUtils = __webpack_require__(69725);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(46076);

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
      } else {
        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {}

        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),

/***/ 45134:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(27378));

var _classnames = _interopRequireDefault(__webpack_require__(60042));

var _innerSliderUtils = __webpack_require__(69725);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread(_objectSpread({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  var _super = _createSuper(Track);

  function Track() {
    var _this;

    _classCallCheck(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "node", null);

    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),

/***/ 69725:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.checkSpecKeys = exports.checkNavigable = exports.changeSlide = exports.canUseDOM = exports.canGoNext = void 0;
exports.clamp = clamp;
exports.swipeStart = exports.swipeMove = exports.swipeEnd = exports.slidesOnRight = exports.slidesOnLeft = exports.slideHandler = exports.siblingDirection = exports.safePreventDefault = exports.lazyStartIndex = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.keyHandler = exports.initializedState = exports.getWidth = exports.getTrackLeft = exports.getTrackCSS = exports.getTrackAnimateCSS = exports.getTotalSlides = exports.getSwipeDirection = exports.getSlideCount = exports.getRequiredLazySlides = exports.getPreClones = exports.getPostClones = exports.getOnDemandLazySlides = exports.getNavigableIndexes = exports.getHeight = exports.extractObject = void 0;

var _react = _interopRequireDefault(__webpack_require__(27378));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}

var safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];

  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};

exports.safePreventDefault = safePreventDefault;

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread(_objectSpread({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread(_objectSpread({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),

/***/ 80434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DEFAULT_LOADER": function() { return /* reexport */ DEFAULT_LOADER; },
  "ERRORS_STACK_SIZE": function() { return /* reexport */ ERRORS_STACK_SIZE; },
  "RecoilDevTools": function() { return /* reexport */ RecoilDevTools; },
  "RecoilReduxBridge": function() { return /* reexport */ RecoilReduxBridge; },
  "RecoilTunnel": function() { return /* reexport */ RecoilTunnel; },
  "TaskStatus": function() { return /* reexport */ TaskStatus; },
  "addCancelSignal": function() { return /* reexport */ addCancelSignal; },
  "and": function() { return /* reexport */ and; },
  "dec": function() { return /* reexport */ dec; },
  "decAbs": function() { return /* reexport */ decAbs; },
  "delay": function() { return /* reexport */ delay; },
  "doCancelSignal": function() { return /* reexport */ doCancelSignal; },
  "errorStack": function() { return /* reexport */ errors_errorStack; },
  "filter": function() { return /* reexport */ filter; },
  "getFetchSignal": function() { return /* reexport */ getFetchSignal; },
  "getRecoilStore": function() { return /* reexport */ getRecoilStore; },
  "hide": function() { return /* reexport */ hide; },
  "inc": function() { return /* reexport */ inc; },
  "isLoading": function() { return /* reexport */ isLoading; },
  "lastError": function() { return /* reexport */ lastError; },
  "lastErrorType": function() { return /* reexport */ lastErrorType; },
  "lastTaskByKey": function() { return /* reexport */ lastTaskByKey; },
  "loader": function() { return /* reexport */ loader; },
  "not": function() { return /* reexport */ not; },
  "or": function() { return /* reexport */ or; },
  "push": function() { return /* reexport */ push; },
  "pushError": function() { return /* reexport */ pushError; },
  "pushTask": function() { return /* reexport */ pushTask; },
  "pushTop": function() { return /* reexport */ pushTop; },
  "reduxSelector": function() { return /* reexport */ reduxSelector; },
  "reduxState": function() { return /* reexport */ reduxState; },
  "removeObj": function() { return /* reexport */ removeObj; },
  "reverse": function() { return /* reexport */ reverse; },
  "runningTasks": function() { return /* reexport */ runningTasks; },
  "set": function() { return /* reexport */ set; },
  "show": function() { return /* reexport */ show; },
  "taskById": function() { return /* reexport */ taskById; },
  "tasks": function() { return /* reexport */ tasks; },
  "toggle": function() { return /* reexport */ toggle; },
  "uniqueId": function() { return /* reexport */ uniqueId; },
  "unshift": function() { return /* reexport */ unshift; },
  "updateObj": function() { return /* reexport */ updateObj; },
  "updateTaskDone": function() { return /* reexport */ updateTaskDone; },
  "updateTaskError": function() { return /* reexport */ updateTaskError; },
  "useDispatch": function() { return /* reexport */ useDispatch; },
  "useIsLoading": function() { return /* reexport */ useIsLoading; },
  "useLastError": function() { return /* reexport */ useLastError; },
  "useMountedRef": function() { return /* reexport */ useMountedRef; },
  "useRecoilCurrentGetLoadable": function() { return /* reexport */ useRecoilCurrentGetLoadable; },
  "useRecoilCurrentGetPromise": function() { return /* reexport */ useRecoilCurrentGetPromise; },
  "useRecoilCurrentRefresh": function() { return /* reexport */ useRecoilCurrentRefresh; },
  "useRecoilCurrentReset": function() { return /* reexport */ useRecoilCurrentReset; },
  "useRecoilCurrentSet": function() { return /* reexport */ useRecoilCurrentSet; },
  "useRecoilCurrentSnapshot": function() { return /* reexport */ useRecoilCurrentSnapshot; },
  "useRecoilQuery": function() { return /* reexport */ useRecoilQuery; },
  "useRecoilRequest": function() { return /* reexport */ useRecoilRequest; },
  "useRecoilTask": function() { return /* reexport */ useRecoilTask; },
  "useResetErrors": function() { return /* reexport */ useResetErrors; },
  "useRunningTasks": function() { return /* reexport */ useRunningTasks; },
  "useSelector": function() { return /* reexport */ useSelector; }
});

;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/delay.js
const delay = (ms) => new Promise(resolve => {
    setTimeout(() => {
        resolve(true);
    }, ms);
});
//# sourceMappingURL=delay.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/uniqueId.js
let uniqueIdCounter = 0;
function uniqueId() {
    // eslint-disable-next-line no-plusplus
    return ++uniqueIdCounter;
}
//# sourceMappingURL=uniqueId.js.map
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/useMountedRef.js

function useMountedRef() {
    const mounted = (0,react.useRef)(true);
    (0,react.useEffect)(() => () => {
        mounted.current = false;
    }, []);
    return mounted;
}
//# sourceMappingURL=useMountedRef.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/index.js



//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../node_modules/recoil/es/index.js
var es = __webpack_require__(69853);
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/number.js
const inc = (s) => s + 1;
const dec = (s) => s - 1;
const decAbs = (s) => (s > 0 ? s - 1 : 0);
// alias
const show = inc;
const hide = decAbs;
//# sourceMappingURL=number.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/useRecoilRequest.js



const useRecoilRequest = (request) => {
    const setRequestId = (0,es.useSetRecoilState)(request);
    return (0,react.useCallback)(() => {
        setRequestId(inc);
    }, [setRequestId]);
};
//# sourceMappingURL=useRecoilRequest.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/recoilStore.js

const useRecoilCurrentGetPromise = () => (0,es.useRecoilCallback)(({ snapshot: { getPromise } }) => getPromise, []);
const useRecoilCurrentGetLoadable = () => (0,es.useRecoilCallback)(({ snapshot: { getLoadable } }) => getLoadable, []);
const useRecoilCurrentSnapshot = () => (0,es.useRecoilCallback)(({ snapshot }) => () => snapshot, []);
const useRecoilCurrentSet = () => (0,es.useRecoilCallback)(({ set }) => set, []);
const useRecoilCurrentReset = () => (0,es.useRecoilCallback)(({ reset }) => reset, []);
const useRecoilCurrentRefresh = () => (0,es.useRecoilCallback)(({ refresh }) => refresh, []);
//# sourceMappingURL=recoilStore.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/signals/store.js
let instanceId = 0;
function getInstanceId() {
    instanceId += 1;
    return instanceId;
}
const signalStore = {};
function addCancelSignal(key, signal) {
    if (!signalStore[key]) {
        signalStore[key] = {};
    }
    signalStore[key][getInstanceId()] = signal;
}
function doCancelSignal(key) {
    if (signalStore[key]) {
        Object.values(signalStore[key]).forEach(abortsignal => {
            try {
                abortsignal.cancel();
            }
            catch (_a) {
                // ignore
            }
        });
        signalStore[key] = {};
    }
}
//# sourceMappingURL=store.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/signals/fetch.js

function getFetchSignal(key) {
    const newAbortController = new AbortController();
    addCancelSignal(key, {
        signal: newAbortController.signal,
        cancel: () => {
            newAbortController.abort();
        },
    });
    return newAbortController.signal;
}
//# sourceMappingURL=fetch.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/signals/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/useRecoilQuery.js



//todo freeze options object
const useRecoilQuery = (selector, options) => {
    const { state, contents } = (0,es.useRecoilValueLoadable)(selector);
    const loading = state === 'loading';
    const error = state === 'hasError' ? contents : undefined;
    const data = (state === 'hasValue' ? contents : undefined);
    const lastData = (0,react.useRef)();
    (0,react.useEffect)(() => {
        if (data !== undefined) {
            lastData.current = data;
        }
    }, [data]);
    const refresh = (0,es.useRecoilRefresher_UNSTABLE)(selector);
    (0,react.useEffect)(() => {
        if ((options === null || options === void 0 ? void 0 : options.refreshOnMount) === 'always' || ((options === null || options === void 0 ? void 0 : options.refreshOnMount) === 'error' && error)) {
            !loading && refresh();
        }
    }, []); //eslint-disable-line
    (0,react.useEffect)(() => () => {
        if ((options === null || options === void 0 ? void 0 : options.cancelOnUnmount) === true) {
            doCancelSignal(selector.key);
        }
        if (typeof (options === null || options === void 0 ? void 0 : options.cancelOnUnmount) === 'function') {
            options === null || options === void 0 ? void 0 : options.cancelOnUnmount();
        }
    }, []);
    return {
        loading,
        data: data !== undefined ? data : lastData.current,
        error,
        refresh,
    };
};
//# sourceMappingURL=useRecoilQuery.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/tunnel/getStore.js
const recoilStores = {};
const DEFAULT_STORE = '$defaultStore$';
function set(recoilVal, valOrUpdater) {
    var _a, _b;
    if ((_a = recoilStores[DEFAULT_STORE]) === null || _a === void 0 ? void 0 : _a.set)
        return (_b = recoilStores[DEFAULT_STORE]) === null || _b === void 0 ? void 0 : _b.set(recoilVal, valOrUpdater);
    throw new Error('Recoil Toolkit Tunnel not ready');
}
const pendigGetStorePromises = [];
const flushGetStorePending = (name) => {
    pendigGetStorePromises.forEach(p => {
        if (p.pending && p.name === name) {
            // @ts-ignore
            if (recoilStores[name]) {
                // @ts-ignore
                p.resolve(recoilStores[name]);
            }
            else
                p.reject(new Error('no store found'));
            p.pending = false;
        }
    });
};
function getRecoilStore(name = DEFAULT_STORE) {
    return new Promise((resolve, reject) => {
        if (recoilStores[name]) {
            // @ts-ignore
            resolve(recoilStores[name]);
        }
        else {
            pendigGetStorePromises.push({
                resolve,
                reject,
                name,
                pending: true,
            });
        }
    });
}
//# sourceMappingURL=getStore.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/tunnel/RecoilTunnel.js




const RecoilTunnel = ({ name = DEFAULT_STORE, children, }) => {
    const storeName = (0,react.useRef)(name);
    const getPromise = useRecoilCurrentGetPromise();
    const getLoadable = useRecoilCurrentGetLoadable();
    const set = useRecoilCurrentSet();
    const reset = useRecoilCurrentReset();
    const refresh = useRecoilCurrentRefresh();
    const getSnapshot = useRecoilCurrentSnapshot();
    const gotoSnapshot = (0,es.useGotoRecoilSnapshot)();
    const [ready, setReady] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        recoilStores[storeName.current] = {
            getPromise,
            getLoadable,
            set,
            reset,
            refresh,
            getSnapshot,
            gotoSnapshot,
            //TODO add runTask
        };
        flushGetStorePending(storeName.current);
        setReady(true);
        return () => {
            recoilStores[storeName.current] = undefined;
            flushGetStorePending(storeName.current);
        };
    }, []);
    return ready ? react.createElement(react.Fragment, null, children) : null;
};
//# sourceMappingURL=RecoilTunnel.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/tunnel/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/array.js
const reverse = (s) => s.slice().reverse();
const filter = (predicate) => (s) => s.filter(predicate);
const push = (item, maxSize) => (s) => maxSize === undefined || s.length < maxSize
    ? [...s, item]
    : [...[...s, item].slice(s.length + 1 - maxSize, s.length + 1)];
const unshift = (item, maxSize) => (s) => maxSize === undefined || s.length < maxSize
    ? [item, ...s]
    : [item, ...s.slice(0, maxSize - 1)];
const updateObj = (item, match) => (s) => s.map(el => (Object.keys(match).every(k => match[k] === el[k]) ? Object.assign(Object.assign({}, el), item) : el));
const removeObj = (match) => filter(el => !Object.keys(match).every(k => match[k] === el[k]));
//alias
const pushTop = unshift;
//# sourceMappingURL=array.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/boolean.js
const not = (s) => !s;
const and = (value) => (s) => s && !!value;
const or = (value) => (s) => s || !!value;
// alias
const toggle = not;
//# sourceMappingURL=boolean.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/errors.js

const ERRORS_STACK_SIZE = 100;
const errors_errorStack = (0,es.atom)({
    key: '@recoil-toolkit.errorStack',
    default: [],
});
const lastError = (0,es.selector)({
    key: '@recoil-toolkit.lastError',
    get: ({ get }) => {
        const e = get(errors_errorStack);
        return e.length > 0 ? e[e.length - 1] : undefined;
    },
});
const lastErrorType = (0,es.selectorFamily)({
    key: '@recoil-toolkit.lastErrorType',
    get: (key) => ({ get }) => get(errors_errorStack)
        .filter(e => e.key === key)
        .pop(),
});
const useLastError = (key) => (0,es.useRecoilValue)(key ? lastErrorType(key) : lastError);
const useResetErrors = () => (0,es.useResetRecoilState)(errors_errorStack);
//# sourceMappingURL=errors.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/loader.js

const DEFAULT_LOADER = '@recoil-toolkit.loader.global';
const loader = (0,es.atomFamily)({
    key: '@recoil-toolkit.loader',
    default: 0,
});
const isLoading = (0,es.selectorFamily)({
    key: '@recoil-toolkit.loader.isLoading',
    get: (key) => ({ get }) => get(loader(key)) > 0,
});
const useIsLoading = (key) => (0,es.useRecoilValue)(isLoading(key || DEFAULT_LOADER));
//# sourceMappingURL=loader.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/types.js
// eslint-disable-next-line no-shadow
var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["Running"] = 0] = "Running";
    TaskStatus[TaskStatus["Error"] = 1] = "Error";
    TaskStatus[TaskStatus["Done"] = 2] = "Done";
})(TaskStatus || (TaskStatus = {}));
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/tasks.js


const tasks = (0,es.atom)({
    key: '@recoil-toolkit.tasks',
    default: [],
});
const runningTasks = (0,es.selector)({
    key: '@recoil-toolkit.runningTasks',
    get: ({ get }) => get(tasks).filter(t => t.status === TaskStatus.Running),
});
const taskById = (0,es.selectorFamily)({
    key: '@recoil-toolkit.taskById',
    get: (id) => ({ get }) => {
        return get(tasks).find(t => t.id === id);
    },
});
const lastTaskByKey = (0,es.selectorFamily)({
    key: '@recoil-toolkit.lastTaskType',
    get: (key) => ({ get }) => {
        return get(tasks)
            .filter(t => { var _a; return ((_a = t === null || t === void 0 ? void 0 : t.options) === null || _a === void 0 ? void 0 : _a.key) === key; })
            .pop();
    },
});
const useRunningTasks = () => (0,es.useRecoilValue)(runningTasks);
//# sourceMappingURL=tasks.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/consts.js
const RecoilToolkitDevTools = {
    consolePrefix: 'recoil-toolkit: ',
    eventMessageFromPage: '@recoil-toolkit/msg-from-web-page',
    eventMessageToPage: '@recoil-toolkit/msg-to-web-page',
    enableConsole: '@recoil-toolkit/enable-content-script-console',
};
//# sourceMappingURL=consts.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/getSnapshotState.js
//todo traverse and json stringify Errors
function getSnapshotState(snapshot) {
    var _a;
    const nodes = [];
    for (const node of snapshot.getNodes_UNSTABLE({ isInitialized: true })) {
        const nodeInfo = snapshot.getInfo_UNSTABLE(node);
        const loadable = snapshot.getLoadable(node);
        const subNodes = [];
        for (const comp of nodeInfo.subscribers.nodes) {
            subNodes.push(comp.key);
        }
        nodes.sort((a, b) => a.key.localeCompare(b.key));
        nodes.push({
            key: node.key,
            type: nodeInfo.type,
            // isSet: nodeInfo.isSet,
            // isActive: nodeInfo.isActive,
            isModified: nodeInfo.isModified,
            subNodes,
            state: loadable.state,
            value: loadable.state === 'hasValue'
                ? loadable.contents
                : loadable.state === 'loading'
                    ? '... loading ...'
                    : JSON.stringify(((_a = loadable.contents) === null || _a === void 0 ? void 0 : _a.message) || loadable.contents),
        });
    }
    return {
        id: snapshot.getID().toString(),
        nodes,
    };
}
//# sourceMappingURL=getSnapshotState.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/RecoilDevTools.js




/*const stringifyCircularJSON = obj => {
   const seen = new WeakSet();
   return JSON.stringify(obj, (k, v) => {
      if (v !== null && typeof v === 'object') {
         if (seen.has(v)) return '[Circular]';
         seen.add(v);
      }
      return v;
   });
};*/
const RecoilDevTools = ({ enableConsole, forceSerialize, serializer }) => {
    const snapshot = (0,es.useRecoilSnapshot)();
    (0,react.useEffect)(() => {
        window.postMessage({ type: RecoilToolkitDevTools.enableConsole, enable: !!enableConsole }, '*');
    }, [enableConsole]);
    /** Send Snapshot to DevTools **/
    (0,react.useEffect)(() => {
        const snapState = getSnapshotState(snapshot);
        window.postMessage({
            type: RecoilToolkitDevTools.eventMessageFromPage,
            data: forceSerialize
                ? JSON.parse(serializer ? serializer(snapState) : JSON.stringify(snapState))
                : snapState,
        }, '*');
    }, [snapshot]); //eslint-disable-line
    /** Listen messages from DevTools **/
    (0,react.useEffect)(() => {
        const onMessage = function (event) {
            // We only accept messages from ourselves
            if (event.source !== window)
                return;
            if (event.data.type && event.data.type === RecoilToolkitDevTools.eventMessageToPage) {
                console.log('DebugObserver Message Received: ', event.data);
            }
        };
        window.addEventListener('message', onMessage, false);
        return () => {
            window.removeEventListener('message', onMessage, false);
        };
    }, []);
    return null;
};
//# sourceMappingURL=RecoilDevTools.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/updaters/tasks.js


const pushTask = ({ parentId, id, options, args, extra, }) => push({
    parentId,
    id,
    args,
    status: TaskStatus.Running,
    options,
    extra,
    startedAt: new Date(),
});
const updateTaskDone = ({ data, id }) => updateObj({ status: TaskStatus.Done, data, endAt: new Date() }, {
    id,
});
const updateTaskError = ({ error, id }) => updateObj({ status: TaskStatus.Error, error, endAt: new Date() }, {
    id,
});
//# sourceMappingURL=tasks.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/updaters/errors.js


const pushError = ({ key, error, taskId }) => push({ key, error, id: uniqueId(), taskId }, ERRORS_STACK_SIZE);
//# sourceMappingURL=errors.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/updaters/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/waitFor.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const cancelledTaskMap = new Map();
const createCancelled = (taskId) => () => cancelledTaskMap.get(taskId) || false;
const createWaitFor = (cancelled) => (promiseOrMs) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof promiseOrMs === 'number') {
        const d = promiseOrMs < 0 ? 0 : Math.trunc(promiseOrMs);
        const times = Math.trunc(d / 50);
        for (let i = 0; i < times; i++) {
            yield delay(50);
            if (cancelled())
                throw new Error('Cancelled!');
        }
        return;
    }
    else {
        const data = yield promiseOrMs;
        if (cancelled())
            throw new Error('Cancelled!');
        return data;
    }
});
const cancelTask = (taskId) => {
    cancelledTaskMap.set(taskId, true);
};
//# sourceMappingURL=waitFor.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/fork.js
var fork_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const createFork = (parentId, recoil) => (taskCreator, args, debugKey) => {
    /* child task id */
    const id = uniqueId();
    const cancelledChild = createCancelled(id);
    const cancelled = () => recoil.cancelled() || cancelledChild();
    const cancel = () => cancelTask(id);
    const waitFor = createWaitFor(cancelled);
    /* injected current snapshot */
    const snapshot = recoil.getSnapshot();
    const childRecoil = Object.assign(Object.assign({}, recoil), { snapshot,
        waitFor,
        cancelled });
    /* injected fork recursively */
    const fork = createFork(id, childRecoil);
    const execute = taskCreator(Object.assign(Object.assign({}, childRecoil), { fork }));
    const childTaskObj = {
        parentId,
        id,
        args,
        options: debugKey ? { key: debugKey } : undefined,
    };
    const taskRunner = () => fork_awaiter(void 0, void 0, void 0, function* () {
        try {
            recoil.set(tasks, pushTask(childTaskObj));
            const data = yield execute(...args);
            recoil.set(tasks, updateTaskDone({ data, id }));
            return data;
        }
        catch (error) {
            recoil.set(tasks, updateTaskError({ error, id }));
        }
    });
    /* run child task */
    const task = taskRunner();
    const getTaskState = () => recoil.getLoadable(taskById(id)).getValue();
    return { id, cancel, task, getTaskState };
};
//# sourceMappingURL=fork.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/useRecoilTask.js
var useRecoilTask_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};








function useRecoilTask(taskCreator, deps, options) {
    const optionsRef = (0,react.useRef)(options || {}); //options freeze
    const { cancelOnUnmount, key, errorStack, loaderStack, exclusive, dataSelector, autoStart } = optionsRef.current;
    if (exclusive && !key) {
        throw new Error('Exclusive tasks must have a key!');
    }
    const [taskId, setTaskId] = (0,react.useState)(0);
    const task = (0,es.useRecoilValue)(exclusive ? lastTaskByKey(key || '') : taskById(taskId));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const taskData = dataSelector ? (0,es.useRecoilValue)(dataSelector) : task === null || task === void 0 ? void 0 : task.data;
    const getSnapshot = useRecoilCurrentSnapshot();
    const getLoadable = useRecoilCurrentGetLoadable();
    const execute = (0,es.useRecoilCallback)((_a) => {
        var { set, snapshot } = _a, rest = __rest(_a, ["set", "snapshot"]);
        return (...args) => useRecoilTask_awaiter(this, void 0, void 0, function* () {
            if (exclusive && key) {
                const t = snapshot.getLoadable(lastTaskByKey(key)).getValue();
                if (t && t.status === TaskStatus.Running)
                    return;
            }
            const id = uniqueId();
            setTaskId(id);
            const cancelled = createCancelled(id);
            const waitFor = createWaitFor(cancelled);
            const fork = createFork(id, Object.assign({ cancelled,
                waitFor,
                getSnapshot,
                getLoadable,
                set,
                snapshot }, rest));
            try {
                if (loaderStack)
                    set(loader(loaderStack === true ? DEFAULT_LOADER : loaderStack), show);
                set(tasks, pushTask({ id, options, args }));
                const data = yield taskCreator(Object.assign({ fork,
                    cancelled,
                    waitFor,
                    getSnapshot,
                    getLoadable,
                    set,
                    snapshot }, rest))(...args);
                set(tasks, updateTaskDone({ data, id }));
            }
            catch (error) {
                set(tasks, updateTaskError({ error, id }));
                if (errorStack) {
                    set(errors_errorStack, pushError({ key, error, taskId: id }));
                }
            }
            finally {
                if (loaderStack)
                    set(loader(loaderStack === true ? DEFAULT_LOADER : loaderStack), hide);
            }
        });
    }, deps);
    (0,react.useEffect)(() => {
        if (autoStart) {
            execute(...autoStart);
        }
    }, [execute]);
    (0,react.useEffect)(() => {
        if (cancelOnUnmount && taskId) {
            return () => {
                cancelTask(taskId);
            };
        }
    }, [taskId]);
    const resetTask = (0,react.useCallback)(() => {
        setTaskId(0);
    }, []);
    return {
        loading: (task === null || task === void 0 ? void 0 : task.status) === TaskStatus.Running,
        execute,
        error: task === null || task === void 0 ? void 0 : task.error,
        data: taskData,
        success: (task === null || task === void 0 ? void 0 : task.status) === TaskStatus.Done,
        taskId,
        resetTask,
    };
}
//# sourceMappingURL=useRecoilTask.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/atoms.js


const reduxSelectorsMap = new Map();
const reduxSelectorsMapInv = new Map();
function getSelectorId(selectorFunc) {
    let cachedSelectorId = reduxSelectorsMapInv.get(selectorFunc);
    if (!cachedSelectorId) {
        const id = uniqueId();
        reduxSelectorsMapInv.set(selectorFunc, id);
        reduxSelectorsMap.set(id, selectorFunc);
        cachedSelectorId = id;
    }
    return cachedSelectorId;
}
const reduxState = (0,es.atom)({
    key: '@recoil-toolkit.reduxState',
    default: undefined,
});
const reduxSelectorFamily = (0,es.selectorFamily)({
    key: '@recoil-toolkit.reduxSelectors',
    get: (selectorId) => ({ get }) => {
        const currentReduxState = get(reduxState);
        const selectorFunc = reduxSelectorsMap.get(selectorId);
        return currentReduxState && selectorFunc ? selectorFunc(currentReduxState) : undefined;
    },
});
function reduxSelector(selector) {
    return reduxSelectorFamily(getSelectorId(selector));
}
//# sourceMappingURL=atoms.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/context.js

const RecoilReduxContext = (0,react.createContext)({});
//# sourceMappingURL=context.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/hooks.js




function useSelector(selector) {
    return (0,es.useRecoilValue)(reduxSelector(selector));
}
function useDispatch() {
    const { store } = (0,react.useContext)(RecoilReduxContext);
    if (!store)
        throw new Error('RecoilReduxBridge with store not found!');
    return store.dispatch;
}
//# sourceMappingURL=hooks.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/RecoilReduxBridge.js




const RecoilReduxBridge = ({ store, children }) => {
    const set = useRecoilCurrentSet();
    const [sub, setSub] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        const unsub = store.subscribe(() => {
            set(reduxState, store.getState());
        });
        set(reduxState, store.getState());
        setSub(true);
        return unsub;
    }, []);
    return (0,react.createElement)(RecoilReduxContext.Provider, {
        children: sub ? children : undefined,
        value: { store },
    });
};
//# sourceMappingURL=RecoilReduxBridge.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/index.js







//# sourceMappingURL=index.js.map

/***/ }),

/***/ 69853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DefaultValue": function() { return /* binding */ Recoil_index_1; },
/* harmony export */   "RecoilEnv": function() { return /* binding */ Recoil_index_4; },
/* harmony export */   "RecoilLoadable": function() { return /* binding */ Recoil_index_3; },
/* harmony export */   "RecoilRoot": function() { return /* binding */ Recoil_index_5; },
/* harmony export */   "atom": function() { return /* binding */ Recoil_index_8; },
/* harmony export */   "atomFamily": function() { return /* binding */ Recoil_index_10; },
/* harmony export */   "constSelector": function() { return /* binding */ Recoil_index_12; },
/* harmony export */   "errorSelector": function() { return /* binding */ Recoil_index_13; },
/* harmony export */   "isRecoilValue": function() { return /* binding */ Recoil_index_2; },
/* harmony export */   "noWait": function() { return /* binding */ Recoil_index_15; },
/* harmony export */   "readOnlySelector": function() { return /* binding */ Recoil_index_14; },
/* harmony export */   "retentionZone": function() { return /* binding */ Recoil_index_38; },
/* harmony export */   "selector": function() { return /* binding */ Recoil_index_9; },
/* harmony export */   "selectorFamily": function() { return /* binding */ Recoil_index_11; },
/* harmony export */   "snapshot_UNSTABLE": function() { return /* binding */ Recoil_index_36; },
/* harmony export */   "useGetRecoilValueInfo_UNSTABLE": function() { return /* binding */ Recoil_index_26; },
/* harmony export */   "useGotoRecoilSnapshot": function() { return /* binding */ Recoil_index_33; },
/* harmony export */   "useRecoilBridgeAcrossReactRoots_UNSTABLE": function() { return /* binding */ Recoil_index_7; },
/* harmony export */   "useRecoilCallback": function() { return /* binding */ Recoil_index_31; },
/* harmony export */   "useRecoilRefresher_UNSTABLE": function() { return /* binding */ Recoil_index_27; },
/* harmony export */   "useRecoilSnapshot": function() { return /* binding */ Recoil_index_34; },
/* harmony export */   "useRecoilState": function() { return /* binding */ Recoil_index_22; },
/* harmony export */   "useRecoilStateLoadable": function() { return /* binding */ Recoil_index_23; },
/* harmony export */   "useRecoilState_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_30; },
/* harmony export */   "useRecoilStoreID": function() { return /* binding */ Recoil_index_6; },
/* harmony export */   "useRecoilTransactionObserver_UNSTABLE": function() { return /* binding */ Recoil_index_35; },
/* harmony export */   "useRecoilTransaction_UNSTABLE": function() { return /* binding */ Recoil_index_32; },
/* harmony export */   "useRecoilValue": function() { return /* binding */ Recoil_index_20; },
/* harmony export */   "useRecoilValueLoadable": function() { return /* binding */ Recoil_index_21; },
/* harmony export */   "useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_28; },
/* harmony export */   "useRecoilValue_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_29; },
/* harmony export */   "useResetRecoilState": function() { return /* binding */ Recoil_index_25; },
/* harmony export */   "useRetain": function() { return /* binding */ Recoil_index_37; },
/* harmony export */   "useSetRecoilState": function() { return /* binding */ Recoil_index_24; },
/* harmony export */   "waitForAll": function() { return /* binding */ Recoil_index_18; },
/* harmony export */   "waitForAllSettled": function() { return /* binding */ Recoil_index_19; },
/* harmony export */   "waitForAny": function() { return /* binding */ Recoil_index_17; },
/* harmony export */   "waitForNone": function() { return /* binding */ Recoil_index_16; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31542);
/* provided dependency */ var process = __webpack_require__(14284);



/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function err(message) {
  const error = new Error(message); // In V8, Error objects keep the closure scope chain alive until the
  // err.stack property is accessed.

  if (error.stack === undefined) {
    // IE sets the stack only if error is thrown
    try {
      throw error;
    } catch (_) {} // eslint-disable-line fb-www/no-unused-catch-bindings, no-empty

  }

  return error;
}

var err_1 = err;

// @oss-only


var Recoil_err = err_1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

// Split declaration and implementation to allow this function to pretend to
// check for actual instance of Promise instead of something with a `then`
// method.
// eslint-disable-next-line no-redeclare
function isPromise(p) {
  return !!p && typeof p.then === 'function';
}

var Recoil_isPromise = isPromise;

function nullthrows(x, message) {
  if (x != null) {
    return x;
  }

  throw Recoil_err(message !== null && message !== void 0 ? message : 'Got unexpected null or undefined');
}

var Recoil_nullthrows = nullthrows;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

class BaseLoadable {
  getValue() {
    throw Recoil_err('BaseLoadable');
  }

  toPromise() {
    throw Recoil_err('BaseLoadable');
  }

  valueMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  valueOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected value, but in "${this.state}" state`);
  }

  promiseMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  promiseOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected promise, but in "${this.state}" state`);
  }

  errorMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  errorOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected error, but in "${this.state}" state`);
  }

  is(other) {
    // $FlowFixMe[prop-missing]
    return other.state === this.state && other.contents === this.contents;
  }

  map(_map) {
    throw Recoil_err('BaseLoadable');
  }

}

class ValueLoadable extends BaseLoadable {
  constructor(value) {
    super();

    _defineProperty(this, "state", 'hasValue');

    _defineProperty(this, "contents", void 0);

    this.contents = value;
  }

  getValue() {
    return this.contents;
  }

  toPromise() {
    return Promise.resolve(this.contents);
  }

  valueMaybe() {
    return this.contents;
  }

  valueOrThrow() {
    return this.contents;
  }

  promiseMaybe() {
    return undefined;
  }

  errorMaybe() {
    return undefined;
  }

  map(map) {
    try {
      const next = map(this.contents);
      return Recoil_isPromise(next) ? loadableWithPromise(next) : isLoadable(next) ? next : loadableWithValue(next);
    } catch (e) {
      return Recoil_isPromise(e) ? // If we "suspended", then try again.
      // errors and subsequent retries will be handled in 'loading' case
      // $FlowFixMe[prop-missing]
      loadableWithPromise(e.next(() => this.map(map))) : loadableWithError(e);
    }
  }

}

class ErrorLoadable extends BaseLoadable {
  constructor(error) {
    super();

    _defineProperty(this, "state", 'hasError');

    _defineProperty(this, "contents", void 0);

    this.contents = error;
  }

  getValue() {
    throw this.contents;
  }

  toPromise() {
    return Promise.reject(this.contents);
  }

  valueMaybe() {
    return undefined;
  }

  promiseMaybe() {
    return undefined;
  }

  errorMaybe() {
    return this.contents;
  }

  errorOrThrow() {
    return this.contents;
  }

  map(_map) {
    // $FlowIssue[incompatible-return]
    return this;
  }

}

class LoadingLoadable extends BaseLoadable {
  constructor(promise) {
    super();

    _defineProperty(this, "state", 'loading');

    _defineProperty(this, "contents", void 0);

    this.contents = promise;
  }

  getValue() {
    throw this.contents;
  }

  toPromise() {
    return this.contents;
  }

  valueMaybe() {
    return undefined;
  }

  promiseMaybe() {
    return this.contents;
  }

  promiseOrThrow() {
    return this.contents;
  }

  errorMaybe() {
    return undefined;
  }

  map(map) {
    return loadableWithPromise(this.contents.then(value => {
      const next = map(value);

      if (isLoadable(next)) {
        const nextLoadable = next;

        switch (nextLoadable.state) {
          case 'hasValue':
            return nextLoadable.contents;

          case 'hasError':
            throw nextLoadable.contents;

          case 'loading':
            return nextLoadable.contents;
        }
      } // $FlowIssue[incompatible-return]


      return next;
    }) // $FlowFixMe[incompatible-call]
    .catch(e => {
      if (Recoil_isPromise(e)) {
        // we were "suspended," try again
        return e.then(() => this.map(map).contents);
      }

      throw e;
    }));
  }

}

function loadableWithValue(value) {
  return Object.freeze(new ValueLoadable(value));
}

function loadableWithError(error) {
  return Object.freeze(new ErrorLoadable(error));
}

function loadableWithPromise(promise) {
  return Object.freeze(new LoadingLoadable(promise));
}

function loadableLoading() {
  return Object.freeze(new LoadingLoadable(new Promise(() => {})));
}

function loadableAllArray(inputs) {
  return inputs.every(i => i.state === 'hasValue') ? loadableWithValue(inputs.map(i => i.contents)) : inputs.some(i => i.state === 'hasError') ? loadableWithError(Recoil_nullthrows(inputs.find(i => i.state === 'hasError'), 'Invalid loadable passed to loadableAll').contents) : loadableWithPromise(Promise.all(inputs.map(i => i.contents)));
}

function loadableAll(inputs) {
  const unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map(key => inputs[key]);
  const normalizedInputs = unwrapedInputs.map(x => isLoadable(x) ? x : Recoil_isPromise(x) ? loadableWithPromise(x) : loadableWithValue(x));
  const output = loadableAllArray(normalizedInputs);
  return Array.isArray(inputs) ? // $FlowIssue[incompatible-return]
  output : // Object.getOwnPropertyNames() has consistent key ordering with ES6
  // $FlowIssue[incompatible-call]
  output.map(outputs => Object.getOwnPropertyNames(inputs).reduce( // $FlowFixMe[invalid-computed-prop]
  (out, key, idx) => ({ ...out,
    [key]: outputs[idx]
  }), {}));
}

function isLoadable(x) {
  return x instanceof BaseLoadable;
}

const LoadableStaticInterface = {
  of: value => Recoil_isPromise(value) ? loadableWithPromise(value) : isLoadable(value) ? value : loadableWithValue(value),
  error: error => loadableWithError(error),
  // $FlowIssue[incompatible-return]
  loading: () => loadableLoading(),
  // $FlowIssue[unclear-type]
  all: loadableAll,
  isLoadable
};
var Recoil_Loadable = {
  loadableWithValue,
  loadableWithError,
  loadableWithPromise,
  loadableLoading,
  loadableAll,
  isLoadable,
  RecoilLoadable: LoadableStaticInterface
};

var Recoil_Loadable_1 = Recoil_Loadable.loadableWithValue;
var Recoil_Loadable_2 = Recoil_Loadable.loadableWithError;
var Recoil_Loadable_3 = Recoil_Loadable.loadableWithPromise;
var Recoil_Loadable_4 = Recoil_Loadable.loadableLoading;
var Recoil_Loadable_5 = Recoil_Loadable.loadableAll;
var Recoil_Loadable_6 = Recoil_Loadable.isLoadable;
var Recoil_Loadable_7 = Recoil_Loadable.RecoilLoadable;

var Recoil_Loadable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadableWithValue: Recoil_Loadable_1,
  loadableWithError: Recoil_Loadable_2,
  loadableWithPromise: Recoil_Loadable_3,
  loadableLoading: Recoil_Loadable_4,
  loadableAll: Recoil_Loadable_5,
  isLoadable: Recoil_Loadable_6,
  RecoilLoadable: Recoil_Loadable_7
});

const env = {
  RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true,
  // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
  RECOIL_GKS_ENABLED: new Set(['recoil_hamt_2020', 'recoil_sync_external_store', 'recoil_suppress_rerender_in_callback', 'recoil_memory_managament_2020'])
};

function readProcessEnvBooleanFlag(name, set) {
  var _process$env$name, _process$env$name$toL;

  const sanitizedValue = (_process$env$name = process.env[name]) === null || _process$env$name === void 0 ? void 0 : (_process$env$name$toL = _process$env$name.toLowerCase()) === null || _process$env$name$toL === void 0 ? void 0 : _process$env$name$toL.trim();

  if (sanitizedValue == null || sanitizedValue === '') {
    return;
  }

  const allowedValues = ['true', 'false'];

  if (!allowedValues.includes(sanitizedValue)) {
    throw Recoil_err(`process.env.${name} value must be 'true', 'false', or empty: ${sanitizedValue}`);
  }

  set(sanitizedValue === 'true');
}

function readProcessEnvStringArrayFlag(name, set) {
  var _process$env$name2;

  const sanitizedValue = (_process$env$name2 = process.env[name]) === null || _process$env$name2 === void 0 ? void 0 : _process$env$name2.trim();

  if (sanitizedValue == null || sanitizedValue === '') {
    return;
  }

  set(sanitizedValue.split(/\s*,\s*|\s+/));
}
/**
 * Allow NodeJS/NextJS/etc to set the initial state through process.env variable
 * Note:  we don't assume 'process' is available in all runtime environments
 *
 * @see https://github.com/facebookexperimental/Recoil/issues/733
 */


function applyProcessEnvFlagOverrides() {
  var _process;

  // note: this check is needed in addition to the check below, runtime error will occur without it!
  // eslint-disable-next-line fb-www/typeof-undefined
  if (typeof process === 'undefined') {
    return;
  }

  if (((_process = process) === null || process === void 0 ? void 0 : process.env) == null) {
    return;
  }

  readProcessEnvBooleanFlag('RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED', value => {
    env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = value;
  });
  readProcessEnvStringArrayFlag('RECOIL_GKS_ENABLED', value => {
    value.forEach(gk => {
      env.RECOIL_GKS_ENABLED.add(gk);
    });
  });
}

applyProcessEnvFlagOverrides();
var Recoil_RecoilEnv = env;

function Recoil_gkx_OSS(gk) {
  return Recoil_RecoilEnv.RECOIL_GKS_ENABLED.has(gk);
}

Recoil_gkx_OSS.setPass = gk => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.add(gk);
};

Recoil_gkx_OSS.setFail = gk => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.delete(gk);
};

Recoil_gkx_OSS.clear = () => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.clear();
};

var Recoil_gkx = Recoil_gkx_OSS; // @oss-only

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function recoverableViolation(message, _projectName, {
  error
} = {}) {
  if (false) {}

  return null;
}

var recoverableViolation_1 = recoverableViolation;

// @oss-only


var Recoil_recoverableViolation = recoverableViolation_1;

var _createMutableSource, _useMutableSource, _useSyncExternalStore;







const createMutableSource = // flowlint-next-line unclear-type:off
(_createMutableSource = react__WEBPACK_IMPORTED_MODULE_0__.createMutableSource) !== null && _createMutableSource !== void 0 ? _createMutableSource : react__WEBPACK_IMPORTED_MODULE_0__.unstable_createMutableSource;
const useMutableSource = // flowlint-next-line unclear-type:off
(_useMutableSource = react__WEBPACK_IMPORTED_MODULE_0__.useMutableSource) !== null && _useMutableSource !== void 0 ? _useMutableSource : react__WEBPACK_IMPORTED_MODULE_0__.unstable_useMutableSource; // https://github.com/reactwg/react-18/discussions/86

const useSyncExternalStore = // flowlint-next-line unclear-type:off
(_useSyncExternalStore = react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore) !== null && _useSyncExternalStore !== void 0 ? _useSyncExternalStore : // flowlint-next-line unclear-type:off
react__WEBPACK_IMPORTED_MODULE_0__.unstable_useSyncExternalStore;
let ReactRendererVersionMismatchWarnOnce = false; // Check if the current renderer supports `useSyncExternalStore()`.
// Since React goes through a proxy dispatcher and the current renderer can
// change we can't simply check if `React.useSyncExternalStore()` is defined.

function currentRendererSupportsUseSyncExternalStore() {
  var _ReactCurrentDispatch;

  // $FlowFixMe[incompatible-use]
  const {
    ReactCurrentDispatcher,
    ReactCurrentOwner
  } =
  /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
   * to detect if the current renderer supports useSyncExternalStore()
   * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */
  react__WEBPACK_IMPORTED_MODULE_0__.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  const dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
  const isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;

  if (useSyncExternalStore && !isUseSyncExternalStoreSupported && !ReactRendererVersionMismatchWarnOnce) {
    ReactRendererVersionMismatchWarnOnce = true;
    Recoil_recoverableViolation('A React renderer without React 18+ API support is being used with React 18+.');
  }

  return isUseSyncExternalStoreSupported;
}

/**
 * mode: The React API and approach to use for syncing state with React
 * early: Re-renders from Recoil updates occur:
 *    1) earlier
 *    2) in sync with React updates in the same batch
 *    3) before transaction observers instead of after.
 * concurrent: Is the current mode compatible with Concurrent Mode and useTransition()
 */
function reactMode() {
  // NOTE: This mode is currently broken with some Suspense cases
  // see Recoil_selector-test.js
  if (Recoil_gkx('recoil_transition_support')) {
    return {
      mode: 'TRANSITION_SUPPORT',
      early: true,
      concurrent: true
    };
  }

  if (Recoil_gkx('recoil_sync_external_store') && useSyncExternalStore != null) {
    return {
      mode: 'SYNC_EXTERNAL_STORE',
      early: true,
      concurrent: false
    };
  }

  if (Recoil_gkx('recoil_mutable_source') && useMutableSource != null && typeof window !== 'undefined' && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) {
    return Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
      mode: 'MUTABLE_SOURCE',
      early: true,
      concurrent: true
    } : {
      mode: 'MUTABLE_SOURCE',
      early: false,
      concurrent: false
    };
  }

  return Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
    mode: 'LEGACY',
    early: true,
    concurrent: false
  } : {
    mode: 'LEGACY',
    early: false,
    concurrent: false
  };
} // TODO Need to figure out if there is a standard/open-source equivalent to see if hot module replacement is happening:


function isFastRefreshEnabled() {
  // @fb-only: const {isAcceptingUpdate} = require('__debug');
  // @fb-only: return typeof isAcceptingUpdate === 'function' && isAcceptingUpdate();
  return false; // @oss-only
}

var Recoil_ReactMode = {
  createMutableSource,
  useMutableSource,
  useSyncExternalStore,
  currentRendererSupportsUseSyncExternalStore,
  reactMode,
  isFastRefreshEnabled
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

// eslint-disable-next-line no-unused-vars
class AbstractRecoilValue {
  constructor(newKey) {
    _defineProperty(this, "key", void 0);

    this.key = newKey;
  }

  toJSON() {
    return {
      key: this.key
    };
  }

}

class RecoilState extends AbstractRecoilValue {}

class RecoilValueReadOnly extends AbstractRecoilValue {}

function isRecoilValue(x) {
  return x instanceof RecoilState || x instanceof RecoilValueReadOnly;
}

var Recoil_RecoilValue = {
  AbstractRecoilValue,
  RecoilState,
  RecoilValueReadOnly,
  isRecoilValue
};

var Recoil_RecoilValue_1 = Recoil_RecoilValue.AbstractRecoilValue;
var Recoil_RecoilValue_2 = Recoil_RecoilValue.RecoilState;
var Recoil_RecoilValue_3 = Recoil_RecoilValue.RecoilValueReadOnly;
var Recoil_RecoilValue_4 = Recoil_RecoilValue.isRecoilValue;

var Recoil_RecoilValue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AbstractRecoilValue: Recoil_RecoilValue_1,
  RecoilState: Recoil_RecoilValue_2,
  RecoilValueReadOnly: Recoil_RecoilValue_3,
  isRecoilValue: Recoil_RecoilValue_4
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function sprintf(format, ...args) {
  let index = 0;
  return format.replace(/%s/g, () => String(args[index++]));
}

var sprintf_1 = (/* unused pure expression or super */ null && (sprintf));

function expectationViolation(format, ...args) {
  if (false) {}
}

var expectationViolation_1 = expectationViolation;

// @oss-only


var Recoil_expectationViolation = expectationViolation_1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the mapper function.
 */

function mapIterable(iterable, callback) {
  // Use generator to create iterable/iterator
  return function* () {
    let index = 0;

    for (const value of iterable) {
      yield callback(value, index++);
    }
  }();
}

var Recoil_mapIterable = mapIterable;

const {
  isFastRefreshEnabled: isFastRefreshEnabled$1
} = Recoil_ReactMode;















class DefaultValue {}

const DEFAULT_VALUE = new DefaultValue();
// flowlint-next-line unclear-type:off
const nodes = new Map(); // flowlint-next-line unclear-type:off

const recoilValues = new Map();
/* eslint-disable no-redeclare */

function recoilValuesForKeys(keys) {
  return Recoil_mapIterable(keys, key => Recoil_nullthrows(recoilValues.get(key)));
}

function checkForDuplicateAtomKey(key) {
  if (nodes.has(key)) {
    const message = `Duplicate atom key "${key}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;

    if (false) {} else {
      // @fb-only: recoverableViolation(message, 'recoil');
      console.warn(message); // @oss-only
    }
  }
}

function registerNode(node) {
  if (Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) {
    checkForDuplicateAtomKey(node.key);
  }

  nodes.set(node.key, node);
  const recoilValue = node.set == null ? new Recoil_RecoilValue$1.RecoilValueReadOnly(node.key) : new Recoil_RecoilValue$1.RecoilState(node.key);
  recoilValues.set(node.key, recoilValue);
  return recoilValue;
}
/* eslint-enable no-redeclare */


class NodeMissingError extends Error {} // flowlint-next-line unclear-type:off


function getNode(key) {
  const node = nodes.get(key);

  if (node == null) {
    throw new NodeMissingError(`Missing definition for RecoilValue: "${key}""`);
  }

  return node;
} // flowlint-next-line unclear-type:off


function getNodeMaybe(key) {
  return nodes.get(key);
}

const configDeletionHandlers = new Map();

function deleteNodeConfigIfPossible(key) {
  var _node$shouldDeleteCon;

  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const node = nodes.get(key);

  if (node !== null && node !== void 0 && (_node$shouldDeleteCon = node.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node)) {
    var _getConfigDeletionHan;

    nodes.delete(key);
    (_getConfigDeletionHan = getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 ? void 0 : _getConfigDeletionHan();
    configDeletionHandlers.delete(key);
  }
}

function setConfigDeletionHandler(key, fn) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  if (fn === undefined) {
    configDeletionHandlers.delete(key);
  } else {
    configDeletionHandlers.set(key, fn);
  }
}

function getConfigDeletionHandler(key) {
  return configDeletionHandlers.get(key);
}

var Recoil_Node = {
  nodes,
  recoilValues,
  registerNode,
  getNode,
  getNodeMaybe,
  deleteNodeConfigIfPossible,
  setConfigDeletionHandler,
  getConfigDeletionHandler,
  recoilValuesForKeys,
  NodeMissingError,
  DefaultValue,
  DEFAULT_VALUE
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function enqueueExecution(s, f) {
  f();
}

var Recoil_Queue = {
  enqueueExecution
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hamt_1 = createCommonjsModule(function (module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
/**
    @fileOverview Hash Array Mapped Trie.

    Code based on: https://github.com/exclipy/pdata
*/


var hamt = {}; // export

/* Configuration
 ******************************************************************************/

var SIZE = 5;
var BUCKET_SIZE = Math.pow(2, SIZE);
var MASK = BUCKET_SIZE - 1;
var MAX_INDEX_NODE = BUCKET_SIZE / 2;
var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
/*
 ******************************************************************************/

var nothing = {};

var constant = function constant(x) {
  return function () {
    return x;
  };
};
/**
    Get 32 bit hash of string.

    Based on:
    http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
*/


var hash = hamt.hash = function (str) {
  var type = typeof str === 'undefined' ? 'undefined' : _typeof(str);
  if (type === 'number') return str;
  if (type !== 'string') str += '';
  var hash = 0;

  for (var i = 0, len = str.length; i < len; ++i) {
    var c = str.charCodeAt(i);
    hash = (hash << 5) - hash + c | 0;
  }

  return hash;
};
/* Bit Ops
 ******************************************************************************/

/**
    Hamming weight.

    Taken from: http://jsperf.com/hamming-weight
*/


var popcount = function popcount(x) {
  x -= x >> 1 & 0x55555555;
  x = (x & 0x33333333) + (x >> 2 & 0x33333333);
  x = x + (x >> 4) & 0x0f0f0f0f;
  x += x >> 8;
  x += x >> 16;
  return x & 0x7f;
};

var hashFragment = function hashFragment(shift, h) {
  return h >>> shift & MASK;
};

var toBitmap = function toBitmap(x) {
  return 1 << x;
};

var fromBitmap = function fromBitmap(bitmap, bit) {
  return popcount(bitmap & bit - 1);
};
/* Array Ops
 ******************************************************************************/

/**
    Set a value in an array.

    @param mutate Should the input array be mutated?
    @param at Index to change.
    @param v New value
    @param arr Array.
*/


var arrayUpdate = function arrayUpdate(mutate, at, v, arr) {
  var out = arr;

  if (!mutate) {
    var len = arr.length;
    out = new Array(len);

    for (var i = 0; i < len; ++i) {
      out[i] = arr[i];
    }
  }

  out[at] = v;
  return out;
};
/**
    Remove a value from an array.

    @param mutate Should the input array be mutated?
    @param at Index to remove.
    @param arr Array.
*/


var arraySpliceOut = function arraySpliceOut(mutate, at, arr) {
  var newLen = arr.length - 1;
  var i = 0;
  var g = 0;
  var out = arr;

  if (mutate) {
    i = g = at;
  } else {
    out = new Array(newLen);

    while (i < at) {
      out[g++] = arr[i++];
    }
  }

  ++i;

  while (i <= newLen) {
    out[g++] = arr[i++];
  }

  if (mutate) {
    out.length = newLen;
  }

  return out;
};
/**
    Insert a value into an array.

    @param mutate Should the input array be mutated?
    @param at Index to insert at.
    @param v Value to insert,
    @param arr Array.
*/


var arraySpliceIn = function arraySpliceIn(mutate, at, v, arr) {
  var len = arr.length;

  if (mutate) {
    var _i = len;

    while (_i >= at) {
      arr[_i--] = arr[_i];
    }

    arr[at] = v;
    return arr;
  }

  var i = 0,
      g = 0;
  var out = new Array(len + 1);

  while (i < at) {
    out[g++] = arr[i++];
  }

  out[at] = v;

  while (i < len) {
    out[++g] = arr[i++];
  }

  return out;
};
/* Node Structures
 ******************************************************************************/


var LEAF = 1;
var COLLISION = 2;
var INDEX = 3;
var ARRAY = 4;
/**
    Empty node.
*/

var empty = {
  __hamt_isEmpty: true
};

var isEmptyNode = function isEmptyNode(x) {
  return x === empty || x && x.__hamt_isEmpty;
};
/**
    Leaf holding a value.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member key Key.
    @member value Value stored.
*/


var Leaf = function Leaf(edit, hash, key, value) {
  return {
    type: LEAF,
    edit: edit,
    hash: hash,
    key: key,
    value: value,
    _modify: Leaf__modify
  };
};
/**
    Leaf holding multiple values with the same hash but different keys.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member children Array of collision children node.
*/


var Collision = function Collision(edit, hash, children) {
  return {
    type: COLLISION,
    edit: edit,
    hash: hash,
    children: children,
    _modify: Collision__modify
  };
};
/**
    Internal node with a sparse set of children.

    Uses a bitmap and array to pack children.

  @member edit Edit of the node.
    @member mask Bitmap that encode the positions of children in the array.
    @member children Array of child nodes.
*/


var IndexedNode = function IndexedNode(edit, mask, children) {
  return {
    type: INDEX,
    edit: edit,
    mask: mask,
    children: children,
    _modify: IndexedNode__modify
  };
};
/**
    Internal node with many children.

    @member edit Edit of the node.
    @member size Number of children.
    @member children Array of child nodes.
*/


var ArrayNode = function ArrayNode(edit, size, children) {
  return {
    type: ARRAY,
    edit: edit,
    size: size,
    children: children,
    _modify: ArrayNode__modify
  };
};
/**
    Is `node` a leaf node?
*/


var isLeaf = function isLeaf(node) {
  return node === empty || node.type === LEAF || node.type === COLLISION;
};
/* Internal node operations.
 ******************************************************************************/

/**
    Expand an indexed node into an array node.

  @param edit Current edit.
    @param frag Index of added child.
    @param child Added child.
    @param mask Index node mask before child added.
    @param subNodes Index node children before child added.
*/


var expand = function expand(edit, frag, child, bitmap, subNodes) {
  var arr = [];
  var bit = bitmap;
  var count = 0;

  for (var i = 0; bit; ++i) {
    if (bit & 1) arr[i] = subNodes[count++];
    bit >>>= 1;
  }

  arr[frag] = child;
  return ArrayNode(edit, count + 1, arr);
};
/**
    Collapse an array node into a indexed node.

  @param edit Current edit.
    @param count Number of elements in new array.
    @param removed Index of removed element.
    @param elements Array node children before remove.
*/


var pack = function pack(edit, count, removed, elements) {
  var children = new Array(count - 1);
  var g = 0;
  var bitmap = 0;

  for (var i = 0, len = elements.length; i < len; ++i) {
    if (i !== removed) {
      var elem = elements[i];

      if (elem && !isEmptyNode(elem)) {
        children[g++] = elem;
        bitmap |= 1 << i;
      }
    }
  }

  return IndexedNode(edit, bitmap, children);
};
/**
    Merge two leaf nodes.

    @param shift Current shift.
    @param h1 Node 1 hash.
    @param n1 Node 1.
    @param h2 Node 2 hash.
    @param n2 Node 2.
*/


var mergeLeaves = function mergeLeaves(edit, shift, h1, n1, h2, n2) {
  if (h1 === h2) return Collision(edit, h1, [n2, n1]);
  var subH1 = hashFragment(shift, h1);
  var subH2 = hashFragment(shift, h2);
  return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [mergeLeaves(edit, shift + SIZE, h1, n1, h2, n2)] : subH1 < subH2 ? [n1, n2] : [n2, n1]);
};
/**
    Update an entry in a collision list.

    @param mutate Should mutation be used?
    @param edit Current edit.
    @param keyEq Key compare function.
    @param hash Hash of collision.
    @param list Collision list.
    @param f Update function.
    @param k Key to update.
    @param size Size ref.
*/


var updateCollisionList = function updateCollisionList(mutate, edit, keyEq, h, list, f, k, size) {
  var len = list.length;

  for (var i = 0; i < len; ++i) {
    var child = list[i];

    if (keyEq(k, child.key)) {
      var value = child.value;

      var _newValue = f(value);

      if (_newValue === value) return list;

      if (_newValue === nothing) {
        --size.value;
        return arraySpliceOut(mutate, i, list);
      }

      return arrayUpdate(mutate, i, Leaf(edit, h, k, _newValue), list);
    }
  }

  var newValue = f();
  if (newValue === nothing) return list;
  ++size.value;
  return arrayUpdate(mutate, len, Leaf(edit, h, k, newValue), list);
};

var canEditNode = function canEditNode(edit, node) {
  return edit === node.edit;
};
/* Editing
 ******************************************************************************/


var Leaf__modify = function Leaf__modify(edit, keyEq, shift, f, h, k, size) {
  if (keyEq(k, this.key)) {
    var _v = f(this.value);

    if (_v === this.value) return this;else if (_v === nothing) {
      --size.value;
      return empty;
    }

    if (canEditNode(edit, this)) {
      this.value = _v;
      return this;
    }

    return Leaf(edit, h, k, _v);
  }

  var v = f();
  if (v === nothing) return this;
  ++size.value;
  return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
};

var Collision__modify = function Collision__modify(edit, keyEq, shift, f, h, k, size) {
  if (h === this.hash) {
    var canEdit = canEditNode(edit, this);
    var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
    if (list === this.children) return this;
    return list.length > 1 ? Collision(edit, this.hash, list) : list[0]; // collapse single element collision list
  }

  var v = f();
  if (v === nothing) return this;
  ++size.value;
  return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
};

var IndexedNode__modify = function IndexedNode__modify(edit, keyEq, shift, f, h, k, size) {
  var mask = this.mask;
  var children = this.children;
  var frag = hashFragment(shift, h);
  var bit = toBitmap(frag);
  var indx = fromBitmap(mask, bit);
  var exists = mask & bit;
  var current = exists ? children[indx] : empty;

  var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);

  if (current === child) return this;
  var canEdit = canEditNode(edit, this);
  var bitmap = mask;
  var newChildren = void 0;

  if (exists && isEmptyNode(child)) {
    // remove
    bitmap &= ~bit;
    if (!bitmap) return empty;
    if (children.length <= 2 && isLeaf(children[indx ^ 1])) return children[indx ^ 1]; // collapse

    newChildren = arraySpliceOut(canEdit, indx, children);
  } else if (!exists && !isEmptyNode(child)) {
    // add
    if (children.length >= MAX_INDEX_NODE) return expand(edit, frag, child, mask, children);
    bitmap |= bit;
    newChildren = arraySpliceIn(canEdit, indx, child, children);
  } else {
    // modify
    newChildren = arrayUpdate(canEdit, indx, child, children);
  }

  if (canEdit) {
    this.mask = bitmap;
    this.children = newChildren;
    return this;
  }

  return IndexedNode(edit, bitmap, newChildren);
};

var ArrayNode__modify = function ArrayNode__modify(edit, keyEq, shift, f, h, k, size) {
  var count = this.size;
  var children = this.children;
  var frag = hashFragment(shift, h);
  var child = children[frag];

  var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);

  if (child === newChild) return this;
  var canEdit = canEditNode(edit, this);
  var newChildren = void 0;

  if (isEmptyNode(child) && !isEmptyNode(newChild)) {
    // add
    ++count;
    newChildren = arrayUpdate(canEdit, frag, newChild, children);
  } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
    // remove
    --count;
    if (count <= MIN_ARRAY_NODE) return pack(edit, count, frag, children);
    newChildren = arrayUpdate(canEdit, frag, empty, children);
  } else {
    // modify
    newChildren = arrayUpdate(canEdit, frag, newChild, children);
  }

  if (canEdit) {
    this.size = count;
    this.children = newChildren;
    return this;
  }

  return ArrayNode(edit, count, newChildren);
};

empty._modify = function (edit, keyEq, shift, f, h, k, size) {
  var v = f();
  if (v === nothing) return empty;
  ++size.value;
  return Leaf(edit, h, k, v);
};
/*
 ******************************************************************************/


function Map(editable, edit, config, root, size) {
  this._editable = editable;
  this._edit = edit;
  this._config = config;
  this._root = root;
  this._size = size;
}

Map.prototype.setTree = function (newRoot, newSize) {
  if (this._editable) {
    this._root = newRoot;
    this._size = newSize;
    return this;
  }

  return newRoot === this._root ? this : new Map(this._editable, this._edit, this._config, newRoot, newSize);
};
/* Queries
 ******************************************************************************/

/**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `alt` if none.
*/


var tryGetHash = hamt.tryGetHash = function (alt, hash, key, map) {
  var node = map._root;
  var shift = 0;
  var keyEq = map._config.keyEq;

  while (true) {
    switch (node.type) {
      case LEAF:
        {
          return keyEq(key, node.key) ? node.value : alt;
        }

      case COLLISION:
        {
          if (hash === node.hash) {
            var children = node.children;

            for (var i = 0, len = children.length; i < len; ++i) {
              var child = children[i];
              if (keyEq(key, child.key)) return child.value;
            }
          }

          return alt;
        }

      case INDEX:
        {
          var frag = hashFragment(shift, hash);
          var bit = toBitmap(frag);

          if (node.mask & bit) {
            node = node.children[fromBitmap(node.mask, bit)];
            shift += SIZE;
            break;
          }

          return alt;
        }

      case ARRAY:
        {
          node = node.children[hashFragment(shift, hash)];

          if (node) {
            shift += SIZE;
            break;
          }

          return alt;
        }

      default:
        return alt;
    }
  }
};

Map.prototype.tryGetHash = function (alt, hash, key) {
  return tryGetHash(alt, hash, key, this);
};
/**
    Lookup the value for `key` in `map` using internal hash function.

    @see `tryGetHash`
*/


var tryGet = hamt.tryGet = function (alt, key, map) {
  return tryGetHash(alt, map._config.hash(key), key, map);
};

Map.prototype.tryGet = function (alt, key) {
  return tryGet(alt, key, this);
};
/**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `undefined` if none.
*/


var getHash = hamt.getHash = function (hash, key, map) {
  return tryGetHash(undefined, hash, key, map);
};

Map.prototype.getHash = function (hash, key) {
  return getHash(hash, key, this);
};
/**
    Lookup the value for `key` in `map` using internal hash function.

    @see `get`
*/


var get = hamt.get = function (key, map) {
  return tryGetHash(undefined, map._config.hash(key), key, map);
};

Map.prototype.get = function (key, alt) {
  return tryGet(alt, key, this);
};
/**
    Does an entry exist for `key` in `map`? Uses custom `hash`.
*/


var hasHash = hamt.has = function (hash, key, map) {
  return tryGetHash(nothing, hash, key, map) !== nothing;
};

Map.prototype.hasHash = function (hash, key) {
  return hasHash(hash, key, this);
};
/**
    Does an entry exist for `key` in `map`? Uses internal hash function.
*/


var has = hamt.has = function (key, map) {
  return hasHash(map._config.hash(key), key, map);
};

Map.prototype.has = function (key) {
  return has(key, this);
};

var defKeyCompare = function defKeyCompare(x, y) {
  return x === y;
};
/**
    Create an empty map.

    @param config Configuration.
*/


hamt.make = function (config) {
  return new Map(0, 0, {
    keyEq: config && config.keyEq || defKeyCompare,
    hash: config && config.hash || hash
  }, empty, 0);
};
/**
    Empty map.
*/


hamt.empty = hamt.make();
/**
    Does `map` contain any elements?
*/

var isEmpty = hamt.isEmpty = function (map) {
  return map && !!isEmptyNode(map._root);
};

Map.prototype.isEmpty = function () {
  return isEmpty(this);
};
/* Updates
 ******************************************************************************/

/**
    Alter the value stored for `key` in `map` using function `f` using
    custom hash.

    `f` is invoked with the current value for `k` if it exists,
    or no arguments if no such value exists. `modify` will always either
    update or insert a value into the map.

    Returns a map with the modified value. Does not alter `map`.
*/


var modifyHash = hamt.modifyHash = function (f, hash, key, map) {
  var size = {
    value: map._size
  };

  var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash, key, size);

  return map.setTree(newRoot, size.value);
};

Map.prototype.modifyHash = function (hash, key, f) {
  return modifyHash(f, hash, key, this);
};
/**
    Alter the value stored for `key` in `map` using function `f` using
    internal hash function.

    @see `modifyHash`
*/


var modify = hamt.modify = function (f, key, map) {
  return modifyHash(f, map._config.hash(key), key, map);
};

Map.prototype.modify = function (key, f) {
  return modify(f, key, this);
};
/**
    Store `value` for `key` in `map` using custom `hash`.

    Returns a map with the modified value. Does not alter `map`.
*/


var setHash = hamt.setHash = function (hash, key, value, map) {
  return modifyHash(constant(value), hash, key, map);
};

Map.prototype.setHash = function (hash, key, value) {
  return setHash(hash, key, value, this);
};
/**
    Store `value` for `key` in `map` using internal hash function.

    @see `setHash`
*/


var set = hamt.set = function (key, value, map) {
  return setHash(map._config.hash(key), key, value, map);
};

Map.prototype.set = function (key, value) {
  return set(key, value, this);
};
/**
    Remove the entry for `key` in `map`.

    Returns a map with the value removed. Does not alter `map`.
*/


var del = constant(nothing);

var removeHash = hamt.removeHash = function (hash, key, map) {
  return modifyHash(del, hash, key, map);
};

Map.prototype.removeHash = Map.prototype.deleteHash = function (hash, key) {
  return removeHash(hash, key, this);
};
/**
    Remove the entry for `key` in `map` using internal hash function.

    @see `removeHash`
*/


var remove = hamt.remove = function (key, map) {
  return removeHash(map._config.hash(key), key, map);
};

Map.prototype.remove = Map.prototype.delete = function (key) {
  return remove(key, this);
};
/* Mutation
 ******************************************************************************/

/**
    Mark `map` as mutable.
 */


var beginMutation = hamt.beginMutation = function (map) {
  return new Map(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
};

Map.prototype.beginMutation = function () {
  return beginMutation(this);
};
/**
    Mark `map` as immutable.
 */


var endMutation = hamt.endMutation = function (map) {
  map._editable = map._editable && map._editable - 1;
  return map;
};

Map.prototype.endMutation = function () {
  return endMutation(this);
};
/**
    Mutate `map` within the context of `f`.
    @param f
    @param map HAMT
*/


var mutate = hamt.mutate = function (f, map) {
  var transient = beginMutation(map);
  f(transient);
  return endMutation(transient);
};

Map.prototype.mutate = function (f) {
  return mutate(f, this);
};
/* Traversal
 ******************************************************************************/

/**
    Apply a continuation.
*/


var appk = function appk(k) {
  return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
};
/**
    Recursively visit all values stored in an array of nodes lazily.
*/


var lazyVisitChildren = function lazyVisitChildren(len, children, i, f, k) {
  while (i < len) {
    var child = children[i++];
    if (child && !isEmptyNode(child)) return lazyVisit(child, f, [len, children, i, f, k]);
  }

  return appk(k);
};
/**
    Recursively visit all values stored in `node` lazily.
*/


var lazyVisit = function lazyVisit(node, f, k) {
  switch (node.type) {
    case LEAF:
      return {
        value: f(node),
        rest: k
      };

    case COLLISION:
    case ARRAY:
    case INDEX:
      var children = node.children;
      return lazyVisitChildren(children.length, children, 0, f, k);

    default:
      return appk(k);
  }
};

var DONE = {
  done: true
};
/**
    Javascript iterator over a map.
*/

function MapIterator(v) {
  this.v = v;
}

MapIterator.prototype.next = function () {
  if (!this.v) return DONE;
  var v0 = this.v;
  this.v = appk(v0.rest);
  return v0;
};

MapIterator.prototype[Symbol.iterator] = function () {
  return this;
};
/**
    Lazily visit each value in map with function `f`.
*/


var visit = function visit(map, f) {
  return new MapIterator(lazyVisit(map._root, f));
};
/**
    Get a Javascsript iterator of `map`.

    Iterates over `[key, value]` arrays.
*/


var buildPairs = function buildPairs(x) {
  return [x.key, x.value];
};

var entries = hamt.entries = function (map) {
  return visit(map, buildPairs);
};

Map.prototype.entries = Map.prototype[Symbol.iterator] = function () {
  return entries(this);
};
/**
    Get array of all keys in `map`.

    Order is not guaranteed.
*/


var buildKeys = function buildKeys(x) {
  return x.key;
};

var keys = hamt.keys = function (map) {
  return visit(map, buildKeys);
};

Map.prototype.keys = function () {
  return keys(this);
};
/**
    Get array of all values in `map`.

    Order is not guaranteed, duplicates are preserved.
*/


var buildValues = function buildValues(x) {
  return x.value;
};

var values = hamt.values = Map.prototype.values = function (map) {
  return visit(map, buildValues);
};

Map.prototype.values = function () {
  return values(this);
};
/* Fold
 ******************************************************************************/

/**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function mapping accumulated value, value, and key to new value.
    @param z Starting value.
    @param m HAMT
*/


var fold = hamt.fold = function (f, z, m) {
  var root = m._root;
  if (root.type === LEAF) return f(z, root.value, root.key);
  var toVisit = [root.children];
  var children = void 0;

  while (children = toVisit.pop()) {
    for (var i = 0, len = children.length; i < len;) {
      var child = children[i++];

      if (child && child.type) {
        if (child.type === LEAF) z = f(z, child.value, child.key);else toVisit.push(child.children);
      }
    }
  }

  return z;
};

Map.prototype.fold = function (f, z) {
  return fold(f, z, this);
};
/**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function invoked with value and key
    @param map HAMT
*/


var forEach = hamt.forEach = function (f, map) {
  return fold(function (_, value, key) {
    return f(value, key, map);
  }, null, map);
};

Map.prototype.forEach = function (f) {
  return forEach(f, this);
};
/* Aggregate
 ******************************************************************************/

/**
    Get the number of entries in `map`.
*/


var count = hamt.count = function (map) {
  return map._size;
};

Map.prototype.count = function () {
  return count(this);
};

Object.defineProperty(Map.prototype, 'size', {
  get: Map.prototype.count
});
/* Export
 ******************************************************************************/

if ( module.exports) {
  module.exports = hamt;
} else {
  undefined.hamt = hamt;
}
});

class BuiltInMap {
  constructor(existing) {
    _defineProperty(this, "_map", void 0);

    this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
  }

  keys() {
    return this._map.keys();
  }

  entries() {
    return this._map.entries();
  }

  get(k) {
    return this._map.get(k);
  }

  has(k) {
    return this._map.has(k);
  }

  set(k, v) {
    this._map.set(k, v);

    return this;
  }

  delete(k) {
    this._map.delete(k);

    return this;
  }

  clone() {
    return persistentMap(this);
  }

  toMap() {
    return new Map(this._map);
  }

}

class HashArrayMappedTrieMap {
  // Because hamt.empty is not a function there is no way to introduce type
  // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
  // $FlowIssue
  constructor(existing) {
    _defineProperty(this, "_hamt", hamt_1.empty.beginMutation());

    if (existing instanceof HashArrayMappedTrieMap) {
      const h = existing._hamt.endMutation();

      existing._hamt = h.beginMutation();
      this._hamt = h.beginMutation();
    } else if (existing) {
      for (const [k, v] of existing.entries()) {
        this._hamt.set(k, v);
      }
    }
  }

  keys() {
    return this._hamt.keys();
  }

  entries() {
    return this._hamt.entries();
  }

  get(k) {
    return this._hamt.get(k);
  }

  has(k) {
    return this._hamt.has(k);
  }

  set(k, v) {
    this._hamt.set(k, v);

    return this;
  }

  delete(k) {
    this._hamt.delete(k);

    return this;
  }

  clone() {
    return persistentMap(this);
  }

  toMap() {
    return new Map(this._hamt);
  }

}

function persistentMap(existing) {
  if (Recoil_gkx('recoil_hamt_2020')) {
    return new HashArrayMappedTrieMap(existing);
  } else {
    return new BuiltInMap(existing);
  }
}

var Recoil_PersistentMap = {
  persistentMap
};

var Recoil_PersistentMap_1 = Recoil_PersistentMap.persistentMap;

var Recoil_PersistentMap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  persistentMap: Recoil_PersistentMap_1
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a set containing all of the values from the first set that are not
 * present in any of the subsequent sets.
 *
 * Note: this is written procedurally (i.e., without filterSet) for performant
 * use in tight loops.
 */

function differenceSets(set, ...setsWithValuesToRemove) {
  const ret = new Set();

  FIRST: for (const value of set) {
    for (const otherSet of setsWithValuesToRemove) {
      if (otherSet.has(value)) {
        continue FIRST;
      }
    }

    ret.add(value);
  }

  return ret;
}

var Recoil_differenceSets = differenceSets;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a new Map object with the same keys as the original, but with the
 * values replaced with the output of the given callback function.
 */

function mapMap(map, callback) {
  const result = new Map();
  map.forEach((value, key) => {
    result.set(key, callback(value, key));
  });
  return result;
}

var Recoil_mapMap = mapMap;

function makeGraph() {
  return {
    nodeDeps: new Map(),
    nodeToNodeSubscriptions: new Map()
  };
}

function cloneGraph(graph) {
  return {
    nodeDeps: Recoil_mapMap(graph.nodeDeps, s => new Set(s)),
    nodeToNodeSubscriptions: Recoil_mapMap(graph.nodeToNodeSubscriptions, s => new Set(s))
  };
} // Note that this overwrites the deps of existing nodes, rather than unioning
// the new deps with the old deps.


function mergeDepsIntoGraph(key, newDeps, graph, // If olderGraph is given then we will not overwrite changes made to the given
// graph compared with olderGraph:
olderGraph) {
  const {
    nodeDeps,
    nodeToNodeSubscriptions
  } = graph;
  const oldDeps = nodeDeps.get(key);

  if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) {
    return;
  } // Update nodeDeps:


  nodeDeps.set(key, newDeps); // Add new deps to nodeToNodeSubscriptions:

  const addedDeps = oldDeps == null ? newDeps : Recoil_differenceSets(newDeps, oldDeps);

  for (const dep of addedDeps) {
    if (!nodeToNodeSubscriptions.has(dep)) {
      nodeToNodeSubscriptions.set(dep, new Set());
    }

    const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
    existing.add(key);
  } // Remove removed deps from nodeToNodeSubscriptions:


  if (oldDeps) {
    const removedDeps = Recoil_differenceSets(oldDeps, newDeps);

    for (const dep of removedDeps) {
      if (!nodeToNodeSubscriptions.has(dep)) {
        return;
      }

      const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
      existing.delete(key);

      if (existing.size === 0) {
        nodeToNodeSubscriptions.delete(dep);
      }
    }
  }
}

function saveDepsToStore(key, deps, store, version) {
  var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;

  const storeState = store.getState();

  if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation('Tried to save dependencies to a discarded tree');
  } // Merge the dependencies discovered into the store's dependency map
  // for the version that was read:


  const graph = store.getGraph(version);
  mergeDepsIntoGraph(key, deps, graph); // If this version is not the latest version, also write these dependencies
  // into later versions if they don't already have their own:

  if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
    const currentGraph = store.getGraph(storeState.currentTree.version);
    mergeDepsIntoGraph(key, deps, currentGraph, graph);
  }

  if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
    var _storeState$nextTree2;

    const nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;

    if (nextVersion !== undefined) {
      const nextGraph = store.getGraph(nextVersion);
      mergeDepsIntoGraph(key, deps, nextGraph, graph);
    }
  }
}

var Recoil_Graph = {
  cloneGraph,
  graph: makeGraph,
  saveDepsToStore
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

let nextTreeStateVersion = 0;

const getNextTreeStateVersion = () => nextTreeStateVersion++;

let nextStoreID = 0;

const getNextStoreID = () => nextStoreID++;

let nextComponentID = 0;

const getNextComponentID = () => nextComponentID++;

var Recoil_Keys = {
  getNextTreeStateVersion,
  getNextStoreID,
  getNextComponentID
};

const {
  persistentMap: persistentMap$1
} = Recoil_PersistentMap$1;

const {
  graph
} = Recoil_Graph;

const {
  getNextTreeStateVersion: getNextTreeStateVersion$1
} = Recoil_Keys;

function makeEmptyTreeState() {
  const version = getNextTreeStateVersion$1();
  return {
    version,
    stateID: version,
    transactionMetadata: {},
    dirtyAtoms: new Set(),
    atomValues: persistentMap$1(),
    nonvalidatedAtoms: persistentMap$1()
  };
}

function makeEmptyStoreState() {
  const currentTree = makeEmptyTreeState();
  return {
    currentTree,
    nextTree: null,
    previousTree: null,
    commitDepth: 0,
    knownAtoms: new Set(),
    knownSelectors: new Set(),
    transactionSubscriptions: new Map(),
    nodeTransactionSubscriptions: new Map(),
    nodeToComponentSubscriptions: new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: new Set(),
    graphsByVersion: new Map().set(currentTree.version, graph()),
    retention: {
      referenceCounts: new Map(),
      nodesRetainedByZone: new Map(),
      retainablesToCheckForRelease: new Set()
    },
    nodeCleanupFunctions: new Map()
  };
}

var Recoil_State = {
  makeEmptyTreeState,
  makeEmptyStoreState,
  getNextTreeStateVersion: getNextTreeStateVersion$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class RetentionZone {}

function retentionZone() {
  return new RetentionZone();
}

var Recoil_RetentionZone = {
  RetentionZone,
  retentionZone
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Utilities for working with built-in Maps and Sets without mutating them.
 *
 * 
 * @format
 * @oncall recoil
 */

function setByAddingToSet(set, v) {
  const next = new Set(set);
  next.add(v);
  return next;
}

function setByDeletingFromSet(set, v) {
  const next = new Set(set);
  next.delete(v);
  return next;
}

function mapBySettingInMap(map, k, v) {
  const next = new Map(map);
  next.set(k, v);
  return next;
}

function mapByUpdatingInMap(map, k, updater) {
  const next = new Map(map);
  next.set(k, updater(next.get(k)));
  return next;
}

function mapByDeletingFromMap(map, k) {
  const next = new Map(map);
  next.delete(k);
  return next;
}

function mapByDeletingMultipleFromMap(map, ks) {
  const next = new Map(map);
  ks.forEach(k => next.delete(k));
  return next;
}

var Recoil_CopyOnWrite = {
  setByAddingToSet,
  setByDeletingFromSet,
  mapBySettingInMap,
  mapByUpdatingInMap,
  mapByDeletingFromMap,
  mapByDeletingMultipleFromMap
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the filter function.
 */

function* filterIterable(iterable, predicate) {
  // Use generator to create iterable/iterator
  let index = 0;

  for (const value of iterable) {
    if (predicate(value, index++)) {
      yield value;
    }
  }
}

var Recoil_filterIterable = filterIterable;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Return a proxy object based on the provided base and factories objects.
 * The proxy will include all properties of the base object as-is.
 * The factories object contains callbacks to obtain the values of the properies
 * for its keys.
 *
 * This is useful for providing users an object where some properties may be
 * lazily computed only on first access.
 */
// $FlowIssue[unclear-type]

function lazyProxy(base, factories) {
  const proxy = new Proxy(base, {
    // Compute and cache lazy property if not already done.
    get: (target, prop) => {
      if (!(prop in target) && prop in factories) {
        target[prop] = factories[prop]();
      }

      return target[prop];
    },
    // This method allows user to iterate keys as normal
    ownKeys: target => {

      return Object.keys(target);
    }
  }); // $FlowIssue[incompatible-return]

  return proxy;
}

var Recoil_lazyProxy = lazyProxy;

const {
  getNode: getNode$1,
  getNodeMaybe: getNodeMaybe$1,
  recoilValuesForKeys: recoilValuesForKeys$1
} = Recoil_Node;

const {
  RetentionZone: RetentionZone$1
} = Recoil_RetentionZone;

const {
  setByAddingToSet: setByAddingToSet$1
} = Recoil_CopyOnWrite;







 // flowlint-next-line unclear-type:off


const emptySet = Object.freeze(new Set());

class ReadOnlyRecoilValueError extends Error {}

function initializeRetentionForNode(store, nodeKey, retainedBy) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return () => undefined;
  }

  const {
    nodesRetainedByZone
  } = store.getState().retention;

  function addToZone(zone) {
    let set = nodesRetainedByZone.get(zone);

    if (!set) {
      nodesRetainedByZone.set(zone, set = new Set());
    }

    set.add(nodeKey);
  }

  if (retainedBy instanceof RetentionZone$1) {
    addToZone(retainedBy);
  } else if (Array.isArray(retainedBy)) {
    for (const zone of retainedBy) {
      addToZone(zone);
    }
  }

  return () => {
    if (!Recoil_gkx('recoil_memory_managament_2020')) {
      return;
    }

    const {
      retention
    } = store.getState();

    function deleteFromZone(zone) {
      const set = retention.nodesRetainedByZone.get(zone);
      set === null || set === void 0 ? void 0 : set.delete(nodeKey);

      if (set && set.size === 0) {
        retention.nodesRetainedByZone.delete(zone);
      }
    }

    if (retainedBy instanceof RetentionZone$1) {
      deleteFromZone(retainedBy);
    } else if (Array.isArray(retainedBy)) {
      for (const zone of retainedBy) {
        deleteFromZone(zone);
      }
    }
  };
}

function initializeNodeIfNewToStore(store, treeState, key, trigger) {
  const storeState = store.getState();

  if (storeState.nodeCleanupFunctions.has(key)) {
    return;
  }

  const node = getNode$1(key);
  const retentionCleanup = initializeRetentionForNode(store, key, node.retainedBy);
  const nodeCleanup = node.init(store, treeState, trigger);
  storeState.nodeCleanupFunctions.set(key, () => {
    nodeCleanup();
    retentionCleanup();
  });
}

function initializeNode(store, key, trigger) {
  initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}

function cleanUpNode(store, key) {
  var _state$nodeCleanupFun;

  const state = store.getState();
  (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 ? void 0 : _state$nodeCleanupFun();
  state.nodeCleanupFunctions.delete(key);
} // Get the current value loadable of a node and update the state.
// Update dependencies and subscriptions for selectors.
// Update saved value validation for atoms.


function getNodeLoadable(store, state, key) {
  initializeNodeIfNewToStore(store, state, key, 'get');
  return getNode$1(key).get(store, state);
} // Peek at the current value loadable for a node without any evaluation or state change


function peekNodeLoadable(store, state, key) {
  return getNode$1(key).peek(store, state);
} // Write value directly to state bypassing the Node interface as the node
// definitions may not have been loaded yet when processing the initial snapshot.


function setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
  var _node$invalidate;

  const node = getNodeMaybe$1(key);
  node === null || node === void 0 ? void 0 : (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node, state);
  return { ...state,
    atomValues: state.atomValues.clone().delete(key),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
    dirtyAtoms: setByAddingToSet$1(state.dirtyAtoms, key)
  };
} // Return the discovered dependencies and values to be written by setting
// a node value. (Multiple values may be written due to selectors getting to
// set upstreams; deps may be discovered because of reads in updater functions.)


function setNodeValue(store, state, key, newValue) {
  const node = getNode$1(key);

  if (node.set == null) {
    throw new ReadOnlyRecoilValueError(`Attempt to set read-only RecoilValue: ${key}`);
  }

  const set = node.set; // so flow doesn't lose the above refinement.

  initializeNodeIfNewToStore(store, state, key, 'set');
  return set(store, state, newValue);
}

function peekNodeInfo(store, state, key) {
  const storeState = store.getState();
  const graph = store.getGraph(state.version);
  const type = getNode$1(key).nodeType;
  return Recoil_lazyProxy({
    type
  }, {
    // $FlowFixMe[underconstrained-implicit-instantiation]
    loadable: () => peekNodeLoadable(store, state, key),
    isActive: () => storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key),
    isSet: () => type === 'selector' ? false : state.atomValues.has(key),
    isModified: () => state.dirtyAtoms.has(key),
    // Report current dependencies.  If the node hasn't been evaluated, then
    // dependencies may be missing based on the current state.
    deps: () => {
      var _graph$nodeDeps$get;

      return recoilValuesForKeys$1((_graph$nodeDeps$get = graph.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
    },
    // Reports all "current" subscribers.  Evaluating other nodes or
    // previous in-progress async evaluations may introduce new subscribers.
    subscribers: () => {
      var _storeState$nodeToCom, _storeState$nodeToCom2;

      return {
        nodes: recoilValuesForKeys$1(Recoil_filterIterable(getDownstreamNodes(store, state, new Set([key])), nodeKey => nodeKey !== key)),
        components: Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], ([name]) => ({
          name
        }))
      };
    }
  });
} // Find all of the recursively dependent nodes


function getDownstreamNodes(store, state, keys) {
  const visitedNodes = new Set();
  const visitingNodes = Array.from(keys);
  const graph = store.getGraph(state.version);

  for (let key = visitingNodes.pop(); key; key = visitingNodes.pop()) {
    var _graph$nodeToNodeSubs;

    visitedNodes.add(key);
    const subscribedNodes = (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : emptySet;

    for (const downstreamNode of subscribedNodes) {
      if (!visitedNodes.has(downstreamNode)) {
        visitingNodes.push(downstreamNode);
      }
    }
  }

  return visitedNodes;
}

var Recoil_FunctionalCore = {
  getNodeLoadable,
  peekNodeLoadable,
  setNodeValue,
  initializeNode,
  cleanUpNode,
  setUnvalidatedAtomValue_DEPRECATED,
  peekNodeInfo,
  getDownstreamNodes
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

let _invalidateMemoizedSnapshot = null;

function setInvalidateMemoizedSnapshot(invalidate) {
  _invalidateMemoizedSnapshot = invalidate;
}

function invalidateMemoizedSnapshot() {
  var _invalidateMemoizedSn;

  (_invalidateMemoizedSn = _invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 ? void 0 : _invalidateMemoizedSn();
}

var Recoil_SnapshotCache = {
  setInvalidateMemoizedSnapshot,
  invalidateMemoizedSnapshot
};

const {
  getDownstreamNodes: getDownstreamNodes$1,
  getNodeLoadable: getNodeLoadable$1,
  setNodeValue: setNodeValue$1
} = Recoil_FunctionalCore;

const {
  getNextComponentID: getNextComponentID$1
} = Recoil_Keys;

const {
  getNode: getNode$2,
  getNodeMaybe: getNodeMaybe$2
} = Recoil_Node;

const {
  DefaultValue: DefaultValue$1
} = Recoil_Node;

const {
  reactMode: reactMode$1
} = Recoil_ReactMode;

const {
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  isRecoilValue: isRecoilValue$1
} = Recoil_RecoilValue$1;

const {
  invalidateMemoizedSnapshot: invalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;







function getRecoilValueAsLoadable(store, {
  key
}, treeState = store.getState().currentTree) {
  var _storeState$nextTree, _storeState$previousT;

  // Reading from an older tree can cause bugs because the dependencies that we
  // discover during the read are lost.
  const storeState = store.getState();

  if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation('Tried to read from a discarded tree');
  }

  const loadable = getNodeLoadable$1(store, treeState, key);

  if (loadable.state === 'loading') {
    loadable.contents.catch(() => {
      /**
       * HACK: intercept thrown error here to prevent an uncaught promise exception. Ideally this would happen closer to selector
       * execution (perhaps introducing a new ERROR class to be resolved by async selectors that are in an error state)
       */
      return;
    });
  }

  return loadable;
}

function applyAtomValueWrites(atomValues, writes) {
  const result = atomValues.clone();
  writes.forEach((v, k) => {
    if (v.state === 'hasValue' && v.contents instanceof DefaultValue$1) {
      result.delete(k);
    } else {
      result.set(k, v);
    }
  });
  return result;
}

function valueFromValueOrUpdater(store, state, {
  key
}, valueOrUpdater) {
  if (typeof valueOrUpdater === 'function') {
    // Updater form: pass in the current value. Throw if the current value
    // is unavailable (namely when updating an async selector that's
    // pending or errored):
    const current = getNodeLoadable$1(store, state, key);

    if (current.state === 'loading') {
      const msg = `Tried to set atom or selector "${key}" using an updater function while the current state is pending, this is not currently supported.`;
      Recoil_recoverableViolation(msg);
      throw Recoil_err(msg);
    } else if (current.state === 'hasError') {
      throw current.contents;
    } // T itself may be a function, so our refinement is not sufficient:


    return valueOrUpdater(current.contents); // flowlint-line unclear-type:off
  } else {
    return valueOrUpdater;
  }
}

function applyAction(store, state, action) {
  if (action.type === 'set') {
    const {
      recoilValue,
      valueOrUpdater
    } = action;
    const newValue = valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
    const writes = setNodeValue$1(store, state, recoilValue.key, newValue);

    for (const [key, loadable] of writes.entries()) {
      writeLoadableToTreeState(state, key, loadable);
    }
  } else if (action.type === 'setLoadable') {
    const {
      recoilValue: {
        key
      },
      loadable
    } = action;
    writeLoadableToTreeState(state, key, loadable);
  } else if (action.type === 'markModified') {
    const {
      recoilValue: {
        key
      }
    } = action;
    state.dirtyAtoms.add(key);
  } else if (action.type === 'setUnvalidated') {
    var _node$invalidate;

    // Write value directly to state bypassing the Node interface as the node
    // definitions may not have been loaded yet when processing the initial snapshot.
    const {
      recoilValue: {
        key
      },
      unvalidatedValue
    } = action;
    const node = getNodeMaybe$2(key);
    node === null || node === void 0 ? void 0 : (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node, state);
    state.atomValues.delete(key);
    state.nonvalidatedAtoms.set(key, unvalidatedValue);
    state.dirtyAtoms.add(key);
  } else {
    Recoil_recoverableViolation(`Unknown action ${action.type}`);
  }
}

function writeLoadableToTreeState(state, key, loadable) {
  if (loadable.state === 'hasValue' && loadable.contents instanceof DefaultValue$1) {
    state.atomValues.delete(key);
  } else {
    state.atomValues.set(key, loadable);
  }

  state.dirtyAtoms.add(key);
  state.nonvalidatedAtoms.delete(key);
}

function applyActionsToStore(store, actions) {
  store.replaceState(state => {
    const newState = copyTreeState(state);

    for (const action of actions) {
      applyAction(store, newState, action);
    }

    invalidateDownstreams(store, newState);
    invalidateMemoizedSnapshot$1();
    return newState;
  });
}

function queueOrPerformStateUpdate(store, action) {
  if (batchStack.length) {
    const actionsByStore = batchStack[batchStack.length - 1];
    let actions = actionsByStore.get(store);

    if (!actions) {
      actionsByStore.set(store, actions = []);
    }

    actions.push(action);
  } else {
    applyActionsToStore(store, [action]);
  }
}

const batchStack = [];

function batchStart() {
  const actionsByStore = new Map();
  batchStack.push(actionsByStore);
  return () => {
    for (const [store, actions] of actionsByStore) {
      applyActionsToStore(store, actions);
    }

    const popped = batchStack.pop();

    if (popped !== actionsByStore) {
      Recoil_recoverableViolation('Incorrect order of batch popping');
    }
  };
}

function copyTreeState(state) {
  return { ...state,
    atomValues: state.atomValues.clone(),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
    dirtyAtoms: new Set(state.dirtyAtoms)
  };
}

function invalidateDownstreams(store, state) {
  // Inform any nodes that were changed or downstream of changes so that they
  // can clear out any caches as needed due to the update:
  const downstreams = getDownstreamNodes$1(store, state, state.dirtyAtoms);

  for (const key of downstreams) {
    var _getNodeMaybe, _getNodeMaybe$invalid;

    (_getNodeMaybe = getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 ? void 0 : (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 ? void 0 : _getNodeMaybe$invalid.call(_getNodeMaybe, state);
  }
}

function setRecoilValue(store, recoilValue, valueOrUpdater) {
  queueOrPerformStateUpdate(store, {
    type: 'set',
    recoilValue,
    valueOrUpdater
  });
}

function setRecoilValueLoadable(store, recoilValue, loadable) {
  if (loadable instanceof DefaultValue$1) {
    return setRecoilValue(store, recoilValue, loadable);
  }

  queueOrPerformStateUpdate(store, {
    type: 'setLoadable',
    recoilValue,
    loadable: loadable
  });
}

function markRecoilValueModified(store, recoilValue) {
  queueOrPerformStateUpdate(store, {
    type: 'markModified',
    recoilValue
  });
}

function setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
  queueOrPerformStateUpdate(store, {
    type: 'setUnvalidated',
    recoilValue,
    unvalidatedValue
  });
}

function subscribeToRecoilValue(store, {
  key
}, callback, componentDebugName = null) {
  const subID = getNextComponentID$1();
  const storeState = store.getState();

  if (!storeState.nodeToComponentSubscriptions.has(key)) {
    storeState.nodeToComponentSubscriptions.set(key, new Map());
  }

  Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : '<not captured>', callback]); // Handle the case that, during the same tick that we are subscribing, an atom
  // has been updated by some effect handler. Otherwise we will miss the update.

  const mode = reactMode$1();

  if (mode.early && (mode.mode === 'LEGACY' || mode.mode === 'MUTABLE_SOURCE')) {
    const nextTree = store.getState().nextTree;

    if (nextTree && nextTree.dirtyAtoms.has(key)) {
      callback(nextTree);
    }
  }

  return {
    release: () => {
      const releaseStoreState = store.getState();
      const subs = releaseStoreState.nodeToComponentSubscriptions.get(key);

      if (subs === undefined || !subs.has(subID)) {
        Recoil_recoverableViolation(`Subscription missing at release time for atom ${key}. This is a bug in Recoil.`);
        return;
      }

      subs.delete(subID);

      if (subs.size === 0) {
        releaseStoreState.nodeToComponentSubscriptions.delete(key);
      }
    }
  };
}

function refreshRecoilValue(store, recoilValue) {
  var _node$clearCache;

  const {
    currentTree
  } = store.getState();
  const node = getNode$2(recoilValue.key);
  (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node, store, currentTree);
}

var Recoil_RecoilValueInterface = {
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  getRecoilValueAsLoadable,
  setRecoilValue,
  setRecoilValueLoadable,
  markRecoilValueModified,
  setUnvalidatedRecoilValue,
  subscribeToRecoilValue,
  isRecoilValue: isRecoilValue$1,
  applyAtomValueWrites,
  // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
  batchStart,
  writeLoadableToTreeState,
  invalidateDownstreams,
  copyTreeState,
  refreshRecoilValue
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * The someSet() method tests whether some elements in the given Set pass the
 * test implemented by the provided function.
 */

function someSet(set, callback, context) {
  const iterator = set.entries();
  let current = iterator.next();

  while (!current.done) {
    const entry = current.value;

    if (callback.call(context, entry[1], entry[0], set)) {
      return true;
    }

    current = iterator.next();
  }

  return false;
}

var Recoil_someSet = someSet;

const {
  cleanUpNode: cleanUpNode$1
} = Recoil_FunctionalCore;

const {
  deleteNodeConfigIfPossible: deleteNodeConfigIfPossible$1,
  getNode: getNode$3
} = Recoil_Node;

const {
  RetentionZone: RetentionZone$2
} = Recoil_RetentionZone;







 // Components that aren't mounted after suspending for this long will be assumed
// to be discarded and their resources released.


const SUSPENSE_TIMEOUT_MS = 120000;
const emptySet$1 = new Set();

function releaseRetainablesNowOnCurrentTree(store, retainables) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;

  if (storeState.nextTree) {
    Recoil_recoverableViolation('releaseNodesNowOnCurrentTree should only be called at the end of a batch');
    return; // leak memory rather than erase something that's about to be used.
  }

  const nodes = new Set();

  for (const r of retainables) {
    if (r instanceof RetentionZone$2) {
      for (const n of nodesRetainedByZone(storeState, r)) {
        nodes.add(n);
      }
    } else {
      nodes.add(r);
    }
  }

  const releasableNodes = findReleasableNodes(store, nodes);

  for (const node of releasableNodes) {
    releaseNode(store, treeState, node);
  }
}

function findReleasableNodes(store, searchFromNodes) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;
  const graph = store.getGraph(treeState.version);
  const releasableNodes = new Set(); // mutated to collect answer

  const nonReleasableNodes = new Set();
  findReleasableNodesInner(searchFromNodes);
  return releasableNodes;

  function findReleasableNodesInner(searchFromNodes) {
    const releasableNodesFoundThisIteration = new Set();
    const downstreams = getDownstreamNodesInTopologicalOrder(store, treeState, searchFromNodes, releasableNodes, // don't descend into these
    nonReleasableNodes // don't descend into these
    ); // Find which of the downstream nodes are releasable and which are not:

    for (const node of downstreams) {
      var _storeState$retention;

      // Not releasable if configured to be retained forever:
      if (getNode$3(node).retainedBy === 'recoilRoot') {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if retained directly by a component:


      if (((_storeState$retention = storeState.retention.referenceCounts.get(node)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if retained by a zone:


      if (zonesThatCouldRetainNode(node).some(z => storeState.retention.referenceCounts.get(z))) {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if it has a non-releasable child (which will already be in
      // nonReleasableNodes because we are going in topological order):


      const nodeChildren = graph.nodeToNodeSubscriptions.get(node);

      if (nodeChildren && Recoil_someSet(nodeChildren, child => nonReleasableNodes.has(child))) {
        nonReleasableNodes.add(node);
        continue;
      }

      releasableNodes.add(node);
      releasableNodesFoundThisIteration.add(node);
    } // If we found any releasable nodes, we need to walk UP from those nodes to
    // find whether their parents can now be released as well:


    const parents = new Set();

    for (const node of releasableNodesFoundThisIteration) {
      for (const parent of (_graph$nodeDeps$get = graph.nodeDeps.get(node)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : emptySet$1) {
        var _graph$nodeDeps$get;

        if (!releasableNodes.has(parent)) {
          parents.add(parent);
        }
      }
    }

    if (parents.size) {
      findReleasableNodesInner(parents);
    }
  }
} // Children before parents


function getDownstreamNodesInTopologicalOrder(store, treeState, nodes, // Mutable set is destroyed in place
doNotDescendInto1, doNotDescendInto2) {
  const graph = store.getGraph(treeState.version);
  const answer = [];
  const visited = new Set();

  while (nodes.size > 0) {
    visit(Recoil_nullthrows(nodes.values().next().value));
  }

  return answer;

  function visit(node) {
    if (doNotDescendInto1.has(node) || doNotDescendInto2.has(node)) {
      nodes.delete(node);
      return;
    }

    if (visited.has(node)) {
      return;
    }

    const children = graph.nodeToNodeSubscriptions.get(node);

    if (children) {
      for (const child of children) {
        visit(child);
      }
    }

    visited.add(node);
    nodes.delete(node);
    answer.push(node);
  }
}

function releaseNode(store, treeState, node) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  } // Atom effects, in-closure caches, etc.:


  cleanUpNode$1(store, node); // Delete from store state:

  const storeState = store.getState();
  storeState.knownAtoms.delete(node);
  storeState.knownSelectors.delete(node);
  storeState.nodeTransactionSubscriptions.delete(node);
  storeState.retention.referenceCounts.delete(node);
  const zones = zonesThatCouldRetainNode(node);

  for (const zone of zones) {
    var _storeState$retention2;

    (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 ? void 0 : _storeState$retention2.delete(node);
  } // Note that we DO NOT delete from nodeToComponentSubscriptions because this
  // already happens when the last component that was retaining the node unmounts,
  // and this could happen either before or after that.
  // Delete from TreeState and dep graph:


  treeState.atomValues.delete(node);
  treeState.dirtyAtoms.delete(node);
  treeState.nonvalidatedAtoms.delete(node);
  const graph = storeState.graphsByVersion.get(treeState.version);

  if (graph) {
    const deps = graph.nodeDeps.get(node);

    if (deps !== undefined) {
      graph.nodeDeps.delete(node);

      for (const dep of deps) {
        var _graph$nodeToNodeSubs;

        (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 ? void 0 : _graph$nodeToNodeSubs.delete(node);
      }
    } // No need to delete sub's deps as there should be no subs at this point.
    // But an invariant would require deleting nodes in topological order.


    graph.nodeToNodeSubscriptions.delete(node);
  } // Node config (for family members only as their configs can be recreated, and
  // only if they are not retained within any other Stores):


  deleteNodeConfigIfPossible$1(node);
}

function nodesRetainedByZone(storeState, zone) {
  var _storeState$retention3;

  return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : emptySet$1;
}

function zonesThatCouldRetainNode(node) {
  const retainedBy = getNode$3(node).retainedBy;

  if (retainedBy === undefined || retainedBy === 'components' || retainedBy === 'recoilRoot') {
    return [];
  } else if (retainedBy instanceof RetentionZone$2) {
    return [retainedBy];
  } else {
    return retainedBy; // it's an array of zones
  }
}

function scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
  const state = store.getState();

  if (state.nextTree) {
    state.retention.retainablesToCheckForRelease.add(retainable);
  } else {
    releaseRetainablesNowOnCurrentTree(store, new Set([retainable]));
  }
}

function updateRetainCount(store, retainable, delta) {
  var _map$get;

  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const map = store.getState().retention.referenceCounts;
  const newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;

  if (newCount === 0) {
    updateRetainCountToZero(store, retainable);
  } else {
    map.set(retainable, newCount);
  }
}

function updateRetainCountToZero(store, retainable) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const map = store.getState().retention.referenceCounts;
  map.delete(retainable);
  scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}

function releaseScheduledRetainablesNow(store) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const state = store.getState();
  releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
  state.retention.retainablesToCheckForRelease.clear();
}

function retainedByOptionWithDefault(r) {
  // The default will change from 'recoilRoot' to 'components' in the future.
  return r === undefined ? 'recoilRoot' : r;
}

var Recoil_Retention = {
  SUSPENSE_TIMEOUT_MS,
  updateRetainCount,
  updateRetainCountToZero,
  releaseScheduledRetainablesNow,
  retainedByOptionWithDefault
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */
const {
  unstable_batchedUpdates
} = react_dom__WEBPACK_IMPORTED_MODULE_1__;

var ReactBatchedUpdates = {
  unstable_batchedUpdates
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */
// @fb-only: const {unstable_batchedUpdates} = require('ReactDOMComet');
// prettier-ignore
const {
  unstable_batchedUpdates: unstable_batchedUpdates$1
} = ReactBatchedUpdates; // @oss-only


var Recoil_ReactBatchedUpdates = {
  unstable_batchedUpdates: unstable_batchedUpdates$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
const {
  batchStart: batchStart$1
} = Recoil_RecoilValueInterface;

const {
  unstable_batchedUpdates: unstable_batchedUpdates$2
} = Recoil_ReactBatchedUpdates; // flowlint-next-line unclear-type:off


/*
 * During SSR, unstable_batchedUpdates may be undefined so this
 * falls back to a basic function that executes the batch
 */
let batcher = unstable_batchedUpdates$2 || (batchFn => batchFn());
/**
 * Sets the provided batcher function as the batcher function used by Recoil.
 *
 * Set the batcher to a custom batcher for your renderer,
 * if you use a renderer other than React DOM or React Native.
 */


const setBatcher = newBatcher => {
  batcher = newBatcher;
};
/**
 * Returns the current batcher function.
 */


const getBatcher = () => batcher;
/**
 * Calls the current batcher function and passes the
 * provided callback function.
 */


const batchUpdates = callback => {
  batcher(() => {
    let batchEnd = () => undefined;

    try {
      batchEnd = batchStart$1();
      callback();
    } finally {
      batchEnd();
    }
  });
};

var Recoil_Batching = {
  getBatcher,
  setBatcher,
  batchUpdates
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Combines multiple Iterables into a single Iterable.
 * Traverses the input Iterables in the order provided and maintains the order
 * of their elements.
 *
 * Example:
 * ```
 * const r = Array.from(concatIterables(['a', 'b'], ['c'], ['d', 'e', 'f']));
 * r == ['a', 'b', 'c', 'd', 'e', 'f'];
 * ```
 */

function* concatIterables(iters) {
  for (const iter of iters) {
    for (const val of iter) {
      yield val;
    }
  }
}

var Recoil_concatIterables = concatIterables;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/* eslint-disable fb-www/typeof-undefined */

const isSSR = // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
typeof Window === 'undefined' || typeof window === 'undefined';
/* eslint-enable fb-www/typeof-undefined */

const isWindow = value => !isSSR && ( // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
value === window || value instanceof Window);

const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative'; // eslint-disable-line fb-www/typeof-undefined

var Recoil_Environment = {
  isSSR,
  isReactNative,
  isWindow
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Caches a function's results based on the key returned by the passed
 * hashFunction.
 */

function memoizeWithArgsHash(fn, hashFunction) {
  let cache;
  return (...args) => {
    if (!cache) {
      cache = {};
    }

    const key = hashFunction(...args);

    if (!Object.hasOwnProperty.call(cache, key)) {
      cache[key] = fn(...args);
    }

    return cache[key];
  };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */


function memoizeOneWithArgsHash(fn, hashFunction) {
  let lastKey;
  let lastResult; // breaking cache when arguments change

  return (...args) => {
    const key = hashFunction(...args);

    if (lastKey === key) {
      return lastResult;
    }

    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */


function memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
  let lastKey;
  let lastResult; // breaking cache when arguments change

  const memoizedFn = (...args) => {
    const key = hashFunction(...args);

    if (lastKey === key) {
      return lastResult;
    }

    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };

  const invalidate = () => {
    lastKey = null;
  };

  return [memoizedFn, invalidate];
}

var Recoil_Memoize = {
  memoizeWithArgsHash,
  memoizeOneWithArgsHash,
  memoizeOneWithArgsHashAndInvalidation
};

const {
  batchUpdates: batchUpdates$1
} = Recoil_Batching;

const {
  initializeNode: initializeNode$1,
  peekNodeInfo: peekNodeInfo$1
} = Recoil_FunctionalCore;

const {
  graph: graph$1
} = Recoil_Graph;

const {
  getNextStoreID: getNextStoreID$1
} = Recoil_Keys;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$1,
  recoilValues: recoilValues$1,
  recoilValuesForKeys: recoilValuesForKeys$2
} = Recoil_Node;

const {
  AbstractRecoilValue: AbstractRecoilValue$2,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$1,
  setRecoilValue: setRecoilValue$1,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$1
} = Recoil_RecoilValueInterface;

const {
  updateRetainCount: updateRetainCount$1
} = Recoil_Retention;

const {
  setInvalidateMemoizedSnapshot: setInvalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;

const {
  getNextTreeStateVersion: getNextTreeStateVersion$2,
  makeEmptyStoreState: makeEmptyStoreState$1
} = Recoil_State;



const {
  isSSR: isSSR$1
} = Recoil_Environment;









const {
  memoizeOneWithArgsHashAndInvalidation: memoizeOneWithArgsHashAndInvalidation$1
} = Recoil_Memoize;



 // Opaque at this surface because it's part of the public API from here.


const retainWarning = (/* unused pure expression or super */ null && (`
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`)); // A "Snapshot" is "read-only" and captures a specific set of values of atoms.
// However, the data-flow-graph and selector values may evolve as selector
// evaluation functions are executed and async selectors resolve.

class Snapshot {
  // eslint-disable-next-line fb-www/no-uninitialized-properties
  constructor(storeState, parentStoreID) {
    _defineProperty(this, "_store", void 0);

    _defineProperty(this, "_refCount", 1);

    _defineProperty(this, "getLoadable", recoilValue => {
      this.checkRefCount_INTERNAL();
      return getRecoilValueAsLoadable$1(this._store, recoilValue);
    });

    _defineProperty(this, "getPromise", recoilValue => {
      this.checkRefCount_INTERNAL();
      return this.getLoadable(recoilValue).toPromise();
    });

    _defineProperty(this, "getNodes_UNSTABLE", opt => {
      this.checkRefCount_INTERNAL(); // TODO Deal with modified selectors

      if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
        if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) {
          return [];
        }

        const state = this._store.getState().currentTree;

        return recoilValuesForKeys$2(state.dirtyAtoms);
      }

      const knownAtoms = this._store.getState().knownAtoms;

      const knownSelectors = this._store.getState().knownSelectors;

      return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? recoilValues$1.values() : opt.isInitialized === true ? recoilValuesForKeys$2(Recoil_concatIterables([knownAtoms, knownSelectors])) : Recoil_filterIterable(recoilValues$1.values(), ({
        key
      }) => !knownAtoms.has(key) && !knownSelectors.has(key));
    });

    _defineProperty(this, "getInfo_UNSTABLE", ({
      key
    }) => {
      this.checkRefCount_INTERNAL();
      return peekNodeInfo$1(this._store, this._store.getState().currentTree, key);
    });

    _defineProperty(this, "map", mapper => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mapper(mutableSnapshot); // if removing batchUpdates from `set` add it here

      return mutableSnapshot;
    });

    _defineProperty(this, "asyncMap", async mapper => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mutableSnapshot.retain(); // Retain new snapshot during async mapper

      await mapper(mutableSnapshot); // Continue to retain the new snapshot for the user, but auto-release it
      // after the next tick, the same as a new synchronous snapshot.

      mutableSnapshot.autoRelease_INTERNAL();
      return mutableSnapshot;
    });

    this._store = {
      storeID: getNextStoreID$1(),
      parentStoreID,
      getState: () => storeState,
      replaceState: replacer => {
        // no batching, so nextTree is never active
        storeState.currentTree = replacer(storeState.currentTree);
      },
      getGraph: version => {
        const graphs = storeState.graphsByVersion;

        if (graphs.has(version)) {
          return Recoil_nullthrows(graphs.get(version));
        }

        const newGraph = graph$1();
        graphs.set(version, newGraph);
        return newGraph;
      },
      subscribeToTransactions: () => ({
        release: () => {}
      }),
      addTransactionMetadata: () => {
        throw Recoil_err('Cannot subscribe to Snapshots');
      }
    }; // Initialize any nodes that are live in the parent store (primarily so that
    // this snapshot gets counted towards the node's live stores count).
    // TODO Optimize this when cloning snapshots for callbacks

    for (const nodeKey of this._store.getState().knownAtoms) {
      initializeNode$1(this._store, nodeKey, 'get');
      updateRetainCount$1(this._store, nodeKey, 1);
    }

    this.autoRelease_INTERNAL();
  }

  retain() {
    if (this._refCount <= 0) {
      if (false) {} else {
        Recoil_recoverableViolation('Attempt to retain() Snapshot that was already released.');
      }
    }

    this._refCount++;
    let released = false;
    return () => {
      if (!released) {
        released = true;

        this._release();
      }
    };
  }
  /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */


  autoRelease_INTERNAL() {
    if (!isSSR$1) {
      // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
      window.setTimeout(() => this._release(), 10);
    }
  }

  _release() {
    this._refCount--;

    if (this._refCount === 0) {
      this._store.getState().nodeCleanupFunctions.forEach(cleanup => cleanup());

      this._store.getState().nodeCleanupFunctions.clear();

      if (!Recoil_gkx('recoil_memory_managament_2020')) {
        return;
      } // Temporarily nerfing this to allow us to find broken call sites without
      // actually breaking anybody yet.
      // for (const k of this._store.getState().knownAtoms) {
      //   updateRetainCountToZero(this._store, k);
      // }

    } else if (this._refCount < 0) {
      if (false) {}
    }
  }

  isRetained() {
    return this._refCount > 0;
  }

  checkRefCount_INTERNAL() {
    if (Recoil_gkx('recoil_memory_managament_2020') && this._refCount <= 0) {
      if (false) {} // What we will ship later:
      // throw err(retainWarning);

    }
  }

  getStore_INTERNAL() {
    this.checkRefCount_INTERNAL();
    return this._store;
  }

  getID() {
    this.checkRefCount_INTERNAL();
    return this._store.getState().currentTree.stateID;
  }

  getStoreID() {
    this.checkRefCount_INTERNAL();
    return this._store.storeID;
  } // We want to allow the methods to be destructured and used as accessors

  /* eslint-disable fb-www/extra-arrow-initializer */

  /* eslint-enable fb-www/extra-arrow-initializer */


}

function cloneStoreState(store, treeState, bumpVersion = false) {
  const storeState = store.getState();
  const version = bumpVersion ? getNextTreeStateVersion$2() : treeState.version;
  return {
    // Always clone the TreeState to isolate stores from accidental mutations.
    // For example, reading a selector from a cloned snapshot shouldn't cache
    // in the original treestate which may cause the original to skip
    // initialization of upstream atoms.
    currentTree: {
      // TODO snapshots shouldn't really have versions because a new version number
      // is always assigned when the snapshot is gone to.
      version: bumpVersion ? version : treeState.version,
      stateID: bumpVersion ? version : treeState.stateID,
      transactionMetadata: { ...treeState.transactionMetadata
      },
      dirtyAtoms: new Set(treeState.dirtyAtoms),
      atomValues: treeState.atomValues.clone(),
      nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
    },
    commitDepth: 0,
    nextTree: null,
    previousTree: null,
    knownAtoms: new Set(storeState.knownAtoms),
    // FIXME here's a copy
    knownSelectors: new Set(storeState.knownSelectors),
    // FIXME here's a copy
    transactionSubscriptions: new Map(),
    nodeTransactionSubscriptions: new Map(),
    nodeToComponentSubscriptions: new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: new Set(),
    graphsByVersion: new Map().set(version, store.getGraph(treeState.version)),
    retention: {
      referenceCounts: new Map(),
      nodesRetainedByZone: new Map(),
      retainablesToCheckForRelease: new Set()
    },
    // FIXME here's a copy
    // Create blank cleanup handlers for atoms so snapshots don't re-run
    // atom effects.
    nodeCleanupFunctions: new Map(Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), ([key]) => [key, () => {}]))
  };
} // Factory to build a fresh snapshot


function freshSnapshot(initializeState) {
  const snapshot = new Snapshot(makeEmptyStoreState$1());
  return initializeState != null ? snapshot.map(initializeState) : snapshot;
} // Factory to clone a snapshot state


const [memoizedCloneSnapshot, invalidateMemoizedSnapshot$2] = memoizeOneWithArgsHashAndInvalidation$1( // $FlowFixMe[missing-local-annot]
(store, version) => {
  var _storeState$nextTree;

  const storeState = store.getState();
  const treeState = version === 'latest' ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : Recoil_nullthrows(storeState.previousTree);
  return new Snapshot(cloneStoreState(store, treeState), store.storeID);
}, (store, version) => {
  var _store$getState$nextT, _store$getState$previ;

  return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
}); // Avoid circular dependencies

setInvalidateMemoizedSnapshot$1(invalidateMemoizedSnapshot$2);

function cloneSnapshot(store, version = 'latest') {
  const snapshot = memoizedCloneSnapshot(store, version);

  if (!snapshot.isRetained()) {
    invalidateMemoizedSnapshot$2();
    return memoizedCloneSnapshot(store, version);
  }

  return snapshot;
}

class MutableSnapshot extends Snapshot {
  constructor(snapshot, batch) {
    super(cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true), snapshot.getStoreID());

    _defineProperty(this, "_batch", void 0);

    _defineProperty(this, "set", (recoilState, newValueOrUpdater) => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // This batchUpdates ensures this `set` is applied immediately and you can
      // read the written value after calling `set`. I would like to remove this
      // behavior and only batch in `Snapshot.map`, but this would be a breaking
      // change potentially.

      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
      });
    });

    _defineProperty(this, "reset", recoilState => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.

      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, DEFAULT_VALUE$1);
      });
    });

    _defineProperty(this, "setUnvalidatedAtomValues_DEPRECATED", values => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.

      batchUpdates$1(() => {
        for (const [k, v] of values.entries()) {
          updateRetainCount$1(store, k, 1);
          setUnvalidatedRecoilValue$1(store, new AbstractRecoilValue$2(k), v);
        }
      });
    });

    this._batch = batch;
  }

}

var Recoil_Snapshot = {
  Snapshot,
  MutableSnapshot,
  freshSnapshot,
  cloneSnapshot
};

var Recoil_Snapshot_1 = Recoil_Snapshot.Snapshot;
var Recoil_Snapshot_2 = Recoil_Snapshot.MutableSnapshot;
var Recoil_Snapshot_3 = Recoil_Snapshot.freshSnapshot;
var Recoil_Snapshot_4 = Recoil_Snapshot.cloneSnapshot;

var Recoil_Snapshot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Snapshot: Recoil_Snapshot_1,
  MutableSnapshot: Recoil_Snapshot_2,
  freshSnapshot: Recoil_Snapshot_3,
  cloneSnapshot: Recoil_Snapshot_4
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function unionSets(...sets) {
  const result = new Set();

  for (const set of sets) {
    for (const value of set) {
      result.add(value);
    }
  }

  return result;
}

var Recoil_unionSets = unionSets;

const {
  useRef
} = react__WEBPACK_IMPORTED_MODULE_0__;
/**
 * The same as `useRef()` except that if a function is specified then it will
 * call that function to get the value to initialize the reference with.
 * This is similar to how `useState()` behaves when given a function.  It allows
 * the user to avoid generating the initial value for subsequent renders.
 * The tradeoff is that to set the reference to a function itself you need to
 * nest it: useRefInitOnce(() => () => {...});
 */


function useRefInitOnce(initialValue) {
  // $FlowExpectedError[incompatible-call]
  const ref = useRef(initialValue);

  if (ref.current === initialValue && typeof initialValue === 'function') {
    // $FlowExpectedError[incompatible-use]
    ref.current = initialValue();
  }

  return ref;
}

var Recoil_useRefInitOnce = useRefInitOnce;

// @fb-only: const RecoilusagelogEvent = require('RecoilusagelogEvent');
// @fb-only: const RecoilUsageLogFalcoEvent = require('RecoilUsageLogFalcoEvent');
// @fb-only: const URI = require('URI');


const {
  getNextTreeStateVersion: getNextTreeStateVersion$3,
  makeEmptyStoreState: makeEmptyStoreState$2
} = Recoil_State;

const {
  cleanUpNode: cleanUpNode$2,
  getDownstreamNodes: getDownstreamNodes$2,
  initializeNode: initializeNode$2,
  setNodeValue: setNodeValue$2,
  setUnvalidatedAtomValue_DEPRECATED: setUnvalidatedAtomValue_DEPRECATED$1
} = Recoil_FunctionalCore;

const {
  graph: graph$2
} = Recoil_Graph;

const {
  cloneGraph: cloneGraph$1
} = Recoil_Graph;

const {
  getNextStoreID: getNextStoreID$2
} = Recoil_Keys;

const {
  createMutableSource: createMutableSource$1,
  reactMode: reactMode$2
} = Recoil_ReactMode;

const {
  applyAtomValueWrites: applyAtomValueWrites$1
} = Recoil_RecoilValueInterface;

const {
  releaseScheduledRetainablesNow: releaseScheduledRetainablesNow$1
} = Recoil_Retention;

const {
  freshSnapshot: freshSnapshot$1
} = Recoil_Snapshot$1;



const {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef: useRef$1,
  useState
} = react__WEBPACK_IMPORTED_MODULE_0__;















function notInAContext() {
  throw Recoil_err('This component must be used inside a <RecoilRoot> component.');
}

const defaultStore = Object.freeze({
  storeID: getNextStoreID$2(),
  getState: notInAContext,
  replaceState: notInAContext,
  getGraph: notInAContext,
  subscribeToTransactions: notInAContext,
  addTransactionMetadata: notInAContext
});
let stateReplacerIsBeingExecuted = false;

function startNextTreeIfNeeded(store) {
  if (stateReplacerIsBeingExecuted) {
    throw Recoil_err('An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.');
  }

  const storeState = store.getState();

  if (storeState.nextTree === null) {
    if (Recoil_gkx('recoil_memory_managament_2020') && Recoil_gkx('recoil_release_on_cascading_update_killswitch_2021')) {
      // If this is a cascading update (that is, rendering due to one state change
      // invokes a second state change), we won't have cleaned up retainables yet
      // because this normally happens after notifying components. Do it before
      // proceeding with the cascading update so that it remains predictable:
      if (storeState.commitDepth > 0) {
        releaseScheduledRetainablesNow$1(store);
      }
    }

    const version = storeState.currentTree.version;
    const nextVersion = getNextTreeStateVersion$3();
    storeState.nextTree = { ...storeState.currentTree,
      version: nextVersion,
      stateID: nextVersion,
      dirtyAtoms: new Set(),
      transactionMetadata: {}
    };
    storeState.graphsByVersion.set(nextVersion, cloneGraph$1(Recoil_nullthrows(storeState.graphsByVersion.get(version))));
  }
}

const AppContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  current: defaultStore
});

const useStoreRef = () => useContext(AppContext); // $FlowExpectedError[incompatible-call]


const MutableSourceContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

function useRecoilMutableSource() {
  const mutableSource = useContext(MutableSourceContext);

  if (mutableSource == null) {
    Recoil_expectationViolation('Attempted to use a Recoil hook outside of a <RecoilRoot>. ' + '<RecoilRoot> must be an ancestor of any component that uses ' + 'Recoil hooks.');
  }

  return mutableSource;
}

function notifyComponents(store, storeState, treeState) {
  const dependentNodes = getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);

  for (const key of dependentNodes) {
    const comps = storeState.nodeToComponentSubscriptions.get(key);

    if (comps) {
      for (const [_subID, [_debugName, callback]] of comps) {
        callback(treeState);
      }
    }
  }
}

function sendEndOfBatchNotifications(store) {
  const storeState = store.getState();
  const treeState = storeState.currentTree; // Inform transaction subscribers of the transaction:

  const dirtyAtoms = treeState.dirtyAtoms;

  if (dirtyAtoms.size) {
    // Execute Node-specific subscribers before global subscribers
    for (const [key, subscriptions] of storeState.nodeTransactionSubscriptions) {
      if (dirtyAtoms.has(key)) {
        for (const [_, subscription] of subscriptions) {
          subscription(store);
        }
      }
    }

    for (const [_, subscription] of storeState.transactionSubscriptions) {
      subscription(store);
    }

    if (!reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
      // Notifying components is needed to wake from suspense, even when using
      // early rendering.
      notifyComponents(store, storeState, treeState); // Wake all suspended components so the right one(s) can try to re-render.
      // We need to wake up components not just when some asynchronous selector
      // resolved, but also when changing synchronous values because this may cause
      // a selector to change from asynchronous to synchronous, in which case there
      // would be no follow-up asynchronous resolution to wake us up.
      // TODO OPTIMIZATION Only wake up related downstream components

      storeState.suspendedComponentResolvers.forEach(cb => cb());
      storeState.suspendedComponentResolvers.clear();
    }
  } // Special behavior ONLY invoked by useInterface.
  // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.


  storeState.queuedComponentCallbacks_DEPRECATED.forEach(cb => cb(treeState));
  storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}

function endBatch(store) {
  const storeState = store.getState();
  storeState.commitDepth++;

  try {
    const {
      nextTree
    } = storeState; // Ignore commits that are not because of Recoil transactions -- namely,
    // because something above RecoilRoot re-rendered:

    if (nextTree == null) {
      return;
    } // nextTree is now committed -- note that copying and reset occurs when
    // a transaction begins, in startNextTreeIfNeeded:


    storeState.previousTree = storeState.currentTree;
    storeState.currentTree = nextTree;
    storeState.nextTree = null;
    sendEndOfBatchNotifications(store);

    if (storeState.previousTree != null) {
      storeState.graphsByVersion.delete(storeState.previousTree.version);
    } else {
      Recoil_recoverableViolation('Ended batch with no previous state, which is unexpected', 'recoil');
    }

    storeState.previousTree = null;

    if (Recoil_gkx('recoil_memory_managament_2020')) {
      // Only release retainables if there were no writes during the end of the
      // batch.  This avoids releasing something we might be about to use.
      if (nextTree == null) {
        releaseScheduledRetainablesNow$1(store);
      }
    }
  } finally {
    storeState.commitDepth--;
  }
}
/*
 * The purpose of the Batcher is to observe when React batches end so that
 * Recoil state changes can be batched. Whenever Recoil state changes, we call
 * setState on the batcher. Then we wait for that change to be committed, which
 * signifies the end of the batch. That's when we respond to the Recoil change.
 */


function Batcher({
  setNotifyBatcherOfChange
}) {
  const storeRef = useStoreRef();
  const [, setState] = useState([]); // $FlowFixMe[incompatible-call]

  setNotifyBatcherOfChange(() => setState({}));
  useEffect(() => {
    // $FlowFixMe[incompatible-call]
    setNotifyBatcherOfChange(() => setState({})); // If an asynchronous selector resolves after the Batcher is unmounted,
    // notifyBatcherOfChange will still be called. An error gets thrown whenever
    // setState is called after a component is already unmounted, so this sets
    // notifyBatcherOfChange to be a no-op.

    return () => {
      setNotifyBatcherOfChange(() => {});
    };
  }, [setNotifyBatcherOfChange]);
  useEffect(() => {
    // enqueueExecution runs this function immediately; it is only used to
    // manipulate the order of useEffects during tests, since React seems to
    // call useEffect in an unpredictable order sometimes.
    Recoil_Queue.enqueueExecution('Batcher', () => {
      endBatch(storeRef.current);
    });
  });
  return null;
}

if (false) {} // When removing this deprecated function, remove stateBySettingRecoilValue
// which will no longer be needed.


function initialStoreState_DEPRECATED(store, initializeState) {
  const initial = makeEmptyStoreState$2();
  initializeState({
    set: (atom, value) => {
      const state = initial.currentTree;
      const writes = setNodeValue$2(store, state, atom.key, value);
      const writtenNodes = new Set(writes.keys());
      const nonvalidatedAtoms = state.nonvalidatedAtoms.clone();

      for (const n of writtenNodes) {
        nonvalidatedAtoms.delete(n);
      }

      initial.currentTree = { ...state,
        dirtyAtoms: Recoil_unionSets(state.dirtyAtoms, writtenNodes),
        atomValues: applyAtomValueWrites$1(state.atomValues, writes),
        // NB: PLEASE un-export applyAtomValueWrites when deleting this code
        nonvalidatedAtoms
      };
    },
    setUnvalidatedAtomValues: atomValues => {
      // FIXME replace this with a mutative loop
      atomValues.forEach((v, k) => {
        initial.currentTree = setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
      });
    }
  });
  return initial;
} // Initialize state snapshot for <RecoilRoot> for the initializeState prop.
// Atom effect initialization takes precedence over this prop.
// Any atom effects will be run before initialization, but then cleaned up,
// they are then re-run when used as part of rendering.  These semantics are
// compatible with React StrictMode where effects may be re-run multiple times
// but state initialization only happens once the first time.


function initialStoreState(initializeState) {
  // Initialize a snapshot and get its store
  const snapshot = freshSnapshot$1(initializeState);
  const storeState = snapshot.getStore_INTERNAL().getState(); // Counteract the snapshot auto-release

  snapshot.retain(); // Cleanup any effects run during initialization and clear the handlers so
  // they will re-initialize if used during rendering.  This allows atom effect
  // initialization to take precedence over initializeState and be compatible
  // with StrictMode semantics.

  storeState.nodeCleanupFunctions.forEach(cleanup => cleanup());
  storeState.nodeCleanupFunctions.clear();
  return storeState;
}

let nextID = 0;

function RecoilRoot_INTERNAL({
  initializeState_DEPRECATED,
  initializeState,
  store_INTERNAL: storeProp,
  // For use with React "context bridging"
  children
}) {
  // prettier-ignore
  // @fb-only: useEffect(() => {
  // @fb-only: if (gkx('recoil_usage_logging')) {
  // @fb-only: try {
  // @fb-only: RecoilUsageLogFalcoEvent.log(() => ({
  // @fb-only: type: RecoilusagelogEvent.RECOIL_ROOT_MOUNTED,
  // @fb-only: path: URI.getRequestURI().getPath(),
  // @fb-only: }));
  // @fb-only: } catch {
  // @fb-only: recoverableViolation(
  // @fb-only: 'Error when logging Recoil Usage event',
  // @fb-only: 'recoil',
  // @fb-only: );
  // @fb-only: }
  // @fb-only: }
  // @fb-only: }, []);
  let storeStateRef; // eslint-disable-line prefer-const

  const getGraph = version => {
    const graphs = storeStateRef.current.graphsByVersion;

    if (graphs.has(version)) {
      return Recoil_nullthrows(graphs.get(version));
    }

    const newGraph = graph$2();
    graphs.set(version, newGraph);
    return newGraph;
  };

  const subscribeToTransactions = (callback, key) => {
    if (key == null) {
      // Global transaction subscriptions
      const {
        transactionSubscriptions
      } = storeRef.current.getState();
      const id = nextID++;
      transactionSubscriptions.set(id, callback);
      return {
        release: () => {
          transactionSubscriptions.delete(id);
        }
      };
    } else {
      // Node-specific transaction subscriptions:
      const {
        nodeTransactionSubscriptions
      } = storeRef.current.getState();

      if (!nodeTransactionSubscriptions.has(key)) {
        nodeTransactionSubscriptions.set(key, new Map());
      }

      const id = nextID++;
      Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id, callback);
      return {
        release: () => {
          const subs = nodeTransactionSubscriptions.get(key);

          if (subs) {
            subs.delete(id);

            if (subs.size === 0) {
              nodeTransactionSubscriptions.delete(key);
            }
          }
        }
      };
    }
  };

  const addTransactionMetadata = metadata => {
    startNextTreeIfNeeded(storeRef.current);

    for (const k of Object.keys(metadata)) {
      Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
    }
  };

  const replaceState = replacer => {
    startNextTreeIfNeeded(storeRef.current); // Use replacer to get the next state:

    const nextTree = Recoil_nullthrows(storeStateRef.current.nextTree);
    let replaced;

    try {
      stateReplacerIsBeingExecuted = true;
      replaced = replacer(nextTree);
    } finally {
      stateReplacerIsBeingExecuted = false;
    }

    if (replaced === nextTree) {
      return;
    }

    if (false) {} // Save changes to nextTree and schedule a React update:


    storeStateRef.current.nextTree = replaced;

    if (reactMode$2().early) {
      notifyComponents(storeRef.current, storeStateRef.current, replaced);
    }

    Recoil_nullthrows(notifyBatcherOfChange.current)();
  };

  const notifyBatcherOfChange = useRef$1(null);
  const setNotifyBatcherOfChange = useCallback(x => {
    notifyBatcherOfChange.current = x;
  }, [notifyBatcherOfChange]);
  const storeRef = Recoil_useRefInitOnce(() => storeProp !== null && storeProp !== void 0 ? storeProp : {
    storeID: getNextStoreID$2(),
    getState: () => storeStateRef.current,
    replaceState,
    getGraph,
    subscribeToTransactions,
    addTransactionMetadata
  });

  if (storeProp != null) {
    storeRef.current = storeProp;
  }

  storeStateRef = Recoil_useRefInitOnce(() => initializeState_DEPRECATED != null ? initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? initialStoreState(initializeState) : makeEmptyStoreState$2());
  const mutableSource = useMemo(() => createMutableSource$1 === null || createMutableSource$1 === void 0 ? void 0 : createMutableSource$1(storeStateRef, () => storeStateRef.current.currentTree.version), [storeStateRef]); // Cleanup when the <RecoilRoot> is unmounted

  useEffect(() => {
    // React is free to call effect cleanup handlers and effects at will, the
    // deps array is only an optimization.  For example, React strict mode
    // will execute each effect twice for testing.  Therefore, we need symmetry
    // to re-initialize all known atoms after they were cleaned up.
    const store = storeRef.current;

    for (const atomKey of new Set(store.getState().knownAtoms)) {
      initializeNode$2(store, atomKey, 'get');
    }

    return () => {
      for (const atomKey of store.getState().knownAtoms) {
        cleanUpNode$2(store, atomKey);
      }
    };
  }, [storeRef]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppContext.Provider, {
    value: storeRef
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(MutableSourceContext.Provider, {
    value: mutableSource
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Batcher, {
    setNotifyBatcherOfChange: setNotifyBatcherOfChange
  }), children));
}

function RecoilRoot(props) {
  const {
    override,
    ...propsExceptOverride
  } = props;
  const ancestorStoreRef = useStoreRef();

  if (override === false && ancestorStoreRef.current !== defaultStore) {
    // If ancestorStoreRef.current !== defaultStore, it means that this
    // RecoilRoot is not nested within another.
    return props.children;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RecoilRoot_INTERNAL, propsExceptOverride);
}

function useRecoilStoreID() {
  return useStoreRef().current.storeID;
}

var Recoil_RecoilRoot = {
  RecoilRoot,
  useStoreRef,
  useRecoilMutableSource,
  useRecoilStoreID,
  notifyComponents_FOR_TESTING: notifyComponents,
  sendEndOfBatchNotifications_FOR_TESTING: sendEndOfBatchNotifications
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function shallowArrayEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0, l = a.length; i < l; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

var Recoil_shallowArrayEqual = shallowArrayEqual;

const {
  useEffect: useEffect$1,
  useRef: useRef$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

function usePrevious(value) {
  const ref = useRef$2();
  useEffect$1(() => {
    // $FlowFixMe[incompatible-type]
    ref.current = value;
  });
  return ref.current;
}

var Recoil_usePrevious = usePrevious;

const {
  useStoreRef: useStoreRef$1
} = Recoil_RecoilRoot;

const {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$1
} = Recoil_Retention;

const {
  updateRetainCount: updateRetainCount$2
} = Recoil_Retention;

const {
  RetentionZone: RetentionZone$3
} = Recoil_RetentionZone;

const {
  useEffect: useEffect$2,
  useRef: useRef$3
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  isSSR: isSSR$2
} = Recoil_Environment;





 // I don't see a way to avoid the any type here because we want to accept readable
// and writable values with any type parameter, but normally with writable ones
// RecoilState<SomeT> is not a subtype of RecoilState<mixed>.


// flowlint-line unclear-type:off
function useRetain(toRetain) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  } // eslint-disable-next-line fb-www/react-hooks


  return useRetain_ACTUAL(toRetain);
}

function useRetain_ACTUAL(toRetain) {
  const array = Array.isArray(toRetain) ? toRetain : [toRetain];
  const retainables = array.map(a => a instanceof RetentionZone$3 ? a : a.key);
  const storeRef = useStoreRef$1();
  useEffect$2(() => {
    if (!Recoil_gkx('recoil_memory_managament_2020')) {
      return;
    }

    const store = storeRef.current;

    if (timeoutID.current && !isSSR$2) {
      // Already performed a temporary retain on render, simply cancel the release
      // of that temporary retain.
      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
    } else {
      for (const r of retainables) {
        updateRetainCount$2(store, r, 1);
      }
    }

    return () => {
      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }; // eslint-disable-next-line fb-www/react-hooks-deps
  }, [storeRef, ...retainables]); // We want to retain if the component suspends. This is terrible but the Suspense
  // API affords us no better option. If we suspend and never commit after some
  // seconds, then release. The 'actual' retain/release in the effect above
  // cancels this.

  const timeoutID = useRef$3();
  const previousRetainables = Recoil_usePrevious(retainables);

  if (!isSSR$2 && (previousRetainables === undefined || !Recoil_shallowArrayEqual(previousRetainables, retainables))) {
    const store = storeRef.current;

    for (const r of retainables) {
      updateRetainCount$2(store, r, 1);
    }

    if (previousRetainables) {
      for (const r of previousRetainables) {
        updateRetainCount$2(store, r, -1);
      }
    }

    if (timeoutID.current) {
      window.clearTimeout(timeoutID.current);
    }

    timeoutID.current = window.setTimeout(() => {
      timeoutID.current = null;

      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }, SUSPENSE_TIMEOUT_MS$1);
  }
}

var Recoil_useRetain = useRetain;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * THIS CODE HAS BEEN COMMENTED OUT INTENTIONALLY
 *
 * This technique of getting the component name is imperfect, since it both only
 * works in a non-minified code base, and more importantly introduces performance
 * problems since it relies in throwing errors which is an expensive operation.
 *
 * At some point we may want to reevaluate this technique hence why we have commented
 * this code out, rather than delete it all together.
 */
// const {useRef} = require('react');
// const gkx = require('recoil-shared/util/Recoil_gkx');
// const stackTraceParser = require('recoil-shared/util/Recoil_stackTraceParser');

function useComponentName() {
  // const nameRef = useRef();
  // if (__DEV__) {
  //   if (gkx('recoil_infer_component_names')) {
  //     if (nameRef.current === undefined) {
  //       // There is no blessed way to determine the calling React component from
  //       // within a hook. This hack uses the fact that hooks must start with 'use'
  //       // and that hooks are either called by React Components or other hooks. It
  //       // follows therefore, that to find the calling component, you simply need
  //       // to look down the stack and find the first function which doesn't start
  //       // with 'use'. We are only enabling this in dev for now, since once the
  //       // codebase is minified, the naming assumptions no longer hold true.
  //       // eslint-disable-next-line fb-www/no-new-error
  //       const frames = stackTraceParser(new Error().stack);
  //       for (const {methodName} of frames) {
  //         // I observed cases where the frame was of the form 'Object.useXXX'
  //         // hence why I'm searching for hooks following a word boundary
  //         if (!methodName.match(/\buse[^\b]+$/)) {
  //           return (nameRef.current = methodName);
  //         }
  //       }
  //       nameRef.current = null;
  //     }
  //     return nameRef.current ?? '<unable to determine component name>';
  //   }
  // }
  // @fb-only: return "<component name only available when both in dev mode and when passing GK 'recoil_infer_component_names'>";
  return '<component name not available>'; // @oss-only
}

var Recoil_useComponentName = useComponentName;

const {
  batchUpdates: batchUpdates$2
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$2
} = Recoil_Node;

const {
  currentRendererSupportsUseSyncExternalStore: currentRendererSupportsUseSyncExternalStore$1,
  reactMode: reactMode$3,
  useMutableSource: useMutableSource$1,
  useSyncExternalStore: useSyncExternalStore$1
} = Recoil_ReactMode;

const {
  useRecoilMutableSource: useRecoilMutableSource$1,
  useStoreRef: useStoreRef$2
} = Recoil_RecoilRoot;

const {
  isRecoilValue: isRecoilValue$2
} = Recoil_RecoilValue$1;

const {
  AbstractRecoilValue: AbstractRecoilValue$3,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$2,
  setRecoilValue: setRecoilValue$2,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$2,
  subscribeToRecoilValue: subscribeToRecoilValue$1
} = Recoil_RecoilValueInterface;



const {
  useCallback: useCallback$1,
  useEffect: useEffect$3,
  useMemo: useMemo$1,
  useRef: useRef$4,
  useState: useState$1
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  setByAddingToSet: setByAddingToSet$2
} = Recoil_CopyOnWrite;



const {
  isSSR: isSSR$3
} = Recoil_Environment;













function handleLoadable(loadable, recoilValue, storeRef) {
  // We can't just throw the promise we are waiting on to Suspense.  If the
  // upstream dependencies change it may produce a state in which the component
  // can render, but it would still be suspended on a Promise that may never resolve.
  if (loadable.state === 'hasValue') {
    return loadable.contents;
  } else if (loadable.state === 'loading') {
    const promise = new Promise(resolve => {
      const suspendedComponentResolvers = storeRef.current.getState().suspendedComponentResolvers;
      suspendedComponentResolvers.add(resolve); // SSR should clear out the wake-up resolver if the Promise is resolved
      // to avoid infinite loops.  (See https://github.com/facebookexperimental/Recoil/pull/2073)

      if (isSSR$3 && Recoil_isPromise(loadable.contents)) {
        loadable.contents.finally(() => {
          suspendedComponentResolvers.delete(resolve);
        });
      }
    }); // $FlowExpectedError Flow(prop-missing) for integrating with tools that inspect thrown promises @fb-only
    // @fb-only: promise.displayName = `Recoil State: ${recoilValue.key}`;

    throw promise;
  } else if (loadable.state === 'hasError') {
    throw loadable.contents;
  } else {
    throw Recoil_err(`Invalid value of loadable atom "${recoilValue.key}"`);
  }
}

function validateRecoilValue(recoilValue, hookName // $FlowFixMe[missing-local-annot]
) {
  if (!isRecoilValue$2(recoilValue)) {
    throw Recoil_err(`Invalid argument to ${hookName}: expected an atom or selector but got ${String(recoilValue)}`);
  }
}

/**
 * Various things are broken with useRecoilInterface, particularly concurrent
 * mode, React strict mode, and memory management. They will not be fixed.
 * */
function useRecoilInterface_DEPRECATED() {
  const componentName = Recoil_useComponentName();
  const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook

  const [, forceUpdate] = useState$1([]);
  const recoilValuesUsed = useRef$4(new Set());
  recoilValuesUsed.current = new Set(); // Track the RecoilValues used just during this render

  const previousSubscriptions = useRef$4(new Set());
  const subscriptions = useRef$4(new Map());
  const unsubscribeFrom = useCallback$1(key => {
    const sub = subscriptions.current.get(key);

    if (sub) {
      sub.release();
      subscriptions.current.delete(key);
    }
  }, [subscriptions]);
  const updateState = useCallback$1((_state, key) => {
    if (subscriptions.current.has(key)) {
      forceUpdate([]);
    }
  }, []); // Effect to add/remove subscriptions as nodes are used

  useEffect$3(() => {
    const store = storeRef.current;
    Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach(key => {
      if (subscriptions.current.has(key)) {
        Recoil_expectationViolation(`Double subscription to RecoilValue "${key}"`);
        return;
      }

      const sub = subscribeToRecoilValue$1(store, new AbstractRecoilValue$3(key), state => updateState(state, key), componentName);
      subscriptions.current.set(key, sub);
      /**
       * Since we're subscribing in an effect we need to update to the latest
       * value of the atom since it may have changed since we rendered. We can
       * go ahead and do that now, unless we're in the middle of a batch --
       * in which case we should do it at the end of the batch, due to the
       * following edge case: Suppose an atom is updated in another useEffect
       * of this same component. Then the following sequence of events occur:
       * 1. Atom is updated and subs fired (but we may not be subscribed
       *    yet depending on order of effects, so we miss this) Updated value
       *    is now in nextTree, but not currentTree.
       * 2. This effect happens. We subscribe and update.
       * 3. From the update we re-render and read currentTree, with old value.
       * 4. Batcher's effect sets currentTree to nextTree.
       * In this sequence we miss the update. To avoid that, add the update
       * to queuedComponentCallback if a batch is in progress.
       */
      // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.

      const state = store.getState();

      if (state.nextTree) {
        store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
          updateState(store.getState(), key);
        });
      } else {
        updateState(store.getState(), key);
      }
    });
    Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach(key => {
      unsubscribeFrom(key);
    });
    previousSubscriptions.current = recoilValuesUsed.current;
  }); // Effect to unsubscribe from all when unmounting

  useEffect$3(() => {
    const currentSubscriptions = subscriptions.current; // Restore subscriptions that were cleared due to StrictMode running this effect twice

    Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach(key => {
      const sub = subscribeToRecoilValue$1(storeRef.current, new AbstractRecoilValue$3(key), state => updateState(state, key), componentName);
      currentSubscriptions.set(key, sub);
    });
    return () => currentSubscriptions.forEach((_, key) => unsubscribeFrom(key));
  }, [componentName, storeRef, unsubscribeFrom, updateState]);
  return useMemo$1(() => {
    // eslint-disable-next-line no-shadow
    function useSetRecoilState(recoilState) {
      if (false) {}

      return newValueOrUpdater => {
        setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
      };
    } // eslint-disable-next-line no-shadow


    function useResetRecoilState(recoilState) {
      if (false) {}

      return () => setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
    } // eslint-disable-next-line no-shadow


    function useRecoilValueLoadable(recoilValue) {
      var _storeState$nextTree;

      if (false) {}

      if (!recoilValuesUsed.current.has(recoilValue.key)) {
        recoilValuesUsed.current = setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
      } // TODO Restore optimization to memoize lookup


      const storeState = storeRef.current.getState();
      return getRecoilValueAsLoadable$2(storeRef.current, recoilValue, reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
    } // eslint-disable-next-line no-shadow


    function useRecoilValue(recoilValue) {
      if (false) {}

      const loadable = useRecoilValueLoadable(recoilValue);
      return handleLoadable(loadable, recoilValue, storeRef);
    } // eslint-disable-next-line no-shadow


    function useRecoilState(recoilState) {
      if (false) {}

      return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
    } // eslint-disable-next-line no-shadow


    function useRecoilStateLoadable(recoilState) {
      if (false) {}

      return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
    }

    return {
      getRecoilValue: useRecoilValue,
      getRecoilValueLoadable: useRecoilValueLoadable,
      getRecoilState: useRecoilState,
      getRecoilStateLoadable: useRecoilStateLoadable,
      getSetRecoilState: useSetRecoilState,
      getResetRecoilState: useResetRecoilState
    };
  }, [recoilValuesUsed, storeRef]);
}

const recoilComponentGetRecoilValueCount_FOR_TESTING = {
  current: 0
};

function useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName();
  const getSnapshot = useCallback$1(() => {
    var _storeState$nextTree2;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
    const loadable = getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    return {
      loadable,
      key: recoilValue.key
    };
  }, [storeRef, recoilValue]); // Memoize the state to avoid unnecessary rerenders

  const memoizePreviousSnapshot = useCallback$1(getState => {
    let prevState;
    return () => {
      var _prevState, _prevState2;

      const nextState = getState();

      if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) {
        return prevState;
      }

      prevState = nextState;
      return nextState;
    };
  }, []);
  const getMemoizedSnapshot = useMemo$1(() => memoizePreviousSnapshot(getSnapshot), [getSnapshot, memoizePreviousSnapshot]);
  const subscribe = useCallback$1(notify => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName]);
  return useSyncExternalStore$1(subscribe, getMemoizedSnapshot, // getSnapshot()
  getMemoizedSnapshot // getServerSnapshot() for SSR support
  ).loadable;
}

function useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
  const storeRef = useStoreRef$2();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree3;

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getLoadableWithTesting = useCallback$1(() => {
    if (false) {}

    return getLoadable();
  }, [getLoadable]);
  const componentName = Recoil_useComponentName();
  const subscribe = useCallback$1((_storeState, notify) => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, () => {
      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return notify();
      } // Only re-render if the value has changed.
      // This will evaluate the atom/selector now as well as when the
      // component renders, but that may help with prefetching.


      const newLoadable = getLoadable();

      if (!prevLoadableRef.current.is(newLoadable)) {
        notify();
      } // If the component is suspended then the effect setting prevLoadableRef
      // will not run.  So, set the previous value here when its subscription
      // is fired to wake it up.  We can't just rely on this, though, because
      // this only executes when an atom/selector is dirty and the atom/selector
      // passed to the hook can dynamically change.


      prevLoadableRef.current = newLoadable;
    }, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName, getLoadable]);
  const source = useRecoilMutableSource$1();

  if (source == null) {
    throw Recoil_err('Recoil hooks must be used in components contained within a <RecoilRoot> component.');
  }

  const loadable = useMutableSource$1(source, getLoadableWithTesting, subscribe);
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  return loadable;
}

function useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName(); // Accessors to get the current state

  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree4;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getState = useCallback$1(() => ({
    loadable: getLoadable(),
    key: recoilValue.key
  }), [getLoadable, recoilValue.key]); // Memoize state snapshots

  const updateState = useCallback$1(prevState => {
    const nextState = getState();
    return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
  }, [getState]); // Subscribe to Recoil state changes

  useEffect$3(() => {
    const subscription = subscribeToRecoilValue$1(storeRef.current, recoilValue, _state => {
      setState(updateState);
    }, componentName); // Update state in case we are using a different key

    setState(updateState);
    return subscription.release;
  }, [componentName, recoilValue, storeRef, updateState]); // Get the current state

  const [state, setState] = useState$1(getState); // If we changed keys, then return the state for the new key.
  // This is important in case the old key would cause the component to suspend.
  // We don't have to set the new state here since the subscribing effect above
  // will do that.

  return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}

function useRecoilValueLoadable_LEGACY(recoilValue) {
  const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook

  const [, forceUpdate] = useState$1([]);
  const componentName = Recoil_useComponentName();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree5;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const loadable = getLoadable();
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  useEffect$3(() => {
    const store = storeRef.current;
    const storeState = store.getState();
    const subscription = subscribeToRecoilValue$1(store, recoilValue, _state => {
      var _prevLoadableRef$curr;

      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return forceUpdate([]);
      }

      const newLoadable = getLoadable();

      if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) {
        // $FlowFixMe[incompatible-call]
        forceUpdate(newLoadable);
      }

      prevLoadableRef.current = newLoadable;
    }, componentName);
    /**
     * Since we're subscribing in an effect we need to update to the latest
     * value of the atom since it may have changed since we rendered. We can
     * go ahead and do that now, unless we're in the middle of a batch --
     * in which case we should do it at the end of the batch, due to the
     * following edge case: Suppose an atom is updated in another useEffect
     * of this same component. Then the following sequence of events occur:
     * 1. Atom is updated and subs fired (but we may not be subscribed
     *    yet depending on order of effects, so we miss this) Updated value
     *    is now in nextTree, but not currentTree.
     * 2. This effect happens. We subscribe and update.
     * 3. From the update we re-render and read currentTree, with old value.
     * 4. Batcher's effect sets currentTree to nextTree.
     * In this sequence we miss the update. To avoid that, add the update
     * to queuedComponentCallback if a batch is in progress.
     */

    if (storeState.nextTree) {
      store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
        // $FlowFixMe[incompatible-type]
        prevLoadableRef.current = null;
        forceUpdate([]);
      });
    } else {
      var _prevLoadableRef$curr2;

      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return forceUpdate([]);
      }

      const newLoadable = getLoadable();

      if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) {
        // $FlowFixMe[incompatible-call]
        forceUpdate(newLoadable);
      }

      prevLoadableRef.current = newLoadable;
    }

    return subscription.release;
  }, [componentName, getLoadable, recoilValue, storeRef]);
  return loadable;
}
/**
  Like useRecoilValue(), but either returns the value if available or
  just undefined if not available for any reason, such as pending or error.
*/


function useRecoilValueLoadable(recoilValue) {
  if (false) {}

  if (Recoil_gkx('recoil_memory_managament_2020')) {
    // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
  }

  return {
    TRANSITION_SUPPORT: useRecoilValueLoadable_TRANSITION_SUPPORT,
    // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
    // `reactMode()` before calling it.  However, sometimes the host React
    // environment supports it but uses additional React renderers (such as with
    // `react-three-fiber`) which do not.  While this is technically a user issue
    // by using a renderer with React 18+ that doesn't fully support React 18 we
    // don't want to break users if it can be avoided. As the current renderer can
    // change at runtime, we need to dynamically check and fallback if necessary.
    SYNC_EXTERNAL_STORE: currentRendererSupportsUseSyncExternalStore$1() ? useRecoilValueLoadable_SYNC_EXTERNAL_STORE : useRecoilValueLoadable_TRANSITION_SUPPORT,
    MUTABLE_SOURCE: useRecoilValueLoadable_MUTABLE_SOURCE,
    LEGACY: useRecoilValueLoadable_LEGACY
  }[reactMode$3().mode](recoilValue);
}
/**
  Returns the value represented by the RecoilValue.
  If the value is pending, it will throw a Promise to suspend the component,
  if the value is an error it will throw it for the nearest React error boundary.
  This will also subscribe the component for any updates in the value.
  */


function useRecoilValue(recoilValue) {
  if (false) {}

  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}
/**
  Returns a function that allows the value of a RecoilState to be updated, but does
  not subscribe the component to changes to that RecoilState.
*/


function useSetRecoilState(recoilState) {
  if (false) {}

  const storeRef = useStoreRef$2();
  return useCallback$1(newValueOrUpdater => {
    setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
  }, [storeRef, recoilState]);
}
/**
  Returns a function that will reset the value of a RecoilState to its default
*/


function useResetRecoilState(recoilState) {
  if (false) {}

  const storeRef = useStoreRef$2();
  return useCallback$1(() => {
    setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
  }, [storeRef, recoilState]);
}
/**
  Equivalent to useState(). Allows the value of the RecoilState to be read and written.
  Subsequent updates to the RecoilState will cause the component to re-render. If the
  RecoilState is pending, this will suspend the component and initiate the
  retrieval of the value. If evaluating the RecoilState resulted in an error, this will
  throw the error so that the nearest React error boundary can catch it.
*/


function useRecoilState(recoilState) {
  if (false) {}

  return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
}
/**
  Like useRecoilState(), but does not cause Suspense or React error handling. Returns
  an object that indicates whether the RecoilState is available, pending, or
  unavailable due to an error.
*/


function useRecoilStateLoadable(recoilState) {
  if (false) {}

  return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
}

function useSetUnvalidatedAtomValues() {
  const storeRef = useStoreRef$2();
  return (values, transactionMetadata = {}) => {
    batchUpdates$2(() => {
      storeRef.current.addTransactionMetadata(transactionMetadata);
      values.forEach((value, key) => setUnvalidatedRecoilValue$2(storeRef.current, new AbstractRecoilValue$3(key), value));
    });
  };
}
/**
 * Experimental variants of hooks with support for useTransition()
 */


function useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (false) {}

  if (Recoil_gkx('recoil_memory_managament_2020')) {
    // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
  }

  return useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}

function useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (false) {}

  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}

function useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
  if (false) {}

  return [useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState), useSetRecoilState(recoilState)];
}

var Recoil_Hooks = {
  recoilComponentGetRecoilValueCount_FOR_TESTING,
  useRecoilInterface: useRecoilInterface_DEPRECATED,
  useRecoilState,
  useRecoilStateLoadable,
  useRecoilValue,
  useRecoilValueLoadable,
  useResetRecoilState,
  useSetRecoilState,
  useSetUnvalidatedAtomValues,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a map containing all of the keys + values from the original map where
 * the given callback returned true.
 */

function filterMap(map, callback) {
  const result = new Map();

  for (const [key, value] of map) {
    if (callback(value, key)) {
      result.set(key, value);
    }
  }

  return result;
}

var Recoil_filterMap = filterMap;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a set containing all of the values from the original set where
 * the given callback returned true.
 */

function filterSet(set, callback) {
  const result = new Set();

  for (const value of set) {
    if (callback(value)) {
      result.add(value);
    }
  }

  return result;
}

var Recoil_filterSet = filterSet;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function mergeMaps(...maps) {
  const result = new Map();

  for (let i = 0; i < maps.length; i++) {
    const iterator = maps[i].keys();
    let nextKey;

    while (!(nextKey = iterator.next()).done) {
      // $FlowIssue[incompatible-call] - map/iterator knows nothing about flow types
      result.set(nextKey.value, maps[i].get(nextKey.value));
    }
  }

  return result;
}

var Recoil_mergeMaps = mergeMaps;

const {
  batchUpdates: batchUpdates$3
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$3,
  getNode: getNode$4,
  nodes: nodes$1
} = Recoil_Node;

const {
  useStoreRef: useStoreRef$3
} = Recoil_RecoilRoot;

const {
  AbstractRecoilValue: AbstractRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$1
} = Recoil_RecoilValueInterface;

const {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$2
} = Recoil_Retention;

const {
  cloneSnapshot: cloneSnapshot$1
} = Recoil_Snapshot$1;

const {
  useCallback: useCallback$2,
  useEffect: useEffect$4,
  useRef: useRef$5,
  useState: useState$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  isSSR: isSSR$4
} = Recoil_Environment;















function useTransactionSubscription(callback) {
  const storeRef = useStoreRef$3();
  useEffect$4(() => {
    const sub = storeRef.current.subscribeToTransactions(callback);
    return sub.release;
  }, [callback, storeRef]);
}

function externallyVisibleAtomValuesInState(state) {
  const atomValues = state.atomValues.toMap();
  const persistedAtomContentsValues = Recoil_mapMap(Recoil_filterMap(atomValues, (v, k) => {
    const node = getNode$4(k);
    const persistence = node.persistence_UNSTABLE;
    return persistence != null && persistence.type !== 'none' && v.state === 'hasValue';
  }), v => v.contents); // Merge in nonvalidated atoms; we may not have defs for them but they will
  // all have persistence on or they wouldn't be there in the first place.

  return Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}

/**
  Calls the given callback after any atoms have been modified and the consequent
  component re-renders have been committed. This is intended for persisting
  the values of the atoms to storage. The stored values can then be restored
  using the useSetUnvalidatedAtomValues hook.

  The callback receives the following info:

  atomValues: The current value of every atom that is both persistable (persistence
              type not set to 'none') and whose value is available (not in an
              error or loading state).

  previousAtomValues: The value of every persistable and available atom before
               the transaction began.

  atomInfo: A map containing the persistence settings for each atom. Every key
            that exists in atomValues will also exist in atomInfo.

  modifiedAtoms: The set of atoms that were written to during the transaction.

  transactionMetadata: Arbitrary information that was added via the
          useSetUnvalidatedAtomValues hook. Useful for ignoring the useSetUnvalidatedAtomValues
          transaction, to avoid loops.
*/
function useTransactionObservation_DEPRECATED(callback) {
  useTransactionSubscription(useCallback$2(store => {
    let previousTree = store.getState().previousTree;
    const currentTree = store.getState().currentTree;

    if (!previousTree) {
      Recoil_recoverableViolation('Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil');
      previousTree = store.getState().currentTree; // attempt to trundle on
    }

    const atomValues = externallyVisibleAtomValuesInState(currentTree);
    const previousAtomValues = externallyVisibleAtomValuesInState(previousTree);
    const atomInfo = Recoil_mapMap(nodes$1, node => {
      var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;

      return {
        persistence_UNSTABLE: {
          type: (_node$persistence_UNS = (_node$persistence_UNS2 = node.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : 'none',
          backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
        }
      };
    }); // Filter on existance in atomValues so that externally-visible rules
    // are also applied to modified atoms (specifically exclude selectors):

    const modifiedAtoms = Recoil_filterSet(currentTree.dirtyAtoms, k => atomValues.has(k) || previousAtomValues.has(k));
    callback({
      atomValues,
      previousAtomValues,
      atomInfo,
      modifiedAtoms,
      transactionMetadata: { ...currentTree.transactionMetadata
      }
    });
  }, [callback]));
}

function useRecoilTransactionObserver(callback) {
  useTransactionSubscription(useCallback$2(store => {
    const snapshot = cloneSnapshot$1(store, 'latest');
    const previousSnapshot = cloneSnapshot$1(store, 'previous');
    callback({
      snapshot,
      previousSnapshot
    });
  }, [callback]));
} // Return a snapshot of the current state and subscribe to all state changes


function useRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  const [snapshot, setSnapshot] = useState$2(() => cloneSnapshot$1(storeRef.current));
  const previousSnapshot = Recoil_usePrevious(snapshot);
  const timeoutID = useRef$5();
  const releaseRef = useRef$5();
  useTransactionSubscription(useCallback$2(store => setSnapshot(cloneSnapshot$1(store)), [])); // Retain snapshot for duration component is mounted

  useEffect$4(() => {
    const release = snapshot.retain(); // Release the retain from the rendering call

    if (timeoutID.current && !isSSR$4) {
      var _releaseRef$current;

      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 ? void 0 : _releaseRef$current.call(releaseRef);
      releaseRef.current = null;
    }

    return () => {
      // Defer the release.  If "Fast Refresh"" is used then the component may
      // re-render with the same state.  The previous cleanup will then run and
      // then the new effect will run. We don't want the snapshot to be released
      // by that cleanup before the new effect has a chance to retain it again.
      // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
      window.setTimeout(release, 10);
    };
  }, [snapshot]); // Retain snapshot until above effect is run.
  // Release after a threshold in case component is suspended.

  if (previousSnapshot !== snapshot && !isSSR$4) {
    // Release the previous snapshot
    if (timeoutID.current) {
      var _releaseRef$current2;

      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 ? void 0 : _releaseRef$current2.call(releaseRef);
      releaseRef.current = null;
    }

    releaseRef.current = snapshot.retain();
    timeoutID.current = window.setTimeout(() => {
      var _releaseRef$current3;

      timeoutID.current = null;
      (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 ? void 0 : _releaseRef$current3.call(releaseRef);
      releaseRef.current = null;
    }, SUSPENSE_TIMEOUT_MS$2);
  }

  return snapshot;
}

function gotoSnapshot(store, snapshot) {
  var _storeState$nextTree;

  const storeState = store.getState();
  const prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
  const next = snapshot.getStore_INTERNAL().getState().currentTree;
  batchUpdates$3(() => {
    const keysToUpdate = new Set();

    for (const keys of [prev.atomValues.keys(), next.atomValues.keys()]) {
      for (const key of keys) {
        var _prev$atomValues$get, _next$atomValues$get;

        if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && getNode$4(key).shouldRestoreFromSnapshots) {
          keysToUpdate.add(key);
        }
      }
    }

    keysToUpdate.forEach(key => {
      setRecoilValueLoadable$1(store, new AbstractRecoilValue$4(key), next.atomValues.has(key) ? Recoil_nullthrows(next.atomValues.get(key)) : DEFAULT_VALUE$3);
    });
    store.replaceState(state => ({ ...state,
      stateID: snapshot.getID()
    }));
  });
}

function useGotoRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  return useCallback$2(snapshot => gotoSnapshot(storeRef.current, snapshot), [storeRef]);
}

var Recoil_SnapshotHooks = {
  useRecoilSnapshot,
  gotoSnapshot,
  useGotoRecoilSnapshot,
  useRecoilTransactionObserver,
  useTransactionObservation_DEPRECATED,
  useTransactionSubscription_DEPRECATED: useTransactionSubscription
};

const {
  peekNodeInfo: peekNodeInfo$2
} = Recoil_FunctionalCore;

const {
  useStoreRef: useStoreRef$4
} = Recoil_RecoilRoot;

function useGetRecoilValueInfo() {
  const storeRef = useStoreRef$4(); // $FlowFixMe[incompatible-return]

  return ({
    key
  }) => peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
}

var Recoil_useGetRecoilValueInfo = useGetRecoilValueInfo;

const {
  reactMode: reactMode$4
} = Recoil_ReactMode;

const {
  RecoilRoot: RecoilRoot$1,
  useStoreRef: useStoreRef$5
} = Recoil_RecoilRoot;



const {
  useMemo: useMemo$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilBridgeAcrossReactRoots() {
  // The test fails when using useMutableSource(), but only if act() is used
  // for the nested root.  So, this may only be a testing environment issue.
  if (reactMode$4().mode === 'MUTABLE_SOURCE') {
    // eslint-disable-next-line fb-www/no-console
    console.warn('Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.');
  }

  const store = useStoreRef$5().current;
  return useMemo$2(() => {
    // eslint-disable-next-line no-shadow
    function RecoilBridge({
      children
    }) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RecoilRoot$1, {
        store_INTERNAL: store
      }, children);
    }

    return RecoilBridge;
  }, [store]);
}

var Recoil_useRecoilBridgeAcrossReactRoots = useRecoilBridgeAcrossReactRoots;

const {
  loadableWithValue: loadableWithValue$1
} = Recoil_Loadable$1;

const {
  initializeNode: initializeNode$3
} = Recoil_FunctionalCore;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$4,
  getNode: getNode$5
} = Recoil_Node;

const {
  copyTreeState: copyTreeState$1,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$3,
  invalidateDownstreams: invalidateDownstreams$1,
  writeLoadableToTreeState: writeLoadableToTreeState$1
} = Recoil_RecoilValueInterface;



function isAtom(recoilValue) {
  return getNode$5(recoilValue.key).nodeType === 'atom';
}

class TransactionInterfaceImpl {
  constructor(store, treeState) {
    _defineProperty(this, "_store", void 0);

    _defineProperty(this, "_treeState", void 0);

    _defineProperty(this, "_changes", void 0);

    _defineProperty(this, "get", recoilValue => {
      if (this._changes.has(recoilValue.key)) {
        // $FlowIssue[incompatible-return]
        return this._changes.get(recoilValue.key);
      }

      if (!isAtom(recoilValue)) {
        throw Recoil_err('Reading selectors within atomicUpdate is not supported');
      }

      const loadable = getRecoilValueAsLoadable$3(this._store, recoilValue, this._treeState);

      if (loadable.state === 'hasValue') {
        return loadable.contents;
      } else if (loadable.state === 'hasError') {
        throw loadable.contents;
      } else {
        throw Recoil_err(`Expected Recoil atom ${recoilValue.key} to have a value, but it is in a loading state.`);
      }
    });

    _defineProperty(this, "set", (recoilState, valueOrUpdater) => {
      if (!isAtom(recoilState)) {
        throw Recoil_err('Setting selectors within atomicUpdate is not supported');
      }

      if (typeof valueOrUpdater === 'function') {
        const current = this.get(recoilState);

        this._changes.set(recoilState.key, valueOrUpdater(current)); // flowlint-line unclear-type:off

      } else {
        // Initialize atom and run effects if not initialized yet
        initializeNode$3(this._store, recoilState.key, 'set');

        this._changes.set(recoilState.key, valueOrUpdater);
      }
    });

    _defineProperty(this, "reset", recoilState => {
      this.set(recoilState, DEFAULT_VALUE$4);
    });

    this._store = store;
    this._treeState = treeState;
    this._changes = new Map();
  } // Allow destructing
  // eslint-disable-next-line fb-www/extra-arrow-initializer


  newTreeState_INTERNAL() {
    if (this._changes.size === 0) {
      return this._treeState;
    }

    const newState = copyTreeState$1(this._treeState);

    for (const [k, v] of this._changes) {
      writeLoadableToTreeState$1(newState, k, loadableWithValue$1(v));
    }

    invalidateDownstreams$1(this._store, newState);
    return newState;
  }

}

function atomicUpdater(store) {
  return fn => {
    store.replaceState(treeState => {
      const changeset = new TransactionInterfaceImpl(store, treeState);
      fn(changeset);
      return changeset.newTreeState_INTERNAL();
    });
  };
}

var Recoil_AtomicUpdates = {
  atomicUpdater
};

var Recoil_AtomicUpdates_1 = Recoil_AtomicUpdates.atomicUpdater;

var Recoil_AtomicUpdates$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  atomicUpdater: Recoil_AtomicUpdates_1
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function invariant(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}

var invariant_1 = invariant;

// @oss-only


var Recoil_invariant = invariant_1;

const {
  atomicUpdater: atomicUpdater$1
} = Recoil_AtomicUpdates$1;

const {
  batchUpdates: batchUpdates$4
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$5
} = Recoil_Node;

const {
  useStoreRef: useStoreRef$6
} = Recoil_RecoilRoot;

const {
  refreshRecoilValue: refreshRecoilValue$1,
  setRecoilValue: setRecoilValue$3
} = Recoil_RecoilValueInterface;

const {
  cloneSnapshot: cloneSnapshot$2
} = Recoil_Snapshot$1;

const {
  gotoSnapshot: gotoSnapshot$1
} = Recoil_SnapshotHooks;

const {
  useCallback: useCallback$3
} = react__WEBPACK_IMPORTED_MODULE_0__;









class Sentinel {}

const SENTINEL = new Sentinel();

function recoilCallback(store, fn, args, extraInterface) {
  let ret = SENTINEL;
  let releaseSnapshot;
  batchUpdates$4(() => {
    const errMsg = 'useRecoilCallback() expects a function that returns a function: ' + 'it accepts a function of the type (RecoilInterface) => (Args) => ReturnType ' + 'and returns a callback function (Args) => ReturnType, where RecoilInterface is ' + 'an object {snapshot, set, ...} and Args and ReturnType are the argument and return ' + 'types of the callback you want to create.  Please see the docs ' + 'at recoiljs.org for details.';

    if (typeof fn !== 'function') {
      throw Recoil_err(errMsg);
    } // Clone the snapshot lazily to avoid overhead if the callback does not use it.
    // Note that this means the snapshot may represent later state from when
    // the callback was called if it first accesses the snapshot asynchronously.


    const callbackInterface = Recoil_lazyProxy({ ...(extraInterface !== null && extraInterface !== void 0 ? extraInterface : {}),
      // flowlint-line unclear-type:off
      // $FlowFixMe[missing-local-annot]
      set: (node, newValue) => setRecoilValue$3(store, node, newValue),
      // $FlowFixMe[missing-local-annot]
      reset: node => setRecoilValue$3(store, node, DEFAULT_VALUE$5),
      // $FlowFixMe[missing-local-annot]
      refresh: node => refreshRecoilValue$1(store, node),
      gotoSnapshot: snapshot => gotoSnapshot$1(store, snapshot),
      transact_UNSTABLE: transaction => atomicUpdater$1(store)(transaction)
    }, {
      snapshot: () => {
        const snapshot = cloneSnapshot$2(store);
        releaseSnapshot = snapshot.retain();
        return snapshot;
      }
    });
    const callback = fn(callbackInterface);

    if (typeof callback !== 'function') {
      throw Recoil_err(errMsg);
    }

    ret = callback(...args);
  });
  !!(ret instanceof Sentinel) ?  false ? 0 : Recoil_invariant(false) : void 0;

  if (Recoil_isPromise(ret)) {
    ret = ret.finally(() => {
      var _releaseSnapshot;

      (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 ? void 0 : _releaseSnapshot();
    });
  } else {
    var _releaseSnapshot2;

    (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 ? void 0 : _releaseSnapshot2();
  }

  return ret;
}

function useRecoilCallback(fn, deps) {
  const storeRef = useStoreRef$6();
  return useCallback$3( // $FlowIssue[incompatible-call]
  (...args) => {
    return recoilCallback(storeRef.current, fn, args);
  }, deps != null ? [...deps, storeRef] : undefined // eslint-disable-line fb-www/react-hooks-deps
  );
}

var Recoil_useRecoilCallback = {
  recoilCallback,
  useRecoilCallback
};

const {
  useStoreRef: useStoreRef$7
} = Recoil_RecoilRoot;

const {
  refreshRecoilValue: refreshRecoilValue$2
} = Recoil_RecoilValueInterface;

const {
  useCallback: useCallback$4
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilRefresher(recoilValue) {
  const storeRef = useStoreRef$7();
  return useCallback$4(() => {
    const store = storeRef.current;
    refreshRecoilValue$2(store, recoilValue);
  }, [recoilValue, storeRef]);
}

var Recoil_useRecoilRefresher = useRecoilRefresher;

const {
  atomicUpdater: atomicUpdater$2
} = Recoil_AtomicUpdates$1;

const {
  useStoreRef: useStoreRef$8
} = Recoil_RecoilRoot;

const {
  useMemo: useMemo$3
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilTransaction(fn, deps) {
  const storeRef = useStoreRef$8();
  return useMemo$3(() => (...args) => {
    const atomicUpdate = atomicUpdater$2(storeRef.current);
    atomicUpdate(transactionInterface => {
      fn(transactionInterface)(...args);
    });
  }, deps != null ? [...deps, storeRef] : undefined // eslint-disable-line fb-www/react-hooks-deps
  );
}

var Recoil_useRecoilTransaction = useRecoilTransaction;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class WrappedValue {
  constructor(value) {
    _defineProperty(this, "value", void 0);

    this.value = value;
  }

}

var Recoil_Wrapper = {
  WrappedValue
};

var Recoil_Wrapper_1 = Recoil_Wrapper.WrappedValue;

var Recoil_Wrapper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  WrappedValue: Recoil_Wrapper_1
});

const {
  isFastRefreshEnabled: isFastRefreshEnabled$2
} = Recoil_ReactMode;



class ChangedPathError extends Error {}

class TreeCache {
  // $FlowIssue[unclear-type]
  constructor(options) {
    var _options$onHit, _options$onSet, _options$mapNodeValue;

    _defineProperty(this, "_name", void 0);

    _defineProperty(this, "_numLeafs", void 0);

    _defineProperty(this, "_root", void 0);

    _defineProperty(this, "_onHit", void 0);

    _defineProperty(this, "_onSet", void 0);

    _defineProperty(this, "_mapNodeValue", void 0);

    this._name = options === null || options === void 0 ? void 0 : options.name;
    this._numLeafs = 0;
    this._root = null;
    this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : () => {};
    this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : () => {};
    this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : val => val;
  }

  size() {
    return this._numLeafs;
  } // $FlowIssue[unclear-type]


  root() {
    return this._root;
  }

  get(getNodeValue, handlers) {
    var _this$getLeafNode;

    return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
  }

  getLeafNode(getNodeValue, handlers) {
    if (this._root == null) {
      return undefined;
    } // Iterate down the tree based on the current node values until we hit a leaf
    // $FlowIssue[unclear-type]


    let node = this._root;

    while (node) {
      handlers === null || handlers === void 0 ? void 0 : handlers.onNodeVisit(node);

      if (node.type === 'leaf') {
        this._onHit(node);

        return node;
      }

      const nodeValue = this._mapNodeValue(getNodeValue(node.nodeKey));

      node = node.branches.get(nodeValue);
    }

    return undefined;
  }

  set(route, value, handlers) {
    const addLeaf = () => {
      var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;

      // First, setup the branch nodes for the route:
      // Iterate down the tree to find or add branch nodes following the route
      let node;
      let branchKey;

      for (const [nodeKey, nodeValue] of route) {
        var _node, _handlers$onNodeVisit, _this$_root;

        // If the previous root was a leaf, while we not have a get(), it means
        // the selector has inconsistent values or implementation changed.
        const root = this._root;

        if ((root === null || root === void 0 ? void 0 : root.type) === 'leaf') {
          throw this.invalidCacheError();
        } // node now refers to the next node down in the tree


        const parent = node; // $FlowFixMe[prop-missing]
        // $FlowFixMe[incompatible-type]

        node = parent ? parent.branches.get(branchKey) : root; // $FlowFixMe[prop-missing]
        // $FlowFixMe[incompatible-type]

        node = (_node = node) !== null && _node !== void 0 ? _node : {
          type: 'branch',
          nodeKey,
          parent,
          branches: new Map(),
          branchKey
        }; // If we found an existing node, confirm it has a consistent value

        if (node.type !== 'branch' || node.nodeKey !== nodeKey) {
          throw this.invalidCacheError();
        } // Add the branch node to the tree


        parent === null || parent === void 0 ? void 0 : parent.branches.set(branchKey, node);
        handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 ? void 0 : _handlers$onNodeVisit.call(handlers, node); // Prepare for next iteration and install root if it is new.

        branchKey = this._mapNodeValue(nodeValue);
        this._root = (_this$_root = this._root) !== null && _this$_root !== void 0 ? _this$_root : node;
      } // Second, setup the leaf node:
      // If there is an existing leaf for this route confirm it is consistent


      const oldLeaf = node ? (_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : this._root;

      if (oldLeaf != null && (oldLeaf.type !== 'leaf' || oldLeaf.branchKey !== branchKey)) {
        throw this.invalidCacheError();
      } // Create a new or replacement leaf.


      const leafNode = {
        type: 'leaf',
        value,
        parent: node,
        branchKey
      }; // Install the leaf and call handlers

      (_node3 = node) === null || _node3 === void 0 ? void 0 : _node3.branches.set(branchKey, leafNode);
      this._root = (_this$_root2 = this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
      this._numLeafs++;

      this._onSet(leafNode);

      handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 ? void 0 : _handlers$onNodeVisit2.call(handlers, leafNode);
    };

    try {
      addLeaf();
    } catch (error) {
      // If the cache was stale or observed inconsistent values, such as with
      // Fast Refresh, then clear it and rebuild with the new values.
      if (error instanceof ChangedPathError) {
        this.clear();
        addLeaf();
      } else {
        throw error;
      }
    }
  } // Returns true if leaf was actually deleted from the tree


  delete(leaf) {
    const root = this.root();

    if (!root) {
      return false;
    }

    if (leaf === root) {
      this._root = null;
      this._numLeafs = 0;
      return true;
    } // Iterate up from the leaf deleteing it from it's parent's branches.


    let node = leaf.parent;
    let branchKey = leaf.branchKey;

    while (node) {
      var _node4;

      node.branches.delete(branchKey); // Stop iterating if we hit the root.

      if (node === root) {
        if (node.branches.size === 0) {
          this._root = null;
          this._numLeafs = 0;
        } else {
          this._numLeafs--;
        }

        return true;
      } // Stop iterating if there are other branches since we don't need to
      // remove any more nodes.


      if (node.branches.size > 0) {
        break;
      } // Iterate up to our parent


      branchKey = (_node4 = node) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
      node = node.parent;
    } // Confirm that the leaf we are deleting is actually attached to our tree


    for (; node !== root; node = node.parent) {
      if (node == null) {
        return false;
      }
    }

    this._numLeafs--;
    return true;
  }

  clear() {
    this._numLeafs = 0;
    this._root = null;
  }

  invalidCacheError() {
    const CHANGED_PATH_ERROR_MESSAGE = isFastRefreshEnabled$2() ? 'Possible Fast Refresh module reload detected.  ' + 'This may also be caused by an selector returning inconsistent values. ' + 'Resetting cache.' : 'Invalid cache values.  This happens when selectors do not return ' + 'consistent values for the same input dependency values.  That may also ' + 'be caused when using Fast Refresh to change a selector implementation.  ' + 'Resetting cache.';
    Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? ` - ${this._name}` : ''));
    throw new ChangedPathError();
  }

}

var Recoil_TreeCache = {
  TreeCache
};

var Recoil_TreeCache_1 = Recoil_TreeCache.TreeCache;

var Recoil_TreeCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TreeCache: Recoil_TreeCache_1
});

class LRUCache {
  constructor(options) {
    var _options$mapKey;

    _defineProperty(this, "_maxSize", void 0);

    _defineProperty(this, "_size", void 0);

    _defineProperty(this, "_head", void 0);

    _defineProperty(this, "_tail", void 0);

    _defineProperty(this, "_map", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    this._maxSize = options.maxSize;
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = new Map();
    this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : v => v;
  }

  head() {
    return this._head;
  }

  tail() {
    return this._tail;
  }

  size() {
    return this._size;
  }

  maxSize() {
    return this._maxSize;
  }

  has(key) {
    return this._map.has(this._keyMapper(key));
  }

  get(key) {
    const mappedKey = this._keyMapper(key);

    const node = this._map.get(mappedKey);

    if (!node) {
      return undefined;
    }

    this.set(key, node.value);
    return node.value;
  }

  set(key, val) {
    const mappedKey = this._keyMapper(key);

    const existingNode = this._map.get(mappedKey);

    if (existingNode) {
      this.delete(key);
    }

    const head = this.head();
    const node = {
      key,
      right: head,
      left: null,
      value: val
    };

    if (head) {
      head.left = node;
    } else {
      this._tail = node;
    }

    this._map.set(mappedKey, node);

    this._head = node;
    this._size++;

    this._maybeDeleteLRU();
  }

  _maybeDeleteLRU() {
    if (this.size() > this.maxSize()) {
      this.deleteLru();
    }
  }

  deleteLru() {
    const tail = this.tail();

    if (tail) {
      this.delete(tail.key);
    }
  }

  delete(key) {
    const mappedKey = this._keyMapper(key);

    if (!this._size || !this._map.has(mappedKey)) {
      return;
    }

    const node = Recoil_nullthrows(this._map.get(mappedKey));
    const right = node.right;
    const left = node.left;

    if (right) {
      right.left = node.left;
    }

    if (left) {
      left.right = node.right;
    }

    if (node === this.head()) {
      this._head = right;
    }

    if (node === this.tail()) {
      this._tail = left;
    }

    this._map.delete(mappedKey);

    this._size--;
  }

  clear() {
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = new Map();
  }

}

var Recoil_LRUCache = {
  LRUCache
};

var Recoil_LRUCache_1 = Recoil_LRUCache.LRUCache;

var Recoil_LRUCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LRUCache: Recoil_LRUCache_1
});

const {
  LRUCache: LRUCache$1
} = Recoil_LRUCache$1;

const {
  TreeCache: TreeCache$1
} = Recoil_TreeCache$1;

function treeCacheLRU({
  name,
  maxSize,
  mapNodeValue = v => v
}) {
  const lruCache = new LRUCache$1({
    maxSize
  });
  const cache = new TreeCache$1({
    name,
    mapNodeValue,
    onHit: node => {
      lruCache.set(node, true);
    },
    onSet: node => {
      const lruNode = lruCache.tail();
      lruCache.set(node, true);

      if (lruNode && cache.size() > maxSize) {
        // $FlowFixMe[incompatible-call]
        cache.delete(lruNode.key);
      }
    }
  });
  return cache;
}

var Recoil_treeCacheLRU = treeCacheLRU;

const TIME_WARNING_THRESHOLD_MS = 15;

function stringify(x, opt, key) {
  // A optimization to avoid the more expensive JSON.stringify() for simple strings
  // This may lose protection for u2028 and u2029, though.
  if (typeof x === 'string' && !x.includes('"') && !x.includes('\\')) {
    return `"${x}"`;
  } // Handle primitive types


  switch (typeof x) {
    case 'undefined':
      return '';
    // JSON.stringify(undefined) returns undefined, but we always want to return a string

    case 'boolean':
      return x ? 'true' : 'false';

    case 'number':
    case 'symbol':
      // case 'bigint': // BigInt is not supported in www
      return String(x);

    case 'string':
      // Add surrounding quotes and escape internal quotes
      return JSON.stringify(x);

    case 'function':
      if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) {
        throw Recoil_err('Attempt to serialize function in a Recoil cache key');
      }

      return `__FUNCTION(${x.name})__`;
  }

  if (x === null) {
    return 'null';
  } // Fallback case for unknown types


  if (typeof x !== 'object') {
    var _JSON$stringify;

    return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
  } // Deal with all promises as equivalent for now.


  if (Recoil_isPromise(x)) {
    return '__PROMISE__';
  } // Arrays handle recursive stringification


  if (Array.isArray(x)) {
    // $FlowFixMe[missing-local-annot]
    return `[${x.map((v, i) => stringify(v, opt, i.toString()))}]`;
  } // If an object defines a toJSON() method, then use that to override the
  // serialization.  This matches the behavior of JSON.stringify().
  // Pass the key for compatibility.
  // Immutable.js collections define this method to allow us to serialize them.


  if (typeof x.toJSON === 'function') {
    // flowlint-next-line unclear-type: off
    return stringify(x.toJSON(key), opt, key);
  } // For built-in Maps, sort the keys in a stable order instead of the
  // default insertion order.  Support non-string keys.


  if (x instanceof Map) {
    const obj = {};

    for (const [k, v] of x) {
      // Stringify will escape any nested quotes
      obj[typeof k === 'string' ? k : stringify(k, opt)] = v;
    }

    return stringify(obj, opt, key);
  } // For built-in Sets, sort the keys in a stable order instead of the
  // default insertion order.


  if (x instanceof Set) {
    return stringify( // $FlowFixMe[missing-local-annot]
    Array.from(x).sort((a, b) => stringify(a, opt).localeCompare(stringify(b, opt))), opt, key);
  } // Anything else that is iterable serialize as an Array.


  if (Symbol !== undefined && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === 'function') {
    // flowlint-next-line unclear-type: off
    return stringify(Array.from(x), opt, key);
  } // For all other Objects, sort the keys in a stable order.


  return `{${Object.keys(x).filter(k => x[k] !== undefined).sort() // stringify the key to add quotes and escape any nested slashes or quotes.
  .map(k => `${stringify(k, opt)}:${stringify(x[k], opt, k)}`).join(',')}}`;
} // Utility similar to JSON.stringify() except:
// * Serialize built-in Sets as an Array
// * Serialize built-in Maps as an Object.  Supports non-string keys.
// * Serialize other iterables as arrays
// * Sort the keys of Objects and Maps to have a stable order based on string conversion.
//    This overrides their default insertion order.
// * Still uses toJSON() of any object to override serialization
// * Support Symbols (though don't guarantee uniqueness)
// * We could support BigInt, but Flow doesn't seem to like it.
// See Recoil_stableStringify-test.js for examples


function stableStringify(x, opt = {
  allowFunctions: false
}) {
  if (false) {}

  return stringify(x, opt);
}

var Recoil_stableStringify = stableStringify;

const {
  TreeCache: TreeCache$2
} = Recoil_TreeCache$1;









const defaultPolicy = {
  equality: 'reference',
  eviction: 'keep-all',
  maxSize: Infinity
};

function treeCacheFromPolicy({
  equality = defaultPolicy.equality,
  eviction = defaultPolicy.eviction,
  maxSize = defaultPolicy.maxSize
} = defaultPolicy, name) {
  const valueMapper = getValueMapper(equality);
  return getTreeCache(eviction, maxSize, valueMapper, name);
}

function getValueMapper(equality) {
  switch (equality) {
    case 'reference':
      return val => val;

    case 'value':
      return val => Recoil_stableStringify(val);
  }

  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}

function getTreeCache(eviction, maxSize, mapNodeValue, name) {
  switch (eviction) {
    case 'keep-all':
      return new TreeCache$2({
        name,
        mapNodeValue
      });

    case 'lru':
      return Recoil_treeCacheLRU({
        name,
        maxSize: Recoil_nullthrows(maxSize),
        mapNodeValue
      });

    case 'most-recent':
      return Recoil_treeCacheLRU({
        name,
        maxSize: 1,
        mapNodeValue
      });
  }

  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}

var Recoil_treeCacheFromPolicy = treeCacheFromPolicy;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function isNode(object) {
  var _ownerDocument, _doc$defaultView;

  if (typeof window === 'undefined') {
    return false;
  }

  const doc = object != null ? (_ownerDocument = object.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object : document;
  const defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
  return !!(object != null && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

var Recoil_isNode = (/* unused pure expression or super */ null && (isNode));

const {
  isReactNative: isReactNative$1,
  isWindow: isWindow$1
} = Recoil_Environment;





function shouldNotBeFrozen(value) {
  // Primitives and functions:
  if (value === null || typeof value !== 'object') {
    return true;
  } // React elements:


  switch (typeof value.$$typeof) {
    case 'symbol':
      return true;

    case 'number':
      return true;
  } // Immutable structures:


  if (value['@@__IMMUTABLE_ITERABLE__@@'] != null || value['@@__IMMUTABLE_KEYED__@@'] != null || value['@@__IMMUTABLE_INDEXED__@@'] != null || value['@@__IMMUTABLE_ORDERED__@@'] != null || value['@@__IMMUTABLE_RECORD__@@'] != null) {
    return true;
  } // DOM nodes:


  if (Recoil_isNode(value)) {
    return true;
  }

  if (Recoil_isPromise(value)) {
    return true;
  }

  if (value instanceof Error) {
    return true;
  }

  if (ArrayBuffer.isView(value)) {
    return true;
  } // Some environments, just as Jest, don't work with the instanceof check


  if (!isReactNative$1 && isWindow$1(value)) {
    return true;
  }

  return false;
} // Recursively freeze a value to enforce it is read-only.
// This may also have minimal performance improvements for enumerating
// objects (based on browser implementations, of course)


function deepFreezeValue(value) {
  if (typeof value !== 'object' || shouldNotBeFrozen(value)) {
    return;
  }

  Object.freeze(value); // Make all properties read-only

  for (const key in value) {
    // $FlowIssue[method-unbinding] added when improving typing for this parameters
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      const prop = value[key]; // Prevent infinite recurssion for circular references.

      if (typeof prop === 'object' && prop != null && !Object.isFrozen(prop)) {
        deepFreezeValue(prop);
      }
    }
  }

  Object.seal(value); // This also makes existing properties non-configurable.
}

var Recoil_deepFreezeValue = (/* unused pure expression or super */ null && (deepFreezeValue));

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is a stub for some integration into FB internal stuff
 *
 * 
 * @format
 * @oncall recoil
 */
function startPerfBlock(_id) {
  return () => null;
}

var Recoil_PerformanceTimings = {
  startPerfBlock
};

const {
  isLoadable: isLoadable$1,
  loadableWithError: loadableWithError$1,
  loadableWithPromise: loadableWithPromise$1,
  loadableWithValue: loadableWithValue$2
} = Recoil_Loadable$1;

const {
  WrappedValue: WrappedValue$1
} = Recoil_Wrapper$1;



const {
  getNodeLoadable: getNodeLoadable$2,
  peekNodeLoadable: peekNodeLoadable$1,
  setNodeValue: setNodeValue$3
} = Recoil_FunctionalCore;

const {
  saveDepsToStore: saveDepsToStore$1
} = Recoil_Graph;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$6,
  getConfigDeletionHandler: getConfigDeletionHandler$1,
  getNode: getNode$6,
  registerNode: registerNode$1
} = Recoil_Node;

const {
  isRecoilValue: isRecoilValue$3
} = Recoil_RecoilValue$1;

const {
  markRecoilValueModified: markRecoilValueModified$1
} = Recoil_RecoilValueInterface;

const {
  retainedByOptionWithDefault: retainedByOptionWithDefault$1
} = Recoil_Retention;

const {
  recoilCallback: recoilCallback$1
} = Recoil_useRecoilCallback;



















const {
  startPerfBlock: startPerfBlock$1
} = Recoil_PerformanceTimings;



class Canceled {}

const CANCELED = new Canceled();
/**
 * An ExecutionID is an arbitrary ID that lets us distinguish executions from
 * each other. This is necessary as we need a way of solving this problem:
 * "given 3 async executions, only update state for the 'latest' execution when
 * it finishes running regardless of when the other 2 finish". ExecutionIDs
 * provide a convenient way of identifying executions so that we can track and
 * manage them over time.
 */

const dependencyStack = []; // for detecting circular dependencies.

const waitingStores = new Map();

const getNewExecutionID = (() => {
  let executionID = 0;
  return () => executionID++;
})();
/* eslint-disable no-redeclare */


function selector(options) {
  let recoilValue = null;
  const {
    key,
    get,
    cachePolicy_UNSTABLE: cachePolicy
  } = options;
  const set = options.set != null ? options.set : undefined; // flow

  if (false) {} // This is every discovered dependency across all executions


  const discoveredDependencyNodeKeys = new Set();
  const cache = Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
    equality: 'reference',
    eviction: 'keep-all'
  }, key);
  const retainedBy = retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
  const executionInfoMap = new Map();
  let liveStoresCount = 0;

  function selectorIsLive() {
    return !Recoil_gkx('recoil_memory_managament_2020') || liveStoresCount > 0;
  }

  function selectorInit(store) {
    store.getState().knownSelectors.add(key);
    liveStoresCount++;
    return () => {
      liveStoresCount--;
    };
  }

  function selectorShouldDeleteConfigOnRelease() {
    return getConfigDeletionHandler$1(key) !== undefined && !selectorIsLive();
  }

  function resolveAsync(store, state, executionID, loadable, depValues) {
    setCache(state, loadable, depValues);
    notifyStoresOfResolvedAsync(store, executionID);
  }

  function notifyStoresOfResolvedAsync(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      clearExecutionInfo(store);
    }

    notifyWaitingStores(executionID, true);
  }
  /**
   * Notify stores to pull the selector again if a new async dep was discovered.
   * 1) Async selector adds a new dep but doesn't resolve yet.
   *    Note that deps for an async selector are based on the state when the
   *    evaluation started, in order to provide a consistent picture of state.
   * 2) But, new value of dep based on the current state might cause the selector
   *    to resolve or resolve differently.
   * 3) Therefore, this notification will pull the selector based on the current
   *    state for the components
   */


  function notifyStoresOfNewAsyncDep(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      const executionInfo = Recoil_nullthrows(getExecutionInfo(store));
      executionInfo.stateVersions.clear();
      notifyWaitingStores(executionID, false);
    }
  }

  function notifyWaitingStores(executionID, clearWaitlist) {
    const stores = waitingStores.get(executionID);

    if (stores != null) {
      for (const waitingStore of stores) {
        markRecoilValueModified$1(waitingStore, Recoil_nullthrows(recoilValue));
      }

      if (clearWaitlist) {
        waitingStores.delete(executionID);
      }
    }
  }

  function markStoreWaitingForResolvedAsync(store, executionID) {
    let stores = waitingStores.get(executionID);

    if (stores == null) {
      waitingStores.set(executionID, stores = new Set());
    }

    stores.add(store);
  }
  /**
   * This function attaches a then() and a catch() to a promise that was
   * returned from a selector's get() (either explicitly or implicitly by
   * running a function that uses the "async" keyword). If a selector's get()
   * returns a promise, we have two possibilities:
   *
   * 1. The promise will resolve, in which case it will have completely finished
   *    executing without any remaining pending dependencies. No more retries
   *    are needed and we can proceed with updating the cache and notifying
   *    subscribers (if it is the latest execution, otherwise only the cache
   *    will be updated and subscriptions will not be fired). This is the case
   *    handled by the attached then() handler.
   *
   * 2. The promise will throw because it either has an error or it came across
   *    an async dependency that has not yet resolved, in which case we will
   *    call wrapDepdencyPromise(), whose responsibility is to handle dependency
   *    promises. This case is handled by the attached catch() handler.
   *
   * Both branches will eventually resolve to the final result of the selector
   * (or an error if a real error occurred).
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was thrown--AKA a
   * dependency promise. Dependency promises should be passed to
   * wrapPendingDependencyPromise()).
   */


  function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
    return promise.then(value => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      }

      const loadable = loadableWithValue$2(value);
      resolveAsync(store, state, executionID, loadable, depValues);
      return value;
    }).catch(errorOrPromise => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      }

      if (Recoil_isPromise(errorOrPromise)) {
        return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
      }

      const loadable = loadableWithError$1(errorOrPromise);
      resolveAsync(store, state, executionID, loadable, depValues);
      throw errorOrPromise;
    });
  }
  /**
   * This function attaches a then() and a catch() to a promise that was
   * thrown from a selector's get(). If a selector's get() throws a promise,
   * we have two possibilities:
   *
   * 1. The promise will resolve, meaning one of our selector's dependencies is
   *    now available and we should "retry" our get() by running it again. This
   *    is the case handled by the attached then() handler.
   *
   * 2. The promise will throw because something went wrong with the dependency
   *    promise (in other words a real error occurred). This case is handled by
   *    the attached catch() handler. If the dependency promise throws, it is
   *    _always_ a real error and not another dependency promise (any dependency
   *    promises would have been handled upstream).
   *
   * The then() branch will eventually resolve to the final result of the
   * selector (or an error if a real error occurs), and the catch() will always
   * resolve to an error because the dependency promise is a promise that was
   * wrapped upstream, meaning it will only resolve to its real value or to a
   * real error.
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was returned from
   * get(). The intention is that this function is only passed promises that
   * were thrown due to a pending dependency. Promises returned by get() should
   * be passed to wrapResultPromise() instead.
   */


  function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
    return promise.then(resolvedDep => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      } // Check if we are handling a pending Recoil dependency or if the user
      // threw their own Promise to "suspend" a selector evaluation.  We need
      // to check that the loadingDepPromise actually matches the promise that
      // we caught in case the selector happened to catch the promise we threw
      // for a pending Recoil dependency from `getRecoilValue()` and threw
      // their own promise instead.


      if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) {
        /**
         * Note for async atoms, this means we are changing the atom's value
         * in the store for the given version. This should be alright because
         * the version of state is now stale and a new version will have
         * already been triggered by the atom being resolved (see this logic
         * in Recoil_atom.js)
         */
        state.atomValues.set(loadingDepsState.loadingDepKey, loadableWithValue$2(resolvedDep));
      } else {
        /**
         * If resolvedDepKey is not defined, the promise was a user-thrown
         * promise. User-thrown promises are an advanced feature and they
         * should be avoided in almost all cases. Using `loadable.map()` inside
         * of selectors for loading loadables and then throwing that mapped
         * loadable's promise is an example of a user-thrown promise.
         *
         * When we hit a user-thrown promise, we have to bail out of an optimization
         * where we bypass calculating selector cache keys for selectors that
         * have been previously seen for a given state (these selectors are saved in
         * state.atomValues) to avoid stale state as we have no way of knowing
         * what state changes happened (if any) in result to the promise resolving.
         *
         * Ideally we would only bail out selectors that are in the chain of
         * dependencies for this selector, but there's currently no way to get
         * a full list of a selector's downstream nodes because the state that
         * is executing may be a discarded tree (so store.getGraph(state.version)
         * will be empty), and the full dep tree may not be in the selector
         * caches in the case where the selector's cache was cleared. To solve
         * for this we would have to keep track of all running selector
         * executions and their downstream deps. Because this only covers edge
         * cases, that complexity might not be justifyable.
         */
        store.getState().knownSelectors.forEach(nodeKey => {
          state.atomValues.delete(nodeKey);
        });
      }
      /**
       * Optimization: Now that the dependency has resolved, let's try hitting
       * the cache in case the dep resolved to a value we have previously seen.
       *
       * TODO:
       * Note this optimization is not perfect because it only prevents re-executions
       * _after_ the point where an async dependency is found. Any code leading
       * up to the async dependency may have run unnecessarily. The ideal case
       * would be to wait for the async dependency to resolve first, check the
       * cache, and prevent _any_ execution of the selector if the resulting
       * value of the dependency leads to a path that is found in the cache.
       * The ideal case is more difficult to implement as it would require that
       * we capture and wait for the the async dependency right after checking
       * the cache. The current approach takes advantage of the fact that running
       * the selector already has a code path that lets us exit early when
       * an async dep resolves.
       */


      const cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);

      if (cachedLoadable && cachedLoadable.state !== 'loading') {
        /**
         * This has to notify stores of a resolved async, even if there is no
         * current pending execution for the following case:
         * 1) A component renders with this pending loadable.
         * 2) The upstream dependency resolves.
         * 3) While processing some other selector it reads this one, such as
         *    while traversing its dependencies.  At this point it gets the
         *    new resolved value synchronously and clears the current
         *    execution ID.  The component wasn't getting the value itself,
         *    though, so it still has the pending loadable.
         * 4) When this code executes the current execution id was cleared
         *    and it wouldn't notify the component of the new value.
         *
         * I think this is only an issue with "early" rendering since the
         * components got their value using the in-progress execution.
         * We don't have a unit test for this case yet.  I'm not sure it is
         * necessary with recoil_transition_support mode.
         */
        if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) {
          notifyStoresOfResolvedAsync(store, executionID);
        }

        if (cachedLoadable.state === 'hasValue') {
          return cachedLoadable.contents;
        } else {
          throw cachedLoadable.contents;
        }
      }
      /**
       * If this execution is stale, let's check to see if there is some in
       * progress execution with a matching state. If we find a match, then
       * we can take the value from that in-progress execution. Note this may
       * sound like an edge case, but may be very common in cases where a
       * loading dependency resolves from loading to having a value (thus
       * possibly triggering a re-render), and React re-renders before the
       * chained .then() functions run, thus starting a new execution as the
       * dep has changed value. Without this check we will run the selector
       * twice (once in the new execution and once again in this .then(), so
       * this check is necessary to keep unnecessary re-executions to a
       * minimum).
       *
       * Also note this code does not check across all executions that may be
       * running. It only optimizes for the _latest_ execution per store as
       * we currently do not maintain a list of all currently running executions.
       * This means in some cases we may run selectors more than strictly
       * necessary when there are multiple executions running for the same
       * selector. This may be a valid tradeoff as checking for dep changes
       * across all in-progress executions may take longer than just
       * re-running the selector. This will be app-dependent, and maybe in the
       * future we can make the behavior configurable. An ideal fix may be
       * to extend the tree cache to support caching loading states.
       */


      if (!isLatestExecution(store, executionID)) {
        const executionInfo = getInProgressExecutionInfo(store, state);

        if (executionInfo != null) {
          /**
           * Returning promise here without wrapping as the wrapper logic was
           * already done upstream when this promise was generated.
           */
          return executionInfo.loadingLoadable.contents;
        }
      } // Retry the selector evaluation now that the dependency has resolved


      const [loadable, depValues] = evaluateSelectorGetter(store, state, executionID);

      if (loadable.state !== 'loading') {
        resolveAsync(store, state, executionID, loadable, depValues);
      }

      if (loadable.state === 'hasError') {
        throw loadable.contents;
      }

      return loadable.contents;
    }).catch(error => {
      // The selector was released since the request began; ignore the response.
      if (error instanceof Canceled) {
        throw CANCELED;
      }

      if (!selectorIsLive()) {
        clearExecutionInfo(store);
        throw CANCELED;
      }

      const loadable = loadableWithError$1(error);
      resolveAsync(store, state, executionID, loadable, existingDeps);
      throw error;
    });
  }

  function updateDeps(store, state, deps, executionID) {
    var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;

    if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
      var _store$getState$nextT, _store$getState3, _store$getState3$next;

      saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
    }

    for (const nodeKey of deps) {
      discoveredDependencyNodeKeys.add(nodeKey);
    }
  }

  function evaluateSelectorGetter(store, state, executionID) {
    const endPerfBlock = startPerfBlock$1(key); // TODO T63965866: use execution ID here

    let duringSynchronousExecution = true;
    let duringAsynchronousExecution = true;

    const finishEvaluation = () => {
      endPerfBlock();
      duringAsynchronousExecution = false;
    };

    let result;
    let resultIsError = false;
    let loadable;
    const loadingDepsState = {
      loadingDepKey: null,
      loadingDepPromise: null
    };
    /**
     * Starting a fresh set of deps that we'll be using to update state. We're
     * starting a new set versus adding it in existing state deps because
     * the version of state that we update deps for may be a more recent version
     * than the version the selector was called with. This is because the latest
     * execution will update the deps of the current/latest version of state
     * (This is safe to do because the fact that the selector is the latest
     * execution means the deps we discover below are our best guess at the
     * deps for the current/latest state in the store)
     */

    const depValues = new Map();

    function getRecoilValue({
      key: depKey
    }) {
      const depLoadable = getNodeLoadable$2(store, state, depKey);
      depValues.set(depKey, depLoadable); // We need to update asynchronous dependencies as we go so the selector
      // knows if it has to restart evaluation if one of them is updated before
      // the asynchronous selector completely resolves.

      if (!duringSynchronousExecution) {
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        notifyStoresOfNewAsyncDep(store, executionID);
      }

      switch (depLoadable.state) {
        case 'hasValue':
          return depLoadable.contents;

        case 'hasError':
          throw depLoadable.contents;

        case 'loading':
          loadingDepsState.loadingDepKey = depKey;
          loadingDepsState.loadingDepPromise = depLoadable.contents;
          throw depLoadable.contents;
      }

      throw Recoil_err('Invalid Loadable state');
    }

    const getCallback = fn => {
      return (...args) => {
        if (duringAsynchronousExecution) {
          throw Recoil_err('Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.');
        }

        !(recoilValue != null) ?  false ? 0 : Recoil_invariant(false) : void 0;
        return recoilCallback$1(store, fn, args, {
          node: recoilValue
        } // flowlint-line unclear-type:off
        );
      };
    };

    try {
      result = get({
        get: getRecoilValue,
        getCallback
      });
      result = isRecoilValue$3(result) ? getRecoilValue(result) : result;

      if (isLoadable$1(result)) {
        if (result.state === 'hasError') {
          resultIsError = true;
        }

        result = result.contents;
      }

      if (Recoil_isPromise(result)) {
        result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        finishEvaluation();
      }

      result = result instanceof WrappedValue$1 ? result.value : result;
    } catch (errorOrDepPromise) {
      result = errorOrDepPromise;

      if (Recoil_isPromise(result)) {
        result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        resultIsError = true;
        finishEvaluation();
      }
    }

    if (resultIsError) {
      loadable = loadableWithError$1(result);
    } else if (Recoil_isPromise(result)) {
      loadable = loadableWithPromise$1(result);
    } else {
      loadable = loadableWithValue$2(result);
    }

    duringSynchronousExecution = false;
    updateExecutionInfoDepValues(store, executionID, depValues);
    updateDeps(store, state, new Set(depValues.keys()), executionID);
    return [loadable, depValues];
  }

  function getLoadableFromCacheAndUpdateDeps(store, state) {
    // First, look up in the state cache
    // If it's here, then the deps in the store should already be valid.
    let cachedLoadable = state.atomValues.get(key);

    if (cachedLoadable != null) {
      return cachedLoadable;
    } // Second, look up in the selector cache and update the deps in the store


    const depsAfterCacheLookup = new Set();

    try {
      cachedLoadable = cache.get(nodeKey => {
        !(typeof nodeKey === 'string') ?  false ? 0 : Recoil_invariant(false) : void 0;
        return getNodeLoadable$2(store, state, nodeKey).contents;
      }, {
        onNodeVisit: node => {
          if (node.type === 'branch' && node.nodeKey !== key) {
            depsAfterCacheLookup.add(node.nodeKey);
          }
        }
      });
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector "${key}": ${error.message}`);
    }

    if (cachedLoadable) {
      var _getExecutionInfo;

      // Cache the results in the state to allow for cheaper lookup than
      // iterating the tree cache of dependencies.
      state.atomValues.set(key, cachedLoadable);
      /**
       * Ensure store contains correct dependencies if we hit the cache so that
       * the store deps and cache are in sync for a given state. This is important
       * because store deps are normally updated when new executions are created,
       * but cache hits don't trigger new executions but they still _may_ signify
       * a change in deps in the store if the store deps for this state are empty
       * or stale.
       */

      updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
    }

    return cachedLoadable;
  }
  /**
   * Given a tree state, this function returns a Loadable of the current state.
   *
   * The selector's get() function will only be re-evaluated if _both_ of the
   * following statements are true:
   *
   * 1. The current dep values from the given state produced a cache key that
   *    was not found in the cache.
   * 2. There is no currently running async execution OR there is an
   *    async execution that is running, but after comparing the dep values in
   *    the given state with the dep values that the execution has discovered so
   *    far we find that at least one dep value has changed, in which case we
   *    start a new execution (the previously running execution will continue to
   *    run to completion, but only the new execution will be deemed the
   *    'latest' execution, meaning it will be the only execution that will
   *    update global state when it is finished. Any non-latest executions will
   *    run to completion and update the selector cache but not global state).
   */


  function getSelectorLoadableAndUpdateDeps(store, state) {
    // First, see if our current state is cached
    const cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);

    if (cachedVal != null) {
      clearExecutionInfo(store);
      return cachedVal;
    } // Second, check if there is already an ongoing execution based on the current state


    const inProgressExecutionInfo = getInProgressExecutionInfo(store, state);

    if (inProgressExecutionInfo != null) {
      var _inProgressExecutionI;

      if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === 'loading') {
        markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
      } // FIXME: check after the fact to see if we made the right choice by waiting


      return inProgressExecutionInfo.loadingLoadable;
    } // Third, start a new evaluation of the selector


    const newExecutionID = getNewExecutionID();
    const [loadable, newDepValues] = evaluateSelectorGetter(store, state, newExecutionID);
    /**
     * Conditionally updates the cache with a given loadable.
     *
     * We only cache loadables that are not loading because our cache keys are
     * based on dep values, which are in an unfinished state for loadables that
     * have a 'loading' state (new deps may be discovered while the selector
     * runs its async code). We never want to cache partial dependencies b/c it
     * could lead to errors, such as prematurely returning the result based on a
     * partial list of deps-- we need the full list of deps to ensure that we
     * are returning the correct result from cache.
     */

    if (loadable.state === 'loading') {
      setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
      markStoreWaitingForResolvedAsync(store, newExecutionID);
    } else {
      clearExecutionInfo(store);
      setCache(state, loadable, newDepValues);
    }

    return loadable;
  }
  /**
   * Searches execution info across all stores to see if there is an in-progress
   * execution whose dependency values match the values of the requesting store.
   */


  function getInProgressExecutionInfo(store, state) {
    // Sort the pending executions so that our current store is checked first.
    const pendingExecutions = Recoil_concatIterables([executionInfoMap.has(store) ? [Recoil_nullthrows(executionInfoMap.get(store))] : [], Recoil_mapIterable(Recoil_filterIterable(executionInfoMap, ([s]) => s !== store), ([, execInfo]) => execInfo)]);

    function anyDepChanged(execDepValues) {
      for (const [depKey, execLoadable] of execDepValues) {
        if (!getNodeLoadable$2(store, state, depKey).is(execLoadable)) {
          return true;
        }
      }

      return false;
    }

    for (const execInfo of pendingExecutions) {
      if ( // If this execution was already checked to be valid with this version
      // of state, then let's use it!
      execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
      !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)) {
        execInfo.stateVersions.set(state.version, true);
        return execInfo;
      } else {
        execInfo.stateVersions.set(state.version, false);
      }
    }

    return undefined;
  }

  function getExecutionInfo(store) {
    return executionInfoMap.get(store);
  }
  /**
   * This function will update the selector's execution info when the selector
   * has either finished running an execution or has started a new execution. If
   * the given loadable is in a 'loading' state, the intention is that a new
   * execution has started. Otherwise, the intention is that an execution has
   * just finished.
   */


  function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
    executionInfoMap.set(store, {
      depValuesDiscoveredSoFarDuringAsyncWork: depValues,
      executionID: newExecutionID,
      loadingLoadable: loadable,
      stateVersions: new Map([[state.version, true]])
    });
  }

  function updateExecutionInfoDepValues(store, executionID, depValues) {
    // We only need to bother updating the deps for the latest execution because
    // that's all getInProgressExecutionInfo() will be looking for.
    if (isLatestExecution(store, executionID)) {
      const executionInfo = getExecutionInfo(store);

      if (executionInfo != null) {
        executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
      }
    }
  }

  function clearExecutionInfo(store) {
    executionInfoMap.delete(store);
  }

  function isLatestExecution(store, executionID) {
    var _getExecutionInfo2;

    return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
  }
  /**
   * FIXME: dep keys should take into account the state of the loadable to
   * prevent the edge case where a loadable with an error and a loadable with
   * an error as a value are treated as the same thing incorrectly. For example
   * these two should be treated differently:
   *
   * selector({key: '', get: () => new Error('hi')});
   * selector({key: '', get () => {throw new Error('hi')}});
   *
   * With current implementation they are treated the same
   */


  function depValuesToDepRoute(depValues) {
    return Array.from(depValues.entries()).map(([depKey, valLoadable]) => [depKey, valLoadable.contents]);
  }

  function setCache(state, loadable, depValues) {
    if (false) {}

    state.atomValues.set(key, loadable);

    try {
      cache.set(depValuesToDepRoute(depValues), loadable);
    } catch (error) {
      throw Recoil_err(`Problem with setting cache for selector "${key}": ${error.message}`);
    }
  }

  function detectCircularDependencies(fn) {
    if (dependencyStack.includes(key)) {
      const message = `Recoil selector has circular dependencies: ${dependencyStack.slice(dependencyStack.indexOf(key)).join(' \u2192 ')}`;
      return loadableWithError$1(Recoil_err(message));
    }

    dependencyStack.push(key);

    try {
      return fn();
    } finally {
      dependencyStack.pop();
    }
  }

  function selectorPeek(store, state) {
    const cachedLoadable = state.atomValues.get(key);

    if (cachedLoadable != null) {
      return cachedLoadable;
    }

    return cache.get(nodeKey => {
      var _peekNodeLoadable;

      !(typeof nodeKey === 'string') ?  false ? 0 : Recoil_invariant(false) : void 0;
      return (_peekNodeLoadable = peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
    });
  }

  function selectorGet(store, state) {
    return detectCircularDependencies(() => getSelectorLoadableAndUpdateDeps(store, state));
  }

  function invalidateSelector(state) {
    state.atomValues.delete(key);
  }

  function clearSelectorCache(store, treeState) {
    !(recoilValue != null) ?  false ? 0 : Recoil_invariant(false) : void 0;

    for (const nodeKey of discoveredDependencyNodeKeys) {
      var _node$clearCache;

      const node = getNode$6(nodeKey);
      (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node, store, treeState);
    }

    discoveredDependencyNodeKeys.clear();
    invalidateSelector(treeState);
    cache.clear();
    markRecoilValueModified$1(store, recoilValue);
  }

  if (set != null) {
    /**
     * ES5 strict mode prohibits defining non-top-level function declarations,
     * so don't use function declaration syntax here
     */
    const selectorSet = (store, state, newValue) => {
      let syncSelectorSetFinished = false;
      const writes = new Map();

      function getRecoilValue({
        key: depKey
      }) {
        if (syncSelectorSetFinished) {
          throw Recoil_err('Recoil: Async selector sets are not currently supported.');
        }

        const loadable = getNodeLoadable$2(store, state, depKey);

        if (loadable.state === 'hasValue') {
          return loadable.contents;
        } else if (loadable.state === 'loading') {
          const msg = `Getting value of asynchronous atom or selector "${depKey}" in a pending state while setting selector "${key}" is not yet supported.`;
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        } else {
          throw loadable.contents;
        }
      }

      function setRecoilState(recoilState, valueOrUpdater // $FlowFixMe[missing-local-annot]
      ) {
        if (syncSelectorSetFinished) {
          const msg = 'Recoil: Async selector sets are not currently supported.';
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        }

        const setValue = typeof valueOrUpdater === 'function' ? // cast to any because we can't restrict type S from being a function itself without losing support for opaque types
        // flowlint-next-line unclear-type:off
        valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
        const upstreamWrites = setNodeValue$3(store, state, recoilState.key, setValue);
        upstreamWrites.forEach((v, k) => writes.set(k, v));
      }

      function resetRecoilState(recoilState) {
        setRecoilState(recoilState, DEFAULT_VALUE$6);
      }

      const ret = set({
        set: setRecoilState,
        get: getRecoilValue,
        reset: resetRecoilState
      }, newValue); // set should be a void method, but if the user makes it `async`, then it
      // will return a Promise, which we don't currently support.

      if (ret !== undefined) {
        throw Recoil_isPromise(ret) ? Recoil_err('Recoil: Async selector sets are not currently supported.') : Recoil_err('Recoil: selector set should be a void function.');
      }

      syncSelectorSetFinished = true;
      return writes;
    };

    return recoilValue = registerNode$1({
      key,
      nodeType: 'selector',
      peek: selectorPeek,
      get: selectorGet,
      set: selectorSet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  } else {
    return recoilValue = registerNode$1({
      key,
      nodeType: 'selector',
      peek: selectorPeek,
      get: selectorGet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  }
}
/* eslint-enable no-redeclare */
// $FlowIssue[incompatible-use]
// $FlowFixMe[missing-local-annot]


selector.value = value => new WrappedValue$1(value);

var Recoil_selector = selector;

// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
// @fb-only: const {scopedAtom} = require('Recoil_ScopedAtom');
const {
  isLoadable: isLoadable$2,
  loadableWithError: loadableWithError$2,
  loadableWithPromise: loadableWithPromise$2,
  loadableWithValue: loadableWithValue$3
} = Recoil_Loadable$1;

const {
  WrappedValue: WrappedValue$2
} = Recoil_Wrapper$1;

const {
  peekNodeInfo: peekNodeInfo$3
} = Recoil_FunctionalCore;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$7,
  DefaultValue: DefaultValue$2,
  getConfigDeletionHandler: getConfigDeletionHandler$2,
  registerNode: registerNode$2,
  setConfigDeletionHandler: setConfigDeletionHandler$1
} = Recoil_Node;

const {
  isRecoilValue: isRecoilValue$4
} = Recoil_RecoilValue$1;

const {
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$4,
  markRecoilValueModified: markRecoilValueModified$2,
  setRecoilValue: setRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$2
} = Recoil_RecoilValueInterface;

const {
  retainedByOptionWithDefault: retainedByOptionWithDefault$2
} = Recoil_Retention;















const unwrap = x => x instanceof WrappedValue$2 ? x.value : x;

function baseAtom(options) {
  const {
    key,
    persistence_UNSTABLE: persistence
  } = options;
  const retainedBy = retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
  let liveStoresCount = 0;

  function unwrapPromise(promise) {
    return loadableWithPromise$2(promise.then(value => {
      defaultLoadable = loadableWithValue$3(value);
      return value;
    }).catch(error => {
      defaultLoadable = loadableWithError$2(error);
      throw error;
    }));
  }

  let defaultLoadable = Recoil_isPromise(options.default) ? unwrapPromise(options.default) : isLoadable$2(options.default) ? options.default.state === 'loading' ? unwrapPromise(options.default.contents) : options.default : // $FlowFixMe[incompatible-call]
  loadableWithValue$3(unwrap(options.default));
  maybeFreezeValueOrPromise(defaultLoadable.contents);
  let cachedAnswerForUnvalidatedValue = undefined; // Cleanup handlers for this atom
  // Rely on stable reference equality of the store to use it as a key per <RecoilRoot>

  const cleanupEffectsByStore = new Map();

  function maybeFreezeValueOrPromise(valueOrPromise) {
    if (false) {}

    return valueOrPromise;
  }

  function wrapPendingPromise(store, promise) {
    const wrappedPromise = promise.then(value => {
      var _store$getState$nextT, _state$atomValues$get;

      const state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;

      if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) {
        setRecoilValue$4(store, node, value);
      }

      return value;
    }).catch(error => {
      var _store$getState$nextT2, _state$atomValues$get2;

      const state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;

      if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) {
        setRecoilValueLoadable$2(store, node, loadableWithError$2(error));
      }

      throw error;
    });
    return wrappedPromise;
  }

  function initAtom(store, initState, trigger) {
    var _options$effects;

    liveStoresCount++;

    const cleanupAtom = () => {
      var _cleanupEffectsByStor;

      liveStoresCount--;
      (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 ? void 0 : _cleanupEffectsByStor.forEach(cleanup => cleanup());
      cleanupEffectsByStore.delete(store);
    };

    store.getState().knownAtoms.add(key); // Setup async defaults to notify subscribers when they resolve

    if (defaultLoadable.state === 'loading') {
      const notifyDefaultSubscribers = () => {
        var _store$getState$nextT3;

        const state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;

        if (!state.atomValues.has(key)) {
          markRecoilValueModified$2(store, node);
        }
      };

      defaultLoadable.contents.finally(notifyDefaultSubscribers);
    } ///////////////////
    // Run Atom Effects
    ///////////////////


    const effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;

    if (effects != null) {
      // This state is scoped by Store, since this is in the initAtom() closure
      let initValue = DEFAULT_VALUE$7;
      let isDuringInit = true;
      let isInitError = false;
      let pendingSetSelf = null;

      function getLoadable(recoilValue) {
        // Normally we can just get the current value of another atom.
        // But for our own value we need to check if there is a pending
        // initialized value or get the fallback default value.
        if (isDuringInit && recoilValue.key === key) {
          // Cast T to S
          const retValue = initValue; // flowlint-line unclear-type:off

          return retValue instanceof DefaultValue$2 ? peekAtom(store, initState) // flowlint-line unclear-type:off
          : Recoil_isPromise(retValue) ? loadableWithPromise$2(retValue.then(v => v instanceof DefaultValue$2 ? // Cast T to S
          defaultLoadable.toPromise() // flowlint-line unclear-type:off
          : v)) : // $FlowFixMe[incompatible-call]
          loadableWithValue$3(retValue);
        }

        return getRecoilValueAsLoadable$4(store, recoilValue);
      }

      function getPromise(recoilValue) {
        return getLoadable(recoilValue).toPromise();
      }

      function getInfo_UNSTABLE(recoilValue) {
        var _store$getState$nextT4;

        const info = peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
        return isDuringInit && recoilValue.key === key && !(initValue instanceof DefaultValue$2) ? { ...info,
          isSet: true,
          loadable: getLoadable(recoilValue)
        } : info;
      }

      const setSelf = effect => valueOrUpdater => {
        if (isDuringInit) {
          const currentLoadable = getLoadable(node);
          const currentValue = currentLoadable.state === 'hasValue' ? currentLoadable.contents : DEFAULT_VALUE$7;
          initValue = typeof valueOrUpdater === 'function' ? // cast to any because we can't restrict T from being a function without losing support for opaque types
          valueOrUpdater(currentValue) // flowlint-line unclear-type:off
          : valueOrUpdater;

          if (Recoil_isPromise(initValue)) {
            initValue = initValue.then(value => {
              // Avoid calling onSet() when setSelf() initializes with a Promise
              pendingSetSelf = {
                effect,
                value
              };
              return value;
            });
          }
        } else {
          if (Recoil_isPromise(valueOrUpdater)) {
            throw Recoil_err('Setting atoms to async values is not implemented.');
          }

          if (typeof valueOrUpdater !== 'function') {
            pendingSetSelf = {
              effect,
              value: unwrap(valueOrUpdater)
            };
          }

          setRecoilValue$4(store, node, typeof valueOrUpdater === 'function' ? currentValue => {
            const newValue = unwrap( // cast to any because we can't restrict T from being a function without losing support for opaque types
            valueOrUpdater(currentValue) // flowlint-line unclear-type:off
            ); // $FlowFixMe[incompatible-type]

            pendingSetSelf = {
              effect,
              value: newValue
            };
            return newValue;
          } : unwrap(valueOrUpdater));
        }
      };

      const resetSelf = effect => () => setSelf(effect)(DEFAULT_VALUE$7);

      const onSet = effect => handler => {
        var _cleanupEffectsByStor2;

        const {
          release
        } = store.subscribeToTransactions(currentStore => {
          var _currentTree$atomValu;

          // eslint-disable-next-line prefer-const
          let {
            currentTree,
            previousTree
          } = currentStore.getState();

          if (!previousTree) {
            Recoil_recoverableViolation('Transaction subscribers notified without a next tree being present -- this is a bug in Recoil');
            previousTree = currentTree; // attempt to trundle on
          }

          const newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;

          if (newLoadable.state === 'hasValue') {
            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;

            const newValue = newLoadable.contents;
            const oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
            const oldValue = oldLoadable.state === 'hasValue' ? oldLoadable.contents : DEFAULT_VALUE$7; // TODO This isn't actually valid, use as a placeholder for now.
            // Ignore atom value changes that were set via setSelf() in the same effect.
            // We will still properly call the handler if there was a subsequent
            // set from something other than an atom effect which was batched
            // with the `setSelf()` call.  However, we may incorrectly ignore
            // the handler if the subsequent batched call happens to set the
            // atom to the exact same value as the `setSelf()`.   But, in that
            // case, it was kind of a noop, so the semantics are debatable..

            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) {
              handler(newValue, oldValue, !currentTree.atomValues.has(key));
            } else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) {
              pendingSetSelf = null;
            }
          }
        }, key);
        cleanupEffectsByStore.set(store, [...((_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : []), release]);
      };

      for (const effect of effects) {
        try {
          const cleanup = effect({
            node,
            storeID: store.storeID,
            parentStoreID_UNSTABLE: store.parentStoreID,
            trigger,
            setSelf: setSelf(effect),
            resetSelf: resetSelf(effect),
            onSet: onSet(effect),
            getPromise,
            getLoadable,
            getInfo_UNSTABLE
          });

          if (cleanup != null) {
            var _cleanupEffectsByStor3;

            cleanupEffectsByStore.set(store, [...((_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : []), cleanup]);
          }
        } catch (error) {
          initValue = error;
          isInitError = true;
        }
      }

      isDuringInit = false; // Mutate initial state in place since we know there are no other subscribers
      // since we are the ones initializing on first use.

      if (!(initValue instanceof DefaultValue$2)) {
        var _store$getState$nextT5;

        const initLoadable = isInitError ? loadableWithError$2(initValue) : Recoil_isPromise(initValue) ? loadableWithPromise$2(wrapPendingPromise(store, initValue)) : loadableWithValue$3(unwrap(initValue));
        maybeFreezeValueOrPromise(initLoadable.contents);
        initState.atomValues.set(key, initLoadable); // If there is a pending transaction, then also mutate the next state tree.
        // This could happen if the atom was first initialized in an action that
        // also updated some other atom's state.

        (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 ? void 0 : _store$getState$nextT5.atomValues.set(key, initLoadable);
      }
    }

    return cleanupAtom;
  }

  function peekAtom(_store, state) {
    var _ref, _state$atomValues$get3;

    return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
  }

  function getAtom(_store, state) {
    if (state.atomValues.has(key)) {
      // Atom value is stored in state:
      return Recoil_nullthrows(state.atomValues.get(key));
    } else if (state.nonvalidatedAtoms.has(key)) {
      // Atom value is stored but needs validation before use.
      // We might have already validated it and have a cached validated value:
      if (cachedAnswerForUnvalidatedValue != null) {
        return cachedAnswerForUnvalidatedValue;
      }

      if (persistence == null) {
        Recoil_expectationViolation(`Tried to restore a persisted value for atom ${key} but it has no persistence settings.`);
        return defaultLoadable;
      }

      const nonvalidatedValue = state.nonvalidatedAtoms.get(key);
      const validatorResult = persistence.validator(nonvalidatedValue, DEFAULT_VALUE$7);
      const validatedValueLoadable = validatorResult instanceof DefaultValue$2 ? defaultLoadable : loadableWithValue$3(validatorResult);
      cachedAnswerForUnvalidatedValue = validatedValueLoadable;
      return cachedAnswerForUnvalidatedValue;
    } else {
      return defaultLoadable;
    }
  }

  function invalidateAtom() {
    cachedAnswerForUnvalidatedValue = undefined;
  }

  function setAtom(_store, state, newValue) {
    // Bail out if we're being set to the existing value, or if we're being
    // reset but have no stored value (validated or unvalidated) to reset from:
    if (state.atomValues.has(key)) {
      const existing = Recoil_nullthrows(state.atomValues.get(key));

      if (existing.state === 'hasValue' && newValue === existing.contents) {
        return new Map();
      }
    } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof DefaultValue$2) {
      return new Map();
    }

    maybeFreezeValueOrPromise(newValue);
    cachedAnswerForUnvalidatedValue = undefined; // can be released now if it was previously in use

    return new Map().set(key, loadableWithValue$3(newValue));
  }

  function shouldDeleteConfigOnReleaseAtom() {
    return getConfigDeletionHandler$2(key) !== undefined && liveStoresCount <= 0;
  }

  const node = registerNode$2({
    key,
    nodeType: 'atom',
    peek: peekAtom,
    get: getAtom,
    set: setAtom,
    init: initAtom,
    invalidate: invalidateAtom,
    shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
    dangerouslyAllowMutability: options.dangerouslyAllowMutability,
    persistence_UNSTABLE: options.persistence_UNSTABLE ? {
      type: options.persistence_UNSTABLE.type,
      backButton: options.persistence_UNSTABLE.backButton
    } : undefined,
    shouldRestoreFromSnapshots: true,
    retainedBy
  });
  return node;
} // prettier-ignore


function atom(options) {
  if (false) {}

  const { // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    ...restOptions
  } = options;
  const optionsDefault = 'default' in options ? // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
  options.default : new Promise(() => {});

  if (isRecoilValue$4(optionsDefault) // Continue to use atomWithFallback for promise defaults for scoped atoms
  // for now, since scoped atoms don't support async defaults
  // @fb-only: || (isPromise(optionsDefault) && scopeRules_APPEND_ONLY_READ_THE_DOCS)
  // @fb-only: || (isLoadable(optionsDefault) && scopeRules_APPEND_ONLY_READ_THE_DOCS)
  ) {
    return atomWithFallback({ ...restOptions,
      default: optionsDefault // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,

    }); // @fb-only: } else if (scopeRules_APPEND_ONLY_READ_THE_DOCS
    // @fb-only: && !isPromise(optionsDefault)
    // @fb-only: && !isLoadable(optionsDefault)
    // @fb-only: ) {
    // @fb-only: return scopedAtom<T>({
    // @fb-only: ...restOptions,
    // @fb-only: default: unwrap<T>(optionsDefault),
    // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    // @fb-only: });
  } else {
    return baseAtom({ ...restOptions,
      default: optionsDefault
    });
  }
}

function atomWithFallback(options) {
  const base = atom({ ...options,
    default: DEFAULT_VALUE$7,
    persistence_UNSTABLE: options.persistence_UNSTABLE === undefined ? undefined : { ...options.persistence_UNSTABLE,
      validator: storedValue => storedValue instanceof DefaultValue$2 ? storedValue : Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, DEFAULT_VALUE$7)
    },
    // TODO Hack for now.
    effects: options.effects,
    // flowlint-line unclear-type: off
    effects_UNSTABLE: options.effects_UNSTABLE // flowlint-line unclear-type: off

  }); // $FlowFixMe[incompatible-call]

  const sel = Recoil_selector({
    key: `${options.key}__withFallback`,
    get: ({
      get
    }) => {
      const baseValue = get(base);
      return baseValue instanceof DefaultValue$2 ? options.default : baseValue;
    },
    // $FlowFixMe[incompatible-call]
    set: ({
      set
    }, newValue) => set(base, newValue),
    // This selector does not need to cache as it is a wrapper selector
    // and the selector within the wrapper selector will have a cache
    // option by default
    cachePolicy_UNSTABLE: {
      eviction: 'most-recent'
    },
    dangerouslyAllowMutability: options.dangerouslyAllowMutability
  });
  setConfigDeletionHandler$1(sel.key, getConfigDeletionHandler$2(options.key));
  return sel;
} // $FlowFixMe[missing-local-annot]


atom.value = value => new WrappedValue$2(value);

var Recoil_atom = atom;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class MapCache {
  constructor(options) {
    var _options$mapKey;

    _defineProperty(this, "_map", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    this._map = new Map();
    this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : v => v;
  }

  size() {
    return this._map.size;
  }

  has(key) {
    return this._map.has(this._keyMapper(key));
  }

  get(key) {
    return this._map.get(this._keyMapper(key));
  }

  set(key, val) {
    this._map.set(this._keyMapper(key), val);
  }

  delete(key) {
    this._map.delete(this._keyMapper(key));
  }

  clear() {
    this._map.clear();
  }

}

var Recoil_MapCache = {
  MapCache
};

var Recoil_MapCache_1 = Recoil_MapCache.MapCache;

var Recoil_MapCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MapCache: Recoil_MapCache_1
});

const {
  LRUCache: LRUCache$2
} = Recoil_LRUCache$1;

const {
  MapCache: MapCache$1
} = Recoil_MapCache$1;







const defaultPolicy$1 = {
  equality: 'reference',
  eviction: 'none',
  maxSize: Infinity
};

function cacheFromPolicy({
  equality = defaultPolicy$1.equality,
  eviction = defaultPolicy$1.eviction,
  maxSize = defaultPolicy$1.maxSize
} = defaultPolicy$1) {
  const valueMapper = getValueMapper$1(equality);
  const cache = getCache(eviction, maxSize, valueMapper);
  return cache;
}

function getValueMapper$1(equality) {
  switch (equality) {
    case 'reference':
      return val => val;

    case 'value':
      return val => Recoil_stableStringify(val);
  }

  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}

function getCache(eviction, maxSize, mapKey) {
  switch (eviction) {
    case 'keep-all':
      return new MapCache$1({
        mapKey
      });

    case 'lru':
      return new LRUCache$2({
        mapKey,
        maxSize: Recoil_nullthrows(maxSize)
      });

    case 'most-recent':
      return new LRUCache$2({
        mapKey,
        maxSize: 1
      });
  }

  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}

var Recoil_cacheFromPolicy = cacheFromPolicy;

// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';


const {
  setConfigDeletionHandler: setConfigDeletionHandler$2
} = Recoil_Node;





// Process scopeRules to handle any entries which are functions taking parameters
// prettier-ignore
// @fb-only: function mapScopeRules<P>(
// @fb-only: scopeRules?: ParameterizedScopeRules<P>,
// @fb-only: param: P,
// @fb-only: ): ScopeRules | void {
// @fb-only: return scopeRules?.map(rule =>
// @fb-only: Array.isArray(rule)
// @fb-only: ? rule.map(entry => (typeof entry === 'function' ? entry(param) : entry))
// @fb-only: : rule,
// @fb-only: );
// @fb-only: }

/*
A function which returns an atom based on the input parameter.

Each unique parameter returns a unique atom. E.g.,

  const f = atomFamily(...);
  f({a: 1}) => an atom
  f({a: 2}) => a different atom

This allows components to persist local, private state using atoms.  Each
instance of the component may have a different key, which it uses as the
parameter for a family of atoms; in this way, each component will have
its own atom not shared by other instances.  These state keys may be composed
into children's state keys as well.
*/
function atomFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;

  const atomCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
    eviction: 'keep-all'
  }); // Simple atomFamily implementation to cache individual atoms based
  // on the parameter value equality.

  return params => {
    var _stableStringify, _options$effects;

    const cachedAtom = atomCache.get(params);

    if (cachedAtom != null) {
      return cachedAtom;
    }

    const {
      cachePolicyForParams_UNSTABLE,
      ...atomOptions
    } = options;
    const optionsDefault = 'default' in options ? // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
    options.default : new Promise(() => {});
    const newAtom = Recoil_atom({ ...atomOptions,
      key: `${options.key}__${(_stableStringify = Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}`,
      default: typeof optionsDefault === 'function' ? // The default was parameterized
      // Flow doesn't know that T isn't a function, so we need to case to any
      // $FlowIssue[incompatible-use]
      optionsDefault(params) : // Default may be a static value, promise, or RecoilValue
      optionsDefault,
      retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
      effects: typeof options.effects === 'function' ? options.effects(params) : typeof options.effects_UNSTABLE === 'function' ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE // prettier-ignore
      // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS: mapScopeRules(
      // @fb-only: options.scopeRules_APPEND_ONLY_READ_THE_DOCS,
      // @fb-only: params,
      // @fb-only: ),

    });
    atomCache.set(params, newAtom);
    setConfigDeletionHandler$2(newAtom.key, () => {
      atomCache.delete(params);
    });
    return newAtom;
  };
}

var Recoil_atomFamily = atomFamily;

const {
  setConfigDeletionHandler: setConfigDeletionHandler$3
} = Recoil_Node;





 // Keep in mind the parameter needs to be serializable as a cahche key
// using Recoil_stableStringify


// Add a unique index to each selector in case the cache implementation allows
// duplicate keys based on equivalent stringified parameters
let nextIndex = 0;
/* eslint-disable no-redeclare */

// Return a function that returns members of a family of selectors of the same type
// E.g.,
//
// const s = selectorFamily(...);
// s({a: 1}) => a selector
// s({a: 2}) => a different selector
//
// By default, the selectors are distinguished by distinct values of the
// parameter based on value equality, not reference equality.  This allows using
// object literals or other equivalent objects at callsites to not create
// duplicate cache entries.  This behavior may be overridden with the
// cacheImplementationForParams option.
function selectorFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;

  const selectorCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
    eviction: 'keep-all'
  });
  return params => {
    var _stableStringify;

    // Throw an error with selector key so that it is clear which
    // selector is causing an error
    let cachedSelector;

    try {
      cachedSelector = selectorCache.get(params);
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector ${options.key}: ${error.message}`);
    }

    if (cachedSelector != null) {
      return cachedSelector;
    }

    const myKey = `${options.key}__selectorFamily/${(_stableStringify = Recoil_stableStringify(params, {
      // It is possible to use functions in parameters if the user uses
      // a cache with reference equality thanks to the incrementing index.
      allowFunctions: true
    })) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}/${nextIndex++}`; // Append index in case values serialize to the same key string

    const myGet = callbacks => options.get(params)(callbacks);

    const myCachePolicy = options.cachePolicy_UNSTABLE;
    const retainedBy = typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
    let newSelector;

    if (options.set != null) {
      const set = options.set;

      const mySet = (callbacks, newValue) => set(params)(callbacks, newValue);

      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        set: mySet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    } else {
      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    }

    selectorCache.set(params, newSelector);
    setConfigDeletionHandler$3(newSelector.key, () => {
      selectorCache.delete(params);
    });
    return newSelector;
  };
}
/* eslint-enable no-redeclare */


var Recoil_selectorFamily = selectorFamily;

// flowlint-next-line unclear-type:off


const constantSelector = Recoil_selectorFamily({
  key: '__constant',
  get: constant => () => constant,
  cachePolicyForParams_UNSTABLE: {
    equality: 'reference'
  }
}); // Function that returns a selector which always produces the
// same constant value.  It may be called multiple times with the
// same value, based on reference equality, and will provide the
// same selector.

function constSelector(constant) {
  return constantSelector(constant);
}

var Recoil_constSelector = constSelector;

// flowlint-next-line unclear-type:off


const throwingSelector = Recoil_selectorFamily({
  key: '__error',
  get: message => () => {
    throw Recoil_err(message);
  },
  // TODO Why?
  cachePolicyForParams_UNSTABLE: {
    equality: 'reference'
  }
}); // Function that returns a selector which always throws an error
// with the provided message.

function errorSelector(message) {
  return throwingSelector(message);
}

var Recoil_errorSelector = errorSelector;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Wraps another recoil value and prevents writing to it.
 *
 * 
 * @format
 * @oncall recoil
 */

function readOnlySelector(atom) {
  // flowlint-next-line unclear-type: off
  return atom;
}

var Recoil_readOnlySelector = readOnlySelector;

const {
  loadableWithError: loadableWithError$3,
  loadableWithPromise: loadableWithPromise$3,
  loadableWithValue: loadableWithValue$4
} = Recoil_Loadable$1;





 /////////////////
//  TRUTH TABLE
/////////////////
// Dependencies        waitForNone         waitForAny        waitForAll       waitForAllSettled
//  [loading, loading]  [Promise, Promise]  Promise           Promise         Promise
//  [value, loading]    [value, Promise]    [value, Promise]  Promise         Promise
//  [value, value]      [value, value]      [value, value]    [value, value]  [value, value]
//
//  [error, loading]    [Error, Promise]    [Error, Promise]  Error           Promise
//  [error, error]      [Error, Error]      [Error, Error]    Error           [error, error]
//  [value, error]      [value, Error]      [value, Error]    Error           [value, error]
// Issue parallel requests for all dependencies and return the current
// status if they have results, have some error, or are still pending.


function concurrentRequests(getRecoilValue, deps) {
  const results = Array(deps.length).fill(undefined);
  const exceptions = Array(deps.length).fill(undefined);

  for (const [i, dep] of deps.entries()) {
    try {
      results[i] = getRecoilValue(dep);
    } catch (e) {
      // exceptions can either be Promises of pending results or real errors
      exceptions[i] = e;
    }
  }

  return [results, exceptions];
}

function isError(exp) {
  return exp != null && !Recoil_isPromise(exp);
}

function unwrapDependencies(dependencies) {
  return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map(key => dependencies[key]);
}

function wrapResults(dependencies,
/* $FlowFixMe[missing-local-annot] The type annotation(s) required by Flow's
 * LTI update could not be added via codemod */
results) {
  return Array.isArray(dependencies) ? results : // Object.getOwnPropertyNames() has consistent key ordering with ES6
  Object.getOwnPropertyNames(dependencies).reduce((out, key, idx) => ({ ...out,
    [key]: results[idx]
  }), {});
}

function wrapLoadables(dependencies, results, exceptions) {
  const output = exceptions.map((exception, idx) => exception == null ? loadableWithValue$4(results[idx]) : Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
  return wrapResults(dependencies, output);
}

function combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
  return asyncResults.map((result, idx) =>
  /**
   * it's important we use === undefined as opposed to == null, because the
   * resolved value of the async promise could be `null`, in which case we
   * don't want to use syncResults[idx], which would be undefined. If async
   * promise resolves to `undefined`, that's ok because `syncResults[idx]`
   * will also be `undefined`. That's a little hacky, but it works.
   */
  result === undefined ? syncResults[idx] : result);
} // Selector that requests all dependencies in parallel and immediately returns
// current results without waiting.


const waitForNone = Recoil_selectorFamily({
  key: '__waitForNone',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // Always return the current status of the results; never block.

    return wrapLoadables(dependencies, results, exceptions);
  },
  dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for at least
// one to be available before returning results.  It will only error if all
// dependencies have errors.

const waitForAny = Recoil_selectorFamily({
  key: '__waitForAny',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If any results are available, value or error, return the current status

    if (exceptions.some(exp => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    } // Otherwise, return a promise that will resolve when the next result is
    // available, whichever one happens to be next.  But, if all pending
    // dependencies end up with errors, then reject the promise.


    return new Promise(resolve => {
      for (const [i, exp] of exceptions.entries()) {
        if (Recoil_isPromise(exp)) {
          exp.then(result => {
            results[i] = result;
            exceptions[i] = undefined;
            resolve(wrapLoadables(dependencies, results, exceptions));
          }).catch(error => {
            exceptions[i] = error;
            resolve(wrapLoadables(dependencies, results, exceptions));
          });
        }
      }
    });
  },
  dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for all to be
// available before returning a value.  It will error if any dependencies error.

const waitForAll = Recoil_selectorFamily({
  key: '__waitForAll',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results

    if (exceptions.every(exp => exp == null)) {
      return wrapResults(dependencies, results);
    } // If we have any errors, throw the first error


    const error = exceptions.find(isError);

    if (error != null) {
      throw error;
    } // Otherwise, return a promise that will resolve when all results are available


    return Promise.all(exceptions).then(exceptionResults => wrapResults(dependencies, combineAsyncResultsWithSyncResults(results, exceptionResults)));
  },
  dangerouslyAllowMutability: true
});
const waitForAllSettled = Recoil_selectorFamily({
  key: '__waitForAllSettled',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results

    if (exceptions.every(exp => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    } // Wait for all results to settle


    return Promise.all(exceptions.map((exp, i) => Recoil_isPromise(exp) ? exp.then(result => {
      results[i] = result;
      exceptions[i] = undefined;
    }).catch(error => {
      results[i] = undefined;
      exceptions[i] = error;
    }) : null)) // Then wrap them as loadables
    .then(() => wrapLoadables(dependencies, results, exceptions));
  },
  dangerouslyAllowMutability: true
});
const noWait = Recoil_selectorFamily({
  key: '__noWait',
  get: dependency => ({
    get
  }) => {
    try {
      return Recoil_selector.value(loadableWithValue$4(get(dependency)));
    } catch (exception) {
      return Recoil_selector.value(Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
    }
  },
  dangerouslyAllowMutability: true
});
var Recoil_WaitFor = {
  waitForNone,
  waitForAny,
  waitForAll,
  waitForAllSettled,
  noWait
};

const {
  RecoilLoadable
} = Recoil_Loadable$1;

const {
  DefaultValue: DefaultValue$3
} = Recoil_Node;

const {
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1
} = Recoil_RecoilRoot;

const {
  isRecoilValue: isRecoilValue$5
} = Recoil_RecoilValue$1;

const {
  retentionZone: retentionZone$1
} = Recoil_RetentionZone;

const {
  freshSnapshot: freshSnapshot$2
} = Recoil_Snapshot$1;

const {
  useRecoilState: useRecoilState$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useRecoilValue: useRecoilValue$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useResetRecoilState: useResetRecoilState$1,
  useSetRecoilState: useSetRecoilState$1
} = Recoil_Hooks;

const {
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver: useRecoilTransactionObserver$1
} = Recoil_SnapshotHooks;





const {
  useRecoilCallback: useRecoilCallback$1
} = Recoil_useRecoilCallback;





















const {
  noWait: noWait$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  waitForAny: waitForAny$1,
  waitForNone: waitForNone$1
} = Recoil_WaitFor;



var Recoil_index = {
  // Types
  DefaultValue: DefaultValue$3,
  isRecoilValue: isRecoilValue$5,
  RecoilLoadable,
  // Global Recoil environment settiongs
  RecoilEnv: Recoil_RecoilEnv,
  // Recoil Root
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1,
  useRecoilBridgeAcrossReactRoots_UNSTABLE: Recoil_useRecoilBridgeAcrossReactRoots,
  // Atoms/Selectors
  atom: Recoil_atom,
  selector: Recoil_selector,
  // Convenience Atoms/Selectors
  atomFamily: Recoil_atomFamily,
  selectorFamily: Recoil_selectorFamily,
  constSelector: Recoil_constSelector,
  errorSelector: Recoil_errorSelector,
  readOnlySelector: Recoil_readOnlySelector,
  // Concurrency Helpers for Atoms/Selectors
  noWait: noWait$1,
  waitForNone: waitForNone$1,
  waitForAny: waitForAny$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  // Hooks for Atoms/Selectors
  useRecoilValue: useRecoilValue$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilState: useRecoilState$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useSetRecoilState: useSetRecoilState$1,
  useResetRecoilState: useResetRecoilState$1,
  useGetRecoilValueInfo_UNSTABLE: Recoil_useGetRecoilValueInfo,
  useRecoilRefresher_UNSTABLE: Recoil_useRecoilRefresher,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  // Hooks for complex operations
  useRecoilCallback: useRecoilCallback$1,
  useRecoilTransaction_UNSTABLE: Recoil_useRecoilTransaction,
  // Snapshots
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver_UNSTABLE: useRecoilTransactionObserver$1,
  snapshot_UNSTABLE: freshSnapshot$2,
  // Memory Management
  useRetain: Recoil_useRetain,
  retentionZone: retentionZone$1
};
var Recoil_index_1 = Recoil_index.DefaultValue;
var Recoil_index_2 = Recoil_index.isRecoilValue;
var Recoil_index_3 = Recoil_index.RecoilLoadable;
var Recoil_index_4 = Recoil_index.RecoilEnv;
var Recoil_index_5 = Recoil_index.RecoilRoot;
var Recoil_index_6 = Recoil_index.useRecoilStoreID;
var Recoil_index_7 = Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var Recoil_index_8 = Recoil_index.atom;
var Recoil_index_9 = Recoil_index.selector;
var Recoil_index_10 = Recoil_index.atomFamily;
var Recoil_index_11 = Recoil_index.selectorFamily;
var Recoil_index_12 = Recoil_index.constSelector;
var Recoil_index_13 = Recoil_index.errorSelector;
var Recoil_index_14 = Recoil_index.readOnlySelector;
var Recoil_index_15 = Recoil_index.noWait;
var Recoil_index_16 = Recoil_index.waitForNone;
var Recoil_index_17 = Recoil_index.waitForAny;
var Recoil_index_18 = Recoil_index.waitForAll;
var Recoil_index_19 = Recoil_index.waitForAllSettled;
var Recoil_index_20 = Recoil_index.useRecoilValue;
var Recoil_index_21 = Recoil_index.useRecoilValueLoadable;
var Recoil_index_22 = Recoil_index.useRecoilState;
var Recoil_index_23 = Recoil_index.useRecoilStateLoadable;
var Recoil_index_24 = Recoil_index.useSetRecoilState;
var Recoil_index_25 = Recoil_index.useResetRecoilState;
var Recoil_index_26 = Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var Recoil_index_27 = Recoil_index.useRecoilRefresher_UNSTABLE;
var Recoil_index_28 = Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_29 = Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_30 = Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_31 = Recoil_index.useRecoilCallback;
var Recoil_index_32 = Recoil_index.useRecoilTransaction_UNSTABLE;
var Recoil_index_33 = Recoil_index.useGotoRecoilSnapshot;
var Recoil_index_34 = Recoil_index.useRecoilSnapshot;
var Recoil_index_35 = Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var Recoil_index_36 = Recoil_index.snapshot_UNSTABLE;
var Recoil_index_37 = Recoil_index.useRetain;
var Recoil_index_38 = Recoil_index.retentionZone;

/* harmony default export */ __webpack_exports__["default"] = (Recoil_index);



/***/ }),

/***/ 65105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/*
 * Dependencies
 */
const visit = __webpack_require__(45572);
const select = __webpack_require__(14339);
const parseSelector = __webpack_require__(18870);

/*
 * Attacher
 */
module.exports = options => {
  options = options || {};
  const selector = options.selector || options.select || 'body';
  const wrapper = options.wrapper || options.wrap;
  const fallback = options.fallback !== undefined ? options.fallback : true;

  /*
   * Transformer
   */
  return tree => {
    if (typeof wrapper !== 'string') {
      throw new TypeError('Expected a `string` as wrapper');
    }

    if (typeof selector !== 'string') {
      throw new TypeError('Expected a `string` as selector');
    }

    if (typeof fallback !== 'boolean') {
      throw new TypeError('Expected a `boolean` as fallback');
    }

    const selected = select.select(selector, tree);
    const wrap = parseSelector(wrapper);

    if (selected) {
      visit(tree, selected, (node, i, parent) => {
        if (node.tagName === 'body') {
          wrap.children = node.children;
          node.children = [wrap];
        } else {
          wrap.children = [selected];
          parent.children[i] = wrap;
        }
      });
    } else if (fallback) {
      wrap.children = tree.children;
      tree.children = [wrap];
    }
  };
};


/***/ }),

/***/ 32713:
/***/ (function(module) {

"use strict";


module.exports = convert

function convert(test) {
  if (test == null) {
    return ok
  }

  if (typeof test === 'string') {
    return typeFactory(test)
  }

  if (typeof test === 'object') {
    return 'length' in test ? anyFactory(test) : allFactory(test)
  }

  if (typeof test === 'function') {
    return test
  }

  throw new Error('Expected function, string, or object as test')
}

// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function allFactory(test) {
  return all

  function all(node) {
    var key

    for (key in test) {
      if (node[key] !== test[key]) return false
    }

    return true
  }
}

function anyFactory(tests) {
  var checks = []
  var index = -1

  while (++index < tests.length) {
    checks[index] = convert(tests[index])
  }

  return any

  function any() {
    var index = -1

    while (++index < checks.length) {
      if (checks[index].apply(this, arguments)) {
        return true
      }
    }

    return false
  }
}

// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
  return type

  function type(node) {
    return Boolean(node && node.type === test)
  }
}

// Utility to return true.
function ok() {
  return true
}


/***/ }),

/***/ 3804:
/***/ (function(module) {

module.exports = identity
function identity(d) {
  return d
}


/***/ }),

/***/ 52820:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = visitParents

var convert = __webpack_require__(32713)
var color = __webpack_require__(3804)

var CONTINUE = true
var SKIP = 'skip'
var EXIT = false

visitParents.CONTINUE = CONTINUE
visitParents.SKIP = SKIP
visitParents.EXIT = EXIT

function visitParents(tree, test, visitor, reverse) {
  var step
  var is

  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  is = convert(test)
  step = reverse ? -1 : 1

  factory(tree, null, [])()

  function factory(node, index, parents) {
    var value = typeof node === 'object' && node !== null ? node : {}
    var name

    if (typeof value.type === 'string') {
      name =
        typeof value.tagName === 'string'
          ? value.tagName
          : typeof value.name === 'string'
          ? value.name
          : undefined

      visit.displayName =
        'node (' + color(value.type + (name ? '<' + name + '>' : '')) + ')'
    }

    return visit

    function visit() {
      var grandparents = parents.concat(node)
      var result = []
      var subresult
      var offset

      if (!test || is(node, index, parents[parents.length - 1] || null)) {
        result = toResult(visitor(node, parents))

        if (result[0] === EXIT) {
          return result
        }
      }

      if (node.children && result[0] !== SKIP) {
        offset = (reverse ? node.children.length : -1) + step

        while (offset > -1 && offset < node.children.length) {
          subresult = factory(node.children[offset], offset, grandparents)()

          if (subresult[0] === EXIT) {
            return subresult
          }

          offset =
            typeof subresult[1] === 'number' ? subresult[1] : offset + step
        }
      }

      return result
    }
  }
}

function toResult(value) {
  if (value !== null && typeof value === 'object' && 'length' in value) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}


/***/ }),

/***/ 45572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = visit

var visitParents = __webpack_require__(52820)

var CONTINUE = visitParents.CONTINUE
var SKIP = visitParents.SKIP
var EXIT = visitParents.EXIT

visit.CONTINUE = CONTINUE
visit.SKIP = SKIP
visit.EXIT = EXIT

function visit(tree, test, visitor, reverse) {
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  visitParents(tree, test, overload, reverse)

  function overload(node, parents) {
    var parent = parents[parents.length - 1]
    var index = parent ? parent.children.indexOf(node) : null
    return visitor(node, index, parent)
  }
}


/***/ }),

/***/ 97329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ 31533:
/***/ (function(module) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ 55862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(3812);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;


/***/ }),

/***/ 59312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldIn": function() { return /* binding */ __classPrivateFieldIn; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArray": function() { return /* binding */ __spreadArray; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__values": function() { return /* binding */ __values; }
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "NIL", ({
  enumerable: true,
  get: function get() {
    return _nil.default;
  }
}));
Object.defineProperty(exports, "parse", ({
  enumerable: true,
  get: function get() {
    return _parse.default;
  }
}));
Object.defineProperty(exports, "stringify", ({
  enumerable: true,
  get: function get() {
    return _stringify.default;
  }
}));
Object.defineProperty(exports, "v1", ({
  enumerable: true,
  get: function get() {
    return _v.default;
  }
}));
Object.defineProperty(exports, "v3", ({
  enumerable: true,
  get: function get() {
    return _v2.default;
  }
}));
Object.defineProperty(exports, "v4", ({
  enumerable: true,
  get: function get() {
    return _v3.default;
  }
}));
Object.defineProperty(exports, "v5", ({
  enumerable: true,
  get: function get() {
    return _v4.default;
  }
}));
Object.defineProperty(exports, "validate", ({
  enumerable: true,
  get: function get() {
    return _validate.default;
  }
}));
Object.defineProperty(exports, "version", ({
  enumerable: true,
  get: function get() {
    return _version.default;
  }
}));

var _v = _interopRequireDefault(__webpack_require__(3925));

var _v2 = _interopRequireDefault(__webpack_require__(62220));

var _v3 = _interopRequireDefault(__webpack_require__(68015));

var _v4 = _interopRequireDefault(__webpack_require__(70197));

var _nil = _interopRequireDefault(__webpack_require__(85529));

var _version = _interopRequireDefault(__webpack_require__(70923));

var _validate = _interopRequireDefault(__webpack_require__(53447));

var _stringify = _interopRequireDefault(__webpack_require__(93584));

var _parse = _interopRequireDefault(__webpack_require__(75842));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 57809:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

var _default = md5;
exports["default"] = _default;

/***/ }),

/***/ 19871:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _default = {
  randomUUID
};
exports["default"] = _default;

/***/ }),

/***/ 85529:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = '00000000-0000-0000-0000-000000000000';
exports["default"] = _default;

/***/ }),

/***/ 75842:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__(53447));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

var _default = parse;
exports["default"] = _default;

/***/ }),

/***/ 64261:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
exports["default"] = _default;

/***/ }),

/***/ 59469:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ 27230:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

var _default = sha1;
exports["default"] = _default;

/***/ }),

/***/ 93584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.unsafeStringify = unsafeStringify;

var _validate = _interopRequireDefault(__webpack_require__(53447));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

var _default = stringify;
exports["default"] = _default;

/***/ }),

/***/ 3925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _rng = _interopRequireDefault(__webpack_require__(59469));

var _stringify = __webpack_require__(93584);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || _rng.default)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || (0, _stringify.unsafeStringify)(b);
}

var _default = v1;
exports["default"] = _default;

/***/ }),

/***/ 62220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__(22969));

var _md = _interopRequireDefault(__webpack_require__(57809));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v3 = (0, _v.default)('v3', 0x30, _md.default);
var _default = v3;
exports["default"] = _default;

/***/ }),

/***/ 22969:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.URL = exports.DNS = void 0;
exports["default"] = v35;

var _stringify = __webpack_require__(93584);

var _parse = _interopRequireDefault(__webpack_require__(75842));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
exports.DNS = DNS;
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
exports.URL = URL;

function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;

    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = (0, _parse.default)(namespace);
    }

    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return (0, _stringify.unsafeStringify)(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/***/ }),

/***/ 68015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _native = _interopRequireDefault(__webpack_require__(19871));

var _rng = _interopRequireDefault(__webpack_require__(59469));

var _stringify = __webpack_require__(93584);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function v4(options, buf, offset) {
  if (_native.default.randomUUID && !buf && !options) {
    return _native.default.randomUUID();
  }

  options = options || {};

  const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0, _stringify.unsafeStringify)(rnds);
}

var _default = v4;
exports["default"] = _default;

/***/ }),

/***/ 70197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__(22969));

var _sha = _interopRequireDefault(__webpack_require__(27230));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v5 = (0, _v.default)('v5', 0x50, _sha.default);
var _default = v5;
exports["default"] = _default;

/***/ }),

/***/ 53447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _regex = _interopRequireDefault(__webpack_require__(64261));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(uuid) {
  return typeof uuid === 'string' && _regex.default.test(uuid);
}

var _default = validate;
exports["default"] = _default;

/***/ }),

/***/ 70923:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__(53447));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function version(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.slice(14, 15), 16);
}

var _default = version;
exports["default"] = _default;

/***/ }),

/***/ 49720:
/***/ (function(module) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),

/***/ 42139:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultJsonSerializer = void 0;
exports.defaultJsonSerializer = JSON;
//# sourceMappingURL=defaultJsonSerializer.js.map

/***/ }),

/***/ 17323:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GraphQLWebSocketClient = void 0;
/* eslint-disable */
const resolveRequestDocument_js_1 = __webpack_require__(37671);
const types_js_1 = __webpack_require__(18876);
// import type WebSocket from 'ws'
const CONNECTION_INIT = `connection_init`;
const CONNECTION_ACK = `connection_ack`;
const PING = `ping`;
const PONG = `pong`;
const SUBSCRIBE = `subscribe`;
const NEXT = `next`;
const ERROR = `error`;
const COMPLETE = `complete`;
class GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id) {
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = { type: this.type };
        if (this.id != null && this.id != undefined)
            result.id = this.id;
        if (this.payload != null && this.payload != undefined)
            result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type, payload, id } = JSON.parse(data);
        return new GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class GraphQLWebSocketClient {
    constructor(socket, { onInit, onAcknowledged, onPing, onPong }) {
        this.socketState = { acknowledged: false, lastRequestId: 0, subscriptions: {} };
        this.socket = socket;
        socket.addEventListener(`open`, async (e) => {
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send(ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e) => {
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e) => {
            console.error(e);
        });
        socket.addEventListener(`message`, (e) => {
            try {
                const message = parseMessage(e.data);
                switch (message.type) {
                    case CONNECTION_ACK: {
                        if (this.socketState.acknowledged) {
                            console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        }
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged)
                                onAcknowledged(message.payload);
                        }
                        return;
                    }
                    case PING: {
                        if (onPing)
                            onPing(message.payload).then((r) => socket.send(Pong(r).text));
                        else
                            socket.send(Pong(null).text);
                        return;
                    }
                    case PONG: {
                        if (onPong)
                            onPong(message.payload);
                        return;
                    }
                }
                if (!this.socketState.acknowledged) {
                    // Web-socket connection not acknowledged
                    return;
                }
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) {
                    // No subscription identifer or subscription indentifier is not found
                    return;
                }
                const { query, variables, subscriber } = this.socketState.subscriptions[message.id];
                switch (message.type) {
                    case NEXT: {
                        if (!message.payload.errors && message.payload.data) {
                            subscriber.next && subscriber.next(message.payload.data);
                        }
                        if (message.payload.errors) {
                            subscriber.error &&
                                subscriber.error(new types_js_1.ClientError({ ...message.payload, status: 200 }, { query, variables }));
                        }
                        else {
                        }
                        return;
                    }
                    case ERROR: {
                        subscriber.error &&
                            subscriber.error(new types_js_1.ClientError({ errors: message.payload, status: 200 }, { query, variables }));
                        return;
                    }
                    case COMPLETE: {
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                    }
                }
            }
            catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = { query, variables, subscriber };
        this.socket.send(Subscribe(subscriptionId, { query, operationName, variables }).text);
        return () => {
            this.socket.send(Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject) => {
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions) => (result = { data, extensions }),
                error: reject,
                complete: () => resolve(result),
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject) => {
            let result;
            this.subscribe(document, {
                next: (data) => (result = data),
                error: reject,
                complete: () => resolve(result),
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query, operationName } = (0, resolveRequestDocument_js_1.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send(Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
exports.GraphQLWebSocketClient = GraphQLWebSocketClient;
// Helper functions
function parseMessage(data, f = (a) => a) {
    const m = GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function ConnectionInit(payload) {
    return new GraphQLWebSocketMessage(CONNECTION_INIT, payload);
}
function Ping(payload) {
    return new GraphQLWebSocketMessage(PING, payload, undefined);
}
function Pong(payload) {
    return new GraphQLWebSocketMessage(PONG, payload, undefined);
}
function Subscribe(id, payload) {
    return new GraphQLWebSocketMessage(SUBSCRIBE, payload, id);
}
function Complete(id) {
    return new GraphQLWebSocketMessage(COMPLETE, undefined, id);
}
//# sourceMappingURL=graphql-ws.js.map

/***/ }),

/***/ 37431:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeadersInstanceToPlainObject = exports.uppercase = void 0;
const uppercase = (str) => str.toUpperCase();
exports.uppercase = uppercase;
/**
 * Convert Headers instance into regular object
 */
const HeadersInstanceToPlainObject = (headers) => {
    const o = {};
    headers.forEach((v, k) => {
        o[k] = v;
    });
    return o;
};
exports.HeadersInstanceToPlainObject = HeadersInstanceToPlainObject;
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 63671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.request = exports.rawRequest = exports.GraphQLClient = exports.ClientError = exports.batchRequests = exports.resolveRequestDocument = exports.GraphQLWebSocketClient = exports.gql = void 0;
const defaultJsonSerializer_js_1 = __webpack_require__(42139);
const helpers_js_1 = __webpack_require__(37431);
const parseArgs_js_1 = __webpack_require__(5912);
const resolveRequestDocument_js_1 = __webpack_require__(37671);
const types_js_1 = __webpack_require__(18876);
Object.defineProperty(exports, "ClientError", ({ enumerable: true, get: function () { return types_js_1.ClientError; } }));
const cross_fetch_1 = __importStar(__webpack_require__(89372)), CrossFetch = cross_fetch_1;
/**
 * Convert the given headers configuration into a plain object.
 */
const resolveHeaders = (headers) => {
    let oHeaders = {};
    if (headers) {
        if ((typeof Headers !== `undefined` && headers instanceof Headers) ||
            (CrossFetch && CrossFetch.Headers && headers instanceof CrossFetch.Headers)) {
            oHeaders = (0, helpers_js_1.HeadersInstanceToPlainObject)(headers);
        }
        else if (Array.isArray(headers)) {
            headers.forEach(([name, value]) => {
                if (name && value !== undefined) {
                    oHeaders[name] = value;
                }
            });
        }
        else {
            oHeaders = headers;
        }
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */
const cleanQuery = (str) => str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */
const buildRequestConfig = (params) => {
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [`query=${encodeURIComponent(cleanQuery(params_.query))}`];
        if (params.variables) {
            search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        }
        if (params_.operationName) {
            search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        }
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) {
        throw new Error(`Cannot create query with given variable type, array expected`);
    }
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index) => {
        acc.push({
            query: cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined,
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const createHttpMethodFetcher = (method) => async (params) => {
    const { url, query, variables, operationName, fetch, fetchOptions, middleware } = params;
    const headers = { ...params.headers };
    let queryParams = ``;
    let body = undefined;
    if (method === `POST`) {
        body = createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
        if (typeof body === `string`) {
            // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        }
    }
    else {
        // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = buildRequestConfig({
            query,
            variables,
            operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? defaultJsonSerializer_js_1.defaultJsonSerializer,
        });
    }
    const init = {
        method,
        headers,
        body,
        ...fetchOptions,
    };
    let urlResolved = url;
    let initResolved = init;
    if (middleware) {
        const result = await Promise.resolve(middleware({ ...init, url, operationName, variables }));
        const { url: urlNew, ...initNew } = result;
        urlResolved = urlNew;
        initResolved = initNew;
    }
    if (queryParams) {
        urlResolved = `${urlResolved}?${queryParams}`;
    }
    return await fetch(urlResolved, initResolved);
};
/**
 * GraphQL Client.
 */
class GraphQLClient {
    constructor(url, requestConfig = {}) {
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */
        this.rawRequest = async (...args) => {
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, parseArgs_js_1.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers, fetch = cross_fetch_1.default, method = `POST`, requestMiddleware, responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url } = this;
            if (rawRequestOptions.signal !== undefined) {
                fetchOptions.signal = rawRequestOptions.signal;
            }
            const { operationName } = (0, resolveRequestDocument_js_1.resolveRequestDocument)(rawRequestOptions.query);
            return makeRequest({
                url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...resolveHeaders(callOrIdentity(headers)),
                    ...resolveHeaders(rawRequestOptions.requestHeaders),
                },
                operationName,
                fetch,
                method,
                fetchOptions,
                middleware: requestMiddleware,
            })
                .then((response) => {
                if (responseMiddleware) {
                    responseMiddleware(response);
                }
                return response;
            })
                .catch((error) => {
                if (responseMiddleware) {
                    responseMiddleware(error);
                }
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, parseArgs_js_1.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers, fetch = cross_fetch_1.default, method = `POST`, requestMiddleware, responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url } = this;
        if (requestOptions.signal !== undefined) {
            fetchOptions.signal = requestOptions.signal;
        }
        const { query, operationName } = (0, resolveRequestDocument_js_1.resolveRequestDocument)(requestOptions.document);
        return makeRequest({
            url,
            query,
            variables: requestOptions.variables,
            headers: {
                ...resolveHeaders(callOrIdentity(headers)),
                ...resolveHeaders(requestOptions.requestHeaders),
            },
            operationName,
            fetch,
            method,
            fetchOptions,
            middleware: requestMiddleware,
        })
            .then((response) => {
            if (responseMiddleware) {
                responseMiddleware(response);
            }
            return response.data;
        })
            .catch((error) => {
            if (responseMiddleware) {
                responseMiddleware(error);
            }
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, parseArgs_js_1.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) {
            fetchOptions.signal = batchRequestOptions.signal;
        }
        const queries = batchRequestOptions.documents.map(({ document }) => (0, resolveRequestDocument_js_1.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables }) => variables);
        return makeRequest({
            url: this.url,
            query: queries,
            // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...resolveHeaders(callOrIdentity(headers)),
                ...resolveHeaders(batchRequestOptions.requestHeaders),
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? cross_fetch_1.default,
            method: this.requestConfig.method || `POST`,
            fetchOptions,
            middleware: this.requestConfig.requestMiddleware,
        })
            .then((response) => {
            if (this.requestConfig.responseMiddleware) {
                this.requestConfig.responseMiddleware(response);
            }
            return response.data;
        })
            .catch((error) => {
            if (this.requestConfig.responseMiddleware) {
                this.requestConfig.responseMiddleware(error);
            }
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
    setHeader(key, value) {
        const { headers } = this.requestConfig;
        if (headers) {
            // todo what if headers is in nested array form... ?
            //@ts-expect-error todo
            headers[key] = value;
        }
        else {
            this.requestConfig.headers = { [key]: value };
        }
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */
    setEndpoint(value) {
        this.url = value;
        return this;
    }
}
exports.GraphQLClient = GraphQLClient;
const makeRequest = async (params) => {
    const { query, variables, fetchOptions } = params;
    const fetcher = createHttpMethodFetcher((0, helpers_js_1.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await getResult(response, fetchOptions.jsonSerializer ?? defaultJsonSerializer_js_1.defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result)
        ? !result.some(({ data }) => !data)
        : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) ||
        !result.errors ||
        (Array.isArray(result.errors) && !result.errors.length) ||
        fetchOptions.errorPolicy === `all` ||
        fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? { data } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status,
        };
    }
    else {
        const errorResult = typeof result === `string`
            ? {
                error: result,
            }
            : result;
        throw new types_js_1.ClientError(
        // @ts-expect-error TODO
        { ...errorResult, status: response.status, headers: response.headers }, { query, variables });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */
const rawRequest = async (...args) => {
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, parseArgs_js_1.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions,
    });
};
exports.rawRequest = rawRequest;
// prettier-ignore
// eslint-disable-next-line
async function request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, parseArgs_js_1.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions,
    });
}
exports.request = request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */
const batchRequests = async (...args) => {
    const params = parseBatchRequestsArgsExtended(args);
    const client = new GraphQLClient(params.url);
    return client.batchRequests(params);
};
exports.batchRequests = batchRequests;
const parseBatchRequestsArgsExtended = (args) => {
    if (args.length === 1) {
        return args[0];
    }
    else {
        return {
            url: args[0],
            documents: args[1],
            requestHeaders: args[2],
            signal: undefined,
        };
    }
};
const createRequestBody = (query, variables, operationName, jsonSerializer) => {
    const jsonSerializer_ = jsonSerializer ?? defaultJsonSerializer_js_1.defaultJsonSerializer;
    if (!Array.isArray(query)) {
        return jsonSerializer_.stringify({ query, variables, operationName });
    }
    if (typeof variables !== `undefined` && !Array.isArray(variables)) {
        throw new Error(`Cannot create request body with given variable type, array expected`);
    }
    // Batch support
    const payload = query.reduce((acc, currentQuery, index) => {
        acc.push({ query: currentQuery, variables: variables ? variables[index] : undefined });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const getResult = async (response, jsonSerializer) => {
    let contentType;
    response.headers.forEach((value, key) => {
        if (key.toLowerCase() === `content-type`) {
            contentType = value;
        }
    });
    if (contentType &&
        (contentType.toLowerCase().startsWith(`application/json`) ||
            contentType.toLowerCase().startsWith(`application/graphql+json`) ||
            contentType.toLowerCase().startsWith(`application/graphql-response+json`))) {
        return jsonSerializer.parse(await response.text());
    }
    else {
        return response.text();
    }
};
const callOrIdentity = (value) => {
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */
const gql = (chunks, ...variables) => {
    return chunks.reduce((acc, chunk, index) => `${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
exports.gql = gql;
var graphql_ws_js_1 = __webpack_require__(17323);
Object.defineProperty(exports, "GraphQLWebSocketClient", ({ enumerable: true, get: function () { return graphql_ws_js_1.GraphQLWebSocketClient; } }));
var resolveRequestDocument_js_2 = __webpack_require__(37671);
Object.defineProperty(exports, "resolveRequestDocument", ({ enumerable: true, get: function () { return resolveRequestDocument_js_2.resolveRequestDocument; } }));
exports["default"] = request;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5912:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseRawRequestExtendedArgs = exports.parseRequestExtendedArgs = exports.parseBatchRequestArgs = exports.parseRawRequestArgs = exports.parseRequestArgs = void 0;
const parseRequestArgs = (documentOrOptions, variables, requestHeaders) => {
    return documentOrOptions.document
        ? documentOrOptions
        : {
            document: documentOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
exports.parseRequestArgs = parseRequestArgs;
const parseRawRequestArgs = (queryOrOptions, variables, requestHeaders) => {
    return queryOrOptions.query
        ? queryOrOptions
        : {
            query: queryOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
exports.parseRawRequestArgs = parseRawRequestArgs;
const parseBatchRequestArgs = (documentsOrOptions, requestHeaders) => {
    return documentsOrOptions.documents
        ? documentsOrOptions
        : {
            documents: documentsOrOptions,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
exports.parseBatchRequestArgs = parseBatchRequestArgs;
const parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document
        ? urlOrOptions
        : {
            url: urlOrOptions,
            document: document,
            variables,
            requestHeaders,
            signal: undefined,
        };
};
exports.parseRequestExtendedArgs = parseRequestExtendedArgs;
const parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query
        ? urlOrOptions
        : {
            url: urlOrOptions,
            query: query,
            variables,
            requestHeaders,
            signal: undefined,
        };
};
exports.parseRawRequestExtendedArgs = parseRawRequestExtendedArgs;
//# sourceMappingURL=parseArgs.js.map

/***/ }),

/***/ 37671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.resolveRequestDocument = void 0;
const graphql_1 = __webpack_require__(64358);
/**
 * helpers
 */
const extractOperationName = (document) => {
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition) => definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) {
        operationName = operationDefinitions[0]?.name?.value;
    }
    return operationName;
};
const resolveRequestDocument = (document) => {
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, graphql_1.parse)(document);
            operationName = extractOperationName(parsedDocument);
        }
        catch (err) {
            // Failed parsing the document, the operationName will be undefined
        }
        return { query: document, operationName };
    }
    const operationName = extractOperationName(document);
    return { query: (0, graphql_1.print)(document), operationName };
};
exports.resolveRequestDocument = resolveRequestDocument;
//# sourceMappingURL=resolveRequestDocument.js.map

/***/ }),

/***/ 18876:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClientError = void 0;
class ClientError extends Error {
    constructor(response, request) {
        const message = `${ClientError.extractMessage(response)}: ${JSON.stringify({
            response,
            request,
        })}`;
        super(message);
        Object.setPrototypeOf(this, ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) {
            Error.captureStackTrace(this, ClientError);
        }
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
exports.ClientError = ClientError;
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 39481:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ touchEndEvent; },
/* harmony export */   "G1": function() { return /* binding */ mouseOutEvent; },
/* harmony export */   "QL": function() { return /* binding */ visibilityChangeEvent; },
/* harmony export */   "Re": function() { return /* binding */ touchStartEvent; },
/* harmony export */   "VH": function() { return /* binding */ touchCancelEvent; },
/* harmony export */   "Wt": function() { return /* binding */ mouseMoveEvent; },
/* harmony export */   "X5": function() { return /* binding */ millisecondsToSeconds; },
/* harmony export */   "YU": function() { return /* binding */ generatedAttribute; },
/* harmony export */   "ZL": function() { return /* binding */ mouseDownEvent; },
/* harmony export */   "aM": function() { return /* binding */ mouseLeaveEvent; },
/* harmony export */   "gK": function() { return /* binding */ errorPrefix; },
/* harmony export */   "rR": function() { return /* binding */ resizeEvent; },
/* harmony export */   "tZ": function() { return /* binding */ percentDenominator; },
/* harmony export */   "vq": function() { return /* binding */ halfRandom; },
/* harmony export */   "zX": function() { return /* binding */ touchMoveEvent; },
/* harmony export */   "zw": function() { return /* binding */ mouseUpEvent; }
/* harmony export */ });
const generatedAttribute = "generated";
const mouseDownEvent = "pointerdown";
const mouseUpEvent = "pointerup";
const mouseLeaveEvent = "pointerleave";
const mouseOutEvent = "pointerout";
const mouseMoveEvent = "pointermove";
const touchStartEvent = "touchstart";
const touchEndEvent = "touchend";
const touchMoveEvent = "touchmove";
const touchCancelEvent = "touchcancel";
const resizeEvent = "resize";
const visibilityChangeEvent = "visibilitychange";
const errorPrefix = "tsParticles - Error";
const percentDenominator = 100;
const halfRandom = 0.5;
const millisecondsToSeconds = 1000;


/***/ }),

/***/ 83918:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ae": function() { return /* binding */ Rectangle; },
/* harmony export */   "Cd": function() { return /* binding */ Circle; }
/* harmony export */ });
/* unused harmony export BaseRange */
/* harmony import */ var _Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);

const squareExp = 2;
class BaseRange {
    constructor(x, y, type) {
        this.position = {
            x: x,
            y: y,
        };
        this.type = type;
    }
}
class Circle extends BaseRange {
    constructor(x, y, radius) {
        super(x, y, "circle");
        this.radius = radius;
    }
    contains(point) {
        return (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getDistance */ .Sp)(point, this.position) <= this.radius;
    }
    intersects(range) {
        const pos1 = this.position, pos2 = range.position, distPos = { x: Math.abs(pos2.x - pos1.x), y: Math.abs(pos2.y - pos1.y) }, r = this.radius;
        if (range instanceof Circle || range.type === "circle") {
            const circleRange = range, rSum = r + circleRange.radius, dist = Math.sqrt(distPos.x ** squareExp + distPos.y ** squareExp);
            return rSum > dist;
        }
        else if (range instanceof Rectangle || range.type === "rectangle") {
            const rectRange = range, { width, height } = rectRange.size, edges = Math.pow(distPos.x - width, squareExp) + Math.pow(distPos.y - height, squareExp);
            return (edges <= r ** squareExp ||
                (distPos.x <= r + width && distPos.y <= r + height) ||
                distPos.x <= width ||
                distPos.y <= height);
        }
        return false;
    }
}
class Rectangle extends BaseRange {
    constructor(x, y, width, height) {
        super(x, y, "rectangle");
        this.size = {
            height: height,
            width: width,
        };
    }
    contains(point) {
        const w = this.size.width, h = this.size.height, pos = this.position;
        return point.x >= pos.x && point.x <= pos.x + w && point.y >= pos.y && point.y <= pos.y + h;
    }
    intersects(range) {
        if (range instanceof Circle) {
            return range.intersects(this);
        }
        const w = this.size.width, h = this.size.height, pos1 = this.position, pos2 = range.position, size2 = range instanceof Rectangle ? range.size : { width: 0, height: 0 }, w2 = size2.width, h2 = size2.height;
        return pos2.x < pos1.x + w && pos2.x + w2 > pos1.x && pos2.y < pos1.y + h && pos2.y + h2 > pos1.y;
    }
}


/***/ }),

/***/ 15641:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Vector; },
/* harmony export */   "U": function() { return /* binding */ Vector3d; }
/* harmony export */ });
/* harmony import */ var _Constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39481);
/* harmony import */ var _Utils_TypeUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92929);


const origin = {
    x: 0,
    y: 0,
    z: 0,
}, squareExp = 2, inverseFactorNumerator = 1.0;
class Vector3d {
    constructor(xOrCoords, y, z) {
        this._updateFromAngle = (angle, length) => {
            this.x = Math.cos(angle) * length;
            this.y = Math.sin(angle) * length;
        };
        if (!(0,_Utils_TypeUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)(xOrCoords) && xOrCoords) {
            this.x = xOrCoords.x;
            this.y = xOrCoords.y;
            const coords3d = xOrCoords;
            this.z = coords3d.z ? coords3d.z : origin.z;
        }
        else if (xOrCoords !== undefined && y !== undefined) {
            this.x = xOrCoords;
            this.y = y;
            this.z = z ?? origin.z;
        }
        else {
            throw new Error(`${_Constants_js__WEBPACK_IMPORTED_MODULE_1__/* .errorPrefix */ .gK} Vector3d not initialized correctly`);
        }
    }
    static get origin() {
        return Vector3d.create(origin.x, origin.y, origin.z);
    }
    get angle() {
        return Math.atan2(this.y, this.x);
    }
    set angle(angle) {
        this._updateFromAngle(angle, this.length);
    }
    get length() {
        return Math.sqrt(this.getLengthSq());
    }
    set length(length) {
        this._updateFromAngle(this.angle, length);
    }
    static clone(source) {
        return Vector3d.create(source.x, source.y, source.z);
    }
    static create(x, y, z) {
        return new Vector3d(x, y, z);
    }
    add(v) {
        return Vector3d.create(this.x + v.x, this.y + v.y, this.z + v.z);
    }
    addTo(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
    }
    copy() {
        return Vector3d.clone(this);
    }
    distanceTo(v) {
        return this.sub(v).length;
    }
    distanceToSq(v) {
        return this.sub(v).getLengthSq();
    }
    div(n) {
        return Vector3d.create(this.x / n, this.y / n, this.z / n);
    }
    divTo(n) {
        this.x /= n;
        this.y /= n;
        this.z /= n;
    }
    getLengthSq() {
        return this.x ** squareExp + this.y ** squareExp;
    }
    mult(n) {
        return Vector3d.create(this.x * n, this.y * n, this.z * n);
    }
    multTo(n) {
        this.x *= n;
        this.y *= n;
        this.z *= n;
    }
    normalize() {
        const length = this.length, noLength = 0;
        if (length != noLength) {
            this.multTo(inverseFactorNumerator / length);
        }
    }
    rotate(angle) {
        return Vector3d.create(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle), origin.z);
    }
    setTo(c) {
        this.x = c.x;
        this.y = c.y;
        const v3d = c;
        this.z = v3d.z ? v3d.z : origin.z;
    }
    sub(v) {
        return Vector3d.create(this.x - v.x, this.y - v.y, this.z - v.z);
    }
    subFrom(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
    }
}
class Vector extends Vector3d {
    constructor(xOrCoords, y) {
        super(xOrCoords, y, origin.z);
    }
    static get origin() {
        return Vector.create(origin.x, origin.y);
    }
    static clone(source) {
        return Vector.create(source.x, source.y);
    }
    static create(x, y) {
        return new Vector(x, y);
    }
}


/***/ }),

/***/ 92418:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ AnimatableColor; }
/* harmony export */ });
/* harmony import */ var _Utils_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92929);
/* harmony import */ var _HslAnimation_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7737);
/* harmony import */ var _OptionsColor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71327);



class AnimatableColor extends _OptionsColor_js__WEBPACK_IMPORTED_MODULE_1__/* .OptionsColor */ .O {
    constructor() {
        super();
        this.animation = new _HslAnimation_js__WEBPACK_IMPORTED_MODULE_0__/* .HslAnimation */ .h();
    }
    static create(source, data) {
        const color = new AnimatableColor();
        color.load(source);
        if (data !== undefined) {
            if ((0,_Utils_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(data) || (0,_Utils_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .kJ)(data)) {
                color.load({ value: data });
            }
            else {
                color.load(data);
            }
        }
        return color;
    }
    load(data) {
        super.load(data);
        if (!data) {
            return;
        }
        const colorAnimation = data.animation;
        if (colorAnimation !== undefined) {
            if (colorAnimation.enable !== undefined) {
                this.animation.h.load(colorAnimation);
            }
            else {
                this.animation.load(data.animation);
            }
        }
    }
}


/***/ }),

/***/ 99836:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ RangedAnimationOptions; },
/* harmony export */   "P": function() { return /* binding */ AnimationOptions; }
/* harmony export */ });
/* harmony import */ var _Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);

class AnimationOptions {
    constructor() {
        this.count = 0;
        this.enable = false;
        this.speed = 1;
        this.decay = 0;
        this.delay = 0;
        this.sync = false;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.count !== undefined) {
            this.count = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(data.count);
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.speed !== undefined) {
            this.speed = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(data.speed);
        }
        if (data.decay !== undefined) {
            this.decay = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(data.decay);
        }
        if (data.delay !== undefined) {
            this.delay = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(data.delay);
        }
        if (data.sync !== undefined) {
            this.sync = data.sync;
        }
    }
}
class RangedAnimationOptions extends AnimationOptions {
    constructor() {
        super();
        this.mode = "auto";
        this.startValue = "random";
    }
    load(data) {
        super.load(data);
        if (!data) {
            return;
        }
        if (data.mode !== undefined) {
            this.mode = data.mode;
        }
        if (data.startValue !== undefined) {
            this.startValue = data.startValue;
        }
    }
}


/***/ }),

/***/ 75382:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ColorAnimation; }
/* harmony export */ });
/* harmony import */ var _AnimationOptions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99836);
/* harmony import */ var _Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94986);


class ColorAnimation extends _AnimationOptions_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimationOptions */ .P {
    constructor() {
        super();
        this.offset = 0;
        this.sync = true;
    }
    load(data) {
        super.load(data);
        if (!data) {
            return;
        }
        if (data.offset !== undefined) {
            this.offset = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .setRangeValue */ .Cs)(data.offset);
        }
    }
}


/***/ }),

/***/ 7737:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ HslAnimation; }
/* harmony export */ });
/* harmony import */ var _ColorAnimation_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75382);

class HslAnimation {
    constructor() {
        this.h = new _ColorAnimation_js__WEBPACK_IMPORTED_MODULE_0__/* .ColorAnimation */ .y();
        this.s = new _ColorAnimation_js__WEBPACK_IMPORTED_MODULE_0__/* .ColorAnimation */ .y();
        this.l = new _ColorAnimation_js__WEBPACK_IMPORTED_MODULE_0__/* .ColorAnimation */ .y();
    }
    load(data) {
        if (!data) {
            return;
        }
        this.h.load(data.h);
        this.s.load(data.s);
        this.l.load(data.l);
    }
}


/***/ }),

/***/ 44920:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Events; }
});

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Events/ClickEvent.js
class ClickEvent {
    constructor() {
        this.enable = false;
        this.mode = [];
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.mode !== undefined) {
            this.mode = data.mode;
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Events/DivEvent.js
class DivEvent {
    constructor() {
        this.selectors = [];
        this.enable = false;
        this.mode = [];
        this.type = "circle";
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.selectors !== undefined) {
            this.selectors = data.selectors;
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.mode !== undefined) {
            this.mode = data.mode;
        }
        if (data.type !== undefined) {
            this.type = data.type;
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Events/Parallax.js
class Parallax {
    constructor() {
        this.enable = false;
        this.force = 2;
        this.smooth = 10;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.force !== undefined) {
            this.force = data.force;
        }
        if (data.smooth !== undefined) {
            this.smooth = data.smooth;
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Events/HoverEvent.js

class HoverEvent {
    constructor() {
        this.enable = false;
        this.mode = [];
        this.parallax = new Parallax();
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.mode !== undefined) {
            this.mode = data.mode;
        }
        this.parallax.load(data.parallax);
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Events/ResizeEvent.js
class ResizeEvent {
    constructor() {
        this.delay = 0.5;
        this.enable = true;
    }
    load(data) {
        if (data === undefined) {
            return;
        }
        if (data.delay !== undefined) {
            this.delay = data.delay;
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/Utils.js
var Utils = __webpack_require__(22486);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Events/Events.js





class Events {
    constructor() {
        this.onClick = new ClickEvent();
        this.onDiv = new DivEvent();
        this.onHover = new HoverEvent();
        this.resize = new ResizeEvent();
    }
    load(data) {
        if (!data) {
            return;
        }
        this.onClick.load(data.onClick);
        const onDiv = data.onDiv;
        if (onDiv !== undefined) {
            this.onDiv = (0,Utils/* executeOnSingleOrMultiple */.KH)(onDiv, (t) => {
                const tmp = new DivEvent();
                tmp.load(t);
                return tmp;
            });
        }
        this.onHover.load(data.onHover);
        this.resize.load(data.resize);
    }
}


/***/ }),

/***/ 24444:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ Interactivity; }
});

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Events/Events.js + 5 modules
var Events = __webpack_require__(44920);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Modes/Modes.js
class Modes {
    constructor(engine, container) {
        this._engine = engine;
        this._container = container;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (!this._container) {
            return;
        }
        const interactors = this._engine.interactors.get(this._container);
        if (!interactors) {
            return;
        }
        for (const interactor of interactors) {
            if (!interactor.loadModeOptions) {
                continue;
            }
            interactor.loadModeOptions(this, data);
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Interactivity.js


class Interactivity {
    constructor(engine, container) {
        this.detectsOn = "window";
        this.events = new Events/* Events */.z();
        this.modes = new Modes(engine, container);
    }
    load(data) {
        if (!data) {
            return;
        }
        const detectsOn = data.detectsOn;
        if (detectsOn !== undefined) {
            this.detectsOn = detectsOn;
        }
        this.events.load(data.events);
        this.modes.load(data.modes);
    }
}


/***/ }),

/***/ 33071:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ManualParticle; }
/* harmony export */ });
/* harmony import */ var _Utils_Utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22486);

const defaultPosition = 50;
class ManualParticle {
    load(data) {
        if (!data) {
            return;
        }
        if (data.position) {
            this.position = {
                x: data.position.x ?? defaultPosition,
                y: data.position.y ?? defaultPosition,
                mode: data.position.mode ?? "percent",
            };
        }
        if (data.options) {
            this.options = (0,_Utils_Utils_js__WEBPACK_IMPORTED_MODULE_0__/* .deepExtend */ .ZB)({}, data.options);
        }
    }
}


/***/ }),

/***/ 73819:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Options; }
});

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/Utils.js
var Utils = __webpack_require__(22486);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/OptionsColor.js
var OptionsColor = __webpack_require__(71327);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Background/Background.js

class Background {
    constructor() {
        this.color = new OptionsColor/* OptionsColor */.O();
        this.color.value = "";
        this.image = "";
        this.position = "";
        this.repeat = "";
        this.size = "";
        this.opacity = 1;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.color !== undefined) {
            this.color = OptionsColor/* OptionsColor.create */.O.create(this.color, data.color);
        }
        if (data.image !== undefined) {
            this.image = data.image;
        }
        if (data.position !== undefined) {
            this.position = data.position;
        }
        if (data.repeat !== undefined) {
            this.repeat = data.repeat;
        }
        if (data.size !== undefined) {
            this.size = data.size;
        }
        if (data.opacity !== undefined) {
            this.opacity = data.opacity;
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/BackgroundMask/BackgroundMaskCover.js

class BackgroundMaskCover {
    constructor() {
        this.opacity = 1;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.color !== undefined) {
            this.color = OptionsColor/* OptionsColor.create */.O.create(this.color, data.color);
        }
        if (data.image !== undefined) {
            this.image = data.image;
        }
        if (data.opacity !== undefined) {
            this.opacity = data.opacity;
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/TypeUtils.js
var TypeUtils = __webpack_require__(92929);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/BackgroundMask/BackgroundMask.js


class BackgroundMask {
    constructor() {
        this.composite = "destination-out";
        this.cover = new BackgroundMaskCover();
        this.enable = false;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.composite !== undefined) {
            this.composite = data.composite;
        }
        if (data.cover !== undefined) {
            const cover = data.cover, color = ((0,TypeUtils/* isString */.HD)(data.cover) ? { color: data.cover } : data.cover);
            this.cover.load(cover.color !== undefined || cover.image !== undefined ? cover : { color: color });
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/FullScreen/FullScreen.js
class FullScreen {
    constructor() {
        this.enable = true;
        this.zIndex = 0;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.zIndex !== undefined) {
            this.zIndex = data.zIndex;
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Interactivity.js + 1 modules
var Interactivity = __webpack_require__(24444);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/ManualParticle.js
var ManualParticle = __webpack_require__(33071);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Responsive.js
var Responsive = __webpack_require__(85759);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Theme/Theme.js + 1 modules
var Theme = __webpack_require__(32355);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/OptionsUtils.js
var OptionsUtils = __webpack_require__(13134);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/NumberUtils.js
var NumberUtils = __webpack_require__(94986);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Options.js











class Options {
    constructor(engine, container) {
        this._findDefaultTheme = (mode) => {
            return (this.themes.find((theme) => theme.default.value && theme.default.mode === mode) ??
                this.themes.find((theme) => theme.default.value && theme.default.mode === "any"));
        };
        this._importPreset = (preset) => {
            this.load(this._engine.getPreset(preset));
        };
        this._engine = engine;
        this._container = container;
        this.autoPlay = true;
        this.background = new Background();
        this.backgroundMask = new BackgroundMask();
        this.clear = true;
        this.defaultThemes = {};
        this.delay = 0;
        this.fullScreen = new FullScreen();
        this.detectRetina = true;
        this.duration = 0;
        this.fpsLimit = 120;
        this.interactivity = new Interactivity/* Interactivity */.o(engine, container);
        this.manualParticles = [];
        this.particles = (0,OptionsUtils/* loadParticlesOptions */.x)(this._engine, this._container);
        this.pauseOnBlur = true;
        this.pauseOnOutsideViewport = true;
        this.responsive = [];
        this.smooth = false;
        this.style = {};
        this.themes = [];
        this.zLayers = 100;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.preset !== undefined) {
            (0,Utils/* executeOnSingleOrMultiple */.KH)(data.preset, (preset) => this._importPreset(preset));
        }
        if (data.autoPlay !== undefined) {
            this.autoPlay = data.autoPlay;
        }
        if (data.clear !== undefined) {
            this.clear = data.clear;
        }
        if (data.key !== undefined) {
            this.key = data.key;
        }
        if (data.name !== undefined) {
            this.name = data.name;
        }
        if (data.delay !== undefined) {
            this.delay = (0,NumberUtils/* setRangeValue */.Cs)(data.delay);
        }
        const detectRetina = data.detectRetina;
        if (detectRetina !== undefined) {
            this.detectRetina = detectRetina;
        }
        if (data.duration !== undefined) {
            this.duration = (0,NumberUtils/* setRangeValue */.Cs)(data.duration);
        }
        const fpsLimit = data.fpsLimit;
        if (fpsLimit !== undefined) {
            this.fpsLimit = fpsLimit;
        }
        if (data.pauseOnBlur !== undefined) {
            this.pauseOnBlur = data.pauseOnBlur;
        }
        if (data.pauseOnOutsideViewport !== undefined) {
            this.pauseOnOutsideViewport = data.pauseOnOutsideViewport;
        }
        if (data.zLayers !== undefined) {
            this.zLayers = data.zLayers;
        }
        this.background.load(data.background);
        const fullScreen = data.fullScreen;
        if ((0,TypeUtils/* isBoolean */.jn)(fullScreen)) {
            this.fullScreen.enable = fullScreen;
        }
        else {
            this.fullScreen.load(fullScreen);
        }
        this.backgroundMask.load(data.backgroundMask);
        this.interactivity.load(data.interactivity);
        if (data.manualParticles) {
            this.manualParticles = data.manualParticles.map((t) => {
                const tmp = new ManualParticle/* ManualParticle */.h();
                tmp.load(t);
                return tmp;
            });
        }
        this.particles.load(data.particles);
        this.style = (0,Utils/* deepExtend */.ZB)(this.style, data.style);
        this._engine.loadOptions(this, data);
        if (data.smooth !== undefined) {
            this.smooth = data.smooth;
        }
        const interactors = this._engine.interactors.get(this._container);
        if (interactors) {
            for (const interactor of interactors) {
                if (interactor.loadOptions) {
                    interactor.loadOptions(this, data);
                }
            }
        }
        if (data.responsive !== undefined) {
            for (const responsive of data.responsive) {
                const optResponsive = new Responsive/* Responsive */.E();
                optResponsive.load(responsive);
                this.responsive.push(optResponsive);
            }
        }
        this.responsive.sort((a, b) => a.maxWidth - b.maxWidth);
        if (data.themes !== undefined) {
            for (const theme of data.themes) {
                const existingTheme = this.themes.find((t) => t.name === theme.name);
                if (!existingTheme) {
                    const optTheme = new Theme/* Theme */.Q();
                    optTheme.load(theme);
                    this.themes.push(optTheme);
                }
                else {
                    existingTheme.load(theme);
                }
            }
        }
        this.defaultThemes.dark = this._findDefaultTheme("dark")?.name;
        this.defaultThemes.light = this._findDefaultTheme("light")?.name;
    }
    setResponsive(width, pxRatio, defaultOptions) {
        this.load(defaultOptions);
        const responsiveOptions = this.responsive.find((t) => t.mode === "screen" && screen ? t.maxWidth > screen.availWidth : t.maxWidth * pxRatio > width);
        this.load(responsiveOptions?.options);
        return responsiveOptions?.maxWidth;
    }
    setTheme(name) {
        if (name) {
            const chosenTheme = this.themes.find((theme) => theme.name === name);
            if (chosenTheme) {
                this.load(chosenTheme.options);
            }
        }
        else {
            const mediaMatch = (0,Utils/* safeMatchMedia */.HY)("(prefers-color-scheme: dark)"), clientDarkMode = mediaMatch && mediaMatch.matches, defaultTheme = this._findDefaultTheme(clientDarkMode ? "dark" : "light");
            if (defaultTheme) {
                this.load(defaultTheme.options);
            }
        }
    }
}


/***/ }),

/***/ 71327:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ OptionsColor; }
/* harmony export */ });
/* harmony import */ var _Utils_TypeUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92929);

class OptionsColor {
    constructor() {
        this.value = "";
    }
    static create(source, data) {
        const color = new OptionsColor();
        color.load(source);
        if (data !== undefined) {
            if ((0,_Utils_TypeUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(data) || (0,_Utils_TypeUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .kJ)(data)) {
                color.load({ value: data });
            }
            else {
                color.load(data);
            }
        }
        return color;
    }
    load(data) {
        if (data?.value === undefined) {
            return;
        }
        this.value = data.value;
    }
}


/***/ }),

/***/ 28799:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ ParticlesBounce; }
/* harmony export */ });
/* harmony import */ var _ParticlesBounceFactor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83623);

class ParticlesBounce {
    constructor() {
        this.horizontal = new _ParticlesBounceFactor_js__WEBPACK_IMPORTED_MODULE_0__/* .ParticlesBounceFactor */ .u();
        this.vertical = new _ParticlesBounceFactor_js__WEBPACK_IMPORTED_MODULE_0__/* .ParticlesBounceFactor */ .u();
    }
    load(data) {
        if (!data) {
            return;
        }
        this.horizontal.load(data.horizontal);
        this.vertical.load(data.vertical);
    }
}


/***/ }),

/***/ 83623:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ ParticlesBounceFactor; }
/* harmony export */ });
/* harmony import */ var _ValueWithRandom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67073);

class ParticlesBounceFactor extends _ValueWithRandom_js__WEBPACK_IMPORTED_MODULE_0__/* .ValueWithRandom */ .SW {
    constructor() {
        super();
        this.value = 1;
    }
}


/***/ }),

/***/ 92392:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ Collisions; }
});

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Collisions/CollisionsAbsorb.js
class CollisionsAbsorb {
    constructor() {
        this.speed = 2;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.speed !== undefined) {
            this.speed = data.speed;
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Collisions/CollisionsOverlap.js
class CollisionsOverlap {
    constructor() {
        this.enable = true;
        this.retries = 0;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.retries !== undefined) {
            this.retries = data.retries;
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Bounce/ParticlesBounce.js
var ParticlesBounce = __webpack_require__(28799);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/NumberUtils.js
var NumberUtils = __webpack_require__(94986);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Collisions/Collisions.js




class Collisions {
    constructor() {
        this.absorb = new CollisionsAbsorb();
        this.bounce = new ParticlesBounce/* ParticlesBounce */.b();
        this.enable = false;
        this.maxSpeed = 50;
        this.mode = "bounce";
        this.overlap = new CollisionsOverlap();
    }
    load(data) {
        if (!data) {
            return;
        }
        this.absorb.load(data.absorb);
        this.bounce.load(data.bounce);
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.maxSpeed !== undefined) {
            this.maxSpeed = (0,NumberUtils/* setRangeValue */.Cs)(data.maxSpeed);
        }
        if (data.mode !== undefined) {
            this.mode = data.mode;
        }
        this.overlap.load(data.overlap);
    }
}


/***/ }),

/***/ 85009:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Move; }
});

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/TypeUtils.js
var TypeUtils = __webpack_require__(92929);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/MoveAngle.js
var MoveAngle = __webpack_require__(99483);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/MoveAttract.js
var MoveAttract = __webpack_require__(11518);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/MoveCenter.js
class MoveCenter {
    constructor() {
        this.x = 50;
        this.y = 50;
        this.mode = "percent";
        this.radius = 0;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.x !== undefined) {
            this.x = data.x;
        }
        if (data.y !== undefined) {
            this.y = data.y;
        }
        if (data.mode !== undefined) {
            this.mode = data.mode;
        }
        if (data.radius !== undefined) {
            this.radius = data.radius;
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/MoveGravity.js
var MoveGravity = __webpack_require__(47921);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/Path/MovePath.js
var MovePath = __webpack_require__(74562);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/OptionsColor.js
var OptionsColor = __webpack_require__(71327);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/MoveTrailFill.js

class MoveTrailFill {
    load(data) {
        if (!data) {
            return;
        }
        if (data.color !== undefined) {
            this.color = OptionsColor/* OptionsColor.create */.O.create(this.color, data.color);
        }
        if (data.image !== undefined) {
            this.image = data.image;
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/MoveTrail.js

class MoveTrail {
    constructor() {
        this.enable = false;
        this.length = 10;
        this.fill = new MoveTrailFill();
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.fill !== undefined) {
            this.fill.load(data.fill);
        }
        if (data.length !== undefined) {
            this.length = data.length;
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/OutModes.js
class OutModes {
    constructor() {
        this.default = "out";
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.default !== undefined) {
            this.default = data.default;
        }
        this.bottom = data.bottom ?? data.default;
        this.left = data.left ?? data.default;
        this.right = data.right ?? data.default;
        this.top = data.top ?? data.default;
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/Spin.js
var Spin = __webpack_require__(38758);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/NumberUtils.js
var NumberUtils = __webpack_require__(94986);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/Move.js










class Move {
    constructor() {
        this.angle = new MoveAngle/* MoveAngle */.k();
        this.attract = new MoveAttract/* MoveAttract */.k();
        this.center = new MoveCenter();
        this.decay = 0;
        this.distance = {};
        this.direction = "none";
        this.drift = 0;
        this.enable = false;
        this.gravity = new MoveGravity/* MoveGravity */.S();
        this.path = new MovePath/* MovePath */.C();
        this.outModes = new OutModes();
        this.random = false;
        this.size = false;
        this.speed = 2;
        this.spin = new Spin/* Spin */.y();
        this.straight = false;
        this.trail = new MoveTrail();
        this.vibrate = false;
        this.warp = false;
    }
    load(data) {
        if (!data) {
            return;
        }
        this.angle.load((0,TypeUtils/* isNumber */.hj)(data.angle) ? { value: data.angle } : data.angle);
        this.attract.load(data.attract);
        this.center.load(data.center);
        if (data.decay !== undefined) {
            this.decay = (0,NumberUtils/* setRangeValue */.Cs)(data.decay);
        }
        if (data.direction !== undefined) {
            this.direction = data.direction;
        }
        if (data.distance !== undefined) {
            this.distance = (0,TypeUtils/* isNumber */.hj)(data.distance)
                ? {
                    horizontal: data.distance,
                    vertical: data.distance,
                }
                : { ...data.distance };
        }
        if (data.drift !== undefined) {
            this.drift = (0,NumberUtils/* setRangeValue */.Cs)(data.drift);
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        this.gravity.load(data.gravity);
        const outModes = data.outModes;
        if (outModes !== undefined) {
            if ((0,TypeUtils/* isObject */.Kn)(outModes)) {
                this.outModes.load(outModes);
            }
            else {
                this.outModes.load({
                    default: outModes,
                });
            }
        }
        this.path.load(data.path);
        if (data.random !== undefined) {
            this.random = data.random;
        }
        if (data.size !== undefined) {
            this.size = data.size;
        }
        if (data.speed !== undefined) {
            this.speed = (0,NumberUtils/* setRangeValue */.Cs)(data.speed);
        }
        this.spin.load(data.spin);
        if (data.straight !== undefined) {
            this.straight = data.straight;
        }
        this.trail.load(data.trail);
        if (data.vibrate !== undefined) {
            this.vibrate = data.vibrate;
        }
        if (data.warp !== undefined) {
            this.warp = data.warp;
        }
    }
}


/***/ }),

/***/ 99483:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ MoveAngle; }
/* harmony export */ });
/* harmony import */ var _Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);

class MoveAngle {
    constructor() {
        this.offset = 0;
        this.value = 90;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.offset !== undefined) {
            this.offset = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(data.offset);
        }
        if (data.value !== undefined) {
            this.value = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(data.value);
        }
    }
}


/***/ }),

/***/ 11518:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ MoveAttract; }
/* harmony export */ });
/* harmony import */ var _Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);

class MoveAttract {
    constructor() {
        this.distance = 200;
        this.enable = false;
        this.rotate = {
            x: 3000,
            y: 3000,
        };
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.distance !== undefined) {
            this.distance = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(data.distance);
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.rotate) {
            const rotateX = data.rotate.x;
            if (rotateX !== undefined) {
                this.rotate.x = rotateX;
            }
            const rotateY = data.rotate.y;
            if (rotateY !== undefined) {
                this.rotate.y = rotateY;
            }
        }
    }
}


/***/ }),

/***/ 47921:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ MoveGravity; }
/* harmony export */ });
/* harmony import */ var _Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);

class MoveGravity {
    constructor() {
        this.acceleration = 9.81;
        this.enable = false;
        this.inverse = false;
        this.maxSpeed = 50;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.acceleration !== undefined) {
            this.acceleration = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(data.acceleration);
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.inverse !== undefined) {
            this.inverse = data.inverse;
        }
        if (data.maxSpeed !== undefined) {
            this.maxSpeed = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(data.maxSpeed);
        }
    }
}


/***/ }),

/***/ 74562:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ MovePath; }
/* harmony export */ });
/* harmony import */ var _ValueWithRandom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67073);
/* harmony import */ var _Utils_Utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22486);


class MovePath {
    constructor() {
        this.clamp = true;
        this.delay = new _ValueWithRandom_js__WEBPACK_IMPORTED_MODULE_0__/* .ValueWithRandom */ .SW();
        this.enable = false;
        this.options = {};
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.clamp !== undefined) {
            this.clamp = data.clamp;
        }
        this.delay.load(data.delay);
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        this.generator = data.generator;
        if (data.options) {
            this.options = (0,_Utils_Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .deepExtend */ .ZB)(this.options, data.options);
        }
    }
}


/***/ }),

/***/ 38758:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ Spin; }
/* harmony export */ });
/* harmony import */ var _Utils_Utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22486);
/* harmony import */ var _Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94986);


class Spin {
    constructor() {
        this.acceleration = 0;
        this.enable = false;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.acceleration !== undefined) {
            this.acceleration = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .setRangeValue */ .Cs)(data.acceleration);
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.position) {
            this.position = (0,_Utils_Utils_js__WEBPACK_IMPORTED_MODULE_0__/* .deepExtend */ .ZB)({}, data.position);
        }
    }
}


/***/ }),

/***/ 24343:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Opacity; }
/* harmony export */ });
/* harmony import */ var _OpacityAnimation_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70361);
/* harmony import */ var _ValueWithRandom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67073);


class Opacity extends _ValueWithRandom_js__WEBPACK_IMPORTED_MODULE_1__/* .RangedAnimationValueWithRandom */ .md {
    constructor() {
        super();
        this.animation = new _OpacityAnimation_js__WEBPACK_IMPORTED_MODULE_0__/* .OpacityAnimation */ .O();
        this.value = 1;
    }
    load(data) {
        if (!data) {
            return;
        }
        super.load(data);
        const animation = data.animation;
        if (animation !== undefined) {
            this.animation.load(animation);
        }
    }
}


/***/ }),

/***/ 70361:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ OpacityAnimation; }
/* harmony export */ });
/* harmony import */ var _AnimationOptions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99836);

class OpacityAnimation extends _AnimationOptions_js__WEBPACK_IMPORTED_MODULE_0__/* .RangedAnimationOptions */ .B {
    constructor() {
        super();
        this.destroy = "none";
        this.speed = 2;
    }
    load(data) {
        super.load(data);
        if (!data) {
            return;
        }
        if (data.destroy !== undefined) {
            this.destroy = data.destroy;
        }
    }
}


/***/ }),

/***/ 74178:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ ParticlesOptions; }
});

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/Utils.js
var Utils = __webpack_require__(22486);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/AnimatableColor.js
var AnimatableColor = __webpack_require__(92418);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Collisions/Collisions.js + 2 modules
var Collisions = __webpack_require__(92392);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Effect/Effect.js

class Effect {
    constructor() {
        this.close = true;
        this.fill = true;
        this.options = {};
        this.type = [];
    }
    load(data) {
        if (!data) {
            return;
        }
        const options = data.options;
        if (options !== undefined) {
            for (const effect in options) {
                const item = options[effect];
                if (item) {
                    this.options[effect] = (0,Utils/* deepExtend */.ZB)(this.options[effect] ?? {}, item);
                }
            }
        }
        if (data.close !== undefined) {
            this.close = data.close;
        }
        if (data.fill !== undefined) {
            this.fill = data.fill;
        }
        if (data.type !== undefined) {
            this.type = data.type;
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/Move.js + 4 modules
var Move = __webpack_require__(85009);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Opacity/Opacity.js
var Opacity = __webpack_require__(24343);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Bounce/ParticlesBounce.js
var ParticlesBounce = __webpack_require__(28799);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Number/ParticlesDensity.js
class ParticlesDensity {
    constructor() {
        this.enable = false;
        this.width = 1920;
        this.height = 1080;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        const width = data.width;
        if (width !== undefined) {
            this.width = width;
        }
        const height = data.height;
        if (height !== undefined) {
            this.height = height;
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Number/ParticlesNumberLimit.js
class ParticlesNumberLimit {
    constructor() {
        this.mode = "delete";
        this.value = 0;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.mode !== undefined) {
            this.mode = data.mode;
        }
        if (data.value !== undefined) {
            this.value = data.value;
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Number/ParticlesNumber.js


class ParticlesNumber {
    constructor() {
        this.density = new ParticlesDensity();
        this.limit = new ParticlesNumberLimit();
        this.value = 0;
    }
    load(data) {
        if (!data) {
            return;
        }
        this.density.load(data.density);
        this.limit.load(data.limit);
        if (data.value !== undefined) {
            this.value = data.value;
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/OptionsColor.js
var OptionsColor = __webpack_require__(71327);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Shadow.js

class Shadow {
    constructor() {
        this.blur = 0;
        this.color = new OptionsColor/* OptionsColor */.O();
        this.enable = false;
        this.offset = {
            x: 0,
            y: 0,
        };
        this.color.value = "#000";
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.blur !== undefined) {
            this.blur = data.blur;
        }
        this.color = OptionsColor/* OptionsColor.create */.O.create(this.color, data.color);
        if (data.enable !== undefined) {
            this.enable = data.enable;
        }
        if (data.offset === undefined) {
            return;
        }
        if (data.offset.x !== undefined) {
            this.offset.x = data.offset.x;
        }
        if (data.offset.y !== undefined) {
            this.offset.y = data.offset.y;
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Shape/Shape.js
var Shape = __webpack_require__(91580);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Size/Size.js
var Size = __webpack_require__(45272);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Stroke.js
var Stroke = __webpack_require__(64750);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/ZIndex/ZIndex.js
var ZIndex = __webpack_require__(74685);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/ParticlesOptions.js













class ParticlesOptions {
    constructor(engine, container) {
        this._engine = engine;
        this._container = container;
        this.bounce = new ParticlesBounce/* ParticlesBounce */.b();
        this.collisions = new Collisions/* Collisions */.y();
        this.color = new AnimatableColor/* AnimatableColor */.R();
        this.color.value = "#fff";
        this.effect = new Effect();
        this.groups = {};
        this.move = new Move/* Move */.A();
        this.number = new ParticlesNumber();
        this.opacity = new Opacity/* Opacity */.D();
        this.reduceDuplicates = false;
        this.shadow = new Shadow();
        this.shape = new Shape/* Shape */.b();
        this.size = new Size/* Size */.$();
        this.stroke = new Stroke/* Stroke */.m();
        this.zIndex = new ZIndex/* ZIndex */.K();
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.groups !== undefined) {
            for (const group of Object.keys(data.groups)) {
                if (!Object.hasOwn(data.groups, group)) {
                    continue;
                }
                const item = data.groups[group];
                if (item !== undefined) {
                    this.groups[group] = (0,Utils/* deepExtend */.ZB)(this.groups[group] ?? {}, item);
                }
            }
        }
        if (data.reduceDuplicates !== undefined) {
            this.reduceDuplicates = data.reduceDuplicates;
        }
        this.bounce.load(data.bounce);
        this.color.load(AnimatableColor/* AnimatableColor.create */.R.create(this.color, data.color));
        this.effect.load(data.effect);
        this.move.load(data.move);
        this.number.load(data.number);
        this.opacity.load(data.opacity);
        this.shape.load(data.shape);
        this.size.load(data.size);
        this.shadow.load(data.shadow);
        this.zIndex.load(data.zIndex);
        this.collisions.load(data.collisions);
        if (data.interactivity !== undefined) {
            this.interactivity = (0,Utils/* deepExtend */.ZB)({}, data.interactivity);
        }
        const strokeToLoad = data.stroke;
        if (strokeToLoad) {
            this.stroke = (0,Utils/* executeOnSingleOrMultiple */.KH)(strokeToLoad, (t) => {
                const tmp = new Stroke/* Stroke */.m();
                tmp.load(t);
                return tmp;
            });
        }
        if (this._container) {
            const updaters = this._engine.updaters.get(this._container);
            if (updaters) {
                for (const updater of updaters) {
                    if (updater.loadOptions) {
                        updater.loadOptions(this, data);
                    }
                }
            }
            const interactors = this._engine.interactors.get(this._container);
            if (interactors) {
                for (const interactor of interactors) {
                    if (interactor.loadParticlesOptions) {
                        interactor.loadParticlesOptions(this, data);
                    }
                }
            }
        }
    }
}


/***/ }),

/***/ 91580:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Shape; }
/* harmony export */ });
/* harmony import */ var _Utils_Utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22486);

class Shape {
    constructor() {
        this.close = true;
        this.fill = true;
        this.options = {};
        this.type = "circle";
    }
    load(data) {
        if (!data) {
            return;
        }
        const options = data.options;
        if (options !== undefined) {
            for (const shape in options) {
                const item = options[shape];
                if (item) {
                    this.options[shape] = (0,_Utils_Utils_js__WEBPACK_IMPORTED_MODULE_0__/* .deepExtend */ .ZB)(this.options[shape] ?? {}, item);
                }
            }
        }
        if (data.close !== undefined) {
            this.close = data.close;
        }
        if (data.fill !== undefined) {
            this.fill = data.fill;
        }
        if (data.type !== undefined) {
            this.type = data.type;
        }
    }
}


/***/ }),

/***/ 45272:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Size; }
/* harmony export */ });
/* harmony import */ var _ValueWithRandom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67073);
/* harmony import */ var _SizeAnimation_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26426);


class Size extends _ValueWithRandom_js__WEBPACK_IMPORTED_MODULE_0__/* .RangedAnimationValueWithRandom */ .md {
    constructor() {
        super();
        this.animation = new _SizeAnimation_js__WEBPACK_IMPORTED_MODULE_1__/* .SizeAnimation */ .a();
        this.value = 3;
    }
    load(data) {
        super.load(data);
        if (!data) {
            return;
        }
        const animation = data.animation;
        if (animation !== undefined) {
            this.animation.load(animation);
        }
    }
}


/***/ }),

/***/ 26426:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ SizeAnimation; }
/* harmony export */ });
/* harmony import */ var _AnimationOptions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99836);

class SizeAnimation extends _AnimationOptions_js__WEBPACK_IMPORTED_MODULE_0__/* .RangedAnimationOptions */ .B {
    constructor() {
        super();
        this.destroy = "none";
        this.speed = 5;
    }
    load(data) {
        super.load(data);
        if (!data) {
            return;
        }
        if (data.destroy !== undefined) {
            this.destroy = data.destroy;
        }
    }
}


/***/ }),

/***/ 64750:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Stroke; }
/* harmony export */ });
/* harmony import */ var _AnimatableColor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92418);
/* harmony import */ var _Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94986);


class Stroke {
    constructor() {
        this.width = 0;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.color !== undefined) {
            this.color = _AnimatableColor_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimatableColor.create */ .R.create(this.color, data.color);
        }
        if (data.width !== undefined) {
            this.width = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .setRangeValue */ .Cs)(data.width);
        }
        if (data.opacity !== undefined) {
            this.opacity = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .setRangeValue */ .Cs)(data.opacity);
        }
    }
}


/***/ }),

/***/ 74685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ZIndex; }
/* harmony export */ });
/* harmony import */ var _ValueWithRandom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67073);

class ZIndex extends _ValueWithRandom_js__WEBPACK_IMPORTED_MODULE_0__/* .ValueWithRandom */ .SW {
    constructor() {
        super();
        this.opacityRate = 1;
        this.sizeRate = 1;
        this.velocityRate = 1;
    }
    load(data) {
        super.load(data);
        if (!data) {
            return;
        }
        if (data.opacityRate !== undefined) {
            this.opacityRate = data.opacityRate;
        }
        if (data.sizeRate !== undefined) {
            this.sizeRate = data.sizeRate;
        }
        if (data.velocityRate !== undefined) {
            this.velocityRate = data.velocityRate;
        }
    }
}


/***/ }),

/***/ 85759:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Responsive; }
/* harmony export */ });
/* harmony import */ var _Utils_Utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22486);

class Responsive {
    constructor() {
        this.maxWidth = Infinity;
        this.options = {};
        this.mode = "canvas";
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.maxWidth !== undefined) {
            this.maxWidth = data.maxWidth;
        }
        if (data.mode !== undefined) {
            if (data.mode === "screen") {
                this.mode = "screen";
            }
            else {
                this.mode = "canvas";
            }
        }
        if (data.options !== undefined) {
            this.options = (0,_Utils_Utils_js__WEBPACK_IMPORTED_MODULE_0__/* .deepExtend */ .ZB)({}, data.options);
        }
    }
}


/***/ }),

/***/ 32355:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ Theme; }
});

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Theme/ThemeDefault.js
class ThemeDefault {
    constructor() {
        this.auto = false;
        this.mode = "any";
        this.value = false;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.auto !== undefined) {
            this.auto = data.auto;
        }
        if (data.mode !== undefined) {
            this.mode = data.mode;
        }
        if (data.value !== undefined) {
            this.value = data.value;
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/Utils.js
var Utils = __webpack_require__(22486);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Theme/Theme.js


class Theme {
    constructor() {
        this.name = "";
        this.default = new ThemeDefault();
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.name !== undefined) {
            this.name = data.name;
        }
        this.default.load(data.default);
        if (data.options !== undefined) {
            this.options = (0,Utils/* deepExtend */.ZB)({}, data.options);
        }
    }
}


/***/ }),

/***/ 67073:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SW": function() { return /* binding */ ValueWithRandom; },
/* harmony export */   "md": function() { return /* binding */ RangedAnimationValueWithRandom; }
/* harmony export */ });
/* unused harmony export AnimationValueWithRandom */
/* harmony import */ var _AnimationOptions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99836);
/* harmony import */ var _Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94986);


class ValueWithRandom {
    constructor() {
        this.value = 0;
    }
    load(data) {
        if (!data) {
            return;
        }
        if (data.value !== undefined) {
            this.value = (0,_Utils_NumberUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .setRangeValue */ .Cs)(data.value);
        }
    }
}
class AnimationValueWithRandom extends ValueWithRandom {
    constructor() {
        super();
        this.animation = new _AnimationOptions_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimationOptions */ .P();
    }
    load(data) {
        super.load(data);
        if (!data) {
            return;
        }
        const animation = data.animation;
        if (animation !== undefined) {
            this.animation.load(animation);
        }
    }
}
class RangedAnimationValueWithRandom extends AnimationValueWithRandom {
    constructor() {
        super();
        this.animation = new _AnimationOptions_js__WEBPACK_IMPORTED_MODULE_0__/* .RangedAnimationOptions */ .B();
    }
    load(data) {
        super.load(data);
    }
}


/***/ }),

/***/ 9685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ drawParticlePlugin; },
/* harmony export */   "C3": function() { return /* binding */ paintImage; },
/* harmony export */   "PL": function() { return /* binding */ alterHsl; },
/* harmony export */   "TQ": function() { return /* binding */ paintBase; },
/* harmony export */   "ZH": function() { return /* binding */ clear; },
/* harmony export */   "Zw": function() { return /* binding */ drawPlugin; },
/* harmony export */   "pS": function() { return /* binding */ drawLine; },
/* harmony export */   "zv": function() { return /* binding */ drawParticle; }
/* harmony export */ });
/* unused harmony exports drawEffect, drawShape, drawShapeAfterDraw */
/* harmony import */ var _ColorUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41594);

const origin = { x: 0, y: 0 };
function drawLine(context, begin, end) {
    context.beginPath();
    context.moveTo(begin.x, begin.y);
    context.lineTo(end.x, end.y);
    context.closePath();
}
function paintBase(context, dimension, baseColor) {
    context.fillStyle = baseColor ?? "rgba(0,0,0,0)";
    context.fillRect(origin.x, origin.y, dimension.width, dimension.height);
}
function paintImage(context, dimension, image, opacity) {
    if (!image) {
        return;
    }
    context.globalAlpha = opacity;
    context.drawImage(image, origin.x, origin.y, dimension.width, dimension.height);
    context.globalAlpha = 1;
}
function clear(context, dimension) {
    context.clearRect(origin.x, origin.y, dimension.width, dimension.height);
}
function drawParticle(data) {
    const { container, context, particle, delta, colorStyles, backgroundMask, composite, radius, opacity, shadow, transform, } = data, pos = particle.getPosition(), defaultAngle = 0, angle = particle.rotation + (particle.pathRotation ? particle.velocity.angle : defaultAngle), rotateData = {
        sin: Math.sin(angle),
        cos: Math.cos(angle),
    }, defaultTransformFactor = 1, transformData = {
        a: rotateData.cos * (transform.a ?? defaultTransformFactor),
        b: rotateData.sin * (transform.b ?? defaultTransformFactor),
        c: -rotateData.sin * (transform.c ?? defaultTransformFactor),
        d: rotateData.cos * (transform.d ?? defaultTransformFactor),
    };
    context.setTransform(transformData.a, transformData.b, transformData.c, transformData.d, pos.x, pos.y);
    if (backgroundMask) {
        context.globalCompositeOperation = composite;
    }
    const shadowColor = particle.shadowColor;
    if (shadow.enable && shadowColor) {
        context.shadowBlur = shadow.blur;
        context.shadowColor = (0,_ColorUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getStyleFromRgb */ .iz)(shadowColor);
        context.shadowOffsetX = shadow.offset.x;
        context.shadowOffsetY = shadow.offset.y;
    }
    if (colorStyles.fill) {
        context.fillStyle = colorStyles.fill;
    }
    const minStrokeWidth = 0, strokeWidth = particle.strokeWidth ?? minStrokeWidth;
    context.lineWidth = strokeWidth;
    if (colorStyles.stroke) {
        context.strokeStyle = colorStyles.stroke;
    }
    const drawData = {
        container,
        context,
        particle,
        radius,
        opacity,
        delta,
        transformData,
        strokeWidth,
    };
    drawShape(drawData);
    drawShapeAfterDraw(drawData);
    drawEffect(drawData);
    context.globalCompositeOperation = "source-over";
    context.resetTransform();
}
function drawEffect(data) {
    const { container, context, particle, radius, opacity, delta, transformData } = data;
    if (!particle.effect) {
        return;
    }
    const drawer = container.effectDrawers.get(particle.effect);
    if (!drawer) {
        return;
    }
    drawer.draw({
        context,
        particle,
        radius,
        opacity,
        delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: { ...transformData },
    });
}
function drawShape(data) {
    const { container, context, particle, radius, opacity, delta, strokeWidth, transformData } = data, minStrokeWidth = 0;
    if (!particle.shape) {
        return;
    }
    const drawer = container.shapeDrawers.get(particle.shape);
    if (!drawer) {
        return;
    }
    context.beginPath();
    drawer.draw({
        context,
        particle,
        radius,
        opacity,
        delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: { ...transformData },
    });
    if (particle.shapeClose) {
        context.closePath();
    }
    if (strokeWidth > minStrokeWidth) {
        context.stroke();
    }
    if (particle.shapeFill) {
        context.fill();
    }
}
function drawShapeAfterDraw(data) {
    const { container, context, particle, radius, opacity, delta, transformData } = data;
    if (!particle.shape) {
        return;
    }
    const drawer = container.shapeDrawers.get(particle.shape);
    if (!drawer?.afterDraw) {
        return;
    }
    drawer.afterDraw({
        context,
        particle,
        radius,
        opacity,
        delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: { ...transformData },
    });
}
function drawPlugin(context, plugin, delta) {
    if (!plugin.draw) {
        return;
    }
    plugin.draw(context, delta);
}
function drawParticlePlugin(context, plugin, particle, delta) {
    if (!plugin.drawParticle) {
        return;
    }
    plugin.drawParticle(context, particle, delta);
}
function alterHsl(color, type, value) {
    const lFactor = 1;
    return {
        h: color.h,
        s: color.s,
        l: color.l + (type === "darken" ? -lFactor : lFactor) * value,
    };
}


/***/ }),

/***/ 41594:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BE": function() { return /* binding */ getLinkColor; },
/* harmony export */   "Dt": function() { return /* binding */ getLinkRandomColor; },
/* harmony export */   "PB": function() { return /* binding */ updateColor; },
/* harmony export */   "VI": function() { return /* binding */ addColorManager; },
/* harmony export */   "Y6": function() { return /* binding */ hslaToRgba; },
/* harmony export */   "bS": function() { return /* binding */ getHslAnimationFromHsl; },
/* harmony export */   "gW": function() { return /* binding */ getHslFromAnimation; },
/* harmony export */   "iz": function() { return /* binding */ getStyleFromRgb; },
/* harmony export */   "lC": function() { return /* binding */ rgbToHsl; },
/* harmony export */   "lN": function() { return /* binding */ rangeColorToHsl; },
/* harmony export */   "oc": function() { return /* binding */ colorMix; },
/* harmony export */   "tX": function() { return /* binding */ rangeColorToRgb; },
/* harmony export */   "ve": function() { return /* binding */ hslToRgb; },
/* harmony export */   "vz": function() { return /* binding */ getStyleFromHsl; }
/* harmony export */ });
/* unused harmony exports colorToRgb, colorToHsl, stringToAlpha, stringToRgb, getRandomRgbColor, updateColorValue */
/* harmony import */ var _NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);
/* harmony import */ var _TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92929);
/* harmony import */ var _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39481);
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22486);




const randomColorValue = "random", midColorValue = "mid", colorManagers = new Map();
function addColorManager(manager) {
    colorManagers.set(manager.key, manager);
}
function stringToRgba(input) {
    for (const [, manager] of colorManagers) {
        if (input.startsWith(manager.stringPrefix)) {
            return manager.parseString(input);
        }
    }
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, hexFixed = input.replace(shorthandRegex, (_, r, g, b, a) => {
        return r + r + g + g + b + b + (a !== undefined ? a + a : "");
    }), regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, result = regex.exec(hexFixed), radix = 16, defaultAlpha = 1, alphaFactor = 0xff;
    return result
        ? {
            a: result[4] !== undefined
                ? parseInt(result[4], radix) / alphaFactor
                : defaultAlpha,
            b: parseInt(result[3], radix),
            g: parseInt(result[2], radix),
            r: parseInt(result[1], radix),
        }
        : undefined;
}
function rangeColorToRgb(input, index, useIndex = true) {
    if (!input) {
        return;
    }
    const color = (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(input) ? { value: input } : input;
    if ((0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(color.value)) {
        return colorToRgb(color.value, index, useIndex);
    }
    if ((0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .kJ)(color.value)) {
        return rangeColorToRgb({
            value: (0,_Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .itemFromArray */ .c8)(color.value, index, useIndex),
        });
    }
    for (const [, manager] of colorManagers) {
        const res = manager.handleRangeColor(color);
        if (res) {
            return res;
        }
    }
}
function colorToRgb(input, index, useIndex = true) {
    if (!input) {
        return;
    }
    const color = (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(input) ? { value: input } : input;
    if ((0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(color.value)) {
        return color.value === randomColorValue ? getRandomRgbColor() : stringToRgb(color.value);
    }
    if ((0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .kJ)(color.value)) {
        return colorToRgb({
            value: (0,_Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .itemFromArray */ .c8)(color.value, index, useIndex),
        });
    }
    for (const [, manager] of colorManagers) {
        const res = manager.handleColor(color);
        if (res) {
            return res;
        }
    }
}
function colorToHsl(color, index, useIndex = true) {
    const rgb = colorToRgb(color, index, useIndex);
    return rgb ? rgbToHsl(rgb) : undefined;
}
function rangeColorToHsl(color, index, useIndex = true) {
    const rgb = rangeColorToRgb(color, index, useIndex);
    return rgb ? rgbToHsl(rgb) : undefined;
}
function rgbToHsl(color) {
    const rgbMax = 255, hMax = 360, sMax = 100, lMax = 100, hMin = 0, sMin = 0, hPhase = 60, half = 0.5, double = 2, r1 = color.r / rgbMax, g1 = color.g / rgbMax, b1 = color.b / rgbMax, max = Math.max(r1, g1, b1), min = Math.min(r1, g1, b1), res = {
        h: hMin,
        l: (max + min) * half,
        s: sMin,
    };
    if (max !== min) {
        res.s = res.l < half ? (max - min) / (max + min) : (max - min) / (double - max - min);
        res.h =
            r1 === max
                ? (g1 - b1) / (max - min)
                : (res.h = g1 === max ? double + (b1 - r1) / (max - min) : double * double + (r1 - g1) / (max - min));
    }
    res.l *= lMax;
    res.s *= sMax;
    res.h *= hPhase;
    if (res.h < hMin) {
        res.h += hMax;
    }
    if (res.h >= hMax) {
        res.h -= hMax;
    }
    return res;
}
function stringToAlpha(input) {
    return stringToRgba(input)?.a;
}
function stringToRgb(input) {
    return stringToRgba(input);
}
function hslToRgb(hsl) {
    const hMax = 360, sMax = 100, lMax = 100, sMin = 0, lMin = 0, h = ((hsl.h % hMax) + hMax) % hMax, s = Math.max(sMin, Math.min(sMax, hsl.s)), l = Math.max(lMin, Math.min(lMax, hsl.l)), hNormalized = h / hMax, sNormalized = s / sMax, lNormalized = l / lMax, rgbFactor = 255, triple = 3;
    if (s === sMin) {
        const grayscaleValue = Math.round(lNormalized * rgbFactor);
        return { r: grayscaleValue, g: grayscaleValue, b: grayscaleValue };
    }
    const half = 0.5, double = 2, channel = (temp1, temp2, temp3) => {
        const temp3Min = 0, temp3Max = 1, sextuple = 6;
        if (temp3 < temp3Min) {
            temp3++;
        }
        if (temp3 > temp3Max) {
            temp3--;
        }
        if (temp3 * sextuple < temp3Max) {
            return temp1 + (temp2 - temp1) * sextuple * temp3;
        }
        if (temp3 * double < temp3Max) {
            return temp2;
        }
        if (temp3 * triple < temp3Max * double) {
            const temp3Offset = double / triple;
            return temp1 + (temp2 - temp1) * (temp3Offset - temp3) * sextuple;
        }
        return temp1;
    }, sNormalizedOffset = 1, temp1 = lNormalized < half
        ? lNormalized * (sNormalizedOffset + sNormalized)
        : lNormalized + sNormalized - lNormalized * sNormalized, temp2 = double * lNormalized - temp1, phaseNumerator = 1, phaseThird = phaseNumerator / triple, red = Math.min(rgbFactor, rgbFactor * channel(temp2, temp1, hNormalized + phaseThird)), green = Math.min(rgbFactor, rgbFactor * channel(temp2, temp1, hNormalized)), blue = Math.min(rgbFactor, rgbFactor * channel(temp2, temp1, hNormalized - phaseThird));
    return { r: Math.round(red), g: Math.round(green), b: Math.round(blue) };
}
function hslaToRgba(hsla) {
    const rgbResult = hslToRgb(hsla);
    return {
        a: hsla.a,
        b: rgbResult.b,
        g: rgbResult.g,
        r: rgbResult.r,
    };
}
function getRandomRgbColor(min) {
    const defaultMin = 0, fixedMin = min ?? defaultMin, rgbMax = 256;
    return {
        b: Math.floor((0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .randomInRange */ .vd)((0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(fixedMin, rgbMax))),
        g: Math.floor((0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .randomInRange */ .vd)((0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(fixedMin, rgbMax))),
        r: Math.floor((0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .randomInRange */ .vd)((0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(fixedMin, rgbMax))),
    };
}
function getStyleFromRgb(color, opacity) {
    const defaultOpacity = 1;
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${opacity ?? defaultOpacity})`;
}
function getStyleFromHsl(color, opacity) {
    const defaultOpacity = 1;
    return `hsla(${color.h}, ${color.s}%, ${color.l}%, ${opacity ?? defaultOpacity})`;
}
function colorMix(color1, color2, size1, size2) {
    let rgb1 = color1, rgb2 = color2;
    if (rgb1.r === undefined) {
        rgb1 = hslToRgb(color1);
    }
    if (rgb2.r === undefined) {
        rgb2 = hslToRgb(color2);
    }
    return {
        b: (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .mix */ .CD)(rgb1.b, rgb2.b, size1, size2),
        g: (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .mix */ .CD)(rgb1.g, rgb2.g, size1, size2),
        r: (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .mix */ .CD)(rgb1.r, rgb2.r, size1, size2),
    };
}
function getLinkColor(p1, p2, linkColor) {
    if (linkColor === randomColorValue) {
        return getRandomRgbColor();
    }
    else if (linkColor === midColorValue) {
        const sourceColor = p1.getFillColor() ?? p1.getStrokeColor(), destColor = p2?.getFillColor() ?? p2?.getStrokeColor();
        if (sourceColor && destColor && p2) {
            return colorMix(sourceColor, destColor, p1.getRadius(), p2.getRadius());
        }
        else {
            const hslColor = sourceColor ?? destColor;
            if (hslColor) {
                return hslToRgb(hslColor);
            }
        }
    }
    else {
        return linkColor;
    }
}
function getLinkRandomColor(optColor, blink, consent) {
    const color = (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(optColor) ? optColor : optColor.value;
    if (color === randomColorValue) {
        if (consent) {
            return rangeColorToRgb({
                value: color,
            });
        }
        if (blink) {
            return randomColorValue;
        }
        return midColorValue;
    }
    else if (color === midColorValue) {
        return midColorValue;
    }
    else {
        return rangeColorToRgb({
            value: color,
        });
    }
}
function getHslFromAnimation(animation) {
    return animation !== undefined
        ? {
            h: animation.h.value,
            s: animation.s.value,
            l: animation.l.value,
        }
        : undefined;
}
function getHslAnimationFromHsl(hsl, animationOptions, reduceFactor) {
    const resColor = {
        h: {
            enable: false,
            value: hsl.h,
        },
        s: {
            enable: false,
            value: hsl.s,
        },
        l: {
            enable: false,
            value: hsl.l,
        },
    };
    if (animationOptions) {
        setColorAnimation(resColor.h, animationOptions.h, reduceFactor);
        setColorAnimation(resColor.s, animationOptions.s, reduceFactor);
        setColorAnimation(resColor.l, animationOptions.l, reduceFactor);
    }
    return resColor;
}
function setColorAnimation(colorValue, colorAnimation, reduceFactor) {
    colorValue.enable = colorAnimation.enable;
    const defaultVelocity = 0, decayOffset = 1, defaultLoops = 0, defaultTime = 0;
    if (colorValue.enable) {
        colorValue.velocity = ((0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(colorAnimation.speed) / _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__/* .percentDenominator */ .tZ) * reduceFactor;
        colorValue.decay = decayOffset - (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(colorAnimation.decay);
        colorValue.status = "increasing";
        colorValue.loops = defaultLoops;
        colorValue.maxLoops = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(colorAnimation.count);
        colorValue.time = defaultTime;
        colorValue.delayTime = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(colorAnimation.delay) * _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__/* .millisecondsToSeconds */ .X5;
        if (!colorAnimation.sync) {
            colorValue.velocity *= (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRandom */ .sZ)();
            colorValue.value *= (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRandom */ .sZ)();
        }
        colorValue.initialValue = colorValue.value;
        colorValue.offset = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .setRangeValue */ .Cs)(colorAnimation.offset);
    }
    else {
        colorValue.velocity = defaultVelocity;
    }
}
function updateColorValue(data, range, decrease, delta) {
    const minLoops = 0, minDelay = 0, identity = 1, minVelocity = 0, minOffset = 0, velocityFactor = 3.6;
    if (!data ||
        !data.enable ||
        ((data.maxLoops ?? minLoops) > minLoops && (data.loops ?? minLoops) > (data.maxLoops ?? minLoops))) {
        return;
    }
    if (!data.time) {
        data.time = 0;
    }
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) {
        data.time += delta.value;
    }
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) {
        return;
    }
    const offset = data.offset ? (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .randomInRange */ .vd)(data.offset) : minOffset, velocity = (data.velocity ?? minVelocity) * delta.factor + offset * velocityFactor, decay = data.decay ?? identity, max = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeMax */ .KI)(range), min = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeMin */ .Uv)(range);
    if (!decrease || data.status === "increasing") {
        data.value += velocity;
        if (data.value > max) {
            if (!data.loops) {
                data.loops = 0;
            }
            data.loops++;
            if (decrease) {
                data.status = "decreasing";
            }
            else {
                data.value -= max;
            }
        }
    }
    else {
        data.value -= velocity;
        const minValue = 0;
        if (data.value < minValue) {
            if (!data.loops) {
                data.loops = 0;
            }
            data.loops++;
            data.status = "increasing";
        }
    }
    if (data.velocity && decay !== identity) {
        data.velocity *= decay;
    }
    data.value = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .clamp */ .uZ)(data.value, min, max);
}
function updateColor(color, delta) {
    if (!color) {
        return;
    }
    const { h, s, l } = color;
    const ranges = {
        h: { min: 0, max: 360 },
        s: { min: 0, max: 100 },
        l: { min: 0, max: 100 },
    };
    if (h) {
        updateColorValue(h, ranges.h, false, delta);
    }
    if (s) {
        updateColorValue(s, ranges.s, true, delta);
    }
    if (l) {
        updateColorValue(l, ranges.l, true, delta);
    }
}


/***/ }),

/***/ 94986:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BV": function() { return /* binding */ parseAlpha; },
/* harmony export */   "CD": function() { return /* binding */ mix; },
/* harmony export */   "Cs": function() { return /* binding */ setRangeValue; },
/* harmony export */   "Gk": function() { return /* binding */ getParticleDirectionAngle; },
/* harmony export */   "Gu": function() { return /* binding */ getRangeValue; },
/* harmony export */   "Gz": function() { return /* binding */ calcPositionOrRandomFromSizeRanged; },
/* harmony export */   "Id": function() { return /* binding */ degToRad; },
/* harmony export */   "KI": function() { return /* binding */ getRangeMax; },
/* harmony export */   "Sp": function() { return /* binding */ getDistance; },
/* harmony export */   "Uv": function() { return /* binding */ getRangeMin; },
/* harmony export */   "_X": function() { return /* binding */ getEasing; },
/* harmony export */   "bx": function() { return /* binding */ addEasing; },
/* harmony export */   "hA": function() { return /* binding */ collisionVelocity; },
/* harmony export */   "lQ": function() { return /* binding */ getParticleBaseVelocity; },
/* harmony export */   "mC": function() { return /* binding */ calcExactPositionOrRandomFromSize; },
/* harmony export */   "oW": function() { return /* binding */ getDistances; },
/* harmony export */   "p": function() { return /* binding */ calcPositionOrRandomFromSize; },
/* harmony export */   "sZ": function() { return /* binding */ getRandom; },
/* harmony export */   "uZ": function() { return /* binding */ clamp; },
/* harmony export */   "vd": function() { return /* binding */ randomInRange; }
/* harmony export */ });
/* unused harmony exports setRandom, calcPositionFromSize, calcExactPositionOrRandomFromSizeRanged */
/* harmony import */ var _Core_Utils_Vectors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15641);
/* harmony import */ var _TypeUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92929);
/* harmony import */ var _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39481);



let _random = Math.random;
const easings = new Map(), double = 2, doublePI = Math.PI * double;
function addEasing(name, easing) {
    if (easings.get(name)) {
        return;
    }
    easings.set(name, easing);
}
function getEasing(name) {
    return easings.get(name) ?? ((value) => value);
}
function setRandom(rnd = Math.random) {
    _random = rnd;
}
function getRandom() {
    const min = 0, max = 1;
    return clamp(_random(), min, max - Number.EPSILON);
}
function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function mix(comp1, comp2, weight1, weight2) {
    return Math.floor((comp1 * weight1 + comp2 * weight2) / (weight1 + weight2));
}
function randomInRange(r) {
    const max = getRangeMax(r), minOffset = 0;
    let min = getRangeMin(r);
    if (max === min) {
        min = minOffset;
    }
    return getRandom() * (max - min) + min;
}
function getRangeValue(value) {
    return (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .isNumber */ .hj)(value) ? value : randomInRange(value);
}
function getRangeMin(value) {
    return (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .isNumber */ .hj)(value) ? value : value.min;
}
function getRangeMax(value) {
    return (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .isNumber */ .hj)(value) ? value : value.max;
}
function setRangeValue(source, value) {
    if (source === value || (value === undefined && (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .isNumber */ .hj)(source))) {
        return source;
    }
    const min = getRangeMin(source), max = getRangeMax(source);
    return value !== undefined
        ? {
            min: Math.min(min, value),
            max: Math.max(max, value),
        }
        : setRangeValue(min, max);
}
function getDistances(pointA, pointB) {
    const dx = pointA.x - pointB.x, dy = pointA.y - pointB.y, squareExp = 2;
    return { dx: dx, dy: dy, distance: Math.sqrt(dx ** squareExp + dy ** squareExp) };
}
function getDistance(pointA, pointB) {
    return getDistances(pointA, pointB).distance;
}
function degToRad(degrees) {
    const PIDeg = 180;
    return (degrees * Math.PI) / PIDeg;
}
function getParticleDirectionAngle(direction, position, center) {
    if ((0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .isNumber */ .hj)(direction)) {
        return degToRad(direction);
    }
    const empty = 0, half = 0.5, quarter = 0.25, threeQuarter = half + quarter;
    switch (direction) {
        case "top":
            return -Math.PI * half;
        case "top-right":
            return -Math.PI * quarter;
        case "right":
            return empty;
        case "bottom-right":
            return Math.PI * quarter;
        case "bottom":
            return Math.PI * half;
        case "bottom-left":
            return Math.PI * threeQuarter;
        case "left":
            return Math.PI;
        case "top-left":
            return -Math.PI * threeQuarter;
        case "inside":
            return Math.atan2(center.y - position.y, center.x - position.x);
        case "outside":
            return Math.atan2(position.y - center.y, position.x - center.x);
        default:
            return getRandom() * doublePI;
    }
}
function getParticleBaseVelocity(direction) {
    const baseVelocity = _Core_Utils_Vectors_js__WEBPACK_IMPORTED_MODULE_0__/* .Vector.origin */ .O.origin;
    baseVelocity.length = 1;
    baseVelocity.angle = direction;
    return baseVelocity;
}
function collisionVelocity(v1, v2, m1, m2) {
    const double = 2;
    return _Core_Utils_Vectors_js__WEBPACK_IMPORTED_MODULE_0__/* .Vector.create */ .O.create((v1.x * (m1 - m2)) / (m1 + m2) + (v2.x * double * m2) / (m1 + m2), v1.y);
}
function calcPositionFromSize(data) {
    return data.position?.x !== undefined && data.position.y !== undefined
        ? {
            x: (data.position.x * data.size.width) / percentDenominator,
            y: (data.position.y * data.size.height) / percentDenominator,
        }
        : undefined;
}
function calcPositionOrRandomFromSize(data) {
    return {
        x: ((data.position?.x ?? getRandom() * _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_2__/* .percentDenominator */ .tZ) * data.size.width) / _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_2__/* .percentDenominator */ .tZ,
        y: ((data.position?.y ?? getRandom() * _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_2__/* .percentDenominator */ .tZ) * data.size.height) / _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_2__/* .percentDenominator */ .tZ,
    };
}
function calcPositionOrRandomFromSizeRanged(data) {
    const position = {
        x: data.position?.x !== undefined ? getRangeValue(data.position.x) : undefined,
        y: data.position?.y !== undefined ? getRangeValue(data.position.y) : undefined,
    };
    return calcPositionOrRandomFromSize({ size: data.size, position });
}
function calcExactPositionOrRandomFromSize(data) {
    return {
        x: data.position?.x ?? getRandom() * data.size.width,
        y: data.position?.y ?? getRandom() * data.size.height,
    };
}
function calcExactPositionOrRandomFromSizeRanged(data) {
    const position = {
        x: data.position?.x !== undefined ? getRangeValue(data.position.x) : undefined,
        y: data.position?.y !== undefined ? getRangeValue(data.position.y) : undefined,
    };
    return calcExactPositionOrRandomFromSize({ size: data.size, position });
}
function parseAlpha(input) {
    const defaultAlpha = 1;
    if (!input) {
        return defaultAlpha;
    }
    return input.endsWith("%") ? parseFloat(input) / _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_2__/* .percentDenominator */ .tZ : parseFloat(input);
}


/***/ }),

/***/ 13134:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ loadOptions; },
/* harmony export */   "x": function() { return /* binding */ loadParticlesOptions; }
/* harmony export */ });
/* harmony import */ var _Options_Classes_Particles_ParticlesOptions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74178);

function loadOptions(options, ...sourceOptionsArr) {
    for (const sourceOptions of sourceOptionsArr) {
        options.load(sourceOptions);
    }
}
function loadParticlesOptions(engine, container, ...sourceOptionsArr) {
    const options = new _Options_Classes_Particles_ParticlesOptions_js__WEBPACK_IMPORTED_MODULE_0__/* .ParticlesOptions */ .B(engine, container);
    loadOptions(options, ...sourceOptionsArr);
    return options;
}


/***/ }),

/***/ 92929:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "jn": function() { return /* binding */ isBoolean; },
/* harmony export */   "kJ": function() { return /* binding */ isArray; }
/* harmony export */ });
/* unused harmony export isFunction */
function isBoolean(arg) {
    return typeof arg === "boolean";
}
function isString(arg) {
    return typeof arg === "string";
}
function isNumber(arg) {
    return typeof arg === "number";
}
function isFunction(arg) {
    return typeof arg === "function";
}
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function isArray(arg) {
    return Array.isArray(arg);
}


/***/ }),

/***/ 22486:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ac": function() { return /* binding */ isPointInside; },
/* harmony export */   "Cr": function() { return /* binding */ updateAnimation; },
/* harmony export */   "HY": function() { return /* binding */ safeMatchMedia; },
/* harmony export */   "KH": function() { return /* binding */ executeOnSingleOrMultiple; },
/* harmony export */   "Kr": function() { return /* binding */ isSsr; },
/* harmony export */   "M_": function() { return /* binding */ calculateBounds; },
/* harmony export */   "NM": function() { return /* binding */ safeIntersectionObserver; },
/* harmony export */   "V0": function() { return /* binding */ initParticleNumericAnimationValue; },
/* harmony export */   "XD": function() { return /* binding */ divModeExecute; },
/* harmony export */   "ZB": function() { return /* binding */ deepExtend; },
/* harmony export */   "ap": function() { return /* binding */ getSize; },
/* harmony export */   "bt": function() { return /* binding */ getPosition; },
/* harmony export */   "c8": function() { return /* binding */ itemFromArray; },
/* harmony export */   "dB": function() { return /* binding */ isInArray; },
/* harmony export */   "dU": function() { return /* binding */ arrayRandomIndex; },
/* harmony export */   "dp": function() { return /* binding */ rectBounce; },
/* harmony export */   "gy": function() { return /* binding */ circleBounceDataFromParticle; },
/* harmony export */   "iC": function() { return /* binding */ divMode; },
/* harmony export */   "jl": function() { return /* binding */ getLogger; },
/* harmony export */   "kR": function() { return /* binding */ circleBounce; },
/* harmony export */   "mx": function() { return /* binding */ loadFont; },
/* harmony export */   "wA": function() { return /* binding */ itemFromSingleOrMultiple; },
/* harmony export */   "wm": function() { return /* binding */ isDivModeEnabled; },
/* harmony export */   "yf": function() { return /* binding */ safeMutationObserver; }
/* harmony export */ });
/* unused harmony exports setLogger, hasMatchMedia, areBoundsInside, singleDivModeExecute, findItemFromSingleOrMultiple */
/* harmony import */ var _NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);
/* harmony import */ var _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39481);
/* harmony import */ var _TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92929);
/* harmony import */ var _Core_Utils_Vectors_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15641);




const _logger = {
    debug: console.debug,
    error: console.error,
    info: console.info,
    log: console.log,
    verbose: console.log,
    warning: console.warn,
};
function setLogger(logger) {
    _logger.debug = logger.debug || _logger.debug;
    _logger.error = logger.error || _logger.error;
    _logger.info = logger.info || _logger.info;
    _logger.log = logger.log || _logger.log;
    _logger.verbose = logger.verbose || _logger.verbose;
    _logger.warning = logger.warning || _logger.warning;
}
function getLogger() {
    return _logger;
}
function rectSideBounce(data) {
    const res = { bounced: false }, { pSide, pOtherSide, rectSide, rectOtherSide, velocity, factor } = data, half = 0.5, minVelocity = 0;
    if (pOtherSide.min < rectOtherSide.min ||
        pOtherSide.min > rectOtherSide.max ||
        pOtherSide.max < rectOtherSide.min ||
        pOtherSide.max > rectOtherSide.max) {
        return res;
    }
    if ((pSide.max >= rectSide.min && pSide.max <= (rectSide.max + rectSide.min) * half && velocity > minVelocity) ||
        (pSide.min <= rectSide.max && pSide.min > (rectSide.max + rectSide.min) * half && velocity < minVelocity)) {
        res.velocity = velocity * -factor;
        res.bounced = true;
    }
    return res;
}
function checkSelector(element, selectors) {
    const res = executeOnSingleOrMultiple(selectors, (selector) => {
        return element.matches(selector);
    });
    return (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .kJ)(res) ? res.some((t) => t) : res;
}
function isSsr() {
    return typeof window === "undefined" || !window || typeof window.document === "undefined" || !window.document;
}
function hasMatchMedia() {
    return !isSsr() && typeof matchMedia !== "undefined";
}
function safeMatchMedia(query) {
    if (!hasMatchMedia()) {
        return;
    }
    return matchMedia(query);
}
function safeIntersectionObserver(callback) {
    if (isSsr() || typeof IntersectionObserver === "undefined") {
        return;
    }
    return new IntersectionObserver(callback);
}
function safeMutationObserver(callback) {
    if (isSsr() || typeof MutationObserver === "undefined") {
        return;
    }
    return new MutationObserver(callback);
}
function isInArray(value, array) {
    const invalidIndex = -1;
    return value === array || ((0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .kJ)(array) && array.indexOf(value) > invalidIndex);
}
async function loadFont(font, weight) {
    try {
        await document.fonts.load(`${weight ?? "400"} 36px '${font ?? "Verdana"}'`);
    }
    catch {
    }
}
function arrayRandomIndex(array) {
    return Math.floor((0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRandom */ .sZ)() * array.length);
}
function itemFromArray(array, index, useIndex = true) {
    return array[index !== undefined && useIndex ? index % array.length : arrayRandomIndex(array)];
}
function isPointInside(point, size, offset, radius, direction) {
    const minRadius = 0;
    return areBoundsInside(calculateBounds(point, radius ?? minRadius), size, offset, direction);
}
function areBoundsInside(bounds, size, offset, direction) {
    let inside = true;
    if (!direction || direction === "bottom") {
        inside = bounds.top < size.height + offset.x;
    }
    if (inside && (!direction || direction === "left")) {
        inside = bounds.right > offset.x;
    }
    if (inside && (!direction || direction === "right")) {
        inside = bounds.left < size.width + offset.y;
    }
    if (inside && (!direction || direction === "top")) {
        inside = bounds.bottom > offset.y;
    }
    return inside;
}
function calculateBounds(point, radius) {
    return {
        bottom: point.y + radius,
        left: point.x - radius,
        right: point.x + radius,
        top: point.y - radius,
    };
}
function deepExtend(destination, ...sources) {
    for (const source of sources) {
        if (source === undefined || source === null) {
            continue;
        }
        if (!(0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isObject */ .Kn)(source)) {
            destination = source;
            continue;
        }
        const sourceIsArray = Array.isArray(source);
        if (sourceIsArray && ((0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isObject */ .Kn)(destination) || !destination || !Array.isArray(destination))) {
            destination = [];
        }
        else if (!sourceIsArray && ((0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isObject */ .Kn)(destination) || !destination || Array.isArray(destination))) {
            destination = {};
        }
        for (const key in source) {
            if (key === "__proto__") {
                continue;
            }
            const sourceDict = source, value = sourceDict[key], destDict = destination;
            destDict[key] =
                (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isObject */ .Kn)(value) && Array.isArray(value)
                    ? value.map((v) => deepExtend(destDict[key], v))
                    : deepExtend(destDict[key], value);
        }
    }
    return destination;
}
function isDivModeEnabled(mode, divs) {
    return !!findItemFromSingleOrMultiple(divs, (t) => t.enable && isInArray(mode, t.mode));
}
function divModeExecute(mode, divs, callback) {
    executeOnSingleOrMultiple(divs, (div) => {
        const divMode = div.mode, divEnabled = div.enable;
        if (divEnabled && isInArray(mode, divMode)) {
            singleDivModeExecute(div, callback);
        }
    });
}
function singleDivModeExecute(div, callback) {
    const selectors = div.selectors;
    executeOnSingleOrMultiple(selectors, (selector) => {
        callback(selector, div);
    });
}
function divMode(divs, element) {
    if (!element || !divs) {
        return;
    }
    return findItemFromSingleOrMultiple(divs, (div) => {
        return checkSelector(element, div.selectors);
    });
}
function circleBounceDataFromParticle(p) {
    return {
        position: p.getPosition(),
        radius: p.getRadius(),
        mass: p.getMass(),
        velocity: p.velocity,
        factor: _Core_Utils_Vectors_js__WEBPACK_IMPORTED_MODULE_1__/* .Vector.create */ .O.create((0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(p.options.bounce.horizontal.value), (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(p.options.bounce.vertical.value)),
    };
}
function circleBounce(p1, p2) {
    const { x: xVelocityDiff, y: yVelocityDiff } = p1.velocity.sub(p2.velocity), [pos1, pos2] = [p1.position, p2.position], { dx: xDist, dy: yDist } = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getDistances */ .oW)(pos2, pos1), minimumDistance = 0;
    if (xVelocityDiff * xDist + yVelocityDiff * yDist < minimumDistance) {
        return;
    }
    const angle = -Math.atan2(yDist, xDist), m1 = p1.mass, m2 = p2.mass, u1 = p1.velocity.rotate(angle), u2 = p2.velocity.rotate(angle), v1 = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .collisionVelocity */ .hA)(u1, u2, m1, m2), v2 = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .collisionVelocity */ .hA)(u2, u1, m1, m2), vFinal1 = v1.rotate(-angle), vFinal2 = v2.rotate(-angle);
    p1.velocity.x = vFinal1.x * p1.factor.x;
    p1.velocity.y = vFinal1.y * p1.factor.y;
    p2.velocity.x = vFinal2.x * p2.factor.x;
    p2.velocity.y = vFinal2.y * p2.factor.y;
}
function rectBounce(particle, divBounds) {
    const pPos = particle.getPosition(), size = particle.getRadius(), bounds = calculateBounds(pPos, size), bounceOptions = particle.options.bounce, resH = rectSideBounce({
        pSide: {
            min: bounds.left,
            max: bounds.right,
        },
        pOtherSide: {
            min: bounds.top,
            max: bounds.bottom,
        },
        rectSide: {
            min: divBounds.left,
            max: divBounds.right,
        },
        rectOtherSide: {
            min: divBounds.top,
            max: divBounds.bottom,
        },
        velocity: particle.velocity.x,
        factor: (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(bounceOptions.horizontal.value),
    });
    if (resH.bounced) {
        if (resH.velocity !== undefined) {
            particle.velocity.x = resH.velocity;
        }
        if (resH.position !== undefined) {
            particle.position.x = resH.position;
        }
    }
    const resV = rectSideBounce({
        pSide: {
            min: bounds.top,
            max: bounds.bottom,
        },
        pOtherSide: {
            min: bounds.left,
            max: bounds.right,
        },
        rectSide: {
            min: divBounds.top,
            max: divBounds.bottom,
        },
        rectOtherSide: {
            min: divBounds.left,
            max: divBounds.right,
        },
        velocity: particle.velocity.y,
        factor: (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(bounceOptions.vertical.value),
    });
    if (resV.bounced) {
        if (resV.velocity !== undefined) {
            particle.velocity.y = resV.velocity;
        }
        if (resV.position !== undefined) {
            particle.position.y = resV.position;
        }
    }
}
function executeOnSingleOrMultiple(obj, callback) {
    const defaultIndex = 0;
    return (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .kJ)(obj) ? obj.map((item, index) => callback(item, index)) : callback(obj, defaultIndex);
}
function itemFromSingleOrMultiple(obj, index, useIndex) {
    return (0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .kJ)(obj) ? itemFromArray(obj, index, useIndex) : obj;
}
function findItemFromSingleOrMultiple(obj, callback) {
    if ((0,_TypeUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .kJ)(obj)) {
        return obj.find((t, index) => callback(t, index));
    }
    const defaultIndex = 0;
    return callback(obj, defaultIndex) ? obj : undefined;
}
function initParticleNumericAnimationValue(options, pxRatio) {
    const valueRange = options.value, animationOptions = options.animation, res = {
        delayTime: (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(animationOptions.delay) * _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__/* .millisecondsToSeconds */ .X5,
        enable: animationOptions.enable,
        value: (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(options.value) * pxRatio,
        max: (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeMax */ .KI)(valueRange) * pxRatio,
        min: (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeMin */ .Uv)(valueRange) * pxRatio,
        loops: 0,
        maxLoops: (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(animationOptions.count),
        time: 0,
    }, decayOffset = 1;
    if (animationOptions.enable) {
        res.decay = decayOffset - (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRangeValue */ .Gu)(animationOptions.decay);
        switch (animationOptions.mode) {
            case "increase":
                res.status = "increasing";
                break;
            case "decrease":
                res.status = "decreasing";
                break;
            case "random":
                res.status = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRandom */ .sZ)() >= _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__/* .halfRandom */ .vq ? "increasing" : "decreasing";
                break;
        }
        const autoStatus = animationOptions.mode === "auto";
        switch (animationOptions.startValue) {
            case "min":
                res.value = res.min;
                if (autoStatus) {
                    res.status = "increasing";
                }
                break;
            case "max":
                res.value = res.max;
                if (autoStatus) {
                    res.status = "decreasing";
                }
                break;
            case "random":
            default:
                res.value = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .randomInRange */ .vd)(res);
                if (autoStatus) {
                    res.status = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getRandom */ .sZ)() >= _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__/* .halfRandom */ .vq ? "increasing" : "decreasing";
                }
                break;
        }
    }
    res.initialValue = res.value;
    return res;
}
function getPositionOrSize(positionOrSize, canvasSize) {
    const isPercent = positionOrSize.mode === "percent";
    if (!isPercent) {
        const { mode: _, ...rest } = positionOrSize;
        return rest;
    }
    const isPosition = "x" in positionOrSize;
    if (isPosition) {
        return {
            x: (positionOrSize.x / _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__/* .percentDenominator */ .tZ) * canvasSize.width,
            y: (positionOrSize.y / _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__/* .percentDenominator */ .tZ) * canvasSize.height,
        };
    }
    else {
        return {
            width: (positionOrSize.width / _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__/* .percentDenominator */ .tZ) * canvasSize.width,
            height: (positionOrSize.height / _Core_Utils_Constants_js__WEBPACK_IMPORTED_MODULE_3__/* .percentDenominator */ .tZ) * canvasSize.height,
        };
    }
}
function getPosition(position, canvasSize) {
    return getPositionOrSize(position, canvasSize);
}
function getSize(size, canvasSize) {
    return getPositionOrSize(size, canvasSize);
}
function checkDestroy(particle, destroyType, value, minValue, maxValue) {
    switch (destroyType) {
        case "max":
            if (value >= maxValue) {
                particle.destroy();
            }
            break;
        case "min":
            if (value <= minValue) {
                particle.destroy();
            }
            break;
    }
}
function updateAnimation(particle, data, changeDirection, destroyType, delta) {
    const minLoops = 0, minDelay = 0, identity = 1, minVelocity = 0, minDecay = 1;
    if (particle.destroyed ||
        !data ||
        !data.enable ||
        ((data.maxLoops ?? minLoops) > minLoops && (data.loops ?? minLoops) > (data.maxLoops ?? minLoops))) {
        return;
    }
    const velocity = (data.velocity ?? minVelocity) * delta.factor, minValue = data.min, maxValue = data.max, decay = data.decay ?? minDecay;
    if (!data.time) {
        data.time = 0;
    }
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) {
        data.time += delta.value;
    }
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) {
        return;
    }
    switch (data.status) {
        case "increasing":
            if (data.value >= maxValue) {
                if (changeDirection) {
                    data.status = "decreasing";
                }
                else {
                    data.value -= maxValue;
                }
                if (!data.loops) {
                    data.loops = minLoops;
                }
                data.loops++;
            }
            else {
                data.value += velocity;
            }
            break;
        case "decreasing":
            if (data.value <= minValue) {
                if (changeDirection) {
                    data.status = "increasing";
                }
                else {
                    data.value += maxValue;
                }
                if (!data.loops) {
                    data.loops = minLoops;
                }
                data.loops++;
            }
            else {
                data.value -= velocity;
            }
    }
    if (data.velocity && decay !== identity) {
        data.velocity *= decay;
    }
    checkDestroy(particle, destroyType, data.value, minValue, maxValue);
    if (!particle.destroyed) {
        data.value = (0,_NumberUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .clamp */ .uZ)(data.value, minValue, maxValue);
    }
}


/***/ }),

/***/ 80080:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RC": function() { return /* reexport */ AnimatableColor/* AnimatableColor */.R; },
  "Cd": function() { return /* reexport */ Ranges/* Circle */.Cd; },
  "L8": function() { return /* reexport */ ExternalInteractorBase; },
  "Oz": function() { return /* reexport */ OptionsColor/* OptionsColor */.O; },
  "$S": function() { return /* reexport */ ParticlesInteractorBase; },
  "Ae": function() { return /* reexport */ Ranges/* Rectangle */.Ae; },
  "SW": function() { return /* reexport */ ValueWithRandom/* ValueWithRandom */.SW; },
  "OW": function() { return /* reexport */ Vectors/* Vector */.O; },
  "bx": function() { return /* reexport */ NumberUtils/* addEasing */.bx; },
  "dU": function() { return /* reexport */ Utils/* arrayRandomIndex */.dU; },
  "p": function() { return /* reexport */ NumberUtils/* calcPositionOrRandomFromSize */.p; },
  "Gz": function() { return /* reexport */ NumberUtils/* calcPositionOrRandomFromSizeRanged */.Gz; },
  "M_": function() { return /* reexport */ Utils/* calculateBounds */.M_; },
  "kR": function() { return /* reexport */ Utils/* circleBounce */.kR; },
  "gy": function() { return /* reexport */ Utils/* circleBounceDataFromParticle */.gy; },
  "uZ": function() { return /* reexport */ NumberUtils/* clamp */.uZ; },
  "oc": function() { return /* reexport */ ColorUtils/* colorMix */.oc; },
  "ZB": function() { return /* reexport */ Utils/* deepExtend */.ZB; },
  "Id": function() { return /* reexport */ NumberUtils/* degToRad */.Id; },
  "iC": function() { return /* reexport */ Utils/* divMode */.iC; },
  "XD": function() { return /* reexport */ Utils/* divModeExecute */.XD; },
  "pS": function() { return /* reexport */ CanvasUtils/* drawLine */.pS; },
  "gK": function() { return /* reexport */ Constants/* errorPrefix */.gK; },
  "KH": function() { return /* reexport */ Utils/* executeOnSingleOrMultiple */.KH; },
  "Sp": function() { return /* reexport */ NumberUtils/* getDistance */.Sp; },
  "oW": function() { return /* reexport */ NumberUtils/* getDistances */.oW; },
  "_X": function() { return /* reexport */ NumberUtils/* getEasing */._X; },
  "bS": function() { return /* reexport */ ColorUtils/* getHslAnimationFromHsl */.bS; },
  "BE": function() { return /* reexport */ ColorUtils/* getLinkColor */.BE; },
  "Dt": function() { return /* reexport */ ColorUtils/* getLinkRandomColor */.Dt; },
  "jl": function() { return /* reexport */ Utils/* getLogger */.jl; },
  "sZ": function() { return /* reexport */ NumberUtils/* getRandom */.sZ; },
  "KI": function() { return /* reexport */ NumberUtils/* getRangeMax */.KI; },
  "Gu": function() { return /* reexport */ NumberUtils/* getRangeValue */.Gu; },
  "ap": function() { return /* reexport */ Utils/* getSize */.ap; },
  "vz": function() { return /* reexport */ ColorUtils/* getStyleFromHsl */.vz; },
  "iz": function() { return /* reexport */ ColorUtils/* getStyleFromRgb */.iz; },
  "vq": function() { return /* reexport */ Constants/* halfRandom */.vq; },
  "V0": function() { return /* reexport */ Utils/* initParticleNumericAnimationValue */.V0; },
  "kJ": function() { return /* reexport */ TypeUtils/* isArray */.kJ; },
  "wm": function() { return /* reexport */ Utils/* isDivModeEnabled */.wm; },
  "dB": function() { return /* reexport */ Utils/* isInArray */.dB; },
  "hj": function() { return /* reexport */ TypeUtils/* isNumber */.hj; },
  "Kn": function() { return /* reexport */ TypeUtils/* isObject */.Kn; },
  "Ac": function() { return /* reexport */ Utils/* isPointInside */.Ac; },
  "Kr": function() { return /* reexport */ Utils/* isSsr */.Kr; },
  "c8": function() { return /* reexport */ Utils/* itemFromArray */.c8; },
  "wA": function() { return /* reexport */ Utils/* itemFromSingleOrMultiple */.wA; },
  "mx": function() { return /* reexport */ Utils/* loadFont */.mx; },
  "hT": function() { return /* reexport */ OptionsUtils/* loadParticlesOptions */.x; },
  "X5": function() { return /* reexport */ Constants/* millisecondsToSeconds */.X5; },
  "aM": function() { return /* reexport */ Constants/* mouseLeaveEvent */.aM; },
  "Wt": function() { return /* reexport */ Constants/* mouseMoveEvent */.Wt; },
  "tZ": function() { return /* reexport */ Constants/* percentDenominator */.tZ; },
  "vd": function() { return /* reexport */ NumberUtils/* randomInRange */.vd; },
  "lN": function() { return /* reexport */ ColorUtils/* rangeColorToHsl */.lN; },
  "tX": function() { return /* reexport */ ColorUtils/* rangeColorToRgb */.tX; },
  "dp": function() { return /* reexport */ Utils/* rectBounce */.dp; },
  "lC": function() { return /* reexport */ ColorUtils/* rgbToHsl */.lC; },
  "Cs": function() { return /* reexport */ NumberUtils/* setRangeValue */.Cs; },
  "S6": function() { return /* binding */ tsParticles; },
  "Cr": function() { return /* reexport */ Utils/* updateAnimation */.Cr; },
  "PB": function() { return /* reexport */ ColorUtils/* updateColor */.PB; }
});

// UNUSED EXPORTS: AnimationOptions, AnimationValueWithRandom, Background, BackgroundMask, BackgroundMaskCover, BaseRange, ClickEvent, Collisions, CollisionsAbsorb, CollisionsOverlap, ColorAnimation, DivEvent, Events, FullScreen, HoverEvent, HslAnimation, HslColorManager, Interactivity, ManualParticle, Modes, Move, MoveAngle, MoveAttract, MoveCenter, MoveGravity, MovePath, MoveTrail, Opacity, OpacityAnimation, Options, OutModes, Parallax, ParticlesBounce, ParticlesBounceFactor, ParticlesDensity, ParticlesNumber, ParticlesNumberLimit, ParticlesOptions, Point, RangedAnimationOptions, RangedAnimationValueWithRandom, ResizeEvent, Responsive, RgbColorManager, Shadow, Shape, Size, SizeAnimation, Spin, Stroke, Theme, ThemeDefault, Vector3d, ZIndex, addColorManager, alterHsl, areBoundsInside, calcExactPositionOrRandomFromSize, calcExactPositionOrRandomFromSizeRanged, calcPositionFromSize, clear, collisionVelocity, colorToHsl, colorToRgb, drawEffect, drawParticle, drawParticlePlugin, drawPlugin, drawShape, drawShapeAfterDraw, findItemFromSingleOrMultiple, generatedAttribute, getHslFromAnimation, getParticleBaseVelocity, getParticleDirectionAngle, getPosition, getRandomRgbColor, getRangeMin, hasMatchMedia, hslToRgb, hslaToRgba, isBoolean, isFunction, isString, loadOptions, mix, mouseDownEvent, mouseOutEvent, mouseUpEvent, paintBase, paintImage, parseAlpha, resizeEvent, safeIntersectionObserver, safeMatchMedia, safeMutationObserver, setLogger, setRandom, singleDivModeExecute, stringToAlpha, stringToRgb, touchCancelEvent, touchEndEvent, touchMoveEvent, touchStartEvent, updateColorValue, visibilityChangeEvent

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Core/Utils/Constants.js
var Constants = __webpack_require__(39481);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/Utils.js
var Utils = __webpack_require__(22486);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Utils/EventDispatcher.js
class EventDispatcher {
    constructor() {
        this._listeners = new Map();
    }
    addEventListener(type, listener) {
        this.removeEventListener(type, listener);
        let arr = this._listeners.get(type);
        if (!arr) {
            arr = [];
            this._listeners.set(type, arr);
        }
        arr.push(listener);
    }
    dispatchEvent(type, args) {
        const listeners = this._listeners.get(type);
        listeners?.forEach((handler) => handler(args));
    }
    hasEventListener(type) {
        return !!this._listeners.get(type);
    }
    removeAllEventListeners(type) {
        if (!type) {
            this._listeners = new Map();
        }
        else {
            this._listeners.delete(type);
        }
    }
    removeEventListener(type, listener) {
        const arr = this._listeners.get(type);
        if (!arr) {
            return;
        }
        const length = arr.length, idx = arr.indexOf(listener), minIndex = 0;
        if (idx < minIndex) {
            return;
        }
        const deleteCount = 1;
        if (length === deleteCount) {
            this._listeners.delete(type);
        }
        else {
            arr.splice(idx, deleteCount);
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/NumberUtils.js
var NumberUtils = __webpack_require__(94986);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Core/Engine.js




async function getItemsFromInitializer(container, map, initializers, force = false) {
    let res = map.get(container);
    if (!res || force) {
        res = await Promise.all([...initializers.values()].map((t) => t(container)));
        map.set(container, res);
    }
    return res;
}
async function getDataFromUrl(data) {
    const url = (0,Utils/* itemFromSingleOrMultiple */.wA)(data.url, data.index);
    if (!url) {
        return data.fallback;
    }
    const response = await fetch(url);
    if (response.ok) {
        return (await response.json());
    }
    (0,Utils/* getLogger */.jl)().error(`${Constants/* errorPrefix */.gK} ${response.status} while retrieving config file`);
    return data.fallback;
}
class Engine {
    constructor() {
        this._configs = new Map();
        this._domArray = [];
        this._eventDispatcher = new EventDispatcher();
        this._initialized = false;
        this.plugins = [];
        this._initializers = {
            interactors: new Map(),
            movers: new Map(),
            updaters: new Map(),
        };
        this.interactors = new Map();
        this.movers = new Map();
        this.updaters = new Map();
        this.presets = new Map();
        this.effectDrawers = new Map();
        this.shapeDrawers = new Map();
        this.pathGenerators = new Map();
    }
    get configs() {
        const res = {};
        for (const [name, config] of this._configs) {
            res[name] = config;
        }
        return res;
    }
    get version() {
        return "3.3.0";
    }
    addConfig(config) {
        const key = config.key ?? config.name ?? "default";
        this._configs.set(key, config);
        this._eventDispatcher.dispatchEvent("configAdded", { data: { name: key, config } });
    }
    async addEffect(effect, drawer, refresh = true) {
        (0,Utils/* executeOnSingleOrMultiple */.KH)(effect, (type) => {
            if (!this.getEffectDrawer(type)) {
                this.effectDrawers.set(type, drawer);
            }
        });
        await this.refresh(refresh);
    }
    addEventListener(type, listener) {
        this._eventDispatcher.addEventListener(type, listener);
    }
    async addInteractor(name, interactorInitializer, refresh = true) {
        this._initializers.interactors.set(name, interactorInitializer);
        await this.refresh(refresh);
    }
    async addMover(name, moverInitializer, refresh = true) {
        this._initializers.movers.set(name, moverInitializer);
        await this.refresh(refresh);
    }
    async addParticleUpdater(name, updaterInitializer, refresh = true) {
        this._initializers.updaters.set(name, updaterInitializer);
        await this.refresh(refresh);
    }
    async addPathGenerator(name, generator, refresh = true) {
        if (!this.getPathGenerator(name)) {
            this.pathGenerators.set(name, generator);
        }
        await this.refresh(refresh);
    }
    async addPlugin(plugin, refresh = true) {
        if (!this.getPlugin(plugin.id)) {
            this.plugins.push(plugin);
        }
        await this.refresh(refresh);
    }
    async addPreset(preset, options, override = false, refresh = true) {
        if (override || !this.getPreset(preset)) {
            this.presets.set(preset, options);
        }
        await this.refresh(refresh);
    }
    async addShape(shape, drawer, refresh = true) {
        (0,Utils/* executeOnSingleOrMultiple */.KH)(shape, (type) => {
            if (!this.getShapeDrawer(type)) {
                this.shapeDrawers.set(type, drawer);
            }
        });
        await this.refresh(refresh);
    }
    clearPlugins(container) {
        this.updaters.delete(container);
        this.movers.delete(container);
        this.interactors.delete(container);
    }
    dispatchEvent(type, args) {
        this._eventDispatcher.dispatchEvent(type, args);
    }
    dom() {
        return this._domArray;
    }
    domItem(index) {
        const dom = this.dom(), item = dom[index];
        if (!item || item.destroyed) {
            const deleteCount = 1;
            dom.splice(index, deleteCount);
            return;
        }
        return item;
    }
    async getAvailablePlugins(container) {
        const res = new Map();
        for (const plugin of this.plugins) {
            if (plugin.needsPlugin(container.actualOptions)) {
                res.set(plugin.id, await plugin.getPlugin(container));
            }
        }
        return res;
    }
    getEffectDrawer(type) {
        return this.effectDrawers.get(type);
    }
    async getInteractors(container, force = false) {
        return await getItemsFromInitializer(container, this.interactors, this._initializers.interactors, force);
    }
    async getMovers(container, force = false) {
        return await getItemsFromInitializer(container, this.movers, this._initializers.movers, force);
    }
    getPathGenerator(type) {
        return this.pathGenerators.get(type);
    }
    getPlugin(plugin) {
        return this.plugins.find((t) => t.id === plugin);
    }
    getPreset(preset) {
        return this.presets.get(preset);
    }
    getShapeDrawer(type) {
        return this.shapeDrawers.get(type);
    }
    getSupportedEffects() {
        return this.effectDrawers.keys();
    }
    getSupportedShapes() {
        return this.shapeDrawers.keys();
    }
    async getUpdaters(container, force = false) {
        return await getItemsFromInitializer(container, this.updaters, this._initializers.updaters, force);
    }
    init() {
        if (this._initialized) {
            return;
        }
        this._initialized = true;
    }
    async load(params) {
        const randomFactor = 10000, id = params.id ?? params.element?.id ?? `tsparticles${Math.floor((0,NumberUtils/* getRandom */.sZ)() * randomFactor)}`, { index, url } = params, options = url ? await getDataFromUrl({ fallback: params.options, url, index }) : params.options;
        let domContainer = params.element ?? document.getElementById(id);
        if (!domContainer) {
            domContainer = document.createElement("div");
            domContainer.id = id;
            document.body.append(domContainer);
        }
        const currentOptions = (0,Utils/* itemFromSingleOrMultiple */.wA)(options, index), dom = this.dom(), oldIndex = dom.findIndex((v) => v.id.description === id), minIndex = 0;
        if (oldIndex >= minIndex) {
            const old = this.domItem(oldIndex);
            if (old && !old.destroyed) {
                old.destroy();
                const deleteCount = 1;
                dom.splice(oldIndex, deleteCount);
            }
        }
        let canvasEl;
        if (domContainer.tagName.toLowerCase() === "canvas") {
            canvasEl = domContainer;
            canvasEl.dataset[Constants/* generatedAttribute */.YU] = "false";
        }
        else {
            const existingCanvases = domContainer.getElementsByTagName("canvas");
            if (existingCanvases.length) {
                const firstIndex = 0;
                canvasEl = existingCanvases[firstIndex];
                canvasEl.dataset[Constants/* generatedAttribute */.YU] = "false";
            }
            else {
                canvasEl = document.createElement("canvas");
                canvasEl.dataset[Constants/* generatedAttribute */.YU] = "true";
                domContainer.appendChild(canvasEl);
            }
        }
        if (!canvasEl.style.width) {
            canvasEl.style.width = "100%";
        }
        if (!canvasEl.style.height) {
            canvasEl.style.height = "100%";
        }
        const { Container } = await __webpack_require__.e(/* import() */ 4421).then(__webpack_require__.bind(__webpack_require__, 94421)), newItem = new Container(this, id, currentOptions);
        if (oldIndex >= minIndex) {
            const deleteCount = 0;
            dom.splice(oldIndex, deleteCount, newItem);
        }
        else {
            dom.push(newItem);
        }
        newItem.canvas.loadCanvas(canvasEl);
        await newItem.start();
        return newItem;
    }
    loadOptions(options, sourceOptions) {
        for (const plugin of this.plugins) {
            plugin.loadOptions(options, sourceOptions);
        }
    }
    loadParticlesOptions(container, options, ...sourceOptions) {
        const updaters = this.updaters.get(container);
        if (!updaters) {
            return;
        }
        for (const updater of updaters) {
            updater.loadOptions?.(options, ...sourceOptions);
        }
    }
    async refresh(refresh = true) {
        if (!refresh) {
            return;
        }
        await Promise.all(this.dom().map((t) => t.refresh()));
    }
    removeEventListener(type, listener) {
        this._eventDispatcher.removeEventListener(type, listener);
    }
    setOnClickHandler(callback) {
        const dom = this.dom();
        if (!dom.length) {
            throw new Error(`${Constants/* errorPrefix */.gK} can only set click handlers after calling tsParticles.load()`);
        }
        for (const domItem of dom) {
            domItem.addClickHandler(callback);
        }
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/ColorUtils.js
var ColorUtils = __webpack_require__(41594);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Utils/HslColorManager.js


class HslColorManager {
    constructor() {
        this.key = "hsl";
        this.stringPrefix = "hsl";
    }
    handleColor(color) {
        const colorValue = color.value, hslColor = colorValue.hsl ?? color.value;
        if (hslColor.h !== undefined && hslColor.s !== undefined && hslColor.l !== undefined) {
            return (0,ColorUtils/* hslToRgb */.ve)(hslColor);
        }
    }
    handleRangeColor(color) {
        const colorValue = color.value, hslColor = colorValue.hsl ?? color.value;
        if (hslColor.h !== undefined && hslColor.l !== undefined) {
            return (0,ColorUtils/* hslToRgb */.ve)({
                h: (0,NumberUtils/* getRangeValue */.Gu)(hslColor.h),
                l: (0,NumberUtils/* getRangeValue */.Gu)(hslColor.l),
                s: (0,NumberUtils/* getRangeValue */.Gu)(hslColor.s),
            });
        }
    }
    parseString(input) {
        if (!input.startsWith("hsl")) {
            return;
        }
        const regex = /hsla?\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([\d.%]+)\s*)?\)/i, result = regex.exec(input), minLength = 4, defaultAlpha = 1, radix = 10;
        return result
            ? (0,ColorUtils/* hslaToRgba */.Y6)({
                a: result.length > minLength ? (0,NumberUtils/* parseAlpha */.BV)(result[5]) : defaultAlpha,
                h: parseInt(result[1], radix),
                l: parseInt(result[3], radix),
                s: parseInt(result[2], radix),
            })
            : undefined;
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Utils/RgbColorManager.js

class RgbColorManager {
    constructor() {
        this.key = "rgb";
        this.stringPrefix = "rgb";
    }
    handleColor(color) {
        const colorValue = color.value, rgbColor = colorValue.rgb ?? color.value;
        if (rgbColor.r !== undefined) {
            return rgbColor;
        }
    }
    handleRangeColor(color) {
        const colorValue = color.value, rgbColor = colorValue.rgb ?? color.value;
        if (rgbColor.r !== undefined) {
            return {
                r: (0,NumberUtils/* getRangeValue */.Gu)(rgbColor.r),
                g: (0,NumberUtils/* getRangeValue */.Gu)(rgbColor.g),
                b: (0,NumberUtils/* getRangeValue */.Gu)(rgbColor.b),
            };
        }
    }
    parseString(input) {
        if (!input.startsWith(this.stringPrefix)) {
            return;
        }
        const regex = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([\d.%]+)\s*)?\)/i, result = regex.exec(input), radix = 10, minLength = 4, defaultAlpha = 1;
        return result
            ? {
                a: result.length > minLength ? (0,NumberUtils/* parseAlpha */.BV)(result[5]) : defaultAlpha,
                b: parseInt(result[3], radix),
                g: parseInt(result[2], radix),
                r: parseInt(result[1], radix),
            }
            : undefined;
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/init.js




function init() {
    const rgbColorManager = new RgbColorManager(), hslColorManager = new HslColorManager();
    (0,ColorUtils/* addColorManager */.VI)(rgbColorManager);
    (0,ColorUtils/* addColorManager */.VI)(hslColorManager);
    const engine = new Engine();
    engine.init();
    return engine;
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Core/Utils/ExternalInteractorBase.js
class ExternalInteractorBase {
    constructor(container) {
        this.type = "external";
        this.container = container;
    }
}

;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/Core/Utils/ParticlesInteractorBase.js
class ParticlesInteractorBase {
    constructor(container) {
        this.type = "particles";
        this.container = container;
    }
}

// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Core/Utils/Ranges.js
var Ranges = __webpack_require__(83918);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Core/Utils/Vectors.js
var Vectors = __webpack_require__(15641);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/AnimatableColor.js
var AnimatableColor = __webpack_require__(92418);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/AnimationOptions.js
var AnimationOptions = __webpack_require__(99836);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/ColorAnimation.js
var ColorAnimation = __webpack_require__(75382);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/HslAnimation.js
var HslAnimation = __webpack_require__(7737);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Events/Events.js + 5 modules
var Events = __webpack_require__(44920);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Interactivity/Interactivity.js + 1 modules
var Interactivity = __webpack_require__(24444);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/ManualParticle.js
var ManualParticle = __webpack_require__(33071);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Options.js + 4 modules
var Options = __webpack_require__(73819);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/OptionsColor.js
var OptionsColor = __webpack_require__(71327);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Bounce/ParticlesBounce.js
var ParticlesBounce = __webpack_require__(28799);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Bounce/ParticlesBounceFactor.js
var ParticlesBounceFactor = __webpack_require__(83623);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Collisions/Collisions.js + 2 modules
var Collisions = __webpack_require__(92392);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/ParticlesOptions.js + 5 modules
var ParticlesOptions = __webpack_require__(74178);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Stroke.js
var Stroke = __webpack_require__(64750);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/MoveAttract.js
var MoveAttract = __webpack_require__(11518);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/Move.js + 4 modules
var Move = __webpack_require__(85009);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/MoveAngle.js
var MoveAngle = __webpack_require__(99483);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/MoveGravity.js
var MoveGravity = __webpack_require__(47921);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/Path/MovePath.js
var MovePath = __webpack_require__(74562);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Move/Spin.js
var Spin = __webpack_require__(38758);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Opacity/Opacity.js
var Opacity = __webpack_require__(24343);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Opacity/OpacityAnimation.js
var OpacityAnimation = __webpack_require__(70361);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Shape/Shape.js
var Shape = __webpack_require__(91580);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Size/Size.js
var Size = __webpack_require__(45272);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/Size/SizeAnimation.js
var SizeAnimation = __webpack_require__(26426);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Particles/ZIndex/ZIndex.js
var ZIndex = __webpack_require__(74685);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Responsive.js
var Responsive = __webpack_require__(85759);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/Theme/Theme.js + 1 modules
var Theme = __webpack_require__(32355);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Options/Classes/ValueWithRandom.js
var ValueWithRandom = __webpack_require__(67073);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/CanvasUtils.js
var CanvasUtils = __webpack_require__(9685);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/OptionsUtils.js
var OptionsUtils = __webpack_require__(13134);
// EXTERNAL MODULE: ../node_modules/@tsparticles/engine/browser/Utils/TypeUtils.js
var TypeUtils = __webpack_require__(92929);
;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/exports.js























































































;// CONCATENATED MODULE: ../node_modules/@tsparticles/engine/browser/index.js


const tsParticles = init();
if (!(0,Utils/* isSsr */.Kr)()) {
    window.tsParticles = tsParticles;
}





/***/ }),

/***/ 64358:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BREAK": function() { return /* reexport */ BREAK; },
  "BreakingChangeType": function() { return /* reexport */ BreakingChangeType; },
  "DEFAULT_DEPRECATION_REASON": function() { return /* reexport */ DEFAULT_DEPRECATION_REASON; },
  "DangerousChangeType": function() { return /* reexport */ DangerousChangeType; },
  "DirectiveLocation": function() { return /* reexport */ DirectiveLocation; },
  "ExecutableDefinitionsRule": function() { return /* reexport */ ExecutableDefinitionsRule; },
  "FieldsOnCorrectTypeRule": function() { return /* reexport */ FieldsOnCorrectTypeRule; },
  "FragmentsOnCompositeTypesRule": function() { return /* reexport */ FragmentsOnCompositeTypesRule; },
  "GRAPHQL_MAX_INT": function() { return /* reexport */ GRAPHQL_MAX_INT; },
  "GRAPHQL_MIN_INT": function() { return /* reexport */ GRAPHQL_MIN_INT; },
  "GraphQLBoolean": function() { return /* reexport */ GraphQLBoolean; },
  "GraphQLDeprecatedDirective": function() { return /* reexport */ GraphQLDeprecatedDirective; },
  "GraphQLDirective": function() { return /* reexport */ GraphQLDirective; },
  "GraphQLEnumType": function() { return /* reexport */ GraphQLEnumType; },
  "GraphQLError": function() { return /* reexport */ GraphQLError; },
  "GraphQLFloat": function() { return /* reexport */ GraphQLFloat; },
  "GraphQLID": function() { return /* reexport */ GraphQLID; },
  "GraphQLIncludeDirective": function() { return /* reexport */ GraphQLIncludeDirective; },
  "GraphQLInputObjectType": function() { return /* reexport */ GraphQLInputObjectType; },
  "GraphQLInt": function() { return /* reexport */ GraphQLInt; },
  "GraphQLInterfaceType": function() { return /* reexport */ GraphQLInterfaceType; },
  "GraphQLList": function() { return /* reexport */ GraphQLList; },
  "GraphQLNonNull": function() { return /* reexport */ GraphQLNonNull; },
  "GraphQLObjectType": function() { return /* reexport */ GraphQLObjectType; },
  "GraphQLScalarType": function() { return /* reexport */ GraphQLScalarType; },
  "GraphQLSchema": function() { return /* reexport */ GraphQLSchema; },
  "GraphQLSkipDirective": function() { return /* reexport */ GraphQLSkipDirective; },
  "GraphQLSpecifiedByDirective": function() { return /* reexport */ GraphQLSpecifiedByDirective; },
  "GraphQLString": function() { return /* reexport */ GraphQLString; },
  "GraphQLUnionType": function() { return /* reexport */ GraphQLUnionType; },
  "Kind": function() { return /* reexport */ Kind; },
  "KnownArgumentNamesRule": function() { return /* reexport */ KnownArgumentNamesRule; },
  "KnownDirectivesRule": function() { return /* reexport */ KnownDirectivesRule; },
  "KnownFragmentNamesRule": function() { return /* reexport */ KnownFragmentNamesRule; },
  "KnownTypeNamesRule": function() { return /* reexport */ KnownTypeNamesRule; },
  "Lexer": function() { return /* reexport */ Lexer; },
  "Location": function() { return /* reexport */ Location; },
  "LoneAnonymousOperationRule": function() { return /* reexport */ LoneAnonymousOperationRule; },
  "LoneSchemaDefinitionRule": function() { return /* reexport */ LoneSchemaDefinitionRule; },
  "NoDeprecatedCustomRule": function() { return /* reexport */ NoDeprecatedCustomRule; },
  "NoFragmentCyclesRule": function() { return /* reexport */ NoFragmentCyclesRule; },
  "NoSchemaIntrospectionCustomRule": function() { return /* reexport */ NoSchemaIntrospectionCustomRule; },
  "NoUndefinedVariablesRule": function() { return /* reexport */ NoUndefinedVariablesRule; },
  "NoUnusedFragmentsRule": function() { return /* reexport */ NoUnusedFragmentsRule; },
  "NoUnusedVariablesRule": function() { return /* reexport */ NoUnusedVariablesRule; },
  "OperationTypeNode": function() { return /* reexport */ OperationTypeNode; },
  "OverlappingFieldsCanBeMergedRule": function() { return /* reexport */ OverlappingFieldsCanBeMergedRule; },
  "PossibleFragmentSpreadsRule": function() { return /* reexport */ PossibleFragmentSpreadsRule; },
  "PossibleTypeExtensionsRule": function() { return /* reexport */ PossibleTypeExtensionsRule; },
  "ProvidedRequiredArgumentsRule": function() { return /* reexport */ ProvidedRequiredArgumentsRule; },
  "ScalarLeafsRule": function() { return /* reexport */ ScalarLeafsRule; },
  "SchemaMetaFieldDef": function() { return /* reexport */ SchemaMetaFieldDef; },
  "SingleFieldSubscriptionsRule": function() { return /* reexport */ SingleFieldSubscriptionsRule; },
  "Source": function() { return /* reexport */ Source; },
  "Token": function() { return /* reexport */ Token; },
  "TokenKind": function() { return /* reexport */ TokenKind; },
  "TypeInfo": function() { return /* reexport */ TypeInfo; },
  "TypeKind": function() { return /* reexport */ TypeKind; },
  "TypeMetaFieldDef": function() { return /* reexport */ TypeMetaFieldDef; },
  "TypeNameMetaFieldDef": function() { return /* reexport */ TypeNameMetaFieldDef; },
  "UniqueArgumentDefinitionNamesRule": function() { return /* reexport */ UniqueArgumentDefinitionNamesRule; },
  "UniqueArgumentNamesRule": function() { return /* reexport */ UniqueArgumentNamesRule; },
  "UniqueDirectiveNamesRule": function() { return /* reexport */ UniqueDirectiveNamesRule; },
  "UniqueDirectivesPerLocationRule": function() { return /* reexport */ UniqueDirectivesPerLocationRule; },
  "UniqueEnumValueNamesRule": function() { return /* reexport */ UniqueEnumValueNamesRule; },
  "UniqueFieldDefinitionNamesRule": function() { return /* reexport */ UniqueFieldDefinitionNamesRule; },
  "UniqueFragmentNamesRule": function() { return /* reexport */ UniqueFragmentNamesRule; },
  "UniqueInputFieldNamesRule": function() { return /* reexport */ UniqueInputFieldNamesRule; },
  "UniqueOperationNamesRule": function() { return /* reexport */ UniqueOperationNamesRule; },
  "UniqueOperationTypesRule": function() { return /* reexport */ UniqueOperationTypesRule; },
  "UniqueTypeNamesRule": function() { return /* reexport */ UniqueTypeNamesRule; },
  "UniqueVariableNamesRule": function() { return /* reexport */ UniqueVariableNamesRule; },
  "ValidationContext": function() { return /* reexport */ ValidationContext; },
  "ValuesOfCorrectTypeRule": function() { return /* reexport */ ValuesOfCorrectTypeRule; },
  "VariablesAreInputTypesRule": function() { return /* reexport */ VariablesAreInputTypesRule; },
  "VariablesInAllowedPositionRule": function() { return /* reexport */ VariablesInAllowedPositionRule; },
  "__Directive": function() { return /* reexport */ __Directive; },
  "__DirectiveLocation": function() { return /* reexport */ __DirectiveLocation; },
  "__EnumValue": function() { return /* reexport */ __EnumValue; },
  "__Field": function() { return /* reexport */ __Field; },
  "__InputValue": function() { return /* reexport */ __InputValue; },
  "__Schema": function() { return /* reexport */ __Schema; },
  "__Type": function() { return /* reexport */ __Type; },
  "__TypeKind": function() { return /* reexport */ __TypeKind; },
  "assertAbstractType": function() { return /* reexport */ assertAbstractType; },
  "assertCompositeType": function() { return /* reexport */ assertCompositeType; },
  "assertDirective": function() { return /* reexport */ assertDirective; },
  "assertEnumType": function() { return /* reexport */ assertEnumType; },
  "assertEnumValueName": function() { return /* reexport */ assertEnumValueName; },
  "assertInputObjectType": function() { return /* reexport */ assertInputObjectType; },
  "assertInputType": function() { return /* reexport */ assertInputType; },
  "assertInterfaceType": function() { return /* reexport */ assertInterfaceType; },
  "assertLeafType": function() { return /* reexport */ assertLeafType; },
  "assertListType": function() { return /* reexport */ assertListType; },
  "assertName": function() { return /* reexport */ assertName; },
  "assertNamedType": function() { return /* reexport */ assertNamedType; },
  "assertNonNullType": function() { return /* reexport */ assertNonNullType; },
  "assertNullableType": function() { return /* reexport */ assertNullableType; },
  "assertObjectType": function() { return /* reexport */ assertObjectType; },
  "assertOutputType": function() { return /* reexport */ assertOutputType; },
  "assertScalarType": function() { return /* reexport */ assertScalarType; },
  "assertSchema": function() { return /* reexport */ assertSchema; },
  "assertType": function() { return /* reexport */ assertType; },
  "assertUnionType": function() { return /* reexport */ assertUnionType; },
  "assertValidName": function() { return /* reexport */ assertValidName; },
  "assertValidSchema": function() { return /* reexport */ assertValidSchema; },
  "assertWrappingType": function() { return /* reexport */ assertWrappingType; },
  "astFromValue": function() { return /* reexport */ astFromValue; },
  "buildASTSchema": function() { return /* reexport */ buildASTSchema; },
  "buildClientSchema": function() { return /* reexport */ buildClientSchema; },
  "buildSchema": function() { return /* reexport */ buildSchema; },
  "coerceInputValue": function() { return /* reexport */ coerceInputValue; },
  "concatAST": function() { return /* reexport */ concatAST; },
  "createSourceEventStream": function() { return /* reexport */ createSourceEventStream; },
  "defaultFieldResolver": function() { return /* reexport */ defaultFieldResolver; },
  "defaultTypeResolver": function() { return /* reexport */ defaultTypeResolver; },
  "doTypesOverlap": function() { return /* reexport */ doTypesOverlap; },
  "execute": function() { return /* reexport */ execute; },
  "executeSync": function() { return /* reexport */ executeSync; },
  "extendSchema": function() { return /* reexport */ extendSchema; },
  "findBreakingChanges": function() { return /* reexport */ findBreakingChanges; },
  "findDangerousChanges": function() { return /* reexport */ findDangerousChanges; },
  "formatError": function() { return /* reexport */ formatError; },
  "getArgumentValues": function() { return /* reexport */ getArgumentValues; },
  "getDirectiveValues": function() { return /* reexport */ getDirectiveValues; },
  "getEnterLeaveForKind": function() { return /* reexport */ getEnterLeaveForKind; },
  "getIntrospectionQuery": function() { return /* reexport */ getIntrospectionQuery; },
  "getLocation": function() { return /* reexport */ getLocation; },
  "getNamedType": function() { return /* reexport */ getNamedType; },
  "getNullableType": function() { return /* reexport */ getNullableType; },
  "getOperationAST": function() { return /* reexport */ getOperationAST; },
  "getOperationRootType": function() { return /* reexport */ getOperationRootType; },
  "getVariableValues": function() { return /* reexport */ getVariableValues; },
  "getVisitFn": function() { return /* reexport */ getVisitFn; },
  "graphql": function() { return /* reexport */ graphql; },
  "graphqlSync": function() { return /* reexport */ graphqlSync; },
  "introspectionFromSchema": function() { return /* reexport */ introspectionFromSchema; },
  "introspectionTypes": function() { return /* reexport */ introspectionTypes; },
  "isAbstractType": function() { return /* reexport */ isAbstractType; },
  "isCompositeType": function() { return /* reexport */ isCompositeType; },
  "isConstValueNode": function() { return /* reexport */ isConstValueNode; },
  "isDefinitionNode": function() { return /* reexport */ isDefinitionNode; },
  "isDirective": function() { return /* reexport */ isDirective; },
  "isEnumType": function() { return /* reexport */ isEnumType; },
  "isEqualType": function() { return /* reexport */ isEqualType; },
  "isExecutableDefinitionNode": function() { return /* reexport */ isExecutableDefinitionNode; },
  "isInputObjectType": function() { return /* reexport */ isInputObjectType; },
  "isInputType": function() { return /* reexport */ isInputType; },
  "isInterfaceType": function() { return /* reexport */ isInterfaceType; },
  "isIntrospectionType": function() { return /* reexport */ isIntrospectionType; },
  "isLeafType": function() { return /* reexport */ isLeafType; },
  "isListType": function() { return /* reexport */ isListType; },
  "isNamedType": function() { return /* reexport */ isNamedType; },
  "isNonNullType": function() { return /* reexport */ isNonNullType; },
  "isNullableType": function() { return /* reexport */ isNullableType; },
  "isObjectType": function() { return /* reexport */ isObjectType; },
  "isOutputType": function() { return /* reexport */ isOutputType; },
  "isRequiredArgument": function() { return /* reexport */ isRequiredArgument; },
  "isRequiredInputField": function() { return /* reexport */ isRequiredInputField; },
  "isScalarType": function() { return /* reexport */ isScalarType; },
  "isSchema": function() { return /* reexport */ isSchema; },
  "isSelectionNode": function() { return /* reexport */ isSelectionNode; },
  "isSpecifiedDirective": function() { return /* reexport */ isSpecifiedDirective; },
  "isSpecifiedScalarType": function() { return /* reexport */ isSpecifiedScalarType; },
  "isType": function() { return /* reexport */ isType; },
  "isTypeDefinitionNode": function() { return /* reexport */ isTypeDefinitionNode; },
  "isTypeExtensionNode": function() { return /* reexport */ isTypeExtensionNode; },
  "isTypeNode": function() { return /* reexport */ isTypeNode; },
  "isTypeSubTypeOf": function() { return /* reexport */ isTypeSubTypeOf; },
  "isTypeSystemDefinitionNode": function() { return /* reexport */ isTypeSystemDefinitionNode; },
  "isTypeSystemExtensionNode": function() { return /* reexport */ isTypeSystemExtensionNode; },
  "isUnionType": function() { return /* reexport */ isUnionType; },
  "isValidNameError": function() { return /* reexport */ isValidNameError; },
  "isValueNode": function() { return /* reexport */ isValueNode; },
  "isWrappingType": function() { return /* reexport */ isWrappingType; },
  "lexicographicSortSchema": function() { return /* reexport */ lexicographicSortSchema; },
  "locatedError": function() { return /* reexport */ locatedError; },
  "parse": function() { return /* reexport */ parse; },
  "parseConstValue": function() { return /* reexport */ parseConstValue; },
  "parseType": function() { return /* reexport */ parseType; },
  "parseValue": function() { return /* reexport */ parseValue; },
  "print": function() { return /* reexport */ print; },
  "printError": function() { return /* reexport */ printError; },
  "printIntrospectionSchema": function() { return /* reexport */ printIntrospectionSchema; },
  "printLocation": function() { return /* reexport */ printLocation; },
  "printSchema": function() { return /* reexport */ printSchema; },
  "printSourceLocation": function() { return /* reexport */ printSourceLocation; },
  "printType": function() { return /* reexport */ printType; },
  "resolveObjMapThunk": function() { return /* reexport */ resolveObjMapThunk; },
  "resolveReadonlyArrayThunk": function() { return /* reexport */ resolveReadonlyArrayThunk; },
  "responsePathAsArray": function() { return /* reexport */ pathToArray; },
  "separateOperations": function() { return /* reexport */ separateOperations; },
  "specifiedDirectives": function() { return /* reexport */ specifiedDirectives; },
  "specifiedRules": function() { return /* reexport */ specifiedRules; },
  "specifiedScalarTypes": function() { return /* reexport */ specifiedScalarTypes; },
  "stripIgnoredCharacters": function() { return /* reexport */ stripIgnoredCharacters; },
  "subscribe": function() { return /* reexport */ subscribe; },
  "syntaxError": function() { return /* reexport */ syntaxError; },
  "typeFromAST": function() { return /* reexport */ typeFromAST; },
  "validate": function() { return /* reexport */ validate; },
  "validateSchema": function() { return /* reexport */ validateSchema; },
  "valueFromAST": function() { return /* reexport */ valueFromAST; },
  "valueFromASTUntyped": function() { return /* reexport */ valueFromASTUntyped; },
  "version": function() { return /* reexport */ version; },
  "versionInfo": function() { return /* reexport */ versionInfo; },
  "visit": function() { return /* reexport */ visit; },
  "visitInParallel": function() { return /* reexport */ visitInParallel; },
  "visitWithTypeInfo": function() { return /* reexport */ visitWithTypeInfo; }
});

;// CONCATENATED MODULE: ../node_modules/graphql/version.mjs
// Note: This file is autogenerated using "resources/gen-version.js" script and
// automatically updated by "npm version" command.

/**
 * A string containing the version of the GraphQL.js library
 */
const version = '16.8.1';
/**
 * An object containing the components of the GraphQL.js version string
 */

const versionInfo = Object.freeze({
  major: 16,
  minor: 8,
  patch: 1,
  preReleaseTag: null,
});

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/devAssert.mjs
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isPromise.mjs
/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */
function isPromise(value) {
  return (
    typeof (value === null || value === void 0 ? void 0 : value.then) ===
    'function'
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ../node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ../node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/ast.mjs
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));



;// CONCATENATED MODULE: ../node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../node_modules/graphql/language/kinds.mjs
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../node_modules/graphql/language/characterClasses.mjs
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/blockString.mjs

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && isWhiteSpace(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || isWhiteSpace(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && isWhiteSpace(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(TokenKind || (TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../node_modules/graphql/language/lexer.mjs





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === TokenKind.BANG ||
    kind === TokenKind.DOLLAR ||
    kind === TokenKind.AMP ||
    kind === TokenKind.PAREN_L ||
    kind === TokenKind.PAREN_R ||
    kind === TokenKind.SPREAD ||
    kind === TokenKind.COLON ||
    kind === TokenKind.EQUALS ||
    kind === TokenKind.AT ||
    kind === TokenKind.BRACKET_L ||
    kind === TokenKind.BRACKET_R ||
    kind === TokenKind.BRACE_L ||
    kind === TokenKind.PIPE ||
    kind === TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new Token(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if (isDigit(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if (isNameStart(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if (isDigit(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || isNameStart(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? TokenKind.FLOAT : TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!isDigit(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while (isDigit(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        dedentBlockStringLines(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if (isNameContinue(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/inspect.mjs
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/instanceOf.mjs

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === 'production'
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = inspect(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

;// CONCATENATED MODULE: ../node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      devAssert(false, `Body must be a string. Received: ${inspect(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      devAssert(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      devAssert(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(TokenKind.NAME);
    return this.node(token, {
      kind: Kind.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: Kind.DOCUMENT,
      definitions: this.many(
        TokenKind.SOF,
        this.parseDefinition,
        TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: Kind.OPERATION_DEFINITION,
        operation: OperationTypeNode.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: Kind.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return OperationTypeNode.QUERY;

      case 'mutation':
        return OperationTypeNode.MUTATION;

      case 'subscription':
        return OperationTypeNode.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseVariableDefinition,
      TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return this.node(start, {
      kind: Kind.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: Kind.SELECTION_SET,
      selections: this.many(
        TokenKind.BRACE_L,
        this.parseSelection,
        TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: Kind.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return this.node(start, {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: Kind.INT,
          value: token.value,
        });

      case TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: Kind.FLOAT,
          value: token.value,
        });

      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: Kind.NULL,
            });

          default:
            return this.node(token, {
              kind: Kind.ENUM,
              value: token.value,
            });
        }

      case TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(TokenKind.DOLLAR);

          if (this._lexer.token.kind === TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return this.node(start, {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: Kind.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(TokenKind.BANG)) {
      return this.node(start, {
        kind: Kind.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: Kind.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseFieldDefinition,
      TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseInputValueDef,
      TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: Kind.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS)
      ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseInputValueDef,
      TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: Kind.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new Location(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (maxTokens !== undefined && token.kind !== TokenKind.EOF) {
      ++this._tokenCounter;

      if (this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/didYouMean.mjs
const MAX_SUGGESTIONS = 5;
/**
 * Given [ A, B, C ] return ' Did you mean A, B, or C?'.
 */

function didYouMean(firstArg, secondArg) {
  const [subMessage, suggestionsArg] = secondArg
    ? [firstArg, secondArg]
    : [undefined, firstArg];
  let message = ' Did you mean ';

  if (subMessage) {
    message += subMessage + ' ';
  }

  const suggestions = suggestionsArg.map((x) => `"${x}"`);

  switch (suggestions.length) {
    case 0:
      return '';

    case 1:
      return message + suggestions[0] + '?';

    case 2:
      return message + suggestions[0] + ' or ' + suggestions[1] + '?';
  }

  const selected = suggestions.slice(0, MAX_SUGGESTIONS);
  const lastItem = selected.pop();
  return message + selected.join(', ') + ', or ' + lastItem + '?';
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/identityFunc.mjs
/**
 * Returns the first argument it receives.
 */
function identityFunc(x) {
  return x;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/keyMap.mjs
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 * ```ts
 * const phoneBook = [
 *   { name: 'Jon', num: '555-1234' },
 *   { name: 'Jenny', num: '867-5309' }
 * ]
 *
 * const entriesByName = keyMap(
 *   phoneBook,
 *   entry => entry.name
 * )
 *
 * // {
 * //   Jon: { name: 'Jon', num: '555-1234' },
 * //   Jenny: { name: 'Jenny', num: '867-5309' }
 * // }
 *
 * const jennyEntry = entriesByName['Jenny']
 *
 * // { name: 'Jenny', num: '857-6309' }
 * ```
 */
function keyMap(list, keyFn) {
  const result = Object.create(null);

  for (const item of list) {
    result[keyFn(item)] = item;
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/keyValMap.mjs
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 * ```ts
 * const phoneBook = [
 *   { name: 'Jon', num: '555-1234' },
 *   { name: 'Jenny', num: '867-5309' }
 * ]
 *
 * // { Jon: '555-1234', Jenny: '867-5309' }
 * const phonesByName = keyValMap(
 *   phoneBook,
 *   entry => entry.name,
 *   entry => entry.num
 * )
 * ```
 */
function keyValMap(list, keyFn, valFn) {
  const result = Object.create(null);

  for (const item of list) {
    result[keyFn(item)] = valFn(item);
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/mapValue.mjs
/**
 * Creates an object map with the same keys as `map` and values generated by
 * running each value of `map` thru `fn`.
 */
function mapValue(map, fn) {
  const result = Object.create(null);

  for (const key of Object.keys(map)) {
    result[key] = fn(map[key], key);
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/naturalCompare.mjs
/**
 * Returns a number indicating whether a reference string comes before, or after,
 * or is the same as the given string in natural sort order.
 *
 * See: https://en.wikipedia.org/wiki/Natural_sort_order
 *
 */
function naturalCompare(aStr, bStr) {
  let aIndex = 0;
  let bIndex = 0;

  while (aIndex < aStr.length && bIndex < bStr.length) {
    let aChar = aStr.charCodeAt(aIndex);
    let bChar = bStr.charCodeAt(bIndex);

    if (naturalCompare_isDigit(aChar) && naturalCompare_isDigit(bChar)) {
      let aNum = 0;

      do {
        ++aIndex;
        aNum = aNum * 10 + aChar - DIGIT_0;
        aChar = aStr.charCodeAt(aIndex);
      } while (naturalCompare_isDigit(aChar) && aNum > 0);

      let bNum = 0;

      do {
        ++bIndex;
        bNum = bNum * 10 + bChar - DIGIT_0;
        bChar = bStr.charCodeAt(bIndex);
      } while (naturalCompare_isDigit(bChar) && bNum > 0);

      if (aNum < bNum) {
        return -1;
      }

      if (aNum > bNum) {
        return 1;
      }
    } else {
      if (aChar < bChar) {
        return -1;
      }

      if (aChar > bChar) {
        return 1;
      }

      ++aIndex;
      ++bIndex;
    }
  }

  return aStr.length - bStr.length;
}
const DIGIT_0 = 48;
const DIGIT_9 = 57;

function naturalCompare_isDigit(code) {
  return !isNaN(code) && DIGIT_0 <= code && code <= DIGIT_9;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/suggestionList.mjs

/**
 * Given an invalid input string and a list of valid options, returns a filtered
 * list of valid options sorted based on their similarity with the input.
 */

function suggestionList(input, options) {
  const optionsByDistance = Object.create(null);
  const lexicalDistance = new LexicalDistance(input);
  const threshold = Math.floor(input.length * 0.4) + 1;

  for (const option of options) {
    const distance = lexicalDistance.measure(option, threshold);

    if (distance !== undefined) {
      optionsByDistance[option] = distance;
    }
  }

  return Object.keys(optionsByDistance).sort((a, b) => {
    const distanceDiff = optionsByDistance[a] - optionsByDistance[b];
    return distanceDiff !== 0 ? distanceDiff : naturalCompare(a, b);
  });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 */

class LexicalDistance {
  constructor(input) {
    this._input = input;
    this._inputLowerCase = input.toLowerCase();
    this._inputArray = stringToArray(this._inputLowerCase);
    this._rows = [
      new Array(input.length + 1).fill(0),
      new Array(input.length + 1).fill(0),
      new Array(input.length + 1).fill(0),
    ];
  }

  measure(option, threshold) {
    if (this._input === option) {
      return 0;
    }

    const optionLowerCase = option.toLowerCase(); // Any case change counts as a single edit

    if (this._inputLowerCase === optionLowerCase) {
      return 1;
    }

    let a = stringToArray(optionLowerCase);
    let b = this._inputArray;

    if (a.length < b.length) {
      const tmp = a;
      a = b;
      b = tmp;
    }

    const aLength = a.length;
    const bLength = b.length;

    if (aLength - bLength > threshold) {
      return undefined;
    }

    const rows = this._rows;

    for (let j = 0; j <= bLength; j++) {
      rows[0][j] = j;
    }

    for (let i = 1; i <= aLength; i++) {
      const upRow = rows[(i - 1) % 3];
      const currentRow = rows[i % 3];
      let smallestCell = (currentRow[0] = i);

      for (let j = 1; j <= bLength; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        let currentCell = Math.min(
          upRow[j] + 1, // delete
          currentRow[j - 1] + 1, // insert
          upRow[j - 1] + cost, // substitute
        );

        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          // transposition
          const doubleDiagonalCell = rows[(i - 2) % 3][j - 2];
          currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
        }

        if (currentCell < smallestCell) {
          smallestCell = currentCell;
        }

        currentRow[j] = currentCell;
      } // Early exit, since distance can't go smaller than smallest element of the previous row.

      if (smallestCell > threshold) {
        return undefined;
      }
    }

    const distance = rows[aLength % 3][bLength];
    return distance <= threshold ? distance : undefined;
  }
}

function stringToArray(str) {
  const strLength = str.length;
  const array = new Array(strLength);

  for (let i = 0; i < strLength; ++i) {
    array[i] = str.charCodeAt(i);
  }

  return array;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/toObjMap.mjs
function toObjMap(obj) {
  if (obj == null) {
    return Object.create(null);
  }

  if (Object.getPrototypeOf(obj) === null) {
    return obj;
  }

  const map = Object.create(null);

  for (const [key, value] of Object.entries(obj)) {
    map[key] = value;
  }

  return map;
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

;// CONCATENATED MODULE: ../node_modules/graphql/language/visitor.mjs




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = QueryDocumentKeys) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(Kind)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      isNode(node) || devAssert(false, `Invalid AST Node: ${inspect(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if (isNode(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visit(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? printBlockString(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/valueFromASTUntyped.mjs


/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * Unlike `valueFromAST()`, no type is provided. The resulting JavaScript value
 * will reflect the provided GraphQL value AST.
 *
 * | GraphQL Value        | JavaScript Value |
 * | -------------------- | ---------------- |
 * | Input Object         | Object           |
 * | List                 | Array            |
 * | Boolean              | Boolean          |
 * | String / Enum        | String           |
 * | Int / Float          | Number           |
 * | Null                 | null             |
 *
 */

function valueFromASTUntyped(valueNode, variables) {
  switch (valueNode.kind) {
    case Kind.NULL:
      return null;

    case Kind.INT:
      return parseInt(valueNode.value, 10);

    case Kind.FLOAT:
      return parseFloat(valueNode.value);

    case Kind.STRING:
    case Kind.ENUM:
    case Kind.BOOLEAN:
      return valueNode.value;

    case Kind.LIST:
      return valueNode.values.map((node) =>
        valueFromASTUntyped(node, variables),
      );

    case Kind.OBJECT:
      return keyValMap(
        valueNode.fields,
        (field) => field.name.value,
        (field) => valueFromASTUntyped(field.value, variables),
      );

    case Kind.VARIABLE:
      return variables === null || variables === void 0
        ? void 0
        : variables[valueNode.name.value];
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/assertName.mjs



/**
 * Upholds the spec rules about naming.
 */

function assertName(name) {
  name != null || devAssert(false, 'Must provide name.');
  typeof name === 'string' || devAssert(false, 'Expected name to be a string.');

  if (name.length === 0) {
    throw new GraphQLError('Expected name to be a non-empty string.');
  }

  for (let i = 1; i < name.length; ++i) {
    if (!isNameContinue(name.charCodeAt(i))) {
      throw new GraphQLError(
        `Names must only contain [_a-zA-Z0-9] but "${name}" does not.`,
      );
    }
  }

  if (!isNameStart(name.charCodeAt(0))) {
    throw new GraphQLError(
      `Names must start with [_a-zA-Z] but "${name}" does not.`,
    );
  }

  return name;
}
/**
 * Upholds the spec rules about naming enum values.
 *
 * @internal
 */

function assertEnumValueName(name) {
  if (name === 'true' || name === 'false' || name === 'null') {
    throw new GraphQLError(`Enum values cannot be named: ${name}`);
  }

  return assertName(name);
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/definition.mjs
















function isType(type) {
  return (
    isScalarType(type) ||
    isObjectType(type) ||
    isInterfaceType(type) ||
    isUnionType(type) ||
    isEnumType(type) ||
    isInputObjectType(type) ||
    isListType(type) ||
    isNonNullType(type)
  );
}
function assertType(type) {
  if (!isType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL type.`);
  }

  return type;
}
/**
 * There are predicates for each kind of GraphQL type.
 */

function isScalarType(type) {
  return instanceOf(type, GraphQLScalarType);
}
function assertScalarType(type) {
  if (!isScalarType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL Scalar type.`);
  }

  return type;
}
function isObjectType(type) {
  return instanceOf(type, GraphQLObjectType);
}
function assertObjectType(type) {
  if (!isObjectType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL Object type.`);
  }

  return type;
}
function isInterfaceType(type) {
  return instanceOf(type, GraphQLInterfaceType);
}
function assertInterfaceType(type) {
  if (!isInterfaceType(type)) {
    throw new Error(
      `Expected ${inspect(type)} to be a GraphQL Interface type.`,
    );
  }

  return type;
}
function isUnionType(type) {
  return instanceOf(type, GraphQLUnionType);
}
function assertUnionType(type) {
  if (!isUnionType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL Union type.`);
  }

  return type;
}
function isEnumType(type) {
  return instanceOf(type, GraphQLEnumType);
}
function assertEnumType(type) {
  if (!isEnumType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL Enum type.`);
  }

  return type;
}
function isInputObjectType(type) {
  return instanceOf(type, GraphQLInputObjectType);
}
function assertInputObjectType(type) {
  if (!isInputObjectType(type)) {
    throw new Error(
      `Expected ${inspect(type)} to be a GraphQL Input Object type.`,
    );
  }

  return type;
}
function isListType(type) {
  return instanceOf(type, GraphQLList);
}
function assertListType(type) {
  if (!isListType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL List type.`);
  }

  return type;
}
function isNonNullType(type) {
  return instanceOf(type, GraphQLNonNull);
}
function assertNonNullType(type) {
  if (!isNonNullType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL Non-Null type.`);
  }

  return type;
}
/**
 * These types may be used as input types for arguments and directives.
 */

function isInputType(type) {
  return (
    isScalarType(type) ||
    isEnumType(type) ||
    isInputObjectType(type) ||
    (isWrappingType(type) && isInputType(type.ofType))
  );
}
function assertInputType(type) {
  if (!isInputType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL input type.`);
  }

  return type;
}
/**
 * These types may be used as output types as the result of fields.
 */

function isOutputType(type) {
  return (
    isScalarType(type) ||
    isObjectType(type) ||
    isInterfaceType(type) ||
    isUnionType(type) ||
    isEnumType(type) ||
    (isWrappingType(type) && isOutputType(type.ofType))
  );
}
function assertOutputType(type) {
  if (!isOutputType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL output type.`);
  }

  return type;
}
/**
 * These types may describe types which may be leaf values.
 */

function isLeafType(type) {
  return isScalarType(type) || isEnumType(type);
}
function assertLeafType(type) {
  if (!isLeafType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL leaf type.`);
  }

  return type;
}
/**
 * These types may describe the parent context of a selection set.
 */

function isCompositeType(type) {
  return isObjectType(type) || isInterfaceType(type) || isUnionType(type);
}
function assertCompositeType(type) {
  if (!isCompositeType(type)) {
    throw new Error(
      `Expected ${inspect(type)} to be a GraphQL composite type.`,
    );
  }

  return type;
}
/**
 * These types may describe the parent context of a selection set.
 */

function isAbstractType(type) {
  return isInterfaceType(type) || isUnionType(type);
}
function assertAbstractType(type) {
  if (!isAbstractType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL abstract type.`);
  }

  return type;
}
/**
 * List Type Wrapper
 *
 * A list is a wrapping type which points to another type.
 * Lists are often created within the context of defining the fields of
 * an object type.
 *
 * Example:
 *
 * ```ts
 * const PersonType = new GraphQLObjectType({
 *   name: 'Person',
 *   fields: () => ({
 *     parents: { type: new GraphQLList(PersonType) },
 *     children: { type: new GraphQLList(PersonType) },
 *   })
 * })
 * ```
 */

class GraphQLList {
  constructor(ofType) {
    isType(ofType) ||
      devAssert(false, `Expected ${inspect(ofType)} to be a GraphQL type.`);
    this.ofType = ofType;
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLList';
  }

  toString() {
    return '[' + String(this.ofType) + ']';
  }

  toJSON() {
    return this.toString();
  }
}
/**
 * Non-Null Type Wrapper
 *
 * A non-null is a wrapping type which points to another type.
 * Non-null types enforce that their values are never null and can ensure
 * an error is raised if this ever occurs during a request. It is useful for
 * fields which you can make a strong guarantee on non-nullability, for example
 * usually the id field of a database row will never be null.
 *
 * Example:
 *
 * ```ts
 * const RowType = new GraphQLObjectType({
 *   name: 'Row',
 *   fields: () => ({
 *     id: { type: new GraphQLNonNull(GraphQLString) },
 *   })
 * })
 * ```
 * Note: the enforcement of non-nullability occurs within the executor.
 */

class GraphQLNonNull {
  constructor(ofType) {
    isNullableType(ofType) ||
      devAssert(
        false,
        `Expected ${inspect(ofType)} to be a GraphQL nullable type.`,
      );
    this.ofType = ofType;
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLNonNull';
  }

  toString() {
    return String(this.ofType) + '!';
  }

  toJSON() {
    return this.toString();
  }
}
/**
 * These types wrap and modify other types
 */

function isWrappingType(type) {
  return isListType(type) || isNonNullType(type);
}
function assertWrappingType(type) {
  if (!isWrappingType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL wrapping type.`);
  }

  return type;
}
/**
 * These types can all accept null as a value.
 */

function isNullableType(type) {
  return isType(type) && !isNonNullType(type);
}
function assertNullableType(type) {
  if (!isNullableType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL nullable type.`);
  }

  return type;
}
function getNullableType(type) {
  if (type) {
    return isNonNullType(type) ? type.ofType : type;
  }
}
/**
 * These named types do not include modifiers like List or NonNull.
 */

function isNamedType(type) {
  return (
    isScalarType(type) ||
    isObjectType(type) ||
    isInterfaceType(type) ||
    isUnionType(type) ||
    isEnumType(type) ||
    isInputObjectType(type)
  );
}
function assertNamedType(type) {
  if (!isNamedType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL named type.`);
  }

  return type;
}
function getNamedType(type) {
  if (type) {
    let unwrappedType = type;

    while (isWrappingType(unwrappedType)) {
      unwrappedType = unwrappedType.ofType;
    }

    return unwrappedType;
  }
}
/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */

function resolveReadonlyArrayThunk(thunk) {
  return typeof thunk === 'function' ? thunk() : thunk;
}
function resolveObjMapThunk(thunk) {
  return typeof thunk === 'function' ? thunk() : thunk;
}
/**
 * Custom extensions
 *
 * @remarks
 * Use a unique identifier name for your extension, for example the name of
 * your library or project. Do not use a shortened identifier as this increases
 * the risk of conflicts. We recommend you add at most one extension field,
 * an object which can contain all the values you need.
 */

/**
 * Scalar Type Definition
 *
 * The leaf values of any request and input values to arguments are
 * Scalars (or Enums) and are defined with a name and a series of functions
 * used to parse input from ast or variables and to ensure validity.
 *
 * If a type's serialize function returns `null` or does not return a value
 * (i.e. it returns `undefined`) then an error will be raised and a `null`
 * value will be returned in the response. It is always better to validate
 *
 * Example:
 *
 * ```ts
 * const OddType = new GraphQLScalarType({
 *   name: 'Odd',
 *   serialize(value) {
 *     if (!Number.isFinite(value)) {
 *       throw new Error(
 *         `Scalar "Odd" cannot represent "${value}" since it is not a finite number.`,
 *       );
 *     }
 *
 *     if (value % 2 === 0) {
 *       throw new Error(`Scalar "Odd" cannot represent "${value}" since it is even.`);
 *     }
 *     return value;
 *   }
 * });
 * ```
 */
class GraphQLScalarType {
  constructor(config) {
    var _config$parseValue,
      _config$serialize,
      _config$parseLiteral,
      _config$extensionASTN;

    const parseValue =
      (_config$parseValue = config.parseValue) !== null &&
      _config$parseValue !== void 0
        ? _config$parseValue
        : identityFunc;
    this.name = assertName(config.name);
    this.description = config.description;
    this.specifiedByURL = config.specifiedByURL;
    this.serialize =
      (_config$serialize = config.serialize) !== null &&
      _config$serialize !== void 0
        ? _config$serialize
        : identityFunc;
    this.parseValue = parseValue;
    this.parseLiteral =
      (_config$parseLiteral = config.parseLiteral) !== null &&
      _config$parseLiteral !== void 0
        ? _config$parseLiteral
        : (node, variables) => parseValue(valueFromASTUntyped(node, variables));
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN = config.extensionASTNodes) !== null &&
      _config$extensionASTN !== void 0
        ? _config$extensionASTN
        : [];
    config.specifiedByURL == null ||
      typeof config.specifiedByURL === 'string' ||
      devAssert(
        false,
        `${this.name} must provide "specifiedByURL" as a string, ` +
          `but got: ${inspect(config.specifiedByURL)}.`,
      );
    config.serialize == null ||
      typeof config.serialize === 'function' ||
      devAssert(
        false,
        `${this.name} must provide "serialize" function. If this custom Scalar is also used as an input type, ensure "parseValue" and "parseLiteral" functions are also provided.`,
      );

    if (config.parseLiteral) {
      (typeof config.parseValue === 'function' &&
        typeof config.parseLiteral === 'function') ||
        devAssert(
          false,
          `${this.name} must provide both "parseValue" and "parseLiteral" functions.`,
        );
    }
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLScalarType';
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      specifiedByURL: this.specifiedByURL,
      serialize: this.serialize,
      parseValue: this.parseValue,
      parseLiteral: this.parseLiteral,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

/**
 * Object Type Definition
 *
 * Almost all of the GraphQL types you define will be object types. Object types
 * have a name, but most importantly describe their fields.
 *
 * Example:
 *
 * ```ts
 * const AddressType = new GraphQLObjectType({
 *   name: 'Address',
 *   fields: {
 *     street: { type: GraphQLString },
 *     number: { type: GraphQLInt },
 *     formatted: {
 *       type: GraphQLString,
 *       resolve(obj) {
 *         return obj.number + ' ' + obj.street
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * When two types need to refer to each other, or a type needs to refer to
 * itself in a field, you can use a function expression (aka a closure or a
 * thunk) to supply the fields lazily.
 *
 * Example:
 *
 * ```ts
 * const PersonType = new GraphQLObjectType({
 *   name: 'Person',
 *   fields: () => ({
 *     name: { type: GraphQLString },
 *     bestFriend: { type: PersonType },
 *   })
 * });
 * ```
 */
class GraphQLObjectType {
  constructor(config) {
    var _config$extensionASTN2;

    this.name = assertName(config.name);
    this.description = config.description;
    this.isTypeOf = config.isTypeOf;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN2 = config.extensionASTNodes) !== null &&
      _config$extensionASTN2 !== void 0
        ? _config$extensionASTN2
        : [];

    this._fields = () => defineFieldMap(config);

    this._interfaces = () => defineInterfaces(config);

    config.isTypeOf == null ||
      typeof config.isTypeOf === 'function' ||
      devAssert(
        false,
        `${this.name} must provide "isTypeOf" as a function, ` +
          `but got: ${inspect(config.isTypeOf)}.`,
      );
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLObjectType';
  }

  getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  }

  getInterfaces() {
    if (typeof this._interfaces === 'function') {
      this._interfaces = this._interfaces();
    }

    return this._interfaces;
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      interfaces: this.getInterfaces(),
      fields: fieldsToFieldsConfig(this.getFields()),
      isTypeOf: this.isTypeOf,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function defineInterfaces(config) {
  var _config$interfaces;

  const interfaces = resolveReadonlyArrayThunk(
    (_config$interfaces = config.interfaces) !== null &&
      _config$interfaces !== void 0
      ? _config$interfaces
      : [],
  );
  Array.isArray(interfaces) ||
    devAssert(
      false,
      `${config.name} interfaces must be an Array or a function which returns an Array.`,
    );
  return interfaces;
}

function defineFieldMap(config) {
  const fieldMap = resolveObjMapThunk(config.fields);
  isPlainObj(fieldMap) ||
    devAssert(
      false,
      `${config.name} fields must be an object with field names as keys or a function which returns such an object.`,
    );
  return mapValue(fieldMap, (fieldConfig, fieldName) => {
    var _fieldConfig$args;

    isPlainObj(fieldConfig) ||
      devAssert(
        false,
        `${config.name}.${fieldName} field config must be an object.`,
      );
    fieldConfig.resolve == null ||
      typeof fieldConfig.resolve === 'function' ||
      devAssert(
        false,
        `${config.name}.${fieldName} field resolver must be a function if ` +
          `provided, but got: ${inspect(fieldConfig.resolve)}.`,
      );
    const argsConfig =
      (_fieldConfig$args = fieldConfig.args) !== null &&
      _fieldConfig$args !== void 0
        ? _fieldConfig$args
        : {};
    isPlainObj(argsConfig) ||
      devAssert(
        false,
        `${config.name}.${fieldName} args must be an object with argument names as keys.`,
      );
    return {
      name: assertName(fieldName),
      description: fieldConfig.description,
      type: fieldConfig.type,
      args: defineArguments(argsConfig),
      resolve: fieldConfig.resolve,
      subscribe: fieldConfig.subscribe,
      deprecationReason: fieldConfig.deprecationReason,
      extensions: toObjMap(fieldConfig.extensions),
      astNode: fieldConfig.astNode,
    };
  });
}

function defineArguments(config) {
  return Object.entries(config).map(([argName, argConfig]) => ({
    name: assertName(argName),
    description: argConfig.description,
    type: argConfig.type,
    defaultValue: argConfig.defaultValue,
    deprecationReason: argConfig.deprecationReason,
    extensions: toObjMap(argConfig.extensions),
    astNode: argConfig.astNode,
  }));
}

function isPlainObj(obj) {
  return isObjectLike(obj) && !Array.isArray(obj);
}

function fieldsToFieldsConfig(fields) {
  return mapValue(fields, (field) => ({
    description: field.description,
    type: field.type,
    args: argsToArgsConfig(field.args),
    resolve: field.resolve,
    subscribe: field.subscribe,
    deprecationReason: field.deprecationReason,
    extensions: field.extensions,
    astNode: field.astNode,
  }));
}
/**
 * @internal
 */

function argsToArgsConfig(args) {
  return keyValMap(
    args,
    (arg) => arg.name,
    (arg) => ({
      description: arg.description,
      type: arg.type,
      defaultValue: arg.defaultValue,
      deprecationReason: arg.deprecationReason,
      extensions: arg.extensions,
      astNode: arg.astNode,
    }),
  );
}
function isRequiredArgument(arg) {
  return isNonNullType(arg.type) && arg.defaultValue === undefined;
}

/**
 * Interface Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Interface type
 * is used to describe what types are possible, what fields are in common across
 * all types, as well as a function to determine which type is actually used
 * when the field is resolved.
 *
 * Example:
 *
 * ```ts
 * const EntityType = new GraphQLInterfaceType({
 *   name: 'Entity',
 *   fields: {
 *     name: { type: GraphQLString }
 *   }
 * });
 * ```
 */
class GraphQLInterfaceType {
  constructor(config) {
    var _config$extensionASTN3;

    this.name = assertName(config.name);
    this.description = config.description;
    this.resolveType = config.resolveType;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN3 = config.extensionASTNodes) !== null &&
      _config$extensionASTN3 !== void 0
        ? _config$extensionASTN3
        : [];
    this._fields = defineFieldMap.bind(undefined, config);
    this._interfaces = defineInterfaces.bind(undefined, config);
    config.resolveType == null ||
      typeof config.resolveType === 'function' ||
      devAssert(
        false,
        `${this.name} must provide "resolveType" as a function, ` +
          `but got: ${inspect(config.resolveType)}.`,
      );
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLInterfaceType';
  }

  getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  }

  getInterfaces() {
    if (typeof this._interfaces === 'function') {
      this._interfaces = this._interfaces();
    }

    return this._interfaces;
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      interfaces: this.getInterfaces(),
      fields: fieldsToFieldsConfig(this.getFields()),
      resolveType: this.resolveType,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

/**
 * Union Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Union type
 * is used to describe what types are possible as well as providing a function
 * to determine which type is actually used when the field is resolved.
 *
 * Example:
 *
 * ```ts
 * const PetType = new GraphQLUnionType({
 *   name: 'Pet',
 *   types: [ DogType, CatType ],
 *   resolveType(value) {
 *     if (value instanceof Dog) {
 *       return DogType;
 *     }
 *     if (value instanceof Cat) {
 *       return CatType;
 *     }
 *   }
 * });
 * ```
 */
class GraphQLUnionType {
  constructor(config) {
    var _config$extensionASTN4;

    this.name = assertName(config.name);
    this.description = config.description;
    this.resolveType = config.resolveType;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN4 = config.extensionASTNodes) !== null &&
      _config$extensionASTN4 !== void 0
        ? _config$extensionASTN4
        : [];
    this._types = defineTypes.bind(undefined, config);
    config.resolveType == null ||
      typeof config.resolveType === 'function' ||
      devAssert(
        false,
        `${this.name} must provide "resolveType" as a function, ` +
          `but got: ${inspect(config.resolveType)}.`,
      );
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLUnionType';
  }

  getTypes() {
    if (typeof this._types === 'function') {
      this._types = this._types();
    }

    return this._types;
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      types: this.getTypes(),
      resolveType: this.resolveType,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function defineTypes(config) {
  const types = resolveReadonlyArrayThunk(config.types);
  Array.isArray(types) ||
    devAssert(
      false,
      `Must provide Array of types or a function which returns such an array for Union ${config.name}.`,
    );
  return types;
}

/**
 * Enum Type Definition
 *
 * Some leaf values of requests and input values are Enums. GraphQL serializes
 * Enum values as strings, however internally Enums can be represented by any
 * kind of type, often integers.
 *
 * Example:
 *
 * ```ts
 * const RGBType = new GraphQLEnumType({
 *   name: 'RGB',
 *   values: {
 *     RED: { value: 0 },
 *     GREEN: { value: 1 },
 *     BLUE: { value: 2 }
 *   }
 * });
 * ```
 *
 * Note: If a value is not provided in a definition, the name of the enum value
 * will be used as its internal value.
 */
class GraphQLEnumType {
  /* <T> */
  constructor(config) {
    var _config$extensionASTN5;

    this.name = assertName(config.name);
    this.description = config.description;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN5 = config.extensionASTNodes) !== null &&
      _config$extensionASTN5 !== void 0
        ? _config$extensionASTN5
        : [];
    this._values = defineEnumValues(this.name, config.values);
    this._valueLookup = new Map(
      this._values.map((enumValue) => [enumValue.value, enumValue]),
    );
    this._nameLookup = keyMap(this._values, (value) => value.name);
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLEnumType';
  }

  getValues() {
    return this._values;
  }

  getValue(name) {
    return this._nameLookup[name];
  }

  serialize(outputValue) {
    const enumValue = this._valueLookup.get(outputValue);

    if (enumValue === undefined) {
      throw new GraphQLError(
        `Enum "${this.name}" cannot represent value: ${inspect(outputValue)}`,
      );
    }

    return enumValue.name;
  }

  parseValue(inputValue) /* T */
  {
    if (typeof inputValue !== 'string') {
      const valueStr = inspect(inputValue);
      throw new GraphQLError(
        `Enum "${this.name}" cannot represent non-string value: ${valueStr}.` +
          didYouMeanEnumValue(this, valueStr),
      );
    }

    const enumValue = this.getValue(inputValue);

    if (enumValue == null) {
      throw new GraphQLError(
        `Value "${inputValue}" does not exist in "${this.name}" enum.` +
          didYouMeanEnumValue(this, inputValue),
      );
    }

    return enumValue.value;
  }

  parseLiteral(valueNode, _variables) /* T */
  {
    // Note: variables will be resolved to a value before calling this function.
    if (valueNode.kind !== Kind.ENUM) {
      const valueStr = print(valueNode);
      throw new GraphQLError(
        `Enum "${this.name}" cannot represent non-enum value: ${valueStr}.` +
          didYouMeanEnumValue(this, valueStr),
        {
          nodes: valueNode,
        },
      );
    }

    const enumValue = this.getValue(valueNode.value);

    if (enumValue == null) {
      const valueStr = print(valueNode);
      throw new GraphQLError(
        `Value "${valueStr}" does not exist in "${this.name}" enum.` +
          didYouMeanEnumValue(this, valueStr),
        {
          nodes: valueNode,
        },
      );
    }

    return enumValue.value;
  }

  toConfig() {
    const values = keyValMap(
      this.getValues(),
      (value) => value.name,
      (value) => ({
        description: value.description,
        value: value.value,
        deprecationReason: value.deprecationReason,
        extensions: value.extensions,
        astNode: value.astNode,
      }),
    );
    return {
      name: this.name,
      description: this.description,
      values,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function didYouMeanEnumValue(enumType, unknownValueStr) {
  const allNames = enumType.getValues().map((value) => value.name);
  const suggestedValues = suggestionList(unknownValueStr, allNames);
  return didYouMean('the enum value', suggestedValues);
}

function defineEnumValues(typeName, valueMap) {
  isPlainObj(valueMap) ||
    devAssert(
      false,
      `${typeName} values must be an object with value names as keys.`,
    );
  return Object.entries(valueMap).map(([valueName, valueConfig]) => {
    isPlainObj(valueConfig) ||
      devAssert(
        false,
        `${typeName}.${valueName} must refer to an object with a "value" key ` +
          `representing an internal value but got: ${inspect(valueConfig)}.`,
      );
    return {
      name: assertEnumValueName(valueName),
      description: valueConfig.description,
      value: valueConfig.value !== undefined ? valueConfig.value : valueName,
      deprecationReason: valueConfig.deprecationReason,
      extensions: toObjMap(valueConfig.extensions),
      astNode: valueConfig.astNode,
    };
  });
}

/**
 * Input Object Type Definition
 *
 * An input object defines a structured collection of fields which may be
 * supplied to a field argument.
 *
 * Using `NonNull` will ensure that a value must be provided by the query
 *
 * Example:
 *
 * ```ts
 * const GeoPoint = new GraphQLInputObjectType({
 *   name: 'GeoPoint',
 *   fields: {
 *     lat: { type: new GraphQLNonNull(GraphQLFloat) },
 *     lon: { type: new GraphQLNonNull(GraphQLFloat) },
 *     alt: { type: GraphQLFloat, defaultValue: 0 },
 *   }
 * });
 * ```
 */
class GraphQLInputObjectType {
  constructor(config) {
    var _config$extensionASTN6;

    this.name = assertName(config.name);
    this.description = config.description;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN6 = config.extensionASTNodes) !== null &&
      _config$extensionASTN6 !== void 0
        ? _config$extensionASTN6
        : [];
    this._fields = defineInputFieldMap.bind(undefined, config);
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLInputObjectType';
  }

  getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  }

  toConfig() {
    const fields = mapValue(this.getFields(), (field) => ({
      description: field.description,
      type: field.type,
      defaultValue: field.defaultValue,
      deprecationReason: field.deprecationReason,
      extensions: field.extensions,
      astNode: field.astNode,
    }));
    return {
      name: this.name,
      description: this.description,
      fields,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function defineInputFieldMap(config) {
  const fieldMap = resolveObjMapThunk(config.fields);
  isPlainObj(fieldMap) ||
    devAssert(
      false,
      `${config.name} fields must be an object with field names as keys or a function which returns such an object.`,
    );
  return mapValue(fieldMap, (fieldConfig, fieldName) => {
    !('resolve' in fieldConfig) ||
      devAssert(
        false,
        `${config.name}.${fieldName} field has a resolve property, but Input Types cannot define resolvers.`,
      );
    return {
      name: assertName(fieldName),
      description: fieldConfig.description,
      type: fieldConfig.type,
      defaultValue: fieldConfig.defaultValue,
      deprecationReason: fieldConfig.deprecationReason,
      extensions: toObjMap(fieldConfig.extensions),
      astNode: fieldConfig.astNode,
    };
  });
}

function isRequiredInputField(field) {
  return isNonNullType(field.type) && field.defaultValue === undefined;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/typeComparators.mjs


/**
 * Provided two types, return true if the types are equal (invariant).
 */
function isEqualType(typeA, typeB) {
  // Equivalent types are equal.
  if (typeA === typeB) {
    return true;
  } // If either type is non-null, the other must also be non-null.

  if (isNonNullType(typeA) && isNonNullType(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  } // If either type is a list, the other must also be a list.

  if (isListType(typeA) && isListType(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  } // Otherwise the types are not equal.

  return false;
}
/**
 * Provided a type and a super type, return true if the first type is either
 * equal or a subset of the second super type (covariant).
 */

function isTypeSubTypeOf(schema, maybeSubType, superType) {
  // Equivalent type is a valid subtype
  if (maybeSubType === superType) {
    return true;
  } // If superType is non-null, maybeSubType must also be non-null.

  if (isNonNullType(superType)) {
    if (isNonNullType(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }

    return false;
  }

  if (isNonNullType(maybeSubType)) {
    // If superType is nullable, maybeSubType may be non-null or nullable.
    return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
  } // If superType type is a list, maybeSubType type must also be a list.

  if (isListType(superType)) {
    if (isListType(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }

    return false;
  }

  if (isListType(maybeSubType)) {
    // If superType is not a list, maybeSubType must also be not a list.
    return false;
  } // If superType type is an abstract type, check if it is super type of maybeSubType.
  // Otherwise, the child type is not a valid subtype of the parent type.

  return (
    isAbstractType(superType) &&
    (isInterfaceType(maybeSubType) || isObjectType(maybeSubType)) &&
    schema.isSubType(superType, maybeSubType)
  );
}
/**
 * Provided two composite types, determine if they "overlap". Two composite
 * types overlap when the Sets of possible concrete types for each intersect.
 *
 * This is often used to determine if a fragment of a given type could possibly
 * be visited in a context of another type.
 *
 * This function is commutative.
 */

function doTypesOverlap(schema, typeA, typeB) {
  // Equivalent types overlap
  if (typeA === typeB) {
    return true;
  }

  if (isAbstractType(typeA)) {
    if (isAbstractType(typeB)) {
      // If both types are abstract, then determine if there is any intersection
      // between possible concrete types of each.
      return schema
        .getPossibleTypes(typeA)
        .some((type) => schema.isSubType(typeB, type));
    } // Determine if the latter type is a possible concrete type of the former.

    return schema.isSubType(typeA, typeB);
  }

  if (isAbstractType(typeB)) {
    // Determine if the former type is a possible concrete type of the latter.
    return schema.isSubType(typeB, typeA);
  } // Otherwise the types do not overlap.

  return false;
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/scalars.mjs






/**
 * Maximum possible Int value as per GraphQL Spec (32-bit signed integer).
 * n.b. This differs from JavaScript's numbers that are IEEE 754 doubles safe up-to 2^53 - 1
 * */

const GRAPHQL_MAX_INT = 2147483647;
/**
 * Minimum possible Int value as per GraphQL Spec (32-bit signed integer).
 * n.b. This differs from JavaScript's numbers that are IEEE 754 doubles safe starting at -(2^53 - 1)
 * */

const GRAPHQL_MIN_INT = -2147483648;
const GraphQLInt = new GraphQLScalarType({
  name: 'Int',
  description:
    'The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'boolean') {
      return coercedValue ? 1 : 0;
    }

    let num = coercedValue;

    if (typeof coercedValue === 'string' && coercedValue !== '') {
      num = Number(coercedValue);
    }

    if (typeof num !== 'number' || !Number.isInteger(num)) {
      throw new GraphQLError(
        `Int cannot represent non-integer value: ${inspect(coercedValue)}`,
      );
    }

    if (num > GRAPHQL_MAX_INT || num < GRAPHQL_MIN_INT) {
      throw new GraphQLError(
        'Int cannot represent non 32-bit signed integer value: ' +
          inspect(coercedValue),
      );
    }

    return num;
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'number' || !Number.isInteger(inputValue)) {
      throw new GraphQLError(
        `Int cannot represent non-integer value: ${inspect(inputValue)}`,
      );
    }

    if (inputValue > GRAPHQL_MAX_INT || inputValue < GRAPHQL_MIN_INT) {
      throw new GraphQLError(
        `Int cannot represent non 32-bit signed integer value: ${inputValue}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== Kind.INT) {
      throw new GraphQLError(
        `Int cannot represent non-integer value: ${print(valueNode)}`,
        {
          nodes: valueNode,
        },
      );
    }

    const num = parseInt(valueNode.value, 10);

    if (num > GRAPHQL_MAX_INT || num < GRAPHQL_MIN_INT) {
      throw new GraphQLError(
        `Int cannot represent non 32-bit signed integer value: ${valueNode.value}`,
        {
          nodes: valueNode,
        },
      );
    }

    return num;
  },
});
const GraphQLFloat = new GraphQLScalarType({
  name: 'Float',
  description:
    'The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'boolean') {
      return coercedValue ? 1 : 0;
    }

    let num = coercedValue;

    if (typeof coercedValue === 'string' && coercedValue !== '') {
      num = Number(coercedValue);
    }

    if (typeof num !== 'number' || !Number.isFinite(num)) {
      throw new GraphQLError(
        `Float cannot represent non numeric value: ${inspect(coercedValue)}`,
      );
    }

    return num;
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'number' || !Number.isFinite(inputValue)) {
      throw new GraphQLError(
        `Float cannot represent non numeric value: ${inspect(inputValue)}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== Kind.FLOAT && valueNode.kind !== Kind.INT) {
      throw new GraphQLError(
        `Float cannot represent non numeric value: ${print(valueNode)}`,
        valueNode,
      );
    }

    return parseFloat(valueNode.value);
  },
});
const GraphQLString = new GraphQLScalarType({
  name: 'String',
  description:
    'The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue); // Serialize string, boolean and number values to a string, but do not
    // attempt to coerce object, function, symbol, or other types as strings.

    if (typeof coercedValue === 'string') {
      return coercedValue;
    }

    if (typeof coercedValue === 'boolean') {
      return coercedValue ? 'true' : 'false';
    }

    if (typeof coercedValue === 'number' && Number.isFinite(coercedValue)) {
      return coercedValue.toString();
    }

    throw new GraphQLError(
      `String cannot represent value: ${inspect(outputValue)}`,
    );
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'string') {
      throw new GraphQLError(
        `String cannot represent a non string value: ${inspect(inputValue)}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== Kind.STRING) {
      throw new GraphQLError(
        `String cannot represent a non string value: ${print(valueNode)}`,
        {
          nodes: valueNode,
        },
      );
    }

    return valueNode.value;
  },
});
const GraphQLBoolean = new GraphQLScalarType({
  name: 'Boolean',
  description: 'The `Boolean` scalar type represents `true` or `false`.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'boolean') {
      return coercedValue;
    }

    if (Number.isFinite(coercedValue)) {
      return coercedValue !== 0;
    }

    throw new GraphQLError(
      `Boolean cannot represent a non boolean value: ${inspect(coercedValue)}`,
    );
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'boolean') {
      throw new GraphQLError(
        `Boolean cannot represent a non boolean value: ${inspect(inputValue)}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== Kind.BOOLEAN) {
      throw new GraphQLError(
        `Boolean cannot represent a non boolean value: ${print(valueNode)}`,
        {
          nodes: valueNode,
        },
      );
    }

    return valueNode.value;
  },
});
const GraphQLID = new GraphQLScalarType({
  name: 'ID',
  description:
    'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'string') {
      return coercedValue;
    }

    if (Number.isInteger(coercedValue)) {
      return String(coercedValue);
    }

    throw new GraphQLError(
      `ID cannot represent value: ${inspect(outputValue)}`,
    );
  },

  parseValue(inputValue) {
    if (typeof inputValue === 'string') {
      return inputValue;
    }

    if (typeof inputValue === 'number' && Number.isInteger(inputValue)) {
      return inputValue.toString();
    }

    throw new GraphQLError(`ID cannot represent value: ${inspect(inputValue)}`);
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== Kind.STRING && valueNode.kind !== Kind.INT) {
      throw new GraphQLError(
        'ID cannot represent a non-string and non-integer value: ' +
          print(valueNode),
        {
          nodes: valueNode,
        },
      );
    }

    return valueNode.value;
  },
});
const specifiedScalarTypes = Object.freeze([
  GraphQLString,
  GraphQLInt,
  GraphQLFloat,
  GraphQLBoolean,
  GraphQLID,
]);
function isSpecifiedScalarType(type) {
  return specifiedScalarTypes.some(({ name }) => type.name === name);
} // Support serializing objects with custom valueOf() or toJSON() functions -
// a common way to represent a complex value which can be represented as
// a string (ex: MongoDB id objects).

function serializeObject(outputValue) {
  if (isObjectLike(outputValue)) {
    if (typeof outputValue.valueOf === 'function') {
      const valueOfResult = outputValue.valueOf();

      if (!isObjectLike(valueOfResult)) {
        return valueOfResult;
      }
    }

    if (typeof outputValue.toJSON === 'function') {
      return outputValue.toJSON();
    }
  }

  return outputValue;
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/directives.mjs









/**
 * Test if the given value is a GraphQL directive.
 */

function isDirective(directive) {
  return instanceOf(directive, GraphQLDirective);
}
function assertDirective(directive) {
  if (!isDirective(directive)) {
    throw new Error(
      `Expected ${inspect(directive)} to be a GraphQL directive.`,
    );
  }

  return directive;
}
/**
 * Custom extensions
 *
 * @remarks
 * Use a unique identifier name for your extension, for example the name of
 * your library or project. Do not use a shortened identifier as this increases
 * the risk of conflicts. We recommend you add at most one extension field,
 * an object which can contain all the values you need.
 */

/**
 * Directives are used by the GraphQL runtime as a way of modifying execution
 * behavior. Type system creators will usually not create these directly.
 */
class GraphQLDirective {
  constructor(config) {
    var _config$isRepeatable, _config$args;

    this.name = assertName(config.name);
    this.description = config.description;
    this.locations = config.locations;
    this.isRepeatable =
      (_config$isRepeatable = config.isRepeatable) !== null &&
      _config$isRepeatable !== void 0
        ? _config$isRepeatable
        : false;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    Array.isArray(config.locations) ||
      devAssert(false, `@${config.name} locations must be an Array.`);
    const args =
      (_config$args = config.args) !== null && _config$args !== void 0
        ? _config$args
        : {};
    (isObjectLike(args) && !Array.isArray(args)) ||
      devAssert(
        false,
        `@${config.name} args must be an object with argument names as keys.`,
      );
    this.args = defineArguments(args);
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLDirective';
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      locations: this.locations,
      args: argsToArgsConfig(this.args),
      isRepeatable: this.isRepeatable,
      extensions: this.extensions,
      astNode: this.astNode,
    };
  }

  toString() {
    return '@' + this.name;
  }

  toJSON() {
    return this.toString();
  }
}

/**
 * Used to conditionally include fields or fragments.
 */
const GraphQLIncludeDirective = new GraphQLDirective({
  name: 'include',
  description:
    'Directs the executor to include this field or fragment only when the `if` argument is true.',
  locations: [
    DirectiveLocation.FIELD,
    DirectiveLocation.FRAGMENT_SPREAD,
    DirectiveLocation.INLINE_FRAGMENT,
  ],
  args: {
    if: {
      type: new GraphQLNonNull(GraphQLBoolean),
      description: 'Included when true.',
    },
  },
});
/**
 * Used to conditionally skip (exclude) fields or fragments.
 */

const GraphQLSkipDirective = new GraphQLDirective({
  name: 'skip',
  description:
    'Directs the executor to skip this field or fragment when the `if` argument is true.',
  locations: [
    DirectiveLocation.FIELD,
    DirectiveLocation.FRAGMENT_SPREAD,
    DirectiveLocation.INLINE_FRAGMENT,
  ],
  args: {
    if: {
      type: new GraphQLNonNull(GraphQLBoolean),
      description: 'Skipped when true.',
    },
  },
});
/**
 * Constant string used for default reason for a deprecation.
 */

const DEFAULT_DEPRECATION_REASON = 'No longer supported';
/**
 * Used to declare element of a GraphQL schema as deprecated.
 */

const GraphQLDeprecatedDirective = new GraphQLDirective({
  name: 'deprecated',
  description: 'Marks an element of a GraphQL schema as no longer supported.',
  locations: [
    DirectiveLocation.FIELD_DEFINITION,
    DirectiveLocation.ARGUMENT_DEFINITION,
    DirectiveLocation.INPUT_FIELD_DEFINITION,
    DirectiveLocation.ENUM_VALUE,
  ],
  args: {
    reason: {
      type: GraphQLString,
      description:
        'Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).',
      defaultValue: DEFAULT_DEPRECATION_REASON,
    },
  },
});
/**
 * Used to provide a URL for specifying the behavior of custom scalar definitions.
 */

const GraphQLSpecifiedByDirective = new GraphQLDirective({
  name: 'specifiedBy',
  description: 'Exposes a URL that specifies the behavior of this scalar.',
  locations: [DirectiveLocation.SCALAR],
  args: {
    url: {
      type: new GraphQLNonNull(GraphQLString),
      description: 'The URL that specifies the behavior of this scalar.',
    },
  },
});
/**
 * The full list of specified directives.
 */

const specifiedDirectives = Object.freeze([
  GraphQLIncludeDirective,
  GraphQLSkipDirective,
  GraphQLDeprecatedDirective,
  GraphQLSpecifiedByDirective,
]);
function isSpecifiedDirective(directive) {
  return specifiedDirectives.some(({ name }) => name === directive.name);
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isIterableObject.mjs
/**
 * Returns true if the provided object is an Object (i.e. not a string literal)
 * and implements the Iterator protocol.
 *
 * This may be used in place of [Array.isArray()][isArray] to determine if
 * an object should be iterated-over e.g. Array, Map, Set, Int8Array,
 * TypedArray, etc. but excludes string literals.
 *
 * @example
 * ```ts
 * isIterableObject([ 1, 2, 3 ]) // true
 * isIterableObject(new Map()) // true
 * isIterableObject('ABC') // false
 * isIterableObject({ key: 'value' }) // false
 * isIterableObject({ length: 1, 0: 'Alpha' }) // false
 * ```
 */
function isIterableObject(maybeIterable) {
  return (
    typeof maybeIterable === 'object' &&
    typeof (maybeIterable === null || maybeIterable === void 0
      ? void 0
      : maybeIterable[Symbol.iterator]) === 'function'
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/astFromValue.mjs







/**
 * Produces a GraphQL Value AST given a JavaScript object.
 * Function will match JavaScript/JSON values to GraphQL AST schema format
 * by using suggested GraphQLInputType. For example:
 *
 *     astFromValue("value", GraphQLString)
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * JavaScript values.
 *
 * | JSON Value    | GraphQL Value        |
 * | ------------- | -------------------- |
 * | Object        | Input Object         |
 * | Array         | List                 |
 * | Boolean       | Boolean              |
 * | String        | String / Enum Value  |
 * | Number        | Int / Float          |
 * | Unknown       | Enum Value           |
 * | null          | NullValue            |
 *
 */

function astFromValue(value, type) {
  if (isNonNullType(type)) {
    const astValue = astFromValue(value, type.ofType);

    if (
      (astValue === null || astValue === void 0 ? void 0 : astValue.kind) ===
      Kind.NULL
    ) {
      return null;
    }

    return astValue;
  } // only explicit null, not undefined, NaN

  if (value === null) {
    return {
      kind: Kind.NULL,
    };
  } // undefined

  if (value === undefined) {
    return null;
  } // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
  // the value is not an array, convert the value using the list's item type.

  if (isListType(type)) {
    const itemType = type.ofType;

    if (isIterableObject(value)) {
      const valuesNodes = [];

      for (const item of value) {
        const itemNode = astFromValue(item, itemType);

        if (itemNode != null) {
          valuesNodes.push(itemNode);
        }
      }

      return {
        kind: Kind.LIST,
        values: valuesNodes,
      };
    }

    return astFromValue(value, itemType);
  } // Populate the fields of the input object by creating ASTs from each value
  // in the JavaScript object according to the fields in the input type.

  if (isInputObjectType(type)) {
    if (!isObjectLike(value)) {
      return null;
    }

    const fieldNodes = [];

    for (const field of Object.values(type.getFields())) {
      const fieldValue = astFromValue(value[field.name], field.type);

      if (fieldValue) {
        fieldNodes.push({
          kind: Kind.OBJECT_FIELD,
          name: {
            kind: Kind.NAME,
            value: field.name,
          },
          value: fieldValue,
        });
      }
    }

    return {
      kind: Kind.OBJECT,
      fields: fieldNodes,
    };
  }

  if (isLeafType(type)) {
    // Since value is an internally represented value, it must be serialized
    // to an externally represented value before converting into an AST.
    const serialized = type.serialize(value);

    if (serialized == null) {
      return null;
    } // Others serialize based on their corresponding JavaScript scalar types.

    if (typeof serialized === 'boolean') {
      return {
        kind: Kind.BOOLEAN,
        value: serialized,
      };
    } // JavaScript numbers can be Int or Float values.

    if (typeof serialized === 'number' && Number.isFinite(serialized)) {
      const stringNum = String(serialized);
      return integerStringRegExp.test(stringNum)
        ? {
            kind: Kind.INT,
            value: stringNum,
          }
        : {
            kind: Kind.FLOAT,
            value: stringNum,
          };
    }

    if (typeof serialized === 'string') {
      // Enum types use Enum literals.
      if (isEnumType(type)) {
        return {
          kind: Kind.ENUM,
          value: serialized,
        };
      } // ID types can use Int literals.

      if (type === GraphQLID && integerStringRegExp.test(serialized)) {
        return {
          kind: Kind.INT,
          value: serialized,
        };
      }

      return {
        kind: Kind.STRING,
        value: serialized,
      };
    }

    throw new TypeError(`Cannot convert value to AST: ${inspect(serialized)}.`);
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || invariant(false, 'Unexpected input type: ' + inspect(type));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */

const integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;

;// CONCATENATED MODULE: ../node_modules/graphql/type/introspection.mjs







const __Schema = new GraphQLObjectType({
  name: '__Schema',
  description:
    'A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.',
  fields: () => ({
    description: {
      type: GraphQLString,
      resolve: (schema) => schema.description,
    },
    types: {
      description: 'A list of all types supported by this server.',
      type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(__Type))),

      resolve(schema) {
        return Object.values(schema.getTypeMap());
      },
    },
    queryType: {
      description: 'The type that query operations will be rooted at.',
      type: new GraphQLNonNull(__Type),
      resolve: (schema) => schema.getQueryType(),
    },
    mutationType: {
      description:
        'If this server supports mutation, the type that mutation operations will be rooted at.',
      type: __Type,
      resolve: (schema) => schema.getMutationType(),
    },
    subscriptionType: {
      description:
        'If this server support subscription, the type that subscription operations will be rooted at.',
      type: __Type,
      resolve: (schema) => schema.getSubscriptionType(),
    },
    directives: {
      description: 'A list of all directives supported by this server.',
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__Directive)),
      ),
      resolve: (schema) => schema.getDirectives(),
    },
  }),
});
const __Directive = new GraphQLObjectType({
  name: '__Directive',
  description:
    "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (directive) => directive.name,
    },
    description: {
      type: GraphQLString,
      resolve: (directive) => directive.description,
    },
    isRepeatable: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (directive) => directive.isRepeatable,
    },
    locations: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__DirectiveLocation)),
      ),
      resolve: (directive) => directive.locations,
    },
    args: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__InputValue)),
      ),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(field, { includeDeprecated }) {
        return includeDeprecated
          ? field.args
          : field.args.filter((arg) => arg.deprecationReason == null);
      },
    },
  }),
});
const __DirectiveLocation = new GraphQLEnumType({
  name: '__DirectiveLocation',
  description:
    'A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.',
  values: {
    QUERY: {
      value: DirectiveLocation.QUERY,
      description: 'Location adjacent to a query operation.',
    },
    MUTATION: {
      value: DirectiveLocation.MUTATION,
      description: 'Location adjacent to a mutation operation.',
    },
    SUBSCRIPTION: {
      value: DirectiveLocation.SUBSCRIPTION,
      description: 'Location adjacent to a subscription operation.',
    },
    FIELD: {
      value: DirectiveLocation.FIELD,
      description: 'Location adjacent to a field.',
    },
    FRAGMENT_DEFINITION: {
      value: DirectiveLocation.FRAGMENT_DEFINITION,
      description: 'Location adjacent to a fragment definition.',
    },
    FRAGMENT_SPREAD: {
      value: DirectiveLocation.FRAGMENT_SPREAD,
      description: 'Location adjacent to a fragment spread.',
    },
    INLINE_FRAGMENT: {
      value: DirectiveLocation.INLINE_FRAGMENT,
      description: 'Location adjacent to an inline fragment.',
    },
    VARIABLE_DEFINITION: {
      value: DirectiveLocation.VARIABLE_DEFINITION,
      description: 'Location adjacent to a variable definition.',
    },
    SCHEMA: {
      value: DirectiveLocation.SCHEMA,
      description: 'Location adjacent to a schema definition.',
    },
    SCALAR: {
      value: DirectiveLocation.SCALAR,
      description: 'Location adjacent to a scalar definition.',
    },
    OBJECT: {
      value: DirectiveLocation.OBJECT,
      description: 'Location adjacent to an object type definition.',
    },
    FIELD_DEFINITION: {
      value: DirectiveLocation.FIELD_DEFINITION,
      description: 'Location adjacent to a field definition.',
    },
    ARGUMENT_DEFINITION: {
      value: DirectiveLocation.ARGUMENT_DEFINITION,
      description: 'Location adjacent to an argument definition.',
    },
    INTERFACE: {
      value: DirectiveLocation.INTERFACE,
      description: 'Location adjacent to an interface definition.',
    },
    UNION: {
      value: DirectiveLocation.UNION,
      description: 'Location adjacent to a union definition.',
    },
    ENUM: {
      value: DirectiveLocation.ENUM,
      description: 'Location adjacent to an enum definition.',
    },
    ENUM_VALUE: {
      value: DirectiveLocation.ENUM_VALUE,
      description: 'Location adjacent to an enum value definition.',
    },
    INPUT_OBJECT: {
      value: DirectiveLocation.INPUT_OBJECT,
      description: 'Location adjacent to an input object type definition.',
    },
    INPUT_FIELD_DEFINITION: {
      value: DirectiveLocation.INPUT_FIELD_DEFINITION,
      description: 'Location adjacent to an input object field definition.',
    },
  },
});
const __Type = new GraphQLObjectType({
  name: '__Type',
  description:
    'The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.',
  fields: () => ({
    kind: {
      type: new GraphQLNonNull(__TypeKind),

      resolve(type) {
        if (isScalarType(type)) {
          return TypeKind.SCALAR;
        }

        if (isObjectType(type)) {
          return TypeKind.OBJECT;
        }

        if (isInterfaceType(type)) {
          return TypeKind.INTERFACE;
        }

        if (isUnionType(type)) {
          return TypeKind.UNION;
        }

        if (isEnumType(type)) {
          return TypeKind.ENUM;
        }

        if (isInputObjectType(type)) {
          return TypeKind.INPUT_OBJECT;
        }

        if (isListType(type)) {
          return TypeKind.LIST;
        }

        if (isNonNullType(type)) {
          return TypeKind.NON_NULL;
        }
        /* c8 ignore next 3 */
        // Not reachable, all possible types have been considered)

         false || invariant(false, `Unexpected type: "${inspect(type)}".`);
      },
    },
    name: {
      type: GraphQLString,
      resolve: (type) => ('name' in type ? type.name : undefined),
    },
    description: {
      type: GraphQLString,
      resolve: (
        type, // FIXME: add test case
      ) =>
        /* c8 ignore next */
        'description' in type ? type.description : undefined,
    },
    specifiedByURL: {
      type: GraphQLString,
      resolve: (obj) =>
        'specifiedByURL' in obj ? obj.specifiedByURL : undefined,
    },
    fields: {
      type: new GraphQLList(new GraphQLNonNull(__Field)),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(type, { includeDeprecated }) {
        if (isObjectType(type) || isInterfaceType(type)) {
          const fields = Object.values(type.getFields());
          return includeDeprecated
            ? fields
            : fields.filter((field) => field.deprecationReason == null);
        }
      },
    },
    interfaces: {
      type: new GraphQLList(new GraphQLNonNull(__Type)),

      resolve(type) {
        if (isObjectType(type) || isInterfaceType(type)) {
          return type.getInterfaces();
        }
      },
    },
    possibleTypes: {
      type: new GraphQLList(new GraphQLNonNull(__Type)),

      resolve(type, _args, _context, { schema }) {
        if (isAbstractType(type)) {
          return schema.getPossibleTypes(type);
        }
      },
    },
    enumValues: {
      type: new GraphQLList(new GraphQLNonNull(__EnumValue)),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(type, { includeDeprecated }) {
        if (isEnumType(type)) {
          const values = type.getValues();
          return includeDeprecated
            ? values
            : values.filter((field) => field.deprecationReason == null);
        }
      },
    },
    inputFields: {
      type: new GraphQLList(new GraphQLNonNull(__InputValue)),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(type, { includeDeprecated }) {
        if (isInputObjectType(type)) {
          const values = Object.values(type.getFields());
          return includeDeprecated
            ? values
            : values.filter((field) => field.deprecationReason == null);
        }
      },
    },
    ofType: {
      type: __Type,
      resolve: (type) => ('ofType' in type ? type.ofType : undefined),
    },
  }),
});
const __Field = new GraphQLObjectType({
  name: '__Field',
  description:
    'Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (field) => field.name,
    },
    description: {
      type: GraphQLString,
      resolve: (field) => field.description,
    },
    args: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__InputValue)),
      ),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(field, { includeDeprecated }) {
        return includeDeprecated
          ? field.args
          : field.args.filter((arg) => arg.deprecationReason == null);
      },
    },
    type: {
      type: new GraphQLNonNull(__Type),
      resolve: (field) => field.type,
    },
    isDeprecated: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (field) => field.deprecationReason != null,
    },
    deprecationReason: {
      type: GraphQLString,
      resolve: (field) => field.deprecationReason,
    },
  }),
});
const __InputValue = new GraphQLObjectType({
  name: '__InputValue',
  description:
    'Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (inputValue) => inputValue.name,
    },
    description: {
      type: GraphQLString,
      resolve: (inputValue) => inputValue.description,
    },
    type: {
      type: new GraphQLNonNull(__Type),
      resolve: (inputValue) => inputValue.type,
    },
    defaultValue: {
      type: GraphQLString,
      description:
        'A GraphQL-formatted string representing the default value for this input value.',

      resolve(inputValue) {
        const { type, defaultValue } = inputValue;
        const valueAST = astFromValue(defaultValue, type);
        return valueAST ? print(valueAST) : null;
      },
    },
    isDeprecated: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (field) => field.deprecationReason != null,
    },
    deprecationReason: {
      type: GraphQLString,
      resolve: (obj) => obj.deprecationReason,
    },
  }),
});
const __EnumValue = new GraphQLObjectType({
  name: '__EnumValue',
  description:
    'One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (enumValue) => enumValue.name,
    },
    description: {
      type: GraphQLString,
      resolve: (enumValue) => enumValue.description,
    },
    isDeprecated: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (enumValue) => enumValue.deprecationReason != null,
    },
    deprecationReason: {
      type: GraphQLString,
      resolve: (enumValue) => enumValue.deprecationReason,
    },
  }),
});
var TypeKind;

(function (TypeKind) {
  TypeKind['SCALAR'] = 'SCALAR';
  TypeKind['OBJECT'] = 'OBJECT';
  TypeKind['INTERFACE'] = 'INTERFACE';
  TypeKind['UNION'] = 'UNION';
  TypeKind['ENUM'] = 'ENUM';
  TypeKind['INPUT_OBJECT'] = 'INPUT_OBJECT';
  TypeKind['LIST'] = 'LIST';
  TypeKind['NON_NULL'] = 'NON_NULL';
})(TypeKind || (TypeKind = {}));


const __TypeKind = new GraphQLEnumType({
  name: '__TypeKind',
  description: 'An enum describing what kind of type a given `__Type` is.',
  values: {
    SCALAR: {
      value: TypeKind.SCALAR,
      description: 'Indicates this type is a scalar.',
    },
    OBJECT: {
      value: TypeKind.OBJECT,
      description:
        'Indicates this type is an object. `fields` and `interfaces` are valid fields.',
    },
    INTERFACE: {
      value: TypeKind.INTERFACE,
      description:
        'Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.',
    },
    UNION: {
      value: TypeKind.UNION,
      description:
        'Indicates this type is a union. `possibleTypes` is a valid field.',
    },
    ENUM: {
      value: TypeKind.ENUM,
      description:
        'Indicates this type is an enum. `enumValues` is a valid field.',
    },
    INPUT_OBJECT: {
      value: TypeKind.INPUT_OBJECT,
      description:
        'Indicates this type is an input object. `inputFields` is a valid field.',
    },
    LIST: {
      value: TypeKind.LIST,
      description: 'Indicates this type is a list. `ofType` is a valid field.',
    },
    NON_NULL: {
      value: TypeKind.NON_NULL,
      description:
        'Indicates this type is a non-null. `ofType` is a valid field.',
    },
  },
});
/**
 * Note that these are GraphQLField and not GraphQLFieldConfig,
 * so the format for args is different.
 */

const SchemaMetaFieldDef = {
  name: '__schema',
  type: new GraphQLNonNull(__Schema),
  description: 'Access the current type schema of this server.',
  args: [],
  resolve: (_source, _args, _context, { schema }) => schema,
  deprecationReason: undefined,
  extensions: Object.create(null),
  astNode: undefined,
};
const TypeMetaFieldDef = {
  name: '__type',
  type: __Type,
  description: 'Request the type information of a single type.',
  args: [
    {
      name: 'name',
      description: undefined,
      type: new GraphQLNonNull(GraphQLString),
      defaultValue: undefined,
      deprecationReason: undefined,
      extensions: Object.create(null),
      astNode: undefined,
    },
  ],
  resolve: (_source, { name }, _context, { schema }) => schema.getType(name),
  deprecationReason: undefined,
  extensions: Object.create(null),
  astNode: undefined,
};
const TypeNameMetaFieldDef = {
  name: '__typename',
  type: new GraphQLNonNull(GraphQLString),
  description: 'The name of the current Object type at runtime.',
  args: [],
  resolve: (_source, _args, _context, { parentType }) => parentType.name,
  deprecationReason: undefined,
  extensions: Object.create(null),
  astNode: undefined,
};
const introspectionTypes = Object.freeze([
  __Schema,
  __Directive,
  __DirectiveLocation,
  __Type,
  __Field,
  __InputValue,
  __EnumValue,
  __TypeKind,
]);
function isIntrospectionType(type) {
  return introspectionTypes.some(({ name }) => type.name === name);
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/schema.mjs









/**
 * Test if the given value is a GraphQL schema.
 */

function isSchema(schema) {
  return instanceOf(schema, GraphQLSchema);
}
function assertSchema(schema) {
  if (!isSchema(schema)) {
    throw new Error(`Expected ${inspect(schema)} to be a GraphQL schema.`);
  }

  return schema;
}
/**
 * Custom extensions
 *
 * @remarks
 * Use a unique identifier name for your extension, for example the name of
 * your library or project. Do not use a shortened identifier as this increases
 * the risk of conflicts. We recommend you add at most one extension field,
 * an object which can contain all the values you need.
 */

/**
 * Schema Definition
 *
 * A Schema is created by supplying the root types of each type of operation,
 * query and mutation (optional). A schema definition is then supplied to the
 * validator and executor.
 *
 * Example:
 *
 * ```ts
 * const MyAppSchema = new GraphQLSchema({
 *   query: MyAppQueryRootType,
 *   mutation: MyAppMutationRootType,
 * })
 * ```
 *
 * Note: When the schema is constructed, by default only the types that are
 * reachable by traversing the root types are included, other types must be
 * explicitly referenced.
 *
 * Example:
 *
 * ```ts
 * const characterInterface = new GraphQLInterfaceType({
 *   name: 'Character',
 *   ...
 * });
 *
 * const humanType = new GraphQLObjectType({
 *   name: 'Human',
 *   interfaces: [characterInterface],
 *   ...
 * });
 *
 * const droidType = new GraphQLObjectType({
 *   name: 'Droid',
 *   interfaces: [characterInterface],
 *   ...
 * });
 *
 * const schema = new GraphQLSchema({
 *   query: new GraphQLObjectType({
 *     name: 'Query',
 *     fields: {
 *       hero: { type: characterInterface, ... },
 *     }
 *   }),
 *   ...
 *   // Since this schema references only the `Character` interface it's
 *   // necessary to explicitly list the types that implement it if
 *   // you want them to be included in the final schema.
 *   types: [humanType, droidType],
 * })
 * ```
 *
 * Note: If an array of `directives` are provided to GraphQLSchema, that will be
 * the exact list of directives represented and allowed. If `directives` is not
 * provided then a default set of the specified directives (e.g. `@include` and
 * `@skip`) will be used. If you wish to provide *additional* directives to these
 * specified directives, you must explicitly declare them. Example:
 *
 * ```ts
 * const MyAppSchema = new GraphQLSchema({
 *   ...
 *   directives: specifiedDirectives.concat([ myCustomDirective ]),
 * })
 * ```
 */
class GraphQLSchema {
  // Used as a cache for validateSchema().
  constructor(config) {
    var _config$extensionASTN, _config$directives;

    // If this schema was built from a source known to be valid, then it may be
    // marked with assumeValid to avoid an additional type system validation.
    this.__validationErrors = config.assumeValid === true ? [] : undefined; // Check for common mistakes during construction to produce early errors.

    isObjectLike(config) ||
      devAssert(false, 'Must provide configuration object.');
    !config.types ||
      Array.isArray(config.types) ||
      devAssert(
        false,
        `"types" must be Array if provided but got: ${inspect(config.types)}.`,
      );
    !config.directives ||
      Array.isArray(config.directives) ||
      devAssert(
        false,
        '"directives" must be Array if provided but got: ' +
          `${inspect(config.directives)}.`,
      );
    this.description = config.description;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN = config.extensionASTNodes) !== null &&
      _config$extensionASTN !== void 0
        ? _config$extensionASTN
        : [];
    this._queryType = config.query;
    this._mutationType = config.mutation;
    this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.

    this._directives =
      (_config$directives = config.directives) !== null &&
      _config$directives !== void 0
        ? _config$directives
        : specifiedDirectives; // To preserve order of user-provided types, we add first to add them to
    // the set of "collected" types, so `collectReferencedTypes` ignore them.

    const allReferencedTypes = new Set(config.types);

    if (config.types != null) {
      for (const type of config.types) {
        // When we ready to process this type, we remove it from "collected" types
        // and then add it together with all dependent types in the correct position.
        allReferencedTypes.delete(type);
        collectReferencedTypes(type, allReferencedTypes);
      }
    }

    if (this._queryType != null) {
      collectReferencedTypes(this._queryType, allReferencedTypes);
    }

    if (this._mutationType != null) {
      collectReferencedTypes(this._mutationType, allReferencedTypes);
    }

    if (this._subscriptionType != null) {
      collectReferencedTypes(this._subscriptionType, allReferencedTypes);
    }

    for (const directive of this._directives) {
      // Directives are not validated until validateSchema() is called.
      if (isDirective(directive)) {
        for (const arg of directive.args) {
          collectReferencedTypes(arg.type, allReferencedTypes);
        }
      }
    }

    collectReferencedTypes(__Schema, allReferencedTypes); // Storing the resulting map for reference by the schema.

    this._typeMap = Object.create(null);
    this._subTypeMap = Object.create(null); // Keep track of all implementations by interface name.

    this._implementationsMap = Object.create(null);

    for (const namedType of allReferencedTypes) {
      if (namedType == null) {
        continue;
      }

      const typeName = namedType.name;
      typeName ||
        devAssert(
          false,
          'One of the provided types for building the Schema is missing a name.',
        );

      if (this._typeMap[typeName] !== undefined) {
        throw new Error(
          `Schema must contain uniquely named types but contains multiple types named "${typeName}".`,
        );
      }

      this._typeMap[typeName] = namedType;

      if (isInterfaceType(namedType)) {
        // Store implementations by interface.
        for (const iface of namedType.getInterfaces()) {
          if (isInterfaceType(iface)) {
            let implementations = this._implementationsMap[iface.name];

            if (implementations === undefined) {
              implementations = this._implementationsMap[iface.name] = {
                objects: [],
                interfaces: [],
              };
            }

            implementations.interfaces.push(namedType);
          }
        }
      } else if (isObjectType(namedType)) {
        // Store implementations by objects.
        for (const iface of namedType.getInterfaces()) {
          if (isInterfaceType(iface)) {
            let implementations = this._implementationsMap[iface.name];

            if (implementations === undefined) {
              implementations = this._implementationsMap[iface.name] = {
                objects: [],
                interfaces: [],
              };
            }

            implementations.objects.push(namedType);
          }
        }
      }
    }
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLSchema';
  }

  getQueryType() {
    return this._queryType;
  }

  getMutationType() {
    return this._mutationType;
  }

  getSubscriptionType() {
    return this._subscriptionType;
  }

  getRootType(operation) {
    switch (operation) {
      case OperationTypeNode.QUERY:
        return this.getQueryType();

      case OperationTypeNode.MUTATION:
        return this.getMutationType();

      case OperationTypeNode.SUBSCRIPTION:
        return this.getSubscriptionType();
    }
  }

  getTypeMap() {
    return this._typeMap;
  }

  getType(name) {
    return this.getTypeMap()[name];
  }

  getPossibleTypes(abstractType) {
    return isUnionType(abstractType)
      ? abstractType.getTypes()
      : this.getImplementations(abstractType).objects;
  }

  getImplementations(interfaceType) {
    const implementations = this._implementationsMap[interfaceType.name];
    return implementations !== null && implementations !== void 0
      ? implementations
      : {
          objects: [],
          interfaces: [],
        };
  }

  isSubType(abstractType, maybeSubType) {
    let map = this._subTypeMap[abstractType.name];

    if (map === undefined) {
      map = Object.create(null);

      if (isUnionType(abstractType)) {
        for (const type of abstractType.getTypes()) {
          map[type.name] = true;
        }
      } else {
        const implementations = this.getImplementations(abstractType);

        for (const type of implementations.objects) {
          map[type.name] = true;
        }

        for (const type of implementations.interfaces) {
          map[type.name] = true;
        }
      }

      this._subTypeMap[abstractType.name] = map;
    }

    return map[maybeSubType.name] !== undefined;
  }

  getDirectives() {
    return this._directives;
  }

  getDirective(name) {
    return this.getDirectives().find((directive) => directive.name === name);
  }

  toConfig() {
    return {
      description: this.description,
      query: this.getQueryType(),
      mutation: this.getMutationType(),
      subscription: this.getSubscriptionType(),
      types: Object.values(this.getTypeMap()),
      directives: this.getDirectives(),
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
      assumeValid: this.__validationErrors !== undefined,
    };
  }
}

function collectReferencedTypes(type, typeSet) {
  const namedType = getNamedType(type);

  if (!typeSet.has(namedType)) {
    typeSet.add(namedType);

    if (isUnionType(namedType)) {
      for (const memberType of namedType.getTypes()) {
        collectReferencedTypes(memberType, typeSet);
      }
    } else if (isObjectType(namedType) || isInterfaceType(namedType)) {
      for (const interfaceType of namedType.getInterfaces()) {
        collectReferencedTypes(interfaceType, typeSet);
      }

      for (const field of Object.values(namedType.getFields())) {
        collectReferencedTypes(field.type, typeSet);

        for (const arg of field.args) {
          collectReferencedTypes(arg.type, typeSet);
        }
      }
    } else if (isInputObjectType(namedType)) {
      for (const field of Object.values(namedType.getFields())) {
        collectReferencedTypes(field.type, typeSet);
      }
    }
  }

  return typeSet;
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/validate.mjs








/**
 * Implements the "Type Validation" sub-sections of the specification's
 * "Type System" section.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the Schema is valid.
 */

function validateSchema(schema) {
  // First check to ensure the provided value is in fact a GraphQLSchema.
  assertSchema(schema); // If this Schema has already been validated, return the previous results.

  if (schema.__validationErrors) {
    return schema.__validationErrors;
  } // Validate the schema, producing a list of errors.

  const context = new SchemaValidationContext(schema);
  validateRootTypes(context);
  validateDirectives(context);
  validateTypes(context); // Persist the results of validation before returning to ensure validation
  // does not run multiple times for this schema.

  const errors = context.getErrors();
  schema.__validationErrors = errors;
  return errors;
}
/**
 * Utility function which asserts a schema is valid by throwing an error if
 * it is invalid.
 */

function assertValidSchema(schema) {
  const errors = validateSchema(schema);

  if (errors.length !== 0) {
    throw new Error(errors.map((error) => error.message).join('\n\n'));
  }
}

class SchemaValidationContext {
  constructor(schema) {
    this._errors = [];
    this.schema = schema;
  }

  reportError(message, nodes) {
    const _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;

    this._errors.push(
      new GraphQLError(message, {
        nodes: _nodes,
      }),
    );
  }

  getErrors() {
    return this._errors;
  }
}

function validateRootTypes(context) {
  const schema = context.schema;
  const queryType = schema.getQueryType();

  if (!queryType) {
    context.reportError('Query root type must be provided.', schema.astNode);
  } else if (!isObjectType(queryType)) {
    var _getOperationTypeNode;

    context.reportError(
      `Query root type must be Object type, it cannot be ${inspect(
        queryType,
      )}.`,
      (_getOperationTypeNode = getOperationTypeNode(
        schema,
        OperationTypeNode.QUERY,
      )) !== null && _getOperationTypeNode !== void 0
        ? _getOperationTypeNode
        : queryType.astNode,
    );
  }

  const mutationType = schema.getMutationType();

  if (mutationType && !isObjectType(mutationType)) {
    var _getOperationTypeNode2;

    context.reportError(
      'Mutation root type must be Object type if provided, it cannot be ' +
        `${inspect(mutationType)}.`,
      (_getOperationTypeNode2 = getOperationTypeNode(
        schema,
        OperationTypeNode.MUTATION,
      )) !== null && _getOperationTypeNode2 !== void 0
        ? _getOperationTypeNode2
        : mutationType.astNode,
    );
  }

  const subscriptionType = schema.getSubscriptionType();

  if (subscriptionType && !isObjectType(subscriptionType)) {
    var _getOperationTypeNode3;

    context.reportError(
      'Subscription root type must be Object type if provided, it cannot be ' +
        `${inspect(subscriptionType)}.`,
      (_getOperationTypeNode3 = getOperationTypeNode(
        schema,
        OperationTypeNode.SUBSCRIPTION,
      )) !== null && _getOperationTypeNode3 !== void 0
        ? _getOperationTypeNode3
        : subscriptionType.astNode,
    );
  }
}

function getOperationTypeNode(schema, operation) {
  var _flatMap$find;

  return (_flatMap$find = [schema.astNode, ...schema.extensionASTNodes]
    .flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      (schemaNode) => {
        var _schemaNode$operation;

        return (
          /* c8 ignore next */
          (_schemaNode$operation =
            schemaNode === null || schemaNode === void 0
              ? void 0
              : schemaNode.operationTypes) !== null &&
            _schemaNode$operation !== void 0
            ? _schemaNode$operation
            : []
        );
      },
    )
    .find((operationNode) => operationNode.operation === operation)) === null ||
    _flatMap$find === void 0
    ? void 0
    : _flatMap$find.type;
}

function validateDirectives(context) {
  for (const directive of context.schema.getDirectives()) {
    // Ensure all directives are in fact GraphQL directives.
    if (!isDirective(directive)) {
      context.reportError(
        `Expected directive but got: ${inspect(directive)}.`,
        directive === null || directive === void 0 ? void 0 : directive.astNode,
      );
      continue;
    } // Ensure they are named correctly.

    validateName(context, directive); // TODO: Ensure proper locations.
    // Ensure the arguments are valid.

    for (const arg of directive.args) {
      // Ensure they are named correctly.
      validateName(context, arg); // Ensure the type is an input type.

      if (!isInputType(arg.type)) {
        context.reportError(
          `The type of @${directive.name}(${arg.name}:) must be Input Type ` +
            `but got: ${inspect(arg.type)}.`,
          arg.astNode,
        );
      }

      if (isRequiredArgument(arg) && arg.deprecationReason != null) {
        var _arg$astNode;

        context.reportError(
          `Required argument @${directive.name}(${arg.name}:) cannot be deprecated.`,
          [
            getDeprecatedDirectiveNode(arg.astNode),
            (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0
              ? void 0
              : _arg$astNode.type,
          ],
        );
      }
    }
  }
}

function validateName(context, node) {
  // Ensure names are valid, however introspection types opt out.
  if (node.name.startsWith('__')) {
    context.reportError(
      `Name "${node.name}" must not begin with "__", which is reserved by GraphQL introspection.`,
      node.astNode,
    );
  }
}

function validateTypes(context) {
  const validateInputObjectCircularRefs =
    createInputObjectCircularRefsValidator(context);
  const typeMap = context.schema.getTypeMap();

  for (const type of Object.values(typeMap)) {
    // Ensure all provided types are in fact GraphQL type.
    if (!isNamedType(type)) {
      context.reportError(
        `Expected GraphQL named type but got: ${inspect(type)}.`,
        type.astNode,
      );
      continue;
    } // Ensure it is named correctly (excluding introspection types).

    if (!isIntrospectionType(type)) {
      validateName(context, type);
    }

    if (isObjectType(type)) {
      // Ensure fields are valid
      validateFields(context, type); // Ensure objects implement the interfaces they claim to.

      validateInterfaces(context, type);
    } else if (isInterfaceType(type)) {
      // Ensure fields are valid.
      validateFields(context, type); // Ensure interfaces implement the interfaces they claim to.

      validateInterfaces(context, type);
    } else if (isUnionType(type)) {
      // Ensure Unions include valid member types.
      validateUnionMembers(context, type);
    } else if (isEnumType(type)) {
      // Ensure Enums have valid values.
      validateEnumValues(context, type);
    } else if (isInputObjectType(type)) {
      // Ensure Input Object fields are valid.
      validateInputFields(context, type); // Ensure Input Objects do not contain non-nullable circular references

      validateInputObjectCircularRefs(type);
    }
  }
}

function validateFields(context, type) {
  const fields = Object.values(type.getFields()); // Objects and Interfaces both must define one or more fields.

  if (fields.length === 0) {
    context.reportError(`Type ${type.name} must define one or more fields.`, [
      type.astNode,
      ...type.extensionASTNodes,
    ]);
  }

  for (const field of fields) {
    // Ensure they are named correctly.
    validateName(context, field); // Ensure the type is an output type

    if (!isOutputType(field.type)) {
      var _field$astNode;

      context.reportError(
        `The type of ${type.name}.${field.name} must be Output Type ` +
          `but got: ${inspect(field.type)}.`,
        (_field$astNode = field.astNode) === null || _field$astNode === void 0
          ? void 0
          : _field$astNode.type,
      );
    } // Ensure the arguments are valid

    for (const arg of field.args) {
      const argName = arg.name; // Ensure they are named correctly.

      validateName(context, arg); // Ensure the type is an input type

      if (!isInputType(arg.type)) {
        var _arg$astNode2;

        context.reportError(
          `The type of ${type.name}.${field.name}(${argName}:) must be Input ` +
            `Type but got: ${inspect(arg.type)}.`,
          (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0
            ? void 0
            : _arg$astNode2.type,
        );
      }

      if (isRequiredArgument(arg) && arg.deprecationReason != null) {
        var _arg$astNode3;

        context.reportError(
          `Required argument ${type.name}.${field.name}(${argName}:) cannot be deprecated.`,
          [
            getDeprecatedDirectiveNode(arg.astNode),
            (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0
              ? void 0
              : _arg$astNode3.type,
          ],
        );
      }
    }
  }
}

function validateInterfaces(context, type) {
  const ifaceTypeNames = Object.create(null);

  for (const iface of type.getInterfaces()) {
    if (!isInterfaceType(iface)) {
      context.reportError(
        `Type ${inspect(type)} must only implement Interface types, ` +
          `it cannot implement ${inspect(iface)}.`,
        getAllImplementsInterfaceNodes(type, iface),
      );
      continue;
    }

    if (type === iface) {
      context.reportError(
        `Type ${type.name} cannot implement itself because it would create a circular reference.`,
        getAllImplementsInterfaceNodes(type, iface),
      );
      continue;
    }

    if (ifaceTypeNames[iface.name]) {
      context.reportError(
        `Type ${type.name} can only implement ${iface.name} once.`,
        getAllImplementsInterfaceNodes(type, iface),
      );
      continue;
    }

    ifaceTypeNames[iface.name] = true;
    validateTypeImplementsAncestors(context, type, iface);
    validateTypeImplementsInterface(context, type, iface);
  }
}

function validateTypeImplementsInterface(context, type, iface) {
  const typeFieldMap = type.getFields(); // Assert each interface field is implemented.

  for (const ifaceField of Object.values(iface.getFields())) {
    const fieldName = ifaceField.name;
    const typeField = typeFieldMap[fieldName]; // Assert interface field exists on type.

    if (!typeField) {
      context.reportError(
        `Interface field ${iface.name}.${fieldName} expected but ${type.name} does not provide it.`,
        [ifaceField.astNode, type.astNode, ...type.extensionASTNodes],
      );
      continue;
    } // Assert interface field type is satisfied by type field type, by being
    // a valid subtype. (covariant)

    if (!isTypeSubTypeOf(context.schema, typeField.type, ifaceField.type)) {
      var _ifaceField$astNode, _typeField$astNode;

      context.reportError(
        `Interface field ${iface.name}.${fieldName} expects type ` +
          `${inspect(ifaceField.type)} but ${type.name}.${fieldName} ` +
          `is type ${inspect(typeField.type)}.`,
        [
          (_ifaceField$astNode = ifaceField.astNode) === null ||
          _ifaceField$astNode === void 0
            ? void 0
            : _ifaceField$astNode.type,
          (_typeField$astNode = typeField.astNode) === null ||
          _typeField$astNode === void 0
            ? void 0
            : _typeField$astNode.type,
        ],
      );
    } // Assert each interface field arg is implemented.

    for (const ifaceArg of ifaceField.args) {
      const argName = ifaceArg.name;
      const typeArg = typeField.args.find((arg) => arg.name === argName); // Assert interface field arg exists on object field.

      if (!typeArg) {
        context.reportError(
          `Interface field argument ${iface.name}.${fieldName}(${argName}:) expected but ${type.name}.${fieldName} does not provide it.`,
          [ifaceArg.astNode, typeField.astNode],
        );
        continue;
      } // Assert interface field arg type matches object field arg type.
      // (invariant)
      // TODO: change to contravariant?

      if (!isEqualType(ifaceArg.type, typeArg.type)) {
        var _ifaceArg$astNode, _typeArg$astNode;

        context.reportError(
          `Interface field argument ${iface.name}.${fieldName}(${argName}:) ` +
            `expects type ${inspect(ifaceArg.type)} but ` +
            `${type.name}.${fieldName}(${argName}:) is type ` +
            `${inspect(typeArg.type)}.`,
          [
            (_ifaceArg$astNode = ifaceArg.astNode) === null ||
            _ifaceArg$astNode === void 0
              ? void 0
              : _ifaceArg$astNode.type,
            (_typeArg$astNode = typeArg.astNode) === null ||
            _typeArg$astNode === void 0
              ? void 0
              : _typeArg$astNode.type,
          ],
        );
      } // TODO: validate default values?
    } // Assert additional arguments must not be required.

    for (const typeArg of typeField.args) {
      const argName = typeArg.name;
      const ifaceArg = ifaceField.args.find((arg) => arg.name === argName);

      if (!ifaceArg && isRequiredArgument(typeArg)) {
        context.reportError(
          `Object field ${type.name}.${fieldName} includes required argument ${argName} that is missing from the Interface field ${iface.name}.${fieldName}.`,
          [typeArg.astNode, ifaceField.astNode],
        );
      }
    }
  }
}

function validateTypeImplementsAncestors(context, type, iface) {
  const ifaceInterfaces = type.getInterfaces();

  for (const transitive of iface.getInterfaces()) {
    if (!ifaceInterfaces.includes(transitive)) {
      context.reportError(
        transitive === type
          ? `Type ${type.name} cannot implement ${iface.name} because it would create a circular reference.`
          : `Type ${type.name} must implement ${transitive.name} because it is implemented by ${iface.name}.`,
        [
          ...getAllImplementsInterfaceNodes(iface, transitive),
          ...getAllImplementsInterfaceNodes(type, iface),
        ],
      );
    }
  }
}

function validateUnionMembers(context, union) {
  const memberTypes = union.getTypes();

  if (memberTypes.length === 0) {
    context.reportError(
      `Union type ${union.name} must define one or more member types.`,
      [union.astNode, ...union.extensionASTNodes],
    );
  }

  const includedTypeNames = Object.create(null);

  for (const memberType of memberTypes) {
    if (includedTypeNames[memberType.name]) {
      context.reportError(
        `Union type ${union.name} can only include type ${memberType.name} once.`,
        getUnionMemberTypeNodes(union, memberType.name),
      );
      continue;
    }

    includedTypeNames[memberType.name] = true;

    if (!isObjectType(memberType)) {
      context.reportError(
        `Union type ${union.name} can only include Object types, ` +
          `it cannot include ${inspect(memberType)}.`,
        getUnionMemberTypeNodes(union, String(memberType)),
      );
    }
  }
}

function validateEnumValues(context, enumType) {
  const enumValues = enumType.getValues();

  if (enumValues.length === 0) {
    context.reportError(
      `Enum type ${enumType.name} must define one or more values.`,
      [enumType.astNode, ...enumType.extensionASTNodes],
    );
  }

  for (const enumValue of enumValues) {
    // Ensure valid name.
    validateName(context, enumValue);
  }
}

function validateInputFields(context, inputObj) {
  const fields = Object.values(inputObj.getFields());

  if (fields.length === 0) {
    context.reportError(
      `Input Object type ${inputObj.name} must define one or more fields.`,
      [inputObj.astNode, ...inputObj.extensionASTNodes],
    );
  } // Ensure the arguments are valid

  for (const field of fields) {
    // Ensure they are named correctly.
    validateName(context, field); // Ensure the type is an input type

    if (!isInputType(field.type)) {
      var _field$astNode2;

      context.reportError(
        `The type of ${inputObj.name}.${field.name} must be Input Type ` +
          `but got: ${inspect(field.type)}.`,
        (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0
          ? void 0
          : _field$astNode2.type,
      );
    }

    if (isRequiredInputField(field) && field.deprecationReason != null) {
      var _field$astNode3;

      context.reportError(
        `Required input field ${inputObj.name}.${field.name} cannot be deprecated.`,
        [
          getDeprecatedDirectiveNode(field.astNode),
          (_field$astNode3 = field.astNode) === null ||
          _field$astNode3 === void 0
            ? void 0
            : _field$astNode3.type,
        ],
      );
    }
  }
}

function createInputObjectCircularRefsValidator(context) {
  // Modified copy of algorithm from 'src/validation/rules/NoFragmentCycles.js'.
  // Tracks already visited types to maintain O(N) and to ensure that cycles
  // are not redundantly reported.
  const visitedTypes = Object.create(null); // Array of types nodes used to produce meaningful errors

  const fieldPath = []; // Position in the type path

  const fieldPathIndexByTypeName = Object.create(null);
  return detectCycleRecursive; // This does a straight-forward DFS to find cycles.
  // It does not terminate when a cycle was found but continues to explore
  // the graph to find all possible cycles.

  function detectCycleRecursive(inputObj) {
    if (visitedTypes[inputObj.name]) {
      return;
    }

    visitedTypes[inputObj.name] = true;
    fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
    const fields = Object.values(inputObj.getFields());

    for (const field of fields) {
      if (isNonNullType(field.type) && isInputObjectType(field.type.ofType)) {
        const fieldType = field.type.ofType;
        const cycleIndex = fieldPathIndexByTypeName[fieldType.name];
        fieldPath.push(field);

        if (cycleIndex === undefined) {
          detectCycleRecursive(fieldType);
        } else {
          const cyclePath = fieldPath.slice(cycleIndex);
          const pathStr = cyclePath.map((fieldObj) => fieldObj.name).join('.');
          context.reportError(
            `Cannot reference Input Object "${fieldType.name}" within itself through a series of non-null fields: "${pathStr}".`,
            cyclePath.map((fieldObj) => fieldObj.astNode),
          );
        }

        fieldPath.pop();
      }
    }

    fieldPathIndexByTypeName[inputObj.name] = undefined;
  }
}

function getAllImplementsInterfaceNodes(type, iface) {
  const { astNode, extensionASTNodes } = type;
  const nodes =
    astNode != null ? [astNode, ...extensionASTNodes] : extensionASTNodes; // FIXME: https://github.com/graphql/graphql-js/issues/2203

  return nodes
    .flatMap((typeNode) => {
      var _typeNode$interfaces;

      return (
        /* c8 ignore next */
        (_typeNode$interfaces = typeNode.interfaces) !== null &&
          _typeNode$interfaces !== void 0
          ? _typeNode$interfaces
          : []
      );
    })
    .filter((ifaceNode) => ifaceNode.name.value === iface.name);
}

function getUnionMemberTypeNodes(union, typeName) {
  const { astNode, extensionASTNodes } = union;
  const nodes =
    astNode != null ? [astNode, ...extensionASTNodes] : extensionASTNodes; // FIXME: https://github.com/graphql/graphql-js/issues/2203

  return nodes
    .flatMap((unionNode) => {
      var _unionNode$types;

      return (
        /* c8 ignore next */
        (_unionNode$types = unionNode.types) !== null &&
          _unionNode$types !== void 0
          ? _unionNode$types
          : []
      );
    })
    .filter((typeNode) => typeNode.name.value === typeName);
}

function getDeprecatedDirectiveNode(definitionNode) {
  var _definitionNode$direc;

  return definitionNode === null || definitionNode === void 0
    ? void 0
    : (_definitionNode$direc = definitionNode.directives) === null ||
      _definitionNode$direc === void 0
    ? void 0
    : _definitionNode$direc.find(
        (node) => node.name.value === GraphQLDeprecatedDirective.name,
      );
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/typeFromAST.mjs


function typeFromAST(schema, typeNode) {
  switch (typeNode.kind) {
    case Kind.LIST_TYPE: {
      const innerType = typeFromAST(schema, typeNode.type);
      return innerType && new GraphQLList(innerType);
    }

    case Kind.NON_NULL_TYPE: {
      const innerType = typeFromAST(schema, typeNode.type);
      return innerType && new GraphQLNonNull(innerType);
    }

    case Kind.NAMED_TYPE:
      return schema.getType(typeNode.name.value);
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/TypeInfo.mjs






/**
 * TypeInfo is a utility class which, given a GraphQL schema, can keep track
 * of the current field and type definitions at any point in a GraphQL document
 * AST during a recursive descent by calling `enter(node)` and `leave(node)`.
 */

class TypeInfo {
  constructor(
    schema,
    /**
     * Initial type may be provided in rare cases to facilitate traversals
     *  beginning somewhere other than documents.
     */
    initialType,
    /** @deprecated will be removed in 17.0.0 */
    getFieldDefFn,
  ) {
    this._schema = schema;
    this._typeStack = [];
    this._parentTypeStack = [];
    this._inputTypeStack = [];
    this._fieldDefStack = [];
    this._defaultValueStack = [];
    this._directive = null;
    this._argument = null;
    this._enumValue = null;
    this._getFieldDef =
      getFieldDefFn !== null && getFieldDefFn !== void 0
        ? getFieldDefFn
        : getFieldDef;

    if (initialType) {
      if (isInputType(initialType)) {
        this._inputTypeStack.push(initialType);
      }

      if (isCompositeType(initialType)) {
        this._parentTypeStack.push(initialType);
      }

      if (isOutputType(initialType)) {
        this._typeStack.push(initialType);
      }
    }
  }

  get [Symbol.toStringTag]() {
    return 'TypeInfo';
  }

  getType() {
    if (this._typeStack.length > 0) {
      return this._typeStack[this._typeStack.length - 1];
    }
  }

  getParentType() {
    if (this._parentTypeStack.length > 0) {
      return this._parentTypeStack[this._parentTypeStack.length - 1];
    }
  }

  getInputType() {
    if (this._inputTypeStack.length > 0) {
      return this._inputTypeStack[this._inputTypeStack.length - 1];
    }
  }

  getParentInputType() {
    if (this._inputTypeStack.length > 1) {
      return this._inputTypeStack[this._inputTypeStack.length - 2];
    }
  }

  getFieldDef() {
    if (this._fieldDefStack.length > 0) {
      return this._fieldDefStack[this._fieldDefStack.length - 1];
    }
  }

  getDefaultValue() {
    if (this._defaultValueStack.length > 0) {
      return this._defaultValueStack[this._defaultValueStack.length - 1];
    }
  }

  getDirective() {
    return this._directive;
  }

  getArgument() {
    return this._argument;
  }

  getEnumValue() {
    return this._enumValue;
  }

  enter(node) {
    const schema = this._schema; // Note: many of the types below are explicitly typed as "unknown" to drop
    // any assumptions of a valid schema to ensure runtime types are properly
    // checked before continuing since TypeInfo is used as part of validation
    // which occurs before guarantees of schema and document validity.

    switch (node.kind) {
      case Kind.SELECTION_SET: {
        const namedType = getNamedType(this.getType());

        this._parentTypeStack.push(
          isCompositeType(namedType) ? namedType : undefined,
        );

        break;
      }

      case Kind.FIELD: {
        const parentType = this.getParentType();
        let fieldDef;
        let fieldType;

        if (parentType) {
          fieldDef = this._getFieldDef(schema, parentType, node);

          if (fieldDef) {
            fieldType = fieldDef.type;
          }
        }

        this._fieldDefStack.push(fieldDef);

        this._typeStack.push(isOutputType(fieldType) ? fieldType : undefined);

        break;
      }

      case Kind.DIRECTIVE:
        this._directive = schema.getDirective(node.name.value);
        break;

      case Kind.OPERATION_DEFINITION: {
        const rootType = schema.getRootType(node.operation);

        this._typeStack.push(isObjectType(rootType) ? rootType : undefined);

        break;
      }

      case Kind.INLINE_FRAGMENT:
      case Kind.FRAGMENT_DEFINITION: {
        const typeConditionAST = node.typeCondition;
        const outputType = typeConditionAST
          ? typeFromAST(schema, typeConditionAST)
          : getNamedType(this.getType());

        this._typeStack.push(isOutputType(outputType) ? outputType : undefined);

        break;
      }

      case Kind.VARIABLE_DEFINITION: {
        const inputType = typeFromAST(schema, node.type);

        this._inputTypeStack.push(
          isInputType(inputType) ? inputType : undefined,
        );

        break;
      }

      case Kind.ARGUMENT: {
        var _this$getDirective;

        let argDef;
        let argType;
        const fieldOrDirective =
          (_this$getDirective = this.getDirective()) !== null &&
          _this$getDirective !== void 0
            ? _this$getDirective
            : this.getFieldDef();

        if (fieldOrDirective) {
          argDef = fieldOrDirective.args.find(
            (arg) => arg.name === node.name.value,
          );

          if (argDef) {
            argType = argDef.type;
          }
        }

        this._argument = argDef;

        this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);

        this._inputTypeStack.push(isInputType(argType) ? argType : undefined);

        break;
      }

      case Kind.LIST: {
        const listType = getNullableType(this.getInputType());
        const itemType = isListType(listType) ? listType.ofType : listType; // List positions never have a default value.

        this._defaultValueStack.push(undefined);

        this._inputTypeStack.push(isInputType(itemType) ? itemType : undefined);

        break;
      }

      case Kind.OBJECT_FIELD: {
        const objectType = getNamedType(this.getInputType());
        let inputFieldType;
        let inputField;

        if (isInputObjectType(objectType)) {
          inputField = objectType.getFields()[node.name.value];

          if (inputField) {
            inputFieldType = inputField.type;
          }
        }

        this._defaultValueStack.push(
          inputField ? inputField.defaultValue : undefined,
        );

        this._inputTypeStack.push(
          isInputType(inputFieldType) ? inputFieldType : undefined,
        );

        break;
      }

      case Kind.ENUM: {
        const enumType = getNamedType(this.getInputType());
        let enumValue;

        if (isEnumType(enumType)) {
          enumValue = enumType.getValue(node.value);
        }

        this._enumValue = enumValue;
        break;
      }

      default: // Ignore other nodes
    }
  }

  leave(node) {
    switch (node.kind) {
      case Kind.SELECTION_SET:
        this._parentTypeStack.pop();

        break;

      case Kind.FIELD:
        this._fieldDefStack.pop();

        this._typeStack.pop();

        break;

      case Kind.DIRECTIVE:
        this._directive = null;
        break;

      case Kind.OPERATION_DEFINITION:
      case Kind.INLINE_FRAGMENT:
      case Kind.FRAGMENT_DEFINITION:
        this._typeStack.pop();

        break;

      case Kind.VARIABLE_DEFINITION:
        this._inputTypeStack.pop();

        break;

      case Kind.ARGUMENT:
        this._argument = null;

        this._defaultValueStack.pop();

        this._inputTypeStack.pop();

        break;

      case Kind.LIST:
      case Kind.OBJECT_FIELD:
        this._defaultValueStack.pop();

        this._inputTypeStack.pop();

        break;

      case Kind.ENUM:
        this._enumValue = null;
        break;

      default: // Ignore other nodes
    }
  }
}

/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */
function getFieldDef(schema, parentType, fieldNode) {
  const name = fieldNode.name.value;

  if (
    name === SchemaMetaFieldDef.name &&
    schema.getQueryType() === parentType
  ) {
    return SchemaMetaFieldDef;
  }

  if (name === TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
    return TypeMetaFieldDef;
  }

  if (name === TypeNameMetaFieldDef.name && isCompositeType(parentType)) {
    return TypeNameMetaFieldDef;
  }

  if (isObjectType(parentType) || isInterfaceType(parentType)) {
    return parentType.getFields()[name];
  }
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */

function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter(...args) {
      const node = args[0];
      typeInfo.enter(node);
      const fn = getEnterLeaveForKind(visitor, node.kind).enter;

      if (fn) {
        const result = fn.apply(visitor, args);

        if (result !== undefined) {
          typeInfo.leave(node);

          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }

        return result;
      }
    },

    leave(...args) {
      const node = args[0];
      const fn = getEnterLeaveForKind(visitor, node.kind).leave;
      let result;

      if (fn) {
        result = fn.apply(visitor, args);
      }

      typeInfo.leave(node);
      return result;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/predicates.mjs

function isDefinitionNode(node) {
  return (
    isExecutableDefinitionNode(node) ||
    isTypeSystemDefinitionNode(node) ||
    isTypeSystemExtensionNode(node)
  );
}
function isExecutableDefinitionNode(node) {
  return (
    node.kind === Kind.OPERATION_DEFINITION ||
    node.kind === Kind.FRAGMENT_DEFINITION
  );
}
function isSelectionNode(node) {
  return (
    node.kind === Kind.FIELD ||
    node.kind === Kind.FRAGMENT_SPREAD ||
    node.kind === Kind.INLINE_FRAGMENT
  );
}
function isValueNode(node) {
  return (
    node.kind === Kind.VARIABLE ||
    node.kind === Kind.INT ||
    node.kind === Kind.FLOAT ||
    node.kind === Kind.STRING ||
    node.kind === Kind.BOOLEAN ||
    node.kind === Kind.NULL ||
    node.kind === Kind.ENUM ||
    node.kind === Kind.LIST ||
    node.kind === Kind.OBJECT
  );
}
function isConstValueNode(node) {
  return (
    isValueNode(node) &&
    (node.kind === Kind.LIST
      ? node.values.some(isConstValueNode)
      : node.kind === Kind.OBJECT
      ? node.fields.some((field) => isConstValueNode(field.value))
      : node.kind !== Kind.VARIABLE)
  );
}
function isTypeNode(node) {
  return (
    node.kind === Kind.NAMED_TYPE ||
    node.kind === Kind.LIST_TYPE ||
    node.kind === Kind.NON_NULL_TYPE
  );
}
function isTypeSystemDefinitionNode(node) {
  return (
    node.kind === Kind.SCHEMA_DEFINITION ||
    isTypeDefinitionNode(node) ||
    node.kind === Kind.DIRECTIVE_DEFINITION
  );
}
function isTypeDefinitionNode(node) {
  return (
    node.kind === Kind.SCALAR_TYPE_DEFINITION ||
    node.kind === Kind.OBJECT_TYPE_DEFINITION ||
    node.kind === Kind.INTERFACE_TYPE_DEFINITION ||
    node.kind === Kind.UNION_TYPE_DEFINITION ||
    node.kind === Kind.ENUM_TYPE_DEFINITION ||
    node.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION
  );
}
function isTypeSystemExtensionNode(node) {
  return node.kind === Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
  return (
    node.kind === Kind.SCALAR_TYPE_EXTENSION ||
    node.kind === Kind.OBJECT_TYPE_EXTENSION ||
    node.kind === Kind.INTERFACE_TYPE_EXTENSION ||
    node.kind === Kind.UNION_TYPE_EXTENSION ||
    node.kind === Kind.ENUM_TYPE_EXTENSION ||
    node.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ExecutableDefinitionsRule.mjs




/**
 * Executable definitions
 *
 * A GraphQL document is only valid for execution if all definitions are either
 * operation or fragment definitions.
 *
 * See https://spec.graphql.org/draft/#sec-Executable-Definitions
 */
function ExecutableDefinitionsRule(context) {
  return {
    Document(node) {
      for (const definition of node.definitions) {
        if (!isExecutableDefinitionNode(definition)) {
          const defName =
            definition.kind === Kind.SCHEMA_DEFINITION ||
            definition.kind === Kind.SCHEMA_EXTENSION
              ? 'schema'
              : '"' + definition.name.value + '"';
          context.reportError(
            new GraphQLError(`The ${defName} definition is not executable.`, {
              nodes: definition,
            }),
          );
        }
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/FieldsOnCorrectTypeRule.mjs






/**
 * Fields on correct type
 *
 * A GraphQL document is only valid if all fields selected are defined by the
 * parent type, or are an allowed meta field such as __typename.
 *
 * See https://spec.graphql.org/draft/#sec-Field-Selections
 */
function FieldsOnCorrectTypeRule(context) {
  return {
    Field(node) {
      const type = context.getParentType();

      if (type) {
        const fieldDef = context.getFieldDef();

        if (!fieldDef) {
          // This field doesn't exist, lets look for suggestions.
          const schema = context.getSchema();
          const fieldName = node.name.value; // First determine if there are any suggested types to condition on.

          let suggestion = didYouMean(
            'to use an inline fragment on',
            getSuggestedTypeNames(schema, type, fieldName),
          ); // If there are no suggested types, then perhaps this was a typo?

          if (suggestion === '') {
            suggestion = didYouMean(getSuggestedFieldNames(type, fieldName));
          } // Report an error, including helpful suggestions.

          context.reportError(
            new GraphQLError(
              `Cannot query field "${fieldName}" on type "${type.name}".` +
                suggestion,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },
  };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest them,
 * sorted by how often the type is referenced.
 */

function getSuggestedTypeNames(schema, type, fieldName) {
  if (!isAbstractType(type)) {
    // Must be an Object type, which does not have possible fields.
    return [];
  }

  const suggestedTypes = new Set();
  const usageCount = Object.create(null);

  for (const possibleType of schema.getPossibleTypes(type)) {
    if (!possibleType.getFields()[fieldName]) {
      continue;
    } // This object type defines this field.

    suggestedTypes.add(possibleType);
    usageCount[possibleType.name] = 1;

    for (const possibleInterface of possibleType.getInterfaces()) {
      var _usageCount$possibleI;

      if (!possibleInterface.getFields()[fieldName]) {
        continue;
      } // This interface type defines this field.

      suggestedTypes.add(possibleInterface);
      usageCount[possibleInterface.name] =
        ((_usageCount$possibleI = usageCount[possibleInterface.name]) !==
          null && _usageCount$possibleI !== void 0
          ? _usageCount$possibleI
          : 0) + 1;
    }
  }

  return [...suggestedTypes]
    .sort((typeA, typeB) => {
      // Suggest both interface and object types based on how common they are.
      const usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];

      if (usageCountDiff !== 0) {
        return usageCountDiff;
      } // Suggest super types first followed by subtypes

      if (isInterfaceType(typeA) && schema.isSubType(typeA, typeB)) {
        return -1;
      }

      if (isInterfaceType(typeB) && schema.isSubType(typeB, typeA)) {
        return 1;
      }

      return naturalCompare(typeA.name, typeB.name);
    })
    .map((x) => x.name);
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */

function getSuggestedFieldNames(type, fieldName) {
  if (isObjectType(type) || isInterfaceType(type)) {
    const possibleFieldNames = Object.keys(type.getFields());
    return suggestionList(fieldName, possibleFieldNames);
  } // Otherwise, must be a Union type, which does not define fields.

  return [];
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/FragmentsOnCompositeTypesRule.mjs





/**
 * Fragments on composite type
 *
 * Fragments use a type condition to determine if they apply, since fragments
 * can only be spread into a composite type (object, interface, or union), the
 * type condition must also be a composite type.
 *
 * See https://spec.graphql.org/draft/#sec-Fragments-On-Composite-Types
 */
function FragmentsOnCompositeTypesRule(context) {
  return {
    InlineFragment(node) {
      const typeCondition = node.typeCondition;

      if (typeCondition) {
        const type = typeFromAST(context.getSchema(), typeCondition);

        if (type && !isCompositeType(type)) {
          const typeStr = print(typeCondition);
          context.reportError(
            new GraphQLError(
              `Fragment cannot condition on non composite type "${typeStr}".`,
              {
                nodes: typeCondition,
              },
            ),
          );
        }
      }
    },

    FragmentDefinition(node) {
      const type = typeFromAST(context.getSchema(), node.typeCondition);

      if (type && !isCompositeType(type)) {
        const typeStr = print(node.typeCondition);
        context.reportError(
          new GraphQLError(
            `Fragment "${node.name.value}" cannot condition on non composite type "${typeStr}".`,
            {
              nodes: node.typeCondition,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownArgumentNamesRule.mjs






/**
 * Known argument names
 *
 * A GraphQL field is only valid if all supplied arguments are defined by
 * that field.
 *
 * See https://spec.graphql.org/draft/#sec-Argument-Names
 * See https://spec.graphql.org/draft/#sec-Directives-Are-In-Valid-Locations
 */
function KnownArgumentNamesRule(context) {
  return {
    // eslint-disable-next-line new-cap
    ...KnownArgumentNamesOnDirectivesRule(context),

    Argument(argNode) {
      const argDef = context.getArgument();
      const fieldDef = context.getFieldDef();
      const parentType = context.getParentType();

      if (!argDef && fieldDef && parentType) {
        const argName = argNode.name.value;
        const knownArgsNames = fieldDef.args.map((arg) => arg.name);
        const suggestions = suggestionList(argName, knownArgsNames);
        context.reportError(
          new GraphQLError(
            `Unknown argument "${argName}" on field "${parentType.name}.${fieldDef.name}".` +
              didYouMean(suggestions),
            {
              nodes: argNode,
            },
          ),
        );
      }
    },
  };
}
/**
 * @internal
 */

function KnownArgumentNamesOnDirectivesRule(context) {
  const directiveArgs = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives = schema
    ? schema.getDirectives()
    : specifiedDirectives;

  for (const directive of definedDirectives) {
    directiveArgs[directive.name] = directive.args.map((arg) => arg.name);
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === Kind.DIRECTIVE_DEFINITION) {
      var _def$arguments;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const argsNodes =
        (_def$arguments = def.arguments) !== null && _def$arguments !== void 0
          ? _def$arguments
          : [];
      directiveArgs[def.name.value] = argsNodes.map((arg) => arg.name.value);
    }
  }

  return {
    Directive(directiveNode) {
      const directiveName = directiveNode.name.value;
      const knownArgs = directiveArgs[directiveName];

      if (directiveNode.arguments && knownArgs) {
        for (const argNode of directiveNode.arguments) {
          const argName = argNode.name.value;

          if (!knownArgs.includes(argName)) {
            const suggestions = suggestionList(argName, knownArgs);
            context.reportError(
              new GraphQLError(
                `Unknown argument "${argName}" on directive "@${directiveName}".` +
                  didYouMean(suggestions),
                {
                  nodes: argNode,
                },
              ),
            );
          }
        }
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownDirectivesRule.mjs








/**
 * Known directives
 *
 * A GraphQL document is only valid if all `@directives` are known by the
 * schema and legally positioned.
 *
 * See https://spec.graphql.org/draft/#sec-Directives-Are-Defined
 */
function KnownDirectivesRule(context) {
  const locationsMap = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives = schema
    ? schema.getDirectives()
    : specifiedDirectives;

  for (const directive of definedDirectives) {
    locationsMap[directive.name] = directive.locations;
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === Kind.DIRECTIVE_DEFINITION) {
      locationsMap[def.name.value] = def.locations.map((name) => name.value);
    }
  }

  return {
    Directive(node, _key, _parent, _path, ancestors) {
      const name = node.name.value;
      const locations = locationsMap[name];

      if (!locations) {
        context.reportError(
          new GraphQLError(`Unknown directive "@${name}".`, {
            nodes: node,
          }),
        );
        return;
      }

      const candidateLocation = getDirectiveLocationForASTPath(ancestors);

      if (candidateLocation && !locations.includes(candidateLocation)) {
        context.reportError(
          new GraphQLError(
            `Directive "@${name}" may not be used on ${candidateLocation}.`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

function getDirectiveLocationForASTPath(ancestors) {
  const appliedTo = ancestors[ancestors.length - 1];
  'kind' in appliedTo || invariant(false);

  switch (appliedTo.kind) {
    case Kind.OPERATION_DEFINITION:
      return getDirectiveLocationForOperation(appliedTo.operation);

    case Kind.FIELD:
      return DirectiveLocation.FIELD;

    case Kind.FRAGMENT_SPREAD:
      return DirectiveLocation.FRAGMENT_SPREAD;

    case Kind.INLINE_FRAGMENT:
      return DirectiveLocation.INLINE_FRAGMENT;

    case Kind.FRAGMENT_DEFINITION:
      return DirectiveLocation.FRAGMENT_DEFINITION;

    case Kind.VARIABLE_DEFINITION:
      return DirectiveLocation.VARIABLE_DEFINITION;

    case Kind.SCHEMA_DEFINITION:
    case Kind.SCHEMA_EXTENSION:
      return DirectiveLocation.SCHEMA;

    case Kind.SCALAR_TYPE_DEFINITION:
    case Kind.SCALAR_TYPE_EXTENSION:
      return DirectiveLocation.SCALAR;

    case Kind.OBJECT_TYPE_DEFINITION:
    case Kind.OBJECT_TYPE_EXTENSION:
      return DirectiveLocation.OBJECT;

    case Kind.FIELD_DEFINITION:
      return DirectiveLocation.FIELD_DEFINITION;

    case Kind.INTERFACE_TYPE_DEFINITION:
    case Kind.INTERFACE_TYPE_EXTENSION:
      return DirectiveLocation.INTERFACE;

    case Kind.UNION_TYPE_DEFINITION:
    case Kind.UNION_TYPE_EXTENSION:
      return DirectiveLocation.UNION;

    case Kind.ENUM_TYPE_DEFINITION:
    case Kind.ENUM_TYPE_EXTENSION:
      return DirectiveLocation.ENUM;

    case Kind.ENUM_VALUE_DEFINITION:
      return DirectiveLocation.ENUM_VALUE;

    case Kind.INPUT_OBJECT_TYPE_DEFINITION:
    case Kind.INPUT_OBJECT_TYPE_EXTENSION:
      return DirectiveLocation.INPUT_OBJECT;

    case Kind.INPUT_VALUE_DEFINITION: {
      const parentNode = ancestors[ancestors.length - 3];
      'kind' in parentNode || invariant(false);
      return parentNode.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION
        ? DirectiveLocation.INPUT_FIELD_DEFINITION
        : DirectiveLocation.ARGUMENT_DEFINITION;
    }
    // Not reachable, all possible types have been considered.

    /* c8 ignore next */

    default:
       false || invariant(false, 'Unexpected kind: ' + inspect(appliedTo.kind));
  }
}

function getDirectiveLocationForOperation(operation) {
  switch (operation) {
    case OperationTypeNode.QUERY:
      return DirectiveLocation.QUERY;

    case OperationTypeNode.MUTATION:
      return DirectiveLocation.MUTATION;

    case OperationTypeNode.SUBSCRIPTION:
      return DirectiveLocation.SUBSCRIPTION;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownFragmentNamesRule.mjs


/**
 * Known fragment names
 *
 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
 * to fragments defined in the same document.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-spread-target-defined
 */
function KnownFragmentNamesRule(context) {
  return {
    FragmentSpread(node) {
      const fragmentName = node.name.value;
      const fragment = context.getFragment(fragmentName);

      if (!fragment) {
        context.reportError(
          new GraphQLError(`Unknown fragment "${fragmentName}".`, {
            nodes: node.name,
          }),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownTypeNamesRule.mjs







/**
 * Known type names
 *
 * A GraphQL document is only valid if referenced types (specifically
 * variable definitions and fragment conditions) are defined by the type schema.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-Spread-Type-Existence
 */
function KnownTypeNamesRule(context) {
  const schema = context.getSchema();
  const existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
  const definedTypes = Object.create(null);

  for (const def of context.getDocument().definitions) {
    if (isTypeDefinitionNode(def)) {
      definedTypes[def.name.value] = true;
    }
  }

  const typeNames = [
    ...Object.keys(existingTypesMap),
    ...Object.keys(definedTypes),
  ];
  return {
    NamedType(node, _1, parent, _2, ancestors) {
      const typeName = node.name.value;

      if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
        var _ancestors$;

        const definitionNode =
          (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0
            ? _ancestors$
            : parent;
        const isSDL = definitionNode != null && isSDLNode(definitionNode);

        if (isSDL && standardTypeNames.includes(typeName)) {
          return;
        }

        const suggestedTypes = suggestionList(
          typeName,
          isSDL ? standardTypeNames.concat(typeNames) : typeNames,
        );
        context.reportError(
          new GraphQLError(
            `Unknown type "${typeName}".` + didYouMean(suggestedTypes),
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}
const standardTypeNames = [...specifiedScalarTypes, ...introspectionTypes].map(
  (type) => type.name,
);

function isSDLNode(value) {
  return (
    'kind' in value &&
    (isTypeSystemDefinitionNode(value) || isTypeSystemExtensionNode(value))
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/LoneAnonymousOperationRule.mjs



/**
 * Lone anonymous operation
 *
 * A GraphQL document is only valid if when it contains an anonymous operation
 * (the query short-hand) that it contains only that one operation definition.
 *
 * See https://spec.graphql.org/draft/#sec-Lone-Anonymous-Operation
 */
function LoneAnonymousOperationRule(context) {
  let operationCount = 0;
  return {
    Document(node) {
      operationCount = node.definitions.filter(
        (definition) => definition.kind === Kind.OPERATION_DEFINITION,
      ).length;
    },

    OperationDefinition(node) {
      if (!node.name && operationCount > 1) {
        context.reportError(
          new GraphQLError(
            'This anonymous operation must be the only defined operation.',
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/LoneSchemaDefinitionRule.mjs


/**
 * Lone Schema definition
 *
 * A GraphQL document is only valid if it contains only one schema definition.
 */
function LoneSchemaDefinitionRule(context) {
  var _ref, _ref2, _oldSchema$astNode;

  const oldSchema = context.getSchema();
  const alreadyDefined =
    (_ref =
      (_ref2 =
        (_oldSchema$astNode =
          oldSchema === null || oldSchema === void 0
            ? void 0
            : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0
          ? _oldSchema$astNode
          : oldSchema === null || oldSchema === void 0
          ? void 0
          : oldSchema.getQueryType()) !== null && _ref2 !== void 0
        ? _ref2
        : oldSchema === null || oldSchema === void 0
        ? void 0
        : oldSchema.getMutationType()) !== null && _ref !== void 0
      ? _ref
      : oldSchema === null || oldSchema === void 0
      ? void 0
      : oldSchema.getSubscriptionType();
  let schemaDefinitionsCount = 0;
  return {
    SchemaDefinition(node) {
      if (alreadyDefined) {
        context.reportError(
          new GraphQLError(
            'Cannot define a new schema within a schema extension.',
            {
              nodes: node,
            },
          ),
        );
        return;
      }

      if (schemaDefinitionsCount > 0) {
        context.reportError(
          new GraphQLError('Must provide only one schema definition.', {
            nodes: node,
          }),
        );
      }

      ++schemaDefinitionsCount;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoFragmentCyclesRule.mjs


/**
 * No fragment cycles
 *
 * The graph of fragment spreads must not form any cycles including spreading itself.
 * Otherwise an operation could infinitely spread or infinitely execute on cycles in the underlying data.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-spreads-must-not-form-cycles
 */
function NoFragmentCyclesRule(context) {
  // Tracks already visited fragments to maintain O(N) and to ensure that cycles
  // are not redundantly reported.
  const visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors

  const spreadPath = []; // Position in the spread path

  const spreadPathIndexByName = Object.create(null);
  return {
    OperationDefinition: () => false,

    FragmentDefinition(node) {
      detectCycleRecursive(node);
      return false;
    },
  }; // This does a straight-forward DFS to find cycles.
  // It does not terminate when a cycle was found but continues to explore
  // the graph to find all possible cycles.

  function detectCycleRecursive(fragment) {
    if (visitedFrags[fragment.name.value]) {
      return;
    }

    const fragmentName = fragment.name.value;
    visitedFrags[fragmentName] = true;
    const spreadNodes = context.getFragmentSpreads(fragment.selectionSet);

    if (spreadNodes.length === 0) {
      return;
    }

    spreadPathIndexByName[fragmentName] = spreadPath.length;

    for (const spreadNode of spreadNodes) {
      const spreadName = spreadNode.name.value;
      const cycleIndex = spreadPathIndexByName[spreadName];
      spreadPath.push(spreadNode);

      if (cycleIndex === undefined) {
        const spreadFragment = context.getFragment(spreadName);

        if (spreadFragment) {
          detectCycleRecursive(spreadFragment);
        }
      } else {
        const cyclePath = spreadPath.slice(cycleIndex);
        const viaPath = cyclePath
          .slice(0, -1)
          .map((s) => '"' + s.name.value + '"')
          .join(', ');
        context.reportError(
          new GraphQLError(
            `Cannot spread fragment "${spreadName}" within itself` +
              (viaPath !== '' ? ` via ${viaPath}.` : '.'),
            {
              nodes: cyclePath,
            },
          ),
        );
      }

      spreadPath.pop();
    }

    spreadPathIndexByName[fragmentName] = undefined;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoUndefinedVariablesRule.mjs


/**
 * No undefined variables
 *
 * A GraphQL operation is only valid if all variables encountered, both directly
 * and via fragment spreads, are defined by that operation.
 *
 * See https://spec.graphql.org/draft/#sec-All-Variable-Uses-Defined
 */
function NoUndefinedVariablesRule(context) {
  let variableNameDefined = Object.create(null);
  return {
    OperationDefinition: {
      enter() {
        variableNameDefined = Object.create(null);
      },

      leave(operation) {
        const usages = context.getRecursiveVariableUsages(operation);

        for (const { node } of usages) {
          const varName = node.name.value;

          if (variableNameDefined[varName] !== true) {
            context.reportError(
              new GraphQLError(
                operation.name
                  ? `Variable "$${varName}" is not defined by operation "${operation.name.value}".`
                  : `Variable "$${varName}" is not defined.`,
                {
                  nodes: [node, operation],
                },
              ),
            );
          }
        }
      },
    },

    VariableDefinition(node) {
      variableNameDefined[node.variable.name.value] = true;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoUnusedFragmentsRule.mjs


/**
 * No unused fragments
 *
 * A GraphQL document is only valid if all fragment definitions are spread
 * within operations, or spread within other fragments spread within operations.
 *
 * See https://spec.graphql.org/draft/#sec-Fragments-Must-Be-Used
 */
function NoUnusedFragmentsRule(context) {
  const operationDefs = [];
  const fragmentDefs = [];
  return {
    OperationDefinition(node) {
      operationDefs.push(node);
      return false;
    },

    FragmentDefinition(node) {
      fragmentDefs.push(node);
      return false;
    },

    Document: {
      leave() {
        const fragmentNameUsed = Object.create(null);

        for (const operation of operationDefs) {
          for (const fragment of context.getRecursivelyReferencedFragments(
            operation,
          )) {
            fragmentNameUsed[fragment.name.value] = true;
          }
        }

        for (const fragmentDef of fragmentDefs) {
          const fragName = fragmentDef.name.value;

          if (fragmentNameUsed[fragName] !== true) {
            context.reportError(
              new GraphQLError(`Fragment "${fragName}" is never used.`, {
                nodes: fragmentDef,
              }),
            );
          }
        }
      },
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoUnusedVariablesRule.mjs


/**
 * No unused variables
 *
 * A GraphQL operation is only valid if all variables defined by an operation
 * are used, either directly or within a spread fragment.
 *
 * See https://spec.graphql.org/draft/#sec-All-Variables-Used
 */
function NoUnusedVariablesRule(context) {
  let variableDefs = [];
  return {
    OperationDefinition: {
      enter() {
        variableDefs = [];
      },

      leave(operation) {
        const variableNameUsed = Object.create(null);
        const usages = context.getRecursiveVariableUsages(operation);

        for (const { node } of usages) {
          variableNameUsed[node.name.value] = true;
        }

        for (const variableDef of variableDefs) {
          const variableName = variableDef.variable.name.value;

          if (variableNameUsed[variableName] !== true) {
            context.reportError(
              new GraphQLError(
                operation.name
                  ? `Variable "$${variableName}" is never used in operation "${operation.name.value}".`
                  : `Variable "$${variableName}" is never used.`,
                {
                  nodes: variableDef,
                },
              ),
            );
          }
        }
      },
    },

    VariableDefinition(def) {
      variableDefs.push(def);
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/sortValueNode.mjs


/**
 * Sort ValueNode.
 *
 * This function returns a sorted copy of the given ValueNode.
 *
 * @internal
 */

function sortValueNode(valueNode) {
  switch (valueNode.kind) {
    case Kind.OBJECT:
      return { ...valueNode, fields: sortFields(valueNode.fields) };

    case Kind.LIST:
      return { ...valueNode, values: valueNode.values.map(sortValueNode) };

    case Kind.INT:
    case Kind.FLOAT:
    case Kind.STRING:
    case Kind.BOOLEAN:
    case Kind.NULL:
    case Kind.ENUM:
    case Kind.VARIABLE:
      return valueNode;
  }
}

function sortFields(fields) {
  return fields
    .map((fieldNode) => ({
      ...fieldNode,
      value: sortValueNode(fieldNode.value),
    }))
    .sort((fieldA, fieldB) =>
      naturalCompare(fieldA.name.value, fieldB.name.value),
    );
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/OverlappingFieldsCanBeMergedRule.mjs








function reasonMessage(reason) {
  if (Array.isArray(reason)) {
    return reason
      .map(
        ([responseName, subReason]) =>
          `subfields "${responseName}" conflict because ` +
          reasonMessage(subReason),
      )
      .join(' and ');
  }

  return reason;
}
/**
 * Overlapping fields can be merged
 *
 * A selection set is only valid if all fields (including spreading any
 * fragments) either correspond to distinct response names or can be merged
 * without ambiguity.
 *
 * See https://spec.graphql.org/draft/#sec-Field-Selection-Merging
 */

function OverlappingFieldsCanBeMergedRule(context) {
  // A memoization for when two fragments are compared "between" each other for
  // conflicts. Two fragments may be compared many times, so memoizing this can
  // dramatically improve the performance of this validator.
  const comparedFragmentPairs = new PairSet(); // A cache for the "field map" and list of fragment names found in any given
  // selection set. Selection sets may be asked for this information multiple
  // times, so this improves the performance of this validator.

  const cachedFieldsAndFragmentNames = new Map();
  return {
    SelectionSet(selectionSet) {
      const conflicts = findConflictsWithinSelectionSet(
        context,
        cachedFieldsAndFragmentNames,
        comparedFragmentPairs,
        context.getParentType(),
        selectionSet,
      );

      for (const [[responseName, reason], fields1, fields2] of conflicts) {
        const reasonMsg = reasonMessage(reason);
        context.reportError(
          new GraphQLError(
            `Fields "${responseName}" conflict because ${reasonMsg}. Use different aliases on the fields to fetch both if this was intentional.`,
            {
              nodes: fields1.concat(fields2),
            },
          ),
        );
      }
    },
  };
}

/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */
// Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function findConflictsWithinSelectionSet(
  context,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  parentType,
  selectionSet,
) {
  const conflicts = [];
  const [fieldMap, fragmentNames] = getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    parentType,
    selectionSet,
  ); // (A) Find find all conflicts "within" the fields of this selection set.
  // Note: this is the *only place* `collectConflictsWithin` is called.

  collectConflictsWithin(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    fieldMap,
  );

  if (fragmentNames.length !== 0) {
    // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    for (let i = 0; i < fragmentNames.length; i++) {
      collectConflictsBetweenFieldsAndFragment(
        context,
        conflicts,
        cachedFieldsAndFragmentNames,
        comparedFragmentPairs,
        false,
        fieldMap,
        fragmentNames[i],
      ); // (C) Then compare this fragment with all other fragments found in this
      // selection set to collect conflicts between fragments spread together.
      // This compares each item in the list of fragment names to every other
      // item in that same list (except for itself).

      for (let j = i + 1; j < fragmentNames.length; j++) {
        collectConflictsBetweenFragments(
          context,
          conflicts,
          cachedFieldsAndFragmentNames,
          comparedFragmentPairs,
          false,
          fragmentNames[i],
          fragmentNames[j],
        );
      }
    }
  }

  return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.

function collectConflictsBetweenFieldsAndFragment(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  areMutuallyExclusive,
  fieldMap,
  fragmentName,
) {
  const fragment = context.getFragment(fragmentName);

  if (!fragment) {
    return;
  }

  const [fieldMap2, referencedFragmentNames] =
    getReferencedFieldsAndFragmentNames(
      context,
      cachedFieldsAndFragmentNames,
      fragment,
    ); // Do not compare a fragment's fieldMap to itself.

  if (fieldMap === fieldMap2) {
    return;
  } // (D) First collect any conflicts between the provided collection of fields
  // and the collection of fields represented by the given fragment.

  collectConflictsBetween(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    areMutuallyExclusive,
    fieldMap,
    fieldMap2,
  ); // (E) Then collect any conflicts between the provided collection of fields
  // and any fragment names found in the given fragment.

  for (const referencedFragmentName of referencedFragmentNames) {
    // Memoize so two fragments are not compared for conflicts more than once.
    if (
      comparedFragmentPairs.has(
        referencedFragmentName,
        fragmentName,
        areMutuallyExclusive,
      )
    ) {
      continue;
    }

    comparedFragmentPairs.add(
      referencedFragmentName,
      fragmentName,
      areMutuallyExclusive,
    );
    collectConflictsBetweenFieldsAndFragment(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fieldMap,
      referencedFragmentName,
    );
  }
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.

function collectConflictsBetweenFragments(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  areMutuallyExclusive,
  fragmentName1,
  fragmentName2,
) {
  // No need to compare a fragment to itself.
  if (fragmentName1 === fragmentName2) {
    return;
  } // Memoize so two fragments are not compared for conflicts more than once.

  if (
    comparedFragmentPairs.has(
      fragmentName1,
      fragmentName2,
      areMutuallyExclusive,
    )
  ) {
    return;
  }

  comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
  const fragment1 = context.getFragment(fragmentName1);
  const fragment2 = context.getFragment(fragmentName2);

  if (!fragment1 || !fragment2) {
    return;
  }

  const [fieldMap1, referencedFragmentNames1] =
    getReferencedFieldsAndFragmentNames(
      context,
      cachedFieldsAndFragmentNames,
      fragment1,
    );
  const [fieldMap2, referencedFragmentNames2] =
    getReferencedFieldsAndFragmentNames(
      context,
      cachedFieldsAndFragmentNames,
      fragment2,
    ); // (F) First, collect all conflicts between these two collections of fields
  // (not including any nested fragments).

  collectConflictsBetween(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    areMutuallyExclusive,
    fieldMap1,
    fieldMap2,
  ); // (G) Then collect conflicts between the first fragment and any nested
  // fragments spread in the second fragment.

  for (const referencedFragmentName2 of referencedFragmentNames2) {
    collectConflictsBetweenFragments(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fragmentName1,
      referencedFragmentName2,
    );
  } // (G) Then collect conflicts between the second fragment and any nested
  // fragments spread in the first fragment.

  for (const referencedFragmentName1 of referencedFragmentNames1) {
    collectConflictsBetweenFragments(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      referencedFragmentName1,
      fragmentName2,
    );
  }
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.

function findConflictsBetweenSubSelectionSets(
  context,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  areMutuallyExclusive,
  parentType1,
  selectionSet1,
  parentType2,
  selectionSet2,
) {
  const conflicts = [];
  const [fieldMap1, fragmentNames1] = getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    parentType1,
    selectionSet1,
  );
  const [fieldMap2, fragmentNames2] = getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    parentType2,
    selectionSet2,
  ); // (H) First, collect all conflicts between these two collections of field.

  collectConflictsBetween(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    areMutuallyExclusive,
    fieldMap1,
    fieldMap2,
  ); // (I) Then collect conflicts between the first collection of fields and
  // those referenced by each fragment name associated with the second.

  for (const fragmentName2 of fragmentNames2) {
    collectConflictsBetweenFieldsAndFragment(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fieldMap1,
      fragmentName2,
    );
  } // (I) Then collect conflicts between the second collection of fields and
  // those referenced by each fragment name associated with the first.

  for (const fragmentName1 of fragmentNames1) {
    collectConflictsBetweenFieldsAndFragment(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fieldMap2,
      fragmentName1,
    );
  } // (J) Also collect conflicts between any fragment names by the first and
  // fragment names by the second. This compares each item in the first set of
  // names to each item in the second set of names.

  for (const fragmentName1 of fragmentNames1) {
    for (const fragmentName2 of fragmentNames2) {
      collectConflictsBetweenFragments(
        context,
        conflicts,
        cachedFieldsAndFragmentNames,
        comparedFragmentPairs,
        areMutuallyExclusive,
        fragmentName1,
        fragmentName2,
      );
    }
  }

  return conflicts;
} // Collect all Conflicts "within" one collection of fields.

function collectConflictsWithin(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  fieldMap,
) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For every response name, if there are multiple fields, they
  // must be compared to find a potential conflict.
  for (const [responseName, fields] of Object.entries(fieldMap)) {
    // This compares every field in the list to every other field in this list
    // (except to itself). If the list only has one item, nothing needs to
    // be compared.
    if (fields.length > 1) {
      for (let i = 0; i < fields.length; i++) {
        for (let j = i + 1; j < fields.length; j++) {
          const conflict = findConflict(
            context,
            cachedFieldsAndFragmentNames,
            comparedFragmentPairs,
            false, // within one collection is never mutually exclusive
            responseName,
            fields[i],
            fields[j],
          );

          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.

function collectConflictsBetween(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  parentFieldsAreMutuallyExclusive,
  fieldMap1,
  fieldMap2,
) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For any response name which appears in both provided field
  // maps, each field from the first field map must be compared to every field
  // in the second field map to find potential conflicts.
  for (const [responseName, fields1] of Object.entries(fieldMap1)) {
    const fields2 = fieldMap2[responseName];

    if (fields2) {
      for (const field1 of fields1) {
        for (const field2 of fields2) {
          const conflict = findConflict(
            context,
            cachedFieldsAndFragmentNames,
            comparedFragmentPairs,
            parentFieldsAreMutuallyExclusive,
            responseName,
            field1,
            field2,
          );

          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.

function findConflict(
  context,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  parentFieldsAreMutuallyExclusive,
  responseName,
  field1,
  field2,
) {
  const [parentType1, node1, def1] = field1;
  const [parentType2, node2, def2] = field2; // If it is known that two fields could not possibly apply at the same
  // time, due to the parent types, then it is safe to permit them to diverge
  // in aliased field or arguments used as they will not present any ambiguity
  // by differing.
  // It is known that two parent types could never overlap if they are
  // different Object types. Interface or Union types might overlap - if not
  // in the current state of the schema, then perhaps in some future version,
  // thus may not safely diverge.

  const areMutuallyExclusive =
    parentFieldsAreMutuallyExclusive ||
    (parentType1 !== parentType2 &&
      isObjectType(parentType1) &&
      isObjectType(parentType2));

  if (!areMutuallyExclusive) {
    // Two aliases must refer to the same field.
    const name1 = node1.name.value;
    const name2 = node2.name.value;

    if (name1 !== name2) {
      return [
        [responseName, `"${name1}" and "${name2}" are different fields`],
        [node1],
        [node2],
      ];
    } // Two field calls must have the same arguments.

    if (!sameArguments(node1, node2)) {
      return [
        [responseName, 'they have differing arguments'],
        [node1],
        [node2],
      ];
    }
  } // The return type for each field.

  const type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
  const type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;

  if (type1 && type2 && doTypesConflict(type1, type2)) {
    return [
      [
        responseName,
        `they return conflicting types "${inspect(type1)}" and "${inspect(
          type2,
        )}"`,
      ],
      [node1],
      [node2],
    ];
  } // Collect and compare sub-fields. Use the same "visited fragment names" list
  // for both collections so fields in a fragment reference are never
  // compared to themselves.

  const selectionSet1 = node1.selectionSet;
  const selectionSet2 = node2.selectionSet;

  if (selectionSet1 && selectionSet2) {
    const conflicts = findConflictsBetweenSubSelectionSets(
      context,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      getNamedType(type1),
      selectionSet1,
      getNamedType(type2),
      selectionSet2,
    );
    return subfieldConflicts(conflicts, responseName, node1, node2);
  }
}

function sameArguments(node1, node2) {
  const args1 = node1.arguments;
  const args2 = node2.arguments;

  if (args1 === undefined || args1.length === 0) {
    return args2 === undefined || args2.length === 0;
  }

  if (args2 === undefined || args2.length === 0) {
    return false;
  }
  /* c8 ignore next */

  if (args1.length !== args2.length) {
    /* c8 ignore next */
    return false;
    /* c8 ignore next */
  }

  const values2 = new Map(args2.map(({ name, value }) => [name.value, value]));
  return args1.every((arg1) => {
    const value1 = arg1.value;
    const value2 = values2.get(arg1.name.value);

    if (value2 === undefined) {
      return false;
    }

    return stringifyValue(value1) === stringifyValue(value2);
  });
}

function stringifyValue(value) {
  return print(sortValueNode(value));
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.

function doTypesConflict(type1, type2) {
  if (isListType(type1)) {
    return isListType(type2)
      ? doTypesConflict(type1.ofType, type2.ofType)
      : true;
  }

  if (isListType(type2)) {
    return true;
  }

  if (isNonNullType(type1)) {
    return isNonNullType(type2)
      ? doTypesConflict(type1.ofType, type2.ofType)
      : true;
  }

  if (isNonNullType(type2)) {
    return true;
  }

  if (isLeafType(type1) || isLeafType(type2)) {
    return type1 !== type2;
  }

  return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.

function getFieldsAndFragmentNames(
  context,
  cachedFieldsAndFragmentNames,
  parentType,
  selectionSet,
) {
  const cached = cachedFieldsAndFragmentNames.get(selectionSet);

  if (cached) {
    return cached;
  }

  const nodeAndDefs = Object.create(null);
  const fragmentNames = Object.create(null);

  _collectFieldsAndFragmentNames(
    context,
    parentType,
    selectionSet,
    nodeAndDefs,
    fragmentNames,
  );

  const result = [nodeAndDefs, Object.keys(fragmentNames)];
  cachedFieldsAndFragmentNames.set(selectionSet, result);
  return result;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.

function getReferencedFieldsAndFragmentNames(
  context,
  cachedFieldsAndFragmentNames,
  fragment,
) {
  // Short-circuit building a type from the node if possible.
  const cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);

  if (cached) {
    return cached;
  }

  const fragmentType = typeFromAST(context.getSchema(), fragment.typeCondition);
  return getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    fragmentType,
    fragment.selectionSet,
  );
}

function _collectFieldsAndFragmentNames(
  context,
  parentType,
  selectionSet,
  nodeAndDefs,
  fragmentNames,
) {
  for (const selection of selectionSet.selections) {
    switch (selection.kind) {
      case Kind.FIELD: {
        const fieldName = selection.name.value;
        let fieldDef;

        if (isObjectType(parentType) || isInterfaceType(parentType)) {
          fieldDef = parentType.getFields()[fieldName];
        }

        const responseName = selection.alias
          ? selection.alias.value
          : fieldName;

        if (!nodeAndDefs[responseName]) {
          nodeAndDefs[responseName] = [];
        }

        nodeAndDefs[responseName].push([parentType, selection, fieldDef]);
        break;
      }

      case Kind.FRAGMENT_SPREAD:
        fragmentNames[selection.name.value] = true;
        break;

      case Kind.INLINE_FRAGMENT: {
        const typeCondition = selection.typeCondition;
        const inlineFragmentType = typeCondition
          ? typeFromAST(context.getSchema(), typeCondition)
          : parentType;

        _collectFieldsAndFragmentNames(
          context,
          inlineFragmentType,
          selection.selectionSet,
          nodeAndDefs,
          fragmentNames,
        );

        break;
      }
    }
  }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.

function subfieldConflicts(conflicts, responseName, node1, node2) {
  if (conflicts.length > 0) {
    return [
      [responseName, conflicts.map(([reason]) => reason)],
      [node1, ...conflicts.map(([, fields1]) => fields1).flat()],
      [node2, ...conflicts.map(([, , fields2]) => fields2).flat()],
    ];
  }
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does not matter.
 */

class PairSet {
  constructor() {
    this._data = new Map();
  }

  has(a, b, areMutuallyExclusive) {
    var _this$_data$get;

    const [key1, key2] = a < b ? [a, b] : [b, a];
    const result =
      (_this$_data$get = this._data.get(key1)) === null ||
      _this$_data$get === void 0
        ? void 0
        : _this$_data$get.get(key2);

    if (result === undefined) {
      return false;
    } // areMutuallyExclusive being false is a superset of being true, hence if
    // we want to know if this PairSet "has" these two with no exclusivity,
    // we have to ensure it was added as such.

    return areMutuallyExclusive ? true : areMutuallyExclusive === result;
  }

  add(a, b, areMutuallyExclusive) {
    const [key1, key2] = a < b ? [a, b] : [b, a];

    const map = this._data.get(key1);

    if (map === undefined) {
      this._data.set(key1, new Map([[key2, areMutuallyExclusive]]));
    } else {
      map.set(key2, areMutuallyExclusive);
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/PossibleFragmentSpreadsRule.mjs






/**
 * Possible fragment spread
 *
 * A fragment spread is only valid if the type condition could ever possibly
 * be true: if there is a non-empty intersection of the possible parent types,
 * and possible types which pass the type condition.
 */
function PossibleFragmentSpreadsRule(context) {
  return {
    InlineFragment(node) {
      const fragType = context.getType();
      const parentType = context.getParentType();

      if (
        isCompositeType(fragType) &&
        isCompositeType(parentType) &&
        !doTypesOverlap(context.getSchema(), fragType, parentType)
      ) {
        const parentTypeStr = inspect(parentType);
        const fragTypeStr = inspect(fragType);
        context.reportError(
          new GraphQLError(
            `Fragment cannot be spread here as objects of type "${parentTypeStr}" can never be of type "${fragTypeStr}".`,
            {
              nodes: node,
            },
          ),
        );
      }
    },

    FragmentSpread(node) {
      const fragName = node.name.value;
      const fragType = getFragmentType(context, fragName);
      const parentType = context.getParentType();

      if (
        fragType &&
        parentType &&
        !doTypesOverlap(context.getSchema(), fragType, parentType)
      ) {
        const parentTypeStr = inspect(parentType);
        const fragTypeStr = inspect(fragType);
        context.reportError(
          new GraphQLError(
            `Fragment "${fragName}" cannot be spread here as objects of type "${parentTypeStr}" can never be of type "${fragTypeStr}".`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

function getFragmentType(context, name) {
  const frag = context.getFragment(name);

  if (frag) {
    const type = typeFromAST(context.getSchema(), frag.typeCondition);

    if (isCompositeType(type)) {
      return type;
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/PossibleTypeExtensionsRule.mjs









/**
 * Possible type extension
 *
 * A type extension is only valid if the type is defined and has the same kind.
 */
function PossibleTypeExtensionsRule(context) {
  const schema = context.getSchema();
  const definedTypes = Object.create(null);

  for (const def of context.getDocument().definitions) {
    if (isTypeDefinitionNode(def)) {
      definedTypes[def.name.value] = def;
    }
  }

  return {
    ScalarTypeExtension: checkExtension,
    ObjectTypeExtension: checkExtension,
    InterfaceTypeExtension: checkExtension,
    UnionTypeExtension: checkExtension,
    EnumTypeExtension: checkExtension,
    InputObjectTypeExtension: checkExtension,
  };

  function checkExtension(node) {
    const typeName = node.name.value;
    const defNode = definedTypes[typeName];
    const existingType =
      schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
    let expectedKind;

    if (defNode) {
      expectedKind = defKindToExtKind[defNode.kind];
    } else if (existingType) {
      expectedKind = typeToExtKind(existingType);
    }

    if (expectedKind) {
      if (expectedKind !== node.kind) {
        const kindStr = extensionKindToTypeName(node.kind);
        context.reportError(
          new GraphQLError(`Cannot extend non-${kindStr} type "${typeName}".`, {
            nodes: defNode ? [defNode, node] : node,
          }),
        );
      }
    } else {
      const allTypeNames = Object.keys({
        ...definedTypes,
        ...(schema === null || schema === void 0
          ? void 0
          : schema.getTypeMap()),
      });
      const suggestedTypes = suggestionList(typeName, allTypeNames);
      context.reportError(
        new GraphQLError(
          `Cannot extend type "${typeName}" because it is not defined.` +
            didYouMean(suggestedTypes),
          {
            nodes: node.name,
          },
        ),
      );
    }
  }
}
const defKindToExtKind = {
  [Kind.SCALAR_TYPE_DEFINITION]: Kind.SCALAR_TYPE_EXTENSION,
  [Kind.OBJECT_TYPE_DEFINITION]: Kind.OBJECT_TYPE_EXTENSION,
  [Kind.INTERFACE_TYPE_DEFINITION]: Kind.INTERFACE_TYPE_EXTENSION,
  [Kind.UNION_TYPE_DEFINITION]: Kind.UNION_TYPE_EXTENSION,
  [Kind.ENUM_TYPE_DEFINITION]: Kind.ENUM_TYPE_EXTENSION,
  [Kind.INPUT_OBJECT_TYPE_DEFINITION]: Kind.INPUT_OBJECT_TYPE_EXTENSION,
};

function typeToExtKind(type) {
  if (isScalarType(type)) {
    return Kind.SCALAR_TYPE_EXTENSION;
  }

  if (isObjectType(type)) {
    return Kind.OBJECT_TYPE_EXTENSION;
  }

  if (isInterfaceType(type)) {
    return Kind.INTERFACE_TYPE_EXTENSION;
  }

  if (isUnionType(type)) {
    return Kind.UNION_TYPE_EXTENSION;
  }

  if (isEnumType(type)) {
    return Kind.ENUM_TYPE_EXTENSION;
  }

  if (isInputObjectType(type)) {
    return Kind.INPUT_OBJECT_TYPE_EXTENSION;
  }
  /* c8 ignore next 3 */
  // Not reachable. All possible types have been considered

   false || invariant(false, 'Unexpected type: ' + inspect(type));
}

function extensionKindToTypeName(kind) {
  switch (kind) {
    case Kind.SCALAR_TYPE_EXTENSION:
      return 'scalar';

    case Kind.OBJECT_TYPE_EXTENSION:
      return 'object';

    case Kind.INTERFACE_TYPE_EXTENSION:
      return 'interface';

    case Kind.UNION_TYPE_EXTENSION:
      return 'union';

    case Kind.ENUM_TYPE_EXTENSION:
      return 'enum';

    case Kind.INPUT_OBJECT_TYPE_EXTENSION:
      return 'input object';
    // Not reachable. All possible types have been considered

    /* c8 ignore next */

    default:
       false || invariant(false, 'Unexpected kind: ' + inspect(kind));
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ProvidedRequiredArgumentsRule.mjs








/**
 * Provided required arguments
 *
 * A field or directive is only valid if all required (non-null without a
 * default value) field arguments have been provided.
 */
function ProvidedRequiredArgumentsRule(context) {
  return {
    // eslint-disable-next-line new-cap
    ...ProvidedRequiredArgumentsOnDirectivesRule(context),
    Field: {
      // Validate on leave to allow for deeper errors to appear first.
      leave(fieldNode) {
        var _fieldNode$arguments;

        const fieldDef = context.getFieldDef();

        if (!fieldDef) {
          return false;
        }

        const providedArgs = new Set( // FIXME: https://github.com/graphql/graphql-js/issues/2203
          /* c8 ignore next */
          (_fieldNode$arguments = fieldNode.arguments) === null ||
          _fieldNode$arguments === void 0
            ? void 0
            : _fieldNode$arguments.map((arg) => arg.name.value),
        );

        for (const argDef of fieldDef.args) {
          if (!providedArgs.has(argDef.name) && isRequiredArgument(argDef)) {
            const argTypeStr = inspect(argDef.type);
            context.reportError(
              new GraphQLError(
                `Field "${fieldDef.name}" argument "${argDef.name}" of type "${argTypeStr}" is required, but it was not provided.`,
                {
                  nodes: fieldNode,
                },
              ),
            );
          }
        }
      },
    },
  };
}
/**
 * @internal
 */

function ProvidedRequiredArgumentsOnDirectivesRule(context) {
  var _schema$getDirectives;

  const requiredArgsMap = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives =
    (_schema$getDirectives =
      schema === null || schema === void 0
        ? void 0
        : schema.getDirectives()) !== null && _schema$getDirectives !== void 0
      ? _schema$getDirectives
      : specifiedDirectives;

  for (const directive of definedDirectives) {
    requiredArgsMap[directive.name] = keyMap(
      directive.args.filter(isRequiredArgument),
      (arg) => arg.name,
    );
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === Kind.DIRECTIVE_DEFINITION) {
      var _def$arguments;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const argNodes =
        (_def$arguments = def.arguments) !== null && _def$arguments !== void 0
          ? _def$arguments
          : [];
      requiredArgsMap[def.name.value] = keyMap(
        argNodes.filter(isRequiredArgumentNode),
        (arg) => arg.name.value,
      );
    }
  }

  return {
    Directive: {
      // Validate on leave to allow for deeper errors to appear first.
      leave(directiveNode) {
        const directiveName = directiveNode.name.value;
        const requiredArgs = requiredArgsMap[directiveName];

        if (requiredArgs) {
          var _directiveNode$argume;

          // FIXME: https://github.com/graphql/graphql-js/issues/2203

          /* c8 ignore next */
          const argNodes =
            (_directiveNode$argume = directiveNode.arguments) !== null &&
            _directiveNode$argume !== void 0
              ? _directiveNode$argume
              : [];
          const argNodeMap = new Set(argNodes.map((arg) => arg.name.value));

          for (const [argName, argDef] of Object.entries(requiredArgs)) {
            if (!argNodeMap.has(argName)) {
              const argType = isType(argDef.type)
                ? inspect(argDef.type)
                : print(argDef.type);
              context.reportError(
                new GraphQLError(
                  `Directive "@${directiveName}" argument "${argName}" of type "${argType}" is required, but it was not provided.`,
                  {
                    nodes: directiveNode,
                  },
                ),
              );
            }
          }
        }
      },
    },
  };
}

function isRequiredArgumentNode(arg) {
  return arg.type.kind === Kind.NON_NULL_TYPE && arg.defaultValue == null;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ScalarLeafsRule.mjs




/**
 * Scalar leafs
 *
 * A GraphQL document is valid only if all leaf fields (fields without
 * sub selections) are of scalar or enum types.
 */
function ScalarLeafsRule(context) {
  return {
    Field(node) {
      const type = context.getType();
      const selectionSet = node.selectionSet;

      if (type) {
        if (isLeafType(getNamedType(type))) {
          if (selectionSet) {
            const fieldName = node.name.value;
            const typeStr = inspect(type);
            context.reportError(
              new GraphQLError(
                `Field "${fieldName}" must not have a selection since type "${typeStr}" has no subfields.`,
                {
                  nodes: selectionSet,
                },
              ),
            );
          }
        } else if (!selectionSet) {
          const fieldName = node.name.value;
          const typeStr = inspect(type);
          context.reportError(
            new GraphQLError(
              `Field "${fieldName}" of type "${typeStr}" must have a selection of subfields. Did you mean "${fieldName} { ... }"?`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/printPathArray.mjs
/**
 * Build a string describing the path.
 */
function printPathArray(path) {
  return path
    .map((key) =>
      typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key,
    )
    .join('');
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/Path.mjs
/**
 * Given a Path and a key, return a new Path containing the new key.
 */
function addPath(prev, key, typename) {
  return {
    prev,
    key,
    typename,
  };
}
/**
 * Given a Path, return an Array of the path keys.
 */

function pathToArray(path) {
  const flattened = [];
  let curr = path;

  while (curr) {
    flattened.push(curr.key);
    curr = curr.prev;
  }

  return flattened.reverse();
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/coerceInputValue.mjs











/**
 * Coerces a JavaScript value given a GraphQL Input Type.
 */
function coerceInputValue(inputValue, type, onError = defaultOnError) {
  return coerceInputValueImpl(inputValue, type, onError, undefined);
}

function defaultOnError(path, invalidValue, error) {
  let errorPrefix = 'Invalid value ' + inspect(invalidValue);

  if (path.length > 0) {
    errorPrefix += ` at "value${printPathArray(path)}"`;
  }

  error.message = errorPrefix + ': ' + error.message;
  throw error;
}

function coerceInputValueImpl(inputValue, type, onError, path) {
  if (isNonNullType(type)) {
    if (inputValue != null) {
      return coerceInputValueImpl(inputValue, type.ofType, onError, path);
    }

    onError(
      pathToArray(path),
      inputValue,
      new GraphQLError(
        `Expected non-nullable type "${inspect(type)}" not to be null.`,
      ),
    );
    return;
  }

  if (inputValue == null) {
    // Explicitly return the value null.
    return null;
  }

  if (isListType(type)) {
    const itemType = type.ofType;

    if (isIterableObject(inputValue)) {
      return Array.from(inputValue, (itemValue, index) => {
        const itemPath = addPath(path, index, undefined);
        return coerceInputValueImpl(itemValue, itemType, onError, itemPath);
      });
    } // Lists accept a non-list value as a list of one.

    return [coerceInputValueImpl(inputValue, itemType, onError, path)];
  }

  if (isInputObjectType(type)) {
    if (!isObjectLike(inputValue)) {
      onError(
        pathToArray(path),
        inputValue,
        new GraphQLError(`Expected type "${type.name}" to be an object.`),
      );
      return;
    }

    const coercedValue = {};
    const fieldDefs = type.getFields();

    for (const field of Object.values(fieldDefs)) {
      const fieldValue = inputValue[field.name];

      if (fieldValue === undefined) {
        if (field.defaultValue !== undefined) {
          coercedValue[field.name] = field.defaultValue;
        } else if (isNonNullType(field.type)) {
          const typeStr = inspect(field.type);
          onError(
            pathToArray(path),
            inputValue,
            new GraphQLError(
              `Field "${field.name}" of required type "${typeStr}" was not provided.`,
            ),
          );
        }

        continue;
      }

      coercedValue[field.name] = coerceInputValueImpl(
        fieldValue,
        field.type,
        onError,
        addPath(path, field.name, type.name),
      );
    } // Ensure every provided field is defined.

    for (const fieldName of Object.keys(inputValue)) {
      if (!fieldDefs[fieldName]) {
        const suggestions = suggestionList(
          fieldName,
          Object.keys(type.getFields()),
        );
        onError(
          pathToArray(path),
          inputValue,
          new GraphQLError(
            `Field "${fieldName}" is not defined by type "${type.name}".` +
              didYouMean(suggestions),
          ),
        );
      }
    }

    return coercedValue;
  }

  if (isLeafType(type)) {
    let parseResult; // Scalars and Enums determine if a input value is valid via parseValue(),
    // which can throw to indicate failure. If it throws, maintain a reference
    // to the original error.

    try {
      parseResult = type.parseValue(inputValue);
    } catch (error) {
      if (error instanceof GraphQLError) {
        onError(pathToArray(path), inputValue, error);
      } else {
        onError(
          pathToArray(path),
          inputValue,
          new GraphQLError(`Expected type "${type.name}". ` + error.message, {
            originalError: error,
          }),
        );
      }

      return;
    }

    if (parseResult === undefined) {
      onError(
        pathToArray(path),
        inputValue,
        new GraphQLError(`Expected type "${type.name}".`),
      );
    }

    return parseResult;
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || invariant(false, 'Unexpected input type: ' + inspect(type));
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/valueFromAST.mjs





/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * GraphQL Value literals.
 *
 * Returns `undefined` when the value could not be validly coerced according to
 * the provided type.
 *
 * | GraphQL Value        | JSON Value    |
 * | -------------------- | ------------- |
 * | Input Object         | Object        |
 * | List                 | Array         |
 * | Boolean              | Boolean       |
 * | String               | String        |
 * | Int / Float          | Number        |
 * | Enum Value           | Unknown       |
 * | NullValue            | null          |
 *
 */

function valueFromAST(valueNode, type, variables) {
  if (!valueNode) {
    // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
  }

  if (valueNode.kind === Kind.VARIABLE) {
    const variableName = valueNode.name.value;

    if (variables == null || variables[variableName] === undefined) {
      // No valid return value.
      return;
    }

    const variableValue = variables[variableName];

    if (variableValue === null && isNonNullType(type)) {
      return; // Invalid: intentionally return no value.
    } // Note: This does no further checking that this variable is correct.
    // This assumes that this query has been validated and the variable
    // usage here is of the correct type.

    return variableValue;
  }

  if (isNonNullType(type)) {
    if (valueNode.kind === Kind.NULL) {
      return; // Invalid: intentionally return no value.
    }

    return valueFromAST(valueNode, type.ofType, variables);
  }

  if (valueNode.kind === Kind.NULL) {
    // This is explicitly returning the value null.
    return null;
  }

  if (isListType(type)) {
    const itemType = type.ofType;

    if (valueNode.kind === Kind.LIST) {
      const coercedValues = [];

      for (const itemNode of valueNode.values) {
        if (isMissingVariable(itemNode, variables)) {
          // If an array contains a missing variable, it is either coerced to
          // null or if the item type is non-null, it considered invalid.
          if (isNonNullType(itemType)) {
            return; // Invalid: intentionally return no value.
          }

          coercedValues.push(null);
        } else {
          const itemValue = valueFromAST(itemNode, itemType, variables);

          if (itemValue === undefined) {
            return; // Invalid: intentionally return no value.
          }

          coercedValues.push(itemValue);
        }
      }

      return coercedValues;
    }

    const coercedValue = valueFromAST(valueNode, itemType, variables);

    if (coercedValue === undefined) {
      return; // Invalid: intentionally return no value.
    }

    return [coercedValue];
  }

  if (isInputObjectType(type)) {
    if (valueNode.kind !== Kind.OBJECT) {
      return; // Invalid: intentionally return no value.
    }

    const coercedObj = Object.create(null);
    const fieldNodes = keyMap(valueNode.fields, (field) => field.name.value);

    for (const field of Object.values(type.getFields())) {
      const fieldNode = fieldNodes[field.name];

      if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
        if (field.defaultValue !== undefined) {
          coercedObj[field.name] = field.defaultValue;
        } else if (isNonNullType(field.type)) {
          return; // Invalid: intentionally return no value.
        }

        continue;
      }

      const fieldValue = valueFromAST(fieldNode.value, field.type, variables);

      if (fieldValue === undefined) {
        return; // Invalid: intentionally return no value.
      }

      coercedObj[field.name] = fieldValue;
    }

    return coercedObj;
  }

  if (isLeafType(type)) {
    // Scalars and Enums fulfill parsing a literal value via parseLiteral().
    // Invalid values represent a failure to parse correctly, in which case
    // no value is returned.
    let result;

    try {
      result = type.parseLiteral(valueNode, variables);
    } catch (_error) {
      return; // Invalid: intentionally return no value.
    }

    if (result === undefined) {
      return; // Invalid: intentionally return no value.
    }

    return result;
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible input types have been considered.

   false || invariant(false, 'Unexpected input type: ' + inspect(type));
} // Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.

function isMissingVariable(valueNode, variables) {
  return (
    valueNode.kind === Kind.VARIABLE &&
    (variables == null || variables[valueNode.name.value] === undefined)
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/values.mjs











/**
 * Prepares an object map of variableValues of the correct type based on the
 * provided variable definitions and arbitrary input. If the input cannot be
 * parsed to match the variable definitions, a GraphQLError will be thrown.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */
function getVariableValues(schema, varDefNodes, inputs, options) {
  const errors = [];
  const maxErrors =
    options === null || options === void 0 ? void 0 : options.maxErrors;

  try {
    const coerced = coerceVariableValues(
      schema,
      varDefNodes,
      inputs,
      (error) => {
        if (maxErrors != null && errors.length >= maxErrors) {
          throw new GraphQLError(
            'Too many errors processing variables, error limit reached. Execution aborted.',
          );
        }

        errors.push(error);
      },
    );

    if (errors.length === 0) {
      return {
        coerced,
      };
    }
  } catch (error) {
    errors.push(error);
  }

  return {
    errors,
  };
}

function coerceVariableValues(schema, varDefNodes, inputs, onError) {
  const coercedValues = {};

  for (const varDefNode of varDefNodes) {
    const varName = varDefNode.variable.name.value;
    const varType = typeFromAST(schema, varDefNode.type);

    if (!isInputType(varType)) {
      // Must use input types for variables. This should be caught during
      // validation, however is checked again here for safety.
      const varTypeStr = print(varDefNode.type);
      onError(
        new GraphQLError(
          `Variable "$${varName}" expected value of type "${varTypeStr}" which cannot be used as an input type.`,
          {
            nodes: varDefNode.type,
          },
        ),
      );
      continue;
    }

    if (!values_hasOwnProperty(inputs, varName)) {
      if (varDefNode.defaultValue) {
        coercedValues[varName] = valueFromAST(varDefNode.defaultValue, varType);
      } else if (isNonNullType(varType)) {
        const varTypeStr = inspect(varType);
        onError(
          new GraphQLError(
            `Variable "$${varName}" of required type "${varTypeStr}" was not provided.`,
            {
              nodes: varDefNode,
            },
          ),
        );
      }

      continue;
    }

    const value = inputs[varName];

    if (value === null && isNonNullType(varType)) {
      const varTypeStr = inspect(varType);
      onError(
        new GraphQLError(
          `Variable "$${varName}" of non-null type "${varTypeStr}" must not be null.`,
          {
            nodes: varDefNode,
          },
        ),
      );
      continue;
    }

    coercedValues[varName] = coerceInputValue(
      value,
      varType,
      (path, invalidValue, error) => {
        let prefix =
          `Variable "$${varName}" got invalid value ` + inspect(invalidValue);

        if (path.length > 0) {
          prefix += ` at "${varName}${printPathArray(path)}"`;
        }

        onError(
          new GraphQLError(prefix + '; ' + error.message, {
            nodes: varDefNode,
            originalError: error,
          }),
        );
      },
    );
  }

  return coercedValues;
}
/**
 * Prepares an object map of argument values given a list of argument
 * definitions and list of argument AST nodes.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */

function getArgumentValues(def, node, variableValues) {
  var _node$arguments;

  const coercedValues = {}; // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */

  const argumentNodes =
    (_node$arguments = node.arguments) !== null && _node$arguments !== void 0
      ? _node$arguments
      : [];
  const argNodeMap = keyMap(argumentNodes, (arg) => arg.name.value);

  for (const argDef of def.args) {
    const name = argDef.name;
    const argType = argDef.type;
    const argumentNode = argNodeMap[name];

    if (!argumentNode) {
      if (argDef.defaultValue !== undefined) {
        coercedValues[name] = argDef.defaultValue;
      } else if (isNonNullType(argType)) {
        throw new GraphQLError(
          `Argument "${name}" of required type "${inspect(argType)}" ` +
            'was not provided.',
          {
            nodes: node,
          },
        );
      }

      continue;
    }

    const valueNode = argumentNode.value;
    let isNull = valueNode.kind === Kind.NULL;

    if (valueNode.kind === Kind.VARIABLE) {
      const variableName = valueNode.name.value;

      if (
        variableValues == null ||
        !values_hasOwnProperty(variableValues, variableName)
      ) {
        if (argDef.defaultValue !== undefined) {
          coercedValues[name] = argDef.defaultValue;
        } else if (isNonNullType(argType)) {
          throw new GraphQLError(
            `Argument "${name}" of required type "${inspect(argType)}" ` +
              `was provided the variable "$${variableName}" which was not provided a runtime value.`,
            {
              nodes: valueNode,
            },
          );
        }

        continue;
      }

      isNull = variableValues[variableName] == null;
    }

    if (isNull && isNonNullType(argType)) {
      throw new GraphQLError(
        `Argument "${name}" of non-null type "${inspect(argType)}" ` +
          'must not be null.',
        {
          nodes: valueNode,
        },
      );
    }

    const coercedValue = valueFromAST(valueNode, argType, variableValues);

    if (coercedValue === undefined) {
      // Note: ValuesOfCorrectTypeRule validation should catch this before
      // execution. This is a runtime check to ensure execution does not
      // continue with an invalid argument value.
      throw new GraphQLError(
        `Argument "${name}" has invalid value ${print(valueNode)}.`,
        {
          nodes: valueNode,
        },
      );
    }

    coercedValues[name] = coercedValue;
  }

  return coercedValues;
}
/**
 * Prepares an object map of argument values given a directive definition
 * and a AST node which may contain directives. Optionally also accepts a map
 * of variable values.
 *
 * If the directive does not exist on the node, returns undefined.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */

function getDirectiveValues(directiveDef, node, variableValues) {
  var _node$directives;

  const directiveNode =
    (_node$directives = node.directives) === null || _node$directives === void 0
      ? void 0
      : _node$directives.find(
          (directive) => directive.name.value === directiveDef.name,
        );

  if (directiveNode) {
    return getArgumentValues(directiveDef, directiveNode, variableValues);
  }
}

function values_hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/collectFields.mjs





/**
 * Given a selectionSet, collects all of the fields and returns them.
 *
 * CollectFields requires the "runtime type" of an object. For a field that
 * returns an Interface or Union type, the "runtime type" will be the actual
 * object type returned by that field.
 *
 * @internal
 */

function collectFields(
  schema,
  fragments,
  variableValues,
  runtimeType,
  selectionSet,
) {
  const fields = new Map();
  collectFieldsImpl(
    schema,
    fragments,
    variableValues,
    runtimeType,
    selectionSet,
    fields,
    new Set(),
  );
  return fields;
}
/**
 * Given an array of field nodes, collects all of the subfields of the passed
 * in fields, and returns them at the end.
 *
 * CollectSubFields requires the "return type" of an object. For a field that
 * returns an Interface or Union type, the "return type" will be the actual
 * object type returned by that field.
 *
 * @internal
 */

function collectSubfields(
  schema,
  fragments,
  variableValues,
  returnType,
  fieldNodes,
) {
  const subFieldNodes = new Map();
  const visitedFragmentNames = new Set();

  for (const node of fieldNodes) {
    if (node.selectionSet) {
      collectFieldsImpl(
        schema,
        fragments,
        variableValues,
        returnType,
        node.selectionSet,
        subFieldNodes,
        visitedFragmentNames,
      );
    }
  }

  return subFieldNodes;
}

function collectFieldsImpl(
  schema,
  fragments,
  variableValues,
  runtimeType,
  selectionSet,
  fields,
  visitedFragmentNames,
) {
  for (const selection of selectionSet.selections) {
    switch (selection.kind) {
      case Kind.FIELD: {
        if (!shouldIncludeNode(variableValues, selection)) {
          continue;
        }

        const name = getFieldEntryKey(selection);
        const fieldList = fields.get(name);

        if (fieldList !== undefined) {
          fieldList.push(selection);
        } else {
          fields.set(name, [selection]);
        }

        break;
      }

      case Kind.INLINE_FRAGMENT: {
        if (
          !shouldIncludeNode(variableValues, selection) ||
          !doesFragmentConditionMatch(schema, selection, runtimeType)
        ) {
          continue;
        }

        collectFieldsImpl(
          schema,
          fragments,
          variableValues,
          runtimeType,
          selection.selectionSet,
          fields,
          visitedFragmentNames,
        );
        break;
      }

      case Kind.FRAGMENT_SPREAD: {
        const fragName = selection.name.value;

        if (
          visitedFragmentNames.has(fragName) ||
          !shouldIncludeNode(variableValues, selection)
        ) {
          continue;
        }

        visitedFragmentNames.add(fragName);
        const fragment = fragments[fragName];

        if (
          !fragment ||
          !doesFragmentConditionMatch(schema, fragment, runtimeType)
        ) {
          continue;
        }

        collectFieldsImpl(
          schema,
          fragments,
          variableValues,
          runtimeType,
          fragment.selectionSet,
          fields,
          visitedFragmentNames,
        );
        break;
      }
    }
  }
}
/**
 * Determines if a field should be included based on the `@include` and `@skip`
 * directives, where `@skip` has higher precedence than `@include`.
 */

function shouldIncludeNode(variableValues, node) {
  const skip = getDirectiveValues(GraphQLSkipDirective, node, variableValues);

  if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) {
    return false;
  }

  const include = getDirectiveValues(
    GraphQLIncludeDirective,
    node,
    variableValues,
  );

  if (
    (include === null || include === void 0 ? void 0 : include.if) === false
  ) {
    return false;
  }

  return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */

function doesFragmentConditionMatch(schema, fragment, type) {
  const typeConditionNode = fragment.typeCondition;

  if (!typeConditionNode) {
    return true;
  }

  const conditionalType = typeFromAST(schema, typeConditionNode);

  if (conditionalType === type) {
    return true;
  }

  if (isAbstractType(conditionalType)) {
    return schema.isSubType(conditionalType, type);
  }

  return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */

function getFieldEntryKey(node) {
  return node.alias ? node.alias.value : node.name.value;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/SingleFieldSubscriptionsRule.mjs




/**
 * Subscriptions must only include a non-introspection field.
 *
 * A GraphQL subscription is valid only if it contains a single root field and
 * that root field is not an introspection field.
 *
 * See https://spec.graphql.org/draft/#sec-Single-root-field
 */
function SingleFieldSubscriptionsRule(context) {
  return {
    OperationDefinition(node) {
      if (node.operation === 'subscription') {
        const schema = context.getSchema();
        const subscriptionType = schema.getSubscriptionType();

        if (subscriptionType) {
          const operationName = node.name ? node.name.value : null;
          const variableValues = Object.create(null);
          const document = context.getDocument();
          const fragments = Object.create(null);

          for (const definition of document.definitions) {
            if (definition.kind === Kind.FRAGMENT_DEFINITION) {
              fragments[definition.name.value] = definition;
            }
          }

          const fields = collectFields(
            schema,
            fragments,
            variableValues,
            subscriptionType,
            node.selectionSet,
          );

          if (fields.size > 1) {
            const fieldSelectionLists = [...fields.values()];
            const extraFieldSelectionLists = fieldSelectionLists.slice(1);
            const extraFieldSelections = extraFieldSelectionLists.flat();
            context.reportError(
              new GraphQLError(
                operationName != null
                  ? `Subscription "${operationName}" must select only one top level field.`
                  : 'Anonymous Subscription must select only one top level field.',
                {
                  nodes: extraFieldSelections,
                },
              ),
            );
          }

          for (const fieldNodes of fields.values()) {
            const field = fieldNodes[0];
            const fieldName = field.name.value;

            if (fieldName.startsWith('__')) {
              context.reportError(
                new GraphQLError(
                  operationName != null
                    ? `Subscription "${operationName}" must not select an introspection top level field.`
                    : 'Anonymous Subscription must not select an introspection top level field.',
                  {
                    nodes: fieldNodes,
                  },
                ),
              );
            }
          }
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/groupBy.mjs
/**
 * Groups array items into a Map, given a function to produce grouping key.
 */
function groupBy(list, keyFn) {
  const result = new Map();

  for (const item of list) {
    const key = keyFn(item);
    const group = result.get(key);

    if (group === undefined) {
      result.set(key, [item]);
    } else {
      group.push(item);
    }
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueArgumentDefinitionNamesRule.mjs



/**
 * Unique argument definition names
 *
 * A GraphQL Object or Interface type is only valid if all its fields have uniquely named arguments.
 * A GraphQL Directive is only valid if all its arguments are uniquely named.
 */
function UniqueArgumentDefinitionNamesRule(context) {
  return {
    DirectiveDefinition(directiveNode) {
      var _directiveNode$argume;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const argumentNodes =
        (_directiveNode$argume = directiveNode.arguments) !== null &&
        _directiveNode$argume !== void 0
          ? _directiveNode$argume
          : [];
      return checkArgUniqueness(`@${directiveNode.name.value}`, argumentNodes);
    },

    InterfaceTypeDefinition: checkArgUniquenessPerField,
    InterfaceTypeExtension: checkArgUniquenessPerField,
    ObjectTypeDefinition: checkArgUniquenessPerField,
    ObjectTypeExtension: checkArgUniquenessPerField,
  };

  function checkArgUniquenessPerField(typeNode) {
    var _typeNode$fields;

    const typeName = typeNode.name.value; // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */

    const fieldNodes =
      (_typeNode$fields = typeNode.fields) !== null &&
      _typeNode$fields !== void 0
        ? _typeNode$fields
        : [];

    for (const fieldDef of fieldNodes) {
      var _fieldDef$arguments;

      const fieldName = fieldDef.name.value; // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */

      const argumentNodes =
        (_fieldDef$arguments = fieldDef.arguments) !== null &&
        _fieldDef$arguments !== void 0
          ? _fieldDef$arguments
          : [];
      checkArgUniqueness(`${typeName}.${fieldName}`, argumentNodes);
    }

    return false;
  }

  function checkArgUniqueness(parentName, argumentNodes) {
    const seenArgs = groupBy(argumentNodes, (arg) => arg.name.value);

    for (const [argName, argNodes] of seenArgs) {
      if (argNodes.length > 1) {
        context.reportError(
          new GraphQLError(
            `Argument "${parentName}(${argName}:)" can only be defined once.`,
            {
              nodes: argNodes.map((node) => node.name),
            },
          ),
        );
      }
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueArgumentNamesRule.mjs



/**
 * Unique argument names
 *
 * A GraphQL field or directive is only valid if all supplied arguments are
 * uniquely named.
 *
 * See https://spec.graphql.org/draft/#sec-Argument-Names
 */
function UniqueArgumentNamesRule(context) {
  return {
    Field: checkArgUniqueness,
    Directive: checkArgUniqueness,
  };

  function checkArgUniqueness(parentNode) {
    var _parentNode$arguments;

    // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */
    const argumentNodes =
      (_parentNode$arguments = parentNode.arguments) !== null &&
      _parentNode$arguments !== void 0
        ? _parentNode$arguments
        : [];
    const seenArgs = groupBy(argumentNodes, (arg) => arg.name.value);

    for (const [argName, argNodes] of seenArgs) {
      if (argNodes.length > 1) {
        context.reportError(
          new GraphQLError(
            `There can be only one argument named "${argName}".`,
            {
              nodes: argNodes.map((node) => node.name),
            },
          ),
        );
      }
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueDirectiveNamesRule.mjs


/**
 * Unique directive names
 *
 * A GraphQL document is only valid if all defined directives have unique names.
 */
function UniqueDirectiveNamesRule(context) {
  const knownDirectiveNames = Object.create(null);
  const schema = context.getSchema();
  return {
    DirectiveDefinition(node) {
      const directiveName = node.name.value;

      if (
        schema !== null &&
        schema !== void 0 &&
        schema.getDirective(directiveName)
      ) {
        context.reportError(
          new GraphQLError(
            `Directive "@${directiveName}" already exists in the schema. It cannot be redefined.`,
            {
              nodes: node.name,
            },
          ),
        );
        return;
      }

      if (knownDirectiveNames[directiveName]) {
        context.reportError(
          new GraphQLError(
            `There can be only one directive named "@${directiveName}".`,
            {
              nodes: [knownDirectiveNames[directiveName], node.name],
            },
          ),
        );
      } else {
        knownDirectiveNames[directiveName] = node.name;
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueDirectivesPerLocationRule.mjs





/**
 * Unique directive names per location
 *
 * A GraphQL document is only valid if all non-repeatable directives at
 * a given location are uniquely named.
 *
 * See https://spec.graphql.org/draft/#sec-Directives-Are-Unique-Per-Location
 */
function UniqueDirectivesPerLocationRule(context) {
  const uniqueDirectiveMap = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives = schema
    ? schema.getDirectives()
    : specifiedDirectives;

  for (const directive of definedDirectives) {
    uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === Kind.DIRECTIVE_DEFINITION) {
      uniqueDirectiveMap[def.name.value] = !def.repeatable;
    }
  }

  const schemaDirectives = Object.create(null);
  const typeDirectivesMap = Object.create(null);
  return {
    // Many different AST nodes may contain directives. Rather than listing
    // them all, just listen for entering any node, and check to see if it
    // defines any directives.
    enter(node) {
      if (!('directives' in node) || !node.directives) {
        return;
      }

      let seenDirectives;

      if (
        node.kind === Kind.SCHEMA_DEFINITION ||
        node.kind === Kind.SCHEMA_EXTENSION
      ) {
        seenDirectives = schemaDirectives;
      } else if (isTypeDefinitionNode(node) || isTypeExtensionNode(node)) {
        const typeName = node.name.value;
        seenDirectives = typeDirectivesMap[typeName];

        if (seenDirectives === undefined) {
          typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
        }
      } else {
        seenDirectives = Object.create(null);
      }

      for (const directive of node.directives) {
        const directiveName = directive.name.value;

        if (uniqueDirectiveMap[directiveName]) {
          if (seenDirectives[directiveName]) {
            context.reportError(
              new GraphQLError(
                `The directive "@${directiveName}" can only be used once at this location.`,
                {
                  nodes: [seenDirectives[directiveName], directive],
                },
              ),
            );
          } else {
            seenDirectives[directiveName] = directive;
          }
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueEnumValueNamesRule.mjs



/**
 * Unique enum value names
 *
 * A GraphQL enum type is only valid if all its values are uniquely named.
 */
function UniqueEnumValueNamesRule(context) {
  const schema = context.getSchema();
  const existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
  const knownValueNames = Object.create(null);
  return {
    EnumTypeDefinition: checkValueUniqueness,
    EnumTypeExtension: checkValueUniqueness,
  };

  function checkValueUniqueness(node) {
    var _node$values;

    const typeName = node.name.value;

    if (!knownValueNames[typeName]) {
      knownValueNames[typeName] = Object.create(null);
    } // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */

    const valueNodes =
      (_node$values = node.values) !== null && _node$values !== void 0
        ? _node$values
        : [];
    const valueNames = knownValueNames[typeName];

    for (const valueDef of valueNodes) {
      const valueName = valueDef.name.value;
      const existingType = existingTypeMap[typeName];

      if (isEnumType(existingType) && existingType.getValue(valueName)) {
        context.reportError(
          new GraphQLError(
            `Enum value "${typeName}.${valueName}" already exists in the schema. It cannot also be defined in this type extension.`,
            {
              nodes: valueDef.name,
            },
          ),
        );
      } else if (valueNames[valueName]) {
        context.reportError(
          new GraphQLError(
            `Enum value "${typeName}.${valueName}" can only be defined once.`,
            {
              nodes: [valueNames[valueName], valueDef.name],
            },
          ),
        );
      } else {
        valueNames[valueName] = valueDef.name;
      }
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueFieldDefinitionNamesRule.mjs



/**
 * Unique field definition names
 *
 * A GraphQL complex type is only valid if all its fields are uniquely named.
 */
function UniqueFieldDefinitionNamesRule(context) {
  const schema = context.getSchema();
  const existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
  const knownFieldNames = Object.create(null);
  return {
    InputObjectTypeDefinition: checkFieldUniqueness,
    InputObjectTypeExtension: checkFieldUniqueness,
    InterfaceTypeDefinition: checkFieldUniqueness,
    InterfaceTypeExtension: checkFieldUniqueness,
    ObjectTypeDefinition: checkFieldUniqueness,
    ObjectTypeExtension: checkFieldUniqueness,
  };

  function checkFieldUniqueness(node) {
    var _node$fields;

    const typeName = node.name.value;

    if (!knownFieldNames[typeName]) {
      knownFieldNames[typeName] = Object.create(null);
    } // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */

    const fieldNodes =
      (_node$fields = node.fields) !== null && _node$fields !== void 0
        ? _node$fields
        : [];
    const fieldNames = knownFieldNames[typeName];

    for (const fieldDef of fieldNodes) {
      const fieldName = fieldDef.name.value;

      if (hasField(existingTypeMap[typeName], fieldName)) {
        context.reportError(
          new GraphQLError(
            `Field "${typeName}.${fieldName}" already exists in the schema. It cannot also be defined in this type extension.`,
            {
              nodes: fieldDef.name,
            },
          ),
        );
      } else if (fieldNames[fieldName]) {
        context.reportError(
          new GraphQLError(
            `Field "${typeName}.${fieldName}" can only be defined once.`,
            {
              nodes: [fieldNames[fieldName], fieldDef.name],
            },
          ),
        );
      } else {
        fieldNames[fieldName] = fieldDef.name;
      }
    }

    return false;
  }
}

function hasField(type, fieldName) {
  if (isObjectType(type) || isInterfaceType(type) || isInputObjectType(type)) {
    return type.getFields()[fieldName] != null;
  }

  return false;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueFragmentNamesRule.mjs


/**
 * Unique fragment names
 *
 * A GraphQL document is only valid if all defined fragments have unique names.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-Name-Uniqueness
 */
function UniqueFragmentNamesRule(context) {
  const knownFragmentNames = Object.create(null);
  return {
    OperationDefinition: () => false,

    FragmentDefinition(node) {
      const fragmentName = node.name.value;

      if (knownFragmentNames[fragmentName]) {
        context.reportError(
          new GraphQLError(
            `There can be only one fragment named "${fragmentName}".`,
            {
              nodes: [knownFragmentNames[fragmentName], node.name],
            },
          ),
        );
      } else {
        knownFragmentNames[fragmentName] = node.name;
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueInputFieldNamesRule.mjs



/**
 * Unique input field names
 *
 * A GraphQL input object value is only valid if all supplied fields are
 * uniquely named.
 *
 * See https://spec.graphql.org/draft/#sec-Input-Object-Field-Uniqueness
 */
function UniqueInputFieldNamesRule(context) {
  const knownNameStack = [];
  let knownNames = Object.create(null);
  return {
    ObjectValue: {
      enter() {
        knownNameStack.push(knownNames);
        knownNames = Object.create(null);
      },

      leave() {
        const prevKnownNames = knownNameStack.pop();
        prevKnownNames || invariant(false);
        knownNames = prevKnownNames;
      },
    },

    ObjectField(node) {
      const fieldName = node.name.value;

      if (knownNames[fieldName]) {
        context.reportError(
          new GraphQLError(
            `There can be only one input field named "${fieldName}".`,
            {
              nodes: [knownNames[fieldName], node.name],
            },
          ),
        );
      } else {
        knownNames[fieldName] = node.name;
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueOperationNamesRule.mjs


/**
 * Unique operation names
 *
 * A GraphQL document is only valid if all defined operations have unique names.
 *
 * See https://spec.graphql.org/draft/#sec-Operation-Name-Uniqueness
 */
function UniqueOperationNamesRule(context) {
  const knownOperationNames = Object.create(null);
  return {
    OperationDefinition(node) {
      const operationName = node.name;

      if (operationName) {
        if (knownOperationNames[operationName.value]) {
          context.reportError(
            new GraphQLError(
              `There can be only one operation named "${operationName.value}".`,
              {
                nodes: [
                  knownOperationNames[operationName.value],
                  operationName,
                ],
              },
            ),
          );
        } else {
          knownOperationNames[operationName.value] = operationName;
        }
      }

      return false;
    },

    FragmentDefinition: () => false,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueOperationTypesRule.mjs


/**
 * Unique operation types
 *
 * A GraphQL document is only valid if it has only one type per operation.
 */
function UniqueOperationTypesRule(context) {
  const schema = context.getSchema();
  const definedOperationTypes = Object.create(null);
  const existingOperationTypes = schema
    ? {
        query: schema.getQueryType(),
        mutation: schema.getMutationType(),
        subscription: schema.getSubscriptionType(),
      }
    : {};
  return {
    SchemaDefinition: checkOperationTypes,
    SchemaExtension: checkOperationTypes,
  };

  function checkOperationTypes(node) {
    var _node$operationTypes;

    // See: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */
    const operationTypesNodes =
      (_node$operationTypes = node.operationTypes) !== null &&
      _node$operationTypes !== void 0
        ? _node$operationTypes
        : [];

    for (const operationType of operationTypesNodes) {
      const operation = operationType.operation;
      const alreadyDefinedOperationType = definedOperationTypes[operation];

      if (existingOperationTypes[operation]) {
        context.reportError(
          new GraphQLError(
            `Type for ${operation} already defined in the schema. It cannot be redefined.`,
            {
              nodes: operationType,
            },
          ),
        );
      } else if (alreadyDefinedOperationType) {
        context.reportError(
          new GraphQLError(
            `There can be only one ${operation} type in schema.`,
            {
              nodes: [alreadyDefinedOperationType, operationType],
            },
          ),
        );
      } else {
        definedOperationTypes[operation] = operationType;
      }
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueTypeNamesRule.mjs


/**
 * Unique type names
 *
 * A GraphQL document is only valid if all defined types have unique names.
 */
function UniqueTypeNamesRule(context) {
  const knownTypeNames = Object.create(null);
  const schema = context.getSchema();
  return {
    ScalarTypeDefinition: checkTypeName,
    ObjectTypeDefinition: checkTypeName,
    InterfaceTypeDefinition: checkTypeName,
    UnionTypeDefinition: checkTypeName,
    EnumTypeDefinition: checkTypeName,
    InputObjectTypeDefinition: checkTypeName,
  };

  function checkTypeName(node) {
    const typeName = node.name.value;

    if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
      context.reportError(
        new GraphQLError(
          `Type "${typeName}" already exists in the schema. It cannot also be defined in this type definition.`,
          {
            nodes: node.name,
          },
        ),
      );
      return;
    }

    if (knownTypeNames[typeName]) {
      context.reportError(
        new GraphQLError(`There can be only one type named "${typeName}".`, {
          nodes: [knownTypeNames[typeName], node.name],
        }),
      );
    } else {
      knownTypeNames[typeName] = node.name;
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueVariableNamesRule.mjs



/**
 * Unique variable names
 *
 * A GraphQL operation is only valid if all its variables are uniquely named.
 */
function UniqueVariableNamesRule(context) {
  return {
    OperationDefinition(operationNode) {
      var _operationNode$variab;

      // See: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const variableDefinitions =
        (_operationNode$variab = operationNode.variableDefinitions) !== null &&
        _operationNode$variab !== void 0
          ? _operationNode$variab
          : [];
      const seenVariableDefinitions = groupBy(
        variableDefinitions,
        (node) => node.variable.name.value,
      );

      for (const [variableName, variableNodes] of seenVariableDefinitions) {
        if (variableNodes.length > 1) {
          context.reportError(
            new GraphQLError(
              `There can be only one variable named "$${variableName}".`,
              {
                nodes: variableNodes.map((node) => node.variable.name),
              },
            ),
          );
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ValuesOfCorrectTypeRule.mjs








/**
 * Value literals of correct type
 *
 * A GraphQL document is only valid if all value literals are of the type
 * expected at their position.
 *
 * See https://spec.graphql.org/draft/#sec-Values-of-Correct-Type
 */
function ValuesOfCorrectTypeRule(context) {
  return {
    ListValue(node) {
      // Note: TypeInfo will traverse into a list's item type, so look to the
      // parent input type to check if it is a list.
      const type = getNullableType(context.getParentInputType());

      if (!isListType(type)) {
        isValidValueNode(context, node);
        return false; // Don't traverse further.
      }
    },

    ObjectValue(node) {
      const type = getNamedType(context.getInputType());

      if (!isInputObjectType(type)) {
        isValidValueNode(context, node);
        return false; // Don't traverse further.
      } // Ensure every required field exists.

      const fieldNodeMap = keyMap(node.fields, (field) => field.name.value);

      for (const fieldDef of Object.values(type.getFields())) {
        const fieldNode = fieldNodeMap[fieldDef.name];

        if (!fieldNode && isRequiredInputField(fieldDef)) {
          const typeStr = inspect(fieldDef.type);
          context.reportError(
            new GraphQLError(
              `Field "${type.name}.${fieldDef.name}" of required type "${typeStr}" was not provided.`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },

    ObjectField(node) {
      const parentType = getNamedType(context.getParentInputType());
      const fieldType = context.getInputType();

      if (!fieldType && isInputObjectType(parentType)) {
        const suggestions = suggestionList(
          node.name.value,
          Object.keys(parentType.getFields()),
        );
        context.reportError(
          new GraphQLError(
            `Field "${node.name.value}" is not defined by type "${parentType.name}".` +
              didYouMean(suggestions),
            {
              nodes: node,
            },
          ),
        );
      }
    },

    NullValue(node) {
      const type = context.getInputType();

      if (isNonNullType(type)) {
        context.reportError(
          new GraphQLError(
            `Expected value of type "${inspect(type)}", found ${print(node)}.`,
            {
              nodes: node,
            },
          ),
        );
      }
    },

    EnumValue: (node) => isValidValueNode(context, node),
    IntValue: (node) => isValidValueNode(context, node),
    FloatValue: (node) => isValidValueNode(context, node),
    StringValue: (node) => isValidValueNode(context, node),
    BooleanValue: (node) => isValidValueNode(context, node),
  };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */

function isValidValueNode(context, node) {
  // Report any error at the full type expected by the location.
  const locationType = context.getInputType();

  if (!locationType) {
    return;
  }

  const type = getNamedType(locationType);

  if (!isLeafType(type)) {
    const typeStr = inspect(locationType);
    context.reportError(
      new GraphQLError(
        `Expected value of type "${typeStr}", found ${print(node)}.`,
        {
          nodes: node,
        },
      ),
    );
    return;
  } // Scalars and Enums determine if a literal value is valid via parseLiteral(),
  // which may throw or return an invalid value to indicate failure.

  try {
    const parseResult = type.parseLiteral(
      node,
      undefined,
      /* variables */
    );

    if (parseResult === undefined) {
      const typeStr = inspect(locationType);
      context.reportError(
        new GraphQLError(
          `Expected value of type "${typeStr}", found ${print(node)}.`,
          {
            nodes: node,
          },
        ),
      );
    }
  } catch (error) {
    const typeStr = inspect(locationType);

    if (error instanceof GraphQLError) {
      context.reportError(error);
    } else {
      context.reportError(
        new GraphQLError(
          `Expected value of type "${typeStr}", found ${print(node)}; ` +
            error.message,
          {
            nodes: node,
            originalError: error,
          },
        ),
      );
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/VariablesAreInputTypesRule.mjs





/**
 * Variables are input types
 *
 * A GraphQL operation is only valid if all the variables it defines are of
 * input types (scalar, enum, or input object).
 *
 * See https://spec.graphql.org/draft/#sec-Variables-Are-Input-Types
 */
function VariablesAreInputTypesRule(context) {
  return {
    VariableDefinition(node) {
      const type = typeFromAST(context.getSchema(), node.type);

      if (type !== undefined && !isInputType(type)) {
        const variableName = node.variable.name.value;
        const typeName = print(node.type);
        context.reportError(
          new GraphQLError(
            `Variable "$${variableName}" cannot be non-input type "${typeName}".`,
            {
              nodes: node.type,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/VariablesInAllowedPositionRule.mjs







/**
 * Variables in allowed position
 *
 * Variable usages must be compatible with the arguments they are passed to.
 *
 * See https://spec.graphql.org/draft/#sec-All-Variable-Usages-are-Allowed
 */
function VariablesInAllowedPositionRule(context) {
  let varDefMap = Object.create(null);
  return {
    OperationDefinition: {
      enter() {
        varDefMap = Object.create(null);
      },

      leave(operation) {
        const usages = context.getRecursiveVariableUsages(operation);

        for (const { node, type, defaultValue } of usages) {
          const varName = node.name.value;
          const varDef = varDefMap[varName];

          if (varDef && type) {
            // A var type is allowed if it is the same or more strict (e.g. is
            // a subtype of) than the expected type. It can be more strict if
            // the variable type is non-null when the expected type is nullable.
            // If both are list types, the variable item type can be more strict
            // than the expected item type (contravariant).
            const schema = context.getSchema();
            const varType = typeFromAST(schema, varDef.type);

            if (
              varType &&
              !allowedVariableUsage(
                schema,
                varType,
                varDef.defaultValue,
                type,
                defaultValue,
              )
            ) {
              const varTypeStr = inspect(varType);
              const typeStr = inspect(type);
              context.reportError(
                new GraphQLError(
                  `Variable "$${varName}" of type "${varTypeStr}" used in position expecting type "${typeStr}".`,
                  {
                    nodes: [varDef, node],
                  },
                ),
              );
            }
          }
        }
      },
    },

    VariableDefinition(node) {
      varDefMap[node.variable.name.value] = node;
    },
  };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */

function allowedVariableUsage(
  schema,
  varType,
  varDefaultValue,
  locationType,
  locationDefaultValue,
) {
  if (isNonNullType(locationType) && !isNonNullType(varType)) {
    const hasNonNullVariableDefaultValue =
      varDefaultValue != null && varDefaultValue.kind !== Kind.NULL;
    const hasLocationDefaultValue = locationDefaultValue !== undefined;

    if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) {
      return false;
    }

    const nullableLocationType = locationType.ofType;
    return isTypeSubTypeOf(schema, varType, nullableLocationType);
  }

  return isTypeSubTypeOf(schema, varType, locationType);
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/specifiedRules.mjs
// Spec Section: "Executable Definitions"
 // Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"

 // Spec Section: "Fragments on Composite Types"

 // Spec Section: "Argument Names"

 // Spec Section: "Directives Are Defined"

 // Spec Section: "Fragment spread target defined"

 // Spec Section: "Fragment Spread Type Existence"

 // Spec Section: "Lone Anonymous Operation"

 // SDL-specific validation rules

 // Spec Section: "Fragments must not form cycles"

 // Spec Section: "All Variable Used Defined"

 // Spec Section: "Fragments must be used"

 // Spec Section: "All Variables Used"

 // Spec Section: "Field Selection Merging"

 // Spec Section: "Fragment spread is possible"


 // Spec Section: "Argument Optionality"

 // Spec Section: "Leaf Field Selections"

 // Spec Section: "Subscriptions with Single Root Field"


 // Spec Section: "Argument Uniqueness"


 // Spec Section: "Directives Are Unique Per Location"



 // Spec Section: "Fragment Name Uniqueness"

 // Spec Section: "Input Object Field Uniqueness"

 // Spec Section: "Operation Name Uniqueness"



 // Spec Section: "Variable Uniqueness"

 // Spec Section: "Value Type Correctness"

 // Spec Section: "Variables are Input Types"

 // Spec Section: "All Variable Usages Are Allowed"



/**
 * This set includes all validation rules defined by the GraphQL spec.
 *
 * The order of the rules in this list has been adjusted to lead to the
 * most clear output when encountering multiple validation errors.
 */
const specifiedRules = Object.freeze([
  ExecutableDefinitionsRule,
  UniqueOperationNamesRule,
  LoneAnonymousOperationRule,
  SingleFieldSubscriptionsRule,
  KnownTypeNamesRule,
  FragmentsOnCompositeTypesRule,
  VariablesAreInputTypesRule,
  ScalarLeafsRule,
  FieldsOnCorrectTypeRule,
  UniqueFragmentNamesRule,
  KnownFragmentNamesRule,
  NoUnusedFragmentsRule,
  PossibleFragmentSpreadsRule,
  NoFragmentCyclesRule,
  UniqueVariableNamesRule,
  NoUndefinedVariablesRule,
  NoUnusedVariablesRule,
  KnownDirectivesRule,
  UniqueDirectivesPerLocationRule,
  KnownArgumentNamesRule,
  UniqueArgumentNamesRule,
  ValuesOfCorrectTypeRule,
  ProvidedRequiredArgumentsRule,
  VariablesInAllowedPositionRule,
  OverlappingFieldsCanBeMergedRule,
  UniqueInputFieldNamesRule,
]);
/**
 * @internal
 */

const specifiedSDLRules = Object.freeze([
  LoneSchemaDefinitionRule,
  UniqueOperationTypesRule,
  UniqueTypeNamesRule,
  UniqueEnumValueNamesRule,
  UniqueFieldDefinitionNamesRule,
  UniqueArgumentDefinitionNamesRule,
  UniqueDirectiveNamesRule,
  KnownTypeNamesRule,
  KnownDirectivesRule,
  UniqueDirectivesPerLocationRule,
  PossibleTypeExtensionsRule,
  KnownArgumentNamesOnDirectivesRule,
  UniqueArgumentNamesRule,
  UniqueInputFieldNamesRule,
  ProvidedRequiredArgumentsOnDirectivesRule,
]);

;// CONCATENATED MODULE: ../node_modules/graphql/validation/ValidationContext.mjs




/**
 * An instance of this class is passed as the "this" context to all validators,
 * allowing access to commonly useful contextual information from within a
 * validation rule.
 */
class ASTValidationContext {
  constructor(ast, onError) {
    this._ast = ast;
    this._fragments = undefined;
    this._fragmentSpreads = new Map();
    this._recursivelyReferencedFragments = new Map();
    this._onError = onError;
  }

  get [Symbol.toStringTag]() {
    return 'ASTValidationContext';
  }

  reportError(error) {
    this._onError(error);
  }

  getDocument() {
    return this._ast;
  }

  getFragment(name) {
    let fragments;

    if (this._fragments) {
      fragments = this._fragments;
    } else {
      fragments = Object.create(null);

      for (const defNode of this.getDocument().definitions) {
        if (defNode.kind === Kind.FRAGMENT_DEFINITION) {
          fragments[defNode.name.value] = defNode;
        }
      }

      this._fragments = fragments;
    }

    return fragments[name];
  }

  getFragmentSpreads(node) {
    let spreads = this._fragmentSpreads.get(node);

    if (!spreads) {
      spreads = [];
      const setsToVisit = [node];
      let set;

      while ((set = setsToVisit.pop())) {
        for (const selection of set.selections) {
          if (selection.kind === Kind.FRAGMENT_SPREAD) {
            spreads.push(selection);
          } else if (selection.selectionSet) {
            setsToVisit.push(selection.selectionSet);
          }
        }
      }

      this._fragmentSpreads.set(node, spreads);
    }

    return spreads;
  }

  getRecursivelyReferencedFragments(operation) {
    let fragments = this._recursivelyReferencedFragments.get(operation);

    if (!fragments) {
      fragments = [];
      const collectedNames = Object.create(null);
      const nodesToVisit = [operation.selectionSet];
      let node;

      while ((node = nodesToVisit.pop())) {
        for (const spread of this.getFragmentSpreads(node)) {
          const fragName = spread.name.value;

          if (collectedNames[fragName] !== true) {
            collectedNames[fragName] = true;
            const fragment = this.getFragment(fragName);

            if (fragment) {
              fragments.push(fragment);
              nodesToVisit.push(fragment.selectionSet);
            }
          }
        }
      }

      this._recursivelyReferencedFragments.set(operation, fragments);
    }

    return fragments;
  }
}
class SDLValidationContext extends ASTValidationContext {
  constructor(ast, schema, onError) {
    super(ast, onError);
    this._schema = schema;
  }

  get [Symbol.toStringTag]() {
    return 'SDLValidationContext';
  }

  getSchema() {
    return this._schema;
  }
}
class ValidationContext extends ASTValidationContext {
  constructor(schema, ast, typeInfo, onError) {
    super(ast, onError);
    this._schema = schema;
    this._typeInfo = typeInfo;
    this._variableUsages = new Map();
    this._recursiveVariableUsages = new Map();
  }

  get [Symbol.toStringTag]() {
    return 'ValidationContext';
  }

  getSchema() {
    return this._schema;
  }

  getVariableUsages(node) {
    let usages = this._variableUsages.get(node);

    if (!usages) {
      const newUsages = [];
      const typeInfo = new TypeInfo(this._schema);
      visit(
        node,
        visitWithTypeInfo(typeInfo, {
          VariableDefinition: () => false,

          Variable(variable) {
            newUsages.push({
              node: variable,
              type: typeInfo.getInputType(),
              defaultValue: typeInfo.getDefaultValue(),
            });
          },
        }),
      );
      usages = newUsages;

      this._variableUsages.set(node, usages);
    }

    return usages;
  }

  getRecursiveVariableUsages(operation) {
    let usages = this._recursiveVariableUsages.get(operation);

    if (!usages) {
      usages = this.getVariableUsages(operation);

      for (const frag of this.getRecursivelyReferencedFragments(operation)) {
        usages = usages.concat(this.getVariableUsages(frag));
      }

      this._recursiveVariableUsages.set(operation, usages);
    }

    return usages;
  }

  getType() {
    return this._typeInfo.getType();
  }

  getParentType() {
    return this._typeInfo.getParentType();
  }

  getInputType() {
    return this._typeInfo.getInputType();
  }

  getParentInputType() {
    return this._typeInfo.getParentInputType();
  }

  getFieldDef() {
    return this._typeInfo.getFieldDef();
  }

  getDirective() {
    return this._typeInfo.getDirective();
  }

  getArgument() {
    return this._typeInfo.getArgument();
  }

  getEnumValue() {
    return this._typeInfo.getEnumValue();
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/validate.mjs







/**
 * Implements the "Validation" section of the spec.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the document is valid.
 *
 * A list of specific validation rules may be provided. If not provided, the
 * default list of rules defined by the GraphQL specification will be used.
 *
 * Each validation rules is a function which returns a visitor
 * (see the language/visitor API). Visitor methods are expected to return
 * GraphQLErrors, or Arrays of GraphQLErrors when invalid.
 *
 * Validate will stop validation after a `maxErrors` limit has been reached.
 * Attackers can send pathologically invalid queries to induce a DoS attack,
 * so by default `maxErrors` set to 100 errors.
 *
 * Optionally a custom TypeInfo instance may be provided. If not provided, one
 * will be created from the provided schema.
 */

function validate(
  schema,
  documentAST,
  rules = specifiedRules,
  options,
  /** @deprecated will be removed in 17.0.0 */
  typeInfo = new TypeInfo(schema),
) {
  var _options$maxErrors;

  const maxErrors =
    (_options$maxErrors =
      options === null || options === void 0 ? void 0 : options.maxErrors) !==
      null && _options$maxErrors !== void 0
      ? _options$maxErrors
      : 100;
  documentAST || devAssert(false, 'Must provide document.'); // If the schema used for validation is invalid, throw an error.

  assertValidSchema(schema);
  const abortObj = Object.freeze({});
  const errors = [];
  const context = new ValidationContext(
    schema,
    documentAST,
    typeInfo,
    (error) => {
      if (errors.length >= maxErrors) {
        errors.push(
          new GraphQLError(
            'Too many validation errors, error limit reached. Validation aborted.',
          ),
        ); // eslint-disable-next-line @typescript-eslint/no-throw-literal

        throw abortObj;
      }

      errors.push(error);
    },
  ); // This uses a specialized visitor which runs multiple visitors in parallel,
  // while maintaining the visitor skip and break API.

  const visitor = visitInParallel(rules.map((rule) => rule(context))); // Visit the whole document with each instance of all provided rules.

  try {
    visit(documentAST, visitWithTypeInfo(typeInfo, visitor));
  } catch (e) {
    if (e !== abortObj) {
      throw e;
    }
  }

  return errors;
}
/**
 * @internal
 */

function validateSDL(
  documentAST,
  schemaToExtend,
  rules = specifiedSDLRules,
) {
  const errors = [];
  const context = new SDLValidationContext(
    documentAST,
    schemaToExtend,
    (error) => {
      errors.push(error);
    },
  );
  const visitors = rules.map((rule) => rule(context));
  visit(documentAST, visitInParallel(visitors));
  return errors;
}
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */

function assertValidSDL(documentAST) {
  const errors = validateSDL(documentAST);

  if (errors.length !== 0) {
    throw new Error(errors.map((error) => error.message).join('\n\n'));
  }
}
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */

function assertValidSDLExtension(documentAST, schema) {
  const errors = validateSDL(documentAST, schema);

  if (errors.length !== 0) {
    throw new Error(errors.map((error) => error.message).join('\n\n'));
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/memoize3.mjs
/**
 * Memoizes the provided three-argument function.
 */
function memoize3(fn) {
  let cache0;
  return function memoized(a1, a2, a3) {
    if (cache0 === undefined) {
      cache0 = new WeakMap();
    }

    let cache1 = cache0.get(a1);

    if (cache1 === undefined) {
      cache1 = new WeakMap();
      cache0.set(a1, cache1);
    }

    let cache2 = cache1.get(a2);

    if (cache2 === undefined) {
      cache2 = new WeakMap();
      cache1.set(a2, cache2);
    }

    let fnResult = cache2.get(a3);

    if (fnResult === undefined) {
      fnResult = fn(a1, a2, a3);
      cache2.set(a3, fnResult);
    }

    return fnResult;
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/promiseForObject.mjs
/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */
function promiseForObject(object) {
  return Promise.all(Object.values(object)).then((resolvedValues) => {
    const resolvedObject = Object.create(null);

    for (const [i, key] of Object.keys(object).entries()) {
      resolvedObject[key] = resolvedValues[i];
    }

    return resolvedObject;
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/promiseReduce.mjs


/**
 * Similar to Array.prototype.reduce(), however the reducing callback may return
 * a Promise, in which case reduction will continue after each promise resolves.
 *
 * If the callback does not return a Promise, then this function will also not
 * return a Promise.
 */
function promiseReduce(values, callbackFn, initialValue) {
  let accumulator = initialValue;

  for (const value of values) {
    accumulator = isPromise(accumulator)
      ? accumulator.then((resolved) => callbackFn(resolved, value))
      : callbackFn(accumulator, value);
  }

  return accumulator;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/toError.mjs

/**
 * Sometimes a non-error is thrown, wrap it as an Error instance to ensure a consistent Error interface.
 */

function toError(thrownValue) {
  return thrownValue instanceof Error
    ? thrownValue
    : new NonErrorThrown(thrownValue);
}

class NonErrorThrown extends Error {
  constructor(thrownValue) {
    super('Unexpected error value: ' + inspect(thrownValue));
    this.name = 'NonErrorThrown';
    this.thrownValue = thrownValue;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/error/locatedError.mjs


/**
 * Given an arbitrary value, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */

function locatedError(rawOriginalError, nodes, path) {
  var _nodes;

  const originalError = toError(rawOriginalError); // Note: this uses a brand-check to support GraphQL errors originating from other contexts.

  if (isLocatedGraphQLError(originalError)) {
    return originalError;
  }

  return new GraphQLError(originalError.message, {
    nodes:
      (_nodes = originalError.nodes) !== null && _nodes !== void 0
        ? _nodes
        : nodes,
    source: originalError.source,
    positions: originalError.positions,
    path,
    originalError,
  });
}

function isLocatedGraphQLError(error) {
  return Array.isArray(error.path);
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/execute.mjs



















/**
 * A memoized collection of relevant subfields with regard to the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */

const execute_collectSubfields = memoize3((exeContext, returnType, fieldNodes) =>
  collectSubfields(
    exeContext.schema,
    exeContext.fragments,
    exeContext.variableValues,
    returnType,
    fieldNodes,
  ),
);
/**
 * Terminology
 *
 * "Definitions" are the generic name for top-level statements in the document.
 * Examples of this include:
 * 1) Operations (such as a query)
 * 2) Fragments
 *
 * "Operations" are a generic name for requests in the document.
 * Examples of this include:
 * 1) query,
 * 2) mutation
 *
 * "Selections" are the definitions that can appear legally and at
 * single level of the query. These include:
 * 1) field references e.g `a`
 * 2) fragment "spreads" e.g. `...c`
 * 3) inline fragment "spreads" e.g. `...on Type { a }`
 */

/**
 * Data that must be available at all points during query execution.
 *
 * Namely, schema of the type system that is currently executing,
 * and the fragments defined in the query document
 */

/**
 * Implements the "Executing requests" section of the GraphQL specification.
 *
 * Returns either a synchronous ExecutionResult (if all encountered resolvers
 * are synchronous), or a Promise of an ExecutionResult that will eventually be
 * resolved and never rejected.
 *
 * If the arguments to this function do not result in a legal execution context,
 * a GraphQLError will be thrown immediately explaining the invalid input.
 */
function execute(args) {
  // Temporary for v15 to v16 migration. Remove in v17
  arguments.length < 2 ||
    devAssert(
      false,
      'graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.',
    );
  const { schema, document, variableValues, rootValue } = args; // If arguments are missing or incorrect, throw an error.

  assertValidExecutionArguments(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
  // a "Response" with only errors is returned.

  const exeContext = buildExecutionContext(args); // Return early errors if execution context failed.

  if (!('schema' in exeContext)) {
    return {
      errors: exeContext,
    };
  } // Return a Promise that will eventually resolve to the data described by
  // The "Response" section of the GraphQL specification.
  //
  // If errors are encountered while executing a GraphQL field, only that
  // field and its descendants will be omitted, and sibling fields will still
  // be executed. An execution which encounters errors will still result in a
  // resolved Promise.
  //
  // Errors from sub-fields of a NonNull type may propagate to the top level,
  // at which point we still log the error and null the parent field, which
  // in this case is the entire response.

  try {
    const { operation } = exeContext;
    const result = executeOperation(exeContext, operation, rootValue);

    if (isPromise(result)) {
      return result.then(
        (data) => buildResponse(data, exeContext.errors),
        (error) => {
          exeContext.errors.push(error);
          return buildResponse(null, exeContext.errors);
        },
      );
    }

    return buildResponse(result, exeContext.errors);
  } catch (error) {
    exeContext.errors.push(error);
    return buildResponse(null, exeContext.errors);
  }
}
/**
 * Also implements the "Executing requests" section of the GraphQL specification.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */

function executeSync(args) {
  const result = execute(args); // Assert that the execution was synchronous.

  if (isPromise(result)) {
    throw new Error('GraphQL execution failed to complete synchronously.');
  }

  return result;
}
/**
 * Given a completed execution context and data, build the `{ errors, data }`
 * response defined by the "Response" section of the GraphQL specification.
 */

function buildResponse(data, errors) {
  return errors.length === 0
    ? {
        data,
      }
    : {
        errors,
        data,
      };
}
/**
 * Essential assertions before executing to provide developer feedback for
 * improper use of the GraphQL library.
 *
 * @internal
 */

function assertValidExecutionArguments(
  schema,
  document,
  rawVariableValues,
) {
  document || devAssert(false, 'Must provide document.'); // If the schema used for execution is invalid, throw an error.

  assertValidSchema(schema); // Variables, if provided, must be an object.

  rawVariableValues == null ||
    isObjectLike(rawVariableValues) ||
    devAssert(
      false,
      'Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.',
    );
}
/**
 * Constructs a ExecutionContext object from the arguments passed to
 * execute, which we will pass throughout the other execution methods.
 *
 * Throws a GraphQLError if a valid execution context cannot be created.
 *
 * @internal
 */

function buildExecutionContext(args) {
  var _definition$name, _operation$variableDe;

  const {
    schema,
    document,
    rootValue,
    contextValue,
    variableValues: rawVariableValues,
    operationName,
    fieldResolver,
    typeResolver,
    subscribeFieldResolver,
  } = args;
  let operation;
  const fragments = Object.create(null);

  for (const definition of document.definitions) {
    switch (definition.kind) {
      case Kind.OPERATION_DEFINITION:
        if (operationName == null) {
          if (operation !== undefined) {
            return [
              new GraphQLError(
                'Must provide operation name if query contains multiple operations.',
              ),
            ];
          }

          operation = definition;
        } else if (
          ((_definition$name = definition.name) === null ||
          _definition$name === void 0
            ? void 0
            : _definition$name.value) === operationName
        ) {
          operation = definition;
        }

        break;

      case Kind.FRAGMENT_DEFINITION:
        fragments[definition.name.value] = definition;
        break;

      default: // ignore non-executable definitions
    }
  }

  if (!operation) {
    if (operationName != null) {
      return [new GraphQLError(`Unknown operation named "${operationName}".`)];
    }

    return [new GraphQLError('Must provide an operation.')];
  } // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */

  const variableDefinitions =
    (_operation$variableDe = operation.variableDefinitions) !== null &&
    _operation$variableDe !== void 0
      ? _operation$variableDe
      : [];
  const coercedVariableValues = getVariableValues(
    schema,
    variableDefinitions,
    rawVariableValues !== null && rawVariableValues !== void 0
      ? rawVariableValues
      : {},
    {
      maxErrors: 50,
    },
  );

  if (coercedVariableValues.errors) {
    return coercedVariableValues.errors;
  }

  return {
    schema,
    fragments,
    rootValue,
    contextValue,
    operation,
    variableValues: coercedVariableValues.coerced,
    fieldResolver:
      fieldResolver !== null && fieldResolver !== void 0
        ? fieldResolver
        : defaultFieldResolver,
    typeResolver:
      typeResolver !== null && typeResolver !== void 0
        ? typeResolver
        : defaultTypeResolver,
    subscribeFieldResolver:
      subscribeFieldResolver !== null && subscribeFieldResolver !== void 0
        ? subscribeFieldResolver
        : defaultFieldResolver,
    errors: [],
  };
}
/**
 * Implements the "Executing operations" section of the spec.
 */

function executeOperation(exeContext, operation, rootValue) {
  const rootType = exeContext.schema.getRootType(operation.operation);

  if (rootType == null) {
    throw new GraphQLError(
      `Schema is not configured to execute ${operation.operation} operation.`,
      {
        nodes: operation,
      },
    );
  }

  const rootFields = collectFields(
    exeContext.schema,
    exeContext.fragments,
    exeContext.variableValues,
    rootType,
    operation.selectionSet,
  );
  const path = undefined;

  switch (operation.operation) {
    case OperationTypeNode.QUERY:
      return executeFields(exeContext, rootType, rootValue, path, rootFields);

    case OperationTypeNode.MUTATION:
      return executeFieldsSerially(
        exeContext,
        rootType,
        rootValue,
        path,
        rootFields,
      );

    case OperationTypeNode.SUBSCRIPTION:
      // TODO: deprecate `subscribe` and move all logic here
      // Temporary solution until we finish merging execute and subscribe together
      return executeFields(exeContext, rootType, rootValue, path, rootFields);
  }
}
/**
 * Implements the "Executing selection sets" section of the spec
 * for fields that must be executed serially.
 */

function executeFieldsSerially(
  exeContext,
  parentType,
  sourceValue,
  path,
  fields,
) {
  return promiseReduce(
    fields.entries(),
    (results, [responseName, fieldNodes]) => {
      const fieldPath = addPath(path, responseName, parentType.name);
      const result = executeField(
        exeContext,
        parentType,
        sourceValue,
        fieldNodes,
        fieldPath,
      );

      if (result === undefined) {
        return results;
      }

      if (isPromise(result)) {
        return result.then((resolvedResult) => {
          results[responseName] = resolvedResult;
          return results;
        });
      }

      results[responseName] = result;
      return results;
    },
    Object.create(null),
  );
}
/**
 * Implements the "Executing selection sets" section of the spec
 * for fields that may be executed in parallel.
 */

function executeFields(exeContext, parentType, sourceValue, path, fields) {
  const results = Object.create(null);
  let containsPromise = false;

  try {
    for (const [responseName, fieldNodes] of fields.entries()) {
      const fieldPath = addPath(path, responseName, parentType.name);
      const result = executeField(
        exeContext,
        parentType,
        sourceValue,
        fieldNodes,
        fieldPath,
      );

      if (result !== undefined) {
        results[responseName] = result;

        if (isPromise(result)) {
          containsPromise = true;
        }
      }
    }
  } catch (error) {
    if (containsPromise) {
      // Ensure that any promises returned by other fields are handled, as they may also reject.
      return promiseForObject(results).finally(() => {
        throw error;
      });
    }

    throw error;
  } // If there are no promises, we can just return the object

  if (!containsPromise) {
    return results;
  } // Otherwise, results is a map from field name to the result of resolving that
  // field, which is possibly a promise. Return a promise that will return this
  // same map, but with any promises replaced with the values they resolved to.

  return promiseForObject(results);
}
/**
 * Implements the "Executing fields" section of the spec
 * In particular, this function figures out the value that the field returns by
 * calling its resolve function, then calls completeValue to complete promises,
 * serialize scalars, or execute the sub-selection-set for objects.
 */

function executeField(exeContext, parentType, source, fieldNodes, path) {
  var _fieldDef$resolve;

  const fieldDef = execute_getFieldDef(exeContext.schema, parentType, fieldNodes[0]);

  if (!fieldDef) {
    return;
  }

  const returnType = fieldDef.type;
  const resolveFn =
    (_fieldDef$resolve = fieldDef.resolve) !== null &&
    _fieldDef$resolve !== void 0
      ? _fieldDef$resolve
      : exeContext.fieldResolver;
  const info = buildResolveInfo(
    exeContext,
    fieldDef,
    fieldNodes,
    parentType,
    path,
  ); // Get the resolve function, regardless of if its result is normal or abrupt (error).

  try {
    // Build a JS object of arguments from the field.arguments AST, using the
    // variables scope to fulfill any variable references.
    // TODO: find a way to memoize, in case this field is within a List type.
    const args = getArgumentValues(
      fieldDef,
      fieldNodes[0],
      exeContext.variableValues,
    ); // The resolve function's optional third argument is a context value that
    // is provided to every resolve function within an execution. It is commonly
    // used to represent an authenticated user, or request-specific caches.

    const contextValue = exeContext.contextValue;
    const result = resolveFn(source, args, contextValue, info);
    let completed;

    if (isPromise(result)) {
      completed = result.then((resolved) =>
        completeValue(exeContext, returnType, fieldNodes, info, path, resolved),
      );
    } else {
      completed = completeValue(
        exeContext,
        returnType,
        fieldNodes,
        info,
        path,
        result,
      );
    }

    if (isPromise(completed)) {
      // Note: we don't rely on a `catch` method, but we do expect "thenable"
      // to take a second callback for the error case.
      return completed.then(undefined, (rawError) => {
        const error = locatedError(rawError, fieldNodes, pathToArray(path));
        return handleFieldError(error, returnType, exeContext);
      });
    }

    return completed;
  } catch (rawError) {
    const error = locatedError(rawError, fieldNodes, pathToArray(path));
    return handleFieldError(error, returnType, exeContext);
  }
}
/**
 * @internal
 */

function buildResolveInfo(
  exeContext,
  fieldDef,
  fieldNodes,
  parentType,
  path,
) {
  // The resolve function's optional fourth argument is a collection of
  // information about the current execution state.
  return {
    fieldName: fieldDef.name,
    fieldNodes,
    returnType: fieldDef.type,
    parentType,
    path,
    schema: exeContext.schema,
    fragments: exeContext.fragments,
    rootValue: exeContext.rootValue,
    operation: exeContext.operation,
    variableValues: exeContext.variableValues,
  };
}

function handleFieldError(error, returnType, exeContext) {
  // If the field type is non-nullable, then it is resolved without any
  // protection from errors, however it still properly locates the error.
  if (isNonNullType(returnType)) {
    throw error;
  } // Otherwise, error protection is applied, logging the error and resolving
  // a null value for this field if one is encountered.

  exeContext.errors.push(error);
  return null;
}
/**
 * Implements the instructions for completeValue as defined in the
 * "Value Completion" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by executing all sub-selections.
 */

function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
  // If result is an Error, throw a located error.
  if (result instanceof Error) {
    throw result;
  } // If field type is NonNull, complete for inner type, and throw field error
  // if result is null.

  if (isNonNullType(returnType)) {
    const completed = completeValue(
      exeContext,
      returnType.ofType,
      fieldNodes,
      info,
      path,
      result,
    );

    if (completed === null) {
      throw new Error(
        `Cannot return null for non-nullable field ${info.parentType.name}.${info.fieldName}.`,
      );
    }

    return completed;
  } // If result value is null or undefined then return null.

  if (result == null) {
    return null;
  } // If field type is List, complete each item in the list with the inner type

  if (isListType(returnType)) {
    return completeListValue(
      exeContext,
      returnType,
      fieldNodes,
      info,
      path,
      result,
    );
  } // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
  // returning null if serialization is not possible.

  if (isLeafType(returnType)) {
    return completeLeafValue(returnType, result);
  } // If field type is an abstract type, Interface or Union, determine the
  // runtime Object type and complete for that type.

  if (isAbstractType(returnType)) {
    return completeAbstractValue(
      exeContext,
      returnType,
      fieldNodes,
      info,
      path,
      result,
    );
  } // If field type is Object, execute and complete all sub-selections.

  if (isObjectType(returnType)) {
    return completeObjectValue(
      exeContext,
      returnType,
      fieldNodes,
      info,
      path,
      result,
    );
  }
  /* c8 ignore next 6 */
  // Not reachable, all possible output types have been considered.

   false ||
    invariant(
      false,
      'Cannot complete value of unexpected output type: ' + inspect(returnType),
    );
}
/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */

function completeListValue(
  exeContext,
  returnType,
  fieldNodes,
  info,
  path,
  result,
) {
  if (!isIterableObject(result)) {
    throw new GraphQLError(
      `Expected Iterable, but did not find one for field "${info.parentType.name}.${info.fieldName}".`,
    );
  } // This is specified as a simple map, however we're optimizing the path
  // where the list contains no Promises by avoiding creating another Promise.

  const itemType = returnType.ofType;
  let containsPromise = false;
  const completedResults = Array.from(result, (item, index) => {
    // No need to modify the info object containing the path,
    // since from here on it is not ever accessed by resolver functions.
    const itemPath = addPath(path, index, undefined);

    try {
      let completedItem;

      if (isPromise(item)) {
        completedItem = item.then((resolved) =>
          completeValue(
            exeContext,
            itemType,
            fieldNodes,
            info,
            itemPath,
            resolved,
          ),
        );
      } else {
        completedItem = completeValue(
          exeContext,
          itemType,
          fieldNodes,
          info,
          itemPath,
          item,
        );
      }

      if (isPromise(completedItem)) {
        containsPromise = true; // Note: we don't rely on a `catch` method, but we do expect "thenable"
        // to take a second callback for the error case.

        return completedItem.then(undefined, (rawError) => {
          const error = locatedError(
            rawError,
            fieldNodes,
            pathToArray(itemPath),
          );
          return handleFieldError(error, itemType, exeContext);
        });
      }

      return completedItem;
    } catch (rawError) {
      const error = locatedError(rawError, fieldNodes, pathToArray(itemPath));
      return handleFieldError(error, itemType, exeContext);
    }
  });
  return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */

function completeLeafValue(returnType, result) {
  const serializedResult = returnType.serialize(result);

  if (serializedResult == null) {
    throw new Error(
      `Expected \`${inspect(returnType)}.serialize(${inspect(result)})\` to ` +
        `return non-nullable value, returned: ${inspect(serializedResult)}`,
    );
  }

  return serializedResult;
}
/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */

function completeAbstractValue(
  exeContext,
  returnType,
  fieldNodes,
  info,
  path,
  result,
) {
  var _returnType$resolveTy;

  const resolveTypeFn =
    (_returnType$resolveTy = returnType.resolveType) !== null &&
    _returnType$resolveTy !== void 0
      ? _returnType$resolveTy
      : exeContext.typeResolver;
  const contextValue = exeContext.contextValue;
  const runtimeType = resolveTypeFn(result, contextValue, info, returnType);

  if (isPromise(runtimeType)) {
    return runtimeType.then((resolvedRuntimeType) =>
      completeObjectValue(
        exeContext,
        ensureValidRuntimeType(
          resolvedRuntimeType,
          exeContext,
          returnType,
          fieldNodes,
          info,
          result,
        ),
        fieldNodes,
        info,
        path,
        result,
      ),
    );
  }

  return completeObjectValue(
    exeContext,
    ensureValidRuntimeType(
      runtimeType,
      exeContext,
      returnType,
      fieldNodes,
      info,
      result,
    ),
    fieldNodes,
    info,
    path,
    result,
  );
}

function ensureValidRuntimeType(
  runtimeTypeName,
  exeContext,
  returnType,
  fieldNodes,
  info,
  result,
) {
  if (runtimeTypeName == null) {
    throw new GraphQLError(
      `Abstract type "${returnType.name}" must resolve to an Object type at runtime for field "${info.parentType.name}.${info.fieldName}". Either the "${returnType.name}" type should provide a "resolveType" function or each possible type should provide an "isTypeOf" function.`,
      fieldNodes,
    );
  } // releases before 16.0.0 supported returning `GraphQLObjectType` from `resolveType`
  // TODO: remove in 17.0.0 release

  if (isObjectType(runtimeTypeName)) {
    throw new GraphQLError(
      'Support for returning GraphQLObjectType from resolveType was removed in graphql-js@16.0.0 please return type name instead.',
    );
  }

  if (typeof runtimeTypeName !== 'string') {
    throw new GraphQLError(
      `Abstract type "${returnType.name}" must resolve to an Object type at runtime for field "${info.parentType.name}.${info.fieldName}" with ` +
        `value ${inspect(result)}, received "${inspect(runtimeTypeName)}".`,
    );
  }

  const runtimeType = exeContext.schema.getType(runtimeTypeName);

  if (runtimeType == null) {
    throw new GraphQLError(
      `Abstract type "${returnType.name}" was resolved to a type "${runtimeTypeName}" that does not exist inside the schema.`,
      {
        nodes: fieldNodes,
      },
    );
  }

  if (!isObjectType(runtimeType)) {
    throw new GraphQLError(
      `Abstract type "${returnType.name}" was resolved to a non-object type "${runtimeTypeName}".`,
      {
        nodes: fieldNodes,
      },
    );
  }

  if (!exeContext.schema.isSubType(returnType, runtimeType)) {
    throw new GraphQLError(
      `Runtime Object type "${runtimeType.name}" is not a possible type for "${returnType.name}".`,
      {
        nodes: fieldNodes,
      },
    );
  }

  return runtimeType;
}
/**
 * Complete an Object value by executing all sub-selections.
 */

function completeObjectValue(
  exeContext,
  returnType,
  fieldNodes,
  info,
  path,
  result,
) {
  // Collect sub-fields to execute to complete this value.
  const subFieldNodes = execute_collectSubfields(exeContext, returnType, fieldNodes); // If there is an isTypeOf predicate function, call it with the
  // current result. If isTypeOf returns false, then raise an error rather
  // than continuing execution.

  if (returnType.isTypeOf) {
    const isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);

    if (isPromise(isTypeOf)) {
      return isTypeOf.then((resolvedIsTypeOf) => {
        if (!resolvedIsTypeOf) {
          throw invalidReturnTypeError(returnType, result, fieldNodes);
        }

        return executeFields(
          exeContext,
          returnType,
          result,
          path,
          subFieldNodes,
        );
      });
    }

    if (!isTypeOf) {
      throw invalidReturnTypeError(returnType, result, fieldNodes);
    }
  }

  return executeFields(exeContext, returnType, result, path, subFieldNodes);
}

function invalidReturnTypeError(returnType, result, fieldNodes) {
  return new GraphQLError(
    `Expected value of type "${returnType.name}" but got: ${inspect(result)}.`,
    {
      nodes: fieldNodes,
    },
  );
}
/**
 * If a resolveType function is not given, then a default resolve behavior is
 * used which attempts two strategies:
 *
 * First, See if the provided value has a `__typename` field defined, if so, use
 * that value as name of the resolved type.
 *
 * Otherwise, test each possible type for the abstract type by calling
 * isTypeOf for the object being coerced, returning the first type that matches.
 */

const defaultTypeResolver = function (
  value,
  contextValue,
  info,
  abstractType,
) {
  // First, look for `__typename`.
  if (isObjectLike(value) && typeof value.__typename === 'string') {
    return value.__typename;
  } // Otherwise, test each possible type.

  const possibleTypes = info.schema.getPossibleTypes(abstractType);
  const promisedIsTypeOfResults = [];

  for (let i = 0; i < possibleTypes.length; i++) {
    const type = possibleTypes[i];

    if (type.isTypeOf) {
      const isTypeOfResult = type.isTypeOf(value, contextValue, info);

      if (isPromise(isTypeOfResult)) {
        promisedIsTypeOfResults[i] = isTypeOfResult;
      } else if (isTypeOfResult) {
        return type.name;
      }
    }
  }

  if (promisedIsTypeOfResults.length) {
    return Promise.all(promisedIsTypeOfResults).then((isTypeOfResults) => {
      for (let i = 0; i < isTypeOfResults.length; i++) {
        if (isTypeOfResults[i]) {
          return possibleTypes[i].name;
        }
      }
    });
  }
};
/**
 * If a resolve function is not given, then a default resolve behavior is used
 * which takes the property of the source object of the same name as the field
 * and returns it as the result, or if it's a function, returns the result
 * of calling that function while passing along args and context value.
 */

const defaultFieldResolver = function (
  source,
  args,
  contextValue,
  info,
) {
  // ensure source is a value for which property access is acceptable.
  if (isObjectLike(source) || typeof source === 'function') {
    const property = source[info.fieldName];

    if (typeof property === 'function') {
      return source[info.fieldName](args, contextValue, info);
    }

    return property;
  }
};
/**
 * This method looks up the field on the given type definition.
 * It has special casing for the three introspection fields,
 * __schema, __type and __typename. __typename is special because
 * it can always be queried as a field, even in situations where no
 * other fields are allowed, like on a Union. __schema and __type
 * could get automatically added to the query type, but that would
 * require mutating type definitions, which would cause issues.
 *
 * @internal
 */

function execute_getFieldDef(schema, parentType, fieldNode) {
  const fieldName = fieldNode.name.value;

  if (
    fieldName === SchemaMetaFieldDef.name &&
    schema.getQueryType() === parentType
  ) {
    return SchemaMetaFieldDef;
  } else if (
    fieldName === TypeMetaFieldDef.name &&
    schema.getQueryType() === parentType
  ) {
    return TypeMetaFieldDef;
  } else if (fieldName === TypeNameMetaFieldDef.name) {
    return TypeNameMetaFieldDef;
  }

  return parentType.getFields()[fieldName];
}

;// CONCATENATED MODULE: ../node_modules/graphql/graphql.mjs






/**
 * This is the primary entry point function for fulfilling GraphQL operations
 * by parsing, validating, and executing a GraphQL document along side a
 * GraphQL schema.
 *
 * More sophisticated GraphQL servers, such as those which persist queries,
 * may wish to separate the validation and execution phases to a static time
 * tooling step, and a server runtime step.
 *
 * Accepts either an object with named arguments, or individual arguments:
 *
 * schema:
 *    The GraphQL type system to use when validating and executing a query.
 * source:
 *    A GraphQL language formatted string representing the requested operation.
 * rootValue:
 *    The value provided as the first argument to resolver functions on the top
 *    level type (e.g. the query object type).
 * contextValue:
 *    The context value is provided as an argument to resolver functions after
 *    field arguments. It is used to pass shared information useful at any point
 *    during executing this query, for example the currently logged in user and
 *    connections to databases or other services.
 * variableValues:
 *    A mapping of variable name to runtime value to use for all variables
 *    defined in the requestString.
 * operationName:
 *    The name of the operation to use if requestString contains multiple
 *    possible operations. Can be omitted if requestString contains only
 *    one operation.
 * fieldResolver:
 *    A resolver function to use when one is not provided by the schema.
 *    If not provided, the default field resolver is used (which looks for a
 *    value or method on the source value with the field's name).
 * typeResolver:
 *    A type resolver function to use when none is provided by the schema.
 *    If not provided, the default type resolver is used (which looks for a
 *    `__typename` field or alternatively calls the `isTypeOf` method).
 */

function graphql(args) {
  // Always return a Promise for a consistent API.
  return new Promise((resolve) => resolve(graphqlImpl(args)));
}
/**
 * The graphqlSync function also fulfills GraphQL operations by parsing,
 * validating, and executing a GraphQL document along side a GraphQL schema.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */

function graphqlSync(args) {
  const result = graphqlImpl(args); // Assert that the execution was synchronous.

  if (isPromise(result)) {
    throw new Error('GraphQL execution failed to complete synchronously.');
  }

  return result;
}

function graphqlImpl(args) {
  // Temporary for v15 to v16 migration. Remove in v17
  arguments.length < 2 ||
    devAssert(
      false,
      'graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.',
    );
  const {
    schema,
    source,
    rootValue,
    contextValue,
    variableValues,
    operationName,
    fieldResolver,
    typeResolver,
  } = args; // Validate Schema

  const schemaValidationErrors = validateSchema(schema);

  if (schemaValidationErrors.length > 0) {
    return {
      errors: schemaValidationErrors,
    };
  } // Parse

  let document;

  try {
    document = parse(source);
  } catch (syntaxError) {
    return {
      errors: [syntaxError],
    };
  } // Validate

  const validationErrors = validate(schema, document);

  if (validationErrors.length > 0) {
    return {
      errors: validationErrors,
    };
  } // Execute

  return execute({
    schema,
    document,
    rootValue,
    contextValue,
    variableValues,
    operationName,
    fieldResolver,
    typeResolver,
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isAsyncIterable.mjs
/**
 * Returns true if the provided object implements the AsyncIterator protocol via
 * implementing a `Symbol.asyncIterator` method.
 */
function isAsyncIterable(maybeAsyncIterable) {
  return (
    typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0
      ? void 0
      : maybeAsyncIterable[Symbol.asyncIterator]) === 'function'
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/mapAsyncIterator.mjs
/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */
function mapAsyncIterator(iterable, callback) {
  const iterator = iterable[Symbol.asyncIterator]();

  async function mapResult(result) {
    if (result.done) {
      return result;
    }

    try {
      return {
        value: await callback(result.value),
        done: false,
      };
    } catch (error) {
      /* c8 ignore start */
      // FIXME: add test case
      if (typeof iterator.return === 'function') {
        try {
          await iterator.return();
        } catch (_e) {
          /* ignore error */
        }
      }

      throw error;
      /* c8 ignore stop */
    }
  }

  return {
    async next() {
      return mapResult(await iterator.next());
    },

    async return() {
      // If iterator.return() does not exist, then type R must be undefined.
      return typeof iterator.return === 'function'
        ? mapResult(await iterator.return())
        : {
            value: undefined,
            done: true,
          };
    },

    async throw(error) {
      if (typeof iterator.throw === 'function') {
        return mapResult(await iterator.throw(error));
      }

      throw error;
    },

    [Symbol.asyncIterator]() {
      return this;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/subscribe.mjs










/**
 * Implements the "Subscribe" algorithm described in the GraphQL specification.
 *
 * Returns a Promise which resolves to either an AsyncIterator (if successful)
 * or an ExecutionResult (error). The promise will be rejected if the schema or
 * other arguments to this function are invalid, or if the resolved event stream
 * is not an async iterable.
 *
 * If the client-provided arguments to this function do not result in a
 * compliant subscription, a GraphQL Response (ExecutionResult) with
 * descriptive errors and no data will be returned.
 *
 * If the source stream could not be created due to faulty subscription
 * resolver logic or underlying systems, the promise will resolve to a single
 * ExecutionResult containing `errors` and no `data`.
 *
 * If the operation succeeded, the promise resolves to an AsyncIterator, which
 * yields a stream of ExecutionResults representing the response stream.
 *
 * Accepts either an object with named arguments, or individual arguments.
 */

async function subscribe(args) {
  // Temporary for v15 to v16 migration. Remove in v17
  arguments.length < 2 ||
    devAssert(
      false,
      'graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.',
    );
  const resultOrStream = await createSourceEventStream(args);

  if (!isAsyncIterable(resultOrStream)) {
    return resultOrStream;
  } // For each payload yielded from a subscription, map it over the normal
  // GraphQL `execute` function, with `payload` as the rootValue.
  // This implements the "MapSourceToResponseEvent" algorithm described in
  // the GraphQL specification. The `execute` function provides the
  // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
  // "ExecuteQuery" algorithm, for which `execute` is also used.

  const mapSourceToResponse = (payload) =>
    execute({ ...args, rootValue: payload }); // Map every source value to a ExecutionResult value as described above.

  return mapAsyncIterator(resultOrStream, mapSourceToResponse);
}

function toNormalizedArgs(args) {
  const firstArg = args[0];

  if (firstArg && 'document' in firstArg) {
    return firstArg;
  }

  return {
    schema: firstArg,
    // FIXME: when underlying TS bug fixed, see https://github.com/microsoft/TypeScript/issues/31613
    document: args[1],
    rootValue: args[2],
    contextValue: args[3],
    variableValues: args[4],
    operationName: args[5],
    subscribeFieldResolver: args[6],
  };
}
/**
 * Implements the "CreateSourceEventStream" algorithm described in the
 * GraphQL specification, resolving the subscription source event stream.
 *
 * Returns a Promise which resolves to either an AsyncIterable (if successful)
 * or an ExecutionResult (error). The promise will be rejected if the schema or
 * other arguments to this function are invalid, or if the resolved event stream
 * is not an async iterable.
 *
 * If the client-provided arguments to this function do not result in a
 * compliant subscription, a GraphQL Response (ExecutionResult) with
 * descriptive errors and no data will be returned.
 *
 * If the the source stream could not be created due to faulty subscription
 * resolver logic or underlying systems, the promise will resolve to a single
 * ExecutionResult containing `errors` and no `data`.
 *
 * If the operation succeeded, the promise resolves to the AsyncIterable for the
 * event stream returned by the resolver.
 *
 * A Source Event Stream represents a sequence of events, each of which triggers
 * a GraphQL execution for that event.
 *
 * This may be useful when hosting the stateful subscription service in a
 * different process or machine than the stateless GraphQL execution engine,
 * or otherwise separating these two steps. For more on this, see the
 * "Supporting Subscriptions at Scale" information in the GraphQL specification.
 */

async function createSourceEventStream(...rawArgs) {
  const args = toNormalizedArgs(rawArgs);
  const { schema, document, variableValues } = args; // If arguments are missing or incorrectly typed, this is an internal
  // developer mistake which should throw an early error.

  assertValidExecutionArguments(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
  // a "Response" with only errors is returned.

  const exeContext = buildExecutionContext(args); // Return early errors if execution context failed.

  if (!('schema' in exeContext)) {
    return {
      errors: exeContext,
    };
  }

  try {
    const eventStream = await executeSubscription(exeContext); // Assert field returned an event stream, otherwise yield an error.

    if (!isAsyncIterable(eventStream)) {
      throw new Error(
        'Subscription field must return Async Iterable. ' +
          `Received: ${inspect(eventStream)}.`,
      );
    }

    return eventStream;
  } catch (error) {
    // If it GraphQLError, report it as an ExecutionResult, containing only errors and no data.
    // Otherwise treat the error as a system-class error and re-throw it.
    if (error instanceof GraphQLError) {
      return {
        errors: [error],
      };
    }

    throw error;
  }
}

async function executeSubscription(exeContext) {
  const { schema, fragments, operation, variableValues, rootValue } =
    exeContext;
  const rootType = schema.getSubscriptionType();

  if (rootType == null) {
    throw new GraphQLError(
      'Schema is not configured to execute subscription operation.',
      {
        nodes: operation,
      },
    );
  }

  const rootFields = collectFields(
    schema,
    fragments,
    variableValues,
    rootType,
    operation.selectionSet,
  );
  const [responseName, fieldNodes] = [...rootFields.entries()][0];
  const fieldDef = execute_getFieldDef(schema, rootType, fieldNodes[0]);

  if (!fieldDef) {
    const fieldName = fieldNodes[0].name.value;
    throw new GraphQLError(
      `The subscription field "${fieldName}" is not defined.`,
      {
        nodes: fieldNodes,
      },
    );
  }

  const path = addPath(undefined, responseName, rootType.name);
  const info = buildResolveInfo(
    exeContext,
    fieldDef,
    fieldNodes,
    rootType,
    path,
  );

  try {
    var _fieldDef$subscribe;

    // Implements the "ResolveFieldEventStream" algorithm from GraphQL specification.
    // It differs from "ResolveFieldValue" due to providing a different `resolveFn`.
    // Build a JS object of arguments from the field.arguments AST, using the
    // variables scope to fulfill any variable references.
    const args = getArgumentValues(fieldDef, fieldNodes[0], variableValues); // The resolve function's optional third argument is a context value that
    // is provided to every resolve function within an execution. It is commonly
    // used to represent an authenticated user, or request-specific caches.

    const contextValue = exeContext.contextValue; // Call the `subscribe()` resolver or the default resolver to produce an
    // AsyncIterable yielding raw payloads.

    const resolveFn =
      (_fieldDef$subscribe = fieldDef.subscribe) !== null &&
      _fieldDef$subscribe !== void 0
        ? _fieldDef$subscribe
        : exeContext.subscribeFieldResolver;
    const eventStream = await resolveFn(rootValue, args, contextValue, info);

    if (eventStream instanceof Error) {
      throw eventStream;
    }

    return eventStream;
  } catch (error) {
    throw locatedError(error, fieldNodes, pathToArray(path));
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/custom/NoDeprecatedCustomRule.mjs




/**
 * No deprecated
 *
 * A GraphQL document is only valid if all selected fields and all used enum values have not been
 * deprecated.
 *
 * Note: This rule is optional and is not part of the Validation section of the GraphQL
 * Specification. The main purpose of this rule is detection of deprecated usages and not
 * necessarily to forbid their use when querying a service.
 */
function NoDeprecatedCustomRule(context) {
  return {
    Field(node) {
      const fieldDef = context.getFieldDef();
      const deprecationReason =
        fieldDef === null || fieldDef === void 0
          ? void 0
          : fieldDef.deprecationReason;

      if (fieldDef && deprecationReason != null) {
        const parentType = context.getParentType();
        parentType != null || invariant(false);
        context.reportError(
          new GraphQLError(
            `The field ${parentType.name}.${fieldDef.name} is deprecated. ${deprecationReason}`,
            {
              nodes: node,
            },
          ),
        );
      }
    },

    Argument(node) {
      const argDef = context.getArgument();
      const deprecationReason =
        argDef === null || argDef === void 0
          ? void 0
          : argDef.deprecationReason;

      if (argDef && deprecationReason != null) {
        const directiveDef = context.getDirective();

        if (directiveDef != null) {
          context.reportError(
            new GraphQLError(
              `Directive "@${directiveDef.name}" argument "${argDef.name}" is deprecated. ${deprecationReason}`,
              {
                nodes: node,
              },
            ),
          );
        } else {
          const parentType = context.getParentType();
          const fieldDef = context.getFieldDef();
          (parentType != null && fieldDef != null) || invariant(false);
          context.reportError(
            new GraphQLError(
              `Field "${parentType.name}.${fieldDef.name}" argument "${argDef.name}" is deprecated. ${deprecationReason}`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },

    ObjectField(node) {
      const inputObjectDef = getNamedType(context.getParentInputType());

      if (isInputObjectType(inputObjectDef)) {
        const inputFieldDef = inputObjectDef.getFields()[node.name.value];
        const deprecationReason =
          inputFieldDef === null || inputFieldDef === void 0
            ? void 0
            : inputFieldDef.deprecationReason;

        if (deprecationReason != null) {
          context.reportError(
            new GraphQLError(
              `The input field ${inputObjectDef.name}.${inputFieldDef.name} is deprecated. ${deprecationReason}`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },

    EnumValue(node) {
      const enumValueDef = context.getEnumValue();
      const deprecationReason =
        enumValueDef === null || enumValueDef === void 0
          ? void 0
          : enumValueDef.deprecationReason;

      if (enumValueDef && deprecationReason != null) {
        const enumTypeDef = getNamedType(context.getInputType());
        enumTypeDef != null || invariant(false);
        context.reportError(
          new GraphQLError(
            `The enum value "${enumTypeDef.name}.${enumValueDef.name}" is deprecated. ${deprecationReason}`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/custom/NoSchemaIntrospectionCustomRule.mjs




/**
 * Prohibit introspection queries
 *
 * A GraphQL document is only valid if all fields selected are not fields that
 * return an introspection type.
 *
 * Note: This rule is optional and is not part of the Validation section of the
 * GraphQL Specification. This rule effectively disables introspection, which
 * does not reflect best practices and should only be done if absolutely necessary.
 */
function NoSchemaIntrospectionCustomRule(context) {
  return {
    Field(node) {
      const type = getNamedType(context.getType());

      if (type && isIntrospectionType(type)) {
        context.reportError(
          new GraphQLError(
            `GraphQL introspection has been disabled, but the requested query contained the field "${node.name.value}".`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/getIntrospectionQuery.mjs
/**
 * Produce the GraphQL query recommended for a full schema introspection.
 * Accepts optional IntrospectionOptions.
 */
function getIntrospectionQuery(options) {
  const optionsWithDefault = {
    descriptions: true,
    specifiedByUrl: false,
    directiveIsRepeatable: false,
    schemaDescription: false,
    inputValueDeprecation: false,
    ...options,
  };
  const descriptions = optionsWithDefault.descriptions ? 'description' : '';
  const specifiedByUrl = optionsWithDefault.specifiedByUrl
    ? 'specifiedByURL'
    : '';
  const directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable
    ? 'isRepeatable'
    : '';
  const schemaDescription = optionsWithDefault.schemaDescription
    ? descriptions
    : '';

  function inputDeprecation(str) {
    return optionsWithDefault.inputValueDeprecation ? str : '';
  }

  return `
    query IntrospectionQuery {
      __schema {
        ${schemaDescription}
        queryType { name }
        mutationType { name }
        subscriptionType { name }
        types {
          ...FullType
        }
        directives {
          name
          ${descriptions}
          ${directiveIsRepeatable}
          locations
          args${inputDeprecation('(includeDeprecated: true)')} {
            ...InputValue
          }
        }
      }
    }

    fragment FullType on __Type {
      kind
      name
      ${descriptions}
      ${specifiedByUrl}
      fields(includeDeprecated: true) {
        name
        ${descriptions}
        args${inputDeprecation('(includeDeprecated: true)')} {
          ...InputValue
        }
        type {
          ...TypeRef
        }
        isDeprecated
        deprecationReason
      }
      inputFields${inputDeprecation('(includeDeprecated: true)')} {
        ...InputValue
      }
      interfaces {
        ...TypeRef
      }
      enumValues(includeDeprecated: true) {
        name
        ${descriptions}
        isDeprecated
        deprecationReason
      }
      possibleTypes {
        ...TypeRef
      }
    }

    fragment InputValue on __InputValue {
      name
      ${descriptions}
      type { ...TypeRef }
      defaultValue
      ${inputDeprecation('isDeprecated')}
      ${inputDeprecation('deprecationReason')}
    }

    fragment TypeRef on __Type {
      kind
      name
      ofType {
        kind
        name
        ofType {
          kind
          name
          ofType {
            kind
            name
            ofType {
              kind
              name
              ofType {
                kind
                name
                ofType {
                  kind
                  name
                  ofType {
                    kind
                    name
                    ofType {
                      kind
                      name
                      ofType {
                        kind
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/getOperationAST.mjs

/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */

function getOperationAST(documentAST, operationName) {
  let operation = null;

  for (const definition of documentAST.definitions) {
    if (definition.kind === Kind.OPERATION_DEFINITION) {
      var _definition$name;

      if (operationName == null) {
        // If no operation name was provided, only return an Operation if there
        // is one defined in the document. Upon encountering the second, return
        // null.
        if (operation) {
          return null;
        }

        operation = definition;
      } else if (
        ((_definition$name = definition.name) === null ||
        _definition$name === void 0
          ? void 0
          : _definition$name.value) === operationName
      ) {
        return definition;
      }
    }
  }

  return operation;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/getOperationRootType.mjs


/**
 * Extracts the root type of the operation from the schema.
 *
 * @deprecated Please use `GraphQLSchema.getRootType` instead. Will be removed in v17
 */
function getOperationRootType(schema, operation) {
  if (operation.operation === 'query') {
    const queryType = schema.getQueryType();

    if (!queryType) {
      throw new GraphQLError(
        'Schema does not define the required query root type.',
        {
          nodes: operation,
        },
      );
    }

    return queryType;
  }

  if (operation.operation === 'mutation') {
    const mutationType = schema.getMutationType();

    if (!mutationType) {
      throw new GraphQLError('Schema is not configured for mutations.', {
        nodes: operation,
      });
    }

    return mutationType;
  }

  if (operation.operation === 'subscription') {
    const subscriptionType = schema.getSubscriptionType();

    if (!subscriptionType) {
      throw new GraphQLError('Schema is not configured for subscriptions.', {
        nodes: operation,
      });
    }

    return subscriptionType;
  }

  throw new GraphQLError(
    'Can only have query, mutation and subscription operations.',
    {
      nodes: operation,
    },
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/introspectionFromSchema.mjs




/**
 * Build an IntrospectionQuery from a GraphQLSchema
 *
 * IntrospectionQuery is useful for utilities that care about type and field
 * relationships, but do not need to traverse through those relationships.
 *
 * This is the inverse of buildClientSchema. The primary use case is outside
 * of the server context, for instance when doing schema comparisons.
 */

function introspectionFromSchema(schema, options) {
  const optionsWithDefaults = {
    specifiedByUrl: true,
    directiveIsRepeatable: true,
    schemaDescription: true,
    inputValueDeprecation: true,
    ...options,
  };
  const document = parse(getIntrospectionQuery(optionsWithDefaults));
  const result = executeSync({
    schema,
    document,
  });
  (!result.errors && result.data) || invariant(false);
  return result.data;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/buildClientSchema.mjs











/**
 * Build a GraphQLSchema for use by client tools.
 *
 * Given the result of a client running the introspection query, creates and
 * returns a GraphQLSchema instance which can be then used with all graphql-js
 * tools, but cannot be used to execute a query, as introspection does not
 * represent the "resolver", "parse" or "serialize" functions or any other
 * server-internal mechanisms.
 *
 * This function expects a complete introspection result. Don't forget to check
 * the "errors" field of a server response before calling this function.
 */

function buildClientSchema(introspection, options) {
  (isObjectLike(introspection) && isObjectLike(introspection.__schema)) ||
    devAssert(
      false,
      `Invalid or incomplete introspection result. Ensure that you are passing "data" property of introspection response and no "errors" was returned alongside: ${inspect(
        introspection,
      )}.`,
    ); // Get the schema from the introspection result.

  const schemaIntrospection = introspection.__schema; // Iterate through all types, getting the type definition for each.

  const typeMap = keyValMap(
    schemaIntrospection.types,
    (typeIntrospection) => typeIntrospection.name,
    (typeIntrospection) => buildType(typeIntrospection),
  ); // Include standard types only if they are used.

  for (const stdType of [...specifiedScalarTypes, ...introspectionTypes]) {
    if (typeMap[stdType.name]) {
      typeMap[stdType.name] = stdType;
    }
  } // Get the root Query, Mutation, and Subscription types.

  const queryType = schemaIntrospection.queryType
    ? getObjectType(schemaIntrospection.queryType)
    : null;
  const mutationType = schemaIntrospection.mutationType
    ? getObjectType(schemaIntrospection.mutationType)
    : null;
  const subscriptionType = schemaIntrospection.subscriptionType
    ? getObjectType(schemaIntrospection.subscriptionType)
    : null; // Get the directives supported by Introspection, assuming empty-set if
  // directives were not queried for.

  const directives = schemaIntrospection.directives
    ? schemaIntrospection.directives.map(buildDirective)
    : []; // Then produce and return a Schema with these types.

  return new GraphQLSchema({
    description: schemaIntrospection.description,
    query: queryType,
    mutation: mutationType,
    subscription: subscriptionType,
    types: Object.values(typeMap),
    directives,
    assumeValid:
      options === null || options === void 0 ? void 0 : options.assumeValid,
  }); // Given a type reference in introspection, return the GraphQLType instance.
  // preferring cached instances before building new instances.

  function getType(typeRef) {
    if (typeRef.kind === TypeKind.LIST) {
      const itemRef = typeRef.ofType;

      if (!itemRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }

      return new GraphQLList(getType(itemRef));
    }

    if (typeRef.kind === TypeKind.NON_NULL) {
      const nullableRef = typeRef.ofType;

      if (!nullableRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }

      const nullableType = getType(nullableRef);
      return new GraphQLNonNull(assertNullableType(nullableType));
    }

    return getNamedType(typeRef);
  }

  function getNamedType(typeRef) {
    const typeName = typeRef.name;

    if (!typeName) {
      throw new Error(`Unknown type reference: ${inspect(typeRef)}.`);
    }

    const type = typeMap[typeName];

    if (!type) {
      throw new Error(
        `Invalid or incomplete schema, unknown type: ${typeName}. Ensure that a full introspection query is used in order to build a client schema.`,
      );
    }

    return type;
  }

  function getObjectType(typeRef) {
    return assertObjectType(getNamedType(typeRef));
  }

  function getInterfaceType(typeRef) {
    return assertInterfaceType(getNamedType(typeRef));
  } // Given a type's introspection result, construct the correct
  // GraphQLType instance.

  function buildType(type) {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (type != null && type.name != null && type.kind != null) {
      // FIXME: Properly type IntrospectionType, it's a breaking change so fix in v17
      // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
      switch (type.kind) {
        case TypeKind.SCALAR:
          return buildScalarDef(type);

        case TypeKind.OBJECT:
          return buildObjectDef(type);

        case TypeKind.INTERFACE:
          return buildInterfaceDef(type);

        case TypeKind.UNION:
          return buildUnionDef(type);

        case TypeKind.ENUM:
          return buildEnumDef(type);

        case TypeKind.INPUT_OBJECT:
          return buildInputObjectDef(type);
      }
    }

    const typeStr = inspect(type);
    throw new Error(
      `Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ${typeStr}.`,
    );
  }

  function buildScalarDef(scalarIntrospection) {
    return new GraphQLScalarType({
      name: scalarIntrospection.name,
      description: scalarIntrospection.description,
      specifiedByURL: scalarIntrospection.specifiedByURL,
    });
  }

  function buildImplementationsList(implementingIntrospection) {
    // TODO: Temporary workaround until GraphQL ecosystem will fully support
    // 'interfaces' on interface types.
    if (
      implementingIntrospection.interfaces === null &&
      implementingIntrospection.kind === TypeKind.INTERFACE
    ) {
      return [];
    }

    if (!implementingIntrospection.interfaces) {
      const implementingIntrospectionStr = inspect(implementingIntrospection);
      throw new Error(
        `Introspection result missing interfaces: ${implementingIntrospectionStr}.`,
      );
    }

    return implementingIntrospection.interfaces.map(getInterfaceType);
  }

  function buildObjectDef(objectIntrospection) {
    return new GraphQLObjectType({
      name: objectIntrospection.name,
      description: objectIntrospection.description,
      interfaces: () => buildImplementationsList(objectIntrospection),
      fields: () => buildFieldDefMap(objectIntrospection),
    });
  }

  function buildInterfaceDef(interfaceIntrospection) {
    return new GraphQLInterfaceType({
      name: interfaceIntrospection.name,
      description: interfaceIntrospection.description,
      interfaces: () => buildImplementationsList(interfaceIntrospection),
      fields: () => buildFieldDefMap(interfaceIntrospection),
    });
  }

  function buildUnionDef(unionIntrospection) {
    if (!unionIntrospection.possibleTypes) {
      const unionIntrospectionStr = inspect(unionIntrospection);
      throw new Error(
        `Introspection result missing possibleTypes: ${unionIntrospectionStr}.`,
      );
    }

    return new GraphQLUnionType({
      name: unionIntrospection.name,
      description: unionIntrospection.description,
      types: () => unionIntrospection.possibleTypes.map(getObjectType),
    });
  }

  function buildEnumDef(enumIntrospection) {
    if (!enumIntrospection.enumValues) {
      const enumIntrospectionStr = inspect(enumIntrospection);
      throw new Error(
        `Introspection result missing enumValues: ${enumIntrospectionStr}.`,
      );
    }

    return new GraphQLEnumType({
      name: enumIntrospection.name,
      description: enumIntrospection.description,
      values: keyValMap(
        enumIntrospection.enumValues,
        (valueIntrospection) => valueIntrospection.name,
        (valueIntrospection) => ({
          description: valueIntrospection.description,
          deprecationReason: valueIntrospection.deprecationReason,
        }),
      ),
    });
  }

  function buildInputObjectDef(inputObjectIntrospection) {
    if (!inputObjectIntrospection.inputFields) {
      const inputObjectIntrospectionStr = inspect(inputObjectIntrospection);
      throw new Error(
        `Introspection result missing inputFields: ${inputObjectIntrospectionStr}.`,
      );
    }

    return new GraphQLInputObjectType({
      name: inputObjectIntrospection.name,
      description: inputObjectIntrospection.description,
      fields: () => buildInputValueDefMap(inputObjectIntrospection.inputFields),
    });
  }

  function buildFieldDefMap(typeIntrospection) {
    if (!typeIntrospection.fields) {
      throw new Error(
        `Introspection result missing fields: ${inspect(typeIntrospection)}.`,
      );
    }

    return keyValMap(
      typeIntrospection.fields,
      (fieldIntrospection) => fieldIntrospection.name,
      buildField,
    );
  }

  function buildField(fieldIntrospection) {
    const type = getType(fieldIntrospection.type);

    if (!isOutputType(type)) {
      const typeStr = inspect(type);
      throw new Error(
        `Introspection must provide output type for fields, but received: ${typeStr}.`,
      );
    }

    if (!fieldIntrospection.args) {
      const fieldIntrospectionStr = inspect(fieldIntrospection);
      throw new Error(
        `Introspection result missing field args: ${fieldIntrospectionStr}.`,
      );
    }

    return {
      description: fieldIntrospection.description,
      deprecationReason: fieldIntrospection.deprecationReason,
      type,
      args: buildInputValueDefMap(fieldIntrospection.args),
    };
  }

  function buildInputValueDefMap(inputValueIntrospections) {
    return keyValMap(
      inputValueIntrospections,
      (inputValue) => inputValue.name,
      buildInputValue,
    );
  }

  function buildInputValue(inputValueIntrospection) {
    const type = getType(inputValueIntrospection.type);

    if (!isInputType(type)) {
      const typeStr = inspect(type);
      throw new Error(
        `Introspection must provide input type for arguments, but received: ${typeStr}.`,
      );
    }

    const defaultValue =
      inputValueIntrospection.defaultValue != null
        ? valueFromAST(parseValue(inputValueIntrospection.defaultValue), type)
        : undefined;
    return {
      description: inputValueIntrospection.description,
      type,
      defaultValue,
      deprecationReason: inputValueIntrospection.deprecationReason,
    };
  }

  function buildDirective(directiveIntrospection) {
    if (!directiveIntrospection.args) {
      const directiveIntrospectionStr = inspect(directiveIntrospection);
      throw new Error(
        `Introspection result missing directive args: ${directiveIntrospectionStr}.`,
      );
    }

    if (!directiveIntrospection.locations) {
      const directiveIntrospectionStr = inspect(directiveIntrospection);
      throw new Error(
        `Introspection result missing directive locations: ${directiveIntrospectionStr}.`,
      );
    }

    return new GraphQLDirective({
      name: directiveIntrospection.name,
      description: directiveIntrospection.description,
      isRepeatable: directiveIntrospection.isRepeatable,
      locations: directiveIntrospection.locations.slice(),
      args: buildInputValueDefMap(directiveIntrospection.args),
    });
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/extendSchema.mjs
















/**
 * Produces a new schema given an existing schema and a document which may
 * contain GraphQL type extensions and definitions. The original schema will
 * remain unaltered.
 *
 * Because a schema represents a graph of references, a schema cannot be
 * extended without effectively making an entire copy. We do not know until it's
 * too late if subgraphs remain unchanged.
 *
 * This algorithm copies the provided schema, applying extensions while
 * producing the copy. The original schema remains unaltered.
 */
function extendSchema(schema, documentAST, options) {
  assertSchema(schema);
  (documentAST != null && documentAST.kind === Kind.DOCUMENT) ||
    devAssert(false, 'Must provide valid Document AST.');

  if (
    (options === null || options === void 0 ? void 0 : options.assumeValid) !==
      true &&
    (options === null || options === void 0
      ? void 0
      : options.assumeValidSDL) !== true
  ) {
    assertValidSDLExtension(documentAST, schema);
  }

  const schemaConfig = schema.toConfig();
  const extendedConfig = extendSchemaImpl(schemaConfig, documentAST, options);
  return schemaConfig === extendedConfig
    ? schema
    : new GraphQLSchema(extendedConfig);
}
/**
 * @internal
 */

function extendSchemaImpl(schemaConfig, documentAST, options) {
  var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;

  // Collect the type definitions and extensions found in the document.
  const typeDefs = [];
  const typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
  // have the same name. For example, a type named "skip".

  const directiveDefs = [];
  let schemaDef; // Schema extensions are collected which may add additional operation types.

  const schemaExtensions = [];

  for (const def of documentAST.definitions) {
    if (def.kind === Kind.SCHEMA_DEFINITION) {
      schemaDef = def;
    } else if (def.kind === Kind.SCHEMA_EXTENSION) {
      schemaExtensions.push(def);
    } else if (isTypeDefinitionNode(def)) {
      typeDefs.push(def);
    } else if (isTypeExtensionNode(def)) {
      const extendedTypeName = def.name.value;
      const existingTypeExtensions = typeExtensionsMap[extendedTypeName];
      typeExtensionsMap[extendedTypeName] = existingTypeExtensions
        ? existingTypeExtensions.concat([def])
        : [def];
    } else if (def.kind === Kind.DIRECTIVE_DEFINITION) {
      directiveDefs.push(def);
    }
  } // If this document contains no new types, extensions, or directives then
  // return the same unmodified GraphQLSchema instance.

  if (
    Object.keys(typeExtensionsMap).length === 0 &&
    typeDefs.length === 0 &&
    directiveDefs.length === 0 &&
    schemaExtensions.length === 0 &&
    schemaDef == null
  ) {
    return schemaConfig;
  }

  const typeMap = Object.create(null);

  for (const existingType of schemaConfig.types) {
    typeMap[existingType.name] = extendNamedType(existingType);
  }

  for (const typeNode of typeDefs) {
    var _stdTypeMap$name;

    const name = typeNode.name.value;
    typeMap[name] =
      (_stdTypeMap$name = stdTypeMap[name]) !== null &&
      _stdTypeMap$name !== void 0
        ? _stdTypeMap$name
        : buildType(typeNode);
  }

  const operationTypes = {
    // Get the extended root operation types.
    query: schemaConfig.query && replaceNamedType(schemaConfig.query),
    mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
    subscription:
      schemaConfig.subscription && replaceNamedType(schemaConfig.subscription),
    // Then, incorporate schema definition and all schema extensions.
    ...(schemaDef && getOperationTypes([schemaDef])),
    ...getOperationTypes(schemaExtensions),
  }; // Then produce and return a Schema config with these types.

  return {
    description:
      (_schemaDef = schemaDef) === null || _schemaDef === void 0
        ? void 0
        : (_schemaDef$descriptio = _schemaDef.description) === null ||
          _schemaDef$descriptio === void 0
        ? void 0
        : _schemaDef$descriptio.value,
    ...operationTypes,
    types: Object.values(typeMap),
    directives: [
      ...schemaConfig.directives.map(replaceDirective),
      ...directiveDefs.map(buildDirective),
    ],
    extensions: Object.create(null),
    astNode:
      (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0
        ? _schemaDef2
        : schemaConfig.astNode,
    extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
    assumeValid:
      (_options$assumeValid =
        options === null || options === void 0
          ? void 0
          : options.assumeValid) !== null && _options$assumeValid !== void 0
        ? _options$assumeValid
        : false,
  }; // Below are functions used for producing this schema that have closed over
  // this scope and have access to the schema, cache, and newly defined types.

  function replaceType(type) {
    if (isListType(type)) {
      // @ts-expect-error
      return new GraphQLList(replaceType(type.ofType));
    }

    if (isNonNullType(type)) {
      // @ts-expect-error
      return new GraphQLNonNull(replaceType(type.ofType));
    } // @ts-expect-error FIXME

    return replaceNamedType(type);
  }

  function replaceNamedType(type) {
    // Note: While this could make early assertions to get the correctly
    // typed values, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.
    return typeMap[type.name];
  }

  function replaceDirective(directive) {
    const config = directive.toConfig();
    return new GraphQLDirective({
      ...config,
      args: mapValue(config.args, extendArg),
    });
  }

  function extendNamedType(type) {
    if (isIntrospectionType(type) || isSpecifiedScalarType(type)) {
      // Builtin types are not extended.
      return type;
    }

    if (isScalarType(type)) {
      return extendScalarType(type);
    }

    if (isObjectType(type)) {
      return extendObjectType(type);
    }

    if (isInterfaceType(type)) {
      return extendInterfaceType(type);
    }

    if (isUnionType(type)) {
      return extendUnionType(type);
    }

    if (isEnumType(type)) {
      return extendEnumType(type);
    }

    if (isInputObjectType(type)) {
      return extendInputObjectType(type);
    }
    /* c8 ignore next 3 */
    // Not reachable, all possible type definition nodes have been considered.

     false || invariant(false, 'Unexpected type: ' + inspect(type));
  }

  function extendInputObjectType(type) {
    var _typeExtensionsMap$co;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co !== void 0
        ? _typeExtensionsMap$co
        : [];
    return new GraphQLInputObjectType({
      ...config,
      fields: () => ({
        ...mapValue(config.fields, (field) => ({
          ...field,
          type: replaceType(field.type),
        })),
        ...buildInputFieldMap(extensions),
      }),
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendEnumType(type) {
    var _typeExtensionsMap$ty;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null &&
      _typeExtensionsMap$ty !== void 0
        ? _typeExtensionsMap$ty
        : [];
    return new GraphQLEnumType({
      ...config,
      values: { ...config.values, ...buildEnumValueMap(extensions) },
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendScalarType(type) {
    var _typeExtensionsMap$co2;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co2 !== void 0
        ? _typeExtensionsMap$co2
        : [];
    let specifiedByURL = config.specifiedByURL;

    for (const extensionNode of extensions) {
      var _getSpecifiedByURL;

      specifiedByURL =
        (_getSpecifiedByURL = getSpecifiedByURL(extensionNode)) !== null &&
        _getSpecifiedByURL !== void 0
          ? _getSpecifiedByURL
          : specifiedByURL;
    }

    return new GraphQLScalarType({
      ...config,
      specifiedByURL,
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendObjectType(type) {
    var _typeExtensionsMap$co3;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co3 !== void 0
        ? _typeExtensionsMap$co3
        : [];
    return new GraphQLObjectType({
      ...config,
      interfaces: () => [
        ...type.getInterfaces().map(replaceNamedType),
        ...buildInterfaces(extensions),
      ],
      fields: () => ({
        ...mapValue(config.fields, extendField),
        ...buildFieldMap(extensions),
      }),
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendInterfaceType(type) {
    var _typeExtensionsMap$co4;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co4 !== void 0
        ? _typeExtensionsMap$co4
        : [];
    return new GraphQLInterfaceType({
      ...config,
      interfaces: () => [
        ...type.getInterfaces().map(replaceNamedType),
        ...buildInterfaces(extensions),
      ],
      fields: () => ({
        ...mapValue(config.fields, extendField),
        ...buildFieldMap(extensions),
      }),
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendUnionType(type) {
    var _typeExtensionsMap$co5;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co5 !== void 0
        ? _typeExtensionsMap$co5
        : [];
    return new GraphQLUnionType({
      ...config,
      types: () => [
        ...type.getTypes().map(replaceNamedType),
        ...buildUnionTypes(extensions),
      ],
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendField(field) {
    return {
      ...field,
      type: replaceType(field.type),
      args: field.args && mapValue(field.args, extendArg),
    };
  }

  function extendArg(arg) {
    return { ...arg, type: replaceType(arg.type) };
  }

  function getOperationTypes(nodes) {
    const opTypes = {};

    for (const node of nodes) {
      var _node$operationTypes;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const operationTypesNodes =
        /* c8 ignore next */
        (_node$operationTypes = node.operationTypes) !== null &&
        _node$operationTypes !== void 0
          ? _node$operationTypes
          : [];

      for (const operationType of operationTypesNodes) {
        // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        // @ts-expect-error
        opTypes[operationType.operation] = getNamedType(operationType.type);
      }
    }

    return opTypes;
  }

  function getNamedType(node) {
    var _stdTypeMap$name2;

    const name = node.name.value;
    const type =
      (_stdTypeMap$name2 = stdTypeMap[name]) !== null &&
      _stdTypeMap$name2 !== void 0
        ? _stdTypeMap$name2
        : typeMap[name];

    if (type === undefined) {
      throw new Error(`Unknown type: "${name}".`);
    }

    return type;
  }

  function getWrappedType(node) {
    if (node.kind === Kind.LIST_TYPE) {
      return new GraphQLList(getWrappedType(node.type));
    }

    if (node.kind === Kind.NON_NULL_TYPE) {
      return new GraphQLNonNull(getWrappedType(node.type));
    }

    return getNamedType(node);
  }

  function buildDirective(node) {
    var _node$description;

    return new GraphQLDirective({
      name: node.name.value,
      description:
        (_node$description = node.description) === null ||
        _node$description === void 0
          ? void 0
          : _node$description.value,
      // @ts-expect-error
      locations: node.locations.map(({ value }) => value),
      isRepeatable: node.repeatable,
      args: buildArgumentMap(node.arguments),
      astNode: node,
    });
  }

  function buildFieldMap(nodes) {
    const fieldConfigMap = Object.create(null);

    for (const node of nodes) {
      var _node$fields;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const nodeFields =
        /* c8 ignore next */
        (_node$fields = node.fields) !== null && _node$fields !== void 0
          ? _node$fields
          : [];

      for (const field of nodeFields) {
        var _field$description;

        fieldConfigMap[field.name.value] = {
          // Note: While this could make assertions to get the correctly typed
          // value, that would throw immediately while type system validation
          // with validateSchema() will produce more actionable results.
          type: getWrappedType(field.type),
          description:
            (_field$description = field.description) === null ||
            _field$description === void 0
              ? void 0
              : _field$description.value,
          args: buildArgumentMap(field.arguments),
          deprecationReason: getDeprecationReason(field),
          astNode: field,
        };
      }
    }

    return fieldConfigMap;
  }

  function buildArgumentMap(args) {
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    const argsNodes =
      /* c8 ignore next */
      args !== null && args !== void 0 ? args : [];
    const argConfigMap = Object.create(null);

    for (const arg of argsNodes) {
      var _arg$description;

      // Note: While this could make assertions to get the correctly typed
      // value, that would throw immediately while type system validation
      // with validateSchema() will produce more actionable results.
      const type = getWrappedType(arg.type);
      argConfigMap[arg.name.value] = {
        type,
        description:
          (_arg$description = arg.description) === null ||
          _arg$description === void 0
            ? void 0
            : _arg$description.value,
        defaultValue: valueFromAST(arg.defaultValue, type),
        deprecationReason: getDeprecationReason(arg),
        astNode: arg,
      };
    }

    return argConfigMap;
  }

  function buildInputFieldMap(nodes) {
    const inputFieldMap = Object.create(null);

    for (const node of nodes) {
      var _node$fields2;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const fieldsNodes =
        /* c8 ignore next */
        (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0
          ? _node$fields2
          : [];

      for (const field of fieldsNodes) {
        var _field$description2;

        // Note: While this could make assertions to get the correctly typed
        // value, that would throw immediately while type system validation
        // with validateSchema() will produce more actionable results.
        const type = getWrappedType(field.type);
        inputFieldMap[field.name.value] = {
          type,
          description:
            (_field$description2 = field.description) === null ||
            _field$description2 === void 0
              ? void 0
              : _field$description2.value,
          defaultValue: valueFromAST(field.defaultValue, type),
          deprecationReason: getDeprecationReason(field),
          astNode: field,
        };
      }
    }

    return inputFieldMap;
  }

  function buildEnumValueMap(nodes) {
    const enumValueMap = Object.create(null);

    for (const node of nodes) {
      var _node$values;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const valuesNodes =
        /* c8 ignore next */
        (_node$values = node.values) !== null && _node$values !== void 0
          ? _node$values
          : [];

      for (const value of valuesNodes) {
        var _value$description;

        enumValueMap[value.name.value] = {
          description:
            (_value$description = value.description) === null ||
            _value$description === void 0
              ? void 0
              : _value$description.value,
          deprecationReason: getDeprecationReason(value),
          astNode: value,
        };
      }
    }

    return enumValueMap;
  }

  function buildInterfaces(nodes) {
    // Note: While this could make assertions to get the correctly typed
    // values below, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.
    // @ts-expect-error
    return nodes.flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      (node) => {
        var _node$interfaces$map, _node$interfaces;

        return (
          /* c8 ignore next */
          (_node$interfaces$map =
            (_node$interfaces = node.interfaces) === null ||
            _node$interfaces === void 0
              ? void 0
              : _node$interfaces.map(getNamedType)) !== null &&
            _node$interfaces$map !== void 0
            ? _node$interfaces$map
            : []
        );
      },
    );
  }

  function buildUnionTypes(nodes) {
    // Note: While this could make assertions to get the correctly typed
    // values below, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.
    // @ts-expect-error
    return nodes.flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      (node) => {
        var _node$types$map, _node$types;

        return (
          /* c8 ignore next */
          (_node$types$map =
            (_node$types = node.types) === null || _node$types === void 0
              ? void 0
              : _node$types.map(getNamedType)) !== null &&
            _node$types$map !== void 0
            ? _node$types$map
            : []
        );
      },
    );
  }

  function buildType(astNode) {
    var _typeExtensionsMap$na;

    const name = astNode.name.value;
    const extensionASTNodes =
      (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null &&
      _typeExtensionsMap$na !== void 0
        ? _typeExtensionsMap$na
        : [];

    switch (astNode.kind) {
      case Kind.OBJECT_TYPE_DEFINITION: {
        var _astNode$description;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLObjectType({
          name,
          description:
            (_astNode$description = astNode.description) === null ||
            _astNode$description === void 0
              ? void 0
              : _astNode$description.value,
          interfaces: () => buildInterfaces(allNodes),
          fields: () => buildFieldMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case Kind.INTERFACE_TYPE_DEFINITION: {
        var _astNode$description2;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLInterfaceType({
          name,
          description:
            (_astNode$description2 = astNode.description) === null ||
            _astNode$description2 === void 0
              ? void 0
              : _astNode$description2.value,
          interfaces: () => buildInterfaces(allNodes),
          fields: () => buildFieldMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case Kind.ENUM_TYPE_DEFINITION: {
        var _astNode$description3;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLEnumType({
          name,
          description:
            (_astNode$description3 = astNode.description) === null ||
            _astNode$description3 === void 0
              ? void 0
              : _astNode$description3.value,
          values: buildEnumValueMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case Kind.UNION_TYPE_DEFINITION: {
        var _astNode$description4;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLUnionType({
          name,
          description:
            (_astNode$description4 = astNode.description) === null ||
            _astNode$description4 === void 0
              ? void 0
              : _astNode$description4.value,
          types: () => buildUnionTypes(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case Kind.SCALAR_TYPE_DEFINITION: {
        var _astNode$description5;

        return new GraphQLScalarType({
          name,
          description:
            (_astNode$description5 = astNode.description) === null ||
            _astNode$description5 === void 0
              ? void 0
              : _astNode$description5.value,
          specifiedByURL: getSpecifiedByURL(astNode),
          astNode,
          extensionASTNodes,
        });
      }

      case Kind.INPUT_OBJECT_TYPE_DEFINITION: {
        var _astNode$description6;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLInputObjectType({
          name,
          description:
            (_astNode$description6 = astNode.description) === null ||
            _astNode$description6 === void 0
              ? void 0
              : _astNode$description6.value,
          fields: () => buildInputFieldMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }
    }
  }
}
const stdTypeMap = keyMap(
  [...specifiedScalarTypes, ...introspectionTypes],
  (type) => type.name,
);
/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */

function getDeprecationReason(node) {
  const deprecated = getDirectiveValues(GraphQLDeprecatedDirective, node); // @ts-expect-error validated by `getDirectiveValues`

  return deprecated === null || deprecated === void 0
    ? void 0
    : deprecated.reason;
}
/**
 * Given a scalar node, returns the string value for the specifiedByURL.
 */

function getSpecifiedByURL(node) {
  const specifiedBy = getDirectiveValues(GraphQLSpecifiedByDirective, node); // @ts-expect-error validated by `getDirectiveValues`

  return specifiedBy === null || specifiedBy === void 0
    ? void 0
    : specifiedBy.url;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/buildASTSchema.mjs








/**
 * This takes the ast of a schema document produced by the parse function in
 * src/language/parser.js.
 *
 * If no schema definition is provided, then it will look for types named Query,
 * Mutation and Subscription.
 *
 * Given that AST it constructs a GraphQLSchema. The resulting schema
 * has no resolve methods, so execution will use default resolvers.
 */
function buildASTSchema(documentAST, options) {
  (documentAST != null && documentAST.kind === Kind.DOCUMENT) ||
    devAssert(false, 'Must provide valid Document AST.');

  if (
    (options === null || options === void 0 ? void 0 : options.assumeValid) !==
      true &&
    (options === null || options === void 0
      ? void 0
      : options.assumeValidSDL) !== true
  ) {
    assertValidSDL(documentAST);
  }

  const emptySchemaConfig = {
    description: undefined,
    types: [],
    directives: [],
    extensions: Object.create(null),
    extensionASTNodes: [],
    assumeValid: false,
  };
  const config = extendSchemaImpl(emptySchemaConfig, documentAST, options);

  if (config.astNode == null) {
    for (const type of config.types) {
      switch (type.name) {
        // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        case 'Query':
          // @ts-expect-error validated in `validateSchema`
          config.query = type;
          break;

        case 'Mutation':
          // @ts-expect-error validated in `validateSchema`
          config.mutation = type;
          break;

        case 'Subscription':
          // @ts-expect-error validated in `validateSchema`
          config.subscription = type;
          break;
      }
    }
  }

  const directives = [
    ...config.directives, // If specified directives were not explicitly declared, add them.
    ...specifiedDirectives.filter((stdDirective) =>
      config.directives.every(
        (directive) => directive.name !== stdDirective.name,
      ),
    ),
  ];
  return new GraphQLSchema({ ...config, directives });
}
/**
 * A helper function to build a GraphQLSchema directly from a source
 * document.
 */

function buildSchema(source, options) {
  const document = parse(source, {
    noLocation:
      options === null || options === void 0 ? void 0 : options.noLocation,
    allowLegacyFragmentVariables:
      options === null || options === void 0
        ? void 0
        : options.allowLegacyFragmentVariables,
  });
  return buildASTSchema(document, {
    assumeValidSDL:
      options === null || options === void 0 ? void 0 : options.assumeValidSDL,
    assumeValid:
      options === null || options === void 0 ? void 0 : options.assumeValid,
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/lexicographicSortSchema.mjs








/**
 * Sort GraphQLSchema.
 *
 * This function returns a sorted copy of the given GraphQLSchema.
 */

function lexicographicSortSchema(schema) {
  const schemaConfig = schema.toConfig();
  const typeMap = keyValMap(
    sortByName(schemaConfig.types),
    (type) => type.name,
    sortNamedType,
  );
  return new GraphQLSchema({
    ...schemaConfig,
    types: Object.values(typeMap),
    directives: sortByName(schemaConfig.directives).map(sortDirective),
    query: replaceMaybeType(schemaConfig.query),
    mutation: replaceMaybeType(schemaConfig.mutation),
    subscription: replaceMaybeType(schemaConfig.subscription),
  });

  function replaceType(type) {
    if (isListType(type)) {
      // @ts-expect-error
      return new GraphQLList(replaceType(type.ofType));
    } else if (isNonNullType(type)) {
      // @ts-expect-error
      return new GraphQLNonNull(replaceType(type.ofType));
    } // @ts-expect-error FIXME: TS Conversion

    return replaceNamedType(type);
  }

  function replaceNamedType(type) {
    return typeMap[type.name];
  }

  function replaceMaybeType(maybeType) {
    return maybeType && replaceNamedType(maybeType);
  }

  function sortDirective(directive) {
    const config = directive.toConfig();
    return new GraphQLDirective({
      ...config,
      locations: sortBy(config.locations, (x) => x),
      args: sortArgs(config.args),
    });
  }

  function sortArgs(args) {
    return sortObjMap(args, (arg) => ({ ...arg, type: replaceType(arg.type) }));
  }

  function sortFields(fieldsMap) {
    return sortObjMap(fieldsMap, (field) => ({
      ...field,
      type: replaceType(field.type),
      args: field.args && sortArgs(field.args),
    }));
  }

  function sortInputFields(fieldsMap) {
    return sortObjMap(fieldsMap, (field) => ({
      ...field,
      type: replaceType(field.type),
    }));
  }

  function sortTypes(array) {
    return sortByName(array).map(replaceNamedType);
  }

  function sortNamedType(type) {
    if (isScalarType(type) || isIntrospectionType(type)) {
      return type;
    }

    if (isObjectType(type)) {
      const config = type.toConfig();
      return new GraphQLObjectType({
        ...config,
        interfaces: () => sortTypes(config.interfaces),
        fields: () => sortFields(config.fields),
      });
    }

    if (isInterfaceType(type)) {
      const config = type.toConfig();
      return new GraphQLInterfaceType({
        ...config,
        interfaces: () => sortTypes(config.interfaces),
        fields: () => sortFields(config.fields),
      });
    }

    if (isUnionType(type)) {
      const config = type.toConfig();
      return new GraphQLUnionType({
        ...config,
        types: () => sortTypes(config.types),
      });
    }

    if (isEnumType(type)) {
      const config = type.toConfig();
      return new GraphQLEnumType({
        ...config,
        values: sortObjMap(config.values, (value) => value),
      });
    }

    if (isInputObjectType(type)) {
      const config = type.toConfig();
      return new GraphQLInputObjectType({
        ...config,
        fields: () => sortInputFields(config.fields),
      });
    }
    /* c8 ignore next 3 */
    // Not reachable, all possible types have been considered.

     false || invariant(false, 'Unexpected type: ' + inspect(type));
  }
}

function sortObjMap(map, sortValueFn) {
  const sortedMap = Object.create(null);

  for (const key of Object.keys(map).sort(naturalCompare)) {
    sortedMap[key] = sortValueFn(map[key]);
  }

  return sortedMap;
}

function sortByName(array) {
  return sortBy(array, (obj) => obj.name);
}

function sortBy(array, mapToKey) {
  return array.slice().sort((obj1, obj2) => {
    const key1 = mapToKey(obj1);
    const key2 = mapToKey(obj2);
    return naturalCompare(key1, key2);
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/printSchema.mjs










function printSchema(schema) {
  return printFilteredSchema(
    schema,
    (n) => !isSpecifiedDirective(n),
    isDefinedType,
  );
}
function printIntrospectionSchema(schema) {
  return printFilteredSchema(schema, isSpecifiedDirective, isIntrospectionType);
}

function isDefinedType(type) {
  return !isSpecifiedScalarType(type) && !isIntrospectionType(type);
}

function printFilteredSchema(schema, directiveFilter, typeFilter) {
  const directives = schema.getDirectives().filter(directiveFilter);
  const types = Object.values(schema.getTypeMap()).filter(typeFilter);
  return [
    printSchemaDefinition(schema),
    ...directives.map((directive) => printDirective(directive)),
    ...types.map((type) => printType(type)),
  ]
    .filter(Boolean)
    .join('\n\n');
}

function printSchemaDefinition(schema) {
  if (schema.description == null && isSchemaOfCommonNames(schema)) {
    return;
  }

  const operationTypes = [];
  const queryType = schema.getQueryType();

  if (queryType) {
    operationTypes.push(`  query: ${queryType.name}`);
  }

  const mutationType = schema.getMutationType();

  if (mutationType) {
    operationTypes.push(`  mutation: ${mutationType.name}`);
  }

  const subscriptionType = schema.getSubscriptionType();

  if (subscriptionType) {
    operationTypes.push(`  subscription: ${subscriptionType.name}`);
  }

  return printDescription(schema) + `schema {\n${operationTypes.join('\n')}\n}`;
}
/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 * ```graphql
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *     subscription: Subscription
 *   }
 * ```
 *
 * When using this naming convention, the schema description can be omitted.
 */

function isSchemaOfCommonNames(schema) {
  const queryType = schema.getQueryType();

  if (queryType && queryType.name !== 'Query') {
    return false;
  }

  const mutationType = schema.getMutationType();

  if (mutationType && mutationType.name !== 'Mutation') {
    return false;
  }

  const subscriptionType = schema.getSubscriptionType();

  if (subscriptionType && subscriptionType.name !== 'Subscription') {
    return false;
  }

  return true;
}

function printType(type) {
  if (isScalarType(type)) {
    return printScalar(type);
  }

  if (isObjectType(type)) {
    return printObject(type);
  }

  if (isInterfaceType(type)) {
    return printInterface(type);
  }

  if (isUnionType(type)) {
    return printUnion(type);
  }

  if (isEnumType(type)) {
    return printEnum(type);
  }

  if (isInputObjectType(type)) {
    return printInputObject(type);
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || invariant(false, 'Unexpected type: ' + inspect(type));
}

function printScalar(type) {
  return (
    printDescription(type) + `scalar ${type.name}` + printSpecifiedByURL(type)
  );
}

function printImplementedInterfaces(type) {
  const interfaces = type.getInterfaces();
  return interfaces.length
    ? ' implements ' + interfaces.map((i) => i.name).join(' & ')
    : '';
}

function printObject(type) {
  return (
    printDescription(type) +
    `type ${type.name}` +
    printImplementedInterfaces(type) +
    printFields(type)
  );
}

function printInterface(type) {
  return (
    printDescription(type) +
    `interface ${type.name}` +
    printImplementedInterfaces(type) +
    printFields(type)
  );
}

function printUnion(type) {
  const types = type.getTypes();
  const possibleTypes = types.length ? ' = ' + types.join(' | ') : '';
  return printDescription(type) + 'union ' + type.name + possibleTypes;
}

function printEnum(type) {
  const values = type
    .getValues()
    .map(
      (value, i) =>
        printDescription(value, '  ', !i) +
        '  ' +
        value.name +
        printDeprecated(value.deprecationReason),
    );
  return printDescription(type) + `enum ${type.name}` + printBlock(values);
}

function printInputObject(type) {
  const fields = Object.values(type.getFields()).map(
    (f, i) => printDescription(f, '  ', !i) + '  ' + printInputValue(f),
  );
  return printDescription(type) + `input ${type.name}` + printBlock(fields);
}

function printFields(type) {
  const fields = Object.values(type.getFields()).map(
    (f, i) =>
      printDescription(f, '  ', !i) +
      '  ' +
      f.name +
      printArgs(f.args, '  ') +
      ': ' +
      String(f.type) +
      printDeprecated(f.deprecationReason),
  );
  return printBlock(fields);
}

function printBlock(items) {
  return items.length !== 0 ? ' {\n' + items.join('\n') + '\n}' : '';
}

function printArgs(args, indentation = '') {
  if (args.length === 0) {
    return '';
  } // If every arg does not have a description, print them on one line.

  if (args.every((arg) => !arg.description)) {
    return '(' + args.map(printInputValue).join(', ') + ')';
  }

  return (
    '(\n' +
    args
      .map(
        (arg, i) =>
          printDescription(arg, '  ' + indentation, !i) +
          '  ' +
          indentation +
          printInputValue(arg),
      )
      .join('\n') +
    '\n' +
    indentation +
    ')'
  );
}

function printInputValue(arg) {
  const defaultAST = astFromValue(arg.defaultValue, arg.type);
  let argDecl = arg.name + ': ' + String(arg.type);

  if (defaultAST) {
    argDecl += ` = ${print(defaultAST)}`;
  }

  return argDecl + printDeprecated(arg.deprecationReason);
}

function printDirective(directive) {
  return (
    printDescription(directive) +
    'directive @' +
    directive.name +
    printArgs(directive.args) +
    (directive.isRepeatable ? ' repeatable' : '') +
    ' on ' +
    directive.locations.join(' | ')
  );
}

function printDeprecated(reason) {
  if (reason == null) {
    return '';
  }

  if (reason !== DEFAULT_DEPRECATION_REASON) {
    const astValue = print({
      kind: Kind.STRING,
      value: reason,
    });
    return ` @deprecated(reason: ${astValue})`;
  }

  return ' @deprecated';
}

function printSpecifiedByURL(scalar) {
  if (scalar.specifiedByURL == null) {
    return '';
  }

  const astValue = print({
    kind: Kind.STRING,
    value: scalar.specifiedByURL,
  });
  return ` @specifiedBy(url: ${astValue})`;
}

function printDescription(def, indentation = '', firstInBlock = true) {
  const { description } = def;

  if (description == null) {
    return '';
  }

  const blockString = print({
    kind: Kind.STRING,
    value: description,
    block: isPrintableAsBlockString(description),
  });
  const prefix =
    indentation && !firstInBlock ? '\n' + indentation : indentation;
  return prefix + blockString.replace(/\n/g, '\n' + indentation) + '\n';
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/concatAST.mjs

/**
 * Provided a collection of ASTs, presumably each from different files,
 * concatenate the ASTs together into batched AST, useful for validating many
 * GraphQL source files which together represent one conceptual application.
 */

function concatAST(documents) {
  const definitions = [];

  for (const doc of documents) {
    definitions.push(...doc.definitions);
  }

  return {
    kind: Kind.DOCUMENT,
    definitions,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/separateOperations.mjs


/**
 * separateOperations accepts a single AST document which may contain many
 * operations and fragments and returns a collection of AST documents each of
 * which contains a single operation as well the fragment definitions it
 * refers to.
 */

function separateOperations(documentAST) {
  const operations = [];
  const depGraph = Object.create(null); // Populate metadata and build a dependency graph.

  for (const definitionNode of documentAST.definitions) {
    switch (definitionNode.kind) {
      case Kind.OPERATION_DEFINITION:
        operations.push(definitionNode);
        break;

      case Kind.FRAGMENT_DEFINITION:
        depGraph[definitionNode.name.value] = collectDependencies(
          definitionNode.selectionSet,
        );
        break;

      default: // ignore non-executable definitions
    }
  } // For each operation, produce a new synthesized AST which includes only what
  // is necessary for completing that operation.

  const separatedDocumentASTs = Object.create(null);

  for (const operation of operations) {
    const dependencies = new Set();

    for (const fragmentName of collectDependencies(operation.selectionSet)) {
      collectTransitiveDependencies(dependencies, depGraph, fragmentName);
    } // Provides the empty string for anonymous operations.

    const operationName = operation.name ? operation.name.value : ''; // The list of definition nodes to be included for this operation, sorted
    // to retain the same order as the original document.

    separatedDocumentASTs[operationName] = {
      kind: Kind.DOCUMENT,
      definitions: documentAST.definitions.filter(
        (node) =>
          node === operation ||
          (node.kind === Kind.FRAGMENT_DEFINITION &&
            dependencies.has(node.name.value)),
      ),
    };
  }

  return separatedDocumentASTs;
}

// From a dependency graph, collects a list of transitive dependencies by
// recursing through a dependency graph.
function collectTransitiveDependencies(collected, depGraph, fromName) {
  if (!collected.has(fromName)) {
    collected.add(fromName);
    const immediateDeps = depGraph[fromName];

    if (immediateDeps !== undefined) {
      for (const toName of immediateDeps) {
        collectTransitiveDependencies(collected, depGraph, toName);
      }
    }
  }
}

function collectDependencies(selectionSet) {
  const dependencies = [];
  visit(selectionSet, {
    FragmentSpread(node) {
      dependencies.push(node.name.value);
    },
  });
  return dependencies;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/stripIgnoredCharacters.mjs




/**
 * Strips characters that are not significant to the validity or execution
 * of a GraphQL document:
 *   - UnicodeBOM
 *   - WhiteSpace
 *   - LineTerminator
 *   - Comment
 *   - Comma
 *   - BlockString indentation
 *
 * Note: It is required to have a delimiter character between neighboring
 * non-punctuator tokens and this function always uses single space as delimiter.
 *
 * It is guaranteed that both input and output documents if parsed would result
 * in the exact same AST except for nodes location.
 *
 * Warning: It is guaranteed that this function will always produce stable results.
 * However, it's not guaranteed that it will stay the same between different
 * releases due to bugfixes or changes in the GraphQL specification.
 *
 * Query example:
 *
 * ```graphql
 * query SomeQuery($foo: String!, $bar: String) {
 *   someField(foo: $foo, bar: $bar) {
 *     a
 *     b {
 *       c
 *       d
 *     }
 *   }
 * }
 * ```
 *
 * Becomes:
 *
 * ```graphql
 * query SomeQuery($foo:String!$bar:String){someField(foo:$foo bar:$bar){a b{c d}}}
 * ```
 *
 * SDL example:
 *
 * ```graphql
 * """
 * Type description
 * """
 * type Foo {
 *   """
 *   Field description
 *   """
 *   bar: String
 * }
 * ```
 *
 * Becomes:
 *
 * ```graphql
 * """Type description""" type Foo{"""Field description""" bar:String}
 * ```
 */

function stripIgnoredCharacters(source) {
  const sourceObj = isSource(source) ? source : new Source(source);
  const body = sourceObj.body;
  const lexer = new Lexer(sourceObj);
  let strippedBody = '';
  let wasLastAddedTokenNonPunctuator = false;

  while (lexer.advance().kind !== TokenKind.EOF) {
    const currentToken = lexer.token;
    const tokenKind = currentToken.kind;
    /**
     * Every two non-punctuator tokens should have space between them.
     * Also prevent case of non-punctuator token following by spread resulting
     * in invalid token (e.g. `1...` is invalid Float token).
     */

    const isNonPunctuator = !isPunctuatorTokenKind(currentToken.kind);

    if (wasLastAddedTokenNonPunctuator) {
      if (isNonPunctuator || currentToken.kind === TokenKind.SPREAD) {
        strippedBody += ' ';
      }
    }

    const tokenBody = body.slice(currentToken.start, currentToken.end);

    if (tokenKind === TokenKind.BLOCK_STRING) {
      strippedBody += printBlockString(currentToken.value, {
        minimize: true,
      });
    } else {
      strippedBody += tokenBody;
    }

    wasLastAddedTokenNonPunctuator = isNonPunctuator;
  }

  return strippedBody;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/assertValidName.mjs



/* c8 ignore start */

/**
 * Upholds the spec rules about naming.
 * @deprecated Please use `assertName` instead. Will be removed in v17
 */

function assertValidName(name) {
  const error = isValidNameError(name);

  if (error) {
    throw error;
  }

  return name;
}
/**
 * Returns an Error if a name is invalid.
 * @deprecated Please use `assertName` instead. Will be removed in v17
 */

function isValidNameError(name) {
  typeof name === 'string' || devAssert(false, 'Expected name to be a string.');

  if (name.startsWith('__')) {
    return new GraphQLError(
      `Name "${name}" must not begin with "__", which is reserved by GraphQL introspection.`,
    );
  }

  try {
    assertName(name);
  } catch (error) {
    return error;
  }
}
/* c8 ignore stop */

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/findBreakingChanges.mjs








var BreakingChangeType;

(function (BreakingChangeType) {
  BreakingChangeType['TYPE_REMOVED'] = 'TYPE_REMOVED';
  BreakingChangeType['TYPE_CHANGED_KIND'] = 'TYPE_CHANGED_KIND';
  BreakingChangeType['TYPE_REMOVED_FROM_UNION'] = 'TYPE_REMOVED_FROM_UNION';
  BreakingChangeType['VALUE_REMOVED_FROM_ENUM'] = 'VALUE_REMOVED_FROM_ENUM';
  BreakingChangeType['REQUIRED_INPUT_FIELD_ADDED'] =
    'REQUIRED_INPUT_FIELD_ADDED';
  BreakingChangeType['IMPLEMENTED_INTERFACE_REMOVED'] =
    'IMPLEMENTED_INTERFACE_REMOVED';
  BreakingChangeType['FIELD_REMOVED'] = 'FIELD_REMOVED';
  BreakingChangeType['FIELD_CHANGED_KIND'] = 'FIELD_CHANGED_KIND';
  BreakingChangeType['REQUIRED_ARG_ADDED'] = 'REQUIRED_ARG_ADDED';
  BreakingChangeType['ARG_REMOVED'] = 'ARG_REMOVED';
  BreakingChangeType['ARG_CHANGED_KIND'] = 'ARG_CHANGED_KIND';
  BreakingChangeType['DIRECTIVE_REMOVED'] = 'DIRECTIVE_REMOVED';
  BreakingChangeType['DIRECTIVE_ARG_REMOVED'] = 'DIRECTIVE_ARG_REMOVED';
  BreakingChangeType['REQUIRED_DIRECTIVE_ARG_ADDED'] =
    'REQUIRED_DIRECTIVE_ARG_ADDED';
  BreakingChangeType['DIRECTIVE_REPEATABLE_REMOVED'] =
    'DIRECTIVE_REPEATABLE_REMOVED';
  BreakingChangeType['DIRECTIVE_LOCATION_REMOVED'] =
    'DIRECTIVE_LOCATION_REMOVED';
})(BreakingChangeType || (BreakingChangeType = {}));


var DangerousChangeType;

(function (DangerousChangeType) {
  DangerousChangeType['VALUE_ADDED_TO_ENUM'] = 'VALUE_ADDED_TO_ENUM';
  DangerousChangeType['TYPE_ADDED_TO_UNION'] = 'TYPE_ADDED_TO_UNION';
  DangerousChangeType['OPTIONAL_INPUT_FIELD_ADDED'] =
    'OPTIONAL_INPUT_FIELD_ADDED';
  DangerousChangeType['OPTIONAL_ARG_ADDED'] = 'OPTIONAL_ARG_ADDED';
  DangerousChangeType['IMPLEMENTED_INTERFACE_ADDED'] =
    'IMPLEMENTED_INTERFACE_ADDED';
  DangerousChangeType['ARG_DEFAULT_VALUE_CHANGE'] = 'ARG_DEFAULT_VALUE_CHANGE';
})(DangerousChangeType || (DangerousChangeType = {}));



/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of breaking changes covered by the other functions down below.
 */
function findBreakingChanges(oldSchema, newSchema) {
  // @ts-expect-error
  return findSchemaChanges(oldSchema, newSchema).filter(
    (change) => change.type in BreakingChangeType,
  );
}
/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of potentially dangerous changes covered by the other functions down below.
 */

function findDangerousChanges(oldSchema, newSchema) {
  // @ts-expect-error
  return findSchemaChanges(oldSchema, newSchema).filter(
    (change) => change.type in DangerousChangeType,
  );
}

function findSchemaChanges(oldSchema, newSchema) {
  return [
    ...findTypeChanges(oldSchema, newSchema),
    ...findDirectiveChanges(oldSchema, newSchema),
  ];
}

function findDirectiveChanges(oldSchema, newSchema) {
  const schemaChanges = [];
  const directivesDiff = diff(
    oldSchema.getDirectives(),
    newSchema.getDirectives(),
  );

  for (const oldDirective of directivesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.DIRECTIVE_REMOVED,
      description: `${oldDirective.name} was removed.`,
    });
  }

  for (const [oldDirective, newDirective] of directivesDiff.persisted) {
    const argsDiff = diff(oldDirective.args, newDirective.args);

    for (const newArg of argsDiff.added) {
      if (isRequiredArgument(newArg)) {
        schemaChanges.push({
          type: BreakingChangeType.REQUIRED_DIRECTIVE_ARG_ADDED,
          description: `A required arg ${newArg.name} on directive ${oldDirective.name} was added.`,
        });
      }
    }

    for (const oldArg of argsDiff.removed) {
      schemaChanges.push({
        type: BreakingChangeType.DIRECTIVE_ARG_REMOVED,
        description: `${oldArg.name} was removed from ${oldDirective.name}.`,
      });
    }

    if (oldDirective.isRepeatable && !newDirective.isRepeatable) {
      schemaChanges.push({
        type: BreakingChangeType.DIRECTIVE_REPEATABLE_REMOVED,
        description: `Repeatable flag was removed from ${oldDirective.name}.`,
      });
    }

    for (const location of oldDirective.locations) {
      if (!newDirective.locations.includes(location)) {
        schemaChanges.push({
          type: BreakingChangeType.DIRECTIVE_LOCATION_REMOVED,
          description: `${location} was removed from ${oldDirective.name}.`,
        });
      }
    }
  }

  return schemaChanges;
}

function findTypeChanges(oldSchema, newSchema) {
  const schemaChanges = [];
  const typesDiff = diff(
    Object.values(oldSchema.getTypeMap()),
    Object.values(newSchema.getTypeMap()),
  );

  for (const oldType of typesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.TYPE_REMOVED,
      description: isSpecifiedScalarType(oldType)
        ? `Standard scalar ${oldType.name} was removed because it is not referenced anymore.`
        : `${oldType.name} was removed.`,
    });
  }

  for (const [oldType, newType] of typesDiff.persisted) {
    if (isEnumType(oldType) && isEnumType(newType)) {
      schemaChanges.push(...findEnumTypeChanges(oldType, newType));
    } else if (isUnionType(oldType) && isUnionType(newType)) {
      schemaChanges.push(...findUnionTypeChanges(oldType, newType));
    } else if (isInputObjectType(oldType) && isInputObjectType(newType)) {
      schemaChanges.push(...findInputObjectTypeChanges(oldType, newType));
    } else if (isObjectType(oldType) && isObjectType(newType)) {
      schemaChanges.push(
        ...findFieldChanges(oldType, newType),
        ...findImplementedInterfacesChanges(oldType, newType),
      );
    } else if (isInterfaceType(oldType) && isInterfaceType(newType)) {
      schemaChanges.push(
        ...findFieldChanges(oldType, newType),
        ...findImplementedInterfacesChanges(oldType, newType),
      );
    } else if (oldType.constructor !== newType.constructor) {
      schemaChanges.push({
        type: BreakingChangeType.TYPE_CHANGED_KIND,
        description:
          `${oldType.name} changed from ` +
          `${typeKindName(oldType)} to ${typeKindName(newType)}.`,
      });
    }
  }

  return schemaChanges;
}

function findInputObjectTypeChanges(oldType, newType) {
  const schemaChanges = [];
  const fieldsDiff = diff(
    Object.values(oldType.getFields()),
    Object.values(newType.getFields()),
  );

  for (const newField of fieldsDiff.added) {
    if (isRequiredInputField(newField)) {
      schemaChanges.push({
        type: BreakingChangeType.REQUIRED_INPUT_FIELD_ADDED,
        description: `A required field ${newField.name} on input type ${oldType.name} was added.`,
      });
    } else {
      schemaChanges.push({
        type: DangerousChangeType.OPTIONAL_INPUT_FIELD_ADDED,
        description: `An optional field ${newField.name} on input type ${oldType.name} was added.`,
      });
    }
  }

  for (const oldField of fieldsDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.FIELD_REMOVED,
      description: `${oldType.name}.${oldField.name} was removed.`,
    });
  }

  for (const [oldField, newField] of fieldsDiff.persisted) {
    const isSafe = isChangeSafeForInputObjectFieldOrFieldArg(
      oldField.type,
      newField.type,
    );

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.FIELD_CHANGED_KIND,
        description:
          `${oldType.name}.${oldField.name} changed type from ` +
          `${String(oldField.type)} to ${String(newField.type)}.`,
      });
    }
  }

  return schemaChanges;
}

function findUnionTypeChanges(oldType, newType) {
  const schemaChanges = [];
  const possibleTypesDiff = diff(oldType.getTypes(), newType.getTypes());

  for (const newPossibleType of possibleTypesDiff.added) {
    schemaChanges.push({
      type: DangerousChangeType.TYPE_ADDED_TO_UNION,
      description: `${newPossibleType.name} was added to union type ${oldType.name}.`,
    });
  }

  for (const oldPossibleType of possibleTypesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
      description: `${oldPossibleType.name} was removed from union type ${oldType.name}.`,
    });
  }

  return schemaChanges;
}

function findEnumTypeChanges(oldType, newType) {
  const schemaChanges = [];
  const valuesDiff = diff(oldType.getValues(), newType.getValues());

  for (const newValue of valuesDiff.added) {
    schemaChanges.push({
      type: DangerousChangeType.VALUE_ADDED_TO_ENUM,
      description: `${newValue.name} was added to enum type ${oldType.name}.`,
    });
  }

  for (const oldValue of valuesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
      description: `${oldValue.name} was removed from enum type ${oldType.name}.`,
    });
  }

  return schemaChanges;
}

function findImplementedInterfacesChanges(oldType, newType) {
  const schemaChanges = [];
  const interfacesDiff = diff(oldType.getInterfaces(), newType.getInterfaces());

  for (const newInterface of interfacesDiff.added) {
    schemaChanges.push({
      type: DangerousChangeType.IMPLEMENTED_INTERFACE_ADDED,
      description: `${newInterface.name} added to interfaces implemented by ${oldType.name}.`,
    });
  }

  for (const oldInterface of interfacesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.IMPLEMENTED_INTERFACE_REMOVED,
      description: `${oldType.name} no longer implements interface ${oldInterface.name}.`,
    });
  }

  return schemaChanges;
}

function findFieldChanges(oldType, newType) {
  const schemaChanges = [];
  const fieldsDiff = diff(
    Object.values(oldType.getFields()),
    Object.values(newType.getFields()),
  );

  for (const oldField of fieldsDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.FIELD_REMOVED,
      description: `${oldType.name}.${oldField.name} was removed.`,
    });
  }

  for (const [oldField, newField] of fieldsDiff.persisted) {
    schemaChanges.push(...findArgChanges(oldType, oldField, newField));
    const isSafe = isChangeSafeForObjectOrInterfaceField(
      oldField.type,
      newField.type,
    );

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.FIELD_CHANGED_KIND,
        description:
          `${oldType.name}.${oldField.name} changed type from ` +
          `${String(oldField.type)} to ${String(newField.type)}.`,
      });
    }
  }

  return schemaChanges;
}

function findArgChanges(oldType, oldField, newField) {
  const schemaChanges = [];
  const argsDiff = diff(oldField.args, newField.args);

  for (const oldArg of argsDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.ARG_REMOVED,
      description: `${oldType.name}.${oldField.name} arg ${oldArg.name} was removed.`,
    });
  }

  for (const [oldArg, newArg] of argsDiff.persisted) {
    const isSafe = isChangeSafeForInputObjectFieldOrFieldArg(
      oldArg.type,
      newArg.type,
    );

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.ARG_CHANGED_KIND,
        description:
          `${oldType.name}.${oldField.name} arg ${oldArg.name} has changed type from ` +
          `${String(oldArg.type)} to ${String(newArg.type)}.`,
      });
    } else if (oldArg.defaultValue !== undefined) {
      if (newArg.defaultValue === undefined) {
        schemaChanges.push({
          type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
          description: `${oldType.name}.${oldField.name} arg ${oldArg.name} defaultValue was removed.`,
        });
      } else {
        // Since we looking only for client's observable changes we should
        // compare default values in the same representation as they are
        // represented inside introspection.
        const oldValueStr = findBreakingChanges_stringifyValue(oldArg.defaultValue, oldArg.type);
        const newValueStr = findBreakingChanges_stringifyValue(newArg.defaultValue, newArg.type);

        if (oldValueStr !== newValueStr) {
          schemaChanges.push({
            type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
            description: `${oldType.name}.${oldField.name} arg ${oldArg.name} has changed defaultValue from ${oldValueStr} to ${newValueStr}.`,
          });
        }
      }
    }
  }

  for (const newArg of argsDiff.added) {
    if (isRequiredArgument(newArg)) {
      schemaChanges.push({
        type: BreakingChangeType.REQUIRED_ARG_ADDED,
        description: `A required arg ${newArg.name} on ${oldType.name}.${oldField.name} was added.`,
      });
    } else {
      schemaChanges.push({
        type: DangerousChangeType.OPTIONAL_ARG_ADDED,
        description: `An optional arg ${newArg.name} on ${oldType.name}.${oldField.name} was added.`,
      });
    }
  }

  return schemaChanges;
}

function isChangeSafeForObjectOrInterfaceField(oldType, newType) {
  if (isListType(oldType)) {
    return (
      // if they're both lists, make sure the underlying types are compatible
      (isListType(newType) &&
        isChangeSafeForObjectOrInterfaceField(
          oldType.ofType,
          newType.ofType,
        )) || // moving from nullable to non-null of the same underlying type is safe
      (isNonNullType(newType) &&
        isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType))
    );
  }

  if (isNonNullType(oldType)) {
    // if they're both non-null, make sure the underlying types are compatible
    return (
      isNonNullType(newType) &&
      isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType)
    );
  }

  return (
    // if they're both named types, see if their names are equivalent
    (isNamedType(newType) && oldType.name === newType.name) || // moving from nullable to non-null of the same underlying type is safe
    (isNonNullType(newType) &&
      isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType))
  );
}

function isChangeSafeForInputObjectFieldOrFieldArg(oldType, newType) {
  if (isListType(oldType)) {
    // if they're both lists, make sure the underlying types are compatible
    return (
      isListType(newType) &&
      isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType)
    );
  }

  if (isNonNullType(oldType)) {
    return (
      // if they're both non-null, make sure the underlying types are
      // compatible
      (isNonNullType(newType) &&
        isChangeSafeForInputObjectFieldOrFieldArg(
          oldType.ofType,
          newType.ofType,
        )) || // moving from non-null to nullable of the same underlying type is safe
      (!isNonNullType(newType) &&
        isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType))
    );
  } // if they're both named types, see if their names are equivalent

  return isNamedType(newType) && oldType.name === newType.name;
}

function typeKindName(type) {
  if (isScalarType(type)) {
    return 'a Scalar type';
  }

  if (isObjectType(type)) {
    return 'an Object type';
  }

  if (isInterfaceType(type)) {
    return 'an Interface type';
  }

  if (isUnionType(type)) {
    return 'a Union type';
  }

  if (isEnumType(type)) {
    return 'an Enum type';
  }

  if (isInputObjectType(type)) {
    return 'an Input type';
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || invariant(false, 'Unexpected type: ' + inspect(type));
}

function findBreakingChanges_stringifyValue(value, type) {
  const ast = astFromValue(value, type);
  ast != null || invariant(false);
  return print(sortValueNode(ast));
}

function diff(oldArray, newArray) {
  const added = [];
  const removed = [];
  const persisted = [];
  const oldMap = keyMap(oldArray, ({ name }) => name);
  const newMap = keyMap(newArray, ({ name }) => name);

  for (const oldItem of oldArray) {
    const newItem = newMap[oldItem.name];

    if (newItem === undefined) {
      removed.push(oldItem);
    } else {
      persisted.push([oldItem, newItem]);
    }
  }

  for (const newItem of newArray) {
    if (oldMap[newItem.name] === undefined) {
      added.push(newItem);
    }
  }

  return {
    added,
    persisted,
    removed,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/index.mjs
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 * ```ts
 * import { parse } from 'graphql';
 * import { parse } from 'graphql/language';
 * ```
 *
 * @packageDocumentation
 */
// The GraphQL.js version info.
 // The primary entry point into fulfilling a GraphQL request.

 // Create and operate on GraphQL type definitions and schema.


// Parse and operate on GraphQL language source files.

// Execute GraphQL queries.

// Validate GraphQL documents.

// Create, format, and print GraphQL errors.

// Utilities for operating on GraphQL type schema and parsed sources.



/***/ }),

/***/ 31655:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ __webpack_exports__["Z"] = (api);


/***/ }),

/***/ 12393:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _state$entry;

  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: undefined
  }); // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.

  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    let unobserve;
    unobserve = observe(ref, (inView, entry) => {
      setState({
        inView,
        entry
      });
      if (callback.current) callback.current(inView, entry);

      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root,
      rootMargin,
      threshold,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
    return () => {
      if (unobserve) {
        unobserve();
      }
    };
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();

  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
    // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: undefined
    });
  }

  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map


/***/ }),

/***/ 81069:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ __commonJS; },
/* harmony export */   "_l": function() { return /* binding */ extractEventHiddenProperties; },
/* harmony export */   "v": function() { return /* binding */ __toESM; }
/* harmony export */ });
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/dom-event.ts
var eventProperties = [
  "bubbles",
  "cancelBubble",
  "cancelable",
  "composed",
  "currentTarget",
  "defaultPrevented",
  "eventPhase",
  "isTrusted",
  "returnValue",
  "srcElement",
  "target",
  "timeStamp",
  "type"
];
var customEventSpecificProperties = ["detail"];
function extractEventHiddenProperties(event) {
  const rebuildEvent = eventProperties.filter((value) => event[value] !== void 0).reduce((acc, value) => {
    return { ...acc, [value]: event[value] };
  }, {});
  if (event instanceof CustomEvent) {
    customEventSpecificProperties.filter((value) => event[value] !== void 0).forEach((value) => {
      rebuildEvent[value] = event[value];
    });
  }
  return rebuildEvent;
}




/***/ }),

/***/ 73347:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse; }
/* harmony export */ });
/* unused harmony exports isJSON, replacer, reviver, stringify */
/* harmony import */ var _chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81069);
/* harmony import */ var memoizerific__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18425);


// node_modules/has-symbols/shams.js
var require_shams = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has-symbols/shams.js"(exports, module) {
    "use strict";
    module.exports = function hasSymbols() {
      if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
        return false;
      }
      if (typeof Symbol.iterator === "symbol") {
        return true;
      }
      var obj = {};
      var sym = Symbol("test");
      var symObj = Object(sym);
      if (typeof sym === "string") {
        return false;
      }
      if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
        return false;
      }
      if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
        return false;
      }
      var symVal = 42;
      obj[sym] = symVal;
      for (sym in obj) {
        return false;
      }
      if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
        return false;
      }
      if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
        return false;
      }
      var syms = Object.getOwnPropertySymbols(obj);
      if (syms.length !== 1 || syms[0] !== sym) {
        return false;
      }
      if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
        return false;
      }
      if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) {
          return false;
        }
      }
      return true;
    };
  }
});

// node_modules/has-symbols/index.js
var require_has_symbols = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has-symbols/index.js"(exports, module) {
    "use strict";
    var origSymbol = typeof Symbol !== "undefined" && Symbol;
    var hasSymbolSham = require_shams();
    module.exports = function hasNativeSymbols() {
      if (typeof origSymbol !== "function") {
        return false;
      }
      if (typeof Symbol !== "function") {
        return false;
      }
      if (typeof origSymbol("foo") !== "symbol") {
        return false;
      }
      if (typeof Symbol("bar") !== "symbol") {
        return false;
      }
      return hasSymbolSham();
    };
  }
});

// node_modules/function-bind/implementation.js
var require_implementation = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/function-bind/implementation.js"(exports, module) {
    "use strict";
    var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
    var slice = Array.prototype.slice;
    var toStr = Object.prototype.toString;
    var funcType = "[object Function]";
    module.exports = function bind(that) {
      var target = this;
      if (typeof target !== "function" || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
      }
      var args2 = slice.call(arguments, 1);
      var bound;
      var binder = function() {
        if (this instanceof bound) {
          var result2 = target.apply(
            this,
            args2.concat(slice.call(arguments))
          );
          if (Object(result2) === result2) {
            return result2;
          }
          return this;
        } else {
          return target.apply(
            that,
            args2.concat(slice.call(arguments))
          );
        }
      };
      var boundLength = Math.max(0, target.length - args2.length);
      var boundArgs = [];
      for (var i = 0; i < boundLength; i++) {
        boundArgs.push("$" + i);
      }
      bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
      if (target.prototype) {
        var Empty = function Empty2() {
        };
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
      }
      return bound;
    };
  }
});

// node_modules/function-bind/index.js
var require_function_bind = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/function-bind/index.js"(exports, module) {
    "use strict";
    var implementation = require_implementation();
    module.exports = Function.prototype.bind || implementation;
  }
});

// node_modules/has/src/index.js
var require_src = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has/src/index.js"(exports, module) {
    "use strict";
    var bind = require_function_bind();
    module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);
  }
});

// node_modules/get-intrinsic/index.js
var require_get_intrinsic = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/get-intrinsic/index.js"(exports, module) {
    "use strict";
    var undefined2;
    var $SyntaxError = SyntaxError;
    var $Function = Function;
    var $TypeError = TypeError;
    var getEvalledConstructor = function(expressionSyntax) {
      try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
      } catch (e) {
      }
    };
    var $gOPD = Object.getOwnPropertyDescriptor;
    if ($gOPD) {
      try {
        $gOPD({}, "");
      } catch (e) {
        $gOPD = null;
      }
    }
    var throwTypeError = function() {
      throw new $TypeError();
    };
    var ThrowTypeError = $gOPD ? function() {
      try {
        arguments.callee;
        return throwTypeError;
      } catch (calleeThrows) {
        try {
          return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
          return throwTypeError;
        }
      }
    }() : throwTypeError;
    var hasSymbols = require_has_symbols()();
    var getProto = Object.getPrototypeOf || function(x) {
      return x.__proto__;
    };
    var needsEval = {};
    var TypedArray = typeof Uint8Array === "undefined" ? undefined2 : getProto(Uint8Array);
    var INTRINSICS = {
      "%AggregateError%": typeof AggregateError === "undefined" ? undefined2 : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined2 : ArrayBuffer,
      "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined2,
      "%AsyncFromSyncIteratorPrototype%": undefined2,
      "%AsyncFunction%": needsEval,
      "%AsyncGenerator%": needsEval,
      "%AsyncGeneratorFunction%": needsEval,
      "%AsyncIteratorPrototype%": needsEval,
      "%Atomics%": typeof Atomics === "undefined" ? undefined2 : Atomics,
      "%BigInt%": typeof BigInt === "undefined" ? undefined2 : BigInt,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView === "undefined" ? undefined2 : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%Float32Array%": typeof Float32Array === "undefined" ? undefined2 : Float32Array,
      "%Float64Array%": typeof Float64Array === "undefined" ? undefined2 : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined2 : FinalizationRegistry,
      "%Function%": $Function,
      "%GeneratorFunction%": needsEval,
      "%Int8Array%": typeof Int8Array === "undefined" ? undefined2 : Int8Array,
      "%Int16Array%": typeof Int16Array === "undefined" ? undefined2 : Int16Array,
      "%Int32Array%": typeof Int32Array === "undefined" ? undefined2 : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined2,
      "%JSON%": typeof JSON === "object" ? JSON : undefined2,
      "%Map%": typeof Map === "undefined" ? undefined2 : Map,
      "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise === "undefined" ? undefined2 : Promise,
      "%Proxy%": typeof Proxy === "undefined" ? undefined2 : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": typeof Reflect === "undefined" ? undefined2 : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set === "undefined" ? undefined2 : Set,
      "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined2 : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined2,
      "%Symbol%": hasSymbols ? Symbol : undefined2,
      "%SyntaxError%": $SyntaxError,
      "%ThrowTypeError%": ThrowTypeError,
      "%TypedArray%": TypedArray,
      "%TypeError%": $TypeError,
      "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined2 : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined2 : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined2 : Uint16Array,
      "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined2 : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": typeof WeakMap === "undefined" ? undefined2 : WeakMap,
      "%WeakRef%": typeof WeakRef === "undefined" ? undefined2 : WeakRef,
      "%WeakSet%": typeof WeakSet === "undefined" ? undefined2 : WeakSet
    };
    var doEval = function doEval2(name2) {
      var value2;
      if (name2 === "%AsyncFunction%") {
        value2 = getEvalledConstructor("async function () {}");
      } else if (name2 === "%GeneratorFunction%") {
        value2 = getEvalledConstructor("function* () {}");
      } else if (name2 === "%AsyncGeneratorFunction%") {
        value2 = getEvalledConstructor("async function* () {}");
      } else if (name2 === "%AsyncGenerator%") {
        var fn = doEval2("%AsyncGeneratorFunction%");
        if (fn) {
          value2 = fn.prototype;
        }
      } else if (name2 === "%AsyncIteratorPrototype%") {
        var gen = doEval2("%AsyncGenerator%");
        if (gen) {
          value2 = getProto(gen.prototype);
        }
      }
      INTRINSICS[name2] = value2;
      return value2;
    };
    var LEGACY_ALIASES = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    };
    var bind = require_function_bind();
    var hasOwn = require_src();
    var $concat = bind.call(Function.call, Array.prototype.concat);
    var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
    var $replace = bind.call(Function.call, String.prototype.replace);
    var $strSlice = bind.call(Function.call, String.prototype.slice);
    var $exec = bind.call(Function.call, RegExp.prototype.exec);
    var rePropName2 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
    var reEscapeChar2 = /\\(\\)?/g;
    var stringToPath2 = function stringToPath3(string) {
      var first = $strSlice(string, 0, 1);
      var last = $strSlice(string, -1);
      if (first === "%" && last !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
      } else if (last === "%" && first !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
      }
      var result2 = [];
      $replace(string, rePropName2, function(match, number, quote, subString) {
        result2[result2.length] = quote ? $replace(subString, reEscapeChar2, "$1") : number || match;
      });
      return result2;
    };
    var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
      var intrinsicName = name2;
      var alias;
      if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
      }
      if (hasOwn(INTRINSICS, intrinsicName)) {
        var value2 = INTRINSICS[intrinsicName];
        if (value2 === needsEval) {
          value2 = doEval(intrinsicName);
        }
        if (typeof value2 === "undefined" && !allowMissing) {
          throw new $TypeError("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
        }
        return {
          alias,
          name: intrinsicName,
          value: value2
        };
      }
      throw new $SyntaxError("intrinsic " + name2 + " does not exist!");
    };
    module.exports = function GetIntrinsic(name2, allowMissing) {
      if (typeof name2 !== "string" || name2.length === 0) {
        throw new $TypeError("intrinsic name must be a non-empty string");
      }
      if (arguments.length > 1 && typeof allowMissing !== "boolean") {
        throw new $TypeError('"allowMissing" argument must be a boolean');
      }
      if ($exec(/^%?[^%]*%?$/, name2) === null) {
        throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      }
      var parts = stringToPath2(name2);
      var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
      var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
      var intrinsicRealName = intrinsic.name;
      var value2 = intrinsic.value;
      var skipFurtherCaching = false;
      var alias = intrinsic.alias;
      if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([0, 1], alias));
      }
      for (var i = 1, isOwn = true; i < parts.length; i += 1) {
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
          throw new $SyntaxError("property names with quotes must have matching quotes");
        }
        if (part === "constructor" || !isOwn) {
          skipFurtherCaching = true;
        }
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) {
          value2 = INTRINSICS[intrinsicRealName];
        } else if (value2 != null) {
          if (!(part in value2)) {
            if (!allowMissing) {
              throw new $TypeError("base intrinsic for " + name2 + " exists, but the property is not available.");
            }
            return void 0;
          }
          if ($gOPD && i + 1 >= parts.length) {
            var desc = $gOPD(value2, part);
            isOwn = !!desc;
            if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
              value2 = desc.get;
            } else {
              value2 = value2[part];
            }
          } else {
            isOwn = hasOwn(value2, part);
            value2 = value2[part];
          }
          if (isOwn && !skipFurtherCaching) {
            INTRINSICS[intrinsicRealName] = value2;
          }
        }
      }
      return value2;
    };
  }
});

// node_modules/call-bind/index.js
var require_call_bind = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/call-bind/index.js"(exports, module) {
    "use strict";
    var bind = require_function_bind();
    var GetIntrinsic = require_get_intrinsic();
    var $apply = GetIntrinsic("%Function.prototype.apply%");
    var $call = GetIntrinsic("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
    var $max = GetIntrinsic("%Math.max%");
    if ($defineProperty) {
      try {
        $defineProperty({}, "a", { value: 1 });
      } catch (e) {
        $defineProperty = null;
      }
    }
    module.exports = function callBind(originalFunction) {
      var func = $reflectApply(bind, $call, arguments);
      if ($gOPD && $defineProperty) {
        var desc = $gOPD(func, "length");
        if (desc.configurable) {
          $defineProperty(
            func,
            "length",
            { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
          );
        }
      }
      return func;
    };
    var applyBind = function applyBind2() {
      return $reflectApply(bind, $apply, arguments);
    };
    if ($defineProperty) {
      $defineProperty(module.exports, "apply", { value: applyBind });
    } else {
      module.exports.apply = applyBind;
    }
  }
});

// node_modules/call-bind/callBound.js
var require_callBound = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/call-bind/callBound.js"(exports, module) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var callBind = require_call_bind();
    var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
    module.exports = function callBoundIntrinsic(name2, allowMissing) {
      var intrinsic = GetIntrinsic(name2, !!allowMissing);
      if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) {
        return callBind(intrinsic);
      }
      return intrinsic;
    };
  }
});

// node_modules/has-tostringtag/shams.js
var require_shams2 = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has-tostringtag/shams.js"(exports, module) {
    "use strict";
    var hasSymbols = require_shams();
    module.exports = function hasToStringTagShams() {
      return hasSymbols() && !!Symbol.toStringTag;
    };
  }
});

// node_modules/is-regex/index.js
var require_is_regex = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/is-regex/index.js"(exports, module) {
    "use strict";
    var callBound = require_callBound();
    var hasToStringTag = require_shams2()();
    var has;
    var $exec;
    var isRegexMarker;
    var badStringifier;
    if (hasToStringTag) {
      has = callBound("Object.prototype.hasOwnProperty");
      $exec = callBound("RegExp.prototype.exec");
      isRegexMarker = {};
      throwRegexMarker = function() {
        throw isRegexMarker;
      };
      badStringifier = {
        toString: throwRegexMarker,
        valueOf: throwRegexMarker
      };
      if (typeof Symbol.toPrimitive === "symbol") {
        badStringifier[Symbol.toPrimitive] = throwRegexMarker;
      }
    }
    var throwRegexMarker;
    var $toString = callBound("Object.prototype.toString");
    var gOPD = Object.getOwnPropertyDescriptor;
    var regexClass = "[object RegExp]";
    module.exports = hasToStringTag ? function isRegex(value2) {
      if (!value2 || typeof value2 !== "object") {
        return false;
      }
      var descriptor = gOPD(value2, "lastIndex");
      var hasLastIndexDataProperty = descriptor && has(descriptor, "value");
      if (!hasLastIndexDataProperty) {
        return false;
      }
      try {
        $exec(value2, badStringifier);
      } catch (e) {
        return e === isRegexMarker;
      }
    } : function isRegex(value2) {
      if (!value2 || typeof value2 !== "object" && typeof value2 !== "function") {
        return false;
      }
      return $toString(value2) === regexClass;
    };
  }
});

// node_modules/is-function/index.js
var require_is_function = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/is-function/index.js"(exports, module) {
    module.exports = isFunction3;
    var toString2 = Object.prototype.toString;
    function isFunction3(fn) {
      if (!fn) {
        return false;
      }
      var string = toString2.call(fn);
      return string === "[object Function]" || typeof fn === "function" && string !== "[object RegExp]" || typeof window !== "undefined" && (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
    }
  }
});

// node_modules/is-symbol/index.js
var require_is_symbol = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/is-symbol/index.js"(exports, module) {
    "use strict";
    var toStr = Object.prototype.toString;
    var hasSymbols = require_has_symbols()();
    if (hasSymbols) {
      symToStr = Symbol.prototype.toString;
      symStringRegex = /^Symbol\(.*\)$/;
      isSymbolObject = function isRealSymbolObject(value2) {
        if (typeof value2.valueOf() !== "symbol") {
          return false;
        }
        return symStringRegex.test(symToStr.call(value2));
      };
      module.exports = function isSymbol3(value2) {
        if (typeof value2 === "symbol") {
          return true;
        }
        if (toStr.call(value2) !== "[object Symbol]") {
          return false;
        }
        try {
          return isSymbolObject(value2);
        } catch (e) {
          return false;
        }
      };
    } else {
      module.exports = function isSymbol3(value2) {
        return false;
      };
    }
    var symToStr;
    var symStringRegex;
    var isSymbolObject;
  }
});

// src/index.ts
var import_is_regex = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__toESM */ .v)(require_is_regex());
var import_is_function = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__toESM */ .v)(require_is_function());
var import_is_symbol = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__toESM */ .v)(require_is_symbol());

// node_modules/isobject/index.js
function isObject(val) {
  return val != null && typeof val === "object" && Array.isArray(val) === false;
}

// node_modules/lodash-es/_freeGlobal.js
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;

// node_modules/lodash-es/_root.js
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root2 = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root2;

// node_modules/lodash-es/_Symbol.js
var Symbol2 = root_default.Symbol;
var Symbol_default = Symbol2;

// node_modules/lodash-es/_getRawTag.js
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(value2) {
  var isOwn = hasOwnProperty.call(value2, symToStringTag), tag = value2[symToStringTag];
  try {
    value2[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result2 = nativeObjectToString.call(value2);
  if (unmasked) {
    if (isOwn) {
      value2[symToStringTag] = tag;
    } else {
      delete value2[symToStringTag];
    }
  }
  return result2;
}
var getRawTag_default = getRawTag;

// node_modules/lodash-es/_objectToString.js
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
function objectToString(value2) {
  return nativeObjectToString2.call(value2);
}
var objectToString_default = objectToString;

// node_modules/lodash-es/_baseGetTag.js
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(value2) {
  if (value2 == null) {
    return value2 === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value2) ? getRawTag_default(value2) : objectToString_default(value2);
}
var baseGetTag_default = baseGetTag;

// node_modules/lodash-es/isObjectLike.js
function isObjectLike(value2) {
  return value2 != null && typeof value2 == "object";
}
var isObjectLike_default = isObjectLike;

// node_modules/lodash-es/isSymbol.js
var symbolTag = "[object Symbol]";
function isSymbol(value2) {
  return typeof value2 == "symbol" || isObjectLike_default(value2) && baseGetTag_default(value2) == symbolTag;
}
var isSymbol_default = isSymbol;

// node_modules/lodash-es/_arrayMap.js
function arrayMap(array, iteratee) {
  var index = -1, length = array == null ? 0 : array.length, result2 = Array(length);
  while (++index < length) {
    result2[index] = iteratee(array[index], index, array);
  }
  return result2;
}
var arrayMap_default = arrayMap;

// node_modules/lodash-es/isArray.js
var isArray = Array.isArray;
var isArray_default = isArray;

// node_modules/lodash-es/_baseToString.js
var INFINITY = 1 / 0;
var symbolProto = Symbol_default ? Symbol_default.prototype : void 0;
var symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(value2) {
  if (typeof value2 == "string") {
    return value2;
  }
  if (isArray_default(value2)) {
    return arrayMap_default(value2, baseToString) + "";
  }
  if (isSymbol_default(value2)) {
    return symbolToString ? symbolToString.call(value2) : "";
  }
  var result2 = value2 + "";
  return result2 == "0" && 1 / value2 == -INFINITY ? "-0" : result2;
}
var baseToString_default = baseToString;

// node_modules/lodash-es/isObject.js
function isObject2(value2) {
  var type = typeof value2;
  return value2 != null && (type == "object" || type == "function");
}
var isObject_default = isObject2;

// node_modules/lodash-es/isFunction.js
var asyncTag = "[object AsyncFunction]";
var funcTag = "[object Function]";
var genTag = "[object GeneratorFunction]";
var proxyTag = "[object Proxy]";
function isFunction(value2) {
  if (!isObject_default(value2)) {
    return false;
  }
  var tag = baseGetTag_default(value2);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_default = isFunction;

// node_modules/lodash-es/_coreJsData.js
var coreJsData = root_default["__core-js_shared__"];
var coreJsData_default = coreJsData;

// node_modules/lodash-es/_isMasked.js
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData_default && coreJsData_default.keys && coreJsData_default.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var isMasked_default = isMasked;

// node_modules/lodash-es/_toSource.js
var funcProto = Function.prototype;
var funcToString = funcProto.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var toSource_default = toSource;

// node_modules/lodash-es/_baseIsNative.js
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto2 = Function.prototype;
var objectProto3 = Object.prototype;
var funcToString2 = funcProto2.toString;
var hasOwnProperty2 = objectProto3.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value2) {
  if (!isObject_default(value2) || isMasked_default(value2)) {
    return false;
  }
  var pattern = isFunction_default(value2) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource_default(value2));
}
var baseIsNative_default = baseIsNative;

// node_modules/lodash-es/_getValue.js
function getValue(object, key2) {
  return object == null ? void 0 : object[key2];
}
var getValue_default = getValue;

// node_modules/lodash-es/_getNative.js
function getNative(object, key2) {
  var value2 = getValue_default(object, key2);
  return baseIsNative_default(value2) ? value2 : void 0;
}
var getNative_default = getNative;

// node_modules/lodash-es/eq.js
function eq(value2, other) {
  return value2 === other || value2 !== value2 && other !== other;
}
var eq_default = eq;

// node_modules/lodash-es/_isKey.js
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
var reIsPlainProp = /^\w*$/;
function isKey(value2, object) {
  if (isArray_default(value2)) {
    return false;
  }
  var type = typeof value2;
  if (type == "number" || type == "symbol" || type == "boolean" || value2 == null || isSymbol_default(value2)) {
    return true;
  }
  return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object != null && value2 in Object(object);
}
var isKey_default = isKey;

// node_modules/lodash-es/_nativeCreate.js
var nativeCreate = getNative_default(Object, "create");
var nativeCreate_default = nativeCreate;

// node_modules/lodash-es/_hashClear.js
function hashClear() {
  this.__data__ = nativeCreate_default ? nativeCreate_default(null) : {};
  this.size = 0;
}
var hashClear_default = hashClear;

// node_modules/lodash-es/_hashDelete.js
function hashDelete(key2) {
  var result2 = this.has(key2) && delete this.__data__[key2];
  this.size -= result2 ? 1 : 0;
  return result2;
}
var hashDelete_default = hashDelete;

// node_modules/lodash-es/_hashGet.js
var HASH_UNDEFINED = "__lodash_hash_undefined__";
var objectProto4 = Object.prototype;
var hasOwnProperty3 = objectProto4.hasOwnProperty;
function hashGet(key2) {
  var data = this.__data__;
  if (nativeCreate_default) {
    var result2 = data[key2];
    return result2 === HASH_UNDEFINED ? void 0 : result2;
  }
  return hasOwnProperty3.call(data, key2) ? data[key2] : void 0;
}
var hashGet_default = hashGet;

// node_modules/lodash-es/_hashHas.js
var objectProto5 = Object.prototype;
var hasOwnProperty4 = objectProto5.hasOwnProperty;
function hashHas(key2) {
  var data = this.__data__;
  return nativeCreate_default ? data[key2] !== void 0 : hasOwnProperty4.call(data, key2);
}
var hashHas_default = hashHas;

// node_modules/lodash-es/_hashSet.js
var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
function hashSet(key2, value2) {
  var data = this.__data__;
  this.size += this.has(key2) ? 0 : 1;
  data[key2] = nativeCreate_default && value2 === void 0 ? HASH_UNDEFINED2 : value2;
  return this;
}
var hashSet_default = hashSet;

// node_modules/lodash-es/_Hash.js
function Hash(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear_default;
Hash.prototype["delete"] = hashDelete_default;
Hash.prototype.get = hashGet_default;
Hash.prototype.has = hashHas_default;
Hash.prototype.set = hashSet_default;
var Hash_default = Hash;

// node_modules/lodash-es/_listCacheClear.js
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
var listCacheClear_default = listCacheClear;

// node_modules/lodash-es/_assocIndexOf.js
function assocIndexOf(array, key2) {
  var length = array.length;
  while (length--) {
    if (eq_default(array[length][0], key2)) {
      return length;
    }
  }
  return -1;
}
var assocIndexOf_default = assocIndexOf;

// node_modules/lodash-es/_listCacheDelete.js
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key2) {
  var data = this.__data__, index = assocIndexOf_default(data, key2);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var listCacheDelete_default = listCacheDelete;

// node_modules/lodash-es/_listCacheGet.js
function listCacheGet(key2) {
  var data = this.__data__, index = assocIndexOf_default(data, key2);
  return index < 0 ? void 0 : data[index][1];
}
var listCacheGet_default = listCacheGet;

// node_modules/lodash-es/_listCacheHas.js
function listCacheHas(key2) {
  return assocIndexOf_default(this.__data__, key2) > -1;
}
var listCacheHas_default = listCacheHas;

// node_modules/lodash-es/_listCacheSet.js
function listCacheSet(key2, value2) {
  var data = this.__data__, index = assocIndexOf_default(data, key2);
  if (index < 0) {
    ++this.size;
    data.push([key2, value2]);
  } else {
    data[index][1] = value2;
  }
  return this;
}
var listCacheSet_default = listCacheSet;

// node_modules/lodash-es/_ListCache.js
function ListCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear_default;
ListCache.prototype["delete"] = listCacheDelete_default;
ListCache.prototype.get = listCacheGet_default;
ListCache.prototype.has = listCacheHas_default;
ListCache.prototype.set = listCacheSet_default;
var ListCache_default = ListCache;

// node_modules/lodash-es/_Map.js
var Map2 = getNative_default(root_default, "Map");
var Map_default = Map2;

// node_modules/lodash-es/_mapCacheClear.js
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash_default(),
    "map": new (Map_default || ListCache_default)(),
    "string": new Hash_default()
  };
}
var mapCacheClear_default = mapCacheClear;

// node_modules/lodash-es/_isKeyable.js
function isKeyable(value2) {
  var type = typeof value2;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
}
var isKeyable_default = isKeyable;

// node_modules/lodash-es/_getMapData.js
function getMapData(map, key2) {
  var data = map.__data__;
  return isKeyable_default(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
}
var getMapData_default = getMapData;

// node_modules/lodash-es/_mapCacheDelete.js
function mapCacheDelete(key2) {
  var result2 = getMapData_default(this, key2)["delete"](key2);
  this.size -= result2 ? 1 : 0;
  return result2;
}
var mapCacheDelete_default = mapCacheDelete;

// node_modules/lodash-es/_mapCacheGet.js
function mapCacheGet(key2) {
  return getMapData_default(this, key2).get(key2);
}
var mapCacheGet_default = mapCacheGet;

// node_modules/lodash-es/_mapCacheHas.js
function mapCacheHas(key2) {
  return getMapData_default(this, key2).has(key2);
}
var mapCacheHas_default = mapCacheHas;

// node_modules/lodash-es/_mapCacheSet.js
function mapCacheSet(key2, value2) {
  var data = getMapData_default(this, key2), size = data.size;
  data.set(key2, value2);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var mapCacheSet_default = mapCacheSet;

// node_modules/lodash-es/_MapCache.js
function MapCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear_default;
MapCache.prototype["delete"] = mapCacheDelete_default;
MapCache.prototype.get = mapCacheGet_default;
MapCache.prototype.has = mapCacheHas_default;
MapCache.prototype.set = mapCacheSet_default;
var MapCache_default = MapCache;

// node_modules/lodash-es/memoize.js
var FUNC_ERROR_TEXT = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args2 = arguments, key2 = resolver ? resolver.apply(this, args2) : args2[0], cache = memoized.cache;
    if (cache.has(key2)) {
      return cache.get(key2);
    }
    var result2 = func.apply(this, args2);
    memoized.cache = cache.set(key2, result2) || cache;
    return result2;
  };
  memoized.cache = new (memoize.Cache || MapCache_default)();
  return memoized;
}
memoize.Cache = MapCache_default;
var memoize_default = memoize;

// node_modules/lodash-es/_memoizeCapped.js
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result2 = memoize_default(func, function(key2) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key2;
  });
  var cache = result2.cache;
  return result2;
}
var memoizeCapped_default = memoizeCapped;

// node_modules/lodash-es/_stringToPath.js
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped_default(function(string) {
  var result2 = [];
  if (string.charCodeAt(0) === 46) {
    result2.push("");
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  });
  return result2;
});
var stringToPath_default = stringToPath;

// node_modules/lodash-es/toString.js
function toString(value2) {
  return value2 == null ? "" : baseToString_default(value2);
}
var toString_default = toString;

// node_modules/lodash-es/_castPath.js
function castPath(value2, object) {
  if (isArray_default(value2)) {
    return value2;
  }
  return isKey_default(value2, object) ? [value2] : stringToPath_default(toString_default(value2));
}
var castPath_default = castPath;

// node_modules/lodash-es/_toKey.js
var INFINITY2 = 1 / 0;
function toKey(value2) {
  if (typeof value2 == "string" || isSymbol_default(value2)) {
    return value2;
  }
  var result2 = value2 + "";
  return result2 == "0" && 1 / value2 == -INFINITY2 ? "-0" : result2;
}
var toKey_default = toKey;

// node_modules/lodash-es/_baseGet.js
function baseGet(object, path) {
  path = castPath_default(path, object);
  var index = 0, length = path.length;
  while (object != null && index < length) {
    object = object[toKey_default(path[index++])];
  }
  return index && index == length ? object : void 0;
}
var baseGet_default = baseGet;

// node_modules/lodash-es/get.js
function get(object, path, defaultValue) {
  var result2 = object == null ? void 0 : baseGet_default(object, path);
  return result2 === void 0 ? defaultValue : result2;
}
var get_default = get;

// src/index.ts

var isObject3 = isObject;
var removeCodeComments = (code) => {
  let inQuoteChar = null;
  let inBlockComment = false;
  let inLineComment = false;
  let inRegexLiteral = false;
  let newCode = "";
  if (code.indexOf("//") >= 0 || code.indexOf("/*") >= 0) {
    for (let i = 0; i < code.length; i += 1) {
      if (!inQuoteChar && !inBlockComment && !inLineComment && !inRegexLiteral) {
        if (code[i] === '"' || code[i] === "'" || code[i] === "`") {
          inQuoteChar = code[i];
        } else if (code[i] === "/" && code[i + 1] === "*") {
          inBlockComment = true;
        } else if (code[i] === "/" && code[i + 1] === "/") {
          inLineComment = true;
        } else if (code[i] === "/" && code[i + 1] !== "/") {
          inRegexLiteral = true;
        }
      } else {
        if (inQuoteChar && (code[i] === inQuoteChar && code[i - 1] !== "\\" || code[i] === "\n" && inQuoteChar !== "`")) {
          inQuoteChar = null;
        }
        if (inRegexLiteral && (code[i] === "/" && code[i - 1] !== "\\" || code[i] === "\n")) {
          inRegexLiteral = false;
        }
        if (inBlockComment && code[i - 1] === "/" && code[i - 2] === "*") {
          inBlockComment = false;
        }
        if (inLineComment && code[i] === "\n") {
          inLineComment = false;
        }
      }
      if (!inBlockComment && !inLineComment) {
        newCode += code[i];
      }
    }
  } else {
    newCode = code;
  }
  return newCode;
};
var cleanCode = memoizerific__WEBPACK_IMPORTED_MODULE_1__(1e4)(
  (code) => removeCodeComments(code).replace(/\n\s*/g, "").trim()
);
var convertShorthandMethods = function convertShorthandMethods2(key2, stringified) {
  const fnHead = stringified.slice(0, stringified.indexOf("{"));
  const fnBody = stringified.slice(stringified.indexOf("{"));
  if (fnHead.includes("=>")) {
    return stringified;
  }
  if (fnHead.includes("function")) {
    return stringified;
  }
  let modifiedHead = fnHead;
  modifiedHead = modifiedHead.replace(key2, "function");
  return modifiedHead + fnBody;
};
var dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
var isJSON = (input) => input.match(/^[\[\{\"\}].*[\]\}\"]$/);
function convertUnconventionalData(data) {
  if (!isObject3(data)) {
    return data;
  }
  let result2 = data;
  let wasMutated = false;
  if (typeof Event !== "undefined" && data instanceof Event) {
    result2 = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .extractEventHiddenProperties */ ._l)(result2);
    wasMutated = true;
  }
  result2 = Object.keys(result2).reduce((acc, key2) => {
    try {
      if (result2[key2]) {
        result2[key2].toJSON;
      }
      acc[key2] = result2[key2];
    } catch (err) {
      wasMutated = true;
    }
    return acc;
  }, {});
  return wasMutated ? result2 : data;
}
var replacer = function replacer2(options2) {
  let objects;
  let map;
  let stack;
  let keys;
  return function replace(key2, value2) {
    try {
      if (key2 === "") {
        keys = [];
        objects = /* @__PURE__ */ new Map([[value2, "[]"]]);
        map = /* @__PURE__ */ new Map();
        stack = [];
        return value2;
      }
      const origin = map.get(this) || this;
      while (stack.length && origin !== stack[0]) {
        stack.shift();
        keys.pop();
      }
      if (typeof value2 === "boolean") {
        return value2;
      }
      if (value2 === void 0) {
        if (!options2.allowUndefined) {
          return void 0;
        }
        return "_undefined_";
      }
      if (value2 === null) {
        return null;
      }
      if (typeof value2 === "number") {
        if (value2 === -Infinity) {
          return "_-Infinity_";
        }
        if (value2 === Infinity) {
          return "_Infinity_";
        }
        if (Number.isNaN(value2)) {
          return "_NaN_";
        }
        return value2;
      }
      if (typeof value2 === "bigint") {
        return `_bigint_${value2.toString()}`;
      }
      if (typeof value2 === "string") {
        if (dateFormat.test(value2)) {
          if (!options2.allowDate) {
            return void 0;
          }
          return `_date_${value2}`;
        }
        return value2;
      }
      if ((0, import_is_regex.default)(value2)) {
        if (!options2.allowRegExp) {
          return void 0;
        }
        return `_regexp_${value2.flags}|${value2.source}`;
      }
      if ((0, import_is_function.default)(value2)) {
        if (!options2.allowFunction) {
          return void 0;
        }
        const { name: name2 } = value2;
        const stringified = value2.toString();
        if (!stringified.match(
          /(\[native code\]|WEBPACK_IMPORTED_MODULE|__webpack_exports__|__webpack_require__)/
        )) {
          return `_function_${name2}|${cleanCode(convertShorthandMethods(key2, stringified))}`;
        }
        return `_function_${name2}|${(() => {
        }).toString()}`;
      }
      if ((0, import_is_symbol.default)(value2)) {
        if (!options2.allowSymbol) {
          return void 0;
        }
        const globalRegistryKey = Symbol.keyFor(value2);
        if (globalRegistryKey !== void 0) {
          return `_gsymbol_${globalRegistryKey}`;
        }
        return `_symbol_${value2.toString().slice(7, -1)}`;
      }
      if (stack.length >= options2.maxDepth) {
        if (Array.isArray(value2)) {
          return `[Array(${value2.length})]`;
        }
        return "[Object]";
      }
      if (value2 === this) {
        return `_duplicate_${JSON.stringify(keys)}`;
      }
      if (value2 instanceof Error && options2.allowError) {
        return {
          __isConvertedError__: true,
          errorProperties: {
            ...value2.cause ? { cause: value2.cause } : {},
            ...value2,
            name: value2.name,
            message: value2.message,
            stack: value2.stack,
            "_constructor-name_": value2.constructor.name
          }
        };
      }
      if (value2.constructor && value2.constructor.name && value2.constructor.name !== "Object" && !Array.isArray(value2) && !options2.allowClass) {
        return void 0;
      }
      const found = objects.get(value2);
      if (!found) {
        const converted = Array.isArray(value2) ? value2 : convertUnconventionalData(value2);
        if (value2.constructor && value2.constructor.name && value2.constructor.name !== "Object" && !Array.isArray(value2) && options2.allowClass) {
          try {
            Object.assign(converted, { "_constructor-name_": value2.constructor.name });
          } catch (e) {
          }
        }
        keys.push(key2);
        stack.unshift(converted);
        objects.set(value2, JSON.stringify(keys));
        if (value2 !== converted) {
          map.set(value2, converted);
        }
        return converted;
      }
      return `_duplicate_${found}`;
    } catch (e) {
      return void 0;
    }
  };
};
var reviver2 = function reviver(options) {
  const refs = [];
  let root;
  return function revive(key, value) {
    if (key === "") {
      root = value;
      refs.forEach(({ target, container, replacement }) => {
        const replacementArr = isJSON(replacement) ? JSON.parse(replacement) : replacement.split(".");
        if (replacementArr.length === 0) {
          container[target] = root;
        } else {
          container[target] = get_default(root, replacementArr);
        }
      });
    }
    if (key === "_constructor-name_") {
      return value;
    }
    if (isObject3(value) && value.__isConvertedError__) {
      const { message, ...properties } = value.errorProperties;
      const error = new Error(message);
      Object.assign(error, properties);
      return error;
    }
    if (isObject3(value) && value["_constructor-name_"] && options.allowFunction) {
      const name2 = value["_constructor-name_"];
      if (name2 !== "Object") {
        const Fn = new Function(`return function ${name2.replace(/[^a-zA-Z0-9$_]+/g, "")}(){}`)();
        Object.setPrototypeOf(value, new Fn());
      }
      delete value["_constructor-name_"];
      return value;
    }
    if (typeof value === "string" && value.startsWith("_function_") && options.allowFunction) {
      const [, name, source] = value.match(/_function_([^|]*)\|(.*)/) || [];
      const sourceSanitized = source.replace(/[(\(\))|\\| |\]|`]*$/, "");
      if (!options.lazyEval) {
        return eval(`(${sourceSanitized})`);
      }
      const result = (...args) => {
        const f = eval(`(${sourceSanitized})`);
        return f(...args);
      };
      Object.defineProperty(result, "toString", {
        value: () => sourceSanitized
      });
      Object.defineProperty(result, "name", {
        value: name
      });
      return result;
    }
    if (typeof value === "string" && value.startsWith("_regexp_") && options.allowRegExp) {
      const [, flags, source2] = value.match(/_regexp_([^|]*)\|(.*)/) || [];
      return new RegExp(source2, flags);
    }
    if (typeof value === "string" && value.startsWith("_date_") && options.allowDate) {
      return new Date(value.replace("_date_", ""));
    }
    if (typeof value === "string" && value.startsWith("_duplicate_")) {
      refs.push({ target: key, container: this, replacement: value.replace(/^_duplicate_/, "") });
      return null;
    }
    if (typeof value === "string" && value.startsWith("_symbol_") && options.allowSymbol) {
      return Symbol(value.replace("_symbol_", ""));
    }
    if (typeof value === "string" && value.startsWith("_gsymbol_") && options.allowSymbol) {
      return Symbol.for(value.replace("_gsymbol_", ""));
    }
    if (typeof value === "string" && value === "_-Infinity_") {
      return -Infinity;
    }
    if (typeof value === "string" && value === "_Infinity_") {
      return Infinity;
    }
    if (typeof value === "string" && value === "_NaN_") {
      return NaN;
    }
    if (typeof value === "string" && value.startsWith("_bigint_") && typeof BigInt === "function") {
      return BigInt(value.replace("_bigint_", ""));
    }
    return value;
  };
};
var defaultOptions = {
  maxDepth: 10,
  space: void 0,
  allowFunction: true,
  allowRegExp: true,
  allowDate: true,
  allowClass: true,
  allowError: true,
  allowUndefined: true,
  allowSymbol: true,
  lazyEval: true
};
var stringify = (data, options2 = {}) => {
  const mergedOptions = { ...defaultOptions, ...options2 };
  return JSON.stringify(convertUnconventionalData(data), replacer(mergedOptions), options2.space);
};
var mutator = () => {
  const mutated = /* @__PURE__ */ new Map();
  return function mutateUndefined(value2) {
    if (isObject3(value2)) {
      Object.entries(value2).forEach(([k, v]) => {
        if (v === "_undefined_") {
          value2[k] = void 0;
        } else if (!mutated.get(v)) {
          mutated.set(v, true);
          mutateUndefined(v);
        }
      });
    }
    if (Array.isArray(value2)) {
      value2.forEach((v, index) => {
        if (v === "_undefined_") {
          mutated.set(v, true);
          value2[index] = void 0;
        } else if (!mutated.get(v)) {
          mutated.set(v, true);
          mutateUndefined(v);
        }
      });
    }
  };
};
var parse = (data, options2 = {}) => {
  const mergedOptions = { ...defaultOptions, ...options2 };
  const result2 = JSON.parse(data, reviver2(mergedOptions));
  mutator()(result2);
  return result2;
};

/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6461), __webpack_exec__(87895); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);